var un = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function da(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var SD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    var r = 1e3, i = 6e4, n = 36e5, a = "millisecond", o = "second", s = "minute", c = "hour", u = "day", d = "week", l = "month", p = "quarter", f = "year", m = "date", h = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, U = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
      var M = ["th", "st", "nd", "rd"], N = O % 100;
      return "[" + O + (M[(N - 20) % 10] || M[N] || M[0]) + "]";
    } }, v = function(O, M, N) {
      var C = String(O);
      return !C || C.length >= M ? O : "" + Array(M + 1 - C.length).join(N) + O;
    }, S = { s: v, z: function(O) {
      var M = -O.utcOffset(), N = Math.abs(M), C = Math.floor(N / 60), F = N % 60;
      return (M <= 0 ? "+" : "-") + v(C, 2, "0") + ":" + v(F, 2, "0");
    }, m: function O(M, N) {
      if (M.date() < N.date()) return -O(N, M);
      var C = 12 * (N.year() - M.year()) + (N.month() - M.month()), F = M.clone().add(C, l), x = N - F < 0, V = M.clone().add(C + (x ? -1 : 1), l);
      return +(-(C + (N - F) / (x ? F - V : V - F)) || 0);
    }, a: function(O) {
      return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
    }, p: function(O) {
      return { M: l, y: f, w: d, d: u, D: m, h: c, m: s, s: o, ms: a, Q: p }[O] || String(O || "").toLowerCase().replace(/s$/, "");
    }, u: function(O) {
      return O === void 0;
    } }, T = "en", A = {};
    A[T] = U;
    var y = "$isDayjsObject", D = function(O) {
      return O instanceof b || !(!O || !O[y]);
    }, P = function O(M, N, C) {
      var F;
      if (!M) return T;
      if (typeof M == "string") {
        var x = M.toLowerCase();
        A[x] && (F = x), N && (A[x] = N, F = x);
        var V = M.split("-");
        if (!F && V.length > 1) return O(V[0]);
      } else {
        var k = M.name;
        A[k] = M, F = k;
      }
      return !C && F && (T = F), F || !C && T;
    }, w = function(O, M) {
      if (D(O)) return O.clone();
      var N = typeof M == "object" ? M : {};
      return N.date = O, N.args = arguments, new b(N);
    }, R = S;
    R.l = P, R.i = D, R.w = function(O, M) {
      return w(O, { locale: M.$L, utc: M.$u, x: M.$x, $offset: M.$offset });
    };
    var b = function() {
      function O(N) {
        this.$L = P(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[y] = !0;
      }
      var M = O.prototype;
      return M.parse = function(N) {
        this.$d = function(C) {
          var F = C.date, x = C.utc;
          if (F === null) return /* @__PURE__ */ new Date(NaN);
          if (R.u(F)) return /* @__PURE__ */ new Date();
          if (F instanceof Date) return new Date(F);
          if (typeof F == "string" && !/Z$/i.test(F)) {
            var V = F.match(g);
            if (V) {
              var k = V[2] - 1 || 0, L = (V[7] || "0").substring(0, 3);
              return x ? new Date(Date.UTC(V[1], k, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, L)) : new Date(V[1], k, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, L);
            }
          }
          return new Date(F);
        }(N), this.init();
      }, M.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, M.$utils = function() {
        return R;
      }, M.isValid = function() {
        return this.$d.toString() !== h;
      }, M.isSame = function(N, C) {
        var F = w(N);
        return this.startOf(C) <= F && F <= this.endOf(C);
      }, M.isAfter = function(N, C) {
        return w(N) < this.startOf(C);
      }, M.isBefore = function(N, C) {
        return this.endOf(C) < w(N);
      }, M.$g = function(N, C, F) {
        return R.u(N) ? this[C] : this.set(F, N);
      }, M.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, M.valueOf = function() {
        return this.$d.getTime();
      }, M.startOf = function(N, C) {
        var F = this, x = !!R.u(C) || C, V = R.p(N), k = function(z, Z) {
          var te = R.w(F.$u ? Date.UTC(F.$y, Z, z) : new Date(F.$y, Z, z), F);
          return x ? te : te.endOf(u);
        }, L = function(z, Z) {
          return R.w(F.toDate()[z].apply(F.toDate("s"), (x ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), F);
        }, B = this.$W, G = this.$M, q = this.$D, Y = "set" + (this.$u ? "UTC" : "");
        switch (V) {
          case f:
            return x ? k(1, 0) : k(31, 11);
          case l:
            return x ? k(1, G) : k(0, G + 1);
          case d:
            var H = this.$locale().weekStart || 0, X = (B < H ? B + 7 : B) - H;
            return k(x ? q - X : q + (6 - X), G);
          case u:
          case m:
            return L(Y + "Hours", 0);
          case c:
            return L(Y + "Minutes", 1);
          case s:
            return L(Y + "Seconds", 2);
          case o:
            return L(Y + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, M.endOf = function(N) {
        return this.startOf(N, !1);
      }, M.$set = function(N, C) {
        var F, x = R.p(N), V = "set" + (this.$u ? "UTC" : ""), k = (F = {}, F[u] = V + "Date", F[m] = V + "Date", F[l] = V + "Month", F[f] = V + "FullYear", F[c] = V + "Hours", F[s] = V + "Minutes", F[o] = V + "Seconds", F[a] = V + "Milliseconds", F)[x], L = x === u ? this.$D + (C - this.$W) : C;
        if (x === l || x === f) {
          var B = this.clone().set(m, 1);
          B.$d[k](L), B.init(), this.$d = B.set(m, Math.min(this.$D, B.daysInMonth())).$d;
        } else k && this.$d[k](L);
        return this.init(), this;
      }, M.set = function(N, C) {
        return this.clone().$set(N, C);
      }, M.get = function(N) {
        return this[R.p(N)]();
      }, M.add = function(N, C) {
        var F, x = this;
        N = Number(N);
        var V = R.p(C), k = function(G) {
          var q = w(x);
          return R.w(q.date(q.date() + Math.round(G * N)), x);
        };
        if (V === l) return this.set(l, this.$M + N);
        if (V === f) return this.set(f, this.$y + N);
        if (V === u) return k(1);
        if (V === d) return k(7);
        var L = (F = {}, F[s] = i, F[c] = n, F[o] = r, F)[V] || 1, B = this.$d.getTime() + N * L;
        return R.w(B, this);
      }, M.subtract = function(N, C) {
        return this.add(-1 * N, C);
      }, M.format = function(N) {
        var C = this, F = this.$locale();
        if (!this.isValid()) return F.invalidDate || h;
        var x = N || "YYYY-MM-DDTHH:mm:ssZ", V = R.z(this), k = this.$H, L = this.$m, B = this.$M, G = F.weekdays, q = F.months, Y = F.meridiem, H = function(Z, te, ne, ee) {
          return Z && (Z[te] || Z(C, x)) || ne[te].slice(0, ee);
        }, X = function(Z) {
          return R.s(k % 12 || 12, Z, "0");
        }, z = Y || function(Z, te, ne) {
          var ee = Z < 12 ? "AM" : "PM";
          return ne ? ee.toLowerCase() : ee;
        };
        return x.replace(I, function(Z, te) {
          return te || function(ne) {
            switch (ne) {
              case "YY":
                return String(C.$y).slice(-2);
              case "YYYY":
                return R.s(C.$y, 4, "0");
              case "M":
                return B + 1;
              case "MM":
                return R.s(B + 1, 2, "0");
              case "MMM":
                return H(F.monthsShort, B, q, 3);
              case "MMMM":
                return H(q, B);
              case "D":
                return C.$D;
              case "DD":
                return R.s(C.$D, 2, "0");
              case "d":
                return String(C.$W);
              case "dd":
                return H(F.weekdaysMin, C.$W, G, 2);
              case "ddd":
                return H(F.weekdaysShort, C.$W, G, 3);
              case "dddd":
                return G[C.$W];
              case "H":
                return String(k);
              case "HH":
                return R.s(k, 2, "0");
              case "h":
                return X(1);
              case "hh":
                return X(2);
              case "a":
                return z(k, L, !0);
              case "A":
                return z(k, L, !1);
              case "m":
                return String(L);
              case "mm":
                return R.s(L, 2, "0");
              case "s":
                return String(C.$s);
              case "ss":
                return R.s(C.$s, 2, "0");
              case "SSS":
                return R.s(C.$ms, 3, "0");
              case "Z":
                return V;
            }
            return null;
          }(Z) || V.replace(":", "");
        });
      }, M.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, M.diff = function(N, C, F) {
        var x, V = this, k = R.p(C), L = w(N), B = (L.utcOffset() - this.utcOffset()) * i, G = this - L, q = function() {
          return R.m(V, L);
        };
        switch (k) {
          case f:
            x = q() / 12;
            break;
          case l:
            x = q();
            break;
          case p:
            x = q() / 3;
            break;
          case d:
            x = (G - B) / 6048e5;
            break;
          case u:
            x = (G - B) / 864e5;
            break;
          case c:
            x = G / n;
            break;
          case s:
            x = G / i;
            break;
          case o:
            x = G / r;
            break;
          default:
            x = G;
        }
        return F ? x : R.a(x);
      }, M.daysInMonth = function() {
        return this.endOf(l).$D;
      }, M.$locale = function() {
        return A[this.$L];
      }, M.locale = function(N, C) {
        if (!N) return this.$L;
        var F = this.clone(), x = P(N, C, !0);
        return x && (F.$L = x), F;
      }, M.clone = function() {
        return R.w(this.$d, this);
      }, M.toDate = function() {
        return new Date(this.valueOf());
      }, M.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, M.toISOString = function() {
        return this.$d.toISOString();
      }, M.toString = function() {
        return this.$d.toUTCString();
      }, O;
    }(), E = b.prototype;
    return w.prototype = E, [["$ms", a], ["$s", o], ["$m", s], ["$H", c], ["$W", u], ["$M", l], ["$y", f], ["$D", m]].forEach(function(O) {
      E[O[1]] = function(M) {
        return this.$g(M, O[0], O[1]);
      };
    }), w.extend = function(O, M) {
      return O.$i || (O(M, b, w), O.$i = !0), w;
    }, w.locale = P, w.isDayjs = D, w.unix = function(O) {
      return w(1e3 * O);
    }, w.en = A[T], w.Ls = A, w.p = {}, w;
  });
})(SD);
var rF = SD.exports;
const la = /* @__PURE__ */ da(rF);
var yD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    return function(r, i) {
      var n = i.prototype, a = n.format;
      n.format = function(o) {
        var s = this, c = this.$locale();
        if (!this.isValid()) return a.bind(this)(o);
        var u = this.$utils(), d = (o || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(l) {
          switch (l) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return c.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return c.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return u.s(s.week(), l === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(s.isoWeek(), l === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(s.$H === 0 ? 24 : s.$H), l === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return l;
          }
        });
        return a.bind(this)(d);
      };
    };
  });
})(yD);
var iF = yD.exports;
const nF = /* @__PURE__ */ da(iF);
var AD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, i = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, a = /\d\d/, o = /\d\d?/, s = /\d*[^-_:/,()\s\d]+/, c = {}, u = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, d = function(g) {
      return function(I) {
        this[g] = +I;
      };
    }, l = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(I) {
        if (!I || I === "Z") return 0;
        var U = I.match(/([+-]|\d\d)/g), v = 60 * U[1] + (+U[2] || 0);
        return v === 0 ? 0 : U[0] === "+" ? -v : v;
      }(g);
    }], p = function(g) {
      var I = c[g];
      return I && (I.indexOf ? I : I.s.concat(I.f));
    }, f = function(g, I) {
      var U, v = c.meridiem;
      if (v) {
        for (var S = 1; S <= 24; S += 1) if (g.indexOf(v(S, 0, I)) > -1) {
          U = S > 12;
          break;
        }
      } else U = g === (I ? "pm" : "PM");
      return U;
    }, m = { A: [s, function(g) {
      this.afternoon = f(g, !1);
    }], a: [s, function(g) {
      this.afternoon = f(g, !0);
    }], Q: [n, function(g) {
      this.month = 3 * (g - 1) + 1;
    }], S: [n, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [a, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [o, d("seconds")], ss: [o, d("seconds")], m: [o, d("minutes")], mm: [o, d("minutes")], H: [o, d("hours")], h: [o, d("hours")], HH: [o, d("hours")], hh: [o, d("hours")], D: [o, d("day")], DD: [a, d("day")], Do: [s, function(g) {
      var I = c.ordinal, U = g.match(/\d+/);
      if (this.day = U[0], I) for (var v = 1; v <= 31; v += 1) I(v).replace(/\[|\]/g, "") === g && (this.day = v);
    }], w: [o, d("week")], ww: [a, d("week")], M: [o, d("month")], MM: [a, d("month")], MMM: [s, function(g) {
      var I = p("months"), U = (p("monthsShort") || I.map(function(v) {
        return v.slice(0, 3);
      })).indexOf(g) + 1;
      if (U < 1) throw new Error();
      this.month = U % 12 || U;
    }], MMMM: [s, function(g) {
      var I = p("months").indexOf(g) + 1;
      if (I < 1) throw new Error();
      this.month = I % 12 || I;
    }], Y: [/[+-]?\d+/, d("year")], YY: [a, function(g) {
      this.year = u(g);
    }], YYYY: [/\d{4}/, d("year")], Z: l, ZZ: l };
    function h(g) {
      var I, U;
      I = g, U = c && c.formats;
      for (var v = (g = I.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(w, R, b) {
        var E = b && b.toUpperCase();
        return R || U[b] || r[b] || U[E].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(O, M, N) {
          return M || N.slice(1);
        });
      })).match(i), S = v.length, T = 0; T < S; T += 1) {
        var A = v[T], y = m[A], D = y && y[0], P = y && y[1];
        v[T] = P ? { regex: D, parser: P } : A.replace(/^\[|\]$/g, "");
      }
      return function(w) {
        for (var R = {}, b = 0, E = 0; b < S; b += 1) {
          var O = v[b];
          if (typeof O == "string") E += O.length;
          else {
            var M = O.regex, N = O.parser, C = w.slice(E), F = M.exec(C)[0];
            N.call(R, F), w = w.replace(F, "");
          }
        }
        return function(x) {
          var V = x.afternoon;
          if (V !== void 0) {
            var k = x.hours;
            V ? k < 12 && (x.hours += 12) : k === 12 && (x.hours = 0), delete x.afternoon;
          }
        }(R), R;
      };
    }
    return function(g, I, U) {
      U.p.customParseFormat = !0, g && g.parseTwoDigitYear && (u = g.parseTwoDigitYear);
      var v = I.prototype, S = v.parse;
      v.parse = function(T) {
        var A = T.date, y = T.utc, D = T.args;
        this.$u = y;
        var P = D[1];
        if (typeof P == "string") {
          var w = D[2] === !0, R = D[3] === !0, b = w || R, E = D[2];
          R && (E = D[2]), c = this.$locale(), !w && E && (c = U.Ls[E]), this.$d = function(C, F, x, V) {
            try {
              if (["x", "X"].indexOf(F) > -1) return new Date((F === "X" ? 1e3 : 1) * C);
              var k = h(F)(C), L = k.year, B = k.month, G = k.day, q = k.hours, Y = k.minutes, H = k.seconds, X = k.milliseconds, z = k.zone, Z = k.week, te = /* @__PURE__ */ new Date(), ne = G || (L || B ? 1 : te.getDate()), ee = L || te.getFullYear(), K = 0;
              L && !B || (K = B > 0 ? B - 1 : te.getMonth());
              var J, $ = q || 0, ae = Y || 0, oe = H || 0, ce = X || 0;
              return z ? new Date(Date.UTC(ee, K, ne, $, ae, oe, ce + 60 * z.offset * 1e3)) : x ? new Date(Date.UTC(ee, K, ne, $, ae, oe, ce)) : (J = new Date(ee, K, ne, $, ae, oe, ce), Z && (J = V(J).week(Z).toDate()), J);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(A, P, y, U), this.init(), E && E !== !0 && (this.$L = this.locale(E).$L), b && A != this.format(P) && (this.$d = /* @__PURE__ */ new Date("")), c = {};
        } else if (P instanceof Array) for (var O = P.length, M = 1; M <= O; M += 1) {
          D[1] = P[M - 1];
          var N = U.apply(this, D);
          if (N.isValid()) {
            this.$d = N.$d, this.$L = N.$L, this.init();
            break;
          }
          M === O && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else S.call(this, T);
      };
    };
  });
})(AD);
var aF = AD.exports;
const oF = /* @__PURE__ */ da(aF);
var TD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    return function(r, i, n) {
      i.prototype.dayOfYear = function(a) {
        var o = Math.round((n(this).startOf("day") - n(this).startOf("year")) / 864e5) + 1;
        return a == null ? o : this.add(a - o, "day");
      };
    };
  });
})(TD);
var sF = TD.exports;
const cF = /* @__PURE__ */ da(sF);
var DD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    var r, i, n = 1e3, a = 6e4, o = 36e5, s = 864e5, c = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, l = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, p = { years: u, months: d, days: s, hours: o, minutes: a, seconds: n, milliseconds: 1, weeks: 6048e5 }, f = function(A) {
      return A instanceof S;
    }, m = function(A, y, D) {
      return new S(A, D, y.$l);
    }, h = function(A) {
      return i.p(A) + "s";
    }, g = function(A) {
      return A < 0;
    }, I = function(A) {
      return g(A) ? Math.ceil(A) : Math.floor(A);
    }, U = function(A) {
      return Math.abs(A);
    }, v = function(A, y) {
      return A ? g(A) ? { negative: !0, format: "" + U(A) + y } : { negative: !1, format: "" + A + y } : { negative: !1, format: "" };
    }, S = function() {
      function A(D, P, w) {
        var R = this;
        if (this.$d = {}, this.$l = w, D === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), P) return m(D * p[h(P)], this);
        if (typeof D == "number") return this.$ms = D, this.parseFromMilliseconds(), this;
        if (typeof D == "object") return Object.keys(D).forEach(function(O) {
          R.$d[h(O)] = D[O];
        }), this.calMilliseconds(), this;
        if (typeof D == "string") {
          var b = D.match(l);
          if (b) {
            var E = b.slice(2).map(function(O) {
              return O != null ? Number(O) : 0;
            });
            return this.$d.years = E[0], this.$d.months = E[1], this.$d.weeks = E[2], this.$d.days = E[3], this.$d.hours = E[4], this.$d.minutes = E[5], this.$d.seconds = E[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var y = A.prototype;
      return y.calMilliseconds = function() {
        var D = this;
        this.$ms = Object.keys(this.$d).reduce(function(P, w) {
          return P + (D.$d[w] || 0) * p[w];
        }, 0);
      }, y.parseFromMilliseconds = function() {
        var D = this.$ms;
        this.$d.years = I(D / u), D %= u, this.$d.months = I(D / d), D %= d, this.$d.days = I(D / s), D %= s, this.$d.hours = I(D / o), D %= o, this.$d.minutes = I(D / a), D %= a, this.$d.seconds = I(D / n), D %= n, this.$d.milliseconds = D;
      }, y.toISOString = function() {
        var D = v(this.$d.years, "Y"), P = v(this.$d.months, "M"), w = +this.$d.days || 0;
        this.$d.weeks && (w += 7 * this.$d.weeks);
        var R = v(w, "D"), b = v(this.$d.hours, "H"), E = v(this.$d.minutes, "M"), O = this.$d.seconds || 0;
        this.$d.milliseconds && (O += this.$d.milliseconds / 1e3, O = Math.round(1e3 * O) / 1e3);
        var M = v(O, "S"), N = D.negative || P.negative || R.negative || b.negative || E.negative || M.negative, C = b.format || E.format || M.format ? "T" : "", F = (N ? "-" : "") + "P" + D.format + P.format + R.format + C + b.format + E.format + M.format;
        return F === "P" || F === "-P" ? "P0D" : F;
      }, y.toJSON = function() {
        return this.toISOString();
      }, y.format = function(D) {
        var P = D || "YYYY-MM-DDTHH:mm:ss", w = { Y: this.$d.years, YY: i.s(this.$d.years, 2, "0"), YYYY: i.s(this.$d.years, 4, "0"), M: this.$d.months, MM: i.s(this.$d.months, 2, "0"), D: this.$d.days, DD: i.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: i.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: i.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: i.s(this.$d.seconds, 2, "0"), SSS: i.s(this.$d.milliseconds, 3, "0") };
        return P.replace(c, function(R, b) {
          return b || String(w[R]);
        });
      }, y.as = function(D) {
        return this.$ms / p[h(D)];
      }, y.get = function(D) {
        var P = this.$ms, w = h(D);
        return w === "milliseconds" ? P %= 1e3 : P = w === "weeks" ? I(P / p[w]) : this.$d[w], P || 0;
      }, y.add = function(D, P, w) {
        var R;
        return R = P ? D * p[h(P)] : f(D) ? D.$ms : m(D, this).$ms, m(this.$ms + R * (w ? -1 : 1), this);
      }, y.subtract = function(D, P) {
        return this.add(D, P, !0);
      }, y.locale = function(D) {
        var P = this.clone();
        return P.$l = D, P;
      }, y.clone = function() {
        return m(this.$ms, this);
      }, y.humanize = function(D) {
        return r().add(this.$ms, "ms").locale(this.$l).fromNow(!D);
      }, y.valueOf = function() {
        return this.asMilliseconds();
      }, y.milliseconds = function() {
        return this.get("milliseconds");
      }, y.asMilliseconds = function() {
        return this.as("milliseconds");
      }, y.seconds = function() {
        return this.get("seconds");
      }, y.asSeconds = function() {
        return this.as("seconds");
      }, y.minutes = function() {
        return this.get("minutes");
      }, y.asMinutes = function() {
        return this.as("minutes");
      }, y.hours = function() {
        return this.get("hours");
      }, y.asHours = function() {
        return this.as("hours");
      }, y.days = function() {
        return this.get("days");
      }, y.asDays = function() {
        return this.as("days");
      }, y.weeks = function() {
        return this.get("weeks");
      }, y.asWeeks = function() {
        return this.as("weeks");
      }, y.months = function() {
        return this.get("months");
      }, y.asMonths = function() {
        return this.as("months");
      }, y.years = function() {
        return this.get("years");
      }, y.asYears = function() {
        return this.as("years");
      }, A;
    }(), T = function(A, y, D) {
      return A.add(y.years() * D, "y").add(y.months() * D, "M").add(y.days() * D, "d").add(y.hours() * D, "h").add(y.minutes() * D, "m").add(y.seconds() * D, "s").add(y.milliseconds() * D, "ms");
    };
    return function(A, y, D) {
      r = D, i = D().$utils(), D.duration = function(R, b) {
        var E = D.locale();
        return m(R, { $l: E }, b);
      }, D.isDuration = f;
      var P = y.prototype.add, w = y.prototype.subtract;
      y.prototype.add = function(R, b) {
        return f(R) ? T(this, R, 1) : P.bind(this)(R, b);
      }, y.prototype.subtract = function(R, b) {
        return f(R) ? T(this, R, -1) : w.bind(this)(R, b);
      };
    };
  });
})(DD);
var uF = DD.exports;
const dF = /* @__PURE__ */ da(uF);
var PD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    return function(r, i) {
      i.prototype.isSameOrAfter = function(n, a) {
        return this.isSame(n, a) || this.isAfter(n, a);
      };
    };
  });
})(PD);
var lF = PD.exports;
const pF = /* @__PURE__ */ da(lF);
var wD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    return function(r, i) {
      i.prototype.isSameOrBefore = function(n, a) {
        return this.isSame(n, a) || this.isBefore(n, a);
      };
    };
  });
})(wD);
var fF = wD.exports;
const mF = /* @__PURE__ */ da(fF);
var RD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    return function(r, i, n) {
      r = r || {};
      var a = i.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(u, d, l, p) {
        return a.fromToBase(u, d, l, p);
      }
      n.en.relativeTime = o, a.fromToBase = function(u, d, l, p, f) {
        for (var m, h, g, I = l.$locale().relativeTime || o, U = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], v = U.length, S = 0; S < v; S += 1) {
          var T = U[S];
          T.d && (m = p ? n(u).diff(l, T.d, !0) : l.diff(u, T.d, !0));
          var A = (r.rounding || Math.round)(Math.abs(m));
          if (g = m > 0, A <= T.r || !T.r) {
            A <= 1 && S > 0 && (T = U[S - 1]);
            var y = I[T.l];
            f && (A = f("" + A)), h = typeof y == "string" ? y.replace("%d", A) : y(A, d, T.l, g);
            break;
          }
        }
        if (d) return h;
        var D = g ? I.future : I.past;
        return typeof D == "function" ? D(h) : D.replace("%s", h);
      }, a.to = function(u, d) {
        return s(u, d, this, !0);
      }, a.from = function(u, d) {
        return s(u, d, this);
      };
      var c = function(u) {
        return u.$u ? n.utc() : n();
      };
      a.toNow = function(u) {
        return this.to(c(this), u);
      }, a.fromNow = function(u) {
        return this.from(c(this), u);
      };
    };
  });
})(RD);
var hF = RD.exports;
const gF = /* @__PURE__ */ da(hF);
var bD = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, i = {};
    return function(n, a, o) {
      var s, c = function(p, f, m) {
        m === void 0 && (m = {});
        var h = new Date(p), g = function(I, U) {
          U === void 0 && (U = {});
          var v = U.timeZoneName || "short", S = I + "|" + v, T = i[S];
          return T || (T = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: I, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: v }), i[S] = T), T;
        }(f, m);
        return g.formatToParts(h);
      }, u = function(p, f) {
        for (var m = c(p, f), h = [], g = 0; g < m.length; g += 1) {
          var I = m[g], U = I.type, v = I.value, S = r[U];
          S >= 0 && (h[S] = parseInt(v, 10));
        }
        var T = h[3], A = T === 24 ? 0 : T, y = h[0] + "-" + h[1] + "-" + h[2] + " " + A + ":" + h[4] + ":" + h[5] + ":000", D = +p;
        return (o.utc(y).valueOf() - (D -= D % 1e3)) / 6e4;
      }, d = a.prototype;
      d.tz = function(p, f) {
        p === void 0 && (p = s);
        var m, h = this.utcOffset(), g = this.toDate(), I = g.toLocaleString("en-US", { timeZone: p }), U = Math.round((g - new Date(I)) / 1e3 / 60), v = 15 * -Math.round(g.getTimezoneOffset() / 15) - U;
        if (!Number(v)) m = this.utcOffset(0, f);
        else if (m = o(I, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(v, !0), f) {
          var S = m.utcOffset();
          m = m.add(h - S, "minute");
        }
        return m.$x.$timezone = p, m;
      }, d.offsetName = function(p) {
        var f = this.$x.$timezone || o.tz.guess(), m = c(this.valueOf(), f, { timeZoneName: p }).find(function(h) {
          return h.type.toLowerCase() === "timezonename";
        });
        return m && m.value;
      };
      var l = d.startOf;
      d.startOf = function(p, f) {
        if (!this.$x || !this.$x.$timezone) return l.call(this, p, f);
        var m = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return l.call(m, p, f).tz(this.$x.$timezone, !0);
      }, o.tz = function(p, f, m) {
        var h = m && f, g = m || f || s, I = u(+o(), g);
        if (typeof p != "string") return o(p).tz(g);
        var U = function(A, y, D) {
          var P = A - 60 * y * 1e3, w = u(P, D);
          if (y === w) return [P, y];
          var R = u(P -= 60 * (w - y) * 1e3, D);
          return w === R ? [P, w] : [A - 60 * Math.min(w, R) * 1e3, Math.max(w, R)];
        }(o.utc(p, h).valueOf(), I, g), v = U[0], S = U[1], T = o(v).utcOffset(S);
        return T.$x.$timezone = g, T;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(p) {
        s = p;
      };
    };
  });
})(bD);
var IF = bD.exports;
const vF = /* @__PURE__ */ da(IF);
var ND = { exports: {} };
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(un, function() {
    var r = "minute", i = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
    return function(a, o, s) {
      var c = o.prototype;
      s.utc = function(h) {
        var g = { date: h, utc: !0, args: arguments };
        return new o(g);
      }, c.utc = function(h) {
        var g = s(this.toDate(), { locale: this.$L, utc: !0 });
        return h ? g.add(this.utcOffset(), r) : g;
      }, c.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = c.parse;
      c.parse = function(h) {
        h.utc && (this.$u = !0), this.$utils().u(h.$offset) || (this.$offset = h.$offset), u.call(this, h);
      };
      var d = c.init;
      c.init = function() {
        if (this.$u) {
          var h = this.$d;
          this.$y = h.getUTCFullYear(), this.$M = h.getUTCMonth(), this.$D = h.getUTCDate(), this.$W = h.getUTCDay(), this.$H = h.getUTCHours(), this.$m = h.getUTCMinutes(), this.$s = h.getUTCSeconds(), this.$ms = h.getUTCMilliseconds();
        } else d.call(this);
      };
      var l = c.utcOffset;
      c.utcOffset = function(h, g) {
        var I = this.$utils().u;
        if (I(h)) return this.$u ? 0 : I(this.$offset) ? l.call(this) : this.$offset;
        if (typeof h == "string" && (h = function(T) {
          T === void 0 && (T = "");
          var A = T.match(i);
          if (!A) return null;
          var y = ("" + A[0]).match(n) || ["-", 0, 0], D = y[0], P = 60 * +y[1] + +y[2];
          return P === 0 ? 0 : D === "+" ? P : -P;
        }(h), h === null)) return this;
        var U = Math.abs(h) <= 16 ? 60 * h : h, v = this;
        if (g) return v.$offset = U, v.$u = h === 0, v;
        if (h !== 0) {
          var S = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (v = this.local().add(U + S, r)).$offset = U, v.$x.$localOffset = S;
        } else v = this.utc();
        return v;
      };
      var p = c.format;
      c.format = function(h) {
        var g = h || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return p.call(this, g);
      }, c.valueOf = function() {
        var h = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * h;
      }, c.isUTC = function() {
        return !!this.$u;
      }, c.toISOString = function() {
        return this.toDate().toISOString();
      }, c.toString = function() {
        return this.toDate().toUTCString();
      };
      var f = c.toDate;
      c.toDate = function(h) {
        return h === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : f.call(this);
      };
      var m = c.diff;
      c.diff = function(h, g, I) {
        if (h && this.$u === h.$u) return m.call(this, h, g, I);
        var U = this.local(), v = s(h).local();
        return m.call(U, v, g, I);
      };
    };
  });
})(ND);
var UF = ND.exports;
const SF = /* @__PURE__ */ da(UF);
la.extend(oF);
la.extend(mF);
la.extend(pF);
la.extend(SF);
la.extend(vF);
la.extend(dF);
la.extend(cF);
la.extend(nF);
la.extend(gF);
var Jt = {}, MD = {};
Object.defineProperty(MD, "__esModule", { value: !0 });
var ED = {};
Object.defineProperty(ED, "__esModule", { value: !0 });
var OD = {};
Object.defineProperty(OD, "__esModule", { value: !0 });
var CD = {};
Object.defineProperty(CD, "__esModule", { value: !0 });
var FD = {};
Object.defineProperty(FD, "__esModule", { value: !0 });
var kD = {};
Object.defineProperty(kD, "__esModule", { value: !0 });
var LD = {};
Object.defineProperty(LD, "__esModule", { value: !0 });
var xD = {};
Object.defineProperty(xD, "__esModule", { value: !0 });
var BD = {};
Object.defineProperty(BD, "__esModule", { value: !0 });
var VD = {};
Object.defineProperty(VD, "__esModule", { value: !0 });
var GD = {};
Object.defineProperty(GD, "__esModule", { value: !0 });
var jD = {};
Object.defineProperty(jD, "__esModule", { value: !0 });
var _D = {};
Object.defineProperty(_D, "__esModule", { value: !0 });
var WD = {};
Object.defineProperty(WD, "__esModule", { value: !0 });
var qD = {};
Object.defineProperty(qD, "__esModule", { value: !0 });
var HD = {};
Object.defineProperty(HD, "__esModule", { value: !0 });
var YD = {};
Object.defineProperty(YD, "__esModule", { value: !0 });
var zD = {};
Object.defineProperty(zD, "__esModule", { value: !0 });
var KD = {};
Object.defineProperty(KD, "__esModule", { value: !0 });
var XD = {};
Object.defineProperty(XD, "__esModule", { value: !0 });
var ZD = {};
Object.defineProperty(ZD, "__esModule", { value: !0 });
var QD = {};
Object.defineProperty(QD, "__esModule", { value: !0 });
var JD = {};
Object.defineProperty(JD, "__esModule", { value: !0 });
var $D = {};
Object.defineProperty($D, "__esModule", { value: !0 });
var eP = {};
Object.defineProperty(eP, "__esModule", { value: !0 });
var tP = {};
Object.defineProperty(tP, "__esModule", { value: !0 });
var rP = {};
Object.defineProperty(rP, "__esModule", { value: !0 });
var iP = {};
Object.defineProperty(iP, "__esModule", { value: !0 });
var nP = {};
Object.defineProperty(nP, "__esModule", { value: !0 });
var aP = {};
Object.defineProperty(aP, "__esModule", { value: !0 });
var oP = {};
Object.defineProperty(oP, "__esModule", { value: !0 });
var sP = {};
Object.defineProperty(sP, "__esModule", { value: !0 });
var cP = {};
Object.defineProperty(cP, "__esModule", { value: !0 });
var uP = {};
Object.defineProperty(uP, "__esModule", { value: !0 });
var dP = {};
Object.defineProperty(dP, "__esModule", { value: !0 });
var lP = {};
Object.defineProperty(lP, "__esModule", { value: !0 });
var pP = {};
Object.defineProperty(pP, "__esModule", { value: !0 });
var fP = {};
Object.defineProperty(fP, "__esModule", { value: !0 });
var mP = {};
Object.defineProperty(mP, "__esModule", { value: !0 });
var hP = {};
Object.defineProperty(hP, "__esModule", { value: !0 });
var gP = {};
Object.defineProperty(gP, "__esModule", { value: !0 });
var IP = {};
Object.defineProperty(IP, "__esModule", { value: !0 });
var vP = {};
Object.defineProperty(vP, "__esModule", { value: !0 });
var UP = {};
Object.defineProperty(UP, "__esModule", { value: !0 });
var SP = {};
Object.defineProperty(SP, "__esModule", { value: !0 });
var yP = {};
Object.defineProperty(yP, "__esModule", { value: !0 });
var AP = {};
Object.defineProperty(AP, "__esModule", { value: !0 });
var TP = {};
Object.defineProperty(TP, "__esModule", { value: !0 });
var DP = {};
Object.defineProperty(DP, "__esModule", { value: !0 });
var xp = {};
Object.defineProperty(xp, "__esModule", { value: !0 });
xp.AddressTypeEnum = void 0;
var sA;
(function(e) {
  e.HOME = "HOME", e.MAIL = "MAIL", e.RESIDENTIAL = "RESIDENTIAL", e.VENUE = "VENUE", e.WORK = "WORK", e.PRIMARY = "PRIMARY";
})(sA || (xp.AddressTypeEnum = sA = {}));
var Bp = {};
Object.defineProperty(Bp, "__esModule", { value: !0 });
Bp.BallTypeEnum = void 0;
var cA;
(function(e) {
  e.HIGH_ALTITUDE = "HIGH_ALTITUDE", e.STAGE1GREEN = "STAGE1GREEN", e.STAGE2ORANGE = "STAGE2ORANGE", e.STAGE3RED = "STAGE3RED", e.T2STANDARD_PRESSURELESS = "T2STANDARD_PRESSURELESS", e.T2STANDARD_PRESSURISED = "T2STANDARD_PRESSURISED", e.TYPE1FAST = "TYPE1FAST", e.TYPE3SLOW = "TYPE3SLOW";
})(cA || (Bp.BallTypeEnum = cA = {}));
var Vp = {};
Object.defineProperty(Vp, "__esModule", { value: !0 });
Vp.CategoryEnum = void 0;
var uA;
(function(e) {
  e.AGE = "AGE", e.BOTH = "BOTH", e.LEVEL = "LEVEL";
})(uA || (Vp.CategoryEnum = uA = {}));
var Gp = {};
Object.defineProperty(Gp, "__esModule", { value: !0 });
Gp.CountryCodeEnum = void 0;
var dA;
(function(e) {
  e.AFGHANISTAN = "AFG", e.ALAND_ISLANDS = "ALA", e.ALBANIA = "ALB", e.ALGERIA = "DZA", e.AMERICAN_SAMOA = "ASM", e.ANDORRA = "AND", e.ANGOLA = "AGO", e.ANGUILLA = "AIA", e.ANTARCTICA = "ATA", e.ANTIGUA_AND_BARBUDA = "ATG", e.ANTILLES = "ANT", e.ARGENTINA = "ARG", e.ARMENIA = "ARM", e.ARUBA = "ABW", e.AUSTRALIA = "AUS", e.AUSTRIA = "AUT", e.AZERBAIJAN = "AZE", e.BAHAMAS = "BHS", e.BAHRAIN = "BHR", e.BANGLADESH = "BGD", e.BARBADOS = "BRB", e.BELARUS = "BLR", e.BELGIUM = "BEL", e.BELIZE = "BLZ", e.BENIN = "BEN", e.BERMUDA = "BMU", e.BHUTAN = "BTN", e.BOLIVIA = "BOL", e.BOSNIA_AND_HERZEGOVINA = "BIH", e.BOTSWANA = "BWA", e.BOUVET_ISLAND = "BVT", e.BRAZIL = "BRA", e.BRITISH_INDIAN_OCEAN_TERRITORY = "IOT", e.BRUNEI_DARUSSALAM = "BRN", e.BULGARIA = "BGR", e.BURKINA_FASO = "BFA", e.BURUNDI = "BDI", e.CAMBODIA = "KHM", e.CAMEROON = "CMR", e.CANADA = "CAN", e.CAPE_VERDE = "CPV", e.CAYMAN_ISLANDS = "CYM", e.CENTRAL_AFRICAN_REPUBLIC = "CAF", e.CHAD = "TCD", e.CHILE = "CHL", e.CHINA = "CHN", e.CHRISTMAS_ISLAND = "CXR", e.COCOS_KEELING_ISLANDS = "CCK", e.COLOMBIA = "COL", e.COMOROS = "COM", e.CONGO = "COG", e.CONGO_DEMOCRATIC_REPUBLIC = "COD", e.COOK_ISLANDS = "COK", e.COSTA_RICA = "CRI", e.COTE_D_IVOIRE = "CIV", e.CROATIA = "HRV", e.CUBA = "CUB", e.CYPRUS = "CYP", e.CZECHREPUBLIC = "CZE", e.DENMARK = "DNK", e.DJIBOUTI = "DJI", e.DOMINICA = "DMA", e.DOMINICAN_REPUBLIC = "DOM", e.ECUADOR = "ECU", e.EGYPT = "EGY", e.EL_SALVADOR = "SLV", e.EQUATORIAL_GUINEA = "GNQ", e.ERITREA = "ERI", e.ESTONIA = "ESE", e.ETHIOPIA = "ETH", e.FALKLAND_ISLANDS = "FLK", e.FAROE_ISLANDS = "FRO", e.FIJI = "FJI", e.FINLAND = "FIN", e.FRANCE = "FRA", e.FRENCH_GUIANA = "GUF", e.FRENCH_POLYNESIA = "PYF", e.FRENCH_SOUTHERN_TERRITORIES = "ATF", e.GABON = "GAB", e.GAMBIA = "GMB", e.GEORGIA = "GEO", e.GERMANY = "DEU", e.GHANA = "GHA", e.GIBRALTAR = "GIB", e.GREECE = "GRC", e.GREENLAND = "GRL", e.GRENADA = "GRD", e.GUADELOUPE = "GLP", e.GUAM = "GUM", e.GUATEMALA = "GTM", e.GUERNSEY = "GGY", e.GUINEA = "GIN", e.GUINEA_BISSAU = "GNB", e.GUYANA = "GUY", e.HAITI = "HTI", e.HEARD_ISLAND_MCDONALD_ISLANDS = "HMD", e.HOLY_SEE_VATICAN_CITY_STATE = "VAT", e.HONDURAS = "HND", e.HONGKONG = "HKG", e.HUNGARY = "HUN", e.ICELAND = "ISL", e.INDIA = "IND", e.INDONESIA = "IDN", e.IRAN = "IRN", e.IRAQ = "IRQ", e.IRELAND = "IRL", e.ISLE_OF_MAN = "IMN", e.ISRAEL = "ISR", e.ITALY = "ITA", e.JAMAICA = "JAM", e.JAPAN = "JPN", e.JERSEY = "JEY", e.JORDAN = "JOR", e.KAZAKHSTAN = "KAZ", e.KENYA = "KEN", e.KIRIBATI = "KIR", e.KOREA_REPUBLIC_OF = "KOR", e.KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF = "PRK", e.KUWAIT = "KWT", e.KYRGYZSTAN = "KGZ", e.LAO_PEOPLES_DEMOCRATIC_REPUBLIC = "LAO", e.LATVIA = "LVA", e.LEBANON = "LBN", e.LESOTHO = "LSO", e.LIBERIA = "LBR", e.LIBYAN_ARAB_JAMAHIRIYA = "LBY", e.LIECHTENSTEIN = "LIE", e.LITHUANIA = "LTU", e.LUXEMBOURG = "LUX", e.MACAO = "MAC", e.MADAGASCAR = "MDG", e.MALAWI = "MWI", e.MALAYSIA = "MYS", e.MALDIVES = "MDV", e.MALI = "MLI", e.MALTA = "MLT", e.MARSHALL_ISLANDS = "MHL", e.MARTINIQUE = "MTQ", e.MAURITANIA = "MRT", e.MAURITIUS = "MUS", e.MAYOTTE = "MYT", e.MEXICO = "MEX", e.MICRONESIA = "FSM", e.MOLDOVA = "MDA", e.MONACO = "MCO", e.MONGOLIA = "MNG", e.MONTENEGRO = "MNE", e.MONTSERRAT = "MSR", e.MOROCCO = "MAR", e.MOZAMBIQUE = "MOZ", e.MYANMAR = "MMR", e.NAMIBIA = "NAM", e.NAURU = "NRU", e.NEPAL = "NPL", e.NETHERLANDS = "NLD", e.NEW_CALEDONIA = "NCL", e.NEW_ZEALAND = "NZL", e.NICARAGUA = "NIC", e.NIGER = "NER", e.NIGERIA = "NGA", e.NIUE = "NIU", e.NORFOLK_ISLAND = "NFK", e.NORTHERN_MARIANA_ISLANDS = "MNP", e.NORWAY = "NOR", e.OMAN = "OMN", e.PAKISTAN = "PAK", e.PALAU = "PLW", e.PALESTINIAN_TERRITORY = "PSE", e.PANAMA = "PAN", e.PAPUA_NEW_GUINEA = "PNG", e.PARAGUAY = "PRY", e.PERU = "PER", e.PHILIPPINES = "PHL", e.PITCAIRN = "PCN", e.POLAND = "POL", e.PORTUGAL = "PRT", e.PUERTO_RICO = "PRI", e.QATAR = "QAT", e.REPUBLIC_OF_NORTH_MACEDONIA = "MKD", e.REUNION = "REU", e.ROMANIA = "ROU", e.RUSSIAN_FEDERATION = "RUS", e.RWANDA = "RWA", e.SAINT_BARTHELEMY = "BLM", e.SAINT_HELENA = "SHN", e.SAINT_KITTS_AND_NEVIS = "KNA", e.SAINT_LUCIA = "LCA", e.SAINT_MARTIN = "MAF", e.SAINT_PIERRE_AND_MIQUELON = "SPM", e.SAINT_VINCENT_AND_GRENADINES = "VCT", e.SAMOA = "WSM", e.SAN_MARINO = "SMR", e.SAO_TOME_AND_PRINCIPE = "STP", e.SAUDI_ARABIA = "SAU", e.SENEGAL = "SEN", e.SERBIA = "SRB", e.SEYCHELLES = "SYC", e.SIERRA_LEONE = "SLE", e.SINGAPORE = "SGP", e.SINT_MAARTEN_DUTCH_PART = "SMX", e.SLOVAKIA = "SVK", e.SLOVENIA = "SVN", e.SOLOMON_ISLANDS = "SLB", e.SOMALIA = "SOM", e.SOUTH_AFRICA = "ZAF", e.SOUTH_GEORGIA_AND_SANDWICH_ISLAND = "SGS", e.SOUTH_SUDAN = "SSD", e.SPAIN = "ESP", e.SRI_LANKA = "LKA", e.SUDAN = "SDN", e.SURINAME = "SUR", e.SVALBARD_AND_JAN_MAYEN = "SJM", e.SWAZILAND = "SWZ", e.SWEDEN = "SWE", e.SWITZERLAND = "CHE", e.SYRIAN_ARAB_REPUBLIC = "SYR", e.TAIWAN = "TWN", e.TAJIKISTAN = "TJK", e.TANZANIA = "TZA", e.THAILAND = "THA", e.TIMOR_LESTE = "TLS", e.TOGO = "TGO", e.TOKELAU = "TKL", e.TONGA = "TON", e.TRINIDAD_AND_TOBAGO = "TTO", e.TUNISIA = "TUN", e.TURKEY = "TUR", e.TURKMENISTAN = "TKM", e.TURKS_AND_CAICOS_ISLANDS = "TCA", e.TUVALU = "TUV", e.UGANDA = "UGA", e.UKRAINE = "UKR", e.UNITED_ARAB_EMIRATES = "ARE", e.UNITED_KINGDOM = "GBR", e.UNITED_STATES_OUTLYING_ISLANDS = "UMI", e.UNITED_STATES = "USA", e.URUGUAY = "URY", e.UZBEKISTAN = "UZB", e.VANUATU = "VUT", e.VENEZUELA = "VEN", e.VIETNAM = "VNM", e.VIRGIN_ISLANDS_BRITISH = "VGB", e.VIRGIN_ISLANDS_US = "VIR", e.WALLIS_AND_FUTUNA = "WLF", e.WESTERN_SAHARA = "ESH", e.YEMEN = "YEM", e.ZAMBIA = "ZMB", e.ZIMBABWE = "ZWE";
})(dA || (Gp.CountryCodeEnum = dA = {}));
var jp = {};
Object.defineProperty(jp, "__esModule", { value: !0 });
jp.CourtPositionEnum = void 0;
var lA;
(function(e) {
  e.BASELINE = "BASELINE", e.LEFT_SERVICE_COURT = "LEFT_SERVICE_COURT", e.NET = "NET", e.RIGHT_SERVICE_COURT = "RIGHT_SERVICE_COURT", e.SERVICELINE = "SERVICELINE";
})(lA || (jp.CourtPositionEnum = lA = {}));
var _p = {};
Object.defineProperty(_p, "__esModule", { value: !0 });
_p.DisciplineEnum = void 0;
var pA;
(function(e) {
  e.BEACH_TENNIS = "BEACH_TENNIS", e.PICKLEBALL = "PICKLEBALL", e.PADEL = "PADEL", e.TENNIS = "TENNIS", e.WHEELCHAIR_TENNIS = "WHEELCHAIR_TENNIS";
})(pA || (_p.DisciplineEnum = pA = {}));
var Wp = {};
Object.defineProperty(Wp, "__esModule", { value: !0 });
Wp.DrawStatusEnum = void 0;
var fA;
(function(e) {
  e.COMPLETE = "COMPLETE", e.IN_PROGRESS = "IN_PROGRESS", e.TO_BE_PLAYED = "TO_BE_PLAYED";
})(fA || (Wp.DrawStatusEnum = fA = {}));
var qp = {};
Object.defineProperty(qp, "__esModule", { value: !0 });
qp.DrawStructureEnum = void 0;
var mA;
(function(e) {
  e.COMPASS = "COMPASS", e.CURTIS = "CURTIS_CONSOLATION", e.DOUBLE_ELIMINATION = "DOUBLE_ELIMINATION", e.SINGLE_ELIMINATION = "SINGLE_ELIMINATION", e.FEED_IN = "FEED_IN", e.FEED_IN_CHAMPIONSHIP = "FEED_IN_CHAMPIONSHIP", e.FEED_IN_CHAMPIONSHIP_TO_SF = "FEED_IN_CHAMPIONSHIP_TO_SF", e.FEED_IN_CHAMPIONSHIP_TO_QF = "FEED_IN_CHAMPIONSHIP_TO_QF", e.FEED_IN_CHAMPIONSHIP_TO_R16 = "FEED_IN_CHAMPIONSHIP_TO_R16", e.FICQF = "FEED_IN_CHAMPIONSHIP_TO_QF", e.FICR16 = "FEED_IN_CHAMPIONSHIP_TO_R16", e.FICSF = "FEED_IN_CHAMPIONSHIP_TO_SF", e.FIRST_MATCH_LOSER_CONSOLATION = "FIRST_MATCH_LOSER_CONSOLATION", e.FMLC = "FIRST_MATCH_LOSER_CONSOLATION", e.MFIC = "MODIFIED_FEED_IN_CHAMPIONSHIP", e.MODIFIED_FEED_IN_CHAMPIONSHIP = "MODIFIED_FEED_IN_CHAMPIONSHIP", e.OLYMPIC = "OLYMPIC", e.OTHER = "OTHER", e.PLAYOFF = "PLAYOFF", e.ROUND_ROBIN = "ROUND_ROBIN", e.ROUND_ROBIN_WITH_PLAYOFF = "ROUND_ROBIN_WITH_PLAYOFF", e.FRLC = "FIRST_ROUND_LOSER_CONSOLATION", e.FIRST_ROUND_LOSER_CONSOLATION = "FIRST_ROUND_LOSER_CONSOLATION", e.AD_HOC = "AD_HOC";
})(mA || (qp.DrawStructureEnum = mA = {}));
var Hp = {};
Object.defineProperty(Hp, "__esModule", { value: !0 });
Hp.EntryStatusEnum = void 0;
var hA;
(function(e) {
  e.ALTERNATE = "ALTERNATE", e.CONFIRMED = "CONFIRMED", e.DIRECT_ACCEPTANCE = "DIRECT_ACCEPTANCE", e.FEED_IN = "FEED_IN", e.JUNIOR_EXEMPT = "JUNIOR_EXEMPT", e.LUCKY_LOSER = "LUCKY_LOSER", e.ORGANISER_ACCEPTANCE = "ORGANISER_ACCEPTANCE", e.QUALIFIER = "QUALIFIER", e.REGISTERED = "REGISTERED", e.SPECIAL_EXEMPT = "SPECIAL_EXEMPT", e.WILDCARD = "WILDCARD", e.WITHDRAWN = "WITHDRAWN", e.UNPAIRED = "UNPAIRED", e.UNGROUPED = "UNGROUPED";
})(hA || (Hp.EntryStatusEnum = hA = {}));
var Yp = {};
Object.defineProperty(Yp, "__esModule", { value: !0 });
Yp.EventTypeEnum = void 0;
var gA;
(function(e) {
  e.DOUBLES = "DOUBLES", e.SINGLES = "SINGLES", e.TEAM = "TEAM";
})(gA || (Yp.EventTypeEnum = gA = {}));
var zp = {};
Object.defineProperty(zp, "__esModule", { value: !0 });
zp.FinishingPositionEnum = void 0;
var IA;
(function(e) {
  e.ROUND_OUTCOME = "ROUND_OUTCOME", e.WIN_RATIO = "WIN_RATIO";
})(IA || (zp.FinishingPositionEnum = IA = {}));
var Kp = {};
Object.defineProperty(Kp, "__esModule", { value: !0 });
Kp.GenderEnum = void 0;
var vA;
(function(e) {
  e.ANY = "ANY", e.FEMALE = "FEMALE", e.MALE = "MALE", e.MIXED = "MIXED";
})(vA || (Kp.GenderEnum = vA = {}));
var Xp = {};
Object.defineProperty(Xp, "__esModule", { value: !0 });
Xp.IndoorOutdoorEnum = void 0;
var UA;
(function(e) {
  e.INDOOR = "INDOOR", e.OUTDOOR = "OUTDOOR", e.MIXED = "MIXED";
})(UA || (Xp.IndoorOutdoorEnum = UA = {}));
var Zp = {};
Object.defineProperty(Zp, "__esModule", { value: !0 });
Zp.LengthUnitEnum = void 0;
var SA;
(function(e) {
  e.CENTIMETER = "CENTIMETER", e.METER = "METER", e.MILLIMETER = "MILLIMETER";
})(SA || (Zp.LengthUnitEnum = SA = {}));
var Qp = {};
Object.defineProperty(Qp, "__esModule", { value: !0 });
Qp.LinkConditionEnum = void 0;
var yA;
(function(e) {
  e.FIRST_MATCHUP = "FIRST_MATCHUP";
})(yA || (Qp.LinkConditionEnum = yA = {}));
var Jp = {};
Object.defineProperty(Jp, "__esModule", { value: !0 });
Jp.LinkTypeEnum = void 0;
var AA;
(function(e) {
  e.LOSER = "LOSER", e.WINNER = "WINNER", e.POSITION = "POSITION";
})(AA || (Jp.LinkTypeEnum = AA = {}));
var $p = {};
Object.defineProperty($p, "__esModule", { value: !0 });
$p.MatchUpStatusEnum = void 0;
var TA;
(function(e) {
  e.ABANDONED = "ABANDONED", e.BYE = "BYE", e.COMPLETED = "COMPLETED", e.DEAD_RUBBER = "DEAD_RUBBER", e.DEFAULTED = "DEFAULTED", e.DOUBLE_DEFAULT = "DOUBLE_DEFAULT", e.INCOMPLETE = "INCOMPLETE", e.IN_PROGRESS = "IN_PROGRESS", e.NOT_PLAYED = "NOT_PLAYED", e.RETIRED = "RETIRED", e.SUSPENDED = "SUSPENDED", e.TO_BE_PLAYED = "TO_BE_PLAYED", e.WALKOVER = "WALKOVER", e.DOUBLE_WALKOVER = "DOUBLE_WALKOVER", e.CANCELLED = "CANCELLED", e.AWAITING_RESULT = "AWAITING_RESULT";
})(TA || ($p.MatchUpStatusEnum = TA = {}));
var ef = {};
Object.defineProperty(ef, "__esModule", { value: !0 });
ef.MatchUpTypeEnum = void 0;
var DA;
(function(e) {
  e.DOUBLES = "DOUBLES", e.SINGLES = "SINGLES", e.TEAM = "TEAM";
})(DA || (ef.MatchUpTypeEnum = DA = {}));
var tf = {};
Object.defineProperty(tf, "__esModule", { value: !0 });
tf.OnlineResourceTypeEnum = void 0;
var PA;
(function(e) {
  e.SOCIAL_MEDIA = "SOCIAL_MEDIA", e.URL = "URL", e.EMAIL = "EMAIL", e.OTHER = "OTHER";
})(PA || (tf.OnlineResourceTypeEnum = PA = {}));
var rf = {};
Object.defineProperty(rf, "__esModule", { value: !0 });
rf.OrganisationTypeEnum = void 0;
var wA;
(function(e) {
  e.CLUB = "CLUB", e.NATIONAL_ASSOCIATION = "NATIONAL_ASSOCIATION", e.SCHOOL = "SCHOOL", e.SECTION = "SECTION", e.AREA = "AREA", e.DISTRICT = "DISTRICT", e.OTHER = "OTHER";
})(wA || (rf.OrganisationTypeEnum = wA = {}));
var nf = {};
Object.defineProperty(nf, "__esModule", { value: !0 });
nf.ParticipantRoleEnum = void 0;
var RA;
(function(e) {
  e.ADMINISTRATION = "ADMINISTRATION", e.CAPTAIN = "CAPTAIN", e.COACH = "COACH", e.COMPETITOR = "COMPETITOR", e.MEDIA = "MEDIA", e.MEDICAL = "MEDICAL", e.OFFICIAL = "OFFICIAL", e.OTHER = "OTHER", e.SECURITY = "SECURITY";
})(RA || (nf.ParticipantRoleEnum = RA = {}));
var af = {};
Object.defineProperty(af, "__esModule", { value: !0 });
af.ParticipantStatusEnum = void 0;
var bA;
(function(e) {
  e.ACTIVE = "ACTIVE", e.WITHDRAWN = "WITHDRAWN";
})(bA || (af.ParticipantStatusEnum = bA = {}));
var of = {};
Object.defineProperty(of, "__esModule", { value: !0 });
of.ParticipantTypeEnum = void 0;
var NA;
(function(e) {
  e.INDIVIDUAL = "INDIVIDUAL", e.PAIR = "PAIR", e.TEAM = "TEAM", e.GROUP = "GROUP";
})(NA || (of.ParticipantTypeEnum = NA = {}));
var sf = {};
Object.defineProperty(sf, "__esModule", { value: !0 });
sf.PenaltyTypeEnum = void 0;
var MA;
(function(e) {
  e.BALL_ABUSE = "BALL_ABUSE", e.COACHING = "COACHING", e.DRESS_CODE_VIOLATION = "DRESS_CODE_VIOLATION", e.EQUIMENT_VIOLATION = "EQUIMENT_VIOLATION", e.FAILUIRE_TO_SIGN_IN = "FAILUIRE_TO_SIGN_IN", e.FAILURE_TO_COMPLETE = "FAILURE_TO_COMPLETE", e.INELIGIBILITY = "INELIGIBILITY", e.LEAVING_THE_COURT = "LEAVING_THE_COURT", e.NO_SHOW = "NO_SHOW", e.PHYSICAL_ABUSE = "PHYSICAL_ABUSE", e.PROHIBITED_SUBSTANCE = "PROHIBITED_SUBSTANCE", e.PUNCTUALITY = "PUNCTUALITY", e.RACKET_ABUSE = "RACKET_ABUSE", e.REFUSAL_TO_PLAY = "REFUSAL_TO_PLAY", e.UNSPORTSMANLIKE_CONDUCT = "UNSPORTSMANLIKE_CONDUCT", e.VERBAL_ABUSE = "VERBAL_ABUSE", e.OTHER = "OTHER";
})(MA || (sf.PenaltyTypeEnum = MA = {}));
var cf = {};
Object.defineProperty(cf, "__esModule", { value: !0 });
cf.PlayingDoubleHandCodeEnum = void 0;
var EA;
(function(e) {
  e.BACKHAND = "BACKHAND", e.BOTH = "BOTH", e.FOREHAND = "FOREHAND", e.NONE = "NONE";
})(EA || (cf.PlayingDoubleHandCodeEnum = EA = {}));
var uf = {};
Object.defineProperty(uf, "__esModule", { value: !0 });
uf.PlayingHandCodeEnum = void 0;
var OA;
(function(e) {
  e.AMBIDEXTROUS = "AMBIDEXTROUS", e.LEFT = "LEFT", e.RIGHT = "RIGHT";
})(OA || (uf.PlayingHandCodeEnum = OA = {}));
var df = {};
Object.defineProperty(df, "__esModule", { value: !0 });
df.PositioningProfileEnum = void 0;
var CA;
(function(e) {
  e.BOTTOM_UP = "BOTTOM_UP", e.DRAW = "DRAW", e.LOSS_POSITION = "LOSS_POSITION", e.RANDOM = "RANDOM", e.TOP_DOWN = "TOP_DOWN", e.WATERFALL = "WATERFALL";
})(CA || (df.PositioningProfileEnum = CA = {}));
var lf = {};
Object.defineProperty(lf, "__esModule", { value: !0 });
lf.SexEnum = void 0;
var FA;
(function(e) {
  e.FEMALE = "FEMALE", e.MALE = "MALE";
})(FA || (lf.SexEnum = FA = {}));
var pf = {};
Object.defineProperty(pf, "__esModule", { value: !0 });
pf.ShotDetailEnum = void 0;
var kA;
(function(e) {
  e.DRIVE = "DRIVE", e.DRIVE_VOLLEY = "DRIVE_VOLLEY", e.DROP_SHOT = "DROP_SHOT", e.GROUND_STROKE = "GROUND_STROKE", e.HALF_VOLLEY = "HALF_VOLLEY", e.LOB = "LOB", e.PASSING_SHOT = "PASSING_SHOT", e.SMASH = "SMASH", e.TRICK = "TRICK", e.VOLLEY = "VOLLEY";
})(kA || (pf.ShotDetailEnum = kA = {}));
var ff = {};
Object.defineProperty(ff, "__esModule", { value: !0 });
ff.ShotOutcomeEnum = void 0;
var LA;
(function(e) {
  e.IN = "IN", e.LET = "LET", e.OUT = "OUT";
})(LA || (ff.ShotOutcomeEnum = LA = {}));
var mf = {};
Object.defineProperty(mf, "__esModule", { value: !0 });
mf.ShotTypeEnum = void 0;
var xA;
(function(e) {
  e.BACKHAND = "BACKHAND", e.FOREHAND = "FOREHAND", e.SERVE = "SERVE";
})(xA || (mf.ShotTypeEnum = xA = {}));
var hf = {};
Object.defineProperty(hf, "__esModule", { value: !0 });
hf.StageTypeEnum = void 0;
var BA;
(function(e) {
  e.CONSOLATION = "CONSOLATION", e.MAIN = "MAIN", e.PLAY_OFF = "PLAY_OFF", e.QUALIFYING = "QUALIFYING", e.VOLUNTARY_CONSOLATION = "VOLUNTARY_CONSOLATION";
})(BA || (hf.StageTypeEnum = BA = {}));
var gf = {};
Object.defineProperty(gf, "__esModule", { value: !0 });
gf.StructureTypeEnum = void 0;
var VA;
(function(e) {
  e.CONTAINER = "CONTAINER", e.ITEM = "ITEM";
})(VA || (gf.StructureTypeEnum = VA = {}));
var If = {};
Object.defineProperty(If, "__esModule", { value: !0 });
If.SurfaceCategoryEnum = void 0;
var GA;
(function(e) {
  e.ARTIFICIAL = "ARTIFICIAL", e.CARPET = "CARPET", e.CLAY = "CLAY", e.GRASS = "GRASS", e.HARD = "HARD";
})(GA || (If.SurfaceCategoryEnum = GA = {}));
var vf = {};
Object.defineProperty(vf, "__esModule", { value: !0 });
vf.TeamStatusEnum = void 0;
var jA;
(function(e) {
  e.ACTIVE = "ACTIVE", e.INACTIVE = "INACTIVE", e.SUSPENDED = "SUSPENDED", e.UNKNOWN = "UNKNOWN";
})(jA || (vf.TeamStatusEnum = jA = {}));
var Uf = {};
Object.defineProperty(Uf, "__esModule", { value: !0 });
Uf.TournamentLevelEnum = void 0;
var _A;
(function(e) {
  e.INTERNATIONAL = "INTERNATIONAL", e.ZONAL = "ZONAL", e.LOCAL = "LOCAL", e.NATIONAL = "NATIONAL", e.REGIONAL = "REGIONAL", e.DISTRICT = "DISTRICT", e.CLUB = "CLUB", e.RECREATIONAL = "RECREATIONAL";
})(_A || (Uf.TournamentLevelEnum = _A = {}));
var Sf = {};
Object.defineProperty(Sf, "__esModule", { value: !0 });
Sf.WeekdaysEnum = void 0;
var WA;
(function(e) {
  e.MON = "MON", e.TUE = "TUE", e.WED = "WED", e.THU = "THU", e.FRI = "FRI", e.SAT = "SAT", e.SUN = "SUN";
})(WA || (Sf.WeekdaysEnum = WA = {}));
var yf = {};
Object.defineProperty(yf, "__esModule", { value: !0 });
yf.WeightUnitEnum = void 0;
var qA;
(function(e) {
  e.GRAM = "GRAM", e.KILOGRAM = "KILOGRAM";
})(qA || (yf.WeightUnitEnum = qA = {}));
var Af = {};
Object.defineProperty(Af, "__esModule", { value: !0 });
Af.WheelchairClassEnum = void 0;
var HA;
(function(e) {
  e.STANDARD = "STANDARD", e.QUAD = "QUAD";
})(HA || (Af.WheelchairClassEnum = HA = {}));
var Tf = {};
Object.defineProperty(Tf, "__esModule", { value: !0 });
Tf.WinReasonEnum = void 0;
var YA;
(function(e) {
  e.ACE = "ACE", e.DOUBLE_FAULT = "DOUBLE_FAULT", e.ERROR = "ERROR", e.FORCED = "FORCED", e.NET_CORD = "NET_CORD", e.PENALTY = "PENALTY", e.UNFORCED = "UNFORCED", e.WINNER = "WINNER";
})(YA || (Tf.WinReasonEnum = YA = {}));
var Df = {};
Object.defineProperty(Df, "__esModule", { value: !0 });
Df.TournamentStatusEnum = void 0;
var zA;
(function(e) {
  e.ABANDONED = "ABANDONED", e.CANCELED = "CANCELED";
})(zA || (Df.TournamentStatusEnum = zA = {}));
var Pf = {};
Object.defineProperty(Pf, "__esModule", { value: !0 });
Pf.NationalAssociationSubType = void 0;
var KA;
(function(e) {
  e.STATE = "STATE", e.SECTION = "SECTION", e.GOVERNING_BODY = "GOVERNING_BODY", e.OTHER = "OTHER";
})(KA || (Pf.NationalAssociationSubType = KA = {}));
(function(e) {
  var t = un && un.__createBinding || (Object.create ? function(i, n, a, o) {
    o === void 0 && (o = a);
    var s = Object.getOwnPropertyDescriptor(n, a);
    (!s || ("get" in s ? !n.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return n[a];
    } }), Object.defineProperty(i, o, s);
  } : function(i, n, a, o) {
    o === void 0 && (o = a), i[o] = n[a];
  }), r = un && un.__exportStar || function(i, n) {
    for (var a in i) a !== "default" && !Object.prototype.hasOwnProperty.call(n, a) && t(n, i, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(MD, e), r(ED, e), r(OD, e), r(CD, e), r(FD, e), r(kD, e), r(LD, e), r(xD, e), r(BD, e), r(VD, e), r(GD, e), r(jD, e), r(_D, e), r(WD, e), r(qD, e), r(HD, e), r(YD, e), r(zD, e), r(KD, e), r(XD, e), r(ZD, e), r(QD, e), r(JD, e), r($D, e), r(eP, e), r(tP, e), r(rP, e), r(iP, e), r(nP, e), r(aP, e), r(oP, e), r(sP, e), r(cP, e), r(uP, e), r(dP, e), r(lP, e), r(pP, e), r(fP, e), r(mP, e), r(hP, e), r(gP, e), r(IP, e), r(vP, e), r(UP, e), r(SP, e), r(yP, e), r(AP, e), r(TP, e), r(DP, e), r(xp, e), r(Bp, e), r(Vp, e), r(Gp, e), r(jp, e), r(_p, e), r(Wp, e), r(qp, e), r(Hp, e), r(Yp, e), r(zp, e), r(Kp, e), r(Xp, e), r(Zp, e), r(Qp, e), r(Jp, e), r($p, e), r(ef, e), r(tf, e), r(rf, e), r(nf, e), r(af, e), r(of, e), r(sf, e), r(cf, e), r(uf, e), r(df, e), r(lf, e), r(pf, e), r(ff, e), r(mf, e), r(hf, e), r(gf, e), r(If, e), r(vf, e), r(Uf, e), r(Sf, e), r(yf, e), r(Af, e), r(Tf, e), r(Df, e), r(Pf, e);
})(Jt);
var cg = { exports: {} }, gu = {}, Rl = { exports: {} }, wt = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XA;
function yF() {
  if (XA) return wt;
  XA = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), l = Symbol.iterator;
  function p(k) {
    return k === null || typeof k != "object" ? null : (k = l && k[l] || k["@@iterator"], typeof k == "function" ? k : null);
  }
  var f = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, m = Object.assign, h = {};
  function g(k, L, B) {
    this.props = k, this.context = L, this.refs = h, this.updater = B || f;
  }
  g.prototype.isReactComponent = {}, g.prototype.setState = function(k, L) {
    if (typeof k != "object" && typeof k != "function" && k != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, k, L, "setState");
  }, g.prototype.forceUpdate = function(k) {
    this.updater.enqueueForceUpdate(this, k, "forceUpdate");
  };
  function I() {
  }
  I.prototype = g.prototype;
  function U(k, L, B) {
    this.props = k, this.context = L, this.refs = h, this.updater = B || f;
  }
  var v = U.prototype = new I();
  v.constructor = U, m(v, g.prototype), v.isPureReactComponent = !0;
  var S = Array.isArray, T = Object.prototype.hasOwnProperty, A = { current: null }, y = { key: !0, ref: !0, __self: !0, __source: !0 };
  function D(k, L, B) {
    var G, q = {}, Y = null, H = null;
    if (L != null) for (G in L.ref !== void 0 && (H = L.ref), L.key !== void 0 && (Y = "" + L.key), L) T.call(L, G) && !y.hasOwnProperty(G) && (q[G] = L[G]);
    var X = arguments.length - 2;
    if (X === 1) q.children = B;
    else if (1 < X) {
      for (var z = Array(X), Z = 0; Z < X; Z++) z[Z] = arguments[Z + 2];
      q.children = z;
    }
    if (k && k.defaultProps) for (G in X = k.defaultProps, X) q[G] === void 0 && (q[G] = X[G]);
    return { $$typeof: e, type: k, key: Y, ref: H, props: q, _owner: A.current };
  }
  function P(k, L) {
    return { $$typeof: e, type: k.type, key: L, ref: k.ref, props: k.props, _owner: k._owner };
  }
  function w(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }
  function R(k) {
    var L = { "=": "=0", ":": "=2" };
    return "$" + k.replace(/[=:]/g, function(B) {
      return L[B];
    });
  }
  var b = /\/+/g;
  function E(k, L) {
    return typeof k == "object" && k !== null && k.key != null ? R("" + k.key) : L.toString(36);
  }
  function O(k, L, B, G, q) {
    var Y = typeof k;
    (Y === "undefined" || Y === "boolean") && (k = null);
    var H = !1;
    if (k === null) H = !0;
    else switch (Y) {
      case "string":
      case "number":
        H = !0;
        break;
      case "object":
        switch (k.$$typeof) {
          case e:
          case t:
            H = !0;
        }
    }
    if (H) return H = k, q = q(H), k = G === "" ? "." + E(H, 0) : G, S(q) ? (B = "", k != null && (B = k.replace(b, "$&/") + "/"), O(q, L, B, "", function(Z) {
      return Z;
    })) : q != null && (w(q) && (q = P(q, B + (!q.key || H && H.key === q.key ? "" : ("" + q.key).replace(b, "$&/") + "/") + k)), L.push(q)), 1;
    if (H = 0, G = G === "" ? "." : G + ":", S(k)) for (var X = 0; X < k.length; X++) {
      Y = k[X];
      var z = G + E(Y, X);
      H += O(Y, L, B, z, q);
    }
    else if (z = p(k), typeof z == "function") for (k = z.call(k), X = 0; !(Y = k.next()).done; ) Y = Y.value, z = G + E(Y, X++), H += O(Y, L, B, z, q);
    else if (Y === "object") throw L = String(k), Error("Objects are not valid as a React child (found: " + (L === "[object Object]" ? "object with keys {" + Object.keys(k).join(", ") + "}" : L) + "). If you meant to render a collection of children, use an array instead.");
    return H;
  }
  function M(k, L, B) {
    if (k == null) return k;
    var G = [], q = 0;
    return O(k, G, "", "", function(Y) {
      return L.call(B, Y, q++);
    }), G;
  }
  function N(k) {
    if (k._status === -1) {
      var L = k._result;
      L = L(), L.then(function(B) {
        (k._status === 0 || k._status === -1) && (k._status = 1, k._result = B);
      }, function(B) {
        (k._status === 0 || k._status === -1) && (k._status = 2, k._result = B);
      }), k._status === -1 && (k._status = 0, k._result = L);
    }
    if (k._status === 1) return k._result.default;
    throw k._result;
  }
  var C = { current: null }, F = { transition: null }, x = { ReactCurrentDispatcher: C, ReactCurrentBatchConfig: F, ReactCurrentOwner: A };
  function V() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return wt.Children = { map: M, forEach: function(k, L, B) {
    M(k, function() {
      L.apply(this, arguments);
    }, B);
  }, count: function(k) {
    var L = 0;
    return M(k, function() {
      L++;
    }), L;
  }, toArray: function(k) {
    return M(k, function(L) {
      return L;
    }) || [];
  }, only: function(k) {
    if (!w(k)) throw Error("React.Children.only expected to receive a single React element child.");
    return k;
  } }, wt.Component = g, wt.Fragment = r, wt.Profiler = n, wt.PureComponent = U, wt.StrictMode = i, wt.Suspense = c, wt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = x, wt.act = V, wt.cloneElement = function(k, L, B) {
    if (k == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + k + ".");
    var G = m({}, k.props), q = k.key, Y = k.ref, H = k._owner;
    if (L != null) {
      if (L.ref !== void 0 && (Y = L.ref, H = A.current), L.key !== void 0 && (q = "" + L.key), k.type && k.type.defaultProps) var X = k.type.defaultProps;
      for (z in L) T.call(L, z) && !y.hasOwnProperty(z) && (G[z] = L[z] === void 0 && X !== void 0 ? X[z] : L[z]);
    }
    var z = arguments.length - 2;
    if (z === 1) G.children = B;
    else if (1 < z) {
      X = Array(z);
      for (var Z = 0; Z < z; Z++) X[Z] = arguments[Z + 2];
      G.children = X;
    }
    return { $$typeof: e, type: k.type, key: q, ref: Y, props: G, _owner: H };
  }, wt.createContext = function(k) {
    return k = { $$typeof: o, _currentValue: k, _currentValue2: k, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, k.Provider = { $$typeof: a, _context: k }, k.Consumer = k;
  }, wt.createElement = D, wt.createFactory = function(k) {
    var L = D.bind(null, k);
    return L.type = k, L;
  }, wt.createRef = function() {
    return { current: null };
  }, wt.forwardRef = function(k) {
    return { $$typeof: s, render: k };
  }, wt.isValidElement = w, wt.lazy = function(k) {
    return { $$typeof: d, _payload: { _status: -1, _result: k }, _init: N };
  }, wt.memo = function(k, L) {
    return { $$typeof: u, type: k, compare: L === void 0 ? null : L };
  }, wt.startTransition = function(k) {
    var L = F.transition;
    F.transition = {};
    try {
      k();
    } finally {
      F.transition = L;
    }
  }, wt.unstable_act = V, wt.useCallback = function(k, L) {
    return C.current.useCallback(k, L);
  }, wt.useContext = function(k) {
    return C.current.useContext(k);
  }, wt.useDebugValue = function() {
  }, wt.useDeferredValue = function(k) {
    return C.current.useDeferredValue(k);
  }, wt.useEffect = function(k, L) {
    return C.current.useEffect(k, L);
  }, wt.useId = function() {
    return C.current.useId();
  }, wt.useImperativeHandle = function(k, L, B) {
    return C.current.useImperativeHandle(k, L, B);
  }, wt.useInsertionEffect = function(k, L) {
    return C.current.useInsertionEffect(k, L);
  }, wt.useLayoutEffect = function(k, L) {
    return C.current.useLayoutEffect(k, L);
  }, wt.useMemo = function(k, L) {
    return C.current.useMemo(k, L);
  }, wt.useReducer = function(k, L, B) {
    return C.current.useReducer(k, L, B);
  }, wt.useRef = function(k) {
    return C.current.useRef(k);
  }, wt.useState = function(k) {
    return C.current.useState(k);
  }, wt.useSyncExternalStore = function(k, L, B) {
    return C.current.useSyncExternalStore(k, L, B);
  }, wt.useTransition = function() {
    return C.current.useTransition();
  }, wt.version = "18.3.1", wt;
}
var Uu = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Uu.exports;
var ZA;
function AF() {
  return ZA || (ZA = 1, function(e, t) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var r = "18.3.1", i = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = Symbol.iterator, I = "@@iterator";
      function U(_) {
        if (_ === null || typeof _ != "object")
          return null;
        var re = g && _[g] || _[I];
        return typeof re == "function" ? re : null;
      }
      var v = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, S = {
        transition: null
      }, T = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, A = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, y = {}, D = null;
      function P(_) {
        D = _;
      }
      y.setExtraStackFrame = function(_) {
        D = _;
      }, y.getCurrentStack = null, y.getStackAddendum = function() {
        var _ = "";
        D && (_ += D);
        var re = y.getCurrentStack;
        return re && (_ += re() || ""), _;
      };
      var w = !1, R = !1, b = !1, E = !1, O = !1, M = {
        ReactCurrentDispatcher: v,
        ReactCurrentBatchConfig: S,
        ReactCurrentOwner: A
      };
      M.ReactDebugCurrentFrame = y, M.ReactCurrentActQueue = T;
      function N(_) {
        {
          for (var re = arguments.length, ue = new Array(re > 1 ? re - 1 : 0), le = 1; le < re; le++)
            ue[le - 1] = arguments[le];
          F("warn", _, ue);
        }
      }
      function C(_) {
        {
          for (var re = arguments.length, ue = new Array(re > 1 ? re - 1 : 0), le = 1; le < re; le++)
            ue[le - 1] = arguments[le];
          F("error", _, ue);
        }
      }
      function F(_, re, ue) {
        {
          var le = M.ReactDebugCurrentFrame, Se = le.getStackAddendum();
          Se !== "" && (re += "%s", ue = ue.concat([Se]));
          var et = ue.map(function(Fe) {
            return String(Fe);
          });
          et.unshift("Warning: " + re), Function.prototype.apply.call(console[_], console, et);
        }
      }
      var x = {};
      function V(_, re) {
        {
          var ue = _.constructor, le = ue && (ue.displayName || ue.name) || "ReactClass", Se = le + "." + re;
          if (x[Se])
            return;
          C("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", re, le), x[Se] = !0;
        }
      }
      var k = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(_) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(_, re, ue) {
          V(_, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(_, re, ue, le) {
          V(_, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(_, re, ue, le) {
          V(_, "setState");
        }
      }, L = Object.assign, B = {};
      Object.freeze(B);
      function G(_, re, ue) {
        this.props = _, this.context = re, this.refs = B, this.updater = ue || k;
      }
      G.prototype.isReactComponent = {}, G.prototype.setState = function(_, re) {
        if (typeof _ != "object" && typeof _ != "function" && _ != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, _, re, "setState");
      }, G.prototype.forceUpdate = function(_) {
        this.updater.enqueueForceUpdate(this, _, "forceUpdate");
      };
      {
        var q = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, Y = function(_, re) {
          Object.defineProperty(G.prototype, _, {
            get: function() {
              N("%s(...) is deprecated in plain JavaScript React classes. %s", re[0], re[1]);
            }
          });
        };
        for (var H in q)
          q.hasOwnProperty(H) && Y(H, q[H]);
      }
      function X() {
      }
      X.prototype = G.prototype;
      function z(_, re, ue) {
        this.props = _, this.context = re, this.refs = B, this.updater = ue || k;
      }
      var Z = z.prototype = new X();
      Z.constructor = z, L(Z, G.prototype), Z.isPureReactComponent = !0;
      function te() {
        var _ = {
          current: null
        };
        return Object.seal(_), _;
      }
      var ne = Array.isArray;
      function ee(_) {
        return ne(_);
      }
      function K(_) {
        {
          var re = typeof Symbol == "function" && Symbol.toStringTag, ue = re && _[Symbol.toStringTag] || _.constructor.name || "Object";
          return ue;
        }
      }
      function J(_) {
        try {
          return $(_), !1;
        } catch {
          return !0;
        }
      }
      function $(_) {
        return "" + _;
      }
      function ae(_) {
        if (J(_))
          return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", K(_)), $(_);
      }
      function oe(_, re, ue) {
        var le = _.displayName;
        if (le)
          return le;
        var Se = re.displayName || re.name || "";
        return Se !== "" ? ue + "(" + Se + ")" : ue;
      }
      function ce(_) {
        return _.displayName || "Context";
      }
      function se(_) {
        if (_ == null)
          return null;
        if (typeof _.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof _ == "function")
          return _.displayName || _.name || null;
        if (typeof _ == "string")
          return _;
        switch (_) {
          case a:
            return "Fragment";
          case n:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case l:
            return "Suspense";
          case p:
            return "SuspenseList";
        }
        if (typeof _ == "object")
          switch (_.$$typeof) {
            case u:
              var re = _;
              return ce(re) + ".Consumer";
            case c:
              var ue = _;
              return ce(ue._context) + ".Provider";
            case d:
              return oe(_, _.render, "ForwardRef");
            case f:
              var le = _.displayName || null;
              return le !== null ? le : se(_.type) || "Memo";
            case m: {
              var Se = _, et = Se._payload, Fe = Se._init;
              try {
                return se(Fe(et));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Te = Object.prototype.hasOwnProperty, xe = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, me, rt, Ge;
      Ge = {};
      function Bt(_) {
        if (Te.call(_, "ref")) {
          var re = Object.getOwnPropertyDescriptor(_, "ref").get;
          if (re && re.isReactWarning)
            return !1;
        }
        return _.ref !== void 0;
      }
      function Ut(_) {
        if (Te.call(_, "key")) {
          var re = Object.getOwnPropertyDescriptor(_, "key").get;
          if (re && re.isReactWarning)
            return !1;
        }
        return _.key !== void 0;
      }
      function Re(_, re) {
        var ue = function() {
          me || (me = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", re));
        };
        ue.isReactWarning = !0, Object.defineProperty(_, "key", {
          get: ue,
          configurable: !0
        });
      }
      function De(_, re) {
        var ue = function() {
          rt || (rt = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", re));
        };
        ue.isReactWarning = !0, Object.defineProperty(_, "ref", {
          get: ue,
          configurable: !0
        });
      }
      function ve(_) {
        if (typeof _.ref == "string" && A.current && _.__self && A.current.stateNode !== _.__self) {
          var re = se(A.current.type);
          Ge[re] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', re, _.ref), Ge[re] = !0);
        }
      }
      var Ye = function(_, re, ue, le, Se, et, Fe) {
        var dt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: _,
          key: re,
          ref: ue,
          props: Fe,
          // Record the component responsible for creating this element.
          _owner: et
        };
        return dt._store = {}, Object.defineProperty(dt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(dt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: le
        }), Object.defineProperty(dt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Se
        }), Object.freeze && (Object.freeze(dt.props), Object.freeze(dt)), dt;
      };
      function Ze(_, re, ue) {
        var le, Se = {}, et = null, Fe = null, dt = null, Gt = null;
        if (re != null) {
          Bt(re) && (Fe = re.ref, ve(re)), Ut(re) && (ae(re.key), et = "" + re.key), dt = re.__self === void 0 ? null : re.__self, Gt = re.__source === void 0 ? null : re.__source;
          for (le in re)
            Te.call(re, le) && !xe.hasOwnProperty(le) && (Se[le] = re[le]);
        }
        var dr = arguments.length - 2;
        if (dr === 1)
          Se.children = ue;
        else if (dr > 1) {
          for (var wr = Array(dr), Rr = 0; Rr < dr; Rr++)
            wr[Rr] = arguments[Rr + 2];
          Object.freeze && Object.freeze(wr), Se.children = wr;
        }
        if (_ && _.defaultProps) {
          var Mr = _.defaultProps;
          for (le in Mr)
            Se[le] === void 0 && (Se[le] = Mr[le]);
        }
        if (et || Fe) {
          var Kr = typeof _ == "function" ? _.displayName || _.name || "Unknown" : _;
          et && Re(Se, Kr), Fe && De(Se, Kr);
        }
        return Ye(_, et, Fe, dt, Gt, A.current, Se);
      }
      function Nt(_, re) {
        var ue = Ye(_.type, re, _.ref, _._self, _._source, _._owner, _.props);
        return ue;
      }
      function Tt(_, re, ue) {
        if (_ == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + _ + ".");
        var le, Se = L({}, _.props), et = _.key, Fe = _.ref, dt = _._self, Gt = _._source, dr = _._owner;
        if (re != null) {
          Bt(re) && (Fe = re.ref, dr = A.current), Ut(re) && (ae(re.key), et = "" + re.key);
          var wr;
          _.type && _.type.defaultProps && (wr = _.type.defaultProps);
          for (le in re)
            Te.call(re, le) && !xe.hasOwnProperty(le) && (re[le] === void 0 && wr !== void 0 ? Se[le] = wr[le] : Se[le] = re[le]);
        }
        var Rr = arguments.length - 2;
        if (Rr === 1)
          Se.children = ue;
        else if (Rr > 1) {
          for (var Mr = Array(Rr), Kr = 0; Kr < Rr; Kr++)
            Mr[Kr] = arguments[Kr + 2];
          Se.children = Mr;
        }
        return Ye(_.type, et, Fe, dt, Gt, dr, Se);
      }
      function je(_) {
        return typeof _ == "object" && _ !== null && _.$$typeof === i;
      }
      var It = ".", Zt = ":";
      function _t(_) {
        var re = /[=:]/g, ue = {
          "=": "=0",
          ":": "=2"
        }, le = _.replace(re, function(Se) {
          return ue[Se];
        });
        return "$" + le;
      }
      var er = !1, Mt = /\/+/g;
      function He(_) {
        return _.replace(Mt, "$&/");
      }
      function Me(_, re) {
        return typeof _ == "object" && _ !== null && _.key != null ? (ae(_.key), _t("" + _.key)) : re.toString(36);
      }
      function Ot(_, re, ue, le, Se) {
        var et = typeof _;
        (et === "undefined" || et === "boolean") && (_ = null);
        var Fe = !1;
        if (_ === null)
          Fe = !0;
        else
          switch (et) {
            case "string":
            case "number":
              Fe = !0;
              break;
            case "object":
              switch (_.$$typeof) {
                case i:
                case n:
                  Fe = !0;
              }
          }
        if (Fe) {
          var dt = _, Gt = Se(dt), dr = le === "" ? It + Me(dt, 0) : le;
          if (ee(Gt)) {
            var wr = "";
            dr != null && (wr = He(dr) + "/"), Ot(Gt, re, wr, "", function(tF) {
              return tF;
            });
          } else Gt != null && (je(Gt) && (Gt.key && (!dt || dt.key !== Gt.key) && ae(Gt.key), Gt = Nt(
            Gt,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            ue + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (Gt.key && (!dt || dt.key !== Gt.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              He("" + Gt.key) + "/"
            ) : "") + dr
          )), re.push(Gt));
          return 1;
        }
        var Rr, Mr, Kr = 0, Ui = le === "" ? It : le + Zt;
        if (ee(_))
          for (var wl = 0; wl < _.length; wl++)
            Rr = _[wl], Mr = Ui + Me(Rr, wl), Kr += Ot(Rr, re, ue, Mr, Se);
        else {
          var jh = U(_);
          if (typeof jh == "function") {
            var nA = _;
            jh === nA.entries && (er || N("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), er = !0);
            for (var $C = jh.call(nA), aA, eF = 0; !(aA = $C.next()).done; )
              Rr = aA.value, Mr = Ui + Me(Rr, eF++), Kr += Ot(Rr, re, ue, Mr, Se);
          } else if (et === "object") {
            var oA = String(_);
            throw new Error("Objects are not valid as a React child (found: " + (oA === "[object Object]" ? "object with keys {" + Object.keys(_).join(", ") + "}" : oA) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Kr;
      }
      function vr(_, re, ue) {
        if (_ == null)
          return _;
        var le = [], Se = 0;
        return Ot(_, le, "", "", function(et) {
          return re.call(ue, et, Se++);
        }), le;
      }
      function Dt(_) {
        var re = 0;
        return vr(_, function() {
          re++;
        }), re;
      }
      function mr(_, re, ue) {
        vr(_, function() {
          re.apply(this, arguments);
        }, ue);
      }
      function qr(_) {
        return vr(_, function(re) {
          return re;
        }) || [];
      }
      function Ee(_) {
        if (!je(_))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return _;
      }
      function ir(_) {
        var re = {
          $$typeof: u,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: _,
          _currentValue2: _,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        re.Provider = {
          $$typeof: c,
          _context: re
        };
        var ue = !1, le = !1, Se = !1;
        {
          var et = {
            $$typeof: u,
            _context: re
          };
          Object.defineProperties(et, {
            Provider: {
              get: function() {
                return le || (le = !0, C("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), re.Provider;
              },
              set: function(Fe) {
                re.Provider = Fe;
              }
            },
            _currentValue: {
              get: function() {
                return re._currentValue;
              },
              set: function(Fe) {
                re._currentValue = Fe;
              }
            },
            _currentValue2: {
              get: function() {
                return re._currentValue2;
              },
              set: function(Fe) {
                re._currentValue2 = Fe;
              }
            },
            _threadCount: {
              get: function() {
                return re._threadCount;
              },
              set: function(Fe) {
                re._threadCount = Fe;
              }
            },
            Consumer: {
              get: function() {
                return ue || (ue = !0, C("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), re.Consumer;
              }
            },
            displayName: {
              get: function() {
                return re.displayName;
              },
              set: function(Fe) {
                Se || (N("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Fe), Se = !0);
              }
            }
          }), re.Consumer = et;
        }
        return re._currentRenderer = null, re._currentRenderer2 = null, re;
      }
      var Oe = -1, ot = 0, Qt = 1, Br = 2;
      function br(_) {
        if (_._status === Oe) {
          var re = _._result, ue = re();
          if (ue.then(function(et) {
            if (_._status === ot || _._status === Oe) {
              var Fe = _;
              Fe._status = Qt, Fe._result = et;
            }
          }, function(et) {
            if (_._status === ot || _._status === Oe) {
              var Fe = _;
              Fe._status = Br, Fe._result = et;
            }
          }), _._status === Oe) {
            var le = _;
            le._status = ot, le._result = ue;
          }
        }
        if (_._status === Qt) {
          var Se = _._result;
          return Se === void 0 && C(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Se), "default" in Se || C(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Se), Se.default;
        } else
          throw _._result;
      }
      function Hr(_) {
        var re = {
          // We use these fields to store the result.
          _status: Oe,
          _result: _
        }, ue = {
          $$typeof: m,
          _payload: re,
          _init: br
        };
        {
          var le, Se;
          Object.defineProperties(ue, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return le;
              },
              set: function(et) {
                C("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), le = et, Object.defineProperty(ue, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Se;
              },
              set: function(et) {
                C("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Se = et, Object.defineProperty(ue, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return ue;
      }
      function di(_) {
        _ != null && _.$$typeof === f ? C("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof _ != "function" ? C("forwardRef requires a render function but was given %s.", _ === null ? "null" : typeof _) : _.length !== 0 && _.length !== 2 && C("forwardRef render functions accept exactly two parameters: props and ref. %s", _.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), _ != null && (_.defaultProps != null || _.propTypes != null) && C("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var re = {
          $$typeof: d,
          render: _
        };
        {
          var ue;
          Object.defineProperty(re, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return ue;
            },
            set: function(le) {
              ue = le, !_.name && !_.displayName && (_.displayName = le);
            }
          });
        }
        return re;
      }
      var Wi;
      Wi = Symbol.for("react.module.reference");
      function Q(_) {
        return !!(typeof _ == "string" || typeof _ == "function" || _ === a || _ === s || O || _ === o || _ === l || _ === p || E || _ === h || w || R || b || typeof _ == "object" && _ !== null && (_.$$typeof === m || _.$$typeof === f || _.$$typeof === c || _.$$typeof === u || _.$$typeof === d || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        _.$$typeof === Wi || _.getModuleId !== void 0));
      }
      function pe(_, re) {
        Q(_) || C("memo: The first argument must be a component. Instead received: %s", _ === null ? "null" : typeof _);
        var ue = {
          $$typeof: f,
          type: _,
          compare: re === void 0 ? null : re
        };
        {
          var le;
          Object.defineProperty(ue, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return le;
            },
            set: function(Se) {
              le = Se, !_.name && !_.displayName && (_.displayName = Se);
            }
          });
        }
        return ue;
      }
      function he() {
        var _ = v.current;
        return _ === null && C(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), _;
      }
      function ze(_) {
        var re = he();
        if (_._context !== void 0) {
          var ue = _._context;
          ue.Consumer === _ ? C("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : ue.Provider === _ && C("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return re.useContext(_);
      }
      function Vt(_) {
        var re = he();
        return re.useState(_);
      }
      function tr(_, re, ue) {
        var le = he();
        return le.useReducer(_, re, ue);
      }
      function Ct(_) {
        var re = he();
        return re.useRef(_);
      }
      function Pt(_, re) {
        var ue = he();
        return ue.useEffect(_, re);
      }
      function vi(_, re) {
        var ue = he();
        return ue.useInsertionEffect(_, re);
      }
      function Nr(_, re) {
        var ue = he();
        return ue.useLayoutEffect(_, re);
      }
      function Vr(_, re) {
        var ue = he();
        return ue.useCallback(_, re);
      }
      function an(_, re) {
        var ue = he();
        return ue.useMemo(_, re);
      }
      function mo(_, re, ue) {
        var le = he();
        return le.useImperativeHandle(_, re, ue);
      }
      function Va(_, re) {
        {
          var ue = he();
          return ue.useDebugValue(_, re);
        }
      }
      function Ei() {
        var _ = he();
        return _.useTransition();
      }
      function mu(_) {
        var re = he();
        return re.useDeferredValue(_);
      }
      function Oh() {
        var _ = he();
        return _.useId();
      }
      function Ch(_, re, ue) {
        var le = he();
        return le.useSyncExternalStore(_, re, ue);
      }
      var hu = 0, xy, By, Vy, Gy, jy, _y, Wy;
      function qy() {
      }
      qy.__reactDisabledLog = !0;
      function kC() {
        {
          if (hu === 0) {
            xy = console.log, By = console.info, Vy = console.warn, Gy = console.error, jy = console.group, _y = console.groupCollapsed, Wy = console.groupEnd;
            var _ = {
              configurable: !0,
              enumerable: !0,
              value: qy,
              writable: !0
            };
            Object.defineProperties(console, {
              info: _,
              log: _,
              warn: _,
              error: _,
              group: _,
              groupCollapsed: _,
              groupEnd: _
            });
          }
          hu++;
        }
      }
      function LC() {
        {
          if (hu--, hu === 0) {
            var _ = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: L({}, _, {
                value: xy
              }),
              info: L({}, _, {
                value: By
              }),
              warn: L({}, _, {
                value: Vy
              }),
              error: L({}, _, {
                value: Gy
              }),
              group: L({}, _, {
                value: jy
              }),
              groupCollapsed: L({}, _, {
                value: _y
              }),
              groupEnd: L({}, _, {
                value: Wy
              })
            });
          }
          hu < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Fh = M.ReactCurrentDispatcher, kh;
      function Sl(_, re, ue) {
        {
          if (kh === void 0)
            try {
              throw Error();
            } catch (Se) {
              var le = Se.stack.trim().match(/\n( *(at )?)/);
              kh = le && le[1] || "";
            }
          return `
` + kh + _;
        }
      }
      var Lh = !1, yl;
      {
        var xC = typeof WeakMap == "function" ? WeakMap : Map;
        yl = new xC();
      }
      function Hy(_, re) {
        if (!_ || Lh)
          return "";
        {
          var ue = yl.get(_);
          if (ue !== void 0)
            return ue;
        }
        var le;
        Lh = !0;
        var Se = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var et;
        et = Fh.current, Fh.current = null, kC();
        try {
          if (re) {
            var Fe = function() {
              throw Error();
            };
            if (Object.defineProperty(Fe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Fe, []);
              } catch (Ui) {
                le = Ui;
              }
              Reflect.construct(_, [], Fe);
            } else {
              try {
                Fe.call();
              } catch (Ui) {
                le = Ui;
              }
              _.call(Fe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ui) {
              le = Ui;
            }
            _();
          }
        } catch (Ui) {
          if (Ui && le && typeof Ui.stack == "string") {
            for (var dt = Ui.stack.split(`
`), Gt = le.stack.split(`
`), dr = dt.length - 1, wr = Gt.length - 1; dr >= 1 && wr >= 0 && dt[dr] !== Gt[wr]; )
              wr--;
            for (; dr >= 1 && wr >= 0; dr--, wr--)
              if (dt[dr] !== Gt[wr]) {
                if (dr !== 1 || wr !== 1)
                  do
                    if (dr--, wr--, wr < 0 || dt[dr] !== Gt[wr]) {
                      var Rr = `
` + dt[dr].replace(" at new ", " at ");
                      return _.displayName && Rr.includes("<anonymous>") && (Rr = Rr.replace("<anonymous>", _.displayName)), typeof _ == "function" && yl.set(_, Rr), Rr;
                    }
                  while (dr >= 1 && wr >= 0);
                break;
              }
          }
        } finally {
          Lh = !1, Fh.current = et, LC(), Error.prepareStackTrace = Se;
        }
        var Mr = _ ? _.displayName || _.name : "", Kr = Mr ? Sl(Mr) : "";
        return typeof _ == "function" && yl.set(_, Kr), Kr;
      }
      function BC(_, re, ue) {
        return Hy(_, !1);
      }
      function VC(_) {
        var re = _.prototype;
        return !!(re && re.isReactComponent);
      }
      function Al(_, re, ue) {
        if (_ == null)
          return "";
        if (typeof _ == "function")
          return Hy(_, VC(_));
        if (typeof _ == "string")
          return Sl(_);
        switch (_) {
          case l:
            return Sl("Suspense");
          case p:
            return Sl("SuspenseList");
        }
        if (typeof _ == "object")
          switch (_.$$typeof) {
            case d:
              return BC(_.render);
            case f:
              return Al(_.type, re, ue);
            case m: {
              var le = _, Se = le._payload, et = le._init;
              try {
                return Al(et(Se), re, ue);
              } catch {
              }
            }
          }
        return "";
      }
      var Yy = {}, zy = M.ReactDebugCurrentFrame;
      function Tl(_) {
        if (_) {
          var re = _._owner, ue = Al(_.type, _._source, re ? re.type : null);
          zy.setExtraStackFrame(ue);
        } else
          zy.setExtraStackFrame(null);
      }
      function GC(_, re, ue, le, Se) {
        {
          var et = Function.call.bind(Te);
          for (var Fe in _)
            if (et(_, Fe)) {
              var dt = void 0;
              try {
                if (typeof _[Fe] != "function") {
                  var Gt = Error((le || "React class") + ": " + ue + " type `" + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _[Fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Gt.name = "Invariant Violation", Gt;
                }
                dt = _[Fe](re, Fe, le, ue, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (dr) {
                dt = dr;
              }
              dt && !(dt instanceof Error) && (Tl(Se), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", le || "React class", ue, Fe, typeof dt), Tl(null)), dt instanceof Error && !(dt.message in Yy) && (Yy[dt.message] = !0, Tl(Se), C("Failed %s type: %s", ue, dt.message), Tl(null));
            }
        }
      }
      function Qs(_) {
        if (_) {
          var re = _._owner, ue = Al(_.type, _._source, re ? re.type : null);
          P(ue);
        } else
          P(null);
      }
      var xh;
      xh = !1;
      function Ky() {
        if (A.current) {
          var _ = se(A.current.type);
          if (_)
            return `

Check the render method of \`` + _ + "`.";
        }
        return "";
      }
      function jC(_) {
        if (_ !== void 0) {
          var re = _.fileName.replace(/^.*[\\\/]/, ""), ue = _.lineNumber;
          return `

Check your code at ` + re + ":" + ue + ".";
        }
        return "";
      }
      function _C(_) {
        return _ != null ? jC(_.__source) : "";
      }
      var Xy = {};
      function WC(_) {
        var re = Ky();
        if (!re) {
          var ue = typeof _ == "string" ? _ : _.displayName || _.name;
          ue && (re = `

Check the top-level render call using <` + ue + ">.");
        }
        return re;
      }
      function Zy(_, re) {
        if (!(!_._store || _._store.validated || _.key != null)) {
          _._store.validated = !0;
          var ue = WC(re);
          if (!Xy[ue]) {
            Xy[ue] = !0;
            var le = "";
            _ && _._owner && _._owner !== A.current && (le = " It was passed a child from " + se(_._owner.type) + "."), Qs(_), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ue, le), Qs(null);
          }
        }
      }
      function Qy(_, re) {
        if (typeof _ == "object") {
          if (ee(_))
            for (var ue = 0; ue < _.length; ue++) {
              var le = _[ue];
              je(le) && Zy(le, re);
            }
          else if (je(_))
            _._store && (_._store.validated = !0);
          else if (_) {
            var Se = U(_);
            if (typeof Se == "function" && Se !== _.entries)
              for (var et = Se.call(_), Fe; !(Fe = et.next()).done; )
                je(Fe.value) && Zy(Fe.value, re);
          }
        }
      }
      function Jy(_) {
        {
          var re = _.type;
          if (re == null || typeof re == "string")
            return;
          var ue;
          if (typeof re == "function")
            ue = re.propTypes;
          else if (typeof re == "object" && (re.$$typeof === d || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          re.$$typeof === f))
            ue = re.propTypes;
          else
            return;
          if (ue) {
            var le = se(re);
            GC(ue, _.props, "prop", le, _);
          } else if (re.PropTypes !== void 0 && !xh) {
            xh = !0;
            var Se = se(re);
            C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Se || "Unknown");
          }
          typeof re.getDefaultProps == "function" && !re.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function qC(_) {
        {
          for (var re = Object.keys(_.props), ue = 0; ue < re.length; ue++) {
            var le = re[ue];
            if (le !== "children" && le !== "key") {
              Qs(_), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", le), Qs(null);
              break;
            }
          }
          _.ref !== null && (Qs(_), C("Invalid attribute `ref` supplied to `React.Fragment`."), Qs(null));
        }
      }
      function $y(_, re, ue) {
        var le = Q(_);
        if (!le) {
          var Se = "";
          (_ === void 0 || typeof _ == "object" && _ !== null && Object.keys(_).length === 0) && (Se += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var et = _C(re);
          et ? Se += et : Se += Ky();
          var Fe;
          _ === null ? Fe = "null" : ee(_) ? Fe = "array" : _ !== void 0 && _.$$typeof === i ? (Fe = "<" + (se(_.type) || "Unknown") + " />", Se = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof _, C("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, Se);
        }
        var dt = Ze.apply(this, arguments);
        if (dt == null)
          return dt;
        if (le)
          for (var Gt = 2; Gt < arguments.length; Gt++)
            Qy(arguments[Gt], _);
        return _ === a ? qC(dt) : Jy(dt), dt;
      }
      var eA = !1;
      function HC(_) {
        var re = $y.bind(null, _);
        return re.type = _, eA || (eA = !0, N("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(re, "type", {
          enumerable: !1,
          get: function() {
            return N("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: _
            }), _;
          }
        }), re;
      }
      function YC(_, re, ue) {
        for (var le = Tt.apply(this, arguments), Se = 2; Se < arguments.length; Se++)
          Qy(arguments[Se], le.type);
        return Jy(le), le;
      }
      function zC(_, re) {
        var ue = S.transition;
        S.transition = {};
        var le = S.transition;
        S.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          _();
        } finally {
          if (S.transition = ue, ue === null && le._updatedFibers) {
            var Se = le._updatedFibers.size;
            Se > 10 && N("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), le._updatedFibers.clear();
          }
        }
      }
      var tA = !1, Dl = null;
      function KC(_) {
        if (Dl === null)
          try {
            var re = ("require" + Math.random()).slice(0, 7), ue = e && e[re];
            Dl = ue.call(e, "timers").setImmediate;
          } catch {
            Dl = function(Se) {
              tA === !1 && (tA = !0, typeof MessageChannel > "u" && C("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var et = new MessageChannel();
              et.port1.onmessage = Se, et.port2.postMessage(void 0);
            };
          }
        return Dl(_);
      }
      var Js = 0, rA = !1;
      function iA(_) {
        {
          var re = Js;
          Js++, T.current === null && (T.current = []);
          var ue = T.isBatchingLegacy, le;
          try {
            if (T.isBatchingLegacy = !0, le = _(), !ue && T.didScheduleLegacyUpdate) {
              var Se = T.current;
              Se !== null && (T.didScheduleLegacyUpdate = !1, Gh(Se));
            }
          } catch (Mr) {
            throw Pl(re), Mr;
          } finally {
            T.isBatchingLegacy = ue;
          }
          if (le !== null && typeof le == "object" && typeof le.then == "function") {
            var et = le, Fe = !1, dt = {
              then: function(Mr, Kr) {
                Fe = !0, et.then(function(Ui) {
                  Pl(re), Js === 0 ? Bh(Ui, Mr, Kr) : Mr(Ui);
                }, function(Ui) {
                  Pl(re), Kr(Ui);
                });
              }
            };
            return !rA && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              Fe || (rA = !0, C("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), dt;
          } else {
            var Gt = le;
            if (Pl(re), Js === 0) {
              var dr = T.current;
              dr !== null && (Gh(dr), T.current = null);
              var wr = {
                then: function(Mr, Kr) {
                  T.current === null ? (T.current = [], Bh(Gt, Mr, Kr)) : Mr(Gt);
                }
              };
              return wr;
            } else {
              var Rr = {
                then: function(Mr, Kr) {
                  Mr(Gt);
                }
              };
              return Rr;
            }
          }
        }
      }
      function Pl(_) {
        _ !== Js - 1 && C("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Js = _;
      }
      function Bh(_, re, ue) {
        {
          var le = T.current;
          if (le !== null)
            try {
              Gh(le), KC(function() {
                le.length === 0 ? (T.current = null, re(_)) : Bh(_, re, ue);
              });
            } catch (Se) {
              ue(Se);
            }
          else
            re(_);
        }
      }
      var Vh = !1;
      function Gh(_) {
        if (!Vh) {
          Vh = !0;
          var re = 0;
          try {
            for (; re < _.length; re++) {
              var ue = _[re];
              do
                ue = ue(!0);
              while (ue !== null);
            }
            _.length = 0;
          } catch (le) {
            throw _ = _.slice(re + 1), le;
          } finally {
            Vh = !1;
          }
        }
      }
      var XC = $y, ZC = YC, QC = HC, JC = {
        map: vr,
        forEach: mr,
        count: Dt,
        toArray: qr,
        only: Ee
      };
      t.Children = JC, t.Component = G, t.Fragment = a, t.Profiler = s, t.PureComponent = z, t.StrictMode = o, t.Suspense = l, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = M, t.act = iA, t.cloneElement = ZC, t.createContext = ir, t.createElement = XC, t.createFactory = QC, t.createRef = te, t.forwardRef = di, t.isValidElement = je, t.lazy = Hr, t.memo = pe, t.startTransition = zC, t.unstable_act = iA, t.useCallback = Vr, t.useContext = ze, t.useDebugValue = Va, t.useDeferredValue = mu, t.useEffect = Pt, t.useId = Oh, t.useImperativeHandle = mo, t.useInsertionEffect = vi, t.useLayoutEffect = Nr, t.useMemo = an, t.useReducer = tr, t.useRef = Ct, t.useState = Vt, t.useSyncExternalStore = Ch, t.useTransition = Ei, t.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Uu, Uu.exports)), Uu.exports;
}
var QA;
function lI() {
  return QA || (QA = 1, process.env.NODE_ENV === "production" ? Rl.exports = yF() : Rl.exports = AF()), Rl.exports;
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JA;
function TF() {
  if (JA) return gu;
  JA = 1;
  var e = lI(), t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, l = {}, p = null, f = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (d in c) i.call(c, d) && !a.hasOwnProperty(d) && (l[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) l[d] === void 0 && (l[d] = c[d]);
    return { $$typeof: t, type: s, key: p, ref: f, props: l, _owner: n.current };
  }
  return gu.Fragment = r, gu.jsx = o, gu.jsxs = o, gu;
}
var Iu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $A;
function DF() {
  return $A || ($A = 1, process.env.NODE_ENV !== "production" && function() {
    var e = lI(), t = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m = Symbol.iterator, h = "@@iterator";
    function g(Q) {
      if (Q === null || typeof Q != "object")
        return null;
      var pe = m && Q[m] || Q[h];
      return typeof pe == "function" ? pe : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(Q) {
      {
        for (var pe = arguments.length, he = new Array(pe > 1 ? pe - 1 : 0), ze = 1; ze < pe; ze++)
          he[ze - 1] = arguments[ze];
        v("error", Q, he);
      }
    }
    function v(Q, pe, he) {
      {
        var ze = I.ReactDebugCurrentFrame, Vt = ze.getStackAddendum();
        Vt !== "" && (pe += "%s", he = he.concat([Vt]));
        var tr = he.map(function(Ct) {
          return String(Ct);
        });
        tr.unshift("Warning: " + pe), Function.prototype.apply.call(console[Q], console, tr);
      }
    }
    var S = !1, T = !1, A = !1, y = !1, D = !1, P;
    P = Symbol.for("react.module.reference");
    function w(Q) {
      return !!(typeof Q == "string" || typeof Q == "function" || Q === i || Q === a || D || Q === n || Q === u || Q === d || y || Q === f || S || T || A || typeof Q == "object" && Q !== null && (Q.$$typeof === p || Q.$$typeof === l || Q.$$typeof === o || Q.$$typeof === s || Q.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Q.$$typeof === P || Q.getModuleId !== void 0));
    }
    function R(Q, pe, he) {
      var ze = Q.displayName;
      if (ze)
        return ze;
      var Vt = pe.displayName || pe.name || "";
      return Vt !== "" ? he + "(" + Vt + ")" : he;
    }
    function b(Q) {
      return Q.displayName || "Context";
    }
    function E(Q) {
      if (Q == null)
        return null;
      if (typeof Q.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Q == "function")
        return Q.displayName || Q.name || null;
      if (typeof Q == "string")
        return Q;
      switch (Q) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case n:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof Q == "object")
        switch (Q.$$typeof) {
          case s:
            var pe = Q;
            return b(pe) + ".Consumer";
          case o:
            var he = Q;
            return b(he._context) + ".Provider";
          case c:
            return R(Q, Q.render, "ForwardRef");
          case l:
            var ze = Q.displayName || null;
            return ze !== null ? ze : E(Q.type) || "Memo";
          case p: {
            var Vt = Q, tr = Vt._payload, Ct = Vt._init;
            try {
              return E(Ct(tr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, M = 0, N, C, F, x, V, k, L;
    function B() {
    }
    B.__reactDisabledLog = !0;
    function G() {
      {
        if (M === 0) {
          N = console.log, C = console.info, F = console.warn, x = console.error, V = console.group, k = console.groupCollapsed, L = console.groupEnd;
          var Q = {
            configurable: !0,
            enumerable: !0,
            value: B,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Q,
            log: Q,
            warn: Q,
            error: Q,
            group: Q,
            groupCollapsed: Q,
            groupEnd: Q
          });
        }
        M++;
      }
    }
    function q() {
      {
        if (M--, M === 0) {
          var Q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, Q, {
              value: N
            }),
            info: O({}, Q, {
              value: C
            }),
            warn: O({}, Q, {
              value: F
            }),
            error: O({}, Q, {
              value: x
            }),
            group: O({}, Q, {
              value: V
            }),
            groupCollapsed: O({}, Q, {
              value: k
            }),
            groupEnd: O({}, Q, {
              value: L
            })
          });
        }
        M < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = I.ReactCurrentDispatcher, H;
    function X(Q, pe, he) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (Vt) {
            var ze = Vt.stack.trim().match(/\n( *(at )?)/);
            H = ze && ze[1] || "";
          }
        return `
` + H + Q;
      }
    }
    var z = !1, Z;
    {
      var te = typeof WeakMap == "function" ? WeakMap : Map;
      Z = new te();
    }
    function ne(Q, pe) {
      if (!Q || z)
        return "";
      {
        var he = Z.get(Q);
        if (he !== void 0)
          return he;
      }
      var ze;
      z = !0;
      var Vt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var tr;
      tr = Y.current, Y.current = null, G();
      try {
        if (pe) {
          var Ct = function() {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (Ei) {
              ze = Ei;
            }
            Reflect.construct(Q, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (Ei) {
              ze = Ei;
            }
            Q.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ei) {
            ze = Ei;
          }
          Q();
        }
      } catch (Ei) {
        if (Ei && ze && typeof Ei.stack == "string") {
          for (var Pt = Ei.stack.split(`
`), vi = ze.stack.split(`
`), Nr = Pt.length - 1, Vr = vi.length - 1; Nr >= 1 && Vr >= 0 && Pt[Nr] !== vi[Vr]; )
            Vr--;
          for (; Nr >= 1 && Vr >= 0; Nr--, Vr--)
            if (Pt[Nr] !== vi[Vr]) {
              if (Nr !== 1 || Vr !== 1)
                do
                  if (Nr--, Vr--, Vr < 0 || Pt[Nr] !== vi[Vr]) {
                    var an = `
` + Pt[Nr].replace(" at new ", " at ");
                    return Q.displayName && an.includes("<anonymous>") && (an = an.replace("<anonymous>", Q.displayName)), typeof Q == "function" && Z.set(Q, an), an;
                  }
                while (Nr >= 1 && Vr >= 0);
              break;
            }
        }
      } finally {
        z = !1, Y.current = tr, q(), Error.prepareStackTrace = Vt;
      }
      var mo = Q ? Q.displayName || Q.name : "", Va = mo ? X(mo) : "";
      return typeof Q == "function" && Z.set(Q, Va), Va;
    }
    function ee(Q, pe, he) {
      return ne(Q, !1);
    }
    function K(Q) {
      var pe = Q.prototype;
      return !!(pe && pe.isReactComponent);
    }
    function J(Q, pe, he) {
      if (Q == null)
        return "";
      if (typeof Q == "function")
        return ne(Q, K(Q));
      if (typeof Q == "string")
        return X(Q);
      switch (Q) {
        case u:
          return X("Suspense");
        case d:
          return X("SuspenseList");
      }
      if (typeof Q == "object")
        switch (Q.$$typeof) {
          case c:
            return ee(Q.render);
          case l:
            return J(Q.type, pe, he);
          case p: {
            var ze = Q, Vt = ze._payload, tr = ze._init;
            try {
              return J(tr(Vt), pe, he);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, ae = {}, oe = I.ReactDebugCurrentFrame;
    function ce(Q) {
      if (Q) {
        var pe = Q._owner, he = J(Q.type, Q._source, pe ? pe.type : null);
        oe.setExtraStackFrame(he);
      } else
        oe.setExtraStackFrame(null);
    }
    function se(Q, pe, he, ze, Vt) {
      {
        var tr = Function.call.bind($);
        for (var Ct in Q)
          if (tr(Q, Ct)) {
            var Pt = void 0;
            try {
              if (typeof Q[Ct] != "function") {
                var vi = Error((ze || "React class") + ": " + he + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Q[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw vi.name = "Invariant Violation", vi;
              }
              Pt = Q[Ct](pe, Ct, ze, he, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Nr) {
              Pt = Nr;
            }
            Pt && !(Pt instanceof Error) && (ce(Vt), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ze || "React class", he, Ct, typeof Pt), ce(null)), Pt instanceof Error && !(Pt.message in ae) && (ae[Pt.message] = !0, ce(Vt), U("Failed %s type: %s", he, Pt.message), ce(null));
          }
      }
    }
    var Te = Array.isArray;
    function xe(Q) {
      return Te(Q);
    }
    function me(Q) {
      {
        var pe = typeof Symbol == "function" && Symbol.toStringTag, he = pe && Q[Symbol.toStringTag] || Q.constructor.name || "Object";
        return he;
      }
    }
    function rt(Q) {
      try {
        return Ge(Q), !1;
      } catch {
        return !0;
      }
    }
    function Ge(Q) {
      return "" + Q;
    }
    function Bt(Q) {
      if (rt(Q))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", me(Q)), Ge(Q);
    }
    var Ut = I.ReactCurrentOwner, Re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, De, ve, Ye;
    Ye = {};
    function Ze(Q) {
      if ($.call(Q, "ref")) {
        var pe = Object.getOwnPropertyDescriptor(Q, "ref").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return Q.ref !== void 0;
    }
    function Nt(Q) {
      if ($.call(Q, "key")) {
        var pe = Object.getOwnPropertyDescriptor(Q, "key").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return Q.key !== void 0;
    }
    function Tt(Q, pe) {
      if (typeof Q.ref == "string" && Ut.current && pe && Ut.current.stateNode !== pe) {
        var he = E(Ut.current.type);
        Ye[he] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', E(Ut.current.type), Q.ref), Ye[he] = !0);
      }
    }
    function je(Q, pe) {
      {
        var he = function() {
          De || (De = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        he.isReactWarning = !0, Object.defineProperty(Q, "key", {
          get: he,
          configurable: !0
        });
      }
    }
    function It(Q, pe) {
      {
        var he = function() {
          ve || (ve = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        he.isReactWarning = !0, Object.defineProperty(Q, "ref", {
          get: he,
          configurable: !0
        });
      }
    }
    var Zt = function(Q, pe, he, ze, Vt, tr, Ct) {
      var Pt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Q,
        key: pe,
        ref: he,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: tr
      };
      return Pt._store = {}, Object.defineProperty(Pt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Pt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ze
      }), Object.defineProperty(Pt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Vt
      }), Object.freeze && (Object.freeze(Pt.props), Object.freeze(Pt)), Pt;
    };
    function _t(Q, pe, he, ze, Vt) {
      {
        var tr, Ct = {}, Pt = null, vi = null;
        he !== void 0 && (Bt(he), Pt = "" + he), Nt(pe) && (Bt(pe.key), Pt = "" + pe.key), Ze(pe) && (vi = pe.ref, Tt(pe, Vt));
        for (tr in pe)
          $.call(pe, tr) && !Re.hasOwnProperty(tr) && (Ct[tr] = pe[tr]);
        if (Q && Q.defaultProps) {
          var Nr = Q.defaultProps;
          for (tr in Nr)
            Ct[tr] === void 0 && (Ct[tr] = Nr[tr]);
        }
        if (Pt || vi) {
          var Vr = typeof Q == "function" ? Q.displayName || Q.name || "Unknown" : Q;
          Pt && je(Ct, Vr), vi && It(Ct, Vr);
        }
        return Zt(Q, Pt, vi, Vt, ze, Ut.current, Ct);
      }
    }
    var er = I.ReactCurrentOwner, Mt = I.ReactDebugCurrentFrame;
    function He(Q) {
      if (Q) {
        var pe = Q._owner, he = J(Q.type, Q._source, pe ? pe.type : null);
        Mt.setExtraStackFrame(he);
      } else
        Mt.setExtraStackFrame(null);
    }
    var Me;
    Me = !1;
    function Ot(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === t;
    }
    function vr() {
      {
        if (er.current) {
          var Q = E(er.current.type);
          if (Q)
            return `

Check the render method of \`` + Q + "`.";
        }
        return "";
      }
    }
    function Dt(Q) {
      return "";
    }
    var mr = {};
    function qr(Q) {
      {
        var pe = vr();
        if (!pe) {
          var he = typeof Q == "string" ? Q : Q.displayName || Q.name;
          he && (pe = `

Check the top-level render call using <` + he + ">.");
        }
        return pe;
      }
    }
    function Ee(Q, pe) {
      {
        if (!Q._store || Q._store.validated || Q.key != null)
          return;
        Q._store.validated = !0;
        var he = qr(pe);
        if (mr[he])
          return;
        mr[he] = !0;
        var ze = "";
        Q && Q._owner && Q._owner !== er.current && (ze = " It was passed a child from " + E(Q._owner.type) + "."), He(Q), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', he, ze), He(null);
      }
    }
    function ir(Q, pe) {
      {
        if (typeof Q != "object")
          return;
        if (xe(Q))
          for (var he = 0; he < Q.length; he++) {
            var ze = Q[he];
            Ot(ze) && Ee(ze, pe);
          }
        else if (Ot(Q))
          Q._store && (Q._store.validated = !0);
        else if (Q) {
          var Vt = g(Q);
          if (typeof Vt == "function" && Vt !== Q.entries)
            for (var tr = Vt.call(Q), Ct; !(Ct = tr.next()).done; )
              Ot(Ct.value) && Ee(Ct.value, pe);
        }
      }
    }
    function Oe(Q) {
      {
        var pe = Q.type;
        if (pe == null || typeof pe == "string")
          return;
        var he;
        if (typeof pe == "function")
          he = pe.propTypes;
        else if (typeof pe == "object" && (pe.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        pe.$$typeof === l))
          he = pe.propTypes;
        else
          return;
        if (he) {
          var ze = E(pe);
          se(he, Q.props, "prop", ze, Q);
        } else if (pe.PropTypes !== void 0 && !Me) {
          Me = !0;
          var Vt = E(pe);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Vt || "Unknown");
        }
        typeof pe.getDefaultProps == "function" && !pe.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ot(Q) {
      {
        for (var pe = Object.keys(Q.props), he = 0; he < pe.length; he++) {
          var ze = pe[he];
          if (ze !== "children" && ze !== "key") {
            He(Q), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ze), He(null);
            break;
          }
        }
        Q.ref !== null && (He(Q), U("Invalid attribute `ref` supplied to `React.Fragment`."), He(null));
      }
    }
    var Qt = {};
    function Br(Q, pe, he, ze, Vt, tr) {
      {
        var Ct = w(Q);
        if (!Ct) {
          var Pt = "";
          (Q === void 0 || typeof Q == "object" && Q !== null && Object.keys(Q).length === 0) && (Pt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var vi = Dt();
          vi ? Pt += vi : Pt += vr();
          var Nr;
          Q === null ? Nr = "null" : xe(Q) ? Nr = "array" : Q !== void 0 && Q.$$typeof === t ? (Nr = "<" + (E(Q.type) || "Unknown") + " />", Pt = " Did you accidentally export a JSX literal instead of a component?") : Nr = typeof Q, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Nr, Pt);
        }
        var Vr = _t(Q, pe, he, Vt, tr);
        if (Vr == null)
          return Vr;
        if (Ct) {
          var an = pe.children;
          if (an !== void 0)
            if (ze)
              if (xe(an)) {
                for (var mo = 0; mo < an.length; mo++)
                  ir(an[mo], Q);
                Object.freeze && Object.freeze(an);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ir(an, Q);
        }
        if ($.call(pe, "key")) {
          var Va = E(Q), Ei = Object.keys(pe).filter(function(Ch) {
            return Ch !== "key";
          }), mu = Ei.length > 0 ? "{key: someKey, " + Ei.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qt[Va + mu]) {
            var Oh = Ei.length > 0 ? "{" + Ei.join(": ..., ") + ": ...}" : "{}";
            U(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mu, Va, Oh, Va), Qt[Va + mu] = !0;
          }
        }
        return Q === i ? ot(Vr) : Oe(Vr), Vr;
      }
    }
    function br(Q, pe, he) {
      return Br(Q, pe, he, !0);
    }
    function Hr(Q, pe, he) {
      return Br(Q, pe, he, !1);
    }
    var di = Hr, Wi = br;
    Iu.Fragment = i, Iu.jsx = di, Iu.jsxs = Wi;
  }()), Iu;
}
process.env.NODE_ENV === "production" ? cg.exports = TF() : cg.exports = DF();
var Ai = cg.exports, PF = Object.defineProperty, qe = (e, t) => {
  for (var r in t) PF(e, r, { get: t[r], enumerable: !0 });
};
function wf() {
  return "2.2.12";
}
var PP = {};
qe(PP, { competitionGovernor: () => wP, drawsGovernor: () => Ub, entriesGovernor: () => RE, eventGovernor: () => FE, generationGovernor: () => ZE, matchUpFormatGovernor: () => s1, matchUpGovernor: () => c1, mocksGovernor: () => cy, participantGovernor: () => tO, policyGovernor: () => tE, publishingGovernor: () => DO, queryGovernor: () => aE, reportGovernor: () => CO, scheduleGovernor: () => FO, scoreGovernor: () => KU, tieFormatGovernor: () => YO, tournamentGovernor: () => tC, venueGovernor: () => mC });
var wP = {};
qe(wP, { getLinkedTournamentIds: () => yd, getTournamentIds: () => Ud, linkTournaments: () => hb, mutate: () => RP, query: () => vb, unlinkTournament: () => Ib, unlinkTournaments: () => gb });
var RP = {};
qe(RP, { linkTournaments: () => hb, unlinkTournament: () => Ib, unlinkTournaments: () => gb });
var es = "SINGLES", mt = "SINGLES", Ao = "DOUBLES", ft = "DOUBLES", Ci = "TEAM", yt = "TEAM", wF = { SINGLES_MATCHUP: es, SINGLES: mt, DOUBLES_MATCHUP: Ao, DOUBLES: ft, TEAM_MATCHUP: Ci, TEAM: yt }, bP = { [mt]: [mt, "S"], [ft]: [ft, "D"], [yt]: [yt, "T"], S: [mt, "S"], D: [ft, "D"], T: [yt, "T"] };
function ar(e, t) {
  return (e ?? 0) - (t ?? 0);
}
function be(e) {
  return typeof e == "number" ? parseInt(e.toString()) : typeof e == "string" ? parseInt(e) : 0;
}
function Rn(e) {
  return isNaN(e) ? !1 : e && (e & e - 1) === 0;
}
function eT(e) {
  if (!e.length) return;
  let t = [...e].sort(ar), r = Math.floor(t.length / 2);
  return t.length % 2 ? t[r] : (t[r - 1] + t[r]) / 2;
}
function RF(e) {
  if (!Rn(e)) return !1;
  let t = e, r = 1;
  for (; t !== 2; ) r += 1, t = t / 2;
  return r;
}
function pI(e) {
  return isNaN(e) ? 0 : e % 2 && e + 1 || e;
}
function fI(e) {
  return Math.pow(2, Math.round(Math.log(e) / Math.log(2)));
}
function jt(e) {
  return !isNaN(parseFloat(e));
}
function NP(e) {
  let t = be(e);
  if (!isNaN(t)) return t === 0 ? !1 : (t & -t) === 1;
}
function Lc(e) {
  if (isNaN(e)) return !1;
  for (; !Rn(e); ) e++;
  return e;
}
function Hi(e, t) {
  return e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e;
}
function ke(e) {
  return Number.isSafeInteger(typeof e == "string" ? +e : e);
}
function bF(e = 1, t = 3, r = !0) {
  let i = 0;
  for (let n = 0; n < t; n++) i += Math.random() * (e / t);
  return r && e > 1 ? Math.round(i) : i;
}
function NF(e, t) {
  t || (t = 1);
  let r = 1 / t;
  return Math.round(e * r) / r;
}
function MP(e, t, r, i, n = 2) {
  let a = 1 - Math.random(), o = 1 - Math.random(), s = Math.sqrt(-2 * Math.log(a)) * Math.cos(2 * Math.PI * o);
  return s = s / 10 + 0.5, s > 1 || s < 0 ? s = MP(e, t, r) : (s = Math.pow(s, r), s *= t - e, s += e), i && (s = NF(s, i)), parseFloat(s.toFixed(n));
}
function ep(e, t = 2) {
  return parseFloat(Number(Math.round(e * 1e3) / 1e3).toFixed(t));
}
function Be(e) {
  return Array.isArray(e) ? e == null ? void 0 : e.filter((t, r, i) => i.lastIndexOf(t) === r) : [];
}
function MF(e) {
  return Array.isArray(e) ? e == null ? void 0 : e.map((t) => t === null ? void 0 : t) : e;
}
function Xr(e) {
  return Array.isArray(e) ? e.map((t) => [Math.random(), t]).sort((t, r) => t[0] - r[0]).map((t) => t[1]) : [];
}
function lc(e) {
  return ke(e) ? e : 1 / 0;
}
function wi(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] || (t[r] = 0), t[r]++, t), {}) : {};
}
function EF(e) {
  return EP(wi(e));
}
function EP(e) {
  return Object.keys(e).reduce((t, r) => {
    let i = e[r];
    return t[i] ? t[i].push(r) : t[i] = [r], t;
  }, {});
}
function OF(e, t, r) {
  return r.indexOf(e) === t;
}
function OP(e) {
  return e.filter(OF);
}
function Di(e) {
  return Array.isArray(e) && e.length ? e.splice(Math.floor(Math.random() * e.length), 1)[0] : void 0;
}
function yi(e) {
  let t = Math.floor(Math.random() * e.length);
  return e[t];
}
function fe(e, t) {
  return Array.from({ length: t - e }, (r, i) => i + e);
}
function Ln(e, t) {
  return t.reduce((r, i, n) => (i === e && r.push(n), r), []);
}
function qt(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => t.indexOf(r) !== -1).filter((r, i, n) => n.indexOf(r) === i);
}
function tT(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => !t.includes(r));
}
function Jr(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? !1 : e.some((r) => t.includes(r));
}
function CF(e, t) {
  return Array.isArray(t) && t.reduce((r, i) => (r[i] = 1 + r[i] || 1, r), {})[e] || 0;
}
function FF(e, t, r, i) {
  return Array.isArray(e) ? [].concat(...e.slice(0, t), ...e.slice(t, t + r).sort(i), ...e.slice(t + r, e.length)) : [];
}
function gr(e, t) {
  return Array.isArray(e) ? e.reduce((r, i, n) => {
    let a = Math.floor(n / t);
    return r[a] = [].concat(r[a] || [], i), r;
  }, []) : [];
}
function CP(e, [t, ...r]) {
  return e.length ? [e.slice(0, t), ...CP(e.slice(t), [...r, t])] : [];
}
function kF(e) {
  return e.reduce((t, r) => {
    let i = t[t.length - 1];
    return (!i || i[i.length - 1] !== r - 1) && t.push([]), t[t.length - 1].push(r), t;
  }, []);
}
function FP(e) {
  return Array.isArray(e) ? e.reduce((t, r) => !isNaN(parseInt(r)) && t, !0) : !1;
}
function kP(e) {
  return Array.isArray(e) ? e.reduce((t, r) => isNaN(parseInt(r)) && t, !0) : !1;
}
function ug(e, t, r) {
  return Array.isArray(e) ? e.reduce((i, n, a) => {
    let o = r ? !!(Math.floor(a / t) % 2) : !1, s = a % t, c = o ? t - 1 - s : s;
    return i[c] || (i[c] = []), i[c].push(n), i;
  }, []) : [];
}
function LF(e, t = 1) {
  if (!Array.isArray(e) || !e.every(ke)) return [];
  let r = Math.min(...e, t), i = Math.max(...e);
  return fe(r, i + 1).filter((n) => !e.includes(n));
}
function Ti(e) {
  return typeof e == "function";
}
function Et(e) {
  return typeof e == "string";
}
function $e(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function xF(e, t) {
  if (!$e(e) || !$e(t)) return !1;
  let r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length) return !1;
  for (let n of r) if (e[n] !== t[n]) return !1;
  return !0;
}
function LP(e, t) {
  return Array.isArray(e) ? Object.assign({}, ...(e ?? []).filter($e).map((r) => r[t] && { [r[t]]: r }).filter(Boolean)) : {};
}
var BF = (e) => (t) => Object.keys(e).every((r) => t[r] === e[r]);
function dg(e, t) {
  if (e === void 0) return null;
  if (!$e(e) || e === null) return e;
  let r = Object.keys(e), i = (n) => n === void 0 ? null : n;
  return Object.assign({}, ...r.map((n) => Array.isArray(e[n]) ? { [n]: t ? e[n] : e[n].map((a) => dg(a)) } : { [n]: t ? i(e[n]) : dg(e[n]) }));
}
function lg(e) {
  return Array.isArray(e) ? e.length + e.map(lg).reduce((t, r) => t + r, 0) : $e(e) && e !== null ? Object.keys(e).length + Object.keys(e).map((t) => lg(e[t])).reduce((t, r) => t + r, 0) : 0;
}
function VF(e) {
  if (e === null || typeof e != "object") return;
  let t = JSON.stringify(e), r = lg(e), i = t.split("").reduce((n, a) => n + a.charCodeAt(0), 0);
  return [t.length, r, i].map((n) => n.toString(36)).join("");
}
function Rf(e, t) {
  return !Array.isArray(e) || !Et(t) ? !1 : qt(e, bP[t]).length;
}
var j = { success: !0 }, xP = "error", GF = { SUCCESS: j, ERROR: xP };
function BP({ collectionValueProfiles: e, matchUpCount: t }) {
  let r = [];
  if (!Array.isArray(e)) return r.push(`collectionValueProfiles is not an array: ${e}`), { errors: r };
  if (e.length && e.length !== t) return r.push("collectionValueProfiles do not align with matchUpsCount"), { errors: r };
  for (let n of e) {
    if (typeof n != "object") return r.push(`valueProfile is not type object: ${n}`), { errors: r };
    let { matchUpValue: a, collectionPosition: o } = n;
    if (typeof a != "number" || typeof o != "number" || o > t || o < 1) return r.push("Invalid value profile: value and collectionPosition must be numeric. collectionPosition cannot be greater than matchUpCount"), { errors: r };
  }
  let i = e.map((n) => n.collectionPosition);
  return i.length !== Be(i).length ? (r.push("collectionPositions are not unique"), { errors: r }) : { ...j };
}
var jF = {};
qe(jF, { addNotice: () => Le, callListener: () => yg, createInstanceState: () => Ak, cycleMutationStatus: () => _I, deepCopyEnabled: () => jI, deleteNotice: () => WI, deleteNotices: () => ud, disableNotifications: () => Xw, enableNotifications: () => Bl, getDevContext: () => ki, getMethods: () => Jw, getNotices: () => $w, getProvider: () => Ag, getTopics: () => Ji, getTournamentId: () => bs, getTournamentRecord: () => qI, getTournamentRecords: () => Ns, globalLog: () => rR, handleCaughtError: () => qf, hasTopic: () => _f, removeTournamentRecord: () => tR, setDeepCopy: () => Fu, setDevContext: () => Cu, setGlobalLog: () => Kw, setGlobalMethods: () => Zw, setGlobalSubscriptions: () => Dk, setMethods: () => Qw, setStateMethods: () => iR, setStateProvider: () => yk, setSubscriptions: () => Pk, setTournamentId: () => ku, setTournamentRecord: () => eR, setTournamentRecords: () => Wf, timeKeeper: () => Tk });
var pg = { message: "Chronological error; time violation.", code: "ANACHRONISM" }, Eu = { message: "Duplicate entry", code: "DUPLICATE_ENTRY" }, VP = { message: "Cannot remove main structure", code: "ERR_CANNOT_REMOVE_MAIN_STRUCTURE" }, fg = { message: "records must be an object with tournamentId keys", code: "ERR_INVALID_TOURNAMENTS" }, xt = { message: "Missing tournamentRecords", code: "ERR_MISSING_TOURNAMENTS" }, de = { message: "Missing tournamentRecord", code: "ERR_MISSING_TOURNAMENT" }, nd = { message: "Invalid tournamentRecord", code: "ERR_INVALID_TOURNAMENT" }, pc = { message: "Missing tournamentId", code: "ERR_MISSING_TOURNAMENT_ID" }, ts = { message: "Invalid drawDefinition", code: "ERR_INVALID_DRAWDEF" }, Ue = { message: "Missing drawDefinition", code: "ERR_MISSING_DRAWDEF" }, GP = { message: "Existing drawDefinition(s)", code: "ERR_EXISTING_DRAWDEFS" }, Fi = { message: "drawDefinition not found", code: "ERR_NOT_FOUND_DRAWDEF" }, xo = { message: "Invalid structure", code: "ERR_INVALID_STRUCTURE" }, mI = { message: "Incomplete source structure", code: "ERR_INCOMPLETE_STRUCTURE" }, hI = { message: "Invalid drawPosition for seedAssignment", code: "ERR_INVALID_SEEDING_POSITION" }, fc = { message: "drawPosition already assigned", code: "ERR_EXISTING_POSITION_ASSIGNMENT" }, jP = { message: "Schedule not cleared", code: "ERR_UNCHANGED_SCHEDULE_NOT_CLEARED" }, _P = { message: "drawPosition not cleared", code: "ERR_FAILURE_POSITION_NOT_CLEARED" }, _F = { message: "drawPosition not found", code: "ERR_NOT_FOUND_DRAW_POSITION" }, gI = { message: "Unrecognized drawType", code: "ERR_UNRECOGNIZED_DRAW_TYPE" }, ad = { message: "Missing drawPositions", code: "ERR_MISSING_DRAW_POSITIONS" }, bf = { message: "drawPosition is active", code: "ERR_ACTIVE_DRAW_POSITION" }, WF = { message: "drawPosition is occupied", code: "ERR_OCCUPIED_DRAW_POSITION" }, xc = { message: "Invlid drawPosition", code: "ERR_INVALID_DRAW_POSITION" }, Bc = { message: "Missing drawPosition", code: "ERR_MISSING_DRAW_POSITION" }, II = { message: "Invalid drawType", code: "ERR_INVALID_DRAW_TYPE" }, Nf = { message: "Invalid drawSize", code: "ERR_INVALID_DRAW_SIZE" }, vI = { message: "Cannot set drawSize to be less than existing entries", code: "ERR_INVALID_DRAW_SIZE_MISMATCH" }, od = { message: "Missing drawSize", code: "ERR_MISSING_DRAW_SIZE" }, Cn = { message: "Missing drawId", code: "ERR_MISSING_DRAW_ID" }, WP = { message: "drawId exists", code: "ERR_EXISTING_DRAW_ID" }, qP = { message: "participantId cannot be assigned to multiple seedNumbers", code: "INVALID_PARTICIPANT_SEEDING" }, HP = { message: "seedsCount greater than drawSize", code: "ERR_INVALID_SEED_COUNT" }, YP = { message: "Missing seedCountThresholds", code: "ERR_MISSING_SEED_COUNT_THRESHOLD" }, zP = { message: "Invalid action", code: "ERR_INVALID_ACTION" }, mg = { message: "Invalid assignment", code: "ERR_INVALID_ASSIGNMENT" }, KP = { message: "Missing seedAssignments", code: "ERR_MISSING_SEED_ASSIGNMENTS" }, XP = { message: "Invalid seedNumber", code: "ERR_INVALID_SEED_NUMBER" }, ZP = { message: "Invalid seedPosition", code: "ERR_INVALID_SEED_POSITION" }, UI = { message: "Missing targetLink", code: "ERR_MISSING_LINK_TARGET" }, QP = { message: "Existing round", code: "ERR_EXISTING_ROUND" }, qF = { message: "Missing roundNumber", code: "ERR_MISSING_ROUND_NUMBER" }, Vi = { message: "Missing structureId", code: "ERR_MISSING_STRUCTURE_ID" }, kt = { message: "structure not found", code: "ERR_NOT_FOUND_STRUCTURE" }, SI = { message: "Missing structures", code: "ERR_MISSING_STRUCTURES" }, Bo = { message: "Missing structure", code: "ERR_MISSING_STRUCTURE" }, JP = { message: "drawDefinition contains unlinked structures", code: "ERR_MISSING_STRUCTURE_LINKS" }, na = { message: "Invalid eventType", code: "ERR_INVALID_EVENT_TYPE" }, At = { message: "Missing event / eventId", code: "ERR_MISSING_EVENT_ID" }, Ki = { message: "Event not found", code: "ERR_NOT_FOUND_EVENT" }, $P = { message: "Event exists", code: "ERR_EXISTING_EVENT" }, ew = { message: "Missing entries", code: "ERR_MISSING_ENTRIES" }, tw = { message: "Invalid entries", code: "ERR_INVALID_ENTRIES" }, yI = { message: "Missing assignments", code: "ERR_MISSING_ASSIGNMENTS" }, rw = { message: "Missing stage", code: "ERR_MISSING_STAGE" }, Vo = { message: "Invalid stage", code: "ERR_INVALID_STAGE" }, iw = { message: "stageSequence limit", code: "ERR_LIMIT_STAGE_SEQUENCE" }, nw = { message: "Missing positionAssignments", code: "ERR_MISSING_POSITION_ASSIGNMENTS" }, aw = { message: "Cannot Assign BYE status if no assignment: { bye: true }", code: "ERR_UNCHANGED_CANNOT_ASSIGN_BYE" }, hg = { message: "Unrecognized matchUpStatus", code: "ERR_UNRECOGNIZED_MATCHUP_STATUS" }, sd = { message: "Unrecognized matchUpFormat", code: "ERR_UNRECOGNIZED_MATCHUP_FORMAT" }, Ll = { message: "Incompatible matchUpStatus", code: "ERR_INCOMPATIBLE_MATCHUP_STATUS" }, Vc = { message: "Invalid matchUpStatus", code: "ERR_INVALID_MATCHUP_STATUS" }, Jn = { message: "Invalid tieFormat", code: "ERR_INVALID_TIE_FORMAT" }, AI = { message: "Invalid matchUpFormat", code: "ERR_INVALID_MATCHUP_FORMAT" }, TI = { message: "Missing matchUpFormat", code: "ERR_MISSING_MATCHUP_FORMAT" }, ow = { message: "Missing collectionDefinition", code: "ERR_MISSING_COLLECTION_DEFINITION" }, Gc = { message: "Missing tieFormat", code: "ERR_MISSING_TIE_FORMAT" }, zr = { message: "Missing matchUpId", code: "ERR_MISSING_MATCHUP_ID" }, Ts = { message: "Missing matchUpIds", code: "ERR_MISSING_MATCHUP_IDS" }, jr = { message: "matchUp not found", code: "ERR_NOT_FOUND_MATCHUP" }, Ma = { message: "Missing matchUps", code: "ERR_MISSING_MATCHUPS" }, hi = { message: "Missing matchUp", code: "ERR_MISSING_MATCHUP" }, gi = { message: "Invalid matchUp", code: "ERR_INVALID_MATCHUP" }, DI = { message: "Missing policyType", code: "ERR_MISSING_POLICY_TYPE" }, Mf = { message: "Missing policyDefinitions", code: "ERR_MISSING_POLICY_DEFINITIONS" }, HF = { message: "Missing seeding policy", code: "ERR_MISSING_POLICY_SEEDING" }, sw = { message: "Missing avoidance policy", code: "ERR_MISSING_POLICY_AVOIDANCE" }, PI = { message: "Missing policy attributes", code: "ERR_MISSING_POLICY_ATTRIBUTES" }, cw = { message: "Invalid policyDefinitions", code: "ERR_INVALID_POLICY_DEFINITIONS" }, wI = { message: "existing policyType", code: "ERR_EXISTING_POLICY_TYPE" }, YF = { message: "Policy not attached", code: "ERR_FAILURE_POLICY_NOT_ATTACHED" }, rs = { message: "Policy not found", code: "ERR_NOT_FOUND_POLICY" }, zF = { message: "Missing scoring policy / matchUpFormats", code: "ERR_MISSING_POLICY_SCORING_MATCHUP_FORMATS" }, RI = { message: "Invalid sideNumber", code: "ERR_INVALID_SIDE_NUMBER" }, KF = { message: "Invalid setNumber", code: "ERR_INVALID_SET_NUMBER" }, Ef = { message: "Missing setObject", code: "ERR_MISSING_SET_ATTRIBUTE" }, XF = { message: "Missing setNumber", code: "ERR_MISSING_SET_NUMBER" }, ZF = { message: "Missing sideNumber", code: "ERR_MISSING_SIDE_NUMBER" }, Ds = { message: "Missing courtId", code: "ERR_MISSING_COURT_ID" }, we = { message: "Missing value", code: "ERR_MISSING_VALUE" }, uw = { message: "Missing birthdate", code: "ERR_MISSING_BIRTH_DATE" }, dw = { message: "Missing date", code: "ERR_MISSING_DATE" }, lw = { message: "No valid dates", code: "ERR_NO_VALID_DATES" }, tp = { message: "Invalid bookings", code: "ERR_INVALID_BOOKINGS" }, xl = { message: "Invalid dateAvailability", code: "ERR_INVALID_DATE_AVAILABILITY" }, pw = { message: "Missing dateAvailability", code: "ERR_MISSING_DATE_AVAILABILITY" }, Sr = { message: "Invalid Date", code: "ERR_INVALID_DATE" }, on = { message: "Invalid time", code: "ERR_INVALID_TIME" }, fw = { message: "Invalid tournament dates", code: "ERR_INVALID_DATES_TOURNAMENT" }, gg = { message: "Invalid game scores", code: "ERR_INVALID_SCORES_GAME" }, mw = { message: "Invalid score", code: "ERR_INVALID_SCORE" }, Of = { message: "Invalid winningSide", code: "ERR_INVALID_WINNING_SIDE" }, QF = { message: "No participants generated", code: "ERR_NO_PARTICIPANTS_GENERATED" }, bI = { message: "Cannot modify tieFormat", code: "ERR_UNCHANGED_CANNOT_MODIFY_TIEFORMAT" }, hw = { message: "Cannot modify participantType", code: "ERR_UNCHANGED_CANNOT_MODIFY_PARTICIPANT_TYPE" }, Cf = { message: "Cannot remove participants", code: "ERR_UNCHANGED_CANNOT_REMOVE_PARTICIPANTS" }, Ig = { message: "Participant category mismatch", code: "ERR_CATEGORY_MISMATCH" }, Ff = { message: "Cannot change winningSide", code: "ERR_UNCHANGED_CANNOT_CHANGE_WINNING_SIDE" }, Ps = { message: "Invalid participant", code: "ERR_INVALID_PARTICIPANT" }, bn = { message: "Invalid participantId", code: "ERR_INVALID_PARTICIPANT_ID" }, Pi = { message: "Invalid participantIds", code: "ERR_INVALID_PARTICIPANT_IDS" }, gw = { message: "Invalid participantRole", code: "ERR_INVALID_PARTICIPANT_ROLE" }, Nn = { message: "Invalid participantType", code: "ERR_INVALID_PARTICIPANT_TYPE" }, Iw = { message: "Missing participantRole", code: "ERR_MISSING_PARTICIPANT_ROLE" }, ws = { message: "Missing participant", code: "ERR_MISSING_PARTICIPANT" }, cd = { message: "Missing participants", code: "ERR_MISSING_PARTICIPANTS" }, cr = { message: "Missing participantId", code: "ERR_MISSING_PARTICIPANT_ID" }, Yt = { message: "Participant Not Found", code: "ERR_NOT_FOUND_PARTICIPANT" }, vw = { message: "participantId exists", code: "ERR_EXISTING_PARTICIPANT_ID" }, JF = { message: "participant pair exists", code: "ERR_EXISTING_PARTICIPANT_PAIR" }, Uw = { message: "No participant removed", code: "ERR_UNCHANGED_NO_PARTICIPANT_REMOVED" }, ro = { message: "Missing participantIds", code: "ERR_MISSING_PARTICIPANT_IDS" }, Sw = { message: "Missing participantsCount", code: "ERR_MISSING_PARTICIPANT_COUNT" }, yw = { message: "Participant not checked in", code: "ERR_UNCHANGED_PARTICIPANT_NOT_CHECKED_IN" }, Aw = { message: "Missing person details", code: "ERR_MISSING_PERSON_DETAILS" }, jc = { message: "Existing participant drawPosition assignment", code: "ERR_EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT" }, kf = { message: "Existing participant", code: "ERR_EXISTING_PARTICIPANT" }, NI = { message: "participantsCount exceeds drawSize", code: "ERR_INVALID_PARTICIPANT_COUNT" }, vg = { message: "Invalid entry status", code: "ERR_INVALID_ENTRY_STATUS" }, Tw = { message: "Participant Entry Not Found", code: "ERR_NOT_FOUND_PARTICIPANT_ENTRY" }, $F = { message: "Participant not entered in stage", code: "ERR_UNCHANGED_PARTICIPANT_NOT_ENTERED" }, ek = { message: "Participant not found in stageSequence", code: "ERR_NOT_FOUND_PARTICIPANT_IN_STAGE" }, Dw = { message: "entryStatus not allowed in stage", code: "ERR_INVALID_ENTRY_STATUS_IN_STAGE" }, Pw = { message: "entryStatus not allowed for event", code: "ERR_INVALID_ENTRY_STATUS_IN_EVENT" }, Ug = { message: "No stage space available for entryStatus", code: "ERR_UNCHANGED_NO_AVAILABLE_STAGE_SPACE" }, ww = { message: "Insufficient drawPositions to accommodate qualifiers", code: "ERR_UNCHANGED_NO_DRAW_POSITIONS_FOR_QUALIFIERS" }, MI = { message: "Insufficient drawPositions to accommodate entries", code: "ERR_INSUFFICIENT_DRAW_POSITIONS" }, Rw = { message: "Missing penaltyType", code: "ERR_MISSING_PENALTY_TYPE" }, EI = { message: "Missing penaltyId", code: "ERR_MISSING_PENALTY_ID" }, mc = { message: "Penalty not found", code: "ERR_NOT_FOUND_PENALTY" }, bw = { message: "Missing courtsCount/courtNames", code: "ERR_MISSING_COURTS_INFO" }, _c = { message: "Court not found", code: "ERR_NOT_FOUND_COURT" }, Nw = { message: "Court exists", code: "ERR_EXISTING_COURT" }, Mw = { message: "Venue exists", code: "ERR_EXISTING_VENUE" }, Rs = { message: "Venue not found", code: "ERR_NOT_FOUND_VENUE" }, io = { message: "Missing venueId", code: "ERR_MISSING_VENUE_ID" }, Ew = { message: "Invalid endTime", code: "ERR_INVALID_END_TIME" }, OI = { message: "Existing endTime", code: "ERR_EXISTING_END_TIME" }, Ow = { message: "Invalid stopTime", code: "ERR_INVALID_STOP_TIME" }, Cw = { message: "Invalid startTime", code: "ERR_INVALID_START_TIME" }, tk = { message: "Invalid resumeTime", code: "ERR_INVALID_RESUME_TIME" }, CI = { message: "Invalid timeItem", code: "ERR_INVALID_TIME_ITEMS" }, Fw = { message: "Missing async state provider", code: "ERR_MISSING_ASYNC_STATE_PROVIDER" }, FI = { message: "Missing timeItem", code: "ERR_MISSING_TIME_ITEM" }, kI = { message: "Missing timeItems", code: "ERR_MISSING_TIME_ITEMS" }, Lf = { message: "Missing context", code: "ERR_MISSING_CONTEXT" }, kw = { message: "Missing schedule", code: "ERR_MISSING_SCHEDULE" }, ps = { message: "Invalid scaleItem", code: "ERR_INVALID_SCALE_ITEM" }, Lw = { message: "Modifications failed", code: "ERR_FAILURE_MODIFICATIONS" }, Wc = { message: "No modifications applied", code: "ERR_UNCHANGED_NO_MODIFICATIONS_APPLIED" }, xw = { message: "Unable to assign court", code: "ERR_UNCHANGED_COURT_NOT_ASSIGNED" }, xf = { message: "No Candidates", code: "ERR_UNCHANGED_NO_CANDIDATES" }, Bw = { message: "Invalid configuration", code: "ERR_INVALID_CONFIG" }, Vw = { message: "Invalid collectionDefinition", code: "ERR_INVALID_COLLECTION_DEFINITION" }, Ea = { message: "Invalid object", code: "ERR_INVALID_OBJECT" }, Au = { message: "Invalid gender", code: "ERR_INVALID_GENDER" }, Ou = { message: "Invalid category", code: "ERR_INVALID_CATEGORY" }, ie = { message: "Invalid values", code: "ERR_INVALID_VALUES" }, Gw = { message: "Duplicate value", code: "ERR_DUPLICATE_VALUE" }, LI = { message: "Team not found", code: "ERR_NOT_FOUND_TEAM" }, jw = { message: "No valid actions", code: "ERR_NO_VALID_ACTIONS" }, Bf = { message: "No valid attributes", code: "ERR_NO_VALID_ATTRIBUTES" }, xI = { message: "Value unchanged", code: "ABORT_UNCHANGED" }, Tr = { message: "Not found", code: "ERR_NOT_FOUND" }, Vf = { message: "Not implemented", code: "ERR_NOT_IMPLEMENTED" }, _w = { message: "Existing flight", code: "ERR_EXISTING_FLIGHT" }, BI = { message: "Existing flight profile", code: "ERR_EXISTING_FLIGHT_PROFILE" }, Ww = { message: "Existing outcome", code: "ERR_EXISTING_OUTCOME" }, qw = { message: "Existing matchUpId", code: "ERR_EXISTING_MATCHUP_ID" }, Sg = { message: "Existing stage", code: "ERR_EXISTING_STAGE" }, VI = { message: "Existing structure", code: "ERR_EXISTING_STRUCTURE" }, Gf = { message: "Method not found", code: "ERR_NOT_FOUND_METHOD" }, Hw = { message: "Scheduled matchUps", code: "ERR_SCHEDULED_MATCHUPS" }, jf = { message: "Scores present", code: "ERR_SCORES_PRESENT" }, rk = { ANACHRONISM: pg, CANNOT_CHANGE_WINNING_SIDE: Ff, CANNOT_MODIFY_TIEFORMAT: bI, CANNOT_MODIFY_PARTICIPANT_TYPE: hw, CANNOT_REMOVE_MAIN_STRUCTURE: VP, CANNOT_REMOVE_PARTICIPANTS: Cf, CATEGORY_MISMATCH: Ig, COURT_EXISTS: Nw, COURT_NOT_FOUND: _c, DRAW_DEFINITION_NOT_FOUND: Fi, DRAW_ID_EXISTS: WP, DRAW_POSITION_ACTIVE: bf, DRAW_POSITION_ASSIGNED: fc, DRAW_POSITION_NOT_CLEARED: _P, DRAW_POSITION_NOT_FOUND: _F, DRAW_SIZE_MISMATCH: vI, DUPLICATE_ENTRY: Eu, DUPLICATE_VALUE: Gw, ENTRY_STATUS_NOT_ALLOWED_FOR_EVENT: Pw, ENTRY_STATUS_NOT_ALLOWED_IN_STAGE: Dw, EVENT_EXISTS: $P, EVENT_NOT_FOUND: Ki, EXISTING_DRAW_DEFINITIONS: GP, EXISTING_END_TIME: OI, EXISTING_FLIGHT: _w, EXISTING_MATCHUP_ID: qw, EXISTING_OUTCOME: Ww, EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT: jc, EXISTING_PARTICIPANT: kf, EXISTING_POLICY_TYPE: wI, EXISTING_PROFILE: BI, EXISTING_ROUND: QP, EXISTING_STAGE: Sg, EXISTING_STRUCTURE: VI, INCOMPATIBLE_MATCHUP_STATUS: Ll, INCOMPLETE_SOURCE_STRUCTURE: mI, INSUFFICIENT_DRAW_POSITIONS: MI, INVALID_ACTION: zP, INVALID_ASSIGNMENT: mg, INVALID_BOOKINGS: tp, INVALID_CATEGORY: Ou, INVALID_COLLECTION_DEFINITION: Vw, INVALID_CONFIGURATION: Bw, INVALID_DATE_AVAILABILITY: xl, INVALID_DATE: Sr, INVALID_DRAW_DEFINITION: ts, INVALID_DRAW_POSITION_FOR_SEEDING: hI, INVALID_DRAW_POSITION: xc, INVALID_DRAW_SIZE: Nf, INVALID_END_TIME: Ew, INVALID_ENTRIES: tw, INVALID_EVENT_TYPE: na, INVALID_GAME_SCORES: gg, INVALID_GENDER: Au, INVALID_MATCHUP_FORMAT: AI, INVALID_MATCHUP_STATUS: Vc, INVALID_MATCHUP_STATUS_BYE: aw, INVALID_MATCHUP: gi, INVALID_OBJECT: Ea, INVALID_PARTICIPANT_ID: bn, INVALID_PARTICIPANT_IDS: Pi, INVALID_PARTICIPANT_ROLE: gw, INVALID_PARTICIPANT_SEEDING: qP, INVALID_PARTICIPANT_TYPE: Nn, INVALID_PARTICIPANT: Ps, INVALID_POLICY_DEFINITION: cw, INVALID_RECORDS: fg, INVALID_SCALE_ITEM: ps, INVALID_SEED_NUMBER: XP, INVALID_SEED_POSITION: ZP, INVALID_SET_NUMBER: KF, INVALID_SIDE_NUMBER: RI, INVALID_SCORE: mw, INVALID_STAGE: Vo, INVALID_START_TIME: Cw, INVALID_STRUCTURE: xo, INVALID_STOP_TIME: Ow, INVALID_TIE_FORMAT: Jn, INVALID_TIME: on, INVALID_TIME_ITEM: CI, INVALID_TOURNAMENT_DATES: fw, INVALID_TOURNAMENT_RECORD: nd, INVALID_VALUES: ie, INVALID_WINNING_SIDE: Of, MATCHUP_NOT_FOUND: jr, METHOD_NOT_FOUND: Gf, MISSING_ASSIGNMENTS: yI, MISSING_ASYNC_STATE_PROVIDER: Fw, MISSING_AVOIDANCE_POLICY: sw, MISSING_BIRTH_DATE: uw, MISSING_COLLECTION_DEFINITION: ow, MISSING_COURT_ID: Ds, MISSING_COURTS_INFO: bw, MISSING_DATE_AVAILABILITY: pw, MISSING_DATE: dw, MISSING_DRAW_DEFINITION: Ue, MISSING_DRAW_ID: Cn, MISSING_DRAW_POSITION: Bc, MISSING_DRAW_POSITIONS: ad, MISSING_DRAW_SIZE: od, MISSING_ENTRIES: ew, MISSING_EVENT: At, MISSING_MATCHUP_FORMAT: TI, MISSING_MATCHUP_ID: zr, MISSING_MATCHUP_IDS: Ts, MISSING_MATCHUP: hi, MISSING_MATCHUPS: Ma, MISSING_PARTICIPANT_COUNT: Sw, MISSING_PARTICIPANT_ID: cr, MISSING_PARTICIPANT_IDS: ro, MISSING_PARTICIPANT_ROLE: Iw, MISSING_PARTICIPANT: ws, MISSING_PARTICIPANTS: cd, MISSING_PENALTY_ID: EI, MISSING_PENALTY_TYPE: Rw, MISSING_PERSON_DETAILS: Aw, MISSING_POLICY_ATTRIBUTES: PI, MISSING_POLICY_DEFINITION: Mf, MISSING_POLICY_TYPE: DI, MISSING_POSITION_ASSIGNMENTS: nw, MISSING_ROUND_NUMBER: qF, MISSING_SCHEDULE: kw, MISSING_SCORING_POLICY: zF, MISSING_SEED_ASSIGNMENTS: KP, MISSING_SEEDCOUNT_THRESHOLDS: YP, MISSING_SEEDING_POLICY: HF, MISSING_SET_NUMBER: XF, MISSING_SET_OBJECT: Ef, MISSING_SIDE_NUMBER: ZF, MISSING_STAGE: rw, MISSING_STRUCTURE_ID: Vi, MISSING_STRUCTURE: Bo, MISSING_STRUCTURES: SI, MISSING_TARGET_LINK: UI, MISSING_TIE_FORMAT: Gc, MISSING_TIME_ITEM: FI, MISSING_TIME_ITEMS: kI, MISSING_TOURNAMENT_ID: pc, MISSING_TOURNAMENT_RECORD: de, MISSING_TOURNAMENT_RECORDS: xt, MISSING_VALUE: we, MISSING_VENUE_ID: io, MODIFICATIONS_FAILED: Lw, NO_CANDIDATES: xf, NO_DRAW_POSITIONS_AVAILABLE_FOR_QUALIFIERS: ww, NO_MODIFICATIONS_APPLIED: Wc, NO_STAGE_SPACE_AVAILABLE_FOR_ENTRY_STATUS: Ug, NO_PARTICIPANT_REMOVED: Uw, NO_VALID_ACTIONS: jw, NO_VALID_ATTRIBUTES: Bf, NO_VALID_DATES: lw, NOT_FOUND: Tr, NOT_IMPLEMENTED: Vf, PARTICIPANT_COUNT_EXCEEDS_DRAW_SIZE: NI, PARTICIPANT_ID_EXISTS: vw, PARTICIPANT_NOT_CHECKED_IN: yw, PARTICIPANT_NOT_FOUND: Yt, PARTICIPANT_PAIR_EXISTS: JF, PENALTY_NOT_FOUND: mc, POLICY_NOT_ATTACHED: YF, POLICY_NOT_FOUND: rs, SCHEDULE_NOT_CLEARED: jP, SCHEDULED_MATCHUPS: Hw, SCORES_PRESENT: jf, SEEDSCOUNT_GREATER_THAN_DRAW_SIZE: HP, STAGE_SEQUENCE_LIMIT: iw, STRUCTURE_NOT_FOUND: kt, TEAM_NOT_FOUND: LI, UNABLE_TO_ASSIGN_COURT: xw, UNLINKED_STRUCTURES: JP, UNRECOGNIZED_DRAW_TYPE: gI, UNRECOGNIZED_MATCHUP_FORMAT: sd, UNRECOGNIZED_MATCHUP_STATUS: hg, VALUE_UNCHANGED: xI, VENUE_EXISTS: Mw }, Ft = { disableNotifications: !1, tournamentId: void 0, tournamentRecords: {}, subscriptions: {}, modified: !1, methods: {}, notices: [] }, Yw = { addNotice: mk, callListener: Uk, cycleMutationStatus: fk, deleteNotice: Ik, deleteNotices: gk, disableNotifications: ik, enableNotifications: nk, getMethods: GI, getNotices: hk, getTopics: vk, getTournamentId: zw, getTournamentRecord: ak, getTournamentRecords: ok, removeTournamentRecord: dk, setMethods: pk, setSubscriptions: lk, setTournamentId: ck, setTournamentRecord: sk, setTournamentRecords: uk, handleCaughtError: Sk };
function ik() {
  Ft.disableNotifications = !0;
}
function nk() {
  Ft.disableNotifications = !1;
}
function zw() {
  return Ft.tournamentId;
}
function ak(e) {
  return Ft.tournamentRecords[e];
}
function ok() {
  return Ft.tournamentRecords;
}
function sk(e) {
  let t = e == null ? void 0 : e.tournamentId;
  return t ? (Ft.tournamentRecords[t] = e, { success: !0 }) : { error: nd };
}
function ck(e) {
  return e ? Ft.tournamentRecords[e] ? (Ft.tournamentId = e, { success: !0 }) : { error: de } : (Ft.tournamentId = void 0, { success: !0 });
}
function uk(e) {
  Ft.tournamentRecords = e;
  let t = Object.keys(e);
  t.length === 1 ? Ft.tournamentId = t[0] : t.length || (Ft.tournamentId = void 0);
}
function dk(e) {
  if (typeof e != "string") return { error: ie };
  if (!Ft.tournamentRecords[e]) return { error: Tr };
  delete Ft.tournamentRecords[e];
  let t = Object.keys(Ft.tournamentRecords);
  return t.length === 1 ? Ft.tournamentId = t[0] : t.length || (Ft.tournamentId = void 0), { success: !0 };
}
function lk(e) {
  return typeof e.subscriptions != "object" ? { error: ie } : (Object.keys(e.subscriptions).forEach((t) => {
    typeof e.subscriptions[t] == "function" ? Ft.subscriptions[t] = e.subscriptions[t] : delete Ft.subscriptions[t];
  }), { ...j });
}
function pk(e) {
  return typeof e != "object" ? { error: ie } : (Object.keys(e).forEach((t) => {
    typeof e[t] == "function" && (Ft.methods[t] = e[t]);
  }), { ...j });
}
function fk() {
  let e = Ft.modified;
  return Ft.modified = !1, e;
}
function mk({ topic: e, payload: t, key: r }, i) {
  if (!(typeof e != "string" || typeof t != "object") && (Ft.disableNotifications || (Ft.modified = !0), !(Ft.disableNotifications || !Ft.subscriptions[e] && !i))) return r && (Ft.notices = Ft.notices.filter((n) => !(n.topic === e && n.key === r))), Ft.notices.push({ topic: e, payload: t, key: r }), { ...j };
}
function GI() {
  return Ft.methods ?? {};
}
function hk({ topic: e }) {
  return Ft.notices.filter((t) => t.topic === e).map((t) => t.payload);
}
function gk() {
  Ft.notices = [];
}
function Ik({ topic: e, key: t }) {
  Ft.notices = Ft.notices.filter((r) => (!e || r.topic === e) && r.key !== t);
}
function vk() {
  return { topics: Object.keys(Ft.subscriptions) };
}
function Uk({ topic: e, notices: t }, r) {
  let i = Ft.subscriptions[e];
  i && typeof i == "function" && i(t);
  let n = r == null ? void 0 : r[e];
  n && typeof n == "function" && n(t);
}
function Sk({ engineName: e, methodName: t, params: r, err: i }) {
  let n;
  return typeof i == "string" ? n = i.toUpperCase() : i instanceof Error && (n = i.message), console.log("ERROR", { tournamentId: zw(), params: JSON.stringify(r), engine: e, methodName: t, error: n }), { error: n };
}
var ht = { timers: { default: { elapsedTime: 0 } }, globalSubscriptions: {}, deepCopyAttributes: { stringify: [], ignore: [], toJSON: [] }, globalMethods: [], deepCopy: !0 }, Dr = Yw, rT = ["addNotice", "callListener", "cycleMutationStatus", "deleteNotice", "deleteNotices", "disableNotifications", "enableNotifications", "getMethods", "getNotices", "getTopics", "getTournamentId", "getTournamentRecord", "getTournamentRecords", "removeTournamentRecord", "setSubscriptions", "setTournamentId", "setTournamentRecord", "setTournamentRecords"];
function yk(e) {
  if (typeof e != "object") throw new Error("Global state provider can not be undefined or null");
  if (qt(Object.keys(e), rT).length !== rT.length) throw new Error("Global state provider is missing required methods");
  return Dr = e, { success: !0 };
}
function Ak() {
  if (Dr.createInstanceState) {
    try {
      Dr.createInstanceState();
    } catch (e) {
      return { error: e };
    }
    return { success: !0 };
  } else return { error: Fw };
}
function ki(e) {
  return !e || typeof e != "object" ? ht.devContext ?? !1 : typeof ht.devContext != "object" ? !1 : Object.keys(e).every((t) => {
    var r;
    return ((r = ht.devContext) == null ? void 0 : r[t]) === e[t];
  }) && ht.devContext;
}
function Tk(e = "reset", t = "default") {
  var i, n;
  let r = Date.now();
  if (e === "report") {
    if (t === "allTimers") return Object.keys(ht.timers).filter((a) => a !== "default" || ht.timers[a].startTime).map((a) => {
      let o = ht.timers[a], s = o.state === "stopped" ? 0 : (r - ((o == null ? void 0 : o.startTime) ?? 0)) / 1e3, c = o.elapsedTime + s;
      return { state: ht.timers[a].state, elapsedTime: c.toFixed(2), timer: a };
    });
    {
      let a = ht.timers[t].state === "stopped" ? 0 : (r - (((i = ht.timers[t]) == null ? void 0 : i.startTime) ?? 0)) / 1e3, o = ht.timers[t].elapsedTime + a;
      return { state: ht.timers[t].state, elapsedTime: o.toFixed(2), timer: t };
    }
  }
  if (!ht.timers[t] || e === "reset") {
    if (t === "allTimers") return ht.timers = { default: { elapsedTime: 0 } }, !0;
    ht.timers[t] = { startTime: r, state: "active", elapsedTime: 0 };
  }
  return ht.timers[t].elapsedTime || (ht.timers[t].elapsedTime = 0), e === "stop" && ht.timers[t].state !== "stopped" && (ht.timers[t].state = "stopped") && (ht.timers[t].elapsedTime += (r - (((n = ht.timers[t]) == null ? void 0 : n.startTime) ?? 0)) / 1e3), e === "start" && (ht.timers[t].startTime = r) && (ht.timers[t].state = "active"), ht.timers[t];
}
function Kw(e) {
  Ti(e) ? ht.globalLog = e : delete ht.globalLog;
}
function Cu(e) {
  ht.devContext = e;
}
function Xw() {
  Dr.disableNotifications();
}
function Bl() {
  Dr.enableNotifications();
}
function Fu(e, t) {
  typeof e == "boolean" && (ht.deepCopy = e), typeof t == "object" && (Array.isArray(t.ignore) && (ht.deepCopyAttributes.ignore = t.ignore), Array.isArray(t.toJSON) && (ht.deepCopyAttributes.toJSON = t.toJSON), Array.isArray(t.stringify) && (ht.deepCopyAttributes.stringify = t.stringify), t.threshold && (ht.deepCopyAttributes.threshold = t.threshold));
}
function jI() {
  return { enabled: ht.deepCopy, ...ht.deepCopyAttributes };
}
function Dk(e) {
  return e != null && e.subscriptions ? (Object.keys(e.subscriptions).forEach((t) => {
    ht.globalSubscriptions[t] = e.subscriptions[t];
  }), { ...j }) : { error: we, info: "missing subscriptions" };
}
function Pk(e) {
  return e != null && e.subscriptions ? Dr.setSubscriptions({ subscriptions: e.subscriptions }) : { error: we, info: "missing subscriptions" };
}
function Zw(e) {
  return e ? typeof e != "object" ? { error: ie } : (Object.keys(e).forEach((t) => {
    Ti(e[t]) && (ht.globalMethods[t] = e[t]);
  }), { ...j }) : { error: we, info: "missing method declarations" };
}
function Qw(e) {
  return e ? typeof e != "object" ? { error: ie } : Dr.setMethods(e) : { error: we, info: "missing method declarations" };
}
function _I() {
  return Dr.cycleMutationStatus();
}
function Le(e) {
  if (typeof (e == null ? void 0 : e.topic) != "string") return;
  let t = ht.globalSubscriptions[e.topic];
  return Dr.addNotice(e, t);
}
function Jw() {
  return { ...ht.globalMethods, ...Dr.getMethods() };
}
function $w(e) {
  return Dr.getNotices(e);
}
function WI({ key: e, topic: t }) {
  return Dr.deleteNotice({ key: e, topic: t });
}
function ud() {
  return Dr.deleteNotices();
}
function Ji() {
  return Dr.getTopics();
}
function _f(e) {
  var t, r;
  return (r = (t = Ji()) == null ? void 0 : t.topics) == null ? void 0 : r.includes(e);
}
async function yg(e) {
  return Dr.callListener(e, ht.globalSubscriptions);
}
function bs() {
  return Dr.getTournamentId();
}
function qI(e) {
  return Dr.getTournamentRecord(e);
}
function Ns() {
  return Dr.getTournamentRecords();
}
function eR(e) {
  return Dr.setTournamentRecord(e);
}
function Wf(e) {
  return Dr.setTournamentRecords(e);
}
function ku(e) {
  return Dr.setTournamentId(e);
}
function tR(e) {
  return Dr.removeTournamentRecord(e);
}
function Ag() {
  return Dr;
}
function qf({ engineName: e, methodName: t, params: r, err: i }) {
  let n = Ti(Dr.handleCaughtError) && Dr.handleCaughtError || Yw.handleCaughtError, { tournamentRecord: a, ...o } = r;
  return n({ params: o, engineName: e, methodName: t, err: i });
}
function rR(e, t) {
  if (ht.globalLog) try {
    ht.globalLog({ log: e, engine: t });
  } catch (r) {
    console.log("globalLog error", r), console.log(t, e), Kw();
  }
  else console.log(t, e);
}
function iR(e, t, r, i) {
  if (!$e(e)) return { error: ie };
  jt || (r = 1);
  let n = Array.isArray(t) ? t : [], a = {}, o = (s, c = 0) => {
    Object.keys(s).forEach((u) => {
      Ti(s[u]) ? a[u] = s[u] : $e(s[u]) && (t === !0 || n != null && n.includes(u)) && (r === void 0 || c < r) && o(s[u], c + 1);
    });
  };
  return o(e), i ? Zw(a) : Qw(a), { methods: a };
}
function wk(e, t, r) {
  return Object.keys(e).filter((i) => !t.includes(e[i]) && (!r || (Array.isArray(e[i]) ? e[i].length : !0)));
}
function ye(e, t, r, i) {
  var o;
  if (typeof e != "object" || e === null) return e;
  (o = jI()) != null && o.enabled || (i = !0);
  let n = ["", void 0, null];
  t && n.push(!1);
  let a = wk(e, n, r);
  return Object.assign({}, ...a.map((s) => Array.isArray(e[s]) ? { [s]: i ? e[s] : e[s].map((c) => ye(c)) } : { [s]: i ? e[s] : ye(e[s]) }));
}
function W({ context: e, result: t, stack: r, info: i }) {
  return t && !Array.isArray(t == null ? void 0 : t.stack) && (t.stack = []), t && Array.isArray(t == null ? void 0 : t.stack) && typeof r == "string" && t.stack.push(r), t && i && (t.info = i), t && typeof e == "object" && Object.keys(e).length && Object.assign(t, ye(e)), t && !(t != null && t.error) && !(t != null && t.success) && Object.assign(t, { ...j }), t ?? { success: !0 };
}
var Mn = "ANY", pt = "MALE", ni = "MIXED", vo = "OTHER", St = "FEMALE", HI = { ANY: Mn, MALE: pt, FEMALE: St, MIXED: ni, OTHER: vo }, Rk = "MIXED events can not contain mixed singles or { gender: ANY } collections", bk = "events with { gender: ANY } can not contain MIXED singles collections";
function Hf(e) {
  let t = "tieFormatGenderValidityCheck", { referenceGender: r, matchUpType: i, gender: n } = e;
  return r && n && [pt, St].includes(r) && r !== n ? W({ result: { valid: !1, error: Au }, context: { gender: n }, stack: t }) : r === ni && (n === Mn || n === ni && i !== ft) ? W({ result: { error: Au, valid: !1 }, info: Rk, stack: t }) : r === Mn && n === ni && i !== ft ? W({ result: { error: Au, valid: !1 }, info: bk, stack: t }) : { valid: !0 };
}
var Nk = "normal", iT = "timed", Mk = "final", YI = "NOAD", Vl = "SET", Ek = { S: Nk, F: Mk };
function Yf(e, t) {
  if ((e != null && e.bestOf || e != null && e.exactly) && (e != null && e.setFormat)) return Ok(e, t);
}
function Lu(e) {
  return !isNaN(Number(e)) && Number(e);
}
function nR(e) {
  let t = `T${e.minutes}`;
  return e.based && (t += e.based), e.modifier && (t += `@${e.modifier}`), t;
}
function Ok(e, t) {
  var d;
  let r = Lu(e.bestOf) || void 0, i = Lu(e.exactly) || void 0, n = r || i;
  if ((d = e.setFormat) != null && d.timed && e.simplified && n === 1) return nR(e.setFormat);
  let a = n && `${Vl}${n}` || "", o = nT(e.setFormat, t), s = o && `S:${o}` || "", c = nT(e.finalSetFormat, t), u = n && n > 1 && c && o !== c && `F:${c}` || "";
  if (a && o) return [a, s, u].filter((l) => l).join("-");
}
function nT(e, t) {
  if (typeof e == "object" && Object.keys(e).length) {
    if (e.timed) return nR(e);
    if (e.tiebreakSet) return aT(e.tiebreakSet);
    let r = Lu(e.setTo);
    if (r) {
      let i = e.NoAD && YI || "", n = aT(e.tiebreakFormat), a = n && `/${n}` || "", o = Lu(e.tiebreakAt), s = o && (o !== r || t) && `@${o}` || "";
      if (n !== !1) return `${r}${i}${a}${s}`;
    }
  }
}
function aT(e) {
  if (e) {
    if (typeof e == "object" && !e.tiebreakTo) return "";
    if (typeof e == "object" && Lu(e.tiebreakTo)) {
      let t = `TB${e.tiebreakTo}${e.NoAD ? YI : ""}`;
      return e.modifier && (t += `@${e.modifier}`), t;
    } else return !1;
  }
}
function ti(e) {
  if (Et(e)) {
    let t = e.startsWith("T") && iT || e.startsWith(Vl) && Vl || "";
    if (t === iT) {
      let r = oR(e), i = { simplified: !0, setFormat: r, bestOf: 1 };
      if (r) return i;
    }
    if (t === Vl) return Ck(e);
  }
}
function Ck(e) {
  let t = e.split("-"), r = dd(t[0].slice(3)), i = r === 1 || r % 2 !== 0 ? r : void 0, n = r !== 1 && r % 2 === 0 ? r : void 0, a = t && oT(t[1]), o = t && oT(t[2]), s = a && a.timed || o && o.timed, c = i && i < 6 || s && n, u = !t[2] || o, d = a, l = ye({ setFormat: a, exactly: n, bestOf: i });
  if (o && (l.finalSetFormat = o), c && d && u) return l;
}
function oT(e) {
  if ((e == null ? void 0 : e[1]) === ":") {
    let t = e.split(":"), r = Ek[t[0]], i = t[1];
    if (r && i) {
      if (i.startsWith("TB")) {
        let m = sT(i);
        return m === !1 ? !1 : typeof m == "object" ? { tiebreakSet: m } : void 0;
      }
      if (i.startsWith("T")) return oR(i);
      let n = e.match(/^[FS]:(\d+)([A-Za-z]*)/), a = n && sR(n[2]) || !1, o = !(n != null && n[2]) || a, s = n ? dd(n[1]) : void 0, c = aR(i), u = c !== !1, d = u && c || s, l = sT(i.split("/")[1]), p = l !== !1, f = { setTo: s };
      return a && (f.NoAD = !0), l ? (f.tiebreakFormat = l, f.tiebreakAt = d) : f.noTiebreak = !0, s && o && p && u && f || !1;
    }
  }
}
function aR(e, t = !0) {
  let r = (e == null ? void 0 : e.indexOf("@")) > 0 && e.split("@");
  if (r) return (t ? dd(r[1]) : r[1]) || !1;
}
function sT(e) {
  if (e) if (e.startsWith("TB")) {
    let t = aR(e, !1), r = e.match(/^TB(\d+)([A-Za-z]*)/), i = r == null ? void 0 : r[1], n = r && sR(r[2]), a = !(r != null && r[2]) || n, o = dd(i);
    if (o && a) {
      let s = { tiebreakTo: o };
      return t && typeof t == "string" && !ke(t) && (s.modifier = t), n && (s.NoAD = !0), s;
    } else return !1;
  } else return !1;
}
function oR(e) {
  var s;
  let t = e.slice(1), r = t.match(/^(\d+)(@?[A-Za-z]*)/), i = dd(r == null ? void 0 : r[1]);
  if (!i) return;
  let n = { timed: !0, minutes: i }, a = r == null ? void 0 : r[2], o = [void 0, "P", "G"].includes(a);
  if (a && !o) {
    let c = (s = t.match(/^(\d+)(@)([A-Za-z]+)$/)) == null ? void 0 : s[3];
    return c ? (n.modifier = c, n) : void 0;
  }
  return a && (n.based = r[2]), n;
}
function sR(e) {
  return e && e.indexOf(YI) >= 0;
}
function dd(e) {
  return isNaN(Number(e)) ? 0 : Number(e);
}
function Ri({ matchUpFormat: e }) {
  if (!Et(e) || e === "") return !1;
  let t = ti(e), r = e.match(/-S:([1-9])+\/TB([0-9]{1,2})@?([1-9]?)*/), i = r == null ? void 0 : r[1], n = r == null ? void 0 : r[2], a = r == null ? void 0 : r[3], o = e.match(/-F:([1-9])+\/TB([0-9]{1,2})@?([1-9]?)*/), s = o == null ? void 0 : o[1], c = o == null ? void 0 : o[2], u = o == null ? void 0 : o[3];
  return Yf(t, !!(r && n && i === a || o && c && s === u)) === e;
}
var rp = /^[\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1])$/, cR = /^((0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)([.,][0-9]{3})?$/, Gn = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))([ T](0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/, Uo = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))?([ T]?(0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/;
function ip(e) {
  let { scheduledDate: t } = e;
  if (!t && e.scheduledTime && (t = Ve(e.scheduledTime)), !t) return;
  let r = Rt(e.scheduledTime), i = Ve(t);
  return i && r && (i += `T${r}`), i;
}
function Fk(e) {
  return typeof e != "object" || Array.isArray(e) ? !1 : Object.prototype.toString.call(e) === "[object Date]";
}
function qc(e) {
  let t = typeof e == "string" ? e == null ? void 0 : e.split(" ") : [];
  return e && (t == null ? void 0 : t.length) > 1 && !["AM", "PM"].includes(t[1].toUpperCase()) ? !1 : !!(!e || Uo.test(Ms(e, !0, !0)));
}
function mi(e) {
  return To(e) || rp.test(e);
}
function kk(e) {
  let t = new Date(e), r = t.getSeconds() + 60 * t.getMinutes() + 60 * 60 * t.getHours();
  return Lk(r, { displaySeconds: !1 });
}
function Lk(e, t) {
  let r = parseInt(e, 10), i = Math.floor(r / 3600), n = Math.floor((r - i * 3600) / 60), a = r - i * 3600 - n * 60;
  return (!t || t != null && t.displaySeconds ? i + ":" + n + ":" + a : i + ":" + n).split(":").map(Yi).join(":");
}
var zI = (e) => {
  let t = xu(e) || To(e) ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getUTCMonth() + 1, i = r < 10 ? `0${r}` : `${r}`;
  return `${t.getUTCFullYear()}-${Yi(i)}-${Yi(t.getUTCDate())}`;
};
function xk(e) {
  let t = xu(e) || To(e) ? new Date(e) : /* @__PURE__ */ new Date();
  return Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
}
function ln(e, t = "-", r = "YMD") {
  if (!e) return "";
  typeof e == "string" && e.indexOf("T") < 0 && (e = e + "T00:00");
  let i = new Date(e), n = "" + (i.getMonth() + 1), a = "" + i.getDate(), o = i.getFullYear();
  return n.length < 2 && (n = "0" + n), a.length < 2 && (a = "0" + a), r === "DMY" ? [a, n, o].join(t) : r === "MDY" ? [n, a, o].join(t) : r === "YDM" ? [o, a, n].join(t) : r === "DYM" ? [a, o, n].join(t) : r === "MYD" ? [n, o, a].join(t) : [o, n, a].join(t);
}
function np(e) {
  let t = e ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getTimezoneOffset();
  return new Date(t.getTime() - r * 60 * 1e3);
}
function Bk(e) {
  return np(e).getTime();
}
function xu(e) {
  if (typeof e == "boolean") return !1;
  let t = e instanceof Date && e || !isNaN(e) && new Date(e) || !1;
  return t && !isNaN(t.valueOf());
}
function hc(e, t) {
  if (!mi(e) || !mi(t)) return [];
  let r = Ve(e) + "T00:00", i = Ve(t) + "T00:00", n = new Date(r), a = new Date(i), o = xu(a) && xu(n) && u(n, a), s = [], c = 0;
  if (o) {
    let d = n, l = d.getTime();
    for (; l <= a.getTime() && c < 300; ) c += 1, s.push(new Date(d)), l = d.setDate(d.getDate() + 1);
  }
  return s.map((d) => ln(d));
  function u(d, l) {
    return d <= l;
  }
}
var Vk = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function To(e) {
  return typeof e != "string" ? !1 : Vk.test(e);
}
function KI(e) {
  if (typeof e != "string") return !1;
  let t = e.split("Z")[0].split(":"), r = t.every((i) => !isNaN(parseInt(i)));
  return !(t.length < 2 || !r || parseInt(t[0]) > 23 || parseInt(t[1]) > 60);
}
function tt(e) {
  let t = Rt(e);
  if (!t) return 0;
  let [r, i] = t.split(":").map((n) => parseInt(n));
  return r * 60 + i;
}
function Gk(e) {
  let t = Math.floor(e / 60), r = e - t * 60;
  return t > 23 && (t = t % 24), [Yi(t), Yi(r)].join(":");
}
function ap(e) {
  return KI(e) ? e.split(":").slice(0, 2).map(Yi).join(":") : void 0;
}
function Rt(e) {
  return To(e) && e.indexOf("T") > 0 ? ap(e.split("T").reverse()[0]) : ap(e);
}
function Ve(e) {
  return To(e) || Gn.test(e) ? e.split("T")[0] : void 0;
}
function Su(e, t) {
  let r = new Date(e);
  return r.setDate(r.getDate() + t), Ve(r.toISOString());
}
function op(e) {
  e = typeof e != "string" ? "00:00" : e;
  let t = {}, r = {};
  return { 0: t.time, 1: t.ampm } = e.split(" ") || [], { 0: r.hours, 1: r.minutes } = t.time.split(":") || [], r.ampm = t.ampm, isNaN(r.hours) || isNaN(r.minutes) || r.ampm && !["AM", "PM"].includes(r.ampm.toUpperCase()) ? {} : r;
}
function jk(e) {
  let t = op(e);
  return t.ampm && t.hours && (t.ampm.toLowerCase() === "pm" && parseInt(t.hours) < 12 && (t.hours = (t.hours && parseInt(t.hours) || 0) + 12), t.ampm.toLowerCase() === "am" && t.hours === "12" && (t.hours = "00")), `${t.hours || "12"}:${t.minutes || "00"}`.split(":").map(Yi).join(":");
}
function _k(e) {
  var r;
  let t = op(e);
  if (!(typeof t == "object" && !Object.keys(t).length)) return t.ampm ? e : (t.hours > 12 ? (t.hours -= 12, t.ampm = "PM") : t.hours === "12" ? t.ampm = "PM" : (t.hours === "00" && (t.hours = "12"), t.ampm = "AM"), ((r = t.hours) == null ? void 0 : r[0]) === "0" && (t.hours = t.hours.slice(1)), `${t.hours || "12"}:${t.minutes || "00"} ${t.ampm}`);
}
function Ms(e, t, r) {
  let i = Ve(e), n = Rt(e), a = i ? n : e;
  return e ? t && (i && r && e || jk(a)) || _k(a) : void 0;
}
function uR(e, t) {
  let r = op(e), i = op(t);
  if (parseInt(r.hours) < parseInt(i.hours)) return -1;
  if (parseInt(r.hours) > parseInt(i.hours)) return 1;
  if (r.hours === i.hours) {
    if (parseInt(r.minutes) < parseInt(i.minutes)) return -1;
    if (parseInt(r.minutes) > parseInt(i.minutes)) return 1;
  }
  return 0;
}
function XI(e, t = 7) {
  let r = Ve(e) + "T00:00", i = new Date(r), n = new Date(i.setDate(i.getDate() + t));
  return ln(n);
}
function Wk(e) {
  return XI(e);
}
function qk(e, t, r, i = !1) {
  let n = new Date(t, 0, 1 + (e - 1) * 7), a = i ? 0 : 1;
  return n.setDate(n.getDate() + (a - n.getDay())), ln(n, r);
}
function Hk(e, t, r) {
  let i = new Date(e, 0);
  return ln(new Date(i.setDate(t)), r);
}
function rr(e, t = void 0) {
  let [r, i] = (e || "00:00").split(":").map(Yi), n = np(t).setHours(r, i, 0, 0);
  return np(n);
}
function ld(e, t, r = !0) {
  let i = new Date(e), n = (new Date(t).getTime() - i.getTime()) / 1e3 / 60;
  return r ? Math.abs(Math.round(n)) : Math.round(n);
}
function fi(e, t) {
  let r = Rt(e);
  if (!r) return "00:00";
  let i = isNaN(t) ? 0 : t;
  return Rt(ZI(rr(r), i).toISOString());
}
function ZI(e, t) {
  let r = new Date(e);
  return new Date(r.getTime() + t * 6e4);
}
function Yi(e) {
  return e.toString()[1] ? e : "0" + e;
}
function aa(e, t) {
  let r = new Date(e), i = new Date(t);
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth() && r.getDate() === i.getDate();
}
var dR = { addDays: XI, addWeek: Wk, addMinutesToTimeString: fi, convertTime: Ms, getIsoDateString: ip, getUTCdateString: zI, DateHHMM: kk, extractDate: Ve, extractTime: Rt, formatDate: ln, getDateByWeek: qk, isISODateString: To, isDate: xu, isTimeString: KI, offsetDate: np, offsetTime: Bk, sameDay: aa, timeStringMinutes: tt, timeToDate: rr, timeUTC: xk, validTimeValue: qc, validDateString: rp, timeValidation: Uo, dateValidation: Gn }, Yk = (e, t) => e.filter(Boolean).every((r) => typeof r === t), zk = (e) => e.filter(Boolean).every(jt);
function fs(e) {
  let t = e.category;
  if (typeof t != "object") return { error: Ou };
  let { ageCategoryCode: r, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o } = t, s = t.categoryName, c;
  if (!(Yk([r, i, n, s], "string") && zk([a, o]) && [i, n].filter(Boolean).every(mi))) return { error: Ou };
  let u = e.consideredDate ?? Ve((/* @__PURE__ */ new Date()).toLocaleDateString("sv"));
  if (!mi(u)) return { error: Sr };
  let [d] = u.split("-").slice(0, 3).map((x) => parseInt(x)), l = Su(u, -1), [p, f] = l.split("-").slice(1, 3).map((x) => parseInt(x)), m = `${Yi(p)}-${Yi(f)}`, h = Su(u, 1), [g, I] = h.split("-").slice(1, 3).map((x) => parseInt(x)), U = `${Yi(g)}-${Yi(I)}`, v = o && Su(u, -1 * 365 * o), S = a && Su(u, -1 * 365 * a), T = [], A = (x) => !T.includes(x) && T.push(x);
  r = r ?? s;
  let y = /^([UO]?)(\d{1,2})([UO]?)$/, D = /^C(\d{1,2})-(\d{1,2})$/, P = r == null ? void 0 : r.includes("-"), w = P && (r == null ? void 0 : r.match(D)), R = r == null ? void 0 : r.match(y), b = (x, V) => `${x}-${V}`, E = (x) => {
    let V = d - x, k = b(V, U);
    t.ageMinDate && t.ageMinDate !== k && A(`Invalid submitted ageMinDate: ${n}`), n = k, r && (t.ageMax && t.ageMax !== x - 1 && (A(`Invalid submitted ageMax: ${a}`), S = void 0), a = x - 1);
  }, O = (x) => {
    let V = d - x - 1, k = b(V, U);
    t.ageMin && t.ageMin > x && A(`Invalid submitted ageMin: ${o}`), t.ageMax && t.ageMax > x && A(`Invalid submitted ageMax: ${a}`), t.ageMinDate && t.ageMinDate !== k && A(`Invalid submitted ageMinDate: ${n}`), n = k, r && (t.ageMax && t.ageMax !== x && (A(`Invalid submitted ageMax: ${a}`), v = void 0), a = x);
  }, M = (x) => {
    let V = d - x, k = b(V, m);
    t.ageMaxDate && t.ageMaxDate !== k && A(`Invalid submitted ageMaxDate: ${i}`), i = k, r && (t.ageMin && t.ageMin !== x + 1 && (A(`Invalid submitted ageMin: ${o}`), v = void 0), o = x + 1);
  }, N = (x) => {
    let V = d - x - 1, k = b(V, m);
    t.ageMaxDate && t.ageMaxDate !== k && A(`Invalid submitted ageMaxDate: ${i}`), i = k, r && (t.ageMin && t.ageMin !== x && (A(`Invalid submitted ageMin: ${o}`), v = void 0), o = x);
  }, C = (x) => {
    let [V, k, L] = (x.match(y) || []).slice(1), B = parseInt(k);
    V === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && A(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), E(B)) : V === "O" && M(B), L === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && A(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), O(B)) : L === "O" && N(B), i = i ?? v, n = n ?? S;
  };
  if (w) {
    if (i = void 0, n = void 0, a = void 0, o = void 0, t.ageMin) {
      let k = d - t.ageMin;
      i = b(k, m);
    }
    if (t.ageMax) {
      let k = d - t.ageMax - 1;
      n = b(k, U);
    }
    let [x, V] = ((r == null ? void 0 : r.match(D)) ?? []).slice(1).map((k) => parseInt(k));
    x <= V ? (o = x, a = V, c = !0) : A(`Invalid combined age range ${r}`);
  } else P ? r == null || r.split("-").forEach(C) : R ? C(r) : (o && M(o), a && O(a));
  a && t.ageMin && t.ageMin > a && (A(`Invalid submitted ageMin: ${t.ageMin}`), o = void 0);
  let F = ye({ consideredDate: u, combinedAge: c, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o });
  return T.length && (F.errors = T), F;
}
function Bu({ category: e }) {
  if (!$e(e)) return { error: ie };
  let t = fs({ category: e });
  if (t.error) return { error: t };
  let { ratingMax: r, ratingMin: i } = e;
  return r && !jt(r) ? W({ result: { error: ie }, context: { ratingMax: r } }) : i && !jt(i) ? W({ result: { error: ie }, context: { ratingMin: i } }) : { ...t };
}
function pd({ childCategory: e, withDetails: t, category: r }) {
  let i = Bu({ category: r }), n = Bu({ category: e }), a = n.ageMin && (i.ageMin && n.ageMin < i.ageMin || i.ageMax && n.ageMin > i.ageMax), o = n.ageMax && (i.ageMax && n.ageMax > i.ageMax || i.ageMin && n.ageMax < i.ageMin), s = n.ageMinDate && i.ageMaxDate && new Date(n.ageMinDate) > new Date(i.ageMaxDate), c = n.ageMaxDate && i.ageMinDate && new Date(n.ageMaxDate) < new Date(i.ageMinDate), u = (r == null ? void 0 : r.ratingType) && (e == null ? void 0 : e.ratingType) && r.ratingType === e.ratingType && (r.ratingMin && e.ratingMin && e.ratingMin < r.ratingMin || r.ratingMax && e.ratingMax && e.ratingMax > r.ratingMax || r.ratingMin && e.ratingMax && e.ratingMax < r.ratingMin || r.ratingMax && e.ratingMin && e.ratingMin > r.ratingMax), d = (r == null ? void 0 : r.ballType) && (e == null ? void 0 : e.ballType) && r.ballType !== e.ballType, l = ye({ invalidRatingRange: u, invalidAgeMinDate: s, invalidAgeMaxDate: c, invalidBallType: d, invalidAgeMax: o, invalidAgeMin: a, valid: !u && !s && !c && !d && !o && !a }, !0);
  return t && Object.assign(l, { categoryDetails: i, childCategoryDetails: n }), l;
}
function fd({ checkCategory: e = !0, collectionDefinition: t, checkCollectionIds: r, checkGender: i = !0, referenceCategory: n, referenceGender: a, event: o }) {
  a = a ?? (o == null ? void 0 : o.gender);
  let s = "validateCollectionDefinition", c = [];
  if (typeof t != "object") return c.push(`collectionDefinition must be an object: ${t}`), W({ result: { errors: c, error: Ea }, stack: s });
  let { collectionValueProfiles: u, collectionGroupNumber: d, collectionValue: l, collectionId: p, matchUpCount: f, matchUpFormat: m, matchUpValue: h, matchUpType: g, scoreValue: I, setValue: U, category: v, gender: S } = t;
  if (r && typeof p != "string" && c.push(`collectionId is not type string: ${p}`), typeof f != "number" && c.push(`matchUpCount is not type number: ${f}`), g && !Rf([mt, ft], g) && c.push(`matchUpType must be SINGLES or DOUBLES: ${g}`), [!!(u != null && u.length)].concat([h, l, I, U].map(ke)).filter(Boolean).length !== 1 && c.push("Missing value definition for matchUps: matchUpValue, collectionValue, or collectionValueProfiles"), h && typeof h != "number" && c.push(`matchUpValue is not type number: ${h}`), l && typeof l != "number" && c.push(`collectionValue is not type number: ${l}`), u && f) {
    let T = BP({ collectionValueProfiles: u, matchUpCount: f });
    T.errors && c.push(...T.errors);
  }
  if (d && typeof d != "number" && c.push(`collectionGroupNumber is not type number: ${l}`), m && !Ri({ matchUpFormat: m }) && c.push(`Invalid matchUpFormat: ${m}`), i) {
    let T = Hf({ referenceGender: a, matchUpType: g, gender: S });
    if (T.error) return W({ context: { referenceGender: a, gender: S }, result: T, stack: s });
  }
  if (e && n && v) {
    let T = pd({ category: n, childCategory: v });
    if (!T.valid) return W({ result: { error: Ou }, context: T, stack: s });
  }
  return c.length ? W({ result: { errors: c, error: Vw }, stack: s }) : { valid: !0 };
}
function oi(e) {
  var g, I, U, v;
  let t = !!((e == null ? void 0 : e.enforceCategory) !== !1 && (e != null && e.category)), r = !!((e == null ? void 0 : e.enforceGender) !== !1 && (e != null && e.gender)), i = e == null ? void 0 : e.checkCollectionIds, n = e == null ? void 0 : e.tieFormat, a = e == null ? void 0 : e.event, o = "validateTieFormat", s = [], c = Kk({ ...e, stack: o });
  if (c != null && c.error) return c;
  let u, d = n.collectionDefinitions.every((S) => {
    let { setValue: T, scoreValue: A, collectionValue: y } = S;
    (T || A) && !y && (u = !0);
    let { valid: D, errors: P } = fd({ referenceCategory: e.category, referenceGender: e.gender, collectionDefinition: S, checkCollectionIds: i, checkCategory: t, checkGender: r, event: a });
    return D ? !0 : (Array.isArray(P) && s.push(...P), !1);
  }), l = typeof ((g = n.winCriteria) == null ? void 0 : g.valueGoal) == "number" && ((I = n.winCriteria) == null ? void 0 : I.valueGoal) > 0 && !u || ((U = n.winCriteria) == null ? void 0 : U.aggregateValue);
  if (!(l || (v = n.winCriteria) != null && v.aggregateValue)) return u ? s.push("aggregateValue is required") : s.push("Either non-zero valueGoal, or { aggregateValue: true } must be specified in winCriteria"), W({ context: { tieFormat: n, errors: s, aggregateValueImperative: u }, result: { error: Jn }, stack: o });
  let p = n.collectionDefinitions.map(({ collectionId: S }) => S), f = !i || p.length === Be(p).length, m = d && l && f;
  return m ? { valid: m, errors: s } : W({ result: { error: Jn }, context: { tieFormat: n, errors: s }, stack: o });
}
function Kk(e) {
  let { tieFormat: t, stack: r } = e;
  return !e || !t || !$e(t) ? W({ result: { error: Jn }, context: { tieFormat: t, message: "tieformat must be an object" }, stack: r }) : $e(t.winCriteria) ? Array.isArray(t.collectionDefinitions) ? { ...j } : W({ result: { error: Jn }, context: { tieFormat: t, message: "collectionDefinitions must be an array" }, stack: r }) : W({ result: { error: Jn }, context: { tieFormat: t, message: "tieformat.winCritiera must be an object" }, stack: r });
}
var gc = "resourceSubType", Ic = "resourceType", vc = "identifier", Xk = { RESOURCE_SUB_TYPE: gc, RESOURCE_TYPE: Ic, IDENTIFIER: vc };
function ge(e, t, r, i, n = 0) {
  if (Ag().makeDeepCopy) return Ag().makeDeepCopy(e, t, r, i);
  let a = jI(), { stringify: o, toJSON: s, ignore: c, modulate: u } = a || {};
  if (!(a != null && a.enabled) && !r || typeof e != "object" || Ti(e) || e === null || typeof (a == null ? void 0 : a.threshold) == "number" && n >= a.threshold) return e;
  let d = Array.isArray(e) ? [] : {}, l = Object.keys(e).filter((f) => !r || !c || Array.isArray(c) && !c.includes(f) || Ti(c) && !c(f)), p = (f, m) => {
    d[f] = Ti(m == null ? void 0 : m.toString) ? m.toString() : JSON.stringify(m);
  };
  for (let f of l) {
    let m = e[f], h = Ti(u) ? u(m) : void 0;
    if (h !== void 0) d[f] = h;
    else if (t && f === "extensions" && Array.isArray(m)) {
      let g = QI(m);
      Object.assign(d, ...g);
    } else i && f === "extensions" ? d[f] = [] : Array.isArray(o) && o.includes(f) ? p(f, m) : Array.isArray(s) && s.includes(f) && Ti(m == null ? void 0 : m.toJSON) ? d[f] = m.toJSON() : m === null ? d[f] = void 0 : Fk(m) ? d[f] = new Date(m).toISOString() : d[f] = ge(m, t, r, i, n + 1);
  }
  return d;
}
function QI(e) {
  return e == null ? void 0 : e.map((t) => {
    let { name: r, value: i } = t;
    return r && i && { [`_${r}`]: i };
  }).filter(Boolean);
}
function lR(e = 1, t) {
  return fe(0, e).map(() => st(t));
}
function st(e) {
  let t = [];
  for (let s = 0; s < 256; s++) t[s] = (s < 16 ? "0" : "") + s.toString(16);
  let r = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, a = Math.random() * 4294967295 | 0, o = t[r & 255] + t[r >> 8 & 255] + t[r >> 16 & 255] + t[r >> 24 & 255] + "-" + t[i & 255] + t[i >> 8 & 255] + "-" + t[i >> 16 & 15 | 64] + t[i >> 24 & 255] + "-" + t[n & 63 | 128] + t[n >> 8 & 255] + "-" + t[n >> 16 & 255] + t[n >> 24 & 255] + t[a & 255] + t[a >> 8 & 255] + t[a >> 16 & 255] + t[a >> 24 & 255];
  return typeof e == "string" ? `${e}_${o.replace(/-/g, "")}` : o;
}
var pR = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpCount: 4, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 4, matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 2, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 2, matchUpValue: 1 }, { collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 4, matchUpValue: 1, gender: "MIXED" }], tieFormatName: "USTA_GOLD_TEAM_CHALLENGE", winCriteria: { valueGoal: 9 } }, fR = { collectionDefinitions: [{ collectionName: "Round 1", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 2", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 3", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "Doubles Shuffle", unrestrictedSelections: !0, winCriteria: { aggregateValue: !0 } }, mR = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_SOUTHERN_LEVEL_5", winCriteria: { valueGoal: 8 } }, hR = { collectionDefinitions: [{ category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Tiebreak Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:TB10", matchUpType: "DOUBLES", matchUpValue: 1, processCodes: ["RANKING.IGNORE"] }], tieFormatName: "USTA_SECTION_BATTLE", winCriteria: { valueGoal: 9 } }, gR = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_INTERSECTIONAL", winCriteria: { valueGoal: 8 } }, IR = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Pro Circuit", winCriteria: { aggregateValue: !0 } }, vR = { collectionDefinitions: [{ collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO_MIXED", winCriteria: { valueGoal: 2 } }, UR = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "DOUBLES", collectionName: "Men's Doubles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Women's Doubles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Dual", winCriteria: { aggregateValue: !0 } }, SR = { collectionDefinitions: [{ category: { ageCategoryCode: "14U" }, collectionName: "14U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], collectionGroups: [{ groupNumber: 1, groupName: "Doubles", groupValue: 1, winCriteria: { valueGoal: 2 } }], tieFormatName: "USTA_BREWER_CUP", winCriteria: { valueGoal: 4 } }, yR = { winCriteria: { valueGoal: 23 }, tieFormatName: "USTA_OZAKI_CUP", collectionDefinitions: [{ category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }] }, Ia = "SET3-S:6/TB7", Zk = "SET3-S:6/TB7-F:TB10", AR = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO", winCriteria: { valueGoal: 2 } }, TR = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", collectionValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "USTA_COLLEGE", winCriteria: { valueGoal: 4 } }, DR = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_LEVEL_1", winCriteria: { valueGoal: 10 } }, PR = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_WTT_ITT", winCriteria: { aggregateValue: !0 } }, wR = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_ZONAL", winCriteria: { valueGoal: 10 } }, RR = { collectionDefinitions: [{ collectionGroupNumber: 1, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 1, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 2, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 2, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 3, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }, { collectionGroupNumber: 3, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }], collectionGroups: [{ groupNumber: 1, groupName: "Day 1" }, { groupNumber: 2, groupName: "Day 2" }, { groupNumber: 3, groupName: "Day 3" }], tieFormatName: "LAVER_CUP", winCriteria: { valueGoal: 13 } }, bR = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_TOC", winCriteria: { aggregateValue: !0 } }, sp = "COLLEGE_DEFAULT", Tg = "COLLEGE_JUCO", Dg = "COLLEGE_D3", NR = "DOMINANT_DUO", MR = "DOMINANT_DUO_MIXED", ER = "LAVER_CUP", OR = "TEAM_DOUBLES_3_AGGREGATION", CR = "TIME_TENNIS_DUAL", FR = "TIME_TENNIS_PRO_CIRCUIT", kR = "USTA_BREWER_CUP", LR = "USTA_OZAKI_CUP", xR = "USTA_COLLEGE", BR = "USTA_GOLD_TEAM_CHALLENGE", VR = "USTA_LEVEL_1", GR = "USTA_INTERSECTIONAL", jR = "USTA_SECTION_BATTLE", _R = "USTA_SOUTHERN_LEVEL_5", WR = "USTA_TOC", qR = "USTA_WTT_ITT", HR = "USTA_ZONAL", Qk = { COLLEGE_D3: Dg, COLLEGE_DEFAULT: sp, COLLEGE_JUCO: Tg, DOMINANT_DUO: NR, DOMINANT_DUO_MIXED: MR, LAVER_CUP: ER, TEAM_DOUBLES_3_AGGREGATION: OR, TIME_TENNIS_DUAL: CR, TIME_TENNIS_PRO_CIRCUIT: FR, USTA_BREWER_CUP: kR, USTA_OZAKI_CUP: LR, USTA_COLLEGE: xR, USTA_GOLD_TEAM_CHALLENGE: BR, USTA_INTERSECTIONAL: GR, USTA_LEVEL_1: VR, USTA_SECTION_BATTLE: jR, USTA_SOUTHERN_LEVEL_5: _R, USTA_TOC: WR, USTA_WTT_ITT: qR, USTA_ZONAL: HR }, YR = "STANDARD", cT = { [YR]: { hydrate: !0, doubles: { matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpCount: 6, matchUpValue: 1 }, valueGoal: 5 }, [Dg]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7@7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Ia, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: Dg, valueGoal: 5 }, [sp]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:6/TB7", collectionValue: 1, matchUpCount: 3 }, singles: { matchUpFormat: Ia, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: sp, valueGoal: 4 }, [Tg]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Ia, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: Tg, valueGoal: 5 }, [ER]: RR, [NR]: AR, [MR]: vR, [OR]: fR, [CR]: UR, [FR]: IR, [kR]: SR, [LR]: yR, [xR]: TR, [BR]: pR, [GR]: gR, [VR]: DR, [jR]: hR, [_R]: mR, [qR]: PR, [WR]: bR, [HR]: wR }, Jk = (e) => {
  let t = e != null && e.namedFormat && Object.keys(cT).includes(e.namedFormat) ? e.namedFormat : YR, r = Array.isArray(e == null ? void 0 : e.uuids) ? e == null ? void 0 : e.uuids : [], i, { category: n, gender: a } = (e == null ? void 0 : e.event) ?? {}, o = ge(cT[t], !1, !0), s = (c) => {
    var d, l;
    if (!(e != null && e.isMock) && !((d = e == null ? void 0 : e.event) != null && d.isMock) || !e.event) return (r == null ? void 0 : r.pop()) ?? st();
    let u = (l = e == null ? void 0 : e.event) == null ? void 0 : l.eventId;
    return r.pop() ?? `${u}-COL-${c + 1}`;
  };
  return o.hydrate ? (i = { winCriteria: { valueGoal: o.valueGoal }, collectionDefinitions: [{ collectionId: s(0), matchUpFormat: Zk, collectionName: "Doubles", matchUpType: ft, ...o.doubles }, { collectionId: s(1), matchUpFormat: Ia, collectionName: "Singles", matchUpType: mt, ...o.singles }] }, o.tieFormatName && (i.tieFormatName = o.tieFormatName)) : (o.collectionDefinitions.forEach((c, u) => c.collectionId = s(u)), i = o), e != null && e.hydrateCollections && i.collectionDefinitions.forEach((c) => {
    n && !c.category && (c.category = n), a && !c.gender && (c.gender = a);
  }), i;
}, Sa = Jk, jn = "SINGLES", ms = "SINGLES", Xi = "DOUBLES", ya = "DOUBLES", or = "TEAM", bi = "TEAM", $k = "AGE", eL = "RATING", tL = "BOTH", rL = { AGE: $k, BOTH: tL, DOUBLES: Xi, DOUBLES_EVENT: ya, RATING: eL, SINGLES: jn, SINGLES_EVENT: ms, TEAM_EVENT: bi, TEAM: or }, Ie = "MAIN", Pe = "QUALIFYING", kr = "CONSOLATION", yr = "VOLUNTARY_CONSOLATION", Wt = "PLAY_OFF", zf = [Ie, Pe, kr, Wt, yr], hs = { [Pe]: 1, [Ie]: 2, [Wt]: 3, [kr]: 3, [yr]: 4 }, zR = "finishingPositions", KR = "aggregateEventStructures", XR = { [Ie]: 1, [Wt]: 2, [kr]: 3, [Pe]: 4, [yr]: 5 }, iL = { [Wt]: 1, [Ie]: 2, [kr]: 3, [Pe]: 4, [yr]: 5 }, JI = "CLUSTER", nL = "SEPARATE", Do = "WATERFALL", Kf = "ITEM", ri = "CONTAINER", sn = "DRAW", Xf = "RANDOM", dn = "TOP_DOWN", Po = "BOTTOM_UP", Aa = "POSITION", Ta = "WINNER", oa = "LOSER", _n = "FIRST_MATCHUP", Li = "AD_HOC", aL = "AD_HOC", Hc = "FEED_IN", Uc = "COMPASS", Sc = "OLYMPIC", oL = "SINGLE_ELIMINATION", xn = "SINGLE_ELIMINATION", md = "DOUBLE_ELIMINATION", yc = "FIRST_MATCH_LOSER_CONSOLATION", hd = "FIRST_ROUND_LOSER_CONSOLATION", Go = "LUCKY_DRAW", Zf = "CURTIS_CONSOLATION", sL = "CURTIS_CONSOLATION", $I = "FEED_IN_CHAMPIONSHIP_TO_SF", Vu = "FEED_IN_CHAMPIONSHIP_TO_SF", ev = "FEED_IN_CHAMPIONSHIP_TO_QF", Gu = "FEED_IN_CHAMPIONSHIP_TO_QF", tv = "FEED_IN_CHAMPIONSHIP_TO_R16", ju = "FEED_IN_CHAMPIONSHIP_TO_R16", ZR = "MODIFIED_FEED_IN_CHAMPIONSHIP", _u = "MODIFIED_FEED_IN_CHAMPIONSHIP", gd = "FEED_IN_CHAMPIONSHIP", cL = "DOUBLE_ROUND_ROBIN", hn = "ROUND_ROBIN", sa = "ROUND_ROBIN_WITH_PLAYOFF", QR = "DECIDER", JR = "BACKDRAW", rv = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-3": { name: "Northeast", abbreviation: "NE" }, "0-1-1": { name: "South", abbreviation: "S" }, "0-1-2": { name: "Southwest", abbreviation: "SW" }, "0-2-1": { name: "Northwest", abbreviation: "NW" }, "0-1-1-1": { name: "Southeast", abbreviation: "SE" } }, iv = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-1-1": { name: "South", abbreviation: "S" } }, wo = "WIN_RATIO", Es = "ROUND_OUTCOME", $R = [Uc, Zf, Gu, ju, Vu, gd, ev, tv, $I, yc, hd, Go, _u, Sc, Wt, sa], uL = [Li, Uc, Zf, md, Gu, ju, Vu, gd, Hc, yc, hd, Go, _u, Sc, Wt, hn, sa, xn], eb = { MAIN: Ie, QUALIFYING: Pe, CONSOLATION: kr, ITEM: Kf, CONTAINER: ri, FIRST_MATCHUP: _n, WINNER: Ta, LOSER: oa, AD_HOC: Li, FEED_IN: Hc, FLEX_ROUNDS: aL, COMPASS: Uc, PLAY_OFF: Wt, OLYMPIC: Sc, KNOCKOUT: oL, SINGLE_ELIMINATION: xn, DOUBLE_ELIMINATION: md, CURTIS: Zf, FICSF: $I, FICQF: ev, FICR16: tv, MFIC: ZR, VOLUNTARY_CONSOLATION: yr, FIRST_MATCH_LOSER_CONSOLATION: yc, FIRST_ROUND_LOSER_CONSOLATION: hd, MODIFIED_FEED_IN_CHAMPIONSHIP: _u, FEED_IN_CHAMPIONSHIP_TO_R16: ju, FEED_IN_CHAMPIONSHIP_TO_QF: Gu, FEED_IN_CHAMPIONSHIP_TO_SF: Vu, FEED_IN_CHAMPIONSHIP: gd, LUCKY_DRAW: Go, ROUND_ROBIN_WITH_PLAYOFF: sa, ROUND_ROBIN: hn, DECIDER: QR, BACKDRAW: JR, COMPASS_ATTRIBUTES: rv, OLYMPIC_ATTRIBUTES: iv, DRAW: sn, RANDOM: Xf, TOP_DOWN: dn, BOTTOM_UP: Po, WATERFALL: Do, WIN_RATIO: wo, ROUND_OUTCOME: Es, MULTI_STRUCTURE_DRAWS: $R, generatedDrawTypes: uL, stageOrder: hs, finishOrder: XR, AGGREGATE_EVENT_STRUCTURES: KR, FINISHING_POSITIONS: zR }, dL = eb, _r = "tournamentRecords", nv = "policyDefinitions", fr = "tournamentRecord", av = "onlineResource", ii = "drawDefinition", tb = "tieFormatName", ov = "matchUpFormat", ca = "participantId", rb = "scheduleDates", lL = "tournamentId", pL = "scheduleDate", fL = "roundNumber", Qf = "structureId", sv = "participant", Id = "matchUpIds", ib = "entryStage", mL = "policyType", nb = "structures", cv = "eventType", zn = "matchUpId", Jf = "tieFormat", $f = "inContext", em = "structure", tm = "courtIds", hL = "personId", rm = "venueIds", uv = "matchUps", ab = "courtId", ob = "eventId", pa = "matchUp", sb = "drawId", pn = "error", no = "event", Yc = "param", dv = "uuids", gL = "averageMatchUpMinutes", IL = "recoveryMinutes", vL = "periodLength", UL = "number", pi = "object", Gr = "array", Or = "_validate", cb = "_message", xi = "_invalid", ui = "_ofType", lv = "_anyOf", Ac = "_oneOf", uT = { [av]: (e) => qt(Object.keys(e), [gc, Ic, vc]).length === 3, [tb]: (e) => e && Sa({ namedFormat: e }), [dv]: (e) => !e || Array.isArray(e) && e.every(Et), [Jf]: (e) => !oi({ tieFormat: e }).error, [cv]: (e) => [jn, Xi, or].includes(e), [ib]: (e) => zf.includes(e) }, SL = { [_r]: xt, [fr]: de, [nv]: Mf, [ii]: Ue, [ca]: cr, [ov]: TI, [lL]: pc, [Qf]: Vi, [Id]: Ts, [sv]: ws, [av]: Ea, [cv]: na, [nb]: SI, [zn]: zr, [Jf]: Jn, [em]: Bo, [ab]: Ds, [uv]: Ma, [ob]: Ki, [pa]: hi, [tm]: we, [rm]: we, [sb]: Cn, [no]: At }, yL = { [_r]: pi, [nv]: pi, [fr]: pi, [ii]: pi, [av]: pi, [rb]: Gr, [sv]: pi, [Id]: Gr, [nb]: Gr, [Jf]: pi, [em]: pi, [tm]: Gr, [rm]: Gr, [uv]: Gr, [pa]: pi, [no]: pi, [dv]: Gr };
function Ae(e, t, r) {
  if (!e && !$e(e)) return { error: ie };
  if (!(t != null && t.length) || e != null && e._bypassParamCheck) return { valid: !0 };
  if (!Array.isArray(t)) return { error: ie };
  let { paramError: i, errorParam: n } = DL(e, t);
  if (!i) return { valid: !0 };
  let a = i[Or] && (i[pn] || i[xi]) || (e == null ? void 0 : e[n]) === void 0 && (i[pn] || i[xi] || SL[n] || ie) || ie, o = n ?? (i[Ac] && Object.keys(i[Ac]).join(", "));
  return W({ info: { param: o, message: i[cb] }, result: { error: a }, stack: r });
}
function ub(e, t) {
  let r = Object.keys(e), i = Object.keys(t);
  return qt(r, i);
}
function AL(e, t) {
  if (!t) return;
  let r = ub(e, t);
  return r.length !== 1 ? { error: ie } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function TL(e, t) {
  if (!t) return;
  let r = ub(e, t).filter((i) => e[i]);
  return r.length < 1 ? { error: ie } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function DL(e, t) {
  let r, i;
  return { paramError: t.find(({ _ofType: n, _oneOf: a, _anyOf: o, _validate: s, _info: c, ...u }) => {
    let d = a && AL(e, a);
    if (d != null && d.error) return d.error;
    d && Object.assign(u, d);
    let l = o && TL(e, o);
    if (l != null && l.error) return l.error;
    l && Object.assign(u, l);
    let p = Object.keys(u).filter((m) => typeof u[m] == "boolean"), f = p.find((m) => {
      let h = s && !Ti(s), g = e[m] !== void 0 && !s && PL(e, m, n), I = u[m] && [void 0, null].includes(e[m]), U = h || g || I || s && e[m] !== void 0 && !wL(e[m], s) || uT[m] && !uT[m](e[m]);
      return U && (r = m, i = c), U;
    });
    return !p.length || f;
  }), errorParam: r, paramInfo: i };
}
function PL(e, t, r) {
  return r = r || yL[t] || "string", r === "array" ? !Array.isArray(e[t]) : typeof e[t] !== r;
}
function wL(e, t) {
  return Ti(t) ? t(e) : !0;
}
var pv = "DYNAMIC", Ya = "RANKING", qa = "RATING", Ro = "SCALE", $n = "SEEDING", RL = { RANKING: Ya, RATING: qa, SCALE: Ro, SEEDING: $n };
function zc(e) {
  var n;
  let t = Ae(e, [{ [sv]: !0 }]);
  if (t.error) return t;
  let r = (n = e.participant.timeItems) == null ? void 0 : n.filter(({ itemType: a }) => (a == null ? void 0 : a.startsWith(Ro)) && [Ya, qa, $n].includes(a.split(".")[1])), i = { ratings: {}, rankings: {}, seedings: {} };
  if (r != null && r.length) {
    let a = (s) => r.filter((c) => (c == null ? void 0 : c.itemType) === s).sort((c, u) => new Date(c.createdAt || void 0).getTime() - new Date(u.createdAt || void 0).getTime()).pop(), o = Be(r.map(({ itemType: s }) => s));
    for (let s of o) {
      let c = a(s);
      if (c) {
        let [, u, d, l, p] = c.itemType.split("."), f = p ? `${l}.${p}` : l, m = u === $n && "seedings" || u === Ya && "rankings" || "ratings";
        i[m][d] || (i[m][d] = []), i[m][d].push({ scaleValue: c.itemValue, scaleDate: c.itemDate, scaleName: f });
      }
    }
  }
  return { ...j, ...i };
}
function gs(e) {
  if (e === null) return {};
  let { source: t, template: r } = e || {};
  if (!r) return t;
  let i = {};
  return n(t, r, i), i;
  function n(a, o, s) {
    if (!a || !o) return;
    let c = Object.keys(a), u = Object.keys(o), d = Object.assign({}, ...u.filter((f) => f.indexOf("||")).map((f) => f.split("||").map((m) => ({ [m]: f }))).flat()), l = u.concat(...Object.keys(d)), p = l.includes("*");
    for (let f of c) if (l.indexOf(f) >= 0 || p) {
      let m = d[f] || f, h = o[m] || p, g = a[f];
      if (typeof h == "object" && typeof g != "function" && !Array.isArray(h)) if (Array.isArray(g)) {
        let I = g.map((U) => {
          let v = {};
          return n(U, h, v) !== !1 ? v : void 0;
        }).filter(Boolean);
        s[f] = I;
      } else g && (s[f] = {}, n(g, h, s[f]));
      else {
        let I = a[f];
        if (Array.isArray(h) && !h.includes(I)) return !1;
        (o[f] || p && o[f] !== !1) && (s[f] = I);
      }
    }
  }
}
var Pg = "voluntaryConsolation", ha = "competitiveBands", fv = "roundRobinTally", Is = "positionActions", Ar = "matchUpActions", Gl = "rankingPoints", Tc = "roundNaming", vd = "participant", Wu = "progression", ao = "scheduling", cp = "avoidance", bL = "participant", NL = "display", En = "scoring", Tn = "seeding", Dc = "feedIn", ML = "audit", up = "draws", EL = { POLICY_TYPE_VOLUNTARY_CONSOLATION: Pg, POLICY_TYPE_COMPETITIVE_BANDS: ha, POLICY_TYPE_ROUND_ROBIN_TALLY: fv, POLICY_TYPE_POSITION_ACTIONS: Is, POLICY_TYPE_MATCHUP_ACTIONS: Ar, POLICY_TYPE_RANKING_POINTS: Gl, POLICY_TYPE_ROUND_NAMING: Tc, POLICY_TYPE_PARTICIPANT: vd, POLICY_TYPE_PROGRESSION: Wu, POLICY_TYPE_SCHEDULING: ao, POLICY_TYPE_AVOIDANCE: cp, POLICY_TYPE_DISPLAY: NL, POLICY_TYPE_PRIVACY: bL, POLICY_TYPE_FEED_IN: Dc, POLICY_TYPE_SCORING: En, POLICY_TYPE_SEEDING: Tn, POLICY_TYPE_AUDIT: ML, POLICY_TYPE_DRAWS: up };
function za({ tournamentParticipants: e = [], policyDefinitions: t = {}, contextProfile: r, participantId: i, internalUse: n, personId: a }) {
  let o = e.find((c) => i && c.participantId === i || a && c.person && c.person.personId === a), s = ge(o, !1, n);
  if (s) {
    let c = t == null ? void 0 : t[vd];
    if (r != null && r.withScaleValues) {
      let { ratings: u, rankings: d } = zc({ participant: s });
      s.rankings = d, s.ratings = u;
    }
    if (c != null && c.participant) return gs({ template: c.participant, source: s });
  }
  return s;
}
var OL = "element required", CL = "missing name";
function Zr(e) {
  if (!e || typeof e != "object") return { error: we };
  if (e.element && typeof (e == null ? void 0 : e.element) != "object") return { error: ie };
  if (!(e != null && e.name)) return { error: we, info: CL };
  if (!(e != null && e.element)) {
    if (e.discover && e.tournamentRecords) {
      for (let t of Object.keys(e.tournamentRecords)) {
        let r = e.tournamentRecords[t], i = Zr({ element: r, name: e.name });
        if (i.error) return W({ result: i, stack: "removeExtension" });
      }
      return { ...j };
    }
    return { error: we, info: OL };
  }
  return e != null && e.element.extensions ? (e.element.extensions = e.element.extensions.filter((t) => (t == null ? void 0 : t.name) !== e.name), { ...j }) : { ...j, info: Tr };
}
function Wn({ requiredAttributes: e = ["name", "value"], extension: t }) {
  if (!t || typeof t != "object" || typeof t.name != "string") return !1;
  let r = Object.keys(t);
  return e.filter((i) => r.includes(i)).length === e.length;
}
function it(e) {
  if (typeof e != "object") return { error: we };
  let t = "addExtension";
  if (e != null && e.element && typeof e.element != "object") return W({ result: { error: ie }, stack: t });
  if (!Wn({ extension: e.extension })) return W({ result: { error: ie, info: "invalid extension" }, stack: t });
  if (!e.element) if (e.discover && !e.tournamentId && e.tournamentRecords) {
    for (let i of Object.values(e.tournamentRecords)) {
      let n = it({ extension: e.extension, element: i });
      if (n.error) return W({ result: n, stack: t });
    }
    return { ...j };
  } else return W({ result: { error: we }, stack: t });
  if (e.element.extensions || (e.element.extensions = []), (e == null ? void 0 : e.creationTime) ?? !0) {
    let i = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(e.extension, { createdAt: i });
  }
  let r = e.element.extensions.find(({ name: i }) => i === e.extension.name);
  return r ? r.value = e.extension.value : e.extension.value && e.element.extensions.push(e.extension), { ...j };
}
function mv(e) {
  return !e || typeof e != "object" ? { error: we } : e.tournamentRecord ? it({ creationTime: e.creationTime, element: e.tournamentRecord, extension: e.extension }) : { error: de };
}
function im(e) {
  return !e || typeof e != "object" ? { error: we } : e.drawDefinition ? it({ creationTime: e.creationTime, element: e.drawDefinition, extension: e.extension }) : { error: Fi };
}
function oo(e) {
  return !e || typeof e != "object" ? { error: we } : e.event ? it({ creationTime: e.creationTime, extension: e.extension, element: e.event }) : { error: Ki };
}
function db(e) {
  var i;
  if (!e || typeof e != "object") return { error: we };
  if (!e.participantId) return { error: cr };
  let t = ((i = e.tournamentRecord) == null ? void 0 : i.participants) || [], r = za({ participantId: e.participantId, tournamentParticipants: t });
  return r ? it({ creationTime: e.creationTime, extension: e.extension, element: r }) : { error: Yt };
}
function hv(e) {
  return !e || typeof e != "object" ? { error: we } : e.tournamentRecord ? Zr({ element: e.tournamentRecord, name: e.name }) : { error: de };
}
function lb(e) {
  return !e || typeof e != "object" ? { error: we } : e.drawDefinition ? Zr({ element: e.drawDefinition, name: e.name }) : { error: Fi };
}
function nm(e) {
  return !e || typeof e != "object" ? { error: we } : e != null && e.event ? Zr({ element: e.event, name: e.name }) : { error: Ki };
}
function pb(e) {
  var i;
  if (!e || typeof e != "object") return { error: we };
  if (!e.participantId) return { error: cr };
  let t = ((i = e.tournamentRecord) == null ? void 0 : i.participants) || [], r = za({ participantId: e.participantId, tournamentParticipants: t });
  return r ? Zr({ element: r, name: e.name }) : { error: Yt };
}
function Ud({ tournamentRecords: e }) {
  return { tournamentIds: $e(e) ? Object.keys(e) : [], ...j };
}
var FL = "extensionQueries";
function We({ discover: e, element: t, name: r, ...i }) {
  var a;
  if (!t || !r) {
    if (e && i) {
      let o = Object.keys(i).filter((u) => typeof e == "boolean" || Array.isArray(e) && e.includes(u)).find((u) => {
        var d;
        return Array.isArray((d = i[u]) == null ? void 0 : d.extensions) ? i[u].extensions.find((l) => (l == null ? void 0 : l.name) === r) : !1;
      }), s = o && i[o];
      !s && i.tournamentRecords && (s = Object.values(i.tournamentRecords).find((u) => {
        var d;
        return (d = u.extensions) == null ? void 0 : d.length;
      }));
      let c = (a = s == null ? void 0 : s.extensions) == null ? void 0 : a.find((u) => (u == null ? void 0 : u.name) === r);
      return { extension: c, info: c ? void 0 : Tr };
    }
    return W({ result: { error: we }, stack: FL });
  }
  if (!Array.isArray(t.extensions)) return { info: "no extensions" };
  let n = t.extensions.find((o) => (o == null ? void 0 : o.name) === r);
  return { extension: n, info: n ? void 0 : Tr };
}
var kL = "activeSuspension", qu = "appliedPolicies", fb = "context", am = "delegatedOutcome", Pn = "disabled", vs = "disableAutoCalc", om = "disableLinks", dp = "display", So = "drawDeletions", LL = "drawProfile", lp = "entryProfile", xL = "eventProfile", BL = "eventWithdrawalRequests", VL = "factory", gn = "flightProfile", wg = "groupingAttribute", Da = "lineUps", bo = "linkedTournamentsIds", sm = "matchUpHistory", gv = "participantRepresentatives", Kc = "personRequests", cc = "positionActions", GL = "rankingPoints", jL = "registration", Kn = "roundTarget", Sd = "scheduleLimits", Pa = "scheduleTiming", Us = "schedulingProfile", _L = "statusDetail", Pc = "subOrder", Ka = "tally", Tu = "tieFormatModification", mb = { ACTIVE_SUSPENSION: kL, APPLIED_POLICIES: qu, CONTEXT: fb, DELEGATED_OUTCOME: am, DISABLED: Pn, DISABLE_LINKS: om, DISABLE_AUTO_CALC: vs, DISPLAY: dp, DRAW_DELETIONS: So, DRAW_PROFILE: LL, ENTRY_PROFILE: lp, EVENT_PROFILE: xL, EVENT_WITHDRAWAL_REQUESTS: BL, FLIGHT_PROFILE: gn, GROUPING_ATTRIBUTE: wg, LINEUPS: Da, LINKED_TOURNAMENTS: bo, MATCHUP_HISTORY: sm, PARTICIPANT_REPRESENTATIVES: gv, PERSON_REQUESTS: Kc, POSITION_ACTIONS: cc, RANKING_POINTS: GL, REGISTRATION: jL, ROUND_TARGET: Kn, SCHEDULE_LIMITS: Sd, SCHEDULE_TIMING: Pa, SCHEDULING_PROFILE: Us, STATUS_DETAIL: _L, SUB_ORDER: Pc, TALLY: Ka, TIE_FORMAT_MODIFICATIONS: Tu, FACTORY: VL }, dT = [am, Pn, vs, om, gn, Da, bo, sm, gv, Kc, Kn, Sd, Pa, Us, Pc, Ka, Tu];
function hb({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let t = Ud({ tournamentRecords: e }), { tournamentIds: r } = t;
  return (r == null ? void 0 : r.length) > 1 ? it({ tournamentRecords: e, discover: !0, extension: { name: bo, value: { tournamentIds: r } } }) : { ...j };
}
function gb({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let t = Zr({ name: bo, tournamentRecords: e, discover: !0 });
  return W({ result: t, stack: "unlinkTournaments" });
}
function Ib({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object") return { error: ie };
  if (!t) return { error: pc };
  let r = Ud({ tournamentRecords: e }), { tournamentIds: i } = r;
  if (!i.includes(t)) return { error: pc };
  let n;
  return i.every((a) => {
    var l;
    let o = e[a], { extension: s } = We({ element: o, name: bo });
    if (!s) return !0;
    let c = ((l = s == null ? void 0 : s.value) == null ? void 0 : l.tournamentIds) || [];
    if (!(c != null && c.length) || c.length === 1 && c.includes(t) || a === t) {
      let p = hv({ name: bo, tournamentRecord: o });
      return p.error && (n = p.error), p.success;
    }
    let u = c.filter((p) => p !== t);
    s.value = { tournamentIds: u };
    let d = mv({ tournamentRecord: o, extension: s });
    return d.error && (n = d.error), d.success;
  }), n ? { error: n } : { ...j };
}
var vb = {};
qe(vb, { getLinkedTournamentIds: () => yd, getTournamentIds: () => Ud });
function yd({ tournamentRecords: e }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: xt } : { linkedTournamentIds: Object.assign({}, ...Object.keys(e).map((t) => {
    var o;
    let r = e[t], i = r == null ? void 0 : r.tournamentId, { extension: n } = We({ element: r, name: bo }), a = (((o = n == null ? void 0 : n.value) == null ? void 0 : o.tournamentIds) || []).filter((s) => s !== i);
    return { [t]: a };
  })) };
}
var Ub = {};
qe(Ub, { adHocPositionSwap: () => uM, addAdHocMatchUps: () => km, addDrawDefinitionTimeItem: () => vU, addFinishingRounds: () => Ld, addGoesTo: () => Eo, addPlayoffStructures: () => Fm, addQualifyingStructure: () => cM, addVoluntaryConsolationStage: () => rM, addVoluntaryConsolationStructure: () => oU, allPlayoffPositionsFilled: () => gU, alternateDrawPositionAssignment: () => HN, assignDrawPosition: () => kM, assignDrawPositionBye: () => _i, attachConsolationStructures: () => EM, attachPlayoffStructures: () => kU, attachQualifyingStructure: () => IU, attachStructures: () => Cm, autoSeeding: () => _j, automatedPlayoffPositioning: () => ru, automatedPositioning: () => Yd, checkValidEntries: () => Bm, deleteAdHocMatchUps: () => xM, drawMatic: () => nS, findDrawDefinition: () => GU, generateAdHocMatchUps: () => Vm, generateAdHocRounds: () => iS, generateAndPopulatePlayoffStructures: () => CU, generateDrawDefinition: () => dl, generateDrawMaticRound: () => zU, generateDrawStructuresAndLinks: () => qU, generateDrawTypeAndModifyDrawDefinition: () => HU, generateQualifyingStructure: () => DU, generateVoluntaryConsolation: () => s0, getAssignedParticipantIds: () => Ko, getAvailableMatchUpsCount: () => Lm, getAvailablePlayoffProfiles: () => Kd, getDrawDefinitionTimeItem: () => xv, getDrawParticipantRepresentativeIds: () => BU, getDrawStructures: () => In, getDrawTypeCoercion: () => rl, getEligibleVoluntaryConsolationParticipants: () => xU, getMatchUpsMap: () => xr, getParticipantIdFinishingPositions: () => VU, getPositionAssignments: () => Zu, getPositionsPlayedOff: () => iu, getSeedingThresholds: () => dU, getSeedsCount: () => il, getStructureSeedAssignments: () => Qi, getTeamLineUp: () => Mo, getValidGroupSizes: () => qd, isAdHoc: () => si, isCompletedStructure: () => $a, isValidForQualifying: () => WU, luckyLoserDrawPositionAssignment: () => BN, modifyDrawDefinition: () => OM, modifyDrawName: () => LU, modifySeedAssignment: () => YN, mutate: () => Sb, positionActions: () => _U, pruneDrawDefinition: () => FM, qualifierDrawPositionAssignment: () => qN, query: () => GM, removeDrawPositionAssignment: () => Xu, removeRoundMatchUps: () => BM, removeSeededParticipant: () => sM, removeStructure: () => eM, renameStructures: () => $N, resetDrawDefinition: () => CM, resetVoluntaryConsolationStructure: () => Lb, setDrawParticipantRepresentativeIds: () => yb, setPositionAssignments: () => _N, setStructureOrder: () => QN, setSubOrder: () => VM, shiftAdHocRounds: () => jN, swapAdHocRounds: () => WN, swapDrawPositionAssignments: () => aM, updateTeamLineUp: () => Hs, withdrawParticipantAtDrawPosition: () => MN });
var Sb = {};
qe(Sb, { adHocPositionSwap: () => uM, addAdHocMatchUps: () => km, addDrawDefinitionTimeItem: () => vU, addPlayoffStructures: () => Fm, addQualifyingStructure: () => cM, addVoluntaryConsolationStage: () => rM, addVoluntaryConsolationStructure: () => oU, alternateDrawPositionAssignment: () => HN, assignDrawPosition: () => kM, assignDrawPositionBye: () => _i, attachConsolationStructures: () => EM, attachPlayoffStructures: () => kU, attachQualifyingStructure: () => IU, attachStructures: () => Cm, automatedPlayoffPositioning: () => ru, automatedPositioning: () => Yd, deleteAdHocMatchUps: () => xM, luckyLoserDrawPositionAssignment: () => BN, modifyDrawDefinition: () => OM, modifyDrawName: () => LU, modifySeedAssignment: () => YN, pruneDrawDefinition: () => FM, qualifierDrawPositionAssignment: () => qN, removeDrawPositionAssignment: () => Xu, removeRoundMatchUps: () => BM, removeSeededParticipant: () => sM, removeStructure: () => eM, renameStructures: () => $N, resetDrawDefinition: () => CM, resetVoluntaryConsolationStructure: () => Lb, setDrawParticipantRepresentativeIds: () => yb, setPositionAssignments: () => _N, setStructureOrder: () => QN, setSubOrder: () => VM, shiftAdHocRounds: () => jN, swapAdHocRounds: () => WN, swapDrawPositionAssignments: () => aM, updateTeamLineUp: () => Hs, withdrawParticipantAtDrawPosition: () => MN });
var Iv = (e) => (t) => e[t], vv = (e = []) => e.map(hr).filter(Boolean), Rg = (e = []) => e.map(Ke).filter(Boolean), Ke = (e = {}) => Iv(e)("participantId"), hr = (e = {}) => Iv(e)("matchUpId"), Hu = (e = {}) => Iv(e)("drawId");
function yb({ representativeParticipantIds: e, drawDefinition: t }) {
  if (!t) return { error: Fi };
  if (!Array.isArray(e)) return { error: ie };
  let r = Rg((t == null ? void 0 : t.entries) || []);
  return e.length && qt(e, r).length < e.length ? { error: ie } : im({ drawDefinition: t, extension: { name: gv, value: e } });
}
var Bi = "ABANDONED", Os = "AWAITING_RESULT", at = "BYE", Oa = "CANCELLED", zt = "COMPLETED", Xc = "DEAD_RUBBER", Je = "DEFAULTED", sr = "DOUBLE_DEFAULT", $t = "DOUBLE_WALKOVER", Sn = "IN_PROGRESS", Zi = "INCOMPLETE", Uv = "NOT_PLAYED", Wr = "RETIRED", so = "SUSPENDED", Xt = "TO_BE_PLAYED", ct = "WALKOVER", WL = [Os, zt, Je, Sn, Zi, Wr, so], Ab = [Os, zt, Je, $t, sr, Sn, Zi, Wr, so, ct], Tb = [Bi, Os, at, Oa, zt, Xc, Je, $t, sr, Sn, Zi, Uv, Wr, so, Xt, ct], Db = [at, $t, sr, zt, Je, Wr, ct], Pb = [Bi, Os, Oa, Xc, Sn, Zi, Uv, so, Xt, void 0], lr = [Oa, Bi, zt, Xc, Je, $t, sr, Wr, ct], Sv = [Bi, zt, Je, $t, sr, Sn, Wr, ct], wb = [Sn, Zi, so, Xt], Rb = { ABANDONED: Bi, AWAITING_RESULT: Os, BYE: at, CANCELLED: Oa, COMPLETED: zt, DEAD_RUBBER: Xc, DEFAULTED: Je, DOUBLE_WALKOVER: $t, DOUBLE_DEFAULT: sr, IN_PROGRESS: Sn, INCOMPLETE: Zi, NOT_PLAYED: Uv, RETIRED: Wr, SUSPENDED: so, TO_BE_PLAYED: Xt, WALKOVER: ct };
function Cs(e, t, r) {
  var l, p;
  let i = (f) => {
    var m, h;
    return (h = (m = We({ element: f, name: Kn })) == null ? void 0 : m.extension) == null ? void 0 : h.value;
  }, n = r == null ? void 0 : r.deprioritizeCompleted, a = (r == null ? void 0 : r.mode) === KR && iL, o = (r == null ? void 0 : r.mode) === zR && XR, s = o || a || hs, c = (f) => (f == null ? void 0 : f.stage) === Ie && (f == null ? void 0 : f.stageSequence) === 1, u = (f) => c(f) ? -1 : s[f == null ? void 0 : f.stage], d = (f) => f == null ? void 0 : f.matchUps.every(({ matchUpStatus: m }) => lr.includes(m) ? 1 : -1);
  return n && d(e) - d(t) || a && u(e) - u(t) || ((e == null ? void 0 : e.stage) && s[e.stage] || 0) - ((t == null ? void 0 : t.stage) && s[t.stage] || 0) || (i(e) || 0) - (i(t) || 0) || !o && !a && (((l = t == null ? void 0 : t.positionAssignments) == null ? void 0 : l.length) ?? 1 / 0) - (((p = e == null ? void 0 : e.positionAssignments) == null ? void 0 : p.length) ?? 1 / 0) || ((e == null ? void 0 : e.stageSequence) ?? 0) - ((t == null ? void 0 : t.stageSequence) ?? 0) || (pp(e) || 0) - (pp(t) || 0);
}
function pp(e) {
  return ((e == null ? void 0 : e.matchUps) || []).reduce((t, r) => {
    var n;
    let i = (((n = r.finishingPositionRange) == null ? void 0 : n.winner) || []).reduce((a, o) => a + o, 0);
    return !t || i < t ? i : t;
  }, void 0);
}
function Ne(e) {
  let t = Ae(e, [{ [ii]: !0, [Qf]: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, structureId: i } = e, { structures: n } = In({ drawDefinition: r }), a = n == null ? void 0 : n.map((c) => c.structures ? [...c.structures].concat(c) : c).flat(), o = a == null ? void 0 : a.find((c) => c.structureId === i);
  if (!o) return { error: kt };
  let s = o.structureType === Kf ? a == null ? void 0 : a.find((c) => {
    var u;
    return (u = c.structures) == null ? void 0 : u.some((d) => d.structureId === i);
  }) : void 0;
  return { structure: o, containingStructure: s };
}
function In({ withStageGrouping: e, drawDefinition: t, stageSequences: r, stageSequence: i, roundTarget: n, sortConfig: a, stages: o, stage: s }) {
  var m;
  let c = !t && Ue || !(t != null && t.structures) && SI || void 0;
  if (c) return { error: c, structures: [], stageStructures: {} };
  let u = (h) => {
    var I, U;
    let g = (U = (I = We({ element: h, name: Kn })) == null ? void 0 : I.extension) == null ? void 0 : U.value;
    return !n || n === g;
  }, d = ((m = t == null ? void 0 : t.structures) == null ? void 0 : m.filter(p).filter(f).filter(u).sort((h, g) => Cs(h, g, a))) ?? [], l = e ? Object.assign({}, ...zf.map((h) => {
    let g = d == null ? void 0 : d.filter((I) => I.stage === h);
    return (g == null ? void 0 : g.length) && { [h]: g };
  }).filter(Boolean)) : {};
  return { structures: d, stageStructures: l };
  function p(h) {
    return !s && !Array.isArray(o) || s && h.stage === s || Array.isArray(o) && o.includes(h.stage);
  }
  function f(h) {
    return !i && !Array.isArray(r) || i && h.stageSequence === i || Array.isArray(r) && r.includes(h.stageSequence);
  }
}
function bb({ drawDefinition: e }) {
  if (!e) return { error: Ue };
  let t = {};
  return { allPositionedParticipantIds: (e.structures || []).map((r) => {
    let i = r.stage;
    t[i] || (t[i] = []);
    let { positionAssignments: n } = gt({ structure: r }), a = (n == null ? void 0 : n.map(Ke).filter(Boolean)) ?? [];
    return t[i].push(...a), a;
  }).flat(), stagePositionedParticipantIds: t };
}
function gt({ drawDefinition: e, structureId: t, structure: r }) {
  let i, n = [];
  if (!r) {
    if (!e) return { positionAssignments: n, error: Ue };
    if ({ structure: r, error: i } = Ne({ drawDefinition: e, structureId: t }), i) return { positionAssignments: n, error: i };
  }
  return r.structures ? n = [].concat(...r.structures.map((a) => gt({ structure: a }).positionAssignments)) : r.positionAssignments ? n = r.positionAssignments : i = nw, { positionAssignments: n, error: i };
}
function Ir({ drawDefinition: e, structureId: t, structure: r }) {
  var u;
  let i = ((u = gt({ drawDefinition: e, structureId: t, structure: r })) == null ? void 0 : u.positionAssignments) || [], n = i == null ? void 0 : i.filter((d) => d.participantId ?? d.bye ?? d.qualifier), a = i && (i == null ? void 0 : i.length) === (n == null ? void 0 : n.length), o = i == null ? void 0 : i.filter((d) => !d.participantId && !d.bye && !d.qualifier), s = i == null ? void 0 : i.filter((d) => !d.participantId && d.bye), c = i == null ? void 0 : i.filter((d) => !d.participantId && d.qualifier);
  return { allPositionsAssigned: a, positionAssignments: i, unassignedPositions: o, assignedPositions: n, qualifierPositions: c, byePositions: s };
}
var yv = "addDrawDefinition", cm = "addMatchUps", Xa = "addParticipants", Av = "addScaleItems", Nb = "addEvent", Tv = "addVenue", va = "audit", Dv = "dataIssue", Pv = "deleteParticipants", wv = "deleteVenue", Rv = "deletedDrawIds", bv = "deletedMatchUpIds", Nv = "modifyDrawDefinition", Mb = "modifyDrawEntries", Eb = "modifyEventEntries", Mv = "modifyMatchUp", Lr = "modifyParticipants", Ev = "modifyPositionAssignments", Ov = "modifySeedAssignments", jo = "modifyTournamentDetail", _o = "modifyVenue", bg = "mutations", Ng = "publishEvent", Ob = "publishEventSeeding", Cb = "publishOrderOfPlay", Fb = "publishParticipants", Cv = "unPublishEvent", Fv = "unPublishEventSeeding", kv = "unPublishOrderOfPlay", qL = "unPublishParticipants", um = "updateInContextMatchUp", HL = { ADD_DRAW_DEFINITION: yv, ADD_MATCHUPS: cm, ADD_PARTICIPANTS: Xa, ADD_SCALE_ITEMS: Av, ADD_EVENT: Nb, ADD_VENUE: Tv, AUDIT: va, DATA_ISSUE: Dv, DELETE_PARTICIPANTS: Pv, DELETE_VENUE: wv, DELETED_DRAW_IDS: Rv, DELETED_MATCHUP_IDS: bv, MODIFY_DRAW_DEFINITION: Nv, MODIFY_DRAW_ENTRIES: Mb, MODIFY_EVENT_ENTRIES: Eb, MODIFY_MATCHUP: Mv, MODIFY_PARTICIPANTS: Lr, MODIFY_POSITION_ASSIGNMENTS: Ev, MODIFY_SEED_ASSIGNMENTS: Ov, MODIFY_TOURNAMENT_DETAIL: jo, MODIFY_VENUE: _o, MUTATIONS: bg, PUBLISH_EVENT_SEEDING: Ob, PUBLISH_EVENT: Ng, PUBLISH_ORDER_OF_PLAY: Cb, PUBLISH_PARTICIPANTS: Fb, UNPUBLISH_EVENT_SEEDING: Fv, UNPUBLISH_EVENT: Cv, UNPUBLISH_ORDER_OF_PLAY: kv, UPDATE_INCONTEXT_MATCHUP: um };
function dm(e, t) {
  var a;
  if (!e) return { error: Ue };
  let r = Date.now();
  e.updatedAt && r === new Date(e.updatedAt).getTime() && (r += 1);
  let i = new Date(r).toISOString(), n = t == null ? void 0 : t.filter(Boolean);
  return e.updatedAt = i, (a = e.structures) == null || a.filter(Boolean).forEach((o) => {
    (!(n != null && n.length) || n != null && n.includes(o.structureId)) && (o.updatedAt = i);
  }), { ...j };
}
function Za({ drawDefinition: e, tournamentId: t, matchUps: r, eventId: i }) {
  return e && dm(e), Le({ payload: { matchUps: r, tournamentId: t, eventId: i }, topic: cm }), { ...j };
}
function Ca({ drawDefinition: e, tournamentId: t, matchUpIds: r, eventId: i, action: n }) {
  e && dm(e), Le({ topic: bv, payload: { tournamentId: t, matchUpIds: r, eventId: i, action: n } });
  for (let a of r) WI({ key: a });
  return { ...j };
}
function Qe({ drawDefinition: e, tournamentId: t, structureId: r, context: i, eventId: n, matchUp: a }) {
  return a ? (e && vt({ drawDefinition: e, structureIds: r ? [r] : void 0, tournamentId: t, eventId: n }), Le({ topic: Mv, payload: { matchUp: a, tournamentId: t, context: i }, key: a.matchUpId }), { ...j }) : (console.log(hi), { error: hi });
}
function YL({ tournamentId: e, inContextMatchUp: t }) {
  return t ? (Le({ payload: { inContextMatchUp: t, tournamentId: e }, topic: um, key: t.matchUpId }), { ...j }) : { error: hi };
}
function Ad({ tournamentId: e, eventId: t, drawDefinition: r }) {
  return r ? (dm(r), Le({ payload: { drawDefinition: r, tournamentId: e, eventId: t }, topic: yv, key: r.drawId }), { ...j }) : (console.log(Ue), { error: Ue });
}
function zL({ tournamentId: e, eventId: t, drawId: r }) {
  return Le({ payload: { drawId: r, tournamentId: e, eventId: t }, topic: Rv, key: r }), WI({ key: r }), { ...j };
}
function vt({ drawDefinition: e, tournamentId: t, structureIds: r, eventId: i }) {
  return e ? (dm(e, r), Le({ payload: { tournamentId: t, eventId: i, drawDefinition: e }, topic: Nv, key: e.drawId }), { ...j }) : { error: Ue };
}
function kb({ drawDefinition: e, tournamentId: t, structure: r, eventId: i }) {
  if (!e) return { error: Ue };
  if (!r) return { error: Bo };
  let n = r.seedAssignments, a = r.structureId, o = e.drawId;
  return Le({ payload: { tournamentId: t, eventId: i, drawId: o, structureId: a, seedAssignments: n }, topic: Ov, key: e.drawId }), vt({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: i }), { ...j };
}
function Qa({ drawDefinition: e, tournamentId: t, structure: r, event: i }) {
  if (!e) return { error: Ue };
  if (!r) return { error: Bo };
  let n = gt({ structure: r }), a = r.structureId, o = e.drawId, s = i == null ? void 0 : i.eventId;
  return Le({ topic: Ev, payload: { positionAssignments: n, tournamentId: t, structureId: a, eventId: s, drawId: o }, key: a }), vt({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: s }), { ...j };
}
function Lb({ tournamentRecord: e, drawDefinition: t, resetEntries: r, event: i }) {
  var o, s;
  if (!t) return { error: Ue };
  let n = (o = t.structures) == null ? void 0 : o.find((c) => c.stage === yr);
  if (!n) return { error: kt };
  let a = ((s = n.matchUps) == null ? void 0 : s.map(({ matchUpId: c }) => c)) || [];
  return n.positionAssignments = [], n.seedAssignments = [], n.matchUps = [], Ca({ tournamentId: e == null ? void 0 : e.tournamentId, action: "resetVoluntaryConsolationStructure", matchUpIds: a, drawDefinition: t }), r && (t.entries = t.entries.filter((c) => c.entryStage !== yr)), vt({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: i == null ? void 0 : i.eventId, drawDefinition: t, structureIds: [n.structureId] }), { ...j };
}
function Lv({ drawPositions: e, structure: t }) {
  var i;
  if ([Pe, Ie].includes(t.stage) && t.stageSequence === 1) return;
  let { positionAssignments: r } = gt({ structure: t });
  (i = r == null ? void 0 : r.filter(({ drawPosition: n }) => e == null ? void 0 : e.includes(n))) == null || i.forEach((n) => {
    it({ element: n, extension: { name: om, value: !0 } });
  });
}
function lm(e) {
  var s, c;
  let { appliedPolicies: t, positionAction: r, drawDefinition: i } = e;
  if (((s = t == null ? void 0 : t.audit) == null ? void 0 : s[cc]) === !1) return;
  let { extension: n } = We({ name: cc, element: i }), a = Array.isArray(n == null ? void 0 : n.value) ? (n == null ? void 0 : n.value) ?? [] : [];
  if (!(a != null && a.length)) {
    let u = i.structures.find((d) => d.stage === Ie);
    if (u) {
      let d = (c = gt({ structure: u }).positionAssignments) == null ? void 0 : c.map(({ drawPosition: l, participantId: p, bye: f, qualifier: m }) => ({ drawPosition: l, participantId: p, qualifier: m, bye: f }));
      a.push({ name: "initialMainAssignments", initialAssignments: d });
    }
  }
  let o = { value: a.concat(r), name: cc };
  it({ element: i, extension: o });
}
function Zc({ tournamentRecord: e, drawDefinition: t, event: r }) {
  var s;
  let i = ((s = (e == null ? void 0 : e.events) || r && [r]) == null ? void 0 : s.map((c) => c == null ? void 0 : c.drawDefinitions).flat().filter(Boolean)) || t && [t] || [], n = {}, a = {}, o = i.map((c) => {
    var u;
    return (u = c == null ? void 0 : c.structures) == null ? void 0 : u.filter((d) => d == null ? void 0 : d.structures);
  }).flat().filter(Boolean);
  for (let c of o) {
    let { structures: u, structureId: d } = c ?? {};
    u && d && (n[d] = u == null ? void 0 : u.map((l) => l.structureId)) && u.forEach((l) => a[l.structureId] = c == null ? void 0 : c.structureId);
  }
  return { containedStructures: n, containerStructures: a };
}
function pm(e) {
  var a;
  let { sides: t, matchUpType: r } = e || {}, i = (a = e.potentialParticipants) != null && a.length ? e.potentialParticipants.flat().map((o) => r === ft ? (o == null ? void 0 : o.individualParticipantIds) || [] : o.participantId).flat() : [], n = (t || []).map((o) => {
    var s;
    return r === ft && (((s = o == null ? void 0 : o.participant) == null ? void 0 : s.individualParticipantIds) || []) || (o == null ? void 0 : o.participantId) && [o.participantId] || [];
  }).flat();
  return { individualParticipantIds: n.concat(i).flat(), enteredIndividualParticipantIds: n, potentialIndividualParticipantIds: i };
}
function $i(e) {
  return (e == null ? void 0 : e.tournamentRecords) ?? ((e == null ? void 0 : e.tournamentRecord) && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
}
var Td = "SIGN_IN_STATUS", xb = "SIGNED_OUT", Yu = "SIGNED_IN", ai = "TEAM", Xe = "INDIVIDUAL", Gi = "GROUP", _e = "PAIR", lt = "TEAM", Du = { TEAM_PARTICIPANT: ai, INDIVIDUAL: Xe, GROUP: Gi, TEAM: lt, PAIR: _e }, KL = { INDIVIDUAL: Xe, GROUP: Gi, PAIR: _e, TEAM: lt, SIGN_IN_STATUS: Td, SIGNED_OUT: xb, SIGNED_IN: Yu };
function fm({ participantsProfile: e, participants: t = [], deepCopy: r }) {
  let i = /* @__PURE__ */ new Map(), n = r !== !1 ? ge(t, e == null ? void 0 : e.convertExtensions, !0) : t, a = n.filter((c) => c.participantType === lt), o = n.filter((c) => c.participantType === Gi), s = n.filter((c) => c.participantType === _e);
  return n.forEach((c) => {
    if (c.participantType === Xe) {
      let { participantId: u } = c;
      c.groupParticipantIds = [], c.teamParticipantIds = [], c.pairParticipantIds = [], c.groups = [], c.teams = [], a.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((l) => {
          var p;
          l === u && !((p = c.teamParticipantIds) != null && p.includes(d.participantId)) && (c.teamParticipantIds.push(d.participantId), i.get(d.participantId) || i.set(d.participantId, { participantName: d.participantName, participantId: d.participantId }), c.teams.push({ participantRoleResponsibilities: d.participantRoleResponsibilities, participantOtherName: d.participantOtherName, participantName: d.participantName, participantId: d.participantId, teamId: d.teamId }));
        });
      }), s.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((l) => {
          l === u && !c.pairParticipantIds.includes(d.participantId) && c.pairParticipantIds.push(d.participantId);
        });
      }), o.forEach((d) => {
        ((d == null ? void 0 : d.individualParticipantIds) || []).forEach((l) => {
          l === u && !c.groupParticipantIds.includes(d.participantId) && (c.groupParticipantIds.push(d.participantId), c.groups.push({ participantRoleResponsibilities: d.participantRoleResponsibilities, participantOtherName: d.participantOtherName, participantName: d.participantName, participantId: d.participantId }));
        });
      });
    }
  }), { participantsWithGroupings: n, groupInfo: Object.fromEntries(i) };
}
var is = [{ ioc: "", iso2: "", iso: "", label: "NONE", phone: "" }, { ioc: "AND", iso2: "AD", iso: "AND", label: "Andorra", phone: "376" }, { ioc: "UAE", iso2: "AE", iso: "ARE", label: "United Arab Emirates", phone: "971" }, { ioc: "AFG", iso2: "AF", iso: "AFG", label: "Afghanistan", phone: "93" }, { ioc: "ANT", iso2: "AG", iso: "ATG", label: "Antigua and Barbuda", phone: "1-268" }, { ioc: "AIA", iso2: "AI", iso: "AIA", label: "Anguilla", phone: "1-264" }, { ioc: "ALB", iso2: "AL", iso: "ALB", label: "Albania", phone: "355" }, { ioc: "ARM", iso2: "AM", iso: "ARM", label: "Armenia", phone: "374" }, { ioc: "ANG", iso2: "AO", iso: "AGO", label: "Angola", phone: "244" }, { ioc: "", iso2: "AQ", iso: "ATA", label: "Antarctica", phone: "672" }, { ioc: "ARG", iso2: "AR", iso: "ARG", label: "Argentina", phone: "54" }, { ioc: "ASA", iso2: "AS", iso: "ASM", label: "American Samoa", phone: "1-684" }, { ioc: "AUT", iso2: "AT", iso: "AUT", label: "Austria", phone: "43" }, { ioc: "AUS", iso2: "AU", iso: "AUS", label: "Australia", phone: "61", suggested: !0 }, { ioc: "ARU", iso2: "AW", iso: "ABW", label: "Aruba", phone: "297" }, { ioc: "AZE", iso2: "AZ", iso: "AZE", label: "Azerbaijan", phone: "994" }, { ioc: "BIH", iso2: "BA", iso: "BIH", label: "Bosnia and Herzegovina", phone: "387" }, { ioc: "BAR", iso2: "BB", iso: "BRB", label: "Barbados", phone: "1-246" }, { ioc: "BAN", iso2: "BD", iso: "BGD", label: "Bangladesh", phone: "880" }, { ioc: "BEL", iso2: "BE", iso: "BEL", label: "Belgium", phone: "32" }, { ioc: "BUR", iso2: "BF", iso: "BFA", label: "Burkina Faso", phone: "226" }, { ioc: "BUL", iso2: "BG", iso: "BGR", label: "Bulgaria", phone: "359" }, { ioc: "BRN", iso2: "BH", iso: "BHR", label: "Bahrain", phone: "973" }, { ioc: "BDI", iso2: "BI", iso: "BDI", label: "Burundi", phone: "257" }, { ioc: "BEN", iso2: "BJ", iso: "BEN", label: "Benin", phone: "229" }, { ioc: "", iso2: "BL", iso: "BLM", label: "Saint Barthelemy", phone: "590" }, { ioc: "BER", iso2: "BM", iso: "BMU", label: "Bermuda", phone: "1-441" }, { ioc: "BRU", iso2: "BN", iso: "BRN", label: "Brunei Darussalam", phone: "673" }, { ioc: "BOL", iso2: "BO", iso: "BOL", label: "Bolivia", phone: "591" }, { ioc: "BRA", iso2: "BR", iso: "BRA", label: "Brazil", phone: "55" }, { ioc: "BAH", iso2: "BS", iso: "BHS", label: "Bahamas", phone: "1-242" }, { ioc: "BHU", iso2: "BT", iso: "BTN", label: "Bhutan", phone: "975" }, { ioc: "", iso2: "BV", iso: "BVT", label: "Bouvet Island", phone: "47" }, { ioc: "BOT", iso2: "BW", iso: "BWA", label: "Botswana", phone: "267" }, { ioc: "BLR", iso2: "BY", iso: "BLR", label: "Belarus", phone: "375" }, { ioc: "BIZ", iso2: "BZ", iso: "BLZ", label: "Belize", phone: "501" }, { ioc: "CAN", iso2: "CA", iso: "CAN", label: "Canada", phone: "1", suggested: !0 }, { ioc: "", iso2: "CC", iso: "CCK", label: "Cocos (Keeling) Islands", phone: "61" }, { ioc: "CGO", iso2: "CD", iso: "COG", label: "Congo, Republic of the", phone: "242" }, { ioc: "CAF", iso2: "CF", iso: "CAF", label: "Central African Republic", phone: "236" }, { ioc: "COD", iso2: "CG", iso: "CGD", label: "Congo, Democratic Republic of the", phone: "243" }, { ioc: "SUI", iso2: "CH", iso: "CHE", label: "Switzerland", phone: "41" }, { ioc: "CIV", iso2: "CI", iso: "CIV", label: "Cote d'Ivoire", phone: "225" }, { ioc: "COK", iso2: "CK", iso: "COK", label: "Cook Islands", phone: "682" }, { ioc: "CHI", iso2: "CL", iso: "CHL", label: "Chile", phone: "56" }, { ioc: "CMR", iso2: "CM", iso: "CMR", label: "Cameroon", phone: "237" }, { ioc: "CHN", iso2: "CN", iso: "CHN", label: "China", phone: "86" }, { ioc: "COL", iso2: "CO", iso: "COL", label: "Colombia", phone: "57" }, { ioc: "CRC", iso2: "CR", iso: "CRI", label: "Costa Rica", phone: "506" }, { ioc: "CUB", iso2: "CU", iso: "CUB", label: "Cuba", phone: "53" }, { ioc: "CPV", iso2: "CV", iso: "CPV", label: "Cape Verde", phone: "238" }, { ioc: "CUW", iso2: "CW", iso: "CUW", label: "Curacao", phone: "599" }, { ioc: "CXR", iso2: "CX", iso: "CXR", label: "Christmas Island", phone: "61" }, { ioc: "CYP", iso2: "CY", iso: "CYP", label: "Cyprus", phone: "357" }, { ioc: "CZE", iso2: "CZ", iso: "CZE", label: "Czech Republic", phone: "420" }, { ioc: "GER", iso2: "DE", iso: "DEU", label: "Germany", phone: "49", suggested: !0 }, { ioc: "DJI", iso2: "DJ", iso: "DJI", label: "Djibouti", phone: "253" }, { ioc: "DEN", iso2: "DK", iso: "DNK", label: "Denmark", phone: "45" }, { ioc: "DMA", iso2: "DM", iso: "DMA", label: "Dominica", phone: "1-767" }, { ioc: "DOM", iso2: "DO", iso: "DOM", label: "Dominican Republic", phone: "1-809" }, { ioc: "ALG", iso2: "DZ", iso: "DZA", label: "Algeria", phone: "213" }, { ioc: "ECU", iso2: "EC", iso: "ECU", label: "Ecuador", phone: "593" }, { ioc: "EST", iso2: "EE", iso: "ESE", label: "Estonia", phone: "372" }, { ioc: "EGY", iso2: "EG", iso: "EGY", label: "Egypt", phone: "20" }, { ioc: "", iso2: "EH", iso: "ESH", label: "Western Sahara", phone: "212" }, { ioc: "ERI", iso2: "ER", iso: "ERI", label: "Eritrea", phone: "291" }, { ioc: "ESP", iso2: "ES", iso: "ESP", label: "Spain", phone: "34" }, { ioc: "ETH", iso2: "ET", iso: "ETH", label: "Ethiopia", phone: "251" }, { ioc: "FIN", iso2: "FI", iso: "FIN", label: "Finland", phone: "358" }, { ioc: "FIJ", iso2: "FJ", iso: "FJI", label: "Fiji", phone: "679" }, { ioc: "FLK", iso2: "FK", iso: "FLK", label: "Falkland Islands (Malvinas)", phone: "500" }, { ioc: "FSM", iso2: "FM", iso: "FSM", label: "Micronesia, Federated States of", phone: "691" }, { ioc: "FAR", iso2: "FO", iso: "FRO", label: "Faroe Islands", phone: "298" }, { ioc: "FRA", iso2: "FR", iso: "FRA", label: "France", phone: "33", suggested: !0 }, { ioc: "GAB", iso2: "GA", iso: "GAB", label: "Gabon", phone: "241" }, { ioc: "GBR", iso2: "GB", iso: "GBR", label: "United Kingdom", phone: "44" }, { ioc: "GRN", iso2: "GD", iso: "GRD", label: "Grenada", phone: "1-473" }, { ioc: "GEO", iso2: "GE", iso: "GEO", label: "Georgia", phone: "995" }, { ioc: "FGU", iso2: "GF", iso: "GUF", label: "French Guiana", phone: "594" }, { ioc: "", iso2: "GG", iso: "GGY", label: "Guernsey", phone: "44" }, { ioc: "", iso2: "GH", iso: "GHA", label: "Ghana", phone: "233" }, { ioc: "GIB", iso2: "GI", iso: "GIB", label: "Gibraltar", phone: "350" }, { ioc: "GRL", iso2: "GL", iso: "GRL", label: "Greenland", phone: "299" }, { ioc: "GAM", iso2: "GM", iso: "GMB", label: "Gambia", phone: "220" }, { ioc: "GUI", iso2: "GN", iso: "GIN", label: "Guinea", phone: "224" }, { ioc: "GUD", iso2: "GP", iso: "GLP", label: "Guadeloupe", phone: "590" }, { ioc: "GEQ", iso2: "GQ", iso: "GNQ", label: "Equatorial Guinea", phone: "240" }, { ioc: "GRE", iso2: "GR", iso: "GRC", label: "Greece", phone: "30" }, { ioc: "", iso2: "GS", iso: "SGS", label: "South Georgia and the South Sandwich Islands", phone: "500" }, { ioc: "GUA", iso2: "GT", iso: "GTM", label: "Guatemala", phone: "502" }, { ioc: "GUM", iso2: "GU", iso: "GUM", label: "Guam", phone: "1-671" }, { ioc: "GBS", iso2: "GW", iso: "GNB", label: "Guinea-Bissau", phone: "245" }, { ioc: "GUY", iso2: "GY", iso: "GUY", label: "Guyana", phone: "592" }, { ioc: "HKG", iso2: "HK", iso: "HKG", label: "Hong Kong", phone: "852" }, { ioc: "", iso2: "HM", iso: "HMD", label: "Heard Island and McDonald Islands", phone: "672" }, { ioc: "HON", iso2: "HN", iso: "HND", label: "Honduras", phone: "504" }, { ioc: "CRO", iso2: "HR", iso: "HRV", label: "Croatia", phone: "385" }, { ioc: "HAI", iso2: "HT", iso: "HTI", label: "Haiti", phone: "509" }, { ioc: "HUN", iso2: "HU", iso: "HUN", label: "Hungary", phone: "36" }, { ioc: "INA", iso2: "ID", iso: "IDN", label: "Indonesia", phone: "62" }, { ioc: "IRL", iso2: "IE", iso: "IRL", label: "Ireland", phone: "353" }, { ioc: "ISR", iso2: "IL", iso: "ISR", label: "Israel", phone: "972" }, { ioc: "", iso2: "IM", iso: "IMN", label: "Isle of Man", phone: "44" }, { ioc: "IND", iso2: "IN", iso: "IND", label: "India", phone: "91" }, { ioc: "", iso2: "IO", iso: "IOT", label: "British Indian Ocean Territory", phone: "246" }, { ioc: "IRQ", iso2: "IQ", iso: "IRQ", label: "Iraq", phone: "964" }, { ioc: "IRI", iso2: "IR", iso: "IRN", label: "Iran, Islamic Republic of", phone: "98" }, { ioc: "ISL", iso2: "IS", iso: "ISL", label: "Iceland", phone: "354" }, { ioc: "ITA", iso2: "IT", iso: "ITA", label: "Italy", phone: "39" }, { ioc: "", iso2: "JE", iso: "JEY", label: "Jersey", phone: "44" }, { ioc: "JAM", iso2: "JM", iso: "JAM", label: "Jamaica", phone: "1-876" }, { ioc: "JOR", iso2: "JO", iso: "JOR", label: "Jordan", phone: "962" }, { ioc: "JPN", iso2: "JP", iso: "JPN", label: "Japan", phone: "81", suggested: !0 }, { ioc: "KEN", iso2: "KE", iso: "KEN", label: "Kenya", phone: "254" }, { ioc: "KGZ", iso2: "KG", iso: "KGZ", label: "Kyrgyzstan", phone: "996" }, { ioc: "CAM", iso2: "KH", iso: "KHM", label: "Cambodia", phone: "855" }, { ioc: "KIR", iso2: "KI", iso: "KIR", label: "Kiribati", phone: "686" }, { ioc: "COM", iso2: "KM", iso: "COM", label: "Comoros", phone: "269" }, { ioc: "SKN", iso2: "KN", iso: "KNA", label: "Saint Kitts and Nevis", phone: "1-869" }, { ioc: "KOR", iso2: "KP", iso: "KOR", label: "Korea, Democratic People's Republic of", phone: "850" }, { ioc: "PRK", iso2: "KR", iso: "PRK", label: "Korea, Republic of", phone: "82" }, { ioc: "KUW", iso2: "KW", iso: "KWT", label: "Kuwait", phone: "965" }, { ioc: "CAY", iso2: "KY", iso: "CYM", label: "Cayman Islands", phone: "1-345" }, { ioc: "KAZ", iso2: "KZ", iso: "KAZ", label: "Kazakhstan", phone: "7" }, { ioc: "LAO", iso2: "LA", iso: "LAO", label: "Lao People's Democratic Republic", phone: "856" }, { ioc: "LIB", iso2: "LB", iso: "LBN", label: "Lebanon", phone: "961" }, { ioc: "LCA", iso2: "LC", iso: "LCA", label: "Saint Lucia", phone: "1-758" }, { ioc: "LIE", iso2: "LI", iso: "LIE", label: "Liechtenstein", phone: "423" }, { ioc: "SRI", iso2: "LK", iso: "LKA", label: "Sri Lanka", phone: "94" }, { ioc: "LBR", iso2: "LR", iso: "LBR", label: "Liberia", phone: "231" }, { ioc: "LES", iso2: "LS", iso: "LSO", label: "Lesotho", phone: "266" }, { ioc: "LTU", iso2: "LT", iso: "LTU", label: "Lithuania", phone: "370" }, { ioc: "LUX", iso2: "LU", iso: "LUX", label: "Luxembourg", phone: "352" }, { ioc: "LAT", iso2: "LV", iso: "LVA", label: "Latvia", phone: "371" }, { ioc: "LBA", iso2: "LY", iso: "LBY", label: "Libya", phone: "218" }, { ioc: "MAR", iso2: "MA", iso: "MAR", label: "Morocco", phone: "212" }, { ioc: "MON", iso2: "MC", iso: "MCO", label: "Monaco", phone: "377" }, { ioc: "MDA", iso2: "MD", iso: "MDA", label: "Moldova, Republic of", phone: "373" }, { ioc: "MNE", iso2: "ME", iso: "MNE", label: "Montenegro", phone: "382" }, { ioc: "", iso2: "MF", iso: "MAF", label: "Saint Martin (French part)", phone: "590" }, { ioc: "MAD", iso2: "MG", iso: "MDG", label: "Madagascar", phone: "261" }, { ioc: "MSH", iso2: "MH", iso: "MHL", label: "Marshall Islands", phone: "692" }, { ioc: "MKD", iso2: "MK", iso: "MKD", label: "Macedonia, the Former Yugoslav Republic of", phone: "389" }, { ioc: "MLI", iso2: "ML", iso: "MLI", label: "Mali", phone: "223" }, { ioc: "MYA", iso2: "MM", iso: "MMR", label: "Myanmar", phone: "95" }, { ioc: "MGL", iso2: "MN", iso: "MNG", label: "Mongolia", phone: "976" }, { ioc: "MAC", iso2: "MO", iso: "MAC", label: "Macao", phone: "853" }, { ioc: "NMA", iso2: "MP", iso: "NMP", label: "Northern Mariana Islands", phone: "1-670" }, { ioc: "MRT", iso2: "MQ", iso: "MTQ", label: "Martinique", phone: "596" }, { ioc: "MTN", iso2: "MR", iso: "MRT", label: "Mauritania", phone: "222" }, { ioc: "MNT", iso2: "MS", iso: "MSR", label: "Montserrat", phone: "1-664" }, { ioc: "MLT", iso2: "MT", iso: "MLT", label: "Malta", phone: "356" }, { ioc: "MRI", iso2: "MU", iso: "MUS", label: "Mauritius", phone: "230" }, { ioc: "MDV", iso2: "MV", iso: "MDV", label: "Maldives", phone: "960" }, { ioc: "MAW", iso2: "MW", iso: "MWI", label: "Malawi", phone: "265" }, { ioc: "MEX", iso2: "MX", iso: "MEX", label: "Mexico", phone: "52" }, { ioc: "MAS", iso2: "MY", iso: "MYS", label: "Malaysia", phone: "60" }, { ioc: "MOZ", iso2: "MZ", iso: "MOZ", label: "Mozambique", phone: "258" }, { ioc: "NAM", iso2: "NA", iso: "NAM", label: "Namibia", phone: "264" }, { ioc: "NCL", iso2: "NC", iso: "NCL", label: "New Caledonia", phone: "687" }, { ioc: "NIG", iso2: "NE", iso: "NER", label: "Niger", phone: "227" }, { ioc: "NFI", iso2: "NF", iso: "NFK", label: "Norfolk Island", phone: "672" }, { ioc: "NGR", iso2: "NG", iso: "NGA", label: "Nigeria", phone: "234" }, { ioc: "NCA", iso2: "NI", iso: "NIC", label: "Nicaragua", phone: "505" }, { ioc: "NED", iso2: "NL", iso: "NLD", label: "Netherlands", phone: "31" }, { ioc: "NOR", iso2: "NO", iso: "NOR", label: "Norway", phone: "47" }, { ioc: "NEP", iso2: "NP", iso: "NPL", label: "Nepal", phone: "977" }, { ioc: "NRU", iso2: "NR", iso: "NRU", label: "Nauru", phone: "674" }, { ioc: "NIU", iso2: "NU", iso: "NIU", label: "Niue", phone: "683" }, { ioc: "NZL", iso2: "NZ", iso: "NZL", label: "New Zealand", phone: "64" }, { ioc: "OMA", iso2: "OM", iso: "OMN", label: "Oman", phone: "968" }, { ioc: "PAN", iso2: "PA", iso: "PAN", label: "Panama", phone: "507" }, { ioc: "PER", iso2: "PE", iso: "PER", label: "Peru", phone: "51" }, { ioc: "FPO", iso2: "PF", iso: "PYF", label: "French Polynesia", phone: "689" }, { ioc: "PNG", iso2: "PG", iso: "PNG", label: "Papua New Guinea", phone: "675" }, { ioc: "PHI", iso2: "PH", iso: "PHL", label: "Philippines", phone: "63" }, { ioc: "PAK", iso2: "PK", iso: "PAK", label: "Pakistan", phone: "92" }, { ioc: "POL", iso2: "PL", iso: "POL", label: "Poland", phone: "48" }, { ioc: "SPM", iso2: "PM", iso: "SPM", label: "Saint Pierre and Miquelon", phone: "508" }, { ioc: "", iso2: "PN", iso: "PCN", label: "Pitcairn", phone: "870" }, { ioc: "PUR", iso2: "PR", iso: "PRI", label: "Puerto Rico", phone: "1" }, { ioc: "PLE", iso2: "PS", iso: "PSE", label: "Palestine, State of", phone: "970" }, { ioc: "POR", iso2: "PT", iso: "PRT", label: "Portugal", phone: "351" }, { ioc: "PLW", iso2: "PW", iso: "PLW", label: "Palau", phone: "680" }, { ioc: "PAR", iso2: "PY", iso: "PRY", label: "Paraguay", phone: "595" }, { ioc: "QAT", iso2: "QA", iso: "QAT", label: "Qatar", phone: "974" }, { ioc: "REU", iso2: "RE", iso: "REU", label: "Reunion", phone: "262" }, { ioc: "ROU", iso2: "RO", iso: "ROU", label: "Romania", phone: "40" }, { ioc: "SRB", iso2: "RS", iso: "SRB", label: "Serbia", phone: "381" }, { ioc: "RUS", iso2: "RU", iso: "RUS", label: "Russia", phone: "7" }, { ioc: "RWA", iso2: "RW", iso: "RWA", label: "Rwanda", phone: "250" }, { ioc: "KSA", iso2: "SA", iso: "SAU", label: "Saudi Arabia", phone: "966" }, { ioc: "SOL", iso2: "SB", iso: "SLB", label: "Solomon Islands", phone: "677" }, { ioc: "SEY", iso2: "SC", iso: "SYC", label: "Seychelles", phone: "248" }, { ioc: "SUD", iso2: "SD", iso: "SDN", label: "Sudan", phone: "249" }, { ioc: "SWE", iso2: "SE", iso: "SWE", label: "Sweden", phone: "46" }, { ioc: "SIN", iso2: "SG", iso: "SGP", label: "Singapore", phone: "65" }, { ioc: "HEL", iso2: "SH", iso: "SHN", label: "Saint Helena", phone: "290" }, { ioc: "SLO", iso2: "SI", iso: "SVN", label: "Slovenia", phone: "386" }, { ioc: "", iso2: "SJ", iso: "SJM", label: "Svalbard and Jan Mayen", phone: "47" }, { ioc: "SVK", iso2: "SK", iso: "SVK", label: "Slovakia", phone: "421" }, { ioc: "SLE", iso2: "SL", iso: "SLE", label: "Sierra Leone", phone: "232" }, { ioc: "SMR", iso2: "SM", iso: "SMR", label: "San Marino", phone: "378" }, { ioc: "SEN", iso2: "SN", iso: "SEN", label: "Senegal", phone: "221" }, { ioc: "SOM", iso2: "SO", iso: "SOM", label: "Somalia", phone: "252" }, { ioc: "SUR", iso2: "SR", iso: "SUR", label: "Suriname", phone: "597" }, { ioc: "", iso2: "SS", iso: "SSD", label: "South Sudan", phone: "211" }, { ioc: "STP", iso2: "ST", iso: "STP", label: "Sao Tome and Principe", phone: "239" }, { ioc: "ESA", iso2: "SV", iso: "SLV", label: "El Salvador", phone: "503" }, { ioc: "", iso2: "SX", iso: "SMX", label: "Sint Maarten", phone: "1-721" }, { ioc: "SYR", iso2: "SY", iso: "SYR", label: "Syria", phone: "963" }, { ioc: "", iso2: "SZ", iso: "SWZ", label: "Swaziland", phone: "268" }, { ioc: "TKS", iso2: "TC", iso: "TCA", label: "Turks and Caicos Islands", phone: "1-649" }, { ioc: "CHA", iso2: "TD", iso: "TCD", label: "Chad", phone: "235" }, { ioc: "", iso2: "TF", iso: "ATF", label: "French Southern Territories", phone: "262" }, { ioc: "TOG", iso2: "TG", iso: "TGO", label: "Togo", phone: "228" }, { ioc: "THA", iso2: "TH", iso: "THA", label: "Thailand", phone: "66" }, { ioc: "TJK", iso2: "TJ", iso: "TJK", label: "Tajikistan", phone: "992" }, { ioc: "", iso2: "TK", iso: "TKL", label: "Tokelau", phone: "690" }, { ioc: "TLS", iso2: "TL", iso: "TLS", label: "Timor-Leste", phone: "670" }, { ioc: "TKM", iso2: "TM", iso: "TKM", label: "Turkmenistan", phone: "993" }, { ioc: "TUN", iso2: "TN", iso: "TUN", label: "Tunisia", phone: "216" }, { ioc: "TGA", iso2: "TO", iso: "TON", label: "Tonga", phone: "676" }, { ioc: "TUR", iso2: "TR", iso: "TUR", label: "Turkey", phone: "90" }, { ioc: "TTO", iso2: "TT", iso: "TTO", label: "Trinidad and Tobago", phone: "1-868" }, { ioc: "TUV", iso2: "TV", iso: "TUV", label: "Tuvalu", phone: "688" }, { ioc: "TPE", iso2: "TW", iso: "TWN", label: "Taiwan", phone: "886" }, { ioc: "TAN", iso2: "TZ", iso: "TZA", label: "United Republic of Tanzania", phone: "255" }, { ioc: "UKR", iso2: "UA", iso: "UKR", label: "Ukraine", phone: "380" }, { ioc: "UGA", iso2: "UG", iso: "UGA", label: "Uganda", phone: "256" }, { ioc: "USA", iso2: "US", label: "United States", phone: "1", suggested: !0, iso: "USA" }, { ioc: "URU", iso2: "UY", iso: "URY", label: "Uruguay", phone: "598" }, { ioc: "UZB", iso2: "UZ", iso: "UZB", label: "Uzbekistan", phone: "998" }, { ioc: "", iso2: "VA", iso: "VAT", label: "Holy See (Vatican City State)", phone: "379" }, { ioc: "VIN", iso2: "VC", iso: "VCT", label: "Saint Vincent and the Grenadines", phone: "1-784" }, { ioc: "VEN", iso2: "VE", iso: "VEN", label: "Venezuela", phone: "58" }, { ioc: "IVB", iso2: "VG", iso: "VGB", label: "British Virgin Islands", phone: "1-284" }, { ioc: "ISV", iso2: "VI", iso: "VIR", label: "US Virgin Islands", phone: "1-340" }, { ioc: "VIE", iso2: "VN", iso: "VNM", label: "Vietnam", phone: "84" }, { ioc: "VAN", iso2: "VU", iso: "VUT", label: "Vanuatu", phone: "678" }, { ioc: "WAF", iso2: "WF", iso: "WLF", label: "Wallis and Futuna", phone: "681" }, { ioc: "SAM", iso2: "WS", iso: "WSM", label: "Samoa", phone: "685" }, { ioc: "KOS", iso2: "XK", iso: "KOS", label: "Kosovo", phone: "383" }, { ioc: "YEM", iso2: "YE", iso: "YEM", label: "Yemen", phone: "967" }, { ioc: "MAY", iso2: "YT", iso: "MYT", label: "Mayotte", phone: "262" }, { ioc: "RSA", iso2: "ZA", iso: "ZAF", label: "South Africa", phone: "27" }, { ioc: "ZAM", iso2: "ZM", iso: "ZMB", label: "Zambia", phone: "260" }, { ioc: "ZIM", iso2: "ZW", iso: "ZWE", label: "Zimbabwe", phone: "263" }];
function Bb({ participant: e, withISO2: t, withIOC: r }) {
  let { person: i, individualParticipants: n } = e, a = [i, n == null ? void 0 : n.map(({ person: s }) => s)].flat().filter(Boolean);
  function o(s) {
    let { nationalityCode: c } = s || {};
    if (c) {
      let u = is.find(({ iso: d }) => d === c);
      r && (u != null && u.ioc) && !s.iocNationalityCode && (s.iocNationalityCode = u.ioc), t && (u != null && u.iso2) && !s.iso2NationalityCode && (s.iso2NationalityCode = u.iso2), u != null && u.label && !s.countryName && (s.countryName = u.label);
    }
  }
  a.forEach(o);
}
function XL({ participantMap: e, template: t }) {
  var i;
  let r = Object.values(e);
  for (let n of r) {
    let a = n.participant;
    if ((i = a.individualParticipantIds) != null && i.length) {
      a.individualParticipants = [];
      for (let o of a.individualParticipantIds) {
        let s = e[o].participant;
        a.individualParticipants.push(t ? gs({ template: t, source: s }) : s);
      }
    }
  }
}
function co(e) {
  var n;
  let { tournamentRecord: t, participantId: r } = e, i = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  for (let a of Object.values(i)) {
    let o = (n = a.participants) == null ? void 0 : n.find((s) => s.participantId === r);
    if (o) return { participant: o, tournamentId: a.tournamentId };
  }
  return { error: Yt };
}
function Vb(e) {
  let { tournamentRecord: t, participantId: r } = e;
  if (r) {
    let n = co({ tournamentRecord: t, participantId: r });
    return n.participant ?? n;
  }
  return e.element || e.drawDefinition || e.event || e.tournamentRecord || { error: we };
}
function en(e) {
  let { returnPreviousValues: t, itemSubTypes: r, itemType: i } = e, n = Vb(e);
  if (n.error) return n;
  if (r && !Array.isArray(r)) return { error: ie, context: { itemSubTypes: r } };
  if (!Array.isArray(n.timeItems)) return { error: kI };
  let a = n.timeItems.filter((s) => (s == null ? void 0 : s.itemType) === i).filter((s) => !(r != null && r.length) || r.some((c) => {
    var u;
    return (u = s == null ? void 0 : s.itemSubTypes) == null ? void 0 : u.includes(c);
  })).sort((s, c) => {
    let u = new Date(s.createdAt || void 0).getTime(), d = new Date(c.createdAt || void 0).getTime();
    return u - d;
  }), o = ge(a.pop(), !1, !0);
  if (o) {
    let s = { timeItem: o, ...j };
    return t && Object.assign(s, { previousItems: a }), s;
  } else return { info: Tr };
}
function xv({ returnPreviousValues: e, drawDefinition: t, itemSubTypes: r, itemType: i }) {
  if (!t) return { error: Cn };
  if (!t.timeItems) return { info: Tr };
  let { timeItem: n, previousItems: a, info: o } = en({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Dd({ returnPreviousValues: e, itemSubTypes: t, itemType: r, event: i }) {
  if (!i) return { error: At };
  if (!i.timeItems) return { info: Tr };
  let { timeItem: n, previousItems: a, info: o } = en({ returnPreviousValues: e, element: i, itemSubTypes: t, itemType: r });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function mm({ returnPreviousValues: e, tournamentRecord: t, itemSubTypes: r, itemType: i }) {
  if (!t) return { error: de };
  if (!t.timeItems) return { info: Tr };
  let { timeItem: n, previousItems: a, info: o } = en({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Bv({ returnPreviousValues: e, tournamentRecord: t, participantId: r, itemSubTypes: i, itemType: n }) {
  if (!t) return { error: de };
  if (!r) return { error: cr };
  let a = co({ tournamentRecord: t, participantId: r });
  if (a.error) return a;
  let { participant: o } = a;
  if (!(o != null && o.timeItems)) return { info: Tr };
  let { timeItem: s, previousItems: c, info: u } = en({ element: a.participant, returnPreviousValues: e, itemSubTypes: i, itemType: n });
  return s && { timeItem: s, previousItems: c } || { info: u };
}
var ZL = { [Gi]: "groupParticipantIds", [_e]: "pairParticipantIds", [lt]: "teamParticipantIds" }, QL = { [Gi]: "groups", [lt]: "teams" };
function Gb({ withIndividualParticipants: e, convertExtensions: t, tournamentRecord: r, withSignInStatus: i, withScaleValues: n, withGroupings: a, internalUse: o, withISO2: s, withIOC: c }) {
  let u = [], d = {};
  for (let p of r.participants ?? []) {
    let f = p == null ? void 0 : p.participantId;
    f && ex({ participantMap: d, participantId: f });
  }
  for (let p of r.participants ?? []) {
    let f = ge(p, t, o), { participantId: m, individualParticipantIds: h, participantType: g } = f;
    if (!d[m]) {
      u.push(m);
      continue;
    }
    if (Object.assign(d[m].participant, f), h) {
      let I = $L({ individualParticipantIds: h, participantCopy: f, participantMap: d, participantType: g, participantId: m });
      I.missingParticipantIds.length && u.push(...I.missingParticipantIds);
    }
    if (i && (d[m].participant.signedIn = JL(f)), n) {
      let { ratings: I, rankings: U, seedings: v } = zc({ participant: f });
      d[m].participant.seedings = v, d[m].participant.rankings = U, d[m].participant.ratings = I;
    }
    (c || s) && Bb({ participant: d[m].participant, withISO2: s, withIOC: c });
  }
  if (e) {
    let p = $e(e) ? e : void 0;
    XL({ participantMap: d, template: p });
  }
  let l;
  return a && (l = fm({ participants: Object.values(d).map(({ participant: p }) => p), participantsProfile: { convertExtensions: t }, deepCopy: !1 }).groupInfo), { missingParticipantIds: u, participantMap: d, groupInfo: l };
}
function JL(e) {
  let { timeItem: t } = en({ itemType: Td, element: e });
  return (t == null ? void 0 : t.itemValue) === Yu;
}
function $L({ individualParticipantIds: e, participantCopy: t, participantMap: r, participantType: i, participantId: n }) {
  var o;
  let a = [];
  for (let s of e) {
    let c = (o = r[s]) == null ? void 0 : o.participant;
    if (!c) {
      a.push(s);
      continue;
    }
    if (c[ZL[i]].push(n), [lt, Gi].includes(i)) {
      let { participantRoleResponsibilities: u, participantOtherName: d, participantName: l, participantId: p, teamId: f } = t, m = QL[i];
      c[m].push({ participantRoleResponsibilities: u, participantOtherName: d, participantName: l, participantId: p, teamId: f });
    }
    if (i === _e) {
      let u = e.find((d) => d !== s);
      r[s].pairIdMap[n] = u, r[s].pairIdMap[u] = n;
    }
  }
  return { missingParticipantIds: a };
}
function ex({ participantMap: e, participantId: t }) {
  if (e[t]) return;
  let r = { walkoverWins: 0, defaultWins: 0, walkovers: 0, defaults: 0, losses: 0, wins: 0 };
  e[t] = { structureParticipation: {}, potentialMatchUps: {}, scheduleConflicts: {}, scheduleItems: [], participant: { groupParticipantIds: [], pairParticipantIds: [], teamParticipantIds: [], seedings: {}, rankings: {}, ratings: {}, groups: [], teams: [] }, statistics: {}, opponents: {}, pairIdMap: {}, matchUps: {}, events: {}, draws: {}, counters: { [mt]: { ...r }, [ft]: { ...r }, [lt]: { ...r }, ...r } };
}
function Wo({ participantsProfile: e, useParticipantMap: t, tournamentRecord: r, contextProfile: i, inContext: n }) {
  if (t) return Gb({ ...e, ...i, tournamentRecord: r });
  let a = ge(r.participants, !1, !0) || [];
  (e != null && e.withIOC || e != null && e.withISO2) && a.forEach((s) => Bb({ participant: s, ...e }));
  let o;
  if ((n || e != null && e.withGroupings) && (a != null && a.length) && ({ participantsWithGroupings: a, groupInfo: o } = fm({ participantsProfile: e, deepCopy: !1, participants: a })), (e == null ? void 0 : e.withScaleValues) && (a == null ? void 0 : a.length)) for (let s of a) {
    let { ratings: c, rankings: u } = zc({ participant: s });
    s.rankings = u, s.ratings = c;
  }
  return { participants: a, groupInfo: o };
}
function nt({ onlySpecifiedPolicyTypes: e = !1, policyTypes: t = [], tournamentRecord: r, drawDefinition: i, structure: n, event: a }) {
  if (!Array.isArray(t)) return { error: DI };
  let o = {};
  return r && s(r), a && s(a), i && s(i), n && s(n), { appliedPolicies: o, ...j };
  function s(c) {
    var d, l;
    let u = (l = (d = c == null ? void 0 : c.extensions) == null ? void 0 : d.find((p) => p.name === qu)) == null ? void 0 : l.value;
    if (u) for (let p of Object.keys(u)) (e ? t.includes(p) : !t.length || t.includes(p)) && (o[p] = ge(u[p], !1, !0));
  }
}
function Fa({ policyTypes: e = [], tournamentRecord: t, drawDefinition: r, structure: i, event: n }) {
  if (!Array.isArray(e)) return { error: DI };
  let { appliedPolicies: a } = nt({ tournamentRecord: t, drawDefinition: r, structure: i, event: n }), o = {};
  for (let s of e) {
    let c = a == null ? void 0 : a[s];
    c && (o[s] = c);
  }
  return Object.keys(o).length ? { policyDefinitions: o } : { info: rs.message };
}
var jb = "WALKOVER", lT = "RETIRED", Vv = "COMPETITIVE", zu = "ROUTINE", Ku = "DECISIVE", jl = "winRatio", tx = { [ha]: { policyName: "Competitive Bands Default", profileBands: { [Ku]: 20, [zu]: 50 } } }, Gv = tx;
function ka({ policyDefinitions: e, tournamentRecord: t, contextProfile: r, drawDefinition: i, event: n }) {
  let a = { policies: {} };
  if (!r) return a;
  let o = Fa({ tournamentRecord: t, drawDefinition: i, event: n }).policyDefinitions;
  if (r.withCompetitiveness) {
    let s = (e == null ? void 0 : e[ha]) ?? (o == null ? void 0 : o[ha]) ?? Gv[ha];
    a.policies[ha] = s;
  }
  return a;
}
function qo({ tournamentRecord: e, drawDefinition: t, policyType: r, structure: i, event: n }) {
  if (!e) return { error: de };
  let { appliedPolicies: a } = nt({ tournamentRecord: e, drawDefinition: t, structure: i, event: n });
  return a != null && a[r] ? { policy: a[r] } : { info: rs == null ? void 0 : rs.message };
}
function Pd({ tournamentRecord: e, categoryName: t, categoryType: r, event: i }) {
  var s, c, u, d, l, p;
  t = t ?? ((s = i == null ? void 0 : i.category) == null ? void 0 : s.categoryName) ?? ((c = i == null ? void 0 : i.category) == null ? void 0 : c.ageCategoryCode), r = r ?? ((u = i == null ? void 0 : i.category) == null ? void 0 : u.categoryType) ?? ((d = i == null ? void 0 : i.category) == null ? void 0 : d.subType);
  let { policy: n } = qo({ policyType: ao, tournamentRecord: e, event: i }), a = (l = e ? We({ element: e, name: Pa }).extension : void 0) == null ? void 0 : l.value, o = (p = i && We({ name: Pa, element: i }).extension) == null ? void 0 : p.value;
  return { scheduleTiming: { tournamentScheduling: a, eventScheduling: o, categoryName: t, categoryType: r, policy: n } };
}
function jv({ drawDefinition: e, attributes: t }) {
  let { extension: r } = We({ element: e, name: lp }), i = (r == null ? void 0 : r.value) || {};
  return t.forEach((n) => {
    Object.keys(n).forEach((a) => {
      i[a] ? Object.assign(i[a], n[a]) : i[a] = n[a];
    });
  }), r = { name: lp, value: i }, im({ drawDefinition: e, extension: r }), { entryProfile: i };
}
function wd({ drawDefinition: e }) {
  let { extension: t } = We({ element: e, name: lp });
  return { entryProfile: (t == null ? void 0 : t.value) || {} };
}
var fn = "ALTERNATE", Rd = "CONFIRMED", Ii = "DIRECT_ACCEPTANCE", bd = "FEED_IN", Nd = "JUNIOR_EXEMPT", wa = "LUCKY_LOSER", Md = "ORGANISER_ACCEPTANCE", Ed = "QUALIFIER", rx = "REGISTERED", Od = "SPECIAL_EXEMPT", tn = "UNGROUPED", Ho = "UNPAIRED", wc = "WILDCARD", Ra = "WITHDRAWN", _l = [Rd, Ii, Nd, Md, Od], _b = [bd, wa, Ed], Yo = [Rd, Ii, bd, Nd, Md, Od, wc], yn = [Rd, Ii, Nd, wa, Ed, Md, Od, wc], Wb = [fn, Rd, Ii, bd, Nd, wa, Md, Ed, rx, Od, tn, Ho, wc, Ra], _v = { ALTERNATE: fn, CONFIRMED: Rd, DIRECT_ACCEPTANCE: Ii, DIRECT_ENTRY_STATUSES: Yo, DRAW_SPECIFIC_STATUSES: _b, EQUIVALENT_ACCEPTANCE_STATUSES: _l, FEED_IN: bd, JUNIOR_EXEMPT: Nd, LUCKY_LOSER: wa, ORGANISER_ACCEPTANCE: Md, QUALIFIER: Ed, SPECIAL_EXEMPT: Od, STRUCTURE_SELECTED_STATUSES: yn, UNGROUPED: tn, UNPAIRED: Ho, VALID_ENTRY_STATUSES: Wb, WILDCARD: wc, WITHDRAWN: Ra };
function Wv({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = wd({ drawDefinition: t }), i = Object.keys(r).includes(e);
  if (!i && zf.includes(e)) {
    let n = [{ [e]: { drawSize: void 0, alternates: !0 } }];
    return jv({ drawDefinition: t, attributes: n }), !0;
  }
  return i;
}
function ix({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = wd({ drawDefinition: t });
  return ((i = r[e]) == null ? void 0 : i.alternates) || 0;
}
function nx({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = wd({ drawDefinition: t });
  return ((i = r[e]) == null ? void 0 : i.wildcardsCount) || 0;
}
function Mg({ stage: e, drawDefinition: t, entryStatus: r }) {
  return t.entries.reduce((i, n) => n.entryStage === e && n.entryStatus === r ? i + 1 : i, 0);
}
function Fs({ provisionalPositioning: e, placementGroup: t, drawDefinition: r, stageSequence: i, entryStatuses: n, structureId: a, roundTarget: o, stages: s, stage: c }) {
  var d;
  let u = ((d = r.entries) == null ? void 0 : d.reduce((l, p) => {
    var I, U;
    let f = (U = (I = We({ name: Kn, element: p })) == null ? void 0 : I.extension) == null ? void 0 : U.value, m = c && p.entryStage === c || (s == null ? void 0 : s.length) && p.entryStage && s.includes(p.entryStage), h = !n || p.entryStatus && n.includes(p.entryStatus), g = p.entryStageSequence ?? 1;
    return m && (!i || g === i) && h && (!o || !f || o === f) ? l.concat(p) : l;
  }, [])) ?? [];
  if (a && c === Wt) {
    let { playoffEntries: l, error: p } = ax({ provisionalPositioning: e, drawDefinition: r, structureId: a });
    return p && console.log("playoff entries error"), (l != null && l.length ? l : u).filter((f) => !t || f.placementGroup === t);
  }
  return u;
}
function ax({ provisionalPositioning: e, drawDefinition: t, structureId: r }) {
  let i = [], n = (t.links ?? []).find((a) => a.linkType === Aa && a.target.structureId === r);
  if (n) {
    let { finishingPositions: a, structureId: o } = n.source, { structure: s } = Ne({ drawDefinition: t, structureId: o });
    (s == null ? void 0 : s.structureType) === ri && (s.structures ?? []).forEach((c) => {
      let u = c.positionAssignments ?? [], { structureId: d } = c, l = d, p = Object.assign({}, ...u.map((h) => {
        var U;
        let { participantId: g } = h, I = (U = We({ element: h, name: Ka }).extension) == null ? void 0 : U.value;
        return I && g ? { [g]: I } : void 0;
      }).filter(Boolean)), f = Object.keys(p).reduce((h, g) => {
        let I = p[g], U = I.groupOrder || e && I.provisionalOrder;
        return h.includes(U) || h.push(U), h;
      }, []).length === Object.keys(p).length, m = Object.keys(p).filter((h) => {
        let g = p[h], I = g.groupOrder || e && g.provisionalOrder;
        return a == null ? void 0 : a.includes(I);
      });
      (!e || f) && m.forEach((h) => {
        let g = p[h], { groupOrder: I, provisionalOrder: U, GEMscore: v } = g, S = I || e && U, T = [...a ?? []].sort(ar).indexOf(S) + 1;
        i.push({ entryStage: Wt, entryStatus: bd, placementGroup: T, groupingValue: l, participantId: h, GEMscore: v });
      });
    });
  }
  return { playoffEntries: i };
}
function ox({ stage: e, drawDefinition: t }) {
  return Yo.reduce((r, i) => (Mg({ drawDefinition: t, entryStatus: i, stage: e }) || 0) + r, 0);
}
function Qi({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: r, structureId: i, structure: n }) {
  var m;
  let a, o = [];
  n || ({ structure: n, error: a } = Ne({ drawDefinition: r, structureId: i }));
  let s = gt({ structure: n }).positionAssignments;
  if (a || !n) return { seedAssignments: [], error: kt };
  i || (i = n.structureId);
  let { stage: c, stageSequence: u } = n, d = c === Wt && r && Fs({ provisionalPositioning: e, drawDefinition: r, stageSequence: u, structureId: i, stage: c }), l = d ? d.filter((h) => h.placementGroup === 1).sort((h, g) => h.GEMscore < g.GEMscore && 1 || h.GEMscore > g.GEMscore && -1 || 0).map((h, g) => {
    let I = g + 1;
    return { participantId: h.participantId, seedValue: I, seedProxy: !0, seedNumber: I };
  }) : [], p = l == null ? void 0 : l.slice(0, t ? l.length : s.length / 2);
  p.length ? o = p : n.seedAssignments ? o = n.seedAssignments : a = KP;
  let f = n.seedLimit ?? ((m = n == null ? void 0 : n.positionAssignments) == null ? void 0 : m.length);
  return { seedAssignments: o, stageSequence: u, seedLimit: f, stage: c, error: a };
}
function Fn(e) {
  if (!e) return;
  let { tieFormatId: t, tieFormats: r } = e;
  if (e.tieFormat) return e.tieFormat;
  if (t && Array.isArray(r)) return r.find((i) => i.tieFormatId === t);
}
function Pu({ item: e, drawDefinition: t, structure: r, event: i }) {
  var n, a, o;
  if (e) {
    if (e.tieFormat) return e.tieFormat;
    if (e.tieFormatId)
      return t.tieFormat ? t.tieFormat : ((n = t.tieFormats) == null ? void 0 : n.find((c) => e.tieFormatId === c.tieFormatId)) || (i.tieFormat ? i.tieFormat : (a = i.tieFormats) == null ? void 0 : a.find((c) => e.tieFormatId === c.tieFormatId));
    if (r.tieFormat) return r.tieFormat;
    if (r.tieFormatId) {
      let s = (o = t.tieFormats) == null ? void 0 : o.find((c) => r.tieFormatId === c.tieFormatId);
      if (s) return s;
    }
  }
}
function Yr({ drawDefinition: e, structure: t, matchUp: r, event: i }) {
  return { tieFormat: Pu({ item: r, drawDefinition: e, structure: t, event: i }) || Pu({ item: t, drawDefinition: e, structure: t, event: i }) || Fn(e) || Fn(i) };
}
function sx({ matchUps: e }) {
  let t = e.reduce((r, i) => !i.collectionPosition || r.includes(i.collectionPosition) ? r : r.concat(i.collectionPosition), []).map((r) => ({ [r]: e.filter((i) => i.collectionPosition === r) }));
  return { collectionPositionMatchUps: Object.assign({}, ...t) };
}
function xr({ drawDefinition: e, structure: t }) {
  let r = {}, i = [];
  return ((e == null ? void 0 : e.structures) ?? [t]).filter((n) => n && typeof n == "object").forEach((n) => {
    if (!n) return;
    let { structureId: a, matchUps: o, structures: s } = n, c = Array.isArray(s);
    if (c) c && s.forEach((u) => {
      let { structureName: d } = u, l = u.matchUps;
      r[u.structureId] = { matchUps: l, itemStructureIds: [], structureName: d }, l && (i.push(...l), l.forEach((p) => {
        p.tieMatchUps && i.push(...p.tieMatchUps);
      })), r[a] || (r[a] = { itemStructureIds: [], matchUps: [] }), r[a].itemStructureIds || (r[a].itemStructureIds = []), r[a].itemStructureIds.push(u.structureId);
    });
    else {
      let u = o;
      r[a] = { matchUps: u, itemStructureIds: [] }, u == null || u.forEach((d) => {
        i.push(d), d.tieMatchUps && i.push(...d.tieMatchUps);
      });
    }
  }), { mappedMatchUps: r, drawMatchUps: i };
}
function No({ mappedMatchUps: e, matchUpsMap: t, structureId: r, inContext: i }) {
  e = (t == null ? void 0 : t.mappedMatchUps) ?? e;
  let n = e[r], a = ((n == null ? void 0 : n.itemStructureIds) || []).map((o) => {
    let { matchUps: s, structureName: c } = e[o];
    return i ? s.map((u) => Object.assign(ge(u, !0, !0), { containerStructureId: r, structureId: o, structureName: c })) : s;
  }).flat();
  return ((n == null ? void 0 : n.matchUps) || []).concat(...a);
}
function qb({ groupedOrder: e, roundPositionsCount: t }) {
  if (!e || (e == null ? void 0 : e.length) <= t) return e;
  let r = gr(e, e.length / t).map((n) => n.reduce((a, o) => a + o)), i = r.slice().sort(ar);
  return r.map((n) => i.indexOf(n) + 1);
}
function hm(e) {
  if (!$e(e)) return !1;
  let { matchUpId: t, drawPositions: r } = e, i = typeof t == "string", n = !r || Array.isArray(r) && r.length <= 2 && r.every((a) => ke(a) || a === void 0 || a === null);
  return i && n;
}
function rn(e) {
  return Array.isArray(e) ? e.every(hm) : !1;
}
function $r({ matchUps: e = [], interpolate: t }) {
  var l;
  if (!rn(e)) return { roundMatchUps: [], error: ie };
  let r = e.reduce((p, f) => {
    let m = typeof f.roundNumber == "string" ? be(f.roundNumber) : f.roundNumber;
    return !f.roundNumber || p.includes(m) ? p : p.concat(m);
  }, []).sort(ar).map((p) => {
    let f = e.filter((g) => g.roundNumber === p), m = f.find(({ matchUpType: g }) => g === yt) ? f.filter(({ matchUpType: g }) => g === yt) : f, h = (g) => g.sort((I, U) => ar(I.roundPosition, U.roundPosition));
    return { [p]: h(m) };
  }), i = e.reduce((p, f) => {
    let m = typeof f.roundNumber == "string" ? be(f.roundNumber) : f.roundNumber;
    return p[m] || (p[m] = ye({ abbreviatedRoundName: f.abbreviatedRoundName, finishingRound: f.finishingRound, roundName: f.roundName })), p;
  }, {}), n = Object.assign({}, ...r);
  if (t) {
    let p = Math.max(...Object.keys(n).map((m) => be(m)).filter((m) => !isNaN(m))), f = (l = n[p]) == null ? void 0 : l.length;
    if (f > 1 && Rn(f)) {
      let m = p + 1, h = m + f / 2;
      fe(m, h).forEach((g, I) => {
        n[g] = fe(0, f / (2 + I * 2)).map(() => ({}));
      });
    }
  }
  let a = 0, o = Object.assign({}, ...Object.keys(n).map((p) => {
    var g, I, U;
    let f = (g = n[p]) == null ? void 0 : g.length, m = (U = (I = n[p]) == null ? void 0 : I.filter((v) => {
      var S;
      return !lr.includes(v.matchUpStatus) && !((S = v.score) != null && S.scoreStringSide1);
    })) == null ? void 0 : U.length, h = f && f === m;
    return a = Math.max(a, f), { [p]: { matchUpsCount: f, inactiveCount: m, inactiveRound: h } };
  })), s = 0, c = 0, u = Object.keys(n).map((p) => be(p)).filter((p) => !isNaN(p));
  u.forEach((p) => {
    var h, g, I, U, v;
    let f = n[p].sort((S, T) => S.roundPosition - T.roundPosition), m = f.map((S) => (S == null ? void 0 : S.drawPositions) || []).flat();
    if (o[p].roundNumber = p, o[p].roundFactor = o[p].matchUpsCount ? a / o[p].matchUpsCount : 1, o[p].finishingRound = (h = i[p]) == null ? void 0 : h.finishingRound, o[p].roundName = (g = i[p]) == null ? void 0 : g.roundName, o[p].abbreviatedRoundName = (I = i[p]) == null ? void 0 : I.abbreviatedRoundName, o[p].finishingPositionRange = (v = (U = n[p]) == null ? void 0 : U[0]) == null ? void 0 : v.finishingPositionRange, p === 1 || !o[p - 1]) {
      let S = m.sort(ar), T = gr(S, 2);
      o[p].drawPositions = S, o[p].pairedDrawPositions = T;
    } else {
      let S = o[p - 1], T = S.drawPositions, A = S.matchUpsCount / o[p].matchUpsCount, y = gr(T, A), D = f.map((P) => {
        let { roundPosition: w } = P, R = [...P.drawPositions || [], void 0, void 0].slice(0, 2);
        if (!w) return R;
        let b = (R == null ? void 0 : R.filter(Boolean)) || [];
        if (!(b != null && b.length)) return [void 0, void 0];
        if (p < 3 && (b == null ? void 0 : b.length) === 2) return R == null ? void 0 : R.slice().sort(ar);
        let E = qt(T, b).length !== (b == null ? void 0 : b.length);
        if (b != null && b.length && E) return (b == null ? void 0 : b.length) === 1 ? [b[0], void 0] : R == null ? void 0 : R.slice().sort(ar);
        let O = (w - 1) * 2;
        return y.slice(O, O + 2).map((M) => b == null ? void 0 : b.find((N) => M.includes(N)));
      });
      o[p].drawPositions = D == null ? void 0 : D.flat(), o[p].pairedDrawPositions = D;
    }
    o[p + 1] && o[p + 1].matchUpsCount === o[p].matchUpsCount && (o[p + 1].feedRound = !0, o[p + 1].feedRoundIndex = c, o[p].preFeedRound = !0, c += 1), o[p] && !o[p].feedRound && (o[p].roundIndex = s, s += 1);
  });
  let d = !!Object.values(o).find(({ matchUpsCount: p }) => !Rn(p));
  return { hasNoRoundPositions: e.some((p) => !p.roundPosition), roundsNotPowerOf2: d, maxMatchUpsCount: a, roundMatchUps: n, roundNumbers: u, roundProfile: o, ...j };
}
function Wl(e) {
  if (!Array.isArray(e)) return "";
  let t = e.filter(jt);
  return t.length ? Be([Math.min(...t), Math.max(...t)]).join("-") : "";
}
function cx({ drawDefinition: e, structureId: t, matchUpsMap: r }) {
  if (!e) return { error: Ue };
  if (!t) return { error: Vi };
  let { structure: i } = Ne({ drawDefinition: e, structureId: t });
  if ((i == null ? void 0 : i.stage) !== kr) return { error: Vo, info: "Structure is not CONSOLATION stage" };
  let { links: n } = e, a = (n == null ? void 0 : n.filter((l) => l.target.structureId === t)) || [], o = (a == null ? void 0 : a.reduce((l, p) => {
    let { structureId: f } = p.source;
    return l.includes(f) ? l : l.concat(f);
  }, [])) || [], s = Object.assign({}, ...o.map((l) => {
    let p = No({ structureId: l, matchUpsMap: r }), f = $r({ matchUps: p }).roundProfile;
    return { [l]: f };
  })), c = No({ matchUpsMap: r, structureId: t }), { roundProfile: u } = $r({ matchUps: c }), d = {};
  return a == null || a.forEach((l) => {
    var b, E, O;
    let { structureId: p, roundNumber: f } = l.source, { feedProfile: m, groupedOrder: h, positionInterleave: g, roundNumber: I } = l.target, U = s[p], v = (b = U[1]) == null ? void 0 : b.drawPositions, S = (E = U[f]) == null ? void 0 : E.matchUpsCount;
    if (!S) return;
    let T = S ? v.length / S : 0, A = v.length / T, y = v.slice(), D = qb({ roundPositionsCount: A, groupedOrder: h }), P = (D == null ? void 0 : D.length) || 1;
    if (P <= A) {
      let M = v.length / P, N = gr(y, M);
      m === Po && N.forEach((C) => C.reverse()), y = (D == null ? void 0 : D.length) && (D == null ? void 0 : D.map((C) => N[C - 1]).flat()) || y;
    }
    let w = gr(y, T);
    if (g) {
      let M = fe(0, g.interleave).map(() => {
      }), N = fe(0, g.offset).map(() => {
      });
      w = w.map((F) => [F, ...M]), w.unshift(N), w = w.flat(1);
      let C = w.length - g.offset;
      w = w.slice(0, C);
    }
    d[I] || (d[I] = {});
    let R = (O = u == null ? void 0 : u[I]) != null && O.feedRound ? 2 : 1;
    w.forEach((M, N) => {
      let C = 1 + N * R;
      d[I][C] || (d[I][C] = Wl(M));
    });
  }), { sourceDrawPositionRanges: d };
}
function Hb({ drawDefinition: e }) {
  if (typeof e != "object") return { error: ts };
  let t = {}, { structures: r = [], links: i = [] } = e || {}, n = r.reduce((o, s) => {
    let { stage: c } = s;
    return o[c] ? o[c].push(s) : o[c] = [s], o;
  }, {});
  for (let o of Object.keys(n)) {
    let s = n[o].find(({ stageSequence: u }) => u === 1);
    if (!s) continue;
    let { structureId: c } = s;
    a({ aggregator: {}, targetRound: 0, exitProfiles: t, exitProfile: "0", structureId: c, stage: o });
  }
  return { exitProfiles: t };
  function a({ exitProfiles: o, exitProfile: s, structureId: c, targetRound: u, aggregator: d, stage: l }) {
    o[c] || (o[c] = []), s === "0" && [kr, Wt].includes(l) || o[c].push(s);
    let p = i.filter((f) => f.source.structureId === c && f.source.roundNumber >= u);
    for (let f of p) {
      let m = f.source.roundNumber, h = f.target.roundNumber, g = f.target.structureId, I = r.find((v) => v.structureId === g).stage, U = [I, g, h, m].join("|");
      if (d[U]) return;
      d[U] = !0, a({ exitProfile: `${s}-${m}`, structureId: g, exitProfiles: o, targetRound: h, aggregator: d, stage: I });
    }
  }
}
function ux({ drawDefinition: e, roundProfile: t, structureId: r, matchUpsMap: i }) {
  var o;
  if (!e) return { error: Ue };
  if (!r) return { error: Vi };
  if (!t) {
    let s = No({ matchUpsMap: i, structureId: r });
    if ({ roundProfile: t } = $r({ matchUps: s }), !t) return { error: we };
  }
  let n = (Math.min(...((o = t == null ? void 0 : t[1]) == null ? void 0 : o.drawPositions) ?? []) || 1) - 1, a = Object.keys(t);
  return { drawPositionsRanges: Object.assign({}, ...(a || []).map((s) => {
    var I, U;
    let c = (I = t == null ? void 0 : t[s]) == null ? void 0 : I.matchUpsCount, u = ((U = t == null ? void 0 : t[1]) == null ? void 0 : U.drawPositions) ?? [], d = gr(u, u.length / c), l = d.map(Wl), p = d.map((v) => v.map((S) => S - n)).map(Wl), f = a.map((v) => {
      var T;
      if (v > s) return;
      let S = ((T = t == null ? void 0 : t[v]) == null ? void 0 : T.drawPositions) ?? [];
      return gr(S, S.length / c);
    }).filter(Boolean), m = fe(0, c).map((v) => f.map((S) => S[v]).flat().filter(Boolean).sort(ar)).map((v) => Be(v)), h = m.map((v) => kF(v).map(Wl).join(", ")), g = Object.assign({}, ...fe(0, c).map((v) => ({ [v + 1]: { firstRoundDrawPositionsRange: l[v], firstRoundOffsetDrawPositionsRange: p[v], possibleDrawPositions: m[v], drawPositionsRange: h[v] } })));
    return { [s]: g };
  })) };
}
function qv({ roundsNotPowerOf2: e, drawDefinition: t, structure: r, matchUps: i }) {
  var a;
  if (!r) return !1;
  i = i ?? r.matchUps ?? [], e = e ?? $r({ matchUps: i }).roundsNotPowerOf2;
  let n = !!((a = r.positionAssignments) != null && a.find(({ drawPosition: o }) => o)) || !!(i != null && i.find(({ drawPositions: o }) => o == null ? void 0 : o.length));
  return (!(t != null && t.drawType) || t.drawType !== Go) && !(r != null && r.structures) && e && n;
}
function si({ structure: e }) {
  if (!e) return !1;
  let t = e.matchUps || e.roundMatchUps && Object.values(e.roundMatchUps).flat(), r = !!(t != null && t.find((n) => n == null ? void 0 : n.roundPosition)), i = !!(t != null && t.find((n) => {
    var a;
    return (a = n == null ? void 0 : n.drawPositions) == null ? void 0 : a.length;
  }));
  return !(e != null && e.structures) && (e == null ? void 0 : e.stage) !== yr && (!t.length || !r && !i);
}
var Yb = { [Tc]: { policyName: "Round Naming Default", namingConventions: { round: "Round", pre: "Pre" }, qualifyingFinishMap: { 1: "Final" }, abbreviatedRoundNamingMap: { 1: "F", 2: "SF", 4: "QF" }, roundNamingMap: { 1: "Final", 2: "Semifinal", 4: "Quarterfinal" }, affixes: { roundNumber: "R", preFeedRound: "Q", preQualifying: "P" }, stageConstants: { [Ie]: "", [Wt]: "P", [Pe]: "Q", [kr]: "C" } } }, dx = Yb;
function lx({ roundNamingPolicy: e, drawDefinition: t, structure: r, matchUps: i }) {
  var b, E, O;
  let { roundProfile: n, roundMatchUps: a } = $r({ matchUps: i }), { structureAbbreviation: o, stage: s } = r, c = si({ structure: r }), u = qv({ structure: r }), d = r.structures, l = {}, p = Yb[Tc], f = r.stage === Pe, m = f ? Math.max(...((t == null ? void 0 : t.structures) ?? []).filter((M) => M.stage === Pe).map(({ stageSequence: M }) => M ?? 1), 0) : 0, h = (r.stageSequence ?? 1) < m ? r.stageSequence ?? 1 : "", g = h && (((b = e == null ? void 0 : e.affixes) == null ? void 0 : b.preQualifying) || p.affixes.preQualifying) || "", I = (e == null ? void 0 : e.roundNamingMap) || p.roundNamingMap || {}, U = (e == null ? void 0 : e.abbreviatedRoundNamingMap) || p.abbreviatedRoundNamingMap || {}, v = ((E = e == null ? void 0 : e.affixes) == null ? void 0 : E.preFeedRound) || p.affixes.preFeedRound, S = ((O = e == null ? void 0 : e.affixes) == null ? void 0 : O.roundNumber) || p.affixes.roundNumber, T = ((e == null ? void 0 : e.namingConventions) || p.namingConventions).round, A = s && s !== Ie ? s[0] : "", y = (e == null ? void 0 : e.stageConstants) || p.stageConstants, D = s && (y == null ? void 0 : y[s]) || A, P = `${g}${D}${h}`, w = n ? Object.keys(n) : [], R = f && (y != null && y[Pe]) ? `${y == null ? void 0 : y[Pe]}-` : "";
  if (d || c || u) Object.assign(l, ...w.map((M) => {
    let N = `${R}${T} ${M}`, C = `${S}${M}`;
    return { [M]: { roundName: N, abbreviatedRoundName: C } };
  }));
  else {
    let M = f && ((e == null ? void 0 : e.qualifyingFinishMap) || (p == null ? void 0 : p.qualifyingFinishMap) || {});
    Object.assign(l, ...w.map((N) => {
      if (!(n != null && n[N])) return;
      let { matchUpsCount: C, preFeedRound: F } = n[N], x = C * 2, V = (M == null ? void 0 : M[n == null ? void 0 : n[N].finishingRound]) || M && `${S}${x}` || I[C] || `${S}${x}`, k = F ? `-${v}` : "", L = `${V}${k}`, B = [P, o, L].filter(Boolean).join("-"), G = `${U[C] || `${S}${x}`}${k}`, q = [P, o, G].filter(Boolean).join("-");
      return { [N]: { abbreviatedRoundName: q, roundName: B } };
    }));
  }
  return { roundNamingProfile: l, roundProfile: n, roundMatchUps: a };
}
var px = (e, t) => (e || 0) + (t || 0);
function zb(e, t) {
  let r = Array.isArray(e) ? e[0] : e;
  return isNaN(r) && jb || r <= t[Ku] && Ku || r <= t[zu] && zu || Vv;
}
function Kb({ score: e }) {
  let t = (e == null ? void 0 : e.sets) || [], r = t.reduce((n, a) => (n[0] += a.side1Score || 0, n[1] += a.side2Score || 0, n), [0, 0]), i = t.reduce((n, a) => (n[0] += a.side1TiebreakScore || 0, n[1] += a.side2TiebreakScore || 0, n), [0, 0]);
  return i.reduce(px) && (r[i[0] > i[1] ? 0 : 1] += 1), { sets: t, games: r, score: e };
}
function fx(e) {
  let t = Math.min(...e.games), r = Math.max(...e.games);
  return Math.round(t / r * 100);
}
function Xb(e) {
  return e.map(fx).sort().map((t) => parseFloat(t.toFixed(2)));
}
function Cd({ tournamentRecord: e, profileBands: t, matchUp: r }) {
  if (!r) return { error: hi };
  let { score: i, winningSide: n } = r;
  if (!n) return { error: ie };
  let a = !t && e && qo({ policyType: ha, tournamentRecord: e }).policy, o = t || (a == null ? void 0 : a.profileBands) || Gv[ha].profileBands, s = Kb({ score: i }), c = Xb([s]), u = zb(c, o), d = Array.isArray(c) ? c[0] : c;
  return { ...j, competitiveness: u, pctSpread: d };
}
function Zb({ matchUp: e }) {
  var o, s, c;
  if (!e) return { error: hi };
  if (e && !e.sides) return { error: gi };
  if (e && !e.hasContext) return { error: Lf };
  let t = (o = e.sides ?? []) == null ? void 0 : o.map((u) => u == null ? void 0 : u.participantId).filter(Boolean), r = ((s = e.sides) == null ? void 0 : s.filter((u) => {
    var d;
    return ((d = u.participant) == null ? void 0 : d.participantType) === Xe;
  }).map((u) => u.participantId).filter(Boolean)) ?? [], i = (((c = e.sides ?? []) == null ? void 0 : c.map((u) => {
    var d;
    return (d = u.participant) == null ? void 0 : d.individualParticipants;
  }).filter(Boolean)) ?? []).map((u) => (u ?? []).map((d) => d == null ? void 0 : d.participantId).filter(Boolean)), n = [...r, ...i.flat()].filter(Boolean) ?? [], a = Be(n.concat(t)).filter(Boolean) ?? [];
  return { nestedIndividualParticipantIds: i, allRelevantParticipantIds: a, individualParticipantIds: n, sideParticipantIds: t, ...j };
}
var fp = "CHECK_IN", mp = "CHECK_OUT", mx = "SCHEDULE", ks = "SCHEDULE.ASSIGNMENT.VENUE", ua = "SCHEDULE.ALLOCATION.COURTS", Ja = "SCHEDULE.ASSIGNMENT.COURT", gm = "SCHEDULE.COURT.ORDER", Ls = "SCHEDULE.DATE", hx = "COMPLETED.DATE", Hv = "HOME_PARTICIPANT_ID", Yv = "SCHEDULE.ASSIGN.OFFICIAL", xs = "SCHEDULE.TIME.SCHEDULED", Dn = "SCHEDULE.TIME.START", Ua = "SCHEDULE.TIME.STOP", ea = "SCHEDULE.TIME.RESUME", ba = "SCHEDULE.TIME.END", Im = "SCHEDULE.TIME.MODIFIERS", Qb = "TO_BE_ANNOUNCED", Jb = "NEXT_AVAILABLE", $b = "FOLLOWED_BY", eN = "AFTER_REST", tN = "RAIN_DELAY", gx = "NOT_BEFORE", Eg = [Qb, Jb, $b, eN, tN], Ix = "ELIGIBILITY", vx = "REGISTRATION", Ux = "SUSPENSION", Sx = "MEDICAL", yx = "PENALTY", rN = "SCALE", iN = "RATING", nN = "RANKING", zv = "SEEDING", uo = "PUBLISH", ji = "PUBLIC", lo = "STATUS", Ax = "MODIFICATION", Tx = "RETRIEVAL", Dx = "other", Px = { MUTUALLY_EXCLUSIVE_TIME_MODIFIERS: Eg, AFTER_REST: eN, ALLOCATE_COURTS: ua, ASSIGN_COURT: Ja, ASSIGN_OFFICIAL: Yv, ASSIGN_VENUE: ks, CHECK_IN: fp, CHECK_OUT: mp, COMPLETED_DATE: hx, COURT_ORDER: gm, ELIGIBILITY: Ix, END_TIME: ba, FOLLOWED_BY: $b, MEDICAL: Sx, MODIFICATION: Ax, NEXT_AVAILABLE: Jb, NOT_BEFORE: gx, OTHER: Dx, PENALTY: yx, PUBLIC: ji, PUBLISH: uo, RANKING: nN, RATING: iN, RAIN_DELAY: tN, REGISTRATION: vx, RESUME_TIME: ea, RETRIEVAL: Tx, SCALE: rN, SCHEDULE: mx, SCHEDULED_DATE: Ls, SCHEDULED_TIME: xs, SEEDING: zv, START_TIME: Dn, STATUS: lo, STOP_TIME: Ua, SUSPENSION: Ux, TIME_MODIFIERS: Im, TO_BE_ANNOUNCED: Qb };
function Bs({ matchUp: e }) {
  if (!e) return { error: hi };
  if (!e.hasContext) return { error: Lf };
  if (!e.sides || e.sides.filter(Boolean).length !== 2) return { error: gi };
  let { nestedIndividualParticipantIds: t, allRelevantParticipantIds: r, sideParticipantIds: i } = Zb({ matchUp: e }), n = (e.timeItems ?? []).filter((s) => (s == null ? void 0 : s.itemType) && [fp, mp].includes(s.itemType)).sort((s, c) => (s.createdAt ? new Date(s.createdAt).getTime() : 0) - (c.createdAt ? new Date(c.createdAt).getTime() : 0)), a = n.map((s) => s.itemValue).filter((s) => n.filter((c) => (c == null ? void 0 : c.itemValue) === s).reverse()[0].itemType === fp);
  t == null || t.forEach((s, c) => {
    let u = i == null ? void 0 : i[c], d = (s == null ? void 0 : s.length) && s.every((l) => a.includes(l));
    u && d && !a.includes(u) && a.push(u);
  }), i == null || i.forEach((s, c) => {
    a.includes(s) && ((t == null ? void 0 : t[c]) ?? []).forEach((u) => {
      u && !a.includes(u) && a.push(u);
    });
  });
  let o = i == null ? void 0 : i.reduce((s, c) => a.includes(c) && s, !0);
  return { allRelevantParticipantIds: r, allParticipantsCheckedIn: o, checkedInParticipantIds: a, ...j };
}
var Kt = (e) => (t) => {
  let r = $e(t) && (t == null ? void 0 : t.matchUpType) || Et(t) && t;
  return r && bP[e].includes(r);
};
function wu(e) {
  var a;
  let { matchUpAverageTimes: t, matchUpFormat: r } = e || {}, i = (t == null ? void 0 : t.map(({ matchUpFormatCodes: o }) => o == null ? void 0 : o.filter((s) => s === r)).flat().filter(Boolean).sort((o, s) => ((o == null ? void 0 : o.length) || 0) - ((s == null ? void 0 : s.length) || 0))) || [], n = i.includes(r) ? r : i[0];
  return (a = t == null ? void 0 : t.find(({ matchUpFormatCodes: o, averageTimes: s }) => (o == null ? void 0 : o.find((c) => n === c)) && s)) == null ? void 0 : a.averageTimes;
}
function Ru(e) {
  var n;
  let { matchUpRecoveryTimes: t, averageMinutes: r, matchUpFormat: i } = e || {};
  return (n = t == null ? void 0 : t.find(({ matchUpFormatCodes: a, averageTimes: o, recoveryTimes: s }) => {
    if (o && r) {
      let { greaterThan: c = 0, lessThan: u = 360 } = o;
      if (r > c && r < u) return !0;
    }
    return (a == null ? void 0 : a.find((c) => c === i)) && s;
  })) == null ? void 0 : n.recoveryTimes;
}
function aN({ timesBlockArray: e, categoryName: t, categoryType: r }) {
  return e.filter((i) => Array.isArray(i)).map((i) => i.sort((n, a) => {
    var o, s;
    return (((o = a.categoryNames) == null ? void 0 : o.length) || 0) - (((s = n.categoryNames) == null ? void 0 : s.length) || 0);
  }).find(({ categoryTypes: n, categoryNames: a }) => !(a != null && a.length) && !(n != null && n.length) || (a == null ? void 0 : a.includes(t)) || (n == null ? void 0 : n.includes(r)))).find(Boolean);
}
function wx({ tournamentScheduling: e, eventScheduling: t, averageMinutes: r, defaultTiming: i, matchUpFormat: n, categoryName: a, categoryType: o, policy: s }) {
  var p;
  let c = (t == null ? void 0 : t.matchUpRecoveryTimes) && Ru({ ...t, averageMinutes: r, matchUpFormat: n }), u = (e == null ? void 0 : e.matchUpRecoveryTimes) && Ru({ ...e, averageMinutes: r, matchUpFormat: n }), d = (s == null ? void 0 : s.matchUpRecoveryTimes) && Ru({ ...s, averageMinutes: r, matchUpFormat: n }), l = [c, u, d, (p = s == null ? void 0 : s.defaultTimes) == null ? void 0 : p.recoveryTimes, i == null ? void 0 : i.recoveryTimes];
  return aN({ categoryName: a, categoryType: o, timesBlockArray: l });
}
function Rx({ matchUpFormat: e, categoryName: t, categoryType: r, defaultTiming: i, tournamentScheduling: n, eventScheduling: a, policy: o }) {
  var l;
  let s = (a == null ? void 0 : a.matchUpAverageTimes) && wu({ ...a, matchUpFormat: e }), c = (n == null ? void 0 : n.matchUpAverageTimes) && wu({ ...n, matchUpFormat: e }), u = (o == null ? void 0 : o.matchUpAverageTimes) && wu({ ...o, matchUpFormat: e }), d = [s, c, u, (l = o == null ? void 0 : o.defaultTimes) == null ? void 0 : l.averageTimes, i == null ? void 0 : i.averageTimes];
  return aN({ categoryName: t, categoryType: r, timesBlockArray: d });
}
var oN = "DOUBLES_SINGLES", sN = "SINGLES_DOUBLES", mn = "total", Og = "participantConflict", ja = "matchUpConflict", cN = "ISSUE_IDS", ho = "CONFLICT", go = "WARNING", Cg = "ERROR", Fg = "ISSUE", ql = "STATE", bx = { SINGLES_DOUBLES: sN, DOUBLES_SINGLES: oN, TOTAL: mn, CONFLICT_MATCHUP_ORDER: ja, CONFLICT_PARTICIPANTS: Og, SCHEDULE_ISSUE_IDS: cN, SCHEDULE_CONFLICT: ho, SCHEDULE_WARNING: go, SCHEDULE_ERROR: Cg, SCHEDULE_ISSUE: Fg, SCHEDULE_STATE: ql };
function Fd({ defaultAverageMinutes: e = 90, defaultRecoveryMinutes: t = 0, tournamentRecord: r, matchUpFormat: i, categoryName: n, categoryType: a, eventType: o, event: s }) {
  if (!r) return { error: de };
  o = o ?? (s == null ? void 0 : s.eventType) ?? ms;
  let c = { averageTimes: [{ minutes: { default: e } }], recoveryTimes: [{ minutes: { default: t } }] }, { scheduleTiming: u } = Pd({ tournamentRecord: r, categoryName: n, categoryType: a, event: s }), d = { ...u, matchUpFormat: i, categoryType: a, defaultTiming: c };
  return vm({ eventType: o, timingDetails: d });
}
function vm({ timingDetails: e, eventType: t }) {
  let r = Rx(e), i = Object.keys((r == null ? void 0 : r.minutes) || {}), n = (r == null ? void 0 : r.minutes) && ((i == null ? void 0 : i.includes(t)) && r.minutes[t] || r.minutes.default), a = wx({ ...e, averageMinutes: n }), o = Object.keys((a == null ? void 0 : a.minutes) || {}), s = (a == null ? void 0 : a.minutes) && ((o == null ? void 0 : o.includes(t)) && a.minutes[t] || a.minutes.default), c = Kt(ms)(t) ? sN : oN, u = (a == null ? void 0 : a.minutes) && ((o == null ? void 0 : o.includes(c)) && a.minutes[c] || s);
  return { averageMinutes: n, recoveryMinutes: s, typeChangeRecoveryMinutes: u };
}
function _h(e) {
  return e.createdAt ? new Date(e.createdAt).getTime() : 0;
}
function zo({ timeItems: e, itemType: t }) {
  let r = e.filter((n) => n && n.itemType === t).sort((n, a) => _h(n) - _h(a)).pop(), i = r && _h(r);
  return { itemValue: r == null ? void 0 : r.itemValue, timeStamp: i };
}
function uN({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: xs });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledTime: i } : t;
}
function Vs({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: Ls });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledDate: i } : t;
}
function Jo(e) {
  if (cR.test(e)) {
    let t = zI();
    return /* @__PURE__ */ new Date(`${t}T${e}`);
  } else return new Date(e);
}
function Nx({ matchUp: e }) {
  if (!e) return { error: hi };
  if (!e.timeItems) return { error: kI };
  let t = e.timeItems.filter((i) => [Dn, Ua, ea, ba].includes(i == null ? void 0 : i.itemType)).sort((i, n) => Jo(i.itemValue).getTime() - Jo(n.itemValue).getTime()), r = t.reduce((i, n) => {
    var c, u;
    let a, o = (c = n == null ? void 0 : n.itemType) == null ? void 0 : c.split("."), s = `SCHEDULE.TIME.${((u = n == null ? void 0 : n.itemType) == null ? void 0 : u.startsWith("SCHEDULE.TIME")) && o[2]}`;
    switch (s) {
      case Dn:
        a = 0;
        break;
      case ba:
        if (i.lastValue && [Dn, ea].includes(i.lastType)) {
          let d = Jo(n.itemValue).getTime() - Jo(i.lastValue).getTime();
          a = i.milliseconds + d;
        } else a = i.milliseconds;
        break;
      case Ua:
        if ([Dn, "SCHECULE.TIME.RESUME"].includes(i.lastType)) {
          let d = Jo(n.itemValue).getTime() - Jo(i.lastValue).getTime();
          a = i.milliseconds + d;
        } else a = i.milliseconds;
        break;
      default:
        a = i.milliseconds;
        break;
    }
    return { milliseconds: a, lastType: s, lastValue: n.itemValue };
  }, { milliseconds: 0, lastType: void 0, lastValue: void 0 });
  if ([Dn, ea].includes(r.lastType)) {
    let i = (/* @__PURE__ */ new Date()).getTime() - Jo(r.lastValue).getTime();
    r.milliseconds += i;
  }
  return { milliseconds: r.milliseconds, time: Mx(r.milliseconds), relevantTimeItems: t };
}
function Mx(e) {
  let t = (r, i = 2) => ("00" + r).slice(-i);
  return t(e / 36e5 | 0) + ":" + t(e % 36e5 / 6e4 | 0) + ":" + t(e % 6e4 / 1e3 | 0);
}
function Ex({ matchUp: e }) {
  var i;
  let t = (e == null ? void 0 : e.timeItems) || [], r = (n) => n.createdAt ? new Date(n.createdAt).getTime() : 0;
  return { startTime: (i = t.reduce((n, a) => {
    let o = a.itemType === Dn && a;
    return o && (!n || r(o) < r(n)) ? o : n;
  }, void 0)) == null ? void 0 : i.itemValue };
}
function kd(e) {
  let { disableNotice: t, venue: r, context: i } = e;
  if (typeof r != "object") return { error: ie };
  let n = $i(e);
  r.venueId || (r.venueId = st());
  let a;
  for (let o of Object.values(n)) {
    let s = Ox({ disableNotice: !0, tournamentRecord: o, context: i, venue: r });
    if (s != null && s.error) return s;
    a = s.venue;
  }
  return t || Le({ topic: Tv, payload: { venue: r } }), ye({ ...j, venue: a });
}
function Ox({ tournamentRecord: e, disableNotice: t, context: r, venue: i }) {
  return e ? i ? (e.venues || (e.venues = []), i.venueId || (i.venueId = st()), e.venues.reduce((n, a) => n || a.venueId === i.venueId, void 0) ? { error: Mw } : (r && it({ element: i, extension: { value: r, name: fb } }), e.venues.push(i), t || Le({ payload: { venue: i, tournamentId: e.tournamentId }, topic: Tv }), { ...j, venue: ge(i) })) : { error: we, info: "missing venue" } : { error: de };
}
function fa({ tournamentRecords: e, tournamentRecord: t, venueId: r }) {
  if (!t) return { error: de };
  if (!r) return { error: io };
  let i = (t.venues ?? []).reduce((n, a) => a.venueId === r ? a : n, void 0);
  if (!i && e) {
    let n = (yd({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let a of n) {
      let o = e[a], s = fa({ tournamentRecord: o, venueId: r });
      if (s.success && s.venue) return kd({ tournamentRecord: t, venue: s.venue }), { ...j, venue: i };
    }
  }
  return i ? { ...j, venue: i } : { error: Rs };
}
function Kv({ convertExtensions: e, ...t }) {
  let { tournamentRecords: r, tournamentRecord: i, venueId: n } = t, a = fa({ tournamentRecords: r, tournamentRecord: i, venueId: n });
  return ge(a, e, !0);
}
function Gs({ tournamentRecords: e, tournamentRecord: t, courtId: r }) {
  if (!t) return { error: de };
  if (!r) return { error: Ds };
  let i = "findCourt", n, a;
  if ((t.venues ?? []).forEach((o) => {
    (o.courts ?? []).forEach((s) => {
      s.courtId === r && (n = s, a = o);
    });
  }), n) return { ...j, court: n, venue: a };
  if (e) {
    let o = (yd({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let s of o) {
      let c = e[s], u = Gs({ tournamentRecord: c, courtId: r });
      if (u.success) return u.venue && kd({ tournamentRecord: t, venue: u.venue }), { ...j, court: n, venue: a };
    }
  }
  return W({ result: { error: _c }, stack: i });
}
function Xv(e) {
  return ge(Gs(e), !1, !0);
}
function Um({ tournamentRecord: e, internalUse: t, courtId: r }) {
  if (!e) return { error: de };
  if (!r) return { error: Ds };
  let i = Gs({ tournamentRecord: e, courtId: r });
  if (i.error) return i;
  let n = i.court && (({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: d, surfaceCategory: l, surfaceType: p, surfacedDate: f, pace: m, notes: h }) => ({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: d, surfaceCategory: l, surfaceType: p, surfacedDate: f, pace: m, notes: h }))(i.court);
  return { ...j, courtInfo: ge(n, !1, t) };
}
function Rc(e) {
  var c;
  let t = Ae(e, [{ [fr]: !0 }, { venueId: !0, [pn]: io }]);
  if (t.error) return t;
  let { tournamentRecord: r, venueId: i } = e, n = fa({ tournamentRecord: r, venueId: i });
  if (n.error) return n;
  let a = (((c = n.venue) == null ? void 0 : c.courts) ?? []).map((u) => (({ courtInfo: d }) => ({ ...d }))(Um({ courtId: u.courtId, internalUse: !0, tournamentRecord: r }))), o = n.venue && (({ venueId: u, venueName: d, venueAbbreviation: l }) => ({ venueAbbreviation: l, venueName: d, venueId: u }))(n.venue), s = o && { ...o, courtsInfo: a };
  return { ...j, venueData: ge(s, !1, !0) };
}
function Cx({ matchUp: e }) {
  var i;
  let t = (e == null ? void 0 : e.timeItems) || [], r = (n) => n.createdAt ? new Date(n.createdAt).getTime() : 0;
  return { endTime: (i = t.reduce((n, a) => {
    let o = a.itemType === ba && a;
    return o && (!n || r(o) > r(n)) ? o : n;
  }, void 0)) == null ? void 0 : i.itemValue };
}
function Ht({ event: e, eventId: t }) {
  var n, a;
  if (!e) return { error: At };
  let r = (n = We({ name: gn, element: e })) == null ? void 0 : n.extension, i = t ? ge(r == null ? void 0 : r.value, !1, !0) : r == null ? void 0 : r.value;
  return t && ((a = e.drawDefinitions) == null || a.forEach((o) => {
    var s;
    (s = i == null ? void 0 : i.flights) == null || s.forEach((c) => {
      c.drawId === o.drawId && Object.assign(c, { drawDefinition: o });
    });
  })), { flightProfile: i };
}
function ci(e) {
  let { tournamentRecord: t, eventId: r, drawId: i } = e, n = "findEvent", a = {}, o = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, s = Object.values(o).map(({ events: u, tournamentId: d }) => (u && u.forEach((l) => {
    a[l.eventId] = { tournamentId: d };
  }), u ?? [])).flat(), c;
  if (i) {
    let u, d = s.find((l) => {
      var f, m, h;
      let p = ((l == null ? void 0 : l.drawDefinitions) ?? []).find((g) => g.drawId === i);
      if (p) u = p, c = a[l.eventId].tournamentId;
      else {
        let g = (h = (m = l && ((f = Ht({ event: l })) == null ? void 0 : f.flightProfile)) == null ? void 0 : m.flights) == null ? void 0 : h.find((I) => I.drawId === i);
        if (g) return c = a[l.eventId].tournamentId, { entries: g.drawEntries, drawName: g.drawName, tournamentId: c, drawId: i };
      }
      return p;
    });
    if (d) return { event: d, drawDefinition: u, tournamentId: c };
  }
  if (r) {
    let u = s.find((d) => (d == null ? void 0 : d.eventId) === r);
    if (u) c = a[u.eventId].tournamentId;
    else return { event: void 0, drawDefinition: void 0, ...W({ result: { error: Ki }, stack: n }) };
    return { event: u, drawDefinition: void 0, tournamentId: c };
  }
  return { event: void 0, drawDefinition: void 0, ...W({ result: { error: Fi }, context: { drawId: i, eventId: r }, stack: n }) };
}
function Sm(e) {
  var T, A, y, D, P, w, R, b, E, O;
  let t = e.event, r = e.matchUpType, { scheduleVisibilityFilters: i, afterRecoveryTimes: n, tournamentRecord: a, usePublishState: o, scheduleTiming: s, matchUpFormat: c, publishStatus: u, matchUp: d } = e;
  if (!d) return { error: hi };
  if (n && !d.matchUpType && !e.matchUpType && (t || a) && d.drawId) {
    let M = e.drawDefinition || ((T = t == null ? void 0 : t.drawDefinitions) == null ? void 0 : T.find((C) => C.drawId === d.drawId));
    !M && a && ({ drawDefinition: M, event: t } = ci({ drawId: d.drawId, tournamentRecord: a }));
    let N = d.structureId && ((A = M == null ? void 0 : M.structures) == null ? void 0 : A.find(({ structureId: C }) => C === d.structureId));
    r = e.matchUpType || (N == null ? void 0 : N.matchUpType) || (M == null ? void 0 : M.matchUpType) || (t == null ? void 0 : t.eventType) !== or && (t == null ? void 0 : t.eventType);
  }
  let { milliseconds: l, time: p } = Nx({ matchUp: d }), { startTime: f } = Ex({ matchUp: d }), { endTime: m } = Cx({ matchUp: d }), h, { eventIds: g, drawIds: I } = i ?? {};
  if ((!g || g.includes(d.eventId)) && (!I || I.includes(d.drawId))) {
    let M = (se) => se.createdAt ? new Date(se.createdAt).getTime() : 0, N = /* @__PURE__ */ new Map(), C = ((y = d.timeItems) == null ? void 0 : y.toSorted((se, Te) => M(se) - M(Te))) ?? [];
    for (let se of C) N.set(se.itemType, se.itemValue);
    let F = N.get(Hv), x = N.get(ua), V = N.get(xs), k = N.get(Im), L = N.get(Ls), B = N.get(Yv), G = N.get(gm), q = N.get(ks), Y = N.get(Ja), H, X, z, Z, te, ne = d.matchUpType ?? r;
    if (s && V && n && ne) {
      let se = { matchUpFormat: d.matchUpFormat ?? c, ...s };
      ({ averageMinutes: X = 0, recoveryMinutes: z = 0, typeChangeRecoveryMinutes: Z = 0 } = vm({ timingDetails: se, eventType: ne })), (X || z) && (H = m ? fi(Rt(m), z) : fi(V, X + z)), Z && (te = m ? fi(Rt(m), Z) : fi(V, X + Z));
    }
    !L && V && (L = Ve(V));
    let ee = ip({ scheduledDate: L, scheduledTime: V }), K = {}, J = ((D = a && q && Rc({ tournamentRecord: a, venueId: q })) == null ? void 0 : D.venueData) || {};
    q && (K[q] = J);
    let { venueName: $, venueAbbreviation: ae, courtsInfo: oe } = J, ce = (P = Y && (oe == null ? void 0 : oe.find((se) => se.courtId === Y))) == null ? void 0 : P.courtName;
    for (let se of x || []) {
      if (!a) break;
      se.venueId && !K[se.venueid] && (K[se.venueId] = (w = Rc({ venueId: se.venueId, tournamentRecord: a })) == null ? void 0 : w.venueData);
      let Te = K[se.venueId];
      se.venueName = Te == null ? void 0 : Te.venueName;
      let xe = (R = Te == null ? void 0 : Te.courtsInfo) == null ? void 0 : R.find((me) => me.courtId === se.courtId);
      se.courtName = xe == null ? void 0 : xe.courtName;
    }
    h = ye({ typeChangeTimeAfterRecovery: te, timeAfterRecovery: H, scheduledDate: L, scheduledTime: V, isoDateString: ee, homeParticipantId: F, venueAbbreviation: ae, allocatedCourts: x, timeModifiers: k, venueName: $, venueId: q, courtOrder: G, courtName: ce, courtId: Y, official: B, typeChangeRecoveryMinutes: Z, recoveryMinutes: z, averageMinutes: X, milliseconds: l, startTime: f, endTime: m, time: p });
  } else h = ye({ milliseconds: l, startTime: f, endTime: m, time: p });
  let { scheduledDate: U } = Vs({ matchUp: d }), { scheduledTime: v } = uN({ matchUp: d });
  if (o && ((b = u == null ? void 0 : u.displaySettings) != null && b.draws)) {
    let M = u.displaySettings.draws, N = (E = (M == null ? void 0 : M[d.drawId]) ?? (M == null ? void 0 : M.default)) == null ? void 0 : E.scheduleDetails;
    if (N) {
      let C = (O = N.find((F) => {
        var x;
        return U && ((x = F.dates) == null ? void 0 : x.includes(U));
      }) ?? N.find((F) => {
        var x;
        return !((x = F.dates) != null && x.length);
      })) == null ? void 0 : O.attributes;
      if (C) {
        let F = Object.assign({}, ...Object.keys(h).map((x) => ({ [x]: !0 })), C);
        h = gs({ source: h, template: F });
      }
    }
  }
  let S = d.matchUpStatus && lr.includes(d.matchUpStatus) && (Ve(m) || Ve(U) || Ve(v)) || void 0;
  return { schedule: h, endDate: S };
}
function Fx({ drawPositions: e, roundProfile: t, roundNumber: r }) {
  var s;
  let i = [void 0, void 0];
  if (kP(e)) return { orderedDrawPositions: i, displayOrder: i };
  let n = t == null ? void 0 : t[r], a = ((s = n == null ? void 0 : n.pairedDrawPositions) == null ? void 0 : s.find((c) => Jr(c || [], e.filter(Boolean)))) ?? i, o = n == null ? void 0 : n.feedRound;
  if (FP(e)) {
    let c = [...e].sort(ar);
    return { orderedDrawPositions: c.length === 2 ? c : a, displayOrder: o ? c : a };
  }
  if (o) {
    let c = [e.find((u) => !isNaN(be(u))), void 0];
    return { orderedDrawPositions: c, displayOrder: c };
  }
  return { orderedDrawPositions: a, displayOrder: a };
}
function hp({ collectionPosition: e, collectionId: t, lineUp: r }) {
  let i = [], n = [];
  if (r) {
    let a = (s) => s === void 0 ? -1 : s, o = r.map((s) => {
      let { collectionAssignments: c, participantId: u } = s, d = c == null ? void 0 : c.find((l) => l.collectionPosition === e && l.collectionId === t);
      return d && { participantId: u, ...d };
    }).filter(Boolean).sort((s, c) => a(s.substitutionOrder) - a(c.substitutionOrder));
    for (let s of o) {
      let { participantId: c, previousParticipantId: u, substitutionOrder: d } = s;
      i.includes(c) || (u && n.push({ previousParticipantId: u, substitutionOrder: d, participantId: c }), i = i.filter((l) => l !== u), i.push(c));
    }
  }
  return { assignedParticipantIds: i, substitutions: n };
}
function vn({ tournamentParticipants: e, tournamentRecord: t, participantIds: r }) {
  let i = "getPairedParticipant";
  if (!e && !t) return { error: de };
  if (!Array.isArray(r) || r.length > 2) return { error: Pi };
  if (!r.length) return W({ result: { error: ro }, stack: i });
  e = e ?? (t == null ? void 0 : t.participants) ?? [];
  let n = e.filter((s) => s.participantType === _e && qt(r, s.individualParticipantIds).length === r.length && s.individualParticipantIds.length === r.length), a = n[0];
  if (!a) return W({ result: { error: Yt }, stack: i });
  let o = ge(n.slice(1), !1, !0);
  return { participant: ge(a), duplicatedPairParticipants: o, ...j };
}
function Mo({ drawDefinition: e, participantId: t }) {
  if (typeof e != "object") return { error: Ue };
  if (typeof t != "string") return { error: cr };
  let { extension: r } = We({ element: e, name: Da });
  return { lineUp: ((r == null ? void 0 : r.value) || {})[t] };
}
function kx({ tournamentParticipants: e, positionAssignments: t, collectionPosition: r, drawPositions: i = [], participantMap: n, drawDefinition: a, collectionId: o, sideLineUps: s, matchUpType: c }) {
  if (!o || !r) return {};
  let u = ({ attribute: l, lineUp: p, teamParticipant: f }) => {
    var g, I, U, v;
    let { assignedParticipantIds: m, substitutions: h } = hp({ collectionPosition: r, collectionId: o, lineUp: p });
    if (c === ft) {
      if ((m == null ? void 0 : m.length) <= 2) {
        let S = (I = (g = n == null ? void 0 : n[m[0]]) == null ? void 0 : g.pairIdMap) == null ? void 0 : I[m[1]], T = (v = S && ((U = n[S]) == null ? void 0 : U.participant) || vn({ participantIds: m, tournamentParticipants: e }).participant) == null ? void 0 : v.participantId;
        return { [l]: { participantId: T, teamParticipant: f, substitutions: h } };
      } else if ((m == null ? void 0 : m.length) > 2) return { [l]: { teamParticipant: f, substitutions: h } };
    } else {
      let S = m == null ? void 0 : m[0];
      return S && { [l]: { participantId: S, teamParticipant: f, substitutions: h } };
    }
  };
  if (!(i != null && i.length)) {
    let l = (s == null ? void 0 : s.map((p) => {
      var g;
      let { teamParticipant: f, sideNumber: m } = p, h = p.lineUp || ((g = Mo({ participantId: f.teamParticipantId, drawDefinition: a })) == null ? void 0 : g.lineUp);
      return u({ attribute: m, lineUp: h, teamParticipant: f });
    }).filter(Boolean)) || {};
    return { sideNumberCollectionAssignment: Object.assign({}, ...l) };
  }
  let d = (i == null ? void 0 : i.map((l) => {
    var g, I, U;
    let p = (g = t.find((v) => v.drawPosition === l)) == null ? void 0 : g.participantId, f = s == null ? void 0 : s.find((v) => (v == null ? void 0 : v.drawPosition) === l), m = (f == null ? void 0 : f.teamParticipant) || p && ((I = n == null ? void 0 : n[p]) == null ? void 0 : I.participant) || (e == null ? void 0 : e.find(({ participantId: v }) => v === p)), h = (f == null ? void 0 : f.lineUp) || ((U = Mo({ participantId: p, drawDefinition: a })) == null ? void 0 : U.lineUp);
    return u({ attribute: l, lineUp: h, teamParticipant: m });
  }).filter(Boolean)) || {};
  return { drawPositionCollectionAssignment: Object.assign({}, ...d) };
}
function ym(e) {
  var n, a, o;
  let t = Ae(e, [{ [pa]: !0 }]);
  if (t.error) return t;
  let r = e == null ? void 0 : e.matchUp, i = r == null ? void 0 : r.matchUpType;
  if (!i && ((n = r == null ? void 0 : r.sides) != null && n.length)) {
    let s = (o = (a = r.sides.find(({ participant: c }) => c)) == null ? void 0 : a.participant) == null ? void 0 : o.participantType;
    i = s === Xe && mt || s === _e && ft || s === lt && lt || void 0;
  }
  return { matchUpType: i };
}
function Lx({ drawPositionCollectionAssignment: e, sideNumberCollectionAssignment: t, positionAssignments: r, displaySideNumber: i, seedAssignments: n, drawPosition: a, isFeedRound: o, sideNumber: s }) {
  var f, m, h, g;
  let c = r.find((I) => I.drawPosition && I.drawPosition === a), u = a && e, d = s && t, l = u ? (f = u[a]) == null ? void 0 : f.participantId : c == null ? void 0 : c.participantId, p = c ? xx({ displaySideNumber: i, seedAssignments: n, participantId: l, assignment: c, sideNumber: s }) : { ...d == null ? void 0 : d[s] };
  if (o && (s === 1 ? Object.assign(p, { participantFed: !0 }) : Object.assign(p, { participantAdvanced: !0 })), a && u) {
    let I = (m = u[a]) == null ? void 0 : m.teamParticipant, U = (h = u[a]) == null ? void 0 : h.participant, v = (g = u[a]) == null ? void 0 : g.substitutions;
    U && (p.participant = U), v && (p.substitutions = v), I && (p.teamParticipant = I);
  }
  return p;
}
function xx({ displaySideNumber: e, seedAssignments: t, participantId: r, assignment: i, sideNumber: n }) {
  let a = { drawPosition: i.drawPosition, displaySideNumber: e, sideNumber: n };
  if (r) {
    let o = Bx({ seedAssignments: t, participantId: r });
    Object.assign(a, o, { participantId: r }), o != null && o.seedNumber && (o == null ? void 0 : o.seedValue) === "" && (a.seedValue = "~");
  } else i.bye && Object.assign(a, { bye: !0 });
  return i.qualifier && Object.assign(a, { qualifier: !0 }), a;
}
function Bx({ seedAssignments: e, participantId: t }) {
  return e == null ? void 0 : e.find((r) => !r.seedProxy && r.participantId === t);
}
function dN({ scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, tournamentParticipants: r, positionAssignments: i, drawPositionsRanges: n, hydrateParticipants: a, afterRecoveryTimes: o, initialRoundOfPlay: s, additionalContext: c, roundNamingProfile: u, tournamentRecord: d, tieDrawPositions: l, appliedPolicies: p, isCollectionBye: f, seedAssignments: m, usePublishState: h, participantMap: g, contextContent: I, scheduleTiming: U, contextProfile: v, drawDefinition: S, publishStatus: T, scoringActive: A, matchUpTieId: y, isRoundRobin: D, roundProfile: P, sideLineUps: w, structure: R, context: b, matchUp: E, event: O }) {
  var Nt, Tt, je, It, Zt, _t, er, Mt, He, Me, Ot, vr, Dt, mr, qr;
  c = c ?? {};
  let M = (Nt = Yr({ drawDefinition: S, structure: R, matchUp: E, event: O })) == null ? void 0 : Nt.tieFormat, { roundOffset: N, structureId: C, structureName: F, stage: x, stageSequence: V } = R, { drawId: k, drawName: L, drawType: B } = S ?? {}, G = M == null ? void 0 : M.collectionDefinitions, q = E.collectionId && (G == null ? void 0 : G.find((Ee) => Ee.collectionId === E.collectionId)), Y = E.collectionId ? q == null ? void 0 : q.matchUpFormat : E.matchUpFormat ?? (R == null ? void 0 : R.matchUpFormat) ?? (S == null ? void 0 : S.matchUpFormat) ?? (O == null ? void 0 : O.matchUpFormat), H = E.matchUpType || (q == null ? void 0 : q.matchUpType) || (R == null ? void 0 : R.matchUpType) || (S == null ? void 0 : S.matchUpType) || !Kt(or)(O == null ? void 0 : O.eventType) && (O == null ? void 0 : O.eventType), X = f ? at : E.matchUpStatus, { schedule: z, endDate: Z } = Sm({ scheduleVisibilityFilters: e, afterRecoveryTimes: o, tournamentRecord: d, usePublishState: h, scheduleTiming: U, drawDefinition: S, matchUpFormat: Y, publishStatus: T, matchUpType: H, matchUp: E, event: O }), te = l ?? E.drawPositions ?? [], { collectionPosition: ne, collectionId: ee, roundPosition: K } = E, J = E.roundNumber ?? c.roundNumber, $ = ee ? kx({ tournamentParticipants: r, positionAssignments: i, collectionPosition: ne, participantMap: g, drawDefinition: S, drawPositions: te, collectionId: ee, sideLineUps: w, matchUpType: H }) : void 0, ae = ((Tt = u == null ? void 0 : u[J]) == null ? void 0 : Tt.roundName) || c.roundName, oe = ((je = u == null ? void 0 : u[J]) == null ? void 0 : je.abbreviatedRoundName) || c.abbreviatedRoundName, ce = (It = P == null ? void 0 : P[J]) == null ? void 0 : It.feedRound, se = (Zt = P == null ? void 0 : P[J]) == null ? void 0 : Zt.preFeedRound, Te = (_t = P == null ? void 0 : P[J]) == null ? void 0 : _t.roundFactor, xe = n == null ? void 0 : n[J], me = K ? xe == null ? void 0 : xe[K] : void 0, rt = t == null ? void 0 : t[J], Ge = q != null && q.category ? { ...(b == null ? void 0 : b.category) || {}, ...q.category } : (b == null ? void 0 : b.category) ?? (O == null ? void 0 : O.category), Bt = ((er = E.processCodes) == null ? void 0 : er.length) && E.processCodes || ((Mt = q == null ? void 0 : q.processCodes) == null ? void 0 : Mt.length) && (q == null ? void 0 : q.processCodes) || ((He = R == null ? void 0 : R.processCodes) == null ? void 0 : He.length) && (R == null ? void 0 : R.processCodes) || ((Me = S == null ? void 0 : S.processCodes) == null ? void 0 : Me.length) && (S == null ? void 0 : S.processCodes) || ((Ot = O == null ? void 0 : O.processCodes) == null ? void 0 : Ot.length) && (O == null ? void 0 : O.processCodes) || (d == null ? void 0 : d.processCodes), Ut = (v == null ? void 0 : v.withCompetitiveness) && Cd({ ...I, matchUp: E }), Re = E.finishingPositionRange ?? c.finishingPositionRange, De = (Ee) => ye(Ee, void 0, !0), ve = { ...De(b), ...De({ matchUpFormat: E.matchUpType === or ? void 0 : Y, tieFormat: E.matchUpType !== or ? void 0 : M, gender: (q == null ? void 0 : q.gender) ?? (O == null ? void 0 : O.gender), roundOfPlay: x !== Pe && ke(s) && s + (J || 0), endDate: E.endDate ?? Z, discipline: O == null ? void 0 : O.discipline, category: Ge, finishingPositionRange: Re, abbreviatedRoundName: oe, drawPositionsRange: me, competitiveProfile: Ut, structureName: F, stageSequence: V, drawPositions: te, matchUpStatus: X, processCodes: Bt, isRoundRobin: D, matchUpTieId: y, preFeedRound: se, matchUpType: H, roundFactor: Te, roundOffset: N, structureId: C, roundNumber: J, feedRound: ce, roundName: ae, drawName: L, drawType: B, schedule: z, drawId: k, stage: x }), ...ge(De(E), !0, !0) };
  if (Y && ((vr = E.score) != null && vr.scoreStringSide1)) {
    let Ee = ti(Y), { bestOf: ir, finalSetFormat: Oe, setFormat: ot } = Ee ?? {};
    (Oe != null && Oe.tiebreakSet || ot != null && ot.tiebreakSet || ot != null && ot.timed) && (ve.score.sets = ve.score.sets.sort((Qt, Br) => Qt.setNumber - Br.setNumber).map((Qt, Br) => (Br + 1 === ir ? (Oe != null && Oe.tiebreakSet || Oe != null && Oe.timed) && (Qt.tiebreakSet = !0) : (ot != null && ot.tiebreakSet || ot != null && ot.timed) && (Qt.tiebreakSet = !0), Qt)));
  }
  if (Array.isArray(te)) {
    let { orderedDrawPositions: Ee, displayOrder: ir } = Fx({ drawPositions: te, roundProfile: P, roundNumber: J }), Oe = (Dt = P == null ? void 0 : P[J]) == null ? void 0 : Dt.feedRound, ot = ir[0] !== Ee[0], Qt = Ee.concat(void 0, void 0).slice(0, 2).map((Br, br) => {
      var ze;
      let Hr = br + 1, di = ot ? 3 - Hr : Hr, Wi = Lx({ ...$, positionAssignments: i, displaySideNumber: di, seedAssignments: m, drawPosition: Br, isFeedRound: Oe, sideNumber: Hr }), Q = (ze = E.sides) == null ? void 0 : ze.find((Vt) => Vt.sideNumber === Hr), pe = K ? (K - 1) * 2 + br + 1 : void 0, he = pe ? rt == null ? void 0 : rt[pe] : void 0;
      return De({ sourceDrawPositionRange: he, ...Q, ...Wi });
    });
    Object.assign(ve, ge({ sides: Qt }, !0, !0));
  }
  if (r && ve.sides) {
    let Ee = p == null ? void 0 : p[vd], ir = (Oe) => {
      var Qt;
      let ot = (Qt = g == null ? void 0 : g[Oe]) == null ? void 0 : Qt.participant;
      return ot && gs({ template: Ee == null ? void 0 : Ee.participant, source: ot });
    };
    if (ve.sides.filter(Boolean).forEach((Oe) => {
      var ot, Qt, Br, br;
      if (Oe.participantId) {
        let Hr = ge(ir(Oe.participantId) || (r ? za({ policyDefinitions: p, participantId: Oe.participantId, tournamentParticipants: r, internalUse: !0, contextProfile: v }) : void 0), void 0, !0);
        if (Hr) {
          let di, Wi;
          if (S != null && S.entries) {
            let Q = S.entries.find((he) => he.participantId === Oe.participantId), pe = (ot = O == null ? void 0 : O.entries) == null ? void 0 : ot.find((he) => he.participantId === Oe.participantId);
            di = (Q == null ? void 0 : Q.entryStatus) || (pe == null ? void 0 : pe.entryStatus), Hr.entryStatus = di, Q != null && Q.entryStage && (Wi = Q.entryStage, Hr.entryStage = Wi);
          }
          a !== !1 ? Object.assign(Oe, { participant: Hr }) : Object.assign(Oe, { participant: { entryStage: Wi, entryStatus: di } });
        }
      }
      if ((Br = (Qt = Oe == null ? void 0 : Oe.participant) == null ? void 0 : Qt.individualParticipantIds) != null && Br.length && !((br = Oe.participant.individualParticipants) != null && br.length)) {
        let Hr = Oe.participant.individualParticipantIds.map((di) => ir(di) || (r ? za({ policyDefinitions: p, tournamentParticipants: r, internalUse: !0, contextProfile: v, participantId: di }) : void 0));
        a !== !1 && Object.assign(Oe.participant, { individualParticipants: Hr });
      }
    }), !ve.matchUpType) {
      let { matchUpType: Oe } = ym({ matchUp: ve });
      Oe && Object.assign(ve, { matchUpType: Oe });
    }
    if (v != null && v.inferGender && (!ve.gender || ve.gender === ni) && ((mr = ve.sides) == null ? void 0 : mr.length) === 2 && ve.matchUpType !== or) {
      let Oe = ve.sides.map((ot) => {
        var Qt, Br, br, Hr;
        if (Kt(mt)(ve.matchUpType)) return (Br = (Qt = ot.participant) == null ? void 0 : Qt.person) == null ? void 0 : Br.sex;
        if (((Hr = (br = ot.participant) == null ? void 0 : br.individualParticipants) == null ? void 0 : Hr.length) === 2) {
          let di = Be(ot.participant.individualParticipants.map((Wi) => {
            var Q;
            return (Q = Wi.person) == null ? void 0 : Q.sex;
          })).filter(Boolean);
          if (di.length === 1) return di[0];
        }
      });
      if (Oe.filter(Boolean).length === 2 && Be(Oe).length === 1) {
        let ot = Oe[0];
        ve.inferredGender = ot;
      }
    }
  }
  if (ve.tieMatchUps) {
    let Ee = ve.matchUpStatus === at, ir = (qr = ve.sides) == null ? void 0 : qr.map(({ participant: Oe, drawPosition: ot, sideNumber: Qt, lineUp: Br }) => {
      let br = (Oe == null ? void 0 : Oe.participantType) === or && Oe;
      return { teamParticipant: br && ye({ participantRoleResponsibilities: br.participantRoleResponsibilities, participantOtherName: br.participanOthertName, participantName: br.participantName, participantId: br.participantId, teamId: br.teamId }), drawPosition: ot, sideNumber: Qt, lineUp: Br };
    });
    ve.tieMatchUps = ve.tieMatchUps.map((Oe) => {
      let ot = ve.matchUpId, Qt = { finishingPositionRange: ve.finishingPositionRange, abbreviatedRoundName: oe, roundNumber: J, roundName: ae };
      return dN({ tieDrawPositions: te, scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, sideLineUps: ir, drawPositionsRanges: n, initialRoundOfPlay: s, roundNamingProfile: u, additionalContext: Qt, appliedPolicies: p, isCollectionBye: Ee, usePublishState: h, publishStatus: T, matchUpTieId: ot, isRoundRobin: D, roundProfile: P, matchUp: Oe, event: O, tournamentParticipants: r, positionAssignments: i, tournamentRecord: d, seedAssignments: m, participantMap: g, contextContent: I, scheduleTiming: U, contextProfile: v, drawDefinition: S, scoringActive: A, structure: R, context: b });
    });
  }
  let Ye = ve.sides && ve.sides.filter((Ee) => Ee == null ? void 0 : Ee.participantId).length === 2, Ze = !ve.winningSide;
  if (Object.assign(ve, { readyToScore: A && Ye && Ze, hasContext: !0 }), Ye) {
    let { allParticipantsCheckedIn: Ee, checkedInParticipantIds: ir } = Bs({ matchUp: ve });
    Object.assign(ve, { allParticipantsCheckedIn: Ee, checkedInParticipantIds: ir });
  }
  return Array.isArray(v == null ? void 0 : v.exclude) && (v == null || v.exclude.forEach((Ee) => delete ve[Ee])), ve;
}
function Vx({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: ua });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { allocatedCourts: ge(i, !1, !0) } : t;
}
function Gx({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: Ja });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { courtId: i } : t;
}
function jx({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: ks });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { venueId: i } : t;
}
function ga(e) {
  if (!Array.isArray(e.matchUps)) return [];
  let { matchUps: t, excludeMatchUpStatuses: r, hasParticipantsCount: i, isCollectionMatchUp: n, matchUpStatuses: a, hasWinningSide: o, matchUpFormats: s, roundPositions: c, matchUpFormat: u, collectionIds: d, isMatchUpTie: l, roundNumbers: p, matchUpIds: f, roundNames: m, filterMatchUpTypes: h = !0, filterMatchUpIds: g = !0, stageSequences: I, scheduledDates: U, scheduledDate: v, participantIds: S, processContext: T, tournamentIds: A, matchUpTypes: y, structureIds: D, readyToScore: P, courtIds: w, eventIds: R, venueIds: b, drawIds: E, stages: O } = e, M = Array.isArray(S) ? S.filter(Boolean) : [], N = Array.isArray(a) ? a.filter(Boolean) : [], C = Array.isArray(r) ? r.filter(Boolean) : [], F = Array.isArray(O) ? O.filter(Boolean) : [], x = Array.isArray(I) ? I.filter(Boolean) : [], V = Array.isArray(d) ? d.filter(Boolean) : [], k = Array.isArray(m) ? m.filter(Boolean) : [], L = Array.isArray(p) ? p.filter(Boolean) : [], B = Array.isArray(c) ? c.filter(Boolean) : [], G = Array.isArray(f) && g ? f.filter(Boolean) : [], q = Array.isArray(y) && h ? y.filter(Boolean) : [], Y = Array.isArray(w) ? w.filter(Boolean) : [], H = Array.isArray(b) ? b.filter(Boolean) : [], X = Array.isArray(s) && s.filter(Boolean) || typeof u == "string" && [u] || [], z = Array.isArray(U) && U.filter(Boolean) || typeof v == "string" && v.length && [v] || [], Z = Array.isArray(A) ? A.filter(Boolean) : [], te = Array.isArray(R) ? R.filter(Boolean) : [], ne = Array.isArray(E) ? E.filter(Boolean) : [], ee = Array.isArray(D) ? D.filter(Boolean) : [];
  return t.filter((K) => {
    var J;
    if (P && !Kt(Ci)(K) && !K.readyToScore || K.winningSide && o && ![1, 2].includes(K.winningSide) || l !== void 0 && (l && !K.tieMatchUps || !l && K.tieMatchUps) || n !== void 0 && (n && !K.collectionId || !n && K.collectionId) || F.length && !F.includes(K.stage) || x.length && !x.includes(K.stageSequence) || V.length && (!K.collectionId || !V.includes(K.collectionId)) || k.length && (!K.roundName || !k.includes(K.roundName)) || L.length && (!K.roundNumber || !L.includes(K.roundNumber)) || B.length && (!K.roundPosition || !B.includes(K.roundPosition)) || N.length && (!K.matchUpStatus || !N.includes(K.matchUpStatus)) || C.length && K.matchUpStatus && C.includes(K.matchUpStatus) || G.length && !G.includes(K.matchUpId) || q.length && (!K.matchUpType || !Rf(q, K.matchUpType)) || X.length && (!K.matchUpFormat || !X.includes(K.matchUpFormat))) return !1;
    if (z != null && z.length) {
      let { scheduledTime: $ } = uN({ matchUp: K }), { scheduledDate: ae } = Vs({ matchUp: K }), oe = Ve($) || ae;
      if (!z.find((ce) => aa(ce, oe))) return !1;
    }
    if (Y.length) {
      let { courtId: $ } = Gx({ matchUp: K }), { allocatedCourts: ae } = Vx({ matchUp: K }), oe = ae == null ? void 0 : ae.map(({ courtId: ce }) => ce);
      if (!Y.filter(Boolean).includes($) || oe != null && oe.includes($)) return !1;
    }
    if (H.length) {
      let { venueId: $ } = jx({ matchUp: K });
      if (!H.filter(Boolean).includes($)) return !1;
    }
    if (T) {
      if (Z.length && !Z.includes(K.tournamentId) || te.length && !te.includes(K.eventId) || ne.length && !ne.includes(K.drawId) || ee.length && !ee.includes(K.structureId)) return !1;
      let $ = ((J = K.sides) == null ? void 0 : J.map(({ participantId: ae }) => ae).filter(Boolean)) ?? [];
      if (i && $.length < i || M.length && !M.some((ae) => $.includes(ae))) return !1;
    }
    return !0;
  });
}
function ut(e) {
  var Y, H, X, z, Z, te, ne;
  let { provisionalPositioning: t, tournamentRecord: r, contextFilters: i, matchUpFilters: n, contextProfile: a, drawDefinition: o, context: s = {}, structure: c, inContext: u, event: d } = e, { seedAssignments: l, contextContent: p, exitProfiles: f, matchUpsMap: m } = e, h = {}, g = {};
  if (!c) return { collectionPositionMatchUps: h, error: Bo, roundMatchUps: g, matchUps: [] };
  let I = Array.isArray(n == null ? void 0 : n.eventIds) ? n == null ? void 0 : n.eventIds.filter(Boolean) : [], U = Array.isArray(n == null ? void 0 : n.structureIds) ? n == null ? void 0 : n.structureIds.filter(Boolean) : [], v = Array.isArray(n == null ? void 0 : n.drawIds) ? n == null ? void 0 : n.drawIds.filter(Boolean) : [], S = !(s != null && s.eventId) || !(I != null && I.length) && !((Y = i == null ? void 0 : i.eventIds) != null && Y.filter(Boolean).length) || (I == null ? void 0 : I.includes(s.eventId)) || ((H = i == null ? void 0 : i.eventIds) == null ? void 0 : H.includes(s.eventId)), T = !(U != null && U.length) || U.includes(c.structureId), A = !o || !(v != null && v.length) || v.includes(o.drawId);
  if (!S || !T || !A) return { collectionPositionMatchUps: h, roundMatchUps: g, matchUps: [] };
  a && !p && (p = ka({ tournamentRecord: r, contextProfile: a, drawDefinition: o }));
  let { appliedPolicies: y } = nt({ drawDefinition: o }), D = { ...e.tournamentAppliedPolicies, ...y, ...e.policyDefinitions }, P = (X = D == null ? void 0 : D.scoring) == null ? void 0 : X.structures, w = c.stage && ((z = P == null ? void 0 : P.stage) == null ? void 0 : z[c.stage]), R = c.stageSequence && ((Z = w == null ? void 0 : w.stageSequence) == null ? void 0 : Z[c.stageSequence]), b = ((te = D == null ? void 0 : D.scoring) == null ? void 0 : te.requireAllPositionsAssigned) || (w == null ? void 0 : w.requireAllPositionsAssigned) || (R == null ? void 0 : R.requireAllPositionsAssigned);
  m || (m = xr({ drawDefinition: o, structure: c }));
  let { positionAssignments: E, allPositionsAssigned: O } = Ir({ structure: c }), M = !b || O, { seedAssignments: N } = Qi({ provisionalPositioning: t, drawDefinition: o, structure: c });
  l = l ?? N;
  let { structureId: C } = c;
  f = f || o && Hb({ drawDefinition: o }).exitProfiles;
  let F = f == null ? void 0 : f[C], x = (F == null ? void 0 : F.length) && (F[0].split("-").map((ee) => parseInt(ee)).reduce((ee, K) => ee + K) || 0), V = !!c.structures, k = No({ matchUpsMap: m, structureId: C, inContext: u }), L = D == null ? void 0 : D[Tc], B = lx({ roundNamingPolicy: L, drawDefinition: o, structure: c, matchUps: k }), { roundNamingProfile: G, roundProfile: q } = B;
  if (g = (B == null ? void 0 : B.roundMatchUps) ?? [], n && (k = ga({ matchUps: k, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), u) {
    let { sourceDrawPositionRanges: ee } = cx({ drawDefinition: o, matchUpsMap: m, structureId: C }), K = o ? ux({ drawDefinition: o, roundProfile: q, matchUpsMap: m, structureId: C }).drawPositionsRanges : void 0, J = e.tournamentParticipants, $ = e.participantMap;
    !(J != null && J.length) && !$ && r && ({ participants: J = [], participantMap: $ } = Wo({ participantsProfile: e.participantsProfile, useParticipantMap: e.useParticipantMap, policyDefinitions: e.policyDefinitions, tournamentRecord: r, contextProfile: a, inContext: u })), k = k.map((ae) => dN({ scheduleVisibilityFilters: e.scheduleVisibilityFilters, hydrateParticipants: e.hydrateParticipants, afterRecoveryTimes: e.afterRecoveryTimes, usePublishState: e.usePublishState, scheduleTiming: e.scheduleTiming, publishStatus: e.publishStatus, sourceDrawPositionRanges: ee, tournamentParticipants: J, positionAssignments: E, drawPositionsRanges: K, initialRoundOfPlay: x, roundNamingProfile: G, tournamentRecord: r, appliedPolicies: D, seedAssignments: l, contextContent: p, participantMap: $, contextProfile: a, drawDefinition: o, scoringActive: M, isRoundRobin: V, roundProfile: q, structure: c, context: s, matchUp: ae, event: d })), (k == null ? void 0 : k.filter((ae) => Array.isArray(ae.tieMatchUps))).forEach((ae) => {
      let oe = ae.tieMatchUps;
      k = k.concat(...oe);
    }), i && (k = ga({ processContext: !0, ...i, matchUps: k }));
  } else (k == null ? void 0 : k.filter((ee) => Array.isArray(ee.tieMatchUps))).forEach((ee) => {
    let K = ee.tieMatchUps;
    k = k.concat(...K);
  });
  return n && (k = ga({ matchUps: k, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), (n != null && n.matchUpTypes || n != null && n.matchUpIds) && (k = ga({ matchUpTypes: n.matchUpTypes, matchUpIds: n.matchUpIds, matchUps: k })), (n != null && n.matchUpTypes || n != null && n.matchUpIds || u) && (g = $r({ matchUps: k }).roundMatchUps ?? []), (ne = Yr({ drawDefinition: o, structure: c, event: d })) != null && ne.tieFormat && ({ collectionPositionMatchUps: h } = sx({ matchUps: k })), { collectionPositionMatchUps: h, roundMatchUps: g, isRoundRobin: V, roundProfile: q, matchUpsMap: m, matchUps: k };
}
function yo({ matchUp: e }) {
  return e ? lr.includes(e == null ? void 0 : e.matchUpStatus) || (e == null ? void 0 : e.winningSide) : !1;
}
function Am({ requireParticipants: e = !0, scheduleVisibilityFilters: t, tournamentAppliedPolicies: r, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: d, contextContent: l, participantMap: p, scheduleTiming: f, publishStatus: m, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: U, structureId: v, inContext: S, structure: T, context: A, event: y }) {
  !T && v && ({ structure: T } = Ne({ drawDefinition: g, structureId: v }));
  let D = ut({ tournamentAppliedPolicies: r, scheduleVisibilityFilters: t, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: d, contextContent: l, participantMap: p, scheduleTiming: f, publishStatus: m, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: U, structure: T, inContext: S, context: A, event: y }), P = [], w = [], R = [], b = [], E = [];
  if (D.error) return D;
  let { matchUps: O } = D, { assignedPositions: M } = Ir({ structure: T }), N = M == null ? void 0 : M.filter((F) => F.participantId).map((F) => F.drawPosition), C;
  return O.filter((F) => {
    var V;
    let x = ((V = u == null ? void 0 : u.matchUpTypes) == null ? void 0 : V.length) === 1 && u.matchUpTypes[0] === yt;
    return !(F.matchUpType !== yt && x);
  }).forEach((F) => {
    var Y, H, X, z;
    if (F.matchUpStatus === Bi) {
      P.push(F);
      return;
    }
    F.matchUpType === yt && (C = !0);
    let x = F.collectionId, V = x && ((Y = F.sides) == null ? void 0 : Y.every((Z) => Z.participantId)), k = !x && ((H = F.drawPositions) == null ? void 0 : H.filter(Boolean).length) === 2, L = !x && ((X = F.drawPositions) == null ? void 0 : X.every((Z) => N == null ? void 0 : N.includes(Z))), B = M == null ? void 0 : M.filter((Z) => Z.bye).map((Z) => Z.drawPosition), G = !x && ((z = F.drawPositions) == null ? void 0 : z.find((Z) => B == null ? void 0 : B.includes(Z))), q = wb.includes(F.matchUpStatus) && (V || k && (!e || L));
    return G ? E.push(F) : yo({ matchUp: F }) ? w.push(F) : q ? R.push(F) : b.push(F);
  }), { includesTeamMatchUps: C, abandonedMatchUps: P, completedMatchUps: w, upcomingMatchUps: R, pendingMatchUps: b, byeMatchUps: E, structure: T };
}
function _x({ drawDefinition: e, roundNumber: t, structureId: r }) {
  if (!e) return { error: Ue };
  if (!r) return { error: Vi };
  let { links: i } = Qc({ drawDefinition: e, structureId: r }), n = i.source.reduce((o, s) => !s.source.roundNumber || s.source.roundNumber === t ? o.concat(s) : o, []), a = i.target.reduce((o, s) => !s.target.roundNumber || s.target.roundNumber === t ? o.concat(s) : o, []);
  return { links: { source: n, target: a } };
}
function Wh({ finishingPositions: e, linkCondition: t, linkType: r, source: i }) {
  var a;
  let n = i.find((o) => {
    var c, u;
    let s = !((c = o.source) != null && c.finishingPositions) || !e || Jr(e, (u = o.source) == null ? void 0 : u.finishingPositions);
    return t === o.linkCondition && s && o.linkType === r;
  });
  return [Ta, oa].includes(n == null ? void 0 : n.linkType) && !((a = n == null ? void 0 : n.source) != null && a.roundNumber) ? W({ result: { error: ie }, stack: "getTargetLink", context: n }) : n;
}
function Qc({ drawDefinition: e, structureId: t, roundNumber: r }) {
  return e ? t ? { links: (e.links || []).filter(Boolean).reduce((i, n) => {
    var a, o;
    return ((a = n.source) == null ? void 0 : a.structureId) === t && (!r || n.source.roundNumber === r) && (i.source = i.source.concat(n)), ((o = n.target) == null ? void 0 : o.structureId) === t && (!r || n.target.roundNumber === r) && (i.target = i.target.concat(n)), i;
  }, { source: [], target: [] }) } : { error: Vi } : { error: Ue };
}
function Wx({ structureMatchUps: e, matchUp: t }) {
  let { roundNumber: r, roundPosition: i } = t, n = e.filter((o) => o.roundNumber === r && !o.matchUpTieId), a = e.filter((o) => o.roundNumber === r + 1 && !o.matchUpTieId);
  if (a.length) {
    let o;
    return a.length === n.length ? o = a.find((s) => s.roundPosition === i) : a.length === n.length / 2 && (o = a.find((s) => s.roundPosition === Math.ceil(i / 2))), { matchUp: o };
  }
  return { message: "no progression found" };
}
function qh({ sourceRoundMatchUpCount: e, inContextDrawMatchUps: t, sourceRoundPosition: r, drawDefinition: i, targetLink: n }) {
  var P;
  if (!n) return { error: UI };
  let { target: { structureId: a, feedProfile: o, groupedOrder: s, roundNumber: c, positionInterleave: u } } = n, { structure: d } = Ne({ drawDefinition: i, structureId: a }), { positionAssignments: l } = gt({ structure: d }), p = (t == null ? void 0 : t.filter((w) => w.structureId === (d == null ? void 0 : d.structureId))).filter((w) => w.roundNumber === c && !w.matchUpTieId), f = p.length, m = fe(1, f + 1), h = f / e, g = Math.ceil(h * r), I = 1 - r % 2;
  if (u != null && u.interleave && h !== 0.5) {
    let w = u.offset + (r - 1) * u.interleave, R = r + w;
    g = Math.ceil(R / 2), I = 1 - R % 2;
  }
  let U = m, v = m[g - 1], S = qb({ roundPositionsCount: m.length, groupedOrder: s }), T = (S == null ? void 0 : S.length) || 1;
  if (T <= m.length) {
    let w = f / T, R = gr(m, w);
    o === Po && R.forEach((b) => b.reverse()), U = (S == null ? void 0 : S.length) && (S == null ? void 0 : S.map((b) => R[b - 1]).flat()) || U;
  }
  o === dn ? v = U[g - 1] : o === Po ? ((!(S != null && S.length) || T > m.length) && (g = p.length + 1 - g), v = U[g - 1]) : o === Xf && ki() && console.log(Vf, { feedProfile: o });
  let A = v && p.reduce((w, R) => R.roundPosition === v ? R : w, void 0), y;
  A != null && A.feedRound ? (I = 0, y = Math.min(...(A.drawPositions || []).filter(Boolean))) : y = ((P = A == null ? void 0 : A.drawPositions) == null ? void 0 : P.length) === 2 && (A == null ? void 0 : A.drawPositions[I]);
  let D = l == null ? void 0 : l.find(({ drawPosition: w }) => w === y);
  if (D) {
    let { extension: w } = We({ element: D, name: om });
    if (w != null && w.value) return { disabledDrawPosition: y };
  }
  return { matchUp: A, targetDrawPosition: y, matchUpDrawPositionIndex: I };
}
function ei({ inContextDrawMatchUps: e = [], useTargetMatchUpIds: t, inContextMatchUp: r, drawDefinition: i, matchUpId: n }) {
  let a = r;
  e.length && !a && (a = e.find((s) => s.matchUpId === n));
  let { structure: o } = Ne({ structureId: a == null ? void 0 : a.structureId, drawDefinition: i });
  return (o == null ? void 0 : o.finishingPosition) === Es ? qx({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: i, structure: o, matchUp: a }) : Hx({ matchUp: a });
}
function qx({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: r, structure: i, matchUp: n }) {
  var b, E, O;
  let { winnerMatchUpId: a, loserMatchUpId: o } = n, { links: s } = _x({ roundNumber: n.roundNumber, structureId: i.structureId, drawDefinition: r }), c = s == null ? void 0 : s.source, u = Wh({ source: c, linkType: Ta }), d = Wh({ linkCondition: _n, linkType: oa, source: c }), l = Wh({ source: c, linkType: oa }), p = d && l;
  l || (l = d);
  let f = (b = u == null ? void 0 : u.target) == null ? void 0 : b.feedProfile, m = (E = l == null ? void 0 : l.target) == null ? void 0 : E.feedProfile, h = (O = d == null ? void 0 : d.target) == null ? void 0 : O.feedProfile, g, I, U, v, S, T, A, y, D, P;
  if (t && (a || o) && (A = a && f !== sn && e.find(({ matchUpId: M }) => M === a), v = o && m !== sn && e.find(({ matchUpId: M }) => M === o), A || v)) return { matchUp: n, targetLinks: { loserTargetLink: l, winnerTargetLink: u }, targetMatchUps: { loserMatchUp: v, winnerMatchUp: A } };
  let { roundPosition: w } = n;
  P = P || e.filter((M) => M.structureId === i.structureId);
  let R = P.reduce((M, N) => N.roundNumber === n.roundNumber && !N.matchUpTieId ? M + 1 : M, 0);
  return l && !v && m !== sn && ({ matchUpDrawPositionIndex: T, targetDrawPosition: S, matchUp: v } = qh({ targetLink: l, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: w, drawDefinition: r })), p && h !== sn && ({ matchUpDrawPositionIndex: U, targetDrawPosition: I, matchUp: g } = qh({ targetLink: d, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: w, drawDefinition: r })), u && !A && f !== sn && ({ matchUpDrawPositionIndex: D, targetDrawPosition: y, matchUp: A } = qh({ targetLink: u, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: w, drawDefinition: r })), A || (P = P || e.filter((M) => M.structureId === i.structureId), { matchUp: A } = Wx({ structureMatchUps: P, matchUp: n })), ye({ matchUp: n, targetLinks: { loserTargetLink: l, winnerTargetLink: u, byeTargetLink: d }, targetMatchUps: { winnerMatchUpDrawPositionIndex: D, loserMatchUpDrawPositionIndex: T, byeMatchUpDrawPositionIndex: U, winnerTargetDrawPosition: y, loserTargetDrawPosition: S, byeTargetDrawPosition: I, winnerMatchUp: A, loserMatchUp: v, byeMatchUp: g }, targetMatchUpIds: !!(a || o) });
}
function Hx({ matchUp: e }) {
  return { targetLinks: { loserTargetLink: void 0, winnerTargetLink: void 0 }, targetMatchUps: { loserMatchUp: void 0, winnerMatchUp: void 0 }, matchUp: e };
}
function Yx({ drawDefinition: e, inContextDrawMatchUps: t }) {
  let r = {};
  return t.forEach((i) => {
    var c, u, d, l, p, f;
    let { matchUpId: n, structureId: a, drawPositions: o = [] } = i, { structure: s } = Ne({ drawDefinition: e, structureId: a });
    if ((s == null ? void 0 : s.finishingPosition) === wo) {
      let { roundNumber: m } = i, h = m && be(m) + 1, g = s.matchUps ?? [], { roundMatchUps: I } = $r({ matchUps: g });
      if (h && (I != null && I[h])) {
        let U = [...o].sort(ar).map((v, S) => {
          let T = I[h].find((A) => {
            var y;
            return (y = A.drawPositions) == null ? void 0 : y.includes(v);
          });
          return { matchUpId: T == null ? void 0 : T.matchUpId, roundNumber: h, schedule: T == null ? void 0 : T.schedule, sideNumber: S + 1, structureName: s.structureName };
        });
        Object.assign(i, { sidesTo: U });
      }
    } else {
      let m = ei({ useTargetMatchUpIds: !0, inContextDrawMatchUps: t, inContextMatchUp: i, drawDefinition: e, matchUpId: n }), { winnerMatchUp: h } = m.targetMatchUps, { loserMatchUp: g } = m.targetMatchUps;
      !i.winnerMatchUpId && h && (i.winnerMatchUpId = h.matchUpId), !i.loserMatchUpId && g && (i.loserMatchUpId = g.matchUpId);
      let I = Hh({ upcomingMatchUp: h }), U = Hh({ upcomingMatchUp: g });
      if (i.matchUpStatus !== at && (g == null ? void 0 : g.matchUpStatus) === at) {
        let { matchUp: S } = lN({ matchUp: g, drawDefinition: e, inContextDrawMatchUps: t }) || {};
        U = S && Hh({ upcomingMatchUp: S }) || U;
      }
      let v = (c = i.schedule) == null ? void 0 : c.timeAfterRecovery;
      if (v && ((u = I == null ? void 0 : I.schedule) != null && u.scheduledTime && tt(I.schedule.scheduledTime) < tt(v) && (r[I.matchUpId] = i.matchUpId, I.schedule.scheduleConflict = i.matchUpId), (d = U == null ? void 0 : U.schedule) != null && d.scheduledTime && tt(U.schedule.scheduledTime) < tt(v) && (r[U.matchUpId] = i.matchUpId, U.schedule.scheduleConflict = i.matchUpId)), Object.assign(i, { winnerTo: I, loserTo: U }), (l = i.drawPositions) == null ? void 0 : l.filter(Boolean).length) {
        let S = ((f = (p = m.targetLinks) == null ? void 0 : p.loserTargetLink) == null ? void 0 : f.linkCondition) === _n, T = zx(i);
        if (T.length) {
          let A = Rg(h == null ? void 0 : h.sides), y = Rg(g == null ? void 0 : g.sides), D = T.find(({ participantId: w }) => A.includes(w)) ? [] : T, P = T.find(({ participantId: w }) => y.includes(w)) ? [] : T;
          g && S && P.length < 2 && P.push({ bye: !0, tbd: !0 }), D != null && D.length && h && (!m.targetMatchUpIds && h && (h = t.find(({ matchUpId: w }) => w === h.matchUpId)), h.potentialParticipants || (h.potentialParticipants = []), h.potentialParticipants.push(D)), P != null && P.length && g && (m.targetMatchUpIds || (h = t.find(({ matchUpId: w }) => w === g.matchUpId)), g.potentialParticipants || (g.potentialParticipants = []), g.potentialParticipants.push(P));
        }
      }
    }
  }), Object.keys(r).length && t.forEach((i) => {
    Object.keys(r).includes(i.matchUpId) && (i.schedule.scheduleConflict = r[i.matchUpId]);
  }), { scheduleConflictMatchUpIds: r };
}
function zx(e) {
  var t;
  return ((t = e == null ? void 0 : e.sides) == null ? void 0 : t.map(({ participant: r, participantId: i, qualifier: n }) => r || i && { participantId: i } || n && { qualifier: n }).filter(Boolean)) || [];
}
function lN({ matchUp: e, drawDefinition: t, inContextDrawMatchUps: r }) {
  var o;
  let { matchUpId: i, matchUpStatus: n, structureId: a } = e || {};
  if (!e || !a || (e == null ? void 0 : e.matchUpStatus) === Xt) return { matchUp: e };
  if (n === at) {
    let s;
    return e.winnerMatchUpId ? s = r.find(({ matchUpId: c }) => c === e.winnerMatchUpId) : { winnerMatchUp: s } = ((o = ei({ inContextDrawMatchUps: r, drawDefinition: t, matchUpId: i })) == null ? void 0 : o.targetMatchUps) || {}, lN({ matchUp: s, drawDefinition: t, inContextDrawMatchUps: r });
  }
  return { matchUp: void 0 };
}
function Hh(e) {
  if (e != null && e.upcomingMatchUp) return (({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }) => ({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }))(e.upcomingMatchUp);
}
function ur(e) {
  let t = "getAllDrawMatchUps";
  Object.assign(e, { requireParticipants: !1 });
  let r = Jc(e);
  if (r.error) return W({ result: r, stack: t });
  let { abandonedMatchUps: i, completedMatchUps: n, upcomingMatchUps: a, pendingMatchUps: o, byeMatchUps: s, matchUpsMap: c } = r;
  return { matchUps: (i ?? []).concat(...n ?? [], ...a ?? [], ...o ?? [], ...s ?? []), matchUpsMap: c };
}
function Jc(e) {
  if (!(e != null && e.drawDefinition)) return { error: Ue };
  let { tournamentParticipants: t, contextContent: r, matchUpsMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, requireParticipants: o, participantsProfile: s, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: d, usePublishState: l, contextFilters: p, matchUpFilters: f, scheduleTiming: m, participantMap: h, publishStatus: g, contextProfile: I, drawDefinition: U, nextMatchUps: v, inContext: S, context: T, event: A } = e, y = [], D = [], P = [], w = [], R = [];
  I && !r && (r = ka({ policyDefinitions: u, tournamentRecord: d, contextProfile: I, event: A }));
  let b;
  !(t != null && t.length) && d && (t = d == null ? void 0 : d.participants, (S || s != null && s.withGroupings) && (t != null && t.length) && ({ participantsWithGroupings: t, groupInfo: b } = fm({ participants: t, participantsProfile: s })));
  let { structures: E } = In({ drawDefinition: U });
  if (!E) return { error: kt };
  i || (i = xr({ drawDefinition: U }));
  let O = U && Hb({ drawDefinition: U }).exitProfiles;
  E.forEach((C) => {
    let { byeMatchUps: F = [], pendingMatchUps: x = [], upcomingMatchUps: V = [], completedMatchUps: k = [], abandonedMatchUps: L = [] } = Am({ matchUpFilters: v ? void 0 : f, contextFilters: v ? void 0 : p, inContext: S || v || p, hydrateParticipants: e.hydrateParticipants, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, requireParticipants: o, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: d, usePublishState: l, contextContent: r, participantMap: h, scheduleTiming: m, publishStatus: g, contextProfile: I, drawDefinition: U, exitProfiles: O, matchUpsMap: i, structure: C, context: T, event: A });
    y = y.concat(...L), D = D.concat(...k), P = P.concat(...V), w = w.concat(...x), R = R.concat(...F);
  });
  let M = (C) => (!f && !v && !p || (f && (C = ga({ matchUps: C, ...f })), p && (C = ga({ matchUps: C, ...p, processContext: !0 }))), C), N = { abandonedMatchUps: M(y), completedMatchUps: M(D), upcomingMatchUps: M(P), pendingMatchUps: M(w), byeMatchUps: M(R), matchUpsMap: i, ...j, groupInfo: b };
  if (v) {
    let C = typeof v == "object" || { abandoned: !0, completed: !0, upcoming: !0, pending: !0, bye: !0 }, { abandoned: F, completed: x, upcoming: V, pending: k, bye: L } = C, B = [].concat(...F && y || [], ...x && D || [], ...V && P || [], ...k && w || [], ...L && R || []);
    Yx({ inContextDrawMatchUps: B, drawDefinition: U });
  }
  return N;
}
function ma(e) {
  let { participants: t = [], contextContent: r, participantMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, usePublishState: l, contextFilters: p, matchUpFilters: f, contextProfile: m, nextMatchUps: h, inContext: g, context: I, event: U } = e;
  if (!U) return { error: At };
  let { eventId: v, eventName: S, endDate: T, eventType: A, category: y, gender: D, matchUpFormat: P } = U ?? {}, w = { ...I, ...ye({ indoorOutDoor: U.indoorOutdoor ?? (d == null ? void 0 : d.indoorOutdoor), surfaceCategory: U.surfaceCategory ?? (d == null ? void 0 : d.surfaceCategory), endDate: U.endDate ?? (d == null ? void 0 : d.endDate), tournamentId: d == null ? void 0 : d.tournamentId, matchUpFormat: P, eventName: S, eventType: A, category: y, eventId: v, gender: D }) };
  T && (w.endDate = T), m && !r && (r = ka({ policyDefinitions: c, tournamentRecord: d, contextProfile: m, event: U }));
  let R;
  if (!(t != null && t.length) && !i && d) {
    let O = Wo({ participantsProfile: o, useParticipantMap: u, policyDefinitions: c, tournamentRecord: d, contextProfile: m, inContext: g });
    i = O.participantMap, t = O.participants ?? [], R = O.groupInfo;
  }
  let b = U.drawDefinitions ?? [], E = Pd({ tournamentRecord: d, event: U }).scheduleTiming;
  return { matchUps: b.flatMap((O) => {
    let { matchUps: M } = ur({ tournamentParticipants: t, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, context: w, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, usePublishState: l, contextFilters: p, contextProfile: m, drawDefinition: O, contextContent: r, matchUpFilters: f, participantMap: i, scheduleTiming: E, nextMatchUps: h, inContext: g, event: U });
    return M ?? [];
  }), groupInfo: R };
}
function Pr(e) {
  let t = Ae(e, [{ tournamentRecord: !0 }]);
  if (t.error) return t;
  if (!(e != null && e.tournamentRecord)) return { error: de };
  let { participantMap: r, participants: i } = e, { scheduleVisibilityFilters: n, participantsProfile: a, afterRecoveryTimes: o, useParticipantMap: s, policyDefinitions: c, tournamentRecord: u, inContext: d = !0, usePublishState: l, contextProfile: p, matchUpFilters: f, contextFilters: m, nextMatchUps: h, context: g } = e, I = e.tournamentId ?? u.tournamentId, U = (u == null ? void 0 : u.events) ?? [];
  i || ({ participants: i, participantMap: r } = Wo({ participantsProfile: a, useParticipantMap: s, policyDefinitions: c, tournamentRecord: u, contextProfile: p, inContext: d }));
  let { appliedPolicies: v } = nt({ tournamentRecord: u }), S = { ...g, tournamentId: I, indoorOutDoor: u.indoorOutdoor, surfaceCategory: u.surfaceCategory, endDate: u.endDate }, T = ka({ policyDefinitions: c, tournamentRecord: u, contextProfile: p });
  return { matchUps: U.flatMap((A) => {
    var y;
    return S.eventDrawsCount = ((y = A.drawDefinitions) == null ? void 0 : y.length) ?? 0, ma({ context: S, scheduleVisibilityFilters: n, tournamentAppliedPolicies: v, participantsProfile: a, afterRecoveryTimes: o, policyDefinitions: c, tournamentRecord: u, usePublishState: l, contextContent: T, contextFilters: m, contextProfile: p, matchUpFilters: f, participantMap: r, nextMatchUps: h, participants: i, inContext: d, event: A }).matchUps ?? [];
  }).concat(...u.matchUps ?? []) };
}
function On({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, tournamentRecords: i, policyDefinitions: n, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u }) {
  if (typeof i != "object" || !Object.keys(i).length) return { error: xt };
  let d = Object.keys(i).map((l) => {
    let p = i[l];
    return Pr({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, policyDefinitions: n, tournamentRecord: p, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u }).matchUps ?? [];
  }).flat();
  return { ...j, matchUps: d };
}
function js(e, t) {
  return Kx(e, t) || ((e == null ? void 0 : e.stageSequence) || 0) - ((t == null ? void 0 : t.stageSequence) || 0) || (e == null ? void 0 : e.roundNumber) && t.roundNumber && (e == null ? void 0 : e.roundNumber) - (t == null ? void 0 : t.roundNumber) || ((e == null ? void 0 : e.roundPosition) ?? 0) - ((t == null ? void 0 : t.roundPosition) ?? 0);
}
function Kx(e, t) {
  return (hs[e == null ? void 0 : e.stage] || 0) - (hs[t == null ? void 0 : t.stage] || 0);
}
function Qr(e) {
  let { participants: t, participantMap: r, contextContent: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, matchUpFilters: l, contextFilters: p, contextProfile: f, drawDefinition: m, nextMatchUps: h, inContext: g, context: I, event: U } = e, { eventId: v, eventName: S, endDate: T, eventType: A, category: y, gender: D, matchUpFormat: P } = U ?? {}, w = { ...I, surfaceCategory: (U == null ? void 0 : U.surfaceCategory) ?? (d == null ? void 0 : d.surfaceCategory), indoorOutDoor: (U == null ? void 0 : U.indoorOutdoor) ?? (d == null ? void 0 : d.indoorOutdoor), matchUpFormat: P, eventType: A, eventName: S, category: y, eventId: v, endDate: T, gender: D }, R;
  return !(t != null && t.length) && !r && d && ({ participants: t = [], participantMap: r, groupInfo: R } = Wo({ participantsProfile: o, useParticipantMap: u, policyDefinitions: c, tournamentRecord: d, contextProfile: f, inContext: g })), f && !i && (i = ka({ policyDefinitions: c, tournamentRecord: d, contextProfile: f, drawDefinition: m, event: U })), { ...ur({ context: w, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, drawDefinition: m, contextContent: i, contextFilters: p, contextProfile: f, matchUpFilters: l, participantMap: r, nextMatchUps: h, inContext: g, event: U }), groupInfo: R };
}
function ns({ element: e, accessor: t }) {
  if (typeof t != "string") return { values: [] };
  let r = ge(e), i = t.split("."), n = [], a;
  s({ targetElement: r, attributes: i });
  let o = { value: a };
  return n.length && (o.values = n), o;
  function s({ targetElement: c, attributes: u = [], significantCharacters: d }) {
    for (let [p, f] of u.entries()) if (c != null && c[f]) {
      let m = u.slice(p + 1);
      m.length ? Array.isArray(c[f]) ? c[f].forEach((h) => s({ targetElement: h, attributes: m })) : (c = c[f], l({ targetElement: c, index: p })) : (a || (a = c[f]), n.includes(c[f]) || n.push(c[f]));
    }
    function l({ targetElement: p, index: f }) {
      if (p && f === u.length - 1 && ["string", "number"].includes(typeof p)) {
        let m = d ? p.slice(0, d) : p;
        a ? n.includes(m) || n.push(m) : (a = m, n.push(m));
      }
    }
  }
}
var pN = (e) => (t) => {
  var r;
  return !e || typeof t != "object" ? void 0 : Array.isArray(e) && e.map((i) => {
    var n;
    return { [i]: (n = ns({ element: t, accessor: i })) == null ? void 0 : n.value };
  }) || typeof e == "object" && Object.keys(e).map((i) => {
    var n;
    return { [i]: (n = ns({ element: t, accessor: i })) == null ? void 0 : n.value };
  }) || ((r = typeof e == "string" && ns({ element: t, accessor: e })) == null ? void 0 : r.value);
}, Ni = pN;
function Ld({ finishingPositionOffset: e = 0, finishingPositionLimit: t, positionsFed: r, roundsCount: i, roundLimit: n, matchUps: a, lucky: o, fmlc: s }) {
  var g;
  if (!rn(a)) return [];
  let { roundProfile: c, roundNumbers: u = [] } = $r({ interpolate: !0, matchUps: a });
  i = i ?? Math.max(...u, 0);
  let d = n ? i - n : 0, l = d && ((g = c == null ? void 0 : c[i - d]) == null ? void 0 : g.matchUpsCount), p = c && Object.values(c).map(Ni("matchUpsCount")), f = (I, U) => {
    let v = Math.min(...I);
    l && U && v === 1 && (v = l);
    let S = Math.max(...I);
    return t && S > t && (S = t), [v, S];
  }, m = c && Object.assign({}, ...u.map((I) => {
    let U = (i ?? 0) + 1 - I - d, v = c[I].matchUpsCount, S = { finishingPositionRange: {}, finishingRound: U }, T = p == null ? void 0 : p.slice(I - 1).reduce((E, O) => E + (O || 0), 0), A = s && I !== 1, y = 1 + e + (A ? r ?? 0 : 0), D = 1, P = fe(y, o ? y + v * 2 : T + y + D), w = T + D - v, R = f(P.slice(w)), b = f(P.slice(0, w), !0);
    return S.finishingPositionRange = { loser: R, winner: b }, { [I]: S };
  })), h = ki({ finishingRound: !0 });
  return a.filter(Boolean).forEach((I) => {
    let U = I.roundNumber && m[I.roundNumber];
    h && !U && console.log({ roundFinishingData: m, matchUp: I }), I.finishingRound = U == null ? void 0 : U.finishingRound, I.finishingPositionRange = U == null ? void 0 : U.finishingPositionRange;
  }), a;
}
function Eo({ inContextDrawMatchUps: e, drawDefinition: t, matchUpsMap: r }) {
  var n;
  if (!t) return { error: Ue };
  let i = { loserMatchUpIds: {}, winnerMatchUpIds: {} };
  if (e || ({ matchUps: e, matchUpsMap: r } = ur({ inContext: !0, drawDefinition: t, matchUpsMap: r })), !(r != null && r.drawMatchUps.some((a) => a.finishingPositionRange)) && ((n = t == null ? void 0 : t.structures) == null ? void 0 : n.length) === 1 && !(t != null && t.structures[0].structures)) {
    let a = (r == null ? void 0 : r.drawMatchUps) ?? [];
    Ld({ matchUps: a });
  }
  return (e ?? []).filter(({ collectionId: a }) => !a).forEach((a) => {
    let { matchUpId: o, structureId: s } = a, c = ei({ inContextDrawMatchUps: e, drawDefinition: t, matchUpId: o }), { winnerMatchUp: u, loserMatchUp: d } = c.targetMatchUps, l = u == null ? void 0 : u.matchUpId, p = d == null ? void 0 : d.matchUpId, f = No({ matchUpsMap: r, structureId: s }).find((m) => m.matchUpId === o);
    if (f && (l && (i.winnerMatchUpIds[f.matchUpId] = l, Object.assign(f, { winnerMatchUpId: l }), Object.assign(a, { winnerMatchUpId: l })), p && (i.loserMatchUpIds[f.matchUpId] = p, a.loserMatchUpId = p, f.loserMatchUpId = p, a.finishingPositionRange))) {
      let m = d.finishingPositionRange && [...a.finishingPositionRange.loser, ...d.finishingPositionRange.loser], h = m && [Math.min(...m), Math.max(...m)];
      a.finishingPositionRange.loser = h, f.finishingPositionRange.loser = h;
    }
  }), { inContextDrawMatchUps: e, goesToMap: i };
}
function An(e) {
  var U;
  let t = $i(e), r = e.matchUps ?? [], i = e.drawIds ?? [], { includeParticipantDependencies: n, tournamentRecord: a, drawDefinition: o } = e;
  if (!Array.isArray(r)) return { error: Ma };
  if (!Array.isArray(i)) return { error: Cn };
  let s = (U = e.matchUpIds) != null && U.length ? e.matchUpIds : r.map((v) => v.matchUpId);
  if (!Array.isArray(s)) return { error: Ts };
  let c = {}, u = {}, d = {}, l = {};
  a && !Object.keys(t).length && (t = { [a.tournamentId]: a });
  let p = Object.values(t), f = p.reduce((v, S) => v.concat(S.events ?? []).map((T) => (T.drawDefinitions || []).map((A) => A.links || [])).flat(1 / 0), []).filter(({ linkType: v }) => v === Aa), m = r;
  if (f.length) {
    m = On({ nextMatchUps: !0, tournamentRecords: t }).matchUps;
    let v = f.reduce((S, T) => {
      var D, P;
      let A = (D = T.source) == null ? void 0 : D.structureId, y = (P = T.target) == null ? void 0 : P.structureId;
      return A && y && (d[y] = A), A && !S.includes(A) && S.push(A), S;
    }, []);
    for (let S of v) c[S] = [];
    for (let S of m ?? []) {
      let T = S.containerStructureId || S.structureId;
      v.includes(T) && c[T].push(S.matchUpId);
    }
  }
  let h = (v) => {
    u[v] || (u[v] = { dependentMatchUpIds: [], participantIds: [], matchUpIds: [], sources: [] }, l[v] = []);
  }, g = (v, S) => {
    u[v].matchUpIds.forEach((T) => {
      u[S].matchUpIds.push(T);
    }), u[S].matchUpIds.push(v), u[v].dependentMatchUpIds.push(S), n && u[v].participantIds.forEach((T) => u[S].participantIds.push(T));
  }, I = (v) => {
    let S = Object.keys(c).length;
    for (let T of v || []) {
      let { matchUpId: A, winnerMatchUpId: y, loserMatchUpId: D } = T;
      if (!s.length || s.includes(A)) {
        if (h(A), n) {
          let { individualParticipantIds: R } = pm(T);
          u[A].participantIds = R;
        }
        y && (h(y), g(A, y), l[y].push(A)), D && (h(D), g(A, D), l[D].push(A)), u[A].sources.push(l[A]);
        let P = l[A].map((R) => u[R].sources[0]).flat(), w = l[A].map((R) => u[R].sources[1]).flat();
        if (u[A].sources.push(P, w), S) {
          let R = T.containerStructureId || T.structureId, b = d[R];
          if (c[b]) for (let E of c[b]) h(E), g(E, A), l[E].push(A);
        }
      }
    }
  };
  if (o) Eo({ drawDefinition: o }), m != null && m.length || (m = Qr({ drawDefinition: o }).matchUps), I(m);
  else {
    if (m != null && m.length || (m = On({ nextMatchUps: !0, tournamentRecords: t }).matchUps), !i.length) {
      let v = p != null && p.length ? p.map(({ events: S = [] }) => S.map(({ drawDefinitions: T = [] }) => T.map(({ drawId: A }) => A))).flat(1 / 0) : [];
      v && (i = v);
    }
    for (let v of i) {
      let S = m == null ? void 0 : m.filter((T) => T.drawId === v).sort(js);
      if (!(S != null && S.find(({ roundPosition: T }) => !T))) {
        let T = S == null ? void 0 : S.find(({ tournamentId: y }) => y), { drawDefinition: A } = ci({ tournamentRecord: t[T == null ? void 0 : T.tournamentId], drawId: v });
        A && Eo({ drawDefinition: A });
      }
      I(S);
    }
  }
  return { positionDependencies: c, matchUpDependencies: u, sourceMatchUpIds: l, matchUps: m, ...j };
}
function pr(e) {
  var l, p;
  let t = e == null ? void 0 : e.matchUp, r = (e == null ? void 0 : e.score) || (t == null ? void 0 : t.score), i = (l = r == null ? void 0 : r.sets) == null ? void 0 : l[0], { side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s, side1PointScore: c, side2PointScore: u } = i || {}, d = n || a || o || s || c || u;
  return !!(((p = r == null ? void 0 : r.sets) == null ? void 0 : p.length) > 1 || d);
}
function xd({ matchUpStatus: e }) {
  return Db.includes(e);
}
function Xx({ matchUpStatus: e }) {
  return Sv.includes(e);
}
function kg({ matchUpStatus: e }) {
  return Pb.includes(e);
}
function Zv({ matchUpStatus: e, winningSide: t, tieMatchUps: r, sides: i, score: n }) {
  var s;
  let a = i == null ? void 0 : i.find(({ participantId: c }) => c), o = (s = r == null ? void 0 : r.filter(Zv)) == null ? void 0 : s.length;
  return pr({ score: n }) || o || t && a || e && Xx({ matchUpStatus: e }) && ![Je, ct, Sn].includes(e);
}
function Bd(e) {
  var y;
  let { drawDefinition: t, findContainer: r, structureId: i, event: n } = e, a = e.structure, o = { isCollectionMatchUp: !1 }, { containedStructures: s } = Zc({ drawDefinition: t }), c = i ? s[i] || [] : [];
  if (!a) {
    let D = Ne({ drawDefinition: t, structureId: i });
    if (D.error) return D;
    a = r ? D.containingStructure ?? D.structure : D.structure;
  }
  if (si({ structure: a })) return { structure: a, isAdHoc: !0, error: xc };
  let { matchUps: u } = ur({ inContext: !0, matchUpFilters: o, drawDefinition: t, event: n }), d = u == null ? void 0 : u.filter((D) => D.structureId === i || c.includes(D.structureId)), { matchUpDependencies: l } = An({ drawIds: [t.drawId], matchUps: u, drawDefinition: t }), p = [], f = [], m = {}, h = [];
  for (let D of u ?? []) {
    if (D.structureId === i || c.includes(D.structureId)) {
      f.push(...D.drawPositions ?? []);
      let P = D.roundNumber;
      for (let w of (D.drawPositions ?? []).filter(Boolean)) (!m[w] || P && m[w] > P) && (m[w] = P);
    }
    Zv(D) && (h.push(D), p.push(D.matchUpId, ...((y = l == null ? void 0 : l[D == null ? void 0 : D.matchUpId]) == null ? void 0 : y.matchUpIds) || []));
  }
  let g = Be(f.filter(Boolean)).sort(ar), I = Be(p), U = Be(d == null ? void 0 : d.map(({ matchUpId: D, drawPositions: P }) => I.includes(D) ? P : []).flat().filter(Boolean)).sort(ar), { positionAssignments: v } = gt({ drawDefinition: t, structure: a }), S = v == null ? void 0 : v.filter((D) => D.bye).map((D) => D.drawPosition), T = v == null ? void 0 : v.filter((D) => D.qualifier).map((D) => D.drawPosition), A = (g == null ? void 0 : g.filter((D) => !U.includes(D))) || [];
  return { allDrawPositions: g, inContextStructureMatchUps: d, drawPositionInitialRounds: m, activeDependentMatchUpIds: I, qualifyingDrawPositions: T, inactiveDrawPositions: A, positionAssignments: v, activeDrawPositions: U, byeDrawPositions: S, activeMatchUps: h, structure: a };
}
function Ss({ drawPosition: e, matchUps: t = [] }) {
  return { initialRoundNumber: t.filter(({ drawPositions: r }) => e && (r == null ? void 0 : r.includes(e))).map(({ roundNumber: r }) => r).sort(ar)[0] };
}
var Ga = { reset: "\x1B[0m", bright: "\x1B[1m", dim: "\x1B[2m", red: "\x1B[31m", brightred: "\x1B[91m", green: "\x1B[32m", brightgreen: "\x1B[92m", yellow: "\x1B[33m", brightyellow: "\x1B[93m", blue: "\x1B[34m", brightblue: "\x1B[94m", lightblue: "\x1B[105m", magenta: "\x1B[35m", brightmagenta: "\x1B[95m", cyan: "\x1B[36m", brightcyan: "\x1B[96m", white: "\x1B[37m", brightwhite: "\x1B[97m" }, Qv = [];
function Oi(e, t) {
  Et(e) && (e = { method: e }), (t || ki()) && Qv.push(e);
}
function Zx(e) {
  return Qv.slice();
}
function Qx(e) {
  let t = Zx().map((r) => {
    let { color: i, keyColors: n, method: a, newline: o } = r, s = Object.keys(Ga).includes(i) ? Ga[i] : Ga.cyan, c = Object.keys(r).filter((d) => !["color", "keyColors", "method", "newline"].includes(d)).map((d) => {
      let l = n && Object.keys(n).includes(d) && Ga[n[d]] ? Ga[n[d]] : Ga.brightwhite;
      return `${Ga.white}${d}: ${l}${r[d]}`;
    }).join(", "), u = (a == null ? void 0 : a.length) < 15 ? "		" : "	";
    return [o ? `
` : "", s, a, u, Ga.white, c, Ga.reset, `
`].join("");
  });
  t != null && t.length && console.log(...t);
}
function Jx() {
  Qv.length = 0;
}
function _i({ provisionalPositioning: e, isPositionAction: t, tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUpsMap: a, structureId: o, structure: s, event: c }) {
  var P, w, R;
  if (!i) return { error: Ue };
  if (s || ({ structure: s } = Ne({ drawDefinition: i, structureId: o })), !s) return { error: kt };
  o || ({ structureId: o } = s);
  let u = "assignDrawPositionBye";
  Oi({ method: u, color: "cyan", drawPosition: n }), a || (a = xr({ drawDefinition: i }));
  let { positionAssignments: d } = gt({ structure: s }), { activeDrawPositions: l } = Bd({ drawDefinition: i, structureId: o });
  if ((P = d == null ? void 0 : d.find((b) => b.drawPosition === n)) != null && P.bye) return { ...j };
  if (l != null && l.includes(n)) return { error: bf };
  let p = d == null ? void 0 : d.find((b) => b.drawPosition === n);
  if (!p) return { error: xc };
  let { filled: f, containsBye: m, assignedParticipantId: h } = $x(p);
  if (m) return { ...j };
  if (f && !m) return W({ result: { error: fc }, stack: u });
  let g = nt({ tournamentRecord: r, drawDefinition: i, event: c }).appliedPolicies ?? {}, I = ur({ inContext: !0, drawDefinition: i, matchUpsMap: a }).matchUps ?? [], U = { isCollectionMatchUp: !1 }, { matchUps: v } = ut({ provisionalPositioning: e, drawDefinition: i, matchUpFilters: U, matchUpsMap: a, structure: s });
  if (d == null || d.forEach((b) => {
    b.drawPosition === n && (b.bye = !0);
  }), s.structureType === ri) return eB({ tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUps: v }), Qa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: s, event: c }), pT({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
  let { roundProfile: S, roundMatchUps: T } = $r({ matchUps: v }), A = (w = S && Object.keys(S).map((b) => parseInt(b)).reverse()) == null ? void 0 : w.find((b) => {
    var E;
    return (E = S == null ? void 0 : S[b].drawPositions) == null ? void 0 : E.includes(n);
  }), y = A ? T == null ? void 0 : T[A].find(({ drawPositions: b }) => b == null ? void 0 : b.includes(n)) : void 0;
  y && fN({ tournamentRecord: r, drawDefinition: i, matchUp: y, event: c });
  let D = (R = y == null ? void 0 : y.drawPositions) == null ? void 0 : R.find((b) => b !== n);
  if (y && D) {
    let b = Jv({ sourceDrawPositions: y.drawPositions, matchUpId: y.matchUpId, inContextDrawMatchUps: I, drawPositionToAdvance: D, tournamentRecord: r, drawDefinition: i, matchUpsMap: a });
    if (b.error) return b;
  }
  return Qa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: s, event: c }), pT({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
}
function pT({ assignedParticipantId: e, isPositionAction: t, appliedPolicies: r, drawDefinition: i, drawPosition: n, structureId: a, stack: o }) {
  return t && lm({ appliedPolicies: r, drawDefinition: i, positionAction: { removedParticipantId: e, drawPosition: n, structureId: a, name: o } }), W({ result: { ...j }, stack: o });
}
function $x(e) {
  let t = e.bye, r = e.qualifier, i = e.participantId;
  return { containsBye: t, containsQualifier: r, assignedParticipantId: i, filled: t || r || i };
}
function fN({ tournamentRecord: e, drawDefinition: t, eventId: r, matchUp: i, event: n }) {
  Object.assign(i, { matchUpStatus: at, score: void 0, winningSide: void 0 }), Qe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: r ?? (n == null ? void 0 : n.eventId), context: "setMatchUpStatusBye", drawDefinition: t, matchUp: i });
}
function eB({ tournamentRecord: e, drawDefinition: t, drawPosition: r, matchUps: i, event: n }) {
  i.forEach((a) => {
    var o;
    (o = a.drawPositions) != null && o.includes(r) && fN({ eventId: n == null ? void 0 : n.eventId, tournamentRecord: e, drawDefinition: t, matchUp: a });
  });
}
function Jv({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, matchUpsMap: a, matchUpId: o, event: s }) {
  var v, S;
  Oi({ method: "advanceDrawPosition", color: "cyan", drawPositionToAdvance: e });
  let c = a.drawMatchUps.find((T) => T.matchUpId === o), u = (v = t.find((T) => T.matchUpId === o)) == null ? void 0 : v.structureId, { structure: d } = Ne({ drawDefinition: n, structureId: u }), { positionAssignments: l } = gt({ structure: d }), p = l == null ? void 0 : l.filter((T) => T.bye).map((T) => T.drawPosition), f = (S = c == null ? void 0 : c.drawPositions) == null ? void 0 : S.find((T) => T !== e), m = f && (p == null ? void 0 : p.includes(f)), { targetLinks: { loserTargetLink: h }, targetMatchUps: { loserMatchUp: g, winnerMatchUp: I, loserTargetDrawPosition: U } } = ei({ inContextDrawMatchUps: t, drawDefinition: n, matchUpId: o });
  if (I && I.structureId === (d == null ? void 0 : d.structureId) && tB({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: I, matchUpsMap: a, event: s }), g && m && g.structureId !== (d == null ? void 0 : d.structureId)) {
    let { roundNumber: T } = g;
    if (T === 1) {
      let A = _i({ structureId: h.target.structureId, drawPosition: U, tournamentRecord: i, drawDefinition: n, event: s });
      if (A.error) return A;
    } else mN({ loserTargetDrawPosition: U, tournamentRecord: i, loserTargetLink: h, drawDefinition: n, loserMatchUp: g, matchUpsMap: a, event: s });
  }
  return { ...j };
}
function tB({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: a, matchUpsMap: o, event: s }) {
  var O, M, N, C, F, x;
  let c = "advanceWinner", u = o.drawMatchUps.find((V) => V.matchUpId === a.matchUpId), d = (O = t.find((V) => V.matchUpId === a.matchUpId)) == null ? void 0 : O.structureId, { structure: l } = Ne({ drawDefinition: n, structureId: d }), { positionAssignments: p } = gt({ structure: l }), f = (M = p == null ? void 0 : p.find(({ drawPosition: V }) => V === e)) == null ? void 0 : M.bye, m = (N = u.drawPositions) == null ? void 0 : N.filter(Boolean), h = p == null ? void 0 : p.filter((V) => m == null ? void 0 : m.includes(V.drawPosition)), g = p == null ? void 0 : p.find(({ drawPosition: V }) => V === e), I = r == null ? void 0 : r.find((V) => V !== e), U = (C = I && (h == null ? void 0 : h.find(({ drawPosition: V }) => V === I))) == null ? void 0 : C.bye, v = f && U;
  if (v && console.log({ isByeAdvancedBye: v }), (m == null ? void 0 : m.length) > 1 && f && !U) return W({ result: { error: fc }, stack: c });
  let S = m == null ? void 0 : m.find((V) => V !== e), T = v, A = [...(u.drawPositions || []).filter(Boolean), void 0, void 0].slice(0, 2), y = A.map((V) => !V && !T || V === e ? (T = !0, e) : V).sort(ar);
  if (!T) return console.log("@@@@@@@", { advancingAssignmentIsBye: g, drawPositionToAdvance: e, existingAssignments: h }), W({ result: { error: fc }, stack: c });
  let D = (F = p == null ? void 0 : p.find(({ drawPosition: V }) => V === S)) == null ? void 0 : F.bye, P = (x = p == null ? void 0 : p.find(({ drawPosition: V }) => V === e)) == null ? void 0 : x.bye;
  Object.assign(u, { matchUpStatus: P || D ? at : Xt, score: void 0, winningSide: void 0, drawPositions: y });
  let w = u.drawPositions.find((V) => !A.includes(V));
  Oi({ method: c, color: "brightyellow", changedDrawPosition: w, pairedDrawPositionIsBye: D, drawPositionIsBye: P }), Qe({ tournamentId: i == null ? void 0 : i.tournamentId, matchUp: u, eventId: s == null ? void 0 : s.eventId, context: c, drawDefinition: n });
  let { targetLinks: { loserTargetLink: R }, targetMatchUps: { loserMatchUp: b, loserTargetDrawPosition: E } } = ei({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: n });
  if (D || P) {
    let V = D ? e : S;
    if (V) Jv({ drawPositionToAdvance: V, matchUpId: a.matchUpId, inContextDrawMatchUps: t, tournamentRecord: i, drawDefinition: n, matchUpsMap: o });
    else if (P && R && b) if (b.feedRound) mN({ loserTargetDrawPosition: E, tournamentRecord: i, loserTargetLink: R, drawDefinition: n, loserMatchUp: b, matchUpsMap: o });
    else {
      let k = 1 - a.roundPosition % 2, L = b.drawPositions[k], B = _i({ structureId: R.target.structureId, drawPosition: L, tournamentRecord: i, drawDefinition: n, event: s });
      if (B.error) return B;
    }
  }
}
function mN({ loserTargetDrawPosition: e, tournamentRecord: t, loserTargetLink: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  let { roundNumber: s } = n;
  Oi({ method: "assignFedDrawPositionBye", color: "cyan", loserTargetDrawPosition: e });
  let c = ((a == null ? void 0 : a.mappedMatchUps) || {})[n.structureId].matchUps, { initialRoundNumber: u } = Ss({ drawPosition: e, matchUps: c });
  if (u === s) {
    let d = _i({ structureId: r.target.structureId, drawPosition: e, tournamentRecord: t, drawDefinition: i, event: o });
    if (d.error) return d;
  }
}
function hN({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: i, structure: n, event: a }) {
  let { matchUps: o } = ut({ drawDefinition: r, matchUpsMap: i, structure: n, event: a });
  o.forEach((s) => {
    let c = e.filter(({ drawPosition: u }) => {
      var d;
      return (d = s.drawPositions) == null ? void 0 : d.includes(u);
    }).filter((u) => u.bye).length;
    s.winningSide || (Object.assign(s, { matchUpStatus: c ? at : Xt }), Qe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "modifyRoundRobinMatchUpsStatus", eventId: a == null ? void 0 : a.eventId, drawDefinition: r, matchUp: s }));
  });
}
function Vd(e) {
  let { inContextDrawMatchUps: t, participantId: r, drawPosition: i } = e, { tournamentRecord: n, drawDefinition: a, structureId: o, matchUpsMap: s, event: c } = e, { structure: u } = Ne({ drawDefinition: a, structureId: o }), d = (Ir({ drawDefinition: a, structure: u }).positionAssignments || []).find((p) => r && p.participantId === r || i && p.drawPosition === i);
  if (d && r && !i && (i = d == null ? void 0 : d.drawPosition), !i) return { error: Bc };
  r || (r = d == null ? void 0 : d.participantId);
  let { activeDrawPositions: l } = Bd({ drawDefinition: a, structureId: o });
  return l.includes(i) ? { error: bf } : (t || ({ matchUps: t } = ur({ inContext: !0, drawDefinition: a, matchUpsMap: s })), Lg({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, structureId: o, drawPosition: i, matchUpsMap: s, event: c }).drawPositionCleared ? (Qa({ tournamentId: n == null ? void 0 : n.tournamentId, drawDefinition: a, structure: u, event: c }), { ...j, participantId: r }) : { error: _P });
}
function Lg({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: a, event: o }) {
  var I, U;
  let { structure: s } = Ne({ drawDefinition: r, structureId: a });
  if (!s) return { error: kt };
  let c = Ir({ drawDefinition: r, structure: s }).positionAssignments || [], u = c.some((v) => {
    if (v.drawPosition === i) return delete v.participantId, delete v.qualifier, delete v.bye, !0;
  });
  if (s.structureType === ri) return hN({ positionAssignments: c, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, structure: s }), { drawPositionCleared: u, ...j };
  let d = { isCollectionMatchUp: !1 }, { matchUps: l } = ut({ drawDefinition: r, matchUpFilters: d, matchUpsMap: n, structure: s, event: o }), { roundProfile: p, roundMatchUps: f } = $r({ matchUps: l }), m = (I = p && Object.keys(p)) == null ? void 0 : I.map((v) => be(v)), h = i, g = (U = m == null ? void 0 : m.map((v) => {
    var b, E, O, M;
    let S = (E = (b = p == null ? void 0 : p[v]) == null ? void 0 : b.pairedDrawPositions) == null ? void 0 : E.find((N) => N.includes(h)), T = S == null ? void 0 : S.find((N) => N !== h), A = c.find((N) => N.drawPosition === T), y = p == null ? void 0 : p[v + 1], D = A == null ? void 0 : A.bye, P = (O = y == null ? void 0 : y.pairedDrawPositions) == null ? void 0 : O.find((N) => N.includes(T)), w = D && P && y && ((M = y.drawPositions) == null ? void 0 : M.includes(T)), R = S && { pairedDrawPositionByeAdvancedPair: !w && P, pairedDrawPosition: T, targetDrawPosition: h, relevantPair: S, roundNumber: v };
    return w && (h = T), R;
  }).filter((v) => v == null ? void 0 : v.targetDrawPosition)) == null ? void 0 : U.reduce((v, S) => {
    let { roundNumber: T, relevantPair: A, targetDrawPosition: y, pairedDrawPosition: D, pairedDrawPositionByeAdvancedPair: P } = S, w = { roundNumber: T, targetDrawPosition: y, relevantPair: A }, R = P && { roundNumber: T + 1, targetDrawPosition: D, relevantPair: P, subsequentRoundRemoval: !0 }, b = [w, R].filter(Boolean);
    return v.concat(...b);
  }, []);
  return g == null || g.forEach(({ roundNumber: v, targetDrawPosition: S, relevantPair: T }) => {
    let A = f == null ? void 0 : f[v].find((y) => {
      var D;
      return Jr((D = y.drawPositions) == null ? void 0 : D.filter(Boolean), T.filter(Boolean));
    });
    A && (rB({ inContextDrawMatchUps: e, targetDrawPosition: S, tournamentRecord: t, drawDefinition: r, structureId: a, roundNumber: v, matchUpsMap: n }), gN({ inContextDrawMatchUps: e, positionAssignments: c, tournamentRecord: t, drawDefinition: r, targetMatchUp: A, drawPosition: i, matchUpsMap: n, structure: s, event: o }));
  }), { tasks: g, drawPositionCleared: u, positionAssignments: c };
}
function rB({ inContextDrawMatchUps: e, targetDrawPosition: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, roundNumber: a, structureId: o }) {
  let { structure: s } = Ne({ drawDefinition: i, structureId: o });
  if (!s) return { error: kt };
  if (s.structureType === ri) return;
  n = n || xr({ drawDefinition: i });
  let c = ((n == null ? void 0 : n.mappedMatchUps) || {})[o].matchUps, { initialRoundNumber: u } = Ss({ drawPosition: t, matchUps: c }), d = c == null ? void 0 : c.filter((p) => {
    var f;
    return p.roundNumber >= a && p.roundNumber !== u && ((f = p.drawPositions) == null ? void 0 : f.includes(t));
  }), l = gt({ drawDefinition: i, structureId: o }).positionAssignments ?? [];
  return d == null || d.forEach((p) => gN({ drawPosition: t, targetMatchUp: p, inContextDrawMatchUps: e, positionAssignments: l, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, structure: s })), { ...j };
}
function gN({ inContextDrawMatchUps: e, positionAssignments: t, tournamentRecord: r, drawDefinition: i, targetMatchUp: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  var y, D, P, w, R;
  let u = "removeDrawPosition", d = (y = n.drawPositions) == null ? void 0 : y.slice(), l = n.matchUpStatus, p = n.winningSide;
  o = o ?? xr({ drawDefinition: i });
  let f = o.mappedMatchUps[s.structureId].matchUps, { initialRoundNumber: m } = Ss({ drawPosition: a, matchUps: f });
  if (n.roundNumber && m && n.roundNumber > m) {
    let b = (n.drawPositions ?? []).map((E) => E === a ? void 0 : E);
    n.drawPositions = b;
  }
  if (n.matchUpType === yt) {
    let b = (((D = e == null ? void 0 : e.find((E) => E.matchUpId === n.matchUpId)) == null ? void 0 : D.sides) ?? []).reduce((E, O, M) => O.drawPosition === a ? M : E, void 0);
    b !== void 0 && ((w = (P = n.sides) == null ? void 0 : P[b]) != null && w.lineUp) && ((R = n.sides) == null || delete R[b].lineUp, Qe({ tournamentId: r == null ? void 0 : r.tournamentId, context: `${u}-TEAM`, eventId: c == null ? void 0 : c.eventId, matchUp: n, drawDefinition: i }));
  }
  let h = ei({ matchUpId: n.matchUpId, inContextDrawMatchUps: e, drawDefinition: i }), { targetLinks: { winnerTargetLink: g }, targetMatchUps: { loserMatchUp: I, winnerMatchUp: U, loserMatchUpDrawPositionIndex: v } } = h, S = t.filter(({ drawPosition: b }) => {
    var E;
    return (E = n.drawPositions) == null ? void 0 : E.includes(b);
  }).filter((b) => b.bye).length, T = S && at || n.matchUpStatus && [Je, ct].includes(n.matchUpStatus) && n.matcHUpStatus || Xt;
  n.matchUpStatus = T, n.matchUpStatus && [ct, Je].includes(n.matchUpStatus) && (n.winningSide = void 0);
  let A = d == null ? void 0 : d.find((b) => {
    var E;
    return !((E = n.drawPositions) != null && E.includes(b));
  });
  if (d != null && d.includes(a) && l === n.matchUpStatus && p === n.winningSide || (A && Oi({ method: u, color: "brightyellow", removedDrawPosition: A }), Qe({ tournamentId: r == null ? void 0 : r.tournamentId, context: `${u}-${a}`, eventId: c == null ? void 0 : c.eventId, matchUp: n, drawDefinition: i })), I && I.structureId !== h.matchUp.structureId && !S) {
    let { drawPositions: b, roundNumber: E } = I;
    if (E === 1) {
      let O = b[v];
      Lg({ structureId: I.structureId, drawPosition: O, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o });
    } else {
      let O = Math.min(...b.filter(Boolean)), M = iB({ loserMatchUpDrawPosition: O, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, loserMatchUp: I, matchUpsMap: o, event: c });
      if (M.error) return W({ result: M, stack: u });
      let N = ((o == null ? void 0 : o.mappedMatchUps) || {})[I.structureId].matchUps, { initialRoundNumber: C } = Ss({ drawPosition: O, matchUps: N });
      C === 1 && (Oi({ method: u, color: "brightyellow", loserMatchUpDrawPosition: O }), Lg({ structureId: I.structureId, drawPosition: O, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o }));
    }
  }
  return U && U.structureId !== h.matchUp.structureId && g.target.feedProfile, { ...j };
}
function iB({ loserMatchUpDrawPosition: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  var u;
  let { structure: s } = Ne({ structureId: n.structureId, drawDefinition: i }), { positionAssignments: c } = gt({ structure: s });
  if ((u = c == null ? void 0 : c.find((d) => d.drawPosition === e)) != null && u.bye) {
    let d = Vd({ drawPosition: e, structureId: n.structureId, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: a, event: o });
    if (d.error) return d;
  }
  return { ...j };
}
function Ko({ drawDefinition: e, stages: t }) {
  if (!e) return { error: Ue };
  let r = ((e == null ? void 0 : e.structures) ?? []).filter((n) => !(t != null && t.length) || n.stage && t.includes(n.stage)), i = Be(r.map((n) => {
    let { positionAssignments: a } = gt({ structure: n });
    return a ? a.map(Ke) : [];
  }).flat().filter(Boolean));
  return { ...j, assignedParticipantIds: i };
}
function wn(e) {
  let t = ((e == null ? void 0 : e.entries) ?? []).filter(Boolean).reduce((i, n) => {
    let { entryStage: a, entryStatus: o } = n, s = `_${a || Ie}${o || ""}`;
    return i[s] || (i[s] = []), i[s].push(n), i;
  }, {}), r = (i) => isNaN(i) ? 1 / 0 : i;
  return Object.keys(t).map((i) => t[i].sort((n, a) => r(n.entryPosition) - r(a.entryPosition)).map((n, a) => {
    let o = a + 1;
    return { ...n, entryPosition: o };
  })).flat();
}
function Io(e) {
  return [Ho, tn].includes(e);
}
function gp({ autoEntryPositions: e = !0, ignoreAssignment: t, tournamentRecord: r, drawDefinition: i, participantIds: n, entryStatus: a, entryStage: o, extension: s, eventSync: c, drawId: u, stage: d, event: l }) {
  var P, w, R, b, E, O, M, N, C, F, x, V;
  if (!n || !Array.isArray(n)) return { error: bn, method: "modifyEntriesStatus", participantIds: n };
  if (!i && !l) return { error: At };
  if (a && !Wb.includes(a)) return { error: vg };
  if (o && !zf.includes(o)) return { error: Vo };
  let p = "modifyEntriesStatus", f = [];
  if (!a && !s) return W({ result: { error: we }, info: "Missing entryStatus", stack: p });
  if (s && !Wn({ extension: s, requiredAttributes: ["name"] })) return W({ result: { error: ie }, info: "Invalid extension", context: { extension: s }, stack: p });
  let m = [];
  (P = l == null ? void 0 : l.drawDefinitions) == null || P.forEach((k) => {
    let L = Ko({ stages: d && [d], drawDefinition: k }).assignedParticipantIds ?? [];
    m.push(...L);
  });
  let h = (r == null ? void 0 : r.participants) ?? [];
  if (!n.every((k) => {
    var B;
    let L = (B = za({ tournamentParticipants: h, participantId: k })) == null ? void 0 : B.participantType;
    return !(L && [_e, ai].includes(L) && Io(a)) && !(a && (l != null && l.eventType) && L === Xe && [Xi, bi].includes(l.eventType) && [fn, ..._l].includes(a));
  })) return { error: vg };
  let g = l && Ht({ event: l }).flightProfile, I = (w = g == null ? void 0 : g.flights) == null ? void 0 : w.find((k) => k.drawId === u), U = (k) => {
    let L = (k || []).filter((G) => !d || !G.entryStage || d === G.entryStage).filter(({ participantId: G }) => n.includes(G)), B = (G) => a && m.includes(G.participantId) && !(_l.includes(G.entryStatus) && _l.includes(a));
    return L.every((G) => B(G) && !t ? !1 : (a && (G.entryStatus = a, delete G.entryPosition), o && (G.entryStage = o, delete G.entryPosition), s && (s.value ? it({ element: G, extension: s }) : Zr({ element: G, name: s.name })), !0)) ? { ...j } : { error: jc };
  }, v = ({ flight: k, drawDefinition: L }) => {
    l && (l.entries = wn({ entries: l.entries ?? [] })), k && (k.drawEntries = wn({ entries: k.drawEntries })), L && (L.entries = wn({ entries: L.entries }));
  }, S = (k) => {
    let { flight: L, drawDefinition: B } = k, G = "updateDrawEntries";
    if (L) {
      let q = U(L.drawEntries);
      if (q.error) return W({ result: q, stack: G });
    }
    if (B) {
      let q = U(B.entries);
      if (q.error) return W({ result: q, stack: G });
      f.includes(B.drawId) || f.push(B.drawId);
    }
    return { ...j };
  }, T = ((R = l == null ? void 0 : l.entries) == null ? void 0 : R.find(({ entryPosition: k }) => k)) ?? (((b = I == null ? void 0 : I.drawEntries) == null ? void 0 : b.find(({ entryPosition: k }) => k)) || ((E = i == null ? void 0 : i.entries) == null ? void 0 : E.find(({ entryPosition: k }) => k)));
  if (e && !T && v({ flight: I, drawDefinition: i }), I || i) {
    let k = S({ flight: I, drawDefinition: i });
    if (k.error) return W({ result: k, stack: p });
  }
  let A = ((O = l == null ? void 0 : l.drawDefinitions) == null ? void 0 : O.map(({ drawId: k }) => k)) ?? [], y = ((M = g == null ? void 0 : g.flights) == null ? void 0 : M.filter((k) => !A.includes(k.drawId))) || [];
  for (let k of y) {
    let L = k && S({ flight: k });
    if (L != null && L.error) return W({ result: L, stack: p });
  }
  let D = ((N = g == null ? void 0 : g.flights) == null ? void 0 : N.length) === 1 && (((C = l == null ? void 0 : l.drawDefinitions) == null ? void 0 : C.length) ?? 0) <= ((F = g == null ? void 0 : g.flights) == null ? void 0 : F.length);
  if (!I && !i && a && _b.includes(a)) return { error: Pw };
  if (!I && !i || a === Ra || c && D) {
    let k = U(l == null ? void 0 : l.entries);
    if (k != null && k.error) return W({ result: k, stack: p });
    let L;
    if (a === Ra && ((x = g == null ? void 0 : g.flights) == null || x.every((B) => {
      let G = U(B.drawEntries);
      return G.error ? (L = G.error, !1) : (B.drawEntries = B.drawEntries.filter(({ participantId: q }) => !n.includes(q)), !0);
    }), (V = l == null ? void 0 : l.drawDefinitions) == null || V.every((B) => {
      var q;
      let G = U(B.entries);
      return G.error ? (L = G.error, !1) : (B.entries = (q = B.entries) == null ? void 0 : q.filter(({ participantId: Y }) => !n.includes(Y)), !0);
    })), L) return W({ result: { error: L }, stack: p });
  }
  e && v({ flight: I, drawDefinition: i });
  for (let k of (l == null ? void 0 : l.drawDefinitions) ?? []) f.length && !f.includes(k.drawId) || vt({ tournamentId: r.tournamentId, eventId: l == null ? void 0 : l.eventId, drawDefinition: k });
  return { ...j };
}
function ta({ requireTimeStamp: e, scaleAttributes: t, participant: r }) {
  var i, n;
  if (!r) return { error: ws };
  if (!$e(t)) return { error: ie };
  if (r.timeItems || (r.timeItems = []), Array.isArray(r.timeItems)) {
    let { accessor: a, scaleType: o, eventType: s, scaleName: c } = t, u = [Ro, o, s, c].join("."), d = r.timeItems.filter((l) => (l == null ? void 0 : l.itemType) === u).filter((l) => !e || (l == null ? void 0 : l.itemDate)).sort((l, p) => (l.createdAt ? new Date(l.createdAt).getTime() : 0) - (p.createdAt ? new Date(p.createdAt).getTime() : 0)).pop();
    if (d) {
      let [l, p, f, m] = ((i = d.itemType) == null ? void 0 : i.split(".")) ?? [];
      if (l !== Ro) return { error: ps };
      let h = ((n = a && ns({ element: d.itemValue, accessor: a })) == null ? void 0 : n.value) || d.itemValue, g = { eventType: f, scaleDate: d.itemDate, scaleValue: h, scaleName: m, scaleType: p };
      return { ...j, scaleItem: g };
    }
  }
  return { ...j, scaleItem: void 0 };
}
function nB({ publishedSeeding: e, usePublishState: t, withSeeding: r, participant: i, event: n }) {
  var d, l, p;
  let a = {}, o = (f) => [Ro, $n, n.eventType, f].join("."), s = Object.assign({}, ...(i.timeItems || []).filter(({ itemType: f }) => f.split(".")[1] === $n).map(({ itemType: f, itemValue: m }) => ({ [f]: m }))), c = ((e == null ? void 0 : e.stageSeedingScaleNames) && Object.values(e == null ? void 0 : e.stageSeedingScaleNames) || Array.isArray(e == null ? void 0 : e.seedingScaleNames) && e.seedingScaleNames || []).map(o), u = qt(Object.keys(s), c);
  if ((!t || !Object.keys(s).length && !((d = e == null ? void 0 : e.drawIds) != null && d.length) || u.length) && u.length) {
    if (e != null && e.stageSeedingScaleNames) {
      let f = Object.keys(e.stageSeedingScaleNames).map((h) => {
        let g = o(e.stageSeedingScaleNames[h]), I = s[g];
        return [h, I];
      }).filter((h) => h[1]).map((h) => ({ [h[0]]: { seedValue: h[1] } })), m = Object.assign({}, ...f);
      a.seedAssignments = m;
    } else if (u) {
      let f = u.map((m) => s[m]);
      a.seedValue = f.pop();
    }
  } else if (!t && typeof r == "object") {
    let f = Object.keys(r).map((h) => {
      let g = o(r[h]), I = s[g];
      return [h, I];
    }).filter((h) => h[1]).map((h) => ({ [h[0]]: { seedValue: h[1] } })), m = Object.assign({}, ...f);
    a.seedAssignments = m;
  } else {
    let { categoryName: f, ageCategoryCode: m } = n.category || {}, h = [m, n.eventId, f].filter(Boolean), g;
    for (let I of h) {
      let U = { eventType: n.eventType, scaleType: $n, scaleName: I }, v = ta({ scaleAttributes: U, participant: i });
      if (v.scaleItem) {
        g = v.scaleItem;
        break;
      }
    }
    if (g && (!t || e != null && e.published && !((p = (l = e == null ? void 0 : e.published) == null ? void 0 : l.drawIds) != null && p.length))) {
      let I = g.scaleValue;
      a.seedValue = I;
    }
  }
  return a;
}
function aB({ convertExtensions: e, seedAssignments: t, participant: r, withSeeding: i, seedValue: n, eventId: a, ranking: o, entry: s }) {
  let { entryStatus: c, entryStage: u, entryPosition: d, extensions: l } = s, p = l != null && l.length && e ? Object.assign({}, ...QI(l ?? [])) : {}, f = Object.assign(p, { entryPosition: d, entryStatus: c, entryStage: u, ranking: o, eventId: a });
  r.events[a] = ye(f, !1, !1, !0), i && (t && (r.events[a].seedAssignments = t), n && (r.events[a].seedValue = n));
}
function IN(e) {
  let { participantMap: t, participantId: r, matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, schedule: d, drawId: l, score: p } = e;
  !d || !Object.keys(d).length || i === at || t[r].scheduleItems.push({ ...d, scheduledDate: Ve(d == null ? void 0 : d.scheduledDate), scheduledTime: Rt(d == null ? void 0 : d.scheduledTime), checkScoreHasValue: pr({ score: p }), matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, drawId: l });
}
function Gd(e) {
  var a, o, s;
  let t = Ae(e, [{ [fr]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, status: i = ji } = e, n = `${uo}.${lo}`;
  return ge((s = (o = (a = mm({ tournamentRecord: r, itemType: n })) == null ? void 0 : a.timeItem) == null ? void 0 : o.itemValue) == null ? void 0 : s[i], !1, !0);
}
function oB(e) {
  let { tournamentId: t } = e ?? {};
  return !!t;
}
function nn({ event: e, status: t = ji }) {
  var i, n, a;
  let r = `${uo}.${lo}`;
  return (a = (n = (i = Dd({ itemType: r, event: e })) == null ? void 0 : i.timeItem) == null ? void 0 : n.itemValue) == null ? void 0 : a[t];
}
function $v({ drawDetails: e, drawId: t }) {
  var r, i;
  return (i = (r = e == null ? void 0 : e[t]) == null ? void 0 : r.publishingDetail) == null ? void 0 : i.published;
}
function _s(e) {
  var l, p, f, m, h, g, I, U, v;
  let { tournamentRecord: t, drawDefinition: r, eventIds: i, eventId: n, drawIds: a, drawId: o, event: s } = e ?? {};
  if (t && !oB(t)) return { error: ie };
  if (n && !s) return { error: Ki };
  if (Array.isArray(i) && (i != null && i.length)) {
    let S = {};
    for (let T of i) {
      if (!Et(T)) return { error: ie };
      let A = (l = ci({ tournamentRecord: t, eventId: T })) == null ? void 0 : l.event;
      if (!A) return { error: Ki };
      let y = Yh({ event: A });
      S[T] = y;
    }
    return { ...j, publishState: S };
  }
  if (s) {
    let S = Yh({ event: s }), T = {};
    if (o) return r ? { publishState: { status: { published: !!((p = S.status.publishedDrawIds) != null && p.includes(o)), drawDetail: (f = S.status.drawDetails) == null ? void 0 : f[o] }, ...j } } : { error: Fi };
    if (Array.isArray(a) && (a != null && a.length)) {
      let A = ((m = s.drawDefinitions) == null ? void 0 : m.map(Hu)) ?? [];
      for (let y of a) {
        if (!Et(y)) return { error: ie };
        if (!A.includes(y)) return { error: Fi };
        T[y] = { status: { published: !!S.status.publishedDrawIds.includes(y), drawDetail: (h = S.status.drawDetails) == null ? void 0 : h[y] } };
      }
    } else T = S;
    return { ...j, publishState: T };
  }
  let c = [], u = !1, d = {};
  for (let S of (t == null ? void 0 : t.events) ?? []) {
    let T = Yh({ event: S });
    d[S.eventId] = T, T.status.published && (c.push(S.eventId), u = !0);
    for (let { drawId: A } of S.drawDefinitions ?? []) {
      let y = (I = (g = T.status) == null ? void 0 : g.publishedDrawIds) == null ? void 0 : I.includes(A);
      y && (d[A] = { status: { published: y } });
    }
  }
  if (t) {
    let S = Gd({ tournamentRecord: t });
    d.tournament = S ?? {}, ((U = S == null ? void 0 : S.orderOfPlay) != null && U.published || (v = S == null ? void 0 : S.participants) != null && v.published) && (u = !0), d.tournament.status = { published: u, publishedEventIds: c };
  }
  return { ...j, publishState: d };
}
function Yh({ event: e }) {
  var s;
  let t = nn({ event: e });
  if (!t) return { status: { published: !1 } };
  let r = { published: void 0, seedingScaleNames: [], drawIds: [] };
  t.seeding && Object.assign(r, t.seeding);
  let i = t.drawDetails ?? {};
  for (let c of ((s = e.drawDefinitions) == null ? void 0 : s.map(Hu)) || []) i[c] || (i[c] = { publishingDetail: { published: !1 } });
  let n = i && Object.keys(i).length && Object.keys(i).filter((c) => $v({ drawDetails: i, drawId: c })), a = n != null && n.length ? n : t.drawIds ?? [];
  if (a != null && a.length && !(n != null && n.length)) for (let c of a) i[c] = { publishingDetail: { published: !0 } };
  let o = (a == null ? void 0 : a.length) > 0;
  return { status: { publishedDrawIds: a, publishedSeeding: r, drawDetails: i, published: o } };
}
function Tm(e, t) {
  return (e || "").localeCompare(t || "");
}
function sB({ finishingPositionRange: e = {}, participantMap: t, finishingRound: r, participantWon: i, matchUpStatus: n, participantId: a, stageSequence: o, roundNumber: s, structureId: c, matchUpId: u, drawId: d, stage: l }) {
  let p = t[a], f = (U) => Math.abs(U[0] - U[1]);
  p.structureParticipation[c] || (p.structureParticipation[c] = { rankingStage: l, walkoverWinCount: 0, defaultWinCount: 0, stageSequence: o, winCount: 0, structureId: c, drawId: d });
  let m = p.structureParticipation[c], { winner: h, loser: g } = e, I = i ? h : g;
  i && (m.winCount += 1, n === ct && (m.walkoverWinCount += 1), n === Je && (m.defaultWinCount += 1)), I && (!m.finishingPositionRange || f(I) < f(m.finishingPositionRange)) && (m.finishingPositionRange = I), r && ((!m.finishingRound || r < m.finishingRound) && (m.finishingMatchUpId = u, m.finishingRound = r, m.roundNumber = s), r === 1 && (m.participantWon = i));
}
function fT(e) {
  var M, N, C, F, x, V, k, L, B, G;
  let { withScheduleItems: t, scheduleAnalysis: r, withTeamMatchUps: i, participantMap: n, withOpponents: a, withMatchUps: o, withEvents: s, withDraws: c, finishingPositionRange: u, finishingRound: d, matchUpStatus: l, stageSequence: p, roundNumber: f, structureId: m, score: h, stage: g, withRankingProfile: I, tieWinningSide: U, roundPosition: v, matchUpTieId: S, matchUpSides: T, collectionId: A, matchUpType: y, winningSide: D, matchUpId: P, schedule: w, eventId: R, drawId: b, sides: E } = e, O = a && (E == null ? void 0 : E.length) === 2 && Object.assign({}, ...E.map(({ sideNumber: q }, Y) => {
    let H = E[1 - Y].participantId;
    return q && { [q]: H };
  }).filter(Boolean));
  for (let q of E) {
    let { participantId: Y, sideNumber: H, bye: X } = q;
    if (X) continue;
    let z = D === H, Z = (ee) => {
      var ae, oe;
      let K = (ae = n[ee]) == null ? void 0 : ae.participant, J = K == null ? void 0 : K.participantType, $ = [{ participantId: ee, participantType: J }];
      if (J !== ai) for (let ce of (K == null ? void 0 : K.individualParticipantIds) || []) {
        let se = (oe = n[ce]) == null ? void 0 : oe.participant;
        $.push({ participantType: se == null ? void 0 : se.participantType, participantId: ce });
      }
      return $;
    }, te = (ee, K) => {
      if (o) {
        if (n[ee].matchUps[P] = { participantWon: z, matchUpType: y, structureId: m, sideNumber: H, matchUpId: P, eventId: R, drawId: b, stage: g }, a) {
          let J = Z(K);
          n[ee].matchUps[P].opponentParticipantInfo = J;
        }
        A && (n[ee].matchUps[P].collectionId = A);
      }
      a && K && (n[ee].opponents[K] = { participantId: K, matchUpId: P, eventId: R, drawId: b }), I && sB({ finishingPositionRange: u, participantMap: n, participantWon: z, finishingRound: d, matchUpStatus: l, participantId: ee, stageSequence: p, roundNumber: f, structureId: m, matchUpId: P, drawId: b, stage: g }), (r || t) && IN({ participantMap: n, participantId: ee, matchUpStatus: l, roundPosition: v, matchUpType: y, roundNumber: f, structureId: m, matchUpId: P, schedule: w, drawId: b, score: h });
    }, ne = ({ participant: ee, partnerParticipantId: K }) => {
      var $, ae, oe;
      let J = (ce, se) => {
        ce && (ce.partnerParticipantIds || (ce.partnerParticipantIds = []), ce.partnerParticipantIds.includes(se) || ce.partnerParticipantIds.push(se));
      };
      c && J(($ = ee == null ? void 0 : ee.draws) == null ? void 0 : $[b], K), s && J((ae = ee == null ? void 0 : ee.events) == null ? void 0 : ae[R], K), o && J((oe = ee == null ? void 0 : ee.matchUps) == null ? void 0 : oe[P], K);
    };
    if (Y && n[Y]) {
      let ee = O == null ? void 0 : O[H];
      te(Y, ee);
      let K = ((M = n[Y]) == null ? void 0 : M.participant.participantType) === _e, J = ((N = n[Y]) == null ? void 0 : N.participant.individualParticipantIds) || [];
      if (S) {
        if (i) {
          let $ = (ae) => n[ae].matchUps[S] = { participantWon: U === H, matchUpId: S, matchUpType: yt, sideNumber: H };
          $(Y), J.forEach($);
        }
        if (c && !n[Y].draws[b]) {
          let $ = (F = (C = T.find((ce) => ce.sideNumber === H)) == null ? void 0 : C.participant) == null ? void 0 : F.participantId, ae = (k = (V = (x = n[$]) == null ? void 0 : x.draws) == null ? void 0 : V[b]) == null ? void 0 : k.entryStatus, oe = (ce) => n[ce].draws[b] = { entryStatus: ae, eventId: R, drawId: b };
          oe(Y), J.forEach(oe);
        }
      }
      if (K && (J.forEach(($) => n[$] && te($, ee)), J.forEach(($, ae) => {
        let oe = J[1 - ae], ce = n[$];
        ce && ne({ participant: ce, partnerParticipantId: oe });
      }), s && T)) {
        let $ = (B = (L = T.find((ae) => ae.sideNumber === H)) == null ? void 0 : L.participant) == null ? void 0 : B.participantId;
        if ($) {
          let ae = (G = n[$]) == null ? void 0 : G.events[R];
          ae ? (n[Y].events[R] = { ...ae }, J.forEach((oe) => n[oe].events[R] = { ...ae })) : console.log("Missing teamEntry", { eventId: R, teamParticipantId: $ });
        }
      }
      if (D) {
        let $ = (ae) => {
          z ? (n[ae].counters[y].wins += 1, n[ae].counters.wins += 1, l === ct && (n[ae].counters[y].walkoverWins += 1, n[ae].counters.walkoverWins += 1), l === Je && (n[ae].counters[y].defaultWins += 1, n[ae].counters.defaultWins += 1)) : (n[ae].counters[y].losses += 1, n[ae].counters.losses += 1, l === ct && (n[ae].counters[y].walkovers += 1, n[ae].counters.walkovers += 1), l === Je && (n[ae].counters[y].defaults += 1, n[ae].counters.defaults += 1));
        };
        $(Y), J.forEach($);
      }
    }
  }
}
function cB(e) {
  var M, N, C, F, x, V, k;
  let { participantFilters: t, convertExtensions: r, policyDefinitions: i, tournamentRecord: n, usePublishState: a, contextFilters: o, matchUpFilters: s, participantMap: c, contextProfile: u, withPotentialMatchUps: d, withRankingProfile: l, withScheduleItems: p, scheduleAnalysis: f, withTeamMatchUps: m, withStatistics: h, withOpponents: g, withMatchUps: I, withSeeding: U, withEvents: v, withDraws: S } = e, T = t == null ? void 0 : t.participantIds, A = (L) => {
    var G, q;
    let B = [L];
    return (q = (G = c[L]) == null ? void 0 : G.participant.individualParticipantIds) == null || q.forEach((Y) => B.push(Y)), B.some((Y) => !(T != null && T.length) || T.includes(Y)) ? B : [];
  }, y = { withMatchUps: I || l, withEvents: v || l, withDraws: S || l, withPotentialMatchUps: d, withRankingProfile: l, withScheduleItems: p, scheduleAnalysis: f, withTeamMatchUps: m, withStatistics: h, participantMap: c, withOpponents: g, withSeeding: U }, D = [], P = {}, w = [], R = {}, b = {}, E = {}, O = ({ eventType: L, scaleNames: B, participantId: G }) => {
    var q, Y, H, X, z;
    return (z = (X = (H = (Y = (q = c[G]) == null ? void 0 : q.participant) == null ? void 0 : Y.rankings) == null ? void 0 : H[L]) == null ? void 0 : X.find((Z) => B.includes(Z.scaleName))) == null ? void 0 : z.scaleValue;
  };
  for (let L of (n == null ? void 0 : n.events) || []) {
    if (t != null && t.eventIds && !t.eventIds.includes(L.eventId)) continue;
    let { drawDefinitions: B = [], extensions: G = [], eventType: q, eventName: Y, category: H, entries: X, eventId: z, gender: Z } = L, { flightProfile: te } = Ht({ event: L }), ne = (te == null ? void 0 : te.flights) ?? [], ee = _s({ event: L }).publishState;
    ee && (R[z] = ee);
    let K = (M = ee == null ? void 0 : ee.status) == null ? void 0 : M.publishedSeeding;
    if (v || U || l) {
      let $ = r ? Object.assign({}, ...QI(G ?? [])) : {};
      b[z] = { ...$, eventName: Y, eventType: q, category: H, eventId: z, gender: Z };
      let ae = [H == null ? void 0 : H.categoryName, H == null ? void 0 : H.ageCategoryCode].filter(Boolean);
      for (let oe of X) {
        let { participantId: ce } = oe;
        if (!ce || !c[ce]) continue;
        let se = O({ eventType: q, scaleNames: ae, participantId: ce }), Te, xe;
        if (U) {
          let rt = c[ce].participant;
          ({ seedAssignments: Te, seedValue: xe } = nB({ publishedSeeding: K, usePublishState: a, withSeeding: U, participant: rt, event: L }));
        }
        let me = (rt) => {
          var Bt, Ut;
          if ((Ut = (Bt = c[rt]) == null ? void 0 : Bt.events) != null && Ut[z]) return;
          let Ge = c[rt];
          aB({ convertExtensions: r, seedAssignments: Te, participant: Ge, withSeeding: U, seedValue: xe, eventId: z, ranking: se, entry: oe });
        };
        me(ce), (c[ce].participant.individualParticipantIds || []).forEach(me);
      }
    }
    let J = (N = R == null ? void 0 : R[z]) == null ? void 0 : N.publishedSeeding;
    if (S || l || U) {
      let $ = (oe) => oe ? Object.assign({}, ...oe.map(({ participantId: ce, seedValue: se, seedNumber: Te }) => ({ [ce]: { seedValue: se, seedNumber: Te } }))) : void 0, ae = Be([...B.map(Hu), ...ne.map(Hu)]);
      for (let oe of ae) {
        let ce = B.find((He) => He.drawId === oe), se = [H == null ? void 0 : H.categoryName, H == null ? void 0 : H.ageCategoryCode].filter(Boolean), { structures: Te = [], drawOrder: xe, drawName: me, drawType: rt } = ce ?? {}, Ge = ne == null ? void 0 : ne.find((He) => He.drawId === oe), Bt = (ce == null ? void 0 : ce.entries) || (Ge == null ? void 0 : Ge.drawEntries), Ut = Ge == null ? void 0 : Ge.flightNumber, Re = ((ce == null ? void 0 : ce.structures) || []).sort((He, Me) => Cs(He, Me)).map(({ structureId: He, structures: Me }) => [He, ...(Me || []).map(({ structureId: Ot }) => Ot)]).flat(1 / 0), De, ve, Ye, Ze, Nt = 0, Tt = Te.filter(({ stage: He, stageSequence: Me }) => He === Ie && Me === 1 || He === Pe).flatMap((He) => {
          let { positionAssignments: Me } = gt({ structure: He }), { seedAssignments: Ot, stageSequence: vr, stage: Dt } = He;
          return Dt === Ie ? (Nt = (Me == null ? void 0 : Me.length) ?? 0, Ye = Me, Ze = Ot) : vr === 1 && (De = Me, ve = Ot), Me;
        }).map(({ participantId: He }) => He).filter(Boolean), je = $(Ze), It = $(ve), Zt = ce ? Bt.filter(({ participantId: He }) => Tt.includes(He)) : Bt, _t = !a || (J == null ? void 0 : J.published) && (((C = J == null ? void 0 : J.drawIds) == null ? void 0 : C.length) === 0 || ((F = J == null ? void 0 : J.drawIds) == null ? void 0 : F.includes(oe)));
        for (let He of Zt) {
          if (!c[He.participantId]) continue;
          let { entryStatus: Me, entryStage: Ot, entryPosition: vr, participantId: Dt } = He, mr = O({ participantId: Dt, scaleNames: se, eventType: q }), qr = (Ee) => {
            var di, Wi, Q, pe, he;
            if (!c[Ee] || (di = c[Ee].draws) != null && di[oe]) return;
            let ir = U && _t, Oe = ir ? {} : void 0, ot = ir ? ((Wi = je == null ? void 0 : je[Dt]) == null ? void 0 : Wi.seedValue) || ((Q = je == null ? void 0 : je[Dt]) == null ? void 0 : Q.seedNumber) : void 0, Qt = ot ? je == null ? void 0 : je[Dt] : void 0, Br = ir ? ((pe = It == null ? void 0 : It[Dt]) == null ? void 0 : pe.seedValue) || ((he = It == null ? void 0 : It[Dt]) == null ? void 0 : he.seedNumber) : void 0, br = Br ? It == null ? void 0 : It[Dt] : void 0;
            Oe && ot && (Oe[Ie] = Qt), Oe && Br && (Oe[Pe] = br);
            let Hr = ot || Br;
            Hr && (c[Ee].participant.seedings[q] || (c[Ee].participant.seedings[q] = []), Qt && c[Ee].participant.seedings[q].push({ ...Qt, scaleName: oe }), br && c[Ee].participant.seedings[q].push({ ...br, scaleName: oe }), Oe && (c[Ee].events[z].seedAssignments || (c[Ee].events[z].seedAssignments = {}), Object.keys(Oe).forEach((ze) => c[Ee].events[z].seedAssignments[ze] = Oe[ze]))), (S || l) && (c[Ee].draws[oe] = ye({ seedAssignments: Oe, entryPosition: vr, entryStatus: Me, entryStage: Ot, seedValue: Hr, eventId: z, ranking: mr, drawId: oe }, !1, !1, !0));
          };
          [tn, Ho].includes(Me) || (qr(Dt), (x = c[Dt].participant.individualParticipantIds || []) == null || x.forEach(qr));
        }
        let er = ((ce == null ? void 0 : ce.structures) ?? []).reduce((He, Me) => (He.includes(Me.stage) || He.push(Me.stage), He), []), Mt = ((ce == null ? void 0 : ce.links) ?? []).length;
        E[oe] = { qualifyingPositionAssignments: De, qualifyingSeedAssignments: ve, mainPositionAssignments: Ye, qualifyingSeedingMap: It, mainSeedAssignments: Ze, orderedStructureIds: Re, mainSeedingMap: je, flightNumber: Ut, linksCount: Mt, drawOrder: xe, drawName: me, drawType: rt, drawSize: Nt, drawId: oe, stages: er };
      }
    }
    if (l || f || m || h || g || I || S) {
      let $ = !!f || d, ae = ((V = ma({ afterRecoveryTimes: !!f, policyDefinitions: i, tournamentRecord: n, inContext: !0, participantMap: c, contextFilters: o, matchUpFilters: s, contextProfile: u, nextMatchUps: $, event: L })) == null ? void 0 : V.matchUps) ?? [];
      for (let oe of ae) {
        let { finishingPositionRange: ce, potentialParticipants: se, tieMatchUps: Te = [], sides: xe = [], winningSide: me, matchUpType: rt, matchUpId: Ge, eventId: Bt, drawId: Ut, collectionId: Re, stageSequence: De, finishingRound: ve, matchUpStatus: Ye, roundPosition: Ze, roundNumber: Nt, structureId: Tt, schedule: je, score: It, stage: Zt } = oe;
        P[Ge] = oe;
        let _t = { finishingPositionRange: ce, finishingRound: ve, stageSequence: De, roundPosition: Ze, collectionId: Re, roundNumber: Nt, structureId: Tt, schedule: je, eventId: Bt, drawId: Ut, score: It, stage: Zt };
        fT({ ..._t, ...y, matchUpStatus: Ye, winningSide: me, matchUpType: rt, matchUpId: Ge, sides: xe });
        for (let er of Te) {
          let { winningSide: Mt, sides: He = [], matchUpId: Me, matchUpStatus: Ot, matchUpType: vr } = er;
          fT({ ..._t, ...y, winningSide: Mt, tieWinningSide: me, matchUpTieId: Ge, matchUpId: Me, sides: He, matchUpSides: xe, matchUpStatus: Ot, matchUpType: vr });
        }
        Array.isArray(se) && ($ || f || p) && ((k = se.flat().map(Ke).filter(Boolean)) == null || k.forEach((er) => {
          var Mt;
          (Mt = A(er)) == null || Mt.forEach((He) => {
            c[He] && (c[He].potentialMatchUps[Ge] = ye({ tournamentId: n == null ? void 0 : n.tournamentId, matchUpId: Ge, eventId: Bt, drawId: Ut }));
          }), (f || p) && IN({ potential: !0, participantMap: c, participantId: er, matchUpStatus: Ye, roundPosition: Ze, structureId: Tt, matchUpType: rt, roundNumber: Nt, matchUpId: Ge, schedule: je, drawId: Ut, score: It });
        }));
      }
      w.push(...ae);
    }
  }
  if (h || l || f) {
    let L = Object.values(c);
    for (let B of L) {
      let { wins: G, losses: q, [mt]: { wins: Y, losses: H }, [ft]: { wins: X, losses: z } } = B.counters, Z = (te, ne, ee) => {
        let K = ne + ee, J = ne, $ = K && J / K;
        B.statistics[te] = { denominator: K, numerator: J, statValue: $, statCode: te };
      };
      if (h && (Z(jl, G, q), Z(`${jl}.${mt}`, Y, H), Z(`${jl}.${ft}`, X, z)), l) {
        let te = (ne = []) => Math.abs(ne[0] - ne[1]);
        for (let ne of Object.keys(B.draws)) {
          let { orderedStructureIds: ee = [], flightNumber: K } = E[ne] || {};
          if (B.structureParticipation && ee.length) {
            let J, $ = 0, ae = ee.map((oe) => {
              let ce = B.structureParticipation[oe];
              if (!ce) return;
              J || (J = ce == null ? void 0 : ce.finishingPositionRange), te(J) > te(ce == null ? void 0 : ce.finishingPositionRange) && (J = ce == null ? void 0 : ce.finishingPositionRange);
              let se = ce.stage !== Pe;
              return se && ($ += 1), ye({ ...ce, participationOrder: se ? $ : void 0, flightNumber: K });
            }).filter(Boolean);
            B.draws[ne] && (B.draws[ne].finishingPositionRange = J, B.draws[ne].structureParticipation = ae);
          }
        }
      }
      if (f) {
        let te = $e(f) ? f.scheduledMinutesDifference : 0, ne = B.scheduleItems || [], ee = B.potentialMatchUps || {}, K = ne.reduce(($, ae) => {
          let { scheduledDate: oe, scheduledTime: ce } = ae;
          return $[oe] || ($[oe] = []), ce && $[oe].push(ae), $;
        }, {});
        Object.values(K).forEach(($) => $.sort(uR));
        for (let $ of ne) {
          let { typeChangeTimeAfterRecovery: ae, timeAfterRecovery: oe, scheduledDate: ce, scheduledTime: se } = $, Te = K[ce], xe = tt(se);
          for (let me of Te) {
            if (me.matchUpId === $.matchUpId || [ct, Je].includes(me.matchUpStatus) && !me.checkScoreHasValue) continue;
            let rt = $.matchUpType !== me.matchUpType && ae || oe, Ge = $.drawId === me.drawId, Bt = ee[$.matchUpId] && ee[me.matchUpId], Ut = tt(me.scheduledTime), Re = Math.abs(Ut - xe), De = Ut >= xe;
            if ((te && !isNaN(te) ? Re <= te : De && tt(me.scheduledTime) < tt(rt)) && !(Bt && Ge) && De) {
              let ve = [$.matchUpId, me.matchUpId].sort(Tm).join("|");
              B.scheduleConflicts[ve] = { priorScheduledMatchUpId: $.matchUpId, matchUpIdWithConflict: me.matchUpId };
            }
          }
        }
        let J = B.participant.participantId;
        Object.keys(B.scheduleConflicts).length && D.push(J), c[J].scheduleConflicts = B.scheduleConflicts;
      }
    }
  }
  return { participantIdsWithConflicts: D, eventsPublishStatuses: R, derivedEventInfo: b, derivedDrawInfo: E, mappedMatchUps: P, participantMap: c, matchUps: w };
}
function jd({ participantFilters: e = {}, tournamentRecord: t, participants: r = [] }) {
  var S;
  if (!Object.keys(e).length) return r;
  let { accessorValues: i, drawEntryStatuses: n, positionedParticipants: a, eventEntryStatuses: o, participantRoles: s, participantRoleResponsibilities: c, participantTypes: u, participantIds: d, signInStatus: l, enableOrFiltering: p, eventIds: f, genders: m } = e, h = Zn(f) && ((S = t == null ? void 0 : t.events) == null ? void 0 : S.filter((T) => f == null ? void 0 : f.includes(T.eventId))) || (t == null ? void 0 : t.events) || [], g = n && uB({ drawEntryStatuses: n, tournamentEvents: h }), I = o && dB({ eventEntryStatuses: o, tournamentEvents: h }), U = a !== void 0 && [!0, !1].includes(a) && h.reduce((T, A) => T.concat(...(A.drawDefinitions || []).map((y) => bb({ drawDefinition: y }).allPositionedParticipantIds).filter(Boolean)), []), v = (T) => i == null ? void 0 : i.reduce((A, y) => {
    let { accessor: D, value: P } = y, { values: w } = ns({ element: T, accessor: D });
    return A && (w == null ? void 0 : w.includes(P));
  }, !0);
  if (r = r == null ? void 0 : r.filter((T) => {
    var E, O;
    let A = (O = (E = en({ element: T, itemType: Td })) == null ? void 0 : E.timeItem) == null ? void 0 : O.itemValue, { participantRoleResponsibilities: y, participantType: D, participantRole: P, participantId: w, person: R } = T, b = Array.isArray(m) && (m == null ? void 0 : m.length) && (R == null ? void 0 : R.sex) && m.includes(R.sex);
    return p ? m && b || a && U.includes(w) || a === !1 && !U.includes(w) || (g == null ? void 0 : g.includes(w)) || (I == null ? void 0 : I.includes(w)) || (d == null ? void 0 : d.includes(w)) || l && A === l || u && D && Zn(u) && u.includes(D) || s && P && Zn(s) && s.includes(P) || c && Zn(y) && Zn(c) && c.find((M) => y == null ? void 0 : y.includes(M)) || (i == null ? void 0 : i.length) && Zn(i) && v(T) : (!m || b) && (a === void 0 || a && U.includes(w) || a === !1 && !U.includes(w)) && (!g || g.includes(w)) && (!I || I.includes(w)) && (!d || d.includes(w)) && (!l || A === l) && (!u || D && Zn(u) && u.includes(D)) && (!s || P && Zn(s) && s.includes(P)) && (!c || Zn(y) && Zn(c) && c.find((M) => y == null ? void 0 : y.includes(M))) && (!(i != null && i.length) || Zn(i) && v(T));
  }), h.length && f) {
    let T = h.filter((A) => f.includes(A.eventId)).map((A) => {
      let y = (A.entries || []).map((P) => P.participantId);
      if (Kt(jn)(A.eventType)) return y;
      let D = ((t == null ? void 0 : t.participants) ?? []).filter((P) => y.includes(P.participantId)).map((P) => P.individualParticipantIds).flat(1);
      return y.concat(...D);
    }).flat(1);
    r = r == null ? void 0 : r.filter((A) => T.includes(A.participantId));
  }
  return r;
}
function Zn(e) {
  return e && Array.isArray(e) && e.length;
}
function uB({ drawEntryStatuses: e, tournamentEvents: t }) {
  let r = ({ entryStatus: i }) => Array.isArray(e) ? e.includes(i) : !0;
  return Be(t.reduce((i, n) => {
    var c, u;
    let { flightProfile: a } = Ht({ event: n }), o = ((c = a == null ? void 0 : a.flights) == null ? void 0 : c.map(({ drawEntries: d }) => Array.isArray(d) ? d.filter(r).map(Ke) : []).flat()) || [], s = ((u = n.drawDefinitions) == null ? void 0 : u.map(({ entries: d }) => d ? d.filter(r).map(Ke) : [])) || [];
    return i.concat(...o, ...s);
  }, []));
}
function dB({ eventEntryStatuses: e, tournamentEvents: t }) {
  return Be(t.reduce((r, i) => {
    let n = (i.entries || []).filter(({ entryStatus: a }) => Array.isArray(e) ? e.includes(a) : !0).map(Ke);
    return r.concat(...n);
  }, []));
}
function Lt(e) {
  var Y;
  let { withIndividualParticipants: t, participantFilters: r = {}, withPotentialMatchUps: i, withRankingProfile: n, convertExtensions: a, policyDefinitions: o, withScheduleItems: s, tournamentRecord: c, scheduleAnalysis: u, withSignInStatus: d, withTeamMatchUps: l, withScaleValues: p, usePublishState: f, withStatistics: m, contextFilters: h, matchUpFilters: g, contextProfile: I, withOpponents: U, withMatchUps: v, internalUse: S, withSeeding: T, withEvents: A, withDraws: y, withISO2: D, withIOC: P } = e;
  if (!c) return { error: de };
  (v || n) && An({ tournamentRecord: c });
  let w = Gb({ convertExtensions: a, tournamentRecord: c, withSignInStatus: d, withScaleValues: p, internalUse: S, withISO2: D, withIOC: P }), { participantMap: R } = w, b = cB({ withMatchUps: v ?? n, withEvents: A ?? n, withDraws: y ?? n, withPotentialMatchUps: i, participantFilters: r, withRankingProfile: n, convertExtensions: a, withScheduleItems: s, policyDefinitions: o, tournamentRecord: c, scheduleAnalysis: u, withTeamMatchUps: l, usePublishState: f, withStatistics: m, contextFilters: h, matchUpFilters: g, participantMap: R, withOpponents: U, contextProfile: I, withSeeding: T }), { participantIdsWithConflicts: E, eventsPublishStatuses: O, derivedEventInfo: M, derivedDrawInfo: N, mappedMatchUps: C } = b, F = b.matchUps;
  R = b.participantMap;
  let x = u ?? i, V = ({ potentialMatchUps: H, scheduleConflicts: X, scheduleItems: z, participant: Z, statistics: te, opponents: ne, matchUps: ee, events: K, draws: J }) => {
    let $ = Object.values(J), ae = Object.values(ne);
    return U && ($ == null || $.forEach((oe) => {
      oe.opponents = ae.filter((ce) => ce.drawId === oe.drawId);
    })), ye({ ...Z, scheduleConflicts: u ? Object.values(X) : void 0, draws: y || n ? $ : void 0, events: A || n ? Object.values(K) : void 0, matchUps: v || n ? Object.values(ee) : void 0, opponents: U ? ae : void 0, potentialMatchUps: x ? Object.values(H) : void 0, statistics: m ? Object.values(te) : void 0, scheduleItems: s ? z : void 0 }, !1, !1, !0);
  }, k = /* @__PURE__ */ new Map();
  for (let H of Object.keys(R)) k.set(H, V(R[H]));
  let L = [...k.values()], B = (Y = o == null ? void 0 : o[vd]) == null ? void 0 : Y.participant, G = jd({ participants: L, participantFilters: r, tournamentRecord: c });
  if (t) {
    let H = $e(t) ? t : void 0;
    for (let X of G) for (let z of X.individualParticipantIds ?? []) {
      X.individualParticipants || (X.individualParticipants = []);
      let Z = k.get(z), te = H ? gs({ template: H, source: Z }) : Z;
      X.individualParticipants.push(te);
    }
  }
  let q = B ? G.map((H) => gs({ source: H, template: B })) : G;
  return { participantMap: e.returnParticipantMap !== !1 ? R : void 0, mappedMatchUps: e.returnMatchUps !== !1 ? C : void 0, matchUps: e.returnMatchUps !== !1 ? F : void 0, missingParticipantIds: w.missingParticipantIds, participantIdsWithConflicts: E, eventsPublishStatuses: O, derivedEventInfo: M, derivedDrawInfo: N, participants: q, ...j };
}
function as({ participantId: e, drawDefinition: t, entryStatus: r, entryStage: i }) {
  var a;
  if (!t) return { error: Ue };
  let n = (a = t.entries) == null ? void 0 : a.find((o) => o.participantId === e && (!r || r === o.entryStatus) && (!i || i === o.entryStage));
  return e && n;
}
function $c(e) {
  var f, m, h, g, I, U, v, S, T;
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, structureId: n, stage: a } = e;
  if (!r) return { error: Ue };
  let { entryProfile: o } = wd({ drawDefinition: r }), s = a && i && ((h = (m = (f = o == null ? void 0 : o[a]) == null ? void 0 : f.stageSequence) == null ? void 0 : m[i]) == null ? void 0 : h.qualifiersCount) || a && ((g = o == null ? void 0 : o[a]) == null ? void 0 : g.qualifiersCount) || 0, c = {};
  if (!n) return { qualifiersCount: s, roundQualifiersCounts: c };
  let { structure: u } = Ne({ drawDefinition: r, structureId: n }), d = (I = r.links) == null ? void 0 : I.filter((A) => {
    var y;
    return ((y = A == null ? void 0 : A.target) == null ? void 0 : y.structureId) === (u == null ? void 0 : u.structureId);
  }), l = 0;
  if (d != null && d.length) for (let A of d) {
    let y = (U = Ne({ structureId: A.source.structureId, drawDefinition: r })) == null ? void 0 : U.structure;
    if ((y == null ? void 0 : y.stage) === Pe) {
      let D = A.source.roundNumber, P = A.target.roundNumber, w = 0;
      if (y.structureType === ri) {
        let R = ((v = y.structures) == null ? void 0 : v.length) ?? 0, b = ((S = A.source.finishingPositions) == null ? void 0 : S.length) ?? 0;
        w = R * b;
      } else w = ((T = ut({ matchUpFilters: { roundNumbers: [D] }, structure: y, afterRecoveryTimes: !1, provisionalPositioning: t, inContext: !1 }).matchUps) == null ? void 0 : T.length) || 0;
      c[P] || (c[P] = 0), c[P] += w, l += w;
    }
  }
  let p = Object.keys(c);
  if (p.length <= 1) {
    let A = p[0] || 1;
    c[A] = Math.max(c[A] || 0, s);
  }
  return l = Math.max(l, s), { qualifiersCount: l, roundQualifiersCounts: c };
}
function Ip({ stage: e, drawDefinition: t }) {
  var i;
  let { entryProfile: r } = wd({ drawDefinition: t });
  return ((i = r == null ? void 0 : r[e]) == null ? void 0 : i.drawSize) || 0;
}
function lB(e) {
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n } = e, a = Ip({ stage: n, drawDefinition: r }), { qualifiersCount: o } = $c({ provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n });
  return a && a - o;
}
function vN({ stage: e, drawDefinition: t }) {
  return !!(e === yr || Wv({ stage: e, drawDefinition: t }) && Ip({ stage: e, drawDefinition: t }));
}
function UN({ entryStatus: e = Ii, drawDefinition: t, stageSequence: r, stage: i }) {
  if (e === fn) return ix({ stage: i, drawDefinition: t }) ? { positionsAvailable: 1 / 0, ...j } : { error: Dw };
  let n = lB({ drawDefinition: t, stageSequence: r, stage: i }), a = nx({ drawDefinition: t, stage: i }), o = Mg({ entryStatus: wc, drawDefinition: t, stage: i }), s = Mg({ entryStatus: Ii, drawDefinition: t, stage: i }), c = o + s, u = c >= n, d = n - c;
  return i !== yr && u ? { error: Ug } : e === wc ? o < a ? { ...j } : { error: Ug } : { positionsAvailable: d, ...j };
}
function eU(e) {
  let t = Ae(e, [{ [ii]: !0, [ib]: !0 }]);
  if (t.error) return t;
  let { suppressDuplicateEntries: r = !0, entryStatus: i = Ii, entryStageSequence: n, entryStage: a = Ie, ignoreStageSpace: o, drawDefinition: s, entryPosition: c, participant: u, roundTarget: d, extensions: l, extension: p, drawType: f, event: m } = e, h = "addDrawEntry";
  if (f !== Li && !vN({ stage: a, drawDefinition: s })) return W({ result: { error: Vo }, stack: h });
  let g = UN({ stageSequence: n, stage: a, drawDefinition: s, entryStatus: i });
  if (!o && !g.success && (!f || f !== Li)) return { error: g.error };
  if (p && !Wn({ extension: p })) return W({ result: { error: ie }, info: "Invalid extension", context: { extension: p }, stack: h });
  let I = e.participantId || (u == null ? void 0 : u.participantId);
  if (!I) return W({ result: { error: cr }, stack: h });
  let U = i === wa && as({ participantId: I, drawDefinition: s, entryStatus: i }), v = a === yr && as({ participantId: I, drawDefinition: s, entryStage: a }), S = as({ participantId: I, drawDefinition: s }), T = i !== wa && a !== yr && S;
  if (T) return r ? (Le({ payload: { drawId: s.drawId, eventId: m == null ? void 0 : m.eventId, error: Eu, participantId: I }, topic: Dv }), { ...j }) : W({ result: { error: Eu }, context: { participantId: I }, stack: h });
  if (U || v) return W({ context: { invalidEntry: T, invalidLuckyLoser: U, invalidVoluntaryConsolation: v }, result: { error: kf }, stack: h });
  let A = ye({ entryStageSequence: n, participantId: I, entryPosition: c, entryStatus: i, entryStage: a, extensions: l });
  return p && it({ element: A, extension: p }), d && it({ extension: { name: "roundEntry", value: d }, element: A }), s.entries || (s.entries = []), s.entries.push(A), vt({ drawDefinition: s }), { ...j };
}
function pB(e) {
  let t = "addDrawEntries", { suppressDuplicateEntries: r = !0, entryStatus: i = Ii, autoEntryPositions: n = !0, ignoreStageSpace: a, participantIds: o, drawDefinition: s, stageSequence: c, stage: u = Ie, roundTarget: d, extension: l, event: p } = e;
  if (!u) return { error: rw };
  if (!s) return { error: Ue };
  if (!Array.isArray(o)) return { error: Pi };
  if (!vN({ stage: u, drawDefinition: s })) return { error: Vo };
  if (l && !Wn({ extension: l })) return W({ result: { error: ie }, info: "Invalid extension", context: { extension: l }, stack: t });
  let f = UN({ drawDefinition: s, stageSequence: c, entryStatus: i, stage: u });
  if (!a && !f.success) return { error: f.error };
  let m = f.positionsAvailable ?? 0;
  if (!a && u !== yr && m < o.length) return { error: NI };
  let h = [], g = s.drawId, I = p == null ? void 0 : p.eventId, U = o.reduce((v, S) => {
    let T = i === wa && as({ participantId: S, drawDefinition: s, entryStatus: i }), A = u === yr && as({ entryStage: u, drawDefinition: s, participantId: S }), y = as({ participantId: S, drawDefinition: s });
    return i !== wa && u !== yr && y && (h.push(S), r && Le({ payload: { error: Eu, participantId: S, eventId: I, drawId: g }, topic: Dv })), T || A ? v.concat(S) : v;
  }, []);
  return h.length && !r ? W({ context: { eventId: I, drawId: g, duplicateEntries: h }, result: { error: Eu }, stack: t }) : (o.filter((v) => v && !U.includes(v)).forEach((v) => {
    let S = { entryStageSequence: c, entryStage: u, participantId: v, entryStatus: i };
    l && it({ element: S, extension: l }), d && it({ extension: { name: Kn, value: d }, element: S }), s.entries || (s.entries = []), s.entries.push(S);
  }), n && (s.entries = wn({ entries: s.entries })), vt({ drawDefinition: s }), U != null && U.length || h != null && h.length ? { info: "some participantIds could not be added", participantIdsNotAdded: U, duplicateEntries: h, ...j } : { ...j });
}
function tU({ suppressDuplicateEntries: e = !0, autoEntryPositions: t = !0, entryStageSequence: r, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, entryStage: c, extension: u, drawId: d, event: l }) {
  if (!(n != null && n.length)) return { error: ro };
  if (!l) return { error: Ki };
  if (!d) return { error: Cn };
  let p = (l.entries || []).map(Ke);
  if (n.filter((h) => !p.includes(h)).length) return { error: ew };
  if (a) {
    let h = pB({ stageSequence: r, suppressDuplicateEntries: e, autoEntryPositions: t, stage: c, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, extension: u });
    if (h.error) return h;
  }
  let { flightProfile: f } = Ht({ event: l }), m = f == null ? void 0 : f.flights.find((h) => h.drawId === d);
  return m != null && m.drawEntries && (n.forEach((h) => {
    let g = o === wa && zh({ participantId: h, entryStatus: o, flight: m }), I = c === yr && zh({ participantId: h, entryStage: c, flight: m });
    !(o !== wa && c !== yr && zh({ flight: m, participantId: h })) && !g && !I && m.drawEntries.push({ participantId: h, entryStatus: o, entryStage: c });
  }), t && (m.drawEntries = wn({ entries: m.drawEntries }))), { ...j };
}
function zh({ participantId: e, entryStatus: t, entryStage: r, flight: i }) {
  var a;
  let n = (a = i.drawEntries) == null ? void 0 : a.find((o) => o.participantId === e && (!t || t === o.entryStatus) && (!r || r === o.entryStage));
  return e && n;
}
function _d({ autoEntryPositions: e = !0, participantIds: t = [], entryStatuses: r, stage: i, event: n }) {
  var l, p, f, m;
  let a = "removeEventEntries";
  if (!(n != null && n.eventId)) return { error: At };
  if (!Array.isArray(t) || t.some((h) => !Et(h))) return W({ result: { error: bn }, stack: a });
  let o = (n.drawDefinitions ?? []).flatMap((h) => Ko({ drawDefinition: h }).assignedParticipantIds ?? []), s = ((r == null ? void 0 : r.length) && ((l = n.entries) == null ? void 0 : l.filter((h) => h.entryStatus && r.includes(h.entryStatus))) || []).map(Ke).filter((h) => !o.includes(h)), c = (i && ((p = n.entries) == null ? void 0 : p.filter((h) => h.entryStage && h.entryStage === i)) || []).map(Ke).filter((h) => !o.includes(h));
  if (t.length ? t = t.filter((h) => (!(r != null && r.length) || s.includes(h)) && (!i || c.includes(h))) : s.length && c.length ? t = qt(s, c) : s.length ? t = s : c.length && (t = c), (t == null ? void 0 : t.length) && o.some((h) => t.includes(h))) return W({ result: { error: jc }, stack: a });
  if (!(t != null && t.length)) return { ...j, participantIdsRemoved: [] };
  let u = [];
  n.entries = (n.entries ?? []).filter((h) => {
    let g = !t.includes(h == null ? void 0 : h.participantId);
    return g || u.push(h.participantId), g;
  }), e && (n.entries = wn({ entries: n.entries }));
  let { flightProfile: d } = Ht({ event: n });
  return (f = d == null ? void 0 : d.flights) == null || f.forEach((h) => {
    h.drawEntries = (h.drawEntries || []).filter((g) => !t.includes(g.participantId));
  }), (m = n.drawDefinitions) == null || m.forEach((h) => {
    h.entries = (h.entries ?? []).filter((g) => !t.includes(g.participantId));
  }), { ...j, participantIdsRemoved: u };
}
var SN = { [Ar]: { policyName: "matchUpActionsDefault", enabledStructures: [{ stages: [], stageSequences: [], enabledActions: [], disabledActions: [] }], participants: { enforceCategory: !0, enforceGender: !0 }, processCodes: { substitution: ["RANKING.IGNORE", "RATING.IGNORE"] }, substituteAfterCompleted: !1, substituteWithoutScore: !1 } }, eu = SN;
function Bn(e) {
  var M, N;
  let { suppressDuplicateEntries: t = !0, entryStatus: r = Ii, autoEntryPositions: i = !0, enforceGender: n = !0, entryStageSequence: a, policyDefinitions: o, entryStage: s = Ie, tournamentRecord: c, ignoreStageSpace: u, drawDefinition: d, roundTarget: l, extensions: p, extension: f, drawId: m, event: h } = e, g = "addEventEntries";
  if (!Array.isArray(e.participantIds)) return W({ result: { error: Pi }, stack: g });
  let I = Be(e.participantIds ?? []);
  if (!h) return { error: At };
  if (!(I != null && I.length)) return W({ result: { error: ro }, stack: g });
  if (!(h != null && h.eventId)) return { error: Ki };
  let U = nt({ tournamentRecord: c, event: h }).appliedPolicies ?? {}, v = (o == null ? void 0 : o[Ar]) ?? (U == null ? void 0 : U[Ar]) ?? eu[Ar], S = (n ?? ((M = v == null ? void 0 : v.participants) == null ? void 0 : M.enforceGender)) !== !1, T = [], A = [];
  if (p && (!Array.isArray(p) || !p.every((C) => Wn({ extension: C }))) || f && !Wn({ extension: f })) return W({ context: ye({ extension: f, extensions: p }), result: { error: ie }, info: "Invalid extension(s)", stack: g });
  let y = !!c, D = [], P, w = ((N = c == null ? void 0 : c.participants) == null ? void 0 : N.filter((C) => {
    var V, k, L;
    if (!I.includes(C.participantId)) return !1;
    let F = Kt(mt)(h.eventType) && C.participantType === Xe && !Io(r), x = h.eventType === ft && C.participantType === _e;
    return F && (!h.gender || !S || [ni, Mn].includes(h.gender) || h.gender === ((V = C.person) == null ? void 0 : V.sex)) || x && !Io(r) || h.eventType === ft && C.participantType === Xe && Io(r) ? !0 : F && h.gender && S && ![ni, Mn].includes(h.gender) && h.gender !== ((k = C.person) == null ? void 0 : k.sex) ? (D.push({ participantId: C.participantId, sex: (L = C.person) == null ? void 0 : L.sex }), !1) : h.eventType === lt && (C.participantType === lt || Io(r) && C.participantType === Xe);
  }).map((C) => C.participantId)) ?? [], R = I.filter((C) => !y || w.includes(C));
  h.entries || (h.entries = []);
  let b = h.entries.map((C) => {
    var F;
    return C.participantId || ((F = C.participant) == null ? void 0 : F.participantId);
  });
  if (R.forEach((C) => {
    var F;
    if (!b.includes(C)) {
      let x = ye({ participantId: C, entryStatus: r, entryStage: s, extensions: p });
      f && it({ element: x, extension: f }), l && it({ extension: { name: Kn, value: l }, element: x }), a && (x.entryStageSequence = a), T.push(x.participantId), (F = h.entries) == null || F.push(x);
    }
  }), m && !Io(s)) {
    let C = tU({ participantIds: R, suppressDuplicateEntries: t, autoEntryPositions: i, entryStageSequence: a, ignoreStageSpace: u, drawDefinition: d, entryStatus: r, roundTarget: l, entryStage: s, extension: f, drawId: m, event: h });
    C.error && (P = C.error);
  }
  if (h.eventType && [ya, bi].includes(h.eventType)) {
    let C = (h.entries || []).map((k) => k.participantId), F = (h.entries || []).filter((k) => Io(k.entryStatus)).map((k) => k.participantId), x = ((c == null ? void 0 : c.participants) ?? []).filter((k) => C.includes(k.participantId) && k.participantType && [_e, lt].includes(k.participantType)).map((k) => k.individualParticipantIds).flat(1 / 0), V = F.filter((k) => x.includes(k));
    V.length && (A.push(...V), _d({ participantIds: V, autoEntryPositions: !1, event: h }));
  }
  if (R.length !== I.length) return W({ context: { mismatchedGender: D, gender: h.gender }, result: { error: Pi }, stack: g });
  i && (h.entries = wn({ entries: h.entries || [] }));
  let E = T.length, O = A.length;
  return W({ result: { ...j, addedEntriesCount: E, removedEntriesCount: O }, stack: g, info: P });
}
var yN = "ADMINISTRATION", fB = "CAPTAIN", mB = "COACH", Cr = "COMPETITOR", AN = "MEDIA", TN = "MEDICAL", rU = "OFFICIAL", DN = "OTHER", PN = "SECURITY", iU = { ADMINISTRATION: yN, CAPTAIN: fB, COACH: mB, COMPETITOR: Cr, MEDIA: AN, MEDICAL: TN, OFFICIAL: rU, OTHER: DN, SECURITY: PN };
function nU({ addIndividualParticipantsToEvents: e, individualParticipantIds: t, groupingParticipantId: r, tournamentRecord: i, suppressErrors: n }) {
  let a = "removeIndividualParticipantIds";
  if (!i) return W({ result: { error: de }, stack: a });
  if (!r || !t) return W({ result: { error: we }, stack: a });
  let o = (i.participants ?? []).find((d) => d.participantId === r);
  if (!o) return W({ result: { error: Yt }, stack: a });
  if (![lt, Gi].includes(o.participantType)) return W({ result: { participantType: o.participantType, error: Nn }, stack: a });
  let s = wN({ individualParticipantIds: t, groupingParticipant: o, tournamentRecord: i, suppressErrors: n }), { removed: c, error: u } = s;
  if (u) return W({ result: s, stack: a });
  if (e) for (let d of i.events ?? []) {
    let l = (d.entries ?? []).map(({ participantId: p }) => p).filter(Boolean);
    if (l.includes(r)) {
      let p = c == null ? void 0 : c.filter((f) => !l.includes(f));
      Bn({ participantIds: p, entryStatus: tn, tournamentRecord: i, event: d });
    }
  }
  return c && Le({ topic: Lr, payload: { tournamentId: i.tournamentId, participants: [o] } }), { ...j, ...s };
}
function wN({ individualParticipantIds: e = [], groupingParticipant: t, tournamentRecord: r, suppressErrors: i, mappedMatchUps: n, participants: a }) {
  var p, f;
  let o = [];
  if (!t) return { removed: o };
  let s = [], c = [];
  a || ({ participants: a, mappedMatchUps: n } = Lt({ withMatchUps: !0, tournamentRecord: r, withEvents: !0 }));
  let u = (f = (p = a == null ? void 0 : a.find(({ participantId: m }) => m === t.participantId)) == null ? void 0 : p.events) == null ? void 0 : f.map(({ eventId: m }) => m), d = (t.individualParticipantIds ?? []).filter((m) => {
    var U;
    let h = e == null ? void 0 : e.includes(m), g = h && ((U = a == null ? void 0 : a.find((v) => v.participantId === m)) == null ? void 0 : U.matchUps.filter(({ eventId: v }) => u.includes(v)).map(({ matchUpId: v }) => n == null ? void 0 : n[v]).filter(({ winningSide: v, score: S }) => v || pr({ score: S }))), I = h && !(g != null && g.length);
    if (h && !I && c.push(m), I) {
      o.push(m);
      for (let v of r.events ?? []) for (let S of v.drawDefinitions ?? []) {
        let { extension: T } = We({ element: S, name: Da }), A = T == null ? void 0 : T.value[t.participantId];
        T && A && (T.value[t.participantId] = A.filter((D) => D.participantId !== m), it({ element: S, extension: T }), Ad({ drawDefinition: S }));
        let y = Qr({ drawDefinition: S, inContext: !1 }).matchUps ?? [];
        for (let D of y) {
          let P = D.sides ?? [];
          for (let w of P) {
            let R = w.lineUp ?? [];
            R.find((b) => b.participantId === m) && (w.lineUp = R.filter((b) => b.participantId !== m), Qe({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: S, matchUp: D }));
          }
        }
      }
    } else s.push(m);
    return !I;
  });
  t.individualParticipantIds = d;
  let l = { groupingParticipantId: t.participantId, cannotRemove: c, notRemoved: s, removed: o };
  return c.length && !i && { ...l, cannotRemove: c, error: Cf } || l;
}
function Dm({ participantRole: e = Cr, individualParticipantIds: t = [], groupingTypes: r = [ai, Gi], tournamentRecord: i }) {
  if (!i) return { error: de };
  let n = i.participants ?? [], { participants: a, mappedMatchUps: o } = Lt({ withMatchUps: !0, tournamentRecord: i, withEvents: !0 }), s = 0;
  return n.filter((c) => (c.participantRole === e || !c.participantRole) && c.participantType && r.includes(c.participantType)).forEach((c) => {
    let { removed: u } = wN({ groupingParticipant: c, individualParticipantIds: t, tournamentRecord: i, mappedMatchUps: o, participants: a });
    u && s++;
  }), s ? j : { error: Uw };
}
function Ws(e) {
  var m, h;
  let t = Ae(e, [{ [fr]: !0 }, { participantIds: !0, [ui]: Gr, [pn]: ro }]);
  if (t.error) return t;
  let { addIndividualParticipantsToEvents: r, tournamentRecord: i, participantIds: n } = e, a = ((m = i.participants) == null ? void 0 : m.length) || 0;
  if (!a) return { ...j };
  let o = (h = i.events || []) == null ? void 0 : h.filter(({ eventType: g }) => g === or).map((g) => {
    var I;
    return (I = g == null ? void 0 : g.drawDefinitions) == null ? void 0 : I.map(({ drawId: U }) => U);
  }).flat(1 / 0), s = Lt({ participantFilters: { participantIds: n }, tournamentRecord: i, withDraws: !0 }).participants ?? [], c = (g) => {
    let I = (Pr({ matchUpFilters: { drawIds: g, matchUpTypes: [ft] }, tournamentRecord: i }).matchUps ?? []).flatMap(({ sides: U }) => U == null ? void 0 : U.map(({ participantId: v }) => v || [])).filter(Boolean);
    return qt(I, n);
  }, u = o != null && o.length ? c(o) : [], d = s.filter((g) => {
    var I;
    return (I = g.draws) == null ? void 0 : I.filter((U) => (!(o != null && o.length) || !(o != null && o.includes(U.drawId))) && U.positionAssignments).length;
  });
  if (u != null && u.length || d.length) return { error: jc };
  let l = {}, p = {};
  for (let g of i.events || []) {
    let I = _d({ participantIds: n, event: g });
    if (I.error) return I;
    l[g.eventId] = I.participantIdsRemoved;
  }
  i.participants = (i.participants ?? []).filter((g) => {
    var U, v;
    let I = n.includes(g.participantId) || g.participantType === _e && ((U = g.individualParticipantIds) == null ? void 0 : U.some((S) => n.includes(S)));
    if (!I && g.participantType === or && ((v = g.individualParticipantIds) != null && v.some((S) => n.includes(S))) && (g.individualParticipantIds = g.individualParticipantIds.filter((S) => !n.includes(S))), I && r && g.participantType && [_e, lt].includes(g.participantType)) for (let S of g.individualParticipantIds || []) n.includes(S) || (p[g.participantId] || (p[g.participantId] = []), p[g.participantId].push(S));
    return !I;
  });
  let f = a - i.participants.length;
  if (Dm({ individualParticipantIds: n, tournamentRecord: i }), r) for (let g of i.events || []) {
    let I = l[g.eventId].map((U) => p[U] || []).flat();
    Bn({ participantIds: I, entryStatus: tn, tournamentRecord: i, event: g });
  }
  return f && Le({ payload: { participantIds: n, tournamentId: i.tournamentId }, topic: Pv }), f ? { ...j, participantsRemovedCount: f } : { error: Cf };
}
function RN({ selected: e = !0, drawDefinition: t, entryStatuses: r, drawId: i, event: n, stage: a }) {
  var c;
  let o = n.entries ?? [];
  if (i) {
    let { flightProfile: u } = Ht({ event: n }), d = (c = u == null ? void 0 : u.flights) == null ? void 0 : c.find((l) => l.drawId === i);
    d ? o = d.drawEntries : t.entries && (o = t == null ? void 0 : t.entries);
  }
  let s = o.filter((u) => (!(r != null && r.length) || !u.entryStatus || r.includes(u.entryStatus)) && (!a || !u.entryStage || u.entryStage === a) && (!e || u.entryStatus && yn.includes(u.entryStatus)));
  return { entries: o, stageEntries: s };
}
function bN({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, stage: a, event: o }) {
  var I;
  let s = "destroyGroupEntry";
  if (!t) return { error: de };
  if (!i) return W({ result: { error: cr }, stack: s });
  if (!o) return { error: At };
  if (!o.eventType || ![ya, bi].includes(o.eventType)) return W({ result: { error: na }, stack: s });
  let c = t.participants ?? [], u = c.find((U) => U.participantId === i);
  if (!u) return W({ result: { error: Yt }, stack: s });
  if (!u.participantType || ![_e, ai].includes(u.participantType) || u.participantType === ai && o.eventType !== bi || u.participantType === _e && o.eventType !== ya) return { error: Nn };
  let d = (o.entries ?? []).find((U) => U.participantId === i);
  if (!d) return { error: Tw };
  let { stageEntries: l } = RN({ selected: !1, drawDefinition: r, drawId: n, event: o, stage: a }), p = l.map(Ke), f = c.filter(({ participantId: U }) => p.includes(U)).map(({ individualParticipantIds: U }) => U).flat().filter(Boolean), m = (I = u.individualParticipantIds) == null ? void 0 : I.filter((U) => Ln(U, f).length === 1), h = _d({ participantIds: [i], event: o });
  if (h.error || m != null && m.length && (h = Bn({ participantIds: m, entryStatus: tn, entryStage: d.entryStage, tournamentRecord: t, drawDefinition: r, drawId: n, event: o }), h.error)) return h;
  let g;
  return e && Ws({ participantIds: [i], tournamentRecord: t }).success && (g = !0), { ...j, participantRemoved: g };
}
function aU({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a }) {
  return bN({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a });
}
function NN(e) {
  if (!e.tournamentRecord) return { error: de };
  let { participantIds: t, ...r } = e, i = 0, n = [];
  for (let a of t) {
    let o = bN({ participantId: a, ...r });
    o.success && (i += 1), o.error && n.push(o.error);
  }
  return i ? { destroyedCount: i, ...j } : { error: n };
}
function Xu(e) {
  let { tournamentRecord: t, replaceWithBye: r, drawDefinition: i, destroyPair: n, entryStatus: a, matchUpsMap: o, drawId: s } = e, c = "removeDrawPositionAssignment", u = Vd(e);
  if (u.error) return W({ result: u, stack: c });
  let { participantId: d } = u, { drawPosition: l, event: p, structureId: f } = e, m = nt({ tournamentRecord: t, drawDefinition: i, event: p }).appliedPolicies ?? {};
  if ([fn, Ra].includes(a) && d) {
    let { tournamentRecord: g } = e, { participant: I } = co({ tournamentRecord: g, participantId: d }), { participantType: U, individualParticipantIds: v } = I ?? {};
    if (n && U === _e) {
      let S = aU({ tournamentRecord: g, drawDefinition: i, participantId: d, event: p });
      if (S.error) return W({ result: S, stack: c });
      v && gp({ participantIds: v, tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: p });
    } else gp({ participantIds: [d], tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: p });
  }
  if (r) {
    let g = _i({ tournamentRecord: t, drawDefinition: i, drawPosition: l, structureId: f, matchUpsMap: o, event: p });
    if (g.error) return W({ result: g, stack: c });
  }
  let { structure: h } = Ne({ drawDefinition: i, structureId: f });
  return Lv({ structure: h, drawPositions: [l] }), lm({ appliedPolicies: m, drawDefinition: i, positionAction: { name: "removeDrawPositionAssignment", replaceWithBye: r, drawPosition: l, entryStatus: a, structureId: f } }), u;
}
function MN(e) {
  return Object.assign(e, { entryStatus: Ra }), Xu(e);
}
function xg(e) {
  return Et(e) ? e.split(" ").map((t) => t.split("").map((r, i) => i ? r.toLowerCase() : r.toUpperCase()).join("")).join(" ") : e;
}
function Fr(e) {
  return Et(e) ? xg(e.replace(/_/g, " ")) : "";
}
var Ha = ({ finishingPosition: e = Es, qualifyingRoundNumber: t, structureAbbreviation: r, seedAssignments: i = [], stageSequence: n = 1, structureOrder: a, seedingProfile: o, matchUpFormat: s, structureType: c, structureName: u, matchUpType: d, matchUps: l = [], structureId: p, roundOffset: f, roundLimit: m, stageOrder: h, structures: g, stage: I }) => {
  let U = { structureId: p ?? st(), structureAbbreviation: r, finishingPosition: e, seedAssignments: i, matchUpFormat: s, stageSequence: n, structureName: u };
  a && (U.structureOrder = a), c && (U.structureType = c), o && (typeof o == "string" ? U.seedingProfile = o : typeof o == "object" && typeof o.positioning == "string" && (U.seedingProfile = o.positioning)), d && (U.matchUpType = d), f && (U.roundOffset = f), h && (U.stageOrder = h), m && (U.roundLimit = m), I && (U.stage = I), t && (U.qualifyingRoundNumber = t);
  let v = l.flatMap(({ drawPositions: S }) => S).filter(Boolean);
  return g ? U.structures = g : (U.matchUps = l, U.positionAssignments = Be(v).sort((S, T) => S - T).map((S) => ({ drawPosition: S }))), U;
}, zi = Ha;
function oU({ structureName: e = Fr(yr), structureAbbreviation: t, drawDefinition: r, matchUpType: i, structureId: n }) {
  if (!r) return { error: Ue };
  let a = zi({ stage: yr, structureAbbreviation: t, structureName: e, matchUps: [], structureId: n, matchUpType: i });
  return r.structures || (r.structures = []), r.structures.push(a), vt({ drawDefinition: r, structureIds: [a.structureId] }), { ...j };
}
function sU({ drawPositions: e }) {
  if (!(e != null && e.length)) return { error: ad };
  let t = (n) => e.filter((a) => a !== n).map((a) => [n, a]), r = [].concat(...(e ?? []).map(t)), i = Be(r.map(Pm)).map((n) => n.split("|").map((a) => +a));
  return { groupMatchUps: r, uniqueMatchUpGroupings: i };
}
function Pm(e = []) {
  return !Array.isArray(e) || !e.length ? "" : [...e].sort(ar).join("|");
}
function EN({ groupSize: e, drawPositionOffset: t }) {
  if (!e) return [];
  let r = (l) => [...Array(l)].map((p, f) => f), i = r(2 * Math.round(e / 2) + 1).slice(1), n = r(i.length - 1).map(() => []), a = i.slice(0, i.length / 2), o = i.slice(i.length / 2);
  i.slice(1).forEach((l, p) => {
    a.forEach((g, I) => {
      n[p].push([a[I], o[I]]);
    });
    let f = a.shift(), m = a.pop(), h = o.shift();
    a = [f, h, ...a].filter(Boolean), o = [...o, m].filter(Boolean);
  });
  let s = a.shift(), c = a.pop(), u = o.shift();
  a = [s, u, ...a].filter(Boolean), o = [...o, c].filter(Boolean);
  let d = (l) => l[0].reduce((p, f) => p + f);
  return [...n].reverse().sort((l, p) => d(l) - d(p)).map((l) => l.filter((p) => p.every((f) => f <= e)).map((p) => {
    let f = p.map((m) => m + t);
    return Pm(f);
  }));
}
function hB({ rounds: e, hash: t }) {
  return e != null && e.length ? e == null ? void 0 : e.reduce((r, i, n) => i.includes(t) ? n + 1 : r, void 0) : { error: we };
}
var gB = { getRoundRobinGroupMatchUps: sU, determineRoundNumber: hB, drawPositionsHash: Pm, groupRounds: EN };
function Wd(e) {
  var y;
  let { groupNameBase: t = "Group", playoffAttributes: r, stageSequence: i = 1, structureOptions: n, appliedPolicies: a, seedingProfile: o, stage: s = Ie, matchUpType: c, roundTarget: u, structureId: d, groupNames: l, drawSize: p, idPrefix: f, isMock: m, uuids: h } = e, g = e.structureName ?? ((y = r == null ? void 0 : r["0"]) == null ? void 0 : y.name) ?? Fr(Ie), { groupCount: I, groupSize: U } = IB({ structureOptions: n, appliedPolicies: a, drawSize: p }), v = wo, S, T = fe(1, I + 1).map((D) => {
    let P = vB({ groupSize: U, structureOrder: D, matchUpType: c, drawSize: p, idPrefix: f, isMock: m });
    S = Array.isArray(P) ? Math.max(...P.map(({ roundNumber: R }) => R ?? 0)) : 0;
    let w = (l == null ? void 0 : l[D - 1]) ?? `${t} ${D}`;
    return Ha({ structureId: h == null ? void 0 : h.pop(), structureType: Kf, finishingPosition: v, structureOrder: D, structureName: w, matchUps: P });
  }), A = Ha({ structureId: d ?? (h == null ? void 0 : h.pop()), structureType: ri, finishingPosition: v, seedingProfile: o, structureName: g, stageSequence: i, structures: T, stage: s });
  return u && it({ extension: { name: Kn, value: u }, element: A }), { structures: [A], maxRoundNumber: S, groupCount: I, links: [], groupSize: U, ...j };
}
function IB({ appliedPolicies: e, structureOptions: t, drawSize: r }) {
  let i = t == null ? void 0 : t.groupSize, n = (t == null ? void 0 : t.groupSizeLimit) || 8, { validGroupSizes: a } = qd({ groupSizeLimit: n, drawSize: r }), o = a && Math.max(...a);
  i && (a != null && a.includes(i)) || (i && i > 4 || !(a != null && a.includes(4)) ? i = o : i = 4);
  let s = Math.ceil(r / i);
  return { groupSize: i, groupCount: s };
}
function qd(e) {
  let { groupSizeLimit: t = 10, drawSize: r = 0 } = e ?? {}, i = fe(3, t + 1).filter((n) => {
    let a = Math.ceil(r / n), o = a * n - r, s = Math.ceil(r / a), c = Math.ceil(o / a);
    return (!o || o < n) && s === n && s >= 3 && c < 2;
  });
  return { ...j, validGroupSizes: i };
}
function vB({ structureOrder: e, matchUpType: t, groupSize: r, drawSize: i, idPrefix: n, isMock: a, uuids: o }) {
  let s = (e - 1) * r, c = fe(1 + s, r + 1 + s), u = sU({ drawPositions: c }).uniqueMatchUpGroupings ?? [], d = EN({ groupSize: r, drawPositionOffset: s });
  return u.map(p).sort((f, m) => (f.roundNumber ?? 1 / 0) - (m.roundNumber ?? 1 / 0));
  function l(f) {
    return d.reduce((m, h, g) => h.includes(f) ? g + 1 : m, void 0);
  }
  function p(f) {
    let m = Pm(f), h = l(m), g = [1, i], I = UB({ structureOrder: e, drawPositions: f, roundNumber: h, idPrefix: n, uuids: o }), U = { matchUpStatus: h ? Xt : at, matchUpType: t, finishingPositionRange: { winner: g, loser: g }, drawPositions: f, roundNumber: h, matchUpId: I };
    return a && (U.isMock = !0), U;
  }
}
function UB({ structureOrder: e, drawPositions: t, roundNumber: r, idPrefix: i, uuids: n }) {
  return i ? `${i}-${e}-${r}-DP-${t.join("-")}` : (n == null ? void 0 : n.pop()) || st();
}
function cU(e) {
  let { roundRobinGroupsCount: t, participantsCount: r, cluster: i } = e;
  if (!ke(r)) return { seedBlocks: void 0, ...W({ result: { error: ie }, context: { participantsCount: r }, stack: "getSeedBlocks" }) };
  let n = Lc(r);
  if (t) {
    let f = Math.min(t, n), m = [], h = 1;
    for (fe(0, f).forEach(() => {
      m.push([h]), h++;
    }); h < n; ) {
      let g = fe(h, h + f);
      h += f, m.push(g);
    }
    return { ...j, seedBlocks: m };
  }
  let a = fe(1, n + 1), o = [], s = n / 2;
  for (; s > 1; ) {
    let f = gr(a, s), m = f.length;
    f.forEach((h, g) => {
      let I, U = g < m / 2, v = g % 2 === 0, S = h[0], T = h[h.length - 1];
      i && m > 4 ? m === 8 ? I = U ? T : S : I = v ? S : T : I = U ? S : T, Jr(h, o) || o.push(I);
    }), s = s / 2;
  }
  let c = a.filter((f) => !o.includes(f));
  for (; c.length; ) c.length % 2 === 0 ? o.push(c.pop()) : o.push(c.shift());
  let u = fe(0, 20).map((f) => Math.pow(2, f));
  u.unshift(1);
  let d = u.indexOf(n), l = 0, p = [];
  return fe(0, d).forEach((f) => {
    p.push(o.slice(l, l + u[f])), l += u[f];
  }), { ...j, seedBlocks: p };
}
function uU({ roundRobinGroupsCount: e, drawSize: t }) {
  let r = "getSeedGroups";
  if (!ke(t)) return { seedGroups: void 0, ...W({ result: { error: ie }, context: { drawSize: t }, stack: r }) };
  if (e) {
    if (!ke(e)) return { seedGroups: void 0, ...W({ context: { roundRobinGroupsCount: e }, result: { error: ie }, stack: r }) };
    let i = 1, n = Math.floor(t / e);
    return { seedGroups: fe(0, n).map(() => {
      let a = fe(i, i + e);
      return i += e, a;
    }) };
  } else {
    let { seedBlocks: i } = cU({ participantsCount: t, roundRobinGroupsCount: e }), n = 0;
    return { seedGroups: (i || []).map((a) => (a || []).map(() => (n += 1, n))) };
  }
}
function dU({ roundRobinGroupsCount: e, participantsCount: t }) {
  var n;
  if (e) {
    let { validGroupSizes: a } = qd({ drawSize: t });
    if (!((n = a == null ? void 0 : a.map((o) => Math.ceil(t / o))) != null && n.includes(e))) return W({ context: { roundRobinGroupsCount: e }, result: { error: ie } });
  }
  let { seedGroups: r } = uU({ drawSize: t, roundRobinGroupsCount: e }), i = (r == null ? void 0 : r.map((a) => Math.min(...a))) || [];
  return { ...j, seedingThresholds: i };
}
function bc(e) {
  if (!e) return 1 / 0;
  if (ke(e)) return be(e);
  let t = e.split("-")[0];
  return ke(t) ? be(t) : 1 / 0;
}
function SB({ size: e }) {
  let t = [e], r = e;
  for (; r / 2 === Math.floor(r / 2); ) r = r / 2, t.push(r);
  return t.includes(1) || t.push(1), t.sort(ar), t.reverse(), t;
}
function yB({ blockPattern: e, index: t }) {
  let r = 0;
  for (let i of e) {
    if (r === t) return i;
    let n = 0;
    for (; n < i.length; ) {
      if (r === t) return i;
      r += 1, n++;
    }
  }
}
function AB({ positioning: e, size: t }) {
  let r = SB({ size: t }), i = [], n = [], a = (p) => p[0], o = (p) => p[p.length - 1], s = (p, f) => (e && [JI, Do].includes(e) && f % 2 ? o(p) : a(p)) || a(p), c = (p, f) => {
    if (p.every((m) => !n.includes(m))) {
      let m = s(p, f);
      return n.push(m), m;
    }
  }, u = (p) => {
    let f = p.filter((m) => !n.includes(m));
    if (f.length) return n.push(...f), f;
  }, d = (p, f) => {
    let m = s(p, f);
    if (!n.includes(m)) return n.push(m), m;
  }, l = fe(1, t + 1);
  for (let p of r) if (p === 1) {
    let f = gr(l, 2), m = f.map(c).filter(Boolean);
    m.length && i.push(m);
    let h = f.flatMap(u).filter(Boolean);
    h.length && i.push(h);
  } else {
    let f = gr(l, p).map(d).filter(Boolean);
    f.length && i.push(f);
  }
  return { divisions: r, divisionGroupings: i };
}
function qs({ provisionalPositioning: e, returnAllProxies: t, appliedPolicies: r, seedingProfile: i, drawDefinition: n, allPositions: a, structure: o }) {
  var N;
  let s = [];
  if (!o) return { error: Bo };
  let { matchUps: c, roundMatchUps: u } = ut({ matchUpFilters: { roundNumbers: [1] }, provisionalPositioning: e, structure: o }), { seedAssignments: d } = Qi({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: n, structure: o }), { positionAssignments: l } = Ir({ structure: o }), p = l == null ? void 0 : l.length, f = (d == null ? void 0 : d.length) ?? 0, m = [], h = Object.keys(u).map((C) => parseInt(C)).sort((C, F) => C - F).map((C) => {
    let F = u[C].map((V) => V.drawPositions).flat(1 / 0).filter(Boolean), x = F.filter((V) => !m.includes(V));
    return m = m.concat(...F), x;
  }).filter((C) => C.length).reverse(), g = h.pop() ?? [], I = g && Math.min(...g) - 1 || 0;
  i = i ?? ((N = r == null ? void 0 : r.seeding) == null ? void 0 : N.seedingProfile);
  let U = (g == null ? void 0 : g.length) || 0, v = h.filter((C) => C.filter((F) => F <= f).length), { stage: S, structureType: T, roundLimit: A } = o, y = T === ri, D = !y && (h == null ? void 0 : h.length), P = !y && S === Pe && A, w = v.flat(1 / 0), R = D ? w == null ? void 0 : w.length : 0, b = a ? p : f, E = qv({ drawDefinition: n, structure: o, matchUps: c }), O = E ? 0 : !D && b || b && w.length < b && b - w.length || 0;
  if (P) {
    let C = o != null && o.matchUps ? o.matchUps.filter(({ roundNumber: x }) => x === o.roundLimit).length : 0, F = g.length / C;
    if (!D) {
      let x = Hd(i), V = gr(g, F), k = 1, L = fe(0, V[0].length).map(() => {
        let B = fe(k, k + V.length);
        return k += V.length, B;
      });
      ({ validSeedBlocks: s } = ON({ drawPositionBlocks: V, nonRandom: i == null ? void 0 : i.nonRandom, positioning: x, seedGroups: L }));
    }
  } else y ? { validSeedBlocks: s } = TB({ nonRandom: i == null ? void 0 : i.nonRandom, seedingProfile: i, structure: o }) : D ? s = v.map((C) => ({ seedNumbers: C, drawPositions: C })) : E && gr(g, 2).map((C, F) => ({ drawPositions: [C[0]], seedNumbers: [F + 1] })).forEach((C) => s.push(C));
  if (!y && !E && !P) {
    let { blocks: C } = DB({ drawPositionOffset: I, seedNumberOffset: R, seedCountGoal: O, seedingProfile: i, baseDrawSize: U });
    C.forEach((F) => s.push(F));
  }
  let M = s.flatMap((C) => C.drawPositions).reduce((C, F) => (g == null ? void 0 : g.includes(F)) && C, !0);
  return !E && !D && !y && !M ? { error: ZP, validSeedBlocks: [], isContainer: y, isFeedIn: D } : { isLuckyStructure: E, validSeedBlocks: s, isContainer: y, isFeedIn: D };
}
function TB({ seedingProfile: e, structure: t, nonRandom: r }) {
  var d;
  let i = t.structures || [], n = i.length, a = (d = gt({ structure: t })) == null ? void 0 : d.positionAssignments, o = Hd(e), s = (a == null ? void 0 : a.length) ?? 0, { seedGroups: c } = uU({ roundRobinGroupsCount: n, drawSize: s }), u = i.map((l) => {
    var p;
    return (p = gt({ structure: l }).positionAssignments) == null ? void 0 : p.map((f) => f.drawPosition);
  });
  return ON({ drawPositionBlocks: u, positioning: o, seedGroups: c, nonRandom: r });
}
function ON({ drawPositionBlocks: e, positioning: t, seedGroups: r, nonRandom: i }) {
  let n = [], { divisionGroupings: a } = AB({ size: r.length, positioning: t }), o = [];
  return r.forEach((s, c) => {
    let u = yB({ blockPattern: a, index: c });
    s.forEach((d, l) => {
      let p = c % 2 ? e.length - l - 1 : l, f = e[p].slice().filter((h, g) => u.includes(g + 1) && h);
      t !== Do ? f = i ? f : Xr(f) : c % 2 && f.reverse();
      let m = f.find((h) => !o.includes(h));
      m && (o.push(m), n.push({ drawPositions: [m], seedNumbers: [d] }));
    });
  }), { validSeedBlocks: n };
}
function DB(e) {
  let { drawPositionOffset: t = 0, roundRobinGroupsCount: r, seedNumberOffset: i = 0, seedingProfile: n, seedCountGoal: a, baseDrawSize: o } = e, s = 1, c = [], { seedBlocks: u } = cU({ cluster: Hd(n) === JI, participantsCount: o, roundRobinGroupsCount: r });
  s = 0;
  for (let l of u) {
    if (s + 1 > a) break;
    let p = l.map((m) => m + t), f = d(s + 1, l.length).map((m) => +m + i);
    s += l.length, c.push({ drawPositions: p, seedNumbers: f });
  }
  return { blocks: c };
  function d(l, p) {
    return Array.from(new Array(p), (f, m) => m + l);
  }
}
function vp({ appliedPolicies: e, drawDefinition: t, seedBlockInfo: r, drawPosition: i, structureId: n, seedNumber: a }) {
  var c, u, d, l, p, f;
  let { structure: o } = Ne({ drawDefinition: t, structureId: n });
  e || (e = nt({ drawDefinition: t }).appliedPolicies);
  let s = r == null ? void 0 : r.validSeedBlocks;
  return !s && o && (s = (c = qs({ appliedPolicies: e, drawDefinition: t, structure: o })) == null ? void 0 : c.validSeedBlocks), (d = (u = e == null ? void 0 : e.seeding) == null ? void 0 : u.validSeedPositions) != null && d.ignore ? !0 : (p = (l = e == null ? void 0 : e.seeding) == null ? void 0 : l.validSeedPositions) != null && p.strict ? (((f = s.find((m) => m.seedNumbers.includes(a))) == null ? void 0 : f.drawPositions) || []).includes(i) : [].concat(...s.map((m) => m.drawPositions)).includes(i);
}
function CN(e) {
  var b, E, O;
  let { provisionalPositioning: t, drawDefinition: r, seedingProfile: i, seedBlockInfo: n, structureId: a, randomize: o } = e, { structure: s } = Ne({ drawDefinition: r, structureId: a }), { seedAssignments: c } = Qi({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, drawDefinition: r, structure: s }), { positionAssignments: u } = Ir({ structure: s }), d = (b = u == null ? void 0 : u.filter((M) => M.participantId ?? M.bye ?? M.qualifier)) == null ? void 0 : b.map((M) => M.drawPosition).filter(Boolean), { appliedPolicies: l } = nt({ drawDefinition: r }), p = ((n == null ? void 0 : n.validSeedBlocks) || s && ((E = qs({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, appliedPolicies: l, drawDefinition: r, seedingProfile: i, structure: s })) == null ? void 0 : E.validSeedBlocks) || []).filter((M) => M.drawPositions.filter((N) => !(d != null && d.includes(N))).length)[0], f = c == null ? void 0 : c.map((M) => M.participantId).filter(Boolean), m = u == null ? void 0 : u.map((M) => M.participantId).filter(Boolean), h = f == null ? void 0 : f.filter((M) => m == null ? void 0 : m.includes(M)), g = f == null ? void 0 : f.filter((M) => !(m != null && m.includes(M))), I = c == null ? void 0 : c.filter((M) => g == null ? void 0 : g.includes(M.participantId)), U = c == null ? void 0 : c.filter((M) => !M.participantId), v = (I != null && I.length && I.length > 0 ? I.length : (U == null ? void 0 : U.length) ?? 0) && (p == null ? void 0 : p.drawPositions.filter((M) => !(d != null && d.includes(M)))) || [], S = o ? Xr(v) : v, T = [], A = S.map(() => {
    var N;
    let M = (N = R(I, T)) == null ? void 0 : N.participantId;
    return M && T.push(M), M;
  }).filter(Boolean), y = c == null ? void 0 : c.filter((M) => h == null ? void 0 : h.includes(M.participantId)).map((M) => M.seedNumber), D = ((p == null ? void 0 : p.seedNumbers) || []).filter((M) => !(y != null && y.includes(M))), P = c == null ? void 0 : c.filter((M) => D.includes(M.seedNumber)).map((M) => M.participantId), w = (O = l == null ? void 0 : l.seeding) == null ? void 0 : O.duplicateSeedNumbers;
  return { nextSeedBlock: p, unplacedSeedParticipantIds: w === void 0 || w ? A : P, unplacedSeedNumbers: D, unfilledPositions: S, unplacedSeedAssignments: I };
  function R(M, N) {
    let C = M.filter((V) => !N.includes(V.participantId)), F = Math.min(...C.map((V) => bc(V.seedValue))), x = C.filter((V) => bc(V.seedValue) === F);
    return Xr(x).pop();
  }
}
function Hd(e) {
  if (typeof e == "string") return e;
  if (typeof e == "object") return e.positioning;
}
function tu({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: r, seedingProfile: i, participantId: n, seedBlockInfo: a, structureId: o, seedNumber: s, seedValue: c, eventId: u, event: d }) {
  var T, A, y;
  let l = "assignSeed", { structure: p } = Ne({ drawDefinition: r, structureId: o }), { positionAssignments: f } = Ir({ structure: p }), m = Qi({ provisionalPositioning: e, drawDefinition: r, structure: p }).seedAssignments, h = m.map((D) => D.seedNumber), g = as({ drawDefinition: r, participantId: n });
  if (n && !g) return W({ result: { error: bn }, context: { participantId: n }, stack: l });
  let I = d ? (A = (T = Ht({ event: d }).flightProfile) == null ? void 0 : T.flights) == null ? void 0 : A.length : 0, U = I && I > 1, v = (y = f == null ? void 0 : f.find((D) => D.participantId === n)) == null ? void 0 : y.drawPosition;
  if (v && !vp({ drawPosition: v, drawDefinition: r, seedBlockInfo: a, structureId: o, seedNumber: s })) return W({ result: { error: hI }, context: { assignedDrawPosition: v }, info: "invalid seed position", stack: l });
  h.includes(s) || m.push({ seedNumber: s, seedValue: c });
  let S;
  return m.forEach((D) => {
    D.participantId === n && D.seedNumber !== s && (D.participantId = void 0), D.seedNumber === s && (D.participantId = n, !(i != null && i.groupSeedingThreshold) && !U && (D.seedValue = c ?? s), S = !0);
  }), S ? (kb({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: r, structure: p, eventId: u }), { ...j }) : W({ result: { error: XP }, stack: l });
}
function lU({ inContextTargetMatchUp: e, drawPositionSideIndex: t, teamParticipantId: r, tournamentRecord: i, drawDefinition: n, matchUp: a, event: o }) {
  var p, f, m, h;
  let s = (f = (p = e == null ? void 0 : e.sides) == null ? void 0 : p[t]) == null ? void 0 : f.sideNumber, c = s && ((m = a.sides) == null ? void 0 : m.find((g) => g.sideNumber === s)), { extension: u } = We({ element: n, name: Da }), d = (u == null ? void 0 : u.value) || {}, l = ge(d[r], !1, !0);
  if (c) (h = a == null ? void 0 : a.sides) == null || h.forEach((g) => {
    g.sideNumber === s && (g.lineUp = l);
  });
  else {
    a.sides = [1, 2].map((I) => {
      var U;
      return { ...((U = a.sides) == null ? void 0 : U.find((v) => v.sideNumber === I)) ?? {}, sideNumber: I };
    });
    let g = a.sides.find((I) => I.sideNumber === s);
    g && (g.lineUp = l);
  }
  Qe({ tournamentId: i == null ? void 0 : i.tournamentId, context: "updateSidLineUp", eventId: o == null ? void 0 : o.eventId, drawDefinition: n, matchUp: a });
}
function FN(e) {
  let { sourceMatchUp: t } = e, { targetMatchUp: r, structure: i, matchUpsMap: n, drawPosition: a } = e, o = r.roundNumber > 1 && r.roundNumber - 1, s = No({ structureId: i.structureId, matchUpsMap: n });
  !t && a && (t = s.find(({ drawPositions: m, roundNumber: h }) => h === o && (m == null ? void 0 : m.includes(a))));
  let c = t == null ? void 0 : t.roundPosition, u = c % 2 ? 1 : -1, d = c + u, l = o && s.find(({ roundNumber: m, roundPosition: h }) => m === o && h === d), p = l == null ? void 0 : l.matchUpStatus, f = [$t, sr].includes(p);
  return { pairedPreviousMatchUp: l, pairedPreviousMatchUpIsDoubleExit: f };
}
function PB({ drawPosition: e, drawPositions: t }) {
  let r = !1, i = !!(t != null && t.includes(e));
  return { updatedDrawPositions: i ? t || [] : [...t, void 0, void 0].slice(0, 2).map((n) => !n && !i ? (i = !0, r = !0, e) : n).sort(ar).filter(Boolean), positionAdded: r, positionAssigned: i };
}
function kN({ structureId: e, matchUpsMap: t, matchUp: r }) {
  let i = r == null ? void 0 : r.roundPosition, n = i % 2 ? 1 : -1, a = i + n;
  return { pairedPreviousMatchUp: No({ matchUpsMap: t, structureId: e }).find(({ roundNumber: o, roundPosition: s }) => o === (r == null ? void 0 : r.roundNumber) && s === a) };
}
function LN({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: r, matchUpsMap: i, matchUp: n }) {
  let a = e.find((s) => s.matchUpId === r), { pairedPreviousMatchUp: o } = kN({ structureId: a == null ? void 0 : a.structureId, matchUp: a, matchUpsMap: i });
  if (a && o) {
    let s = o == null ? void 0 : o.matchUpId, c = e.find((d) => d.matchUpId === s), u = (a == null ? void 0 : a.structureId) === (c == null ? void 0 : c.structureId) ? (a == null ? void 0 : a.roundPosition) < (c == null ? void 0 : c.roundPosition) && 1 || 2 : a.structureId === (c == null ? void 0 : c.structureId) && 2 || 1;
    n.matchUpStatusCodes = (n.matchUpStatusCodes ?? []).map((d) => {
      let l = Et(d) || !isNaN(d) ? { code: d } : d;
      return l.sideNumber === u ? { ...l, previousMatchUpStatus: t } : l;
    });
  }
}
function Hl({ inContextDrawMatchUps: e, drawPosition: t, matchUpId: r }) {
  let i = e.filter(({ winnerMatchUpId: n, loserMatchUpId: a }) => a === r || n === r).sort((n, a) => n.roundPosition - a.roundPosition);
  return e.find((n) => n.matchUpId === r).feedRound ? 1 : i.reduce((n, a, o) => {
    var s;
    return (s = a.drawPositions) != null && s.includes(t) ? o + 1 : n;
  }, void 0);
}
function Nc({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, tournamentRecord: r, sourceMatchUpId: i, drawDefinition: n, matchUpStatus: a, drawPosition: o, matchUpsMap: s, matchUpId: c, event: u }) {
  var b, E, O, M;
  let d = "assignMatchUpDrawPosition";
  s || (s = xr({ drawDefinition: n })), e || (e = ur({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? []);
  let l = e.find((N) => N.matchUpId === c), p = l == null ? void 0 : l.structureId, f = (b = n == null ? void 0 : n.structures) == null ? void 0 : b.find((N) => N.structureId === p);
  if (!f) return { error: kt };
  let m = (E = s == null ? void 0 : s.drawMatchUps) == null ? void 0 : E.find((N) => N.matchUpId === c), h = (m == null ? void 0 : m.drawPositions) ?? [], { positionAdded: g, positionAssigned: I, updatedDrawPositions: U } = PB({ drawPositions: h, drawPosition: o }), { positionAssignments: v } = gt({ drawDefinition: n, structure: f }), S = (O = v == null ? void 0 : v.filter((N) => U.includes(N.drawPosition))) == null ? void 0 : O.find(({ bye: N }) => N), T = (m == null ? void 0 : m.matchUpStatus) && [ct, Je].includes(m.matchUpStatus) && U.filter(Boolean).length < 2;
  if (a = S && at || a || T && m.matchUpStatus || (m == null ? void 0 : m.matchUpStatus) && [$t, sr].includes(m.matchUpStatus) && m.matchUpStatus || Xt, m && g) {
    e = ur({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? [];
    let N = T && Hl({ inContextDrawMatchUps: e, drawPosition: o, matchUpId: c }) || void 0;
    m != null && m.matchUpStatusCodes && LN({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: i, matchUpsMap: s, matchUp: m }), Object.assign(m, { drawPositions: U, winningSide: N, matchUpStatus: a }), Qe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: l == null ? void 0 : l.eventId, context: d, drawDefinition: n, matchUp: m });
  }
  let A = ei({ inContextDrawMatchUps: e, inContextMatchUp: l, drawDefinition: n, matchUpId: c }), { targetMatchUps: { winnerMatchUp: y, loserMatchUp: D, loserTargetDrawPosition: P }, targetLinks: { loserTargetLink: w } } = A, R = No({ structureId: f.structureId, matchUpsMap: s });
  if (I && S) {
    if (y) if ([at, $t, sr].includes(a)) {
      let N = Nc({ matchUpId: y.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (N.error) return N;
    } else {
      let { structureId: N } = y;
      N !== f.structureId && console.log("winnerMatchUp in different structure... participant is in different targetDrawPosition");
    }
  } else if (y && l && !l.feedRound) {
    let { pairedPreviousMatchUpIsDoubleExit: N } = FN({ targetMatchUp: m, drawPosition: o, matchUpsMap: s, structure: f });
    if (N) {
      let C = Nc({ matchUpId: y.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (C.error) return C;
    }
  }
  if ((m == null ? void 0 : m.matchUpType) === yt) {
    let N = e == null ? void 0 : e.find(({ matchUpId: x }) => x === m.matchUpId), C = ((N == null ? void 0 : N.sides) ?? []).reduce((x, V, k) => V.drawPosition === o ? k : x, void 0), F = (M = v == null ? void 0 : v.find((x) => x.drawPosition === o)) == null ? void 0 : M.participantId;
    F && C !== void 0 && lU({ inContextTargetMatchUp: N, drawPositionSideIndex: C, teamParticipantId: F, tournamentRecord: r, drawDefinition: n, matchUp: m });
  }
  if ((w == null ? void 0 : w.linkCondition) === _n && U.filter(Boolean).length === 2 && !S && R.filter(({ drawPositions: N, roundNumber: C }) => C === 1 && Jr(N, U)).every(({ matchUpStatus: N }) => [zt, Wr].includes(N)) && D) {
    let { structureId: N } = D, C = _i({ drawPosition: P, tournamentRecord: r, drawDefinition: n, structureId: N, matchUpsMap: s, event: u });
    if (C.error) return C;
  }
  return I ? { ...j } : W({ result: { error: fc }, context: { drawPosition: o }, stack: d });
}
function xN({ inContextDrawMatchUps: e, drawDefinition: t, assignments: r, matchUpsMap: i, structure: n }) {
  var d, l, p, f;
  let a = ((p = (l = (d = Zc({ drawDefinition: t })) == null ? void 0 : d.containedStructures) == null ? void 0 : l[n.structureId]) == null ? void 0 : p.map(({ structureId: m }) => m)) || [];
  a.push(n == null ? void 0 : n.structureId);
  let o = (r == null ? void 0 : r.map(({ drawPosition: m }) => m)) || [], s = (e == null ? void 0 : e.filter((m) => a.includes(m.structureId) && qt(m.drawPositions ?? [], o).length)) ?? [], c = s.map(({ matchUpId: m }) => m), u = ((f = i == null ? void 0 : i.drawMatchUps) == null ? void 0 : f.filter((m) => c.includes(m.matchUpId))) ?? [];
  return { drawPositions: o, matchUps: u, targetMatchUps: s };
}
function pU({ lineUp: e }) {
  if (!Array.isArray(e)) return;
  let t = {};
  return Be(e.flatMap(({ collectionAssignments: r }) => r == null ? void 0 : r.map(({ collectionId: i, collectionPosition: n }) => [i, n].join("|"))).filter(Boolean)).forEach((r) => {
    let [i, n] = r.split("|"), a = parseInt(n), { assignedParticipantIds: o } = hp({ collectionPosition: a, collectionId: i, lineUp: e });
    o.forEach((s) => {
      t[s] || (t[s] = []), t[s].push({ collectionId: i, collectionPosition: a });
    });
  }), Object.keys(t).map((r) => ({ participantId: r, collectionAssignments: t[r] }));
}
function Oo(e) {
  return `${e} must be an array`;
}
function wm({ lineUp: e, tieFormat: t }) {
  let r = [];
  if (!Array.isArray(e)) return r.push(Oo("lineUp")), { valid: !1, errors: r, error: ie };
  let i = e.every((a) => {
    if (typeof a != "object") return r.push("lineUp entries must be objects"), !1;
    let { participantId: o, collectionAssignments: s } = a;
    return o ? typeof o != "string" ? (r.push("participantIds must be strings"), !1) : Array.isArray(s) ? s.every((c) => {
      if (typeof c != "object") return r.push("collectionAssignments must be objects"), !1;
      let { collectionPosition: u } = c;
      return typeof u != "number" ? (r.push("collectionPosition must be a number"), !1) : !0;
    }) : (r.push(Oo("collectionAssignments")), !1) : (r.push("Missing participantId"), !1);
  }), n = Be(e.map(Ke)).length === e.length;
  return n || r.push("Duplicated participantId(s)"), { valid: i && n, errors: r, error: r.length ? ie : void 0 };
}
function Hs({ drawDefinition: e, participantId: t, tieFormat: r, lineUp: i }) {
  if (typeof e != "object") return { error: Ue };
  if (typeof t != "string") return { error: cr };
  let n = wm({ lineUp: i, tieFormat: r });
  if (!n.valid) return n;
  let { extension: a } = We({ element: e, name: Da }), o = (a == null ? void 0 : a.value) || {};
  return o[t] = pU({ lineUp: i }), it({ element: e, extension: { name: Da, value: o } }), Ad({ drawDefinition: e }), { ...j };
}
function fU({ inContextDrawMatchUps: e, inheritance: t = !0, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, assignments: a, structure: o, event: s }) {
  if (!i) return { error: Ue };
  let { drawPositions: c, matchUps: u, targetMatchUps: d } = xN({ inContextDrawMatchUps: e, matchUpsMap: n, assignments: a, structure: o });
  for (let l of d) l.matchUpType === Ci && (l.sides ?? []).forEach((p, f) => {
    var m;
    if (p != null && p.drawPosition && (c != null && c.includes(p.drawPosition))) {
      let h = u.find(({ matchUpId: g }) => g === l.matchUpId);
      if ((m = h == null ? void 0 : h.sides) != null && m[f]) {
        if (delete h.sides[f].lineUp, t === !1) {
          let g = l.tieFormat, I = p.participantId;
          g && I && Hs({ drawDefinition: i, participantId: I, lineUp: [], tieFormat: g });
        }
        Qe({ tournamentId: r == null ? void 0 : r.tournamentId, context: "resetLineUps", eventId: s == null ? void 0 : s.eventId, drawDefinition: i, matchUp: h });
      }
    }
  });
  return { ...j };
}
function qn({ provisionalPositioning: e, inContextDrawMatchUps: t, isQualifierPosition: r, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: s, seedBlockInfo: c, drawPosition: u, matchUpsMap: d, structureId: l, event: p }) {
  var w, R, b, E, O;
  let f = "assignDrawPosition";
  if (!s && !r) return W({ result: { error: cr }, stack: f });
  d = d ?? xr({ drawDefinition: a }), t || ({ matchUps: t } = ur({ inContext: !0, drawDefinition: a, matchUpsMap: d }));
  let m = Ne({ drawDefinition: a, structureId: l });
  if (m.error) return W({ result: m, stack: f });
  let { structure: h } = m;
  if (!h) return { error: kt };
  if (si({ structure: h })) return W({ result: { error: gi }, stack: f });
  let { seedAssignments: g } = Qi({ provisionalPositioning: e, drawDefinition: a, structure: h }), I = (w = g == null ? void 0 : g.find((M) => M.participantId === s)) == null ? void 0 : w.seedNumber, { appliedPolicies: U } = nt({ tournamentRecord: n, drawDefinition: a, structure: h, event: p });
  if (I && !vp({ seedNumber: I, appliedPolicies: U, drawDefinition: a, seedBlockInfo: c, drawPosition: u, structureId: l })) return W({ result: { error: hI }, context: { drawPosition: u }, stack: f });
  let v = Ir({ structure: h }).positionAssignments || [], S = v == null ? void 0 : v.find((M) => M.drawPosition === u);
  if (!S) return W({ result: { error: xc }, context: { drawPosition: u }, stack: f });
  if (v != null && v.map(Ke).includes(s)) return W({ result: { error: jc }, context: { drawPosition: u }, stack: f });
  let { containsParticipant: T, containsBye: A } = P(S);
  if (A) {
    let M = Vd({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, drawPosition: u, structureId: l, matchUpsMap: d, event: p });
    if (M.error) return W({ result: M, stack: f });
  }
  if (T && S.participantId !== s) {
    let { activeDrawPositions: M } = Bd({ drawDefinition: a, structureId: l });
    if (M.includes(u)) return W({ result: { error: bf }, stack: f });
    fU({ assignments: [S], inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, matchUpsMap: d, structure: h });
  }
  if (S.participantId = s, r && (S.qualifier = !0), h.stage === Ie && (!h.stageSequence || h.stageSequence > 1) || h.stage && [kr, Wt].includes(h.stage)) {
    let M = h.stage === Pe ? Pe : Ie, N = (((b = (R = a.structures) == null ? void 0 : R.find((C) => (C == null ? void 0 : C.stage) === M && (C == null ? void 0 : C.stageSequence) === 1)) == null ? void 0 : b.seedAssignments) ?? []).find((C) => C.participantId === s);
    if (N != null && N.participantId) {
      let { participantId: C, seedNumber: F, seedValue: x } = N;
      tu({ eventId: p == null ? void 0 : p.eventId, provisionalPositioning: e, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: C, seedNumber: F, seedValue: x, structureId: l, event: p });
    }
  }
  if (h.structureType !== ri) wB({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, drawPosition: u, matchUpsMap: d, structure: h, event: p });
  else {
    hN({ positionAssignments: v, tournamentRecord: n, drawDefinition: a, matchUpsMap: d, structure: h });
    let { drawPositions: M, matchUps: N, targetMatchUps: C } = xN({ assignments: [S], inContextDrawMatchUps: t, drawDefinition: a, matchUpsMap: d, structure: h });
    if (M && (N == null ? void 0 : N.length) === 1 && N[0].matchUpType === yt) {
      let F = ((C == null ? void 0 : C[0].sides) ?? []).reduce((x, V, k) => M != null && M.includes(V.drawPosition) ? k : x, void 0);
      lU({ inContextTargetMatchUp: C[0], teamParticipantId: s, matchUp: N[0], drawPositionSideIndex: F, tournamentRecord: n, drawDefinition: a });
    }
  }
  let y = (E = a.entries) == null ? void 0 : E.find((M) => M.participantId === s), D = (O = p == null ? void 0 : p.entries) == null ? void 0 : O.find((M) => M.participantId === s);
  return !y && D && eU({ entryStatus: D.entryStatus, entryStage: h.stage, ignoreStageSpace: !0, drawDefinition: a, participantId: s, event: p }), Qa({ tournamentId: n == null ? void 0 : n.tournamentId, drawDefinition: a, structure: h, event: p }), { positionAssignments: v, ...j };
  function P(M) {
    let N = M.bye, C = M.qualifier, F = M.participantId;
    return { containsBye: N, containsQualifier: C, containsParticipant: F, filled: N || C || F };
  }
}
function wB({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  let u = { isCollectionMatchUp: !1 }, { matchUps: d } = ut({ provisionalPositioning: e, matchUpFilters: u, drawDefinition: n, matchUpsMap: o, structure: s, event: c }), { roundMatchUps: l } = $r({ matchUps: d }), { initialRoundNumber: p } = Ss({ drawPosition: a, matchUps: d }), f = p && (l == null ? void 0 : l[p].find((m) => {
    var h;
    return (h = m.drawPositions) == null ? void 0 : h.includes(a);
  }));
  if (f) {
    let m = Nc({ matchUpId: f.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o });
    if (m.error) return W({ stack: "assignDrawPositionToMatchUps", context: { drawPosition: a }, result: m });
  }
  return { ...j };
}
function mU(e) {
  let { participantIdAttributeName: t = "participantId", isQualifierPosition: r, positionActionName: i, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, event: u } = e, d = "positionParticipantAction";
  if (!a) return { error: Ue };
  let l = nt({ tournamentRecord: n, drawDefinition: a, event: u }).appliedPolicies ?? {}, { inContextDrawMatchUps: p, matchUpsMap: f } = e;
  f || (f = xr({ drawDefinition: a }), Object.assign(e, { matchUpsMap: f })), p || ({ matchUps: p } = ur({ inContext: !0, drawDefinition: a, matchUpsMap: f }), Object.assign(e, { inContextDrawMatchUps: p }));
  let { positionAssignments: m } = gt({ drawDefinition: a, structureId: c }), h = m == null ? void 0 : m.find((S) => S.drawPosition === s);
  if (h != null && h.participantId) {
    let S = h.participantId, T = qn({ inContextDrawMatchUps: p, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: f, event: u });
    return T.success ? v({ appliedPolicies: l, removedParticipantId: S }) : W({ result: T, stack: d });
  }
  let g = Vd({ inContextDrawMatchUps: p, tournamentRecord: n, drawDefinition: a, drawPosition: s, structureId: c, matchUpsMap: f, event: u });
  if (g.error) return W({ result: g, stack: d });
  let I = g.participantId, U = qn({ inContextDrawMatchUps: p, isQualifierPosition: r, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: f, event: u });
  if (!U.success) return W({ result: U, stack: d });
  return v({ appliedPolicies: l, removedParticipantId: I });
  function v({ appliedPolicies: S, removedParticipantId: T }) {
    let { structure: A } = Ne({ drawDefinition: a, structureId: c });
    Lv({ drawPositions: [s], structure: A });
    let y = { [t]: o, name: i, drawPosition: s, structureId: c };
    return lm({ appliedPolicies: S, drawDefinition: a, positionAction: y }), W({ context: { removedParticipantId: T }, result: { ...j }, stack: d });
  }
}
function RB({ luckyLoserParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return mU({ positionActionName: "luckyLoserDrawPositionAssignment", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function BN(e) {
  return RB(e);
}
function VN({ params: e, modMap: t, structure: r }) {
  let { tournamentRecord: i, drawDefinition: n, event: a } = e;
  for (let o of r.matchUps) t[o.matchUpId] && (o.roundNumber = t[o.matchUpId], Qe({ tournamentId: i == null ? void 0 : i.tournamentId, eventId: a == null ? void 0 : a.eventId, drawDefinition: n, matchUp: o }));
}
function GN(e, t) {
  let r = [{ drawDefinition: !0, structureId: !0 }];
  Array.isArray(t) && r.push(...t);
  let i = Ae(e, r);
  if (i.error) return i;
  let n = Ne(e);
  if (n.error) return n;
  let a = n.structure;
  if (!si({ structure: a })) return W({ result: { error: xo, message: "structure must be adHoc" } });
  let { roundMatchUps: o = [], roundNumbers: s } = $r({ matchUps: a == null ? void 0 : a.matchUps });
  return s != null && s.length ? { valid: !0, structure: a, roundMatchUps: o, roundNumbers: s } : { error: Ma };
}
function jN(e) {
  var d;
  let t = GN(e, [{ targetRoundNumber: !0, roundNumber: !0, [ui]: UL }]);
  if (t.error) return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t, { targetRoundNumber: a, roundNumber: o } = e;
  if (!(n != null && n.includes(o)) || !(n != null && n.includes(a))) return W({ result: { error: ie }, info: "roundNumbers must be valid rounds" });
  let s = a > o, c = s ? fe(o + 1, a + 1) : fe(a, o), u = {};
  return c.forEach((l) => ((i == null ? void 0 : i[l]) ?? []).forEach(({ matchUpId: p }) => {
    u[p] = l - (s ? 1 : -1);
  })), (d = i == null ? void 0 : i[o]) == null || d.forEach(({ matchUpId: l }) => u[l] = a), VN({ params: e, modMap: u, structure: r }), { ...j };
}
function _N({ structurePositionAssignments: e, provisionalPositioning: t, tournamentRecord: r, drawDefinition: i, event: n }) {
  var s;
  if (!i) return { error: Ue };
  if (!Array.isArray(e)) return { error: ie };
  let a = "setPositionAssignments";
  for (let c of e) {
    let { structureId: u, positionAssignments: d } = c;
    if (!d) continue;
    let l = Ne({ drawDefinition: i, structureId: u });
    if (l.error) return l;
    let p = l.structure;
    if (!p) return { error: kt };
    let f = (s = gt({ structure: p }).positionAssignments) == null ? void 0 : s.map(({ drawPosition: I }) => I), m = d == null ? void 0 : d.map(({ drawPosition: I }) => I);
    if (qt(f, m).length !== (f == null ? void 0 : f.length)) return W({ result: { error: ie }, info: "drawPositions do not match", stack: a });
    let h = xr({ drawDefinition: i }), { matchUps: g } = ur({ inContext: !0, drawDefinition: i, matchUpsMap: h });
    for (let I of d || []) {
      let { drawPosition: U, participantId: v, bye: S, qualifier: T } = I;
      if (S) {
        let A = _i({ tournamentRecord: r, drawDefinition: i, drawPosition: U, matchUpsMap: h, structureId: u, structure: p, event: n });
        if (A != null && A.error) return A;
      } else if (T) d.forEach((A) => {
        A.drawPosition === U && (A.qualifier = !0, delete A.participantId, delete A.bye);
      });
      else if (v) {
        let A = qn({ provisionalPositioning: t, inContextDrawMatchUps: g, tournamentRecord: r, drawDefinition: i, participantId: v, drawPosition: U, matchUpsMap: h, structureId: u, event: n });
        if (A != null && A.error) return A;
      }
    }
    Qa({ tournamentId: r == null ? void 0 : r.tournamentId, drawDefinition: i, structure: p, event: n });
  }
  let o = e.map(({ structureId: c }) => c);
  return vt({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: n == null ? void 0 : n.eventId, drawDefinition: i, structureIds: o }), { ...j };
}
function WN(e) {
  let t = GN(e, [{ roundNumbers: !0, [ui]: Gr, [Or]: (o) => o.length === 2 && o.every(jt) }]);
  if (t.error) return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t;
  if (!e.roundNumbers.every((o) => n == null ? void 0 : n.includes(o))) return W({ result: { error: ie, message: "roundNumbers must be valid rounds" } });
  let a = {};
  return e.roundNumbers.forEach((o, s) => ((i == null ? void 0 : i[o]) ?? []).forEach(({ matchUpId: c }) => {
    a[c] = e.roundNumbers[1 - s];
  })), VN({ params: e, modMap: a, structure: r }), { ...j };
}
function bB({ qualifyingParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return mU({ positionActionName: "qualifierDrawPositionAssignment", participantId: e, isQualifierPosition: !0, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function qN(e) {
  return bB(e);
}
function HN({ alternateParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a }) {
  return mU({ positionActionName: "alternateDrawPositionAssignment", participantIdAttributeName: "alternateParticipantid", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a });
}
function YN({ validation: e = !0, tournamentRecord: t, drawDefinition: r, participantId: i, structureId: n, seedValue: a, event: o }) {
  if (!r) return { error: Ue };
  if (!n) return { error: Vi };
  let s = ((t == null ? void 0 : t.participants) ?? []).find((p) => p.participantId === i);
  if (t && !s) return { error: bn };
  let { structure: c } = Ne({ drawDefinition: r, structureId: n });
  if (!c) return { error: kt };
  if (!(!e || jt(a) || a === void 0 || a === "" || typeof a == "string" && a.split("-").every((p) => jt(p) && be(p) > 0))) return { error: ie };
  let { seedAssignments: u } = Qi({ drawDefinition: r, structure: c }), d = u == null ? void 0 : u.map((p) => p.seedNumber), l = u == null ? void 0 : u.find((p) => p.participantId === i);
  if (l) {
    let p = typeof a == "string" ? a.includes("-") && a.split("-").map((f) => parseInt(f)).join("-") || parseInt(a) > 0 && parseInt(a) || "" : a && a > 0 && a || "";
    l.seedValue = p;
  } else {
    let p = { seedNumber: Math.max(0, ...d || []) + 1, participantId: i };
    a && (p.seedValue = a), c.seedAssignments || (c.seedAssignments = []), c.seedAssignments.push(p);
  }
  return kb({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: o == null ? void 0 : o.eventId, drawDefinition: r, structure: c }), { ...j };
}
function zN({ drawDefinition: e, structureId: t }) {
  if (!e) return { error: Ue };
  let { structure: r } = Ne({ drawDefinition: e, structureId: t }), i = ((e == null ? void 0 : e.links) || []).filter((n) => {
    var a;
    return ((a = n.source) == null ? void 0 : a.structureId) === t;
  }).map((n) => {
    var a;
    return (a = n.target) == null ? void 0 : a.structureId;
  });
  return { playoffStructures: ((e == null ? void 0 : e.structures) || []).filter((n) => i.includes(n.structureId)), structure: r };
}
function Rm({ withStageGrouping: e, stageSequences: t, stageSequence: r, roundTarget: i, stages: n, event: a, stage: o }) {
  if (!a) return { error: At };
  let s = {}, c = [];
  for (let u of a.drawDefinitions || []) {
    let { structures: d, stageStructures: l } = In({ withStageGrouping: e, stageSequences: t, drawDefinition: u, stageSequence: r, roundTarget: i, stages: n, stage: o });
    if (c.push(...d), l) for (let p of Object.keys(l)) s[p] || (s[p] = []), s[p].push(...l[p]);
  }
  return { structures: c, stageStructures: s };
}
function hU({ withStageGrouping: e, tournamentRecord: t, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, stage: o }) {
  if (!t) return { error: de };
  let s = {}, c = [];
  for (let u of t.events || []) {
    let { structures: d, stageStructures: l } = Rm({ withStageGrouping: e, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, event: u, stage: o });
    if (d && c.push(...d), l) for (let p of Object.keys(l)) s[p] || (s[p] = []), s[p].push(...l[p]);
  }
  return { structures: c, stageStructures: s };
}
function $a(e) {
  if (!(e != null && e.drawDefinition)) return !1;
  let t = Am(e), r = t == null ? void 0 : t.includesTeamMatchUps, { completedMatchUps: i, pendingMatchUps: n, upcomingMatchUps: a } = t || {};
  return r && (i = i == null ? void 0 : i.filter(({ matchUpType: o }) => o === yt), n = n == null ? void 0 : n.filter(({ matchUpType: o }) => o === yt), a = a == null ? void 0 : a.filter(({ matchUpType: o }) => o === yt)), !!(i != null && i.length && !(n != null && n.length) && !(a != null && a.length));
}
function gU(e) {
  var o, s;
  let { drawDefinition: t, structureId: r } = e;
  if (!t) return { error: Ue };
  let { playoffStructures: i } = zN({ drawDefinition: t, structureId: r });
  if (!(i != null && i.length)) return !1;
  let n = ((s = (o = t == null ? void 0 : t.entries) == null ? void 0 : o.filter((c) => (c == null ? void 0 : c.entryStatus) && yn.includes(c.entryStatus))) == null ? void 0 : s.length) ?? 0, a = 0;
  return (i || []).reduce((c, u) => {
    var d;
    return !!((d = gt({ structure: u }).positionAssignments ?? []) != null && d.filter((l) => (l.participantId && a++, (l == null ? void 0 : l.bye) ?? (l == null ? void 0 : l.participantId))).length && c);
  }, !!i.length) || a === n;
}
function Bg({ significantCharacters: e, accessors: t = [], value: r }) {
  let i = [], n = t[0];
  if (r != null && r[n]) {
    let o = t.slice(1);
    if (Array.isArray(r[n])) r[n].forEach((s) => {
      let c = Bg({ accessors: o, significantCharacters: e, value: s });
      i.push(...c);
    });
    else if (r = r[n], o.length) {
      let s = Bg({ accessors: o, significantCharacters: e, value: r });
      i.push(...s);
    } else a({ value: r });
  }
  function a({ value: o }) {
    if (o && ["string", "number"].includes(typeof o)) {
      let s = e ? o.slice(0, e) : o;
      i.push(s);
    }
  }
  return i;
}
function NB({ targetParticipantIds: e, policyAttributes: t, idCollections: r, participants: i }) {
  if (!Array.isArray(t)) return { error: PI };
  if (!Array.isArray(i)) return { error: cd };
  let n = {};
  return e.forEach((a) => {
    let o = i.find((c) => c.participantId === a), { values: s } = KN({ policyAttributes: t, idCollections: r, participants: i, participant: o });
    s && s.forEach((c) => {
      n[c] || (n[c] = []), n[c].includes(a) || n[c].push(a);
    });
  }), n;
}
function KN({ policyAttributes: e, idCollections: t, participants: r, participant: i }) {
  if (!Array.isArray(e)) return { error: PI };
  if (!i) return { error: ws };
  let n = [];
  return e.forEach((a) => {
    let { directive: o, groupings: s, key: c, significantCharacters: u } = a || {};
    if (c) {
      let d = c.split(".");
      n.push(...Bg({ significantCharacters: u, value: i, accessors: d }));
    } else if (o) {
      let d = a == null ? void 0 : a.includeIds, l = ((t == null ? void 0 : t[o]) || []).filter((p) => !d || d.includes(p));
      l != null && l.length && (r != null && r.length) && l.forEach((p) => {
        var m;
        let f = r.find((h) => h.participantId === p);
        if ((m = f == null ? void 0 : f.individualParticipantIds) != null && m.includes(i.participantId)) {
          let h = f == null ? void 0 : f.participantId;
          n.push(h);
        }
      });
    } else s && Object.keys(s).forEach((d) => {
      s[d].includes(i.participantId) && n.push(d);
    });
  }), { values: Be(n) };
}
function mT({ candidatePositionAssignments: e, participantsWithGroupings: t, policyAttributes: r, idCollections: i }) {
  let n = Object.assign({}, ...t.map((a) => ({ [a.participantId]: a })));
  return e.map((a) => {
    let o = n[a.participantId], { values: s } = KN({ participants: t, policyAttributes: r, idCollections: i, participant: o });
    return { ...a, values: s };
  });
}
function XN({ participantIdGroups: e, positionAssignments: t, groupsToAvoid: r }) {
  return Object.assign({}, ...t.filter((i) => i == null ? void 0 : i.participantId).map((i) => {
    let { drawPosition: n, participantId: a } = i, o = e ? e[a] || [] : [], s = !!r.some((c) => o.includes(c));
    return { [n]: { participantGroups: o, includesGroupsToAvoid: s } };
  }));
}
function MB(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = XN(e);
  return r.map((a) => {
    let o = t.filter((u) => a.includes(u)), s = n(o), c = o.filter((u) => !s.includes(u)).filter((u) => {
      var l;
      let d = hT(u);
      return !((l = i[d]) != null && l.includesGroupsToAvoid);
    });
    return { unassigned: o, unpaired: s, pairedNoConflict: c };
  });
  function n(a) {
    return a.filter((s) => !o(s));
    function o(s) {
      let c = hT(s);
      return !a.includes(c);
    }
  }
}
function EB(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = XN(e);
  return r.map((n) => {
    let a = t.filter((c) => n.includes(c)), o = a.length === n.length ? a : [], s = n.filter((c) => {
      var u;
      return (u = i[c]) == null ? void 0 : u.includesGroupsToAvoid;
    }).length;
    return { unassigned: a, unpaired: o, pairedNoConflict: s ? [] : a, conflictsCount: s };
  });
}
function hT(e) {
  return Number(e % 2 ? e + 1 : e - 1);
}
function OB({ allGroups: e, participantId: t }) {
  return Object.keys(e).filter((r) => e[r].includes(t));
}
function CB({ selectedParticipantGroups: e, participantIdGroups: t, positionAssignments: r, drawPositionChunks: i, unfilledPositions: n, isRoundRobin: a }) {
  let o = i.map((s) => a ? EB({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }) : MB({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }));
  if (a) {
    let s = o.map((d) => d.map((l) => l.unassigned).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length).sort((d, l) => (l.length || 0) - (d.length || 0)), c = o.map((d) => d.map((l) => l.unpaired).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length), u = o.map((d) => d.map((l) => l.pairedNoConflict).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length).sort((d, l) => (l.length || 0) - (d.length || 0));
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  } else {
    let s = o.map((d) => d.map((l) => l.unassigned).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length), c = o.map((d) => d.map((l) => l.unpaired).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length), u = o.map((d) => d.map((l) => l.pairedNoConflict).filter((l) => l == null ? void 0 : l.length)).filter((d) => d == null ? void 0 : d.length);
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  }
}
function ZN({ positionAssignments: e, participantIds: t }) {
  let r = e.map((i) => i.participantId);
  return t.filter((i) => !r.includes(i));
}
function FB({ useSpecifiedGroupKey: e = !1, targetParticipantIds: t, largestFirst: r = !0, allGroups: i, groupKey: n }) {
  var u;
  let a = Object.assign({}, ...Object.keys(i).map((d) => [d, i[d].filter((l) => t.includes(l))]).filter((d) => d[1].length).map(([d, l]) => ({ [d]: l }))), o = Object.keys(a).reduce((d, l) => a[l].length > d ? a[l].length : d, 0), s = Object.keys(a).filter((d) => a[d].length === o), c = yi(r ? s : Object.keys(a));
  return n = e && ((u = a[n]) != null && u.length) ? n : c, { participantId: n && a[n] ? yi(a[n]) : yi(t), groupKey: n };
}
function kB({ drawPositionGroups: e, positionAssignments: t }) {
  let r = Object.assign({}, ...t.map((i) => ({ [i.drawPosition]: i })));
  return e.map((i) => i.filter(Boolean).map((n) => r[n]).filter(Boolean).filter((n) => !n.participantId && !n.bye).map((n) => n.drawPosition)).flat().filter(Boolean);
}
function LB({ candidatePositionAssignments: e, unseededParticipantIds: t, participantIdGroups: r, drawPositionChunks: i, drawPositionGroups: n, pairedPriority: a, allGroups: o, groupKey: s }) {
  let c = n.reduce((D, P) => P.length > D ? P.length : D, 0) <= 2, u = ZN({ positionAssignments: e, participantIds: t }), d = kB({ positionAssignments: e, drawPositionGroups: n }), { participantId: l, groupKey: p } = FB({ targetParticipantIds: u, useSpecifiedGroupKey: c, allGroups: o, groupKey: s }), f = OB({ participantId: l, allGroups: o }), m = CB({ positionAssignments: e, isRoundRobin: c, selectedParticipantGroups: f, participantIdGroups: r, drawPositionChunks: i, unfilledPositions: d }), { unassigned: h, unpaired: g, pairedNoConflict: I } = m, U = (I == null ? void 0 : I.length) && I[0], v = (g == null ? void 0 : g.length) && g[0], S = a && U ? U : v, T = a ? v : U, A = (S == null ? void 0 : S.length) && S || (T == null ? void 0 : T.length) && T, y;
  if (A != null && A.length) {
    let D = Di(A);
    y = Di(D);
  } else {
    let D = Di(h[0]);
    y = Di(D);
  }
  return { newGroupKey: p, selectedParticipantId: l, targetDrawPosition: y };
}
function Up({ isRoundRobin: e, groupedParticipants: t }) {
  let r = [];
  return e ? t.forEach((i) => {
    let n = i.map((s) => s.drawPosition), a = sU({ drawPositions: n }).uniqueMatchUpGroupings ?? [], o = Object.assign({}, ...i.map((s) => ({ [s.drawPosition]: s })));
    a.forEach((s) => {
      Jr(o[s[0]].values || [], o[s[1]].values || []) && (r.push(s), i.conflict = !0);
    });
  }) : t.forEach((i) => {
    var n, a;
    Jr(((n = i[0]) == null ? void 0 : n.values) || [], ((a = i[1]) == null ? void 0 : a.values) || []) && (r.push(i), i.conflict = !0);
  }), r;
}
function xB({ positionedParticipants: e, potentialDrawPositions: t, drawPositionGroups: r, avoidanceConflicts: i, isRoundRobin: n }) {
  return i.map((a) => {
    let o = a.map((s) => s.drawPosition);
    return a.filter((s) => t.includes(s.drawPosition)).map((s) => {
      let c = t.filter((u) => !(o != null && o.includes(u))).filter((u) => {
        let d = r.find((h) => h.includes(u)).find((h) => h !== u), l = e.find((h) => h.drawPosition === d), p = Up({ isRoundRobin: n, groupedParticipants: [[s, l]] }), f = [e.find((h) => h.drawPosition === u), l], m = Up({ isRoundRobin: n, groupedParticipants: [f] });
        return !p.length && !m.length;
      });
      if (c.length) return { drawPosition: s.drawPosition, possibleDrawPositions: c };
    }).filter(Boolean);
  }).flat(1);
}
function gT(e) {
  let { initialPositionAssignments: t, participantsWithGroupings: r, opponentsToPlaceCount: i, unseededByePositions: n, drawPositionGroups: a, policyAttributes: o, idCollections: s, allGroups: c } = e, u = [], d, l = Math.min(...(a || []).map((v) => v == null ? void 0 : v.length).filter(Boolean)), p = l > 2, f = ge(t, !1, !0).filter((v) => !v.qualifier), m = t.filter((v) => !v.participantId && (!v.bye || (n == null ? void 0 : n.includes(v.drawPosition)))).map((v) => v.drawPosition);
  fe(0, i).forEach(() => {
    let { newGroupKey: v, selectedParticipantId: S, targetDrawPosition: T } = LB({ ...e, candidatePositionAssignments: f, allGroups: c, groupKey: d });
    d = v, f.forEach((A) => {
      A.drawPosition === T && (A.participantId = S);
    });
  });
  let h = mT({ candidatePositionAssignments: f, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = gr(h, l), I = Up({ groupedParticipants: g, isRoundRobin: p }), U = 0;
  for (; U < 20 && I.length; ) {
    let v = xB({ positionedParticipants: h, potentialDrawPositions: m, avoidanceConflicts: I, drawPositionGroups: a, isRoundRobin: p });
    if (v.length) {
      let S = BB({ candidatePositionAssignments: f, swapOptions: v });
      S.error && console.log({ result: S }), h = mT({ candidatePositionAssignments: f, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = gr(h, l), I = Up({ groupedParticipants: g, isRoundRobin: p }), U++;
    } else U = 20;
  }
  return f.forEach((v) => {
    if (v.bye && v.participantId) {
      let S = mg;
      u.push(S);
    }
    if (v.qualifier && v.participantId) {
      let S = mg;
      u.push(S);
    }
  }), { positionAssignments: f, conflicts: I.length, groupedParticipants: g, errors: u };
}
function BB({ candidatePositionAssignments: e, swapOptions: t }) {
  let r = Di(t);
  if (!r) return { error: { message: "No swap options" } };
  let i = r.drawPosition, n = Di(r.possibleDrawPositions), a = e.find((u) => u.drawPosition === i), o = e.find((u) => u.drawPosition === n) ?? {}, s = { participantId: o == null ? void 0 : o.participantId, qualifier: o == null ? void 0 : o.qualifier, bye: o == null ? void 0 : o.bye }, c = { participantId: a.participantId, qualifier: a.qualifier, bye: a.bye };
  return Object.assign(a, s), Object.assign(o, c), { ...j };
}
function VB({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unseededByePositions: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: d, drawSize: l, event: p }) {
  var k;
  if (!d) return { error: sw };
  let { candidatesCount: f = 1, policyAttributes: m, targetDivisions: h } = d, { roundsToSeparate: g } = d, I = "randomUnseededSeparation", { structure: U } = Ne({ drawDefinition: a, structureId: u }), { matchUps: v } = ut({ provisionalPositioning: e, matchUpsMap: c, structure: U, event: p });
  if (h && Rn(h) && !g) {
    let L = RF(h) || 0, B = v.reduce((G, q) => q.roundNumber > G ? q.roundNumber : G, 0);
    g = B < L ? 1 : B - L + 1;
  }
  let { positionAssignments: S } = Ir({ structure: U }), T = fm({ participantsProfile: { convertExtensions: !0 }, deepCopy: !1, participants: s }).participantsWithGroupings, A = S == null ? void 0 : S.filter((L) => !L.participantId), y = S == null ? void 0 : S.map((L) => L.drawPosition), D = (U == null ? void 0 : U.structureType) === ri, P = D ? { structure: U, matchUps: v, allDrawPositions: y, roundsToSeparate: g } : { matchUps: v, allDrawPositions: y, roundsToSeparate: g }, { drawPositionGroups: w, drawPositionChunks: R } = D ? GB(P) : jB(P), b = { groupParticipants: s.filter((L) => L.participantType === Gi).map((L) => L.participantId), teamParticipants: s.filter((L) => L.participantType === lt).map((L) => L.participantId), pairParticipants: s.filter((L) => L.participantType === _e).map((L) => L.participantId) }, E = NB({ targetParticipantIds: t, policyAttributes: m, idCollections: b, participants: s });
  if (E.error) return W({ result: E, stack: I });
  let O = Object.assign({}, ...t.map((L) => {
    let B = Object.keys(E).filter((G) => (E[G] ?? []).includes(L));
    return { [L]: B };
  })), M = ZN({ participantIds: t, positionAssignments: S });
  if (M.length > ((A == null ? void 0 : A.length) || 0)) return { error: MI };
  let N, C = M.length, F = fe(0, f).map(() => gT({ initialPositionAssignments: S, participantsWithGroupings: T, unseededParticipantIds: t, opponentsToPlaceCount: C, pairedPriority: !1, unseededByePositions: i, participantIdGroups: O, drawPositionChunks: R, drawPositionGroups: w, policyAttributes: m, idCollections: b, allGroups: E, drawSize: l }));
  if (N = F.reduce((L, B) => !L || (B.conflicts || 0) < (L.conflicts || 0) ? B : L, void 0), !N || N.conflicts) {
    let L = fe(0, f).map(() => gT({ initialPositionAssignments: S, participantsWithGroupings: T, unseededParticipantIds: t, opponentsToPlaceCount: C, pairedPriority: !0, unseededByePositions: i, participantIdGroups: O, drawPositionChunks: R, drawPositionGroups: w, policyAttributes: m, idCollections: b, allGroups: E, drawSize: l }));
    N = F.concat(...L).filter((B) => {
      var G;
      return !((G = B.errors) != null && G.length);
    }).reduce((B, G) => !B || (G.conflicts || 0) < (B.conflicts || 0) ? G : B, void 0);
  }
  if (!N) return { error: xf };
  let x = (((k = gt({ structure: U })) == null ? void 0 : k.positionAssignments) ?? []).filter((L) => L.participantId).map((L) => L.participantId), V = N.positionAssignments.filter((L) => !x.includes(L.participantId));
  for (let L of V) if (L.bye) {
    let B = _i({ tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, event: p, ...L });
    if (B.error) return W({ result: B, stack: I });
  } else if (L.participantId) {
    let B = qn({ automaticPlacement: !0, inContextDrawMatchUps: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, event: p, ...L });
    if (B.error) return W({ result: B, stack: I, context: { assignment: L } });
  }
  return { ...j };
}
function GB(e) {
  let { structure: { structures: t } } = e, r = t.map((i) => i.positionAssignments.map((n) => n.drawPosition));
  return { drawPositionGroups: r, drawPositionChunks: [r] };
}
function jB({ allDrawPositions: e, roundsToSeparate: t, matchUps: r }) {
  let i = r.filter((d) => d.roundNumber === 1).map((d) => d.drawPositions), n = i.flat().sort(ar), a = Math.max(...n), o = e.filter((d) => d > a), s = n.length, c = fe(s === 2 ? 1 : 2, s).filter((d) => d === fI(d)), u = c.slice(0, t || c.length).reverse().map((d) => gr(n, d));
  return o.length && console.log({ fedDrawPositions: o }), { drawPositionGroups: i, drawPositionChunks: u };
}
function _B({ provisionalPositioning: e, inContextDrawMatchUps: t, unseededByePositions: r, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, structure: d, drawSize: l, event: p }) {
  var P, w;
  let f = "positionUnseededParticipants";
  d || ({ structure: d } = Ne({ drawDefinition: a, structureId: u })), u || ({ structureId: u } = d);
  let { positionAssignments: m } = Ir({ structure: d }), { seedAssignments: h } = Qi({ provisionalPositioning: e, drawDefinition: a, structure: d }), g = h == null ? void 0 : h.map((R) => R.participantId).filter(Boolean), { stage: I, stageSequence: U } = d, v = I === Pe ? (w = (P = We({ element: d, name: Kn })) == null ? void 0 : P.extension) == null ? void 0 : w.value : void 0, S = Fs({ provisionalPositioning: e, drawDefinition: a, stageSequence: U, entryStatuses: Yo, structureId: u, roundTarget: v, stage: I }), T = S.filter((R) => !(g != null && g.includes(R.participantId))).map((R) => R.participantId), A = m == null ? void 0 : m.filter((R) => !R.participantId && !R.bye && !R.qualifier).map((R) => R.drawPosition);
  if (!i && T.length > ((A == null ? void 0 : A.length) || 0)) return W({ result: { error: MI }, context: { unseededParticipantsCount: T.length, unfilledDrawPositionsCount: A == null ? void 0 : A.length }, stack: f });
  let { appliedPolicies: y } = nt({ tournamentRecord: n, drawDefinition: a, event: p }), D = y == null ? void 0 : y[cp];
  if (d.stage === Wt) {
    let R = S.reduce((b, E) => (b[E.groupingValue] || (b[E.groupingValue] = []), b[E.groupingValue].push(E.participantId), b), {});
    Object.keys(R).length && (D || (D = { policyName: "Playoff Avoidance" }), D.policyAttributes || (D.policyAttributes = []), D.policyAttributes.push({ groupings: R }));
  }
  return D && s ? VB({ provisionalPositioning: e, unseededParticipantIds: T, inContextDrawMatchUps: t, unseededByePositions: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: D, drawSize: l, entries: S }) : WB({ provisionalPositioning: e, unseededParticipantIds: T, inContextDrawMatchUps: t, unfilledDrawPositions: A, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, drawSize: l, event: p });
}
function WB({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unfilledDrawPositions: i, multipleStructures: n, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, matchUpsMap: c, structureId: u, drawSize: d, event: l }) {
  let p = d > 2 ? Xr(i) : i.reverse();
  for (let f of t) {
    let m = p.pop();
    if (!n || m) {
      let h = qn({ provisionalPositioning: e, inContextDrawMatchUps: r, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, participantId: f, drawPosition: m, matchUpsMap: c, structureId: u, event: l });
      if (h != null && h.error && console.log("!!!!!", { result: h }), h == null ? void 0 : h.error) return W({ result: h, stack: "randomUnseededDistribution" });
    }
  }
  return { ...j };
}
function qB(e) {
  let t = e.structure ?? Ne(e).structure, r = "positionQualifiers", i = [];
  if (t.stage === kr) return W({ result: { error: Vo }, stack: r });
  let { unplacedRoundQualifierCounts: n, positionAssignments: a, roundDrawPositions: o } = HB(e);
  for (let s of Object.keys(n)) {
    let c = a == null ? void 0 : a.filter((u) => o[s].includes(u.drawPosition) && !u.participantId && !u.qualifier && !u.bye).map((u) => u.drawPosition);
    if (n[s] > (c || 0)) return W({ result: { error: ww }, context: { unfilledDrawPositions: c }, stack: r });
    fe(0, n[s]).forEach(() => {
      let u = Di(c);
      i.push(u), a == null || a.forEach((d) => {
        d.drawPosition === u && (d.qualifier = !0, delete d.participantId, delete d.bye);
      });
    });
  }
  return { ...j, qualifierDrawPositions: i };
}
function HB({ drawDefinition: e, structure: t, structureId: r }) {
  t || ({ structure: t } = Ne({ drawDefinition: e, structureId: r })), r || ({ structureId: r } = t);
  let { positionAssignments: i } = Ir({ structure: t }), { stage: n, stageSequence: a } = t, { qualifiersCount: o, roundQualifiersCounts: s } = $c({ drawDefinition: e, stageSequence: a, structureId: r, stage: n }), c = (s ? Object.keys(s) : []).map((h) => be(h)), { matchUps: u } = ut({ structure: t }), { roundProfile: d } = $r({ matchUps: u }), l = Object.assign({}, ...c.filter((h) => d == null ? void 0 : d[h]).map((h) => {
    var g, I;
    return { [h]: ((I = (g = d == null ? void 0 : d[h]) == null ? void 0 : g.drawPositions) == null ? void 0 : I.filter(Boolean)) ?? [] };
  })), p = i == null ? void 0 : i.filter((h) => h.qualifier).map((h) => h.drawPosition), f = o - ((p == null ? void 0 : p.length) ?? 0), m = p == null ? void 0 : p.length;
  return { unplacedRoundQualifierCounts: Object.assign({}, ...c.map((h) => {
    let g = i == null ? void 0 : i.filter((I) => {
      var U, v;
      return I.qualifier && ((v = (U = l[h]) == null ? void 0 : U.drawPositions) == null ? void 0 : v.includes(I.drawPosition));
    }).map((I) => I.drawPosition);
    return { [h]: ((s == null ? void 0 : s[h]) ?? 0) - ((g == null ? void 0 : g.length) ?? 0) };
  })), unplacedQualifiersCount: f, placedQualifiersCount: m, roundQualifiersCounts: s, positionAssignments: i, roundDrawPositions: l, qualifiersCount: o };
}
function IT({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, appliedPolicies: i, validSeedBlocks: n, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, groupsCount: u, structureId: d, matchUpsMap: l, structure: p, event: f }) {
  let m = [], h = [], g = 0;
  if (p || ({ structure: p } = Ne({ drawDefinition: a, structureId: d })), d || (d = p == null ? void 0 : p.structureId), i || (i = nt({ drawDefinition: a }).appliedPolicies), !n) {
    let I = p && qs({ provisionalPositioning: e, appliedPolicies: i, drawDefinition: a, seedingProfile: o, structure: p });
    I != null && I.error && h.push(I.error), n = I == null ? void 0 : I.validSeedBlocks;
  }
  return u = u ?? (n == null ? void 0 : n.length) ?? 0, fe(0, u).forEach(() => {
    if (g < (u || 0)) {
      let I = YB({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, structureId: d, matchUpsMap: l, event: f });
      I != null && I.success && (g++, m.push(...I.seedPositions ?? [])), I.error && h.push({ seedPositionError: I.error });
    }
  }), h.length ? { error: h } : { ...j, seedPositions: m };
}
function YB({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, participants: o, structureId: s, matchUpsMap: c, event: u }) {
  let { unplacedSeedParticipantIds: d, unfilledPositions: l } = CN({ provisionalPositioning: e, randomize: !0, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, structureId: s, event: u }), { appliedPolicies: p } = nt({ drawDefinition: i }), { avoidance: f } = p ?? {};
  f && o && (d == null ? void 0 : d.length) > 2;
  let m = [];
  for (let h of d) {
    let g = l.pop();
    if (!g) return { error: Bc };
    m.push(g);
    let I = qn({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, participantId: h, seedBlockInfo: a, drawPosition: g, matchUpsMap: c, structureId: s, event: u });
    if (!I.success) return I;
  }
  return { ...j, seedPositions: m };
}
function zB({ provisionalPositioning: e, drawDefinition: t, structure: r }) {
  let { positionAssignments: i } = Ir({ structure: r }), { seedAssignments: n } = Qi({ provisionalPositioning: e, drawDefinition: t, structure: r }), a = Object.assign({}, ...(n || []).filter((o) => o.participantId).map((o) => ({ [o.participantId]: o })));
  return i == null ? void 0 : i.map((o) => a[o.participantId] ? { ...o, seedNumber: a[o.participantId].seedNumber, seedValue: a[o.participantId].seedValue } : "").filter(Boolean);
}
function KB({ orderedSortedFirstRoundSeededDrawPositions: e, validSeedBlocks: t, byesToPlace: r }) {
  let i = [];
  t.forEach((a) => {
    if (r - i.length > a.drawPositions.length) i.push(...a.drawPositions);
    else {
      let o = Vg(gr(a.drawPositions, 2)), s, c = e[i.length];
      for (; s = Yl(o, c); ) i.push(s), c = e[i.length];
    }
  });
  let n = i.map((a) => Array.isArray(a) ? Xr(a) : a).flat(1 / 0);
  return NP(r) && t.map((a) => a.seedNumbers[0]).includes(r) ? e : n;
}
function Yl(e, t) {
  if (Array.isArray(e) && e.length !== 2) return e.pop();
  if (!Array.isArray(e[0])) return e.includes(t) ? e.indexOf(t) ? e.pop() : e.shift() : Math.round(Math.random()) ? e.pop() : e.shift();
  let r = e[0].flat(1 / 0).length, i = e[1].flat(1 / 0).length;
  if (r === i) {
    let n = e[0].flat(1 / 0).includes(t) ? e[0] : e[1];
    return Yl(t ? n : e[Math.round(Math.random())], t);
  }
  return r < i ? Yl(e[1], t) : Yl(e[0], t);
}
function Vg(e) {
  let t = Math.floor(e.length / 2);
  return e.length > 2 ? [Vg(e.slice(0, t)), Vg(e.slice(t))] : e;
}
function XB({ provisionalPositioning: e, relevantMatchUps: t, appliedPolicies: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, byesToPlace: o, structure: s }) {
  var S;
  a || (a = qs({ provisionalPositioning: e, appliedPolicies: r, drawDefinition: i, seedingProfile: n, structure: s }));
  let { isFeedIn: c, isLuckyStructure: u, isContainer: d } = a, { validSeedBlocks: l } = a;
  (S = r == null ? void 0 : r.seeding) != null && S.containerByesIgnoreSeeding && (l = []);
  let p = zB({ provisionalPositioning: e, drawDefinition: i, structure: s }) ?? [], f = Be([].concat(...t.map((T) => T.drawPositions))), m = p.filter((T) => f.includes(T.drawPosition)), h = (T, A) => bc(T.seedValue) - bc(A.seedValue), g = l.reduce((T, A) => {
    let y = m.filter((D) => {
      var P;
      return (P = A.drawPositions) == null ? void 0 : P.includes(D.drawPosition);
    }).sort(h);
    return T.concat(...y);
  }, []).map((T) => T.drawPosition), I = KB({ orderedSortedFirstRoundSeededDrawPositions: g, validSeedBlocks: l, byesToPlace: o }), U = vT({ orderedSeedDrawPositions: g, relevantMatchUps: t }).slice(0, o), v = vT({ orderedSeedDrawPositions: I, relevantMatchUps: t }).slice(0, o);
  return { strictSeedOrderByePositions: U, blockSeedOrderByePositions: v, isLuckyStructure: u, positionedSeeds: p, isContainer: d, isFeedIn: c };
}
function vT({ orderedSeedDrawPositions: e, relevantMatchUps: t }) {
  let r = t.map((i) => i.drawPositions).map((i) => i == null ? void 0 : i.sort((n, a) => n - a)).filter((i) => (i == null ? void 0 : i[0]) + 1 === (i == null ? void 0 : i[1]));
  return e.map((i) => r.find((n) => n == null ? void 0 : n.includes(i))).filter(Boolean).map((i) => i == null ? void 0 : i.reduce((n, a) => e.includes(a) ? n : a, void 0)).filter(Boolean);
}
function ZB({ provisionalPositioning: e, seedOrderByePositions: t, isLuckyStructure: r, appliedPolicies: i, drawDefinition: n, seedLimit: a, structure: o, isFeedIn: s }) {
  var M, N;
  let c = (M = i == null ? void 0 : i.seeding) == null ? void 0 : M.seedingProfile, u = o.stage === Pe, { positionAssignments: d } = Ir({ structure: o }), l = d == null ? void 0 : d.filter((C) => C.participantId).map((C) => C.drawPosition), p = { isCollectionMatchUp: !1 }, { matchUps: f, roundMatchUps: m } = ut({ provisionalPositioning: e, matchUpFilters: p, structure: o }), h = (m == null ? void 0 : m[1]) || [], g = o.structureType === ri ? f : h, I = Be([].concat(...g.map((C) => C.drawPositions))), U = Math.min(...I) - 1, v = l == null ? void 0 : l.filter((C) => I.includes(C)), S = (C) => {
    let F = Math.ceil(C.length / 2), x = [C.slice(0, F), C.slice(F)], V = x.map((X) => [].concat(...X.flat(1 / 0)).length), k = Math.min(...V.flat(1 / 0)), L = Math.max(...V.flat(1 / 0)), B = V.indexOf(L), G = k !== L, q = Xr(x), [Y, H] = !k || G ? [x[B], x[1 - B]] : [q[0], q[1]];
    return { greaterHalf: Y, lesserHalf: H };
  }, T = (C) => {
    let { greaterHalf: F, lesserHalf: x } = S(C), { greaterHalf: V, lesserHalf: k } = S(F), L = Xr(V.flat(1 / 0)).pop(), B = V.flat().filter((G) => G !== L);
    return { newlyFilteredChunks: [...x, ...k, B], drawPosition: L };
  }, A = (C) => !t.includes(C), y = (C) => !(v != null && v.includes(C)), D = (C) => {
    let F = gr(C.sort(ar), Math.ceil(C.length / 4)).map((k) => k.filter(y)), x = [].concat(...F.flat(1 / 0)).length, V = [];
    for (let k = 0; k < x; k++) {
      let { newlyFilteredChunks: L, drawPosition: B } = T(F);
      V.push(B), F = L;
    }
    return V;
  }, { validSeedBlocks: P } = qs({ provisionalPositioning: e, allPositions: !0, appliedPolicies: i, drawDefinition: n, structure: o }), w = P == null ? void 0 : P.map((C) => {
    var F;
    return (F = C.drawPositions) == null ? void 0 : F.map((x) => x + U);
  }), R;
  if (s) {
    let C = I.length, { seedBlocks: F } = cU({ cluster: Hd(c) === JI, participantsCount: C });
    R = F.map((x) => x.map((V) => V + U)).map(D).filter((x) => x.length);
  } else u ? R = w == null ? void 0 : w.map((C) => C.filter(y)) : R = w == null ? void 0 : w.map(D).filter((C) => C.length);
  let b = g.map((C) => C.drawPositions).map((C) => C == null ? void 0 : C.sort((F, x) => F - x)).filter((C) => (C == null ? void 0 : C[0]) + 1 === (C == null ? void 0 : C[1])), E = (C) => b.reduce((F, x) => x.includes(C) ? x.reduce((V, k) => k !== C ? k : V, void 0) : F, void 0), O = R.map((C) => C.map(E)).flat(1 / 0).filter(y).filter(A).filter(Boolean);
  if (u && !o.structures) {
    let C = a % 4, F = O.slice(0, C), x = (N = m[o.roundLimit]) == null ? void 0 : N.length, V = gr(O.slice(C), x).map(Xr).flat();
    O = F.concat(V);
  }
  return { unseededByePositions: O };
}
function QB({ provisionalPositioning: e, drawDefinition: t, matchUpsMap: r, structure: i, event: n }) {
  var w;
  let a = { isCollectionMatchUp: !1 }, { matchUps: o, roundMatchUps: s } = ut({ afterRecoveryTimes: !1, provisionalPositioning: e, drawDefinition: t, matchUpFilters: a, matchUpsMap: r, structure: i, event: n }), c = (s == null ? void 0 : s[1]) || [], u = (i == null ? void 0 : i.structureType) === ri, d = u ? o : c, l = u ? ((w = i == null ? void 0 : i.structures) == null ? void 0 : w.length) || 0 : o.length, { structureId: p, stage: f, stageSequence: m } = i, h = Fs({ entryStatuses: yn, provisionalPositioning: e, drawDefinition: t, stageSequence: m, structureId: p, stage: f }), { qualifiersCount: g } = $c({ provisionalPositioning: e, drawDefinition: t, stageSequence: m, structureId: p, stage: f }), I = h.length + g, { positionAssignments: U, unassignedPositions: v } = Ir({ structure: i }), S = v == null ? void 0 : v.map((R) => R.drawPosition), T = U == null ? void 0 : U.filter((R) => R.bye).length, A = U == null ? void 0 : U.filter((R) => R.bye).map((R) => R.drawPosition), y = d.map((R) => R.drawPositions).filter((R) => R == null ? void 0 : R.reduce((b, E) => !(A != null && A.includes(E)) && b, !0)).flat(1 / 0).filter((R) => S == null ? void 0 : S.includes(R)), D = U == null ? void 0 : U.length, P = D ? D - I : 0;
  return P > l && i.stageSequence === 1 && i.stage !== kr && (P = l), { placedByes: T, byesCount: P, relevantMatchUps: d, placedByePositions: A, roundMatchUps: s, positionsToAvoidDoubleBye: y };
}
function UT({ provisionalPositioning: e, tournamentRecord: t, appliedPolicies: r, drawDefinition: i, seedBlockInfo: n, seedingProfile: a, matchUpsMap: o, structureId: s, structure: c, seedLimit: u, seedsOnly: d, event: l }) {
  var b;
  c || ({ structure: c } = Ne({ drawDefinition: i, structureId: s })), s || (s = c == null ? void 0 : c.structureId);
  let p = !((c == null ? void 0 : c.structures) ?? (c == null ? void 0 : c.stage) === Pe), { byesCount: f, placedByes: m, relevantMatchUps: h } = QB({ provisionalPositioning: e, drawDefinition: i, matchUpsMap: o, structure: c, event: l }), g = f - (m || 0);
  if (g <= 0) return { ...j };
  let { strictSeedOrderByePositions: I, blockSeedOrderByePositions: U, isLuckyStructure: v, isFeedIn: S } = XB({ provisionalPositioning: e, relevantMatchUps: h, appliedPolicies: r, drawDefinition: i, seedingProfile: a, seedBlockInfo: n, byesToPlace: g, structure: c }), T = (c == null ? void 0 : c.structureType) && [ri, Kf].includes(c.structureType) && ((b = r == null ? void 0 : r.seeding) == null ? void 0 : b.containerByesIgnoreSeeding), A = p && (U != null && U.length) ? U : I, { unseededByePositions: y } = ZB({ provisionalPositioning: e, seedOrderByePositions: A, isLuckyStructure: v, appliedPolicies: r, drawDefinition: i, seedLimit: u, structure: c, isFeedIn: S }), D = (E) => E % 2, P = (E, O) => (E || []).every((M) => D(M) ? O !== M + 1 : O !== M - 1), w = [].concat(...A);
  if (!d) for (; y.length; ) {
    let E = y.find((O) => P(w, O));
    E ? (w.push(E), y = y.filter((O) => O !== E)) : (w.push(...y), y = []);
  }
  T && (w = Xr(w), ki({ ignoreSeededByes: T }) && console.log({ byePositions: w }));
  let R = w.slice(0, g);
  for (let E of R) {
    let O = _i({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: i, drawPosition: E, matchUpsMap: o, structureId: s, structure: c, event: l });
    if (O != null && O.error) return O;
  }
  return { ...j, unseededByePositions: y, byeDrawPositions: R };
}
function Yd(e) {
  var M, N, C, F;
  let { drawDefinition: t } = e, { applyPositioning: r = !0, provisionalPositioning: i, multipleStructures: n, placeByes: a = !0, tournamentRecord: o, placementGroup: s, seedingProfile: c, structureId: u, seedLimit: d, seedsOnly: l, drawType: p, drawSize: f, event: m } = e, h = [];
  r || (Xw(), t = ge(t, !1, !0));
  let g = (x) => (r || Bl(), W({ result: x, stack: "automatedPositioning" })), I = (x) => (r || Bl(), x), U = Ne({ drawDefinition: t, structureId: u });
  if (U.error) return g(U);
  let v = U.structure;
  if (!v) return { error: kt };
  let S = e.appliedPolicies || ((M = nt({ drawDefinition: t, structure: v, event: m })) == null ? void 0 : M.appliedPolicies), { qualifiersCount: T } = $c({ stageSequence: v.stageSequence, provisionalPositioning: i, stage: v.stage, drawDefinition: t, structureId: u }), A = Yo;
  if (!((N = Fs({ stageSequence: v.stageSequence, provisionalPositioning: i, stage: v.stage, placementGroup: s, drawDefinition: t, entryStatuses: A, structureId: u })) != null && N.length) && !T) return I({ ...j });
  let y = e.matchUpsMap ?? xr({ drawDefinition: t }), D = e.inContextDrawMatchUps ?? ((C = ur({ inContext: !0, drawDefinition: t, matchUpsMap: y })) == null ? void 0 : C.matchUps), P = [], w = qs({ provisionalPositioning: i, appliedPolicies: S, drawDefinition: t, seedingProfile: c, structure: v });
  if (w.error) return w;
  let { validSeedBlocks: R } = w;
  h.push({ validSeedBlocks: R });
  let b = e.participants || (o ? (F = Lt({ withIndividualParticipants: !0, convertExtensions: !0, tournamentRecord: o })) == null ? void 0 : F.participants : []);
  if (Hd(v.seedingProfile || c) === Do) {
    let x = a ? UT({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: S, drawDefinition: t, seedBlockInfo: w, matchUpsMap: y, structure: v, seedLimit: d, seedsOnly: l, event: m }) : void 0;
    if (x != null && x.error) return g(x);
    P = x.unseededByePositions, h.push({ action: "positionByes", unseededByePositions: P });
    let V = v.seedingProfile ? { positioning: v.seedingProfile } : c;
    if (x = IT({ seedingProfile: V, provisionalPositioning: i, inContextDrawMatchUps: D, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: w, participants: b, matchUpsMap: y, structure: v, event: m }), x.error) return g(x);
    h.push({ seedPositions: x.seedPositions, action: "positionSeedBlocks" });
  } else {
    if (p !== Go) {
      let V = v.seedingProfile ? { positioning: v.seedingProfile } : c, k = IT({ seedingProfile: V, provisionalPositioning: i, inContextDrawMatchUps: D, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: w, participants: b, matchUpsMap: y, structure: v, event: m });
      if (k.error) return g(k);
      h.push({ action: "positionSeedBlocks", seedPositions: k.seedPositions });
    }
    let x = a ? UT({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: S, drawDefinition: t, seedBlockInfo: w, matchUpsMap: y, structure: v, seedLimit: d, seedsOnly: l, event: m }) : void 0;
    if (x != null && x.error) return g(x);
    P = x == null ? void 0 : x.unseededByePositions, h.push({ action: "positionByes", byeDrawPositions: x == null ? void 0 : x.byeDrawPositions, unseededByePositions: P });
  }
  let E = {};
  if (!l) {
    let x = qB({ inContextDrawMatchUps: D, tournamentRecord: o, appliedPolicies: S, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: w, participants: b, matchUpsMap: y, structure: v });
    if (x.error || (x.conflicts && (E.qualifierConflicts = x.conflicts), h.push({ action: "positionQualifiers", qualifierDrawPositions: x.qualifierDrawPositions }), x = _B({ provisionalPositioning: i, inContextDrawMatchUps: D, unseededByePositions: P, multipleStructures: n, tournamentRecord: o, drawDefinition: t, seedBlockInfo: w, participants: b, matchUpsMap: y, structureId: u, structure: v, drawSize: f, event: m }), x.error)) return g(x);
    x.conflicts && (E.unseededConflicts = x.conflicts), h.push({ action: "positionUnseededParticipants" });
  }
  let { positionAssignments: O } = gt({ drawDefinition: t, structure: v });
  return vt({ drawDefinition: t, structureIds: [u] }), r || Bl(), { positionAssignments: O, conflicts: E, ...j, positioningReport: h };
}
function ru(e) {
  var p;
  let { applyPositioning: t = !0, provisionalPositioning: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, placeByes: s, seedsOnly: c } = e;
  if (!n) return { error: Fi };
  if (!$a({ drawDefinition: n, structureId: o }) && !r) return { error: mI };
  let u = (p = zN({ drawDefinition: n, structureId: o }).playoffStructures) == null ? void 0 : p.sort((f, m) => pp(f) - pp(m)), d = [], l = [];
  if (u) for (let f of u) {
    let { structureId: m } = f, h = Yd({ structureId: m, provisionalPositioning: r, applyPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, placeByes: s, seedsOnly: c });
    if (h.error) return h;
    h.positionAssignments && d.push({ positionAssignments: h.positionAssignments, structureId: m }), h.positioningReport && l.push(h.positioningReport);
  }
  return { ...j, structurePositionAssignments: d, positioningReports: l };
}
function QN({ drawDefinition: e, orderMap: t }) {
  return e ? ((typeof t != "object" || !Object.values(t).every((r) => ke(r))) && W({ result: { error: ie }, context: { orderMap: t } }), e.structures || (e.structures = []), e.structures.forEach((r) => {
    let i = t[r.structureId];
    i && (r.structureOrder = i);
  }), e.structures.sort((r, i) => lc(r.structureOrder) - lc(i.structureOrder)), { ...j }) : { error: Ue };
}
function bm({ drawDefinition: e }) {
  var g, I, U, v, S, T, A;
  let t = e.structures ?? [], r = e.links ?? [], i = /* @__PURE__ */ new Map(), n = (y) => {
    let D = i.get(y) || i.set(y, { drawSources: [], drawTargets: [], progeny: [], sources: [], targets: [] }) && i.get(y);
    if (D && !(D != null && D.stage)) {
      let P = t.find((w) => w.structureId === y);
      D.stage = P == null ? void 0 : P.stage;
    }
    return D;
  }, a = {}, o = {}, s = r.map((y) => {
    let D = y.source.structureId, P = y.target.structureId, w = n(D), R = n(P);
    return [Po, dn, Xf, Do].includes(y.target.feedProfile) ? (w == null || w.targets.push(P), R == null || R.sources.push(D)) : y.target.feedProfile === sn && (R == null || R.drawSources.push(D), w == null || w.drawTargets.push(P)), o[P] = o[P] || y.target.feedProfile === sn, a[P] = Be([...a[P] || [], D]).filter(Boolean), [y.source.structureId, y.target.structureId];
  });
  for (let y of i.keys()) {
    let D = i.get(y);
    if (D) {
      let P = D.targets ?? [];
      for (; P.length; ) {
        let w = P.pop(), R = w && i[w];
        (g = R == null ? void 0 : R.targets) != null && g.length ? P.push(...R.targets) : R && (D.rootStage = R.stage);
      }
      if (D.rootStage || (D.rootStage = D.stage), !((I = D.targets) != null && I.length)) {
        let w = D.sources ?? [];
        for (; w.length; ) {
          let R = w.pop(), b = R && i[R];
          if ((U = b == null ? void 0 : b.sources) != null && U.length) {
            for (let E of b.sources) (v = D.progeny) != null && v.includes(E) || ((S = D.progeny) == null || S.push(E));
            w.push(...b.sources);
          }
        }
      }
    }
  }
  let c = 0;
  for (let y of i.keys()) {
    let D = i.get(y);
    if (D && D.rootStage === Pe) {
      let P = [(T = D.drawTargets) == null ? void 0 : T[0]], w = 0;
      for (; P.length; ) {
        w += 1;
        let R = P.pop(), b = R ? i.get(R) : void 0;
        (A = b == null ? void 0 : b.drawTargets) != null && A.length && P.push(b.drawTargets[0]);
      }
      D.distanceFromMain = w, w > c && (c = w);
    }
  }
  let u = s.length;
  fe(0, Math.ceil(u / 2)).forEach(() => {
    s = fe(0, u).map((y) => {
      let D = s[y], P = s.reduce((w, R) => Jr(D, R) ? w.concat(...R) : w, []) || [];
      return Be(D.concat(...P));
    });
  });
  let d = s[0], l = (y, D) => qt(y, D).length === y.length, p = s.slice(1).reduce((y, D) => y && l(D, d), !0), f = [d].filter(Boolean), m = [d].filter(Boolean);
  t.forEach((y) => {
    let { structureId: D, stage: P } = y;
    f.find((w) => w.includes(D)) || (f.push([D]), P !== yr && m.push([D]));
  });
  let h = p && m.length === 1;
  return !(r != null && r.length) && t.length === 1 && n(t[0].structureId), { structureProfiles: Object.fromEntries(i), allStructuresLinked: h, maxQualifyingDepth: c, sourceStructureIds: a, hasDrawFeedProfile: o, structureGroups: f };
}
function JN({ drawDefinition: e }) {
  let { maxQualifyingDepth: t, structureProfiles: r } = bm({ drawDefinition: e });
  for (let i of e.structures) {
    let n = r[i.structureId];
    n.distanceFromMain && (i.stageSequence = t + 1 - n.distanceFromMain);
  }
  return { ...j };
}
function IU(e) {
  let t = Ae(e, [{ [fr]: !0, [ii]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, drawDefinition: i, structure: n, link: a } = e;
  return JB({ tournamentId: r.tournamentId, drawDefinition: i, structure: n, link: a });
}
function JB(e) {
  var d;
  let t = Ae(e, [{ [ii]: !0, [em]: !0 }, { link: !0, [ui]: pi, [xP]: UI }]);
  if (t.error) return t;
  let { drawDefinition: r, tournamentId: i, structure: n, eventId: a, link: o } = e, s = o.target.structureId, c = Ne({ drawDefinition: r, structureId: s });
  if (c.error) return W({ stack: "attachQualifyingStructure", context: { targetStructureId: s }, result: c });
  r.structures || (r.structures = []), r.links || (r.links = []), r.structures.push(n), r.links.push(o), JN({ drawDefinition: r });
  let u = ((d = ut({ structure: n })) == null ? void 0 : d.matchUps) || [];
  return Za({ drawDefinition: r, tournamentId: i, matchUps: u, eventId: a }), vt({ drawDefinition: r, structureIds: [n.structureId] }), { ...j };
}
function $N({ drawDefinition: e, structureDetails: t }) {
  if (!Array.isArray(t)) return { error: ie };
  if (!e) return { error: Ue };
  let r = Object.assign({}, ...t.map((i) => {
    if (!$e(i)) return;
    let { structureId: n, structureName: a } = i || {};
    if (!(!n || !a)) return { [n]: a };
  }).filter(Boolean));
  if (!Object.values(r).length) return { error: we };
  for (let i of e.structures || []) {
    let n = r[i.structureId];
    if (n && (i.structureName = n), i.structures) for (let a of i.structures) {
      let o = r[a.structureId];
      o && (a.structureName = o);
    }
  }
  return { ...j };
}
function vU({ drawDefinition: e, timeItem: t }) {
  if (!e) return { error: Fi };
  if (!t) return { error: FI };
  let r = t && Object.keys(t), i = ["itemType", "itemValue"];
  if (i.filter((a) => r.includes(a)).length !== i.length) return { error: CI };
  e.timeItems || (e.timeItems = []);
  let n = (/* @__PURE__ */ new Date()).toISOString();
  return Object.assign(t, { createdAt: n }), e.timeItems.push(t), Ad({ drawDefinition: e }), { ...j };
}
function eM(e) {
  var I;
  let { tournamentRecord: t, drawDefinition: r, structureId: i, event: n } = e, a = Ae(e, [{ drawDefinition: !0, structureId: !0 }]);
  if (a.error) return a;
  let o = r.structures ?? [], s = o.find((U) => U.structureId === i);
  if (!s) return { error: kt };
  let c = o.find(({ stage: U, stageSequence: v }) => U === Ie && v === 1), u = i === (c == null ? void 0 : c.structureId), d = o.filter(({ stage: U }) => U === Pe).map(Ni("structureId"));
  if (u && !d.length) return { error: VP };
  let l = d.includes(i), p = $B({ isQualifyingStructure: l, structure: s, ...e });
  if (p != null && p.error) return p;
  let { structureIdsToRemove: f, relatedStructureIdsMap: m } = tV({ qualifyingStructureIds: d, isQualifyingStructure: l, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureId: i }), { removedMatchUpIds: h, removedStructureIds: g } = rV({ relatedStructureIdsMap: m, qualifyingStructureIds: d, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureIdsToRemove: f, structureId: i });
  if (eV({ removedMatchUpIds: h, drawDefinition: r }), u) {
    let U = (I = c.matchUps ?? []) == null ? void 0 : I.map(Ni("matchUpId"));
    h.push(...U), c.positionAssignments = [], c.seedAssignments = [], c.matchUps = [], c.extensions && (c.extensions = []);
  }
  return l && JN({ drawDefinition: r }), Ca({ tournamentId: t == null ? void 0 : t.tournamentId, matchUpIds: h, action: "removeStructure", eventId: n == null ? void 0 : n.eventId, drawDefinition: r }), vt({ drawDefinition: r, eventId: n == null ? void 0 : n.eventId }), { ...j, removedMatchUpIds: h, removedStructureIds: g };
}
function $B({ isQualifyingStructure: e, tournamentRecord: t, drawDefinition: r, structureId: i, structure: n, event: a, force: o }) {
  var c, u, d, l, p, f;
  let s = [i];
  if (e) {
    let m = (g) => {
      var I;
      return (I = r.links) == null ? void 0 : I.find((U) => U.target.structureId === g);
    }, h = (c = m(i)) == null ? void 0 : c.source.structureId;
    for (; h; ) s.push(h), h = (u = m(h)) == null ? void 0 : u.source.structureId;
  }
  if ((d = ur({ matchUpFilters: { structureIds: s }, drawDefinition: r }).matchUps) != null && d.some(({ score: m }) => pr({ score: m }))) {
    let m = (l = nt({ tournamentRecord: t, drawDefinition: r, structure: n, event: a })) == null ? void 0 : l.appliedPolicies;
    if (!(o ?? ((f = (p = m == null ? void 0 : m[En]) == null ? void 0 : p.allowDeletionWithScoresPresent) == null ? void 0 : f.structures))) return { error: jf };
  }
  return { ...j };
}
function eV({ removedMatchUpIds: e, drawDefinition: t }) {
  let { matchUps: r } = ur({ drawDefinition: t });
  r == null || r.forEach((i) => {
    i.winnerMatchUpId && e.includes(i.winnerMatchUpId) && delete i.winnerMatchUpId, i.loserMatchUpId && e.includes(i.loserMatchUpId) && delete i.loserMatchUpId;
  });
}
function tV({ qualifyingStructureIds: e, isQualifyingStructure: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureId: a }) {
  let o = (n.structures ?? []).map(Ni("structureId")), s = (d) => {
    var l;
    return ((l = n.links) == null ? void 0 : l.map((p) => p.source.structureId === d && p.target.structureId !== (i == null ? void 0 : i.structureId) && p.target.structureId).filter(Boolean)) ?? [];
  }, c = (d) => {
    var l;
    return ((l = n.links) == null ? void 0 : l.map((p) => e.includes(p.source.structureId) && p.target.structureId === d && p.source.structureId).filter(Boolean)) ?? [];
  }, u = /* @__PURE__ */ new Map();
  return o.forEach((d) => u.set(d, t ? c(d) : s(d))), { structureIdsToRemove: r ? u.get(a) : [a], relatedStructureIdsMap: u };
}
function rV({ relatedStructureIdsMap: e, qualifyingStructureIds: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureIdsToRemove: a, structureId: o }) {
  let s = [], c = [];
  for (; a != null && a.length; ) {
    let u = a.pop();
    c.push(...aV({ idBeingRemoved: u, drawDefinition: n }));
    let d = nV({ qualifyingStructureIds: t, isMainStageSequence1: r, idBeingRemoved: u, drawDefinition: n, structureId: o });
    s.push(...d.removedStructureIds);
    let l = iV({ relatedStructureIdsMap: e, mainStageSequence1: i, idBeingRemoved: u, structureId: o });
    l != null && l.length && a.push(...l);
  }
  return { removedMatchUpIds: c, removedStructureIds: s };
}
function iV({ idBeingRemoved: e, relatedStructureIdsMap: t, mainStageSequence1: r, structureId: i }) {
  var n;
  return e && ((n = t.get(e)) == null ? void 0 : n.filter((a) => a !== (r == null ? void 0 : r.structureId) || i === r.structureId));
}
function nV({ qualifyingStructureIds: e, isMainStageSequence1: t, idBeingRemoved: r, drawDefinition: i, structureId: n }) {
  var o;
  let a = [];
  return i.links = ((o = i.links) == null ? void 0 : o.filter((s) => s.source.structureId !== r && s.target.structureId !== r)) ?? [], (!t || t && e.length || r !== n) && (i.structures = (i.structures ?? []).filter((s) => (r && r === s.structureId && a.push(r), s.structureId !== r))), { removedStructureIds: a };
}
function aV({ idBeingRemoved: e, drawDefinition: t }) {
  let { structure: r } = Ne({ structureId: e, drawDefinition: t }), i = ut({ structure: r }).matchUps;
  return vv(i);
}
function Sp({ stageSequence: e = 1, drawDefinition: t, drawSize: r, stage: i }) {
  if (!t) return { error: Ue };
  if (!Wv({ drawDefinition: t, stage: i })) return { error: Vo };
  let n = ox({ drawDefinition: t, stage: i }), { qualifiersCount: a } = $c({ drawDefinition: t, stageSequence: e, stage: i }), o = n + a;
  if (r < o) return { error: vI };
  let { entryProfile: s } = jv({ attributes: [{ [i]: { drawSize: r } }], drawDefinition: t });
  return vt({ drawDefinition: t }), { ...j, entryProfile: s };
}
function tM({ qualifiersCount: e = 0, drawDefinition: t, stage: r }) {
  return t ? Wv({ drawDefinition: t, stage: r }) ? r !== Ie ? { error: vI, info: "qualifiersCount can only be set for main stage" } : (jv({ attributes: [{ [r]: { qualifiersCount: e } }], drawDefinition: t }), vt({ drawDefinition: t }), { ...j }) : { error: Vo } : { error: Ue };
}
function oV({ drawDefinition: e, drawSize: t }) {
  if (!e) return { error: Ue };
  let r = Sp({ stage: yr, stageSequence: 1, drawDefinition: e, drawSize: t });
  return r.error ? r : (vt({ drawDefinition: e }), { ...j });
}
function rM(e) {
  return oV(e);
}
var sV = "qualifierDrawPositionAssignment", cV = "withdrawParticipantAtDrawPosition", uV = "alternateDrawPositionAssignment", dV = "luckyLoserDrawPositionAssignment", ST = "removeDrawPositionAssignment", iM = "swapDrawPositionAssignments", lV = "modifyPairAssignment", pV = "adHocPositionSwap", fV = "modifyParticipantOtherName", yT = "assignDrawPosition", mV = "removeSeededParticipant", hV = "assignDrawPositionBye", gV = "modifySeedAssignment", nM = "addPenalty", UU = "MODIFY_PAIR", Nm = "QUALIFIER", SU = "ALTERNATE", yU = "WITHDRAW", ys = "ASSIGN", Gg = "REMOVE", AU = "LUCKY", zl = "REMOVE_SEED", Mm = "SWAP", yp = "NICKNAME", bu = "SEED_VALUE", Mc = "PENALTY", Ap = "BYE", IV = { MODIFY_PAIR_ASSIGNMENT: UU, QUALIFYING_PARTICIPANT: Nm, ALTERNATE_PARTICIPANT: SU, WITHDRAW_PARTICIPANT: yU, ASSIGN_PARTICIPANT: ys, LUCKY_PARTICIPANT: AU, REMOVE_ASSIGNMENT: Gg, SWAP_PARTICIPANTS: Mm, ADD_NICKNAME: yp, REMOVE_SEED: zl, ADD_PENALTY: Mc, ASSIGN_BYE: Ap, SEED_VALUE: bu };
function aM({ tournamentRecord: e, drawDefinition: t, drawPositions: r, structureId: i, event: n }) {
  if (!t) return { error: Ue };
  if (!i) return { error: Vi };
  if ((r == null ? void 0 : r.length) !== 2) return { error: ie, drawPositions: r };
  let a = xr({ drawDefinition: t }), { matchUps: o } = ur({ inContext: !0, drawDefinition: t, matchUpsMap: a }), { structure: s } = Ne({ drawDefinition: t, structureId: i });
  if (!s) return { error: kt };
  let c = nt({ tournamentRecord: e, drawDefinition: t, event: n }).appliedPolicies ?? {}, u;
  if (s.structureType === ri ? u = SV({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }) : u = vV({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }), u.error) return u;
  if (Lv({ structure: s, drawPositions: r }), lm({ appliedPolicies: c, drawDefinition: t, positionAction: { name: iM, drawPositions: r, structureId: i } }), Qa({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t, structure: s, event: n }), n.eventType === bi) {
    let d = ut({ matchUpFilters: { matchUpTypes: [Ci] }, inContext: !0, structure: s }).matchUps.filter((p) => {
      var f;
      return (f = p.drawPositions) == null ? void 0 : f.some((m) => r.includes(m));
    }), l = ut({ matchUpFilters: { matchUpTypes: [Ci] }, structure: s }).matchUps;
    d.forEach((p) => {
      (p.sides || []).forEach((f) => {
        var h;
        let m = f == null ? void 0 : f.drawPosition;
        if (r.includes(m)) {
          let g = f.participantId, I = l.find(({ matchUpId: v }) => v === p.matchUpId), U = (h = p == null ? void 0 : p.sides) == null ? void 0 : h.reduce((v, S, T) => S.drawPosition === m ? T : v, void 0);
          lU({ inContextTargetMatchUp: p, drawPositionSideIndex: U, teamParticipantId: g, tournamentRecord: e, drawDefinition: t, matchUp: I, event: n });
        }
      });
    });
  }
  return vt({ drawDefinition: t, structureIds: [i] }), { ...j };
}
function vV({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  let s = a == null ? void 0 : a.positionAssignments.filter((u) => i == null ? void 0 : i.includes(u.drawPosition));
  if (!s) return { error: ie, structure: a, info: "Missing positionAssignments" };
  if (s.filter(({ bye: u }) => u).length === 2) return { ...j };
  if (s.filter(({ qualifier: u }) => u).length === 2) return { ...j };
  let c = s.some(({ qualifier: u }) => u);
  return s.some(({ bye: u }) => u) && !c ? oM({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o }) : UV({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
}
function oM({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = i.find(({ bye: m }) => m), c = i.find(({ participantId: m }) => m), u = s.drawPosition, { participantId: d, drawPosition: l } = c, { structureId: p } = a, f = Xu({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n });
  return f.error || (f = Xu({ drawPosition: l, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n }), f.error) || (_i({ drawPosition: l, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n, event: o }), f = qn({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, participantId: d, matchUpsMap: n, event: o }), f.error) ? f : { ...j };
}
function UV({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = Object.assign({}, ...i.map((c, u) => {
    let { drawPosition: d } = c, l = { ...i[1 - u], drawPosition: d };
    return { [d]: l };
  }));
  return a.positionAssignments = a.positionAssignments.map((c) => s[c.drawPosition] || c), fU({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: i, structure: a, event: o }), { ...j };
}
function SV({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  var u;
  let s = (u = a.structures) == null ? void 0 : u.reduce((d, l) => {
    let p = l == null ? void 0 : l.positionAssignments.filter((f) => i == null ? void 0 : i.includes(f.drawPosition));
    return p && d.push(...p), d;
  }, []);
  if (s.filter(({ bye: d }) => d).length === 2) return { ...j };
  if (s.filter(({ qualifier: d }) => d).length === 2) return { ...j };
  fU({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: s, structure: a, event: o });
  let c = s.some(({ qualifier: d }) => d);
  if (s.some(({ bye: d }) => d) && !c) oM({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
  else {
    let d = ge(s, !1, !0);
    s.forEach((l, p) => {
      let f = d[1 - p].participantId;
      l.qualifier = d[1 - p].qualifier, l.participantId = f;
    });
  }
  return { ...j };
}
function sM({ tournamentRecord: e, drawDefinition: t, participantId: r, structureId: i }) {
  var o;
  let n = "removeSeededParticipant";
  if (!e) return { error: de };
  if (!t) return { error: Ue };
  let a = (t.structures ?? []).find((s) => s.structureId === i);
  return a ? !a.stage || ![Ie, Pe].includes(a.stage) || a.stage === Ie && a.stageSequence !== 1 ? W({ result: { error: xo }, stack: n }) : (o = a.seedAssignments) != null && o.find((s) => s.participantId === r) ? { ...j } : W({ info: "participant not seeded", result: { error: Tr }, context: { participantId: r } }) : W({ result: { error: kt }, stack: n });
}
function zd({ targetEntryRound: e = 1, finishingPositions: t, sourceRoundNumber: r, sourceStructureId: i, targetStructureId: n, linkType: a = Ta }) {
  return !i || !n ? { error: Vi } : { link: ye({ linkType: a, source: { roundNumber: r, structureId: i, finishingPositions: t }, target: { feedProfile: sn, roundNumber: e, structureId: n } }) };
}
function TU({ roundPosition: e, roundNumber: t, idPrefix: r, uuids: i }) {
  return r ? `${r}-${t}-${e}` : (i == null ? void 0 : i.pop()) || st();
}
function Tp({ includeMatchUpType: e, matchUpType: t, roundNumber: r, matchUps: i, idPrefix: n, isMock: a, uuids: o, nodes: s }) {
  let c = 0, u = [], d = 1, l = r - 1, p = s == null ? void 0 : s.length;
  for (; c < (p || 0); ) {
    let f = s == null ? void 0 : s[c], m = s == null ? void 0 : s[c + 1];
    l && (f.roundNumber = l), m && l && (m.roundNumber = l);
    let h = TU({ roundPosition: d, roundNumber: r, idPrefix: n, uuids: o }), g = { roundPosition: d, children: [f, m], matchUpId: h };
    u.push(g);
    let I = { drawPositions: g.children.map((U) => U == null ? void 0 : U.drawPosition).filter(Boolean), matchUpStatus: Xt, matchUpId: g.matchUpId, roundPosition: d, roundNumber: r };
    e && t && (I.matchUpType = t), a && (I.isMock = !0), i.push(I), d++, c += 2;
  }
  return { roundNodes: u, matchUps: i };
}
function Hn({ finishingPositionOffset: e, finishingPositionLimit: t, qualifyingRoundNumber: r, qualifyingPositions: i, matchUpType: n, roundLimit: a, idPrefix: o, drawSize: s, isMock: c, uuids: u }) {
  if (isNaN(s) || s < 2 || i && s <= i) return { matchUps: [], roundsCount: 0 };
  if (i && (!Rn(s) || s % i)) {
    let g = i;
    for (; g < s; ) g = 2 * g;
    s = g;
  }
  let d = i && !(s % 2) && (!isNaN(i) || r && !isNaN(r)) && (s / i === Math.round(s / i) || r && s / r === Math.round(s / r));
  if (!Rn(s) && !d) return { matchUps: [], roundsCount: 0 };
  let l = fe(1, s + 1).map((g) => ({ drawPosition: g })), p, f = [], m = 1;
  for ({ roundNodes: p, matchUps: f } = Tp({ matchUpType: n, roundNumber: m, idPrefix: o, matchUps: f, isMock: c, nodes: l, uuids: u }), m++, a = a ?? r; p.length > 1; ) i && p.length === i && (a = m - 1), { roundNodes: p, matchUps: f } = Tp({ nodes: p, matchUpType: n, roundNumber: m, idPrefix: o, matchUps: f, isMock: c, uuids: u }), m++;
  let h = m - 1;
  return f = Ld({ finishingPositionOffset: e, finishingPositionLimit: t, roundsCount: h, roundLimit: a, matchUps: f }), a ? f = f.filter((g) => a && (g.roundNumber ?? 0) <= a) : a = m - 1, { drawSize: s, matchUps: f, roundsCount: h, roundLimit: a };
}
function DU(e) {
  var F, x, V, k, L, B;
  let t = "generateQualifyingStructure";
  if (!e.drawDefinition) return W({ result: { error: Ue }, stack: t });
  if (e.drawSize && !ke(e.drawSize) || e.participantsCount && !ke(e.participantsCount) || e.qualifyingPositions && !ke(e.qualifyingPositions)) return W({ result: { error: ie }, stack: t });
  let r = e.drawSize ?? pI(e.participantsCount), { qualifyingRoundNumber: i, qualifyingPositions: n, targetStructureId: a, structureOptions: o, appliedPolicies: s, drawDefinition: c, matchUpFormat: u, structureName: d, structureId: l, roundTarget: p, drawType: f, idPrefix: m, isMock: h, uuids: g } = e;
  if (!e.drawSize) return W({ result: { error: od }, context: { drawSize: r }, stack: t });
  if (n && n >= e.drawSize) return W({ result: { error: ie }, context: { drawSize: r, qualifyingPositions: n }, stack: t });
  let I, U, v, S, T = 0, A, y = 1, { structureProfiles: D } = bm({ drawDefinition: c }), P = D[a];
  if (!P) return W({ result: { error: kt }, context: { targetStructureId: a }, stack: t });
  let w = c.matchUpType, R = p ? `${p}-` : "", b = P.stage === Pe, E = ((x = (F = s == null ? void 0 : s[Tc]) == null ? void 0 : F.namingConventions) == null ? void 0 : x.pre) ?? ((k = (V = dx[Tc]) == null ? void 0 : V.namingConventions) == null ? void 0 : k.pre), O = b && E ? `${E}-` : "", M = d ?? (R ? `${O}${Fr(Pe)} ${R}` : `${O}${Fr(Pe)}`);
  if (f === hn) {
    let { maxRoundNumber: G, structures: q, groupCount: Y } = Wd({ structureName: d ?? M, structureId: l ?? (g == null ? void 0 : g.pop()), stage: Pe, structureOptions: o, appliedPolicies: s, stageSequence: y, matchUpType: w, roundTarget: p, idPrefix: m, drawSize: r, isMock: h, uuids: g });
    T = Y, I = G, v = q[0], A = [1];
  } else ({ drawSize: r, matchUps: S, roundLimit: I, roundsCount: U } = Hn({ qualifyingRoundNumber: i, qualifyingPositions: n, matchUpType: w, idPrefix: m, drawSize: r, isMock: h, uuids: g })), I || (I = U), v = zi({ structureName: d ?? M, structureId: l ?? (g == null ? void 0 : g.pop()), qualifyingRoundNumber: I, stage: Pe, matchUpFormat: u, stageSequence: y, matchUpType: w, roundLimit: I, matchUps: S }), p && it({ extension: { name: Kn, value: p }, element: v }), T = (L = S == null ? void 0 : S.filter((G) => G.roundNumber === I)) == null ? void 0 : L.length;
  let N = f === hn ? Aa : Ta, C = v && I && ((B = zd({ sourceStructureId: v.structureId, sourceRoundNumber: I, targetStructureId: a, finishingPositions: A, linkType: N })) == null ? void 0 : B.link);
  return { qualifyingDrawPositionsCount: r, qualifiersCount: T, ...j, structure: v, link: C };
}
function cM(e) {
  if (!e.tournamentRecord) return { error: de };
  let t = yV(e);
  return t.error, t;
}
function yV(e) {
  if (!e.drawDefinition) return { error: Ue };
  if (!e.targetStructureId) return { error: Vi };
  let t = DU(e);
  if (t.error) return t;
  let { structure: r, link: i } = t;
  return !r || !i ? { error: ie } : IU({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, structure: r, link: i });
}
function uM(e) {
  var l;
  let t = Ae(e, [{ [ii]: !0, [Qf]: !0, [zn]: !0 }, { [fL]: !0, [Or]: (p) => Number.isInteger(p) && p > 0 }, { [Or]: (p) => Array.isArray(p) && p.length === 2 && p.every(Et), [xi]: Pi, participantIds: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, structureId: i, tournamentRecord: n, event: a } = e, { structure: o } = Ne({ drawDefinition: r, structureId: i });
  if (!o) return { error: kt };
  if (!si({ structure: o })) return { error: xo };
  let s = (p) => {
    var f;
    return (f = p.sides) == null ? void 0 : f.map((m) => m.participantId).some((m) => e.participantIds.includes(m));
  }, c = (p) => p.roundNumber === e.roundNumber, u = (p) => !pr(p), d = ((o == null ? void 0 : o.matchUps) ?? []).filter(c).filter(u).filter(s);
  if (d.length !== 2) return { error: Pi };
  for (let p of d) {
    let f = (l = p == null ? void 0 : p.sides) == null ? void 0 : l.find((m) => e.participantIds.includes(m == null ? void 0 : m.participantId));
    if (f) {
      let m = e.participantIds.find((h) => h !== (f == null ? void 0 : f.participantId));
      f.participantId = m, Qe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: a == null ? void 0 : a.eventId, drawDefinition: r, matchUp: p });
    }
  }
  return vt({ drawDefinition: r, structureIds: [i] }), { ...j };
}
function AV({ includeMatchUpType: e, drawPosition: t, roundNumber: r, matchUpType: i, idPrefix: n, matchUps: a, isMock: o, uuids: s, nodes: c, fed: u }) {
  let d = c.length, l = t ? t - d : void 0, p = fe(0, d).map((h) => l ? l + h : void 0), f = [];
  for (let h = 0; h < d; h++) {
    let g = p.shift(), I = { drawPosition: g, fed: u + 1, feed: !0 }, U = c[h];
    U.roundNumber = r - 1;
    let v = TU({ roundPosition: U.roundPosition, roundNumber: r, idPrefix: n, uuids: s }), S = { roundPosition: U.roundPosition, drawPositions: [g], matchUpStatus: Xt, roundNumber: r, matchUpId: v };
    e && (S.matchUpType = i), o && (S.isMock = !0), a.push(S);
    let T = { children: [U, I] };
    f.push(T);
  }
  let m = t ? t - d : void 0;
  return { roundNodes: f, matchUps: a, drawPosition: m };
}
function eo(e) {
  let t = e.drawSize, { feedRoundsProfile: r, feedRounds: i = 0, skipRounds: n = 0, baseDrawSize: a } = e, { linkFedFinishingRoundNumbers: o, finishingPositionOffset: s, linkFedRoundNumbers: c, feedsFromFinal: u, isConsolation: d, matchUpType: l, idPrefix: p, isMock: f, uuids: m, fmlc: h } = e;
  a = a ?? O(t);
  let g = TV({ drawSize: a }), I = g.length, U = 0;
  if (r != null && r.length) U = r.reduce((M, N) => M + N, 0);
  else if (t) {
    let M = t - a;
    r = g.filter((N) => N <= M ? (M -= N, !0) : !1), U = r.reduce((N, C) => N + C, 0), i = r.length;
  } else n >= I ? i = 0 : u && (i = I - u, n = 0), r = g.filter((M, N) => u && !i || i && N >= n + i || N < n ? 0 : M), U = r.reduce((M, N) => M + N, 0), i = r.length;
  let v = [...g, ...r].sort((M, N) => N - M), S = v.length, T = [...(c ?? []).map((M) => M - 1), ...(o ?? []).map((M) => S - M)].map((M) => v[M]).reduce((M, N) => M + N, 0);
  U = U - T;
  let A = 0, y = [], D, P = 1, w = fe(0, a).map((M, N) => ({ drawPosition: N + 1 + U })), R = U + 1;
  for (let M of g) {
    if ({ roundNodes: D, matchUps: y } = Tp({ matchUpType: l, roundNumber: P, idPrefix: p, matchUps: y, isMock: f, nodes: w, uuids: m }), P++, r.includes(M)) {
      let N = wi(r)[M], C = fe(0, N), F = S + 1 - P, x = (o == null ? void 0 : o.includes(F)) ?? (c == null ? void 0 : c.includes(P));
      C.forEach(() => {
        ({ roundNodes: D, matchUps: y, drawPosition: R } = AV({ drawPosition: !x && R || void 0, nodes: D, matchUpType: l, roundNumber: P, idPrefix: p, matchUps: y, isMock: f, uuids: m, fed: A })), P++, A += 1;
      });
    }
    w = D;
  }
  S !== P - 1 && console.log("ERROR");
  let b = a - U;
  y = Ld({ finishingPositionOffset: d ? b : s, positionsFed: U, roundsCount: S, matchUps: y, fmlc: h });
  let E = D != null && D.length ? D[0] : D;
  return E && (E.roundNumber = P - 1, E.matchUps = y), { draw: E, matchUps: y, roundsCount: S };
  function O(M) {
    let N = fI(M);
    return N > M ? N / 2 : N;
  }
}
function TV({ drawSize: e }) {
  let t = Math.ceil(Math.log(e) / Math.log(2));
  return fe(0, t).reverse().map((r) => Math.pow(2, r));
}
function uc(e) {
  let { finishingPositionOffset: t = 0, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, stageSequence: s = 1, exitProfile: c = "0", exitProfileLimit: u, roundOffsetLimit: d, roundOffset: l = 0, drawDefinition: p, staggeredEntry: f, sequenceLimit: m, stage: h = Ie, drawSize: g, idPrefix: I, isMock: U, uuids: v } = e;
  if (!(!o || !u || o != null && o[c]) || g < 2 || m && s > m) return {};
  let S = [], T = [], A = [], y = e.matchUpType ?? (p == null ? void 0 : p.matchUpType), D = t + 1, P = t + g, w = `${D}-${P}`, R = o == null ? void 0 : o[c], b = i && `${i} ` || "", E = (o == null ? void 0 : o[w]) ?? (n == null ? void 0 : n[w]), O = e.structureName || (E == null ? void 0 : E.name) || (R == null ? void 0 : R.name) && (r ? `${b}${R == null ? void 0 : R.name}` : R.name) || `${b}${w}`, M = (E == null ? void 0 : E.abbreviation) ?? (R == null ? void 0 : R.abbreviation), N = e.structureId ?? (R == null ? void 0 : R.structureId) ?? (v == null ? void 0 : v.pop()), C = { idPrefix: I && `${I}-${O}-RP`, finishingPositionOffset: t, matchUpType: y, drawSize: g, isMock: U, uuids: v }, { matchUps: F } = f ? eo(C) : Hn(C), x = zi({ structureAbbreviation: M, stageSequence: s, structureName: O, matchUpType: y, roundOffset: l, structureId: N, matchUps: F, stage: h });
  S.push(...F), T.push(x);
  let V = Math.ceil(Math.log(g) / Math.log(2)), k = d ? Math.min(d - l, V) : (!a || D < a) && V || 0;
  return g > 2 && fe(1, k + 1).forEach((B) => L(B)), { structureId: x.structureId, matchUps: S, structureName: O, structures: T, links: A, ...j };
  function L(B) {
    let G = g / Math.pow(2, B);
    if (G < 2) return;
    let q = g / Math.pow(2, B) + t;
    if (a && q + 1 > a) return;
    let { structures: Y, structureId: H, matchUps: X, links: z } = uc({ finishingPositionOffset: q, exitProfile: `${c}-${B}`, roundOffset: l + B, stageSequence: s + 1, drawSize: G, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, exitProfileLimit: u, roundOffsetLimit: d, drawDefinition: p, sequenceLimit: m, matchUpType: y, idPrefix: I, uuids: v, stage: h });
    if (x.structureId && H) {
      let Z = { linkType: oa, source: { roundNumber: B, structureId: x.structureId }, target: { roundNumber: 1, feedProfile: dn, structureId: H } };
      z && x && z.push(Z), z != null && z.length && A.push(...z);
    }
    return Y != null && Y.length && T.push(...Y), X != null && X.length && S.push(...X), { structureId: H, childLinks: z, structures: T };
  }
}
function PU({ drawDefinition: e, matchUpsMap: t, structureId: r }) {
  let i = Ne({ drawDefinition: e, structureId: r });
  if (i.error) return W({ result: i });
  let { matchUps: n } = ut({ structure: i.structure, matchUpsMap: t });
  return { ...$r({ matchUps: n }), matchUps: n, matchUpsMap: t };
}
function AT({ finishingPositions: e, drawDefinition: t, structureId: r }) {
  var n;
  let { roundProfile: i } = PU({ drawDefinition: t, structureId: r });
  return (n = i && Object.keys(i)) == null ? void 0 : n.reduce((a, o) => (dM(i == null ? void 0 : i[o]).forEach((s) => {
    e.forEach((c) => {
      DV({ position: c, rangeDefinition: s }) && (a[c] = { roundNumber: o });
    });
  }), a), {});
}
function DV({ position: e, rangeDefinition: t }) {
  if (!Array.isArray(t) || t.reduce((n, a) => n || isNaN(a), !1)) return !1;
  let [r, i] = t;
  return fe(r, (i || r) + 1).includes(e);
}
function dM(e) {
  var t, r;
  return [Be(((t = e == null ? void 0 : e.finishingPositionRange) == null ? void 0 : t.loser) || []), Be(((r = e == null ? void 0 : e.finishingPositionRange) == null ? void 0 : r.winner) || [])];
}
function PV(e) {
  return dM(e).map((t) => fe(t[0], t[1] && t[1] + 1 || t[0] + 1));
}
function iu({ drawDefinition: e, structureIds: t, matchUpsMap: r }) {
  if (t && !Array.isArray(t)) return { error: ie, context: { structureIds: t } };
  if (!e) return { error: Ue };
  t = t ?? (e.structures ?? []).filter((a) => a.stage !== Pe).map(({ structureId: a }) => a);
  let i = t.map((a) => {
    var s;
    let { roundProfile: o } = PU({ drawDefinition: e, matchUpsMap: r, structureId: a });
    return (s = o && Object.values(o)) == null ? void 0 : s.map(PV).flat();
  }).flat(), n = i.filter((a) => (a == null ? void 0 : a.length) === 1).sort(ar).flat();
  return { positionsNotPlayedOff: Be(i.flat()).filter((a) => !n.includes(a)), positionsPlayedOff: n };
}
function lM({ excludeRoundNumbers: e = [], playoffPositions: t = [], drawDefinition: r, structureId: i }) {
  if (!r) return { error: Ue };
  if (!i) return { error: Vi };
  if (!t) return { error: we, info: "missing playoffPositions" };
  let n = iu({ drawDefinition: r });
  if (n.error) return n;
  let a = n.positionsPlayedOff, o = t.filter((I) => !a.includes(I)), s = AT({ finishingPositions: o, drawDefinition: r, structureId: i }), c = Object.values(s).reduce((I, U) => I.includes(U.roundNumber) ? I : I.concat(U.roundNumber), []).map((I) => be(I)).filter((I) => !e.includes(I)), u = AT({ finishingPositions: a, drawDefinition: r, structureId: i }), d = u ? Object.values(u) : [], l = u ? d.reduce((I, U) => I.includes(U.roundNumber) ? I : I.concat(U.roundNumber), []).map((I) => be(I)) : [], p = c.filter((I) => !l.includes(I)).sort(ar), { roundProfile: f } = PU({ drawDefinition: r, structureId: i }), m = p.map((I) => {
    let U = f == null ? void 0 : f[I].finishingPositionRange.loser, [v, S] = U ?? [0, 0];
    return fe(v, (S || v) + 1);
  }).flat().sort(ar), { playoffRoundsRanges: h } = wV({ playoffSourceRounds: p, roundProfile: f }), g = [...p, ...l];
  return { playoffPositionsReturned: m, playedOffSourceRounds: l, playoffRoundsRanges: h, playoffSourceRounds: p, sourceRounds: g, roundProfile: f };
}
function wV({ playoffSourceRounds: e, roundProfile: t }) {
  return { playoffRoundsRanges: e.map((r) => {
    let i = t[r].finishingPositionRange.loser, [n, a] = i, o = fe(n, (a || n) + 1);
    return { finishingPositionRange: i.join("-"), finishingPositions: o, roundNumber: r };
  }) };
}
function Kd({ drawDefinition: e, structureId: t }) {
  if (!e) return { error: Ue };
  let { matchUps: r, matchUpsMap: i } = Qr({ inContext: !0, drawDefinition: e }), { positionsNotPlayedOff: n, positionsPlayedOff: a } = iu({ drawDefinition: e, matchUpsMap: i }), { structures: o } = In({ drawDefinition: e }), s = o.filter((u) => !t && u.stage !== yr || u.structureId === t), c = {};
  for (let u of s) {
    let d = u == null ? void 0 : u.structureId, l = RV({ playoffPositions: n, drawDefinition: e, structure: u, matchUps: r }), { error: p, ...f } = l;
    if (p) return l;
    c[d] = { structureId: d, ...f };
  }
  return t ? { positionsPlayedOff: a, ...c[t] } : { availablePlayoffProfiles: Object.values(c), availablePlayoffRounds: Object.values(c), positionsPlayedOff: a };
}
function RV({ playoffPositions: e, drawDefinition: t, structure: r, matchUps: i }) {
  var f, m, h, g, I, U, v, S, T;
  let n = r == null ? void 0 : r.structureId, { links: a } = Qc({ drawDefinition: t, structureId: n });
  if (r.structureType === ri || r.structures) {
    let A = (m = (f = gt({ structure: r })) == null ? void 0 : f.positionAssignments) == null ? void 0 : m.length, y = r.structures.length, D = (A ?? 0) / y, P = ((h = a.source) == null ? void 0 : h.flatMap(({ source: x }) => (x == null ? void 0 : x.finishingPositions) || [])) || [], w = fe(1, D + 1).filter((x) => !P.includes(x)), R = ((I = (g = i.find((x) => x.containerStructureId === n && x.finishingPositionRange)) == null ? void 0 : g.finishingPositionRange) == null ? void 0 : I.winner) || [0, 1], b = a == null ? void 0 : a.source.map(({ target: x }) => x.structureId), { positionsPlayedOff: E = [], positionsNotPlayedOff: O = [] } = iu({ structureIds: b, drawDefinition: t }), M = [...E, ...O], N = fe(R[0], R[1] + 1).filter((x) => !M.includes(x)), C = gr(N, N.length / w.length), F = w.map((x, V) => {
      let k = C[V], L = [Math.min(...k || []), Math.max(...k || [])].join("-");
      return { finishingPosition: x, finishingPositions: k, finishingPositionRange: L };
    });
    return { positionsNotPlayedOff: N, playoffFinishingPositionRanges: F, finishingPositionsAvailable: w, finishingPositionsPlayedOff: P, positionsPlayedOff: E, groupCount: y, groupSize: D };
  }
  let o = ((U = a == null ? void 0 : a.source) == null ? void 0 : U.filter((A) => A.linkCondition !== _n).map((A) => {
    var y;
    return (y = A.source) == null ? void 0 : y.roundNumber;
  })) || [], s = ((v = a == null ? void 0 : a.source) == null ? void 0 : v.filter((A) => A.linkCondition === _n).map((A) => {
    var y;
    return (y = A.source) == null ? void 0 : y.roundNumber;
  })) || [], c = lM({ excludeRoundNumbers: o, playoffPositions: e, drawDefinition: t, structureId: n }), u = c != null && c.playoffSourceRounds ? [...(c == null ? void 0 : c.playoffSourceRounds) || []] : void 0, d = [...(c == null ? void 0 : c.playoffRoundsRanges) || []], { roundProfile: l, error: p } = c;
  for (let A of s) {
    let y = a == null ? void 0 : a.source.find((b) => b.source.roundNumber === A), D = y == null ? void 0 : y.target.roundNumber, P = y == null ? void 0 : y.target.structureId, w = i.filter(({ roundNumber: b, structureId: E }) => E === P && b === D), R = w.filter(({ sides: b }) => b.find((E) => E.participantFed && !E.participantId)).length;
    if (u && R === w.length) {
      u.push(A);
      let b = (T = (S = l == null ? void 0 : l[A]) == null ? void 0 : S.finishingPositionRange) == null ? void 0 : T.loser;
      if (b) {
        let E = Math.min(...b), O = E + R, M = fe(E, O), N = { finishingPositionRange: [E, O - 1].join("-"), finishingPositions: M, roundNumber: A };
        d.push(N);
      }
    }
  }
  return u && u.sort(ar), d.sort((A, y) => A.roundNumber - y.roundNumber), { playoffRounds: u, playoffRoundsRanges: d, error: p };
}
function bV({ playoffGroups: e, drawDefinition: t, structureId: r }) {
  var n, a;
  if (!t) return { error: Ue };
  if (!Et(r) || !Array.isArray(e)) return { error: ie };
  let i = e.map(({ finishingPositions: o }) => o).flat();
  return { positionRangeMap: (a = (n = Kd({ drawDefinition: t, structureId: r }).playoffFinishingPositionRanges) == null ? void 0 : n.filter((o) => i.includes(o.finishingPosition))) == null ? void 0 : a.reduce((o, s) => (o[s.finishingPosition] = s, o), {}) };
}
function pM(e) {
  var U, v;
  let { finishingPositionOffset: t = 0, playoffAttributes: r, stageSequence: i = 1, staggeredEntry: n, structureName: a, stage: o = Ie, matchUpType: s, structureId: c, idPrefix: u, drawSize: d, isMock: l, uuids: p } = e, f = { finishingPositionOffset: t, matchUpType: s, drawSize: d, idPrefix: u, isMock: l, uuids: p }, { matchUps: m } = n ? eo(f) : Hn(f), h = zi({ structureName: a || ((U = r == null ? void 0 : r["0"]) == null ? void 0 : U.name) || Fr(Ie), structureId: c || (p == null ? void 0 : p.pop()), stageSequence: i, matchUpType: s, matchUps: m, stage: o }), g = [h], I = [];
  if (d > 2) {
    let S = d / 2, { matchUps: T } = Hn({ finishingPositionOffset: t + S, idPrefix: u && `${u}-c`, drawSize: S, matchUpType: s, isMock: l }), A = Fr(kr), y = ((v = r == null ? void 0 : r["0-1"]) == null ? void 0 : v.name) ?? e.consolationStructureName ?? (a ? `${a} ${A}` : A), D = zi({ structureName: y, matchUps: T, structureId: p == null ? void 0 : p.pop(), stage: kr, stageSequence: 1, matchUpType: s });
    g.push(D);
    let P = { linkType: oa, source: { roundNumber: 1, structureId: h.structureId }, target: { roundNumber: 1, feedProfile: dn, structureId: D.structureId } };
    I.push(P);
  }
  return { ...j, structures: g, links: I };
}
function fM({ consolationStructure: e, roundOffset: t = 0, mainStructure: r, roundsCount: i, feedPolicy: n, fmlc: a }) {
  let o = e.matchUps.reduce((u, d) => (d.drawPositions || []).filter(Boolean).length && !u.includes(d.roundNumber) ? u.concat(d.roundNumber) : u, []), s = (n == null ? void 0 : n.roundGroupedOrder) || [], c = n == null ? void 0 : n.roundFeedProfiles;
  return fe(1 + t, i + 1 + t).map((u) => {
    let d = c != null && c[u - 1] ? c[u - 1] : u % 2 && dn || Po, l = u - t <= 2 ? u - t : (u - t - 2) * 2 + 2, p = { linkType: oa, source: { roundNumber: u, structureId: r.structureId }, target: { feedProfile: d, roundNumber: l, structureId: e.structureId } }, f = s[u - 1];
    return f && (p.target.groupedOrder = f), ki() && (p.source.structureName = r.structureName, p.target.structureName = e.structureName), u === 2 && a && (p.linkCondition = _n, p.target.feedProfile = dn), o.includes(l) ? p : void 0;
  }).filter(Boolean);
}
function mM(e) {
  var T, A;
  let { playoffStructureNameBase: t, finishingPositionOffset: r, stageSequence: i = 1, playoffAttributes: n, structureNameMap: a, staggeredEntry: o, stage: s = Ie, matchUpType: c, structureId: u, drawSize: d, idPrefix: l, isMock: p, uuids: f } = e, m = { finishingPositionOffset: r, matchUpType: c, drawSize: d, idPrefix: l, isMock: p, uuids: f }, { matchUps: h, roundsCount: g } = o ? eo(m) : Hn(m), I = e.structureName ?? ((T = n == null ? void 0 : n["0"]) == null ? void 0 : T.name) ?? Fr(Ie), U = Ha({ structureId: u || (f == null ? void 0 : f.pop()), structureName: I, stageSequence: i, matchUpType: c, matchUps: h, stage: s }), v = [U], S = [];
  if (d > 2) {
    let y = [0, 2].slice(0, d / 16).map((D, P) => {
      let w = P + 1, { consolationStructure: R } = NV({ idPrefix: l && `${l}-c${P}`, structureId: f == null ? void 0 : f.pop(), playoffStructureNameBase: t, playoffAttributes: n, structureNameMap: a, stageSequence: w, roundOffset: D, matchUpType: c, drawSize: d, isMock: p, index: P, uuids: f });
      v.push(R);
      let b = fM({ consolationStructure: R, roundsCount: 2, mainStructure: U, roundOffset: D });
      return { consolationStructure: R, links: b };
    }).map((D) => D.links).flat();
    if (S.push(...y), d >= 4 && d <= 16 || d > 32) {
      let { matchUps: D } = Hn({ idPrefix: l && `${l}-p3t4`, finishingPositionOffset: 2, drawSize: 2, matchUpType: c, isMock: p }), P = ((A = n == null ? void 0 : n["3-4"]) == null ? void 0 : A.name) ?? Fr(Wt), w = (a == null ? void 0 : a[P]) || P, R = t ? `${t} ${w}` : w, b = Ha({ structureId: f == null ? void 0 : f.pop(), matchUps: D, stageSequence: 2, stage: Wt, structureName: R, matchUpType: c }), E = { linkType: oa, source: { roundNumber: g - 1, structureId: U.structureId }, target: { structureId: b.structureId, feedProfile: dn, roundNumber: 1 } };
      v.push(b), S.push(E);
    }
  }
  return { structures: v, links: S, ...j };
}
function NV({ playoffStructureNameBase: e, stageSequence: t = 1, playoffAttributes: r, structureNameMap: i, roundOffset: n = 0, matchUpType: a, structureId: o, idPrefix: s, drawSize: c, isMock: u, index: d, uuids: l }) {
  var U, v;
  let p = c / (2 * Math.pow(2, n)), { matchUps: f, roundsCount: m } = eo({ finishingPositionOffset: p, baseDrawSize: p, isConsolation: !0, feedRounds: 1, matchUpType: a, idPrefix: s, isMock: u, uuids: l }), h = d === 0 && ((U = r == null ? void 0 : r["0-1"]) == null ? void 0 : U.name) || d === 1 && ((v = r == null ? void 0 : r["0-3"]) == null ? void 0 : v.name) || `${Fr(kr)} ${d + 1}`, g = (i == null ? void 0 : i[h]) || h, I = e ? `${e} ${g}` : g;
  return { consolationStructure: Ha({ matchUps: f, stage: kr, structureName: I, stageSequence: t, matchUpType: a, structureId: o }), consolationRoundsCount: m };
}
function $o(e) {
  var w, R, b, E;
  let { finishingPositionOffset: t, stageSequence: r = 1, playoffAttributes: i, feedsFromFinal: n, staggeredEntry: a, structureName: o, stage: s = Ie, structureId: c, matchUpType: u, skipRounds: d, feedRounds: l, idPrefix: p, drawSize: f, isMock: m, uuids: h, fmlc: g } = e, I = e.feedPolicy || ((w = e.policyDefinitions) == null ? void 0 : w[Dc]) || ((R = e.appliedPolicies) == null ? void 0 : R[Dc]), U = { finishingPositionOffset: t, matchUpType: u, skipRounds: d, drawSize: f, idPrefix: p, isMock: m, uuids: h }, { matchUps: v } = a ? eo(U) : Hn(U), S = zi({ structureName: o || ((b = i == null ? void 0 : i["0"]) == null ? void 0 : b.name) || Fr(Ie), structureId: c || (h == null ? void 0 : h.pop()), stageSequence: r, matchUpType: u, matchUps: v, stage: s }), T = [S], A = [], y = f / 2, { matchUps: D, roundsCount: P } = eo({ finishingPositionOffset: y, idPrefix: p && `${p}-c`, isConsolation: !0, feedsFromFinal: n, baseDrawSize: y, matchUpType: u, feedRounds: l, skipRounds: d, isMock: m, uuids: h, fmlc: g });
  if (f > 2) {
    let O = ((E = i == null ? void 0 : i["0-1"]) == null ? void 0 : E.name) ?? Fr(kr), M = e.playoffStructureNameBase ? `${e.playoffStructureNameBase} ${O}` : O, N = zi({ matchUps: D, structureId: h == null ? void 0 : h.pop(), stage: kr, stageSequence: 1, structureName: M, matchUpType: u });
    T.push(N);
    let C = fM({ consolationStructure: N, mainStructure: S, roundsCount: P, feedPolicy: I, fmlc: g });
    A.push(...C);
  }
  return { ...j, structures: T, links: A };
}
function hM({ requireSequential: e = !0, playoffMatchUpFormat: t, playoffAttributes: r, sourceStructureId: i, policyDefinitions: n, stageSequence: a, drawDefinition: o, playoffGroups: s, matchUpType: c, feedPolicy: u, groupCount: d, idPrefix: l, isMock: p, uuids: f }) {
  var T, A, y, D, P, w;
  u = u || (n == null ? void 0 : n[Dc]);
  let m = "processPlayoffGroups", h = 0, g = [], I = [], U = [], { error: v, positionRangeMap: S } = bV({ structureId: i, drawDefinition: o, playoffGroups: s });
  if (v) return W({ result: { error: v }, stack: m });
  if (!(!S || s != null && s.every((R) => {
    let { finishingPositions: b = [] } = R;
    if (!b.length) return !1;
    let E = [...b].sort(ar).map((O, M) => (b[M + 1] || O) - O).every((O) => O < 2);
    return (!e || E) && b.every((O) => S[O]);
  }))) return W({ context: { validFinishingPositions: Object.values(S) }, result: { error: ie }, stack: m });
  for (let R of s) {
    let b = R.finishingPositions, E = S && b.map((k) => {
      var L;
      return (L = S[k]) == null ? void 0 : L.finishingPositions;
    }).flat(), O = d * b.length, M = Lc(O), N = M === 2 && xn || R.drawType || xn;
    E && (h = Math.min(...E) - 1);
    let C = E && `${Math.min(...E)}-${Math.max(...E)}`, F = R.structureName || C && ((A = (T = R.playoffAttributes) == null ? void 0 : T[C]) == null ? void 0 : A.name) || ((D = (y = R.playoffAttributes) == null ? void 0 : y["0"]) == null ? void 0 : D.name), x = { addNameBaseToAttributeName: R.addNameBaseToAttributeName, playoffStructureNameBase: R.playoffStructureNameBase, finishingPositionNaming: R.finishingPositionNaming, finishingPositionLimit: R.finishingPositionLimit, structureId: R.structureId ?? (f == null ? void 0 : f.pop()), playoffAttributes: R.playoffAttributes, structureNameMap: R.structureNameMap, sequenceLimit: R.sequenceLimit, structureName: F, idPrefix: l && `${l}-po`, appliedPolicies: n, finishingPositionOffset: h, stage: Wt, stageSequence: a, matchUpType: c, drawSize: M, isMock: p, uuids: f }, V = ({ playoffStructures: k, playoffLinks: L }) => {
      let [B] = k, G = bl({ playoffStructureId: B.structureId, finishingPositions: b, sourceStructureId: i });
      U.push(G), U.push(...L), I.push(...k), g.push({ structureId: B.structureId, finishingPositions: b }), h += O;
    };
    if (N === xn) {
      let { matchUps: k } = Hn({ finishingPositionLimit: h + O, idPrefix: l && `${l}-po`, finishingPositionOffset: h, matchUpType: c, drawSize: M, isMock: p, uuids: f }), L = zi({ structureId: R.structureId ?? (f == null ? void 0 : f.pop()), matchUpFormat: t, stage: Wt, structureName: F, stageSequence: a, matchUps: k });
      I.push(L);
      let B = bl({ playoffStructureId: L.structureId, finishingPositions: b, sourceStructureId: i });
      U.push(B), h += O, g.push({ structureId: L.structureId, finishingPositions: b });
    } else if ([Uc, Sc, Wt].includes(N)) {
      let k = { playoffAttributes: R.playoffAttributes ?? r, playoffStructureNameBase: R.playoffStructureNameBase, structureId: R.structureId ?? (f == null ? void 0 : f.pop()), structureName: R.structureName, idPrefix: l && `${l}-po`, addNameBaseToAttributeName: !0, finishingPositionOffset: h, stage: Wt, roundOffset: 0, stageSequence: a, drawSize: M, isMock: p, uuids: f };
      N === Uc ? Object.assign(k, { playoffAttributes: (R == null ? void 0 : R.playoffAttributes) ?? r ?? rv, roundOffsetLimit: 3 }) : N === Sc && Object.assign(k, { playoffAttributes: (R == null ? void 0 : R.playoffAttributes) ?? r ?? iv, roundOffsetLimit: 2 });
      let L = uc(k);
      if (L.error) return L;
      if ((P = L.links) != null && P.length && U.push(...L.links), (w = L.structures) != null && w.length && I.push(...L.structures), I.sort(Cs), L.structureId) {
        let B = bl({ playoffStructureId: L.structureId, finishingPositions: b, sourceStructureId: i });
        U.push(B), g.push({ structureId: L.structureId, finishingPositions: b });
      }
      h += O;
    } else if ([yc, gd, ju, Gu, Vu, _u].includes(N)) {
      let k = [f == null ? void 0 : f.pop(), f == null ? void 0 : f.pop()], L = { playoffStructureNameBase: R.playoffStructureNameBase, structureId: R.structureId ?? (f == null ? void 0 : f.pop()), playoffAttributes: R.playoffAttributes, idPrefix: l && `${l}-po`, finishingPositionOffset: h, uuids: k, stage: Wt, structureName: F, matchUpType: c, feedPolicy: u, drawSize: M, isMock: p }, B = { [yc]: { fmlc: !0, feedRounds: 1 }, [_u]: { feedRounds: 1 }, [ju]: { feedsFromFinal: 3 }, [Gu]: { feedsFromFinal: 2 }, [Vu]: { feedsFromFinal: 1 } };
      Object.assign(L, B[N] || {});
      let { structures: G, links: q } = $o(L), [Y] = G, H = bl({ playoffStructureId: Y.structureId, finishingPositions: b, sourceStructureId: i });
      U.push(H), U.push(...q), I.push(...G), g.push({ structureId: Y.structureId, finishingPositions: b }), h += O;
    } else if ([hn].includes(N)) {
      let { structures: k, links: L } = Wd({ ...x, structureOptions: R.structureOptions || { groupSize: 4 } });
      V({ playoffStructures: k, playoffLinks: L });
    } else if ([hd].includes(N)) {
      let { structures: k, links: L } = pM(x);
      V({ playoffStructures: k, playoffLinks: L });
    } else if ([sL].includes(N)) {
      let { structures: k, links: L } = mM(x);
      V({ playoffStructures: k, playoffLinks: L });
    } else if ([Li].includes(N)) {
      let k = zi({ structureId: R.structureId ?? (f == null ? void 0 : f.pop()), structureName: R.structureName, finishingPosition: jl, stage: Wt, stageSequence: a, matchUps: [] });
      V({ playoffStructures: [k], playoffLinks: [] });
    }
  }
  return { finishingPositionTargets: g, positionRangeMap: S, structures: I, links: U };
}
function bl({ playoffStructureId: e, finishingPositions: t, sourceStructureId: r }) {
  return { linkType: Aa, source: { structureId: r, finishingPositions: t }, target: { structureId: e, feedProfile: sn, roundNumber: 1 } };
}
function Xd({ matchUp: e, tieFormat: t, isMock: r, uuids: i }) {
  let { collectionDefinitions: n } = t ?? {};
  return { tieMatchUps: (n ?? []).map((a) => Zd({ matchUp: e, collectionDefinition: a, uuids: i, isMock: r })).filter(Boolean).flat() };
}
function Zd({ collectionPositionOffset: e = 0, collectionDefinition: t, matchUpsLimit: r, matchUp: i, isMock: n, uuids: a }) {
  let { matchUpCount: o, matchUpType: s, collectionId: c, processCodes: u } = t || {}, d = r ?? o ?? 0, l = (p) => {
    if (!n && !(i != null && i.isMock)) return (a == null ? void 0 : a.pop()) ?? st();
    let f = t == null ? void 0 : t.collectionId;
    return (a == null ? void 0 : a.pop()) ?? `${i == null ? void 0 : i.matchUpId}-${f}-TMU-${p + 1}`;
  };
  return fe(0, d).map((p) => {
    let f = e + p + 1;
    return { sides: [{ sideNumber: 1 }, { sideNumber: 2 }], matchUpId: l(p), matchUpStatus: Xt, collectionPosition: f, collectionId: c, processCodes: u, matchUpType: s, isMock: n };
  });
}
function MV(e) {
  var D, P, w;
  let t = "generateAndPopulateRRplayoffStructures";
  if (!e.playoffGroups) return W({ result: { error: we }, info: "playoffGroups required", stack: t });
  let { sourceStructureId: r, requireSequential: i, tournamentRecord: n, drawDefinition: a, playoffGroups: o, groupCount: s, groupSize: c, event: u } = e, d = hM({ requireSequential: i, sourceStructureId: r, playoffGroups: o, groupCount: s, groupSize: c, ...e });
  if (d.error) return W({ result: d, stack: t });
  let { structures: l = [], links: p = [], finishingPositionTargets: f, positionRangeMap: m } = d, h = f == null ? void 0 : f.map(({ finishingPositions: R }) => R).flat().map((R) => m[R].finishingPositions).flat();
  a.structures.push(...l), a.links.push(...p);
  let { matchUps: g, matchUpsMap: I } = ur({ inContext: !0, drawDefinition: a }), U = l.map(({ structureId: R }) => R), v = g == null ? void 0 : g.filter(({ structureId: R }) => U.includes(R)).map(hr), S = (D = I == null ? void 0 : I.drawMatchUps) == null ? void 0 : D.filter(({ matchUpId: R }) => v == null ? void 0 : v.includes(R));
  if (S != null && S.length) {
    let R = (P = Yr({ drawDefinition: a, event: u })) == null ? void 0 : P.tieFormat;
    R && S.forEach((b) => {
      let { tieMatchUps: E } = Xd({ isMock: e.isMock, tieFormat: R, matchUp: b });
      Object.assign(b, { tieMatchUps: E, matchUpType: Ci });
    });
  }
  let { positionAssignments: T } = gt({ structureId: r, drawDefinition: a }), A = {};
  T == null || T.forEach((R) => {
    var E, O, M;
    let b = (M = (O = (E = We({ element: R, name: Ka })) == null ? void 0 : E.extension) == null ? void 0 : O.value) == null ? void 0 : M.groupOrder;
    b && (A[b] || (A[b] = []), A[b].push(R.participantId));
  });
  let y = ru({ provisionalPositioning: e.provisionalPositioning, structureId: r, applyPositioning: !0, event: e.event, tournamentRecord: n, drawDefinition: a });
  return y.error && ((w = y.error) == null ? void 0 : w.code) !== mI.code ? W({ result: y, stack: t }) : { structures: l, links: p, positionsPlayedOff: h, drawDefinition: a, ...j };
}
function ac({ value: e, sourceRange: t, targetRange: r }) {
  let i = Math.min(...t), n = Math.max(...t), a = Math.min(...r), o = Math.max(...r);
  return (e - i) * (o - a) / (n - i) + a;
}
var cn = "ELO", gM = "NTRP", EV = "TRN", IM = "UTR", wU = "WTN", OV = { ELO: cn, NTRP: gM, TRN: EV, UTR: IM, WTN: wU }, CV = { [cn]: { defaultInitialization: 1500, decimalsCount: 0, range: [0, 3e3], ascending: !0 }, [gM]: { accessors: ["ntrpRating", "dntrpRatingHundredths"], attributes: { ustaRatingType: "" }, accessor: "dntrpRatingHundredths", defaultInitialization: 3, decimalsCount: 1, ascending: !0, range: [1, 7] }, [IM]: { defaultInitialization: 6, accessors: ["utrRating"], accessor: "utrRating", decimalsCount: 2, ascending: !0, range: [1, 16] }, [wU]: { attributes: { confidence: { generator: !0, range: [60, 100] } }, accessors: ["wtnRating", "confidence"], defaultInitialization: 23, accessor: "wtnRating", ascending: !1, decimalsCount: 2, range: [40, 1] } }, Ur = CV;
function FV({ sourceRatingType: e, sourceRating: t }) {
  let r = Ur[e].range, i = r[0] > r[1], n = Ur[cn].range;
  return ac({ value: i ? r[0] - t : t, sourceRange: r, targetRange: n });
}
function kV({ targetRatingType: e, sourceRating: t }) {
  let r = Ur[e].decimalsCount || 0, i = Ur[e].range, n = i[0] > i[1], a = Math.max(...i), o = Ur[cn].range, s = ac({ targetRange: i, sourceRange: o, value: t }), c = parseFloat(s.toFixed(r));
  return n ? a - c : c;
}
function TT(e) {
  var l;
  let t = Ae(e, [{ ratings: !0, [ui]: pi }]);
  if (t.error) return t;
  let r = e.matchUpType && [mt, ft].includes(e.matchUpType) ? e.matchUpType : mt, i = Object.keys(Ur), n = e.targetRatingType && i.includes(e.targetRatingType) ? e.targetRatingType : cn, a = e.ratings[r] ? e.ratings[r].reduce((p, f) => p.includes(f.scaleName) ? p : p.concat(f.scaleName), []) : [];
  if (!a) return { error: Tr };
  let o = ((l = e.ratings[r]) == null ? void 0 : l.find((p) => p.scaleName === n)) ?? e.ratings[r][0];
  if (a[0] === n) return o;
  let s = o.scaleName, c = Ur[o.scaleName].accessor, u = c ? o.scaleValue[c] : o.scaleValue, d = FV({ sourceRatingType: s, sourceRating: u });
  return { convertedRating: kV({ targetRatingType: n, sourceRating: d }), sourceRating: u };
}
function LV({ participantResults: e, sides: t, score: r }) {
  var s, c;
  let i = t.find(({ sideNumber: u }) => u === 1), n = t.find(({ sideNumber: u }) => u === 2), a = (s = i == null ? void 0 : i.participant) == null ? void 0 : s.ratings, o = (c = n == null ? void 0 : n.participant) == null ? void 0 : c.ratings;
  if (a != null && a[mt] && (o != null && o[mt])) {
    let u = cn, { convertedRating: d } = TT({ ratings: a, targetRatingType: u }), { convertedRating: l } = TT({ ratings: o, targetRatingType: u }), { side1pressure: p, side2pressure: f } = xV({ side1ConvertedRating: d, side2ConvertedRating: l, score: r });
    p && e[i == null ? void 0 : i.participantId].pressureScores.push(p), f && e[n == null ? void 0 : n.participantId].pressureScores.push(f);
    let m = Math.max(...Ur[cn].range), h = ep((l - d) / m), g = ep((d - l) / m);
    e[i == null ? void 0 : i.participantId].ratingVariation.push(h), e[n == null ? void 0 : n.participantId].ratingVariation.push(g);
  }
}
function xV({ side1ConvertedRating: e, side2ConvertedRating: t, score: r }) {
  var U, v;
  let i = e > t ? e : t, n = e > t ? t : e, a = Math.abs(e - t), o = Ur[cn].range, s = Math.max(...o), c = (s - i) * 0, u = (i + c) / s * a, d = (U = r == null ? void 0 : r.sets) == null ? void 0 : U.reduce((S, T) => S + ((T == null ? void 0 : T.side1Score) ?? 0), 0), l = (v = r == null ? void 0 : r.sets) == null ? void 0 : v.reduce((S, T) => S + (T.side2Score ?? 0), 0), p = e > t ? 2 : 1, f = (d || 0) * (n + (p === 1 ? u : 0)), m = (l || 0) * (n + (p === 2 ? u : 0)), h = f + m, g = h ? ep(f / h) : 0, I = h ? ep(m / h) : 0;
  return { side1pressure: g, side2pressure: I };
}
function RU({ winningSide: e, matchUpFormat: t = Ia, matchUpStatus: r, tallyPolicy: i, score: n }) {
  let a = [0, 0], o = n == null ? void 0 : n.sets, s = typeof e == "number" && e - 1, c = ti(t), u = bU((c == null ? void 0 : c.bestOf) ?? 1);
  if (typeof s == "number" && (r === Je && (i != null && i.setsCreditForDefaults) || r === ct && (i != null && i.setsCreditForWalkovers))) a[s] = u;
  else for (let d of o || []) {
    let { winningSide: l } = d;
    l && (a[l - 1] += 1);
  }
  return typeof s == "number" && r === Wr && (+a[1 - s] === u && (a[1 - s] -= 1), i != null && i.setsCreditForRetirements && (a[s] = u)), a;
}
function vM({ matchUpFormat: e = Ia, winningSide: t, matchUpStatus: r, tallyPolicy: i, score: n }) {
  var p, f;
  let { sets: a } = n || {};
  if (!a) return [0, 0];
  let o = typeof t == "number" && t - 1, s = ti(e), c = (s == null ? void 0 : s.bestOf) ?? 1, u = bU(c), d = ((p = s == null ? void 0 : s.setFormat) == null ? void 0 : p.tiebreakAt) || 0, l = [[], []];
  if (typeof o == "number" && (r === Je && (i != null && i.gamesCreditForDefaults) || r === ct && (i != null && i.gamesCreditForWalkovers))) {
    let m = ((f = s == null ? void 0 : s.setFormat) == null ? void 0 : f.setTo) || 0, h = u * m;
    l[o].push(h);
  } else a.forEach((m, h) => {
    var T;
    let g = (m.setNumber || h + 1) > u && (s != null && s.finalSetFormat) ? "finalSetFormat" : "setFormat", I = (T = s == null ? void 0 : s[g]) == null ? void 0 : T.based, U = s == null ? void 0 : s[g].tiebreakSet, { side1Score: v, side2Score: S } = m;
    DT(I) && (l[0].push(be(v || 0)), l[1].push(be(S || 0))), U && m.winningSide && (i == null ? void 0 : i.gamesCreditForTiebreakSets) !== !1 && l[m.winningSide - 1].push(1);
  });
  if (r === Wr && typeof o == "number") {
    let m = a.length > u && (s != null && s.finalSetFormat) ? "finalSetFormat" : "setFormat", h = s == null ? void 0 : s[m];
    if (DT(h.based)) {
      let g = (h == null ? void 0 : h.setTo) || 0, I = (v) => {
        if (!(!s || v === "")) return +v === d - 1 || +v === d ? be(d || 0) + 1 : +v < d ? g : d;
      }, U = RU({ winningSide: t, score: { sets: a }, matchUpStatus: r, matchUpFormat: e, tallyPolicy: i });
      if (l.map((v) => v[o] <= v[1 - o]).reduce((v, S) => v + (S ? 1 : 0), 0) > U[1 - o]) {
        let v = l[o].length, S = I(l[1 - o][v - 1]);
        S && (l[o][v - 1] = S);
      }
      u > l[o].length && (i != null && i.gamesCreditForRetirements) && l[o].push(g);
    }
  }
  return [l[0].reduce((m, h) => m + h, 0), l[1].reduce((m, h) => m + h, 0)];
}
function UM({ matchUpFormat: e, score: t }) {
  var s;
  let r = e ? ti(e) : void 0, i = (r == null ? void 0 : r.bestOf) ?? 1, n = bU(i), a = [0, 0], o = [0, 0];
  return (s = t == null ? void 0 : t.sets) == null || s.forEach((c, u) => {
    var p;
    let d = (c.setNumber || u + 1) > n && (r != null && r.finalSetFormat) ? "finalSetFormat" : "setFormat", l = (p = r == null ? void 0 : r[d]) == null ? void 0 : p.based;
    if (SM(l)) {
      let { side1Score: f, side2Score: m } = c;
      f && (o[0] += be(f || 0)), m && (o[1] += be(m || 0));
    } else c.side1TiebreakScore && (o[0] += be(c.side1TiebreakScore || 0)), c.side2TiebreakScore && (o[1] += be(c.side2TiebreakScore || 0)), (c.side1TiebreakScore || c.side2TiebreakScore) && c.winningSide && (a[c.winningSide - 1] += 1);
  }), { pointsTally: o, tiebreaksTally: a };
}
function bU(e) {
  return e && Math.ceil(e / 2) || 1;
}
function SM(e) {
  return e === "P";
}
function DT(e) {
  return !SM(e);
}
function BV({ participantResults: e, matchUpFormat: t, tallyPolicy: r, perPlayer: i, totalSets: n }) {
  var u;
  let a = t && ti(t) || {}, o = a.bestOf, s = o && Math.ceil(o / 2) || 1, c = (u = a.setFormat) == null ? void 0 : u.setTo;
  Object.keys(e).forEach((d) => {
    let l = e[d].setsWon, p = e[d].setsLost, f = r != null && r.groupTotalSetsPlayed ? n : i * (s || 0) || l + p, m = Math.round(l / f * 1e3) / 1e3;
    (m === 1 / 0 || isNaN(m)) && (m = f);
    let h = e[d].tieMatchUpsWon, g = e[d].tieMatchUpsLost, I = h + g, U = Math.round(h / I * 1e3) / 1e3;
    (U === 1 / 0 || isNaN(U)) && (U = h);
    let v = e[d].matchUpsWon, S = e[d].matchUpsLost, T = v + S, A = Math.round(v / T * 1e3) / 1e3;
    (A === 1 / 0 || isNaN(A)) && (A = v);
    let y = e[d].gamesWon || 0, D = e[d].gamesLost || 0, P = (i || 0) * (s || 0) * (c || 0), w = Math.max(P, y + D), R = Math.round(y / w * 1e3) / 1e3;
    (R === 1 / 0 || isNaN(R)) && (R = 0);
    let b = e[d].pointsWon + e[d].pointsLost, E = Math.round(e[d].pointsWon / b * 1e3) / 1e3;
    (E === 1 / 0 || isNaN(E)) && (E = 0), e[d].setsWon = l, e[d].setsLost = p, e[d].setsPct = m, e[d].tieMatchUpsWon = h, e[d].tieMatchUpsPct = U, e[d].matchUpsPct = A, e[d].gamesWon = y, e[d].gamesLost = D, e[d].gamesPct = R, e[d].pointsPct = E, e[d].result = `${e[d].matchUpsWon}/${e[d].matchUpsLost}`;
  });
}
function Qd({ participantIds: e, pressureRating: t, matchUpFormat: r, tallyPolicy: i, perPlayer: n, matchUps: a }) {
  var d, l, p, f, m, h, g;
  let o = {}, s = (i == null ? void 0 : i.excludeMatchUpStatuses) || [], c = a == null ? void 0 : a.filter((I) => (I.tieMatchUps || !s.includes(I.matchUpStatus)) && (!(e != null && e.length) || qt(e, [oc(I, 0), oc(I, 1)]).length === 2)), u = (d = c == null ? void 0 : c.flatMap(({ score: I, tieMatchUps: U }) => {
    var v;
    return U ? U.filter(({ matchUpStatus: S }) => !s.includes(S)).flatMap(({ score: S }) => {
      var T;
      return ((T = S == null ? void 0 : S.sets) == null ? void 0 : T.length) ?? 0;
    }) : ((v = I == null ? void 0 : I.sets) == null ? void 0 : v.length) ?? 0;
  })) == null ? void 0 : d.reduce((I, U) => I + U, 0);
  for (let I of c ?? []) {
    let { matchUpStatus: U, tieMatchUps: v, tieFormat: S, score: T, winningSide: A, sides: y } = I, D = S && I._disableAutoCalc && S.collectionDefinitions.every(({ scoreValue: E }) => E), P = A && VV(I), w = A && GV(I);
    if (!P && !w) if (U && lr.includes(U)) {
      let E = oc(I, 0), O = oc(I, 1);
      E && (_a(o, E), o[E].matchUpsCancelled += 1), O && (_a(o, O), o[O].matchUpsCancelled += 1);
    } else if (v != null && v.length) {
      n = 0;
      for (let E of v) {
        if (E.winningSide) {
          let O = (l = y == null ? void 0 : y.find(({ sideNumber: N }) => N === E.winningSide)) == null ? void 0 : l.participantId, M = (p = y == null ? void 0 : y.find(({ sideNumber: N }) => N === E.winningSide)) == null ? void 0 : p.participantId;
          O && M && (_a(o, O), _a(o, M), o[O].tieMatchUpsWon += 1, o[M].tieMatchUpsLost += 1, Kt(mt)(E.matchUpType) ? (o[O].tieSinglesWon += 1, o[M].tieSinglesLost += 1) : Kt(ft)(E.matchUpType) && (o[O].tieDoublesWon += 1, o[M].tieDoublesLost += 1));
        }
        PT({ score: E.score, manualGamesOverride: D, participantResults: o, sides: y });
      }
    } else PT({ manualGamesOverride: D, participantResults: o, score: T, sides: y });
    else if (_a(o, P), _a(o, w), v == null ? void 0 : v.length) {
      n = 0;
      for (let E of v) {
        let { matchUpType: O } = E, M = Kt(ft)(O), N = Kt(mt)(O);
        E.winningSide && (E.winningSide === A ? (P && (o[P].tieMatchUpsWon += 1, N && (o[P].tieSinglesWon += 1), M && (o[P].tieDoublesWon += 1)), w && (o[w].tieMatchUpsLost += 1, N && (o[w].tieSinglesLost += 1), M && (o[w].tieDoublesLost += 1))) : E.winningSide !== A && (w && (o[w].tieMatchUpsWon += 1, N && (o[w].tieSinglesWon += 1), M && (o[w].tieDoublesWon += 1)), P && (o[P].tieMatchUpsLost += 1, N && (o[P].tieSinglesLost += 1), M && (o[P].tieDoublesLost += 1)))), wT({ matchUpFormat: E.matchUpFormat, matchUpStatus: E.matchUpStatus, matchUpType: E.matchUpType, score: E.score, sides: E.sides, winningParticipantId: P, losingParticipantId: w, manualGamesOverride: D, participantResults: o, isTieMatchUp: !0, pressureRating: t, tallyPolicy: i, winningSide: A });
      }
      yM({ winningParticipantId: P, losingParticipantId: w, participantResults: o, matchUpStatus: U });
    } else wT({ matchUpFormat: I.matchUpFormat ?? r, matchUpType: I.matchUpType, isTieMatchUp: void 0, winningParticipantId: P, manualGamesOverride: D, losingParticipantId: w, participantResults: o, pressureRating: t, matchUpStatus: U, tallyPolicy: i, winningSide: A, score: T, sides: y });
    let R = (f = T == null ? void 0 : T.sets) == null ? void 0 : f.reduce((E, O) => E + ((O == null ? void 0 : O.side1Score) ?? 0), 0), b = (m = T == null ? void 0 : T.sets) == null ? void 0 : m.reduce((E, O) => E + (O.side2Score ?? 0), 0);
    if (D) {
      let E = (h = y == null ? void 0 : y.find(({ sideNumber: M }) => M === 1)) == null ? void 0 : h.participantId, O = (g = y == null ? void 0 : y.find(({ sideNumber: M }) => M === 2)) == null ? void 0 : g.participantId;
      _a(o, E), _a(o, O), E && (o[E].gamesWon += R, o[E].gamesLost += b), O && (o[O].gamesWon += b, o[O].gamesLost += R);
    }
  }
  return BV({ participantResults: o, matchUpFormat: r, tallyPolicy: i, perPlayer: n, totalSets: u }), { participantResults: o };
}
function VV(e) {
  let t = e.winningSide - 1;
  return oc(e, t);
}
function GV(e) {
  let t = 1 - (e.winningSide - 1);
  return oc(e, t);
}
function oc(e, t) {
  if (!(e != null && e.sides)) return console.log("no sides:", { matchUp: e }), "foo";
  let r = e.sides[t];
  return r ? r.participantId : (console.log("No Side", { matchUp: e, index: t }), "foo");
}
function _a(e, t) {
  t && !e[t] && (e[t] = { allDefaults: 0, defaults: 0, defeats: [], gamesLost: 0, gamesWon: 0, matchUpsCancelled: 0, matchUpsLost: 0, matchUpsWon: 0, pointsLost: 0, pointsWon: 0, pressureScores: [], ratingVariation: [], retirements: 0, setsLost: 0, setsWon: 0, tieSinglesWon: 0, tieSinglesLost: 0, tieDoublesWon: 0, tieDoublesLost: 0, tieMatchUpsLost: 0, tieMatchUpsWon: 0, victories: [], walkovers: 0 });
}
function PT({ manualGamesOverride: e, participantResults: t, score: r, sides: i }) {
  let { sets: n } = r || {}, a = [[], []], o = [0, 0];
  for (let c of n || []) {
    let { winningSide: u, side1Score: d, side2Score: l } = c;
    u && (o[u - 1] += 1), a[0].push(be(d || 0)), a[1].push(be(l || 0));
  }
  let s = [a[0].reduce((c, u) => c + u, 0), a[1].reduce((c, u) => c + u, 0)];
  i.forEach((c, u) => {
    let { participantId: d } = c;
    d && (_a(t, d), t[d].setsWon += o[u], t[d].setsLost += o[1 - u], e || (t[d].gamesWon += s[u], t[d].gamesLost += s[1 - u]));
  });
}
function wT({ winningParticipantId: e, manualGamesOverride: t, losingParticipantId: r, participantResults: i, pressureRating: n, matchUpFormat: a, matchUpStatus: o, isTieMatchUp: s, matchUpType: c, tallyPolicy: u, winningSide: d, score: l, sides: p }) {
  let f = d && d - 1, m = 1 - f;
  n && c === mt && LV({ participantResults: i, sides: p, score: l }), s || yM({ winningParticipantId: e, losingParticipantId: r, participantResults: i, matchUpStatus: o });
  let h = RU({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: d, score: l }), g = vM({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: d, score: l }), { pointsTally: I } = UM({ score: l, matchUpFormat: a });
  e && (i[e].setsWon += h[f], i[e].setsLost += h[m], t || (i[e].gamesWon += g[f], i[e].gamesLost += g[m]), i[e].pointsWon += I[f], i[e].pointsLost += I[m]), r && (i[r].setsWon += h[m], i[r].setsLost += h[f], t || (i[r].gamesWon += g[m], i[r].gamesLost += g[f]), i[r].pointsWon += I[m], i[r].pointsLost += I[f]);
}
function yM({ winningParticipantId: e, losingParticipantId: t, participantResults: r, matchUpStatus: i }) {
  t && (i === ct && (r[t].walkovers += 1), i === Je && (r[t].defaults += 1), i === Wr && (r[t].retirements += 1), [Je, Wr, ct].includes(i) && (r[t].allDefaults += 1), r[t].matchUpsLost += 1), e && (r[e].matchUpsWon += 1), t && e && (r[t].defeats.push(e), r[e].victories.push(t));
}
function jV({ matchUps: e, order: t, report: r }) {
  let i = {};
  e.forEach(({ sides: a }) => {
    a.forEach((o) => {
      o.participantId && o.participant && (i[o.participantId] = o.participant.participantName);
    });
  });
  let n = [];
  return Array.isArray(r) && r.forEach((a, o) => {
    var s, c;
    if ((s = a.excludedDirectives) != null && s.length) {
      let u = a.excludedDirectives.map(({ attribute: p }) => p).join(", "), d = `${u.length} directives were excluded due to participants limit}`;
      n.push(d);
      let l = `Excluded: ${u}`;
      n.push(l);
    } else {
      let u = (h, g) => parseFloat(a.reversed ? h : g) - parseFloat(a.reversed ? g : h), d = a.groups ? Object.values(a.groups).flat(1 / 0).length : ((c = a.participantIds) == null ? void 0 : c.length) ?? 0, l = (h) => {
        h.groups && Object.keys(h.groups).sort(u).forEach((g) => {
          let I = h.groups[g].map((v) => i[v]).join(", "), U = `${g} ${h.attribute}: ${I}`;
          n.push(U);
        });
      }, p = a.reversed ? " in reverse order" : "", f = a.groups ? "grouped" : "separated", m = `Step ${o + 1}: ${d} particiants were ${f}${p} by ${a.attribute}`;
      if (n.push(m), a.idsFilter) {
        let h = `${a.attribute} was calculated considering ONLY TIED PARTICIPANTS`;
        n.push(h);
      }
      l(a);
    }
    n.push("----------------------");
  }), n.push("Final Order:"), t.forEach((a) => {
    let { participantId: o, resolved: s } = a, c = a.groupOrder || a.provisionalOrder;
    n.push(`${c}: ${i[o]} => resolved: ${!!s}`);
  }), n.join(`\r
`);
}
function AM({ participantResults: e, participantIds: t, attribute: r }) {
  return TM({ participantResults: e, participantIds: t }).reduce((i, n) => {
    let { participantId: a, results: o } = n, s = o == null ? void 0 : o[r];
    return !isNaN(s) && a && (i[s] ? i[s].push(a) : i[s] = [a]), i;
  }, {});
}
function TM(e) {
  return (e.participantIds || Object.keys(e.participantResults)).reduce((t, r, i) => (t.push({ participantId: r, i, results: e.participantResults[r] }), t), []);
}
var _V = [{ attribute: "matchUpsPct", idsFilter: !1 }, { attribute: "allDefaults", reversed: !0, idsFilter: !1 }, { attribute: "defaults", reversed: !0, idsFilter: !1 }, { attribute: "walkovers", reversed: !0, idsFilter: !1 }, { attribute: "retirements", reversed: !0, idsFilter: !1 }, { attribute: "setsPct", idsFilter: !1 }, { attribute: "gamesPct", idsFilter: !1 }, { attribute: "pointsPct", idsFilter: !1 }, { attribute: "matchUpsPct", idsFilter: !0 }, { attribute: "setsPct", idsFilter: !0 }, { attribute: "gamesPct", idsFilter: !0 }, { attribute: "pointsPct", idsFilter: !0 }], Kh = { matchUpsPct: 20, tieMatchUpsPct: 16, pointsPct: 4, gamesPct: 8, setsPct: 12 };
function RT(e) {
  let { requireCompletion: t = !0, participantResults: r, subOrderMap: i, tallyPolicy: n } = e, a = [];
  if (t && !WV(e)) return {};
  let o = ["tieMatchUpsWon", "tieSinglesWon", "tieDoublesWon", "matchUpsWon", "pointsWon", "gamesWon", "setsWon", "gamesPct", "setsPct", "pointsPct", "matchUpsPct"].includes(n == null ? void 0 : n.groupOrderKey) ? n.groupOrderKey : "matchUpsWon", s = AM({ participantResults: r, attribute: o });
  a.push({ attribute: o, groups: s });
  let c = Object.keys(s).map((g) => parseFloat(g)).sort((g, I) => I - g).map((g) => s[g]).map((g) => {
    let I = DM({ participantIds: g, ...e });
    return a.push(...I.report ?? []), I.order;
  }).map((g, I) => g.map((U) => U.resolved ? U : { ...U, subGroup: [I].concat(...U.subGroup ?? []) })).flat(), u, d = 0, l = 1, p;
  c.forEach((g, I) => {
    var v;
    I && (g.resolved || p && !g.resolved) && (l += 1), p = g.resolved;
    let U = parseInt(((v = g.subGroup) == null ? void 0 : v.join("")) || 0);
    g.resolved ? (g.position = I + 1, l = g.position) : (u && U > u && (l += d, d = 0), g.position = l, d += 1), u = U;
  });
  let f = c.map(({ position: g }) => g), m = wi(f);
  return c.forEach((g) => {
    let { participantId: I, position: U } = g || {}, v = r[I];
    g.GEMscore = h(v);
    let S = m[U];
    (g == null ? void 0 : g.position) !== void 0 && (S > 1 && (g.ties = S, i && (g.subOrder = i[I])), g.rankOrder = U, g.groupOrder = U + (g.subOrder || 1) - 1);
  }), { groupOrder: c, report: a.flat(1 / 0).filter(Boolean) };
  function h(g) {
    return (Array.isArray(n == null ? void 0 : n.GEMscore) ? Object.keys(Kh).filter((I) => n.GEMscore.includes(I)) : Object.keys(Kh)).map((I) => (g[I] || 0) * Math.pow(10, Kh[I].toFixed(3))).reduce((I, U) => I + U, 0);
  }
}
function WV({ participantResults: e, participantsCount: t }) {
  let r = TM({ participantResults: e }).filter((i) => t - 1 === i.results.matchUpsWon + i.results.matchUpsLost + i.results.matchUpsCancelled);
  return t === r.length;
}
function qV({ disableHeadToHead: e, participantIds: t, matchUpFormat: r, tallyPolicy: i, attribute: n, idsFilter: a, matchUps: o, reversed: s }) {
  let { participantResults: c } = Qd({ participantIds: a && t, matchUpFormat: r, tallyPolicy: i, matchUps: o }), u = AM({ participantResults: c, participantIds: t, attribute: n }), d = [{ attribute: n, reversed: s, groups: u, idsFilter: a }], l;
  return Object.keys(u).length > 1 && t.length && (l = Object.keys(u).map((p) => parseFloat(p)).sort((p, f) => s ? p - f : f - p).map((p) => u[p]).map((p) => {
    let f = DM({ participantResults: c, disableHeadToHead: e, participantIds: p, matchUpFormat: r, tallyPolicy: i, matchUps: o });
    return d.push(...f.report ?? []), f.order;
  }).map((p, f) => p.map((m) => m.resolved ? m : { ...m, subGroup: [f].concat(...m.subGroup ?? []) })).flat()), { order: l, report: d };
}
function DM({ participantResults: e, disableHeadToHead: t, participantIds: r, matchUpFormat: i, tallyPolicy: n, matchUps: a }) {
  let o = [], s = [], c;
  if ((r == null ? void 0 : r.length) === 1) return { order: [{ resolved: !0, participantId: r[0] }] };
  if ((r == null ? void 0 : r.length) === 2 && (!(n != null && n.headToHead) || !n.headToHead.disabled && !t)) {
    let d = HV({ participantIds: r, participantResults: e });
    if (d) {
      let l = d[0].participantId;
      return s.push({ attribute: "head2Head", participantIds: r, headToHeadWinner: l }), { order: d, headToHeadWinner: l, report: s };
    }
  }
  let u = ((n == null ? void 0 : n.tallyDirectives) || _V).filter((d) => {
    let l = !(jt(d.maxParticipants) && (r == null ? void 0 : r.length) > d.maxParticipants);
    return l || o.push(d), l;
  });
  return o.length && s.push({ excludedDirectives: o, participantIds: r }), u.every(({ attribute: d, reversed: l, idsFilter: p, disableHeadToHead: f }) => (c = qV({ disableHeadToHead: f, participantIds: r, matchUpFormat: i, tallyPolicy: n, attribute: d, idsFilter: p, matchUps: a, reversed: l }), s.push(c.report), !c.order)), c.order ? { order: c.order, report: s } : { order: r == null ? void 0 : r.map((d) => ({ participantId: d })), report: s };
}
function HV({ participantIds: e, participantResults: t }) {
  if (e) {
    if (t[e[0]].victories.includes(e[1])) return e.map((r) => ({ resolved: !0, participantId: r }));
    if (t[e[1]].victories.includes(e[0])) return e.reverse().map((r) => ({ resolved: !0, participantId: r }));
  }
}
function nu({ policyDefinitions: e, generateReport: t, pressureRating: r, matchUpFormat: i, matchUps: n = [], subOrderMap: a, perPlayer: o }) {
  if (!(n != null && n.length) || !rn(n)) return { error: Ma };
  let s = Be(n.map(({ structureId: S }) => S));
  if (s.length !== 1) return W({ result: { error: ie, info: "Maximum one structureId" }, stack: "tallyParticipantResults", context: { structureIds: s } });
  let c = n.filter((S) => S && S.matchUpStatus !== at), u = c.length && Be(c.map(({ drawPositions: S }) => S).flat()).length, d = c.filter((S) => yo({ matchUp: S })).length === c.length;
  d || (o = 0);
  let l = n.every(({ matchUpType: S, tieMatchUps: T }) => S === yt && (T == null ? void 0 : T.every((A) => yo({ matchUp: A })))), p = e == null ? void 0 : e[fv], f = n.filter((S) => yo({ matchUp: S }) || S.matchUpType === yt), { participantResults: m } = Qd({ matchUps: f, pressureRating: r, matchUpFormat: i, tallyPolicy: p, perPlayer: o }), h, g, { groupOrder: I, report: U } = RT({ matchUps: f, participantResults: m, participantsCount: u, matchUpFormat: i, tallyPolicy: p, subOrderMap: a });
  if (r && YV({ participantResults: m }), d && I) h = U, g = I, I.forEach((S) => {
    let { participantId: T, groupOrder: A, rankOrder: y, subOrder: D, ties: P, GEMscore: w } = S, R = m[T];
    Object.assign(R, { groupOrder: A, rankOrder: y, GEMscore: w, subOrder: D, ties: P });
  });
  else {
    let { groupOrder: S, report: T } = RT({ requireCompletion: !1, participantResults: m, participantsCount: u, matchUpFormat: i, tallyPolicy: p, subOrderMap: a, matchUps: n });
    h = T, g = S, S && S.forEach((A) => {
      let { participantId: y, groupOrder: D, GEMscore: P } = A, w = m[y];
      Object.assign(w, { provisionalOrder: D, GEMscore: P });
    });
  }
  let v = { completedTieMatchUps: l, readableReport: "", participantResults: m, bracketComplete: d, order: [], report: h };
  if ((d || l) && (v.order = g), t || ki({ tally: !0 })) {
    let S = jV({ matchUps: n, report: h, order: g });
    ki({ tally: !0 }) && console.log(S), v.readableReport = S;
  }
  return v;
}
function YV({ participantResults: e }) {
  let t = (n) => n.reduce((a, o) => a + parseFloat(o), 0), r = (n) => parseFloat((t(n) / n.length).toFixed(2)), i = Object.keys(e).map((n) => {
    let a = e[n], { pressureScores: o } = a, s = o != null && o.length ? r(o) : 0;
    return { participantId: n, averagePressure: s };
  }).sort((n, a) => (a.averagePressure || 0) - (n.averagePressure || 0)).map((n, a) => ({ ...n, order: a + 1 }));
  for (let n of i) e[n.participantId].pressureOrder = n.order;
}
function PM({ positionAssignments: e }) {
  let t = (e || []).filter(Ni(ca)).map((n) => {
    let { extension: a } = We({ element: n, name: Pc }), o = be(a == null ? void 0 : a.value), s = !isNaN(o) && o;
    return s && { participantId: n.participantId, subOrder: s };
  }).filter(Boolean), r = t.map(({ subOrder: n }) => n), i = wi(r);
  return { subOrderMap: Object.assign({}, ...t.filter(({ subOrder: n }) => i[n] === 1).map(({ participantId: n, subOrder: a }) => ({ [n]: a }))) };
}
function NU({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpFormat: i, matchUps: n, event: a }) {
  if (!rn(n)) return { error: ie };
  if (!e) return { error: ie };
  let { policyDefinitions: o } = Fa({ policyTypes: [fv], tournamentRecord: t, drawDefinition: r, event: a }), { subOrderMap: s } = PM({ positionAssignments: e }), c = n.length ? nu({ policyDefinitions: o, matchUpFormat: i, subOrderMap: s, matchUps: n }) : void 0;
  if (c != null && c.error) return c;
  let { participantResults: u = {}, bracketComplete: d, report: l } = c ?? {}, p = Object.keys(u);
  return e.forEach((f) => {
    let { participantId: m } = f;
    if (p.includes(m)) {
      let h = { value: u[m], name: Ka };
      it({ element: f, extension: h }), u[m].ties || Zr({ element: f, name: Pc });
    } else Zr({ element: f, name: Ka }), Zr({ element: f, name: Pc });
  }), vt({ drawDefinition: r }), { ...j, participantResults: u, bracketComplete: d, report: l };
}
function wM({ matchUps: e, matchUpId: t }) {
  return { matchUp: (e || []).find((r) => r.matchUpId === t) };
}
function bt(e) {
  let t = Ae(e, [{ [ii]: !0, [zn]: !0 }]);
  if (t.error) return t;
  let { tournamentParticipants: r, afterRecoveryTimes: i, contextProfile: n, drawDefinition: a, matchUpsMap: o, matchUpId: s, inContext: c, context: u, event: d } = e, { structures: l = [] } = In({ drawDefinition: a }), p = e.contextContent || n && ka({ contextProfile: n, drawDefinition: a });
  for (let f of l) {
    let { matchUps: m } = ut({ tournamentParticipants: r, afterRecoveryTimes: i, contextContent: p, drawDefinition: a, contextProfile: n, matchUpsMap: o, inContext: c, structure: f, context: u, event: d }), { matchUp: h } = wM({ matchUps: m, matchUpId: s });
    if (h) return { matchUp: h, structure: f };
  }
  return { error: jr };
}
function Em(e) {
  var t;
  return !$e(e) || !e.notes ? { error: we } : $e(e.element) ? !Et(e.notes) && !((t = e.notes) != null && t.testing) ? { error: ie } : (Object.assign(e.element, { notes: e.notes }), { ...j }) : { error: ie };
}
function MU(e) {
  return $e(e) ? $e(e.element) ? (e.element.notes && delete e.element.notes, { ...j }) : { error: ie } : { error: we };
}
var Om = { matchUpStatus: Xt, matchUpStatusCodes: [], score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 }, matchUpFormat: void 0, winningSide: void 0 };
function Vn(e) {
  var y, D, P, w, R, b, E, O;
  let t = "modifyMatchUpScore", r = e.matchUpFormat, i = e.matchUp, n, { matchUpStatusCodes: a, tournamentRecord: o, drawDefinition: s, matchUpStatus: c, removeScore: u, winningSide: d, matchUpId: l, event: p, notes: f, score: m } = e, h = e.appliedPolicies && Object.keys(e.appliedPolicies).length ? e.appliedPolicies : (y = nt({ policyTypes: [En], tournamentRecord: o, drawDefinition: s, structure: n, event: p })) == null ? void 0 : y.appliedPolicies, g = i.matchUpType === yt;
  if (g && s) {
    if (l && i.matchUpId !== l) {
      let M = bt({ drawDefinition: s, matchUpId: l, event: p });
      if (!M.matchUp) return { error: jr };
      ({ matchUp: i, structure: n } = M);
    }
  } else i.matchUpId !== l && console.log("!!!!!");
  c && [ct, $t].includes(c) || u ? Object.assign(i, { ...Om }) : m && (i.score = m);
  let I = c && (i == null ? void 0 : i.matchUpStatus) === Je && c !== Je;
  c && (i.matchUpStatus = c), r && (i.matchUpFormat = r), a && (i.matchUpStatusCodes = a), d && (i.winningSide = d), e.removeWinningSide && (i.winningSide = void 0), !n && s && ({ structure: n } = bt({ drawDefinition: s, matchUpId: l, event: p })), c && !i.winningSide && pr(i) && !lr.includes(c) && ![Os, so, Zi].includes(c) && (i.matchUpStatus = Sn);
  let U;
  if ((I && ((D = i == null ? void 0 : i.processCodes) != null && D.length) || c === Je) && (U = (w = (P = h == null ? void 0 : h[En]) == null ? void 0 : P.processCodes) == null ? void 0 : w.incompleteAssignmentsOnDefault), !i.collectionId) {
    let M = (n == null ? void 0 : n.structureType) === ri, N = si({ structure: n });
    if (qv({ drawDefinition: s, structure: n }) || N || M) {
      let C = (V) => {
        r = g ? "SET1-S:T100" : r ?? i.matchUpFormat ?? (V == null ? void 0 : V.matchUpFormat) ?? (s == null ? void 0 : s.matchUpFormat) ?? (p == null ? void 0 : p.matchUpFormat);
        let k = g ? { matchUpTypes: [yt] } : void 0, { matchUps: L } = ut({ afterRecoveryTimes: !1, tournamentRecord: o, inContext: !0, matchUpFilters: k, drawDefinition: s, structure: V, event: p });
        return N && (V.positionAssignments = Be(L.flatMap((B) => (B.sides ?? []).map((G) => G.participantId)).filter(Boolean)).map((B) => ({ participantId: B }))), NU({ positionAssignments: V.positionAssignments, tournamentRecord: o, drawDefinition: s, matchUpFormat: r, matchUps: L, event: p });
      }, F = M && n.structures.find((V) => V == null ? void 0 : V.matchUps.find((k) => k.matchUpId === l)), x = C(F || n);
      if (x.error) return W({ result: x, stack: t });
    }
  }
  if (f) {
    let M = Em({ element: i, notes: f });
    if (M.error) return W({ result: M, stack: t });
  }
  let v = o == null ? void 0 : o.tournamentId, S = Ji().topics.includes(um), T = (S || U) && xr({ drawDefinition: s }), A = T && ((R = ur({ matchUpFilters: { matchUpIds: [l] }, nextMatchUps: !0, tournamentRecord: o, inContext: !0, drawDefinition: s, matchUpsMap: T }).matchUps) == null ? void 0 : R[0]);
  if (S && A && YL({ tournamentId: v, inContextMatchUp: A }), Array.isArray(U) && A && !((b = A.sides) != null && b.every(({ participantId: M }) => M))) if (c === Je) i.processCodes = Be([...i.processCodes ?? [], ...U]);
  else for (let M of U || []) {
    let N = M && ((E = i == null ? void 0 : i.processCodes) == null ? void 0 : E.lastIndexOf(M));
    (O = i == null ? void 0 : i.processCodes) == null || O.splice(N, 1);
  }
  return Qe({ eventId: p == null ? void 0 : p.eventId, context: t, drawDefinition: s, tournamentId: v, matchUp: i }), { ...j };
}
function EU(e) {
  var m, h, g, I;
  let { matchUpStatusCodes: t, matchUpStatus: r, structure: i, matchUp: n, dualMatchUp: a, inContextMatchUp: o, autoCalcDisabled: s } = e, c = xd({ matchUpStatus: r }) || [Oa, Bi].includes(r) && a || s, u = ((m = n == null ? void 0 : n.sides) == null ? void 0 : m.map((U) => U.participantId).filter(Boolean).length) || ((h = o == null ? void 0 : o.sides) == null ? void 0 : h.map((U) => U.participantId).filter(Boolean).length), d = "attemptToModifyScore";
  if (!(si({ structure: i }) && u === 1 || r === Je && u || zV({ structure: i, matchUp: n, inContextMatchUp: o }) || ((I = (g = e.appliedPolicies) == null ? void 0 : g[En]) == null ? void 0 : I.requireParticipantsForScoring) === !1)) return W({ result: { error: yI }, stack: d });
  let l = [ct].includes(r), p = c ? r : e.winningSide && zt || Zi, f = Vn({ ...e, matchUpStatusCodes: c && t || [], matchUpStatus: p, context: d, removeScore: l });
  return W({ result: f, stack: d });
}
function zV({ structure: e, matchUp: t, inContextMatchUp: r }) {
  var s;
  let { drawPositions: i } = t, { positionAssignments: n } = Ir({ structure: e }), a = n == null ? void 0 : n.filter((c) => (i == null ? void 0 : i.includes(c.drawPosition)) && c.participantId), o = (s = r == null ? void 0 : r.sides) == null ? void 0 : s.every((c) => c.participantId);
  return (a == null ? void 0 : a.length) === 2 || o;
}
function RM({ collectionGroups: e = [] }) {
  let t = Object.assign({}, ...e.filter((i) => ke(i == null ? void 0 : i.groupValue) && (i == null ? void 0 : i.groupNumber)).map((i) => ({ [i.groupNumber]: { ...i, allGroupMatchUpsCompleted: !0, matchUpsCount: 0, sideWins: [0, 0], values: [0, 0] } }))), r = Object.keys(t).map((i) => be(i));
  return { groupValueGroups: t, groupValueNumbers: r };
}
function KV({ collectionDefinition: e, groupValueNumbers: t, groupValueGroups: r, sideTieValues: i, tieMatchUps: n }) {
  let a = n.filter((U) => U.collectionId === e.collectionId), o = [0, 0], s = [0, 0], c = a.every((U) => lr.includes(U.matchUpStatus)), { collectionValueProfiles: u, collectionGroupNumber: d, collectionValue: l, matchUpValue: p, winCriteria: f, scoreValue: m, setValue: h } = e, g = d && t.includes(d), I = [0, 0];
  if (a.forEach((U) => {
    U.winningSide && (I[U.winningSide - 1] += 1);
  }), ke(p) ? a.forEach((U) => {
    U.winningSide && (o[U.winningSide - 1] += p);
  }) : ke(h) ? a.forEach((U) => {
    var v, S;
    (S = (v = U.score) == null ? void 0 : v.sets) == null || S.forEach((T) => {
      T.winningSide && (o[T.winningSide - 1] += h);
    });
  }) : ke(m) ? a.forEach((U) => {
    var v, S;
    (S = (v = U.score) == null ? void 0 : v.sets) == null || S.forEach((T) => {
      let { side1TiebreakScore: A = 0, side2TiebreakScore: y = 0, side1Score: D = 0, side2Score: P = 0 } = T;
      (U.matchUpStatus === zt || U.winningSide || T.winningSide) && (D || P ? (o[0] += D, o[1] += P) : (A || y) && T.winningSide && (o[T.winningSide - 1] += 1));
    });
  }) : Array.isArray(u) && a.forEach((U) => {
    if (U.winningSide) {
      let v = U.collectionPosition, S = XV({ collectionDefinition: e, collectionPosition: v });
      ke(S) && (o[U.winningSide - 1] += S);
    }
  }), ke(l)) {
    let U;
    if (f != null && f.aggregateValue) c && (ke(p || h || m) && o[0] !== o[1] ? U = o[0] > o[1] ? 1 : 2 : I[0] !== I[1] && (U = I[0] > I[1] ? 1 : 2));
    else if (f != null && f.valueGoal) U = o.reduce((v, S, T) => S >= f.valueGoal ? T + 1 : v, 0);
    else {
      let v = Math.floor(e.matchUpCount / 2) + 1;
      U = I.reduce((S, T, A) => T >= v ? A + 1 : S, 0);
    }
    U && (g ? r[d].values[U - 1] += l : s[U - 1] += l);
  } else g ? (r[d].values[0] += o[0] || 0, r[d].values[1] += o[1] || 0) : s = o;
  g ? (r[d].sideWins[0] += I[0] || 0, r[d].sideWins[1] += I[1] || 0, r[d].allGroupMatchUpsCompleted = r[d].allGroupMatchUpsCompleted && c, r[d].matchUpsCount += a.length) : s.forEach((U, v) => i[v] += U || 0);
}
function XV({ collectionDefinition: e, collectionPosition: t }) {
  var r, i;
  return (i = (r = e.collectionValueProfiles || []) == null ? void 0 : r.find((n) => n.collectionPosition === t)) == null ? void 0 : i.matchUpValue;
}
function Jd(e) {
  var S, T, A, y, D;
  let { sideAdjustments: t = [0, 0], separator: r = "-", drawDefinition: i, matchUpsMap: n, structure: a, matchUp: o, event: s } = e;
  if (!Array.isArray(t) || t.length !== 2 || isNaN(t.reduce((P, w) => P + w))) return { error: ie };
  if (!o) return { error: hi };
  let c = ((S = Yr({ matchUp: o, drawDefinition: i, structure: a, event: s })) == null ? void 0 : S.tieFormat) || (e == null ? void 0 : e.tieFormat);
  if (!c) return { error: Gc };
  let u = oi({ tieFormat: c });
  if (u.error) return u;
  let d = (c == null ? void 0 : c.collectionDefinitions) || [], l = (o == null ? void 0 : o.tieMatchUps) ?? [], p = [0, 0], { groupValueGroups: f, groupValueNumbers: m } = RM(c);
  for (let P of d) KV({ collectionDefinition: P, groupValueNumbers: m, groupValueGroups: f, sideTieValues: p, tieMatchUps: l });
  for (let P of m) {
    let w = f[P], { allGroupMatchUpsCompleted: R, matchUpCount: b, winCriteria: E, groupValue: O, sideWins: M, values: N } = w, C;
    if (E != null && E.aggregateValue) R && N[0] !== N[1] && (C = N[0] > N[1] ? 1 : 2);
    else if (E != null && E.valueGoal) C = N.reduce((F, x, V) => x >= E.valueGoal ? V + 1 : F, void 0);
    else {
      let F = Math.floor(b / 2) + 1;
      C = M.reduce((x, V, k) => V >= F ? k + 1 : x, void 0);
    }
    C && (p[C - 1] += O || 0);
  }
  let h = p.map((P, w) => (P || 0) + t[w]), g = { side1Score: h[0], side2Score: h[1], winningSide: void 0 }, I = h.join(r), U = h.slice().reverse().join(r), v;
  if (c != null && c.winCriteria) {
    let { valueGoal: P, aggregateValue: w, tallyDirectives: R } = c.winCriteria;
    if (P ? v = (T = h.map((b, E) => ({ sideNumber: E + 1, points: b })).find(({ points: b }) => b >= P)) == null ? void 0 : T.sideNumber : w && l.every((b) => b.matchUpStatus && lr.includes(b.matchUpStatus) || b.winningSide) && h[0] !== h[1] && (v = h[0] > h[1] ? 1 : 2), !v && R) {
      let b = o.matchUpId, E = o.hasContext ? o : ((A = n == null ? void 0 : n.drawMatchUps) == null ? void 0 : A[b]) || i && ((y = bt({ inContext: !0, drawDefinition: i, matchUpId: b })) == null ? void 0 : y.matchUp);
      if (E) {
        let { completedTieMatchUps: O, order: M } = nu({ matchUps: [E] });
        if (O && (M != null && M.length)) {
          let N = M[0].participantId;
          v = (D = E.sides.find(({ participantId: C }) => C === N)) == null ? void 0 : D.sideNumber;
        }
      }
    }
  }
  return v && (g.winningSide = v), { scoreStringSide1: I, scoreStringSide2: U, winningSide: v, set: g };
}
function $d({ inContextDualMatchUp: e, drawDefinition: t, tournamentId: r, dualMatchUp: i, eventId: n }) {
  var a, o;
  if (i) {
    e || (e = (a = bt({ matchUpId: i.matchUpId, inContext: !0, drawDefinition: t })) == null ? void 0 : a.matchUp);
    let { extension: s } = We({ element: t, name: Da }), c = ge((s == null ? void 0 : s.value) || {}, !1, !0), u = ({ displaySideNumber: d, drawPosition: l, sideNumber: p }) => ({ drawPosition: l, sideNumber: p, displaySideNumber: d });
    i.sides = (o = e == null ? void 0 : e.sides) == null ? void 0 : o.map((d) => {
      var g;
      let l = d.participantId, p = l && c[l] || void 0, { lineUp: f, ...m } = ((g = i.sides) == null ? void 0 : g.find(({ sideNumber: I }) => I === d.sideNumber)) ?? {}, h = f != null && f.length ? f : p;
      return { ...u(d), ...m, lineUp: h };
    }), Qe({ context: "ensureSidLineUps", matchUp: i, drawDefinition: t, tournamentId: r, eventId: n });
  }
}
function Er(e) {
  if (e) return ge(e, !1, !0);
}
function OU(e) {
  let t = Ae(e, [{ [_r]: !0 }]);
  return t.error ? t : Object.keys(e.tournamentRecords).reduce((r, i) => {
    r.tournamentIdMap[i] = [];
    let n = e.tournamentRecords[i].events ?? [], a = n.map(({ eventId: s }) => s), o = n.map((s) => (s.drawDefinitions ?? []).map(({ drawId: c }) => c)).flat();
    return r.tournamentIdMap[i].push(...a, ...o), r.eventIds.push(...a), r.drawIds.push(...o), r;
  }, { eventIds: [], drawIds: [], tournamentIdMap: {} });
}
function bM({ tournamentRecords: e, eventId: t, drawId: r }) {
  let { tournamentIdMap: i } = OU({ tournamentRecords: e });
  return (i ? Object.keys(i) : []).find((n) => t && (i == null ? void 0 : i[n].includes(t)) || r && (i == null ? void 0 : i[n].includes(r)));
}
function La(e) {
  var b, E, O, M;
  let { exitWhenNoValues: t, drawDefinition: r, matchUpStatus: i, removeScore: n, matchUpsMap: a, matchUpId: o, event: s } = e, c = e.tournamentRecords || e.tournamentRecord && { [(b = e.tournamentRecord) == null ? void 0 : b.tournamentId]: e.tournamentRecord } || {}, u = e.tournamentId || ((E = e.tournamentRecord) == null ? void 0 : E.tournamentId);
  c && bM({ tournamentRecords: c, ...e });
  let d = u && c[u];
  if (!d) return { error: de };
  let l = bt({ drawDefinition: r, event: s, matchUpId: o });
  if (l.error) return l;
  if (!l.matchUp) return { error: jr };
  let { matchUp: p, structure: f } = l;
  if (!p.tieMatchUps) return { error: gi };
  $d({ tournamentId: d == null ? void 0 : d.tournamentId, eventId: s == null ? void 0 : s.eventId, dualMatchUp: p, drawDefinition: r });
  let { extension: m } = We({ name: vs, element: p });
  if (m != null && m.value) if (n) Zr({ element: p, name: vs });
  else return { ...j, score: p.score };
  let h = (O = Yr({ drawDefinition: r, structure: f, matchUp: p, event: s })) == null ? void 0 : O.tieFormat;
  p.tieFormat = Er(h);
  let g = Jd({ drawDefinition: r, matchUpsMap: a, structure: f, matchUp: p, event: s }), { winningSide: I, set: U, scoreStringSide1: v, scoreStringSide2: S } = g, T = (U == null ? void 0 : U.side1Score) || (U == null ? void 0 : U.side2Score);
  if (t && !p.score && !T) return { ...j };
  let A = { scoreStringSide1: v, scoreStringSide2: S, sets: U ? [U] : [] }, y = I && [1, 2].includes(I), D = y && zt || Zv({ matchUpStatus: i ?? p.matchUpStatus, tieMatchUps: p.tieMatchUps, winningSide: p.winningSide, score: A }) && Sn || Xt, P = !!(p.winningSide && !y), w = p.tieMatchUps.find(({ score: N, winningSide: C, matchUpStatus: F }) => {
    var x;
    return ((x = N == null ? void 0 : N.sets) == null ? void 0 : x.length) && (N.sets[0].side1Score || N.sets[0].side2Score) || F && lr.includes(F) || C;
  }), R;
  if (p.tieFormat && !y && !w) {
    let N = (M = Yr({ drawDefinition: r, structure: f, event: s })) == null ? void 0 : M.tieFormat;
    N && JSON.stringify(h) === JSON.stringify(N) && (p.tieFormatId = void 0, p.tieFormat = void 0, R = !0);
  }
  return Vn({ appliedPolicies: e.appliedPolicies, matchUpStatus: D, score: A, removeWinningSide: P, tournamentRecord: d, drawDefinition: r, removeScore: n, winningSide: I, matchUpId: o, matchUp: p, event: s }), { ...j, score: A, removeWinningSide: P, tieFormatRemoved: R, winningSide: I };
}
function ZV({ winnerMatchUpDrawPositionIndex: e, inContextDrawMatchUps: t, projectedWinningSide: r, sourceMatchUpStatus: i, winningDrawPosition: n, tournamentRecord: a, winnerTargetLink: o, sourceMatchUpId: s, drawDefinition: c, winnerMatchUp: u, dualMatchUp: d, matchUpsMap: l, event: p }) {
  var m, h, g, I, U;
  let f = "directWinner";
  if (o) {
    let v = u.drawPositions || [], S = v[e], T = o.source.structureId, A = Ne({ structureId: T, drawDefinition: c });
    if (A.error) return A;
    let { structure: y } = A, { positionAssignments: D } = Ir({ structureId: T, drawDefinition: c }), P = (m = D == null ? void 0 : D.find((M) => M.drawPosition === n)) == null ? void 0 : m.participantId, w = o.target.structureId, { positionAssignments: R } = Ir({ structureId: w, drawDefinition: c }), b = (h = R == null ? void 0 : R.find((M) => M.participantId === P)) == null ? void 0 : h.drawPosition, E = R == null ? void 0 : R.filter((M) => {
      let N = v.includes(M.drawPosition), C = !M.participantId && !M.bye && !M.qualifier;
      return N && C;
    }).map((M) => M.drawPosition), O = E == null ? void 0 : E.includes(S);
    if (P && o.target.roundNumber === 1 && O) qn({ drawPosition: S, participantId: P, structureId: w, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, matchUpsMap: l, event: p });
    else if (P && (E != null && E.length)) {
      let M = E.pop();
      M && qn({ participantId: P, structureId: w, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, drawPosition: M, matchUpsMap: l, event: p });
    } else if (b) {
      let M = Nc({ drawPosition: b, matchUpId: u.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: l });
      if (M.error) return W({ result: M, stack: f });
    } else if ((y == null ? void 0 : y.stage) !== Pe) {
      let M = "winner target position unavaiallble";
      return console.log(M), { error: M };
    }
    if (y != null && y.seedAssignments && y.structureId !== w) {
      let M = y.seedAssignments.find(({ participantId: C }) => C === P), N = M == null ? void 0 : M.participantId;
      M && N && tu({ eventId: u == null ? void 0 : u.eventId, structureId: w, ...M, tournamentRecord: a, drawDefinition: c, participantId: N });
    }
  } else {
    let v = Nc({ matchUpId: u.matchUpId, drawPosition: n, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: l });
    if (v.error) return v;
  }
  if (d && r) {
    let v = (g = d.sides) == null ? void 0 : g.find((S) => S.sideNumber === r);
    if (v != null && v.lineUp) {
      let S = d.roundPosition, T = u.roundPosition, A = S === T && S !== 1 || Math.floor(S / 2) === T ? 2 : 1, y = (I = l == null ? void 0 : l.drawMatchUps) == null ? void 0 : I.find(({ matchUpId: w }) => w === u.matchUpId), D = [1, 2].map((w) => {
        var R;
        return { ...((R = y.sides) == null ? void 0 : R.find((b) => b.sideNumber === w)) || {}, sideNumber: w };
      });
      y.sides = D;
      let P = y.sides.find((w) => w.sideNumber === A);
      if (P) {
        let w = (U = v.lineUp) == null ? void 0 : U.filter((R) => R == null ? void 0 : R.participantId);
        P.lineUp = pU({ lineUp: w }), Qe({ tournamentId: a == null ? void 0 : a.tournamentId, eventId: u == null ? void 0 : u.eventId, matchUp: y, context: f, drawDefinition: c });
      }
    }
  }
  return { ...j };
}
function QV(e) {
  var V, k, L;
  let { loserMatchUpDrawPositionIndex: t, inContextDrawMatchUps: r, projectedWinningSide: i, sourceMatchUpStatus: n, loserDrawPosition: a, tournamentRecord: o, loserTargetLink: s, drawDefinition: c, loserMatchUp: u, dualMatchUp: d, matchUpsMap: l, event: p } = e, f = "directLoser", m = s.linkCondition, h = u.drawPositions || [], g = m === _n && u.roundNumber === 2 && Math.min(...h.filter(Boolean)), I = g || h[t], U = g || h[1 - t], v = s.source.structureId, { structure: S } = Ne({ structureId: v, drawDefinition: c }), { matchUps: T } = ut({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: c, structure: S, event: p }), A = T.filter((B) => {
    var G;
    return (G = B.drawPositions) == null ? void 0 : G.includes(a);
  }).filter((B) => {
    let G = B.sides.find((Y) => Y.drawPosition === a), q = B.matchUpStatus === ct || B.matchUpStatus === Je && !pr(B);
    return (G == null ? void 0 : G.sideNumber) === B.winningSide && !q;
  }), y = m === _n && A.length === 0, { positionAssignments: D } = Ir({ structureId: v, drawDefinition: c }), P = (V = D == null ? void 0 : D.find((B) => B.drawPosition === a)) == null ? void 0 : V.participantId, w = s.target.structureId, { positionAssignments: R } = Ir({ structureId: w, drawDefinition: c }), b = R == null ? void 0 : R.filter(({ drawPosition: B }) => h.includes(B));
  if (b != null && b.some((B) => B.participantId === P)) return { ...j };
  let E = b == null ? void 0 : b.filter((B) => {
    let G = h.includes(B.drawPosition), q = !B.participantId && !B.bye && !B.qualifier;
    return G && q;
  }).map((B) => B.drawPosition), O = E == null ? void 0 : E.includes(I), M = s.target.roundNumber > 1 && (E == null ? void 0 : E.length), N = s.target.roundNumber === 1 && O;
  if (g) {
    let B = C();
    if (B.error) return W({ result: B, stack: f });
  } else if (N) {
    let B = x();
    if (B.error) return W({ result: B, stack: f });
  } else if (P && M) {
    E.sort(ar);
    let B = E[0], G = qn({ participantId: P, structureId: w, drawPosition: B, inContextDrawMatchUps: r, sourceMatchUpStatus: n, tournamentRecord: o, drawDefinition: c, matchUpsMap: l, event: p });
    if (G.error) return W({ result: G, stack: f });
  } else return W({ context: { loserDrawPosition: a, loserTargetLink: s, targetDrawPositionIsUnfilled: O }, result: { error: O ? xc : WF }, stack: f });
  if (S != null && S.seedAssignments && S.structureId !== w) {
    let B = S.seedAssignments.find(({ participantId: q }) => q === P), G = B == null ? void 0 : B.participantId;
    B && G && tu({ eventId: u == null ? void 0 : u.eventId, structureId: w, ...B, tournamentRecord: o, drawDefinition: c, participantId: G });
  }
  if (d && i) {
    let B = (k = d.sides) == null ? void 0 : k.find((G) => G.sideNumber === 3 - i);
    if (B != null && B.lineUp) {
      let { roundNumber: G, eventId: q } = u, { roundPosition: Y } = d, H = G === 1 ? 2 - Y % 2 : 1, X = (L = l == null ? void 0 : l.drawMatchUps) == null ? void 0 : L.find(({ matchUpId: te }) => te === u.matchUpId), z = [1, 2].map((te) => {
        var ne;
        return { ...((ne = X.sides) == null ? void 0 : ne.find((ee) => ee.sideNumber === te)) || {}, sideNumber: te };
      });
      X.sides = z;
      let Z = X.sides.find((te) => te.sideNumber === H);
      Z && (Z.lineUp = pU({ lineUp: B.lineUp }), Qe({ tournamentId: o == null ? void 0 : o.tournamentId, matchUp: X, context: f, drawDefinition: c, eventId: q }));
    }
  }
  return { ...j };
  function C() {
    let B = "loserLinkFedFMLC";
    return W(y ? { result: x(), stack: B } : { result: F(), stack: B });
  }
  function F() {
    let B = _i({ drawPosition: U, structureId: w, tournamentRecord: o, drawDefinition: c, event: p });
    return W({ result: B, stack: "assignLoserPositionBye" });
  }
  function x() {
    let B = P ? qn({ drawPosition: I, participantId: P, structureId: w, inContextDrawMatchUps: r, sourceMatchUpStatus: n, tournamentRecord: o, drawDefinition: c, matchUpsMap: l, event: p }) : { error: cr };
    return W({ result: B, stack: "assignLoserDrawPosition" });
  }
}
function NM(e) {
  var A;
  let t = "directParticipants", r = EU(e);
  if (r.error) return W({ result: r, stack: t });
  let i = xd({ matchUpStatus: e.matchUpStatus }), { dualWinningSideChange: n, projectedWinningSide: a, inContextDrawMatchUps: o, tournamentRecord: s, drawDefinition: c, matchUpStatus: u, dualMatchUp: d, matchUpsMap: l, winningSide: p, targetData: f, matchUpId: m, structure: h, matchUp: g, event: I } = e, U = !!g.collectionId, v = si({ structure: h }), S = g.drawPositions, T;
  if (U) {
    let { matchUpTieId: y, matchUpsMap: D } = e, P = La({ appliedPolicies: e.appliedPolicies, matchUpId: y, tournamentRecord: s, drawDefinition: c, matchUpsMap: D, event: I });
    if (T = P && { tieMatchUpResult: P }, S = (A = o.find(({ matchUpId: w }) => w === y)) == null ? void 0 : A.drawPositions, !n) return W({ result: { ...j, ...T }, stack: t });
  }
  if (v) return W({ result: { ...j, ...T }, stack: t });
  if (S) {
    let y = a ? a - 1 : p - 1, D = 1 - y, P = S[y], w = S[D], { targetLinks: { loserTargetLink: R, winnerTargetLink: b, byeTargetLink: E }, targetMatchUps: { winnerMatchUpDrawPositionIndex: O, loserMatchUpDrawPositionIndex: M, winnerMatchUp: N, loserMatchUp: C, byeMatchUp: F } } = f;
    if (N) {
      let x = ZV({ sourceMatchUpStatus: i && u || zt, winnerMatchUpDrawPositionIndex: O, sourceMatchUpId: m, inContextDrawMatchUps: o, projectedWinningSide: a, winningDrawPosition: P, tournamentRecord: s, winnerTargetLink: b, drawDefinition: c, winnerMatchUp: N, dualMatchUp: d, matchUpsMap: l, event: I });
      if (x.error) return W({ result: x, stack: t });
    }
    if (C) {
      let x = QV({ sourceMatchUpStatus: i && u || zt, loserMatchUpDrawPositionIndex: M, sourceMatchUpId: m, inContextDrawMatchUps: o, projectedWinningSide: a, loserDrawPosition: w, tournamentRecord: s, loserTargetLink: R, drawDefinition: c, loserMatchUp: C, winningSide: p, matchUpsMap: l, dualMatchUp: d, event: I });
      if (x.error) return W({ result: x, stack: t });
    }
    if (F) {
      let x = F.drawPositions || [], V = Math.min(...x.filter(Boolean)), k = E.target.structureId, L = _i({ drawPosition: V, structureId: k, tournamentRecord: s, drawDefinition: c, event: I });
      if (L.error) return W({ result: L, stack: t });
    }
  } else return W({ result: { error: ad }, stack: t });
  return W({ result: { ...j, ...T }, stack: t });
}
function CU(e) {
  var H, X, z, Z;
  let t = "genPlayoffStructure";
  if (!e.drawDefinition) return W({ result: { error: Ue }, stack: t });
  let r = Kd(e);
  if (r.error) return W({ result: r, stack: t });
  let { structureId: i, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionNaming: o, finishingPositionLimit: s, playoffAttributes: c, playoffPositions: u, roundOffsetLimit: d, tournamentRecord: l, exitProfileLimit: p, roundProfiles: f, roundNumbers: m, idPrefix: h, isMock: g, event: I, uuids: U } = e, v = ge(e.drawDefinition, !1, !0), { structure: S } = Ne({ structureId: i, drawDefinition: v });
  if (!S) return W({ result: { error: kt }, stack: t });
  if (S.structureType === ri || S.structures) return MV({ sourceStructureId: S.structureId, ...e, ...r, drawDefinition: v });
  let { playoffRoundsRanges: T, playoffRounds: A } = r, { playoffPositionsReturned: y, error: D, playoffSourceRounds: P, playoffRoundsRanges: w } = lM(e);
  if (D) return W({ result: { error: D }, stack: t });
  let R = (f == null ? void 0 : f.length) && Object.assign({}, ...f), b = m || typeof f == "object" && f.map((te) => Object.keys(te)).flat(), E = Array.isArray(b) && b.map((te) => !isNaN(te) && be(te)).filter(Boolean);
  if (E) {
    if (!Array.isArray(E)) return W({ result: { error: ie }, context: { validRoundNumbers: E }, stack: t });
    E.forEach((te) => {
      if (!(A != null && A.includes(te))) return W({ result: { error: ie }, context: { roundNumber: te }, stack: t });
    });
  }
  u && u.forEach((te) => {
    if (!(y != null && y.includes(te))) return W({ result: { error: ie }, context: { playoffPosition: te }, stack: t });
  });
  let O = E || P, M = E ? T : w, N = [], C = [];
  for (let te of O ?? []) {
    let ne = M == null ? void 0 : M.find((se) => se.roundNumber === te);
    if (!ne) return W({ result: { error: ie }, context: { roundNumber: te }, stack: t });
    let ee = ne.finishingPositions.length, K = Math.min(...ne.finishingPositions) - 1, J = 2, $ = te && (R == null ? void 0 : R[te]) && J + R[te] - 1, ae = uc({ exitProfile: `0-${te}`, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionOffset: K, playoffAttributes: c, exitProfileLimit: p, stage: Wt, roundOffset: 0, drawDefinition: v, sequenceLimit: $, stageSequence: J, drawSize: ee, idPrefix: h, isMock: g, uuids: U, finishingPositionNaming: o, finishingPositionLimit: s, roundOffsetLimit: d });
    if (ae.error) return W({ result: ae, stack: t });
    let { structures: oe, links: ce } = ae;
    if (oe != null && oe.length && N.push(...oe), ce != null && ce.length && C.push(...ce), ae.structureId && te) {
      let se = { linkType: oa, source: { structureId: i, roundNumber: te }, target: { structureId: ae.structureId, feedProfile: dn, roundNumber: 1 } };
      C.push(se);
    }
  }
  if (!N.length) return W({ result: { error: ie }, info: "No structures generated", stack: t });
  v.structures.push(...N), v.links.push(...C);
  let { matchUps: F, matchUpsMap: x } = ur({ inContext: !0, drawDefinition: v }), V = N.map(({ structureId: te }) => te), k = F == null ? void 0 : F.filter(({ structureId: te }) => V.includes(te)).map(hr), L = (H = x == null ? void 0 : x.drawMatchUps) == null ? void 0 : H.filter(({ matchUpId: te }) => k == null ? void 0 : k.includes(te));
  if (L != null && L.length) {
    let te = (X = Yr({ drawDefinition: v, event: I })) == null ? void 0 : X.tieFormat;
    te && L.forEach((ne) => {
      let { tieMatchUps: ee } = Xd({ matchUp: ne, tieFormat: te, isMock: g });
      Object.assign(ne, { tieMatchUps: ee, matchUpType: yt });
    });
  }
  (z = F == null ? void 0 : F.filter((te) => yo({ matchUp: te }) && te.structureId === i)) == null || z.forEach((te) => {
    let { matchUpId: ne, score: ee, winningSide: K } = te, J = ei({ inContextDrawMatchUps: F, drawDefinition: v, matchUpId: ne }), $ = NM({ inContextDrawMatchUps: F, tournamentRecord: l, drawDefinition: v, matchUpsMap: x, winningSide: K, targetData: J, matchUpId: ne, structure: S, matchUp: te, score: ee, event: I });
    $.error && console.log($.error);
  }), (Z = F == null ? void 0 : F.filter((te) => te.matchUpStatus === at && te.structureId === i)) == null || Z.forEach((te) => {
    let { matchUpId: ne } = te, ee = ei({ inContextDrawMatchUps: F, drawDefinition: v, matchUpId: ne }), { targetLinks: { loserTargetLink: K }, targetMatchUps: { loserMatchUpDrawPositionIndex: J, loserMatchUp: $ } } = ee;
    if (K && $) {
      let ae = K.target.structureId, oe = $.drawPositions[J], ce = _i({ drawPosition: oe, structureId: ae, tournamentRecord: l, drawDefinition: v, event: I });
      ce.error && console.log(ce.error);
    }
  });
  let B = [], G = Eo({ inContextDrawMatchUps: F, drawDefinition: v, matchUpsMap: x }).goesToMap, { structure: q } = Ne({ drawDefinition: e.drawDefinition, structureId: i }), { matchUps: Y } = ut({ structure: q });
  return Y.forEach((te) => {
    var K, J;
    let ne = G == null ? void 0 : G.loserMatchUpIds[te.matchUpId];
    if (ne && te.loserMatchUpId !== ne) {
      te.loserMatchUpId = ne;
      let $ = { tournamentId: l == null ? void 0 : l.tournamentId, eventId: (K = e.event) == null ? void 0 : K.eventId, context: t, matchUp: te };
      B.push($);
    }
    let ee = G == null ? void 0 : G.winnerMatchUpIds[te.matchUpId];
    if (ee && te.winnerMatchUpId !== ee) {
      te.winnerMatchUpId = ee;
      let $ = { tournamentId: l == null ? void 0 : l.tournamentId, eventId: (J = e.event) == null ? void 0 : J.eventId, context: t, matchUp: te };
      B.push($);
    }
  }), { structures: N, matchUpModifications: B, links: C, drawDefinition: v, ...j };
}
function MM({ element: e }) {
  if (!e) return { error: ie };
  if (!e.timeItems) return {};
  if (!Array.isArray(e.timeItems)) return { error: ie };
  let t = (r, i) => (n, a) => (a[r] && (n[a[r]] = a[i]), n);
  return e.timeItems.reduce(t("itemType", "itemValue"), {});
}
function Xn(e) {
  let { duplicateValues: t = !0, creationTime: r = !0, removePriorValues: i, timeItem: n } = e;
  if (!n) return { error: FI };
  let a = Vb(e);
  if (a.error) return a;
  if (!($e(n) && Et(n.itemType) && Object.keys(n).includes("itemValue"))) return { error: CI };
  if (!a.timeItems) a.timeItems = [];
  else if (JV({ element: a, duplicateValues: t, timeItem: n })) return { ...j };
  if (n.itemSubTypes && !n.itemSubTypes.length && delete n.itemSubTypes, r) {
    let o = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(n, { createdAt: o });
  }
  return i && (a.timeItems = a.timeItems.filter(({ itemType: o }) => n.itemType !== o)), i && !n.itemValue || a.timeItems.push(n), { ...j };
}
function JV({ element: e, duplicateValues: t, timeItem: r }) {
  var s;
  let { itemType: i, itemSubTypes: n, itemValue: a } = r, o = i && ((s = en({ itemSubTypes: n, itemType: i, element: e })) == null ? void 0 : s.timeItem);
  return o && JSON.stringify(o == null ? void 0 : o.itemValue) === JSON.stringify(a) && !t;
}
function FU({ creationTime: e = !0, removePriorValues: t, tournamentRecord: r, duplicateValues: i, participantId: n, timeItem: a }) {
  if (!r) return { error: de };
  if (!n) return { error: cr };
  let o = co({ tournamentRecord: r, participantId: n });
  return o.error ? o : Xn({ element: o.participant, removePriorValues: t, duplicateValues: i, creationTime: e, timeItem: a });
}
function el(e) {
  let { removePriorValues: t, tournamentRecord: r, duplicateValues: i, creationTime: n, timeItem: a } = e;
  if (!r) return { error: de };
  let o = Xn({ element: r, removePriorValues: t, duplicateValues: i, creationTime: n, timeItem: a });
  if (o.error) return o;
  let s = MM({ element: r });
  return Le({ payload: { parentOrganisation: r.parentOrganisation, tournamentId: r.tournamentId, timeItemValues: s }, topic: jo }), o;
}
function Ys(e) {
  let { removePriorValues: t, duplicateValues: r, creationTime: i, timeItem: n, event: a } = e;
  return a ? Xn({ removePriorValues: t, duplicateValues: r, element: a, creationTime: i, timeItem: n }) : { error: Ki };
}
function EM(e) {
  return Cm({ ...e, itemType: "attachConsolationStructures" });
}
function kU(e) {
  return Cm({ ...e, itemType: "attachPlayoffStructures" });
}
function Cm({ itemType: e = "attachStructures", matchUpModifications: t, tournamentRecord: r, drawDefinition: i, structures: n, links: a = [], event: o }) {
  var g, I, U;
  let s = "attachStructures";
  if (!i) return { error: Ue };
  if (!Array.isArray(n) || !Array.isArray(a)) return W({ result: { error: ie }, stack: s });
  let c = (v) => {
    var S;
    return [v.source.structureId, v.source.roundNumber || ((S = v.source.finishingPositions) == null ? void 0 : S.join("|")), v.target.roundNumber].join("|");
  }, u = (g = i.links) == null ? void 0 : g.map(c);
  if (a.some((v) => {
    let S = c(v);
    return u == null ? void 0 : u.includes(S);
  })) return W({ result: { error: VI }, info: "playoff structure exists", stack: s });
  a.length && ((I = i.links) == null || I.push(...a));
  let d = n.map(({ structureId: v }) => v), l = (U = i.structures) == null ? void 0 : U.map(({ structureId: v }) => v);
  i.structures = (i.structures ?? []).map((v) => d.includes(v.structureId) ? n.find(({ structureId: S }) => S === v.structureId) : v);
  let p = n == null ? void 0 : n.filter(({ structureId: v }) => !(l != null && l.includes(v)));
  p.length && i.structures.push(...p), Eo({ drawDefinition: i });
  let f = n.map((v) => {
    var S;
    return ((S = ut({ structure: v })) == null ? void 0 : S.matchUps) || [];
  }).flat();
  Za({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: o == null ? void 0 : o.eventId, drawDefinition: i, matchUps: f });
  let m = n.map(({ structureId: v }) => v);
  if (vt({ drawDefinition: i, structureIds: m }), t == null ? void 0 : t.length) {
    let v = {};
    t.forEach((T) => {
      var y;
      let A = (y = T.matchUp) == null ? void 0 : y.matchUpId;
      A && (v[A] = T);
    });
    let S = (T) => {
      T.matchUps.forEach((A) => {
        if (v[A.matchUpId]) {
          let { tieMatchUps: y, ...D } = v[A.matchUpId].matchUp;
          if (Object.assign(A, D), y == null ? void 0 : y.length) {
            let P = {};
            y.forEach((w) => v[w.matchUpId] = w), A.tieMatchUps.forEach((w) => Object.assign(w, P[w.matchUpId]));
          }
          v[A.matchUpId].matchUp = A, Qe(v[A.matchUpId]);
        }
      });
    };
    i.structures.forEach((T) => {
      if (l != null && l.includes(T.structureId)) if (T.structures) for (let A of T.structures) S(A);
      else S(T);
    });
  }
  let h = p.map(Ni("structureId"));
  if (r) {
    let v = { itemValue: { structureIds: m, drawId: i.drawId }, itemType: e };
    Xn({ element: r, timeItem: v });
  }
  return { ...j, addedStructureIds: h };
}
function Fm(e) {
  var o, s;
  let { structures: t, links: r, matchUpModifications: i, error: n } = CU(e);
  if (n) return { error: n };
  let a = e.drawDefinition;
  return kU({ tournamentId: (o = e.tournamentRecord) == null ? void 0 : o.tournamentId, eventId: ((s = e.event) == null ? void 0 : s.eventId) || e.eventId, matchUpModifications: i, drawDefinition: a, structures: t, links: r });
}
function Co(e) {
  let t = Ae(e, [{ _anyOf: { [_r]: !1, [fr]: !1, [ii]: !1, [no]: !1 }, [nv]: !0 }]);
  if (t.error) return t;
  let r = [], i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i) {
    let n = bT(e, i);
    if (n.error) return n;
    r.push(...(n == null ? void 0 : n.applied) ?? []), e.drawDefinition && vt({ drawDefinition: e.drawDefinition, tournamentId: e.tournamentId });
  } else if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length) return { error: de };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = bT(e, o);
      if (s.error) return s;
      r.push(...(s == null ? void 0 : s.applied) ?? []);
    }
  } else return { error: de };
  return r.length ? { ...j, applied: r } : { error: wI };
}
function bT(e, t) {
  let r = nt(e).appliedPolicies ?? {};
  t.extensions || (t.extensions = []);
  let i = [], n = Object.keys(e.policyDefinitions);
  if (!n.length) return { error: Mf };
  for (let a of n) if (!r[a] || e.allowReplacement) {
    let o = e.policyDefinitions[a];
    if (!o) continue;
    if (!$e(o)) return { error: ie };
    let { policyName: s, ...c } = o;
    if (!c || !Object.keys(c).length || s && !Et(s)) return { error: ie };
    r[a] = e.policyDefinitions[a], i.push(a);
  }
  return i != null && i.length ? { ...it({ element: t, extension: { name: qu, value: r } }), applied: i } : { applied: i, error: wI };
}
function LU({ tournamentRecord: e, drawDefinition: t, flightProfile: r, drawName: i, drawId: n, event: a }) {
  var s;
  if (!i || typeof i != "string") return W({ result: { error: ie }, context: { drawName: i } });
  r || (r = Ht({ event: a }).flightProfile);
  let o = (s = r == null ? void 0 : r.flights) == null ? void 0 : s.find((c) => c.drawId === n);
  if (o) {
    o.drawName = i;
    let c = { name: gn, value: { ...r, flights: r.flights } };
    oo({ event: a, extension: c });
  }
  return t && (t.drawName = i, vt({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t })), !o && !t ? { error: Ue } : { ...j, flight: o };
}
function OM({ tournamentRecord: e, drawDefinition: t, drawUpdates: r, drawId: i, event: n }) {
  var c;
  if (!$e(r)) return { error: ie };
  let a = Ht({ event: n }).flightProfile, o = r.drawName && LU({ drawName: r.drawName, tournamentRecord: e, drawDefinition: t, flightProfile: a, drawId: i, event: n });
  if (o != null && o.error) return o == null ? void 0 : o.error;
  let s = (o == null ? void 0 : o.flight) || ((c = a == null ? void 0 : a.flights) == null ? void 0 : c.find((u) => u.drawId === i));
  if (!s && !t) return { error: Ue };
  if (s) {
    let u = { name: gn, value: { ...a, flights: a.flights } };
    oo({ event: n, extension: u });
  }
  return t && (r.policyDefinitions && Co({ policyDefinitions: r.policyDefinitions, drawDefinition: t }), vt({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t })), { ...j };
}
function CM({ tournamentRecord: e, removeScheduling: t, drawDefinition: r }) {
  var o, s;
  if (!r) return { error: Ue };
  let i = xr({ drawDefinition: r }), n = (c) => {
    var u;
    return (u = i == null ? void 0 : i.drawMatchUps) == null ? void 0 : u.find((d) => d.matchUpId === c);
  };
  for (let c of r.structures || []) {
    let { positionAssignments: u, stage: d, stageSequence: l } = c;
    u && (l !== 1 || ![Pe, Ie].includes(d)) && (c.positionAssignments = u.map((m) => (delete m.participantId, m)), c.seedAssignments = []);
    let { matchUps: p, isRoundRobin: f } = ut({ afterRecoveryTimes: !1, inContext: !0, matchUpsMap: i, structure: c });
    for (let m of p) {
      let { matchUpId: h, roundNumber: g } = m, I = m.sides || [], U = n(h);
      if (U) {
        if (delete U.extensions, delete U.notes, U.matchUpStatus !== at && Object.assign(U, Om), g && g > 1 && ((o = U.drawPositions) == null ? void 0 : o.length) && !f) {
          let v = I == null ? void 0 : I.map(({ drawPosition: T, participantFed: A }) => !A && T).filter(Boolean), S = U.drawPositions.map((T) => v.includes(T) ? void 0 : T);
          U.drawPositions = S;
        }
        t ? delete U.timeItems : (s = U.timeItems) != null && s.length && (U.timeItems = U.timeItems.filter((v) => v.itemType && ![ua, Ja, ks, Yv, Ls, xs].includes(v.itemType))), Qe({ tournamentId: e == null ? void 0 : e.tournamentId, context: "resetDrawDefiniton", drawDefinition: r, matchUp: U });
      }
    }
  }
  r.extensions = r.extensions.filter((c) => c.name !== cc);
  let a = (r.structures || []).map(({ structureId: c }) => c);
  return vt({ drawDefinition: r, structureIds: a }), { ...j };
}
function tl({ tournamentRecord: e }) {
  var i;
  if (!e) return { error: de };
  let t = { positionsNoOutcomes: [], canBePruned: [], matchPlay: [], inactive: [], drawAnalysis: {} }, r = {};
  return ((i = e.events) == null ? void 0 : i.map((n) => {
    let a = n.eventId;
    return r[a] = n, ((n == null ? void 0 : n.drawDefinitions) || []).map((o) => ({ drawDefinition: o, eventId: a }));
  }).flat().filter(Boolean)).forEach(({ drawDefinition: n, eventId: a }) => {
    let o = 0, s = 0, c = 0, { allStructuresLinked: u } = bm({ drawDefinition: n }), d = r[a], l = ((n == null ? void 0 : n.structures) || []).map((S) => {
      let { stage: T, stageSequence: A, structureId: y } = S, D = hs[T], { inContextStructureMatchUps: P } = Bd({ drawDefinition: n, structure: S, event: d }), w = P == null ? void 0 : P.filter(({ winningSide: B }) => B), R = w.filter(Boolean).length || 0;
      s += R, c += P.length - s;
      let b = Math.max(w.filter(({ roundNumber: B }) => B === 1).map(({ roundPosition: B }) => B)), { positionAssignments: E } = gt({ structure: S }), O = E == null ? void 0 : E.filter(({ participantId: B }) => B);
      o += (O == null ? void 0 : O.length) ?? 0;
      let M = ((E == null ? void 0 : E.length) ?? 0) - ((O == null ? void 0 : O.length) ?? 0), { roundMatchUps: N, roundProfile: C, roundNumbers: F, maxMatchUpsCount: x } = $r({ matchUps: P }), V = C && Object.keys(C).filter((B) => !C[B].inactiveRound).map((B) => parseInt(B)), k = C && Object.keys(C).filter((B) => C[B].inactiveRound).map((B) => parseInt(B)), L = C && Object.values(C).every((B) => B.inactiveRound);
      return { positionsAssignedCount: (O == null ? void 0 : O.length) ?? 0, maxWinningSideFirstRoundPosition: b, unassignedPositionsCount: M, inactiveStructure: L, maxMatchUpsCount: x, inactiveRounds: k, roundMatchUps: N, activeRounds: V, roundNumbers: F, roundProfile: C, structureId: y, stageSequence: A, orderNumber: D, stage: T };
    }), p = l.find((S) => S.orderNumber === 2 && S.stageSequence === 1), f = l.filter(({ inactiveStructure: S }) => !S).length, { links: m } = Qc({ structureId: p.structureId, drawDefinition: n }), h = be(p.activeRounds[0]) === 1 && p.activeRounds.length === 1 && f === 1, g = l == null ? void 0 : l.every(({ inactiveStructure: S }) => S), I = !m.length && p.activeRounds.length && (p.roundProfile[1].inactiveCount || p.inactiveRounds.length), U = n.drawId;
    o && !s && t.positionsNoOutcomes.push(U), g && t.inactive.push(U), h && t.matchPlay.push(U), I && t.canBePruned.push(U);
    let v = { matchUpsWithWinningSideCount: s, matchUpsNoOutcomeCount: c, positionsAssignedCount: o, allStructuresLinked: u, structuresData: l, inactiveDraw: g, isMatchPlay: h, drawId: U };
    t.drawAnalysis[U] = v;
  }), { ...j, drawsAnalysis: t };
}
function FM({ matchPlayDrawPositions: e = !0, tournamentRecord: t, drawDefinition: r, drawId: i }) {
  var o;
  if (!t) return { error: de };
  if (!r) return { error: Ue };
  let n = [], { drawsAnalysis: a } = tl({ tournamentRecord: t });
  if (a.canBePruned.includes(i)) {
    let s = a.matchPlay.includes(i), c = a.drawAnalysis[i], { structures: [u] } = In({ stageSequence: 1, drawDefinition: r, stage: Ie }), d = c.structuresData.find(({ structureId: m }) => u.structureId === m), l = (u.matchUps ?? []).sort((m, h) => m.roundPosition - h.roundPosition);
    n = l.filter(({ roundNumber: m }) => !d.inactiveRounds.includes(m));
    let p = n.map(hr), f = l.map(hr).filter((m) => !p.includes(m));
    if (s) {
      let m = n.filter(({ roundNumber: v }) => !d.inactiveRounds.includes(v)).filter(({ winningSide: v }) => v), h = m.map(hr), g = p.filter((v) => !h.includes(v));
      f.push(...g);
      let I = m.flatMap((v) => v.drawPositions ?? []).filter(Boolean).flat(), U = Object.assign({}, ...I.map((v, S) => ({ [v]: S + 1 })));
      if (m.forEach((v) => {
        e ? v.drawPositions = v.drawPositions.map((S) => U[S]) : delete v.drawPositions;
      }), e) {
        let v = (o = u == null ? void 0 : u.positionAssignments) == null ? void 0 : o.filter((S) => I.includes(S.drawPosition)).map((S) => (S.drawPosition = U[S.drawPosition], S));
        u.positionAssignments = v;
      } else u.positionAssignments = [];
      u.matchUps = m, n = m;
    }
    Ca({ tournamentId: t == null ? void 0 : t.tournamentId, matchUpIds: f, drawDefinition: r }), vt({ drawDefinition: r });
  }
  return { ...j, matchUps: n };
}
function kM({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, qualifier: a, event: o, bye: s }) {
  if (!t) return { error: Ue };
  if (!i) return { error: Bc };
  if (!n) return { error: Vi };
  if (s) {
    let c = _i({ tournamentRecord: e, drawDefinition: t, drawPosition: i, structureId: n, event: o });
    if (c.error) return c;
  } else {
    if (a) return { error: Vf };
    {
      let c = qn({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, event: o });
      if (c.error) return c;
    }
  }
  return { ...j };
}
function LM(e) {
  var c, u, d, l, p;
  let t = e.matchUpIds ?? [], { drawDefinition: r } = e, i = e.structureId ?? ((u = (c = r == null ? void 0 : r.structures) == null ? void 0 : c.find((f) => {
    var m;
    return (m = f.matchUps) == null ? void 0 : m.some(({ matchUpId: h }) => t.includes(h));
  })) == null ? void 0 : u.structureId) ?? ((l = (d = r == null ? void 0 : r.structures) == null ? void 0 : d[0]) == null ? void 0 : l.structureId);
  if (!i) return { error: kt };
  let n = (p = r.structures) == null ? void 0 : p.find((f) => f.structureId === i);
  if (!n) return { error: kt };
  let a = n == null ? void 0 : n.matchUps, o = a == null ? void 0 : a.find((f) => !!f.roundPosition);
  if (n.structures || o || n.finishingPosition === Es) return { error: xo };
  let s = a.filter(({ roundNumber: f }) => {
    var m;
    return (m = e.roundNumbers) == null ? void 0 : m.includes(f);
  }).map(hr);
  return t = t.filter((f) => !s.includes(f)), e.roundNumbers && !t.length && (t = s), { existingMatchUps: a, matchUpIds: t, structureId: i, structure: n };
}
function xM(e) {
  let t = Ae(e, [{ [ii]: !0 }, { [Ac]: { [Id]: !1, roundNumbers: !1 }, [xi]: ie, [ui]: Gr }]);
  if (t.error) return t;
  let { removeIncomplete: r = !1, removeUnAssigned: i = !0, removeCompleted: n = !1, tournamentRecord: a, drawDefinition: o, event: s } = e, c = LM(e);
  if (c.error) return c;
  let { structure: u, structureId: d, existingMatchUps: l, matchUpIds: p } = c, f = [], m = (l == null ? void 0 : l.filter(({ matchUpId: I, score: U, winningSide: v }) => {
    if (v && !n) return !1;
    if (v || pr({ score: U })) {
      if (!v && !r) return !1;
      f.push(I);
    } else if (!i) return !1;
    return p == null ? void 0 : p.includes(I);
  })) ?? [], h = m.map(hr), g = m.map(({ tieMatchUps: I }) => I == null ? void 0 : I.map(hr)).filter(Boolean).flat();
  if (h.length) {
    u.matchUps = (u.matchUps ?? []).filter(({ matchUpId: v }) => !h.includes(v)), Ca({ tournamentId: a == null ? void 0 : a.tournamentId, matchUpIds: [...g, ...h], action: "deleteAdHocMatchUps", eventId: s == null ? void 0 : s.eventId, drawDefinition: o });
    let I = Be(u.matchUps.map(Ni("roundNumber"))), U = LF(I);
    if (U.length) {
      U.reverse();
      for (let v of U) u.matchUps.forEach((S) => {
        S.roundNumber && S.roundNumber > v && (S.roundNumber -= 1, Qe({ tournamentId: a == null ? void 0 : a.tournamentId, context: ["adHoc round deletion"], eventId: s == null ? void 0 : s.eventId, drawDefinition: o, matchUp: S }));
      });
    }
    if (f.length) {
      u.positionAssignments = Be(u.matchUps.flatMap((y) => (y.sides ?? []).map((D) => D.participantId)).filter(Boolean)).map((y) => ({ participantId: y }));
      let v = (u == null ? void 0 : u.matchUpFormat) ?? (o == null ? void 0 : o.matchUpFormat) ?? (s == null ? void 0 : s.matchUpFormat), S = c.existingMatchUps.some((y) => y.matchUpType === Ci) ? { matchUpTypes: [Ci] } : void 0, { matchUps: T } = ut({ afterRecoveryTimes: !1, inContext: !0, matchUpFilters: S, structure: u, event: s });
      si({ structure: u }) && (u.positionAssignments = Be(T.flatMap((y) => (y.sides ?? []).map((D) => D.participantId)).filter(Boolean)).map((y) => ({ participantId: y })));
      let A = NU({ positionAssignments: u.positionAssignments, tournamentRecord: a, drawDefinition: o, matchUpFormat: v, matchUps: T, event: s });
      A.error && console.log(A);
    }
    vt({ structureIds: [d], eventId: s == null ? void 0 : s.eventId, drawDefinition: o });
  }
  return !h.length && p.length ? { error: jf } : { ...j, deletedMatchUpsCount: [...h, ...g].length };
}
function BM({ removeCompletedMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: i, roundNumber: n, event: a }) {
  if (!t) return { error: de };
  if (!r) return { error: Ue };
  if (!n) return W({ result: { error: we }, info: "roundNumber required" });
  let o = Ne({ drawDefinition: r, structureId: i });
  if (o.error) return o;
  let s = o.structure;
  return s != null && s.structures ? { error: xo } : si({ structure: s }) ? $V({ tournamentId: t.tournamentId, removeCompletedMatchUps: e, eventId: a.eventId, drawDefinition: r, roundNumber: n, structure: s }) : (console.log("not implemented"), { ...j });
}
function $V({ removeCompletedMatchUps: e, drawDefinition: t, tournamentId: r, roundNumber: i, structure: n, eventId: a }) {
  let o = (n == null ? void 0 : n.matchUps) ?? [], s = [], c = [], u = !1;
  if (o.reduce((d, l) => {
    let p = l == null ? void 0 : l.roundNumber;
    return p ? d.includes(p) ? d : d.concat(p) : d;
  }, []).sort(ar).includes(i)) {
    let d = o.filter((l) => {
      let p = l.roundNumber === i && (!lr.includes(l.matchUpStatus) || e);
      return p && (c.push(l.matchUpId), l.tieMatchUps && s.push(...l.tieMatchUps.map(hr))), !p;
    });
    c.length && (Ca({ matchUpIds: [...s, ...c], drawDefinition: t, tournamentId: r, eventId: a }), d.some((l) => l.roundNumber === i) || (d.forEach((l) => {
      l.roundNumber > i && (l.roundNumber -= 1, Qe({ drawDefinition: t, tournamentId: r, eventId: a, matchUp: l }));
    }), u = !0), n.matchUps = d);
  }
  return { deletedMatchUpsCount: c.length, roundRemoved: u, ...j };
}
function km(e) {
  var p, f, m, h, g, I;
  let { suppressNotifications: t, tournamentRecord: r, drawDefinition: i, matchUps: n, event: a } = e;
  if (typeof i != "object") return { error: Ue };
  let o = e == null ? void 0 : e.structureId;
  if (!o && ((p = i.structures) == null ? void 0 : p.length) === 1 && (o = (m = (f = i.structures) == null ? void 0 : f[0]) == null ? void 0 : m.structureId), typeof o != "string") return { error: Vi };
  if (!rn(n)) return { error: ie, info: Oo("matchUps") };
  let s = (h = i.structures) == null ? void 0 : h.find((U) => U.structureId === o);
  if (!s) return { error: kt };
  let c = (s == null ? void 0 : s.matchUps).find((U) => !!U.roundPosition);
  if (s.structures || c || s.finishingPosition === Es) return { error: xo };
  let u = ((I = (g = Pr({ tournamentRecord: r, inContext: !1 })) == null ? void 0 : g.matchUps) == null ? void 0 : I.map(hr)) ?? [], d = n.map(hr);
  if (Jr(u, d)) return { error: qw, info: "One or more matchUpIds already present in tournamentRecord" };
  s.matchUps.push(...n);
  let l = n.map(({ tieMatchUps: U }) => U).filter(Boolean).flat();
  return t || (Za({ tournamentId: r == null ? void 0 : r.tournamentId, matchUps: [...l, ...n], eventId: a == null ? void 0 : a.eventId, drawDefinition: i }), vt({ drawDefinition: i, structureIds: [o] })), { ...j };
}
function VM({ tournamentRecord: e, drawDefinition: t, drawPosition: r, structureId: i, subOrder: n, event: a }) {
  var f;
  if (!t) return { error: Ue };
  if (!i) return { error: Vi };
  if (!r) return { error: Bc };
  let { structure: o } = Ne({ drawDefinition: t, structureId: i });
  if (!o) return { error: kt };
  let s = o;
  o.structures && o.structureType === ri && (s = (f = o.structures) == null ? void 0 : f.find((m) => {
    var h;
    return (h = m.positionAssignments) == null ? void 0 : h.find((g) => g.drawPosition === r);
  }));
  let c = s == null ? void 0 : s.positionAssignments, u = c == null ? void 0 : c.find((m) => m.drawPosition === r);
  u && it({ element: u, extension: { name: Pc, value: n } });
  let d = ((a == null ? void 0 : a.eventType) === yt || t.matchUpType === yt || ((a == null ? void 0 : a.tieFormat) ?? (t == null ? void 0 : t.tieFormat) ?? (o == null ? void 0 : o.tieFormat))) && { matchUpTypes: [yt] }, { matchUps: l } = ut({ structure: s, afterRecoveryTimes: !1, inContext: !0, matchUpFilters: d, event: a }), p = (o == null ? void 0 : o.matchUpFormat) ?? t.matchUpFormat;
  return NU({ positionAssignments: c, tournamentRecord: e, drawDefinition: t, matchUpFormat: p, matchUps: l, event: a }), vt({ drawDefinition: t, structureIds: [i] }), { ...j };
}
var GM = {};
qe(GM, { addGoesTo: () => Eo, allPlayoffPositionsFilled: () => gU, checkValidEntries: () => Bm, findDrawDefinition: () => GU, getAssignedParticipantIds: () => Ko, getAvailableMatchUpsCount: () => Lm, getAvailablePlayoffProfiles: () => Kd, getDrawDefinitionTimeItem: () => xv, getDrawParticipantRepresentativeIds: () => BU, getDrawStructures: () => In, getDrawTypeCoercion: () => rl, getEligibleVoluntaryConsolationParticipants: () => xU, getMatchUpsMap: () => xr, getParticipantIdFinishingPositions: () => VU, getPositionAssignments: () => Zu, getPositionsPlayedOff: () => iu, getSeedingThresholds: () => dU, getSeedsCount: () => il, getStructureSeedAssignments: () => Qi, getTeamLineUp: () => Mo, getValidGroupSizes: () => qd, isAdHoc: () => si, isCompletedStructure: () => $a, isValidForQualifying: () => WU, positionActions: () => _U });
function xU({ excludedMatchUpStatuses: e = [], includeEventParticipants: t, includeQualifyingStage: r, finishingRoundLimit: i, policyDefinitions: n, roundNumberLimit: a, tournamentRecord: o, drawDefinition: s, matchUpsLimit: c, requirePlay: u, requireLoss: d, allEntries: l, winsLimit: p, event: f }) {
  var C, F, x, V, k;
  if (!s) return { error: Ue };
  let m = [Ie, Wt];
  r && m.push(Pe);
  let h = f != null && f.eventType ? { matchUpTypes: [f.eventType] } : void 0, g = s != null && s.matchUpType ? { matchUpTypes: [s.matchUpType] } : void 0, I = t && f ? ((C = ma({ contextFilters: { stages: m }, matchUpFilters: h, tournamentRecord: o, inContext: !0, event: f })) == null ? void 0 : C.matchUps) ?? [] : ((F = Qr({ contextFilters: { stages: m }, matchUpFilters: g, tournamentRecord: o, inContext: !0, drawDefinition: s })) == null ? void 0 : F.matchUps) ?? [], U = Fs({ stage: yr, drawDefinition: s }).map(({ participantId: L }) => L), v = {}, S = {}, T = {}, A = {};
  n || (n = Fa({ policyTypes: [Pg], tournamentRecord: o, drawDefinition: s, event: f }).policyDefinitions);
  let y = n == null ? void 0 : n[Pg];
  e = e.length && e || (y == null ? void 0 : y.excludedMatchUpStatuses) || [], t = t ?? (y == null ? void 0 : y.includeEventParticipants), l = l ?? (y == null ? void 0 : y.allEntries), i = i ?? (y == null ? void 0 : y.finishingRoundLimit), a = a ?? (y == null ? void 0 : y.roundNumberLimit), c = c ?? (y == null ? void 0 : y.matchUpsLimit), u === void 0 && (u = (y == null ? void 0 : y.requirePlay) !== void 0 ? y.requirePlay : !0), d === void 0 && (d = (y == null ? void 0 : y.requireLoss) !== void 0 ? y.requireLoss : !0), p = p ?? (y == null ? void 0 : y.winsLimit);
  for (let L of I) {
    if (u && L.winningSide && ![1, 2].includes(L.winningSide) && L.matchUpStatus !== $t || L.finishingRound && i && L.finishingRound >= i || L.finishingRound && a && L.finishingRound <= a) continue;
    let B = (x = L.sides) == null ? void 0 : x.find(({ sideNumber: q }) => L.winningSide && q === 3 - L.winningSide), G = (V = L.sides) == null ? void 0 : V.find(({ sideNumber: q }) => L.winningSide && q === L.winningSide);
    if ((k = L.sides) == null || k.forEach((q) => {
      var H;
      let Y = (H = q == null ? void 0 : q.participant) == null ? void 0 : H.participantId;
      Y && (T[Y] = q.participant, L.matchUpStatus === $t && !u && (S[Y] = q.participant, v[Y] || (v[Y] = 0), (!L.matchUpStatus || !e.includes(L.matchUpStatus)) && (v[Y] += 1)));
    }), B == null ? void 0 : B.participant) {
      let q = B.participant.participantId;
      S[q] = B.participant, v[q] || (v[q] = 0), L.matchUpStatus && !e.includes(L.matchUpStatus) && (v[q] += 1);
    }
    if (G != null && G.participant) {
      let q = G.participant.participantId;
      A[q] || (A[q] = 0), A[q] += 1, v[q] || (v[q] = 0), L.matchUpStatus && !e.includes(L.matchUpStatus) && (v[q] += 1);
    }
  }
  let D = (o == null ? void 0 : o.participants) && !u && !d && l, P = D ? ((t && f ? f.entries : s.entries) ?? []).filter((L) => ![Ra, tn].includes(L.entryStatus)).map(({ participantId: L }) => L) : [], w = Object.keys(S), R = D ? ((o == null ? void 0 : o.participants) ?? []).filter(({ participantId: L }) => P.includes(L)) : d && Object.values(S) || Object.values(T), b = (L) => !d || w.includes(L), E = (L) => !u || (v[L] || 0) >= 0, O = (L) => !p || (A[L] || 0) <= p, M = (L) => !c || v[L] <= c, N = (L) => !U.includes(L);
  return { eligibleParticipants: R.filter((L) => b(L.participantId) && E(L.participantId) && O(L.participantId) && M(L.participantId) && N(L.participantId)).map((L) => {
    var B;
    return { ...L, individualParticipants: (B = L.individualParticipantIds) == null ? void 0 : B.map((G) => {
      var q;
      return (q = o == null ? void 0 : o.participants) == null ? void 0 : q.find((Y) => Y.participantId === G);
    }) };
  }), losingParticipantIds: w, ...j };
}
function Lm(e) {
  var m, h, g, I, U, v, S, T;
  let t = Ae(e, [{ drawDefinition: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, roundNumber: i } = e, n = e.structureId ?? (((m = r.structures) == null ? void 0 : m.length) === 1 && ((g = (h = r.structures) == null ? void 0 : h[0]) == null ? void 0 : g.structureId));
  if (typeof n != "string") return { error: Vi };
  let a = (I = r.structures) == null ? void 0 : I.find((A) => A.structureId === n);
  if (!a) return { error: kt };
  let o, s = (U = a.matchUps ?? []) == null ? void 0 : U.reduce((A, y) => (y.roundPosition && (o = !0), ((y == null ? void 0 : y.roundNumber) || 0) > A ? y.roundNumber : A), 0);
  if (a.structures || o || a.finishingPosition === Es) return { error: xo };
  let c = ((v = r == null ? void 0 : r.entries) == null ? void 0 : v.filter((A) => {
    let y = A.entryStatus;
    return yn.includes(y);
  })) ?? [], u = Math.floor((c == null ? void 0 : c.length) / 2) || 1, d = i ?? s ?? 1, l = ((T = (S = a.matchUps) == null ? void 0 : S.filter((A) => A.roundNumber === d)) == null ? void 0 : T.length) ?? 0, p = u - l, f = p > 0 ? p : 0;
  return { ...j, availableMatchUpsCount: f, lastRoundNumber: s, roundMatchUpsCount: u };
}
function BU({ drawDefinition: e }) {
  var r;
  let t = We({ name: "participantRepresentatives", element: e });
  return t.error ? t : { representativeParticipantIds: ((r = t.extension) == null ? void 0 : r.value) || [] };
}
function eG({ tournamentParticipants: e, drawDefinition: t, event: r }) {
  if (!t) return { error: Ue };
  let i = ur({ tournamentParticipants: e, inContext: !0, drawDefinition: t, event: r }), n = ge(i.matchUps, !1, !0), a = Be(n.reduce((s, c) => s.concat(...c.sides.map((u) => u.participantId).filter(Boolean)), [])), o = Object.assign({}, ...a.map((s) => {
    let c = n.filter((u) => u.sides.map((d) => d.participantId).filter(Boolean).includes(s));
    return { [s]: c };
  }));
  return { participantIds: a, participantIdMatchUps: o };
}
function VU({ byeAdvancements: e = !1, tournamentRecord: t, drawDefinition: r }) {
  if (!r) return { error: Ue };
  let { participantIds: i, participantIdMatchUps: n } = eG({ tournamentParticipants: t == null ? void 0 : t.participants, drawDefinition: r }), a = (i == null ? void 0 : i.map((o) => {
    let s = n[o].filter((l) => [zt, at].includes(l.matchUpStatus) || l.winningSide), c = s.map((l) => {
      let p = l.sides.find((m) => m.bye), f = l.sides.find((m) => m.participantId === o).sideNumber;
      return (l.winningSide || e && p && f) === f ? l.finishingPositionRange.winner : l.finishingPositionRange.loser;
    }), u = (l) => Math.abs(l[0] - l[1]), d = c.reduce((l, p) => l && u(l) < u(p) ? l : p, void 0);
    return { [o]: { relevantMatchUps: s, finishingPositionRanges: c, finishingPositionRange: d } };
  })) || [];
  return Object.assign({}, ...a);
}
function po({ tournamentRecords: e, tournamentRecord: t, tournamentId: r, drawId: i }) {
  if (!t && !e) return { error: de };
  if (!i) return { error: Cn };
  if (!t && e) {
    if (typeof r != "string" && (r = bM({ tournamentRecords: e, drawId: i }), !r)) return { error: pc };
    if (t = e[r], !t) return { error: de };
  }
  let n = t && ci({ tournamentRecord: t, drawId: i });
  return n != null && n.drawDefinition ? { drawDefinition: n.drawDefinition, event: n.event, tournamentRecord: t, ...j } : W({ result: { error: Fi }, stack: "findDrawDefinition" });
}
function GU(e) {
  let { drawDefinition: t, error: r } = po(e);
  return r ? { error: r } : { drawDefinition: ge(t) };
}
function jg({ targetRoundNumber: e, finishingPosition: t, drawDefinition: r, structureId: i, linkType: n }) {
  let { links: a } = Qc({ drawDefinition: r, structureId: i }) || {}, o = ((a == null ? void 0 : a.target) || []).filter(({ linkType: s }) => s === n).filter(({ target: s }) => !e || e === s.roundNumber).map((s) => {
    let c = s.source.structureId, { structure: u } = Ne({ structureId: c, drawDefinition: r });
    if (!(t && (u == null ? void 0 : u.finishingPosition) !== t)) return s;
  }).filter(Boolean);
  return { sourceStructureIds: o.map(({ source: s }) => s.structureId), relevantLinks: o };
}
function tG({ tournamentParticipants: e, returnParticipants: t, drawPosition: r, participant: i, drawId: n, event: a }) {
  var s;
  let o = ((s = a == null ? void 0 : a.entries) == null ? void 0 : s.filter(({ entryStatus: c }) => [tn, Ho].includes(c)).map(({ participantId: c }) => c)) || [];
  if (o.length) {
    let c = i.individualParticipantIds, u = t ? e.filter(({ participantId: l }) => o.includes(l)) : void 0, d = t ? e.filter(({ participantId: l }) => c.includes(l)) : void 0;
    return { validModifyAssignedPairAction: ye({ payload: { participantId: i.participantId, replacementIndividualParticipantId: void 0, existingIndividualParticipantId: void 0, drawPosition: r, drawId: n }, method: lV, availableIndividualParticipantIds: o, availableIndividualParticipants: u, existingIndividualParticipantIds: c, existingIndividualParticipants: d, type: UU }, !1, !1, !0) };
  }
  return {};
}
function Fo(e) {
  var g, I, U, v, S;
  let { inContextDrawMatchUps: t, targetData: r, drawDefinition: i, relevantLink: n } = e;
  if ((n == null ? void 0 : n.linkCondition) === _n && ((g = r == null ? void 0 : r.matchUp) == null ? void 0 : g.matchUpStatus) === at) return !1;
  let { targetMatchUps: { loserMatchUp: a, winnerMatchUp: o }, targetLinks: s } = r, c = a && ei({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), u = (I = c == null ? void 0 : c.targetMatchUps) == null ? void 0 : I.loserMatchUp, d = (U = c == null ? void 0 : c.targetMatchUps) == null ? void 0 : U.loserMatchUpDrawPositionIndex, l = (v = u == null ? void 0 : u.sides[d]) == null ? void 0 : v.participant, p = [Je, ct].includes(a == null ? void 0 : a.matchUpStatus) && !l, f = ((S = o == null ? void 0 : o.drawPositions) == null ? void 0 : S.filter(Boolean).length) || 0;
  if (a != null && a.winningSide && !p || o != null && o.winningSide && f === 2 && (!o.feedRound || ![ct, Je].includes(o == null ? void 0 : o.matchUpStatus))) return !0;
  let m = o && ei({ matchUpId: o.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), h = c && Fo({ relevantLink: s == null ? void 0 : s.loserTargetLink, targetData: c, inContextDrawMatchUps: t, drawDefinition: i });
  return !!(m && Fo({ targetData: m, inContextDrawMatchUps: t, drawDefinition: i }) || h);
}
var rG = { [Is]: { policyName: "positionActionsDefault", enabledStructures: [{ stages: [Pe, Ie], stageSequences: [1], enabledActions: [], disabledActions: [] }, { stages: [], stageSequences: [], enabledActions: [yp, Mc, Nm, bu], disabledActions: [] }], disbledStructures: [], otherFlightEntries: !1, activePositionOverrides: [] } }, Kl = "positionAction", _g = "matchUpAction";
function jM({ actionType: e = Kl, appliedPolicies: t, drawDefinition: r, structure: i }) {
  var l, p;
  let n = e === Kl && Is || e === _g && Ar, a = e === Kl && rG || e === _g && SN, o = n && ((t == null ? void 0 : t[n]) || (a == null ? void 0 : a[n])), s = ((p = (l = r.links) == null ? void 0 : l.filter((f) => {
    var m;
    return ((m = f == null ? void 0 : f.target) == null ? void 0 : m.structureId) === (i == null ? void 0 : i.structureId);
  })) == null ? void 0 : p.map(({ target: f }) => f.feedProfile)) ?? [], { enabledStructures: c, disabledStructures: u } = o || {}, d = u == null ? void 0 : u.find((f) => {
    let { stages: m, stageSequences: h, structureTypes: g, feedProfiles: I } = f;
    return (!(I != null && I.length) || Array.isArray(I) && I.some((U) => s.includes(U))) && (!(m != null && m.length) || Array.isArray(m) && (m == null ? void 0 : m.includes(i == null ? void 0 : i.stage))) && (!(g != null && g.length) || Array.isArray(g) && (g == null ? void 0 : g.includes(i == null ? void 0 : i.structureType))) && (!(h != null && h.length) || Array.isArray(h) && h.includes(i == null ? void 0 : i.stageSequence));
  });
  return { enabledStructures: c, actionsDisabled: d, actionsPolicy: o };
}
function NT({ activePositionOverrides: e, activeDrawPositions: t, action: r }) {
  return r && e.includes(r) ? !0 : !t.length;
}
function _M({ enabledStructures: e, drawDefinition: t, structure: r }) {
  var s, c;
  if (e === !1) return {};
  if (!(e != null && e.length)) return { policyActions: { enabledActions: [], disabledActions: [] } };
  let { stage: i, stageSequence: n, structureType: a } = r || {}, o = ((c = (s = t.links) == null ? void 0 : s.filter((u) => {
    var d;
    return ((d = u == null ? void 0 : u.target) == null ? void 0 : d.structureId) === (r == null ? void 0 : r.structureId);
  })) == null ? void 0 : c.map(({ target: u }) => u.feedProfile)) || [];
  return { policyActions: e.find((u) => {
    let { stages: d, stageSequences: l, structureTypes: p, feedProfiles: f } = u || {}, m = !(d != null && d.length) || Array.isArray(d) && d.includes(i), h = !(l != null && l.length) || Array.isArray(l) && l.includes(n), g = !(p != null && p.length) || Array.isArray(p) && p.includes(a), I = !(f != null && f.length) || Array.isArray(f) && f.some((U) => o.includes(U));
    return h && g && I && u && m;
  }) };
}
function li({ action: e, policyActions: t }) {
  var i;
  let r = !(t != null && t.enabledActions) || ((i = t == null ? void 0 : t.disabledActions) == null ? void 0 : i.length) && t.disabledActions.includes(e);
  return r ? !1 : ((t == null ? void 0 : t.enabledActions.length) === 0 || (t == null ? void 0 : t.enabledActions.includes(e))) && !r;
}
var WM = "replaceTieMatchUpParticipantId", qM = "assignTieMatchUpParticipantId", Wg = "removeTieMatchUpParticipantId", MT = "assignMatchUpSideParticipant", iG = "removeMatchUpSideParticipant", HM = "substituteParticipant", qg = "REMOVE_SUBSTITUTION", YM = "REPLACE_PARTICIPANT", jU = "REMOVE_PARTICIPANT", Hg = "setMatchUpStatus", Yg = "SUBSTITUTION", zM = "SCHEDULE", nG = "PENALTY", zg = "REFEREE", KM = "STATUS", Kg = "START", XM = "SCORE", Xg = "END", aG = { REPLACE_TEAM_POSITION_METHOD: WM, ASSIGN_TEAM_POSITION_METHOD: qM, REMOVE_TEAM_POSITION_METHOD: Wg, REPLACE_PARTICIPANT: YM, SUBSTITUTION_METHOD: HM, REMOVE_SUBSTITUTION: qg, REMOVE_PARTICIPANT: jU, SCHEDULE_METHOD: Hg, SUBSTITUTION: Yg, SCHEDULE: zM, PENALTY: nG, REFEREE: zg, STATUS: KM, SCORE: XM, START: Kg, END: Xg };
function oG({ specifiedPolicyDefinitions: e, inContextDrawMatchUps: t, matchUpParticipantIds: r, matchUpActionsPolicy: i, inContextMatchUp: n, policyActions: a, enforceGender: o, participantId: s, sideNumber: c, matchUpId: u, matchUp: d, drawId: l, side: p }) {
  var O, M, N, C, F, x, V, k, L, B, G, q, Y, H, X;
  let f = [], m = (O = n.sides) == null ? void 0 : O.find((z) => z.participant), h = n.gender === ni && n.sideNumber && ((M = n.sides) == null ? void 0 : M.filter((z) => z.particiapntId).length) === 1 && ((C = (N = m == null ? void 0 : m.participant) == null ? void 0 : N.person) == null ? void 0 : C.sex), g = n.matchUpType, I = (o ?? ((F = i == null ? void 0 : i.participants) == null ? void 0 : F.enforceGender)) !== !1 ? n.gender : void 0, U = (V = (x = n.sides) == null ? void 0 : x.flatMap((z) => {
    var Z;
    return ((Z = z.participant) == null ? void 0 : Z.individualParticipants) || z.participant;
  }).filter(Boolean)) == null ? void 0 : V.map(Ke), v = (k = n.sides) == null ? void 0 : k.filter((z) => !c || z.sideNumber === c).flatMap((z) => {
    var Z;
    return ((Z = z.participant) == null ? void 0 : Z.individualParticipants) || z.participant;
  }).filter(Boolean), S = v == null ? void 0 : v.map(Ke), T = (B = (L = t == null ? void 0 : t.find((z) => z.matchUpId === n.matchUpTieId)) == null ? void 0 : L.sides) == null ? void 0 : B.map((z) => {
    var Z, te;
    return (te = (Z = z == null ? void 0 : z.participant) == null ? void 0 : Z.individualParticipants) == null ? void 0 : te.filter(({ participantId: ne, person: ee }) => !(S != null && S.includes(ne)) && (!I || I === Mn || ee.sex === I || I === ni && !h || h && ee.sex !== h));
  }), A = c ? T == null ? void 0 : T[c - 1] : T == null ? void 0 : T.map((z, Z) => ({ participants: z, sideNumber: Z + 1 })), y = c ? (G = T == null ? void 0 : T[c - 1]) == null ? void 0 : G.map(Ke) : T == null ? void 0 : T.map((z, Z) => ({ participants: z == null ? void 0 : z.map(Ke), sideNumber: Z + 1 })), D = c && (Kt(es)(g) && !(S != null && S.length) || Kt(Ao)(g) && ((S == null ? void 0 : S.length) ?? 0) < 2) || !c && (Kt(es)(g) && ((S == null ? void 0 : S.length) ?? 0) < 2 || Kt(Ao)(g) && ((S == null ? void 0 : S.length) ?? 0) < 4), P = y == null ? void 0 : y.filter((z) => !(U != null && U.includes(z))), w = A == null ? void 0 : A.filter(({ participantId: z }) => P.includes(z));
  if (D && (P != null && P.length) && f.push({ availableParticipantIds: P, method: qM, availableParticipants: w, type: ys, payload: { participantId: void 0, tieMatchUpId: u, sideNumber: c, drawId: l } }), S != null && S.length && (!pr(d) || (q = p == null ? void 0 : p.substitutions) != null && q.length) && f.push({ method: Wg, type: jU, existingParticipantIds: S, payload: { participantId: void 0, tieMatchUpId: u, drawId: l } }), w != null && w.length && (!c && (S != null && S.length) || c && (p != null && p.participant)) && f.push({ availableParticipantIds: P, method: WM, availableParticipants: w, type: YM, existingParticipantIds: S, payload: { existingParticipantId: void 0, participantId: void 0, tieMatchUpId: u, drawId: l } }), li({ policyActions: a, action: qg }) && ((Y = p == null ? void 0 : p.substitutions) == null ? void 0 : Y.length)) {
    let z = ((H = p.participant) == null ? void 0 : H.participantType) === Xe && [p.participantId] || ((X = p.participant) == null ? void 0 : X.participantType) === _e && p.participant.individualParticipantIds || [], Z = p.substitutions.map((te) => te.participantId).filter((te) => z.includes(te));
    (!s || Z.includes(s)) && f.push({ method: Wg, type: qg, substitutedParticipantIds: Z, payload: { participantId: void 0, tieMatchUpId: u, drawId: l } });
  }
  let R = e == null ? void 0 : e[Ar], b = R == null ? void 0 : R.substituteWithoutScore, E = R == null ? void 0 : R.substituteAfterCompleted;
  if (li({ policyActions: a, action: Yg }) && r.length === 2 && (!c && (S != null && S.length) || c && (p != null && p.participant)) && (b || pr(d)) && (E || d.matchUpStatus && !lr.includes(d.matchUpStatus)) && (v != null && v.length) && A.length) {
    let z = v.map(Ke);
    f.push({ info: "list of team players available for substitution", method: HM, availableParticipantIds: y, existingParticipantIds: z, availableParticipants: A, existingParticipants: v, type: Yg, payload: { substituteParticipantId: void 0, existingParticipantId: void 0, sideNumber: c, matchUpId: u, drawId: l } });
  }
  return f;
}
function sG({ tournamentParticipants: e = [], possiblyDisablingAction: t, activeDrawPositions: r, positionAssignments: i, returnParticipants: n, appliedPolicies: a, drawDefinition: o, drawPosition: s, validActions: c, structureId: u, structure: d, drawId: l, event: p }) {
  var y, D, P, w, R;
  if (r.includes(s)) return {};
  let f = (y = c.find((b) => b.type === ys)) == null ? void 0 : y.availableParticipantIds, m = (D = a == null ? void 0 : a[Is]) == null ? void 0 : D.otherFlightEntries, h = (P = a == null ? void 0 : a[Is]) == null ? void 0 : P.restrictQualifyingAlternates, g = (o.entries ?? []).filter(({ entryStage: b }) => !h || (d.stage === Pe ? b === Pe : b !== Pe)).sort((b, E) => (b.entryPosition ?? 1 / 0) - (E.entryPosition ?? 1 / 0)).map(({ participantId: b }) => b).filter(Boolean), { allPositionedParticipantIds: I } = bb({ drawDefinition: o }), U = i.map((b) => b.participantId).filter(Boolean), v = g.filter((b) => d.stage && [Pe, Ie, Wt].includes(d.stage) ? !(I != null && I.includes(b)) : !U.includes(b)), S = ((p == null ? void 0 : p.entries) ?? []).filter((b) => b.entryStatus === fn && ZM({ restrictQualifyingAlternates: h, structure: d, entry: b }) && (d.stage && [Pe, Ie, Wt].includes(d.stage) ? !(I != null && I.includes(b.participantId)) : !U.includes(b.participantId))).sort((b, E) => (b.entryPosition ?? 1 / 0) - (E.entryPosition ?? 1 / 0)).map((b) => b.participantId), T = Be(v.concat(S));
  if (m) {
    let b = (R = (w = p ? Ht({ event: p }).flightProfile : void 0) == null ? void 0 : w.flights) == null ? void 0 : R.filter((E) => E.drawId !== l).map((E) => E.drawEntries.filter((O) => O.participantId && ![Ra, tn, Ho].includes(O.entryStatus) && !g.includes(O.participantId)).map(({ participantId: O }) => O)).flat().filter(Boolean);
    b != null && b.length && T.push(...b);
  }
  f != null && f.length && (T = T.filter((b) => !f.includes(b)));
  let A = n ? e == null ? void 0 : e.filter((b) => T.includes(b.participantId)) : void 0;
  return A == null || A.forEach((b) => {
    let E = (o.entries ?? []).find((O) => O.participantId === b.participantId);
    b.entryPosition = E == null ? void 0 : E.entryPosition;
  }), A == null || A.sort((b, E) => (b.entryPosition || 1 / 0) - (E.entryPosition || 1 / 0)), T.length ? { validAlternatesAction: ye({ payload: { drawId: l, structureId: u, drawPosition: s }, willDisableLinks: t, method: uV, availableAlternatesParticipantIds: T, type: SU, availableAlternates: A }) } : {};
}
function ZM({ restrictQualifyingAlternates: e, structure: t, entry: r }) {
  let { stage: i } = t;
  if (!r.entryStage || r.entryStage === i || i === Pe && !e || r.entryStage === Ie && i === kr) return !0;
}
function cG({ eventEntries: e, structure: t }) {
  let r = (n) => n.entryStatus === fn && ZM({ structure: t, entry: n }), i = (n, a) => (n.entryPosition || 1 / 0) - (a.entryPosition || 1 / 0);
  return e.filter(r).sort(i).map(Ke);
}
function uG({ restrictAdHocRoundParticipants: e, tournamentParticipants: t, matchUpParticipantIds: r, otherFlightEntries: i, drawDefinition: n, structureId: a, sideNumber: o, matchUpId: s, structure: c, matchUp: u, drawId: d, event: l }) {
  var D, P, w, R, b, E, O;
  let p = [], f = (c == null ? void 0 : c.matchUps) ?? [], m = (P = (D = u.sides) == null ? void 0 : D.find((M) => M.sideNumber === o)) == null ? void 0 : P.participantId, h = f.filter(({ roundNumber: M }) => M === u.roundNumber), g = ((w = n == null ? void 0 : n.entries) == null ? void 0 : w.filter(({ entryStatus: M }) => M && Yo.includes(M)).map(Ke)) ?? [], I = h.map((M) => (M.sides ?? []).flatMap(Ke)).flat().filter(Boolean), U = g.filter((M) => !r.includes(M) && (!e || !I.includes(M))), v = t == null ? void 0 : t.filter((M) => U == null ? void 0 : U.includes(M.participantId)).map((M) => ge(M, void 0, !0));
  v == null || v.forEach((M) => {
    let N = (n.entries ?? []).find((C) => C.participantId === M.participantId);
    M.entryPosition = N == null ? void 0 : N.entryPosition;
  }), U.length && p.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, method: MT, type: ys, availableParticipantIds: U, participantsAvailable: v });
  let S = (l == null ? void 0 : l.entries) ?? [], T = cG({ eventEntries: S, structure: c }), A = Be(g.concat(T));
  if (i) {
    let M = (b = (R = l ? Ht({ event: l }) : void 0) == null ? void 0 : R.flights) == null ? void 0 : b.filter((N) => N.drawId !== d).flatMap((N) => N.drawEntries.filter((C) => C.participantId && ![Ra, tn, Ho].includes(C.entryStatus)).map(({ participantId: C }) => C)).filter(Boolean);
    M != null && M.length && A.push(...M);
  }
  A = A.filter((M) => !r.includes(M) && !U.includes(M) && (!e || !I.includes(M)));
  let y = t == null ? void 0 : t.filter((M) => A.includes(M.participantId)).map((M) => ge(M, void 0, !0));
  if (y == null || y.forEach((M) => {
    let N = (n.entries ?? []).find((C) => C.participantId === M.participantId);
    M.entryPosition = N == null ? void 0 : N.entryPosition;
  }), y == null || y.sort((M, N) => (M.entryPosition || 1 / 0) - (N.entryPosition || 1 / 0)), A.length && p.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, availableParticipantIds: A, participantsAvailable: y, method: MT, type: fn }), !pr(u) && o && m) {
    p.push({ payload: { drawId: d, matchUpId: s, structureId: a, sideNumber: o }, method: iG, type: jU });
    let M = (B) => B.sides.map(Ke), N = ({ matchUpId: B }) => B !== u.matchUpId, C = (B) => !pr(B), F = (O = (E = u.sides) == null ? void 0 : E.find((B) => B.sideNumber !== o)) == null ? void 0 : O.participantId, x = f.filter(({ roundNumber: B }) => B !== u.roundNumber).filter(N).map(M), V = [F, ...x.filter((B) => B.includes(m)).flat()].filter(Boolean), k = (B) => !V.flat().includes(B), L = h.filter(C).filter(N).map(M).flat().filter(k);
    if (L.length) {
      let B = t == null ? void 0 : t.filter((G) => L.includes(G.participantId)).map((G) => ge(G, void 0, !0));
      p.push({ payload: { participantIds: [m], roundNumber: u.roundNumber, structureId: a, sideNumber: o, matchUpId: s, drawId: d }, swappableParticipantIds: L, method: pV, type: Mm, swappableParticipants: B });
    }
  }
  return p;
}
function xm(e) {
  var z, Z, te, ne, ee, K, J, $, ae;
  if (!e) return { error: ie };
  let { drawDefinition: t, event: r } = e, { restrictAdHocRoundParticipants: i = !0, policyDefinitions: n, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c } = e, u = e.tournamentRecord ?? (e.tournamentId && Et(e.tournamentId) && ((z = e.tournamentRecords) == null ? void 0 : z[e.tournamentId]));
  if (!u) return { error: de };
  if (!c || !Et(c)) return { error: zr };
  if (s && ![1, 2].includes(s)) return W({ result: { error: ie }, context: { sideNumber: s } });
  if (!t) {
    let oe = (Pr({ tournamentRecord: u }).matchUps ?? []).find((se) => se.matchUpId === c);
    r = ((u == null ? void 0 : u.events) ?? []).find((se) => se.eventId === (oe == null ? void 0 : oe.eventId));
    let ce = ((r == null ? void 0 : r.drawDefinitions) ?? []).find((se) => se.drawId === (oe == null ? void 0 : oe.drawId));
    ce && (t = ce);
  }
  if (!t) return { error: Ue };
  let d = Lt({ withIndividualParticipants: !0, tournamentRecord: u }).participants, { drawId: l } = t, { matchUp: p, structure: f } = bt({ drawDefinition: t, matchUpId: c, event: r });
  if (!p) return { error: jr };
  let m = nt({ tournamentRecord: u, drawDefinition: t, structure: f, event: r }).appliedPolicies ?? {};
  Object.assign(m, n ?? {});
  let h = (Z = m == null ? void 0 : m[Is]) == null ? void 0 : Z.otherFlightEntries, g = (m == null ? void 0 : m[Ar]) ?? eu[Ar], { enabledStructures: I } = jM({ actionType: _g, appliedPolicies: m, drawDefinition: t, structure: f }), { policyActions: U } = _M({ enabledStructures: I, drawDefinition: t, structure: f }), v = e.matchUpsMap ?? xr({ drawDefinition: t }), S = e.inContextDrawMatchUps ?? ur({ tournamentParticipants: d, inContext: !0, drawDefinition: t, matchUpsMap: v, event: r }).matchUps, T = S == null ? void 0 : S.find((oe) => oe.matchUpId === c), A = s && ((te = T == null ? void 0 : T.sides) == null ? void 0 : te.find((oe) => oe.sideNumber === s)), y = ((ne = T == null ? void 0 : T.sides) == null ? void 0 : ne.map((oe) => {
    var ce;
    return oe.participantId || ((ce = oe.participant) == null ? void 0 : ce.participantid);
  }).filter(Boolean)) ?? [], { assignedPositions: D, allPositionsAssigned: P } = Ir({ structure: f }), { structureId: w } = f ?? {}, R = [];
  if (!w) return { validActions: R };
  let b = si({ structure: f }), E = p.collectionId;
  if (b && !E) {
    let oe = uG({ restrictAdHocRoundParticipants: i, tournamentParticipants: d, matchUpParticipantIds: y, otherFlightEntries: h, drawDefinition: t, structureId: w, sideNumber: s, matchUpId: c, structure: f, matchUp: p, drawId: l, event: r });
    R.push(...oe);
  }
  let O = $a({ drawDefinition: t, structure: f }), M = D == null ? void 0 : D.filter((oe) => oe.participantId).map((oe) => oe.drawPosition), N = D == null ? void 0 : D.filter((oe) => oe.bye).map((oe) => oe.drawPosition), C = p.matchUpStatus === at || !E && ((ee = p.drawPositions) == null ? void 0 : ee.reduce((oe, ce) => (N == null ? void 0 : N.includes(ce)) || oe, !1));
  if (C) return { validActions: R, isByeMatchUp: C };
  li({ policyActions: U, action: zg }) && R.push({ type: zg, payload: { matchUpId: c } });
  let F = !xd({ matchUpStatus: p.matchUpStatus }), x = (K = m == null ? void 0 : m.scoring) == null ? void 0 : K.structures, V = (f == null ? void 0 : f.stage) && (x == null ? void 0 : x.stage) && (x == null ? void 0 : x.stage[f.stage]), k = (f == null ? void 0 : f.stageSequence) && (V == null ? void 0 : V.stageSequence) && V.stageSequence[f.stageSequence], L = !((J = m == null ? void 0 : m.scoring) != null && J.requireAllPositionsAssigned || V != null && V.requireAllPositionsAssigned || k != null && k.requireAllPositionsAssigned) || P, B = p.sides && p.sides.filter((oe) => oe == null ? void 0 : oe.participantId).length === 2, G = p.matchUpStatus && [$t, sr].includes(p.matchUpStatus), q = ei({ inContextDrawMatchUps: S, drawDefinition: t, matchUpId: c }), Y = Fo({ inContextDrawMatchUps: S, drawDefinition: t, targetData: q }), H = ((($ = T == null ? void 0 : T.drawPositions) == null ? void 0 : $.length) === 2 && T.drawPositions.every((oe) => M == null ? void 0 : M.includes(oe)) && ((ae = T == null ? void 0 : T.sides) == null ? void 0 : ae.length) === 2 && T.sides.every(({ participantId: oe }) => oe) || B) && !(G && Y), X = { method: nM, type: Mc, payload: { drawId: l, matchUpId: c, penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0 } };
  if (F && R.push({ payload: { drawId: l, matchUpId: c, schedule: {} }, method: Hg, type: zM }), li({ policyActions: U, action: Mc }) && (A != null && A.participant || !s && (y != null && y.length)) && R.push(X), F && H && R.push({ type: KM }), L && H) {
    let { matchUpId: oe, matchUpFormat: ce } = p, se = { drawId: l, matchUpId: oe, matchUpFormat: ce, outcome: { scoreStringSide1: void 0, scoreStringSide2: void 0, sets: [] }, winningSide: void 0 };
    R.push({ info: "set outcome and winningSide", method: Hg, type: XM, payload: se }), li({ policyActions: U, action: Kg }) && R.push({ type: Kg }), li({ policyActions: U, action: Xg }) && R.push({ type: Xg });
  }
  if (E && T) {
    let oe = oG({ specifiedPolicyDefinitions: n, inContextDrawMatchUps: S, matchUpParticipantIds: y, matchUpActionsPolicy: g, inContextMatchUp: T, policyActions: U, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c, matchUp: p, drawId: l, side: A });
    R.push(...oe);
  }
  return { structureIsComplete: O, validActions: R, isDoubleExit: G, ...j };
}
function dG({ tournamentParticipants: e = [], sourceStructuresComplete: t, possiblyDisablingAction: r, isWinRatioFedStructure: i, activeDrawPositions: n, positionAssignments: a, drawDefinition: o, drawPosition: s, structureId: c, structure: u, drawId: d, event: l }) {
  var I, U, v, S, T, A, y;
  if (n.includes(s) || i && !t) return {};
  let { sourceStructureIds: p, targetStructureIds: f } = ((I = o.links) == null ? void 0 : I.reduce((D, P) => {
    var b, E;
    let w = (b = P.source) == null ? void 0 : b.structureId, R = (E = P.target) == null ? void 0 : E.structureId;
    return D.sourceStructureIds.includes(w) || D.sourceStructureIds.push(w), D.targetStructureIds.includes(R) || D.targetStructureIds.push(R), D;
  }, { sourceStructureIds: [], targetStructureIds: [] })) || {}, m = [], h = ((U = o.links) == null ? void 0 : U.filter((D) => {
    var P;
    return ((P = D.target) == null ? void 0 : P.structureId) === u.structureId;
  })) ?? [];
  for (let D of h) {
    let P = (v = D == null ? void 0 : D.source) == null ? void 0 : v.structureId, { structure: w } = Ne({ structureId: P, drawDefinition: o }), R = (w == null ? void 0 : w.finishingPosition) === Es && ((p == null ? void 0 : p.length) !== 1 || (f == null ? void 0 : f.length) !== 1), b = {};
    if (R) {
      let { matchUps: M } = ut({ drawDefinition: o, structure: u, event: l }), { initialRoundNumber: N } = Ss({ drawPosition: s, matchUps: M }), C = (A = (T = (S = o.links) == null ? void 0 : S.find((F) => {
        var x;
        return ((x = F.target) == null ? void 0 : x.structureId) === (u == null ? void 0 : u.structureId) && F.target.roundNumber === N;
      })) == null ? void 0 : T.source) == null ? void 0 : A.roundNumber;
      b.roundNumbers = [C];
    }
    let { completedMatchUps: E } = Am({ structureId: P, inContext: !0, matchUpFilters: b, drawDefinition: o }), O = a.map((M) => M.participantId).filter(Boolean);
    (y = E == null ? void 0 : E.filter(({ matchUpType: M, winningSide: N }) => N && ((l == null ? void 0 : l.eventType) !== or || M === or)).map(({ winningSide: M, sides: N }) => M && (N == null ? void 0 : N[1 - (M - 1)])).map(Ke).filter((M) => M && !O.includes(M))) == null || y.forEach((M) => {
      m.includes(M) || m.push(M);
    });
  }
  let g = e == null ? void 0 : e.filter((D) => m == null ? void 0 : m.includes(D.participantId));
  return g == null || g.forEach((D) => {
    let P = (o.entries ?? []).find((w) => w.participantId === D.participantId);
    D.entryPosition = P == null ? void 0 : P.entryPosition;
  }), m != null && m.length ? { validLuckyLosersAction: { type: AU, method: dV, availableLuckyLosers: g, availableLuckyLoserParticipantIds: m, willDisableLinks: r, payload: { drawId: d, structureId: c, drawPosition: s } } } : {};
}
function lG({ positionSourceStructureIds: e, unassignedParticipantIds: t, possiblyDisablingAction: r, provisionalPositioning: i, tournamentParticipants: n, isWinRatioFedStructure: a, positionAssignments: o, returnParticipants: s, appliedPolicies: c, drawDefinition: u, seedingProfile: d, isByePosition: l, drawPosition: p, structureId: f, event: m }) {
  var T, A, y;
  let { drawId: h } = u, g = [], I, U, v = [], S = (A = (T = c == null ? void 0 : c[Tn]) == null ? void 0 : T.validSeedPositions) == null ? void 0 : A.ignore;
  if (S || ({ unplacedSeedParticipantIds: I, unplacedSeedAssignments: U, unfilledPositions: v } = CN({ provisionalPositioning: i, returnAllProxies: !0, randomize: !0, drawDefinition: u, seedingProfile: d, structureId: f, event: m })), v != null && v.length || (v = o.filter((D) => !D.participantId && !D.bye && !D.qualifier).map((D) => D.drawPosition)), l || g.push({ payload: { drawId: h, structureId: f, drawPosition: p, isPositionAction: !0 }, willDisableLinks: r, method: hV, type: Ap }), a && S) {
    let D = o.map((E) => E.participantId).filter(Boolean), P = { structureIds: e }, { completedMatchUps: w } = Jc({ inContext: !0, matchUpFilters: P, drawDefinition: u }), R = Be((y = (w ?? []).filter(({ matchUpType: E }) => (m == null ? void 0 : m.eventType) !== or || E === or)) == null ? void 0 : y.map(({ sides: E }) => E == null ? void 0 : E.map(Ke)).flat().filter((E) => E && !D.includes(E))), b = s ? n == null ? void 0 : n.filter((E) => R == null ? void 0 : R.includes(E.participantId)).map((E) => ge(E, void 0, !0)) : void 0;
    return b == null || b.forEach((E) => {
      let O = (u.entries ?? []).find((M) => M.participantId === E.participantId);
      E.entryPosition = O == null ? void 0 : O.entryPosition;
    }), b != null && b.length && g.push(ye({ payload: { drawId: h, structureId: f, drawPosition: p }, willDisableLinks: r, method: yT, type: ys, availableParticipantIds: R, participantsAvailable: b })), { validAssignmentActions: g };
  }
  if (v.includes(p) || l) {
    let D;
    if (U != null && U.length) {
      let w = U.filter((R) => I == null ? void 0 : I.includes(R.participantId));
      w.sort(pG), D = w.map((R) => R.participantId);
    } else D = t;
    let P = s ? n == null ? void 0 : n.filter((w) => D.includes(w.participantId)).map((w) => ge(w, void 0, !0)) : void 0;
    P != null && P.length && g.push(ye({ payload: { drawId: h, structureId: f, drawPosition: p }, willDisableLinks: r, method: yT, type: ys, availableParticipantIds: D, participantsAvailable: P }));
  }
  return { validAssignmentActions: g };
}
function pG(e, t) {
  return e.bye || bc(e.seedValue) < bc(t.seedValue) || e.seedValue && !t.seedValue ? -1 : (e.seedNumber || 0) - (t.seedNumber || 0);
}
function fG({ drawPositionInitialRounds: e, tournamentParticipants: t, positionAssignments: r, returnParticipants: i, appliedPolicies: n, drawDefinition: a, drawPosition: o, structureId: s, drawId: c }) {
  var T, A, y;
  let u = [], d = [], l = [], p = [], f = r.map((D) => D.participantId).filter(Boolean), m = n == null ? void 0 : n[Is], h = !(m != null && m.disableRoundRestrictions) && e[o], g = m == null ? void 0 : m.requireCompletedStructures, { sourceStructureIds: I, relevantLinks: U } = jg({ targetRoundNumber: h, linkType: Ta, drawDefinition: a, structureId: s }) || {};
  I != null && I.length && p.push(...I);
  let { sourceStructureIds: v, relevantLinks: S } = jg({ targetRoundNumber: h, linkType: Aa, drawDefinition: a, structureId: s }) || {};
  v != null && v.length && p.push(...v);
  for (let D of U) {
    let P = (T = a.structures) == null ? void 0 : T.find((R) => R.structureId === D.source.structureId);
    if ((P == null ? void 0 : P.stage) !== Pe) continue;
    let w = $a({ structureId: D.source.structureId, drawDefinition: a });
    if (!g || w) {
      let R = P.qualifyingRoundNumber, { matchUps: b } = ut({ matchUpFilters: { roundNumbers: [R], hasWinningSide: !0 }, afterRecoveryTimes: !1, tournamentParticipants: t, inContext: !0, structure: P });
      for (let E of b) {
        let O = E.sides.find((N) => (N == null ? void 0 : N.sideNumber) === E.winningSide), M = E.matchUpStatus === at && ((A = E.sides) == null ? void 0 : A.find(({ participantId: N }) => N));
        if (O || M) {
          let { participantId: N, participant: C } = O || M || {};
          N && !f.includes(N) && (C && i && u.push(C), d.push(N));
        }
      }
    }
  }
  for (let D of S) {
    let P = (y = a.structures) == null ? void 0 : y.find((R) => R.structureId === D.source.structureId);
    if ((P == null ? void 0 : P.stage) !== Pe) continue;
    let w = $a({ structureId: D.source.structureId, drawDefinition: a });
    if (!g || w) {
      let { positionAssignments: R } = gt({ structure: P }), b = (R == null ? void 0 : R.map((E) => {
        var N;
        let O = E.participantId, M = (N = We({ element: E, name: Ka }).extension) == null ? void 0 : N.value;
        return M ? { participantId: O, groupOrder: M == null ? void 0 : M.groupOrder } : {};
      }).filter(({ groupOrder: E, participantId: O }) => E === 1 && !f.includes(O)).map(({ participantId: E }) => E)) ?? [];
      if (b && d.push(...b), i) {
        let E = t.filter(({ participantId: O }) => b.includes(O));
        u.push(...E);
      }
    }
  }
  return d.length && l.push(ye({ qualifyingParticipants: i ? u : void 0, method: sV, type: Nm, qualifyingParticipantIds: d, payload: { qualifyingParticipantId: void 0, drawPosition: o, structureId: s, drawId: c } })), { validAssignmentActions: l, sourceStructureIds: p };
}
function mG({ onlyAssignedPositions: e = !0, possiblyDisablingAction: t, tournamentParticipants: r, inactiveDrawPositions: i, activeDrawPositions: n, positionAssignments: a, returnParticipants: o, byeDrawPositions: s, drawDefinition: c, isByePosition: u, drawPosition: d, structureId: l, structure: p, drawId: f, event: m }) {
  if (n.includes(d)) return {};
  let h = (w) => !e || w.participantId || w.qualifier || w.bye, g = i == null ? void 0 : i.filter((w) => w !== d && !(u && s.includes(w))), I = (a == null ? void 0 : a.filter((w) => h(w) && (g == null ? void 0 : g.includes(w.drawPosition)))) ?? [], U = I.map(({ drawPosition: w }) => w), { matchUps: v } = ut({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: c, structure: p, event: m }), S = v.filter(({ drawPositions: w }) => Jr(w, U)), T = Object.assign({}, ...S.map((w) => {
    var R;
    return (R = w.sides) == null ? void 0 : R.filter(({ sourceDrawPositionRange: b }) => b).map(({ drawPosition: b, sourceDrawPositionRange: E }) => ({ [b]: E }));
  }).flat()), A = I.map((w) => w.participantId).filter(Boolean), y = (r ?? []).filter((w) => A.includes(w.participantId)), D = Object.assign({}, ...y.map((w) => ({ [w.participantId]: w }))), P = I.map((w) => {
    let R = D == null ? void 0 : D[w.participantId], b = T[w.drawPosition];
    return ye({ ...w, participant: o ? ge(R, !1, !0) : void 0, sourceDrawPositionRange: b });
  });
  return P.length ? { validSwapAction: { payload: { drawId: f, structureId: l, drawPositions: [d] }, willDisableLinks: t, method: iM, type: Mm, availableAssignments: P } } : {};
}
function _U(e) {
  var X;
  let t = Ae(e, [{ event: !0, drawDefinition: !0, structureId: !0 }]);
  if (t.error) return t;
  let { policyDefinitions: r, returnParticipants: i = !0, provisionalPositioning: n, tournamentRecord: a, drawDefinition: o, drawPosition: s, event: c } = e, u = e.tournamentParticipants ?? (a && Lt({ withIndividualParticipants: !0, tournamentRecord: a }).participants) ?? [], d = Ne({ structureId: e.structureId, drawDefinition: o });
  if (d.error) return d;
  let l = d.containingStructure || d.structure;
  if (!l) return { error: kt };
  let p = l.structureId;
  if (d = Bd({ drawDefinition: o, structureId: p }), s === void 0 && !d.isAdHoc) return { error: Bc };
  if (d.isAdHoc) return xm(e);
  if (d.error) return d;
  let { drawPositionInitialRounds: f, inactiveDrawPositions: m, activeDrawPositions: h, byeDrawPositions: g } = d, I = nt({ tournamentRecord: a, drawDefinition: o, structure: l, event: c }).appliedPolicies ?? {};
  Object.assign(I, r ?? {});
  let { actionsPolicy: U, enabledStructures: v, actionsDisabled: S } = jM({ actionType: Kl, appliedPolicies: I, drawDefinition: o, structure: l }), T = (U == null ? void 0 : U.activePositionOverrides) || [], { sourceStructureIds: A } = jg({ finishingPosition: wo, targetRoundNumber: 1, linkType: Aa, drawDefinition: o, structureId: p }) || {}, y;
  A != null && A.length && (y = A.every((z) => $a({ structureId: z, drawDefinition: o })));
  let D = A.length, P = A.length && !y, { policyActions: w } = _M({ enabledStructures: v, drawDefinition: o, structure: l }), R = ![Pe, Ie].includes(l.stage) || l.stageSequence !== 1, { drawId: b } = o, E = [], { assignedPositions: O, positionAssignments: M } = Ir({ structure: l }), N = O == null ? void 0 : O.find((z) => z.drawPosition === s), C = !!N;
  if (!((X = M == null ? void 0 : M.map((z) => z.drawPosition)) != null && X.includes(s))) return { error: xc };
  let { stage: F, stageSequence: x } = l, V = [F];
  F === kr && V.push(Ie), F === Ie && V.push(kr);
  let k = Fs({ entryStatuses: Yo, provisionalPositioning: n, drawDefinition: o, stageSequence: x, structureId: p, stages: V }), L = Ko({ drawDefinition: o, stages: V }).assignedParticipantIds ?? [], B = k.filter((z) => !L.includes(z.participantId)).map((z) => z.participantId), G = g.includes(s), q = h.includes(s);
  if (S) return { info: "Actions Disabled for structure", isActiveDrawPosition: q, isDrawPosition: !0, hasPositionAssigned: C, validActions: [], isByePosition: G };
  if (li({ policyActions: w, action: ys }) && !q && M && !P && (!N || G)) {
    let { validAssignmentActions: z } = lG({ positionSourceStructureIds: A, unassignedParticipantIds: B, possiblyDisablingAction: R, isWinRatioFedStructure: D, tournamentParticipants: u, positionAssignments: M, returnParticipants: i, appliedPolicies: I, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: p, event: c });
    z == null || z.forEach((Z) => E.push(Z));
  }
  if (li({ policyActions: w, action: Nm }) && !q) {
    let { validAssignmentActions: z } = fG({ drawPositionInitialRounds: f, tournamentParticipants: u, positionAssignments: M, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, structureId: p, drawId: b });
    z == null || z.forEach((Z) => E.push(Z));
  }
  let { participantId: Y } = N || {}, H = Y && u.find((z) => z.participantId === Y);
  if (N) {
    li({ policyActions: w, action: Gg }) && !q && (E.push({ type: Gg, method: ST, payload: { drawId: b, structureId: p, drawPosition: s }, willDisableLinks: R }), G || E.push({ type: yU, method: cV, payload: { drawId: b, structureId: p, drawPosition: s }, willDisableLinks: R }), li({ policyActions: w, action: Ap }) && !G && E.push({ type: Ap, method: ST, payload: { drawId: b, structureId: p, drawPosition: s, replaceWithBye: !0 }, willDisableLinks: R }));
    let z = l.stage === Pe || l.stage === Ie && l.stageSequence === 1;
    if (!G && NT({ activePositionOverrides: T, activeDrawPositions: h, action: bu }) && li({ policyActions: w, action: bu }) && vp({ drawDefinition: o, structureId: p, drawPosition: s }) && z) {
      let { seedAssignments: Z } = Qi({ returnAllProxies: !0, drawDefinition: o, structure: l }), { seedNumber: te, seedValue: ne } = (Z == null ? void 0 : Z.find((ee) => ee.participantId === Y)) ?? {};
      E.push({ type: bu, method: gV, participant: H, seedNumber: te, payload: { drawId: b, structureId: p, participantId: Y, seedValue: ne } });
    }
    if (!G && NT({ activePositionOverrides: T, activeDrawPositions: h, action: zl }) && li({ policyActions: w, action: zl }) && vp({ drawDefinition: o, structureId: p, drawPosition: s }) && z) {
      let { seedAssignments: Z } = Qi({ returnAllProxies: !0, drawDefinition: o, structure: l }), { seedNumber: te } = (Z == null ? void 0 : Z.find((ne) => ne.participantId === Y)) ?? {};
      E.push({ method: mV, type: zl, participant: H, seedNumber: te, payload: { participantId: Y, structureId: p, drawId: b } });
    }
    if (!G && Y) {
      if (li({ policyActions: w, action: Mc })) {
        let Z = { type: Mc, method: nM, participant: H, payload: { penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0, drawId: b } };
        E.push(Z);
      }
      if (li({ policyActions: w, action: yp })) {
        let Z = { type: yp, method: fV, participant: H, payload: { participantId: Y, otherName: void 0 } };
        E.push(Z);
      }
    }
    if (li({ policyActions: w, action: Mm })) {
      let { validSwapAction: Z } = mG({ possiblyDisablingAction: R, tournamentParticipants: u, inactiveDrawPositions: m, activeDrawPositions: h, positionAssignments: M, returnParticipants: i, byeDrawPositions: g, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: p, structure: l, drawId: b });
      Z && E.push(Z);
    }
  }
  if (li({ policyActions: w, action: SU }) && !P) {
    let { validAlternatesAction: z } = sG({ possiblyDisablingAction: R, tournamentParticipants: u, positionAssignments: M, activeDrawPositions: h, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, validActions: E, structureId: p, structure: l, drawId: b, event: c });
    z && E.push(z);
  }
  if (li({ policyActions: w, action: AU }) && !P && !q && M) {
    let { validLuckyLosersAction: z } = dG({ sourceStructuresComplete: y, possiblyDisablingAction: R, isWinRatioFedStructure: D, tournamentParticipants: u, activeDrawPositions: h, positionAssignments: M, drawDefinition: o, drawPosition: s, structureId: p, structure: l, drawId: b });
    z && E.push(z);
  }
  if ((H == null ? void 0 : H.participantType) === _e && li({ policyActions: w, action: UU })) {
    let { validModifyAssignedPairAction: z } = tG({ tournamentParticipants: u, returnParticipants: i, drawPosition: s, participant: H, drawId: b, event: c });
    z && E.push(z);
  }
  return { isActiveDrawPosition: q, isDrawPosition: !0, hasPositionAssigned: C, isByePosition: G, validActions: E, ...j };
}
function rl({ policyDefinitions: e, appliedPolicies: t, drawType: r }) {
  var a, o;
  let i = (a = e == null ? void 0 : e[up]) == null ? void 0 : a.drawTypeCoercion, n = (o = t == null ? void 0 : t[up]) == null ? void 0 : o.drawTypeCoercion;
  return (typeof i == "boolean" ? i : void 0) ?? (r && (i == null ? void 0 : i[r])) ?? (typeof n == "boolean" ? n : void 0) ?? (r && (n == null ? void 0 : n[r])) ?? !0;
}
function Zu({ tournamentRecord: e, drawDefinition: t, stage: r = Ie, structureId: i, structure: n }) {
  var s;
  if (!e) return { error: de };
  if (!n && !t) return { error: Ue };
  if (!n && !i && ((s = t == null ? void 0 : t.structures) == null ? void 0 : s.filter((c) => c.stage === r).length) === 1 && (n = t.structures.find((c) => c.stage === r)), !n && !i) return { error: Vi };
  let { error: a, positionAssignments: o } = gt({ drawDefinition: t, structureId: i, structure: n });
  return { positionAssignments: o ?? [], structureId: n == null ? void 0 : n.structureId, error: a };
}
function WU({ structureId: e, drawDefinition: t }) {
  if (!t) return { error: Ue };
  if (!Et(e)) return { error: ie };
  let r = Qc({ drawDefinition: t, structureId: e });
  if (r.error) return r;
  let i = r.links.target.flatMap((a) => a.target.feedProfile).filter(Boolean), n = !qt([Po, dn, Xf, Do], i).length;
  return { ...j, valid: n };
}
function QM({ participantsCount: e, participantCount: t }) {
  if (e = e ?? t, !e) return { error: ie };
  let r = Lc(e);
  return r ? { drawSize: r } : W({ result: { error: ie }, stack: "getEliminationDrawSize", context: { participantsCount: e } });
}
function il(e) {
  let { drawSizeProgression: t = !1, policyDefinitions: r, drawSize: i } = e || {}, { requireParticipantCount: n = !0, tournamentRecord: a, drawDefinition: o, event: s } = e || {}, c = "getSeedsCount", u = (e == null ? void 0 : e.participantsCount) ?? (e == null ? void 0 : e.participantCount);
  if (!r) {
    let m = Fa({ tournamentRecord: a, drawDefinition: o, event: s });
    if (m.error) return W({ result: m, stack: c });
    r = m.policyDefinitions;
  }
  let d = ke(u);
  if (u && !d) return W({ result: { error: ie }, context: { participantsCount: u }, stack: c });
  if (n && !d) return W({ result: { error: Sw }, stack: c });
  if (isNaN(i)) if (u) ({ drawSize: i } = QM({ participantsCount: u }));
  else return W({ result: { error: od }, stack: c });
  let l = n && u || i;
  if (l && l > i) return { error: NI };
  let p = r == null ? void 0 : r[Tn];
  if (!p) return { error: cw };
  let f = p.seedsCountThresholds;
  return f ? (p.drawSizeProgression !== void 0 && (t = p.drawSizeProgression), { seedsCount: f.filter((m) => t ? m.drawSize <= i : i === m.drawSize).reduce((m, h) => u && u >= h.minimumParticipantCount ? h.seedsCount : m, 0) }) : { error: YP };
}
function Bm({ consideredEntries: e, policyDefinitions: t, tournamentRecord: r, appliedPolicies: i, participantMap: n, enforceGender: a, participants: o, event: s }) {
  var I;
  if ((!o || !n) && r && ({ participants: o, participantMap: n } = Lt({ tournamentRecord: r })), !o) return { error: cd };
  if (!Array.isArray(o)) return { error: ie };
  if (!s) return { error: At };
  let c = (t == null ? void 0 : t[Ar]) ?? (i == null ? void 0 : i[Ar]) ?? eu[Ar], u = (a ?? ((I = c == null ? void 0 : c.participants) == null ? void 0 : I.enforceGender)) !== !1, { eventType: d, gender: l } = s, p = d === ya, f = d === bi && lt || p && _e || Xe, m = Object.assign({}, ...(e ?? s.entries ?? []).map((U) => ({ [U.participantId]: U.entryStatus }))), h = Object.keys(m), g = o.filter((U) => h.includes(U.participantId)).filter((U) => {
    let v = hG({ participant: U, participantType: f, eventType: d, entryStatusMap: m }), S = gG({ genderEnforced: u, participantMap: n, eventGender: l, participant: U, isDoubles: p, mismatch: v });
    return v || !S;
  });
  if (g.length) {
    let U = g.map((v) => v.participantId);
    return { error: tw, invalidParticipantIds: U };
  }
  return { ...j, valid: !0 };
}
function hG({ participant: e, participantType: t, eventType: r, entryStatusMap: i }) {
  let n = i[e.participantId], a = r && [ya, bi].includes(r) && e.participantType === Xe && (Io(n) || n === Ra);
  return e.participantType !== t && !a;
}
function gG(e) {
  var l, p, f;
  let { participant: t, participantMap: r, eventGender: i, mismatch: n, isDoubles: a, genderEnforced: o } = e, s = !n && a && Be(((l = t == null ? void 0 : t.individualParticipantIds) == null ? void 0 : l.map((m) => {
    var h, g, I;
    return (I = (g = (h = r == null ? void 0 : r[m]) == null ? void 0 : h.participant) == null ? void 0 : g.person) == null ? void 0 : I.sex;
  }).filter(Boolean)) ?? []) || [], c = !i || !(s != null && s.length) || Mn === i || [pt, St].includes(i) && s[0] === i || ni === i && (s.length === 1 && ((p = t.individualParticipantIds) == null ? void 0 : p.length) === 1 || s.length === 2), u = (f = t == null ? void 0 : t.person) == null ? void 0 : f.sex, d = !(t != null && t.person) || !i || [Mn, ni].includes(i) || [pt, St].includes(i) && u === i;
  return !o || c && d;
}
function JM({ qualifyingProfiles: e, appliedPolicies: t, idPrefix: r, isMock: i, uuids: n }) {
  var h;
  let a = "generateQualifyingSTructures", o = [], s = [], c = [], u = (g, I) => g.stageSequence - I.stageSequence, d = (g, I) => g.roundTarget - I.roundTarget, l = 0, p = 0, f, m = 1;
  for (let g of e.sort(d)) {
    let I = g.structureProfiles || [];
    m = g.roundTarget || m;
    let U = 1, v = 0, S, T, A;
    for (let y of (I || []).sort(u)) {
      let D = pI(y.drawSize || y.participantsCount), { qualifyingRoundNumber: P, structureOptions: w, matchUpFormat: R, structureName: b, structureId: E, drawType: O } = y, M = y.matchUpType, N = y.qualifyingPositions || IG({ drawSize: D, qualifyingRoundNumber: P }), C, F, x;
      if (!ke(D)) return W({ result: { error: od }, stack: a });
      let V = e.length > 1 ? `${m}-` : "", k = I.length > 1 || V ? U : "", L = b || (V || k ? `${Fr(Pe)} ${V}${k}` : Fr(Pe));
      if (O === hn) {
        let { structures: B, groupCount: G, maxRoundNumber: q } = Wd({ structureName: y.structureName || L, structureId: E || (n == null ? void 0 : n.pop()), stage: Pe, structureOptions: w, appliedPolicies: t, stageSequence: U, matchUpType: M, roundTarget: m, drawSize: D, idPrefix: r, isMock: i, uuids: n });
        v = G, C = q, F = B[0], f = [1];
      } else ({ drawSize: D, matchUps: x, roundLimit: C } = Hn({ qualifyingRoundNumber: P, qualifyingPositions: N, matchUpType: M, drawSize: D, idPrefix: r, isMock: i, uuids: n })), F = zi({ structureName: y.structureName || L, structureId: E || (n == null ? void 0 : n.pop()), qualifyingRoundNumber: C, stage: Pe, matchUpFormat: R, stageSequence: U, matchUpType: M, roundLimit: C, matchUps: x }), m && it({ extension: { name: Kn, value: m }, element: F }), v = ((h = x == null ? void 0 : x.filter((B) => B.roundNumber === C)) == null ? void 0 : h.length) || 0;
      if (U > 1) {
        let { link: B } = zd({ sourceStructureId: T, sourceRoundNumber: S, targetStructureId: F.structureId, finishingPositions: A === Aa ? [1] : void 0, linkType: A });
        c.push(B), l += (D || 0) - v;
      } else l += D || 0;
      A = O === hn ? Aa : Ta, T = F.structureId, S = C, s.push(F), U += 1;
    }
    p += v, o.push({ qualifiersCount: v, finalQualifyingRoundNumber: S, finalQualifyingStructureId: T, finishingPositions: f, roundTarget: m, linkType: A }), m += 1;
  }
  return { qualifiersCount: p, qualifyingDrawPositionsCount: l, qualifyingDetails: o, structures: s, ...j, links: c };
}
function IG({ drawSize: e, qualifyingRoundNumber: t }) {
  let r = e, i = 0;
  for (; i < t; ) r = Math.floor(r / 2), i += 1;
  return r;
}
function $M(e) {
  let { drawTypeCoercion: t, enforceMinimumDrawSize: r } = e, i = be(e.drawSize), n = t && e.drawType !== Li && (typeof t == "boolean" || t <= 2) && i === 2 && xn || e.drawType || xn, a = $R.includes(n);
  if (i && a) {
    if (t && (typeof t == "boolean" && i < 4 || i <= t)) n = xn;
    else if (i < 4 && r) return { ...W({ context: { enforceMinimumDrawSize: r, drawSize: i, drawType: n }, result: { error: Nf }, stack: "getCoercedDrawType" }), drawType: n };
  }
  return { drawType: n };
}
function vG(e) {
  let { drawDefinition: t, structureOptions: r, requireSequential: i } = e, n = { structureName: Fr(Ie), ...e, stage: Ie }, { structures: a, groupCount: o, groupSize: s } = Wd(n);
  if (o < 1) return { error: Bw };
  let c = (r == null ? void 0 : r.playoffGroups) || [{ finishingPositions: [1], structureName: Fr(Wt) }], [u] = a, { structures: d, links: l } = hM({ sourceStructureId: u.structureId, requireSequential: i, drawDefinition: t, playoffGroups: c, groupCount: o, groupSize: s, ...e });
  return d && a.push(...d), { ...j, structures: a, links: l };
}
function UG({ mainStructure: e, consolationStructure: t, deciderStructure: r }) {
  let i = t.matchUps.reduce((u, d) => (d.drawPositions || []).filter(Boolean).length && !u.includes(d.roundNumber) ? u.concat(d.roundNumber) : u, []), n = e.matchUps.reduce((u, d) => !u || d.roundNumber > u ? d.roundNumber : u, void 0), a = t.matchUps.reduce((u, d) => !u || d.roundNumber > u ? d.roundNumber : u, void 0), o = i.map((u, d) => {
    let l = i.indexOf(u) % 2 ? dn : Po, p = 1 + d;
    return { linkType: oa, source: { roundNumber: p, structureId: e.structureId }, target: { feedProfile: l, roundNumber: u, structureId: t.structureId } };
  }), s = { linkType: Ta, source: { roundNumber: a, structureId: t.structureId }, target: { feedProfile: dn, roundNumber: n, structureId: e.structureId } }, c = [{ linkType: Ta, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: dn, roundNumber: 1, structureId: r.structureId } }, { linkType: oa, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: dn, roundNumber: 1, structureId: r.structureId } }];
  return [...o, s, ...c];
}
function SG({ structureName: e, matchUpType: t, idPrefix: r, drawSize: i, isMock: n, uuids: a }) {
  let o = [], { matchUps: s } = eo({ linkFedFinishingRoundNumbers: [1], drawSize: i + 1, matchUpType: t, idPrefix: r, isMock: n }), c = Ha({ structureName: e || Fr(Ie), structureId: a == null ? void 0 : a.pop(), stageSequence: 1, stage: Ie, matchUpType: t, matchUps: s });
  o.push(c);
  let u = i / 2, { matchUps: d } = eo({ finishingPositionOffset: u, idPrefix: r && `${r}-c`, drawSize: i - 1, isConsolation: !0, matchUpType: t, isMock: n, uuids: a }), l = Ha({ structureName: Fr(JR), matchUps: d, structureId: a == null ? void 0 : a.pop(), stage: kr, stageSequence: 2, matchUpType: t });
  o.push(l);
  let { matchUps: p } = Hn({ idPrefix: r && `${r}-p1t2`, drawSize: 2, matchUpType: t, isMock: n }), f = Ha({ structureName: Fr(QR), matchUps: p, structureId: a == null ? void 0 : a.pop(), stageSequence: 3, stage: Wt, matchUpType: t });
  o.push(f);
  let m = UG({ mainStructure: c, consolationStructure: l, deciderStructure: f });
  return { structures: o, links: m, ...j };
}
function yG(e) {
  let { qualifyingRoundNumber: t, finishingPositionOffset: r, qualifyingPositions: i, matchUpType: n, idPrefix: a, drawSize: o, isMock: s, uuids: c } = e;
  if (!ke(o) || o < 2) return { matchUps: [], roundsCount: 0 };
  if (Rn(o)) return Hn(e);
  let u = AG(o), d = u.shift(), l = fe(1, ((d == null ? void 0 : d.participantsCount) || 0) + 1).map((g) => ({ drawPosition: g })), p = [], f = 1;
  ({ matchUps: p } = Tp({ roundNumber: f, matchUpType: n, idPrefix: a, matchUps: p, isMock: s, nodes: l, uuids: c })), f++;
  let m = e.roundLimit || t;
  for (let g of u) {
    let I = g.participantsCount / 2, U = fe(1, I + 1);
    i && I === i && (m = f - 1);
    let v = U.map((S) => {
      let T = TU({ roundPosition: S, roundNumber: f, idPrefix: a, uuids: c });
      return { roundPosition: S, roundNumber: f, matchUpId: T };
    });
    p.push(...v), f++;
  }
  let h = f - 1;
  return p = Ld({ finishingPositionOffset: r, lucky: !0, roundsCount: h, roundLimit: m, matchUps: p }), m && (p = p.filter((g) => g.roundNumber <= m)), { matchUps: p, roundsCount: h, roundLimit: m };
}
function AG(e) {
  let t = be(e), r = t % 2 ? t + 1 : t, i = !!(Math.ceil(r / 2) % 2), n = [{ participantsCount: r, preFeedRound: i }];
  for (; r > 2; ) {
    let a = Math.ceil(r / 2), o = a === 1, s = !!(!o && a % 2);
    r = !o && s ? a + 1 : a;
    let c = !!(r !== 2 && Math.ceil(r / 2) % 2);
    n.push({ participantsCount: r, preFeedRound: c, feedRound: s });
  }
  return n;
}
function e0(e) {
  var f, m;
  let { playoffAttributes: t, stageSequence: r = 1, stage: i = Ie, matchUpType: n, drawSize: a, uuids: o } = e, s = () => !e.isMock && !e.idPrefix ? void 0 : `${e.drawDefinition.drawId}-s-0`, c = e.structureId || s() || (o == null ? void 0 : o.pop()), u = e.appliedPolicies ?? nt(e), d = ((f = e.policyDefinitions) == null ? void 0 : f[Dc]) || (u == null ? void 0 : u[Dc]);
  e.skipRounds = e.skipRounds || a <= 4 && (d != null && d.feedFromMainFinal ? 0 : 1) || 0;
  let l = e.structureName ?? ((m = t == null ? void 0 : t["0"]) == null ? void 0 : m.name) ?? Fr(Ie), p = () => {
    let { matchUps: h } = Hn(e);
    return { structures: [zi({ stageSequence: r, structureName: l, matchUpType: n, structureId: c, matchUps: h, stage: i })], links: [], ...j };
  };
  return { generators: { [Li]: () => ({ structures: [zi({ finishingPosition: wo, stageSequence: r, structureName: l, matchUps: [], matchUpType: n, structureId: c, stage: i })], links: [], ...j }), [Go]: () => {
    let { matchUps: h } = yG(e);
    return { structures: [zi({ stageSequence: r, structureName: l, matchUpType: n, structureId: c, matchUps: h, stage: i })], links: [], ...j };
  }, [xn]: () => p(), [md]: () => SG(e), [Uc]: () => uc({ ...e, roundOffsetLimit: 3, playoffAttributes: t ?? rv }), [Sc]: () => uc({ ...e, roundOffsetLimit: 2, playoffAttributes: t ?? iv }), [Wt]: () => uc(e), [Hc]: () => {
    let { matchUps: h } = eo({ drawSize: a, uuids: o, matchUpType: n });
    return { structures: [zi({ stageSequence: r, structureName: l, matchUpType: n, structureId: c, stage: Ie, matchUps: h })], links: [], ...j };
  }, [hd]: () => pM(e), [yc]: () => $o({ ...e, feedRounds: 1, fmlc: !0 }), [ZR]: () => $o({ ...e, feedRounds: 1 }), [$I]: () => $o({ ...e, feedsFromFinal: 1 }), [ev]: () => $o({ ...e, feedsFromFinal: 2 }), [tv]: () => $o({ ...e, feedsFromFinal: 3 }), [gd]: () => $o(e), [Zf]: () => mM(e), [hn]: () => Wd(e), [sa]: () => vG(e) } };
}
function qU(e) {
  var L, B, G, q, Y;
  let { enforceMinimumDrawSize: t = !0, overwriteExisting: r, appliedPolicies: i, staggeredEntry: n, drawDefinition: a, tieFormat: o, isMock: s, uuids: c } = e || {}, u = be(e.drawSize), d = e.drawTypeCoercion ?? rl({ appliedPolicies: i, drawType: e.drawType }), l = "generateDrawStructuresAndLinks", p = $M({ drawType: e.drawType, enforceMinimumDrawSize: t, drawTypeCoercion: d, drawSize: u });
  if (p.error) return p;
  let f = p.drawType, m = [], h = [], g = (e == null ? void 0 : e.matchUpType) ?? mt, I = (L = a == null ? void 0 : a.structures) == null ? void 0 : L.filter(({ stage: H }) => H === Pe);
  I && m.push(...I);
  let U = I == null ? void 0 : I.map(({ structureId: H }) => H), v = (B = a == null ? void 0 : a.structures) == null ? void 0 : B.find(({ stage: H, stageSequence: X }) => H === Ie && X === 1), S = (G = a == null ? void 0 : a.links) == null ? void 0 : G.filter((H) => H.target.structureId === (v == null ? void 0 : v.structureId) && (U == null ? void 0 : U.includes(H.source.structureId))), T = (H, X) => {
    var z;
    if (H.linkType === Aa && (X != null && X.structures)) {
      let Z = H.source.finishingPositions || [];
      return X.structures.length * Z.length;
    } else if (H.linkType === Ta && ((z = X == null ? void 0 : X.matchUps) != null && z.length)) {
      let Z = H.source.roundNumber;
      return X.matchUps.filter(({ roundNumber: te }) => te === Z).length;
    }
  }, A = I == null ? void 0 : I.map((H) => {
    var ee, K, J;
    let X = S == null ? void 0 : S.find(($) => $.target.structureId === H.structureId), z = ((K = (ee = gt({ structure: H })) == null ? void 0 : ee.positionAssignments) == null ? void 0 : K.length) ?? 0;
    if (!X) return z;
    let Z = X == null ? void 0 : X.source.structureId, te = (J = a.structures) == null ? void 0 : J.find(($) => $.structureId === Z), ne = T(X, te) || 0;
    return z - ne;
  }).filter(Boolean).reduce((H, X) => H + X, 0), y = S == null ? void 0 : S.map((H) => {
    let X = H.source.structureId, z = I == null ? void 0 : I.find((Z) => Z.structureId === X);
    return T(H, z);
  }).filter(Boolean).reduce((H, X) => H + X, 0), D = !!(v && !((q = v == null ? void 0 : v.matchUps) != null && q.length));
  if (I != null && I.length && !D) return { error: Sg };
  let P = !(I != null && I.length) && e.qualifyingProfiles, w = (P == null ? void 0 : P.length) && JM({ idPrefix: e.idPrefix, qualifyingProfiles: P, appliedPolicies: i, isMock: s, uuids: c });
  if (w != null && w.error) return w;
  let { qualifyingDrawPositionsCount: R, qualifyingDetails: b, qualifiersCount: E } = w || { qualifyingDrawPositionsCount: A, qualifiersCount: y };
  R && (w != null && w.structures && m.push(...w.structures), w != null && w.links && h.push(...w.links)), Object.assign(e, ye({ drawSize: u, matchUpType: g, tieFormat: o }));
  let O = f !== Li && (!u || u < 2 || !n && ![Hc, Go].includes(f) && ([sa, hn].includes(f) && u < 3 || ![hn, sa].includes(f) && !Rn(u)));
  if (O && !R) return W({ context: { drawSize: u, invalidDrawSize: O }, result: { error: Nf }, stack: l });
  let { generators: M, error: N } = e0(e);
  if (N) return { error: N };
  let C = M[f];
  if (!C) return { error: gI };
  let F = C == null ? void 0 : C();
  if (F.error) return F;
  let { structures: x, links: V } = F;
  if (x != null && x.length) {
    let H = x.find(({ stage: X, stageSequence: z }) => X === Ie && z === 1);
    if (v && H) {
      if (D) {
        let X = H.structureId;
        if (H.structureId = v.structureId, V == null ? void 0 : V.length) for (let z of V) z.source.structureId === X && (z.source.structureId = v.structureId), z.target.structureId === X && (z.target.structureId = v.structureId);
      } else if (!r) return { error: Sg };
    }
    m.push(...x);
  }
  m.sort(Cs), V != null && V.length && h.push(...V);
  let k = F.structures.find(({ stage: H, stageSequence: X }) => H === Ie && X === 1);
  for (let H of b || []) {
    let { finalQualifyingRoundNumber: X, finalQualifyingStructureId: z, roundTarget: Z, finishingPositions: te, linkType: ne } = H, ee = k && ((Y = zd({ targetStructureId: k.structureId, sourceStructureId: z, sourceRoundNumber: X, finishingPositions: te, targetEntryRound: Z, linkType: ne })) == null ? void 0 : Y.link);
    if (ee != null && ee.error) return ee;
    ee && h.push(ee);
  }
  return S && h.push(...S), { ...j, qualifyingResult: { qualifyingDrawPositionsCount: R, qualifiersCount: E }, structures: m, links: h };
}
function HU(e) {
  var v, S;
  let { modifyOriginal: t = !0, stageSequence: r = 1, isMock: i } = e || {}, n = "generateDrawTypeAndModifyDrawDefinition";
  if (!e.drawDefinition) return W({ result: { error: Ue }, stack: n });
  let a = t ? e.drawDefinition : ge(e.drawDefinition, !1, !0), { tieFormat: o, matchUpType: s } = e;
  if (o) {
    let T = oi({ tieFormat: o });
    if (T.error) return T;
  }
  o = Er(o ?? ((v = Yr({ drawDefinition: a })) == null ? void 0 : v.tieFormat)), s = s ?? (a.matchUpType || mt), e.tieFormat = o, e.matchUpType = s;
  let c = Ip({ drawDefinition: a, stage: Ie });
  e.drawSize = e.drawSize ?? c, !c && e.drawSize && Sp({ drawSize: e.drawSize, drawDefinition: a, stageSequence: r, stage: Ie });
  let u = xr({ drawDefinition: a }).drawMatchUps.map(hr), d = qU(e);
  if (d.error) return W({ result: d, stack: n });
  let { structures: l, links: p, qualifyingResult: f } = d;
  a.structures = l, a.links = p;
  let m = Math.max(e.qualifiersCount ?? 0, (f == null ? void 0 : f.qualifiersCount) || 0);
  if (f != null && f.qualifyingDrawPositionsCount && !Ip({ stage: Pe, drawDefinition: a })) {
    let T = Sp({ drawSize: f.qualifyingDrawPositionsCount, stage: Pe, drawDefinition: a });
    if (T.error) return T;
  }
  if (m) {
    let T = tM({ qualifiersCount: m, drawDefinition: a, stage: Ie });
    if (T.error) return T;
  }
  let h = e.drawSize ?? c;
  Object.assign(e, ye({ drawSize: h, matchUpType: s, tieFormat: o }));
  let { matchUps: g, matchUpsMap: I } = ur({ drawDefinition: a });
  o && (g == null || g.forEach((T) => {
    if (!u.includes(T.matchUpId)) {
      let { tieMatchUps: A } = Xd({ tieFormat: o, matchUp: T, isMock: i });
      Object.assign(T, { tieMatchUps: A, matchUpType: s });
    }
  }));
  let { inContextDrawMatchUps: U } = Eo({ drawDefinition: a, matchUpsMap: I });
  return vt({ tournamentId: (S = e.tournamentRecord) == null ? void 0 : S.tournamentId, drawDefinition: a }), { inContextDrawMatchUps: U, drawDefinition: a, matchUpsMap: I, ...j, structures: l, matchUps: g, links: p };
}
function nl(e) {
  let { removePriorValues: t, tournamentRecord: r, participantId: i, scaleItem: n } = e, a, o;
  if (!r0({ scaleItem: n })) return { error: ps };
  if (i && Array.isArray(r.participants) && (o = r.participants.find((s) => s.participantId === i), o)) {
    if (o.participantType === ai && (n == null ? void 0 : n.eventType) !== bi) return { error: ps };
    let s = i0({ removePriorValues: t, participant: o, scaleItem: n });
    if (s.error) return s;
    a = !s.valueChanged;
    let { topics: c } = Ji();
    c.includes(Lr) && Le({ topic: Lr, payload: { tournamentId: r.tournamentId, participants: [o] } });
  }
  return a && { ...j, info: xI, existingValue: n == null ? void 0 : n.scaleValue } || o && { ...j, newValue: n == null ? void 0 : n.scaleValue } || { error: Yt };
}
function t0(e) {
  var l;
  let { scaleItemsWithParticipantIds: t = [], removePriorValues: r, tournamentRecord: i, auditData: n, context: a } = e;
  if (!i) return { error: de };
  if (!i.participants) return { error: cd };
  let o = 0, s = {}, c = [];
  for (let p of t) {
    let f = p == null ? void 0 : p.participantId;
    if (Array.isArray(p == null ? void 0 : p.scaleItems)) for (let m of p.scaleItems) if (r0({ scaleItem: m })) Array.isArray(s[f]) || (s[f] = []), s[f].push(m);
    else return { error: ps };
  }
  for (let p of i.participants) {
    let { participantId: f } = p || {};
    if (Array.isArray(s[f])) for (let m of s[f]) {
      if (p.participantType === ai && (m == null ? void 0 : m.eventType) !== bi) return W({ context: { participantId: f, scaleItem: m, participantType: p.participantType }, info: "Invalid participantType for eventType", result: { error: ps } });
      i0({ participant: p, scaleItem: m, removePriorValues: r }), c.push(p), o++;
    }
  }
  let u = o ? void 0 : Wc, { topics: d } = Ji();
  if (d.includes(Lr) && o && Le({ topic: Lr, payload: { tournamentId: i.tournamentId, participants: c } }), a) {
    let { eventId: p, drawId: f, ...m } = a, h = ((l = m.scaleAttributes) == null ? void 0 : l.scaleType) && [m.scaleAttributes.scaleType];
    if (Object.keys(m).length) {
      let g = { itemType: Av, itemValue: m };
      if (h && (g.itemSubTypes = h), f || p) {
        let { drawDefinition: I, event: U } = ci({ tournamentRecord: i, eventId: p, drawId: f });
        f && vU({ drawDefinition: I, timeItem: g }), p && Ys({ event: U, timeItem: g });
      } else el({ tournamentRecord: i, timeItem: g });
    }
  }
  return n && d.includes(va) && Le({ topic: va, payload: n }), ye({ ...j, modificationsApplied: o, info: u });
}
function r0({ scaleItem: e }) {
  let t = e && Object.keys(e), r = ["scaleType", "eventType", "scaleName"];
  return r.filter((i) => t == null ? void 0 : t.includes(i)).length === r.length;
}
function i0({ removePriorValues: e, participant: t, scaleItem: r }) {
  if (!t) return { error: ws };
  let i = r && Object.keys(r), n = ["scaleType", "eventType", "scaleName"];
  if (n.filter((u) => i.includes(u) && r[u]).length !== n.length) return { error: ps };
  let a = (/* @__PURE__ */ new Date()).toISOString();
  t.timeItems || (t.timeItems = []);
  let { scaleItem: o } = ta({ scaleAttributes: r, participant: t }), s = (u) => [void 0, null, ""].includes(u), c = !(s(o == null ? void 0 : o.scaleValue) && s(r.scaleValue)) && JSON.stringify(o == null ? void 0 : o.scaleValue) !== JSON.stringify(r.scaleValue);
  if (c) {
    let { scaleType: u, eventType: d, scaleName: l } = r, p = [Ro, u, d, l].join("."), f = ye({ itemValue: r.scaleValue, itemDate: r.scaleDate, createdAt: a, itemType: p });
    r.scaleId && (f.itemSubTypes = [r.scaleId]), e && (t.timeItems = t.timeItems.filter((m) => m.itemType !== p)), t.timeItems.push(f);
  }
  return { ...j, valueChanged: c, newValue: r.scaleValue };
}
function YU(e) {
  let { tournamentRecord: t, modifiedScaleValues: r, removePriorValues: i } = e, n = Ae(e, [{ [fr]: !0 }, { modifiedScaleValues: !0, [ui]: pi }]);
  if (n.error) return n;
  for (let a in r) {
    let o = nl({ scaleItem: r[a], removePriorValues: i, tournamentRecord: t, participantId: a });
    if (o.error) return o;
  }
  return { ...j };
}
function Ec(e) {
  let { tournamentRecord: t, scaleAttributes: r, participantId: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!i) return { error: cr };
  let { participant: a, tournamentId: o } = co({ tournamentRecords: n, tournamentRecord: t, participantId: i });
  return a ? { ...ta({ participant: a, scaleAttributes: r }), tournamentId: o } : { error: Yt };
}
var TG = (e = 0) => 250 / Math.pow(e + 5, 0.4), DG = () => 1;
function PG(e = 3, t = 2) {
  let r = e / t;
  return isNaN(r) ? nc.kDefault() : r;
}
var nc = { nSpread: 400, diffThreshold: 0.125, kCalc: TG, kMultiplier: PG, kDefault: DG };
function n0(e) {
  let { winnerRating: t, loserRating: r } = e, { ratings: i = Ur, winnerCountables: n = 1, loserCountables: a = 0, ratingType: o = cn, maxCountables: s, countables: c } = e || {}, u = i == null ? void 0 : i[o];
  if (!u) return { error: we };
  let d = u.range || e.ratingRange;
  t = t || u.defaultInitialization, r = r || u.defaultInitialization;
  let l = d[0] > d[1], p = u.decimalsCount || 0, f = l ? d.slice().reverse() : d, m = (N, C) => parseFloat(C) >= Math.min(...N) && parseFloat(C) <= Math.max(...N);
  (!m(d, t) || !m(d, r)) && (m(d, t) || (t = u.defaultInitialization), m(d, r) || (r = u.defaultInitialization));
  let h = ac({ targetRange: Ur[cn].range, sourceRange: f, value: l ? d[0] - t : t }), g = ac({ targetRange: Ur[cn].range, sourceRange: f, value: l ? d[0] - r : r }), I = (N, C) => 1 / (1 + Math.pow(10, (C - N) / nc.nSpread)), U = I(h, g), v = I(g, h), S = nc.kCalc(n), T = nc.kCalc(a), A = nc.kMultiplier(s, c), y = h + A * S * (1 - U), D = g + A * T * (0 - v), P = ac({ sourceRange: Ur[cn].range, value: y, targetRange: f }), w = ac({ sourceRange: Ur[cn].range, value: D, targetRange: f }), R = l ? d[0] - P : P, b = parseFloat(R.toFixed(p)), E = l ? d[0] - w : w, O = parseFloat(E.toFixed(p)), M = Math.max(...d) ? Math.abs(t - r) / Math.max(...d) : 0;
  return (P > w && M > nc.diffThreshold || b < 0 || O < 0) && (b = t, O = r), { newWinnerRating: b, newLoserRating: O };
}
var wG = (e) => (e == null ? void 0 : e.reduce((t, r) => (r.winningSide && (t[r.winningSide - 1] += 1), t), [0, 0])) || [0, 0];
function a0(e) {
  var U, v;
  let t = Ae(e, [{ [fr]: !0 }, { matchUpIds: !0, [ui]: Gr, [pn]: Ts }, { ratingType: !1, [Or]: (S) => Ur[S] }]);
  if (t.error) return t;
  let { updateParticipantRatings: r, removePriorValues: i = !0, tournamentRecord: n, ratingType: a = cn, refreshDynamic: o, considerGames: s, drawDefinition: c, matchUpIds: u, asDynamic: d } = e, l = Ur[a], { accessor: p } = l, f = {}, m = (e.matchUps || o && Qr({ drawDefinition: c, tournamentRecord: n, inContext: !0, matchUpFilters: { matchUpStatuses: lr } }).matchUps || Pr({ matchUpFilters: { matchUpIds: u, matchUpStatuses: lr }, tournamentRecord: n, inContext: !0 }).matchUps) ?? [], h = `${a}.${pv}`, g = d ? h : a;
  m.sort(js);
  for (let S of m) {
    let { endDate: T, matchUpFormat: A, score: y, sides: D, winningSide: P } = S, w = S.matchUpType, R = { eventType: w, scaleName: a, scaleType: qa }, b = { scaleName: h, eventType: w, scaleType: qa }, E = Object.assign({}, ...(D ?? []).map((L) => {
      let { sideNumber: B, participant: G } = L;
      return B && { [B]: [G == null ? void 0 : G.participantId, ...(G == null ? void 0 : G.individualParticipantIds) ?? []].filter(Boolean).flat() };
    })), O = Object.assign({}, ...Object.values(E).flat().map((L) => {
      let B = f[L], G = !o || B ? Ec({ scaleAttributes: b, tournamentRecord: n, participantId: L }).scaleItem : void 0, q = Ec({ tournamentRecord: n, scaleAttributes: R, participantId: L }).scaleItem, Y = p ? { [p]: void 0 } : void 0;
      return L && { [L]: G ?? q ?? { scaleName: g, eventType: w, scaleDate: T, scaleType: qa, scaleValue: Y } };
    })), M = A ? ti(A) : {}, N = (M == null ? void 0 : M.bestOf) || 1, C = (M == null ? void 0 : M.setsTo) || 1, F = s ? N & C : N, x = (y == null ? void 0 : y.sets) && wG(y.sets) || P === 1 && [1, 0] || [0, 1], V = P ? E[P] : [], k = P ? E[3 - P] : [];
    for (let L of V) {
      let B = (U = O[L]) == null ? void 0 : U.scaleValue, G = typeof B == "object" ? B[p] : B;
      for (let q of k) {
        let Y = (v = O[q]) == null ? void 0 : v.scaleValue, H = typeof Y == "object" ? Y[p] : Y, X = P ? x[P] : [0, 0], z = P ? x[3 - P] : [0, 0], { newWinnerRating: Z, newLoserRating: te } = n0({ winnerCountables: X, loserCountables: z, maxCountables: F, winnerRating: G, loserRating: H, ratingType: a }), ne = p ? { ...B, [p]: Z } : Z, ee = p ? { ...Y, [p]: te } : te;
        O[L].scaleValue = ne, O[q].scaleValue = ee, O[L].scaleName = g, O[q].scaleName = g;
      }
    }
    Object.assign(f, O), r && YU({ tournamentRecord: n, modifiedScaleValues: f, removePriorValues: i });
  }
  let I = m.map(({ matchUpId: S }) => S);
  return { ...j, modifiedScaleValues: f, outputScaleName: g, processedMatchUpIds: I };
}
function Vm(e) {
  var g;
  let { matchUpIds: t = [], drawDefinition: r, roundNumber: i, newRound: n, isMock: a, event: o } = e;
  if (typeof r != "object") return { error: Ue };
  let { participantIdPairings: s, matchUpsCount: c } = e, u = Lm(e);
  if (u.error) return W({ result: u });
  let { lastRoundNumber: d, availableMatchUpsCount: l = 0, roundMatchUpsCount: p = 0 } = u;
  if (!c) n ? c = p : l > 0 && (c = l);
  else if (c > p && e.restrictMatchUpsCount !== !1) return W({ result: { error: ie, info: "matchUpsCount error", context: { roundMatchUpsCount: p } } });
  if (s && !Array.isArray(s) || c && !ke(c) || t && !Array.isArray(t) || !s && !c) return { error: ie, info: "matchUpsCount or pairings error" };
  if (c && e.restrictMatchUpsCount !== !1 && c > 32) return { error: ie, info: "matchUpsCount must be less than 33" };
  if (i && !e.ignoreLastRoundNumber && i - 1 > (d || 0)) return { error: ie, info: "roundNumber error" };
  let f = i ?? (n && (d ?? 0) + 1 || d || 1);
  s = s ?? fe(0, c).map(() => ({ participantIds: [void 0, void 0] }));
  let m = (I) => {
    if (!e.idPrefix) return;
    let U = r.drawId, v = e.idPrefix ?? "ah";
    return `${U}-${v}-${f}-${I}`;
  }, h = s == null ? void 0 : s.map((I, U) => {
    let v = (I == null ? void 0 : I.participantIds) ?? [void 0, void 0];
    v.push(void 0, void 0);
    let S = v.slice(0, 2).map((A, y) => ye({ sideNumber: y + 1, participantId: A })), T = t[U] ?? m(U) ?? st();
    return { roundNumber: f, matchUpStatus: Xt, matchUpId: T, sides: S };
  });
  if (h != null && h.length) {
    let I = (g = Yr({ drawDefinition: r, event: o })) == null ? void 0 : g.tieFormat;
    I && h.forEach((U) => {
      let { tieMatchUps: v } = Xd({ tieFormat: I, matchUp: U, isMock: a });
      Object.assign(U, { tieMatchUps: v, matchUpType: yt });
    });
  }
  return { roundNumber: f, matchUpsCount: (h == null ? void 0 : h.length) ?? 0, matchUps: h, ...j };
}
function RG({ maxIterations: e = 4e3, valueSortedPairings: t, pairingValues: r, valueObjects: i, deltaObjects: n }) {
  let a = Object.assign({}, ...t.map((U) => ({ [U.pairing]: U.value }))), o = Object.keys(r), s = [], c = ET({ actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i }), u = [Xh(c)];
  s.push(c);
  let d = c.value, l = c, p = 1, f = 0, m = o.length, h;
  do
    m -= 1, h = o.length * r[o[0]].length;
  while (h > e && m > 5);
  let g = [];
  o.forEach((U) => {
    r[U].slice(0, m).forEach((v) => {
      f += 1;
      let S = os(U, v.opponent);
      if (!g.includes(S)) {
        let T = ET({ stipulated: [[U, v.opponent]], actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i });
        if (!u.includes(Xh(T))) {
          u.push(Xh(T)), s.push(T);
          let { maxDelta: A, value: y } = T;
          A < l.maxDelta && (l = T), (y < d || y === d && Math.round(Math.random())) && (d = y), g.push(S), p += 1;
        }
      }
    }), s = s.filter((v) => Math.abs(v.value - d) < 5);
  }), s.sort((U, v) => U.maxDiff - v.maxDiff);
  let I = Di(s);
  return { candidatesCount: p, deltaCandidate: l, maxIterations: e, iterations: f, candidate: I };
}
function Xh(e) {
  return e.participantIdPairings.map(({ participantIds: t }) => t.sort().join("|")).sort().join("/");
}
function ET({ valueSortedPairings: e, stipulated: t = [], pairingValueMap: r, deltaObjects: i, valueObjects: n, actorsCount: a }) {
  let o = [].concat(...t), s = [], c = 0;
  t.filter(Boolean).forEach((l) => {
    let [p, f] = l, m = os(p, f), h = r[m];
    s.push({ participantIds: l, value: h }), c += r[m];
  }), gr(e, a).map((l) => Xr(l).map((p) => ({ ...p, value: p.value + Math.random() * Math.round(Math.random()) }))).flat().forEach((l) => {
    let p = l.pairing.split("|");
    if (!p.reduce((f, m) => o.includes(m) || f, !1)) {
      o.push(...p);
      let f = l.value;
      c += f, s.push({ participantIds: p, value: f });
    }
  }), s.sort((l, p) => l.value - p.value);
  let u = s.reduce((l, p) => {
    let [f, m] = p.participantIds, h = os(f, m), g = i[h];
    return g > l ? g : l;
  }, 0), d = s.reduce((l, p) => {
    let [f, m] = p.participantIds, h = os(f, m), g = n[h];
    return g > l ? g : l;
  }, 0);
  return { value: c, participantIdPairings: s, maxDelta: u, maxDiff: d };
}
function os(e, t) {
  return [e, t].sort(Tm).join("|");
}
function o0({ participantIds: e }) {
  let t = {}, r = [];
  e.forEach((n) => {
    t[n] = e.filter((a) => a !== n), t[n].forEach((a) => {
      let o = os(a, n);
      r.includes(o) || r.push(o);
    });
  });
  let i = Object.assign({}, ...r.map((n) => ({ [n]: 0 })));
  return { uniquePairings: r, possiblePairings: t, deltaObjects: i };
}
function bG({ matchUps: e }) {
  let t = [];
  for (let r of e) {
    let i = r.sides.map(Ke);
    if (i.length === 2) {
      let [n, a] = i, o = os(n, a);
      t.includes(o) || t.push(o);
    }
  }
  return { encounters: t };
}
function NG({ possiblePairings: e, valueObjects: t }) {
  let r = {};
  for (let n of Object.keys(e)) {
    let a = e[n].map((o) => i(n, o));
    r[n] = a.sort((o, s) => o.value - s.value);
  }
  function i(n, a) {
    let o = os(n, a);
    return { opponent: a, value: t[o] };
  }
  return { pairingValues: r };
}
var MG = 0;
function EG({ tournamentParticipants: e, adHocRatings: t, eventType: r, scaleName: i, pairing: n }) {
  var o;
  let a = ((o = Ur[i]) == null ? void 0 : o.defaultInitialization) ?? MG;
  return n.split("|").map((s) => {
    var c;
    if (r === Xi) {
      let u = (c = e == null ? void 0 : e.find((d) => d.participantId === s)) == null ? void 0 : c.individualParticipantIds;
      return u ? u == null ? void 0 : u.map((d) => t[d] || a) : a * 2;
    } else return t[s] || a;
  });
}
function OG(e) {
  let { tournamentParticipants: t, adHocRatings: r = {}, possiblePairings: i, uniquePairings: n, maxIterations: a, minimizeDelta: o, deltaObjects: s, valueObjects: c, eventType: u, scaleName: d, salted: l } = e;
  n.forEach((v) => {
    let S = EG({ tournamentParticipants: t, adHocRatings: r, scaleName: d, eventType: u, pairing: v }), T = typeof l == "number" && l || 0.5, A = l && (Math.round(Math.random()) ? T : T * -1) || 0, y = Math.abs(S[0] - S[1]) + A, D = Math.abs(S[0] - S[1]);
    s[v] = D, c[v] || (c[v] = 0), c[v] += y ? Math.pow(y, 2) : 0;
  });
  let p = n.map((v) => ({ pairing: v, value: c[v] })).sort((v, S) => v.value - S.value), { pairingValues: f } = NG({ possiblePairings: i, valueObjects: c }), { candidate: m, candidatesCount: h, deltaCandidate: g, iterations: I } = RG({ valueSortedPairings: p, maxIterations: a, pairingValues: f, deltaObjects: s, valueObjects: c }), { participantIdPairings: U } = o ? g : m;
  return { participantIdPairings: U, candidatesCount: h, deltaCandidate: g, iterations: I, candidate: m };
}
var CG = 100, FG = 100, kG = 4e3;
function zU(e) {
  var Y, H;
  let { encounterValue: t = CG, sameTeamValue: r = FG, maxIterations: i = kG, updateParticipantRatings: n, generateMatchUps: a = !0, ignoreLastRoundNumber: o, iterationMatchUps: s, tournamentRecord: c, dynamicRatings: u, refreshDynamic: d, participantIds: l, drawDefinition: p, roundNumber: f, structureId: m, matchUpIds: h, eventType: g, scaleName: I, idPrefix: U, isMock: v, salted: S, event: T } = e;
  if (!p) return { error: Ue };
  if (!e.structure && !m) return { error: kt };
  let A = e.structure || Ne({ drawDefinition: p, structureId: m }).structure;
  if (!$e(A)) return { error: Bo };
  if (!(l != null && l.length)) return { error: ro };
  let y = [...s ?? [], ...(A == null ? void 0 : A.matchUps) ?? []], { encounters: D } = bG({ matchUps: y }), P = (c == null ? void 0 : c.participants) ?? [], w = {};
  if (u) {
    let X = Be(A != null && A.matchUps ? A.matchUps.map(({ roundNumber: Z }) => Z) : []), z = Math.max(...X, 0);
    if (z) {
      let Z = (Y = A == null ? void 0 : A.matchUps) == null ? void 0 : Y.filter(({ roundNumber: ne }) => ne === z).map(({ matchUpId: ne }) => ne), te = a0({ ratingType: I ?? ((H = T == null ? void 0 : T.category) == null ? void 0 : H.ratingType), updateParticipantRatings: n, tournamentRecord: c, asDynamic: !0, refreshDynamic: d, drawDefinition: p, matchUpIds: Z });
      if (te.error) return te;
      te.modifiedScaleValues && (w = te.modifiedScaleValues);
    }
  }
  let { valueObjects: R } = LG({ tournamentParticipants: P, encounterValue: t, sameTeamValue: r, encounters: D }), { uniquePairings: b, possiblePairings: E, deltaObjects: O } = o0({ participantIds: l }), M = Object.values(w).length ? w : e.adHocRatings, N = { tournamentParticipants: P, possiblePairings: E, participantIds: l, uniquePairings: b, drawDefinition: p, maxIterations: i, adHocRatings: M, deltaObjects: O, valueObjects: R, eventType: g, scaleName: I, structure: A, salted: S }, { candidatesCount: C, participantIdPairings: F, deltaCandidate: x, iterations: V, candidate: k } = OG(N);
  if (!C) return { error: xf };
  let L, B;
  if (a) {
    let X = Vm({ structureId: A == null ? void 0 : A.structureId, ignoreLastRoundNumber: o, participantIdPairings: F, newRound: !0, drawDefinition: p, roundNumber: f, matchUpIds: h, idPrefix: U, isMock: v, event: T });
    if (X.error) return X;
    L = X.roundNumber, B = X.matchUps;
  }
  let { maxDelta: G, maxDiff: q } = k;
  return { roundNumber: L, participantIdPairings: F, modifiedScaleValues: w, candidatesCount: C, deltaCandidate: x, ...j, iterations: V, matchUps: B, maxDelta: G, maxDiff: q };
}
function LG({ encounters: e, tournamentParticipants: t, encounterValue: r, sameTeamValue: i }) {
  let n = {};
  for (let o of e) n[o] || (n[o] = 0), n[o] += r;
  let a = t == null ? void 0 : t.filter(({ participantType: o }) => o === lt);
  if (a) for (let o of a) {
    let s = o.individualParticipantIds ?? [], { uniquePairings: c } = o0({ participantIds: s });
    for (let u of c) n[u] || (n[u] = 0), n[u] += i;
  }
  return { valueObjects: n };
}
function s0(e) {
  var R, b, E, O;
  let { drawType: t = xn, attachConsolation: r = !0, applyPositioning: i = !0, tournamentRecord: n, staggeredEntry: a, automated: o, placeByes: s, isMock: c, event: u } = e, d = e == null ? void 0 : e.drawDefinition;
  if (!d) return { error: Ue };
  let l = yr, p = Fs({ stageSequence: 1, drawDefinition: d, stage: l }), f = [hn, md, sa].includes(t) ? p.length : Lc(p.length);
  if (!a && t === Hc && p.length < 2 || t === hn && p.length < 3) return { error: Nf };
  let { tieFormat: m, matchUpType: h } = e;
  if (m) {
    let M = oi({ tieFormat: m });
    if (M.error) return M;
  }
  m = Er(m ?? ((R = Yr({ drawDefinition: d })) == null ? void 0 : R.tieFormat)), h = h ?? d.matchUpType;
  let { structures: g } = In({ stageSequence: 1, drawDefinition: d, stage: l });
  if (g.length > 1) return { error: iw };
  if ((E = (b = g == null ? void 0 : g[0]) == null ? void 0 : b.matchUps) != null && E.length) return { error: VI };
  let I = (O = g == null ? void 0 : g[0]) == null ? void 0 : O.structureId;
  Object.assign(e, ye({ structureName: e.structureName ?? Fr(yr), structureId: I, matchUpType: h, tieFormat: m, drawSize: f, stage: l }));
  let U = e0(e);
  if (U.error) return U;
  let v = U.generators[t];
  if (!v) return { error: gI };
  let S = v == null ? void 0 : v();
  if (S.error) return S;
  let { structures: T, links: A } = S, y = T.map((M) => ut({ structure: M }).matchUps).flat();
  m && y.forEach((M) => {
    let { tieMatchUps: N } = Xd({ matchUp: M, tieFormat: m, isMock: c });
    Object.assign(M, { tieMatchUps: N, matchUpType: h });
  }), (!i || !r) && (d = ge(d, !1, !0)), d.links || (d.links = []), A.length && d.links.push(...A);
  let D = T.map(({ structureId: M }) => M);
  d.structures || (d.structures = []);
  let P = d.structures.map(({ structureId: M }) => M);
  d.structures = d.structures.map((M) => D.includes(M.structureId) ? T.find(({ structureId: N }) => N === M.structureId) : M);
  let w = T.filter(({ structureId: M }) => !P.includes(M));
  return w.length && d.structures.push(...w), o && Yd({ seedingProfile: e.seedingProfile, applyPositioning: i, tournamentRecord: n, drawDefinition: d, structureId: I, placeByes: s, drawSize: f, event: u }), r && vt({ drawDefinition: d }), { links: A, structures: T, ...j };
}
var KU = {};
qe(KU, { addGame: () => h0, addPoint: () => m0, addSet: () => I0, addShot: () => g0, analyzeScore: () => eS, analyzeSet: () => Ju, calculateHistoryScore: () => l0, checkScoreHasValue: () => pr, checkSetIsComplete: () => _m, clearHistory: () => f0, generate: () => c0, generateScoreString: () => ra, generateTieMatchUpScore: () => Jd, getSetComplement: () => rS, getTiebreakComplement: () => Ym, helpers: () => y0, isValidMatchUpFormat: () => Ri, keyValueScore: () => z0, mutate: () => d0, parseMatchUpFormat: () => ti, parseScoreString: () => Rp, query: () => J0, redo: () => v0, reverseScore: () => u0, setServingSide: () => p0, stringifyMatchUpFormat: () => Yf, tidyScore: () => Q0, umo: () => S0, undo: () => U0, validateScore: () => tS, validateTieFormat: () => oi });
var c0 = {};
qe(c0, { generateScoreString: () => ra, generateTieMatchUpScore: () => Jd, reverseScore: () => u0 });
function ra(e) {
  let { winnerFirst: t = !0, setTBlast: r = !0, addOutcomeString: i, reversed: n = !1, matchUpStatus: a, matchUpFormat: o, autoComplete: s, winningSide: c, sets: u } = e;
  if (!u) return { error: we, info: "missing sets" };
  let d = o && ti(o), { bestOf: l, finalSetFormat: p, setFormat: f } = d ?? {}, m = n || !(!t || !c || c === 1), h = i ? xG({ matchUpStatus: a }) : "", g = (u == null ? void 0 : u.sort(BG).map(I).filter(Boolean).join(" ")) || "";
  if (!h) return g;
  if (c === 2) return `${h} ${g}`;
  return `${g} ${h}`;
  function I(U) {
    let v = l && U.setNumber === l && p ? p : f, S = (B) => jt(B == null ? void 0 : B.side1Score) || jt(B == null ? void 0 : B.side2Score), T = ((B) => jt(B == null ? void 0 : B.side1TiebreakScore) || jt(B == null ? void 0 : B.side2TiebreakScore))(U), A = (v == null ? void 0 : v.tiebreakSet) || !S(U) && T, { side1Score: y, side2Score: D, side1TiebreakScore: P, side2TiebreakScore: w } = U, R = P || (jt(P) || T && s ? 0 : ""), b = w || (jt(w) || T && s ? 0 : "");
    if (A) return `[${(m ? [b, R] : [R, b]).join("-")}]`;
    let E = T ? Math.min(R, b) : "", O = E === R ? 1 : 2, M = jt(E) ? `(${E})` : "", N = y || (jt(y) || s ? 0 : ""), C = D || (jt(D) || s ? 0 : ""), F = (B) => !r && O === B ? M : "", x = `${N}${F(1)}`, V = `${C}${F(2)}`, k = r && T ? `(${E})` : "", L = m ? `${[V, x].join("-")}${k}` : `${[x, V].join("-")}${k}`;
    return ["-", " "].includes(L) && (L = ""), L;
  }
}
function xG({ matchUpStatus: e }) {
  let t = { [Wr]: "RET", [ct]: "WO", [sr]: "DF/DF", [$t]: "WO/WO", [so]: "SUS", [Bi]: "ABN", [Je]: "DEF", [Xc]: "DR" };
  return e && t[e] || "";
}
function BG(e, t) {
  return e.setNumber - t.setNumber;
}
function u0(e) {
  if (!(e != null && e.score)) return { error: we };
  let { sets: t } = e.score, r = t.map((o) => {
    let { side1TiebreakScore: s, side2TiebreakScore: c, winningSide: u, side1Score: d, side2Score: l, setNumber: p } = o;
    return ye({ winningSide: u ? 3 - u : void 0, side1TiebreakScore: c, side2TiebreakScore: s, side1Score: l, side2Score: d, setNumber: p });
  }), i = e == null ? void 0 : e.setTBlast, n = ra({ setTBlast: i, sets: r }), a = ra({ sets: r, reversed: !0, setTBlast: i });
  return { reversedScore: { sets: r, scoreStringSide1: n, scoreStringSide2: a }, ...j };
}
var d0 = {};
qe(d0, { addGame: () => h0, addPoint: () => m0, addSet: () => I0, addShot: () => g0, calculateHistoryScore: () => l0, clearHistory: () => f0, redo: () => v0, setServingSide: () => p0, umo: () => S0, undo: () => U0 });
function Xo({ matchUp: e }) {
  let { extension: t } = We({ name: sm, element: e });
  if (!t) return { error: Tr };
  let { history: r = [], undoHistory: i = [] } = t.value;
  return { history: r, undoHistory: i, ...j };
}
function l0(e) {
  var w, R;
  if (!e) return { error: we };
  let { matchUp: t, updateScore: r } = e;
  if (!t) return { error: hi };
  let i = ((w = Xo({ matchUp: t })) == null ? void 0 : w.history) || [];
  if (!Array.isArray(i)) return { error: ie, info: "history is not an array" };
  let { matchUpFormat: n } = t;
  if (!n) return { error: TI };
  if (!Ri({ matchUpFormat: n })) return { error: AI };
  let a = ti(n), { bestOf: o, finalSetFormat: s, setFormat: c } = a, u = ["0", "15", "30", "40", "A", "G"], d = { sets: [] }, l = [], p, f = [0, 0], m = 1, h = 0, g, I = 0, U = (b) => [1, 2].includes(b), v = () => (h += 1, { winningSide: void 0, side1Score: 0, side2Score: 0, setNumber: h, games: [] }), S = () => ({ winningSide: void 0, points: [] }), T = () => ({ winningSide: void 0, side1Score: "", side2Score: "", shots: [] }), A = T(), y = S(), D = v(), P = 0;
  for (let b of i) {
    P += 1, g = d.sets.length + 1 === o;
    let E = g && s ? s : c, { tiebreakAt: O, setTo: M, NoAD: N, tiebbreakFormat: C } = E, F = D.side1Score === O && D.side1Score === D.side2Score, x = !!E.tiebreakSet, V = x ? E.tiebreakSet : C, { tiebreakTo: k, NoAD: L } = V || {}, B = () => {
      p = void 0, f = [0, 0], m = 3 - m, D.side1TiebreakScore = "", D.side2TiebreakScore = "", D.side1PointScore = "", D.side2PointScore = "", I = 0;
    }, G = (H) => {
      D.winningSide = H;
      let { s: X, ...z } = D;
      d.sets.push(z), A = T(), y = S(), D = v(), B();
    }, q = (H) => {
      y.winningSide = H;
      let { g: X, ...z } = y;
      D.games.push(z), A = T(), y = S(), B();
      let Z = `side${H}Score`;
      D[Z] += 1;
    }, Y = (H) => {
      A.winningSide = H;
      let { p: X, ...z } = A;
      y.points.push(z), A = T(), I = 0;
      let Z = () => f.reduce((ne, ee) => ne + ee) % 4 / 4 > 0.5 ? m : 3 - m, te = H - 1;
      if (F || x) {
        f[te] += 1, p = Z(), D[`side${H}TiebreakScore`] = f[te], D[`side${3 - H}TiebreakScore`] = f[1 - te];
        let ne = L ? 1 : 2;
        if (f[te] >= k && f[te] >= f[1 - te] + ne) return q(H), { gameCompleted: !0 };
      } else if (f[1 - te] === 4 && f[te] === 3 ? f[1 - te] -= 1 : f[te] += 1, D.side1PointScore = u[f[0]], D.side2PointScore = u[f[1]], f[te] === 5 || f[te] === 4 && f[1 - te] < 3 || N && f[te] === 4) return q(H), { gameCompleted: !0 };
    };
    if (U(b.srv) && (m = b.srv), ["p", "s", "g", "o"].includes(b.u) && l.push(b.u), b.shotOutcome && (A.shots.push(b), b.shotType === "SERVE" && ["OUT", "NET"].includes(b.shotOutcome) && (I += 1), I === 2)) {
      let H = 3 - m;
      Y(H);
    }
    if (U(b.p) || ke(b.pointNumber)) {
      let H = b.winningSide || b.p;
      if ((R = Y(H)) != null && R.gameCompleted) continue;
    }
    if (U(b.g) || ke(b.gameNumber)) {
      let H = b.winningSide || b.g;
      y.winningSide = H;
      let X = `side${H}Score`, z = `side${3 - H}Score`;
      if (l.length && (l.includes("p"), l = []), q(H), D[X] === M && D[X] - D[z] >= (N ? 1 : 2) && (G(H), g)) break;
    }
    if (U(b.s) || ke(b.setNumber)) {
      let H = b.winningSide || b.s;
      if (G(H), l.length && (l.includes("p"), l.includes("g"), l = []), g) break;
    }
  }
  return P !== i.length && console.log({ error: "Match completed with excess history" }), (D.side1Score || D.side2Score || D.games.length || D.side1TiebreakScore || D.side2TiebreakScore) && d.sets.push(D), d.scoreStringSide1 = ra({ ...d, matchUpFormat: n }), d.scoreStringSide2 = ra({ ...d, matchUpFormat: n, reversed: !0 }), m = p || m, r && (t.score = d), { ...j, servingSide: m, score: d };
}
function Zo({ undoHistory: e, history: t, matchUp: r }) {
  return it({ element: r, extension: { value: { history: t, undoHistory: e }, name: sm } });
}
function p0({ matchUp: e, sideNumber: t }) {
  if (![1, 2].includes(t)) return { error: RI };
  let { history: r = [] } = Xo({ matchUp: e });
  return r.push({ srv: t }), Zo({ matchUp: e, history: r });
}
function f0({ matchUp: e }) {
  return Zo({ matchUp: e });
}
function m0({ matchUp: e, point: t }) {
  if (!t || !e) return { error: we };
  if (typeof t != "object") return { error: ie, context: { point: t } };
  let { history: r = [] } = Xo({ matchUp: e });
  return r.push(t), Zo({ matchUp: e, history: r });
}
function h0({ matchUp: e, game: t }) {
  if (typeof t != "object") return { error: ie, context: { game: t } };
  let { history: r = [] } = Xo({ matchUp: e });
  return r.push(t), Zo({ matchUp: e, history: r });
}
function g0({ matchUp: e, shot: t }) {
  if (typeof t != "object") return { error: we };
  let { history: r = [] } = Xo({ matchUp: e });
  return r.push(t), Zo({ matchUp: e, history: r });
}
function I0({ matchUp: e, set: t }) {
  if (typeof t != "object") return { error: we };
  let { history: r = [] } = Xo({ matchUp: e });
  return r.push(t), Zo({ matchUp: e, history: r });
}
function v0({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = Xo({ matchUp: e });
  return r.length && t.push(r.pop()), Zo({ matchUp: e, history: t, undoHistory: r });
}
function U0({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = Xo({ matchUp: e });
  return r.push(t.pop()), Zo({ matchUp: e, history: t, undoHistory: r });
}
var S0 = {}, y0 = {};
qe(y0, { keyValueScore: () => z0, parseMatchUpFormat: () => ti, stringifyMatchUpFormat: () => Yf, tidyScore: () => Q0 });
var ss = " ", Zg = "DEF", VG = "COMPLETED", A0 = "WO", GG = "WO/WO", T0 = "ABN", D0 = "SUS", P0 = "RET", w0 = "INT", R0 = [P0, Zg, A0, GG, T0, D0, w0], Qg = "DEFAULTED", b0 = "WALKOVER", N0 = "ABANDONED", M0 = "SUSPENDED", E0 = "RETIRED", O0 = "INTERRUPTED", jG = [E0, Qg, b0], _G = "Enter Score", As = "()", ko = "[]", XU = ["up", "left", "shift+tab"], ZU = ["enter", "down", "tab", "right"], Dp = "backspace", C0 = "r", F0 = "s", k0 = "a", L0 = "d", x0 = "w", B0 = "i", Gm = [C0, L0, x0, k0, F0, B0], jm = "space", Zh = ["[", "("], Pp = [...XU, ...ZU, jm, "]"], V0 = "-", WG = "/", cs = V0, ia = V0, G0 = [WG], qG = 0, HG = ["=", "+", "num_1", "num_2", "shift+=", "shift+-"], QU = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].concat(Gm), j0 = QU.map((e) => `shift+${e}`), _0 = [cs, Dp].concat(Pp, G0), W0 = [QU, j0, _0].join(","), YG = [W0, XU, ZU, HG].join(","), zG = { OUTCOMEKEYS: Gm, SIDE1KEYS: QU, SIDE2KEYS: j0, MODIFIERS: _0, PROMPT: _G, MOVEUP: XU, MOVEDOWN: ZU, HOTKEYS: YG };
function $s({ scoreString: e, lowSide: t, outcome: r }) {
  if ({ scoreString: e } = q0({ scoreString: e }), t === 2) {
    let i = (e && e[e.length - 1]) !== ss ? ss : "";
    return e + i + r;
  } else return r + ss + e;
}
function q0({ scoreString: e }) {
  if (!e) return { scoreString: "" };
  let t = !1;
  for (let r of R0) {
    let i = e == null ? void 0 : e.indexOf(r);
    i === 0 ? e = e.slice(r.length + 1).trim() + ss : i > 0 && (e = e.slice(0, i)), i >= 0 && (t = !0);
  }
  return e != null && e.trim() || (e = ""), { scoreString: e, removed: t };
}
function Jg({ analysis: e, scoreString: t, sets: r, lowSide: i }) {
  var h, g, I;
  let n, a;
  if (!t) return { scoreString: t, sets: r };
  let { scoreString: o, removed: s } = q0({ scoreString: t });
  if (t = o, s) return { scoreString: t, sets: r, outcomeRemoved: !0 };
  let c = r[r.length - 1] || {}, u = Object.values(c).filter((U) => U !== void 0).length;
  c.setNumber && u === 1 && (r = r.slice(0, r.length - 1), c = r[r.length - 1] || {});
  let { tiebreakSet: d } = e.setFormat, { tiebreakTo: l, NoAD: p } = d || {}, { isTiebreakEntry: f } = dc({ brackets: ko, scoreString: t }), m = XG(t);
  if (m >= 0) {
    n = t.slice(0, m);
    let { isTiebreakEntry: U } = dc({ brackets: As, scoreString: n }), { lastOpenBracketIndex: v, isTiebreakEntry: S } = dc({ brackets: ko, scoreString: n }), T = n && n[n.length - 1].trim(), A = n && !isNaN(T), y = e.isIncompleteSetScore;
    if (f && S) {
      let D = n.slice(v + 1).split(ia), P = (D == null ? void 0 : D.length) > 0 && D[0] !== void 0 && !isNaN(parseInt(D[0])) && parseInt(D[0]) || void 0, w = (D == null ? void 0 : D.length) > 1 && D[1] !== void 0 && parseInt(D[1]) || void 0, R = [P, w];
      if (w) {
        let b = i === 1 ? 1 : 0;
        R[b] = ((R == null ? void 0 : R[1 - b]) || 0) + (p ? 1 : 2), (R[b] || 0) < l && (R[b] = l), n = t.slice(0, v + 1), n += R.join(ia);
      } else P !== void 0 ? (n = t.slice(0, v + 1), n += P) : (n = t.slice(0, v), y = !0);
      c.side1TiebreakScore = R[0] || 0, c.side2TiebreakScore = R[1] || 0;
    }
    if (n.length || (n = void 0), y) {
      let D = (h = c.side1Score) == null ? void 0 : h.toString();
      if (D) {
        let P = D == null ? void 0 : D.slice(0, D.length - 1);
        c.side1Score = !isNaN(P) && parseInt(P) || void 0, c.side1Score === void 0 && (c.side2Score = void 0);
      }
      e.isTimedSet ? (a = c.side1Score ? r : (r == null ? void 0 : r.slice(0, r.length - 1)) || [], a[r.length - 1] = c) : a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [];
    } else if (A) {
      let D = (g = c.side2Score) == null ? void 0 : g.toString(), P = (I = c.side1Score) == null ? void 0 : I.toString();
      if (!e.isTiebreakEntry && !e.isMatchTiebreak) if (c.side2Score) {
        let w = D == null ? void 0 : D.slice(0, D.length - 1);
        c.side2Score = !isNaN(w) && parseInt(w) || void 0;
      } else {
        let w = P == null ? void 0 : P.slice(0, P.length - 1);
        c.side1Score = !isNaN(w) && parseInt(w) || void 0;
      }
      e.isTimedSet ? c.side1Score ? (a = r || [], a[r.length - 1] = c) : a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [] : (a = r || [], a[r.length - 1] = c), a[a.length - 1] && Object.assign(a[a.length - 1], { winningSide: void 0 });
    } else U ? (a = r || [], Object.assign(a[a.length - 1] || {}, { winningSide: void 0, side1TiebreakScore: void 0, side2TiebreakScore: void 0 })) : (f && !S ? a = (r == null ? void 0 : r.slice(0, r.length - 1)) || [] : (a = r, a[r.length - 1] = c), f || (a[a.length - 1].side2Score = 0, a[a.length - 1].winningSide = void 0));
    return { scoreString: n, sets: a };
  }
  return { scoreString: t, sets: r };
}
function dc({ brackets: e = As, scoreString: t }) {
  if (!t) return {};
  let [r, i] = e.split(""), n = t.split(""), a = Math.max(...Ln(r, n)), o = Math.max(...Ln(i, n));
  return { isTiebreakEntry: a > o, lastOpenBracketIndex: a };
}
function KG({ scoreString: e }) {
  if (!e) return !1;
  let t = e && e[e.length - 1].trim(), r = e && !isNaN(t), [i, n] = ko.split(""), a = e.split(""), o = Math.max(...Ln(i, a)), s = Math.max(...Ln(n, a)), c = Math.max(...Ln(ia, a));
  return r && o > s && c > o;
}
function XG(e) {
  return e.split("").reduce((t, r, i) => (r.match(/\d+/g) && t.push(i), t), []).pop();
}
function H0(e) {
  let { lowValue: t = 0, NoAD: r = !1, tiebreakTo: i } = e || {}, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : parseInt(i);
}
function OT({ matchUpFormat: e, matchUpStatus: t, winningSide: r, sets: i }) {
  var c;
  let n = ti(e), { bestOf: a } = n, o = Math.ceil(a / 2), s = ((c = i == null ? void 0 : i.reduce((u, d) => {
    let { winningSide: l } = d;
    return l && u[l - 1]++, u;
  }, [0, 0])) == null ? void 0 : c.indexOf(o)) + 1 || void 0;
  return jG.includes(t) && r && (s = r), { matchUpWinningSide: s };
}
function _m({ ignoreTiebreak: e = !1, matchUpScoringFormat: t, matchUpFormat: r, isTiebreakSet: i, isDecidingSet: n, isTimedSet: a, set: o }) {
  var S;
  if (!o) return { error: we, info: "missing set" };
  t = t || r && ti(r);
  let s = n && t.finalSetFormat || (t == null ? void 0 : t.setFormat) || {}, { side1Score: c, side2Score: u } = o, { setTo: d, tiebreakAt: l } = s, p = c || u, f = Wm({ set: o }), m = Math.abs(c - u), h = c >= d || u >= d, g = i || c >= d && u >= d || l && l < d && (c === l || u === l), I = e || g && (f === 1 && o.side1TiebreakScore > o.side2TiebreakScore || f === 2 && o.side2TiebreakScore > o.side1TiebreakScore), U = !g && s.NoAD || g || i && ((S = s.tiebreakFormat) != null && S.NoAD) ? 1 : 2, v = m >= U;
  return !!((a && p || h && (v || g) || i) && (!g || I));
}
function Wm({ set: e }) {
  if (e.side1Score || e.side2Score) {
    if (e.side1Score > e.side2Score) return 1;
    if (e.side2Score > e.side1Score) return 2;
  } else if (e.side1TiebreakScore || e.side2TiebreakScore) {
    if (e.side1TiebreakScore > e.side2TiebreakScore) return 1;
    if (e.side2TiebreakScore > e.side1TiebreakScore) return 2;
  }
}
function JU({ analysis: e, set: t }) {
  let r = Wm({ set: t }), { isDecidingSet: i, isTiebreakSet: n, matchUpScoringFormat: a } = e;
  return _m({ matchUpScoringFormat: a, isDecidingSet: i, isTiebreakSet: n, set: t }) && r;
}
function ZG({ analysis: e, scoreString: t, sets: r, value: i }) {
  let n;
  if (!(r != null && r.length)) return { sets: [] };
  let a = r[r.length - 1];
  i = be(i);
  let { validSide2Score: o, requiresTiebreak: s } = QG({ analysis: e, set: a, value: i });
  if (o) {
    n = !0, t = (t || "") + i, a.side2Score = i;
    let c = JU({ analysis: e, set: r[r.length - 1] });
    if (a.winningSide = c || void 0, s) {
      let u = As.split("")[0];
      t += u;
    } else e.isDecidingSet || (t += ss);
  }
  return { sets: r, scoreString: t, updated: n };
}
function QG({ analysis: e, set: t = {}, value: r }) {
  let i = e.isDecidingSet && e.matchUpScoringFormat.finalSetFormat || e.matchUpScoringFormat.setFormat, { tiebreakAt: n, setTo: a, NoAD: o } = i, { side1Score: s } = t, c, u;
  return n && n < a ? s === n ? c = r <= a : c = r <= n : s === a ? o ? c = r < a : c = r <= a + 1 : s === a - 1 ? o ? c = r <= a : c = r <= a + 1 : s === a + 1 ? c = r === a || r === a - 1 : c = r <= a, c && (n && n < a ? u = s === a && r === n || s === n && r === a : u = s >= a && r >= a && s !== r), { validSide2Score: c, requiresTiebreak: u };
}
function Y0({ lowSide: e, value: t, sets: r, scoreString: i, winningSide: n, matchUpStatus: a }) {
  let o;
  return t === C0 ? i ? (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: P0 }), n = e === 2 ? 1 : 2, a = E0) : (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: Zg }), n = e === 2 ? 1 : 2, a = Qg) : t === L0 ? (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: Zg }), n = e === 2 ? 1 : 2, a = Qg) : t === x0 ? (o = !0, r = [], i = A0, n = e === 2 ? 1 : 2, a = b0) : t === F0 && i ? (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: D0 }), a = M0, n = void 0) : t === k0 ? (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: T0 }), a = N0, n = void 0) : t === B0 && i && (o = !0, i = $s({ scoreString: i, lowSide: e, outcome: w0 }), a = O0, n = void 0), { updated: o, sets: r, scoreString: i, matchUpStatus: a, winningSide: n };
}
function JG(e) {
  let { sets: t, info: r, scoreString: i, winningSide: n, matchUpStatus: a } = e, { analysis: o, lowSide: s, value: c } = e, u, d;
  !(t != null && t.length) && c !== Dp && (t = [{ setNumber: 1 }]);
  let l = t.length - 1;
  if (Gm.includes(c)) {
    let p = t[t.length - 1] || {}, { side1Score: f, side2Score: m } = p;
    f && !m ? r = "missing side2Score" : o.finalSetIsComplete || n ? r = "final set is already complete" : o.isIncompleteSetScore ? r = "incomplete set scoreString" : o.isIncompleteSetScore || ({ sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: u } = Y0({ lowSide: s, value: c, sets: t, scoreString: i, matchUpStatus: a, winningSide: n }));
  } else if (c === Dp) {
    if ({ scoreString: i, sets: t, outcomeRemoved: d } = Jg({ analysis: o, scoreString: i, sets: t }), (i == null ? void 0 : i.trim()) === "" && (i = i.trim()), i || (t = []), d) {
      let p = t[t.length - 1] || {}, { side1Score: f, side2Score: m } = p;
      if (f && m) {
        let h = f > m && 1 || m > f && 2 || void 0;
        h && (p.winningSide = h, t.push({ setNumber: t.length + 1 }));
      }
    }
    a = void 0, n = void 0, u = !0;
  } else if (o.hasOutcome) r = "has outcome";
  else {
    if (n) return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: !1, info: "matchUp is complete" };
    if (c === jm) {
      let p = t[t.length - 1] || {}, { side1Score: f, side2Score: m } = p, h = f > m && 1 || m > f && 2 || void 0;
      h && !n && !o.isIncompleteSetScore && (t[t.length - 1].winningSide = h, t.push({ setNumber: t.length + 1 }), i += " ", u = !0);
    } else if (c === cs && t[l].side1Score !== void 0 && t[l].side2Score === void 0 && i && o.isNumericEnding) i += "-", t[l].side2Score = 0, a = void 0, n = void 0, u = !0;
    else if (!isNaN(c)) {
      let p;
      if (t[l].side2Score === void 0) {
        let f = be((t[l].side1Score || 0).toString() + c).toString().slice(0, 2);
        t[l].side1Score = be(f), p = t[l].side1Score.toString(), u = !0;
      } else {
        let f = be((t[l].side2Score || 0).toString() + c).toString().slice(0, 2);
        t[l].side2Score = be(f), p = [t[l].side1Score, t[l].side2Score].join("-"), u = !0;
      }
      if (u) {
        let f = (t.slice(0, l) || []).filter((m) => m).map((m) => {
          let { side1Score: h, side2Score: g } = m;
          return [h, g].join("-");
        }).join(" ");
        f ? i = f + " " + p : i = p;
      }
    }
  }
  return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, info: r, updated: u };
}
function $G({ analysis: e, auto: t, lowSide: r, scoreString: i = "", sets: n, value: a }) {
  var l;
  let o, s, { tiebreakSet: { tiebreakTo: c, NoAD: u } } = e.setFormat, [d] = ko.split("");
  if (e.isMatchTiebreakEntry || (i += d), n[e.setNumber - 1]) {
    let { lastOpenBracketIndex: p } = dc({ brackets: ko, scoreString: i }), f = (i.slice((p ?? 0) + 1) + (t ? "" : a)).split(ia);
    if ((((l = f[r - 1]) == null ? void 0 : l.length) || 0) >= 2) s = "tiebreak digit limit";
    else if (t) {
      r === 1 && (f[0] = (f[0] || "") + a), r === 2 && (f[1] = (f[1] || "") + a);
      let m = [f[0] || 0, f[1] || 0].map((I) => be(I)), h = r === 1 ? 1 : 0;
      m[h] = m[1 - h] + (u ? 1 : 2), m[h] < c && (m[h] = c);
      let g = n[n.length - 1];
      g.side1TiebreakScore = m[0], g.side2TiebreakScore = m[1], i = i.slice(0, (p ?? 0) + 1), i += m.join(ia), o = !0;
    } else {
      let m = [f[0] || 0, f[1] || 0].map((g) => be(g)), h = n[n.length - 1];
      h.side1TiebreakScore = m[0], h.side2TiebreakScore = m[1], i += a, o = !0;
    }
  } else {
    let p = H0({ lowValue: be(a || 0), tiebreakTo: c, NoAD: u }), f = [be(a), p];
    r === 2 && f.reverse();
    let m = { side1TiebreakScore: f[0], side2TiebreakScore: f[1], setNumber: (n == null ? void 0 : n.length) + 1 || 1 };
    n.push(m), i += f.join(ia), o = !0;
  }
  return { info: s, scoreString: i, sets: n, updated: o };
}
function e2({ analysis: e, lowSide: t, scoreString: r, value: i }) {
  let { setTo: n, tiebreakAt: a, NoAD: o } = (e == null ? void 0 : e.setFormat) || {}, s = i === parseInt(a || n);
  if (a && a < n && i > a) return { scoreString: r };
  if (o && i === n || i > n) return { scoreString: r };
  let c = m(), u = [i, c];
  t === 2 && u.reverse();
  let d = As.split("")[0], l = u.join(cs) + (s ? d : ss);
  r = (r || "") + l;
  let p = { side1Score: u[0], side2Score: u[1] }, f = JU({ analysis: e, set: p });
  return p.winningSide = f || void 0, { scoreString: r, set: p };
  function m() {
    return s ? i + 1 : i + 1 === n ? i + (o ? 1 : 2) : n;
  }
}
function t2({ matchUpFormat: e, scoreString: t, winningSide: r, value: i, sets: n }) {
  var x, V, k;
  let a = (((x = n == null ? void 0 : n.filter((L) => L == null ? void 0 : L.winningSide)) == null ? void 0 : x.length) || 0) + (r ? 0 : 1), o = ti(e), s = a === (o == null ? void 0 : o.bestOf), c = s && (o == null ? void 0 : o.finalSetFormat) || (o == null ? void 0 : o.setFormat) || {}, u = c == null ? void 0 : c.timed, d = s && n[(o == null ? void 0 : o.bestOf) - 1], l = d == null ? void 0 : d.winningSide, { isTiebreakEntry: p } = dc({ brackets: As, scoreString: t }), { isTiebreakEntry: f } = dc({ brackets: ko, scoreString: t }), m = p || f, h = !!c.tiebreakSet, g = (V = t == null ? void 0 : t[t.length - 1]) == null ? void 0 : V.trim(), I = t && !isNaN(g), U = !m && g === cs, v = p && Zh.includes(g), S = f && Zh.includes(g), T = f && g === ia, A = t == null ? void 0 : t.split(""), [y] = ko.split(""), D = A && Math.max(...Ln(y, A)), P = A && Math.max(...Ln(ia, A)), w = A && P > D, R = (k = n[n.length - 1]) == null ? void 0 : k.winningSide, b = (n == null ? void 0 : n.length) && !R, E = R0.find((L) => (t == null ? void 0 : t.indexOf(L)) >= 0), O = !isNaN(i), M = i === jm, N = Pp.includes(i), C = t == null ? void 0 : t.split("").find((L) => Zh.includes(L)), F = N && f && !S && (T || !KG({ scoreString: t }));
  return { isTiebreakSetValue: h && O, matchUpScoringFormat: o, setNumber: a, setFormat: c, matchTiebreakHasJoiner: w, isGameScoreEntry: b, isSpace: M, isCloser: N, isTiebreakCloser: N && C && m && I, isDecidingSet: s, isTiebreakSet: h, isTimedSet: u, isNumericEnding: I, isNumericValue: O, hasOpener: C, hasOutcome: E, finalSet: d, finalSetIsComplete: l, lastSetIsComplete: R, isInvalidSetTiebreakValue: M && m && v, isInvalidMatchTiebreakValue: F, isTiebreakEntry: m, isSetTiebreakEntry: p, isMatchTiebreakEntry: f, isIncompleteSetScore: U, isIncompleteSetTiebreak: v, isIncompleteMatchTiebreak: S, isPartialMatchTiebreakValue: T };
}
function z0(e) {
  let { lowSide: t = 1, value: r } = e, { scoreString: i, sets: n, winningSide: a, matchUpStatus: o } = e, { matchUpFormat: s, shiftFirst: c, auto: u = !0 } = e, d, l, p = c && t === 2 || !c && t === 1;
  if (!W0.includes(r)) return { updated: !1, info: "invalid key" };
  c && (t = 3 - t);
  let { matchUpWinningSide: f } = OT({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
  a = f;
  let m = t2({ value: r, winningSide: a, scoreString: i, sets: n, matchUpFormat: s });
  if (G0.includes(r) && (r = cs), m.hasOpener && m.isTiebreakEntry && !m.isTiebreakSet && p && be(r) === 0 && (m.isTiebreakCloser = !0), Pp.includes(r) && m.hasOpener && (r = ""), Pp.includes(r) && (r = jm), m.lastSetIsComplete) {
    let h = (i == null ? void 0 : i.length) && i[i.length - 1];
    i && h !== " " && (i += " ");
  }
  if (m.isTimedSet) ({ info: l, sets: n, scoreString: i, updated: d, matchUpStatus: o, winningSide: a } = JG({ analysis: m, lowSide: t, scoreString: i, sets: n, matchUpStatus: o, winningSide: a, value: r }));
  else if (Gm.includes(r)) m.finalSetIsComplete || a ? l = "final set is already complete" : !m.isTiebreakEntry && !m.isIncompleteSetScore ? { sets: n, scoreString: i, matchUpStatus: o, winningSide: a, updated: d } = Y0({ lowSide: t, sets: n, scoreString: i, matchUpStatus: o, winningSide: a, value: r }) : m.isTiebreakEntry || m.isIncompleteSetScore ? l = "incomplete set scoreString or tiebreak entry" : console.log("handle case", { value: r });
  else if (r === Dp) d = !0, { scoreString: i, sets: n } = Jg({ analysis: m, scoreString: i, sets: n, lowSide: t }), i || (n = []), o = void 0, a = void 0;
  else if (m.hasOutcome) l = "has outcome";
  else if (r === cs && !m.isMatchTiebreakEntry) (!m.isSetTiebreakEntry || m.isSetTiebreakEntry && !m.isNumericEnding) && (d = !0, { scoreString: i, sets: n } = Jg({ analysis: m, scoreString: i, sets: n, lowSide: t }), o = void 0);
  else if (r === ia && m.isMatchTiebreakEntry && !m.isSetTiebreakEntry) m.matchTiebreakHasJoiner ? l = "existing joiner" : m.isNumericEnding && (d = !0, i += ia);
  else if ([cs, ia].includes(r)) l = "invalid location for joiner";
  else {
    if (a) return { updated: !1, info: "matchUp is complete" };
    if (m.isIncompleteSetScore) m.isNumericValue && ({ sets: n, scoreString: i, updated: d } = ZG({ analysis: m, scoreString: i, sets: n, value: r }));
    else if (m.isInvalidMatchTiebreakValue) l = "invalid matchUp tiebreak character";
    else if (m.isInvalidSetTiebreakValue) l = "invalid set tiebreak character";
    else if (m.isTiebreakCloser) {
      let h = m.isSetTiebreakEntry ? As : ko, g = h.split("").reverse()[0], I = h.split("")[0], U = n[n.length - 1], { tiebreakFormat: v } = m.setFormat, { tiebreakTo: S, NoAD: T } = v || {}, A = Wm({ set: U });
      if (!m.isTiebreakSet) {
        let D = parseInt(i.split(I).reverse()[0]), P = H0({ lowValue: D, tiebreakTo: S, NoAD: T });
        A === 1 ? (U.side1TiebreakScore = P, U.side2TiebreakScore = D) : (U.side1TiebreakScore = D, U.side2TiebreakScore = P);
      }
      i = (i || "") + g, m.isDecidingSet || (i += ss);
      let y = JU({ analysis: m, set: U });
      U.winningSide = y || void 0, d = !0;
    } else if (m.isTiebreakSetValue) ({ info: l, scoreString: i, sets: n, updated: d } = $G({ analysis: m, auto: u, lowSide: t, scoreString: i, sets: n, value: r }));
    else if (m.isSetTiebreakEntry) {
      let [h] = As.split(""), g = Math.max(...Ln(h, i.split(""))), I = i.slice(g + 1), U = I && be(I) === qG, v = be(I ? I + r : r), { tiebreakFormat: S } = m.setFormat, { tiebreakTo: T, NoAD: A } = S || {};
      !U && I.length < 2 ? A && v > T - 1 ? l = "invalid low value for NoAD tiebreak" : (d = !0, i = (i || "") + r) : l = U ? "tiebreak begins with zero" : "tiebreak digit limit";
    } else if (m.isCloser) l = `invalid key: ${r}`;
    else if (m.isGameScoreEntry) l = "game scoreString entry";
    else if (m.lastSetIsComplete || !n.length) {
      d = !0;
      let { scoreString: h, set: g } = e2({ analysis: m, lowSide: t, scoreString: i, value: be(r) });
      g && (g.setNumber = (n == null ? void 0 : n.length) + 1 || 1), n = (n == null ? void 0 : n.concat(g).filter(Boolean)) || [g], i = h || void 0;
    } else console.log("error: unknown outcome");
  }
  if (d) {
    n = n == null ? void 0 : n.filter(Boolean);
    let { matchUpWinningSide: h } = OT({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
    return a = h, h && (!o || [Xt, Zi].includes(o)) ? (o = VG, n = n.filter((g) => {
      let { side1Score: I, side2Score: U, side1TiebreakScore: v, side2TiebreakScore: S } = g;
      return I || U || v || S;
    })) : i && !a && ![M0, N0, O0].includes(o) && (o = void 0), { updated: d, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: l };
  }
  return { updated: d, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: l };
}
var qm = "\\d+-\\d+", Qu = "\\d+-\\d+\\(\\d+\\)", $U = "\\[\\d+-\\d+\\]", r2 = "\\d+-\\d+\\(\\d+-\\d+\\)", i2 = new RegExp(`(${qm}),`, "g"), n2 = new RegExp(`(${Qu}),`, "g"), a2 = [qm, Qu, $U, r2], o2 = ["0", "1", "2", "00", "01", "10", "11", "002", "012", "102", "112", "000", "001", "010", "100", "011", "101", "110", "111", "002", "012", "102", "112", "0002", "0012", "0102", "1002", "0112", "1012", "1102", "1112", "3", "03", "13", "013", "103"], s2 = o2.map((e) => {
  let t = e.split("").map((r) => a2[r]).join(" ");
  return new RegExp(`^${t}$`);
});
function CT(e) {
  return !e || s2.some((t) => t.test(e));
}
function c2(e) {
  let t = "[];", r = "()", i = t + r, n = [t[0], r[0]], a = Object.assign({}, ...i.split("").map((c) => ({ [c]: 0 }))), o = "", s = e.split("").map((c) => {
    let u = i.includes(c) && c, d = n.includes(u);
    if (d && u) return a[u] += 1, o = u, c;
    if (!d && u && o && u !== o) {
      a[o] -= 1;
      let l = t.includes(o) && t || r.includes(o) && r || "", p = l.split("").find((f) => f !== o);
      if (l.includes(u)) a[o] || (o = "");
      else return a[u] || (o = ""), p;
    }
    return c;
  }).join("");
  return e !== s ? s : e;
}
function Xl(e) {
  return /^\(\d+\)$/.test(e) || /^\(\d+$/.test(e);
}
function u2(e) {
  return /^\(\d+-\d+\)$/.test(e) || /^\[\d+-\d+\]$/.test(e);
}
function Oc(e) {
  let t = ((r) => r == null ? void 0 : r.split("-").join("").split("/").join(""))(e);
  if (/^\d+$/.test(t) && t.length === 2) {
    let r = t.split("");
    return Math.abs(r.reduce((i, n) => +i - +n)) === 1;
  }
  return !1;
}
function wp(e, t) {
  let r = [e.slice(t, t + 2), t ? e.slice(0, 1) : e.slice(2)].map((n) => parseInt(n.join("")));
  t && r.reverse();
  let i = r;
  if (Math.abs(i.reduce((n, a) => +n - +a)) >= 2) return i.join("-");
}
function FT(e) {
  return e.length === 2 ? e.split("").join("-") : ([", ", ",", "/", " "].forEach((t) => e = e.split(t).join("-")), e = e.replace(/-{2,}/, "-"), e);
}
function d2(e) {
  return e.startsWith("(") && e.endsWith(")");
}
function l2({ score: e, applied: t }) {
  e = c2(e);
  let r = /\)(\d+)/g;
  if (r.test(e)) for (let A of e.match(r)) {
    let y = A.replace(")", ") ");
    e = e.replace(A, y);
  }
  e = e.replace(/\)\//g, ") / "), e = e.replace(/\/\)/g, ")");
  let i = /\(([\d- ]+)\)/g, n = /\(([\d- ]+)\)/, a = e.match(i);
  for (let A of a || []) {
    let [y] = A.match(n).slice(1), D = y.replace(/ /g, "");
    e = e.replace(A, `(${D})`);
  }
  let o = /\(\(\d-\d\)\)/g;
  if (o.test(e)) {
    let A = e.match(o);
    A.length && A.forEach((y) => {
      let D = y.match(/\((\(\d-\d\))\)/).slice(1)[0];
      e = e.replace(y, D);
    });
  }
  if (o = /\(\((\d)\)\)/g, o.test(e)) {
    let A = e.match(o);
    A.length && A.forEach((y) => {
      let D = y.match(/\((\(\d\))\)/).slice(1)[0];
      e = e.replace(y, D);
    });
  }
  /(^|\s)6-,/.test(e) && (e = e.replace(/(^|\s)6-,/g, "6-0,"));
  let s = new RegExp(/[-,]{2,}/g);
  e = e.replace(s, "-"), ["- ", " -"].forEach((A) => {
    let y = new RegExp(`(\\d+)${A}(\\d+)`, "g"), D = e.match(y);
    D && D.forEach((P) => e = e.replace(P, P.split(A).join("-")));
  }), /^[(-/,]+$/.test(e) && (e = ""), /\)[-/,]+$/.test(e) && (e = e.slice(0, e.length - 1)), /\d \/\d/.test(e) && (e = e.replace(/ \//g, "/")), e.includes(" /") && (e = e.replace(/ \//g, " "));
  let c = /\(\d+, \)/g;
  c.test(e) && e.match(c).forEach((A) => {
    let [y] = A.match(/\((\d+), \)/).slice(1);
    y.length === 2 ? e = e.replace(A, `(${y})`) : y.length === 1 && y === "6" && (e = e.replace(A, "(6-0)"));
  });
  let u = /\((\d+)\/\)/g;
  u.test(e) && e.match(u).forEach((A) => {
    let [y] = A.match(/\((\d+)\/\)/).slice(1);
    y.length === 2 ? e = e.replace(A, `(${y})`) : y.length === 1 && y === "6" ? e = e.replace(A, "(6-0)") : e = e.replace(A, `(${y})`);
  });
  let d = /\d\/\d\/,/g;
  d.test(e) && e.match(d).forEach((A) => {
    let [y] = A.match(/(\d\/\d)\/,/).slice(1);
    e = e.replace(A, `${y},`), t.push("slashComma");
  });
  let l = /\(\/(\d+)\)/g;
  l.test(e) && e.match(l).forEach((A) => {
    let [y] = A.match(/\(\/(\d+)\)/).slice(1);
    y.length === 2 ? e = e.replace(A, `(${y})`) : y.length === 1 && parseInt(y) < 6 ? e = e.replace(A, `(6-${y})`) : e = e.replace(A, `(${y})`);
  });
  let p, f, m, h, g, I = () => {
    g = wi(e.split("")), f = g["("] === (g[")"] || 0) + 1, p = (g["("] || 0) + 1 === g[")"], m = g["["] === g["]"] + 1, h = f && !m;
  };
  I();
  let U = /(\d+-\d+\(\d+)0,/;
  if (U.test(e)) {
    let [A] = e.match(U).slice(1);
    e = e.replace(U, A + ")");
  }
  if (g["("] === g[")"] && g["("] > 1) {
    let A = e.split(")(").join(") (").split(" ");
    A.every(d2) ? e = A.map((y) => {
      let D = y.slice(1, y.length - 1);
      return D.length > 2 ? D : y;
    }).join(" ") : e = A.join(" ");
  }
  I();
  let v = /[A-Za-z]+/.test(e), S = /\d+/.test(e);
  if (!v && !S) return { score: "" };
  if (/^\[.+\]$/.test(e) && "()/,- ".split("").some((A) => g[A]) && (e = e.slice(1, e.length - 1)), /^\(.+\)$/.test(e) && g["("] === 1 && g[")"] === 1 && "[]/,".split("").some((A) => g[A] > 1) && (e = e.slice(1, e.length - 1)), e.startsWith("(") && e.endsWith("))") && (e = e.slice(1, e.length - 1)), g["("] > (g[")"] || 0) && e[e.length - 1] === "(" && (e = e.slice(0, e.length - 1) + ")", I()), g["("] === 1 && !g[")"] && e[0] === "(" && (e = e + ")", I()), g["("] > (g[")"] || 0) && e.slice(0, 2) === "((" && (e = e.slice(1)), p) {
    if (/^9\d/.test(e)) e = "(" + e.slice(1);
    else if (e[0] !== "(") e = "(" + e;
    else {
      let A = [], y = 0;
      for (let D of e.split("").reverse()) D === ")" && (y ? A.push("(") : y += 1), D === "(" && (y -= 1), A.push(D);
      A.reverse(), e = A.join("");
    }
    I();
  }
  if (g[")"] > (g["("] || 0) && e[0] === ")" && (e = "(" + e.slice(1), I()), h && (e.endsWith(9) || /\d+0$/.test(e)) && (e = e.slice(0, e.length - 1) + ")", I()), h && (!e.endsWith(")") || e.startsWith("((")) && (e = e + ")", I()), h) {
    let A = "", y = 0;
    for (let D of e.split("")) D === "(" && (y ? A += ")" : y += 1), D === ")" && (y -= 1), A += D;
    e = A;
  }
  I(), m && !f && (e = e + "]"), e.includes("([") && e.includes("])") && (e = e.split("([").join("[").split("])").join("]"), I()), /\(\d+0$/.test(e) && (e = e.slice(0, e.length - 1) + ")"), I(), g[")"] === 1 && !g["("] && e.endsWith(")") && (e = e.slice(0, e.length - 1)), e.startsWith("(") && e.endsWith(")") && g["("] === 1 && g[")"] === 1 && (e = e.slice(1, e.length - 1), I());
  let T = (A) => {
    let y = A.indexOf("("), D = A.indexOf(")");
    return y >= 0 && D >= 0 && y < D;
  };
  if (/^\([\d ]+.*[\d ]+\)$/.test(e) && g["("] === g[")"]) {
    let A = e.slice(1, e.length - 1);
    T(A) && (e = A, I());
  }
  return { score: e, applied: t };
}
function Hm(e) {
  if (!/^[\d-]+(\(\d\))*$/.test(e)) return e;
  let t = Ln("-", e.split(""));
  if (!t.length) return e;
  let r = e.split("-"), i = !(r.length % 2), n = !!(t.length % 2);
  return i && n && t.length > r.length / 2 && t.filter((a, o) => o % 2).forEach((a) => {
    e = e.substring(0, a) + " " + e.substring(a + 1);
  }), e;
}
function p2({ score: e, applied: t }) {
  return e.includes("( ") && (t.push("removeParenSpacingAfterOpen"), e = e.split("( ").map((r) => r.trim()).join("(")), e.includes(" )") && (t.push("removeParenSpacingBeforeClose"), e = e.split(" )").map((r) => r.trim()).join(")")), [i2, n2].forEach((r) => {
    let i = e.match(r);
    i != null && i.length && (i.forEach((n) => {
      e = e.replace(n, n.slice(0, n.length - 1) + " ");
    }), t.push("setsEndComma"));
  }), e = e.split(" ").filter(Boolean).map(Hm).join(" "), { score: e, applied: t };
}
function f2({ score: e }) {
  if (typeof e != "string") return { score: e };
  let t = (p) => p == null ? void 0 : p.split("-").join("").split("/").join(""), r = (p) => p.split("[").join("(").split("]").join(")");
  e = e.split(", ").join(" ");
  let i = e.split(" ");
  e = i.map((p) => {
    let f = /^-(\d+)$/;
    if (f.test(p)) {
      let [m] = p.match(f).slice(1);
      if (m.length === 2) return m.split("").join("-");
    }
    return p;
  }).join(" "), i = e.split(" ");
  let n = i.filter(Xl), a = 0, o = "";
  for (let p of n) {
    let f = Ln(p, i).filter((I) => !a || I > a)[0], m = i.slice(a, f - 1), h = i[f - 1], g = t(h);
    if (/^\d+$/.test(g) && g.length === 2) {
      let I = g.split(""), U = Math.abs(I.reduce((v, S) => +v - +S));
      if (U === 1) {
        let v = [m.join(" "), [h, p].join("")].join(" ");
        o += v, a = f + 1;
      } else if (U === 0) {
        let v = Math.max(...I);
        if ([4, 5, 6, 7, 8, 9].includes(v)) {
          let S = [6, 4].includes(v) ? v + 1 : v - 1, T = [v, S].sort().reverse().join("-"), A = [m.join(" "), [T, p].join("")].join(" ");
          o += A, a = f + 1;
        }
      }
    }
  }
  if (n.length && o.length) {
    let p = i.slice(a).join(" ");
    return o = [o, p].join(" "), { score: o.trim() };
  }
  if (i.length === 2 && ["(", "["].some((p) => i[1].includes(p))) {
    let p = t(i[0]).split("");
    if (Math.abs(p.reduce((f, m) => +f - +m, 0)) === 1) return i[1] = r(i[1]), { score: i.join("") };
  }
  let s = i.map((p) => u2(p) && "bracket" || Oc(p) && "set");
  if (s.includes("set") && s.includes("bracket")) {
    let p, f = "";
    return i.forEach((m, h) => {
      s[h] === "bracket" && p === "set" ? (m = r(m), f += m) : f += ` ${m}`, p = s[h];
    }), { score: f.trim() };
  }
  i = e.split(" ");
  let c, u = i.map((p) => {
    let f = new RegExp(/^(\d+)-(\d+)$/);
    if (f.test(p)) {
      let [m, h] = p.match(f).slice(1), g = Math.abs([m, h].reduce((U, v) => +U - +v)), I = Math.max(m, h);
      if (g === 1) return c = "tiebreakSet", c;
      if (g >= 2 && I >= 7 && c === "tiebreakSet") return c = "tiebreak", c;
    }
  }), d = Ln("tiebreak", u);
  if (d.length) {
    let p = "";
    i.forEach((f, m) => {
      d.includes(m) ? p += `(${f}) ` : d.includes(m + 1) ? p += `${f}` : p += `${f} `;
    }), e = p.trim();
  }
  let l = /(\d+-\d+)\((\d+)-(\d+)\)$/;
  if (l.test(e)) {
    let [p, f, m] = e.match(l).slice(1), h = Math.max(f, m) >= 10;
    !Oc(p) && h && (e = e.replace(l, `${p} [${f}-${m}]`));
  }
  return u = [], e = e.split(" ").map((p) => {
    let f = /^\((.*)\)$/, m = f.test(p), h = new RegExp($U).test(p) && "super" || new RegExp(Qu).test(p) && "tiebreak" || new RegExp(qm).test(p) && "standard" || "unknown";
    return u.push(h), h === "standard" && m ? p.match(f)[1] : p;
  }).join(" "), { score: e };
}
function m2({ score: e, applied: t }) {
  for (let D of [".", ",", " ", "/"]) {
    let P = new RegExp(`^(\\d+)\\${D}(\\d+)$`);
    if (P.test(e)) {
      let w = e.match(P).slice(1).map((b) => parseInt(b)), R = Math.abs(w[0] - w[1]);
      R <= 10 && R >= 2 && (e = e.split(D).join("-"), t.push("variedJoinerPattern"));
    }
  }
  e.includes(";") && (e = e.split(";").join(" "), t.push("semicolon set separation"));
  let r = /(^|\s)(\d)\/(\d)(\d)\/(\d)(\(|$)/;
  if (r.test(e)) {
    let [D, P, w, R, b, E] = e.match(r).slice(1);
    e = e.replace(r, `${D}${P}-${w} ${R}-${b}${E}`), t.push("smashSlashPattern");
  }
  /.*\s6[/-]+$/.test(e) && (e += "0", t.push("incompleteFinalSetPattern"));
  let i = /\(6,\)/g;
  i.test(e) && (e = e.replace(i, "(6, 0)"), t.push("missingZeroPattern1"));
  let n = /^\d{3,}\(/, a = /\(\d+\)\d+/;
  [n, a].forEach(() => {
    e = e.split(" ").map((D) => (n.test(D) && (D = D.replace("(", " (")), a.test(D) && (D = D.replace(")", ") ")), D)).join(" "), t.push("spaceConsiderationPatterns");
  });
  let o = Hm(e);
  o !== e && (e = o, t.push("deDashMash"));
  let s = /^(\d)[-/,]+(\d{2})[-/,]+(\d)$/;
  if (s.test(e)) {
    let [D, P, w] = e.match(s).slice(1), [R, b] = P.split("");
    e = `${D}-${R} ${b}-${w}`, t.push("smashSetPattern");
  }
  let c = /^(\d+)[ -](\d+)$/, u = /^([\d -]+)\/([\d -]+)$/;
  if (u.test(e)) {
    let [D, P] = e.match(u).slice(1), w = D.trim(), R = P.trim();
    if (c.test(w) && c.test(R)) {
      let b = w.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${b} ${E}`, t.push("slashSeparationPattern");
    }
  }
  let d = /^([\d -]+),([\d -]+)$/;
  if (d.test(e)) {
    let [D, P] = e.match(d).slice(1), w = D.trim(), R = P.trim();
    if (c.test(w) && c.test(R)) {
      let b = w.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${b} ${E}`, t.push("commaSeparationPattern");
    }
  }
  let l = /^\d \d,/;
  if (l.test(e)) {
    let D = e.match(l)[0], P = D.slice(0, D.length - 1).split(" ").join("-");
    e = e.replace(D, P), t.push("singleSetCommaSeparationPattern");
  }
  let p = 0, f = /(\d+)-(\d{2})-(\d+)/;
  for (; f.test(e) && p < 3; ) {
    let [D, P, w] = e.match(f).slice(1), R = P.split(""), b = `${D}-${R[0]} ${R[1]}-${w}`;
    e = e.replace(f, b), t.push("noSetSeparationPattern"), p += 1;
  }
  let m = /(^|\s)7-6\s(\d+)\s/g, h = e.match(m);
  if (h != null && h.length) {
    let D = /(^|\s)7-6\s(\d+)\s/;
    h.forEach((P) => {
      let w = P.match(D).slice(2)[0];
      e = e.replace(P, `7-6(${w}) `), t.push("floatingTiebreakPattern1");
    });
  }
  let g = e.match(/\d \d /);
  g == null || g.forEach((D) => {
    let P = D.slice(0, D.length - 1).split(" ").join("-");
    e = e.replace(D, P), t.push("spaceSeparatedSetPattern1");
  }), g = e.match(/ \d \d$/), g == null || g.forEach((D) => {
    let P = " " + D.slice(1).split(" ").join("-");
    e = e.replace(D, P), t.push("spaceSeparatedSetPattern2");
  });
  let I = /^\d, *\d\/\d, *\d/;
  if (I.test(e)) {
    let D = e.match(I)[0], P = D.split("/").map((w) => `(${w})`).join(" ") + " ";
    e = e.replace(D, P), t.push("slashCommaSetPattern");
  }
  let U = /\(6-\)/g;
  U.test(e) && (e = e.replace(U, "(6-0)"), t.push("missingZeroPattern2"));
  let v = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)", "g");
  if (v.test(e)) {
    let D = e.match(v), P = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)"), w = e;
    D.forEach((R) => {
      let [b, E] = R.match(P).slice(1), O = `${b}-${E}`;
      w = w.replace(R, O);
    }), e = w, t.push("slashSetPattern");
  }
  let S = /(.*)\s(1\d)\s(\d+)$/;
  if (S.test(e)) {
    let [D, P, w] = e.match(S).slice(1);
    D.replace(/\D/g, "").length >= 4 && (e = D + ` ${P}${w}`, t.push("spaceSeparatedSuperPattern"));
  }
  let T = /(^|\s)(\d+-\d+)\s(\d+)(\s|$)/g;
  for (let D of e.match(T) || []) {
    let [P, w, R, b] = D.match(/(^|\s)(\d+-\d+)\s(\d+)(\s|$)/).slice(1), [E, O] = w.split("-").map((M) => parseInt(M));
    Math.abs(E - O) === 1 && (e = e.replace(D, `${P}${w}(${R})${b}`), t.push("spaceSeparatedSetPattern"));
  }
  let A = /\d-\d \(\d{1,2}\)(\s|$|,)/g;
  for (let D of e.match(A) || []) {
    let P = /(\d-\d) \((\d{1,2})\)(\s|$|,)/, [w, R, b] = D.match(P).slice(1), [E, O] = w.split("-").map((M) => parseInt(M));
    Math.abs(E - O) === 1 && (e = e.replace(D, `${w}(${R})${b}`), t.push("floatingTiebreakPattern2"));
  }
  let y = /(^|\s)(\d \d)\(/g;
  for (let D of e.match(y) || []) {
    let P = /(^|\s)(\d \d)\(/, [w, R] = D.match(P).slice(1);
    e = e.replace(D, `${w}${R.split(" ").join("-")}(`), t.push("spacedTiebreakPattern");
  }
  return { score: e, applied: t };
}
function h2({ score: e, matchUpStatus: t }) {
  var s;
  let r = e == null ? void 0 : e.split(" ");
  e = r.map((c) => {
    if (c.endsWith("]")) {
      let u = c.split("[");
      if (Oc(u[0])) return u[0] + `(${u[1].slice(0, u[1].length - 1)})`;
    }
    return c;
  }).join(" ");
  let i = new RegExp(/(\([\d ]+\))/g);
  if (i.test(e)) for (let c of e.match(i)) {
    let u = (s = c.replace(" ", "-").match(/\((.*)\)/)) == null ? void 0 : s[1];
    if (jt(u) && (u == null ? void 0 : u[0]) > 2) {
      if ([2, 4].includes(u.length)) u = u.split("").join("-");
      else if (u.length === 3) {
        let d = u.indexOf("1");
        u = wp(u.split(""), d);
      }
    }
    e = e.replace(c, `(${u})`);
  }
  r = e == null ? void 0 : e.split(" ");
  let n = new RegExp(/^(\d[-/]+\d)\((\d+)[-/]+(\d+)\)$/), a = r.length - 1;
  e = r.map((c, u) => {
    let d = [void 0, "", "COMPLETED"].includes(t) || u !== a;
    if (n.test(c) && d) {
      let [l, p, f] = Array.from(c.match(n)).slice(1), m = Math.min(p, f);
      return `${l}(${m})`;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^(\d{2})\((\d+)\)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u, d] = Array.from(c.match(n)).slice(1), l = u.split("");
      return `${l[0]}-${l[1]}(${d})`;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^\((\d[-/]+\d)\)(\d+)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u, d] = Array.from(c.match(n)).slice(1);
      return Oc(u) ? `${u}(${d})` : u;
    }
    return c;
  }).join(" "), r = e == null ? void 0 : e.split(" "), n = new RegExp(/^1-0\((\d+)\)$/), e = r.map((c) => {
    if (n.test(c)) {
      let [u] = c.match(n).slice(1);
      return `[${u < 9 ? 10 : parseInt(u) + 2}-${u}]`;
    }
    return c;
  }).join(" ");
  let o = /\((\d)+0 /;
  if (o.test(e)) {
    let c = e.match(o)[1];
    e = e.replace(o, `(${c}) `);
  }
  return { score: e };
}
function g2({ score: e, attributes: t, identifier: r }) {
  var d, l, p;
  if (typeof e != "string") return { score: e, identifier: r };
  let i = new RegExp(/\([\d,/ ]+\)/g), n = e.match(i);
  for (let f of n || []) {
    let m = (l = (d = f.match(/^\((.*)\)$/)) == null ? void 0 : d.slice(1)) == null ? void 0 : l[0], h = e.split(f)[0].split(")").reverse()[0].replace(/\D/g, "");
    if ((m == null ? void 0 : m.length) === 2 && (h == null ? void 0 : h.length) >= 2) {
      let U = h.slice(h.length - 2).split("").map((v) => parseInt(v));
      if (Math.abs(U[0] - U[1]) === 1) continue;
    }
    let g = FT(m), I = Hm(g);
    e = e.replace(f, `(${I})`).trim();
  }
  let a = new RegExp(/\[[\d,/ ]+\]/g);
  (p = e.match(a)) == null || p.forEach((f) => {
    let m = FT(f.match(/^\[(.*)\]$/)[1]);
    e = e.replace(f, `(${m}) `).trim();
  });
  let o = [")", "]"], s = [")(", "), (", ") (", ")[", ") [", "](", "] ("];
  if (e.startsWith("(") && o.some((f) => e.endsWith(f)) && s.some((f) => e.includes(f))) {
    let f = "", m = e.split(/[)\]]/).filter(Boolean).map((v) => (v.startsWith(",") && (v = v.slice(1)), v.trim())), h = m.every((v) => v.includes(",") || Xl(v)), g = m.every((v) => v.includes("/") || Xl(v)), I = m.every((v) => v.includes("-") || Xl(v)), U = h && "," || I && "-" || g && "/";
    if (U) {
      let v;
      m.forEach((S) => {
        if (S.startsWith("(")) if (v === "set" && (f += " "), S.includes(U)) f += S.slice(1).split(U).map((T) => T.trim()).join("-"), v = "set";
        else {
          let T = S.slice(1);
          f += `(${T}) `, v = "tiebreak";
        }
        else if (S.startsWith("[")) {
          let T = S.slice(1).split(U).map((y) => parseInt(y.trim())), A = Math.min(...T);
          v === "set" ? f += `(${A}) ` : f += `[${T.join("-")}] `, v = "tiebreak";
        }
      }), e = f.trim();
    }
  }
  let c = wi(e.split(""));
  c["("] === 1 && c[")"] === 1 && e.startsWith("(") && e.endsWith(")") && (e = e.slice(1, e.length - 1), c["-"] === 1 && Oc(e) && jt(t == null ? void 0 : t.removed) && (e = e + `(${t.removed})`, t.removed = void 0));
  let u = /\(\)/g;
  return u.test(e) && (e = e.replace(u, "").trim()), { score: e };
}
function K0({ score: e }) {
  let t = e.split(""), r = [], i, n = () => i = [void 0, void 0, void 0], a = () => {
    let s = `${i[0]}-${i[1]}`;
    return i[2] && (s += ` (${i[2]})`), n(), i.push(i), s;
  };
  n();
  let o = () => i[0] !== void 0 && i[1] !== void 0 && Math.abs(parseInt(i[0]) - parseInt(i[1]));
  for (; t.length; ) {
    let s = t.shift(), c = jt(s) && parseInt(s), u = i[0] !== void 0 && i[1] !== void 0;
    if (jt(c)) {
      if (i[0] === void 0) {
        i[0] = c;
        continue;
      }
      if (i[1] === void 0 && (i[1] = c, o())) {
        r.push(a()), i = [void 0, void 0];
        continue;
      }
      if (u && t.length === 1 && jt(t[0])) {
        let d = t.pop();
        i[0] = i[0].toString() + i[1].toString(), i[1] = d, r.push(a()), i = [void 0, void 0];
      }
      u && o();
    }
  }
  return { sets: r };
}
function $g(e) {
  let t = e.indexOf("1"), r = e.split(""), i = r.every((n) => !isNaN(n));
  if (i && e.length === 3 && t === 0) {
    let n = wp(r, t);
    if (n) return n;
  }
  if (i && e.length === 7 && t > 3) {
    let n = r.slice(4), a = wp(n, t - 4);
    if (a) return `${r[0]}-${r[1]} ${r[2]}-${r[3]} ${a}`;
  }
}
function X0(e) {
  let { score: t } = e, { applied: r, matchUpStatus: i } = e, n = t == null ? void 0 : t.toString().split(""), a = n == null ? void 0 : n.every((s) => jt(s)), o = (s) => Math.abs(s[0] - s[1]);
  if (typeof t == "number" || a) {
    t = t.toString().toLowerCase(), a && (t = n.join(""));
    let s = a ? n.map((c) => parseInt(c)) : t.split("").map((c) => parseInt(c));
    if (K0({ score: t }), s.length, t.length === 3 && o(s.slice(0, 2)) === 1) {
      let [c, u, d] = s;
      t = `${c}-${u}(${d})`, r.push("numericTiebreakPattern1");
    } else if (t.length === 3 && s[0] === 1) {
      let [c, u, d] = s;
      t = `[${c}${u}-${d}]`, r.push("numericTiebreakPattern2");
    } else if (t.length === 4 && o(s.slice(0, 2)) === 1 && "987654".split("").includes(s[0].toString())) {
      let [c, u, d, l] = s, p = Math.min(d, l);
      t = `${c}-${u}(${p})`, r.push("numericTiebreakPattern3");
    } else if (t.length === 4 && s[0] === 1 && s[2] === 1) {
      let [c, u, d, l] = s;
      t = `[${c}${u}-${d}${l}]`, r.push("bigSuper");
    } else if (t.length === 4) {
      let [c, u, d, l] = s;
      t = `${c}${u} ${d}${l}`, r.push("split4");
    } else if (t.length === 5 && o(s.slice(0, 2)) === 1) {
      let [c, u, d, l, p] = s;
      t = `${c}-${u}(${d}) ${l}-${p}`, r.push("numericTiebreakPattern4");
    } else if (t.length === 5 && o(s.slice(3)) === 1) {
      let [c, u, d, l, p] = s;
      t = `${c}-${u} ${d}-${l}(${p})`, r.push("numericTiebreakPattern5");
    } else if (s.length === 7) if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && s[4] === 1) {
      let [c, u, d, l, p, f, m] = s;
      t = `${c}-${u} ${d}-${l} [${p}${f}-${m}]`, r.push("numericTiebreakPattern6");
    } else if (o(s.slice(0, 2)) === 1 && o(s.slice(3, 5)) > 1 && o(s.slice(5, 7)) > 1) {
      let [c, u, d, l, p, f, m] = s;
      t = `${c}-${u}(${d}) ${l}-${p} ${f}-${m}`, r.push("numericTiebreakPattern7");
    } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) === 1 && o(s.slice(5, 7)) > 1) {
      let [c, u, d, l, p, f, m] = s;
      t = `${c}-${u} ${d}-${l}(${p}) ${f}-${m}`, r.push("numericTiebreakPattern8");
    } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && o(s.slice(4, 6)) === 1) {
      let [c, u, d, l, p, f, m] = s;
      t = `${c}-${u} ${d}-${l} ${p}-${f}(${m})`, r.push("numericTiebreakPattern9");
    } else t = t.slice(0, 2) + " " + t.slice(2, 4) + " " + t.slice(4), r.push("numericMatchTiebreakPattern");
    else if (t.length % 2) {
      let c = $g(t);
      c && t !== c && r.push("parsedSuperPattern"), t = c ?? t;
    } else {
      let c = gr(t.split(""), 2).map((g) => g.join("")), u = c.map((g) => {
        let [I, U] = g.split("").map((T) => parseInt(T)), v = Math.abs(I - U), S = I > U ? 1 : 2;
        return v > 1 && S || S * -1;
      }), d = u.reduce((g, I) => g > 0 && I > 0, 1), l = wi(u), p = u.map((g) => Math.abs(g)), f = wi(p), m = u[0] < 0, h = !m && u[1] < 0;
      if (u[0] > 0 && u[1] > 0 && u[0] !== u[1]) t = [c.slice(0, 2).join(" "), c.slice(2).join("-")].join(" "), r.push("numeric3rdSetTiebreakPattern");
      else if (d) t = c.join(" "), r.push("chunkSplit");
      else if (s.length === 6) {
        if (l[1] === 2 || l[2] === 2) if (!Object.values(f).includes(3)) t = c.join(" "), r.push("chunkSplit");
        else {
          let [g, I, U, v, S, T] = s, A = u.reduce((y, D, P) => D < 0 ? P : y, void 0);
          if (A === 0) {
            let y = Math.min(U, v);
            t = `${g}-${I}(${y}) ${S}-${T}`, r.push("chunkSplitTiebreak1");
          } else if (A === 1) {
            let y = Math.min(S, T);
            t = `${g}-${I} ${U}-${v}(${y})`, r.push("chunkSplitTiebreak2");
          } else t = `${g}-${I} ${U}-${v}`, r.push("chunkSplitTrimExtraneous");
        }
      } else if (s.length === 8) {
        let [g, I, U, v, S, T, A, y] = s;
        m || h ? s[5] === 1 && (m ? t = `${g}-${I}(${U}) ${v}-${S} [${T}${A}-${y}]` : t = `${g}-${I} ${U}-${v}(${S}) [${T}${A}-${y}]`) : (u[0], u[1]);
      }
    }
  }
  return { score: t, applied: r, matchUpStatus: i };
}
function Z0(e) {
  let t = [0, 0], r = [], i = e.split(" "), n = /(\d+)-(\d+)/;
  i.forEach((c) => {
    if (n.test(c)) {
      let u = c.match(n).slice(1).map((l) => parseInt(l)), d = u[0] > u[1] && 1 || u[1] > u[0] && 2;
      d && (t[d - 1] += 1, r.push(d));
    }
  });
  let a = t[0] > t[1] && 1 || t[1] > t[0] && 2, o = t[0] > 0 && t[0] === t[1], s = t.reduce((c, u) => c + u, 0);
  return { setsWon: t, setsTied: o, setWinners: r, totalSets: s, winningSide: a };
}
function I2({ score: e, matchUpStatus: t, attributes: r }) {
  let i = [], n, a = e.split(" "), o = a.length;
  e = a.map((d, l) => {
    if (new RegExp(Qu).test(d)) {
      let f = d.slice(3), m = d.slice(0, 3), h = m.split("-");
      if (!Oc(m) && !t) {
        let g = Math.max(...h), I = m.indexOf(g), U = [g, g - 1];
        return I && U.reverse(), U.join("-") + f;
      }
    } else if (d.length === 2 && jt(d)) return d.split("").join("-");
    d = Hm(d);
    let p = new RegExp(`^${$U}$`).test(d) && "super" || new RegExp(`^${Qu}$`).test(d) && "tiebreak" || new RegExp(`^${qm}$`).test(d) && "standard" || "unknown";
    if (i.push(p), o > 1 && p === "standard" && l < 2) {
      let [f, m] = d.split("-"), h = Math.abs(parseInt(f) - parseInt(m)), g = Math.max(f, m), I = Math.min(f, m), U = [parseInt(f), parseInt(m)].indexOf(I);
      if (g > 9 && h > 2) {
        let v = g.toString().split(""), S = v.find((T) => parseInt(T) > I || l && parseInt(T) <= n) ?? v[0];
        S && (d = U ? [S, I].join("-") : [I, S].join("-"));
      }
      g > (n || 0) && (n = g);
    }
    if (p === "standard") {
      let [f, m] = d.split("-");
      if (!Math.abs(parseInt(f) - parseInt(m)) && t !== "RETIRED") return "";
    }
    return d;
  }).filter(Boolean).join(" ");
  let { setsWon: s, setWinners: c, totalSets: u } = Z0(e);
  if (u === 1 && (r == null ? void 0 : r.removed) === "6" && (e += " 6-0"), e.split(" ").length > 2 && Math.max(...s) >= 2 && c[0] === c[1] && (e = e.split(" ").slice(0, 2).join(" ")), Math.max(...s) > 2) {
    let d = [0, 0];
    e = e.split(" ").map((l, p) => (d[c[p]] += 1, Math.max(...d) > 2 ? void 0 : l)).filter(Boolean).join(" ");
  }
  return { score: e, profile: i };
}
function v2({ score: e }) {
  let { setsTied: t, winningSide: r } = Z0(e), i = /\s\((\d+)\)$/;
  if (!r && t && i.test(e)) {
    let s = e.match(i).slice(1)[0], c = s <= 8 ? 10 : s + 2;
    e = e.replace(i, ` [${c}-${s}]`);
  }
  let n = e.split(" "), a = n[n.length - 1];
  if (!a.includes("-") || a.indexOf("(") > 0) return { score: e };
  let o = a.split("(").join("").split(")").join("").split("-");
  if (!o.every((s) => jt(s))) return { score: e };
  if (o[0] === "76") {
    let s = o[1].length === 2 ? Math.min(...o[1].split("").map((c) => parseInt(c))) : o[1];
    e = [...n.slice(0, n.length - 1), `7-6(${s})`].join(" ");
  } else {
    o = o.map((u) => parseInt(u));
    let s = Math.max(...o), c = Math.abs(o[0] - o[1]);
    if (s >= 10) {
      if (c > 2 && o.every((u) => +u >= 10)) {
        let u = o.map((d) => d === s ? d - 10 : 10).sort();
        c = Math.abs(u[0] - u[1]), c > 2 && (o = u);
      }
      e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" ");
    } else n.length === 3 && s >= 7 && c > 2 && (e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" "));
  }
  return { score: e };
}
function U2({ score: e }) {
  return e = (e == null ? void 0 : e.toString().toLowerCase()) || "", { score: e };
}
function S2({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e.toLowerCase().includes("o") && (e = e.toLowerCase().split(" ").map((r) => r.split("o").join("0")).join(" "), t.push("replaceOh")), { score: e, applied: t });
}
function y2({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length > 2) {
      let i = r.indexOf("1");
      if (r.length % 2) {
        if (r.length === 3 && i === 0) {
          let n = wp(r.split(""), i);
          return t.push("getSuper"), n;
        }
      } else {
        let { score: n, applied: a } = X0({ score: r, applied: [] });
        n !== r && (r = n, t.push(...a));
      }
    }
    return r;
  }).join(" "), { score: e, applied: t });
}
function A2({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : [3, 4].includes(e.length) && $g(e) ? { score: $g(e) } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length === 1) {
      t.push("removeErroneous1");
      return;
    }
    return r;
  }).filter(Boolean).join(" "), { score: e, applied: t });
}
function T2({ score: e, applied: t }) {
  return ["walkover", "wo", "w/o", "w-o"].includes(e == null ? void 0 : e.toString().toLowerCase()) ? (t.push("handleWalkover"), { matchUpStatus: "walkover", score: "", applied: t }) : { score: e };
}
function D2({ score: e, profile: t, applied: r }) {
  var o;
  e = e == null ? void 0 : e.toString().toLowerCase();
  let i = /^(.*\d+.*)(ret|con)+[A-Za-z ]*$/;
  if (i.test(e)) {
    let [s] = e.match(i).slice(1);
    return r.push("handleRetired"), { score: s.trim(), matchUpStatus: "retired", applied: r };
  }
  let n = (o = t == null ? void 0 : t.matchUpStatuses) == null ? void 0 : o.retired, a = ["rtd", ...Array.isArray(n) ? n : [n].filter(Boolean)].find((s) => e == null ? void 0 : e.endsWith(s));
  return a ? (r.push("handleRetired"), { matchUpStatus: "retired", score: e == null ? void 0 : e.replace(a, "").trim(), applied: r }) : { score: e };
}
function P2({ score: e, attributes: t }) {
  (e.endsWith(" am") || e.endsWith(" pm")) && (e = ""), e = e.replace(/[A-Za-z]+/g, "").trim(), [".", ","].some((n) => e.endsWith(n)) && (e = e.slice(0, e.length - 1));
  let r = "()/-".split("").some((n) => e.includes(n));
  / \d$/.test(e) && r && (t = { removed: e.slice(e.length - 2).trim() }, e = e.slice(0, e.length - 2));
  let i = /(.*)[A-Za-z]+$/;
  return i.test(e) && (e = e.match(i).slice(1)[0].trim()), { score: e, attributes: t };
}
function w2({ score: e }) {
  return new RegExp(/-\d+\/\d+-/).test(e) && (e = e.split("/").join(" ")), { score: e };
}
function R2({ score: e }) {
  let t = new RegExp(/^\d+\/\d+/), r = e.split(" ");
  r.some((n) => t.test(n)) && (e = r.map((n) => t.test(n) ? n.replace("/", "-") : n).join(" "));
  let i = /^(\d+), *(\d+)$/;
  if (i.test(e)) {
    let [n, a] = e.match(i).slice(1);
    e = [n, a].join("-");
  }
  return { score: e };
}
function b2({ score: e }) {
  let t = new RegExp(/\(\d+\/\d+\)/g), r = e.match(t);
  for (let i of r || []) {
    let n = i.replace("/", "-");
    e = e.replace(i, n);
  }
  return { score: e };
}
function N2({ score: e }) {
  if (e.includes(",")) {
    let t = e.split(",").map((i) => i.trim()), r = (i) => /\d \d/.test(i);
    t.every(r) && (e = t.map((i) => {
      let n = /\d+ \d+/g;
      for (let a of i.match(n)) {
        let [o, s] = a.match(/(\d+) (\d+)/).slice(1);
        i = i.replace(a, `${o}-${s}`);
      }
      return i;
    }).join(" "));
  }
  if (e.includes(" ")) {
    let t = e.replace(/[ ,]/g, "");
    t.split("").every((r) => jt(r)) && t.length === 4 && (e = t);
  }
  return { score: e };
}
function M2({ score: e }) {
  let t = new RegExp(/^\[\d+\](.*)$/);
  t.test(e) && (e = e.match(t).slice(1)[0].trim());
  let r = /\(,/g;
  return r.test(e) && (e = e.replace(r, "(")), { score: e };
}
var E2 = { handleTiebreakSlashSeparation: b2, handleSetSlashSeparation: w2, punctuationAdjustments: l2, handleGameSeparation: R2, joinFloatingTiebreak: f2, handleBracketSpacing: p2, handleSpaceSeparator: N2, separateScoreBlocks: y2, matchKnownPatterns: m2, removeDanglingBits: P2, removeErroneous: A2, handleWalkover: T2, properTiebreak: h2, handleNumeric: X0, handleRetired: D2, containedSets: g2, sensibleSets: I2, stringScore: U2, superSquare: v2, setBuilder: K0, excisions: M2, replaceOh: S2 }, Qh = {}, O2 = ["handleNumeric", "handleWalkover", "handleRetired", "replaceOh", "stringScore", "punctuationAdjustments", "excisions", "handleSpaceSeparator", "matchKnownPatterns", "removeDanglingBits", "handleBracketSpacing", "matchKnownPatterns", "containedSets", "separateScoreBlocks", "handleGameSeparation", "removeErroneous", "joinFloatingTiebreak", "handleSetSlashSeparation", "handleTiebreakSlashSeparation", "properTiebreak", "sensibleSets", "superSquare"], C2 = ["handleNumeric", "separateScoreBlocks", "sensibleSets", "superSquare"];
function Q0(e) {
  if (!e.score) return { error: ie };
  let { score: t, sheetName: r, identifier: i, fileName: n, stepLog: a, fullLog: o, profile: s } = e, c = [], u, d = [], l, p, f = t, m = (g) => {
    g.forEach((I) => {
      p = E2[I]({ profile: s, identifier: i, matchUpStatus: u, attributes: l, applied: d, score: f });
      let U = p.score !== f;
      U && c.push({ method: I, score: p.score }), a && (o || U || p.matchUpStatus !== u) && console.log(u ? { score: p.score, matchUpStatus: u } : { score: p.score }, I), p.matchUpStatus && (u = p.matchUpStatus), p.attributes && (l = p.attributes), p.applied && (d = p.applied), f = p.score;
    });
  };
  m(O2);
  let h = CT(f);
  return h || (f = t.toString().replace(/\D/g, ""), l != null && l.removed && (l.removed = void 0), m(C2), h = CT(f), h || (f = "")), d.forEach((g) => {
    Qh[g] || (Qh[g] = 0), Qh[g] += 1;
  }), { matchUpStatus: u == null ? void 0 : u.toUpperCase(), modifications: c, attributes: l, isValid: h, score: f };
}
var J0 = {};
qe(J0, { analyzeScore: () => eS, analyzeSet: () => Ju, checkScoreHasValue: () => pr, checkSetIsComplete: () => _m, getSetComplement: () => rS, getTiebreakComplement: () => Ym, isValidMatchUpFormat: () => Ri, parseScoreString: () => Rp, validateScore: () => tS, validateTieFormat: () => oi });
function eS({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  var T, A;
  let a = (n == null ? void 0 : n.sets) ?? [], o = ((a == null ? void 0 : a.filter((y) => y == null ? void 0 : y.winningSide)) || []).reduce((y, D) => {
    let { winningSide: P } = D;
    if (!P) return y;
    let w = P - 1;
    return y[w]++, y;
  }, [0, 0]), s = i ? i - 1 : void 0, c = s !== void 0 ? 1 - s : void 0, u = s !== void 0 && o[s], d = c !== void 0 && o[c], l = t ? ti(t) : void 0, p = Math.max(...o), f = wi(o)[p], m = ((T = l == null ? void 0 : l.setFormat) == null ? void 0 : T.timed) || ((A = l == null ? void 0 : l.finalSetFormat) == null ? void 0 : A.timed), h = l == null ? void 0 : l.bestOf, g = h && Math.ceil(h / 2) || 1, I = r ?? e, U = I && [Je, Wr, ct].includes(I), v = !l || !a.length || a.every((y, D) => {
    let P = D + 1, w = P === h, R = P === a.length, { side1Score: b, side2Score: E, side1TiebreakScore: O, side2TiebreakScore: M, winningSide: N } = y, C = Math.max(b ?? 0, E ?? 0), F = O ?? M, { finalSetFormat: x, setFormat: V } = l, k = w && x || V;
    if (F) {
      let { tiebreakTo: L, NoAD: B } = (k == null ? void 0 : k.tiebreakFormat) || {}, G = Math.max(O ?? 0, M ?? 0);
      if (B && G > L || G < L && N && (R && !U || !R)) return !1;
    }
    return k.setTo ? !(!k.noTiebreak && C > k.setTo + 1) : !0;
  }), S = (!t || p === g) && f === 1 && o.indexOf(p) + 1 || void 0;
  return { valid: !!(v && (i && u > d && i === S || i && U || !i && !S && (![zt, Je, Wr, ct].includes(I) || m && I === zt))) };
}
function tS({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  if (typeof n != "object") return { error: ie };
  let { sets: a, scoreStringSide1: o, scoreStringSide2: s } = n, c = "scoreString must be a string!";
  if (o !== void 0 && typeof o != "string") return { error: ie, info: c };
  if (s !== void 0 && typeof s != "string") return { error: ie, info: c };
  if (a !== void 0 && !Array.isArray(a)) return { error: ie, info: Oo("sets") };
  if (a != null && a.length) {
    let u = a.map((l) => l == null ? void 0 : l.setNumber).filter(Boolean);
    if (u.length !== Be(u).length) return { error: ie, info: "setNumbers not unique" };
    for (let l of a) {
      let { side1Score: p, side2Score: f, side1TiebreakScore: m, side2TiebreakScore: h, side1PointScore: g, side2PointScore: I, winningSide: U, setNumber: v } = l;
      if (![[p, f], [m, h], [g, I]].filter((S) => S.some((T) => ![void 0, null].includes(T))).every((S) => S.every((T) => ke(T)))) return { error: ie, info: "non-numeric values" };
      if (![v, U].filter((S) => ![void 0, null].includes(S)).every((S) => ke(S))) return { error: ie, info: "non-numeric values" };
      if (U && ![1, 2].includes(U)) return { error: ie, info: "winningSide must be 1 or 2" };
    }
    let { valid: d } = eS({ existingMatchUpStatus: e, matchUpStatus: r, matchUpFormat: t, winningSide: i, score: n });
    if (!d) return { error: mw, info: "score is invalid for matchUpFormat or winningSide does not match calculated winningSide" };
  }
  return { valid: !0 };
}
var rS = (e) => {
  let { isSide1: t, lowValue: r, setTo: i, tiebreakAt: n, NoAD: a } = e;
  if (r === void 0) return !1;
  let o = be(r);
  (o == null ? void 0 : o.toString().length) > 2 && (o = parseInt(o.toString().slice(0, 2))), n && n < i && o > n && (o = n);
  let s;
  return a && !n ? (o > i && (s = i), s = o < i ? i : i - 1) : s = o + 1 < i && i || n && n < i && o === n && i || !n && o + 2 || i + 1, [t ? o : s, t ? s : o];
}, Ym = (e) => {
  let { isSide1: t, lowValue: r, tiebreakTo: i, tiebreakNoAd: n } = e;
  if (r === void 0) return !1;
  let a = typeof r == "string" ? parseInt(r) : r;
  (a == null ? void 0 : a.toString().length) > 2 && (a = parseInt(a.toString().slice(0, 2))), n && a > i - 1 && (a = i - 1);
  let o = F2({ lowValue: a, NoAD: n, tiebreakTo: i });
  return [t ? a : o, t ? o : a];
};
function F2(e) {
  let { lowValue: t, NoAD: r, tiebreakTo: i } = e, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : i;
}
function Rp({ tiebreakTo: e = 7, scoreString: t = "" }) {
  return t == null ? void 0 : t.split(" ").filter(Boolean).map((i, n) => r({ set: i, setNumber: n + 1 }));
  function r({ set: i, setNumber: n }) {
    let a = /\(([^)]+)\)/, o = /\[([^)]+)\]/, s = a.exec(i), c = o.exec(i), u = (i == null ? void 0 : i.startsWith("[")) && c && c[1].split("-").map((v) => parseInt(v)), d = s && i.replace(s[0], "") || c && i.replace(c[0], "") || i, l = !u && d.split("-").map((v) => parseInt(v)), p = u ? u[0] > u[1] && 1 || u[0] < u[1] && 2 || void 0 : l[0] > l[1] && 1 || l[0] < l[1] && 2 || void 0, f = s ? s[1] : void 0, m = (f && Ym({ lowValue: f, isSide1: p === 2, tiebreakTo: e })) ?? [], [h, g] = l || [], [I, U] = u || m || [];
    return { side1Score: h, side2Score: g, side1TiebreakScore: I, side2TiebreakScore: U, winningSide: p, setNumber: n };
  }
}
function k2({ matchUpScoringFormat: e, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i, setObject: n }) {
  if (!n) return;
  let a = Wm({ set: n });
  return _m({ matchUpScoringFormat: e, set: n, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i }) && a || void 0;
}
function Ju(e) {
  let { setObject: t, matchUpScoringFormat: r } = e;
  if (!t) return { error: Ef };
  let { setNumber: i } = t || {}, { bestOf: n, exactly: a } = r || {}, o = n || a, s = !!(i && o && i === o), c = s && (r == null ? void 0 : r.finalSetFormat) || (r == null ? void 0 : r.setFormat), u = !!(c != null && c.tiebreakSet), d = !!(c != null && c.timed), l = !u && !d, p = !!(i && o && i <= o), f = [t == null ? void 0 : t.side1Score, t == null ? void 0 : t.side2Score], m = [t == null ? void 0 : t.side1PointScore, t == null ? void 0 : t.side2PointScore], h = [t == null ? void 0 : t.side1TiebreakScore, t == null ? void 0 : t.side2TiebreakScore], g = f.filter((F) => F !== void 0).length, I = m.filter((F) => F !== void 0).length, U = h.filter((F) => F !== void 0).length, v = f == null ? void 0 : f.filter((F) => !isNaN(F)).length, S = h == null ? void 0 : h.filter((F) => !isNaN(F)).length, { tiebreakAt: T } = c || {}, A = T && f.filter((F) => F >= T).length === 2, y = A && (f[0] > f[1] && 1 || f[1] > f[0] && 2 || void 0), D = !!(S && !v), P = !!(t != null && t.winningSide), { error: w, result: R } = L2({ sideTiebreakScores: h, sideGameScores: f, setFormat: c, setObject: t }), { error: b, result: E } = x2({ sideTiebreakScores: h, setObject: t, setFormat: c }), O = l && !D && R || u && D && E || d, M = p && !(u && !D) && !(l && D) && (!P || O), N = k2({ isTimedSet: d, matchUpScoringFormat: r, isDecidingSet: s, isTiebreakSet: D, setObject: t }), C = { expectTiebreakSet: u, expectTimedSet: d, hasTiebreakCondition: A, isCompletedSet: P, isDecidingSet: s, isTiebreakSet: D, isValidSet: M, isValidSetNumber: p, isValidSetOutcome: O, leadingSide: y, setFormat: c, sideGameScores: f, sideGameScoresCount: g, sidePointScores: m, sidePointScoresCount: I, sideTiebreakScores: h, sideTiebreakScoresCount: U, winningSide: N };
  return (t == null ? void 0 : t.winningSide) !== void 0 && (D ? (C.isValidTiebreakSetOutcome = E, E || (C.tiebreakSetError = b)) : (C.isValidStandardSetOutcome = R, R || (C.standardSetError = w))), C;
}
function L2({ setObject: e, setFormat: t, sideGameScores: r, sideTiebreakScores: i }) {
  if (!e) return { result: !1, error: Ef };
  let n = !!(t != null && t.tiebreakSet), a = !!(t != null && t.timed);
  if (!t || n || a) return { result: !1, error: ie };
  if ((r == null ? void 0 : r.filter((y) => !isNaN(y)).length) !== 2) return { result: !1, error: gg };
  let { setTo: o, tiebreakAt: s, tiebreakFormat: c, NoAD: u } = t || {};
  if (!(o && (r != null && r.find((y) => y >= o)))) return { result: !1, error: gg };
  let d = [1, 2].includes(e == null ? void 0 : e.winningSide);
  if (!e || !d) return { result: !1, error: Of };
  let l = (e == null ? void 0 : e.winningSide) - 1, p = 1 - l, f = r[l], m = r[p], h = f - m;
  if (!(f > m)) return { result: !1, error: { message: "winningSide game scoreString is not high" } };
  let g = s && c, I = (i == null ? void 0 : i.filter((y) => !isNaN(y)).length) === 2, U = i == null ? void 0 : i[l], v = i == null ? void 0 : i[p], S = s && r.filter((y) => y >= s).length === 2;
  if (g) {
    let { NoAD: y, tiebreakTo: D } = c;
    if (S) {
      if (h > 1) return { result: !1, error: { message: "invalid winning game scoreString (5)" } };
      if (!I) return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
      if (isNaN(D)) return { result: !1, error: { message: "tiebreakTo error" } };
      if (!(D && (i != null && i.find((E) => E >= D)))) return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
      let P = s < o ? o : o + 1;
      if (f > P) return { result: !1, error: { message: "invalid winning game scoreString (1)" } };
      if (!U || !v || U < v) return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
      let w = y ? 1 : 2, R = U - v, b = v >= D - 1;
      if (R && b && R < w) return { result: !1, error: { message: "invalid tiebreak scores (3)" } };
    }
    if (f > o && !S) return { result: !1, error: { message: "invalid winning game scoreString (2)" } };
  }
  let T = u ? 1 : 2, A = m >= o - 1;
  return h && A && !S && h < T ? { result: !1, error: { message: "invalid winning game scoreString (3)" } } : h > T && f > o ? { result: !1, error: { message: "invalid winning game scoreString (4)" } } : { result: !0 };
}
function x2({ setObject: e, setFormat: t, sideTiebreakScores: r }) {
  if (!e) return { result: !1, error: Ef };
  let i = !!(t != null && t.tiebreakSet), n = !!(t != null && t.timed);
  if (!t || !i || n) return { result: !1, error: { message: "not tiebreak set" } };
  let a = [1, 2].includes(e == null ? void 0 : e.winningSide);
  if (!e || !a) return { result: !1, error: Of };
  let { tiebreakSet: o } = t || {}, { NoAD: s, tiebreakTo: c } = o || {};
  if ((r == null ? void 0 : r.filter((g) => !isNaN(g)).length) !== 2) return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
  if (isNaN(c)) return { result: !1, error: { message: "tiebreakTo error" } };
  if (!(r != null && r.find((g) => g >= c))) return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
  let u = (e == null ? void 0 : e.winningSide) - 1, d = 1 - u, l = r[u], p = r[d];
  if (!l || !p || l < p) return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
  let f = s ? 1 : 2, m = l - p, h = p >= c - 1;
  return m && h && m < f ? { result: !1, error: { message: "invalid tiebreak scores (3)" } } : { result: !0 };
}
function B2(e) {
  var l, p, f;
  let { existingDrawDefinition: t, hydrateCollections: r, enforceGender: i, tieFormatName: n, matchUpType: a, eventType: o, isMock: s, event: c } = e, { tieFormat: u, matchUpFormat: d } = e;
  if (a === or && o === or) {
    let m = (p = (l = t == null ? void 0 : t.structures) == null ? void 0 : l.find(({ stage: h }) => h === Ie)) == null ? void 0 : p.tieFormat;
    u = u || m || n && ((f = c == null ? void 0 : c.tieFormat) == null ? void 0 : f.tieFormatName) === n && c.tieFormat || n && Sa({ namedFormat: n, hydrateCollections: r, isMock: s, event: c }) || (c == null ? void 0 : c.tieFormat) || Sa({ event: c, isMock: s, hydrateCollections: r }), d = void 0;
  } else d || (u = void 0, c != null && c.matchUpFormat || (d = Ia));
  if (u) {
    let m = oi({ gender: c == null ? void 0 : c.gender, enforceGender: i, tieFormat: u });
    if (m.error) return m;
  }
  return { tieFormat: u, matchUpFormat: d };
}
function V2(e) {
  var v, S, T, A, y;
  let t = e.drawDefinition, { existingQualifyingPlaceholderStructureId: r, appliedPolicies: i, drawEntries: n, structureId: a, idPrefix: o, isMock: s, event: c } = e, u = e.qualifyingProfiles, d = u != null && u.length ? JM({ uuids: e.uuids, qualifyingProfiles: u, appliedPolicies: i, idPrefix: o, isMock: s }) : void 0;
  if (d != null && d.error) return d;
  t.structures = (v = t.structures) == null ? void 0 : v.filter(({ structureId: D }) => D !== r), t.links = (S = t.links) == null ? void 0 : S.filter(({ source: D }) => D.structureId !== r);
  let { qualifiersCount: l, qualifyingDrawPositionsCount: p, qualifyingDetails: f } = d ?? {};
  p && (d != null && d.structures && ((T = t.structures) == null || T.push(...d.structures)), d != null && d.links && ((A = t.links) == null || A.push(...d.links)));
  let m = (y = t.structures) == null ? void 0 : y.find(({ stage: D, stageSequence: P }) => D === Ie && P === 1), { qualifiersCount: h } = $c({ stageSequence: 1, drawDefinition: t, structureId: a, stage: Ie }), g = Math.max(l ?? 0, h ?? 0), I = tM({ qualifiersCount: g, drawDefinition: t, stage: Ie });
  if (I.error || (I = Sp({ drawSize: p, stage: Pe, drawDefinition: t }), I.error)) return I;
  G2({ drawDefinition: t, drawEntries: n, event: c });
  let U = j2({ mainStructure: m, qualifyingDetails: f, drawDefinition: t });
  return U.error ? U : { drawDefinition: t, structureId: a };
}
function G2({ drawDefinition: e, drawEntries: t, event: r }) {
  for (let i of (t ?? []).filter(({ entryStage: n }) => n === Pe)) {
    let n = { ...i, entryStage: i.entryStage ?? Ie, drawDefinition: e, event: r };
    eU(n);
  }
}
function j2({ mainStructure: e, qualifyingDetails: t, drawDefinition: r }) {
  var i;
  for (let n of t || []) {
    let { finalQualifyingRoundNumber: a, finalQualifyingStructureId: o, roundTarget: s, finishingPositions: c, linkType: u } = n, d = e && ((i = zd({ targetStructureId: e.structureId, sourceStructureId: o, sourceRoundNumber: a, finishingPositions: c, targetEntryRound: s, linkType: u })) == null ? void 0 : i.link);
    if (d != null && d.error) return d;
    d && (r.links || (r.links = []), r.links.push(d));
  }
  return { error: void 0 };
}
function $0(e) {
  var i, n;
  let { participantIds: t } = e, r = ((n = (i = e.drawDefinition) == null ? void 0 : i.entries) == null ? void 0 : n.filter((a) => {
    let o = a.entryStatus;
    return !e.restrictEntryStatus || yn.includes(o);
  }).map(Ke)) ?? [];
  if (t) {
    let a = t.filter((o) => !(r != null && r.includes(o)));
    if (a != null && a.length) return W({ result: { error: bn }, info: { invalidParticipantIds: a } });
  } else t = r;
  return e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > t.length - 1 && (!e.enableDoubleRobin || e.roundsCount > (t.length - 1) * 2) ? { error: ie, info: "Not enough participants for roundsCount" } : e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > 31 ? { error: ie, info: "roundsCount must be less than 32" } : { participantIds: t };
}
function iS(e) {
  var l;
  let t = [], { roundsCount: r = 1, drawDefinition: i, matchUpsCount: n, structureId: a, idPrefix: o, isMock: s, event: c } = e, u, d = $0(e);
  if (d.error) return d;
  for (let p of fe(1, r + 1)) {
    let f = Vm({ restrictMatchUpsCount: e.restrictMatchUpsCount, ignoreLastRoundNumber: !!u, newRound: !u, drawDefinition: i, matchUpsCount: n, structureId: a, roundNumber: u, idPrefix: o, isMock: s, event: c });
    if (f.error) return W({ result: f, info: { iteration: p } });
    (l = f.matchUps) != null && l.length && t.push(...f.matchUps), u = ((f == null ? void 0 : f.roundNumber) ?? 1) + 1;
  }
  return { matchUps: t };
}
function _2(e) {
  var c;
  let { tournamentRecord: t, participantIds: r, scaleName: i, eventType: n, adHocRatings: a = {} } = e, o = e.scaleAccessor ?? ((c = Ur[i]) == null ? void 0 : c.accessor), s = t.participants ?? [];
  for (let u of r ?? []) {
    let d = s == null ? void 0 : s.find((p) => p.participantId === u), l = kT({ scaleName: `${i}.${pv}`, participant: d, eventType: n });
    !l && i && (l = kT({ scaleAccessor: o, participant: d, scaleName: i, eventType: n })), l && !a[u] && (a[u] = l);
  }
  return a;
}
function kT({ scaleType: e = qa, scaleAccessor: t, participant: r, scaleName: i, eventType: n }) {
  var o, s;
  let a = (s = (o = r && ta({ scaleAttributes: { eventType: n ?? ms, scaleType: e, scaleName: i }, participant: r })) == null ? void 0 : o.scaleItem) == null ? void 0 : s.scaleValue;
  return t && $e(a) ? a[t] : a;
}
function nS(e) {
  var d, l;
  let t = q2(e);
  if (t != null && t.error) return t;
  let r = $0(e);
  if (r.error) return r;
  let i = W2(e);
  if (i.error) return i;
  let n = _2(e), a = ((d = e.tournamentRecord) == null ? void 0 : d.isMock) ?? e.isMock, o = e.eventType ?? ((l = e.event) == null ? void 0 : l.eventType), s = [], c = [], u;
  for (let p of fe(1, (e.roundsCount ?? 1) + 1)) {
    let f = zU({ ...e, participantIds: r.participantIds, structure: i.structure, ignoreLastRoundNumber: !0, iterationMatchUps: s, adHocRatings: n, roundNumber: u, eventType: o, isMock: a });
    if (f.error) return f;
    let { matchUps: m, ...h } = f;
    h.modifiedScaleValues && (n = h.modifiedScaleValues), c.push({ ...h, iteration: p, matchUpsCount: m == null ? void 0 : m.length }), u = ((h == null ? void 0 : h.roundNumber) ?? 1) + 1, m != null && m.length && s.push(...m);
  }
  return { ...j, matchUps: s, roundResults: c };
}
function W2(e) {
  var n, a, o;
  if (e.structureId) return e.structureId;
  let t = e.drawDefinition, r = (a = (n = t == null ? void 0 : t.structures) == null ? void 0 : n.filter((s) => s.stageSequence === 1)) == null ? void 0 : a.reduce((s, c) => {
    let u = c.stage && hs[c.stage];
    return si({ structure: c }) && u > (hs[s == null ? void 0 : s.stage] || 1) ? c : s;
  }, void 0), i = (o = t == null ? void 0 : t.structures) == null ? void 0 : o.find((s) => s.structureId === (r == null ? void 0 : r.structureId));
  return i ? si({ structure: i }) ? { structure: i } : { error: ts } : { error: kt };
}
function q2(e) {
  var t;
  return e.roundsCount && typeof e.roundsCount != "number" ? { error: ie, info: "roundsCount must be a number" } : typeof e.drawDefinition != "object" || e.drawDefinition.drawType && e.drawDefinition.drawType !== Li ? { error: ts } : !Array.isArray((t = e.drawDefinition) == null ? void 0 : t.entries) && e.participantIds && !Array.isArray(e.participantIds) ? { error: ie, info: "Missing Entries" } : { error: void 0 };
}
function H2(e) {
  var d, l;
  let { tournamentRecord: t, drawDefinition: r, structureId: i, idPrefix: n, isMock: a, event: o } = e, s = (d = o == null ? void 0 : o.entries) == null ? void 0 : d.filter(({ entryStage: p, entryStatus: f }) => (!p || p === Ie) && f && yn.includes(f)), c = s == null ? void 0 : s.map(Ke), u = s ? Math.floor(s.length / 2) : 0;
  if (e.automated) return Y2({ ...e, participantIds: c });
  {
    let p = iS({ roundsCount: e.roundsCount, drawDefinition: r, matchUpsCount: u, idPrefix: n, isMock: a, event: o });
    if (p.error) return p;
    (l = p.matchUps) != null && l.length && km({ matchUps: p.matchUps, suppressNotifications: !0, tournamentRecord: t, drawDefinition: r, structureId: i, event: o });
  }
  return { ...j };
}
function Y2(e) {
  var c, u;
  let { restrictEntryStatus: t, generateMatchUps: r, structureId: i, matchUpIds: n, scaleName: a, scaleAccessor: o } = e.drawMatic ?? {}, s = nS({ ...e, eventType: ((c = e.drawMatic) == null ? void 0 : c.eventType) ?? e.matchUpType, generateMatchUps: r ?? !0, scaleAccessor: o ?? e.scaleAccessor, scaleName: a ?? e.scaleName, participantIds: e.participantIds, roundsCount: e.roundsCount, restrictEntryStatus: t, structureId: i, matchUpIds: n });
  return s.error ? s : ((u = s == null ? void 0 : s.matchUps) != null && u.length && km({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, suppressNotifications: !0, matchUps: s.matchUps, event: e.event, structureId: i }), { ...j });
}
function z2({ requireParticipantCount: e = !0, enforcePolicyLimits: t = !0, drawSizeProgression: r, participantsCount: i, participantCount: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, seedsCount: u }) {
  var U, v;
  i = i ?? n;
  let d = Ne({ drawDefinition: o, structureId: c });
  if (d.error) return d;
  let l = d.structure;
  if (!l) return { error: kt };
  let { positionAssignments: p } = Ir({ structure: l }), f = (p == null ? void 0 : p.length) || 0;
  if (u > f) return { error: HP };
  let m = (U = l.structures) == null ? void 0 : U.length, h = ke(s == null ? void 0 : s.groupSeedingThreshold) && (s == null ? void 0 : s.groupSeedingThreshold), g = (v = uU({ roundRobinGroupsCount: m, drawSize: f })) == null ? void 0 : v.seedGroups, { seedsCount: I } = il({ policyDefinitions: a, requireParticipantCount: e, drawSizeProgression: r, participantsCount: i, drawSize: f });
  return I && (a != null && a[Tn]) && u > I && t && (u = I), l.seedLimit = u, l.seedAssignments = fe(1, u + 1).map((S) => {
    let T = g == null ? void 0 : g.find((D) => D.includes(S)), A = T && Math.min(...T), y = h && S >= h ? A : S;
    return { participantId: void 0, seedNumber: S, seedValue: y };
  }), vt({ drawDefinition: o, structureIds: [c] }), { ...j, seedLimit: u };
}
function zs({ sortDescending: e = !1, tournamentRecord: t, scaleAttributes: r, scaleSortMethod: i, stageSequence: n, entries: a, event: o, stage: s }) {
  if (!t) return { error: de };
  return a = a ?? (o == null ? void 0 : o.entries) ?? [], { scaledEntries: a.filter((d) => (!s || !d.entryStage || d.entryStage === s) && (!n || !d.entryStageSequence || d.entryStageSequence === n) && yn.includes(d.entryStatus)).map((d) => {
    let { participantId: l } = d, { scaleItem: p } = Ec({ tournamentRecord: t, scaleAttributes: r, participantId: l });
    return { ...d, ...p };
  }).filter((d) => {
    let l = d.scaleValue;
    return !i && (isNaN(l) || !parseFloat(l)) ? !1 : l;
  }).sort(i || c) };
  function c(d, l) {
    return e ? u(l) - u(d) : u(d) - u(l);
  }
  function u(d) {
    return parseFloat(d.scaleValue || (e ? -1 : 1e5));
  }
}
function eE(e) {
  let t = "prepareStage", { drawDefinition: r } = e, { structures: i } = In({ stageSequence: e.stageSequence || 1, roundTarget: e.roundTarget, stage: e.stage, drawDefinition: r }), n = e.preparedStructureIds || [], a = i == null ? void 0 : i.find(({ structureId: f }) => !n.includes(f));
  if (!a) return W({ result: { error: kt }, stack: t });
  let o = a == null ? void 0 : a.structureId, { seedsCount: s, stageEntries: c, seedLimit: u } = tj({ ...e, structureId: o });
  (e.seededParticipants || e.event || e.seedingScaleName) && Z2({ ...e, seedsCount: s, structure: a, structureId: o });
  let d = e.automated !== !1 && e.drawType !== Li && !(e.qualifyingOnly && e.stage !== Pe), l = ((i == null ? void 0 : i.length) || 0) > 1, p = d ? X2({ ...e, multipleStructures: l, seedLimit: u, structureId: o }) : {};
  return p != null && p.error ? W({ result: p, stack: t }) : { ...p, stageEntries: c, structureId: o, seedsCount: s };
}
function K2({ entries: e, stage: t, stageSequence: r, roundTarget: i }) {
  return e.filter((n) => {
    var o, s;
    let a = (s = (o = We({ name: Kn, element: n })) == null ? void 0 : o.extension) == null ? void 0 : s.value;
    return (!n.entryStage || n.entryStage === t) && (!r || !n.entryStageSequence || n.entryStageSequence === r) && (!i || !a || a === i) && Yo.includes(n.entryStatus);
  });
}
function X2(e) {
  let t = typeof e.automated == "object" && e.automated.seedsOnly, r = Yd({ ...e, seedsOnly: t });
  if (r.error) return r;
  let i = r == null ? void 0 : r.positionAssignments, n = r == null ? void 0 : r.positioningReport;
  return { conflicts: r.conflicts, positionAssignments: i, positioningReport: n };
}
function Z2(e) {
  let { seededParticipants: t, seedingScaleName: r, entries: i, event: n } = e, a = i.map(Ke);
  t ? Q2({ ...e, enteredParticipantIds: a }) : (n || r) && J2({ ...e, enteredParticipantIds: a });
}
function Q2(e) {
  let { provisionalPositioning: t, enteredParticipantIds: r, seededParticipants: i, tournamentRecord: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, structure: u, event: d } = e, l = u ? qs({ provisionalPositioning: t, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structure: u }) : void 0;
  i.filter(({ participantId: p }) => r.includes(p)).filter((p) => !p.seedNumber || p.seedNumber <= i.length).sort((p, f) => p.seedNumber < f.seedNumber ? -1 : p.seedNumber < f.seedNumber ? 1 : 0).forEach((p) => {
    let { participantId: f, seedNumber: m, seedValue: h } = p;
    tu({ provisionalPositioning: t, tournamentRecord: n, drawDefinition: o, seedingProfile: s, participantId: f, seedBlockInfo: l, structureId: c, seedNumber: m, seedValue: h, event: d });
  });
}
function J2(e) {
  let t = e.seedsCount, { provisionalPositioning: r, enteredParticipantIds: i, seedAssignmentProfile: n, assignSeedsCount: a, tournamentRecord: o, drawDefinition: s, seedByRanking: c, seedingProfile: u, structureId: d, event: l } = e, { categoryName: p, ageCategoryCode: f } = (l == null ? void 0 : l.category) || {}, m = l == null ? void 0 : l.eventType, h = $2({ ...e, ageCategoryCode: f, categoryName: p, eventType: m }) || c && ej({ ...e, ageCategoryCode: f, categoryName: p, eventType: m }), g = (h == null ? void 0 : h.length) ?? 0;
  g < t && (t = g), h == null || h.filter(({ participantId: I }) => i.includes(I)).slice(0, a || t).forEach((I, U) => {
    let v = U + 1, { participantId: S, scaleValue: T } = I, A = (n == null ? void 0 : n[v]) || T || v;
    tu({ provisionalPositioning: r, tournamentRecord: o, drawDefinition: s, seedingProfile: u, participantId: S, structureId: d, seedNumber: v, seedValue: A, event: l });
  });
}
function $2(e) {
  let { tournamentRecord: t, seedingScaleName: r, stageSequence: i, entries: n, stage: a, event: o } = e, { categoryName: s, ageCategoryCode: c } = (o == null ? void 0 : o.category) || {}, u = o == null ? void 0 : o.eventType, d = { scaleName: r || s || c || o.eventId, scaleType: $n, eventType: u };
  return zs({ scaleAttributes: d, tournamentRecord: t, stageSequence: i, entries: n, stage: a }).scaledEntries;
}
function ej(e) {
  let { tournamentRecord: t, stageSequence: r, event: i, entries: n, stage: a } = e, { categoryName: o, ageCategoryCode: s } = (i == null ? void 0 : i.category) || {}, c = i == null ? void 0 : i.eventType;
  return zs({ scaleAttributes: { scaleName: o || s, scaleType: Ya, eventType: c }, tournamentRecord: t, stageSequence: r, entries: n, stage: a }).scaledEntries;
}
function tj(e) {
  let { seedsCount: t } = e;
  e.seededParticipants && (t = e.seededParticipants.length), t > e.drawSize && (t = e.drawSize);
  let r = K2(e);
  t > r.length && (t = r.length);
  let { seedLimit: i } = z2({ enforcePolicyLimits: e.enforcePolicyLimits ?? !0, appliedPolicies: e.appliedPolicies, participantsCount: r.length, seedingProfile: e.seedingProfile, drawDefinition: e.drawDefinition, structureId: e.structureId, seedsCount: t });
  return i && i < t && (t = i), { seedsCount: t, stageEntries: r, seedLimit: i };
}
function rj(e) {
  var S;
  let t = HU({ ...e, modifyOriginal: !1 });
  if (t.error) return t;
  let r = t.drawDefinition, { suppressDuplicateEntries: i = !0, ignoreStageSpace: n, appliedPolicies: a, qualifyingOnly: o, seedingProfile: s, participants: c, drawEntries: u, placeByes: d, drawSize: l, drawType: p, entries: f } = e, m = [], h = [], g = ij({ suppressDuplicateEntries: i, ignoreStageSpace: n, drawDefinition: r, drawEntries: u, drawType: p, entries: f });
  if (g.error) return g;
  let I = p === Go ? 0 : be(e.seedsCount ?? 0), U = eE({ ...e, qualifyingOnly: !l || o, appliedPolicies: a, drawDefinition: r, seedingProfile: s, participants: c, stage: Ie, seedsCount: I, placeByes: d, drawSize: l, entries: f });
  if (U.error && !U.conflicts) return U;
  (S = U.positioningReport) != null && S.length && m.push({ [Ie]: U.positioningReport });
  let v = U.structureId;
  return U.conflicts && (h = U.conflicts), p === Li && e.roundsCount && H2({ ...e, drawDefinition: r, structureId: v }), { drawDefinition: r, positioningReports: m, conflicts: h, structureId: v };
}
function ij(e) {
  let { ignoreStageSpace: t, drawDefinition: r, drawEntries: i, drawType: n, entries: a } = e;
  for (let o of a) {
    if (i && o.entryStage && o.entryStage !== Ie) continue;
    let s = { ...o, ignoreStageSpace: t ?? n === Li, entryStage: o.entryStage ?? Ie, event: e.event, drawDefinition: r, drawType: n }, c = eU(s);
    if (i && c.error) return c;
  }
  return { error: void 0 };
}
var nj = () => ({ matchUpType: void 0, drawName: void 0, drawId: void 0, structures: [], entries: [], links: [] }), aj = nj;
function oj(e) {
  let { drawId: t = st(), processCodes: r, matchUpType: i, drawType: n } = e ?? {}, a = aj();
  return Object.assign(a, { processCodes: r, matchUpType: i, drawType: n, drawId: t });
}
function aS(e) {
  let t = e.structureIds, { tournamentRecord: r, drawDefinition: i, matchUpFormat: n, structureId: a, matchUpId: o, event: s } = e, c = Ae(e, [{ [ii]: !0, [ov]: !0 }]);
  if (c.error) return c;
  if (!Ri({ matchUpFormat: n })) return { error: sd };
  let u = "setMatchUpFormat";
  if (o) {
    let d = bt({ drawDefinition: i, matchUpId: o, event: s });
    if (d.error) return d;
    let l = d.matchUp;
    if ((l == null ? void 0 : l.matchUpType) === or) return { info: "Cannot set matchUpFormat when { matchUpType: TEAM }", error: gi };
    l && (l.matchUpFormat = n, Qe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: s == null ? void 0 : s.eventId, context: u, drawDefinition: i, matchUp: l }));
  } else if (Array.isArray(t)) {
    if ((s == null ? void 0 : s.eventType) === or) return { error: na };
    for (let d of t) {
      let l = Ne({ drawDefinition: i, structureId: d });
      if (l.error) return l;
      l.structure && (l.structure.matchUpFormat = n);
    }
  } else if (a) {
    if ((s == null ? void 0 : s.eventType) === or) return { error: na };
    let d = Ne({ drawDefinition: i, structureId: a });
    if (d.error) return d;
    d.structure && (d.structure.matchUpFormat = n);
  } else i && (i.matchUpFormat = n);
  return t = t ?? (a ? [a] : void 0), vt({ drawDefinition: i, structureIds: t }), { ...j };
}
function sj({ tieFormat: e }) {
  let t = oi({ checkCollectionIds: !1, tieFormat: e });
  if (t.error) return t;
  for (let r of e.collectionDefinitions) r.collectionId || (r.collectionId = st());
  return { tieFormat: e };
}
function cj({ tournamentRecord: e, drawDefinition: t, matchUpFormat: r, matchUpType: i, tieFormat: n, event: a }) {
  if ((r || n) && !(r && (a == null ? void 0 : a.matchUpFormat) === r || a != null && a.tieFormat && n && JSON.stringify(a.tieFormat) === JSON.stringify(n))) {
    if (n) {
      let o = sj({ tieFormat: n });
      if (o.error) return o;
      t.tieFormat = o.tieFormat ?? n;
    } else if (r) {
      let o = aS({ tournamentRecord: e, drawDefinition: t, matchUpFormat: r, event: a });
      if (o.error) return { info: "matchUpFormat or tieFormat error", error: o.error };
    }
    i && (t.matchUpType = i);
  }
  return { error: void 0 };
}
var tE = {};
qe(tE, { attachPolicies: () => Co, findPolicy: () => qo, getAppliedPolicies: () => nt, getPolicyDefinitions: () => Fa, mutate: () => rE, query: () => nE, removePolicy: () => iE });
var rE = {};
qe(rE, { attachPolicies: () => Co, removePolicy: () => iE });
function iE(e) {
  let t = Ae(e, [{ [mL]: !0, _anyOf: { [_r]: !1, [fr]: !1, [ii]: !1, [no]: !1 } }]);
  if (t.error) return t;
  let r, i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i) return LT(e, i);
  if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length) return { error: de };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = LT(e, o);
      if (s.error) return s;
      r = !0;
    }
  } else return { error: de };
  return r ? { ...j } : { error: rs };
}
function LT(e, t) {
  let r = nt(e).appliedPolicies ?? {};
  return r[e.policyType] ? (delete r[e.policyType], Object.keys(r).length ? it({ element: t, extension: { name: qu, value: r } }) : Zr({ element: t, name: qu }), { ...j }) : { error: rs };
}
var nE = {};
qe(nE, { findPolicy: () => qo, getAppliedPolicies: () => nt, getPolicyDefinitions: () => Fa });
var uj = { [Tn]: { validSeedPositions: { ignore: !0 }, duplicateSeedNumbers: !0, drawSizeProgression: !0, seedingProfile: { drawTypes: { [sa]: { positioning: Do }, [hn]: { positioning: Do } }, positioning: nL }, policyName: "USTA SEEDING", seedsCountThresholds: [{ drawSize: 4, minimumParticipantCount: 3, seedsCount: 2 }, { drawSize: 16, minimumParticipantCount: 12, seedsCount: 4 }, { drawSize: 32, minimumParticipantCount: 24, seedsCount: 8 }, { drawSize: 64, minimumParticipantCount: 48, seedsCount: 16 }, { drawSize: 128, minimumParticipantCount: 96, seedsCount: 32 }, { drawSize: 256, minimumParticipantCount: 192, seedsCount: 64 }] } }, eI = uj;
function dj({ appliedPolicies: e, policyDefinitions: t, drawDefinition: r, stack: i }) {
  if (t && typeof t != "object") return W({ info: "policyDefinitions must be an object", result: { error: ie }, stack: i });
  let n = { [cp]: e == null ? void 0 : e[cp] };
  return t ? lj({ policyDefinitions: t, appliedPolicies: e, policiesToAttach: n, drawDefinition: r }) : n.avoidance && Co({ drawDefinition: r, policyDefinitions: n }), !(e != null && e[Tn]) && !(t != null && t[Tn]) && (Co({ policyDefinitions: eI, drawDefinition: r }), e && Object.assign(e, eI)), { error: void 0 };
}
function lj({ policyDefinitions: e, appliedPolicies: t, policiesToAttach: r, drawDefinition: i }) {
  for (let n of Object.keys(e)) JSON.stringify(t == null ? void 0 : t[n]) !== JSON.stringify(e[n]) && (r[n] = e[n]);
  Object.keys(r).length && (Co({ policyDefinitions: r, drawDefinition: i }), t && Object.assign(t, r));
}
function pj(e) {
  var I, U, v, S, T;
  let { tournamentRecord: t, matchUpFormat: r, appliedPolicies: i, policyDefinitions: n, matchUpType: a, tieFormat: o, drawType: s, stack: c, event: u } = e, d = e.drawId ? (I = u == null ? void 0 : u.drawDefinitions) == null ? void 0 : I.find((A) => A.drawId === e.drawId) : void 0;
  d && s !== d.drawType && (d.drawType = s);
  let l = d ?? oj({ processCodes: e.processCodes, drawId: e.drawId, drawType: s }), p = cj({ tournamentRecord: t, drawDefinition: l, matchUpFormat: r, matchUpType: a, tieFormat: o, event: u });
  if (p.error) return W({ result: p, stack: c });
  let f = dj({ appliedPolicies: i, policyDefinitions: n, drawDefinition: l, stack: c });
  if (f.error) return f;
  let m = (v = (U = d == null ? void 0 : d.structures) == null ? void 0 : U.find((A) => A.stage === Ie && A.stageSequence === 1)) == null ? void 0 : v.structureId, h = d ? (S = d.structures) == null ? void 0 : S.filter((A) => A.stage === Pe) : [], g = (h == null ? void 0 : h.length) === 1 && !((T = h[0].matchUps) != null && T.length) && h[0].structureId;
  return { drawDefinition: l, structureId: m, existingDrawDefinition: d, existingQualifyingPlaceholderStructureId: g };
}
function fj(e) {
  var d, l;
  let t = "generateOrGetExisting", r = [], i = [], n = pj(e);
  if (n.error) return W({ result: n, stack: t });
  let a = n.existingDrawDefinition, o = n.drawDefinition ?? {}, s = n.structureId, c = e.drawEntries ?? e.eventEntries ?? [], u = n.existingQualifyingPlaceholderStructureId && V2({ ...e, ...n }) || rj({ ...e, ...n, entries: c });
  return u.error ? W({ result: u, stack: t }) : ((d = u.positioningReports) != null && d.length && r.push(...u.positioningReports ?? []), (l = u.conflicts) != null && l.length && i.push(...u.conflicts ?? []), o = u.drawDefinition, s = u.structureId, { existingDrawDefinition: a, positioningReports: r, drawDefinition: o, structureId: s, conflicts: i, entries: c });
}
function mj(e) {
  var h, g, I;
  let { qualifyingPlaceholder: t, qualifyingProfiles: r, existingDrawDefinition: i, positioningReports: n, appliedPolicies: a, qualifyingOnly: o, drawDefinition: s, seedingProfile: c, participants: u, structureId: d, entries: l, stack: p } = e, f = t && !(r != null && r.length) && !i, m = [];
  if (r) {
    let U = (A, y) => A.stageSequence - y.stageSequence, v = (A, y) => A.roundTarget - y.roundTarget, S = [], T = 1;
    r.sort(v);
    for (let A of r) {
      if (!Array.isArray(A.structureProfiles)) return W({ info: Oo("structureProfiles"), result: { error: we }, stack: p });
      T = A.roundTarget || T;
      let y = ((h = A.structureProfiles) == null ? void 0 : h.sort(U)) || [], D = 1;
      for (let P of y) {
        let { qualifyingRoundNumber: w, qualifyingPositions: R, seededParticipants: b, seedingScaleName: E, seedsCount: O = 0, seedByRanking: M, placeByes: N, drawSize: C } = P, F = eE({ ...e, seedingProfile: P.seedingProfile ?? c, stageSequence: D, qualifyingRoundNumber: w, preparedStructureIds: S, qualifyingPositions: R, seededParticipants: b, stage: Pe, seedingScaleName: E, appliedPolicies: a, drawDefinition: s, qualifyingOnly: o, seedByRanking: M, participants: u, roundTarget: T, seedsCount: O, placeByes: N, drawSize: C, entries: l });
        if (F.error) return F;
        F.structureId && S.push(F.structureId), D += 1, (g = F.conflicts) != null && g.length && m.push(...F.conflicts), (I = F.positioningReport) != null && I.length && n.push({ [Pe]: F.positioningReport });
      }
      T += 1;
    }
  } else if (d && f) {
    let U = zi({ structureName: Fr(Pe), stage: Pe }), { link: v } = zd({ sourceStructureId: U.structureId, targetStructureId: d, sourceRoundNumber: 0, linkType: Aa });
    s.structures || (s.structures = []), s.structures.push(U), s.links || (s.links = []), s.links.push(v);
  }
  return { qualifyingConflicts: m, error: void 0 };
}
var aE = {};
qe(aE, { addGoesTo: () => Eo, allCompetitionMatchUps: () => On, allDrawMatchUps: () => Qr, allEventMatchUps: () => ma, allPlayoffPositionsFilled: () => gU, allTournamentMatchUps: () => Pr, analyzeDraws: () => tl, analyzeMatchUp: () => ed, analyzeTournament: () => hS, bulkUpdatePublishedEventIds: () => IS, calculateWinCriteria: () => Xs, categoryCanContain: () => pd, checkMatchUpIsComplete: () => yo, checkValidEntries: () => Bm, compareTieFormats: () => Na, competitionScheduleMatchUps: () => ul, courtGridRows: () => nh, credits: () => hj, drawMatchUps: () => ES, eventMatchUps: () => sh, filterMatchUps: () => ga, filterParticipants: () => jd, findDrawDefinition: () => GU, findExtension: () => We, findVenue: () => fa, getAggregateTeamResults: () => mS, getAllDrawMatchUps: () => ur, getAllEventData: () => vS, getAllStructureMatchUps: () => ut, getAllowedDrawTypes: () => zm, getAllowedMatchUpFormats: () => lS, getAppliedPolicies: () => nt, getAssignedParticipantIds: () => Ko, getAvailableMatchUpsCount: () => Lm, getAvailablePlayoffProfiles: () => Kd, getCategoryAgeDetails: () => fs, getCheckedInParticipantIds: () => Bs, getCompetitionDateRange: () => Xm, getCompetitionMatchUps: () => $u, getCompetitionParticipants: () => oS, getCompetitionPenalties: () => pS, getCompetitionVenues: () => al, getCourtInfo: () => Um, getCourts: () => OS, getDrawData: () => Jm, getDrawDefinitionTimeItem: () => xv, getDrawParticipantRepresentativeIds: () => BU, getDrawStructures: () => In, getDrawTypeCoercion: () => rl, getEligibleVoluntaryConsolationParticipants: () => xU, getEntriesAndSeedsCount: () => ah, getEvent: () => kS, getEventData: () => $m, getEventMatchUpFormatTiming: () => AS, getEventProperties: () => CS, getEventPublishStatus: () => nn, getEventStructures: () => Rm, getEventTimeItem: () => Dd, getEvents: () => FS, getFlightProfile: () => Ht, getHomeParticipantId: () => wS, getLinkedTournamentIds: () => yd, getMatchUpCompetitiveProfile: () => Cd, getMatchUpContextIds: () => RS, getMatchUpDailyLimits: () => uh, getMatchUpDailyLimitsUpdate: () => TS, getMatchUpDependencies: () => An, getMatchUpFormat: () => bS, getMatchUpFormatTiming: () => Fd, getMatchUpFormatTimingUpdate: () => yS, getMatchUpScheduleDetails: () => Sm, getMatchUpType: () => ym, getMatchUpsMap: () => xr, getMatchUpsStats: () => NS, getMatchUpsToSchedule: () => eh, getMaxEntryPosition: () => SS, getModifiedMatchUpFormatTiming: () => oh, getPairedParticipant: () => vn, getParticipantEventDetails: () => sS, getParticipantIdFinishingPositions: () => VU, getParticipantMembership: () => cS, getParticipantResults: () => Qd, getParticipantScaleItem: () => Ec, getParticipantSchedules: () => uS, getParticipantSignInStatus: () => dS, getParticipantTimeItem: () => Bv, getParticipants: () => Lt, getPersonRequests: () => Qo, getPolicyDefinitions: () => Fa, getPositionAssignments: () => Zu, getPositionsPlayedOff: () => iu, getPredictiveAccuracy: () => PS, getProfileRounds: () => ih, getPublishState: () => _s, getRoundMatchUps: () => $r, getRounds: () => MS, getScaleValues: () => zc, getScaledEntries: () => zs, getScheduledRoundsDetails: () => ol, getSchedulingProfile: () => Ba, getSchedulingProfileIssues: () => US, getSeedingThresholds: () => dU, getSeedsCount: () => il, getStructureSeedAssignments: () => Qi, getTeamLineUp: () => Mo, getTieFormat: () => Qm, getTimeItem: () => en, getTournamentIds: () => Ud, getTournamentInfo: () => Ks, getTournamentPenalties: () => Km, getTournamentPersons: () => fS, getTournamentPoints: () => Zm, getTournamentPublishStatus: () => Gd, getTournamentStructures: () => hU, getTournamentTimeItem: () => mm, getValidGroupSizes: () => qd, getVenueData: () => Rc, getVenuesAndCourts: () => xa, isAdHoc: () => si, isCompletedStructure: () => $a, isValidForQualifying: () => WU, isValidMatchUpFormat: () => Ri, matchUpActions: () => xm, participantScaleItem: () => ta, participantScheduledMatchUps: () => DS, positionActions: () => _U, publicFindCourt: () => Xv, publicFindVenue: () => Kv, tallyParticipantResults: () => nu, tieFormatGenderValidityCheck: () => Hf, tournamentMatchUps: () => ch, validMatchUp: () => hm, validMatchUps: () => rn, validateCollectionDefinition: () => fd, validateLineUp: () => wm });
function hj() {
  return `
    This project would not have been possible without the generous input and patience
    of tournament organizers and directors who worked with early versions of CourtHive/TMX.

    Thanks to Pavel, Ivan, Mladen, Zdenko, Antonia, Jakov, Kreso, Barry, Jeff, Bobby... to name just a few. 

    The project would not have even begun without the support of Miro, or the introduction by Sretchko.
    The project would not have succeeded without the enthusiasm of Randy and Bruce.
    Thanks to serendipity and Luca and the ensuing TODS conversations with ITF.
    Thanks to Scott and Jake for sanity checks, suggestions, and camaraderie.
    Thanks to Zoran for inspiring the async support and getting into the weeds with subscriptions.
    Thanks to Dave for backing the conversion of TMX 1.x source into the factory repository.
    Thanks to Vuk and Pavle and Rich and Chris and Deepa for the direct engagement with the APIs.
    Thanks to Joe for repeatedly challenging me and the many pointers to useful tooling.
    Thanks to Shannon for the validation of the approach from his deep domain experience.
    Thanks to Nikola for the ongoing camaraderie and explorations of what we can do with TODS.

    And a special thanks to my family for putting up with the long days and weeks and months of coding
    and conversations at all hours.
  `;
}
var oE = {};
qe(oE, { filterParticipants: () => jd, getCompetitionParticipants: () => oS, getPairedParticipant: () => vn, getParticipantEventDetails: () => sS, getParticipantMembership: () => cS, getParticipantScaleItem: () => Ec, getParticipantSchedules: () => uS, getParticipantSignInStatus: () => dS, getParticipantTimeItem: () => Bv, getParticipants: () => Lt, getScaleValues: () => zc, participantScaleItem: () => ta, validateLineUp: () => wm });
function oS(e) {
  let { tournamentRecords: t } = e || {};
  if (typeof t != "object" || !Object.keys(t).length) return { error: xt };
  let r = [], i = {}, n = {}, a = {}, o = [], s = {}, c = [];
  for (let u of Object.values(t)) {
    let { participantIdsWithConflicts: d, mappedMatchUps: l, participantMap: p, participants: f, matchUps: m, derivedEventInfo: h, derivedDrawInfo: g } = Lt({ ...e, tournamentRecord: u });
    Object.assign(s, l), Object.assign(i, p), Object.assign(n, h), Object.assign(a, g), r.push(...f ?? []), o.push(...m ?? []), d == null || d.forEach((I) => {
      c.includes(I) || c.push(I);
    });
  }
  return { participantIdsWithConflicts: c, derivedEventInfo: n, derivedDrawInfo: a, participantMap: i, mappedMatchUps: s, participants: r, ...j, matchUps: o };
}
function sS({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: de };
  if (!t) return { error: cr };
  let r = [t].concat((e.participants ?? []).filter((i) => {
    var n;
    return (i == null ? void 0 : i.participantType) && [lt, _e].includes(i.participantType) && ((n = i.individualParticipantIds) == null ? void 0 : n.includes(t));
  }).map((i) => i.participantId));
  return { eventDetails: (e.events ?? []).filter((i) => {
    let n = ((i == null ? void 0 : i.entries) ?? []).map((a) => a.participantId);
    return Jr(n, r);
  }).map((i) => ({ eventName: i.eventName, eventId: i.eventId })) };
}
function cS({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: de };
  if (!t) return { error: cr };
  let { participants: r } = Lt({ participantFilters: { participantTypes: [lt, _e, Gi] }, tournamentRecord: e });
  return (r ?? []).filter((i) => {
    var n;
    return (n = i.individualParticipantIds) == null ? void 0 : n.includes(t);
  }).reduce((i, n) => {
    let a = n.participantType;
    return a && (i[a] || (i[a] = []), i[a].push(n)), i;
  }, {});
}
function uS({ participantFilters: e = {}, tournamentRecord: t }) {
  if (!t) return { error: de };
  if (typeof e != "object") return { error: Ea, context: { participantFilters: e } };
  let r = { eventIds: e.eventIds }, i = Pr({ tournamentRecord: t, contextFilters: r }).matchUps ?? [], n = Object.assign({}, ...i.map((c) => ({ [c.matchUpId]: c }))), a = i.filter(({ schedule: c }) => c && Object.keys(c).length), o = An({ tournamentRecord: t, matchUps: i }).sourceMatchUpIds ?? [], s = {};
  for (let c of a) {
    let { sides: u } = c, d, l = (u == null ? void 0 : u.map((f) => {
      if (f.participant) return [f.participant].concat(...f.participant.individualParticipants || []);
      o[c.matchUpId] && !d && (d = (o[c.matchUpId] || []).map((m) => n[m]).filter(({ winningSide: m, bye: h }) => !m && !h));
    }).filter(Boolean).flat()) ?? [];
    for (let f of l) {
      let { participantId: m } = f;
      s[m] || (s[m] = { potentialMatchUps: [], participant: f, matchUps: [] }), s[m].matchUps.push(c);
    }
    let p = (d == null ? void 0 : d.map(({ sides: f }) => f).flat().map(({ participant: f }) => f && [f].concat(...f.individualParticipants || [])).filter(Boolean).flat()) || [];
    for (let f of p) {
      let { participantId: m } = f;
      s[m] || (s[m] = { potentialMatchUps: [], participant: f, matchUps: [] }), s[m].potentialMatchUps.push(c);
    }
  }
  return { participantSchedules: Object.values(s).filter(({ participant: c }) => !(e.participantIds && !e.participantIds.includes(c.participantId) || e.participantTypes && !e.participantTypes.includes(c.participantType))), ...j };
}
function dS({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: de };
  if (!t) return { error: cr };
  let { participant: r } = co({ tournamentRecord: e, participantId: t });
  if (!r) return { error: Yt };
  let { timeItem: i } = en({ itemType: Td, element: r });
  return i && i.itemValue === Yu && Yu;
}
var sE = {};
qe(sE, { analyzeDraws: () => tl, analyzeTournament: () => hS, getAggregateTeamResults: () => mS, getAllowedDrawTypes: () => zm, getAllowedMatchUpFormats: () => lS, getAppliedPolicies: () => nt, getCompetitionDateRange: () => Xm, getCompetitionPenalties: () => pS, getPolicyDefinitions: () => Fa, getTournamentInfo: () => Ks, getTournamentPenalties: () => Km, getTournamentPersons: () => fS, getTournamentPoints: () => Zm, getTournamentStructures: () => hU, getTournamentTimeItem: () => mm });
function lS({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  var n;
  if (!e) return { error: de };
  let { appliedPolicies: i } = nt({ tournamentRecord: e });
  return (((n = i == null ? void 0 : i[En]) == null ? void 0 : n.matchUpFormats) || []).filter(({ categoryNames: a, categoryTypes: o }) => !t && !o || t && (a == null ? void 0 : a.includes(t)) || r && (o == null ? void 0 : o.includes(r)));
}
function zm({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  var n;
  if (!e) return { error: de };
  let { appliedPolicies: i } = nt({ tournamentRecord: e });
  return (((n = i == null ? void 0 : i[up]) == null ? void 0 : n.allowedDrawTypes) || []).filter(({ categoryNames: a, categoryTypes: o }) => !t && !o || t && (a == null ? void 0 : a.includes(t)) || r && (o == null ? void 0 : o.includes(r)));
}
function Km({ tournamentRecord: e }) {
  if (!e) return { error: de };
  let t = ((e == null ? void 0 : e.participants) ?? []).reduce((r, i) => {
    let { participantId: n } = i;
    return (i.penalties ?? []).forEach((a) => {
      let { penaltyId: o } = a || {};
      r[o] ? r[o].participants.push(n) : r[o] = { ...a, participantIds: [n] };
    }), r;
  }, {});
  return { penalties: Object.values(t) };
}
function pS({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let t = [];
  for (let r of Object.values(e)) {
    let { penalties: i } = Km({ tournamentRecord: r });
    t.push(...i ?? []);
  }
  return { penalties: t };
}
function cE({ event: e }) {
  return { eventInfo: (({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: d, ballType: l, discipline: p, onlineResources: f, notes: m }) => ({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: d, ballType: l, discipline: p, onlineResources: f, notes: m }))(e) };
}
var gj = { [vd]: { policyName: "Staff Privacy Policy", participant: { contacts: !1, individualParticipants: !1, individualParticipantIds: !1, onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantRoleResponsibilities: !0, participantStatus: !0, penalties: !1, representing: !0, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } } } }, Ij = gj;
function Ks(e) {
  var s, c, u, d;
  let { tournamentRecord: t } = e ?? {};
  if (!t) return { error: de };
  let r = (({ tournamentId: l, tournamentRank: p, tournamentStatus: f, formalName: m, tournamentName: h, promotionalName: g, onlineResources: I, localTimeZone: U, activeDates: v, startDate: S, endDate: T, hostCountryCode: A, venues: y, notes: D, updatedAt: P }) => ({ tournamentId: l, tournamentRank: p, tournamentStatus: f, formalName: m, tournamentName: h, promotionalName: g, onlineResources: I, localTimeZone: U, activeDates: v, startDate: S, endDate: T, hostCountryCode: A, venues: y, notes: D, updatedAt: P }))(t), i = ((s = Lt({ participantFilters: { participantRoles: [yN, rU, AN, TN, PN] }, policyDefinitions: Ij, tournamentRecord: t })) == null ? void 0 : s.participants) ?? [];
  i && (r.tournamentContacts = i);
  let n = (c = _s({ tournamentRecord: t })) == null ? void 0 : c.publishState, a = ((d = (u = n == null ? void 0 : n.tournament) == null ? void 0 : u.status) == null ? void 0 : d.publishedEventIds) || [], o = [];
  for (let l of t.events ?? []) if (!(e != null && e.usePublishState) || a.includes(l.eventId)) {
    let p = cE({ event: l }).eventInfo;
    p && o.push(p);
  }
  return r.timeItemValues = MM({ element: t }), r.publishState = n == null ? void 0 : n.tournament, r.eventInfo = o, { tournamentInfo: ge(ye(r), !1, !0), ...j };
}
function Xm({ tournamentRecords: e }) {
  if (!$e(e)) return { error: xt };
  let t = Object.keys(e ?? {}).reduce((n, a) => {
    let o = e[a], { tournamentInfo: { startDate: s, endDate: c } } = Ks({ tournamentRecord: o }), u = s && new Date(Ve(s));
    (!n.startDate || u && u < n.startDate) && (n.startDate = u);
    let d = c && new Date(Ve(c));
    return (!n.endDate || d && d > n.endDate) && (n.endDate = d), n;
  }, { startDate: void 0, endDate: void 0 }), r = t.startDate && Ve(t.startDate.toISOString()), i = t.endDate && Ve(t.endDate.toISOString());
  return !r || !i ? { error: dw } : { startDate: r, endDate: i };
}
function fS({ tournamentRecord: e, participantFilters: t }) {
  if (!e) return { error: de };
  let r = e.participants || [];
  t && (r = jd({ participants: r, participantFilters: t, tournamentRecord: e }));
  let i = {}, n = (a) => {
    if (a.person) {
      let { personId: o } = a.person;
      i[o] ? i[o].participantIds.push(a.participantId) : i[o] = { ...a.person, participantIds: [a.participantId] };
    }
  };
  return r.forEach((a) => {
    a.person && n(a);
  }), { tournamentPersons: Object.values(i) };
}
function mS(e) {
  var l, p, f, m, h, g, I, U;
  let t = Ae(e, [{ [fr]: !0 }]);
  if (t.error) return t;
  let r = e.finishingPositionRangeBounsPoints || {}, i = {}, n = (v) => {
    var T, A, y;
    let S = (T = v == null ? void 0 : v.individualParticipants) == null ? void 0 : T.map((D) => {
      var P;
      return ((P = D.teams) == null ? void 0 : P.length) === 1 && D.teams[0];
    });
    return ((A = v == null ? void 0 : v.teams) == null ? void 0 : A.length) === 1 && ((y = v == null ? void 0 : v.teams) == null ? void 0 : y[0]) || (S == null ? void 0 : S[0].participantId) === (S == null ? void 0 : S[1].participantId) && (S == null ? void 0 : S[0]);
  }, { matchUps: a, participants: o } = Lt({ participantFilters: { participantTypes: [Xe] }, withRankingProfile: !0, withStatistics: !0, ...e });
  for (let v of o ?? []) {
    if (v.participantType === ai) continue;
    ((p = (l = v.draws) == null ? void 0 : l[0]) == null ? void 0 : p.drawId) === "draw-0-3" && console.log(v.participantType, v.draws[0].finishingPositionRange);
    let S = n(v);
    if (S) for (let T of (v == null ? void 0 : v.draws) ?? []) {
      let A = (f = T == null ? void 0 : T.finishingPositionRange) == null ? void 0 : f.join("-");
      if (A && (r != null && r[A])) {
        let y = S == null ? void 0 : S.participantId, D = T == null ? void 0 : T.drawId, P = `${y}|${D}|${A}`;
        i[P] = r[A];
      }
    }
  }
  let s = (v) => ({ teamName: v, standingPoints: 0, pointsPlayed: 0, pointsPct: 0, points: 0, bonus: 0, diff: 0, loss: 0, win: 0 }), c = (v, S, T) => {
    v[S] === void 0 && (v[S] = 0), v[S] += T;
  }, u = {}, d = {};
  for (let v of a ?? []) {
    let { sides: S, matchUpFormat: T } = v, A = T && ti(T);
    if ((S == null ? void 0 : S.length) === 2 && ((m = A.setFormat) != null && m.timed) && (!A.finalSetFormat || (h = A.finalSetFormat) != null && h.timed)) for (let y of S) {
      let D = n(y.participant), P = D == null ? void 0 : D.participantId, w = (g = y.participant) == null ? void 0 : g.participantId, R = D == null ? void 0 : D.participantName, b = y.sideNumber, E = ((I = y.participant) == null ? void 0 : I.individualParticipantIds) || w && [w] || [];
      if (E.forEach((O) => {
        O && !u[O] && (u[O] = s(R));
      }), P && b) {
        d[P] || (d[P] = s(R));
        let O = [...E.map((N) => u[N]), d[P]];
        v.winningSide && (b === v.winningSide ? O.forEach((N) => c(N, "win", 1)) : O.forEach((N) => c(N, "loss", 1)));
        let M = ((U = v.score) == null ? void 0 : U.sets) || [];
        for (let N of M) {
          let C = (N == null ? void 0 : N[`side${3 - b}Score`]) || 0, F = (N == null ? void 0 : N[`side${b}Score`]) || 0, x = F - C;
          O.forEach((V) => c(V, "pointsPlayed", F + C)), O.forEach((V) => c(V, "points", F)), O.forEach((V) => c(V, "diff", x));
        }
      }
    }
  }
  for (let v of Object.keys(i)) {
    let [S] = v.split("|");
    d[S] && (d[S].bonus += i[v], d[S].pointsPct = parseFloat((d[S].points / d[S].pointsPlayed).toFixed(2)), d[S].standingPoints = d[S].win + d[S].bonus);
  }
  for (let v of Object.keys(u)) u[v].pointsPct = parseFloat((u[v].points / u[v].pointsPlayed).toFixed(2));
  return { ...j, individualResults: u, teamResults: d };
}
function vj(e) {
  var a, o, s, c, u, d, l;
  let t = ((o = (a = e.participants) == null ? void 0 : a.filter(({ participantType: p }) => p === lt)) == null ? void 0 : o.length) === 2, r = ((s = e.events) == null ? void 0 : s.length) === 1 && e.events[0], i = ((c = r == null ? void 0 : r.drawDefinitions) == null ? void 0 : c.length) === 1 && r.drawDefinitions[0], n = ((l = (d = ((u = i == null ? void 0 : i.structures) == null ? void 0 : u.length) === 1 && i.structures[0]) == null ? void 0 : d.positionAssignments) == null ? void 0 : l.length) === 2;
  return !!(r.tieFormat && t && n);
}
function hS({ tournamentRecord: e }) {
  var n;
  if (!e) return { error: de };
  let { drawsAnalysis: t } = tl({ tournamentRecord: e }), r = { isDual: vj(e), drawsAnalysis: t }, i = Lt({ tournamentRecord: e });
  return (n = i.missingParticipantIds) != null && n.length && (r.missingParticipantIds = i.missingParticipantIds), { ...j, analysis: r };
}
function uE(e, t) {
  return e && t && Array.isArray(t) && t[e - 1] || typeof t == "object" && t[e];
}
function Uj(e) {
  let { participation: t = {}, awardProfiles: r, startDate: i, eventType: n, drawSize: a, drawType: o, category: s, endDate: c, level: u } = e, { participationOrder: d, flightNumber: l, rankingStage: p } = t, f = (m) => !i && !c || !m.dateRanges ? !0 : m.dateRanges.some((h) => {
    let g = !i || !h.startDate || new Date(i) > new Date(h.startDate), I = !c || !h.endDate || new Date(c) <= new Date(h.endDate);
    return g && I;
  });
  return { awardProfile: r.find((m) => {
    var h, g, I, U, v, S, T, A, y, D;
    return f(m) && (!m.maxFlightNumber || l <= m.maxFlightNumber) && (!((h = m.drawTypes) != null && h.length) || ((g = m.drawTypes) == null ? void 0 : g.includes(o))) && (!((I = m.drawSizes) != null && I.length) || m.drawSizes.includes(a)) && (!((U = m.stages) != null && U.length) || m.stages.includes(p)) && (!((v = m.levels) != null && v.length) || m.levels.includes(u)) && (!m.maxDrawSize || a <= m.maxDrawSize) && (!m.drawSize || m.drawSize === a) && (!m.maxLevel || u <= m.maxLevel) && (!l || !((T = (S = m.flights) == null ? void 0 : S.flightNumbers) != null && T.length) || m.flights.flightNumbers.includes(l)) && (!m.participationOrder || m.participationOrder === d) && (!((A = m.category) != null && A.ageCategoryCodes) || m.category.ageCategoryCodes.includes(s == null ? void 0 : s.ageCategoryCode)) && (!((y = m.eventTypes) != null && y.length) || ((D = m.eventTypes) == null ? void 0 : D.includes(n)));
  }) };
}
function xT({ participantWon: e, flightNumber: t, valueObj: r, drawSize: i, flights: n, level: a }) {
  var m, h;
  let o = (g, I) => {
    if (g) {
      if (Array.isArray(I)) {
        let U = I.find((v) => v.flight === g || v.f === g);
        return U.value || U.v;
      }
      if (typeof I == "object") {
        let U = I.flights || I.f;
        if (Array.isArray(U)) return U[g - 1];
      }
    }
  }, s = (g, I) => {
    let U = (g == null ? void 0 : g.value) || (g == null ? void 0 : g.v) || (ke(g) ? g : 0), v = uE(a, g == null ? void 0 : g.level);
    return { value: o(I, v) || ke(v) && v || U };
  }, c = 0, u, d, l, p, f = e && "won" || e === !1 && "lost" || void 0;
  if (Array.isArray(r)) {
    let g = r.find((v) => {
      var S;
      return v.drawSize === i || ((S = v.drawSizes) == null ? void 0 : S.includes(i));
    }), I = r.find((v) => v.drawSize && v.threshold && i > v.drawSize), U = r.find((v) => {
      var S;
      return !v.drawSize && !((S = v.drawSizes) != null && S.length);
    });
    f !== void 0 && (g = g == null ? void 0 : g[f], I = I == null ? void 0 : I[f], U = U == null ? void 0 : U[f]), d = s(g, t).value, l = s(I, t).value, p = s(U, t).value, c = d || l || p, u = d && g.requireWin || l && I.requireWin || (U == null ? void 0 : U.requireWin);
  } else if (typeof r == "object") {
    let g = (m = r == null ? void 0 : r.drawSizes) == null ? void 0 : m[i], I = r;
    f !== void 0 && (g = g == null ? void 0 : g[f], I = I == null ? void 0 : I[f]), d = s(g, t).value, p = s(I, t).value, c = d || p, u = d ? g.requireWin : I == null ? void 0 : I.requireWin;
  } else ke(r) && f === void 0 && (c = r);
  return t && ((h = n == null ? void 0 : n.pct) != null && h[t]) && (c = Math.round(c * n.pct[t])), { awardPoints: c, requireWin: u };
}
function Zm({ participantFilters: e, policyDefinitions: t, tournamentRecord: r, level: i }) {
  var I;
  if (!r) return { error: de };
  let { policyDefinitions: n } = Fa({ policyTypes: [Gl], tournamentRecord: r }), a = (t == null ? void 0 : t[Gl]) ?? (n == null ? void 0 : n[Gl]);
  if (!a) return { error: Mf };
  let o = a.awardProfiles, s = a.requireWinFirstRound, c = a.requireWinForPoints, { participants: u, derivedEventInfo: d, derivedDrawInfo: l, mappedMatchUps: p } = Lt({ withRankingProfile: !0, participantFilters: e, tournamentRecord: r }), f = u == null ? void 0 : u.filter((U) => {
    var v;
    return (v = U.draws) == null ? void 0 : v.length;
  }), m = {}, h = {}, g = {};
  for (let U of f ?? []) {
    let { participantType: v, participantId: S, person: T, draws: A } = U;
    for (let y of A) {
      let { drawId: D, structureParticipation: P, eventId: w } = y, R = d[w], b = l[D], E = b == null ? void 0 : b.drawType, { category: O, eventType: M } = R || {}, N = y.startDate || R.startDate || r.startDate, C = y.endDate || R.endDate || r.endDate;
      if (M === bi && S !== ai) continue;
      let F;
      if (o) {
        let x = c, V = 0, k = 0, L = 0, B;
        for (let G of P) {
          let { finishingPositionRange: q, participationOrder: Y, participantWon: H, flightNumber: X, rankingStage: z, winCount: Z } = G;
          V += Z || 0;
          let te = b == null ? void 0 : b.drawSize, { awardProfile: ne } = Uj({ awardProfiles: o, participation: G, eventType: M, startDate: N, category: O, drawSize: te, drawType: E, endDate: C, level: i });
          if (ne) {
            if (!te) continue;
            let ee = Array.isArray(q) && Math.max(...q), K = Be(q || []).join("-"), J = ee && z !== Pe && (q == null ? void 0 : q.includes(te));
            ne.requireWinForPoints !== void 0 && (x = ne.requireWinForPoints), ne.requireWinFirstRound !== void 0 && (s = ne.requireWinFirstRound);
            let { finishingPositionPoints: $ = {}, finishingPositionRanges: ae, finishingRound: oe, pointsPerWin: ce, flights: se } = ne, Te = Array.isArray(ne.perWinPoints) ? (I = ne.perWinPoints) == null ? void 0 : I.find((Ge) => {
              var Bt;
              return (Bt = Ge.participationOrders) == null ? void 0 : Bt.includes(Y);
            }) : ne.perWinPoints, xe = $.participationOrders, me = 0, rt;
            if ((!xe || xe.includes(Y)) && ae && ee) {
              let Ge = ae[ee];
              Ge && ({ awardPoints: me, requireWin: rt } = xT({ flightNumber: X, valueObj: Ge, drawSize: te, flights: se, level: i }));
            }
            if (!me && oe && Y === 1 && ee) {
              let Ge = oe[ee];
              Ge && ({ awardPoints: me, requireWin: rt } = xT({ participantWon: H, flightNumber: X, valueObj: Ge, drawSize: te, flights: se, level: i }));
            }
            if (J && s !== void 0 && (x = s), rt !== void 0 && (x = rt), me > k && (!x || Z) && (k = me, B = ee), !me && ce && Z && (L += Z * ce, B = K), !me && Z && Te) {
              let Ge = uE(i, Te == null ? void 0 : Te.level);
              Ge ? L += Z * Ge : Te.value && (L += Z * Te.value);
            }
          }
          if (F = k + L, v === ai) {
            let ee = (U.matchUps || []).filter(({ structureId: K }) => K === G.structureId);
            for (let { matchUpId: K } of ee) {
              let J = p[K], $ = J.sides.find((ae) => ae.participantId === S).sideNumber;
              if (J.winningSice === $) for (let ae of J.tieMatchUps) ae.winningSide;
            }
          }
        }
        if (L || k) {
          let G = { winCount: V, positionPoints: k, rangeAccessor: B, perWinPoints: L, eventType: M, drawId: D, points: F }, q = T == null ? void 0 : T.personId;
          q ? (m[q] || (m[q] = []), m[q].push(G)) : v === _e ? (g[S] || (g[S] = []), g[S].push(G)) : v === ai && (h[S] || (h[S] = []), h[S].push(G));
        }
      }
    }
  }
  return { participantsWithOutcomes: f, personPoints: m, pairPoints: g, teamPoints: h, ...j };
}
var dE = {};
qe(dE, { compareTieFormats: () => Na, getTieFormat: () => Qm, tieFormatGenderValidityCheck: () => Hf, validateCollectionDefinition: () => fd });
function bp(e) {
  var n;
  if (!e) return {};
  let t = [], r = e.tieFormatName, i = (n = e.collectionDefinitions) == null ? void 0 : n.map((a) => {
    let { matchUpType: o, matchUpFormat: s, matchUpCount: c, category: u, gender: d } = a;
    t.includes(s) || t.push(s);
    let l = u == null ? void 0 : u.ageCategoryCode;
    return [c, o === Ao ? "D" : "S", l, s, d].join(";");
  }).join("|");
  return { tieFormatName: e && r || "UNNAMED", matchUpFormats: t, tieFormatDesc: i };
}
function Na({ considerations: e = {}, descendant: t, ancestor: r }) {
  var T, A;
  let i = {}, n = {}, { matchUpFormats: a, tieFormatDesc: o } = bp(t), { matchUpFormats: s, tieFormatDesc: c } = bp(r), u = Be((a ?? []).filter((y) => !(s ?? []).includes(y)).concat((s ?? []).filter((y) => !(a ?? []).includes(y)))), d = !!(e != null && e.collectionName && t.collectionDefinitions.map(({ collectionName: y }) => y).join("|") !== r.collectionDefinitions.map(({ collectionName: y }) => y).join("|")), l = !!(e != null && e.collectionOrder && t.collectionDefinitions.map(({ collectionOrder: y }) => y).join("|") !== r.collectionDefinitions.map(({ collectionOrder: y }) => y).join("|")), p = Object.assign({}, ...((t == null ? void 0 : t.collectionDefinitions) || []).map((y) => ({ [y.collectionId]: y }))), f = Object.assign({}, ...((r == null ? void 0 : r.collectionDefinitions) || []).map((y) => ({ [y.collectionId]: y })));
  i.collectionIds = tT(Object.keys(p), Object.keys(f)), n.collectionIds = tT(Object.keys(f), Object.keys(p)), i.collectionsValue = BT(p), n.collectionsValue = BT(f), i.groupsCount = ((T = r == null ? void 0 : r.collectionGroups) == null ? void 0 : T.length) ?? (0 - (((A = t == null ? void 0 : t.collectionGroups) == null ? void 0 : A.length) ?? 0) || 0), n.groupsCount = i.groupsCount ? -1 * i.groupsCount : 0;
  let m = i.collectionsValue.totalValue - n.collectionsValue.totalValue, h = i.collectionsValue.totalMatchUps - n.collectionsValue.totalMatchUps, g = n.collectionsValue.assignmentValues.length !== i.collectionsValue.assignmentValues.length, I = n.collectionsValue.assignmentValues.some((y, D) => {
    let P = i.collectionsValue.assignmentValues[D];
    return !P || y.valueKey !== P.valueKey || y.value !== P.value ? !0 : Array.isArray(y.value) ? y.value.every((w, R) => P.value[R] === w) : !1;
  }), U = d || l || c !== o || g || I || m !== 0, v = [...n.collectionsValue.invalidValues, ...i.collectionsValue.invalidValues], S = v.length && v;
  return { matchUpFormatDifferences: u, matchUpCountDifference: h, descendantDifferences: i, ancestorDifferences: n, orderDifference: l, valueDifference: m, nameDifference: d, descendantDesc: o, ancestorDesc: c, ...j, different: U, invalid: S };
}
function BT(e) {
  let t = [], r = [], i = 0;
  return { totalValue: Object.keys(e).sort(Tm).reduce((n, a) => {
    let o = e[a], { collectionValueProfiles: s, collectionValue: c, matchUpCount: u, matchUpValue: d, scoreValue: l, setValue: p } = o, f = { collectionValueProfiles: s, collectionValue: c, matchUpValue: d, scoreValue: l, setValue: p }, m = Object.keys(f).filter((g) => ![void 0, null].includes(f[g]) && (!Array.isArray(f[g]) || f[g].length > 0));
    m.length !== 1 && t.push({ collectionId: a });
    let h = m[0];
    if (h) {
      let g = h === "collectionValueProfiles" ? Object.values(s) : f[h];
      r.push({ valueKey: h, value: g });
    }
    return i += u, s != null && s.length ? n + s.reduce((g, I) => g + I.value, 0) : u ? ke(d) ? n + d * u : ke(l) ? n + l * u : ke(p) ? n + p * u : n + c : n;
  }, 0), totalMatchUps: i, invalidValues: t, assignmentValues: r };
}
function gS(e) {
  Object.assign(e, { inContext: !0 });
  let { matchUp: t, error: r } = lE(e);
  return { matchUp: ge(t, !0, !0), error: r };
}
function lE({ participantsProfile: e, afterRecoveryTimes: t, tournamentRecord: r, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, matchUpId: s, inContext: c, eventId: u, drawId: d, event: l }) {
  var m;
  if (!r) return { error: de };
  if (typeof s != "string") return { error: zr };
  if (!a || !l) {
    let h = (Pr({ tournamentRecord: r, nextMatchUps: o }).matchUps ?? []).find((g) => g.matchUpId === s);
    if (!h) return { error: jr };
    ({ eventId: u, drawId: d } = h), { event: l, drawDefinition: a } = ci({ tournamentRecord: r, eventId: u, drawId: d });
  }
  if (!a) return { error: Fi };
  n && !i && (i = ka({ tournamentRecord: r, contextProfile: n }));
  let p = { surfaceCategory: (l == null ? void 0 : l.surfaceCategory) ?? r.surfaceCategory, indoorOutDoor: (l == null ? void 0 : l.indoorOutdoor) ?? r.indoorOutdoor, endDate: (l == null ? void 0 : l.endDate) ?? r.endDate, tournamentId: r.tournamentId, eventId: u ?? (l == null ? void 0 : l.eventId), drawId: d }, { participants: f = [] } = Wo({ participantsProfile: e, tournamentRecord: r, contextProfile: n, inContext: c });
  if (o) {
    let h = (Qr({ context: c ? p : void 0, participants: f, afterRecoveryTimes: t, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, inContext: c, event: l }).matchUps ?? []).find((I) => I.matchUpId === s);
    if (!h) return { error: jr };
    let g = (m = a == null ? void 0 : a.structures) == null ? void 0 : m.find((I) => I.structureId === h.structureId);
    return { drawDefinition: a, structure: g, matchUp: h };
  } else {
    let { matchUp: h, structure: g } = bt({ context: c ? p : void 0, tournamentParticipants: f, afterRecoveryTimes: t, contextContent: i, drawDefinition: a, contextProfile: n, matchUpId: s, inContext: c, event: l });
    return { matchUp: h, structure: g, drawDefinition: a };
  }
}
function Qm({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, structure: n, eventId: a, drawId: o, event: s }) {
  var f, m, h, g, I;
  if (!e) return { error: de };
  if (!o && !s && !r && !i) return W({ result: { error: we }, stack: "getTieFormat" });
  a && !s && (s = (f = e.events) == null ? void 0 : f.find((U) => U.eventId === a));
  let c = gS({ tournamentRecord: e, drawDefinition: t, matchUpId: i, drawId: o, event: s });
  if (i && (c != null && c.error)) return c;
  if (!t && (c != null && c.drawDefinition) && (t = c == null ? void 0 : c.drawDefinition), n = n ?? (c == null ? void 0 : c.structure), !n && r && !i) {
    if (!t) return { error: Cn };
    let U = Ne({ drawDefinition: t, structureId: r });
    if (U.error) return U;
    n = U.structure;
  }
  let u = ((n == null ? void 0 : n.tieFormat) || (n == null ? void 0 : n.tieFormatId)) && ((m = Yr({ structure: n, drawDefinition: t, event: s })) == null ? void 0 : m.tieFormat), d = ((t == null ? void 0 : t.tieFormat) || (t == null ? void 0 : t.tieFormatId)) && ((h = Yr({ drawDefinition: t, event: s })) == null ? void 0 : h.tieFormat), l = (g = Yr({ event: s })) == null ? void 0 : g.tieFormat, p = (I = Yr({ matchUp: c == null ? void 0 : c.matchUp, drawDefinition: t, structure: n, event: s })) == null ? void 0 : I.tieFormat;
  return { ...j, matchUp: c == null ? void 0 : c.matchUp, structureDefaultTieFormat: Er(u), eventDefaultTieFormat: Er(l), drawDefaultTieFormat: Er(d), tieFormat: Er(p), structure: n };
}
var pE = {};
qe(pE, { bulkUpdatePublishedEventIds: () => IS, getAllEventData: () => vS, getCourtInfo: () => Um, getDrawData: () => Jm, getEventData: () => $m, getEventPublishStatus: () => nn, getPublishState: () => _s, getTournamentPublishStatus: () => Gd, getVenueData: () => Rc });
function IS({ tournamentRecord: e, outcomes: t }) {
  var n;
  if (!e) return { error: de };
  if (!(t != null && t.length)) return { error: we, info: "Missing outcomes" };
  let r = t.reduce((a, o) => {
    let { drawId: s, eventId: c } = o;
    return c && s && (a[c] ? a[c].includes(s) || a[c].push(s) : a[c] = [s]), a;
  }, {}), i = Object.keys(r);
  return { publishedEventIds: ((n = e.events) == null ? void 0 : n.filter((a) => i.includes(a.eventId))).filter((a) => {
    let o = nn({ event: a }), { drawDetails: s, drawIds: c } = o ?? {}, { eventId: u } = a;
    return r[u].filter((d) => {
      let l = s ? Object.keys(o.drawDetails).filter((p) => $v({ drawId: p, drawDetails: s })) : [];
      return (c == null ? void 0 : c.includes(d)) || l.includes(d);
    }).length;
  }).map((a) => a.eventId), eventIdPublishedDrawIdsMap: r };
}
function fE({ dates: e = [], extension: t }) {
  var i;
  if (!t) return !1;
  if (typeof t.value == "boolean" && t.value) return !0;
  if (!e.length) return !1;
  let r = $e(t.value) ? (i = t.value) == null ? void 0 : i.dates : void 0;
  if (Array.isArray(r)) return r != null && r.length ? !!r.filter((n) => !e.length || e.includes(n)).length : !1;
}
function mE({ convertExtensions: e, ignoreDisabled: t, venue: r, court: i }) {
  var o;
  let n = { ...ge(i, e, !0), venueId: r.venueId }, { extension: a } = We({ name: Pn, element: i });
  if (t && a) {
    let s = $e(a.value) ? (o = a.value) == null ? void 0 : o.dates : void 0, c = (a == null ? void 0 : a.value) === !0 ? [] : n.dateAvailability.map((u) => {
      let d = u.date;
      if (!(!d || s.includes(d))) return u;
    }).filter(Boolean);
    n.dateAvailability = c;
  }
  return { inContextCourt: n };
}
function xa(e) {
  let { convertExtensions: t, ignoreDisabled: r, venueIds: i = [], dates: n } = e, a = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, o = [], s = [], c = [], u = [];
  return Object.keys(a).filter((d) => !e.tournamentId || d === e.tournamentId).forEach((d) => {
    let l = a[d];
    for (let p of l.venues ?? []) if (!(i.length && !i.includes(p.venueId))) {
      if (r) {
        let { extension: f } = We({ name: Pn, element: p });
        if (f != null && f.value) continue;
      }
      o.includes(p.venueId) || (u.push(ge(p, t, !0)), o.push(p.venueId));
      for (let f of p.courts ?? []) if (!s.includes(f.courtId)) {
        if (r) {
          let { extension: h } = We({ name: Pn, element: f });
          if (fE({ extension: h, dates: n })) continue;
        }
        let { inContextCourt: m } = mE({ convertExtensions: t, ignoreDisabled: r, venue: p, court: f });
        c.push(m), s.push(f.courtId);
      }
    }
  }), { courts: c, venues: u, ...j };
}
function Sj({ convertExtensions: e, tournamentRecord: t, ignoreDisabled: r, dates: i }) {
  if (!t) return { error: xt };
  let n = ge(t.venues ?? [], e).filter((o) => {
    if (!r) return o;
    let { extension: s } = We({ name: Pn, element: o });
    return !(s != null && s.value) && o;
  }).filter(Boolean), a = n.reduce((o, s) => {
    let c = ((s == null ? void 0 : s.courts) || []).filter((u) => {
      if (!r && !(i != null && i.length)) return u;
      let { extension: d } = We({ name: Pn, element: u });
      return fE({ extension: d, dates: i });
    }).filter(Boolean).map((u) => {
      let { inContextCourt: d } = mE({ convertExtensions: e, ignoreDisabled: r, venue: s, court: u });
      return d;
    });
    return c.length ? o.concat(c) : o;
  }, []);
  return { venues: n, courts: a };
}
function al({ tournamentRecords: e, requireCourts: t, dates: r }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: xt } : Object.keys(e).reduce((i, n) => {
    let a = e[n], { venues: o } = Sj({ tournamentRecord: a, dates: r });
    return o == null || o.forEach((s) => {
      let { venueId: c, courts: u } = s;
      (!t || u != null && u.length) && !i.venueIds.includes(c) && (i.venues.push(s), i.venueIds.push(c));
    }), i;
  }, { venues: [], venueIds: [] });
}
function vS({ tournamentRecord: e, policyDefinitions: t }) {
  if (!e) return { error: de };
  let r = e.events || [], i = (e == null ? void 0 : e.participants) || [], { tournamentInfo: n } = Ks({ tournamentRecord: e }), { venues: a } = xa({ tournamentRecord: e }), o = r.map((s) => {
    let { eventId: c } = s, u = cE({ event: s }).eventInfo, d = Pd({ tournamentRecord: e, event: s }).scheduleTiming, l = (s.drawDefinitions || []).map((f) => {
      let m = (({ drawId: v, drawName: S, matchUpFormat: T, updatedAt: A }) => ({ matchUpFormat: T, updatedAt: A, drawName: S, drawId: v }))(f), { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: U } = Jc({ requireParticipants: !0, tournamentParticipants: i, context: { eventId: c }, policyDefinitions: t, tournamentRecord: e, inContext: !0, scheduleTiming: d, drawDefinition: f, event: s });
      return { drawInfo: m, matchUps: { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: U } };
    }), p = nn({ event: s });
    return Object.assign(u, { drawsData: l, publish: p }), u;
  });
  return { allEventData: { tournamentInfo: n, venuesData: a, eventsData: o } };
}
function hE({ publishStatus: e, drawId: t }) {
  var r, i, n;
  return e != null && e.drawDetails ? (n = (i = (r = e.drawDetails) == null ? void 0 : r[t]) == null ? void 0 : i.publishingDetail) == null ? void 0 : n.published : e != null && e.drawIds ? e.drawIds.includes(t) : !0;
}
var gE = "PUBLIC", yj = "ADMIN", Aj = { PUBLIC_DISPLAY: gE, ADMIN_DISPLAY: yj };
function Jm(e) {
  var b, E, O;
  let { tournamentParticipants: t = [], includePositionAssignments: r, policyDefinitions: i, tournamentRecord: n, inContext: a = !0, usePublishState: o, status: s = ji, pressureRating: c, refreshResults: u, contextProfile: d, drawDefinition: l, noDeepCopy: p, sortConfig: f, context: m, event: h } = e;
  if (!l) return { error: Ue };
  let g = (({ matchUpFormat: M, updatedAt: N, drawType: C, drawName: F, drawId: x }) => ({ matchUpFormat: M, updatedAt: N, drawName: F, drawType: C, drawId: x }))(l);
  g.display = (b = We({ element: l, name: dp }).extension) == null ? void 0 : b.value;
  let I = {}, U, { allStructuresLinked: v, sourceStructureIds: S, hasDrawFeedProfile: T, structureGroups: A } = bm({ drawDefinition: l });
  if (!v) return { error: JP };
  let y = (e == null ? void 0 : e.publishStatus) ?? nn({ event: h, status: s }), D = e.eventPublished ?? !!((O = (E = _s({ event: h }).publishState) == null ? void 0 : E.status) != null && O.published), P = !1, w = !1, R = A.map((M) => {
    let N = {}, C = M.map((F) => {
      let { structure: x } = Ne({ drawDefinition: l, structureId: F }), { seedAssignments: V } = Qi({ drawDefinition: l, structure: x });
      return (x == null ? void 0 : x.stage) === Ie && x.stageSequence === 1 && (U = V), (x == null ? void 0 : x.stage) === Pe && (I[x.stageSequence ?? 0] = V), x;
    }).sort((F, x) => Cs(F, x, f)).map((F) => {
      var z, Z;
      if (!F) return;
      let x = F == null ? void 0 : F.structureId, V = [];
      F.stage && [Ie, kr, Wt].includes(F.stage) && (V = U), (F == null ? void 0 : F.stage) === Pe && (V = I[F.stageSequence ?? 0]);
      let { matchUps: k, roundMatchUps: L, roundProfile: B } = ut({ seedAssignments: (z = F == null ? void 0 : F.seedAssignments) != null && z.length ? void 0 : V, context: { drawId: g.drawId, ...m }, hydrateParticipants: e.hydrateParticipants, participantsProfile: e.participantsProfile, tournamentParticipants: t, policyDefinitions: i, tournamentRecord: n, usePublishState: o, publishStatus: y, contextProfile: d, drawDefinition: l, inContext: a, structure: F, event: h }), { positionAssignments: G } = gt({ structure: F }), q = G == null ? void 0 : G.filter(Ni(ca)).map((te) => {
        var J, $;
        let ne = ($ = (J = We({ element: te, name: Ka })) == null ? void 0 : J.extension) == null ? void 0 : $.value, { drawPosition: ee, participantId: K } = te;
        return w = !0, { participantResult: ne, participantId: K, drawPosition: ee };
      });
      if (k.length && (!(q != null && q.length) && e.allParticipantResults || u && !F.structures)) {
        let { subOrderMap: te } = PM({ positionAssignments: G }), ne = k.some((K) => K.matchUpType === Ci) ? k.filter((K) => K.matchUpType === Ci) : k, ee = nu({ matchUpFormat: F.matchUpFormat, matchUps: ne, policyDefinitions: i, pressureRating: c, subOrderMap: te });
        q = G == null ? void 0 : G.filter(Ni(ca)).map((K) => {
          var ae;
          let { drawPosition: J, participantId: $ } = K;
          return w = !0, { participantResult: $ && ((ae = ee == null ? void 0 : ee.participantResults) == null ? void 0 : ae[$]), participantId: $, drawPosition: J };
        });
      }
      let Y = F ? (({ stageSequence: te, structureName: ne, structureType: ee, matchUpFormat: K, stage: J }) => ({ stageSequence: te, structureName: ne, structureType: ee, matchUpFormat: K, stage: J }))(F) : {}, H = (Z = We({ element: F, name: dp }).extension) == null ? void 0 : Z.value;
      Y.display = (H == null ? void 0 : H[gE]) ?? H, Y.sourceStructureIds = S[x], Y.hasDrawFeedProfile = T[x], Y.positionAssignments = G, Y.structureActive = k.reduce((te, ne) => {
        var K;
        let ee = [$t, sr, Sn, zt, Oa, Je, Wr, ct].includes(ne.matchUpStatus);
        return te || ee || !!ne.winningSide || !!((K = ne.score) != null && K.scoreStringSide1);
      }, !1);
      let X = k.reduce((te, ne) => te && [at, zt, Wr, ct, Je, Bi].includes(ne.matchUpStatus), !!k.length);
      return Y.structureCompleted = X, N[x] = X, Y.structureActive && (P = !0), { ...Y, participantResults: q, seedAssignments: V, roundMatchUps: L, roundProfile: B, structureId: x };
    });
    return C.forEach((F) => {
      var x;
      r || delete F.positionAssignments, F.sourceStructuresComplete = (x = F.sourceStructureIds) == null ? void 0 : x.every((V) => N[V]);
    }), C;
  }).flat();
  return g.drawActive = P, g.participantPlacements = w, g.drawGenerated = R == null ? void 0 : R.reduce((M, N) => M || !!(N != null && N.roundMatchUps), !1), g.drawCompleted = R == null ? void 0 : R.reduce((M, N) => M && N.structureCompleted, !0), g.drawPublished = o ? D && hE({ publishStatus: y, drawId: g.drawId }) : void 0, { structures: !o || g.drawPublished ? p && R || ge(R, !1, !0) : void 0, drawInfo: p ? g : ge(g, !1, !0), ...j };
}
function $m(e) {
  var E, O, M;
  let { includePositionAssignments: t, participantsProfile: r, policyDefinitions: i, usePublishState: n, status: a = ji, contextProfile: o, sortConfig: s } = e, c = Ae(e, [{ tournamentRecord: !0 }, { [lv]: { event: !1, eventId: !1 } }]);
  if (c.error) return c;
  let u = ge(e.tournamentRecord, !1, !0), d = e.event ? void 0 : ci({ tournamentRecord: u, eventId: e.eventId }).event, l = e.event ? ge(e.event, !1, !0) : d && ge(d, !1, !0) || void 0;
  if (!l) return { error: Ki };
  let { eventId: p } = l, { tournamentId: f, endDate: m } = u, h = nn({ event: l, status: a }), g = _s({ event: l }).publishState ?? {}, I = !!((E = g == null ? void 0 : g.status) != null && E.published), { participants: U } = Lt({ withGroupings: !0, withEvents: !1, withDraws: !1, policyDefinitions: i, ...r, tournamentRecord: u }), v = ({ stage: N, drawId: C }) => {
    var x, V, k;
    if (!n) return !0;
    let F = (V = (x = h == null ? void 0 : h.drawDetails) == null ? void 0 : x[C]) == null ? void 0 : V.stageDetails;
    return !F || !Object.keys(F).length ? !0 : (k = F[N]) == null ? void 0 : k.published;
  }, S = ({ structureId: N, drawId: C }) => {
    var x, V, k;
    if (!n) return !0;
    let F = (V = (x = h == null ? void 0 : h.drawDetails) == null ? void 0 : x[C]) == null ? void 0 : V.structureDetails;
    return !F || !Object.keys(F).length ? !0 : (k = F[N]) == null ? void 0 : k.published;
  }, T = ({ drawId: N }) => n ? hE({ publishStatus: h, drawId: N }) : !0, A = ({ drawId: N, structure: C }) => {
    var x, V, k, L;
    if (!n) return C;
    let F = (L = (k = (V = (x = h == null ? void 0 : h.drawDetails) == null ? void 0 : x[N]) == null ? void 0 : V.structureDetails) == null ? void 0 : k[C.structureId]) == null ? void 0 : L.roundLimit;
    if (ke(F)) {
      let B = fe(1, F + 1), G = {}, q = {};
      for (let Y of B) C.roundMatchUps[Y] && (G[Y] = C.roundMatchUps[Y], q[Y] = C.roundProfile[Y]);
      C.roundMatchUps = G, C.roundProfile = q;
    }
    return C;
  }, y = l.drawDefinitions || [], D = !n || I ? y.filter(T).map((N) => (({ drawInfo: C, structures: F }) => ({ ...C, structures: F }))(Jm({ allParticipantResults: e.allParticipantResults, hydrateParticipants: e.hydrateParticipants, context: { eventId: p, tournamentId: f, endDate: m }, pressureRating: e.pressureRating, refreshResults: e.refreshResults, includePositionAssignments: t, tournamentParticipants: U, noDeepCopy: !0, policyDefinitions: i, tournamentRecord: u, usePublishState: n, contextProfile: o, drawDefinition: N, publishStatus: h, sortConfig: s, event: l }))).map(({ structures: N, ...C }) => {
    let F = N == null ? void 0 : N.filter(({ stage: x, structureId: V }) => S({ structureId: V, drawId: C.drawId }) && v({ stage: x, drawId: C.drawId })).map((x) => A({ drawId: C.drawId, structure: x }));
    return { ...C, structures: F };
  }).filter((N) => {
    var C;
    return (C = N.structures) == null ? void 0 : C.length;
  }) : void 0, P = (Array.isArray(u.venues) ? u.venues : []).map((N) => (({ venueData: C }) => ({ ...C }))(Rc({ venueId: N.venueId, tournamentRecord: u }))), w = (({ eventId: N, eventName: C, eventType: F, eventLevel: x, surfaceCategory: V, matchUpFormat: k, category: L, gender: B, startDate: G, endDate: q, ballType: Y, discipline: H }) => ({ eventId: N, eventName: C, eventType: F, eventLevel: x, surfaceCategory: V, matchUpFormat: k, category: L, gender: B, startDate: G, endDate: q, ballType: Y, discipline: H }))(l);
  w.display = (O = We({ element: l, name: dp }).extension) == null ? void 0 : O.value;
  let { tournamentInfo: R } = Ks({ tournamentRecord: u }), b = { tournamentInfo: R, venuesData: P, eventInfo: w, drawsData: D };
  return b.eventInfo.publishState = g, b.eventInfo.published = (M = g == null ? void 0 : g.status) == null ? void 0 : M.published, { ...j, eventData: b, participants: U };
}
var IE = {};
qe(IE, { courtGridRows: () => nh, findVenue: () => fa, getMatchUpsToSchedule: () => eh, getPersonRequests: () => Qo, getProfileRounds: () => ih, getScheduledRoundsDetails: () => ol, getSchedulingProfile: () => Ba, getSchedulingProfileIssues: () => US, publicFindCourt: () => Xv });
function Cc({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: t, timeAfterRecovery: r, matchUp: i }) {
  var u, d, l, p;
  let { individualParticipantIds: n } = pm(i);
  r = r ?? ((u = i.schedule) == null ? void 0 : u.timeAfterRecovery);
  let a = (f) => {
    e[f] || (e[f] = []), e[f] = Be(e[f].concat(...n));
  }, o = (f) => {
    r && (!t[f] || r > t[f]) && (t[f] = r);
  }, s = ((d = i.winnerTo) == null ? void 0 : d.matchUpId) || i.winnerMatchUpId;
  s && (r && o(s), a(s));
  let c = ((l = i.loserTo) == null ? void 0 : l.matchUpId) || i.loserMatchUpId;
  c && (r && o(c), a(c)), (p = i.sidesTo) != null && p.length && i.sidesTo.forEach(({ matchUpId: f }) => {
    f && (r && o(f), a(f));
  });
}
function eh(e) {
  let t = Ae(e, [{ [uv]: !0 }]);
  if (t.error) return t;
  let { matchUpPotentialParticipantIds: r, dateScheduledMatchUpIds: i = [], scheduleCompletedMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, orderedMatchUpIds: s, clearDate: c, matchUps: u } = e, d = o ? Object.keys(o) : [], l = (s ?? []).map((f) => u.find((m) => m.matchUpId === f)).filter(Boolean).filter((f) => {
    let m = !c && (i.includes(f.matchUpId) || d.includes(f.matchUpId)), h = [at, Je, zt, Bi, Wr, ct, $t, sr].includes(f == null ? void 0 : f.matchUpStatus);
    return n || !m && !f.winningSide && !h;
  }), p = r && a ? l.reduce((f, m) => {
    let { drawId: h, tournamentId: g } = m;
    return f.matchUpMap[g] || (f.matchUpMap[g] = {}), f.matchUpMap[g][h] ? f.matchUpMap[g][h].push(m) : f.matchUpMap[g][h] = [m], Cc({ matchUpPotentialParticipantIds: r, matchUpNotBeforeTimes: a, matchUp: m }), f;
  }, { matchUpMap: {} }).matchUpMap : {};
  return { matchUpsToSchedule: l, matchUpMap: p };
}
function th({ defaultRecoveryMinutes: e = 0, defaultAverageMinutes: t, tournamentRecords: r, matchUpFormat: i, categoryName: n, categoryType: a, tournamentId: o, eventType: s, eventId: c }) {
  if (!Ri({ matchUpFormat: i })) return { error: sd };
  let u = Object.keys(r).filter((l) => !o || l === o), d;
  return u.forEach((l) => {
    var m;
    if (d) return;
    let p = r[l], f = c ? (m = ci({ tournamentRecord: p, eventId: c })) == null ? void 0 : m.event : void 0;
    return d = Fd({ tournamentRecord: p, matchUpFormat: i, categoryName: n, categoryType: a, eventType: s, event: f }), (d == null ? void 0 : d.averageMinutes) || (d == null ? void 0 : d.recoveryMinutes);
  }), { recoveryMinutes: (d == null ? void 0 : d.recoveryMinutes) || e, averageMinutes: (d == null ? void 0 : d.averageMinutes) || t, typeChangeRecoveryMinutes: (d == null ? void 0 : d.typeChangeRecoveryMinutes) || (d == null ? void 0 : d.recoveryMinutes) || e };
}
function ol(e) {
  let t = Ae(e, [{ [lv]: { tournamentRecords: !1, tournamentRecord: !1 } }, { rounds: !0, [ui]: Gr }]);
  if (t.error) return t;
  let { scheduleCompletedMatchUps: r, periodLength: i = 30 } = e, n = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {};
  if (typeof n != "object") return { error: xt };
  let a = {}, o = [], s = e.rounds.toSorted((m, h) => (m.sortOrder ?? 0) - (h.sortOrder ?? 0)), c = e.containedStructureIds ?? Object.assign({}, ...Object.values(n).map((m) => Zc({ tournamentRecord: m }).containedStructures)), u = e.matchUps ?? On({ nextMatchUps: !0, tournamentRecords: n }).matchUps, d = 0, l = {}, p = {}, f = {};
  return { scheduledRoundsDetails: s.flatMap((m) => {
    var y;
    let h = m.periodLength || i, g = [];
    c != null && c[m.structureId] ? g.push(...c[m.structureId]) : g.push(m.structureId);
    let I = u ? ga({ tournamentIds: [m.tournamentId], roundNumbers: [m.roundNumber], matchUpIds: m.matchUpIds, eventIds: [m.eventId], drawIds: [m.drawId], processContext: !0, structureIds: g, matchUps: u }).sort(js) : [], { segmentNumber: U, segmentsCount: v } = m.roundSegment || {};
    if (ke(U) && Rn(I == null ? void 0 : I.length) && Rn(v) && U > 0 && U <= v && v < (I == null ? void 0 : I.length) && !((y = m.matchUpIds) != null && y.length)) {
      let D = I.length / v, P = D * (U - 1);
      I = I.slice(P, P + D);
    }
    let S = n[m.tournamentId], T = ci({ drawId: m.drawId, tournamentRecord: S }).event, A = [];
    for (let D of I) {
      let P = D.matchUpFormat;
      P && (a[P] || (a[P] = [], a[P].push(D)), A.push(P));
    }
    for (let D of A) {
      let { eventType: P, category: w } = T ?? {}, { categoryName: R, ageCategoryCode: b } = w ?? {}, { typeChangeRecoveryMinutes: E, recoveryMinutes: O, averageMinutes: M, error: N } = th({ categoryName: R ?? b, categoryType: w == null ? void 0 : w.categoryType, tournamentId: m.tournamentId, eventId: m.eventId, tournamentRecords: n, matchUpFormat: D, eventType: P });
      if (N) return { error: N, round: m };
      let C = I.filter((x) => (r || !lr.includes(x.matchUpStatus)) && x.matchUpStatus !== at).map(hr);
      C.forEach((x) => {
        f[x] = { typeChangeRecoveryMinutes: E, recoveryMinutes: O, averageMinutes: M }, l[x] = O, p[x] = M;
      }), o.push(...C), d = Math.max(M || 0, d);
      let F = `${M}|${h}`;
      return { roundPeriodLength: h, recoveryMinutes: O, averageMinutes: M, matchUpIds: C, hash: F };
    }
  }), greatestAverageMinutes: d, matchUpFormatCohorts: a, recoveryMinutesMap: l, averageMinutesMap: p, orderedMatchUpIds: o, minutesMap: f, ...j };
}
function vE({ schedulingProfile: e, venueIds: t, eventIds: r, drawIds: i }) {
  let n = [], a = e == null ? void 0 : e.map((s) => {
    let c = Ve(s == null ? void 0 : s.scheduleDate);
    if (!c) {
      n.push(`Invalid date: ${s == null ? void 0 : s.scheduledDate}`);
      return;
    }
    let u = ((s == null ? void 0 : s.venues) || []).map((d) => {
      let { rounds: l, venueId: p } = d;
      if (!(t != null && t.includes(p))) {
        n.push(`Missing venueId: ${p}`);
        return;
      }
      let f = l.filter((m) => {
        let h = r.includes(m.eventId) && i.includes(m.drawId);
        return h || n.push(`Invalid eventId: ${m.eventId} or drawId: ${m.drawId}`), h;
      });
      if (f.length) return { venueId: p, rounds: f };
    }).filter(Boolean);
    return u.length && c && { ...s, venues: u };
  }).filter(Boolean), o = n.length;
  return { updatedSchedulingProfile: a, modifications: o, issues: n };
}
function rh({ tournamentRecords: e, schedulingProfile: t }) {
  if (!t) return { valid: !0 };
  if (!Array.isArray(t)) return { valid: !1, error: ie };
  let { venueIds: r, tournamentsMap: i } = Dj({ tournamentRecords: e }), n, a, o = t.every((s) => {
    let { scheduleDate: c, venues: u } = s;
    return mi(c) ? u.every((d) => {
      let { venueId: l, rounds: p } = d;
      return typeof l != "string" ? (a = "venueId should be a string", !1) : Array.isArray(p) ? r.includes(l) ? !!p.every((f) => {
        var D, P, w, R;
        if (!f) return a = "empty round", !1;
        let { roundSegment: m, tournamentId: h, structureId: g, roundNumber: I, eventId: U, drawId: v } = f, S = (R = (w = (P = (D = i == null ? void 0 : i[h]) == null ? void 0 : D[U]) == null ? void 0 : P[v]) == null ? void 0 : w[g]) == null ? void 0 : R.includes(I);
        S || (a = "Invalid rounds");
        let { segmentNumber: T, segmentsCount: A } = m || {}, y = !m || ke(T) && Rn(A) && T <= A;
        return y || (a = "Invalid segment"), S && y;
      }) : (n = Rs, !1) : (a = "rounds should be an array", !1);
    }) : !1;
  });
  return !o && !n && (n = ie), { valid: !!o, error: n, info: a };
}
function Tj(e) {
  let { tournamentRecord: t = {}, tournamentMap: r = {}, requireCourts: i } = e, n = [], a = [], o = [], s = [], c = ((t == null ? void 0 : t.venues) || []).map(({ venueId: d, courts: l }) => (!i || (l == null ? void 0 : l.length)) && d), u = t == null ? void 0 : t.tournamentId;
  return u && (n.push(u), r[u] = {}, ((t == null ? void 0 : t.events) || []).forEach((d) => {
    let l = d.eventId;
    o.push(l), r[u][l] = {}, (d.drawDefinitions || []).forEach((p) => {
      let f = p.drawId;
      s.push(f), r[u][l][f] = {};
      let { structures: m } = In({ drawDefinition: p });
      (m || []).forEach((h) => {
        var S;
        let g = h.structureId, { matchUps: I } = ut({ structure: h }), { roundMatchUps: U } = $r({ matchUps: I }), v = U && Object.keys(U).map((T) => parseInt(T));
        r[u][l][f][g] = v, a.push(g), (S = h.structures) != null && S.length && h.structures.forEach((T) => {
          a.push(T.structureId), r[u][l][f][T.structureId] = v;
        });
      });
    });
  })), { tournamentMap: r, tournamentIds: n, structureIds: a, venueIds: c, eventIds: o, drawIds: s };
}
function Dj(e) {
  let t = (e == null ? void 0 : e.tournamentRecords) && Object.values(e == null ? void 0 : e.tournamentRecords) || [], r = {}, { venueIds: i, eventIds: n, drawIds: a, structureIds: o, tournamentIds: s } = t.reduce((c, u) => {
    let { tournamentIds: d, tournamentMap: l, structureIds: p, venueIds: f, eventIds: m, drawIds: h } = Tj({ tournamentRecord: u });
    return f.forEach((g) => {
      c.venueIds.includes(g) || c.venueIds.push(g);
    }), c.tournamentIds.push(...d), c.structureIds.push(...p), c.eventIds.push(...m), c.drawIds.push(...h), Object.assign(r, l), c;
  }, { tournamentIds: [], structureIds: [], venueIds: [], eventIds: [], drawIds: [] });
  return { tournamentsMap: r, tournamentIds: s, structureIds: o, venueIds: i, eventIds: n, drawIds: a };
}
function Ba({ tournamentRecords: e, tournamentRecord: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let { extension: r } = We({ element: t, name: Us, tournamentRecords: e, discover: !0 }), i = (r == null ? void 0 : r.value) || [];
  if (i.length) {
    let { venueIds: n } = al({ requireCourts: !0, tournamentRecords: e }), { eventIds: a, drawIds: o } = OU({ tournamentRecords: e }), { updatedSchedulingProfile: s, modifications: c, issues: u } = vE({ schedulingProfile: i, venueIds: n, eventIds: a, drawIds: o });
    if (c) {
      i = s;
      let d = au({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: i });
      return d.error ? d : { schedulingProfile: i, modifications: c, issues: u };
    }
  }
  return { schedulingProfile: i, modifications: 0 };
}
function au({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: r }) {
  let i = rh({ tournamentRecords: e, schedulingProfile: r });
  return i.error ? i : r ? it({ tournamentRecords: e, discover: !0, extension: { name: Us, value: r } }) : Zr({ element: t, name: Us, tournamentRecords: e, discover: !0 });
}
function sl(e) {
  let { tournamentRecord: t } = e, r = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!e.schedulingProfile) {
    let { modifications: u, issues: d } = Ba({ tournamentRecords: r, tournamentRecord: t });
    return { success: !u, modifications: u, issues: d };
  }
  let { venueIds: i } = al({ tournamentRecords: r }), { eventIds: n, drawIds: a } = OU({ tournamentRecords: r }), { updatedSchedulingProfile: o, modifications: s, issues: c } = vE({ schedulingProfile: e.schedulingProfile, venueIds: i, eventIds: n, drawIds: a });
  return s ? { ...au({ schedulingProfile: o, tournamentRecords: r }), modifications: s, issues: c } : { ...j, modifications: s, issues: c };
}
function US(e) {
  let { scheduleDates: t = [], tournamentRecords: r, periodLength: i = 30 } = e ?? {};
  if (typeof r != "object") return { error: nd };
  if (!Array.isArray(t)) return { error: ie };
  if (!t.every(mi)) return { error: Sr };
  let n = [], a = 0, o = {}, { schedulingProfile: s } = Ba({ tournamentRecords: r });
  if (!s) return { issues: n, ...j };
  let { matchUps: c } = On({ nextMatchUps: !0, tournamentRecords: r });
  for (let d of s) {
    let { scheduleDate: l, venues: p = [] } = d;
    if (!(t != null && t.length) || t.includes(l)) {
      for (let f of p || []) if (f) {
        let { rounds: m } = f, h = [], { orderedMatchUpIds: g, scheduledRoundsDetails: I } = ol({ tournamentRecords: r, periodLength: i, matchUps: c, rounds: m }), { matchUpDependencies: U } = An({ tournamentRecords: r, matchUps: c }), v = (S) => {
          let T;
          return I == null || I.find((A, y) => {
            let D = A.matchUpIds.includes(S);
            return D && (T = y), D;
          }), T;
        };
        if (g == null || g.forEach((S, T) => {
          var D;
          let A = g.slice(T + 1), y = qt(A, ((D = U == null ? void 0 : U[S]) == null ? void 0 : D.matchUpIds) || []);
          y.length && h.push({ matchUpId: S, shouldBeAfter: y });
        }), h.length) {
          a += h.length;
          let S = h.map(({ matchUpId: T, shouldBeAfter: A }) => {
            let y = v(T), D = Be(A.map(v));
            return o[l] || (o[l] = {}), o[l][y] || (o[l][y] = []), D.forEach((P) => {
              o[l][y].includes(P) || o[l][y].push(P);
            }), { matchUpId: T, matchUpRoundIndex: y, earlierRoundIndices: D, shouldBeAfter: A };
          });
          n.push(...S);
        }
      }
    }
  }
  let u = { matchUpIdShouldBeAfter: Object.assign({}, ...n.map((d) => {
    let { matchUpId: l, shouldBeAfter: p, earlierRoundIndices: f } = d;
    return { [l]: { earlierRoundIndices: f, shouldBeAfter: p } };
  })) };
  return { issuesCount: a, profileIssues: u, roundIndexShouldBeAfter: o, ...j };
}
function Qo(e) {
  let { tournamentRecords: t, requestType: r } = e, i = Ae(e, [{ [_r]: !0 }]);
  if (i.error) return i;
  let n = {};
  for (let a of Object.values(t)) {
    let { extension: o } = We({ element: a, name: Kc }), s = (o == null ? void 0 : o.value) || [];
    for (let c of s) {
      let { personId: u, requests: d } = c || {};
      n[u] || (n[u] = []);
      for (let l of d) r && l.requestType !== r || n[u].push(l);
    }
  }
  return { personRequests: n, ...j };
}
function tI(e) {
  let { containerStructureId: t, roundSegment: r, isRoundRobin: i, tournamentId: n, roundNumber: a, structureId: o, eventId: s, drawId: c } = e, u = i ? t : o, d = [n, s, c, u, a].join("|");
  return ye({ structureId: u, roundSegment: r, tournamentId: n, roundNumber: a, eventId: s, drawId: c, id: d });
}
function VT({ round: e, matchUps: t, events: r, tournamentRecords: i }) {
  let n = r.find((p) => p.eventId === e.eventId), { eventType: a, category: o, categoryType: s } = n || {}, { categoryName: c, ageCategoryCode: u } = o || {}, d = wi(t.map(({ matchUpFormat: p }) => p)), l = 0;
  return Object.keys(d).forEach((p) => {
    let f = d[p], m = th({ categoryName: c || u, tournamentId: e.tournamentId, eventId: e.eventId, tournamentRecords: i, matchUpFormat: p, categoryType: s, eventType: a });
    if (m.error) return m;
    let h = m.averageMinutes * f;
    isNaN(l) || (l += h);
  }), { roundMinutes: l };
}
function Pj(e) {
  return (e || []).reduce((t, r) => {
    var a, o;
    let i = (((a = r.finishingPositionRange) == null ? void 0 : a.winner) || []).reduce((s, c) => s + c, 0), n = (((o = r.finishingPositionRange) == null ? void 0 : o.winner) || []).join("-") || "";
    return !t.minFinishingSum || i < t.minFinishingSum ? { minFinishingSum: i, winnerFinishingPositionRange: n } : t;
  }, { minFinishingSum: 0, winnerFinishingPositionRange: "" });
}
function GT(e) {
  let t = e.length, r = e.filter(({ sides: u }) => u == null ? void 0 : u.some(({ bye: d }) => d)).length || 0, i = e.filter(({ winningSide: u, matchUpStatus: d }) => u || lr.includes(d)).length || 0, n = e.filter(({ schedule: u, matchUpStatus: d }) => (u == null ? void 0 : u.scheduledDate) && (u == null ? void 0 : u.scheduledTime) && d !== at).length || 0, a = t - r, o = a === i, s = a - n, c = a - n;
  return { unscheduledCount: s, incompleteCount: c, scheduledCount: n, completedCount: i, matchUpsCount: t, isScheduled: a === n, isComplete: o, byeCount: r };
}
function ih({ tournamentRecords: e, schedulingProfile: t, tournamentRecord: r, withRoundId: i }) {
  if (r && !e) {
    if (typeof r != "object") return { error: nd };
    e = { [r.tournamentId]: r };
  }
  if (t) {
    let a = rh({ tournamentRecords: e, schedulingProfile: t });
    if (a.error) return a;
  }
  if (!t && e) {
    let a = Ba({ tournamentRecords: e });
    if (a.error) return a;
    t = a.schedulingProfile;
  }
  if (!t) return { error: Tr };
  let n = {};
  return { profileRounds: t.map(({ venues: a, scheduleDate: o }) => a.map(({ rounds: s }) => s.map((c) => {
    var d;
    let u = tI(c);
    return (d = u.roundSegment) != null && d.segmentsCount && (n[u.id] = u.roundSegment.segmentsCount), ye({ id: i ? u.id : void 0, scheduleDate: o, ...u });
  }))).flat(1 / 0), segmentedRounds: n };
}
function nh({ courtPrefix: e = "C|", minRowsCount: t, courtsData: r }) {
  if (!Array.isArray(r)) return { error: ie };
  let i = r == null ? void 0 : r.reduce((o, s) => {
    let c = s.matchUps || [], u = Math.max(0, ...c.map((d) => d.schedule.courtOrder || 0));
    return u > o ? u : o;
  }, 1), n = t ? Math.max(t, i) : i, a = fe(0, n).map((o) => ({ matchUps: fe(0, r.length).map((s) => {
    let c = r[s], { courtId: u, venueId: d } = c;
    return { schedule: { courtOrder: o + 1, venueId: d, courtId: u } };
  }) }));
  return r.forEach((o, s) => {
    var c;
    for (let u of o.matchUps) {
      let d = (c = u.schedule) == null ? void 0 : c.courtOrder;
      d && (a[d - 1].matchUps[s] = u);
    }
  }), { courtPrefix: e, rows: a.map((o, s) => Object.assign({ rowId: `rowId-${s + 1}` }, ...o.matchUps.map((c, u) => ({ [`${e}${u}`]: c })))) };
}
var UE = {};
qe(UE, { getEntriesAndSeedsCount: () => ah, getMaxEntryPosition: () => SS });
function ah({ policyDefinitions: e, drawDefinition: t, drawSize: r, drawId: i, event: n, stage: a }) {
  if (!n) return { error: At };
  let { entries: o, stageEntries: s } = RN({ drawDefinition: t, drawId: i, stage: a, event: n }), c = s.length, { drawSize: u } = QM({ participantsCount: c }), d = il({ drawSize: r ?? u, participantsCount: c, policyDefinitions: e });
  if (d.error) return W({ result: d, stack: "getEntriesAndSeedsCount" });
  let { seedsCount: l } = d;
  return { entries: o, seedsCount: l, stageEntries: s };
}
function SS(e) {
  let { entries: t = [], entryStatus: r, stage: i } = e;
  return Math.max(...t.filter((n) => (!i || i === n.entryStage) && (!r || n.entryStatus === r) && !isNaN(n.entryPosition)).map(({ entryPosition: n }) => be(n || 0)), 0);
}
var SE = {};
qe(SE, { allCompetitionMatchUps: () => On, allDrawMatchUps: () => Qr, allEventMatchUps: () => ma, allTournamentMatchUps: () => Pr, analyzeMatchUp: () => ed, calculateWinCriteria: () => Xs, checkMatchUpIsComplete: () => yo, competitionScheduleMatchUps: () => ul, drawMatchUps: () => ES, eventMatchUps: () => sh, filterMatchUps: () => ga, getAllDrawMatchUps: () => ur, getAllStructureMatchUps: () => ut, getCheckedInParticipantIds: () => Bs, getCompetitionMatchUps: () => $u, getEventMatchUpFormatTiming: () => AS, getHomeParticipantId: () => wS, getMatchUpCompetitiveProfile: () => Cd, getMatchUpContextIds: () => RS, getMatchUpDailyLimits: () => uh, getMatchUpDailyLimitsUpdate: () => TS, getMatchUpDependencies: () => An, getMatchUpFormat: () => bS, getMatchUpFormatTiming: () => Fd, getMatchUpFormatTimingUpdate: () => yS, getMatchUpScheduleDetails: () => Sm, getMatchUpType: () => ym, getMatchUpsStats: () => NS, getModifiedMatchUpFormatTiming: () => oh, getParticipantResults: () => Qd, getPredictiveAccuracy: () => PS, getRoundMatchUps: () => $r, getRounds: () => MS, isValidMatchUpFormat: () => Ri, matchUpActions: () => xm, participantScheduledMatchUps: () => DS, tallyParticipantResults: () => nu, tournamentMatchUps: () => ch, validMatchUp: () => hm, validMatchUps: () => rn });
function yE({ tournamentRecords: e, extensionName: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let r = [], i;
  for (let n of Object.values(e)) {
    let { extension: a } = We({ element: n, name: t });
    a && !i && (r.push({ params: { extension: a, discover: !0 }, method: "addExtension" }), i = !0);
    let o = n.events ?? [];
    for (let s of o) {
      let { eventId: c } = s, { extension: u } = We({ name: t, element: s });
      u && r.push({ params: { eventId: c, extension: u }, method: "addEventExtension" });
    }
  }
  return { methods: r };
}
function yS({ tournamentRecords: e }) {
  return yE({ extensionName: Pa, tournamentRecords: e });
}
var Jh = "ADULT", $h = "JUNIOR", Nl = "WHEELCHAIR", wj = { [ao]: { allowModificationWhenMatchUpsScheduled: { courts: !1, venues: !1 }, defaultTimes: { averageTimes: [{ categoryNames: [], minutes: { default: 90 } }], recoveryTimes: [{ minutes: { [ft]: 30, default: 60 } }] }, defaultDailyLimits: { [mt]: 2, [ft]: 2, total: 3 }, matchUpAverageTimes: [{ matchUpFormatCodes: [Ia], averageTimes: [{ categoryNames: [], minutes: { default: 90 } }, { categoryTypes: [Nl], minutes: { default: 120 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 85 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 70 } }] }, { matchUpFormatCodes: ["SET3-S:4NOAD-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 50 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB5@3"], averageTimes: [{ categoryNames: [], minutes: { default: 45 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7"], averageTimes: [{ categoryNames: [], minutes: { default: 40 } }] }, { matchUpFormatCodes: ["SET1-S:5/TB9@4"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB7", "SET1-S:4/TB5@3", "SET3-S:TB10", "SET1-S:T20"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:4NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 10 } }] }], matchUpRecoveryTimes: [{ matchUpFormatCodes: ["SET3-S:6/TB7", "SET3-S:6/TB7-F:TB10", "SET3-S:6/TB7-F:TB7"], recoveryTimes: [{ categoryTypes: [Jh, Nl], minutes: { default: 60, [ft]: 30 } }, { categoryTypes: [$h], minutes: { default: 60, [ft]: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7", "SET3-S:4/TB7-F:TB10", "SET3-S:4NOAD-F:TB7", "SET3-S:4/TB7", "SET3-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [Jh, Nl], minutes: { default: 30 } }, { categoryTypes: [$h], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7", "SET1-S:5/TB9@4", "SET1-S:6/TB7", "SET1-S:6NOAD", "SET1-S:4/TB7", "SET1-S:4NOAD", "SET3-S:TB10", "SET1-S:T20"], recoveryTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [Jh, $h], minutes: { default: 30 } }, { categoryTypes: [Nl], minutes: { default: 15 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], recoveryTimes: [{ categoryNames: [], minutes: { default: 15 } }] }], matchUpDailyLimits: [] } }, Rj = wj;
function AS({ tournamentRecord: e, matchUpFormats: t, categoryType: r, event: i }) {
  if (!i) return { error: At };
  let n = [], a;
  if (t != null && t.length) {
    let l = [];
    n = t.map((p) => {
      let f = typeof p == "string" ? { matchUpFormat: p } : p;
      if (!l.includes(f == null ? void 0 : f.matchUpFormat) && Ri({ matchUpFormat: f == null ? void 0 : f.matchUpFormat })) return l.push(f.matchUpFormat), f;
    }).filter(Boolean);
  } else {
    let { policy: l } = qo({ policyType: En, tournamentRecord: e, event: i });
    if (l != null && l.matchUpFormats) n = l == null ? void 0 : l.matchUpFormats;
    else {
      let { extension: p } = We({ name: Pa, element: i }), f, m;
      p != null && p.value ? { matchUpAverageTimes: f, matchUpRecoveryTimes: m } = p.value : { matchUpAverageTimes: f, matchUpRecoveryTimes: m } = Rj[ao], n = Be([...(f || []).map((h) => h.matchUpFormatCodes), ...(m || []).map((h) => h.matchUpFormatCodes)].flat()).map((h) => ({ matchUpFormat: h })), a = "default scheduling policy in use";
    }
  }
  let { eventType: o, eventId: s, category: c } = i, u = (c == null ? void 0 : c.categoryName) ?? (c == null ? void 0 : c.ageCategoryCode) ?? s;
  if (!s) return { error: At };
  let d = n.map(({ matchUpFormat: l, description: p }) => {
    let f = Fd({ tournamentRecord: e, matchUpFormat: l, categoryName: u, categoryType: r, eventType: o, event: i });
    return { matchUpFormat: l, description: p, ...f };
  });
  return ye({ eventMatchUpFormatTiming: d, info: a });
}
function oh(e) {
  let t = Ae(e, [{ [fr]: !0 }, { [Or]: (h) => Ri({ matchUpFormat: h }), [xi]: sd, [ov]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, matchUpFormat: i, event: n } = e, { extension: a } = We({ name: Pa, element: n }), o = a == null ? void 0 : a.value, { extension: s } = We({ element: r, name: Pa }), c = s == null ? void 0 : s.value, u = (o == null ? void 0 : o.matchUpAverageTimes) && wu({ ...o, matchUpFormat: i }), d = (c == null ? void 0 : c.matchUpAverageTimes) && wu({ ...c, matchUpFormat: i }), l = [u, d].find((h) => h), p = (o == null ? void 0 : o.matchUpRecoveryTimes) && Ru({ ...o, matchUpFormat: i }), f = (c == null ? void 0 : c.matchUpRecoveryTimes) && Ru({ ...c, matchUpFormat: i }), m = [p, f].find((h) => h);
  return { matchUpFormat: i, recoveryTimes: m, averageTimes: l };
}
function TS({ tournamentRecords: e }) {
  return yE({ extensionName: Sd, tournamentRecords: e });
}
var cl = ({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], schedule: t = {} }) => !!Object.keys(t).filter((r) => e.includes(r)).filter((r) => t[r]).length;
function DS({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], matchUps: t = [] }) {
  if (!rn(t)) return { error: Ma };
  if (!Array.isArray(e)) return { error: ie };
  let r = t.filter(Boolean).filter(({ schedule: i }) => cl({ schedule: i, scheduleAttributes: e })).reduce((i, n) => {
    let { schedule: a } = n, o = Ve(a == null ? void 0 : a.scheduledDate), s = Rt(a == null ? void 0 : a.scheduledTime);
    return o && s && (i[o] ? i[o].push(n) : i[o] = [n]), i;
  }, {});
  return Object.keys(r).forEach((i) => {
    r[i].sort((n, a) => {
      var o, s;
      return uR(Rt((o = n.schedule) == null ? void 0 : o.scheduledTime), Rt((s = a.schedule) == null ? void 0 : s.scheduledTime));
    });
  }), { ...j, scheduledMatchUps: r };
}
function bj({ tournamentRecords: e }) {
  var i;
  let t = {}, r = [];
  for (let n of Object.values(e)) for (let a of n.events ?? []) {
    let o = nn({ event: a }), s = o == null ? void 0 : o.drawDetails;
    $e(s) ? (Object.assign(t, s), r.push(...Object.keys(s).filter((c) => $v({ drawId: c, drawDetails: s })))) : (i = o == null ? void 0 : o.drawIds) != null && i.length && r.push(...o.drawIds);
  }
  return { drawIds: r, detailsMap: t };
}
function Np({ schedulingProfile: e, matchUps: t = [] }) {
  let r = {}, i = ({ eventId: s, drawId: c, structureId: u, roundNumber: d }) => `${s}|${c}|${u}${d}`;
  e != null && e.length && e.map(({ venues: s }) => s.map(({ rounds: c }) => c)).flat().forEach((s) => {
    s.sort((c, u) => (c.sortOrder || 0) - (u.sortOrder || 0)).forEach(({ eventId: c, drawId: u, structureId: d, roundNumber: l }, p) => {
      let f = i({ eventId: c, drawId: u, structureId: d, roundNumber: l });
      r[f] = p;
    });
  });
  let n = [], a = { noScheduledDate: [] };
  for (let s of t) {
    let c = s.schedule || {}, u = c.scheduledDate && Ve(c.scheduledDate) || c.scheduledTime && Ve(c.scheduledTime) || "noScheduledDate";
    a[u] || (a[u] = []), a[u].push(s);
  }
  let o = Object.keys(a).sort();
  for (let s of o) {
    let c = a[s], u = { noScheduledTime: [] };
    for (let l of c) {
      let p = l.schedule || {}, f = p.scheduledTime && Rt(p.scheduledTime) || "noScheduledTime";
      u[f] || (u[f] = []), u[f].push(l);
    }
    for (let l of Object.keys(u)) {
      let p = u[l].sort((f, m) => (f.roundNumber || 0) - (m.roundNumber || 0));
      u[l] = p;
    }
    let d = Object.keys(u).sort();
    for (let l of d) {
      let p = u[l];
      p.sort((f, m) => {
        let h = r[i(f)] || 0, g = r[i(m)] || 0;
        return h - g;
      }), n.push(...p);
    }
  }
  return n;
}
function sh(e) {
  let { participants: t, contextContent: r, participantMap: i } = e, { tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, usePublishState: l, contextFilters: p, matchUpFilters: f, contextProfile: m, nextMatchUps: h, tournamentId: g, inContext: I, context: U, event: v } = e;
  if (!v) return { error: At };
  let { eventId: S, eventName: T, endDate: A, eventType: y, category: D, gender: P } = v ?? {}, w = { ...U, ...ye({ surfaceCategory: v.surfaceCategory ?? (d == null ? void 0 : d.surfaceCategory), indoorOutDoor: v.indoorOutdoor ?? (d == null ? void 0 : d.indoorOutdoor), tournamentId: g ?? (d == null ? void 0 : d.tournamentId), endDate: A ?? (d == null ? void 0 : d.endDate), eventName: T, eventType: y, category: D, eventId: S, gender: P }) }, R;
  !t && d && ({ participants: t, participantMap: i, groupInfo: R } = Wo({ participantsProfile: o, policyDefinitions: c, useParticipantMap: u, tournamentRecord: d, contextProfile: m, inContext: I })), m && !r && (r = ka({ policyDefinitions: c, tournamentRecord: d, contextProfile: m, event: v }));
  let b = nn({ event: v });
  return { ...(v.drawDefinitions ?? []).reduce((E, O) => {
    var N;
    let M = Jc({ hydrateParticipants: e.hydrateParticipants, context: w, tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: d, usePublishState: l, contextContent: r, contextFilters: p, matchUpFilters: f, participantMap: i, publishStatus: b, contextProfile: m, drawDefinition: O, nextMatchUps: h, inContext: I, event: v });
    return (N = Object.keys(M)) == null || N.forEach((C) => {
      Array.isArray(M[C]) && (E[C] || (E[C] = []), E[C] = E[C].concat(M[C]));
    }), E;
  }, {}), ...j, groupInfo: R };
}
function ch(e) {
  if (!(e != null && e.tournamentRecord)) return { error: de };
  let t = e.contextContent, { scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: o, inContext: s = !0, usePublishState: c, contextFilters: u, matchUpFilters: d, contextProfile: l, nextMatchUps: p, context: f } = e, m = e.tournamentId ?? o.tournamentId, h = (o == null ? void 0 : o.events) ?? [], { participants: g, participantMap: I, groupInfo: U } = Wo({ participantsProfile: i, policyDefinitions: a, tournamentRecord: o, contextProfile: l, inContext: s });
  l && !t && (t = ka({ policyDefinitions: a, tournamentRecord: o, contextProfile: l }));
  let { appliedPolicies: v } = nt({ tournamentRecord: o }), S = (u == null ? void 0 : u.eventIds) ?? [];
  return { ...h.filter((T) => !S.includes(T.eventId)).map((T) => {
    var y, D, P;
    let A = { eventDrawsCount: ((D = (y = Ht({ event: T }).flightProfile) == null ? void 0 : y.flights) == null ? void 0 : D.length) || ((P = T.drawDefinitions) == null ? void 0 : P.length) || 0, ...f };
    return sh({ hydrateParticipants: e.hydrateParticipants, context: A, tournamentAppliedPolicies: v, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: o, usePublishState: c, contextFilters: u, contextProfile: l, contextContent: t, matchUpFilters: d, participantMap: I, participants: g, tournamentId: m, nextMatchUps: p, inContext: s, event: T });
  }).reduce((T, A) => {
    var y;
    return (y = A && Object.keys(A).filter((D) => !["success", "matchUpsMap"].includes(D))) == null || y.forEach((D) => {
      Array.isArray(A[D]) && (T[D] || (T[D] = []), T[D] = T[D].concat(A[D]), T.matchUpsCount !== void 0 ? T.matchUpsCount += A[D].length : T.matchUpsCount = A[D].length);
    }), T;
  }, { matchUpsCount: 0 }), groupInfo: U, participants: g };
}
function $u({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, tournamentRecords: i, useParticipantMap: n, policyDefinitions: a, usePublishState: o, matchUpFilters: s, contextFilters: c, nextMatchUps: u, inContext: d }) {
  if (typeof i != "object" || !Object.keys(i).length) return { error: xt };
  let l = Object.keys(i).map((m) => {
    let h = i[m];
    return ch({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, useParticipantMap: n, policyDefinitions: a, tournamentRecord: h, usePublishState: o, matchUpFilters: s, contextFilters: c, nextMatchUps: u, inContext: d });
  }), p = {}, f = {};
  return { ...l.reduce((m, h) => (Object.keys(h).forEach((g) => {
    if (g === "groupInfo") Object.assign(f, h[g]);
    else if (g === "participants") for (let I of h[g] ?? []) p[I.participantId] = I;
    else Array.isArray(h[g]) && (m[g] || (m[g] = []), m[g] = m[g].concat(h[g]));
  }), m), {}), groupInfo: f, mappedParticipants: p };
}
function ul(e) {
  var E, O, M, N, C, F, x;
  if (typeof (e == null ? void 0 : e.tournamentRecords) != "object" || !Object.keys(e == null ? void 0 : e.tournamentRecords).length) return { error: xt };
  let { courts: t, venues: r } = xa(e), i = Ba(e).schedulingProfile, { sortDateMatchUps: n = !0, courtCompletedMatchUps: a, alwaysReturnCompleted: o, activeTournamentId: s, tournamentRecords: c, withCourtGridRows: u, minCourtGridRows: d, usePublishState: l, status: p = ji, sortCourtsData: f } = e, m = s ?? bs() ?? Object.keys(c)[0], h = l ? Gd({ tournamentRecord: c[m], status: p }) : void 0, g = o ? $u({ ...e, matchUpFilters: { ...e.matchUpFilters, matchUpStatuses: [zt] }, contextFilters: e.contextFilters }).completedMatchUps : [];
  if (l && !((E = h == null ? void 0 : h.orderOfPlay) != null && E.published)) return { completedMatchUps: g, dateMatchUps: [], courtsData: [], venues: r };
  let I, U;
  l && ({ drawIds: I, detailsMap: U } = bj({ tournamentRecords: c })), I != null && I.length && (e.contextFilters || (e.contextFilters = {}), (O = e.contextFilters) != null && O.drawIds ? e.contextFilters.drawIds = e.contextFilters.drawIds.filter((V) => I.includes(V)) : e.contextFilters.drawIds = I), (M = h == null ? void 0 : h.eventIds) != null && M.length && (e.matchUpFilters || (e.matchUpFilters = {}), (N = e.matchUpFilters) != null && N.eventIds && e.matchUpFilters.eventIds.length ? e.matchUpFilters.eventIds = e.matchUpFilters.eventIds.filter((V) => h.eventIds.includes(V)) : e.matchUpFilters.eventIds = h.eventIds), (C = h == null ? void 0 : h.scheduledDates) != null && C.length && (e.matchUpFilters || (e.matchUpFilters = {}), e.matchUpFilters.scheduledDates && e.matchUpFilters.scheduledDates.length ? e.matchUpFilters.scheduledDates = e.matchUpFilters.scheduledDates.filter((V) => h.scheduledDates.includes(V)) : e.matchUpFilters.scheduledDates = h.scheduledDates), o && (e.matchUpFilters || (e.matchUpFilters = {}), (x = (F = e.matchUpFilters) == null ? void 0 : F.excludeMatchUpStatuses) != null && x.length ? e.matchUpFilters.excludeMatchUpStatuses.includes(zt) || e.matchUpFilters.excludeMatchUpStatuses.push(zt) : e.matchUpFilters.excludeMatchUpStatuses = [zt]);
  let { completedMatchUps: v, upcomingMatchUps: S, pendingMatchUps: T, groupInfo: A, mappedParticipants: y } = $u({ ...e, matchUpFilters: e.matchUpFilters, contextFilters: e.contextFilters }), D = [...S ?? [], ...T ?? []];
  U && (!(I != null && I.length) || Object.keys(U).length) && (D = D.filter((V) => {
    var G, q;
    let { drawId: k, structureId: L, stage: B } = V;
    if (!((q = (G = U == null ? void 0 : U[k]) == null ? void 0 : G.publishingDetail) != null && q.published)) return !1;
    if (U[k].stageDetails) {
      let Y = Object.keys(U[k].stageDetails), H = Y.filter((z) => !U[k].stageDetails[z].published), X = Y.filter((z) => U[k].stageDetails[z].published);
      return H.length && H.includes(B) ? !1 : X.length && X.includes(B) ? !0 : H.length && !H.includes(B) && !X.length;
    }
    if (U[k].structureDetails) {
      let Y = Object.keys(U[k].structureDetails), H = Y.filter((z) => !U[k].structureDetails[z].published), X = Y.filter((z) => U[k].structureDetails[z].published);
      return H.length && H.includes(L) ? !1 : X.length && X.includes(L) ? !0 : H.length && !H.includes(L) && !X.length;
    }
    return !0;
  }));
  let P = n ? Np({ matchUps: D, schedulingProfile: i }) : D, w = t == null ? void 0 : t.map((V) => {
    let k = b(V);
    return { surfaceCategory: (V == null ? void 0 : V.surfaceCategory) ?? "", matchUps: k, ...V };
  }), R = { completedMatchUps: o ? g : v, mappedParticipants: e.hydrateParticipants ? void 0 : y, dateMatchUps: P, courtsData: w, groupInfo: A, venues: r };
  if (u) {
    let { rows: V, courtPrefix: k } = nh({ minRowsCount: d, courtsData: w });
    R.courtPrefix = k, R.rows = V;
  }
  return { ...R, ...j };
  function b({ courtId: V }) {
    let k = (a ? P.concat(v ?? []) : P).filter((L) => {
      var B, G, q;
      return ((B = L.schedule) == null ? void 0 : B.courtId) === V || ((q = (G = L.schedule) == null ? void 0 : G.allocatedCourts) == null ? void 0 : q.map(({ courtId: Y }) => Y).includes(V));
    });
    return f ? Np({ matchUps: k, schedulingProfile: i }) : k;
  }
}
function uh({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: xt };
  let r = Object.keys(e).filter((n) => !t || n === t), i;
  return r.forEach((n) => {
    let a = e[n], { matchUpDailyLimits: o } = Nj({ tournamentRecord: a });
    i = o;
  }), { matchUpDailyLimits: i };
}
function Nj(e) {
  var s;
  let t = Ae(e, [{ [fr]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r } = e, { policy: i } = qo({ policyType: ao, tournamentRecord: r }), { extension: n } = We({ element: r, name: Sd }), a = (s = n == null ? void 0 : n.value) == null ? void 0 : s.dailyLimits, o = i == null ? void 0 : i.defaultDailyLimits;
  return { matchUpDailyLimits: a || o };
}
function PS(e) {
  var O, M, N, C;
  let { matchUps: t } = e, { singlesForDoubles: r, tournamentRecord: i, drawDefinition: n, excludeMargin: a, exclusionRule: o, zoneDoubling: s, matchUpType: c, scaleName: u, eventId: d, zonePct: l, drawId: p, event: f } = e;
  if (!i && !t) return { error: de };
  if (c && ![mt, ft].includes(c)) return { error: ie, info: { matchUpType: c } };
  if (t && !rn(t)) return { error: ie, context: { matchUps: t } };
  let m = Ur[u], h = (m == null ? void 0 : m.ascending) ?? e.ascending ?? !1, g = (m == null ? void 0 : m.accessor) ?? e.valueAccessor, I = Array.isArray(m == null ? void 0 : m.range) ? Math.abs(m.range[0] - m.range[1]) : 0, U = ke(l) && I ? (l ?? 0 / 100) * I : e.zoneMargin ?? I, v = { withScaleValues: !0, withCompetitiveness: !0 }, S = { matchUpTypes: c ? [c] : [mt, ft] }, T = i == null ? void 0 : i.participants;
  (O = t == null ? void 0 : t[0]) != null && O.hasContext ? p ? t = t.filter((F) => F.drawId === p) : d && (t = t.filter((F) => F.eventId === d)) : t === void 0 && (t = p && !n && [] || !p && d && !f && [] || p && ((M = Qr({ inContext: !0, drawDefinition: n, contextFilters: S, contextProfile: v, participants: T })) == null ? void 0 : M.matchUps) || !p && d && ((N = ma({ inContext: !0, contextFilters: S, contextProfile: v, participants: T, event: f })) == null ? void 0 : N.matchUps) || ((C = Pr({ tournamentRecord: i, contextFilters: S, contextProfile: v })) == null ? void 0 : C.matchUps) || []), c && (t = t.filter((F) => F.matchUpType === c));
  let A = t.filter(({ winningSide: F, score: x, sides: V, matchUpStatus: k }) => ![Wr, Je, ct, Xc, Bi].includes(k ?? "") && pr({ score: x }) && (V == null ? void 0 : V.length) === 2 && F), y = Ej({ matchUps: A, excludeMargin: a, exclusionRule: o, valueAccessor: g, ascending: h, scaleName: u }), D = !s || Kt(mt)(c) ? U : (U || 0) * 2, P = U ? A.map(({ competitiveProfile: F, matchUpType: x, score: V, sides: k }) => {
    let L = AE({ singlesForDoubles: r, valueAccessor: g, matchUpType: x, scaleName: u, sides: k }), B = Math.abs(L[0].value - L[1].value);
    return { competitiveness: F == null ? void 0 : F.competitiveness, valuesGap: B, score: V };
  }).filter(({ valuesGap: F }) => F <= D) : [], w = Mj({ zoneData: P }), R = w && [].concat(Object.values(w)).flat().length, b = R && Object.assign({}, ...Object.keys(w).map((F) => ({ [F]: Math.round(1e4 * w[F].length / R) / 100 }))), E = A.length - ((P == null ? void 0 : P.length) || 0);
  return { ...j, relevantMatchUps: A, zoneDistribution: b, zoneData: P, accuracy: y, nonZone: E };
}
function Mj({ zoneData: e }) {
  let t = { [Vv]: [], [zu]: [], [Ku]: [] };
  for (let r of e) {
    let { competitiveness: i, score: n, valuesGap: a } = r;
    t[i] && t[i].push({ score: n, valuesGap: a });
  }
  return t;
}
function AE({ singlesForDoubles: e, exclusionRule: t, valueAccessor: r, matchUpType: i, scaleName: n, sides: a }) {
  let o = t == null ? void 0 : t.range.sort(), s = (c) => {
    let u = c == null ? void 0 : c[t == null ? void 0 : t.valueAccessor];
    return { exclude: t && u >= o[0] && u <= o[1], exclusionValue: u };
  };
  return a.sort((c, u) => c.sideNumber - u.sideNumber).map(({ participant: c }) => {
    let u = [], d = c == null ? void 0 : c.individualParticipants;
    if (d != null && d.length) {
      let l = [], p = 0;
      for (let f of d) {
        let { scaleValue: m, value: h } = jT({ singlesForDoubles: e, valueAccessor: r, participant: f, matchUpType: i, scaleName: n }), { exclude: g, exclusionValue: I } = s(m);
        g && u.push(I), l.push(m), h && !isNaN(p) ? p += h : p = void 0;
      }
      return { participantName: c.participantName, exclusionValues: u, scaleValues: l, value: p };
    } else if (c) {
      let { scaleValue: l, value: p } = jT({ singlesForDoubles: e, valueAccessor: r, matchUpType: i, participant: c, scaleName: n }), { exclude: f, exclusionValue: m } = s(l);
      return f && u.push(m), { participantName: c.participantName, exclusionValues: u, scaleValue: l, value: p };
    } else return {};
  });
}
function jT({ singlesForDoubles: e, valueAccessor: t, matchUpType: r, participant: i, scaleName: n }) {
  var u, d, l, p, f;
  let a = e ? mt : r, o = (d = (u = i == null ? void 0 : i.rankings) == null ? void 0 : u[a]) == null ? void 0 : d.find((m) => m.scaleName === n), s = (f = ((p = (l = i == null ? void 0 : i.ratings) == null ? void 0 : l[a]) == null ? void 0 : p.find((m) => m.scaleName === n)) || o) == null ? void 0 : f.scaleValue, c = t ? s == null ? void 0 : s[t] : s;
  return { scaleValue: s, value: c };
}
function Ej({ excludeMargin: e, exclusionRule: t, valueAccessor: r, ascending: i, scaleName: n, matchUps: a }) {
  let o = { affirmative: [], negative: [], excluded: [] };
  for (let u of a) {
    let { matchUpType: d, sides: l, score: p, winningSide: f } = u;
    if (!f) continue;
    if (t && (!t.valueAccessor || !t.range)) return { info: "exclusionRule requires valueAccessor and range", error: we };
    let m = f - 1, h = AE({ exclusionRule: t, valueAccessor: r, matchUpType: d, scaleName: n, sides: l });
    if (t) {
      let T = h.map(({ exclusionValues: A }) => A).flat();
      if (T.length) {
        o.excluded.push({ scoreString: p == null ? void 0 : p.scoreStringSide1, exclusionValues: T, winningSide: f, sideValues: h });
        continue;
      }
    }
    if (h.filter((T) => ![void 0, "", null].includes(T.value)).length < 2) {
      o.excluded.push({ scoreString: p == null ? void 0 : p.scoreStringSide1, missingValues: !0, winningSide: f, sideValues: h });
      continue;
    }
    let g = h[m].value - h[1 - m].value, I = parseFloat(e || 0), U = I && Math.abs(g) < I;
    if (U) {
      o.excluded.push({ scoreString: p == null ? void 0 : p.scoreStringSide1, excludeMargin: e, winningSide: f, excludeGap: U, sideValues: h, valuesGap: g });
      continue;
    }
    let v = i ? g : g * -1, S = f === 1 ? p == null ? void 0 : p.scoreStringSide1 : p == null ? void 0 : p.scoreStringSide2;
    v > 0 ? o.affirmative.push({ winningScoreString: S, winningSide: f, sideValues: h, valuesGap: g, score: p }) : o.negative.push({ winningScoreString: S, winningSide: f, sideValues: h, valuesGap: g, score: p });
  }
  let s = o.affirmative.length + o.negative.length, c = s && o.affirmative.length / s * 100;
  return o.percent = c ? Math.round(100 * c) / 100 : 0, o;
}
function Xs({ collectionDefinitions: e = [], collectionGroups: t = [] }) {
  let r = 0, { groupValueNumbers: i } = RM({ collectionGroups: t }), n;
  for (let a of e || []) {
    let { collectionValueProfiles: o, collectionGroupNumber: s, collectionValue: c, matchUpCount: u, matchUpValue: d, scoreValue: l, setValue: p } = a, f = s && i.includes(s);
    if (ke(p || l)) n = !0;
    else {
      if (f) continue;
      if (typeof c == "number" && ke(c)) r += c;
      else if (Array.isArray(o) && (o != null && o.length)) for (let m of o) r += m.matchUpValue;
      else typeof d == "number" && ke(d) && (r += (u ?? 0) * d);
    }
  }
  for (let a of t) r += a.groupValue ?? 0;
  return n || !r ? { aggregateValue: !0, ...j } : { valueGoal: Math.floor(r / 2) + 1, ...j };
}
function wS(e) {
  let { timeStamp: t, schedule: r, matchUp: i } = e, n = Ae(e, [{ [pa]: !0 }]);
  if (n.error) return n;
  let { itemValue: a, timeStamp: o } = zo({ timeItems: (i == null ? void 0 : i.timeItems) || [], itemType: Hv });
  return !r || o && t && new Date(o).getTime() > new Date(t).getTime() ? { homeParticipantId: a } : r;
}
function RS({ matchUps: e, matchUpId: t }) {
  if (!rn(e)) return { error: ie };
  let r = e.find((s) => s.matchUpId === t), { drawId: i, eventId: n, structureId: a, tournamentId: o } = r || {};
  return { matchUpId: t, drawId: i, eventId: n, structureId: a, tournamentId: o };
}
function ou(e, t) {
  if (!$e(e)) return { error: ie };
  if (!Array.isArray(t)) return { error: ie };
  let r = {};
  for (let { param: i, error: n, attr: a } of t) {
    let o = Oj({ params: e, param: i, attr: a, error: n });
    if (o != null && o.error) return o;
    r[i] = o;
  }
  return r;
}
function Oj({ params: e, param: t, attr: r, error: i }) {
  if (t === em && $e(e.drawDefinition) && Et(e.structureId)) {
    let n = (e.drawDefinition.structures ?? []).find(({ structureId: a }) => a === e.structureId);
    return !n.length && i ? { error: i } : { structure: n };
  }
  if (t === pa) {
    let n = lE({ ...e, ...r });
    return n.error && i ? { ...n, error: i } : n;
  }
  return { error: Tr, info: { param: t } };
}
function bS(e) {
  var p, f;
  let { structureId: t, matchUpId: r, event: i } = e, n = e.drawDefinition, a = Ae(e, [{ [fr]: !0 }, { [lv]: { [Qf]: !1, [zn]: !1, [sb]: !1, [no]: !1 } }]);
  if (a[pn]) return a;
  let o = (p = ou(e, [{ [Yc]: pa, [pn]: we }])) == null ? void 0 : p.matchUp;
  if (r && (o != null && o.error)) return o;
  !n && (o != null && o.drawDefinition) && (n = o == null ? void 0 : o.drawDefinition);
  let s = o == null ? void 0 : o.structure;
  if (!s && t && !r) {
    if (!n) return { error: Cn };
    let m = Ne({ drawDefinition: n, structureId: t });
    if (m.error) return m;
    s = m.structure;
  }
  let c = s == null ? void 0 : s.matchUpFormat, u = n == null ? void 0 : n.matchUpFormat, d = i == null ? void 0 : i.matchUpFormat, l = ((f = o == null ? void 0 : o.matchUp) == null ? void 0 : f.matchUpFormat) || c || u || d;
  return { structureDefaultMatchUpFormat: c, eventDefaultMatchUpFormat: d, drawDefaultMatchUpFormat: u, matchUpFormat: l };
}
function NS({ profileBands: e, tournamentRecord: t, matchUps: r }) {
  if (!rn(r)) return { error: Ma };
  let i = !e && qo({ policyType: ha, tournamentRecord: t }).policy, n = e || (i == null ? void 0 : i.profileBands) || Gv[ha].profileBands, a = r.filter(({ winningSide: p }) => p), o = a.map(Kb), s = (p, f) => {
    let m = zb(f, n);
    return p[m] += 1, p;
  }, c = Xb(o).reduce((p, f) => s(p, f), { [Vv]: 0, [zu]: 0, [Ku]: 0, [jb]: 0 }), u = Object.keys(c).reduce((p, f) => (c[f] || 0) + p, 0), d = Object.keys(c).map((p) => {
    let f = parseFloat((c[p] / u).toFixed(4));
    return { [p]: f * 100 };
  }), l = a.filter(({ matchUpStatus: p }) => p === lT).length;
  return d.push({ [lT]: parseFloat((l / u).toFixed(4)) * 100 }), { competitiveBands: Object.assign({}, ...d), ...j };
}
var { stageOrder: _T } = dL;
function Cj(e, t) {
  return e.eventName.localeCompare(t.eventName) || e.eventId.localeCompare(t.eventId) || (_T[e == null ? void 0 : e.stage] || 0) - (_T[t == null ? void 0 : t.stage] || 0) || t.matchUpsCount - e.matchUpsCount || `${e.stageSequence}-${e.roundNumber}-${e.minFinishingSum}`.localeCompare(`${t.stageSequence}-${t.roundNumber}-${t.minFinishingSum}`);
}
function MS({ excludeScheduleDateProfileRounds: e, excludeScheduledRounds: t, excludeCompletedRounds: r, inContextMatchUps: i, tournamentRecords: n, schedulingProfile: a, tournamentRecord: o, withSplitRounds: s, matchUpFilters: c, scheduleDate: u, withRoundId: d, venueId: l, context: p }) {
  var A;
  if (i && !Array.isArray(i || typeof i[0] != "object")) return { error: ie, inContextMatchUps: i };
  if (o && !n) {
    if (typeof o != "object") return { error: nd };
    n = { [o.tournamentId]: o };
  }
  let f = typeof n != "object" || !Object.keys(n).length;
  if ((l || u || !i || !a && (e || r || a || s)) && f) return { error: xt };
  let m = Object.assign({}, ...Object.values(n ?? {}).map(({ venues: y = [], tournamentId: D }) => ({ [D]: y == null ? void 0 : y.map(({ venueId: P }) => P) }))), h = Object.values(n ?? {}).map(({ events: y = [], tournamentId: D, startDate: P, endDate: w }) => y.map((R) => ({ ...R, validVenueIds: m[D], startDate: R.startDate ?? P, endDate: R.endDate ?? w }))).flat(), { segmentedRounds: g, profileRounds: I } = n && (e || r || a || s) && ih({ tournamentRecords: n, schedulingProfile: a }) || {}, U = e && Object.assign({}, ...I.map((y) => ({ [y.id]: y }))), v = i || n && ((A = On({ tournamentRecords: n, matchUpFilters: c })) == null ? void 0 : A.matchUps) || [], S = [], T = v && Object.values(v.reduce((y, D) => {
    var H;
    let P = tI(D).id, w = g == null ? void 0 : g[P], R = [...((H = y[P]) == null ? void 0 : H.matchUps) ?? [], D], { containerStructureId: b, stageSequence: E, structureName: O, tournamentId: M, isRoundRobin: N, matchUpType: C, roundNumber: F, roundOffset: x, structureId: V, eventName: k, roundName: L, drawName: B, eventId: G, drawId: q } = D, Y = N ? b : V;
    return { ...y, [P]: { id: d ? P : void 0, structureId: Y, stageSequence: E, segmentsCount: w, structureName: O, tournamentId: M, matchUpType: C, roundNumber: F, roundOffset: x, eventName: k, roundName: L, drawName: B, matchUps: R, eventId: G, drawId: q } };
  }, {})).map((y) => {
    let { minFinishingSum: D, winnerFinishingPositionRange: P } = Pj(y.matchUps), w = y.segmentsCount;
    if (w) {
      let F = y.matchUps.length / w;
      return gr(y.matchUps.sort((x, V) => x.roundPosition - V.roundPosition), F).map((x, V) => {
        let { unscheduledCount: k, incompleteCount: L, matchUpsCount: B, isScheduled: G, isComplete: q, byeCount: Y } = GT(x), H = VT({ matchUps: y.matchUps, tournamentRecords: n, events: h, round: y });
        return ye({ ...y, ...p, roundSegment: { segmentsCount: w, segmentNumber: V + 1 }, winnerFinishingPositionRange: P, unscheduledCount: k, incompleteCount: L, minFinishingSum: D, matchUpsCount: B, isScheduled: G, roundTiming: H, isComplete: q, byeCount: Y, matchUps: x });
      });
    }
    let { unscheduledCount: R, incompleteCount: b, matchUpsCount: E, isScheduled: O, isComplete: M, byeCount: N } = GT(y.matchUps), C = VT({ matchUps: y.matchUps, tournamentRecords: n, events: h, round: y });
    return ye({ ...y, ...p, winnerFinishingPositionRange: P, unscheduledCount: R, incompleteCount: b, minFinishingSum: D, matchUpsCount: E, isScheduled: O, roundTiming: C, isComplete: M, byeCount: N });
  }).flat().filter((y) => {
    if (e) {
      let V = Ve(e), k = d ? y.id : tI(y).id;
      if (V && U[k] && Ve(U[k].scheduleDate) === V) return !1;
    }
    let { isComplete: D, isScheduled: P } = y, w = !r || !D, R = !t || !P, b = l || u ? h == null ? void 0 : h.find(({ eventId: V }) => V === y.eventId) : void 0, E = (b == null ? void 0 : b.startDate) ?? (o == null ? void 0 : o.startDate), O = (b == null ? void 0 : b.endDate) ?? (o == null ? void 0 : o.endDate), M = !u || !E || new Date(u) >= new Date(E), N = !u || !O || new Date(u) <= new Date(O), C = M && N, F = !l || (b == null ? void 0 : b.validVenueIds.includes(l)), x = w && R && F && C;
    return x || S.push(y), x;
  }).sort(Cj) || [];
  return { ...j, rounds: T, excludedRounds: S };
}
function ed(e) {
  var q;
  let { matchUp: t, sideNumber: r, setNumber: i, isTiebreakValue: n, isPointValue: a } = e || {}, { matchUpFormat: o } = e || {};
  if (!t) return { error: hi };
  o = o || (t == null ? void 0 : t.matchUpFormat);
  let s = ti(o), c = !!(t != null && t.winningSide), u = (q = t.score) == null ? void 0 : q.sets, d = u == null ? void 0 : u.length, l = i && i - 1, p = !!(u != null && u.find((Y, H) => Y.setNumber === i && H === l)), f = (u == null ? void 0 : u.filter((Y) => Y == null ? void 0 : Y.winningSide)) || [], m = (f == null ? void 0 : f.length) || 0, h = i && (u == null ? void 0 : u.slice(i)) || [], g = !!(d && i && (h != null && h.reduce((Y, H) => (!H || !H.side1Score && !H.side2Score && !H.side1TiebreakScore && !H.side2TiebreakScore && !H.side1PointScore && !H.side2PointScore) && Y, !0))), I = i <= d && u.find((Y) => Y.setNumber === i), U = I && Ju({ setObject: I, matchUpScoringFormat: s }), { isCompletedSet: v, sideGameScores: S, sideTiebreakScores: T } = U || {}, A = !!(I && !v && g || i && i === d + 1 && !c), y = [1, 2].includes(r), D = y ? r - 1 : 0, P = I && y && (!n && !a && S[D] !== void 0 && S[D] || n && T[D] !== void 0 && T[D]), w = !!P, R = f == null ? void 0 : f.map((Y) => Ju({ setObject: Y, matchUpScoringFormat: s }).isValidSetOutcome).reduce((Y, H) => Y && H, !0), b = f.reduce((Y, H) => {
    let { winningSide: X } = H, z = X - 1;
    return Y[z]++, Y;
  }, [0, 0]), E = t == null ? void 0 : t.winningSide, O = E && E - 1, M = 1 - O, N = b[O], C = b[M], F = Math.max(...b), x = wi(b)[F], { bestOf: V, exactly: k } = s ?? {}, L = V && Math.ceil(V / 2) || k || 1, B = F === L && x === 1 && b.indexOf(F) + 1 || void 0, G = N > C && E === B;
  return { completedSetsHaveValidOutcomes: R, validMatchUpWinningSide: G, calculatedWinningSide: B, matchUpScoringFormat: s, validMatchUpOutcome: B && R && G, isLastSetWithValues: g, completedSetsCount: m, isCompletedMatchUp: c, isValidSideNumber: y, hasExistingValue: w, existingValue: P, isExistingSet: p, isActiveSet: A, ...U };
}
function ES({ participants: e, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, usePublishState: c, contextFilters: u, contextContent: d, matchUpFilters: l, participantMap: p, publishStatus: f, contextProfile: m, drawDefinition: h, nextMatchUps: g, tournamentId: I, inContext: U, context: v, event: S }) {
  let { eventId: T, eventName: A, endDate: y, eventType: D, category: P, gender: w } = S ?? {}, R = { ...v, ...ye({ surfaceCategory: (S == null ? void 0 : S.surfaceCategory) ?? (s == null ? void 0 : s.surfaceCategory), indoorOutDoor: (S == null ? void 0 : S.indoorOutdoor) ?? (s == null ? void 0 : s.indoorOutdoor), endDate: y ?? (S == null ? void 0 : S.endDate) ?? (s == null ? void 0 : s.endDate), tournamentId: I ?? (s == null ? void 0 : s.tournamentId), eventName: A, eventType: D, category: P, eventId: T, gender: w }) }, b;
  return !(e != null && e.length) && s && ({ participants: e, participantMap: p, groupInfo: b } = Wo({ participantsProfile: i, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, contextProfile: m, inContext: U })), S && m && !d && (d = ka({ policyDefinitions: a, tournamentRecord: s, contextProfile: m, drawDefinition: h, event: S })), { ...Jc({ context: R, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, tournamentParticipants: e, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: s, usePublishState: c, participantMap: p, contextContent: d, contextFilters: u, matchUpFilters: l, publishStatus: f, contextProfile: m, drawDefinition: h, nextMatchUps: g, inContext: U, event: S }), groupInfo: b };
}
var TE = {};
qe(TE, { getCompetitionVenues: () => al, getCourts: () => OS, getVenuesAndCourts: () => xa, publicFindVenue: () => Kv });
function OS({ tournamentRecord: e, venueId: t, venueIds: r }) {
  return e ? { courts: (e.venues || []).filter((i) => t ? i.venueId === t : r ? r.includes(i.venueId) : !0).map((i) => {
    let { venueId: n } = i, a = ge(i.courts || []);
    return a.forEach((o) => Object.assign(o, { venueId: n })), a;
  }).flat() } : { error: de };
}
var DE = {};
qe(DE, { categoryCanContain: () => pd, getCategoryAgeDetails: () => fs, getEvent: () => kS, getEventProperties: () => CS, getEventStructures: () => Rm, getEventTimeItem: () => Dd, getEvents: () => FS, getFlightProfile: () => Ht, getScaledEntries: () => zs });
function CS({ tournamentRecord: e, event: t }) {
  var l, p;
  if (!e) return { error: de };
  if (!t) return { error: At };
  let r = t.entries || [], i = e.participants || [], n = ((l = t.category) == null ? void 0 : l.categoryName) || ((p = t.category) == null ? void 0 : p.ageCategoryCode), { eventType: a } = t, o = r.map((f) => f.participantId), s = i.filter((f) => o.includes(f.participantId)), c, u, d;
  return { entryScaleAttributes: s.map((f) => {
    var T, A, y, D, P, w;
    let { participantId: m, participantName: h, name: g } = f, I = { scaleType: zv, eventType: a, scaleName: n }, U = (A = (T = ta({ participant: f, scaleAttributes: I })) == null ? void 0 : T.scaleItem) == null ? void 0 : A.scaleValue;
    I = { scaleType: nN, eventType: a, scaleName: n };
    let v = (D = (y = ta({ participant: f, scaleAttributes: I })) == null ? void 0 : y.scaleItem) == null ? void 0 : D.scaleValue;
    I = { scaleType: iN, eventType: a, scaleName: n };
    let S = (w = (P = ta({ participant: f, scaleAttributes: I })) == null ? void 0 : P.scaleItem) == null ? void 0 : w.scaleValue;
    return c = !!(c || U), u = !!(u || v), d = !!(d || S), { participantId: m, participantName: h || g, seed: U, ranking: v, rating: S };
  }), hasSeededParticipants: c, hasRankedParticipants: u, hasRatedParticipants: d };
}
function FS({ tournamentRecord: e, withScaleValues: t, scaleEventType: r, inContext: i, eventIds: n, drawIds: a, context: o }) {
  var d, l, p, f;
  if (!e) return { error: de };
  let { tournamentId: s } = e, c = (e.events ?? []).filter(({ eventId: m }) => !n || Array.isArray(n) && n.includes(m)).map((m) => {
    var I;
    let h = (I = m.drawDefinitions) == null ? void 0 : I.map(Hu);
    if (a != null && a.length && !qt(a, h).length) return;
    let g = ge(m);
    return i && Object.assign(g, { tournamentId: s }), o && Object.assign(g, o), g;
  }).filter(Boolean), u = {};
  if (t) {
    let m = Lt({ withScaleValues: !0, tournamentRecord: e }).participantMap, h = (g) => g.reduce((I, U) => I + parseFloat(U), 0);
    for (let g of c) {
      let I = r ?? g.eventType, U = g.eventId;
      u[U] || (u[U] = { ratingsStats: {}, ratings: {}, ranking: {}, draws: {} });
      let v = (g.entries ?? []).filter(({ entryStatus: w }) => yn.includes(w)).map(Ke), S = (w) => {
        var R, b, E, O, M, N;
        if ((R = w == null ? void 0 : w.ratings) != null && R[I]) for (let C of ((b = w == null ? void 0 : w.ratings) == null ? void 0 : b[I]) ?? []) {
          let F = C.scaleName;
          u[U].ratings[F] || (u[U].ratings[F] = []);
          let x = (E = Ur[F]) == null ? void 0 : E.accessor;
          if (x) {
            let V = parseFloat((O = C.scaleValue) == null ? void 0 : O[x]);
            V && u[U].ratings[F].push(V);
          }
        }
        if ((M = w == null ? void 0 : w.rankings) != null && M[I]) for (let C of ((N = w == null ? void 0 : w.rankings) == null ? void 0 : N[I]) ?? []) {
          let F = C.scaleName;
          u[U].ranking[F] || (u[U].ranking[F] = []), C.scaleValue && u[U].ranking[F].push(C.scaleValue);
        }
      };
      for (let w of v) {
        let R = (d = m == null ? void 0 : m[w]) == null ? void 0 : d.participant;
        if ((R == null ? void 0 : R.participantType) !== Xe) for (let b of (R == null ? void 0 : R.individualParticipantIds) ?? []) {
          let E = (l = m == null ? void 0 : m[b]) == null ? void 0 : l.participant;
          S(E);
        }
        else S(R);
      }
      let T = u[U].ratings;
      for (let w of Object.keys(T)) {
        let R = T[w];
        if (!R.length) continue;
        let b = (p = eT(R)) == null ? void 0 : p.toFixed(2);
        u[U].ratingsStats[w] = { avg: parseFloat((h(R) / R.length).toFixed(2)), median: b ? parseFloat(b) : void 0, max: Math.max(...R), min: Math.min(...R) };
      }
      let A = (w, R) => {
        var E, O;
        let b = (M) => {
          var N, C, F, x, V, k, L, B, G, q;
          if ((N = u[U].draws) != null && N[w] && ((C = M == null ? void 0 : M.ratings) != null && C[I])) for (let Y of ((F = M == null ? void 0 : M.ratings) == null ? void 0 : F[I]) ?? []) {
            let H = Y.scaleName;
            (x = u[U].draws[w]) != null && x.ratings[H] || (u[U].draws[w].ratings[H] = []);
            let X = (V = Ur[H]) == null ? void 0 : V.accessor;
            if (X) {
              let z = parseFloat((k = Y.scaleValue) == null ? void 0 : k[X]);
              z && u[U].draws[w].ratings[H].push(z);
            }
          }
          if ((L = u[U].draws) != null && L[w] && ((B = M == null ? void 0 : M.rankings) != null && B[I])) for (let Y of ((G = M == null ? void 0 : M.rankings) == null ? void 0 : G[I]) ?? []) {
            let H = Y.scaleName;
            (q = u[U].draws[w]) != null && q.ranking[H] || (u[U].draws[w].ranking[H] = []);
            let X = Y.scaleValue;
            X && u[U].draws[w].ranking[H].push(X);
          }
        };
        for (let M of R.filter(Boolean)) {
          let N = (E = m == null ? void 0 : m[M]) == null ? void 0 : E.participant;
          if ((N == null ? void 0 : N.participantType) !== Xe) for (let C of (N == null ? void 0 : N.individualParticipantIds) ?? []) {
            let F = (O = m == null ? void 0 : m[C]) == null ? void 0 : O.participant;
            b(F);
          }
          else b(N);
        }
      }, y = [], D = (w) => (a == null ? void 0 : a.length) && a.includes(w) || y.includes(w);
      for (let w of g.drawDefinitions ?? []) {
        let R = w.drawId;
        if (D(R)) continue;
        let b = Ko({ drawDefinition: w }).assignedParticipantIds ?? [];
        u[U].draws[R] || (u[U].draws[R] = { ratingsStats: {}, ratings: {}, ranking: {} }), y.push(R), A(R, b);
      }
      let P = Ht({ event: g }).flightProfile;
      for (let w of (P == null ? void 0 : P.flights) ?? []) {
        let R = w.drawId;
        if (D(R)) continue;
        let b = w.drawEntries.map(Ke);
        A(R, b);
      }
      for (let w of y) {
        let R = u[U].draws[w].ratings;
        for (let b of Object.keys(R)) {
          let E = R[b];
          if (!E.length) continue;
          let O = (f = eT(E)) == null ? void 0 : f.toFixed(2);
          u[U].draws[w].ratingsStats[b] = { avg: parseFloat((h(E) / E.length).toFixed(2)), median: O ? parseFloat(O) : void 0, max: Math.max(...E), min: Math.min(...E) };
        }
      }
    }
  }
  return ye({ eventScaleValues: u, events: c, ...j });
}
function kS({ tournamentRecord: e, drawDefinition: t, context: r, event: i }) {
  var o;
  if (!e) return { error: de };
  if (!i) return { error: At };
  let n = ge(i);
  r && Object.assign(n, r);
  let a = t && ((o = n.drawDefinitions) == null ? void 0 : o.find(({ drawId: s }) => t.drawId === s));
  return ye({ drawDefinition: a, event: n });
}
function Fj(e) {
  var f, m;
  let t = "validateAndDeriveDrawValues", { appliedPolicies: r, policyDefinitions: i } = xj(e), n = Bj({ ...e, policyDefinitions: i, appliedPolicies: r }), a = Lj(e), o = Vj({ ...e, consideredEntries: a, appliedPolicies: r });
  if (o != null && o.error) return W({ result: o, stack: t });
  let s = Gj({ ...e, consideredEntries: a }), c = kj({ ...e, appliedPolicies: r, policyDefinitions: i, drawSize: s });
  if (c.error) return W({ result: c, stack: t });
  let u = c.drawType;
  if (isNaN(s) && u !== Li) return W({ result: { error: od }, stack: t });
  let d = (i == null ? void 0 : i[Tn]) ?? (r == null ? void 0 : r[Tn]), l = e.seedingProfile ?? ((m = (f = d == null ? void 0 : d.seedingProfile) == null ? void 0 : f.drawTypes) == null ? void 0 : m[u ?? ""]) ?? (d == null ? void 0 : d.seedingProfile);
  e.seedingProfile && (i[Tn] || (i[Tn] = { ...eI[Tn] }), i[Tn].seedingProfile = l);
  let p = jj({ ...e, drawType: u });
  return p != null && p.error ? W({ result: p, stack: t }) : { drawSize: s, drawType: u, enforceGender: n, seedingProfile: l, appliedPolicies: r, policyDefinitions: i };
}
function kj(e) {
  let { policyDefinitions: t, appliedPolicies: r, enforceMinimumDrawSize: i = !0, drawSize: n } = e, a = e.drawTypeCoercion ?? rl({ drawType: e.drawType, policyDefinitions: t, appliedPolicies: r }), o = $M({ drawType: e.drawType, enforceMinimumDrawSize: i, drawTypeCoercion: a, drawSize: n });
  return o.error ? o : { drawType: o.drawType };
}
function PE(e) {
  return e == null ? void 0 : e.filter((t) => t.entryStatus && [...yn, Ed].includes(t.entryStatus));
}
function Lj({ considerEventEntries: e = !0, drawEntries: t, eventEntries: r, qualifyingOnly: i }) {
  return (i && [] || PE(t) || (e ? r : [])).filter(({ entryStage: n }) => !n || n === Ie);
}
function xj(e) {
  let { tournamentRecord: t, event: r } = e, i = nt({ tournamentRecord: t, event: r }).appliedPolicies ?? {}, n = ge(e.policyDefinitions ?? {}, !1, !0);
  return { appliedPolicies: i, policyDefinitions: n };
}
function Bj({ enforceGender: e, policyDefinitions: t, appliedPolicies: r }) {
  var i, n, a, o;
  return e ?? ((n = (i = t == null ? void 0 : t[Ar]) == null ? void 0 : i.participants) == null ? void 0 : n.enforceGender) ?? ((o = (a = r == null ? void 0 : r[Ar]) == null ? void 0 : a.participants) == null ? void 0 : o.enforceGender);
}
function Vj(e) {
  let { consideredEntries: t, appliedPolicies: r, policyDefinitions: i, enforceGender: n, participantMap: a, participants: o, event: s } = e;
  return s && o && Bm({ consideredEntries: t, policyDefinitions: i, appliedPolicies: r, participantMap: a, enforceGender: n, participants: o, event: s });
}
function Gj(e) {
  return !e.drawSize && e.consideredEntries.length && ![Li, md, Hc, hn, sa].includes(e.drawType ?? "") && Lc(e.consideredEntries.length) || e.drawSize && be(e.drawSize) || !1;
}
function jj(e) {
  var o, s;
  let { tournamentRecord: t, event: r, ignoreAllowedDrawTypes: i, drawType: n } = e, a = !i && t && zm({ tournamentRecord: t, categoryType: (o = r == null ? void 0 : r.category) == null ? void 0 : o.categoryType, categoryName: (s = r == null ? void 0 : r.category) == null ? void 0 : s.categoryName });
  return a != null && a.length && !a.includes(n) ? { error: II } : { ...j };
}
function dl(e) {
  let { voluntaryConsolation: t, tournamentRecord: r, event: i } = e, n = "generateDrawDefinition", { participants: a, participantMap: o } = Lt({ withIndividualParticipants: !0, convertExtensions: !0, internalUse: !0, tournamentRecord: r }), s = PE(i == null ? void 0 : i.entries) ?? [], c = Fj({ ...e, participantMap: o, participants: a, eventEntries: s });
  if (c.error) return W({ result: c, stack: n });
  let { appliedPolicies: u, policyDefinitions: d, drawSize: l, drawType: p, enforceGender: f, seedingProfile: m } = c, h = i == null ? void 0 : i.eventType, g = e.matchUpType ?? h, I = B2({ ...e, enforceGender: f, eventType: h, matchUpType: g });
  if (I.error) return W({ result: I, stack: n });
  let { matchUpFormat: U, tieFormat: v } = I;
  if (e.drawId && typeof e.drawId != "string") return W({ result: { error: ie }, stack: n });
  let S = fj({ ...e, policyDefinitions: d, tournamentRecord: r, appliedPolicies: u, matchUpFormat: U, seedingProfile: m, participants: a, eventEntries: s, matchUpType: g, tieFormat: v, drawSize: l, drawType: p, event: i });
  if (S.error) return W({ result: S, stack: n });
  let { existingDrawDefinition: T, positioningReports: A, drawDefinition: y, structureId: D, conflicts: P, entries: w } = S;
  if (!y) return W({ result: { error: ie }, stack: n });
  let R = mj({ ...e, existingDrawDefinition: T, positioningReports: A, appliedPolicies: u, drawDefinition: y, seedingProfile: m, participants: a, structureId: D, entries: w, params: e, stack: n });
  if (R.error) return R;
  let { qualifyingConflicts: b } = R;
  return y.drawName = e.drawName ?? (p && Fr(p)), l && typeof t == "object" && l >= 4 && oU({ ...t, drawDefinition: y, matchUpType: g }), { existingDrawDefinition: !!T, qualifyingConflicts: b, positioningReports: A, drawDefinition: y, structureId: D, ...j, conflicts: P };
}
function wE({ scaleAttributes: e, scaledEntries: t, stageEntries: r, seedsCount: i, scaleName: n }) {
  if (!e) return { error: we, info: "missing scaleAttributes" };
  let a = Object.assign({}, ...(t || []).slice(0, i).map(({ participantId: s }, c) => ({ [s]: c + 1 })));
  n = n || e.scaleName;
  let o = (/* @__PURE__ */ new Date()).toISOString();
  return { scaleItemsWithParticipantIds: r.map(({ participantId: s }) => ({ scaleItems: [{ scaleValue: a[s], eventType: e.eventType, scaleType: $n, scaleName: n, scaleDate: o }], participantId: s })) };
}
function _j({ tournamentRecord: e, drawDefinition: t, policyDefinitions: r, scaleAttributes: i, scaleName: n, drawSize: a, drawId: o, event: s, stage: c, sortDescending: u, scaleSortMethod: d }) {
  let l = ah({ policyDefinitions: r, drawDefinition: t, drawSize: a, drawId: o, event: s, stage: c });
  if (l.error) return l;
  let { entries: p, seedsCount: f, stageEntries: m } = l;
  if (!m || !f) return { error: ie };
  let h = zs({ tournamentRecord: e, scaleAttributes: i, scaleSortMethod: d, sortDescending: u, entries: p, stage: c }).scaledEntries ?? [], { scaleItemsWithParticipantIds: g } = wE({ scaleAttributes: i, scaledEntries: h, stageEntries: m, seedsCount: f, scaleName: n });
  return { scaleItemsWithParticipantIds: g };
}
var RE = {};
qe(RE, { addDrawEntries: () => tU, addEventEntries: () => Bn, addEventEntryPairs: () => OE, destroyPairEntries: () => NN, destroyPairEntry: () => aU, getEntriesAndSeedsCount: () => ah, getMaxEntryPosition: () => SS, modifyEntriesStatus: () => gp, modifyEventEntries: () => CE, mutate: () => bE, promoteAlternate: () => ME, promoteAlternates: () => xS, query: () => UE, removeDrawEntries: () => EE, removeEventEntries: () => _d, setEntryPosition: () => LS, setEntryPositions: () => NE });
var bE = {};
qe(bE, { addDrawEntries: () => tU, addEventEntries: () => Bn, addEventEntryPairs: () => OE, destroyPairEntries: () => NN, destroyPairEntry: () => aU, modifyEntriesStatus: () => gp, modifyEventEntries: () => CE, promoteAlternate: () => ME, promoteAlternates: () => xS, removeDrawEntries: () => EE, removeEventEntries: () => _d, setEntryPosition: () => LS, setEntryPositions: () => NE });
function LS({ tournamentRecord: e, drawDefinition: t, participantId: r, entryPosition: i, skipRefresh: n, event: a }) {
  let o = "setEntryPositions";
  if (!e) return { error: de };
  if (!r) return W({ result: { error: cr }, stack: o });
  if (i !== void 0 && !Number.isSafeInteger(i)) return { error: ie, entryPosition: i };
  ((a == null ? void 0 : a.entries) || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  }), ((t == null ? void 0 : t.entries) || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  });
  let s = (c) => {
    c.entries.forEach((u) => {
      u.entryPosition === i && u.participantId !== r && (u.entryPosition += 0.1);
    });
  };
  return n || (a != null && a.entries && (s(a), a.entries = wn({ entries: a.entries })), t != null && t.entries && (s(t), t.entries = wn({ entries: t.entries }))), { ...j };
}
function NE({ tournamentRecord: e, entryPositions: t, drawDefinition: r, event: i }) {
  if (!e) return { error: de };
  if (!Array.isArray(t)) return { error: ie };
  for (let n of t) {
    let { participantId: a, entryPosition: o } = n, s = LS({ skipRefresh: !0, tournamentRecord: e, drawDefinition: r, participantId: a, entryPosition: o, event: i });
    if (s.error) return s;
  }
  return i != null && i.entries && (i.entries = wn({ entries: i.entries })), r != null && r.entries && (r.entries = wn({ entries: r.entries })), { ...j };
}
function ME(e) {
  let { participantId: t } = e;
  return t && typeof t != "string" ? { error: ie, participantId: t } : xS({ ...e, participantIds: [t].filter(Boolean) });
}
function xS({ tournamentRecord: e, drawDefinition: t, participantIds: r, stageSequence: i, stage: n = Ie, eventId: a, event: o }) {
  if (!e) return { error: de };
  if (!Array.isArray(r)) return { error: ie, participantIds: r };
  if (!o) return { error: At };
  let s = "promoteAlternates";
  if (o) {
    let c = WT({ element: o, participantIds: r, stageSequence: i, stage: n });
    if (c.error) return c;
  }
  if (t) {
    let c = WT({ element: t, participantIds: r, stageSequence: i, stage: n });
    if (c.error) return a ? W({ context: { drawPromotionError: c.error, drawId: t.drawId }, result: { ...j }, stack: s }) : c;
  }
  return { ...j };
}
function WT({ participantIds: e, stageSequence: t, element: r, stage: i }) {
  let n = (r.entries || []).filter((l) => l.entryStatus === fn), a = (r.entries || []).filter((l) => e.includes(l.participantId)), o = n.reduce((l, p) => {
    let { entryPosition: f } = p;
    return isNaN(f) && l || (!l || f < l.entryPosition) && p || l;
  }, void 0), s = a.length ? a : [o].filter(Boolean);
  if (!(s != null && s.length)) return { error: Tw };
  let c = s.filter(({ entryStatus: l }) => l !== fn);
  if (c.length) return { error: vg, invalidEntryStatus: c };
  let u = s.filter(({ entryStage: l }) => l && l !== i);
  if (u.length) return { error: $F, invalidStage: u };
  let d = t && s.filter((l) => l.stageSequence !== t);
  if (d != null && d.length) return { error: ek, invalidStageSequence: d };
  for (let l of s) {
    l.entryStatus = Ii;
    let p = l == null ? void 0 : l.entryPosition;
    isNaN(p) || r.entries.forEach((m) => {
      m.entryStatus === fn && m.entryPosition > p && (m.entryPosition = m.entryPosition - 1);
    });
    let f = Math.max(...r.entries.filter((m) => m.entryStatus === Ii && !isNaN(m.entryPosition)).map(({ entryPosition: m }) => be(m || 0)), 0);
    l.entryPosition = f || 0;
  }
  return { ...j };
}
function EE({ autoEntryPositions: e = !0, participantIds: t, drawDefinition: r, drawId: i, stages: n, event: a }) {
  var d;
  if (!a) return { error: At };
  if (!i) return { error: Cn };
  if (!(t != null && t.length)) return { error: ro };
  let o = Ko({ drawDefinition: r, stages: n }).assignedParticipantIds ?? [];
  if (Jr(o, t)) return { error: jc };
  let s = (l) => {
    let p = l.participantId;
    return !t.includes(p);
  }, { flightProfile: c } = Ht({ event: a }), u = (d = c == null ? void 0 : c.flights) == null ? void 0 : d.find((l) => l.drawId === i);
  return u != null && u.drawEntries && (u.drawEntries = u.drawEntries.filter(s), e && (u.drawEntries = wn({ entries: u.drawEntries }))), r != null && r.entries && (r.entries = r.entries.filter(s), e && (r.entries = wn({ entries: r.entries }))), { ...j };
}
function Yn(e) {
  var h, g, I, U, v;
  let t = "addParticipant", { allowDuplicateParticipantIdPairs: r, returnParticipant: i, disableNotice: n, pairOverride: a, participant: o } = e, s = e.tournamentId ? (h = e.tournamentRecords) == null ? void 0 : h[e.tournamentId] : e.tournamentRecord ?? (e.activeTournamentId && ((g = e.tournamentRecords) == null ? void 0 : g[e.activeTournamentId]));
  if (!s) return { error: de };
  if (!o) return W({ result: { error: ws }, stack: t });
  o.participantId || (o.participantId = st()), s.participants || (s.participants = []);
  let { participantId: c, individualParticipantIds: u } = o;
  if (s.participants.reduce((S, T) => T.participantId === c || S, !1)) return { error: vw };
  let { participantType: d, participantRole: l } = o;
  if (!d || !Object.keys(Du).includes(d)) return { error: Nn, participantType: d };
  if (!l) return { error: Iw };
  let p = s.participants || [], f = p.filter((S) => S.participantType === Xe).map((S) => S.participantId);
  if (d !== Xe && o.person) return { error: ie, person: o.person };
  if (u && !Array.isArray(u)) return { error: ie, individualParticipantIds: u };
  if (d === _e) {
    if (o.person) return { error: ie, person: o.person };
    if (o.individualParticipantIds) {
      if (o.individualParticipantIds.length !== 2 && !a) return W({ info: "PAIR must be 2 individualParticipantIds", result: { error: Pi }, stack: t });
      {
        let A = p.filter((y) => y.participantType === Xe).map((y) => y.participantId);
        if (!Array.isArray(o.individualParticipantIds)) return W({ result: { error: Pi }, stack: t });
        if (!o.individualParticipantIds.reduce((y, D) => A.includes(D) && y, !0)) return W({ result: { error: Pi }, stack: t });
      }
    } else return W({ result: { error: ro }, stack: t });
    let S = p.filter((A) => A.participantType === _e).map((A) => ({ individualParticipantIds: A.individualParticipantIds, participant: A })), T = o.participantType === _e && S.find((A) => qt(A.individualParticipantIds, o.individualParticipantIds).length === 2);
    if (T && !r) return { ...j, existingParticipant: !0, participant: i && ge(T.participant) };
    if (!o.participantName) {
      let A = p.filter((D) => {
        var P;
        return (P = o.individualParticipantIds) == null ? void 0 : P.includes(D.participantId);
      }), y = A.map((D) => {
        var P;
        return (P = D.person) == null ? void 0 : P.standardFamilyName;
      }).filter(Boolean).join("/");
      A.length === 1 && (y += "/Unknown"), o.participantName = y;
    }
  } else if (d === Xe) {
    if (!((I = o.person) != null && I.standardFamilyName) || !((U = o.person) != null && U.standardGivenName)) return { error: Aw };
    if (!o.participantName) {
      let S = `${o.person.standardFamilyName.toUpperCase()}, ${o.person.standardGivenName}`;
      o.participantName = S;
    }
  } else if (d && [lt, Gi].includes(d)) {
    if (u || (o.individualParticipantIds = []), (v = o.individualParticipantIds) == null ? void 0 : v.length) for (let S of o.individualParticipantIds) {
      if (typeof S != "string") return W({ result: { participantId: S, error: ie }, stack: t });
      if (!f.includes(S)) return W({ result: { participantId: S, error: Yt }, stack: t });
    }
  } else return { error: Nn };
  s.participants.push(o), n || Le({ payload: { tournamentId: s.tournamentId, participants: [o] }, topic: Xa });
  let m = { participant: i && ge(o), ...j };
  return ye(m);
}
function Un({ allowDuplicateParticipantIdPairs: e, returnParticipants: t, tournamentRecord: r, participants: i = [] }) {
  if (!r) return { error: de };
  r.participants || (r.participants = []);
  let n = r.participants.map((l) => l.participantId) || [];
  i.forEach((l) => {
    l.participantId || (l.participantId = st());
  });
  let a = i.filter((l) => !n.includes(l.participantId)), o = i.filter((l) => n.includes(l.participantId)), s = a.filter((l) => l.participantType === Xe), c = a.filter((l) => l.participantType !== Xe), u = s.concat(...c), d = [];
  if (u.length) {
    for (let p of u) {
      let f = Yn({ allowDuplicateParticipantIdPairs: e, returnParticipant: !0, disableNotice: !0, tournamentRecord: r, participant: p });
      if (f.error) return f;
      f.success && !f.existingParticipant && d.push(f.participant);
    }
    d.length && Le({ topic: Xa, payload: { tournamentId: r.tournamentId, participants: d } });
    let l = { participants: t && ge(d), addedCount: d.length, ...j };
    return o.length && Object.assign(l, { notAdded: o, info: kf }), ye(l);
  } else return { info: "No new participants to add", addedCount: 0, ...j };
}
function OE(e) {
  let t = Ae(e, [{ [fr]: !0, [no]: !0 }]);
  if (t.error) return t;
  let { allowDuplicateParticipantIdPairs: r, entryStatus: i = fn, participantIdPairs: n = [], entryStage: a = Ie, tournamentRecord: o, drawDefinition: s, event: c, uuids: u } = e;
  if (c.eventType !== ft) return { error: na };
  let d = [], l = /* @__PURE__ */ new Map();
  for (let S of o.participants ?? []) {
    let { participantType: T, participantId: A, person: y, individualParticipantIds: D } = S;
    T === Xe && (y != null && y.sex) ? l.set(A, y.sex) : T === _e && D && d.push(D);
  }
  let p = n.filter((S) => {
    if (S.length !== 2) return !0;
    if (!c.gender || c.gender === Mn) return !1;
    if (!l.has(S[0]) || !l.has(S[1])) return !0;
    let T = S.map((y) => l.get(y)), A = c.gender === pt && (T[0] !== pt || T[1] !== pt) || c.gender === St && (T[0] !== St || T[1] !== St);
    return c.gender === ni && (T.sort(Tm), (T[0] !== St || T[1] !== pt) && (A = !0)), A;
  });
  if (p.length) return { error: Pi, invalidParticipantIdPairs: p };
  let f = n.map((S) => ({ participantId: (u == null ? void 0 : u.pop()) ?? st(), participantRole: Cr, individualParticipantIds: S, participantType: _e })), m = r ? f : f.filter((S) => !d.find((T) => qt(T, S.individualParticipantIds).length === 2)), h, g = [];
  if (m) {
    let S = Un({ allowDuplicateParticipantIdPairs: r, participants: m, returnParticipants: !0, tournamentRecord: o });
    if (S.error) return S;
    g = S.participants || [], h = S.info;
  }
  let I = n.map((S) => {
    let T = g.find((y) => qt(y.individualParticipantIds, S).length === 2);
    if (T) return T;
    let { participant: A } = vn({ tournamentRecord: o, participantIds: S });
    return A;
  }).map((S) => S.participantId), U = Bn({ participantIds: I, tournamentRecord: o, drawDefinition: s, entryStatus: i, entryStage: a, event: c });
  m.length && Le({ payload: { participants: m }, topic: Xa });
  let v = m.map(Ke);
  return { ...U, info: h, newParticipantIds: v };
}
function CE({ entryStatus: e = Ii, unpairedParticipantIds: t = [], participantIdPairs: r = [], entryStage: i = Ie, tournamentRecord: n, event: a }) {
  if (!n) return { error: de };
  if (!a) return { error: At };
  let o = n.participants ?? [], s = o.filter((h) => h.participantType === Xe).map((h) => h.participantId), c = t.concat(...r).flat(1 / 0).filter((h) => !s.includes(h));
  if (c.length) return { error: Pi, invalidParticipantIds: c };
  let u = r.filter((h) => h.length !== 2);
  if (u.length) return { error: Pi, invalidParticipantIdPairs: u };
  let d = o.filter((h) => h.participantType === _e).map((h) => h.individualParticipantIds), l = r.filter((h) => !d.find((g) => qt(g, h).length === 2)).map((h) => ({ participantType: _e, participantRole: Cr, individualParticipantIds: h })), p = Un({ participants: l, tournamentRecord: n });
  if (p.error) return p;
  let f = r.map((h) => {
    let { participant: g } = vn({ tournamentRecord: n, participantIds: h });
    return g;
  }).map((h) => ({ participantId: h, entryStatus: e, entryStage: i })), m = t.map((h) => ({ entryStatus: tn, participantId: h, entryStage: i }));
  return a.entries = (a.entries ?? []).filter((h) => h.entryStage === i), a.entries = a.entries.concat(...f, ...m), { ...j };
}
var FE = {};
qe(FE, { addDrawDefinition: () => ll, addEvent: () => su, addFlight: () => fh, assignSeedPositions: () => YE, attachFlightProfile: () => qS, categoryCanContain: () => pd, deleteDrawDefinitions: () => dh, deleteEvents: () => KE, deleteFlightAndFlightDraw: () => qE, deleteFlightProfileAndFlightDraws: () => VE, generate: () => kE, generateEventsFromTieFormat: () => LE, getCategoryAgeDetails: () => fs, getEvent: () => kS, getEventProperties: () => CS, getEventStructures: () => Rm, getEventTimeItem: () => Dd, getEvents: () => FS, getFlightProfile: () => Ht, getScaledEntries: () => zs, modifyEvent: () => XE, modifyEventMatchUpFormatTiming: () => GE, modifyPairAssignment: () => HE, mutate: () => xE, query: () => DE, refreshEventDrawOrder: () => WS, removeEventMatchUpFormatTiming: () => lh, removeScaleValues: () => HS, removeSeeding: () => zE, setEventDates: () => jS, setEventDisplay: () => ph, setEventEndDate: () => GS, setEventStartDate: () => VS, updateDrawIdsOrder: () => _S, validateCategory: () => Bu });
var kE = {};
qe(kE, { generateEventsFromTieFormat: () => LE });
function Wj({ tournamentId: e, event: t }) {
  return t ? (Le({ payload: { tournamentId: e, event: t }, key: t.eventId, topic: Nb }), { ...j }) : { error: At };
}
var qj = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_D3", winCriteria: { valueGoal: 5 } }, Hj = { collectionDefinitions: [{ collectionName: "Doubles", collectionValue: 1, matchUpCount: 3, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES" }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_DEFAULT", winCriteria: { valueGoal: 5 } }, Yj = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_JUCO", winCriteria: { valueGoal: 5 } }, zj = { COLLEGE_D3: qj, COLLEGE_DEFAULT: Hj, COLLEGE_JUCO: Yj, DOMINANT_DUO: AR, DOMINANT_DUO_MIXED: vR, LAVER_CUP: RR, TEAM_DOUBLES_3_AGGREGATION: fR, TIME_TENNIS_DUAL: UR, TIME_TENNIS_PRO_CIRCUIT: IR, USTA_BREWER_CUP: SR, USTA_OZAKI_CUP: yR, USTA_COLLEGE: TR, USTA_GOLD_TEAM_CHALLENGE: pR, USTA_INTERSECTIONAL: gR, USTA_LEVEL_1: DR, USTA_SECTION_BATTLE: hR, USTA_SOUTHERN_LEVEL_5: mR, USTA_TOC: bR, USTA_WTT_ITT: PR, USTA_ZONAL: wR };
function su({ suppressNotifications: e, tournamentRecord: t, internalUse: r, event: i }) {
  var s, c, u, d;
  if (!t) return { error: de };
  if (t.events || (t.events = []), !i) return { error: At };
  let { startDate: n, endDate: a } = t;
  if (!r && ((s = i.entries) != null && s.length || (c = i.drawDefinitions) != null && c.length)) {
    let l = ye({ drawDefinitions: !!((u = i.drawDefinitions) != null && u.length), entries: !!((d = i.entries) != null && d.length) });
    return { info: "entries/drawDefinitions cannot exist", error: ie, context: l };
  }
  let o = { eventType: ms, drawDefinitions: [], entries: [], startDate: n, endDate: a, ...i };
  if (i.eventType === bi) {
    if (i.tieFormat) {
      let l = oi({ tieFormat: i.tieFormat });
      if (l.error) return l;
    } else if (i.tieFormatName) {
      if (!zj[i.tieFormatName]) return { context: { tieFormatName: i.tieFormatName }, error: ie };
      let l = Sa({ isMock: t == null ? void 0 : t.isMock, namedFormat: i.tieFormatName, event: i });
      o.tieFormat = l;
    }
  }
  if (o.eventId || (o.eventId = st()), t.events.reduce((l, p) => l || p.eventId === o.eventId, void 0)) return { error: $P };
  {
    let l = o;
    if (t.events.push(l), !e) {
      let { topics: p } = Ji();
      if (p.includes(cm)) {
        let h = ma({ event: i }).matchUps ?? [];
        Za({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: i.eventId, matchUps: h });
      }
      let { drawDefinitions: f, ...m } = i;
      for (let h of f || []) Ad({ drawDefinition: h });
      Wj({ tournamentId: t == null ? void 0 : t.tournamentId, event: m });
    }
    return { ...j, event: o };
  }
}
function LE(e) {
  var o, s, c, u;
  let t = Ae(e, [{ [Ac]: { [Jf]: !0, [tb]: !0 } }, { [fr]: !0 }]);
  if (t.error) return t;
  let r = e.tieFormat || Sa({ namedFormat: e.tieFormatName }), i = e.uuids || [lR(r.collectionDefinitions.length)], n = { [pt]: [], [St]: [] };
  if (e.addEntriesFromTeams) {
    let d = (s = (o = e.tournamentRecord.participants) == null ? void 0 : o.filter((l) => l.participantType === ai)) == null ? void 0 : s.flatMap((l) => l.individualParticipantIds ?? []);
    for (let l of e.tournamentRecord.participants ?? []) if (d != null && d.includes(l.participantId)) {
      let p = (c = l.person) == null ? void 0 : c.sex;
      p && [pt, St].includes(p) && n[p].push(l.participantId);
    }
  }
  let a = [];
  for (let d of r.collectionDefinitions ?? []) {
    let l = ((u = i == null ? void 0 : i.pop()) == null ? void 0 : u.toString()) || st(), p = d.matchUpType, f = d.gender, m = { matchUpFormat: d.matchUpFormat, eventName: d.collectionName, category: d.category, gender: f, eventType: p, eventId: l };
    if (e.addEntriesFromTeams) {
      let h = p === ya ? tn : e.entryStatus || Ii, g = f === ni ? [...n[pt], ...n[St]] : n[f] ?? [];
      if (g.length) {
        let I = Bn({ participantIds: g, entryStatus: h, event: m });
        if (I.error) return I;
      }
    }
    if (a.push(m), e.addEvents !== !1) {
      let h = su({ internalUse: !0, tournamentRecord: e.tournamentRecord, event: m });
      if (h.error) return h;
    }
  }
  return { ...j, events: a };
}
var xE = {};
qe(xE, { addDrawDefinition: () => ll, addEvent: () => su, addFlight: () => fh, assignSeedPositions: () => YE, attachFlightProfile: () => qS, deleteDrawDefinitions: () => dh, deleteEvents: () => KE, deleteFlightAndFlightDraw: () => qE, deleteFlightProfileAndFlightDraws: () => VE, modifyEvent: () => XE, modifyEventMatchUpFormatTiming: () => GE, modifyPairAssignment: () => HE, refreshEventDrawOrder: () => WS, removeEventMatchUpFormatTiming: () => lh, removeScaleValues: () => HS, removeSeeding: () => zE, setEventDates: () => jS, setEventDisplay: () => ph, setEventEndDate: () => GS, setEventStartDate: () => VS, updateDrawIdsOrder: () => _S, validateCategory: () => Bu });
function cu({ removePriorValues: e = !0, status: t = ji, statusObject: r, event: i }) {
  if (!$e(r)) return { error: ie };
  let n = nn({ event: i, status: t }), a = `${uo}.${lo}`, o = { itemValue: { [t]: { ...n, ...r } }, itemType: a };
  return Ys({ timeItem: o, removePriorValues: e, event: i });
}
function uu(e) {
  var T, A, y, D, P, w, R;
  let t = Ae(e, [{ [fr]: !0, [no]: !0 }, { eventDataParams: !1, [ui]: pi }]);
  if (t.error) return t;
  let { includePositionAssignments: r, removePriorValues: i, tournamentRecord: n, status: a = ji, event: o, drawIdsToRemove: s, drawIdsToAdd: c } = e, { appliedPolicies: u } = nt({ tournamentRecord: n, event: o }), d = { ...u, ...e.policyDefinitions }, l = ((T = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : T.map(({ drawId: b }) => b)) ?? [], p = e.drawDetails ? Object.keys(e.drawDetails) : [], f = p.length ? [] : e.drawIds, m = (c ?? []).concat(...s ?? [], ...f ?? [], ...p), h = m.filter((b) => !l.includes(b));
  if (h.length) return W({ result: { error: Fi }, context: { invalidDrawIds: h } });
  let g = nn({ event: o, status: a }), I = Object.keys((g == null ? void 0 : g.drawDetails) || {}).filter((b) => l.includes(b)).reduce((b, E) => (b[E] = g.drawDetails[E], b), {});
  for (let b of l) if ((!m.length || m.includes(b)) && (s != null && s.includes(b) || f != null && f.length && !f.includes(b) ? I[b] = { ...I[b], publishingDetail: { published: !1 } } : (c != null && c.includes(b) || f != null && f.includes(b) || !(f != null && f.length)) && (I[b] = { ...I[b], publishingDetail: { published: !0 } })), (A = e.drawDetails) == null ? void 0 : A[b]) {
    let E = e.drawDetails[b], O = E.structureDetails ?? I[b].structureDetails, M = E.stageDetails ?? I[b].stageDetails ?? {}, { structureIdsToRemove: N = [], structureIdsToAdd: C = [], publishingDetail: F = {}, stagesToRemove: x = [], stagesToAdd: V = [] } = E;
    if ((C || V) && (F.published = !0), I[b] = { publishingDetail: F, structureDetails: O, stageDetails: M }, C.length || N.length) {
      let L = (((D = (y = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : y.find((G) => G.drawId === b)) == null ? void 0 : D.structures) ?? []).map(({ structureId: G }) => G), B = (C ?? []).concat(N ?? []).filter((G) => !L.includes(G));
      if (B.length) return W({ result: { error: kt }, context: { invalidStructureIds: B } });
      O = O ?? {};
      for (let G of L) N.includes(G) ? O[G] = { published: !1 } : O[G] = { published: !0 };
      I[b].structureDetails = O;
    }
    let k = (((w = (P = o == null ? void 0 : o.drawDefinitions) == null ? void 0 : P.find((L) => L.drawId === b)) == null ? void 0 : w.structures) ?? []).map(({ stage: L }) => L);
    if (V.length) {
      for (let L of V) M[L] = { published: !0 };
      for (let L of k) M[L] || (M[L] = { published: !1 });
    }
    if (V.length || x.length) {
      for (let L of x) M[L] = { published: !1 };
      for (let L of k) M[L] || (M[L] = { published: !0 });
    }
    (V.length || x.length) && (I[b].stageDetails = M);
  }
  cu({ statusObject: { drawDetails: I }, removePriorValues: i, status: a, event: o });
  let { topics: U } = Ji(), v = U.includes(Ng), S = v || e.returnEventData ? (R = $m({ includePositionAssignments: r, ...e.eventDataParams, usePublishState: !0, tournamentRecord: n, policyDefinitions: d, event: o })) == null ? void 0 : R.eventData : void 0;
  return v && Le({ payload: { eventData: S, tournamentId: n.tournamentId }, topic: Ng }), { ...j, eventData: S };
}
var BE = "deleteDrawDefinitions", rI = "autoSchedulingAudit", Zl = "deleteEvents", Kj = { AUTO_SCHEDULING_AUDIT: rI, DELETE_EVENTS: Zl, DELETE_DRAW_DEFINITIONS: BE };
function dh(e) {
  var D, P, w, R, b;
  if (!e.tournamentRecord) return { error: de };
  let t = "deleteDrawDefinitions", r = e.drawIds ?? [], i = e.event, { autoPublish: n = !0, tournamentRecord: a, auditData: o, eventId: s, force: c } = e, { appliedPolicies: u } = nt({ tournamentRecord: a, event: i }), d = { ...u, ...e.policyDefinitions }, l = Array.isArray(r) ? r[0] : void 0;
  if (!i) {
    let E = ci({ tournamentRecord: a, eventId: s, drawId: l });
    if (E.error) return E;
    i = E.event;
  }
  let p = [], f = [], m = [];
  if (!(i != null && i.drawDefinitions)) return W({ info: "event has no drawDefinition", result: { ...j }, stack: t });
  let h = i.drawDefinitions.map(({ drawId: E }) => E);
  if (r.length || (r = h), r = r.filter((E) => h.includes(E)), !r.length) return W({ info: "nothing to do; no matching drawIds in event.", result: { ...j }, stack: t });
  let g = ge(Ht({ event: i }).flightProfile, !1, !0), I = ({ participantId: E, drawPosition: O, qualifier: M, bye: N }) => ({ bye: N, qualifier: M, drawPosition: O, participantId: E }), U = c ?? ((P = (D = u == null ? void 0 : u[En]) == null ? void 0 : D.allowDeletionWithScoresPresent) == null ? void 0 : P.drawDefinitions), v = nn({ event: i }) ?? {}, S = v.drawIds ?? (v.drawDetails && Object.keys(v.drawDetails)) ?? [], T, A = [], y = i.drawDefinitions.filter((E) => {
    var O, M, N, C, F, x, V, k;
    if (r.includes(E.drawId)) {
      let L = ((O = Qr({ event: i, drawDefinition: E })) == null ? void 0 : O.matchUps) ?? [];
      if (L.some(({ score: ne }) => pr({ score: ne })) && !U) return A.push(E.drawId), !0;
      let { drawId: B, drawType: G, drawName: q } = E, Y = (M = g == null ? void 0 : g.flights) == null ? void 0 : M.find((ne) => ne.drawId === E.drawId);
      Y && (Y.drawEntries = (N = Y.drawEntries) == null ? void 0 : N.filter((ne) => yn.includes(ne.entryStatus))), S.includes(B) && (S = S.filter((ne) => ne !== B), T = !0);
      let H = (F = (C = In({ stageSequence: 1, drawDefinition: E, stage: Ie })) == null ? void 0 : C.structures) == null ? void 0 : F[0], X = (V = (x = H ? Zu({ structureId: H.structureId, tournamentRecord: a, drawDefinition: E }) : void 0) == null ? void 0 : x.positionAssignments) == null ? void 0 : V.map(I), z = (k = In({ stage: Pe, drawDefinition: E })) == null ? void 0 : k.structures, Z = z != null && z.length ? z.map((ne) => {
        var K;
        let ee = ne.stageSequence;
        return { positionAssignments: (K = Zu({ structureId: ne.structureId, tournamentRecord: a, drawDefinition: E })) == null ? void 0 : K.positionAssignments.map(I), stageSequence: ee };
      }) : void 0, te = { action: BE, payload: { drawDefinitions: [E], eventId: s ?? (i == null ? void 0 : i.eventId), auditData: o } };
      m.push(te), p.push(ye({ tournamentId: a.tournamentId, eventId: s ?? (i == null ? void 0 : i.eventId), qualifyingPositionAssignments: Z, positionAssignments: X, auditData: o, drawType: G, drawName: q, drawId: B })), L == null || L.forEach(({ matchUpId: ne }) => f.push(ne));
    }
    return !r.includes(E.drawId);
  });
  if (A.length && !c) return W({ context: { drawIdsWithScoresPresent: A }, result: { error: jf }, stack: t });
  if (i.drawDefinitions = y, g && oo({ event: i, extension: { name: gn, value: g } }), sl({ tournamentRecord: a }), T) {
    let E = {};
    for (let M of S) E[M] = ((w = v.drawDetails) == null ? void 0 : w[M]) ?? { published: !0 };
    let O = cu({ statusObject: { drawDetails: E }, event: i });
    if (O.error) return { error: O.error };
  }
  if (m.length) if (_f(va)) {
    let E = a.tournamentId;
    Le({ topic: va, payload: { tournamentId: E, detail: m } });
    let O = (((b = (R = en({ element: i, itemType: So })) == null ? void 0 : R.timeItem) == null ? void 0 : b.itemValue) || 0) + 1;
    Xn({ element: i, timeItem: { itemType: So, itemValue: O }, removePriorValues: !0 });
  } else Xj({ appliedPolicies: u, event: i, deletedDrawsDetail: p, auditData: o });
  if (f.length && Ca({ tournamentId: a == null ? void 0 : a.tournamentId, matchUpIds: f }), r.forEach((E) => zL({ drawId: E })), n && T) {
    let E = uu({ ...e.eventDataParams, drawIdsToRemove: r, policyDefinitions: d, tournamentRecord: a, event: i });
    if (E.error) return { ...j, info: E.error };
  }
  return { ...j };
}
function Xj({ appliedPolicies: e, event: t, deletedDrawsDetail: r, auditData: i }) {
  var s;
  if (((s = e == null ? void 0 : e.audit) == null ? void 0 : s[So]) === !1) return;
  let { extension: n } = We({ name: So, element: t }), a = { ...i, deletedDrawsDetail: r }, o = { value: Array.isArray(n == null ? void 0 : n.value) ? n == null ? void 0 : n.value.concat(a) : [a], name: So };
  it({ element: t, extension: o });
}
function VE({ autoPublish: e = !0, tournamentRecord: t, auditData: r, event: i, force: n }) {
  var o;
  if (!t) return { error: de };
  if (!i) return { error: At };
  let { flightProfile: a } = Ht({ event: i });
  if (a) {
    let s = (o = a.flights) == null ? void 0 : o.map(({ drawId: u }) => u).filter(Boolean), c = dh({ eventId: i.eventId, tournamentRecord: t, autoPublish: e, auditData: r, drawIds: s, event: i, force: n });
    return c.error ? c : nm({ event: i, name: gn });
  }
  return { ...j };
}
function BS(e) {
  let { matchUpFormat: t, recoveryTimes: r, averageTimes: i, tournamentId: n, eventId: a } = e, o = (e == null ? void 0 : e.tournamentRecords) ?? ((e == null ? void 0 : e.tournamentRecord) && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
  if (!Object.keys(o).length) return { error: xt };
  let s = Object.keys(o).filter((u) => !n || n === u);
  if (n && !s.includes(n)) return { error: ie };
  let c;
  for (let u of s) {
    let d = o[u], { event: l } = ci({ tournamentRecord: d, eventId: a });
    a && l && (c = !0);
    let p = Zj({ tournamentRecord: d, event: l, matchUpFormat: t, averageTimes: i, recoveryTimes: r });
    if (p.error) return p;
  }
  return !a || c ? { ...j } : { error: Ki };
}
function Zj({ tournamentRecord: e, recoveryTimes: t, matchUpFormat: r, averageTimes: i, event: n }) {
  if (!e) return { error: de };
  if (i && !Array.isArray(i)) return { error: ie };
  if (t && !Array.isArray(t)) return { error: ie };
  let a = Pa;
  if (n) {
    let { extension: o } = We({ element: n, name: a }), s = (o == null ? void 0 : o.value) || {}, c = qT({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    it({ element: n, extension: { name: a, value: c } });
  } else {
    let { extension: o } = We({ element: e, name: a }), s = (o == null ? void 0 : o.value) || {}, c = qT({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    it({ extension: { name: a, value: c }, element: e });
  }
  return { ...j };
}
function qT(e) {
  let { matchUpRecoveryTimes: t = [], matchUpAverageTimes: r = [], matchUpFormat: i } = e, { averageTimes: n, recoveryTimes: a } = e;
  n = (n || []).filter((c) => {
    var u, d;
    return ((u = c == null ? void 0 : c.categoryNames) == null ? void 0 : u.length) || ((d = c == null ? void 0 : c.categoryTypes) == null ? void 0 : d.length);
  });
  let o = (n == null ? void 0 : n.length) && r.map((c) => {
    var u;
    return c != null && c.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: (u = c.matchUpFormatCodes) == null ? void 0 : u.filter((d) => d !== i) } : c;
  }).filter(({ matchUpFormatCodes: c }) => c == null ? void 0 : c.length).concat({ matchUpFormatCodes: [i], averageTimes: n });
  a = (a || []).filter((c) => {
    var u, d;
    return ((u = c == null ? void 0 : c.categoryNames) == null ? void 0 : u.length) || ((d = c == null ? void 0 : c.categoryTypes) == null ? void 0 : d.length);
  });
  let s = (a == null ? void 0 : a.length) && t.map((c) => {
    var u;
    return c != null && c.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: (u = c.matchUpFormatCodes) == null ? void 0 : u.filter((d) => d !== i) } : c;
  }).filter(({ matchUpFormatCodes: c, averageTimes: u }) => (c == null ? void 0 : c.length) || u).concat({ matchUpFormatCodes: [i], recoveryTimes: a });
  return { matchUpAverageTimes: (o == null ? void 0 : o.length) && o || r, matchUpRecoveryTimes: (s == null ? void 0 : s.length) && s || t };
}
function GE(e) {
  let { tournamentRecord: t, recoveryMinutes: r, averageMinutes: i, matchUpFormat: n, categoryType: a, eventId: o, event: s } = e;
  if (!t) return { error: de };
  if (!Ri({ matchUpFormat: n })) return { error: ie };
  if (!s) return { error: At };
  let { averageTimes: c = [], recoveryTimes: u = [] } = oh({ tournamentRecord: t, matchUpFormat: n, event: s }), d = s.category, l = (d == null ? void 0 : d.categoryName) || (d == null ? void 0 : d.ageCategoryCode) || (s == null ? void 0 : s.eventId), p = { categoryNames: [l], minutes: {} }, f = { categoryNames: [l], minutes: {} }, m = (v) => {
    var S, T;
    if ((S = v.categoryTypes) != null && S.includes(a) && console.log("encountered:", { categoryType: a }), !((T = v.categoryNames) != null && T.includes(l) && (v.categoryNames = v.categoryNames.filter((A) => A !== l), p = { minutes: v.minutes, categoryNames: [l] }, !v.categoryNames.length))) return v;
  }, h = i && !isNaN(be(i)), g = r && !isNaN(be(r)), I = c.map(m).filter((v) => {
    var S;
    return (S = v == null ? void 0 : v.categoryNames) == null ? void 0 : S.length;
  }), U = u.map(m).filter((v) => {
    var S;
    return (S = v == null ? void 0 : v.categoryNames) == null ? void 0 : S.length;
  });
  return h && (Object.assign(p.minutes, { [(s == null ? void 0 : s.eventType) || mt]: i }), I.push(p)), g && (Object.assign(f.minutes, { [(s == null ? void 0 : s.eventType) || mt]: r }), U.push(f)), !h && !g ? { error: ie } : BS({ averageTimes: h && I, recoveryTimes: g && U, tournamentRecord: t, matchUpFormat: n, eventId: o, event: s });
}
function lh(e) {
  if (e.event) return HT({ event: e.event });
  {
    e.tournamentRecord && !e.tournamentRecords && (e.tournamentRecords = { [e.tournamentRecord.tournamentId]: e.tournamentRecord });
    let t = Ae(e, [{ [_r]: !0, [ob]: !0 }]);
    if (t.error) return t;
    let { tournamentRecords: r, eventId: i } = e;
    for (let n of Object.values(r ?? {})) {
      let { event: a } = ci({ tournamentRecord: n, eventId: i });
      if (a) return HT({ event: a });
    }
  }
  return { error: Ki };
}
function HT({ event: e }) {
  return nm({ event: e, name: Pa });
}
var Qj = "MON", Jj = "TUE", $j = "WED", e_ = "THU", t_ = "FRI", r_ = "SAT", i_ = "SUN", jE = { MON: Qj, TUE: Jj, WED: $j, THU: e_, FRI: t_, SAT: r_, SUN: i_ };
function _E(e) {
  return !Array.isArray(e) || Be(e).length !== e.length ? !1 : e.every((t) => Object.keys(jE).includes(t));
}
function VS({ tournamentRecord: e, event: t, startDate: r }) {
  if (!e) return { error: de };
  if (!t) return { error: At };
  if (!Gn.test(r)) return { error: Sr };
  let i = WE(e);
  if (i.error) return i;
  let { tournamentStartDate: n, tournamentEndDate: a } = i, o = new Date(Ve(r)).getTime();
  if (!n || !a || o < n || o > a) return { error: Sr };
  let s = t.endDate && new Date(Ve(t.endDate)).getTime();
  return s && o > s && (t.endDate = r), t.startDate = r, { ...j };
}
function GS(e) {
  let { tournamentRecord: t, event: r, endDate: i } = e;
  if (!t) return { error: de };
  if (!r) return { error: At };
  if (!Gn.test(i)) return { error: Sr };
  let n = WE(t);
  if (n.error) return n;
  let { tournamentStartDate: a, tournamentEndDate: o } = n, s = new Date(Ve(i)).getTime();
  if (!a || !o || s < a || s > o) return { error: Sr };
  let c = r.startDate && new Date(Ve(r.startDate)).getTime();
  return c && s < c && (r.startDate = i), r.endDate = i, { ...j };
}
function jS(e) {
  var c;
  let t = Ae(e, [{ tournamentRecord: !0, event: !0 }, { [Or]: (u) => Gn.test(u), [xi]: Sr, startDate: !1, endDate: !1 }, { [Or]: (u) => u.filter(Boolean).every((d) => Gn.test(d)), [xi]: Sr, activeDates: !1 }, { [Or]: _E, weekdays: !1 }]);
  if (t.error) return t;
  let { tournamentRecord: r, weekdays: i, event: n, startDate: a, endDate: o } = e, s = (c = e.activeDates) == null ? void 0 : c.filter(Boolean);
  if (a && o) {
    let u = new Date(Ve(a)).getTime(), d = new Date(Ve(o)).getTime();
    if (u > d) return { error: ie };
  }
  if (s) {
    let u = a || r.startDate, d = o || r.endDate, l = !u || s.every((f) => new Date(f) >= new Date(u)), p = !d || s.every((f) => new Date(f) <= new Date(d));
    if (!l || !p) return { error: Sr };
  }
  if (a) {
    let u = VS({ tournamentRecord: r, event: n, startDate: a });
    if (u.error) return u;
  }
  if (o) {
    let u = GS({ tournamentRecord: r, event: n, endDate: o });
    if (u.error) return u;
  }
  return s && (n.activeDates = s), i && (n.weekdays = i), { ...j };
}
function WE(e) {
  let { startDate: t, endDate: r } = e;
  return !Gn.test(t) || !Gn.test(r) ? W({ result: { error: fw }, context: { startDate: t, endDate: r } }) : { tournamentStartDate: new Date(Ve(t)).getTime(), tournamentEndDate: new Date(Ve(r)).getTime() };
}
function _S({ event: e, orderedDrawIdsMap: t }) {
  var n, a;
  if (typeof e != "object") return { error: At };
  if (!t) return { error: we, info: "Missing drawIdsOrderMap" };
  if (typeof t != "object") return { error: ie, info: "orderedDrawIdsMap must be an object" };
  let r = Object.values(t);
  if (!r.every((o) => !isNaN(o))) return { error: ie, info: "drawOrder must be numeric" };
  if (Be(r).length !== r.length) return { error: ie, info: "drawOrder values must be unique" };
  if ((n = e.drawDefinitions) != null && n.length) {
    let o = (e.drawDefinitions || []).map(({ drawId: c }) => c), s = Object.keys(t);
    if (s != null && s.length && qt(o, s).length !== o.length) return { error: ie, info: "Missing drawIds" };
    e.drawDefinitions.forEach((c) => {
      c.drawOrder = t[c.drawId];
    });
  }
  let { flightProfile: i } = Ht({ event: e });
  return (a = i == null ? void 0 : i.flights) == null || a.forEach((o) => {
    o.flightNumber = t[o.drawId];
  }), { ...j };
}
function WS({ tournamentRecord: e, event: t }) {
  var n;
  if (!e) return { error: de };
  if (!t) return { error: At };
  let { flightProfile: r } = Ht({ event: t }), i = (r == null ? void 0 : r.flights) && Object.assign({}, ...r.flights.sort((a, o) => a.flightNumber - o.flightNumber).map((a, o) => ({ [a.drawId]: o + 1 }))) || ((n = t.drawDefinitions) == null ? void 0 : n.length) && Object.assign({}, ...t.drawDefinitions.sort((a, o) => a.drawOrder - o.drawOrder).map((a, o) => ({ [a.drawId]: o + 1 }))) || void 0;
  return i ? _S({ event: t, orderedDrawIdsMap: i }) : { ...j };
}
function qE({ autoPublish: e = !0, tournamentRecord: t, auditData: r, drawId: i, event: n, force: a }) {
  var s, c;
  if (!t) return { error: de };
  if (!i) return { error: Cn };
  if (!n) return { error: At };
  let { flightProfile: o } = Ht({ event: n });
  if (o && ((s = o.flights) != null && s.find((u) => u.drawId === i))) {
    let u = o.flights.filter((l) => l.drawId !== i), d = { name: gn, value: { ...o, flights: u } };
    oo({ event: n, extension: d });
  }
  if ((c = n.drawDefinitions) != null && c.find((u) => u.drawId === i)) {
    let u = dh({ drawIds: [i], eventId: n.eventId, tournamentRecord: t, autoPublish: e, auditData: r, event: n, force: a });
    if (u.error) return u;
  }
  return WS({ tournamentRecord: t, event: n });
}
function HE(e) {
  var g, I;
  let t = Ae(e, [{ [no]: !0, [fr]: !0, [dv]: !1 }, { replacementIndividualParticipantId: !0, [Or]: (U) => Et(U), existingIndividualParticipantId: !0, [pn]: cr, participantId: !0 }]), { replacementIndividualParticipantId: r, existingIndividualParticipantId: i, tournamentRecord: n, drawDefinition: a, participantId: o, event: s, uuids: c } = e;
  if (t.error) return t;
  if ((s == null ? void 0 : s.eventType) !== Xi) return { error: na };
  if (!(((g = s == null ? void 0 : s.entries) == null ? void 0 : g.filter(({ entryStatus: U }) => [tn, Ho].includes(U)).map(({ participantId: U }) => U)) || []).includes(r)) return { error: bn };
  let u = (n.participants || []).find((U) => U.participantId === o);
  if ((u == null ? void 0 : u.participantType) !== _e) return { error: Ps, participant: u };
  let d = u.individualParticipantIds, l = [r, ...d.filter((U) => U !== i)], { participant: p } = vn({ participantIds: l, tournamentRecord: n }), f;
  if (p) f = p.participantId;
  else {
    let U = { participantId: c == null ? void 0 : c.pop(), participantRole: Cr, individualParticipantIds: l, participantType: _e }, v = Yn({ participant: U, returnParticipant: !0, tournamentRecord: n });
    if (v.error) return v;
    f = v.participant.participantId;
  }
  let { flightProfile: m } = Ht({ event: s });
  if (a) {
    let U = (I = m == null ? void 0 : m.flights) == null ? void 0 : I.find(({ drawId: v }) => v === a.drawId);
    U && (U.drawEntries = U.drawEntries.map((v) => v.participantId === o ? { ...v, participantId: f } : v)), a.entries = a.entries.map((v) => v.participantId === o ? { ...v, participantId: f } : v);
    for (let v of a.structures || []) if (v.structures) {
      v.positionAssignments = void 0;
      for (let S of v.structures) S.positionAssignments = S.positionAssignments.map((T) => T.participantId === o ? { ...T, participantId: f } : T);
    } else v.positionAssignments && (v.positionAssignments = v.positionAssignments.map((S) => S.participantId === o ? { ...S, participantId: f } : S));
  }
  s.entries = s.entries.map((U) => U.participantId === o && { ...U, participantId: f } || U.participantId === r && { ...U, participantId: i } || U);
  let h = n.events.some(({ entries: U, eventId: v, drawDefinitions: S }) => s.eventId === v ? S.some(({ drawId: T, entries: A }) => T === (a == null ? void 0 : a.drawId) ? !1 : A == null ? void 0 : A.find((y) => y.participantId === o)) : U == null ? void 0 : U.find((T) => T.participantId === o));
  if (!h) {
    let U = Ws({ addIndividualParticipantsToEvents: !1, participantIds: [o], tournamentRecord: n });
    if (U.error) return U;
  }
  return { ...j, participantOtherEntries: h, newPairParticipantId: f };
}
function ll(e) {
  var b, E, O, M, N, C, F, x, V, k, L, B;
  let { flight: t, suppressNotifications: r, modifyEventEntries: i, existingDrawCount: n, allowReplacement: a, checkEntryStatus: o, tournamentRecord: s, drawDefinition: c, event: u } = e;
  if (!c) return { error: Ue };
  if (!u) return { error: At };
  u.drawDefinitions || (u.drawDefinitions = []);
  let { drawId: d, drawName: l, entries: p } = c, { entries: f } = u, m = 0;
  if (n !== void 0 && n !== u.drawDefinitions.length) return { error: ie, info: "drawDefintions count mismatch" };
  let { flightProfile: h } = Ht({ event: u }), g = t && ((b = h == null ? void 0 : h.flights) == null ? void 0 : b.find((G) => G.flightNumber === t.flightNumber)), I = (M = (O = (E = h == null ? void 0 : h.links) == null ? void 0 : E.find((G) => {
    var q;
    return ((q = G == null ? void 0 : G.target) == null ? void 0 : q.drawId) === d;
  })) == null ? void 0 : O.source) == null ? void 0 : M.drawId;
  if (I && !u.drawDefinitions.find((G) => G.drawId === I)) return W({ result: { error: Ue }, info: { sourceDrawId: I } });
  if (g && g.drawId !== c.drawId) return W({ result: { error: ts }, info: { relevantFlight: g } });
  let U = p == null ? void 0 : p.every(({ participantId: G, entryStatus: q }) => {
    let Y = g == null ? void 0 : g.drawEntries.find((H) => H.participantId === G);
    return !q || (Y == null ? void 0 : Y.entryStatus) === q;
  }), v = !o || f && (p == null ? void 0 : p.every(({ participantId: G, entryStatus: q, entryStage: Y }) => {
    var H;
    return ((H = f.find((X) => X.participantId === G && (!X.entryStage || X.entryStage === Y))) == null ? void 0 : H.entryStatus) === q;
  }));
  if (g && !U) return W({ result: { error: ts }, context: { drawEntriesPresentInFlight: U, matchingEventEntries: v, relevantFlight: g }, info: "Draw entries are not present in flight or do not match entryStatuses" });
  if (i && (p == null || p.filter(Boolean).forEach((G) => {
    if (G != null && G.entryStatus && yn.includes(G == null ? void 0 : G.entryStatus)) {
      let q = f == null ? void 0 : f.filter(Boolean).find((Y) => Y.participantId === G.participantId);
      q && G.entryStatus && (q == null ? void 0 : q.entryStatus) !== G.entryStatus && (q.entryStatus = G.entryStatus, m += 1);
    }
  })), f && !v) return W({ result: { info: "Draw entries do not match event entryStatuses", context: { matchingEventEntries: v, eventEntries: f }, error: ts } });
  let S = ((C = (N = h == null ? void 0 : h.flights) == null ? void 0 : N.map(({ flightNumber: G }) => !isNaN(G) && be(G))) == null ? void 0 : C.filter(Boolean)) || [], T = ((F = u.drawDefinitions.map(({ drawOrder: G }) => G && be(G))) == null ? void 0 : F.filter(Boolean)) || [], A = Math.max(0, ...T, ...S) + 1, y = (x = h == null ? void 0 : h.flights) == null ? void 0 : x.find((G) => G.drawId === d), D;
  if (y) {
    y.drawName = c.drawName, D = { name: gn, value: { ...h, flights: h.flights } };
    let G = y.flightNumber;
    G && !T.includes(G) ? A = G : y.flightNumber = A;
  } else {
    let G = (h == null ? void 0 : h.flights) || [];
    G.push({ manuallyAdded: !0, flightNumber: A, drawEntries: p, drawName: l, drawId: d }), D = { name: gn, value: { ...h || {}, flights: G } };
  }
  oo({ event: u, extension: D }), Object.assign(c, { drawOrder: A });
  let P = u.drawDefinitions.find((G) => G.drawId === d), w = s == null ? void 0 : s.tournamentId, R = u.eventId;
  if (P) {
    if (!a) return { error: WP };
    let G = ((k = (V = Qr({ drawDefinition: P })) == null ? void 0 : V.matchUps) == null ? void 0 : k.map(hr)) ?? [], q = (L = Qr({ drawDefinition: c })) == null ? void 0 : L.matchUps;
    if (!r) {
      G != null && G.length && Ca({ matchUpIds: G, action: "modifyDrawDefinition", tournamentId: w, eventId: R }), q != null && q.length && Za({ matchUps: q, tournamentId: w, eventId: R }), u.drawDefinitions = u.drawDefinitions.map((H) => H.drawId === d ? c : H);
      let Y = (B = c.structures) == null ? void 0 : B.map(({ structureId: H }) => H);
      vt({ drawDefinition: c, tournamentId: w, structureIds: Y, eventId: R });
    }
  } else if (u.drawDefinitions.push(c), !r) {
    let { matchUps: G } = Qr({ drawDefinition: c, event: u });
    G && Za({ tournamentId: s == null ? void 0 : s.tournamentId, matchUps: G }), Ad({ drawDefinition: c, tournamentId: w, eventId: R });
  }
  return { ...j, modifiedEventEntryStatusCount: m };
}
function YE(e) {
  let { provisionalPositioning: t, useExistingSeedLimit: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, assignments: s, drawId: c, event: u } = e, d = 0;
  if (!(s != null && s.length)) return { error: yI };
  if (!i) return { error: de };
  if (!c) return { error: Cn };
  let l = Qi({ provisionalPositioning: t, drawDefinition: n, structureId: o });
  if (l.error) return l;
  let { seedAssignments: p, seedLimit: f } = l, m = Object.assign({}, ...(p ?? []).filter((I) => I.seedNumber).map((I) => ({ [I.seedNumber]: I })));
  s.forEach((I) => {
    let { seedNumber: U } = I;
    f && U <= f && (!r || m[U]) && (m[U] = I);
  });
  let h = Object.values(m), g = h.map((I) => I == null ? void 0 : I.participantId).filter(Boolean);
  if (g.length !== OP(g).length) return { error: qP };
  for (let I of h) {
    let U = tu({ ...I, provisionalPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, event: u });
    if (U != null && U.error) return U;
    U != null && U.success && d++;
  }
  return d ? { ...j, modifications: d } : { error: Wc };
}
function qS({ deleteExisting: e, event: t, flightProfile: r }) {
  var a;
  let i = "attachFlightProfile";
  if (!r) return W({ result: { error: we }, stack: i });
  if (!t) return W({ result: { error: At }, stack: i });
  let { flightProfile: n } = Ht({ event: t });
  return n && !e ? W({ result: { error: BI }, stack: i }) : (a = t.drawDefinitions) != null && a.length ? W({ result: { error: GP }, stack: i }) : (oo({ event: t, extension: { name: gn, value: r } }), { flightProfile: ge(r, !1, !0), ...j });
}
function n_({ tournamentRecord: e, scaleAttributes: t, participantIds: r }) {
  var s;
  if (!e) return { error: de };
  if (!r) return { error: ro };
  if (!t) return { error: we, info: "scaleAttributes required" };
  let { scaleType: i, eventType: n, scaleName: a } = t, o = [rN, i, n, a].join(".");
  return (s = e.participants) == null || s.forEach((c) => {
    r.includes(c.participantId) && c.timeItems && (c.timeItems = c.timeItems.filter((u) => u && (u == null ? void 0 : u.itemType) !== o));
  }), { ...j };
}
function HS({ tournamentRecord: e, scaleAttributes: t, drawDefinition: r, entryStatuses: i, drawId: n, event: a, stage: o }) {
  var u;
  if (!a) return { error: At };
  if (i && !Array.isArray(i)) return W({ result: { error: ie }, info: Oo("entryStatus"), stack: "removeScaleValues" });
  let s = a.entries;
  if (n) {
    let { flightProfile: d } = Ht({ event: a }), l = (u = d == null ? void 0 : d.flights) == null ? void 0 : u.find((p) => p.drawId === n);
    l ? s = l.drawEntries : s = r == null ? void 0 : r.entries;
  }
  let c = (s || []).filter((d) => (!o || !d.entryStage || d.entryStage === o) && (!i || i.includes(d.entryStatus))).map(Ke);
  return n_({ tournamentRecord: e, scaleAttributes: t, participantIds: c });
}
function ph({ removePriorValues: e, tournamentRecord: t, displaySettings: r, status: i = ji, event: n }) {
  if (!t) return W({ result: { error: de } });
  if (!n) return W({ result: { error: At } });
  if (!$e(r)) return W({ result: { error: we } });
  if ($e(r.draws)) for (let o of Object.keys(r.draws)) {
    let s = r.draws[o].scheduleDetails ?? [];
    if (s.length) {
      let c = [];
      for (let u of s) {
        let d = c.find((l) => xF(l.attributes, u.attributes));
        d != null && d.dates && u.dates ? d.dates.push(...u.dates) : c.push(u);
      }
      r.draws[o].scheduleDetails = c;
    }
  }
  let a = cu({ statusObject: { displaySettings: r }, removePriorValues: e, status: i, event: n });
  return a.error ? a : { ...j };
}
function zE({ tournamentRecord: e, drawDefinition: t, entryStatuses: r, scaleName: i, drawId: n, event: a, stage: o }) {
  var c, u;
  if (!e) return { error: de };
  if (!a) return { error: At };
  i = i || ((c = a.category) == null ? void 0 : c.categoryName) || ((u = a.category) == null ? void 0 : u.ageCategoryCode);
  let s = { eventType: a.eventType, scaleType: $n, scaleName: i };
  return HS({ tournamentRecord: e, scaleAttributes: s, drawDefinition: t, entryStatuses: r, drawId: n, event: a, stage: o });
}
function KE(e) {
  let t = Ae(e, [{ [fr]: !0 }, { eventIds: !0, [ui]: Gr }]);
  if (t.error) return t;
  let { removePairParticipants: r, tournamentRecord: i, eventIds: n } = e, a = [], o = [], s = [], c = [];
  if (i.events = (i.events || []).filter((u) => {
    if (n.includes(u.eventId)) {
      let p = { action: Zl, payload: { events: [u] } };
      a.push(p), o.push({ tournamentId: i.tournamentId, eventName: u.eventName, eventType: u.eventType, category: u.category, eventId: u.eventId, gender: u.gender });
    }
    let d = u.eventType === Xi ? (u.entries || []).map(({ entryStatus: p, participantId: f }) => p !== tn && f).filter(Boolean) : [], l = n.includes(u.eventId);
    return l ? c.push(...d) : s.push(...d), !l;
  }), r) {
    let u = c.filter((d) => !s.includes(d));
    i.participants = i.participants.filter(({ participantId: d }) => !u.includes(d));
  }
  if (sl({ tournamentRecord: i }), a.length) if (_f(va)) {
    let u = i.tournamentId;
    Le({ topic: va, payload: { type: Zl, tournamentId: u, detail: a } });
  } else el({ tournamentRecord: i, timeItem: { itemValue: o, itemType: Zl } });
  return { ...j };
}
function XE(e) {
  var h, g, I;
  let t = Ae(e, [{ tournamentRecord: !0, eventId: !0, event: !0 }, { eventUpdates: !0, _ofType: pi }]);
  if (t.error) return t;
  let { eventUpdates: r, event: i } = e, n = "modifyEvent", a = s_(e), o = c_({ enteredParticipants: a }), { enteredParticipantGenders: s, enteredParticipantTypes: c } = o, u = (g = (h = Ht({ event: i })) == null ? void 0 : h.flightProfile) == null ? void 0 : g.flights, d = !((I = i.drawDefinitions) != null && I.length) && !(u != null && u.length), l = u_({ noFlightsNoDraws: d, enteredParticipantGenders: s, eventUpdates: r, stack: n });
  if (l.error) return l;
  let p = d_({ enteredParticipantTypes: c, eventUpdates: r, stack: n });
  if (p.error) return p;
  let f = a_({ ...e, ...o, enteredParticipants: a, stack: n });
  if (f.error) return f;
  let m = o_({ ...e, stack: n });
  return m.error ? m : (r.eventType && (i.eventType = r.eventType), r.eventName && (i.eventName = r.eventName), r.gender && (i.gender = r.gender), { ...j });
}
function a_(e) {
  var i, n, a, o, s, c;
  let t = (i = e.eventUpdates) == null ? void 0 : i.category;
  if (!t) return { ...j };
  let r = Bu({ category: t });
  if (r.error) return r;
  if (e.event.eventType === or) {
    let u = ((a = (n = e.event) == null ? void 0 : n.drawDefinitions) == null ? void 0 : a.map((p) => Fn(p))) ?? [], d = Fn(e.event), l = (((o = ma(e)) == null ? void 0 : o.matchUps) ?? []).map((p) => Fn(p)) ?? [];
    if (![d, ...u, ...l].filter(Boolean).every((p) => p.collectionDefinitions.every((f) => !f.category || pd({ category: e.eventUpdates.category, childCategory: f.category })))) return W({ result: { error: Ou }, stack: e.stack });
  }
  if ((s = e.enteredParticipants) != null && s.length) {
    let u = e.eventUpdates.startDate || e.event.startDate || e.tournamentRecord.startDate, d = e.eventUpdates.endDate || e.event.endDate || e.tournamentRecord.endDate, l = e.enteredParticipants.map((m) => m.participantType === Xe ? m : m.individualParticpants ?? []).flat(), p = fs({ category: t, consideredDate: u }), f = fs({ category: t, consideredDate: d });
    if (p != null && p.ageMinDate || p != null && p.ageMaxDate || f != null && f.ageMinDate || f != null && f.ageMaxDate) for (let m of l) {
      let h = (c = m.person) == null ? void 0 : c.birthDate;
      if (!h) return W({ result: { error: uw }, stack: e.stack });
      let g = new Date(h).getTime();
      if (p.ageMinDate || p.ageMaxDate) {
        let I = new Date(p.ageMinDate).getTime(), U = new Date(p.ageMaxDate).getTime();
        if (g < I || g > U) return W({ result: { error: Ig }, stack: e.stack });
      }
      if (f.ageMin || f.ageMax) {
        let I = new Date(f.ageMinDate).getTime(), U = new Date(f.ageMaxDate).getTime();
        if (g < I || g > U) return W({ result: { error: Ig }, stack: e.stack });
      }
    }
  }
  return { ...j };
}
function o_(e) {
  let { tournamentRecord: t, eventUpdates: r, event: i, stack: n } = e;
  if (r.startDate || r.endDate) {
    let a = jS({ startDate: r.startDate, endDate: r.endDate, tournamentRecord: t, event: i });
    if (a.error) return W({ result: a, stack: n });
  }
  return { ...j };
}
function s_(e) {
  var n;
  let { tournamentRecord: t, event: r } = e, i = ((n = r == null ? void 0 : r.entries) == null ? void 0 : n.filter(({ entryStatus: a }) => {
    let o = a;
    return [...yn, fn].includes(o);
  }).map(({ participantId: a }) => a)) ?? [];
  return i ? Lt({ participantFilters: { participantIds: i }, withIndividualParticipants: !0, tournamentRecord: t }).participants ?? [] : [];
}
function c_({ enteredParticipants: e }) {
  let t = [], r = e.reduce((n, a) => {
    var s, c;
    let o = (s = a.person) != null && s.sex ? [a.person.sex] : ((c = a.individualParticpants) == null ? void 0 : c.map((u) => {
      var d;
      return (d = u.person) == null ? void 0 : d.sex;
    })) || [];
    return t.push(...o), n.includes(a.participantType) ? n : n.concat(a.participantType);
  }, []), i = Be(t);
  return { enteredParticipantTypes: r, enteredParticipantGenders: i };
}
function u_({ noFlightsNoDraws: e, enteredParticipantGenders: t, eventUpdates: r, stack: i }) {
  let n = !t.length || !r.gender || r.gender === Mn || t.length === 1 && t[0] === r.gender || e && r.gender === ni;
  return r.gender && !n ? W({ context: { gender: r.gender, validGender: n }, result: { error: Au }, stack: i }) : { ...j };
}
function d_({ enteredParticipantTypes: e, eventUpdates: t, stack: r }) {
  let i = (e.includes(or) && [or] || e.includes(Xe) && [jn] || e.includes(_e) && [Xi] || [Xi, jn, or]).includes(t.eventType ?? "");
  return t.eventType && !i ? W({ context: { participantType: t.eventType, validEventType: i }, result: { error: na }, stack: r }) : { ...j };
}
function fh({ qualifyingPositions: e, drawEntries: t = [], drawName: r, drawId: i, event: n, stage: a }) {
  var f, m, h;
  let o = "addFlight";
  if (!n) return W({ result: { error: At }, stack: o });
  if (!r) return W({ result: { error: we }, stack: o });
  if (t != null && t.length) {
    let g = (n.entries ?? []).map(Ke), I = t.map(Ke);
    if (qt(I, g).length !== I.length) return W({ result: { error: ie }, stack: o });
  }
  let s = (f = Ht({ event: n })) == null ? void 0 : f.flightProfile, c = ((h = (m = s == null ? void 0 : s.flights) == null ? void 0 : m.map(({ flightNumber: g }) => !isNaN(g) && be(g))) == null ? void 0 : h.filter(Boolean)) || [], u = Math.max(0, ...c) + 1, d = { drawId: i || st(), flightNumber: u, drawEntries: t, drawName: r };
  if (a && (d.stage = a), e && (d.qualifyingPositions = e), ((s == null ? void 0 : s.flights) || []).find(({ drawId: g }) => g === d.drawId)) return W({ result: { error: _w }, stack: o });
  let l = ((s == null ? void 0 : s.flights) || []).concat(d), p = { name: gn, value: { ...s || {}, flights: l } };
  return oo({ event: n, extension: p });
}
var ZE = {};
qe(ZE, { drawMatic: () => nS, garman: () => i1, generateAdHocMatchUps: () => Vm, generateAdHocRounds: () => iS, generateAndPopulatePlayoffStructures: () => CU, generateCourts: () => YS, generateDrawDefinition: () => dl, generateDrawMaticRound: () => zU, generateDrawStructuresAndLinks: () => qU, generateDrawTypeAndModifyDrawDefinition: () => HU, generateFlightProfile: () => f_, generateLineUps: () => r1, generateQualifyingStructure: () => DU, generateSeedingScaleItems: () => wE, generateStatCrew: () => m_, generateVoluntaryConsolation: () => s0, roundRobinGroups: () => gB });
var l_ = "splitLevelBased", QE = "splitWaterfall", JE = "splitShuttle", p_ = { SPLIT_LEVEL_BASED: l_, SPLIT_WATERFALL: QE, SPLIT_SHUTTLE: JE };
function f_(e) {
  let { drawNameRoot: t = "Flight", attachFlightProfile: r, tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, deleteExisting: o, sortDescending: s, drawNames: c = [], flightsCount: u, splitMethod: d, uuids: l = [], event: p, stage: f } = e;
  if (!p) return { error: At };
  let m = p.entries ?? [], { flightProfile: h } = Ht({ event: p });
  if (h && r && !o) return { error: BI };
  let g = e.scaledEntries ?? zs({ tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, sortDescending: s, event: p, stage: f }).scaledEntries, I = g.map(Ke), U = Xr(m.filter(({ participantId: w }) => !I.includes(w)).filter((w) => (!f || !w.entryStage || w.entryStage === f) && (!w.entryStatus || Yo.includes(w.entryStatus)))), v = g.concat(...U), S = v.length, T = Math.ceil(S / u), A = gr(v, T);
  d === QE ? A = ug(v, u) : d === JE && (A = ug(v, u, !0));
  function y(w) {
    return (w || []).map(({ participantId: R, scaleValue: b }) => {
      let E = m.find((O) => O.participantId === R);
      return E != null && E.scaleValue && b && (E.scaleValue = b), E;
    }).sort((R, b) => R.scaleValue - b.scaleValue).map((R, b) => (R.scaleValue && (R.seedNumber = b + 1), R));
  }
  let D = fe(0, u).map((w) => {
    let R = w + 1;
    return { flightNumber: R, drawId: (l == null ? void 0 : l.pop()) ?? st(), drawEntries: y(A[w]), drawName: (c == null ? void 0 : c.length) && c[w] || `${t} ${R}` };
  }), P = { scaleAttributes: n, splitMethod: d, flights: D };
  if (r) {
    let w = qS({ flightProfile: P, deleteExisting: o, event: p });
    return { splitEntries: ki() && A || void 0, ...w };
  } else return { flightProfile: P, ...j };
}
function $E({ json: e, tagName: t }) {
  let r = Object.keys(e).filter((a) => Array.isArray(e[a])).map((a) => ({ key: a, value: e[a].filter((o) => typeof o == "object" && Object.keys(o).length === 1) })), i = Object.keys(e).filter((a) => typeof e[a] == "object" && !Array.isArray(e[a])).map((a) => ({ key: a, value: e[a] })), n = Object.keys(e).filter((a) => ["string", "number"].includes(typeof e[a])).map((a) => ({ key: a, value: e[a] }));
  return e1({ tagName: t, attributes: n, childArrays: r, childObjects: i });
}
function e1(e) {
  let { tagName: t, attributes: r = [], childArrays: i = [], childObjects: n } = e, a = `\r
`, o = (f) => {
    let m = Object.keys(f)[0], h = f[m];
    return { key: m, value: h };
  }, s = i == null ? void 0 : i.map(({ key: f, value: m }) => e1({ tagName: f, childObjects: m.map(o) })).join(`\r
`), c = n == null ? void 0 : n.map(({ key: f, value: m }) => $E({ tagName: f, json: m ?? [] })).join(`\r
`), u = r == null ? void 0 : r.map(({ key: f, value: m }) => `${f}="${m}"`).join(" "), d = u ? ` ${u}` : "";
  if (t === "childArray") return c;
  let l = c != null && c.length ? `${a}${c}${a}` : "", p = s != null && s.length ? `${a}${s}${a}` : "";
  return `<${t}${d}>${l}${p}</${t}>`;
}
function m_(e) {
  var v, S, T;
  let t = Ae(e, [{ [fr]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r } = e, { startDate: i, tournamentId: n, tournamentName: a } = r, { participantMap: o, matchUps: s, mappedMatchUps: c } = Lt({ withMatchUps: !0, withEvents: !0, tournamentRecord: r }), u = r.participants.filter((A) => A.participantType === lt), d = (s == null ? void 0 : s.filter((A) => A.matchUpType === lt)) ?? [], l = (d == null ? void 0 : d.reduce((A, y) => {
    let D = (y == null ? void 0 : y.tieMatchUps) ?? [];
    return D && [...A, ...D];
  }, [])) ?? [], p = (s == null ? void 0 : s.filter((A) => A.matchUpType === mt)) ?? [], f = (s == null ? void 0 : s.filter((A) => A.matchUpType === ft)) ?? [], m = l.length === p.length + f.length, h = d.length === 1 && m, g = { mappedMatchUps: c, participantMap: o, tournamentName: a, tournamentId: n, tournament: m ? "N" : "Y", startDate: i }, I = [], U = [];
  if (h) {
    let A = d[0], { json: y, xml: D } = YT({ teamParticipants: u, teamMatchUp: A, ...g, doubles: f, singles: p });
    U.push(y), I.push(D);
  } else for (let A of d) {
    let y = (v = A == null ? void 0 : A.sides) == null ? void 0 : v.map(({ participant: R }) => R == null ? void 0 : R.participantId).filter(Boolean);
    if ((y == null ? void 0 : y.length) !== 2) continue;
    let D = y.map((R) => {
      var b;
      return R && ((b = o == null ? void 0 : o[R]) == null ? void 0 : b.participant);
    }), { xml: P, json: w } = YT({ doubles: (S = A.tieMatchUps) == null ? void 0 : S.filter((R) => R.matchUpType === ft), singles: (T = A.tieMatchUps) == null ? void 0 : T.filter((R) => R.matchUpType === mt), teamParticipants: D, teamMatchUp: A, ...g });
    U.push(w), I.push(P);
  }
  return { json: U, xml: I, ...j };
}
function YT({ teamParticipants: e, mappedMatchUps: t, participantMap: r, tournamentName: i, tournamentId: n, teamMatchUp: a, tournament: o, startDate: s, doubles: c, singles: u }) {
  var S, T, A, y;
  let d = e == null ? void 0 : e.find((D) => {
    var P;
    return (P = D.participantRoleResponsibilities) == null ? void 0 : P.includes("Home");
  }), l = e == null ? void 0 : e.filter((D) => D.participantId !== (d == null ? void 0 : d.participantId)), p = ln(s, "/", "MDY"), f = (d == null ? void 0 : d.participantName) || ((S = l == null ? void 0 : l[1]) == null ? void 0 : S.participantName), m = (d == null ? void 0 : d.participantId) || ((T = l == null ? void 0 : l[1]) == null ? void 0 : T.participantId), h = (A = l == null ? void 0 : l[0]) == null ? void 0 : A.participantName, g = (y = l == null ? void 0 : l[0]) == null ? void 0 : y.participantId, I = {}, U = e.map((D) => ({ team: { ...I_({ teamParticipant: D, teamMatchUp: a, uniValues: I, participantMap: r, mappedMatchUps: t, homeid: m }) } })), v = ye({ venue: { tournamentname: o ? i : void 0, neutralgame: d ? "N" : "Y", gameid: n, officials: {}, tournament: o, rules: {}, homename: f, visname: h, homeid: m, visid: g, date: p }, childArray: U, singles_matches: u == null ? void 0 : u.map((D) => zT({ matchUp: D, homeid: m, uniValues: I })), doubles_matches: c == null ? void 0 : c.map((D) => zT({ matchUp: D, homeid: m, uniValues: I })) });
  return { json: v, xml: $E({ json: v, tagName: "tngame" }) };
}
function h_({ homeid: e, uniValues: t, participant: r }) {
  var h, g, I, U, v, S, T, A, y, D, P, w, R, b, E;
  if (!r) return {};
  let i = ((h = r.individualParticipants) == null ? void 0 : h.length) === 2, n = i ? Be((g = r.individualParticipants) == null ? void 0 : g.map((O) => {
    var M, N;
    return (N = (M = O.teams) == null ? void 0 : M[0]) == null ? void 0 : N.participantId;
  })) : [], a = i ? Be((I = r.individualParticipants) == null ? void 0 : I.map((O) => {
    var M, N;
    return (N = (M = O.teams) == null ? void 0 : M[0]) == null ? void 0 : N.teamId;
  })) : [], o = !i && ((v = (U = r.teams) == null ? void 0 : U[0]) == null ? void 0 : v.participantId) || (n == null ? void 0 : n.length) === 1 && n[0] || void 0, s = !i && ((T = (S = r.teams) == null ? void 0 : S[0]) == null ? void 0 : T.teamId) || (a == null ? void 0 : a.length) === 1 && a[0] || o, c = i ? void 0 : r.participantName, u = (y = (A = r.individualParticipants) == null ? void 0 : A[0]) == null ? void 0 : y.participantName, d = (P = (D = r.individualParticipants) == null ? void 0 : D[1]) == null ? void 0 : P.participantName, l = e && (o === e ? "H" : "V") || "", p = i ? void 0 : t[o][r.participantId], f = t[o][(R = (w = r.individualParticipants) == null ? void 0 : w[0]) == null ? void 0 : R.participantId], m = t[o][(E = (b = r.individualParticipants) == null ? void 0 : b[1]) == null ? void 0 : E.participantId];
  return ye({ vh: l, uni: p, uni_1: f, uni_2: m, team: s, name: c, name_1: u, name_2: d });
}
function g_({ sets: e, sideNumber: t }) {
  return Object.assign({}, ...(e == null ? void 0 : e.map((r) => {
    let { setNumber: i, side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s } = r, c = `set_${i}`, u = `tie_${i}`, d = t === 1 ? n : a, l = t === 1 ? o : s;
    return { [c]: d, [u]: l };
  })) ?? []);
}
function I_({ teamParticipant: e, teamMatchUp: t, participantMap: r, mappedMatchUps: i, homeid: n, uniValues: a }) {
  var S, T, A, y, D, P, w, R, b, E, O, M, N, C;
  let { participantId: o, participantName: s } = e, c = n && (o === n ? "H" : "V") || "", u = (S = r == null ? void 0 : r[o]) == null ? void 0 : S.matchUps, d = u && Object.keys(u), l = (A = (T = t == null ? void 0 : t.sides) == null ? void 0 : T.find(({ participant: F }) => F.participantId === o)) == null ? void 0 : A.sideNumber, p = ((P = (D = (y = t == null ? void 0 : t.score) == null ? void 0 : y.sets) == null ? void 0 : D[0]) == null ? void 0 : P[`side${l}Score`]) ?? 0;
  a[o] = {};
  let f = { SINGLES: { w: 0, l: 0 }, DOUBLES: { w: 0, l: 0 } }, m = [], h = [], g = 0;
  for (let F of d ?? []) {
    let x = i == null ? void 0 : i[F], V = (w = x.sides.find(({ participant: L }) => L.participantId === o)) == null ? void 0 : w.sideNumber, k = ((E = (b = (R = x.score) == null ? void 0 : R.sets) == null ? void 0 : b[0]) == null ? void 0 : E[`side${V}Score`]) ?? 0;
    g += k;
    for (let L of x.tieMatchUps ?? []) {
      let { matchUpType: B, winningSide: G } = L, q = G && (G === V ? "w" : "l") || "";
      q && (f[B][q] += 1);
      let Y = q === "w" ? "1" : "0", H = q === "l" ? "1" : "0";
      if (B === mt) {
        let X = h.length + 1;
        h.push({ singles_pair: { pair: X, won: Y, lost: H, tied: "0" } });
      } else if (B === ft) {
        let X = m.length + 1;
        m.push({ doubles_pair: { pair: X, won: Y, lost: H, tied: "0" } });
      }
    }
  }
  let I = [{ singles: { childArray: h, won: f.SINGLES.w, lost: f.SINGLES.l } }, { doubles: { childArray: m, won: f.DOUBLES.w, lost: f.DOUBLES.l } }], U = [], v = 1;
  for (let F of e.individualParticipantIds) {
    let x = r == null ? void 0 : r[F];
    if (x) {
      let { participant: V, counters: k } = x, L = { won: ((O = k == null ? void 0 : k.DOUBLES) == null ? void 0 : O.wins) || 0, lost: ((M = k == null ? void 0 : k.DOUBLES) == null ? void 0 : M.losses) || 0 }, B = { won: ((N = k == null ? void 0 : k.SINGLES) == null ? void 0 : N.wins) || 0, lost: ((C = k == null ? void 0 : k.SINGLES) == null ? void 0 : C.losses) || 0 }, { participantName: G, participantId: q } = V;
      a[o][q] = v, U.push({ player: { name: G, uni: v, singles: B, doubles: L } });
    }
    v += 1;
  }
  return { vh: c, id: o, name: s, score: p || g, totals: I, childArray: U };
}
function zT({ matchUp: e, homeid: t, uniValues: r }) {
  let { collectionPosition: i, orderOfFinish: n, matchUpType: a, sides: o } = e ?? {}, s = o == null ? void 0 : o.map((c) => {
    var p;
    let { sideNumber: u, participant: d } = c, l = g_({ sets: (p = e.score) == null ? void 0 : p.sets, sideNumber: u });
    return { [a === mt ? "singles_score" : "doubles_score"]: { ...h_({ homeid: t, uniValues: r, participant: d }), ...l } };
  });
  return { [a === mt ? "singles_match" : "doubles_match"]: { match: i, order: n, childArray: s } };
}
var v_ = "ASC", t1 = "ASC", U_ = "DESC", iI = "DESC", S_ = { ASC: v_, ASCENDING: t1, DESC: U_, DESCENDING: iI };
function r1(e) {
  var R, b, E, O, M;
  let { tieFormat: t } = e, { useDefaultEventRanking: r, tournamentRecord: i, drawDefinition: n, scaleAccessor: a, singlesOnly: o, attach: s, event: c } = e;
  if ((c == null ? void 0 : c.eventType) !== bi) return { error: na };
  if (!i) return { error: de };
  if (!t && !n) return { error: Fi };
  if (t = t ?? ((R = Yr({ drawDefinition: n, event: c })) == null ? void 0 : R.tieFormat), oi({ tieFormat: t }).error) return { error: Jn };
  if (typeof a != "object" && !r) return { error: ie, context: { scaleAccessor: a } };
  let u = {}, d = ((n == null ? void 0 : n.entries) ?? (c == null ? void 0 : c.entries) ?? []).filter((N) => (N == null ? void 0 : N.entryStatus) === Ii).map(Ke), { participants: l = [] } = Lt({ withIndividualParticipants: !0, withScaleValues: !0, tournamentRecord: i }), p = l.filter(({ participantId: N }) => d.includes(N)), f = (N) => N === Ya ? "rankings" : "ratings", m = ((b = c == null ? void 0 : c.category) == null ? void 0 : b.categoryName) ?? ((E = c == null ? void 0 : c.category) == null ? void 0 : E.ageCategoryCode), { scaleName: h = m, scaleType: g = Ya, sortOrder: I, accessor: U } = a || {}, v = f(g), S = (N, C) => {
    var x, V, k;
    let F = (x = N[v]) == null ? void 0 : x[C];
    if (!F && r && (F = (V = N[v]) == null ? void 0 : V[es]), Array.isArray(F)) {
      let L = (k = F.find((B) => B.scaleName === h)) == null ? void 0 : k.scaleValue;
      if (jt(L)) return L;
      if (U && typeof L == "object") return L[U];
    }
    return 0;
  }, T = (N, C, F) => {
    let x = I === iI ? C : N, V = I === iI ? N : C;
    return S(x, F) - S(V, F);
  }, A = (N, C) => T(N, C, es), y = (N, C) => T(N, C, Ao), D = [], P = (t == null ? void 0 : t.collectionDefinitions) ?? [];
  for (let N of p) {
    let C = ((O = N.individualParticipants) == null ? void 0 : O.sort(A)) ?? [], F = o ? C : ((M = N.individualParticipants) == null ? void 0 : M.sort(y)) ?? [], x = {};
    for (let k of P) {
      let L = [], { collectionId: B, matchUpCount: G, matchUpType: q, gender: Y } = k, H = Kt(es)(q);
      fe(0, G).forEach((X) => {
        let z = H ? C : F ?? [], Z = X + 1, te = [];
        fe(0, H ? 1 : 2).forEach((ne) => {
          var K;
          let ee = (K = z == null ? void 0 : z.find((J) => {
            var ae;
            let $ = Y && ([pt, St].includes(Y) && Y || Y === ni && [pt, St][ne]);
            return (!$ || $ === ((ae = J.person) == null ? void 0 : ae.sex)) && !L.includes(J.participantId);
          })) == null ? void 0 : K.participantId;
          ee && (te.push(ee), L.push(ee), x[ee] || (x[ee] = []), x[ee].push({ collectionPosition: Z, collectionId: B }));
        }), H || D.push(te);
      });
    }
    let V = Object.keys(x).map((k) => ({ collectionAssignments: x[k], participantId: k }));
    u[N.participantId] = V;
  }
  let w = [];
  for (let N of D) {
    let { participant: C } = vn({ tournamentParticipants: l, participantIds: N });
    if (!C) {
      let F = { individualParticipantIds: N, participantRole: Cr, participantType: _e };
      w.push(F);
    }
  }
  if (s) {
    for (; w.length; ) Yn({ participant: w.pop(), tournamentRecord: i });
    it({ element: n, extension: { name: Da, value: u } });
  }
  return { ...j, lineUps: u, participantsToAdd: w };
}
function YS(e) {
  if (!e) return { error: we };
  let t = Ae(e, [{ dates: !1, [Or]: (o) => Array.isArray(o) && o.every(mi) }, { uuids: !1, [Or]: (o) => Array.isArray(o) && o.every(Et) }, { startTime: !1, endTime: !1, [Or]: KI }, { idPrefix: !1, namePrefix: !1, [Or]: Et }, { count: !0, [Or]: jt }]);
  if (t.error) return t;
  let { startDate: r, endDate: i } = e.tournamentRecord ?? {}, n = e.dates || r && i && hc(r, i) || [], a = fe(1, e.count + 1).map((o) => {
    var s, c;
    return ye({ courtId: ((s = e.uuids) == null ? void 0 : s.pop()) ?? (e.idPrefix && `${e.idPrefix}-${o}`) ?? st(), courtName: ((c = e.courtNames) == null ? void 0 : c.pop()) ?? (e.namePrefix && `${e.namePrefix} ${o}`), dateAvailability: n.map((u) => ({ startTime: e.startTime ?? "08:00", endTime: e.endTime ?? "20:00", date: u })) });
  });
  return { ...j, courts: a };
}
var i1 = {};
qe(i1, { default: () => T_, garman: () => o1 });
function pl({ court: e, date: t }) {
  let r = t && e.dateAvailability.find((n) => aa(n.date, t)), i = e.dateAvailability.find((n) => !n.date);
  return r || i;
}
function du(e) {
  let t = Ae(e, [{ courtDate: !0, _ofType: pi }]);
  if (t.error) return t;
  let { includeBookingTypes: r = [], courtDate: i } = e, n = [], a = rr(i.startTime);
  (i.bookings || []).filter((s) => !s.bookingType || !r.includes(s.bookingType)).sort((s, c) => ap(s.startTime).localeCompare(ap(c.startTime))).forEach((s) => {
    let c = { startTime: Rt(a.toISOString()), endTime: s.startTime };
    rr(s.startTime) > a && n.push(c), rr(s.endTime) > a && (a = rr(s.endTime));
  });
  let o = { startTime: Rt(a.toISOString()), endTime: i.endTime };
  return rr(i.endTime) > a && n.push(o), { timeSlots: n };
}
function y_({ averageMatchUpMinutes: e, includeBookingTypes: t, periodStartTime: r, periodEndTime: i }) {
  let n = (o) => {
    var c;
    let { timeSlots: s } = du({ includeBookingTypes: t, courtDate: o });
    return !!((c = s == null ? void 0 : s.filter(a)) != null && c.length);
  };
  function a(o) {
    let s = rr(o.startTime), c = rr(o.endTime);
    return s > r || c < i ? !1 : ld(r, c) >= e;
  }
  return { enoughTime: n };
}
function n1(e) {
  let t = Ae(e, [{ periodStart: !0, date: !0 }, { courts: !0, _ofType: Gr }]);
  if (t.error) return t;
  let { averageMatchUpMinutes: r, includeBookingTypes: i, periodStart: n, date: a } = e, o = e.courts, s = rr(n), c = ZI(s, r), { enoughTime: u } = y_({ averageMatchUpMinutes: r, includeBookingTypes: i, periodStartTime: s, periodEndTime: c });
  return { availableToScheduleCount: ((o == null ? void 0 : o.filter((d) => {
    if (!Array.isArray(d.dateAvailability)) return !1;
    let l = pl({ date: a, court: d });
    return !!(l && u(l));
  })) || []).length, ...j };
}
function mh(e) {
  var p;
  let { remainingScheduleTimes: t = [], clearScheduleDates: r, periodLength: i = 30, scheduleDate: n, courts: a = [] } = e, { bookings: o = [] } = e;
  if (!Array.isArray(a) || !a.length) return { error: ie, courts: a };
  if (!Array.isArray(o)) return { error: tp };
  if (!mi(n)) return { error: Sr };
  r && (Array.isArray(r) ? r.includes(n) && (o = []) : o = []);
  let { courtBookings: s, unassignedBookings: c } = o.reduce((f, m) => {
    let { courtId: h } = m;
    return h ? f.courtBookings[h] ? f.courtBookings[h].push(m) : f.courtBookings[h] = [m] : f.unassignedBookings.push(m), f;
  }, { courtBookings: {}, unassignedBookings: [] }), u = a.map((f, m) => {
    let { courtId: h, courtName: g } = f, I = s[h] || [], U = pl({ date: n, court: f }) || {}, { bookings: v = [], startTime: S, endTime: T, date: A } = U, y = [t[m] && { startTime: S, endTime: t[m] }, ...ge(v, !1, !0), ...I].filter(Boolean);
    return { courtId: h, courtName: g, dateAvailability: { bookings: y, startTime: S, endTime: T, date: A } };
  });
  c.sort((f, m) => tt(f.startTime) - tt(m.startTime));
  let d = () => u.map((f) => {
    let m = f.dateAvailability, { timeSlots: h = [] } = du({ courtDate: m });
    return { courtName: f.courtName, courtId: f.courtId, timeSlots: h };
  }).flat(), l = [];
  for (let f of c) {
    let { startTime: m, endTime: h, averageMinutes: g, recoveryMinutes: I, matchUpId: U } = f, v = tt(m), S = tt(h), T = d().reduce((A, { courtId: y, courtName: D, timeSlots: P }) => {
      let w;
      return P.find(({ startTime: R, endTime: b }) => {
        w = tt(R) - v;
        let E = v >= tt(R);
        return S <= tt(b) && A.startDifference !== 0 && ((w === 0 || w + i >= 0) && (A.startDifference === void 0 || w < A.startDifference) || E);
      }) ? { courtName: D, courtId: y, startDifference: w } : A;
    }, {});
    if (T.courtId) {
      let A = { averageMinutes: g, recoveryMinutes: I, matchUpId: U, startTime: m, endTime: h };
      l.push(A), (p = u.find(({ courtId: y }) => y === T.courtId)) == null || p.dateAvailability.bookings.push(A);
    } else console.log({ unassignedBooking: f });
  }
  return { virtualCourts: u.map(({ courtId: f, courtName: m, dateAvailability: h }) => ({ dateAvailability: [h], courtName: m, courtId: f })), assignedBookings: l };
}
function hh({ averageMatchUpMinutes: e, periodLength: t = 30, recoveryMinutes: r }) {
  let i = (e || 90) + (r || 0);
  return t > i ? i : t || 30;
}
function a1(e) {
  let { startTime: t = "8:00", endTime: r = "20:30", count: i = 10, date: n } = e ?? {};
  return fe(0, i).map(() => ({ dateAvailability: [{ date: n, startTime: t, endTime: r }] }));
}
function Fc({ scheduleDate: e, startTime: t, endTime: r, courts: i }) {
  let n = t && "startTime" || r && "endTime" || void 0;
  return i.reduce((a, o) => {
    let s = pl({ date: e, court: o }), c = n && ((s == null ? void 0 : s[n]) || o[n]);
    return c && (!a || t && tt(c) < tt(a) || r && tt(c) > tt(a)) ? c : a;
  }, void 0);
}
function A_({ averageMinutes: e, startTime: t, endTime: r, courts: i, date: n }) {
  t = t || Fc({ courts: i, scheduleDate: n, startTime: !0 }), r = r || Fc({ courts: i, scheduleDate: n, endTime: !0 });
  let a;
  if (t && r) {
    let o = rr(t), s = rr(r);
    for (let c of i || []) {
      if (!Array.isArray(c.dateAvailability)) continue;
      let u = pl({ court: c, date: n }), { timeSlots: d } = du({ courtDate: u });
      d == null || d.forEach((l) => {
        let p = rr(l.startTime), f = rr(l.endTime);
        if (p > s || p < o || f < o) return !1;
        if (ld(p, f) >= e) {
          let m = Rt(p.toISOString());
          (!a || m < a) && (a = m);
        }
      });
    }
  }
  return { firstTimeSlotStartTime: a };
}
function zS(e) {
  let t = Ae(e, [{ courts: !0, _ofType: Gr }]);
  if (t.error) return t;
  let { date: r = zI(), startTime: i = "08:00", endTime: n = "19:00", periodLength: a, courts: o } = e, { calculateStartTimeFromCourts: s = !0, remainingScheduleTimes: c, averageMatchUpMinutes: u, clearScheduleDates: d, courtsCount: l, bookings: p } = e;
  a = a || hh({ averageMatchUpMinutes: u }), r = Ve(r), i = Rt(i), n = Rt(n);
  let f = 0, m = 0, h = 0, g = 0, I = 0;
  !o && l && (o = a1({ startTime: i, endTime: n, count: l, date: r }));
  let { virtualCourts: U } = mh({ remainingScheduleTimes: c, clearScheduleDates: d, scheduleDate: r, periodLength: a, bookings: p, courts: o }), { firstTimeSlotStartTime: v } = A_({ averageMinutes: u, courts: U, startTime: i, endTime: n, date: r });
  s && v && (i = v ?? i);
  let S = tt(i), T = tt(n) - S, A = Math.floor(T / a), y = fe(0, A + 1).map((D) => {
    let P = S + D * a, w = Gk(P), R = n1({ courts: U ?? [], averageMatchUpMinutes: u, periodStart: w, date: r });
    if (R.error) return { error: R.error };
    let { availableToScheduleCount: b = 0 } = R, E = b > m ? b - m : 0;
    I += D ? b : 0;
    let O = D ? I / D : b, M = a * O / u, N = D ? M * (D - 1) + O : O, C = b ? m && N - f || E : 0;
    f = N, m = b, h += C;
    let F = be(h) - g;
    return g += F, { periodStart: w, add: F, availableToScheduleCount: b, newCourts: E, totalMatchUps: g };
  });
  return { scheduleTimes: y.reduce((D, P) => {
    let w = fe(0, P.add).map(() => ({ scheduleTime: P.periodStart }));
    return D.concat(...w);
  }, []).flat(), timingProfile: y, totalMatchUps: g };
}
var o1 = { getCourtsAvailableAtPeriodStart: n1, generateTimeSlots: du, getScheduleTimes: zS, courtGenerator: a1 }, T_ = o1, s1 = {};
qe(s1, { isValid: () => Ri, isValidMatchUpFormat: () => Ri, parse: () => ti, stringify: () => Yf });
var c1 = {};
qe(c1, { allCompetitionMatchUps: () => On, allDrawMatchUps: () => Qr, allEventMatchUps: () => ma, allTournamentMatchUps: () => Pr, analyzeMatchUp: () => ed, applyLineUps: () => E1, assignMatchUpSideParticipant: () => d1, assignTieMatchUpParticipantId: () => Mp, bulkMatchUpStatusUpdate: () => R1, calculateWinCriteria: () => Xs, checkInParticipant: () => XS, checkMatchUpIsComplete: () => yo, checkOutParticipant: () => KS, competitionScheduleMatchUps: () => ul, disableTieAutoCalc: () => D1, drawMatchUps: () => ES, enableTieAutoCalc: () => y1, eventMatchUps: () => sh, filterMatchUps: () => ga, findMatchUp: () => gS, getAllDrawMatchUps: () => ur, getAllStructureMatchUps: () => ut, getCheckedInParticipantIds: () => Bs, getCompetitionMatchUps: () => $u, getEventMatchUpFormatTiming: () => AS, getHomeParticipantId: () => wS, getMatchUpCompetitiveProfile: () => Cd, getMatchUpContextIds: () => RS, getMatchUpDailyLimits: () => uh, getMatchUpDailyLimitsUpdate: () => TS, getMatchUpDependencies: () => An, getMatchUpFormat: () => bS, getMatchUpFormatTiming: () => Fd, getMatchUpFormatTimingUpdate: () => yS, getMatchUpScheduleDetails: () => Sm, getMatchUpType: () => ym, getMatchUpsStats: () => NS, getModifiedMatchUpFormatTiming: () => oh, getParticipantResults: () => Qd, getPredictiveAccuracy: () => PS, getRoundMatchUps: () => $r, getRounds: () => MS, isValidMatchUpFormat: () => Ri, matchUpActions: () => xm, mutate: () => u1, participantScheduledMatchUps: () => DS, query: () => SE, removeDelegatedOutcome: () => A1, removeMatchUpSideParticipant: () => JS, removeTieMatchUpParticipantId: () => p1, replaceTieMatchUpParticipantId: () => QS, resetAdHocMatchUps: () => N1, resetMatchUpLineUps: () => ay, resetScorecard: () => sy, resetTieFormat: () => oy, setDelegatedOutcome: () => b1, setMatchUpFormat: () => P1, setMatchUpStatus: () => ml, setOrderOfFinish: () => M1, substituteParticipant: () => T1, tallyParticipantResults: () => nu, toggleParticipantCheckInState: () => gh, tournamentMatchUps: () => ch, updateTieMatchUpScore: () => La, validMatchUp: () => hm, validMatchUps: () => rn });
var u1 = {};
qe(u1, { applyLineUps: () => E1, assignMatchUpSideParticipant: () => d1, assignTieMatchUpParticipantId: () => Mp, bulkMatchUpStatusUpdate: () => R1, checkInParticipant: () => XS, checkOutParticipant: () => KS, disableTieAutoCalc: () => D1, enableTieAutoCalc: () => y1, findMatchUp: () => gS, removeDelegatedOutcome: () => A1, removeMatchUpSideParticipant: () => JS, removeTieMatchUpParticipantId: () => p1, replaceTieMatchUpParticipantId: () => QS, resetAdHocMatchUps: () => N1, resetMatchUpLineUps: () => ay, resetScorecard: () => sy, resetTieFormat: () => oy, setDelegatedOutcome: () => b1, setMatchUpFormat: () => P1, setMatchUpStatus: () => ml, setOrderOfFinish: () => M1, substituteParticipant: () => T1, toggleParticipantCheckInState: () => gh, updateTieMatchUpScore: () => La });
function d1({ tournamentRecord: e, drawDefinition: t, participantId: r, sideNumber: i, matchUpId: n, event: a }) {
  var u, d;
  if (r && typeof r != "string") return { error: bn };
  if (!t) return { error: Ue };
  if (!n) return { error: zr };
  let o = i === void 0;
  if (o && (i = 1), ![1, 2].includes(i)) return W({ result: { error: ie, context: { sideNumber: i } } });
  let { matchUp: s, structure: c } = bt({ drawDefinition: t, matchUpId: n, event: a });
  if (!s) return { error: jr };
  if (!(!(c != null && c.structures) && !(t.drawType && t.drawType !== Li) && !((u = c == null ? void 0 : c.matchUps) != null && u.find(({ roundPosition: l }) => !!l)))) return { error: II };
  if (!r && ((d = s == null ? void 0 : s.score) != null && d.scoreStringSide1 || lr.includes(s == null ? void 0 : s.matchUpstatus) || s != null && s.matchUpStatus && [$t, sr].includes(s.matchUpStatus))) return { error: Cf, info: "matchUp has completed status or score" };
  if (s) {
    if (s.sides = [1, 2].map((l) => {
      var f;
      let p = ((f = s.sides) == null ? void 0 : f.find((m) => m.sideNumber === l)) ?? { sideNumber: l };
      return i === l ? { ...p, participantId: r } : p;
    }), o) for (let l of s.sides) l.sideNumber && (l.sideNumber = 3 - l.sideNumber);
    Qe({ tournamentId: e == null ? void 0 : e.tournamentId, context: "assignSideParticipant", drawDefinition: t, matchUp: s });
  }
  return { ...j, sidesSwapped: o };
}
function Mi({ removePriorValues: e, tournamentRecord: t, duplicateValues: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: o, event: s }) {
  let { matchUp: c } = bt({ drawDefinition: i, event: s, matchUpId: a });
  if (!c) return { error: jr };
  let u = Xn({ removePriorValues: e, element: c, duplicateValues: r, timeItem: o });
  return n || Qe({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: s == null ? void 0 : s.eventId, context: "addTimeItem", drawDefinition: i, matchUp: c }), u;
}
function KS(e) {
  var U;
  let t = [{ [fr]: !0 }, { [ii]: !0 }, { [ca]: !0 }, { [zn]: !0 }], r = Ae(e, t);
  if (r.error) return r;
  let i = ou(e, [{ [Yc]: pa, attr: { [$f]: !0 } }]);
  if (i.error) return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = (U = i == null ? void 0 : i.matchUp) == null ? void 0 : U.matchUp, { matchUpStatus: u, score: d } = c ?? {};
  if (u && Sv.includes(u) || u && lr.includes(u) || pr({ score: d })) return { error: zP };
  let l = Bs({ matchUp: c });
  if (l != null && l.error) return l;
  let { checkedInParticipantIds: p, allRelevantParticipantIds: f } = l ?? {};
  if (!(f != null && f.includes(o))) return { error: bn };
  if (!(p != null && p.includes(o))) return { error: yw };
  let m = Zb({ matchUp: c });
  if (m != null && m.error) return m;
  let { sideParticipantIds: h, nestedIndividualParticipantIds: g } = m ?? {}, I = h == null ? void 0 : h.indexOf(o);
  return I !== void 0 && [0, 1].includes(I) && ((g == null ? void 0 : g[I]) ?? []).forEach((v) => {
    Mi({ drawDefinition: a, matchUpId: s, timeItem: { itemType: mp, itemValue: v } });
  }), Mi({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: mp } }), { ...j, checkedOut: !0 };
}
function XS(e) {
  var p;
  let t = [{ [fr]: !0 }, { [ii]: !0 }, { [ca]: !0 }, { [zn]: !0 }], r = Ae(e, t);
  if (r[pn]) return r;
  let i = ou(e, [{ [Yc]: pa, attr: { [$f]: !0 } }]);
  if (i[pn]) return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = Bs({ matchUp: (p = i == null ? void 0 : i.matchUp) == null ? void 0 : p.matchUp });
  if (c != null && c.error) return c;
  let { checkedInParticipantIds: u, allRelevantParticipantIds: d } = c ?? {};
  if (!(d != null && d.includes(o))) return { [pn]: bn };
  let l = { ...j, checkedIn: !0 };
  return u != null && u.includes(o) || Mi({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: fp } }), l;
}
function gh(e) {
  var u, d;
  let t = Ae(e, [{ [ca]: !0, [ii]: !0, [zn]: !0 }]);
  if (t.error) return t;
  let r = e.tournamentId ?? e.activeTournamentId, i = e.tournamentRecord ?? (r && ((u = e.tournamentRecords) == null ? void 0 : u[r]));
  if (!i) return { error: de };
  let n = (d = ou(e, [{ [Yc]: pa, attr: { [$f]: !0 }, [pn]: jr }]).matchUp) == null ? void 0 : d.matchUp;
  if (!n) return { error: jr };
  let { checkedInParticipantIds: a = [] } = Bs({ matchUp: n }), { participantId: o, matchUpId: s, drawDefinition: c } = e;
  return o && a.includes(o) ? KS({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n }) : XS({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n });
}
function ZS({ tournamentRecord: e, drawDefinition: t, tieMatchUpId: r, event: i }) {
  var A, y;
  if (!e) return { error: de };
  if (!t) return { error: Cn };
  if (!i) return { error: Ki };
  let n = xr({ drawDefinition: t }), { matchUp: a } = bt({ matchUpId: r, drawDefinition: t, matchUpsMap: n });
  if (!a) return { error: jr };
  let { matchUp: o, structure: s } = bt({ tournamentParticipants: e.participants, matchUpId: r, inContext: !0, drawDefinition: t, matchUpsMap: n, event: i });
  if (!o) return { error: jr };
  let { collectionPosition: c, drawPositions: u, collectionId: d, matchUpTieId: l, matchUpType: p } = o;
  if (p && !Rf([mt, ft], p)) return { error: gi };
  let { positionAssignments: f } = gt({ structure: s }), m = f == null ? void 0 : f.filter((D) => u == null ? void 0 : u.includes(D.drawPosition)), { matchUp: h } = bt({ matchUpId: l, drawDefinition: t, matchUpsMap: n }), g = ((A = h == null ? void 0 : h.sides) == null ? void 0 : A.map(Ke)) ?? [], I = (m == null ? void 0 : m.map(Ke)) ?? [], U = [...g, ...I], { participants: v } = Lt({ tournamentRecord: e, participantFilters: { participantTypes: [lt], participantIds: U } }), { matchUp: S } = bt({ matchUpId: l, inContext: !0, drawDefinition: t, matchUpsMap: n }), T = (y = Yr({ matchUp: h, drawDefinition: t, structure: s, event: i })) == null ? void 0 : y.tieFormat;
  return { inContextDualMatchUp: S, inContextTieMatchUp: o, relevantAssignments: m, collectionPosition: c, teamParticipants: v, collectionId: d, matchUpType: p, dualMatchUp: h, tieMatchUp: a, tieFormat: T, structure: s, ...j };
}
function QS(e) {
  var F, x, V, k, L, B, G, q, Y, H, X, z, Z, te, ne, ee;
  let t = ZS(e);
  if (t.error) return t;
  let r = "replaceTieMatchUpParticipantid", { existingParticipantId: i, tournamentRecord: n, newParticipantId: a, drawDefinition: o, substitution: s, event: c } = e;
  if (!i || !a) return W({ result: { error: cr }, stack: r });
  if (i === a) return { ...j };
  let { inContextDualMatchUp: u, inContextTieMatchUp: d, collectionPosition: l, collectionId: p, dualMatchUp: f, tieMatchUp: m, tieFormat: h } = t, g = d == null ? void 0 : d.matchUpType, I = (F = d == null ? void 0 : d.sides) == null ? void 0 : F.find((K) => {
    var J, $, ae;
    return ((J = K.participant) == null ? void 0 : J.participantId) === i || ((ae = ($ = K.participant) == null ? void 0 : $.individualParticipantIds) == null ? void 0 : ae.includes(i));
  });
  if (!I) return { error: Yt };
  let U = ((x = Lt({ tournamentRecord: n, participantFilters: { participantIds: [i, a] } })) == null ? void 0 : x.participants) ?? [];
  if (U.length !== 2) return W({ result: { error: cr }, stack: r });
  if (U[0].participantType !== U[1].participantType) return W({ result: { error: Nn }, stack: r });
  let { appliedPolicies: v } = nt({ tournamentRecord: n, drawDefinition: o, event: c }), S = ((V = e.policyDefinitions) == null ? void 0 : V[Ar]) ?? (v == null ? void 0 : v[Ar]) ?? eu[Ar], T = U.find(({ participantId: K }) => K === a);
  if ((e.enforceGender ?? ((k = S == null ? void 0 : S.participants) == null ? void 0 : k.enforceGender)) !== !1 && [pt, St].includes(d == null ? void 0 : d.gender) && (d == null ? void 0 : d.gender) !== ((L = T == null ? void 0 : T.person) == null ? void 0 : L.sex)) return { error: Ps, info: "Gender mismatch" };
  let A = (B = S == null ? void 0 : S.processCodes) == null ? void 0 : B.substitution;
  $d({ tournamentId: n.tournamentId, eventId: c.eventId, inContextDualMatchUp: u, drawDefinition: o, dualMatchUp: f });
  let y = (G = f == null ? void 0 : f.sides) == null ? void 0 : G.find(({ sideNumber: K }) => K === I.sideNumber);
  if (!y) return W({ result: { sideNumber: I.sideNumber, existingParticipantId: i, error: Tr }, stack: r });
  if ((Y = (q = d == null ? void 0 : d.sides) == null ? void 0 : q.flatMap((K) => {
    var J, $;
    return ((J = K.participant) == null ? void 0 : J.individualParticipantIds) || (($ = K.participant) == null ? void 0 : $.participantId) || [];
  })) != null && Y.includes(a)) return W({ result: { error: kf }, stack: r });
  let D = (X = (H = u == null ? void 0 : u.sides) == null ? void 0 : H.find(({ sideNumber: K }) => K === I.sideNumber)) == null ? void 0 : X.participantId, P = y.lineUp, w = P == null ? void 0 : P.find(({ participantId: K }) => a === K), R = P == null ? void 0 : P.reduce((K, J) => J.substitutionOrder > K ? J.substitutionOrder : K, 0), b = (P == null ? void 0 : P.map((K) => {
    var $;
    let J = ge(K, !1, !0);
    if (![i, a].includes(J.participantId)) return J;
    if (!s && [i, a].includes(J.participantId) && (J.collectionAssignments = ($ = J.collectionAssignments) == null ? void 0 : $.filter((ae) => !(ae.collectionPosition === l && ae.collectionId === p))), s && i === J.participantId && (J.collectionAssignments = J.collectionAssignments.map((ae) => ae.collectionPosition === l && ae.collectionId === p && ae.substitutionOrder === void 0 ? { ...ae, substitutionOrder: R } : ae)), J.participantId === a) {
      J.collectionAssignments || (J.collectionAssignments = []);
      let ae = { collectionId: p, collectionPosition: l };
      s && (ae.previousParticipantId = i, ae.substitutionOrder = (R ?? 0) + 1), J.collectionAssignments.push(ae);
    }
    return J;
  })) ?? [];
  if (!w) {
    let K = { collectionId: p, collectionPosition: l };
    s && (K.substitutionOrder = (R ?? 0) + 1, K.previousParticipantId = i);
    let J = { collectionAssignments: [K], participantId: a };
    b.push(J);
  }
  let E = g === ft, { assignedParticipantIds: O } = hp({ lineUp: P, collectionPosition: l, collectionId: p }), { assignedParticipantIds: M } = hp({ lineUp: b, collectionPosition: l, collectionId: p });
  if (y.lineUp = b, D && h) {
    let K = Hs({ participantId: D, lineUp: b, drawDefinition: o, tieFormat: h });
    if (K.error) return W({ result: K, stack: r });
  } else console.log("team participantId not found");
  let N, C;
  if (E) {
    let { tournamentRecord: K } = e, J = vn({ participantIds: M, tournamentRecord: K });
    if (!J.participant) {
      let ae = Yn({ returnParticipant: !0, pairOverride: !0, tournamentRecord: K, participant: { participantRole: Cr, individualParticipantIds: M, participantType: _e } });
      if (ae.error) return W({ result: ae, stack: r });
      N = (z = ae.participant) == null ? void 0 : z.participantId;
    }
    J = vn({ participantIds: O, tournamentRecord: K });
    let $ = (Z = J.participant) == null ? void 0 : Z.participantId;
    $ && Ws({ participantIds: [$], tournamentRecord: K }).success && (C = $);
  }
  if (s || ((te = I.substitutions) == null ? void 0 : te.length) === 1) {
    if (s) A && m && (m.processCodes = Be([...(m == null ? void 0 : m.processCodes) ?? [], ...A]));
    else for (let K of A || []) {
      let J = (ne = m == null ? void 0 : m.processCodes) == null ? void 0 : ne.lastIndexOf(K);
      J !== void 0 && ((ee = m == null ? void 0 : m.processCodes) == null || ee.splice(J, 1));
    }
    m && Qe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: m, context: r, drawDefinition: o });
  }
  return f && Qe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: f, context: r, drawDefinition: o }), { ...j, modifiedLineUp: b, participantRemoved: C, participantAdded: N };
}
function l1({ collectionPosition: e, teamParticipantId: t, dualMatchUpSide: r, drawDefinition: i, participantIds: n, collectionId: a }) {
  var u;
  if (!a || !e || !Array.isArray(n)) return { modifiedLineUp: (r == null ? void 0 : r.lineUp) || [], error: ie };
  let o = (r == null ? void 0 : r.lineUp) || ((u = Mo({ participantId: t, drawDefinition: i })) == null ? void 0 : u.lineUp), s = [], c = [];
  return { modifiedLineUp: (o == null ? void 0 : o.map((d) => {
    var p;
    if (!n.includes(d.participantId)) return d;
    let l = (p = d.collectionAssignments) == null ? void 0 : p.filter((f) => {
      let m = f.collectionId === a && f.collectionPosition === e;
      return m && (f.previousParticipantId && s.push(f.previousParticipantId), c.push({ participantId: d.participantId, ...f })), !m;
    });
    return { participantId: d.participantId, collectionAssignments: l };
  }).filter(Boolean)) || [], assignmentsRemoved: c, previousParticipantIds: s };
}
function D_({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  var a, o;
  let i = (r.events || []).filter((s) => {
    var c;
    return (s == null ? void 0 : s.eventType) === or && ((c = s == null ? void 0 : s.entries) == null ? void 0 : c.some((u) => u.participantId === t));
  }), n = (s) => !e.includes(s.participantId);
  for (let s of i) {
    s.entries = (s.entries || []).filter(n);
    let { flightProfile: c } = Ht({ event: s });
    (a = c == null ? void 0 : c.flights) == null || a.forEach((u) => {
      u.drawEntries = (u.drawEntries || []).filter(n);
    }), (o = s == null ? void 0 : s.drawDefinitions) == null || o.forEach((u) => {
      u.entries = (u.entries || []).filter(n);
    });
  }
  return { ...j };
}
function Ih({ individualParticipantIds: e, groupingParticipantId: t, removeFromOtherTeams: r, tournamentRecord: i }) {
  let n = "addIndividualParticipantIds";
  if (!i) return W({ result: { error: de }, stack: n });
  if (!t || !e) return W({ result: { error: we }, stack: n });
  let a = i.participants ?? [], o = a.find((l) => l.participantId === t);
  if (!o) return W({ result: { error: Yt }, stack: n });
  if (o != null && o.participantType && ![lt, Gi].includes(o.participantType)) return W({ context: { participantType: o.participantType }, result: { error: Nn }, stack: n });
  let s = e.filter((l) => {
    var p;
    return ((p = a.find((f) => f.participantId === l)) == null ? void 0 : p.participantType) !== Xe;
  });
  if (s.length) return W({ result: { error: Pi, invalidParticipantIds: s }, stack: n });
  o.individualParticipantIds || (o.individualParticipantIds = []);
  let c = o.individualParticipantIds, u = e.filter((l) => !c.includes(l));
  u.length && (r && Dm({ individualParticipantIds: u, tournamentRecord: i }), o.individualParticipantIds = o.individualParticipantIds.concat(...u));
  let { topics: d } = Ji();
  if (d.includes(Lr)) {
    let l = a.find(({ participantId: p }) => p === t);
    Le({ topic: Lr, payload: { participants: [l] } });
  }
  return D_({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: i }), { groupingParticipant: ge(o, !1, !0), added: u.length, ...j };
}
function vh(e) {
  let { updateParticipantName: t = !0, groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n, pairOverride: a, participant: o } = e;
  if (!n) return { error: de };
  if (!o) return { error: ws };
  if (!o.participantId) return Yn({ tournamentRecord: n, participant: o });
  let { participant: s } = co({ participantId: o.participantId, tournamentRecord: n });
  if (!s) return Yn({ tournamentRecord: n, participant: o });
  let { participantRoleResponsibilties: c, individualParticipantIds: u, participantOtherName: d, participantName: l, participantRole: p, participantType: f, onlineResources: m, contacts: h, person: g } = o;
  if (f && s.participantType !== f) return { error: hw };
  let I = {};
  if (h && (I.contacts = h), m && (I.onlineResources = m), d && Et(d) && (I.participantOtherName = d), l && Et(l) && (I.participantName = l), Array.isArray(u)) {
    let { participants: U } = Lt({ participantFilters: { participantTypes: [Xe] }, tournamentRecord: n }), v = U == null ? void 0 : U.map(Ke);
    if (v) {
      let S = u.filter((T) => Et(T) && v.includes(T));
      ([Gi, yt].includes(f || s.participantType) || f === _e && (S.length === 2 || a)) && (I.individualParticipantIds = S), s.participantType === Du.PAIR && t && (I.participantName = P_({ individualParticipants: U, newValues: I }));
    }
  }
  return Object.keys(iU).includes(p) && (I.participantRole = p), Object.keys(Du).includes(f) && (I.participantType = f), Array.isArray(c) && (I.participantRoleResponsibilties = c), s.participantType === Du.INDIVIDUAL && g && w_({ updateParticipantName: t, existingParticipant: s, newValues: I, person: g }), Object.assign(s, ye(I)), r && Ih({ individualParticipantIds: [s.participantId], groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n }), Le({ topic: Lr, payload: { tournamentId: n.tournamentId, participants: [s] } }), { participant: ge(s), ...j };
}
function P_({ individualParticipants: e, newValues: t }) {
  let r = t.individualParticipantIds, i = e.filter(({ participantId: n }) => r.includes(n)).map(({ person: n }) => n == null ? void 0 : n.standardFamilyName).filter(Boolean).sort().join("/");
  return r.length === 1 && (i += "/Unknown"), i;
}
function w_({ updateParticipantName: e, existingParticipant: t, newValues: r, person: i }) {
  let n = {}, { standardFamilyName: a, standardGivenName: o, nationalityCode: s, personId: c, birthdate: u, tennisId: d, sex: l } = i;
  l && Object.keys(HI).includes(l) && (n.sex = l);
  let p;
  if (Et(c) && (n.personId = c), s && Et(s) && (R_(s) || s === "") && (n.nationalityCode = s), a && typeof Et(a) && a.length > 1 && (n.standardFamilyName = a, p = !0), o && typeof Et(o) && o.length > 1 && (n.standardGivenName = o, p = !0), p && e) {
    let f = `${n.standardGivenName} ${n.standardFamilyName}`;
    r.participantName = f;
  }
  u && mi(u) && (n.birthdate = u), d && Et(d) && (n.tennisId = d), Object.assign(t.person, n);
}
function R_(e) {
  return is.flatMap(({ iso: t, ioc: r }) => [t, r]).filter(Boolean).includes(e);
}
function Mp(e) {
  var V, k, L, B, G, q, Y, H, X, z, Z, te, ne, ee, K, J, $, ae, oe, ce;
  let t = ZS(e);
  if (t.error) return t;
  let r = "assignTieMatchUpParticipantId", i = e.teamParticipantId, { tournamentRecord: n, drawDefinition: a, participantId: o, event: s } = e;
  if (!o) return W({ result: { error: cr }, stack: r });
  if (e.sideNumber && ![1, 2].includes(e.sideNumber)) return W({ result: { error: RI }, stack: r });
  let { inContextDualMatchUp: c, inContextTieMatchUp: u, relevantAssignments: d, collectionPosition: l, teamParticipants: p, collectionId: f, matchUpType: m, dualMatchUp: h, tieFormat: g } = t;
  if ((k = (V = u == null ? void 0 : u.sides) == null ? void 0 : V.flatMap((se) => {
    var Te, xe;
    return ((Te = se.participant) == null ? void 0 : Te.individualParticipantIds) || ((xe = se.participant) == null ? void 0 : xe.participantId) || [];
  })) != null && k.includes(o)) return W({ result: { ...j }, stack: r });
  i = i ?? (e.sideNumber ? (B = (L = c == null ? void 0 : c.sides) == null ? void 0 : L.find((se) => se.sideNumber === e.sideNumber)) == null ? void 0 : B.participantId : void 0);
  let I = (q = (G = Lt({ participantFilters: { participantIds: [o] }, tournamentRecord: n })) == null ? void 0 : G.participants) == null ? void 0 : q[0];
  if (!I) return W({ result: { error: Yt }, stack: r });
  let { appliedPolicies: U } = nt({ tournamentRecord: n, drawDefinition: a, event: s }), v = ((Y = e.policyDefinitions) == null ? void 0 : Y[Ar]) ?? (U == null ? void 0 : U[Ar]) ?? eu[Ar];
  if ((e.enforceGender ?? ((H = v == null ? void 0 : v.participants) == null ? void 0 : H.enforceGender)) !== !1 && [pt, St].includes(u == null ? void 0 : u.gender) && (u == null ? void 0 : u.gender) !== ((X = I.person) == null ? void 0 : X.sex)) return { error: Ps, info: "Gender mismatch" };
  let { individualParticipantIds: S, participantType: T } = I;
  if (Kt(mt)(m) && T !== Xe) return { error: Nn };
  let A = T === Xe ? [o] : S, y = i && (p == null ? void 0 : p.find(({ participantId: se }) => se === i)) || (p == null ? void 0 : p.find(({ individualParticipantIds: se }) => Jr(A, se)));
  if (!y) return { error: LI };
  if (i || (i = y.participantId), !i) return { error: Yt };
  let D = (z = d == null ? void 0 : d.find((se) => se.participantId === (y == null ? void 0 : y.participantId))) == null ? void 0 : z.drawPosition, P = (te = (Z = h == null ? void 0 : h.sides) == null ? void 0 : Z.find((se) => se.participantId === i)) == null ? void 0 : te.sideNumber, w = (ee = (ne = u == null ? void 0 : u.sides) == null ? void 0 : ne.find((se) => D && se.drawPosition === D)) == null ? void 0 : ee.sideNumber, R = P ?? w ?? e.sideNumber;
  if (!g) return { error: Gc };
  if (!((K = g.collectionDefinitions) != null && K.find((se) => se.collectionId === f))) return { error: ow };
  $d({ tournamentId: n.tournamentId, eventId: s.eventId, inContextDualMatchUp: c, drawDefinition: a, dualMatchUp: h });
  let b = (J = h == null ? void 0 : h.sides) == null ? void 0 : J.find((se) => se.sideNumber === R), E = ($ = u == null ? void 0 : u.sides) == null ? void 0 : $.find((se) => se.sideNumber === R), O = (ce = (oe = (b == null ? void 0 : b.lineUp) ?? ((ae = Mo({ participantId: i, drawDefinition: a })) == null ? void 0 : ae.lineUp)) == null ? void 0 : oe.filter((se) => {
    var Te;
    return (Te = se.collectionAssignments) == null ? void 0 : Te.find((xe) => xe.collectionPosition === l && xe.collectionId === f && !xe.previousParticipantId);
  })) == null ? void 0 : ce.map((se) => se == null ? void 0 : se.participantId), M = (O == null ? void 0 : O.length) > 1 && O || (T === _e ? I.individualParticipantIds : [o]), N = l1({ collectionPosition: l, teamParticipantId: i, dualMatchUpSide: b, drawDefinition: a, participantIds: M, collectionId: f });
  if (N.error) return W({ result: N, stack: r });
  let { modifiedLineUp: C } = N, F;
  if (m === ft) {
    if (T !== _e) {
      let se = eg({ collectionPosition: l, teamParticipantId: i, drawDefinition: a, modifiedLineUp: C, participantId: o, collectionId: f, tieFormat: g });
      if (se != null && se.error) return W({ result: se, stack: r });
      if (se = x({ side: E }), se.error) return se;
      F = se.deletedParticipantId, b && (b.lineUp = C), h && Qe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: h, context: r, drawDefinition: a });
    } else if (T === _e) for (let se of M) eg({ collectionPosition: l, teamParticipantId: i, drawDefinition: a, modifiedLineUp: C, participantId: se, collectionId: f, tieFormat: g });
  } else {
    let se = eg({ collectionPosition: l, teamParticipantId: i, drawDefinition: a, modifiedLineUp: C, participantId: o, collectionId: f, tieFormat: g });
    if (se != null && se.error) return se;
  }
  if (b && (b.lineUp = C), h && Qe({ tournamentId: n == null ? void 0 : n.tournamentId, matchUp: h, context: r, drawDefinition: a }), F) {
    let { error: se } = Ws({ participantIds: [F], tournamentRecord: n });
    se && console.log("cleanup");
  }
  return { ...j, modifiedLineUp: C };
  function x({ side: se }) {
    let Te;
    if (se.participant) {
      let xe = se.participant.individualParticipantIds || [];
      if (xe.filter(Boolean).length === 1) {
        let { participant: me } = vn({ participantIds: xe, tournamentRecord: n });
        xe.push(o);
        let { participant: rt } = vn({ participantIds: xe, tournamentRecord: n });
        if (!rt && me) {
          me.individualParticipantIds = xe;
          let Ge = vh({ pairOverride: !0, tournamentRecord: n, participant: me });
          if (Ge.error) return Ge;
        } else Te = me == null ? void 0 : me.participantId;
      }
    } else {
      let xe = Yn({ participant: { individualParticipantIds: [o], participantRole: Cr, participantType: _e }, pairOverride: !0, tournamentRecord: n });
      if (xe.error) return xe;
    }
    return { ...j, deletedParticipantId: Te };
  }
}
function eg({ collectionPosition: e, teamParticipantId: t, drawDefinition: r, modifiedLineUp: i, participantId: n, collectionId: a, tieFormat: o }) {
  var d, l;
  let s = (d = Mo({ participantId: t, drawDefinition: r })) == null ? void 0 : d.lineUp, c = (l = i || s) == null ? void 0 : l.find((p) => (p == null ? void 0 : p.participantId) === n), u = { collectionId: a, collectionPosition: e };
  if (c) c.collectionAssignments.push(u);
  else {
    let p = { collectionAssignments: [u], participantId: n };
    i.push(p);
  }
  return Hs({ participantId: t, lineUp: i, drawDefinition: r, tieFormat: o });
}
function p1(e) {
  var R, b, E, O, M, N, C, F, x, V, k, L, B, G, q, Y, H, X, z, Z, te, ne, ee;
  let { tournamentRecord: t, drawDefinition: r, participantId: i, event: n } = e, a = "removeTieMatchUpParticiapantId";
  if (!i) return W({ result: { error: cr }, stack: a });
  let o = ZS(e);
  if (o.error) return o;
  let { appliedPolicies: s } = nt({ tournamentRecord: t, drawDefinition: r, event: n }), c = (E = (b = ((R = e.policyDefinitions) == null ? void 0 : R[Ar]) ?? (s == null ? void 0 : s[Ar]) ?? eu[Ar]) == null ? void 0 : b.processCodes) == null ? void 0 : E.substitution, { inContextDualMatchUp: u, inContextTieMatchUp: d, relevantAssignments: l, collectionPosition: p, teamParticipants: f, collectionId: m, matchUpType: h, dualMatchUp: g, tieMatchUp: I, tieFormat: U } = o;
  if (!g) return W({ result: { error: hi }, stack: a });
  let v = (O = d == null ? void 0 : d.sides) == null ? void 0 : O.find((K) => {
    var J, $, ae;
    return ((J = K.participant) == null ? void 0 : J.participantId) === i || ((ae = ($ = K.participant) == null ? void 0 : $.individualParticipantIds) == null ? void 0 : ae.includes(i));
  });
  if (!v) return W({ result: { error: Yt }, stack: a });
  let S = ((M = e.policyDefinitions) == null ? void 0 : M[En]) ?? (s == null ? void 0 : s[En]);
  if (!((N = v.substitutions) != null && N.length) && (pr({ score: d == null ? void 0 : d.score }) || d != null && d.winningSide) && (S == null ? void 0 : S.requireParticipantsForScoring) !== !1) return W({ result: { error: Ww }, stack: a });
  let T = (F = (C = u == null ? void 0 : u.sides) == null ? void 0 : C.find(({ sideNumber: K }) => K === v.sideNumber)) == null ? void 0 : F.participantId;
  if (!T) return W({ result: { error: Yt }, stack: a });
  let A = (V = (x = Lt({ participantFilters: { participantIds: [i] }, tournamentRecord: t })) == null ? void 0 : x.participants) == null ? void 0 : V[0];
  if (!A) return W({ result: { error: Yt }, stack: a });
  if (h === mt && A.participantType === _e) return W({ result: { error: Ps }, stack: a });
  let y = A.participantType === Xe ? [i] : A.individualParticipantIds;
  $d({ tournamentId: t.tournamentId, eventId: n.eventId, inContextDualMatchUp: u, drawDefinition: r, dualMatchUp: g });
  let D = (k = g.sides) == null ? void 0 : k.find(({ sideNumber: K }) => K === v.sideNumber);
  if (!D && (((L = g.sides) == null ? void 0 : L.filter(({ lineUp: K }) => !K).length) || 0) < 2) {
    let K = f == null ? void 0 : f.map(({ participantId: J }) => {
      var $;
      return { drawPosition: ($ = l == null ? void 0 : l.find((ae) => ae.participantId === J)) == null ? void 0 : $.drawPosition, teamParticipantId: J };
    });
    D = (B = g.sides) == null ? void 0 : B.find((J) => {
      var $;
      return (($ = K == null ? void 0 : K.find(({ drawPosition: ae }) => ae === J.drawPosition)) == null ? void 0 : $.teamParticipantId) === T;
    });
  }
  if (!D) return W({ result: { error: Yt, context: { participantId: i } } });
  let { modifiedLineUp: P, previousParticipantIds: w } = l1({ collectionPosition: p, teamParticipantId: T, dualMatchUpSide: D, participantIds: y, drawDefinition: r, collectionId: m });
  if (D.lineUp = P, T && U && Hs({ participantId: T, lineUp: P, drawDefinition: r, tieFormat: U }), h === ft && A.participantType === Xe) {
    let K = (G = d == null ? void 0 : d.sides) == null ? void 0 : G.find((ae) => ae.sideNumber === (D == null ? void 0 : D.sideNumber)), { participantId: J } = K ?? {}, $ = J && ((Y = (q = Lt({ participantFilters: { participantIds: [J] }, tournamentRecord: t, withDraws: !0 })) == null ? void 0 : q.participants) == null ? void 0 : Y[0]);
    if ($) {
      let ae = ((H = $ == null ? void 0 : $.individualParticipantIds) == null ? void 0 : H.filter((oe) => oe !== i)) ?? [];
      if (w && ae.push(...w), ae.length > 2) return W({ result: { error: Pi }, stack: a });
      if ((X = $.draws) != null && X.length) {
        if (ae.length === 1) {
          let { participant: oe } = vn({ participantIds: ae, tournamentRecord: t });
          if (!oe) {
            let ce = Yn({ participant: { participantRole: Cr, individualParticipantIds: ae, participantType: _e }, pairOverride: !0, tournamentRecord: t });
            if (ce.error) return W({ result: ce, stack: a });
          }
        }
      } else if (ae.length) {
        $.individualParticipantIds = ae;
        let oe = vh({ participant: $, pairOverride: !0, tournamentRecord: t });
        if (oe.error) return W({ result: oe, stack: a });
      } else {
        let oe = Ws({ participantIds: [J], tournamentRecord: t });
        oe.error && console.log("cleanup", { result: oe });
      }
    } else return W({ result: { error: Yt }, stack: a });
  }
  if (((z = v.substitutions) == null ? void 0 : z.length) === 1 && !((ne = (te = (Z = d == null ? void 0 : d.sides) == null ? void 0 : Z.find((K) => K.sideNumber !== v.sideNumber)) == null ? void 0 : te.substitutions) != null && ne.length) && ((ee = I == null ? void 0 : I.processCodes) != null && ee.length)) {
    for (let K of c || []) {
      let J = I.processCodes.lastIndexOf(K);
      I.processCodes.splice(J, 1);
    }
    Qe({ tournamentId: t == null ? void 0 : t.tournamentId, matchUp: I, context: a, drawDefinition: r });
  }
  return Qe({ tournamentId: t == null ? void 0 : t.tournamentId, matchUp: g, context: a, drawDefinition: r }), { ...j, modifiedLineUp: P };
}
function JS(e) {
  var c, u;
  let t = Ae(e, [{ [fr]: !0, [ii]: !0, [zn]: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, sideNumber: i, matchUpId: n, event: a } = e;
  if (i && ![1, 2].includes(i)) return { error: ie, sideNumber: i };
  let { matchUp: o, structure: s } = bt({ drawDefinition: r, matchUpId: n, event: a });
  return o ? si({ structure: s }) ? ((c = o.sides) == null || c.forEach((d) => {
    (!i || d.sideNumber === i) && delete d.participantId;
  }), Qe({ tournamentId: (u = e.tournamentRecord) == null ? void 0 : u.tournamentId, context: "assignSideParticipant", drawDefinition: r, matchUp: o }), { ...j }) : { error: II } : { error: jr };
}
function b_({ matchUpStatuses: e = [at, ct, Je], drawPositionMatchUps: t, loserDrawPosition: r, sourceMatchUps: i }) {
  var d;
  let n = t == null ? void 0 : t.reduce((l, p) => !l || p.roundNumber > l.roundNumber ? p : l, void 0), a = (d = n == null ? void 0 : n.drawPositions) == null ? void 0 : d.find((l) => l !== r), o = i.filter((l) => {
    var p;
    return (p = l == null ? void 0 : l.drawPositions) == null ? void 0 : p.includes(a);
  }).map((l) => l.matchUpStatus), s = i.filter((l) => {
    var p;
    return (p = l == null ? void 0 : l.drawPositions) == null ? void 0 : p.includes(r);
  }).map((l) => l.matchUpStatus), c = Jr(o || [], e), u = Jr(s || [], e);
  return { sourceMatchUp: n, winnerHadMatchUpStatus: c, winnerMatchUpStatuses: o, loserHadMatchUpStatus: u, loserMatchUpStatuses: s };
}
function N_({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, structureId: o, dualMatchUp: s, roundNumber: c, matchUpsMap: u, event: d }) {
  let { structure: l } = Ne({ drawDefinition: a, structureId: o });
  if ((l == null ? void 0 : l.structureType) === ri) return { ...j };
  u = u ?? xr({ drawDefinition: a });
  let p = ((u == null ? void 0 : u.mappedMatchUps) || {})[o].matchUps, { initialRoundNumber: f } = Ss({ drawPosition: r, matchUps: p }), m = p == null ? void 0 : p.filter((g) => {
    var I;
    return g.roundNumber >= c && g.roundNumber !== f && ((I = g.drawPositions) == null ? void 0 : I.includes(r));
  }), { positionAssignments: h } = gt({ drawDefinition: a, structureId: o });
  for (let g of m ?? []) M_({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, positionAssignments: h, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, dualMatchUp: s, matchUpsMap: u, matchUp: g, event: d });
  return { ...j };
}
function M_({ inContextDrawMatchUps: e, positionAssignments: t, sourceMatchUpStatus: r, targetDrawPosition: i, tournamentRecord: n, sourceMatchUpId: a, drawDefinition: o, dualMatchUp: s, matchUpsMap: c, matchUp: u, event: d }) {
  var f, m, h;
  let l = "removeSubsequentDrawPosition";
  if (s) {
    let g = (m = (f = e.find(({ matchUpId: U }) => u.matchUpId === U).sides) == null ? void 0 : f.find((U) => U.drawPosition === i)) == null ? void 0 : m.sideNumber, I = (h = u.sides) == null ? void 0 : h.find((U) => U.sideNumber === g);
    I && delete I.lineUp;
  }
  u.drawPositions = (u.drawPositions || []).map((g) => g === i ? void 0 : g).filter(Boolean);
  let p = t.filter(({ drawPosition: g }) => {
    var I;
    return (I = u.drawPositions) == null ? void 0 : I.includes(g);
  }).filter((g) => g.bye).length;
  return u.matchUpStatus = p && at || [Je, ct].includes(u.matchUpStatus) && u.matchUpStatus || Xt, [ct, Je].includes(u.matchUpStatus) && (u.winningSide = void 0), u.matchUpStatusCodes && LN({ inContextDrawMatchUps: e, sourceMatchUpStatus: r, sourceMatchUpId: a, matchUpsMap: c, matchUp: u }), Qe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: d == null ? void 0 : d.eventId, context: `${l}-${i}`, drawDefinition: o, matchUp: u }), { ...j };
}
function lu(e) {
  let { dualWinningSideChange: t, inContextDrawMatchUps: r, tournamentRecord: i, drawDefinition: n, matchUpStatus: a, matchUpsMap: o, dualMatchUp: s, targetData: c, matchUpId: u, structure: d, event: l } = e, p = !!e.matchUp.collectionId, f = si({ structure: d }), { drawPositions: m, winningSide: h } = c.matchUp || {};
  if (!f && !m) return { error: ad };
  let { targetLinks: { loserTargetLink: g, winnerTargetLink: I, byeTargetLink: U }, targetMatchUps: { loserMatchUp: v, winnerMatchUp: S, byeMatchUp: T } } = c, A = Vn({ ...e, matchUpStatus: a || Xt, removeWinningSide: !0 });
  if (A.error) return A;
  let y;
  if (p) {
    let { matchUpTieId: C, matchUpsMap: F } = e;
    if (y = La({ appliedPolicies: e.appliedPolicies, matchUpId: C, tournamentRecord: i, drawDefinition: n, matchUpsMap: F, event: l }), !t && !y.removeWinningSide) return { ...j };
  }
  if (f) return { ...j };
  let { matchUps: D } = ut({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: n, matchUpsMap: o, structure: d }), { positionAssignments: P } = Ir({ structure: d }), w = h - 1, R = 1 - w, b = m[w], E = m[R], { winnerParticipantId: O, loserParticipantId: M } = (P == null ? void 0 : P.reduce((C, F) => (F.drawPosition === E && (C.loserParticipantId = F.participantId), F.drawPosition === b && (C.winnerParticipantId = F.participantId), C), { winnerParticipantId: void 0, loserParticipantId: void 0 })) || {}, N = D.filter((C) => {
    var F;
    return (F = C.drawPositions) == null ? void 0 : F.includes(E);
  });
  if (S && f1({ sourceMatchUpStatus: a, sourceMatchUpId: u, inContextDrawMatchUps: r, winningDrawPosition: b, winnerParticipantId: O, tournamentRecord: i, winnerTargetLink: I, drawDefinition: n, winnerMatchUp: S, dualMatchUp: s, matchUpsMap: o }), v) {
    let { winnerHadMatchUpStatus: C } = b_({ drawPositionMatchUps: N, loserDrawPosition: E, sourceMatchUps: D }), F = g.linkCondition === _n;
    if (C && F) {
      let V = Math.min(...v.drawPositions);
      nI({ targetLink: g, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: V, matchUpsMap: o, event: l });
    }
    let x = E_({ sourceMatchUpStatus: a, sourceMatchUpId: u, loserParticipantId: M, tournamentRecord: i, loserTargetLink: g, drawDefinition: n, loserMatchUp: v, dualMatchUp: s, matchUpsMap: o, event: l });
    if (x.error) return x;
  }
  if (T) {
    let C = Math.min(...T.drawPositions);
    nI({ sourceMatchUpId: u, targetLink: U, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: C, matchUpsMap: o, event: l });
  }
  return { ...j, ...y && { tieMatchUpResult: y } };
}
function f1({ inContextDrawMatchUps: e, winningDrawPosition: t, sourceMatchUpStatus: r, winnerParticipantId: i, tournamentRecord: n, winnerTargetLink: a, sourceMatchUpId: o, drawDefinition: s, winnerMatchUp: c, matchUpsMap: u, dualMatchUp: d, event: l }) {
  var h, g;
  let { structureId: p, roundNumber: f } = c, m = "removeDirectedWinner";
  if (a) {
    let I = a.target.structureId, { structure: U } = Ne({ drawDefinition: s, structureId: I });
    if (!U) return { error: kt };
    let { positionAssignments: v } = Ir({ structure: U });
    U.seedAssignments = (U.seedAssignments ?? []).filter((P) => P.participantId !== i);
    let S = (h = v == null ? void 0 : v.find((P) => P.participantId === i)) == null ? void 0 : h.drawPosition, { matchUps: T } = ut({ drawDefinition: s, structure: U, event: l }), A = T.map((P) => P.drawPositions).flat(1 / 0).filter(Boolean), y = wi(A);
    if ((S ? y[S] : void 0) === 1) v == null || v.forEach((P) => {
      P.participantId === i && delete P.participantId;
    });
    else {
      let P = T.filter(({ drawPositions: w }) => w.includes(S));
      console.log("not removing from position assignments since instances > 1", { drawPositionMatchUps: P, winnerTargetLink: a });
    }
    let D = (g = u == null ? void 0 : u.drawMatchUps) == null ? void 0 : g.find(({ matchUpId: P }) => P === c.matchUpId);
    D && Qe({ tournamentId: n == null ? void 0 : n.tournamentId, eventId: l == null ? void 0 : l.eventId, matchUp: D, context: m, drawDefinition: s });
  }
  return f && N_({ targetDrawPosition: t, inContextDrawMatchUps: e, sourceMatchUpStatus: r, tournamentRecord: n, sourceMatchUpId: o, drawDefinition: s, dualMatchUp: d, matchUpsMap: u, roundNumber: f, structureId: p }), { ...j };
}
function E_({ sourceMatchUpStatus: e, loserParticipantId: t, tournamentRecord: r, loserTargetLink: i, sourceMatchUpId: n, drawDefinition: a, loserMatchUp: o, matchUpsMap: s, dualMatchUp: c, event: u }) {
  var h, g, I;
  let d = "removeDirectedLoser", l = i.target.structureId, { structure: p } = Ne({ drawDefinition: a, structureId: l });
  if (!p) return { error: kt };
  let { positionAssignments: f } = Ir({ structure: p }), m = (h = f == null ? void 0 : f.find((U) => U.participantId === t)) == null ? void 0 : h.drawPosition;
  if (f == null || f.forEach((U) => {
    U.participantId === t && delete U.participantId;
  }), p.seedAssignments = (p.seedAssignments ?? []).filter((U) => U.participantId !== t), c) {
    let U = o == null ? void 0 : o.sides.reduce((T, A, y) => A.drawPosition === m ? y : T, void 0), v = (g = s == null ? void 0 : s.drawMatchUps) == null ? void 0 : g.find(({ matchUpId: T }) => T === o.matchUpId), S = (I = v == null ? void 0 : v.sides) == null ? void 0 : I[U];
    S && (delete S.lineUp, Qe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: u == null ? void 0 : u.eventId, matchUp: v, context: d, drawDefinition: a }));
  }
  return { ...j };
}
function nI({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, targetLink: a, event: o }) {
  let s = a.target.structureId, c = "removeDirectedBye";
  Oi({ color: "brightyellow", method: c, drawPosition: i });
  let u = Vd({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: s, event: o });
  return W({ result: u, stack: c });
}
function O_(e) {
  var c, u;
  let { matchUpFormat: t, score: r } = e, i = (c = r == null ? void 0 : r.sets) == null ? void 0 : c.length, n = t && ti(t), { setFormat: a, finalSetFormat: o, bestOf: s } = n ?? {};
  return ((u = s && i === s && o || a) == null ? void 0 : u.timed) || !1;
}
function C_({ tournamentRecord: e, drawDefinition: t, structure: r, matchUp: i }) {
  var s;
  let n = "attemptToSetMatchUpStatusBYE";
  if (i != null && i.winningSide) return W({ result: { error: Vc }, context: { matchUpStatus: at }, stack: n });
  let { positionAssignments: a } = Ir({ structure: r }), o = a == null ? void 0 : a.filter((c) => c.bye).map((c) => c.drawPosition);
  return (s = i.drawPositions) != null && s.some((c) => o == null ? void 0 : o.includes(c)) ? (i.matchUpStatus = at, i.matchUpStatusCodes = [], Qe({ tournamentId: e == null ? void 0 : e.tournamentId, context: n, drawDefinition: t, matchUp: i }), { ...j }) : W({ result: { error: aw }, info: "matchUp does not include BYE", stack: n });
}
function Nu(e) {
  var g, I;
  let { tournamentRecord: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, structure: o, event: s } = e, c = "doubleExitAdvancement";
  if (o.structureType === ri) return W({ result: { ...j }, stack: c });
  let { matchUp: u, targetMatchUps: d, targetLinks: l } = a, { loserMatchUp: p, winnerMatchUp: f, loserTargetDrawPosition: m } = d, h = [ct, Je].includes(p == null ? void 0 : p.matchUpStatus) && !((g = p.sides) != null && g.map((U) => U.participantId ?? U.participant).filter(Boolean).length);
  if (p && p.matchUpStatus !== at) {
    let { loserTargetLink: U } = l;
    if ((I = r == null ? void 0 : r.progression) != null && I.doubleExitPropagateBye) {
      let v = m1({ loserTargetDrawPosition: m, tournamentRecord: t, loserTargetLink: U, drawDefinition: i, loserMatchUp: p, matchUpsMap: n, event: s });
      if (v.error) return W({ result: v, stack: c });
    } else if (!h) {
      let { feedRound: v, drawPositions: S, matchUpId: T } = p, A = v ? 2 : 2 - S.indexOf(m), y = KT({ ...e, targetMatchUp: p, walkoverWinningSide: A, tournamentRecord: t, sourceMatchUp: u, matchUpId: T });
      if (y.error) return W({ result: y, stack: c });
    }
  }
  if (f) {
    let U = KT({ ...e, matchUpId: f.matchUpId, targetMatchUp: f, tournamentRecord: t, sourceMatchUp: u });
    if (U.error) return W({ result: U, stack: c });
  }
  return W({ result: { ...j }, stack: c });
}
function KT(e) {
  var q, Y, H;
  let { inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o } = e, s = i.structures.find(({ structureId: X }) => X === a.structureId), c = e.matchUpStatus === sr ? sr : $t, u = e.matchUpStatus === sr ? Je : ct, d = "conditionallyAdvanceDrawPosition", l = o.drawMatchUps.find((X) => X.matchUpId === a.matchUpId);
  if (!l) return { error: hi };
  let p = (n == null ? void 0 : n.drawPositions) || [], f = (q = l.drawPositions) == null ? void 0 : q.filter(Boolean), m = (n == null ? void 0 : n.structureId) === a.structureId;
  if (m && Jr(p, f) && (f = f.filter((X) => !p.includes(X))), m && f.length > 1) return W({ result: { error: fc }, stack: d });
  let { pairedPreviousMatchUpIsDoubleExit: h, pairedPreviousMatchUp: g } = FN(e), I = ei({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: U, targetLinks: v } = I, { loserTargetDrawPosition: S, winnerMatchUp: T, loserMatchUp: A } = U;
  if (A) {
    let { loserTargetLink: X } = v, z = m1({ loserTargetDrawPosition: S, loserMatchUp: A, tournamentRecord: r, loserTargetLink: X, drawDefinition: i, matchUpsMap: o });
    if (z.error) return W({ result: z, stack: d });
  }
  let y = ((Y = l.drawPositions) == null ? void 0 : Y.filter(Boolean)) || [], D = y.length === 1, P = e.walkoverWinningSide || D && Hl({ drawPosition: y[0], matchUpId: a.matchUpId, inContextDrawMatchUps: t }) || void 0, w = [ct, Je].includes(l.matchUpStatus) && !y.length, R = l.finishingRound === 1, b = w && !R ? c : u, E = t.find((X) => X.matchUpId === g.matchUpId), O = [], M;
  n && ((n == null ? void 0 : n.structureId) === (E == null ? void 0 : E.structureId) ? n.roundPosition < (g == null ? void 0 : g.roundPosition) ? M = 1 : M = 2 : a.feedRound ? n.structureId === a.structureId ? M = 2 : M = 1 : P && (M = 3 - P));
  let N = e.matchUpStatus, C = g == null ? void 0 : g.matchUpStatus;
  M === 1 ? O = [{ matchUpStatus: Ml(N), previousMatchUpStatus: N, sideNumber: 1 }, { matchUpStatus: Ml(C), previousMatchUpStatus: C, sideNumber: 2 }] : M === 2 && (O = [{ matchUpStatus: Ml(C), previousMatchUpStatus: C, sideNumber: 1 }, { matchUpStatus: Ml(N), previousMatchUpStatus: N, sideNumber: 2 }]), O.length && (O = O.map((X) => ye(X)));
  let F = Vn({ ...e, winningSide: P, matchUp: l, matchUpStatusCodes: O, context: d, matchUpStatus: b });
  if (F.error) return W({ result: F, stack: d });
  if (w) return Nu({ ...e, matchUpStatus: b, targetData: I });
  if (!T) return W({ result: { ...j }, stack: d });
  let x = f.length === 2 ? f[P - 1] : f[0], { positionAssignments: V } = gt({ structure: s }), k = V == null ? void 0 : V.find((X) => X.drawPosition === x), L = o.drawMatchUps.find((X) => X.matchUpId === T.matchUpId), B = (H = L == null ? void 0 : L.drawPositions) == null ? void 0 : H.filter(Boolean), G = B.length === 1;
  if (x) {
    if (k != null && k.bye) {
      let X = ei({ matchUpId: L.matchUpId, inContextDrawMatchUps: t, drawDefinition: i });
      if (G) {
        let z = B.filter(Boolean)[0], Z = Hl({ drawPosition: z, matchUpId: L.matchUpId, inContextDrawMatchUps: t }), te = Vn({ appliedPolicies: e.appliedPolicies, matchUpId: L.matchUpId, matchUp: L, matchUpStatus: u, matchUpStatusCodes: [], removeScore: !0, context: d, drawDefinition: i, winningSide: Z });
        return te.error ? W({ result: te, stack: d }) : Jv({ drawPositionToAdvance: z, matchUpId: L.matchUpId, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
      } else if ([ct, Je].includes(T.matchUpStatus)) {
        let z = Nu({ ...e, matchUpId: L.matchUpId, matchUpStatus: b, targetData: X });
        if (z.error) return W({ result: z, stack: d });
      }
      return W({ result: { ...j }, stack: d });
    }
    return Nc({ matchUpId: T.matchUpId, drawPosition: x, inContextDrawMatchUps: t, drawDefinition: i });
  } else if (h) {
    if (!L) return { error: hi };
    if (G) {
      let Z = B[0], te = Hl({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawPosition: Z });
      console.log("existing drawPosition is winningSide", { walkoverWinningSide: te });
    }
    let X = [ct, Je].includes(L.matchUpStatus) ? u : c, z = Vn({ matchUpId: L.matchUpId, appliedPolicies: e.appliedPolicies, matchUp: L, matchUpStatusCodes: [], removeScore: !0, context: d, drawDefinition: i, matchUpStatus: X });
    if (z.error) return W({ result: z, stack: d });
    if (X === c) {
      let Z = Nu({ ...e, matchUpId: a.matchUpId, matchUpStatus: X, targetData: I });
      if (Z.error) return Z;
    }
  }
  return W({ result: { ...j }, stack: d });
}
function m1(e) {
  var u;
  let { loserTargetDrawPosition: t, tournamentRecord: r, loserTargetLink: i, drawDefinition: n, matchUpsMap: a, event: o } = e, s = (u = i == null ? void 0 : i.target) == null ? void 0 : u.structureId, { structure: c } = Ne({ drawDefinition: n, structureId: s });
  return c ? _i({ drawPosition: t, tournamentRecord: r, drawDefinition: n, structureId: s, matchUpsMap: a, event: o }) : { error: Bo };
}
function Ml(e) {
  return e === $t ? ct : e === sr ? Je : e;
}
function F_(e) {
  let { tournamentRecord: t, drawDefinition: r, matchUpStatus: i, structure: n, matchUp: a } = e, o = !!(a.tieMatchUps && !a.rondPosition && e.inContextDrawMatchUps.find((I) => I.matchUpId === a.matchUpId).containerStructureId), s = "attemptToSetMatchUpStatus", c = i === at, u = a.winningSide, d = [$t, sr].includes(i), l = xd({ matchUpStatus: i }), p = kg({ matchUpStatus: i }), f = !l && !p, m = e.matchUpTieId || u && l && !d, h = u && d, g = () => Vn({ ...e, removeScore: [Oa, ct].includes(i), matchUpStatus: i || Xt });
  return f && { error: hg } || m && aI(e) || h && k_(e) || u && lu(e) || p && g() || c && C_({ tournamentRecord: t, drawDefinition: r, structure: n, matchUp: a }) || !l && { error: hg } || d && L_(e) || o && aI(e) || W({ result: { error: Vc }, stack: s });
}
function k_(e) {
  let t = lu(e);
  return t.error ? t : Nu(e);
}
function L_(e) {
  let t = aI({ ...e, removeScore: !0 });
  return t.error ? t : Nu(e);
}
function aI(e) {
  var n;
  let t = "scoreModification";
  if (e.isCollectionMatchUp && ((n = e.dualMatchUp) != null && n.winningSide) && !e.projectedWinningSide) {
    let a = lu(e);
    if (a.error) return W({ result: a, stack: t });
  }
  let r = !!e.matchUp.collectionId, i = Vn({ ...e, context: t });
  if (r) {
    let { matchUpTieId: a, drawDefinition: o, matchUpsMap: s } = e, c = La({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: a, event: e.event, drawDefinition: o, matchUpsMap: s });
    if (c.error) return W({ result: c, stack: t });
    Object.assign(i, { tieMatchUpResult: c });
  }
  return W({ result: i, stack: t });
}
function x_({ drawDefinition: e, structure: t, matchUp: r }) {
  var c, u, d, l;
  let { drawPositions: i } = r, { positionAssignments: n } = gt({ drawDefinition: e, structure: t }), a = (c = n == null ? void 0 : n.filter(({ drawPosition: p }) => i == null ? void 0 : i.includes(p))) == null ? void 0 : c.map((p) => {
    var m;
    let { extension: f } = We({ element: p, name: Ka });
    return (m = f == null ? void 0 : f.value) == null ? void 0 : m.groupOrder;
  }), { containerStructures: o } = Zc({ drawDefinition: e }), s = o[t.structureId];
  return { structureIds: (l = (d = (u = Qc({ drawDefinition: e, structureId: s })) == null ? void 0 : u.links) == null ? void 0 : d.source) == null ? void 0 : l.filter((p) => {
    var f;
    return Jr(a, ((f = p.source) == null ? void 0 : f.finishingPositions) || []);
  }).map((p) => p.source.structureId) };
}
function h1({ drawDefinition: e, structure: t, matchUp: r }) {
  let i = [];
  if (t.finishingPosition === wo && $a({ drawDefinition: e, structure: t })) {
    let { structureIds: n } = x_({ drawDefinition: e, structure: t, matchUp: r });
    n != null && n.length && i.push(...n);
  }
  return { connectedStructureIds: i };
}
function B_(e) {
  var s, c, u;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = (s = e.targetData.targetLinks) == null ? void 0 : s.winnerTargetLink;
  if (o.target.feedProfile === sn) {
    let d = i.sides.find(({ sideNumber: p }) => p !== a).participantId, l = r.find((p) => p.structureId === o.target.structureId && p.roundNumber === o.target.roundNumber && p.sides.some(({ participantId: f }) => f === d));
    if ((l == null ? void 0 : l.matchUpStatus) === Xt) {
      let p = ei({ matchUpId: l.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Fo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: p })) {
        let { structure: f } = Ne({ structureId: l.structureId, drawDefinition: n }), m = gt({ structure: f }).positionAssignments;
        for (let h of m || []) if (h.participantId === d) {
          let g = i.sides.find(({ sideNumber: I }) => I === a).participantId;
          if (h.participantId = g, f == null ? void 0 : f.positionAssignments) f.positionAssignments = m;
          else if (f != null && f.structures) {
            let I = Object.assign({}, ...(m || []).map((U) => ({ [U.drawPosition]: U.participantId })));
            for (let U of f.structures) (c = U.positionAssignments) == null || c.forEach((v) => v.participantId = I[v.drawPosition]);
          }
          Qa({ tournamentId: (u = e.tournamentRecord) == null ? void 0 : u.tournamentId, event: e.event, drawDefinition: n, structure: f }), t = !0;
        }
      }
    }
  }
  return { ...j, qualifierReplaced: t };
}
function V_(e) {
  var s, c, u, d, l;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = (s = e.targetData.targetLinks) == null ? void 0 : s.winnerTargetLink;
  if (o.target.feedProfile === sn) {
    let p = (c = i.sides.find(({ sideNumber: h }) => h === a)) == null ? void 0 : c.participantId, f = r.filter((h) => h.structureId === o.target.structureId && h.roundNumber === o.target.roundNumber && h.sides.some(({ participantId: g, qualifier: I }) => I && !g)), m = yi(f);
    if ((m == null ? void 0 : m.matchUpStatus) === Xt) {
      let h = ei({ matchUpId: m.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Fo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: h })) {
        let g = (u = m.sides.find((v) => v.qualifier && !v.participantId)) == null ? void 0 : u.drawPosition, { structure: I } = Ne({ structureId: m.structureId, drawDefinition: n });
        if (!I) return { error: kt };
        let U = gt({ structure: I }).positionAssignments;
        for (let v of U || []) if (v.drawPosition === g && !v.participantId) {
          if (v.participantId = p, I.positionAssignments) I.positionAssignments = U;
          else if (I.structures) {
            let S = Object.assign({}, ...(U || []).map((T) => ({ [T.drawPosition]: T.participantId })));
            for (let T of I.structures) (d = T.positionAssignments) == null || d.forEach((A) => A.participantId = S[A.drawPosition]);
          }
          Qa({ tournamentId: (l = e.tournamentRecord) == null ? void 0 : l.tournamentId, event: e.event, drawDefinition: n, structure: I }), t = !0;
        }
      }
    }
  }
  return { ...j, qualifierPlaced: t };
}
function G_(e) {
  var f, m;
  let t = "attemptToSetWinningSide", r, { appliedPolicies: i, disableAutoCalc: n, drawDefinition: a, dualMatchUp: o, winningSide: s, structure: c, matchUp: u } = e;
  if (o != null && o._disableAutoCalc && n !== !1) return EU(e);
  if (u.winningSide && u.winningSide !== s) {
    let { connectedStructureIds: h } = h1({ drawDefinition: a, structure: c, matchUp: u });
    h.length && (console.log({ connectedStructureIds: h }), r = !0);
    let g = lu(e);
    if (g.error) return g;
  }
  let d = NM(e);
  if (d.error) return W({ result: d, stack: t });
  let l, p;
  return e.qualifierChanging && ((f = i == null ? void 0 : i[Wu]) != null && f.autoReplaceQualifiers) && (l = B_(e).qualifierReplaced), e.qualifierAdvancing && ((m = i == null ? void 0 : i[Wu]) != null && m.autoPlaceQualifiers) && (p = V_(e).qualifierPlaced), W({ result: ye({ ...j, ...d, connectedStructures: r, qualifierReplaced: l, qualifierPlaced: p }), stack: t });
}
var Ql = { drawPositionToRemove: "green", iteration: "brightred", winner: "green", loser: "brightred" };
function g1(e) {
  var g, I, U, v;
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, matchUp: o } = e, { matchUpId: s } = o, { iteration: c = 0 } = e;
  c += 1;
  let u = "removeDoubleExit";
  Oi({ color: "brightyellow", method: u, matchUpId: s, iteration: c, keyColors: Ql });
  let { targetMatchUps: { loserMatchUp: d, winnerMatchUp: l, loserTargetDrawPosition: p }, targetLinks: { loserTargetLink: f } } = a;
  if (l && l.matchUpStatus !== at) {
    let { stage: S, roundNumber: T, roundPosition: A, structureName: y } = l;
    Oi({ winner: "winner", roundPosition: A, structureName: y, roundNumber: T, keyColors: Ql, stage: S }), XT({ ...e, targetMatchUp: l, sourceMatchUp: o, iteration: c });
  }
  let m = (d == null ? void 0 : d.matchUpStatus) === at && ((d == null ? void 0 : d.feedRound) || (d == null ? void 0 : d.roundNumber) === 1), h = ((I = (g = a == null ? void 0 : a.targetLinks) == null ? void 0 : g.loserTargetLink) == null ? void 0 : I.linkCondition) === _n;
  if (m && h) {
    let S = t.filter(({ roundNumber: y, structureId: D }) => D === o.structureId && y === 1), T = S.map(({ roundPosition: y }) => y), A = gr(T.sort(), 2).find((y) => y.includes(o.roundPosition));
    if (((U = S.filter(({ roundPosition: y }) => A.includes(y))) == null ? void 0 : U.map(({ matchUpStatus: y }) => y)).every((y) => [sr, $t].includes(y))) return W({ result: { ...j }, stack: u });
  }
  if (d && (d.matchUpStatus !== at || m)) {
    let S = t.find(({ matchUpId: R }) => R === d.matchUpId), { structure: T } = Ne({ drawDefinition: i, structureId: S.structureId }), { stage: A, roundNumber: y, roundPosition: D, feedRound: P, structureName: w } = d;
    if (Oi({ loser: "loser", roundPosition: D, structureName: w, roundNumber: y, keyColors: Ql, feedRound: P, stage: A }), ((v = r == null ? void 0 : r.progression) == null ? void 0 : v.doubleExitPropagateBye) || m) nI({ drawPosition: p, targetLink: f, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: n });
    else {
      let R = XT({ ...e, targetMatchUp: d, structure: T, iteration: c });
      if (R.error) return W({ result: R, stack: u });
    }
  }
  return W({ result: { ...j }, stack: u });
}
function XT(e) {
  var S, T, A, y, D, P;
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o, structure: s, iteration: c } = e, u = "conditionallyRemoveDrawPosition";
  Oi({ method: u, structureName: s == null ? void 0 : s.structureName, iteration: c });
  let d = ei({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: { winnerMatchUp: l } } = d, p = o == null ? void 0 : o.drawMatchUps.find((w) => w.matchUpId === a.matchUpId), f = [], m, h, g;
  if (a.feedRound) g = (T = (S = l == null ? void 0 : l.drawPositions) == null ? void 0 : S.filter(Boolean)) == null ? void 0 : T.find((w) => a.drawPositions.includes(w));
  else if (!n) g = (A = qt((a == null ? void 0 : a.drawPositions) || [], (l == null ? void 0 : l.drawPositions) || [])) == null ? void 0 : A[0];
  else if (h = (y = kN({ structureId: s.structureId, matchUp: n, matchUpsMap: o })) == null ? void 0 : y.pairedPreviousMatchUp, m = [$t, sr].includes(h == null ? void 0 : h.matchUpStatus), f = ((D = h == null ? void 0 : h.drawPositions) == null ? void 0 : D.filter(Boolean)) || [], [...lr, at].includes(h == null ? void 0 : h.matchUpStatus) || (h == null ? void 0 : h.winningSide)) {
    let w = n.drawPositions || [], R = (P = a.drawPositions) == null ? void 0 : P.filter(Boolean);
    Jr(w, R) && (R = R == null ? void 0 : R.filter((b) => !w.includes(b))), g = w.concat(f).find((b) => R == null ? void 0 : R.includes(b));
  }
  if (l && g) {
    let { stage: w, roundNumber: R, roundPosition: b, structureName: E } = l;
    Oi({ method: "removeDirectedWinner", drawPositionToRemove: g, color: "brightgreen", roundPosition: b, structureName: E, roundNumber: R, keyColors: Ql, stage: w }), f1({ winningDrawPosition: g, winnerMatchUp: l, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
  }
  let I = g1({ targetData: d, matchUp: a, inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: o, structure: s, iteration: c });
  if (I.error) return W({ result: I, stack: u });
  let U = j_({ pairedPreviousDoubleExit: m, noContextTargetMatchUp: p }), v = !m;
  return I = Vn({ ...e, matchUpId: a.matchUpId, matchUp: p, removeWinningSide: !0, matchUpStatusCodes: [], context: u, matchUpStatus: U, removeScore: v, score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 } }), I.error ? W({ result: I, stack: u }) : { ...j };
}
function j_({ pairedPreviousDoubleExit: e, noContextTargetMatchUp: t }) {
  return t.matchUpStatus === at ? at : e ? [sr, Je].includes(t == null ? void 0 : t.matchUpStatus) ? Je : ct : Xt;
}
function __(e) {
  var o, s, c, u, d;
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n } = e, a = (o = e.targetData.targetLinks) == null ? void 0 : o.winnerTargetLink;
  if (a.target.feedProfile === sn) {
    let l = (c = (s = i.sides) == null ? void 0 : s.find(({ sideNumber: f }) => f === i.winningSide)) == null ? void 0 : c.participantId, p = r.find((f) => {
      var m;
      return f.structureId === a.target.structureId && f.roundNumber === a.target.roundNumber && ((m = f.sides) == null ? void 0 : m.some(({ participantId: h }) => h === l));
    });
    if (p && p.matchUpStatus === Xt) {
      let f = ei({ matchUpId: p.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Fo({ inContextDrawMatchUps: r, drawDefinition: n, targetData: f })) {
        let { structure: m } = Ne({ structureId: p.structureId, drawDefinition: n }), h = gt({ structure: m }).positionAssignments;
        for (let g of h || []) if (g.participantId === l) {
          if (g.participantId = void 0, m == null ? void 0 : m.positionAssignments) m.positionAssignments = h;
          else if (m != null && m.structures) {
            let I = Object.assign({}, ...(h || []).map((U) => ({ [U.drawPosition]: U.participantId })));
            for (let U of (m == null ? void 0 : m.structures) || []) (u = U.positionAssignments) == null || u.forEach((v) => v.participantId = I[v.drawPosition]);
          }
          Qa({ tournamentId: (d = e.tournamentRecord) == null ? void 0 : d.tournamentId, event: e.event, drawDefinition: n, structure: m }), t = !0;
        }
      }
    }
  }
  return { qualifierRemoved: t };
}
function W_(e) {
  var h;
  let { matchUp: t, matchUpStatus: r, score: i, winningSide: n } = e, a = "noDownStreamDependencies";
  if ([$t, sr].includes(t == null ? void 0 : t.matchUpStatus) && ![$t, sr].includes(r)) {
    let g = g1(e);
    if (g.error) return W({ result: g, stack: a });
  }
  let o = r === $t, s = pr({ score: i }) && !o && (e.isCollectionMatchUp && !e.projectedWinningSide || !n), c = ((h = e == null ? void 0 : e.inContextMatchUp) == null ? void 0 : h.collectionId) && O_(e.inContextMatchUp), u = e.removeScore || !c && ![Zi, Bi].includes(r || Zi), d = e.isCollectionMatchUp && e.dualMatchUp.winningSide && !e.projectedWinningSide || t.winningSide && !n && !pr({ score: i }), l = r && r !== Xt, p = (g) => {
    var D, P;
    let I, { structure: U, drawDefinition: v, dualMatchUp: S, disableAutoCalc: T } = e;
    if (S != null && S._disableAutoCalc && T !== !1) return EU({ ...e, removeWinningSide: d });
    let { connectedStructureIds: A } = h1({ drawDefinition: v, structure: U, matchUp: t });
    A.length && (console.log({ connectedStructureIds: A }), I = !0), Object.assign(e, { removeScore: g });
    let y = lu(e);
    if (y.error) return y;
    if (e.removingQualifier && ((P = (D = e.appliedPolicies) == null ? void 0 : D[Wu]) != null && P.autoRemoveQualifiers)) {
      let w = __(e);
      return { ...j, connectedStructures: I, ...w };
    }
    return { ...j, connectedStructures: I };
  };
  if (d && n && e.isCollectionMatchUp) return ZT(e);
  let f = [Oa, Bi].includes(r) && e.dualWinningSideChange, m = (n || f) && G_(e) || s && p(u) || l && F_(e) || d && p(u) || t && ZT({ ...e, removeScore: !0 }) || { ...j };
  return W({ result: m, stack: a });
}
function ZT(e) {
  var i;
  let t = "ndd:scoreModification";
  if (e.isCollectionMatchUp && ((i = e.dualMatchUp) != null && i.winningSide) && !e.projectedWinningSide && !e.autoCalcDisabled) {
    let n = lu(e);
    if (n.error) return n;
  }
  let r = Vn({ ...e, context: t });
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: n, drawDefinition: a, event: o, matchUpsMap: s } = e, { removeWinningSide: c } = La({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: n, drawDefinition: a, matchUpsMap: s, event: o });
    c && console.log("REMOVE WINNING SIDE");
  }
  return W({ result: r, stack: t });
}
function $S(e) {
  var d, l, p;
  let t = Ae(e, [{ [fr]: !0, [ii]: !0, [zn]: !0 }, { homeParticipantId: !0, [pn]: cr }]);
  if (t.error) return t;
  let r = ou(e, [{ [Yc]: pa, attr: { [$f]: !0 } }]);
  if (r.error) return r;
  let i = (p = (l = (d = r == null ? void 0 : r.matchUp) == null ? void 0 : d.matchUp) == null ? void 0 : l.sides) == null ? void 0 : p.map((f) => f == null ? void 0 : f.participantId);
  if (e.homeParticipantId && !(i != null && i.includes(e.homeParticipantId))) return { error: bn };
  let { disableNotice: n, homeParticipantId: a, removePriorValues: o, tournamentRecord: s, drawDefinition: c, matchUpId: u } = e;
  return Mi({ duplicateValues: !1, removePriorValues: o, tournamentRecord: s, drawDefinition: c, disableNotice: n, matchUpId: u, timeItem: { itemType: Hv, itemValue: a } });
}
function I1({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = zo({ timeItems: (r == null ? void 0 : r.timeItems) || [], itemType: Im });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { timeModifiers: i } : t;
}
function fo(e) {
  var f;
  let t = "addMatchUpScheduledTime", r = e.matchUp, { removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, scheduledTime: s, matchUpId: c } = e;
  if (!c) return W({ result: { error: zr }, stack: t });
  if (!qc(s)) return W({ result: { error: on }, stack: t });
  if (!r) {
    let m = bt({ drawDefinition: a, matchUpId: c });
    if (m.error) return W({ result: m, stack: t });
    r = m.matchUp;
  }
  let u = Ve(s), d = Vs({ matchUp: r }).scheduledDate, l = u && !d;
  if ((f = I1({ matchUp: r }).timeModifiers || []) != null && f.length) {
    let m = v1({ disableNotice: !0, removePriorValues: i, tournamentRecord: n, timeModifiers: [], drawDefinition: a, matchUpId: c, matchUp: r });
    if (m != null && m.error) return W({ result: m, stack: t });
  }
  let p = Ms(s, !0, l);
  return Mi({ duplicateValues: !1, removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, matchUpId: c, timeItem: { itemType: xs, itemValue: p } });
}
function v1({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, timeModifiers: n, matchUpId: a, matchUp: o }) {
  let s = "addMatchUpTimeModifiers";
  if (!a) return W({ result: { error: zr }, stack: s });
  if (n !== void 0 && !Array.isArray(n)) return W({ info: Oo("timeModifiers"), result: { error: ie }, stack: s });
  if (!o) {
    let l = bt({ drawDefinition: r, matchUpId: a });
    if (l.error) return W({ result: l, stack: s });
    o = l.matchUp;
  }
  let c = I1({ matchUp: o }).timeModifiers || [], u = n.filter((l) => !c.includes(l));
  if (n.length && !u.length) return { ...j };
  if (u.some((l) => Eg.includes(l))) {
    c = c.filter((p) => !Eg.includes(p));
    let l = fo({ disableNotice: !0, removePriorValues: e, scheduledTime: "", tournamentRecord: t, drawDefinition: r, matchUpId: a });
    if (l.error) return W({ result: l, stack: s });
  }
  let d = n != null && n.length ? [...u, ...c] : void 0;
  return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: Im, itemValue: d } });
}
function Uh({ scheduledDate: e, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a }) {
  if (!a) return { error: zr };
  let o = e && Gn.test(e);
  if (e && !o) return { error: Sr };
  let s = { itemValue: Ve(e), itemType: Ls };
  return Mi({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: s });
}
function Sh({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtIds: s }) {
  var d, l;
  if (!r && !t) return { error: de };
  if (!o) return { error: zr };
  let c = bt({ drawDefinition: i, matchUpId: o });
  if (c.error) return c;
  if (((d = c == null ? void 0 : c.matchUp) == null ? void 0 : d.matchUpType) !== Ci) return { error: gi };
  if (!(s === void 0 || Array.isArray(s) && s.length && s.every((p) => typeof p == "string"))) return { error: ie, context: { courtIds: s } };
  let u;
  if (s) {
    let p = t || r && { [r.tournamentId]: r }, f = xa({ tournamentRecords: p });
    if (f.error) return f;
    let m = (l = f.courts) == null ? void 0 : l.filter((h) => s.includes(h.courtId));
    if ((m == null ? void 0 : m.length) !== s.length) return { error: ie, context: { courtIds: s } };
    u = m == null ? void 0 : m.map((h) => ({ venueId: h.venueId, courtId: h.courtId }));
  }
  return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: ua, itemDate: a, itemValue: u } });
}
function pu({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, venueId: o }) {
  if (!r) return { error: de };
  if (!a) return { error: zr };
  if (o) {
    let s = fa({ tournamentRecords: t, tournamentRecord: r, venueId: o });
    if (s.error) return s;
  }
  return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: ks, itemValue: o } });
}
function Zs({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtId: s }) {
  var c;
  if (!r && !t) return { error: de };
  if (!o) return { error: zr };
  if (s) {
    let u = Gs({ tournamentRecords: t, tournamentRecord: r, courtId: s });
    if (u.error) return u;
    let d = (c = u.venue) == null ? void 0 : c.venueId;
    pu({ tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, venueId: d });
  }
  return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: Ja, itemDate: a, itemValue: s } });
}
function kn(e, t) {
  let r = cR.test(e) ? e : Rt(e), i = Ve(e) || Ve(t) || ln(/* @__PURE__ */ new Date());
  return (/* @__PURE__ */ new Date(`${i}T${r}`)).getTime();
}
function yh(e) {
  var M;
  let t = "addMatchUpScheduleItems", r = Ae(e, [{ drawDefinition: !0, matchUpId: !0 }, { schedule: !0, [ui]: pi }], t);
  if (r.error) return r;
  let { matchUpDependencies: i, inContextMatchUps: n } = e, { errorOnAnachronism: a = !1, checkChronology: o = !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, disableNotice: l, drawMatchUps: p, matchUpId: f, schedule: m, event: h } = e, g, I;
  if (p) g = p.find((N) => N.matchUpId === f);
  else {
    let N = bt({ drawDefinition: d, event: h, matchUpId: f });
    if (N.error) return N;
    g = N.matchUp;
  }
  let { endTime: U, courtId: v, courtIds: S, courtOrder: T, resumeTime: A, homeParticipantId: y, scheduledDate: D, scheduledTime: P, startTime: w, stopTime: R, timeModifiers: b, venueId: E } = m;
  o && (!i || !n) && ({ matchUpDependencies: i, matchUps: n } = An({ drawDefinition: d }));
  let O = (M = i == null ? void 0 : i[f]) == null ? void 0 : M.matchUpIds;
  if (m.scheduledDate && o && O) {
    let N = n == null ? void 0 : n.filter((C) => {
      var F, x;
      return (((F = C.schedule) == null ? void 0 : F.scheduledDate) || Ve((x = C.schedule) == null ? void 0 : x.scheduledTime)) && O.includes(C.matchUpId);
    }).map(({ schedule: C }) => {
      let F = ip(C);
      return new Date(F).getTime();
    });
    if (N != null && N.length) {
      let C = ip(m), F = new Date(C).getTime();
      if (Math.max(...N) >= F) {
        if (a) return W({ result: { error: pg }, stack: t });
        I = pg;
      }
    }
  }
  if (D !== void 0) {
    let N = Uh({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, scheduledDate: D, matchUpId: f });
    if (N != null && N.error) return W({ result: N, stack: t, context: { scheduledDate: D } });
  }
  if (P !== void 0) {
    let N = fo({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, scheduledTime: P, matchUpId: f, matchUp: g });
    if (N != null && N.error) return W({ result: N, stack: t, context: { scheduledTime: P } });
  }
  if (w !== void 0) {
    let N = ty({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: f, startTime: w, event: h });
    if (N != null && N.error) return W({ result: N, stack: t, context: { startTime: w } });
  }
  if (R !== void 0) {
    let N = iy({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: f, stopTime: R, event: h });
    if (N != null && N.error) return W({ result: N, stack: t, context: { stopTime: R } });
  }
  if (A !== void 0) {
    let N = ny({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, resumeTime: A, matchUpId: f, event: h });
    if (N != null && N.error) return W({ result: N, stack: t, context: { resumeTime: A } });
  }
  if (U !== void 0) {
    let N = ry({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: f, endTime: U, event: h });
    if (N != null && N.error) return W({ result: N, stack: t, context: { endTime: U } });
  }
  if (S !== void 0) {
    let N = Sh({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: f, courtIds: S });
    if (N != null && N.error) return W({ result: N, stack: t, context: { courtIds: S } });
  }
  if (v !== void 0 && D !== void 0) {
    let N = Zs({ courtDayDate: D, disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, matchUpId: f, courtId: v });
    if (N != null && N.error) return W({ result: N, stack: t, context: { courtId: v } });
  }
  if (E !== void 0) {
    let N = pu({ disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: d, matchUpId: f, venueId: E });
    if (N != null && N.error) return W({ result: N, stack: t, context: { venueId: E } });
  }
  if (T !== void 0 && ke(T)) {
    let N = ey({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, courtOrder: T, matchUpId: f });
    if (N != null && N.error) return W({ result: N, stack: t, context: { courtOrder: T } });
  }
  if (b !== void 0) {
    let N = v1({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: d, timeModifiers: b, matchUpId: f, matchUp: g });
    if (N != null && N.error) return W({ result: N, stack: t, context: { timeModifiers: b } });
  }
  return Et(y) && $S({ disableNotice: !0, homeParticipantId: y, removePriorValues: s, tournamentRecord: u, drawDefinition: d, matchUpId: f }), l || Qe({ tournamentId: u == null ? void 0 : u.tournamentId, eventId: h == null ? void 0 : h.eventId, context: t, drawDefinition: d, matchUp: g }), I ? { ...j, warnings: [I] } : { ...j };
}
function ey({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, courtOrder: n, matchUpId: a }) {
  if (!a) return { error: zr };
  if (n && !ke(n)) return { error: ie, info: "courtOrder must be numeric" };
  let o = n && be(n);
  return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: gm, itemValue: o } });
}
function U1({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, participantId: n, officialType: a, matchUpId: o }) {
  if (!o) return { error: zr };
  if (!n) return { error: cr };
  if (t) {
    let c = Lt({ tournamentRecord: t, participantFilters: { participantTypes: [Xe], participantRoles: [rU] } }).participants ?? [];
    if (!za({ tournamentParticipants: c, participantId: n })) return { error: Yt };
  }
  let s = { itemType: "SCHEDULE.ASSIGNMENT.OFFICIAL", itemValue: n };
  return a && (s.itemSubTypes = [a]), Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: o, timeItem: s });
}
function ty({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, startTime: a, event: o }) {
  if (!n) return { error: zr };
  if (!qc(a)) return { error: on };
  let { matchUp: s } = bt({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = Vs({ matchUp: s }), u = ((s == null ? void 0 : s.timeItems) ?? []).filter((d) => [Ua, ea, ba].includes(d == null ? void 0 : d.itemType)).map((d) => kn(d.itemValue, c)).reduce((d, l) => !d || l < d ? l : d, void 0);
  if (!u || kn(a, c) < u) {
    s != null && s.timeItems && (s.timeItems = s.timeItems.filter((l) => l.itemType !== Dn));
    let d = Ms(a, !0, !0);
    return Mi({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: { itemType: Dn, itemValue: d } });
  } else return { error: Cw };
}
function ry({ validateTimeSeries: e = !0, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, endTime: o, event: s }) {
  if (!a) return { error: zr };
  if (!qc(o)) return { error: on };
  let { matchUp: c } = bt({ drawDefinition: i, event: s, matchUpId: a }), { scheduledDate: u } = Vs({ matchUp: c }), d = ((c == null ? void 0 : c.timeItems) ?? []).filter((l) => [Dn, ea, Ua].includes(l == null ? void 0 : l.itemType)).map((l) => kn(l.itemValue, u)).reduce((l, p) => !l || p > l ? p : l, void 0);
  if (!e || !d || kn(o, u) > d) {
    c != null && c.timeItems && (c.timeItems = c.timeItems.filter((p) => p.itemType !== ba));
    let l = Ms(o, !0, !0);
    return Mi({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: ba, itemValue: l } });
  } else return { error: Ew };
}
function iy({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, stopTime: a, event: o }) {
  if (!n) return { error: zr };
  if (!qc(a)) return { error: on };
  let { matchUp: s } = bt({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = Vs({ matchUp: s }), u = (s == null ? void 0 : s.timeItems) ?? [];
  if (u.reduce((m, h) => h.itemType === ba || m, void 0)) return { error: OI };
  let d = u.filter((m) => [Dn, ea, Ua].includes(m == null ? void 0 : m.itemType)).sort((m, h) => kn(m.itemValue, c) - kn(h.itemValue, c)), l = d[d.length - 1], p = l && l.itemType === Ua, f = d.filter((m) => !p || m.createdAt !== l.createdAt).map((m) => kn(m.itemValue, c)).reduce((m, h) => !m || h > m ? h : m, void 0);
  if (kn(a, c) > f) {
    if (s != null && s.timeItems && p) {
      let h = l.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let m = { itemValue: Ms(a, !0, !0), itemType: Ua };
    return Mi({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: m });
  } else return { error: Ow };
}
function ny({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, resumeTime: n, matchUpId: a, event: o }) {
  if (!a) return { error: zr };
  if (!qc(n)) return { error: on };
  let { matchUp: s } = bt({ drawDefinition: r, event: o, matchUpId: a }), { scheduledDate: c } = Vs({ matchUp: s }), u = (s == null ? void 0 : s.timeItems) ?? [];
  if (u.reduce((m, h) => h.itemType === ba || m, void 0)) return { error: OI };
  let d = u.filter((m) => [Dn, ea, Ua].includes(m == null ? void 0 : m.itemType)).sort((m, h) => kn(m.itemValue, c) - kn(h.itemValue, c)), l = d[d.length - 1], p = l && l.itemType === ea, f = d.filter((m) => !p || m.createdAt !== l.createdAt).map((m) => kn(m.itemValue, c)).reduce((m, h) => !m || h > m ? h : m, void 0);
  if (kn(n, c) > f) {
    if (s != null && s.timeItems && p) {
      let h = l.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let m = { itemValue: Ms(n, !0, !0), itemType: ea };
    return Mi({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: m });
  } else return { error: tk };
}
function q_({ drawDefinition: e, matchUpStatus: t, matchUpsMap: r, winningSide: i, dualMatchUp: n, tieFormat: a, structure: o, matchUp: s, event: c, score: u }) {
  var p;
  let d = ge(n, void 0, !0);
  for (let f of (d == null ? void 0 : d.tieMatchUps) || []) f.matchUpId === s.matchUpId && (f.winningSide = i, f.score = u, !pr({ score: u }) && !t ? Object.assign(f, { ...Om }) : t && (f.matchUpStatus = t));
  a = a ?? ((p = Yr({ matchUp: s, structure: o, drawDefinition: e, event: c })) == null ? void 0 : p.tieFormat);
  let { winningSide: l } = Jd({ matchUp: d, drawDefinition: e, matchUpsMap: r, structure: o, tieFormat: a, event: c });
  return { projectedWinningSide: l };
}
function H_(e) {
  var T;
  let { tournamentRecord: t, inContextMatchUp: r, structure: i, drawDefinition: n } = e, a = r.roundNumber, o = r.sides.find((A) => A.sideNumber === r.winningSide), s = r.sides.find((A) => A.sideNumber !== r.winningSide), { drawPosition: c, participantId: u } = o, { drawPosition: d, participantId: l } = s, p = "swapWinnerLoser", { matchUps: f } = ut(e), m = f.filter(({ drawPositions: A, roundNumber: y }) => (A == null ? void 0 : A.includes(c)) && y > a);
  ki({ changeWinner: !0 }) && console.log({ existingWinnerSubsequentMatchUps: m }), m.forEach((A) => {
    var y, D;
    A.drawPositions = ((y = A.drawPositions) == null ? void 0 : y.map((P) => P === c ? d : P)) || [], Qe({ tournamentId: t == null ? void 0 : t.tournamentId, eventId: (D = e.event) == null ? void 0 : D.eventId, context: p, drawDefinition: n, matchUp: A });
  });
  let { stage: h, stageSequence: g } = i, I = n.structures.filter(({ stage: A, stageSequence: y }) => A === h && y > g).map(({ structureId: A }) => A), { targetLinks: { loserTargetLink: U, winnerTargetLink: v } } = e.targetData, S = [U == null ? void 0 : U.target.structureId, (T = v == null ? void 0 : v.target) == null ? void 0 : T.structureId].filter(Boolean);
  return n.structures.filter(({ stage: A, structureId: y }) => A !== h && S.includes(y)).forEach(({ stage: A, stageSequence: y, structureId: D }) => {
    I.includes(D) || I.push(D), n.structures.filter(({ stage: P, stageSequence: w }) => P === A && w > y).forEach(({ structureId: P }) => {
      I.includes(P) || I.push(P);
    });
  }), n.structures.filter(({ structureId: A }) => I.includes(A)).forEach((A) => {
    let { positionAssignments: y } = gt({ structure: A }), D = y == null ? void 0 : y.find(({ participantId: w }) => w === u), P = y == null ? void 0 : y.find(({ participantId: w }) => w === l);
    D && (D.participantId = l), P && (P.participantId = u);
  }), Vn({ ...e, context: p });
}
function fl(e) {
  var k, L, B;
  let t = "setMatchUpStatus";
  e.matchUpStatus && [ct, $t].includes(e.matchUpStatus) && (e.score = void 0);
  let { allowChangePropagation: r, disableScoreValidation: i, tournamentRecords: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpStatus: u, winningSide: d, matchUpId: l, event: p, score: f } = e;
  if (!c) return { error: Ue };
  if (u && [Oa, Zi, Bi, Xt].includes(u) && d) return { error: ie, winningSide: d, matchUpStatus: u };
  if (![void 0, ...Tb].includes(u)) return W({ result: { error: Vc }, info: "matchUpStatus does not exist", stack: "setMatchUpStatus" });
  let m = xr({ drawDefinition: c }), { matchUps: h } = ur({ nextMatchUps: !0, tournamentRecord: a, inContext: !0, drawDefinition: c, matchUpsMap: m, event: p }), g = m.drawMatchUps.find((G) => G.matchUpId === l), I = h == null ? void 0 : h.find((G) => G.matchUpId === l);
  if (!g || !h) return { error: jr };
  if ((g.winningSide || d) && u === at) return { context: "Cannot have Bye with winningSide", error: Ll, matchUpStatus: u };
  let U = I == null ? void 0 : I.structureId, { structure: v } = Ne({ drawDefinition: c, structureId: U }), S = Kt(yt)(g.matchUpType), T = (k = I == null ? void 0 : I.drawPositions) == null ? void 0 : k.filter(Boolean), A = I == null ? void 0 : I.matchUpTieId, y = ei({ matchUpId: A || l, inContextDrawMatchUps: h, drawDefinition: c });
  Object.assign(e, { inContextDrawMatchUps: h, inContextMatchUp: I, matchUpTieId: A, matchUpsMap: m, targetData: y, structure: v, matchUp: g });
  let D = Fo(e), P;
  if (S) {
    if (o) it({ extension: { name: vs, value: !0 }, element: g });
    else if (s) {
      let G = g.winningSide, { winningSide: q, scoreStringSide1: Y, scoreStringSide2: H, set: X } = Jd({ drawDefinition: c, matchUpsMap: m, structure: v, matchUp: g, event: p }), z = { scoreStringSide1: Y, scoreStringSide2: H, sets: X ? [X] : [] };
      if (P = q !== G, D && P) return W({ stack: "winningSideWithDownstreamDependencies", result: { error: Ff }, context: { winningSide: d, matchUp: g } });
      Zr({ name: vs, element: g }), Object.assign(e, { winningSide: q, dualWinningSideChange: P, projectedWinningSide: q, score: z });
    }
    $d({ tournamentId: a == null ? void 0 : a.tournamentId, inContextDualMatchUp: I, eventId: p == null ? void 0 : p.eventId, dualMatchUp: g, drawDefinition: c });
  }
  if (S && u && [Os].includes(u)) return { info: "Not supported for matchUpType: TEAM", error: ie };
  if (f && !S && !i) {
    let G = g.matchUpFormat ?? (v == null ? void 0 : v.matchUpFormat) ?? (c == null ? void 0 : c.matchUpFormat) ?? (p == null ? void 0 : p.matchUpFormat), q = tS({ existingMatchUpStatus: g.matchUpStatus, matchUpFormat: G, matchUpStatus: u, winningSide: d, score: f });
    if (q.error) return q;
  }
  let w = ((L = nt({ policyTypes: [Wu, En], tournamentRecord: a, drawDefinition: c, event: p })) == null ? void 0 : L.appliedPolicies) ?? {};
  $e(e.policyDefinitions) && Object.assign(w, e.policyDefinitions);
  let R = z_({ assignedDrawPositions: T, inContextMatchUp: I, appliedPolicies: w, drawDefinition: c, matchUpStatus: u, structure: v, matchUp: g });
  if (R != null && R.error) return R;
  let b = (I == null ? void 0 : I.stage) === Pe && I.finishingRound === 1, E = b && d, O = b && g.winningSide && !d && (!e.matchUpStatus || e.matchUpStatus && kg({ matchUpStatus: e.matchUpStatus })) && (!e.outcome || !pr({ outcome: e.outcome })), M = E && d !== g.winningSide && g.winningSide;
  if (Object.assign(e, { qualifierAdvancing: E, qualifierChanging: M, removingQualifier: O, appliedPolicies: w }), A) {
    let { matchUp: G } = bt({ matchUpId: A, inContext: !0, drawDefinition: c, matchUpsMap: m, event: p });
    if (G) {
      let q = (B = Yr({ matchUp: G, drawDefinition: c, structure: v, event: p })) == null ? void 0 : B.tieFormat, { projectedWinningSide: Y } = q_({ drawDefinition: c, matchUpStatus: u, dualMatchUp: G, matchUpsMap: m, winningSide: d, tieFormat: q, structure: v, matchUp: g, event: p, score: f }), H = G.winningSide;
      P = Y !== H;
      let X = G._disableAutoCalc;
      Object.assign(e, { isCollectionMatchUp: !0, dualWinningSideChange: P, projectedWinningSide: Y, autoCalcDisabled: X, matchUpTieId: A, dualMatchUp: G, tieFormat: q });
    }
  }
  let N = xd({ matchUpStatus: u });
  if (!A) {
    if (D && !d && (u && kg({ matchUpStatus: u }) || u && [$t, sr].includes(u))) return { error: Ll, activeDownstream: D, winningSide: d };
    if (d && d === g.winningSide && u && !N) return { context: "winningSide must include directing matchUpStatus", error: Ll, directingMatchUpStatus: N, matchUpStatus: u };
  }
  let { schedule: C } = e;
  if (C) {
    let G = yh({ disableNotice: !0, tournamentRecords: n, tournamentRecord: a, drawDefinition: c, matchUpId: l, schedule: C });
    if (G.error) return G;
  }
  let F = !S && !P && d && g.winningSide && g.winningSide !== d;
  if (r && F && g.roundPosition) return H_(e);
  let x = d && !A || e.projectedWinningSide;
  Oi({ activeDownstream: D, matchUpWinner: x, method: t, winningSide: d });
  let V = !D && W_(e) || x && Y_(e) || (N || e.autoCalcDisabled) && S1(e) || { error: jw };
  return W({ result: V, stack: t });
}
function Y_(e) {
  let { matchUp: t, winningSide: r, matchUpTieId: i, dualWinningSideChange: n } = e;
  return r === t.winningSide || i && !n ? S1(e) : W({ stack: "winningSideWithDownstreamDependencies", result: { error: Ff }, context: { winningSide: r, matchUp: t } });
}
function S1(e) {
  let { tournamentRecord: t, matchUp: r, event: i } = e, n = e.isCollectionMatchUp && r.winningSide && !e.winningSide && !pr({ score: e.score }), a = e.isCollectionMatchUp ? e.matchUpStatus || n && Xt || e.winningSide && zt || Zi : e.matchUpStatus || zt, o = e.removeScore || [Oa, ct].includes(a) && ![Zi, Bi].includes(a), s = Vn({ ...e, matchUpStatus: a, removeWinningSide: n, context: "sms", removeScore: o });
  if (s.error) return s;
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: c, drawDefinition: u, matchUpsMap: d } = e, l = La({ appliedPolicies: e.appliedPolicies, matchUpId: c, tournamentRecord: t, drawDefinition: u, matchUpsMap: d, event: i });
    if (l.error) return l;
    Object.assign(s, { tieMatchUpResult: l });
  }
  return s;
}
function z_({ assignedDrawPositions: e, inContextMatchUp: t, appliedPolicies: r, drawDefinition: i, matchUpStatus: n, structure: a, matchUp: o }) {
  var d, l;
  if (((d = r == null ? void 0 : r[En]) == null ? void 0 : d.requireParticipantsForScoring) === !1) return { ...j };
  let s = (l = t == null ? void 0 : t.sides) == null ? void 0 : l.map((p) => p.participantId).filter(Boolean).length, c = o != null && o.sides ? [] : gt({ structureId: a == null ? void 0 : a.structureId, drawDefinition: i }).positionAssignments, u = s && s === 2 || o.collectionId && si({ structure: a }) && s && s >= 1 || (e == null ? void 0 : e.length) === 2 && (c == null ? void 0 : c.filter((p) => e.includes(p.drawPosition)).every((p) => p.participantId));
  return n && Ab.includes(n) && !u ? W({ info: "matchUpStatus requires assigned participants", context: { matchUpStatus: n, requiredParticipants: u }, result: { error: Vc } }) : { ...j };
}
function y1({ tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i }) {
  if (!t) return { error: Ue };
  let { matchUp: n } = bt({ drawDefinition: t, matchUpId: r, event: i });
  return (n == null ? void 0 : n.matchUpType) !== Ci ? { error: gi } : fl({ enableAutoCalc: !0, tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i });
}
function A1({ drawDefinition: e, event: t, matchUpId: r }) {
  if (!e) return { error: Ue };
  if (!r) return { error: zr };
  let { matchUp: i } = bt({ drawDefinition: e, event: t, matchUpId: r });
  return i ? Zr({ name: am, element: i }) : { error: jr };
}
function K_({ substituteParticipantId: e, existingParticipantId: t, tournamentRecord: r, drawDefinition: i, sideNumber: n, matchUpId: a, event: o }) {
  var f, m, h, g, I;
  let s = "substituteParticipant";
  if (!i) return { error: Ue };
  if (!a) return { error: zr };
  if (!t || !e) return W({ result: { error: cr }, stack: s });
  let { matchUp: c } = bt({ drawDefinition: i, matchUpId: a, event: o });
  if (!c) return { error: jr };
  if (!c.collectionId) return W({ result: { error: gi }, stack: s });
  let u = xr({ drawDefinition: i }), { matchUps: d } = ur({ tournamentParticipants: r == null ? void 0 : r.participants, inContext: !0, drawDefinition: i, matchUpsMap: u }), l = d == null ? void 0 : d.find((U) => U.matchUpId === a), p = (m = (f = d == null ? void 0 : d.find((U) => U.matchUpId === (l == null ? void 0 : l.matchUpTieId))) == null ? void 0 : f.sides) == null ? void 0 : m.find((U) => U.participant.individualParticipants.some(({ participantId: v }) => v === t));
  return !p || n && p.sideNumber !== n ? { error: bn } : (I = (g = (h = p.participant) == null ? void 0 : h.individualParticipants) == null ? void 0 : g.map(Ke).filter((U) => U !== t)) != null && I.includes(e) ? QS({ newParticipantId: e, tieMatchUpId: a, existingParticipantId: t, substitution: !0, tournamentRecord: r, drawDefinition: i, event: o }) : W({ result: { error: bn }, stack: s });
}
function T1(e) {
  return K_(e);
}
function D1({ drawDefinition: e, matchUpId: t, event: r }) {
  if (!e) return { error: Ue };
  let { matchUp: i } = bt({ drawDefinition: e, matchUpId: t, event: r });
  return it({ extension: { name: vs, value: !0 }, element: i });
}
function P1(e) {
  let t = "setMatchUpFormat", r = Ae(e, [{ tournamentRecord: !0 }, { [Or]: (T) => Ri({ matchUpFormat: T }), [xi]: sd, matchUpFormat: !0 }]);
  if (r.error) return W({ result: r, stack: t });
  let { tournamentRecord: i, drawDefinition: n, scheduledDates: a, stageSequences: o, matchUpFormat: s, structureId: c, eventType: u, matchUpId: d, eventId: l, stages: p, drawId: f, event: m, force: h } = e;
  if (a && !Array.isArray(a)) return W({ result: { error: ie, scheduledDates: a }, stack: t });
  if (u && !Rf([jn, Xi], u)) return W({ result: { error: na }, stack: t });
  let g = 0, I = e.structureIds || c && [c].filter(Boolean) || [], U = e.eventIds || l && [l].filter(Boolean) || [], v = e.drawIds || f && [f].filter(Boolean) || [];
  if ((c || I != null && I.length) && !n) return W({ result: { error: Ue }, stack: t });
  if (f && d && n) {
    let T = aS({ tournamentRecord: i, drawDefinition: n, matchUpFormat: s, structureIds: I, structureId: c, matchUpId: d });
    if (T.error) return T;
    g += 1;
  }
  let S = (T) => {
    let A = [];
    for (let y of T.structures || []) {
      if (Array.isArray(p) && !p.includes(y.stage) || Array.isArray(o) && !o.includes(y.stageSequence) || I != null && I.length && !I.includes(y.structureId)) continue;
      I != null && I.length && y.matchUpFormat !== s && (y.matchUpFormat = s, A.push(y.structureId), g += 1);
      let D = ((h || a) && ut({ matchUpFilters: { matchUpStatuses: [Xt] }, structure: y }).matchUps) ?? [], P = (a && ut({ matchUpFilters: { matchUpStatuses: [Xt] }, contextFilters: { scheduledDates: a }, afterRecoveryTimes: !1, inContext: !0, structure: y }).matchUps) ?? [];
      if (D != null && D.length) {
        let w = P ? P.map(hr) : D.map(hr);
        for (let R of D) w.includes(R.matchUpId) && (R.matchUpFormat = a != null && a.length ? s : void 0, Qe({ tournamentId: i == null ? void 0 : i.tournamentId, eventId: m == null ? void 0 : m.eventId, context: t, drawDefinition: T, matchUp: R }));
      }
    }
    return !A.length && T.matchUpFormat !== s && (T.matchUpFormat = s, g += 1), A;
  };
  for (let T of (i == null ? void 0 : i.events) || []) if (!(U != null && U.length && !U.includes(T.eventId) || u && u !== T.eventType || u === or)) if (Array.isArray(o) || Array.isArray(p) || I != null && I.length || v != null && v.length) for (let A of T.drawDefinitions || []) {
    if (Array.isArray(v) && !v.includes(A.drawId)) continue;
    let y = S(A);
    vt({ structureIds: y, drawDefinition: A });
  }
  else T.matchUpFormat !== s && (T.matchUpFormat = s, g += 1);
  return g ? { ...j, modificationsCount: g } : { ...j, info: Wc };
}
function ay({ inheritance: e = !0, tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n }) {
  var c, u;
  if (!r) return { error: Ue };
  let a = (c = bt({ drawDefinition: r, matchUpId: i })) == null ? void 0 : c.matchUp;
  if (!(a != null && a.tieMatchUps)) return { error: gi };
  let o = (u = bt({ inContext: !0, drawDefinition: r, matchUpId: i, event: n })) == null ? void 0 : u.matchUp, s = 0;
  return ((a == null ? void 0 : a.sides) || []).forEach((d) => {
    d.lineUp && delete d.lineUp;
  }), ((o == null ? void 0 : o.sides) || []).forEach((d) => {
    if (s += 1, e === !1) {
      let l = o == null ? void 0 : o.tieFormat, p = d.participantId;
      l && p && Hs({ drawDefinition: r, participantId: p, lineUp: [], tieFormat: l });
    }
    Qe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "resetMatchUpLineUps", eventId: n == null ? void 0 : n.eventId, drawDefinition: r, matchUp: a });
  }), { ...j, modificationsCount: s };
}
function w1(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n, setTBlast: a } = e;
  if (!n) return { sets: [] };
  let o = n.sets || [], s = ra({ winnerFirst: !1, matchUpFormat: t, matchUpStatus: r, setTBlast: a, sets: o }), c = ra({ winnerFirst: !1, reversed: !0, matchUpFormat: t, matchUpStatus: r, setTBlast: a, sets: o }), u = ra({ matchUpFormat: t, matchUpStatus: r, winningSide: i, setTBlast: a, sets: o }), d = s === u ? c : s;
  return i && (s = i === 1 ? u : d, c = i === 2 ? u : d), { score: { sets: o, scoreStringSide1: s, scoreStringSide2: c } };
}
function ml(e) {
  var U, v;
  let t = Ae(e, [{ [zn]: !0, [ii]: !0 }]);
  if (t.error) return t;
  let r = $i(e);
  if (!e.drawDefinition) {
    let S = e.tournamentRecord ?? (e.tournamentId && r[e.tournamentId]);
    e.tournamentRecord || (e.tournamentRecord = S);
    let T = ci({ eventId: e.eventId, drawId: e.drawId, tournamentRecord: S });
    if (T.error) return T;
    T.drawDefinition && (e.drawDefinition = T.drawDefinition), e.event = T.event;
  }
  let { disableScoreValidation: i, policyDefinitions: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpId: u, schedule: d, event: l, notes: p } = e, f = e.matchUpFormat || ((U = e.outcome) == null ? void 0 : U.matchUpFormat), { policy: m } = qo({ policyType: En, tournamentRecord: a, event: l }), h = e.allowChangePropagation !== void 0 && e.allowChangePropagation || (m == null ? void 0 : m.allowChangePropagation) !== void 0 && m.allowChangePropagation || void 0, { outcome: g, setTBlast: I } = e;
  if (g != null && g.winningSide && ![1, 2].includes(g.winningSide)) return { error: Of };
  if (f) {
    let S = aS({ tournamentRecord: a, drawDefinition: c, matchUpFormat: f, matchUpId: u, event: l });
    if (S.error) return S;
  }
  if ((v = g == null ? void 0 : g.score) != null && v.sets && !g.score.scoreStringSide1) {
    let { score: S } = w1({ ...g, setTBlast: I });
    g.score = S, g.score.sets = g.score.sets.filter((T) => T.side1Score || T.side2Score || T.side1TiebreakScore || T.side2TiebreakScore);
  }
  return fl({ matchUpStatusCodes: g == null ? void 0 : g.matchUpStatusCodes, matchUpStatus: g == null ? void 0 : g.matchUpStatus, winningSide: g == null ? void 0 : g.winningSide, allowChangePropagation: h, disableScoreValidation: i, score: g == null ? void 0 : g.score, tournamentRecords: r, policyDefinitions: n, tournamentRecord: a, disableAutoCalc: o, enableAutoCalc: s, drawDefinition: c, matchUpFormat: f, matchUpId: u, schedule: d, event: l, notes: p });
}
function R1(e) {
  if (!(e != null && e.outcomes)) return { error: we };
  if (!Array.isArray(e.outcomes)) return { error: we, info: { outcomes: e.outcomes } };
  let t = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, r = e.outcomes ?? [], i = r.reduce((n, a) => n.includes(a.tournamentId) ? n : n.concat(a.tournamentId), []);
  for (let n of i) {
    let a = t[n];
    if (!a) return { error: de };
    let o = r.filter((s) => s.tournamentId === n);
    if (o.length) {
      let s = X_({ outcomes: o, tournamentRecord: a });
      if (s.error) return s;
    }
  }
  return { ...j };
}
function X_(e) {
  var o;
  let { tournamentRecords: t, tournamentRecord: r, outcomes: i, policyDefinitions: n } = e, a = {};
  i.forEach((s) => {
    let { eventId: c } = s;
    a[c] || (a[c] = []), a[c].push(s);
  });
  for (let s of Object.keys(a)) {
    let { event: c } = ci({ tournamentRecord: r, eventId: s });
    for (let u of a[s]) {
      let { drawId: d } = u, l = (o = c == null ? void 0 : c.drawDefinitions) == null ? void 0 : o.find((p) => p.drawId === d);
      if (l && d) {
        let { matchUpFormat: p, matchUpId: f } = u, m = ml({ schedule: u == null ? void 0 : u.schedule, tournamentRecords: t, policyDefinitions: n, tournamentRecord: r, drawDefinition: l, matchUpFormat: p, matchUpId: f, outcome: u, drawId: d, event: c });
        if (m.error) return m;
      }
    }
  }
  return { ...j };
}
function Z_({ drawDefinition: e, matchUpId: t, outcome: r, matchUp: i }) {
  var n, a;
  if (!i && !e) return { error: Ue };
  if (!r) return { error: we, info: "missing outcome" };
  if (!i && !t) return { error: hi };
  if (!i) {
    let o = bt({ drawDefinition: e, matchUpId: t });
    if (o.error) return o;
    i = o.matchUp;
  }
  return typeof r != "object" || !((n = r.score) != null && n.scoreStringSide1) || !((a = r.score) != null && a.scoreStringSide2) ? { error: ie } : it({ element: i, extension: { name: am, value: r } });
}
function b1(e) {
  return Z_(e);
}
function oy(e) {
  var h, g;
  let t = "resetTieFormat", { drawDefinition: r, event: i, uuids: n } = e, a = Ae(e, [{ [fr]: !0, [zn]: !0 }], t);
  if (a.error) return a;
  let o = ou(e, [{ [Yc]: pa }]);
  if (o[pn]) return o;
  let s = (h = e.tournamentRecord) == null ? void 0 : h.tournamentId, { matchUp: c, structure: u } = (o == null ? void 0 : o.matchUp) ?? {};
  if (!(c != null && c.tieMatchUps)) return W({ result: { error: gi }, info: "Must be a TEAM matchUp", stack: t });
  if (!c.tieFormat) return { ...j };
  let d = (g = Yr({ structure: u, drawDefinition: r, event: i })) == null ? void 0 : g.tieFormat;
  if (!d) return W({ result: { error: Tr }, info: "No inherited tieFormat", stack: t });
  let l = [], p = [], f = [], m = [];
  for (let I of d.collectionDefinitions) {
    let { matchUpCount: U, collectionId: v } = I;
    p.push(v);
    let S = (c.tieMatchUps || []).filter((T) => T.collectionId === v);
    if (S.length > U) S.sort((T, A) => (T.matchUpStatus === Xt ? 1 : 0) - (A.matchUpStatus === Xt ? 1 : 0)), f.push(...S.slice(0, U)), l.push(...S.slice(3).map(hr));
    else if (f.push(...S), S.length < U) {
      let T = U - S.length, A = Zd({ collectionDefinition: I, matchUpsLimit: T, matchUp: c, uuids: n });
      m.push(...A);
    }
  }
  for (let I of (c == null ? void 0 : c.tieMatchUps) || []) I.collectionId && !p.includes(I.collectionId) && l.push(I.matchUpId);
  return m.length && (f.push(...m), Za({ eventId: i == null ? void 0 : i.eventId, matchUps: m, drawDefinition: r, tournamentId: s })), l.length && Ca({ matchUpIds: l, eventId: i == null ? void 0 : i.eventId, drawDefinition: r, tournamentId: s }), c && (c.tieMatchUps = f, c.tieFormatId = void 0, c.tieFormat = void 0, Qe({ structureId: u == null ? void 0 : u.structureId, eventId: i == null ? void 0 : i.eventId, context: t, drawDefinition: r, tournamentId: s, matchUp: c })), { ...j, newMatchUps: m, deletedMatchUpIds: l };
}
function sy(e) {
  var h, g, I;
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n } = e, a = "resetScorecard";
  if (!r) return W({ result: { error: Ue }, stack: a });
  if (!i) return W({ result: { error: zr }, stack: a });
  if (!Et(i)) return W({ result: { error: ie, matchUpId: i }, stack: a });
  let o = xr({ drawDefinition: r }), { matchUps: s } = ur({ nextMatchUps: !0, inContext: !0, drawDefinition: r, matchUpsMap: o }), c = o.drawMatchUps.find((U) => U.matchUpId === i), u = s == null ? void 0 : s.find((U) => U.matchUpId === i);
  if (!c || !s) return { error: jr };
  if (c.matchUpType !== bi) return { error: gi };
  let d = ei({ inContextDrawMatchUps: s, drawDefinition: r, matchUpId: i }), l = u == null ? void 0 : u.structureId, { structure: p } = Ne({ drawDefinition: r, structureId: l });
  if (Object.assign(e, { inContextDrawMatchUps: s, inContextMatchUp: u, matchUpsMap: o, targetData: d, structure: p, matchUp: c }), Fo(e)) return { error: Ff };
  if ((h = c.tieMatchUps) != null && h.length) for (let U of c.tieMatchUps) {
    let v = fl({ matchUpId: U.matchUpId, matchUpTieId: i, winningSide: void 0, removeScore: !0, tournamentRecord: t, drawDefinition: r, event: n });
    if (v.error) return W({ result: v, stack: a });
  }
  let f = (g = nt({ tournamentRecord: t, drawDefinition: r, event: n })) == null ? void 0 : g.appliedPolicies, m = La({ event: e.event, removeScore: !0, tournamentRecord: t, appliedPolicies: f, drawDefinition: r, matchUpsMap: o, matchUpId: i });
  if (m.error) return W({ result: m, stack: a });
  if (e.tiebreakReset && !m.tieFormatRemoved) {
    let U = (I = Yr({ drawDefinition: r, structure: p, event: n })) == null ? void 0 : I.tieFormat;
    if (c.tieFormat && U) {
      let { matchUpCountDifference: v, descendantDifferences: S, ancestorDifferences: T, valueDifference: A } = Na({ descendant: c.tieFormat, ancestor: U });
      if (S.collectionIds.length === 1 && !T.collectionIds.length && !T.groupsCount && v === 1 && A === 1) {
        let y = oy({ tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n });
        if (y.error) return y;
      }
    }
  }
  return { ...j };
}
function N1(e) {
  let t = Ae(e, [{ [ii]: !0, [no]: !0 }, { [Ac]: { [Id]: !1, roundNumbers: !1 }, [cb]: "At least one must be provided", [ui]: Gr }]);
  if (t.error) return t;
  let r = LM(e);
  if (r.error) return r;
  let { matchUpIds: i } = r, n = Kt(bi)(e.event.eventType), { tournamentRecord: a, drawDefinition: o, event: s } = e;
  for (let c of i) {
    if (n) {
      let d = sy({ tiebreakReset: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
      if (d.error || e.removeAssignments && ay({ inheritance: !1, drawDefinition: o, matchUpId: c }).error) return d;
    }
    let u = fl({ winningSide: void 0, removeScore: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
    if (u.error) return u;
    if (e.removeAssignments) {
      let d = JS({ ...e, matchUpId: c });
      if (d.error) return d;
    }
  }
  return { ...j };
}
function Q_({ tournamentRecord: e, drawDefinition: t, finishingOrder: r }) {
  var U;
  if (!t) return { error: Ue };
  let i = "setOrderOfFinish";
  if (!Array.isArray(r)) return W({ info: Oo("finishingOrder"), result: { error: ie }, stack: i });
  let { completedMatchUps: n, matchUpsMap: a } = Jc({ inContext: !0, drawDefinition: t }), o = (n == null ? void 0 : n.map(hr)) ?? [], s = r.map(hr), { matchUpTypes: c, roundNumbers: u, structureIds: d, matchUpTieIds: l } = (n ?? []).filter(({ matchUpId: v }) => s.includes(v)).reduce((v, S) => {
    let { matchUpTieId: T, matchUpType: A, roundNumber: y, structureId: D } = S;
    return v.matchUpTypes.includes(A) || v.matchUpTypes.push(A), v.roundNumbers.includes(y) || v.roundNumbers.push(y), v.structureIds.includes(D) || v.structureIds.push(D), v.matchUpTieIds.includes(T) || v.matchUpTieIds.push(T), v;
  }, { matchUpTypes: [], roundNumbers: [], structureIds: [], matchUpTieIds: [] });
  if (c.length > 1 || l.length > 1 || u.length > 1 || d.length > 1) return W({ info: "matchUpType, structureId and roundNumber must be equivalent", result: { error: ie }, stack: i });
  let p, f, m = {}, h = [], g = [];
  if (!r.every(({ orderOfFinish: v, matchUpId: S }) => (h.push(S), v && g.push(v), m[S] = v, p = o.includes(S), f = v === void 0 || ke(v) && Math.floor(v) > 0, p && f))) return W({ result: { error: p ? ie : Vc }, info: !p && "matchUps must be completed" || !f && "orderOfFinish must be integer > 0 or undefined" || void 0, stack: i });
  let I = n == null ? void 0 : n.filter((v) => v.structureId === d[0] && v.roundNumber === u[0] && v.matchUpType === c[0] && v.matchUpTieId === l[0] && !h.includes(v.matchUpId));
  for (let v of I ?? []) {
    let { orderOfFinish: S } = v || {};
    if (S) {
      if (!ke(S)) return W({ context: { orderOfFinish: S, matchUp: v }, result: { error: ie }, stack: i });
      g.push(S);
    }
  }
  if (OP(g).length !== g.length || Math.max(...g) > g.length) return W({ info: "Values not unique or greater than expected number of values", result: { error: ie }, stack: i });
  if (d.length) {
    let v = Am({ matchUpFilters: { matchUpIds: s }, structureId: d[0], drawDefinition: t, matchUpsMap: a });
    if (v.error) return W({ result: v, stack: i });
    (U = v.completedMatchUps) == null || U.forEach((S) => {
      S.orderOfFinish = m[S.matchUpId], Qe({ tournamentId: e.tournamentId, context: "setOrderOfFinish", drawDefinition: t, matchUp: S });
    });
  }
  return { ...j };
}
function M1(e) {
  return Q_(e);
}
function E1(e) {
  var I, U, v, S;
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, lineUps: n, event: a } = e, o = "applyLineUps", s = Ae(e, [{ [fr]: !0, [ii]: !0, [zn]: !0 }, { lineUps: !0, [ui]: Gr }], o);
  if (s.error) return s;
  let c = t.participants || [], u = bt({ tournamentParticipants: c, inContext: !0, drawDefinition: r, matchUpId: i });
  if (u.error) return u;
  if (!u.matchUp) return { error: jr };
  let { matchUp: d, structure: l } = u, { drawPositions: p, matchUpType: f } = d;
  if (f !== yt) return { error: gi };
  if (!(p != null && p.length)) return { error: ad };
  let m = (I = Yr({ matchUp: d, drawDefinition: r, structure: l, event: a })) == null ? void 0 : I.tieFormat, h = {};
  for (let T of n) {
    if (!Array.isArray(T)) return { error: ie, lineUp: T };
    let A = {}, y = [];
    for (let b of T) {
      if (typeof b != "object") return { error: ie, lineUpAssignment: b };
      let { participantId: E, collectionAssignments: O = [] } = b;
      if (!Array.isArray(O)) return { error: ie, collectionAssignments: O };
      let M = c.find((C) => C.participantId === E);
      if (!M) return { error: Yt };
      if (M.participantType !== Xe) return { error: Nn };
      let N = (v = (U = d.sides) == null ? void 0 : U.find((C) => {
        var F, x;
        return (x = (F = C.participant) == null ? void 0 : F.individualParticipantIds) == null ? void 0 : x.includes(E);
      })) == null ? void 0 : v.sideNumber;
      N && y.push(N);
      for (let C of O) {
        if (typeof C != "object") return { error: ie, collectionAssignment: C };
        let { collectionId: F, collectionPosition: x } = C, V = (S = m == null ? void 0 : m.collectionDefinitions) == null ? void 0 : S.find((B) => B.collectionId === F);
        if (!V) return { error: ie, collectionId: F };
        let k = `${F}-${x}`;
        A[k] || (A[k] = []);
        let L = A[k].length;
        if (Kt(mt)(V.matchUpType) && L || V.matchUpType === ft && L > 1) return { info: "Excessive collectionPosition assignments", error: ie };
        A[k].push(E);
      }
    }
    let D = Object.values(A);
    for (let b of D) if (b.length === 2) {
      let { participant: E } = vn({ tournamentParticipants: c, participantIds: b });
      if (!E) {
        let O = Yn({ participant: { participantType: _e, participantRole: Cr, individualParticipantIds: b }, pairOverride: !0, tournamentRecord: t });
        if (O.error) return O;
      }
    }
    let P = wi(y), w = (P[1] || 0) > (P[2] || 0) && 1 || (P[2] || 0) > (P[1] || 0) && 2 || void 0, R = Object.keys(h).map((b) => parseInt(b));
    w && !R.includes(w) && (h[w] = T);
  }
  if (!Object.keys(h).length) return { error: xI };
  if (u = bt({ drawDefinition: r, matchUpId: i }), u.error) return u;
  if (!u.matchUp) return { error: jr };
  let { matchUp: g } = u;
  g.sides || (g.sides = []);
  for (let T of [1, 2]) {
    let A = g.sides.find((D) => D.sideNumber === T), y = h[T];
    if (y) A ? A.lineUp = y : g.sides.push({ lineUp: y, sideNumber: T });
    else continue;
  }
  return Qe({ tournamentId: t == null ? void 0 : t.tournamentId, context: o, drawDefinition: r, matchUp: g }), { ...j };
}
var cy = {};
qe(cy, { anonymizeTournamentRecord: () => $1, generate: () => O1, generateEventWithDraw: () => wh, generateOutcome: () => gy, generateOutcomeFromScoreString: () => uy, generateParticipants: () => fu, generateTournamentRecord: () => Q1, modifyTournamentRecord: () => eO, mutate: () => J1 });
var O1 = {};
qe(O1, { generateEventWithDraw: () => wh, generateOutcome: () => gy, generateOutcomeFromScoreString: () => uy, generateParticipants: () => fu, generateTournamentRecord: () => Q1 });
function uy(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, scoreString: n, setTBlast: a } = e;
  if (!n) return { outcome: { ...Om, winningSide: i, matchUpStatus: r } };
  if (i && ![1, 2, void 0].includes(i)) return { error: ie, winningSide: i };
  let o = n && Rp({ scoreString: n }), s = {}, c = ra({ sets: o, matchUpFormat: t, setTBlast: a }), u = ra({ sets: o, reversed: !0, matchUpFormat: t, setTBlast: a });
  return i === 2 ? (s.scoreStringSide1 = u, s.scoreStringSide2 = c) : (s.scoreStringSide1 = c, s.scoreStringSide2 = u), s.sets = Rp({ scoreString: s.scoreStringSide1 }), ye({ outcome: { matchUpStatus: r, winningSide: i, score: s } });
}
function dy({ matchUpScheduleTimes: e, matchUpDependencies: t, allDateMatchUpIds: r, matchUp: i }) {
  var a;
  let n = (((a = t == null ? void 0 : t[i.matchUpId]) == null ? void 0 : a.matchUpIds) || []).filter((o) => r.includes(o)).filter((o) => !e[o]);
  return { dependenciesScheduled: !(n != null && n.length), remainingDependencies: n };
}
function hl({ individualParticipantProfiles: e, participantId: t }) {
  e[t] || (e[t] = { typeChangeTimeAfterRecovery: void 0, timeAfterRecovery: void 0, priorMatchUpType: void 0, potentialRecovery: {}, potentialCounted: {}, potentialBookings: {}, bookings: [], counters: {} });
}
function J_({ individualParticipantProfiles: e, recoveryValue: t, participantId: r, scheduleTime: i, drawId: n }) {
  e[r].potentialRecovery[n] || (e[r].potentialRecovery[n] = []), e[r].potentialRecovery[n].push(t), e[r].potentialBookings[n] || (e[r].potentialBookings[n] = []), e[r].potentialBookings[n].push({ timeAfterRecovery: t, scheduleTime: i });
}
function td({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, typeChangeRecoveryMinutes: r, averageMatchUpMinutes: i = 0, matchUpNotBeforeTimes: n, matchUpDependencies: a, recoveryMinutes: o = 0, scheduleTime: s, matchUp: c }) {
  var m, h;
  let u = Rt((m = c == null ? void 0 : c.schedule) == null ? void 0 : m.endTime), d = u ? fi(u, be(o)) : fi(s, be(i) + be(o)), l = r && (u ? fi(Rt(u), r) : fi(s, be(i) + be(r))), p = ((h = a == null ? void 0 : a[c.matchUpId]) == null ? void 0 : h.participantIds) || [], f = (c.roundPosition && e[c.matchUpId] || []).flat();
  p.forEach((g) => {
    hl({ individualParticipantProfiles: t, participantId: g });
    let I = t[g].priorMatchUpType !== c.matchUpType && l || d;
    f.includes(g) ? J_({ individualParticipantProfiles: t, drawId: c.drawId, recoveryValue: I, participantId: g, scheduleTime: s }) : (t[g].timeAfterRecovery = I, t[g].bookings.push({ scheduleTime: s, timeAfterRecovery: I }));
  }), Cc({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: n, timeAfterRecovery: d, matchUp: c });
}
function C1({ matchUpScheduleTimes: e, matchUpDependencies: t, scheduleTime: r, matchUpId: i, details: n }) {
  var d, l, p, f, m;
  let a, o = (l = (d = n.minutesMap) == null ? void 0 : d[i]) == null ? void 0 : l.recoveryMinutes, s = (((f = (p = n.minutesMap) == null ? void 0 : p[i]) == null ? void 0 : f.averageMinutes) || 0) + (o || 0), c = fi(r, s), u = ((m = t == null ? void 0 : t[i]) == null ? void 0 : m.dependentMatchUpIds) || [];
  if (u.length) {
    let h = u.reduce((g, I) => {
      let U = e[I];
      if (!U) return g;
      let v = { scheduleTime: U, matchUpId: I };
      return U && !g.matchUpId || tt(U) < tt(g.scheduleTime) ? v : g;
    }, {});
    h.scheduleTime && tt(c) > tt(h.scheduleTime) && (a = h);
  }
  return { scheduledDependent: a };
}
function $_(e) {
  let { sides: t, matchUpType: r } = e || {};
  return (t || []).map((i) => {
    var n;
    return r === ft && (((n = i == null ? void 0 : i.participant) == null ? void 0 : n.individualParticipants) || []) || (i == null ? void 0 : i.participant) && [i.participant] || [];
  }).flat();
}
var gl = "DO_NOT_SCHEDULE", eW = { DO_NOT_SCHEDULE: gl };
function ly({ averageMatchUpMinutes: e = 90, requestConflicts: t = {}, potentials: r = !0, personRequests: i, scheduleTime: n, scheduleDate: a, matchUp: o }) {
  let s = $_(o).map(({ person: f }) => f == null ? void 0 : f.personId);
  if (r) {
    let f = ((o == null ? void 0 : o.potentialParticipants) || []).flat().map(({ person: m }) => m == null ? void 0 : m.personId);
    s.push(...f);
  }
  let c = s.map((f) => {
    var m;
    return (m = i[f]) == null ? void 0 : m.map((h) => ({ ...h, personId: f }));
  }).filter(Boolean).flat().filter((f) => f.requestType === gl && aa(a, f.date)), u = [], d = o == null ? void 0 : o.matchUpId, l = rr(Rt(n), Ve(a)), p = Rt(ZI(l, e).toISOString());
  for (let f of c) {
    let { requestId: m, startTime: h, endTime: g } = f;
    (n > h && n < g || p > h && p < g) && (u.push({ matchUpId: d, request: f, scheduleTime: n }), t[m] ? (t[m].scheduleTimes.includes(n) || t[m].scheduleTimes.push(n), t[m].matchUpIds.includes(d) || t[m].matchUpIds.push(d)) : t[m] = { request: f, scheduleTimes: [n], matchUpIds: [d] });
  }
  return { conflicts: u };
}
function oI({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUp: r, value: i }) {
  let { matchUpType: n } = r, { individualParticipantIds: a } = pm(r), o = (e[r.matchUpId] || []).filter((s) => !Jr(s, a)).flat();
  [...a, ...o].forEach((s) => {
    if (hl({ individualParticipantProfiles: t, participantId: s }), !t[s].potentialCounted[r.drawId]) {
      let c = t[s].counters;
      c[n] ? c[n] += i : i > 0 && (c[n] = i), c[mn] ? c[mn] += i : i > 0 && (c[mn] = i), o.includes(s) && (t[s].potentialCounted[r.drawId] = !0);
    }
  });
}
function tW({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: r, greatestAverageMinutes: i, dateScheduledMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, matchUpDependencies: s, clearScheduleDates: c, scheduleDate: u, minutesMap: d, matchUps: l }) {
  var h, g;
  let p = [];
  r || (n = l == null ? void 0 : l.filter((I) => {
    let U = I.schedule || {}, v = I.matchUpStatus === at;
    return v && p.push({ tournamentId: I.tournamentId, matchUpId: I.matchUpId }), !v && cl({ schedule: U }) && (!u || I.schedule.scheduledDate === u);
  }), r = n.map(hr));
  let f = Array.isArray(c) ? c.includes(u) : c, m = f ? [] : l.filter(({ matchUpId: I }) => r.includes(I));
  for (let I of m) {
    oI({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, value: 1, matchUp: I });
    let U = (h = I.schedule) == null ? void 0 : h.scheduledTime;
    if (U) {
      o[I.matchUpId] = U;
      let v = (g = d == null ? void 0 : d[I.matchUpId]) == null ? void 0 : g.recoveryMinutes;
      td({ individualParticipantProfiles: t, matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: a, matchUpDependencies: s, averageMatchUpMinutes: i, recoveryMinutes: v, scheduleTime: U, matchUp: I });
    }
  }
  return { dateScheduledMatchUpIds: r, byeScheduledMatchUpDetails: p, dateScheduledMatchUps: n, clearDate: f };
}
function Ah({ defaultRecoveryMinutes: e = 0, averageMatchUpMinutes: t = 90, dateScheduledMatchUps: r, tournamentRecords: i, venueIds: n = [], periodLength: a, scheduleDate: o, matchUps: s }) {
  if (typeof i != "object") return { error: xt };
  if (!rn(s) && !Array.isArray(r)) return { error: Ma };
  a = a ?? hh({ recoveryMinutes: e, averageMatchUpMinutes: t });
  let c = Object.assign({}, ...Object.values(i).map((l) => (l.events ?? []).map((p) => {
    let { scheduleTiming: f } = Pd({ tournamentRecord: l, event: p });
    return { [p.eventId]: { event: p, scheduleTiming: f } };
  })).flat()), u = { averageTimes: [{ minutes: { default: t } }], recoveryTimes: [{ minutes: { default: e } }] };
  r || (r = s == null ? void 0 : s.filter((l) => {
    let p = l.schedule;
    return cl({ schedule: p }) && (!o || l.schedule.scheduledDate === o);
  }));
  let d = r == null ? void 0 : r.filter((l) => (!n.length || n.includes(l.schedule.venueId)) && l.matchUpStatus !== at);
  return { bookings: d == null ? void 0 : d.map(({ eventId: l, schedule: p, matchUpFormat: f }) => {
    let { event: m, scheduleTiming: h } = c[l], g = m == null ? void 0 : m.eventType, I = { ...h, defaultTiming: u, matchUpFormat: f }, { averageMinutes: U, recoveryMinutes: v } = vm({ timingDetails: I, eventType: g }), { courtId: S, venueId: T } = p, A = Rt(p.scheduledTime), y = fi(A, U);
    return { recoveryMinutes: v, averageMinutes: U, periodLength: a, startTime: A, courtId: S, endTime: y, venueId: T };
  }).filter(Boolean), relevantMatchUps: d, dateScheduledMatchUps: r };
}
function rW({ calculateStartTimeFromCourts: e = !0, remainingScheduleTimes: t, defaultRecoveryMinutes: r, averageMatchUpMinutes: i, clearScheduleDates: n, tournamentRecords: a, tournamentRecord: o, periodLength: s, scheduleDate: c, startTime: u, venueIds: d, matchUps: l, endTime: p }) {
  if (o && !a && (a = { [o.tournamentId]: o }), typeof a != "object" || !Object.keys(a).length) return { error: xt };
  s = s ?? hh({ recoveryMinutes: r, averageMatchUpMinutes: i });
  let { courts: f, venues: m } = xa({ dates: [c], ignoreDisabled: !0, tournamentRecords: a }), h = (f == null ? void 0 : f.filter((T) => !d || d.includes(T.venueId))) ?? [];
  u = u ?? Fc({ courts: h, scheduleDate: c, startTime: !0 }), p = p ?? Fc({ courts: h, scheduleDate: c, endTime: !0 });
  let { bookings: g, dateScheduledMatchUps: I } = Ah({ defaultRecoveryMinutes: r, averageMatchUpMinutes: i, tournamentRecords: a, scheduleDate: c, periodLength: s, venueIds: d, matchUps: l }), U = { calculateStartTimeFromCourts: e, remainingScheduleTimes: t, averageMatchUpMinutes: i, clearScheduleDates: n, date: c, periodLength: s, startTime: u, bookings: g, endTime: p, courts: h }, { scheduleTimes: v } = zS(U), S = (d == null ? void 0 : d.length) === 1 && d[0] || (m == null ? void 0 : m.length) === 1 && m[0].venueId || void 0;
  return { dateScheduledMatchUpIds: I == null ? void 0 : I.map(Ni("matchUpId")), dateScheduledMatchUps: I, scheduleTimes: v, venueId: S };
}
function iW({ scheduledRoundsDetails: e, greatestAverageMinutes: t, garmanSinglePass: r }) {
  let i = [], n = [], a, o, s, c;
  for (let u of e.filter(Boolean)) c || (c = u.hash), (u.hash === c || r) && (n = n.concat(u.matchUpIds)), u.hash !== c && !r && (c = u.hash, i.push({ averageMinutes: s, recoveryMinutes: o, roundPeriodLength: a, matchUpIds: n }), n = u.matchUpIds), s = r ? t : u.averageMinutes, o = u.recoveryMinutes, a = u.roundPeriodLength;
  return n.length && i.push({ matchUpIds: n, roundPeriodLength: a, recoveryMinutes: o, averageMinutes: s }), { groupedRounds: i };
}
function F1({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, scheduleCompletedMatchUps: r, containedStructureIds: i, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, tournamentRecords: c, periodLength: u, scheduleDate: d, useGarman: l, matchUps: p, courts: f, venues: m }) {
  var v;
  let h = {}, g = [], I = [], U = [];
  for (let S of m) {
    let { rounds: T = [], venueId: A } = S, { scheduledRoundsDetails: y, greatestAverageMinutes: D, orderedMatchUpIds: P, minutesMap: w } = ol({ scheduleCompletedMatchUps: r, containedStructureIds: i, tournamentRecords: c, periodLength: u, matchUps: p, rounds: T });
    U.push(...P ?? []);
    let { groupedRounds: R } = iW({ scheduledRoundsDetails: y, greatestAverageMinutes: D, garmanSinglePass: !0 }), b, E = [];
    l && ({ scheduleTimes: E, dateScheduledMatchUpIds: b } = rW({ averageMatchUpMinutes: (v = R[0]) == null ? void 0 : v.averageMinutes, scheduleDate: Ve(d), venueIds: [S.venueId], clearScheduleDates: s, tournamentRecords: c, periodLength: u, matchUps: p }));
    let O = tW({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: b, greatestAverageMinutes: D, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, scheduleDate: d, minutesMap: w, matchUps: p });
    ({ dateScheduledMatchUpIds: b } = O);
    let M = O, { byeScheduledMatchUpDetails: N, clearDate: C } = O;
    N != null && N.length && I.push(...N);
    let { matchUpsToSchedule: F, matchUpMap: x } = eh({ matchUpPotentialParticipantIds: e, scheduleCompletedMatchUps: r, dateScheduledMatchUpIds: b, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, orderedMatchUpIds: P, clearDate: C, matchUps: p }), V = f.filter((k) => k.venueId === A);
    h[A] = { previousRemainingScheduleTimes: [], courtsCount: V.length, greatestAverageMinutes: D, scheduledRoundsDetails: y, dateScheduledMatchUps: M, matchUpsToSchedule: F, scheduleTimes: E, groupedRounds: R, venueCourts: V, minutesMap: w, matchUpMap: x }, s || g.push(...b);
  }
  return { allDateScheduledByeMatchUpDetails: I, allDateScheduledMatchUpIds: g, venueScheduledRoundDetails: h, allDateMatchUpIds: U };
}
function nW(e, t) {
  let r = tt(e.scheduleTime), i = tt(e.timeAfterRecovery), n = tt(t.scheduleTime), a = tt(t.timeAfterRecovery), o = r === n || i === a, s = r > n && r < a, c = n > r && n < i, u = i > n && i < a, d = a > r && a < i;
  return ye({ hasOverlap: o || s || u || c || d, startAisContained: s, endAisContained: u, startBisContained: c, endBisContained: d }, !0);
}
function py({ individualParticipantProfiles: e, matchUpNotBeforeTimes: t, matchUpDependencies: r, scheduleTime: i, matchUp: n, details: a }) {
  var p, f, m, h, g;
  let o = (((p = r == null ? void 0 : r[n.matchUpId]) == null ? void 0 : p.participantIds) || []).flat(), s = ((m = (f = a == null ? void 0 : a.minutesMap) == null ? void 0 : f[n.matchUpId]) == null ? void 0 : m.averageMinutes) || 0, c = ((g = (h = a == null ? void 0 : a.minutesMap) == null ? void 0 : h[n.matchUpId]) == null ? void 0 : g.recoveryMinutes) || 0, u = o.every((I) => {
    var T;
    hl({ individualParticipantProfiles: e, participantId: I });
    let U = e[I];
    if (!U.timeAfterRecovery) return !0;
    let v = Rt((T = n == null ? void 0 : n.schedule) == null ? void 0 : T.endTime), S = v ? fi(v, be(c)) : fi(i, be(s) + be(c));
    return ![...Object.keys(U.potentialBookings).filter((A) => A !== n.drawId).map((A) => U.potentialBookings[A]).flat(), ...U.bookings].find((A) => nW({ scheduleTime: i, timeAfterRecovery: S }, A).hasOverlap);
  }), d = t[n.matchUpId], l = (d ? ld(rr(d), rr(i), !1) : 0) >= 0;
  return { enoughTime: u && l };
}
function k1({ autoSchedulingAudit: e, tournamentRecords: t }) {
  var o;
  Le({ topic: va, payload: e });
  let r = (s) => s ? Object.values(s).reduce((c, u) => c + u.length || 0, 0) : 0, i = ((e == null ? void 0 : e.schedulingProfile) || []).reduce((s, c) => s + c.venues.reduce((u, d) => u + d.rounds.length, 0), 0), n = { scheduledDatesCount: (o = e.scheduledDates) == null ? void 0 : o.length, noTimeMatchUpIdsCount: r(e == null ? void 0 : e.noTimeMatchUpIds), scheduledMatchUpIdsCount: r(e == null ? void 0 : e.scheduledMatchUpIds), overLimitMatchUpIdsCount: r(e == null ? void 0 : e.overLimitMatchUpIds), requestConflictsCount: r(e == null ? void 0 : e.requestConflicts), profileRoundsCount: i }, a = { itemType: rI, itemValue: n };
  for (let s of Object.values(t)) {
    let c = s.tournamentId;
    _f(va) ? Le({ payload: { type: rI, tournamentId: c, detail: n }, topic: va }) : el({ tournamentRecord: s, timeItem: a });
  }
}
function fy({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUpDailyLimits: r = {}, matchUp: i }) {
  let { enteredIndividualParticipantIds: n } = pm(i), { matchUpId: a, matchUpType: o } = i, s = (i.roundPosition && e[a] || []).flat(), c = Be(n.concat(...s));
  return c.forEach((u) => {
    hl({ individualParticipantProfiles: t, participantId: u });
  }), { participantIdsAtLimit: c.filter((u) => {
    let d = t[u];
    if (d) return [o, mn].find((l) => {
      var m;
      let p = ((m = d.counters) == null ? void 0 : m[l]) || 0, f = r[l] || 0;
      return p && f && p >= f;
    });
  }), relevantParticipantIds: c };
}
function rd({ scheduleCompletedMatchUps: e = !1, scheduleByeMatchUps: t = !1, errorOnAnachronism: r = !1, checkChronology: i = !0, matchUpDependencies: n, removePriorValues: a, tournamentRecords: o, tournamentRecord: s, matchUpDetails: c, matchUpIds: u, schedule: d }) {
  var g, I, U;
  if (!s) return { error: de };
  if (!c && (!u || !Array.isArray(u))) return { error: Ts };
  if (!c && (!d || typeof d != "object")) return { error: kw };
  let l, p = [], f = 0;
  if (i && !n) {
    let v = An({ tournamentRecords: o, tournamentRecord: s });
    n = v.matchUpDependencies, l = v.matchUps;
  }
  l || (l = ((g = Pr({ tournamentRecord: s })) == null ? void 0 : g.matchUps) ?? []);
  let m = l.reduce((v, S) => {
    let { matchUpId: T, drawId: A, matchUpStatus: y } = S;
    return (t || y !== at) && (e || !lr.includes(y)) && (v[A] ? v[A].push(T) : v[A] = [T]), v;
  }, {}), h = c == null ? void 0 : c.map((v) => v.matchUpId);
  for (let v of Object.keys(m)) {
    let { drawDefinition: S } = po({ tournamentRecord: s, drawId: v });
    if (!S) continue;
    let T = m[v].filter((y) => (u == null ? void 0 : u.includes(y)) ?? (h == null ? void 0 : h.includes(y))), A = Qr({ inContext: !1, drawDefinition: S }).matchUps;
    for (let y of T) {
      let D = ((I = c == null ? void 0 : c.find((w) => w.matchUpId === y)) == null ? void 0 : I.schedule) || d, P = yh({ schedule: D, matchUpDependencies: n, errorOnAnachronism: r, removePriorValues: a, inContextMatchUps: l, tournamentRecords: o, tournamentRecord: s, checkChronology: i, drawDefinition: S, drawMatchUps: A, matchUpId: y });
      if ((U = P == null ? void 0 : P.warnings) != null && U.length && p.push(...P.warnings), P != null && P.success && (f += 1), P.error) return P;
    }
  }
  return p.length ? { ...j, scheduled: f, warnings: p } : { ...j, scheduled: f };
}
function Il(e) {
  var m;
  let { scheduleCompletedMatchUps: t = !1, scheduleByeMatchUps: r = !1, errorOnAnachronism: i, matchUpContextIds: n, removePriorValues: a, tournamentRecords: o, checkChronology: s, matchUpDetails: c, schedule: u } = e;
  if (e.matchUpIds && !n) return rd(e);
  let d = Ae(e, [{ [_r]: !0 }, { [Ac]: { matchUpContextIds: !1, matchUpDetails: !1 }, [xi]: ie, [ui]: Gr }]);
  if (d.error) return d;
  if ((!c || n) && !u) return { error: we, info: "schedule is required" };
  let l = [], p = 0, { matchUpDependencies: f } = An({ tournamentRecords: o });
  for (let h of Object.values(o)) {
    let { tournamentId: g } = h, I = n == null ? void 0 : n.filter((v) => v.tournamentId === g).map(hr), U = c == null ? void 0 : c.filter((v) => (v == null ? void 0 : v.tournamentId) === g);
    if (I != null && I.length || U != null && U.length) {
      let v = rd({ matchUpDetails: U, scheduleCompletedMatchUps: t, scheduleByeMatchUps: r, matchUpDependencies: f, errorOnAnachronism: i, removePriorValues: a, tournamentRecords: o, tournamentRecord: h, checkChronology: s, matchUpIds: I, schedule: u });
      if ((m = v.warnings) != null && m.length && l.push(...v.warnings), v.scheduled && (p += v.scheduled), v.error) return v;
    }
  }
  return l.length ? { ...j, scheduled: p, warnings: l } : { ...j, scheduled: p };
}
function aW({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, schedulingProfile: d, personRequests: l, periodLength: p, matchUps: f, courts: m, dryRun: h }) {
  var b, E, O, M, N, C, F;
  let g = {}, I = {}, U = {}, v = {}, S = {}, T = {}, A = {}, y = {}, D = {}, P = {};
  for (let x of n) {
    let V = Ve(x == null ? void 0 : x.scheduleDate), k = (x == null ? void 0 : x.venues) || [], L = {}, B = {}, G = (ee, K) => {
      ee.forEach((J) => {
        let $ = B[J].counters;
        $[K] ? $[K] += 1 : $[K] = 1, $[mn] ? $[mn] += 1 : $[mn] = 1;
      });
    };
    U[V] = {}, v[V] = {}, g[V] = {}, I[V] = {}, A[V] = [], y[V] = [], D[V] = [], P[V] = [];
    let q = {};
    f.forEach((ee) => {
      var K;
      (K = ee.schedule) != null && K.scheduledDate && aa(V, Ve(ee.schedule.scheduledDate)) && Cc({ matchUpPotentialParticipantIds: L, matchUpNotBeforeTimes: q, matchUp: ee });
    });
    let { allDateScheduledByeMatchUpDetails: Y, venueScheduledRoundDetails: H, allDateMatchUpIds: X } = F1({ matchUpPotentialParticipantIds: L, individualParticipantProfiles: B, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: q, matchUpScheduleTimes: T, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, useGarman: !0, periodLength: p, scheduleDate: V, matchUps: f, courts: m, venues: k }), z = 10, Z = 0, te, ne = 10;
    for (; !te; ) {
      for (let { venueId: ee } of k) {
        let K = 0, J = H[ee];
        for (; J.courtsCount && ((b = J.scheduleTimes) != null && b.length) && ((E = J.matchUpsToSchedule) != null && E.length) && K <= J.courtsCount; ) {
          let { scheduleTime: $, attempts: ae = 0 } = J.scheduleTimes.shift(), oe = J.matchUpsToSchedule.find((ce) => {
            var Ye, Ze;
            let { matchUpId: se, matchUpType: Te } = ce, { participantIdsAtLimit: xe, relevantParticipantIds: me } = fy({ matchUpPotentialParticipantIds: L, individualParticipantProfiles: B, matchUpDailyLimits: s, matchUp: ce });
            if (xe.length) return y[V].includes(se) || y[V].push(se), !1;
            let { scheduledDependent: rt } = C1({ matchUpScheduleTimes: T, matchUpDependencies: o, scheduleTime: $, matchUpId: se, details: J });
            if (rt) return !1;
            let { dependenciesScheduled: Ge, remainingDependencies: Bt } = dy({ matchUpScheduleTimes: T, matchUpDependencies: o, allDateMatchUpIds: X, matchUp: ce });
            if (!Ge) return v[V][se] || (v[V][se] = []), v[V][se].push({ scheduleTime: $, remainingDependencies: Bt }), !1;
            let { enoughTime: Ut } = py({ individualParticipantProfiles: B, matchUpNotBeforeTimes: q, matchUpDependencies: o, scheduleTime: $, details: J, matchUp: ce });
            if (!Ut) return U[V][se] || (U[V][se] = []), U[V][se].push({ scheduleTime: $ }), !1;
            let Re = J.greatestAverageMinutes, { conflicts: De } = ly({ potentials: t, averageMatchUpMinutes: Re, requestConflicts: P, personRequests: l, scheduleTime: $, scheduleDate: V, matchUp: ce });
            if (De != null && De.length) return S[V] || (S[V] = []), S[V].push(...De), !1;
            G(me, Te);
            let ve = (Ze = (Ye = J.minutesMap) == null ? void 0 : Ye[se]) == null ? void 0 : Ze.recoveryMinutes;
            return td({ matchUpPotentialParticipantIds: L, individualParticipantProfiles: B, matchUpNotBeforeTimes: q, averageMatchUpMinutes: Re, matchUpDependencies: o, recoveryMinutes: ve, scheduleTime: $, matchUp: ce }), T[se] = $, !0;
          });
          J.matchUpsToSchedule = J.matchUpsToSchedule.filter(({ matchUpId: ce }) => ce !== (oe == null ? void 0 : oe.matchUpId)), oe ? K += 1 : (I[V][ee] || (I[V][ee] = []), I[V][ee].push({ scheduleTime: $, attempts: ae + 1 }));
        }
        (O = J.matchUpsToSchedule) != null && O.length && (I[V][ee] = (M = I[V][ee]) == null ? void 0 : M.filter(($) => {
          let ae = $.attempts < z;
          return ae && J.scheduleTimes.push($), !ae;
        })), (!((N = J.scheduleTimes) != null && N.length) || !((C = J.matchUpsToSchedule) != null && C.length)) && (J.complete = !0);
      }
      Z += 1, te = k.every(({ venueId: ee }) => H[ee].complete) || Z === ne;
    }
    for (let { venueId: ee } of k) {
      let K = H[ee].matchUpMap;
      Object.keys(K).forEach((J) => {
        let $ = u[J];
        $ && Object.keys(K[J]).forEach((ae) => {
          let { drawDefinition: oe } = po({ tournamentRecord: $, drawId: ae });
          oe && K[J][ae].forEach(({ matchUpId: ce }) => {
            let se = T[ce];
            if (se) {
              let Te = se.split(":").map(Yi).join(":"), xe = `${Ve(V)}T${Te}`;
              h ? A[V].push(ce) : (fo({ drawDefinition: oe, scheduledTime: xe, matchUpId: ce }).success && A[V].push(ce), ee && pu({ tournamentRecord: $, drawDefinition: oe, matchUpId: ce, venueId: ee }));
            }
          });
        });
      }), D[V] = H[ee].matchUpsToSchedule.map(hr), g[V][ee] = H[ee].scheduleTimes.sort((J, $) => tt(J.scheduleTime) - tt($.scheduleTime));
    }
    !h && (Y != null && Y.length) && Il({ matchUpDetails: Y, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let ee of x.venues) for (let K of ee.rounds) {
      let J = (((F = K.matchUps) == null ? void 0 : F.map(({ matchUpId: ae }) => ae)) || []).filter((ae) => A[V].includes(ae));
      K.canScheduledMatchUpIds = J;
      let $ = Math.round(J.length / K.matchUpsCount * 1e4) / 100;
      ($ === 1 / 0 || isNaN($)) && ($ = 0), K.possibleToSchedulePct = $, K.matchUpsCount === J.length && (K.possibleToSchedule = !0);
    }
  }
  let w = n.map(({ scheduleDate: x }) => x), R = { timeStamp: Date.now(), overLimitMatchUpIds: y, scheduledMatchUpIds: A, schedulingProfile: d, noTimeMatchUpIds: D, requestConflicts: P, scheduledDates: w };
  return k1({ tournamentRecords: u, autoSchedulingAudit: R }), { ...j, schedulingProfileModifications: e, schedulingProfileIssues: i, scheduleTimesRemaining: g, dateSchedulingProfiles: n, skippedScheduleTimes: I, recoveryTimeDeferredMatchUpIds: U, dependencyDeferredMatchUpIds: v, matchUpScheduleTimes: T, overLimitMatchUpIds: y, scheduledMatchUpIds: A, noTimeMatchUpIds: D, requestConflicts: P, scheduledDates: w };
}
function QT({ averageMinutes: e, startTime: t, endTime: r, court: i, date: n }) {
  if (!Array.isArray(i.dateAvailability)) return { error: we, stack: "getEarliestCourtTime" };
  let a = Fc({ scheduleDate: n, courts: [i], startTime: !0 }), o = Fc({ scheduleDate: n, courts: [i], endTime: !0 });
  t = t || a, r = r || o;
  let s = pl({ court: i, date: n }), { timeSlots: c } = du({ courtDate: s }), u = rr(t), d = rr(r);
  return { earliestCourtTime: c == null ? void 0 : c.reduce((l, p) => {
    let f = rr(p.startTime), m = rr(p.endTime);
    if (f > d || m < u) return l;
    let h = u > f ? u : f;
    if (ld(h, m) >= e) {
      let g = Rt(h.toISOString());
      (!l || g < l) && (l = g);
    }
    return l;
  }, void 0), courtStartTime: a, courtEndTime: o };
}
function oW({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, periodLength: d = 30, schedulingProfile: l, personRequests: p, matchUps: f = [], courts: m, dryRun: h }) {
  var R, b;
  let g = {}, I = {}, U = {}, v = {}, S = {}, T = {}, A = {}, y = {}, D = {};
  for (let E of n ?? []) {
    let O = Ve(E == null ? void 0 : E.scheduleDate), M = (E == null ? void 0 : E.venues) || [], N = {}, C = {}, F = (ee, K) => {
      ee.forEach((J) => {
        let $ = C[J].counters;
        $[K] ? $[K] += 1 : $[K] = 1, $[mn] ? $[mn] += 1 : $[mn] = 1;
      });
    };
    g[O] = {}, I[O] = {}, T[O] = [], A[O] = [], y[O] = [], D[O] = [];
    let x = {};
    f == null || f.forEach((ee) => {
      var K;
      (K = ee.schedule) != null && K.scheduledDate && aa(O, Ve(ee.schedule.scheduledDate)) && Cc({ matchUpPotentialParticipantIds: N, matchUpNotBeforeTimes: x, matchUp: ee });
    });
    let { allDateScheduledByeMatchUpDetails: V, allDateScheduledMatchUpIds: k, venueScheduledRoundDetails: L, allDateMatchUpIds: B } = F1({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: x, matchUpScheduleTimes: S, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, periodLength: d, scheduleDate: O, matchUps: f, courts: m, venues: M }), G = f == null ? void 0 : f.filter(({ matchUpId: ee }) => k.includes(ee)), { bookings: q } = Ah({ dateScheduledMatchUps: G, tournamentRecords: u, scheduleDate: O, periodLength: d }), { virtualCourts: Y } = mh({ scheduleDate: O, periodLength: d, bookings: q, courts: m }), H = Y == null ? void 0 : Y.reduce((ee, K) => {
      let { earliestCourtTime: J, courtEndTime: $ } = QT({ date: O, averageMinutes: 0, court: K });
      return (!ee.startTime || rr(J) < rr(ee.startTime)) && (ee.startTime = J), (!ee.endTime || rr($) > rr(ee.endTime)) && (ee.endTime = $), ee;
    }, {}), X = H.startTime, z = ({ courtId: ee, booking: K }) => {
      var J;
      return (J = Y == null ? void 0 : Y.find(($) => $.courtId === ee)) == null ? void 0 : J.dateAvailability[0].bookings.push(K);
    }, Z = 10, te = 0, ne;
    for (; !ne; ) {
      for (let { venueId: ee } of M) {
        let K = L[ee], J = K.matchUpsToSchedule.length, $ = [], ae = [], oe, ce = 0;
        for (; !oe; ) {
          for (let se of K.matchUpsToSchedule) {
            if (ae.length === K.courtsCount || $.length === K.courtsCount) {
              oe = !0;
              break;
            }
            let { matchUpId: Te, matchUpType: xe } = se, { participantIdsAtLimit: me, relevantParticipantIds: rt } = fy({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, matchUpDailyLimits: s, matchUp: se });
            if (me.length) {
              A[O].includes(Te) || A[O].push(Te);
              continue;
            }
            let { dependenciesScheduled: Ge, remainingDependencies: Bt } = dy({ matchUpScheduleTimes: S, matchUpDependencies: o, allDateMatchUpIds: B, matchUp: se });
            if (!Ge) {
              I[O][Te] || (I[O][Te] = []), I[O][Te].push({ remainingDependencies: Bt });
              continue;
            }
            let Ut = [], Re = Y == null ? void 0 : Y.reduce((De, ve) => {
              var Zt, _t, er, Mt;
              if (ae.includes(ve.courtId)) return De;
              let { earliestCourtTime: Ye } = QT({ averageMinutes: K.greatestAverageMinutes, startTime: X, date: O, court: ve });
              if (De.scheduleTime && tt(Ye) >= tt(De.scheduleTime)) return De;
              let { scheduledDependent: Ze } = C1({ matchUpScheduleTimes: S, matchUpDependencies: o, scheduleTime: Ye, matchUpId: Te, details: K });
              if (Ze) return De;
              let { enoughTime: Nt } = py({ individualParticipantProfiles: C, matchUpNotBeforeTimes: x, matchUpDependencies: o, scheduleTime: Ye, details: K, matchUp: se });
              if (!Nt) return g[O][Te] || (g[O][Te] = []), g[O][Te].includes(Ye) || g[O][Te].push(Ye), De;
              let Tt = ((_t = (Zt = K.minutesMap) == null ? void 0 : Zt[Te]) == null ? void 0 : _t.averageMinutes) || K.greatestAverageMinutes, { conflicts: je } = ly({ potentials: t, averageMatchUpMinutes: Tt, requestConflicts: D, personRequests: p, scheduleTime: Ye, scheduleDate: O, matchUp: se });
              if (je != null && je.length) return Ut.push(...je), !1;
              F(rt, xe);
              let It = (Mt = (er = K.minutesMap) == null ? void 0 : er[Te]) == null ? void 0 : Mt.recoveryMinutes;
              return td({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, matchUpNotBeforeTimes: x, averageMatchUpMinutes: Tt, matchUpDependencies: o, recoveryMinutes: It, scheduleTime: Ye, matchUp: se }), (!De.scheduleTime || tt(Ye) < tt(De.scheduleTime)) && (De.averageMatchUpMinutes = Tt, De.recoveryMinutes = It, De.scheduleTime = Ye, De.courtName = ve.courtName, De.courtId = ve.courtId), De;
            }, {});
            if (Re.scheduleTime) {
              let { averageMatchUpMinutes: De, recoveryMinutes: ve, scheduleTime: Ye, courtId: Ze } = Re;
              S[Te] = Ye, v[Te] = Ze, $.push(Te), ae.push(Ze);
              let Nt = Ye, Tt = fi(Nt, De);
              z({ courtId: Ze, booking: { averageMatchUpMinutes: De, recoveryMinutes: ve, periodLength: d, matchUpId: Te, startTime: Nt, courtId: Ze, endTime: Tt, venueId: ee } }), K.matchUpsToSchedule = K.matchUpsToSchedule.filter((je) => je.matchUpId !== Te);
            } else Ut != null && Ut.length && (U[O] || (U[O] = []), U[O].push(...Ut));
          }
          (ae.length === K.courtsCount || $.length === K.courtsCount || !K.matchUpsToSchedule.length) && (oe = !0), K.matchUpsToSchedule.length && $ < K.courtsCount && (rr(X) < rr(H.endTime) ? X = fi(X, d) : (oe = !0, K.complete = !0)), ce += 1, !oe && ce >= J && (oe = !0);
        }
        (R = K.matchUpsToSchedule) != null && R.length || (K.complete = !0);
      }
      te += 1, ne = M.every(({ venueId: ee }) => L[ee].complete) || te === Z;
    }
    for (let { venueId: ee } of M) {
      let K = L[ee].matchUpMap;
      Object.keys(K).forEach((J) => {
        let $ = u[J];
        $ && Object.keys(K[J]).forEach((ae) => {
          let { drawDefinition: oe } = po({ tournamentRecord: $, drawId: ae });
          oe && K[J][ae].forEach(({ matchUpId: ce }) => {
            let se = S[ce], Te = v[ce];
            if (se) {
              let xe = se.split(":").map(Yi).join(":"), me = `${Ve(O)}T${xe}`;
              h || (fo({ drawDefinition: oe, scheduledTime: me, matchUpId: ce }), Zs({ courtDayDate: O, tournamentRecords: u, tournamentRecord: $, drawDefinition: oe, matchUpId: ce, courtId: Te })), T[O].push(ce);
            }
          });
        });
      }), y[O] = L[ee].matchUpsToSchedule.map(hr);
    }
    !h && (V != null && V.length) && Il({ matchUpDetails: V, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let ee of E.venues) for (let K of ee.rounds) {
      let J = (b = (K.matchUps ?? []).map(({ matchUpId: ae }) => ae)) == null ? void 0 : b.filter((ae) => T[O].includes(ae));
      K.canScheduledMatchUpIds = J;
      let $ = Math.round(((J == null ? void 0 : J.length) || 0) / K.matchUpsCount * 1e4) / 100;
      ($ === 1 / 0 || isNaN($)) && ($ = void 0), K.possibleToSchedulePct = $, K.matchUpsCount === (J == null ? void 0 : J.length) && (K.possibleToSchedule = !0);
    }
  }
  let P = (n ?? []).map(({ scheduleDate: E }) => E), w = { timeStamp: Date.now(), overLimitMatchUpIds: A, scheduledMatchUpIds: T, schedulingProfile: l, noTimeMatchUpIds: y, requestConflicts: D, scheduledDates: P };
  return k1({ tournamentRecords: u, autoSchedulingAudit: w }), { ...j, schedulingProfileModifications: e, schedulingProfileIssues: i, dateSchedulingProfiles: n, recoveryTimeDeferredMatchUpIds: g, dependencyDeferredMatchUpIds: I, matchUpScheduleTimes: S, overLimitMatchUpIds: A, scheduledMatchUpIds: T, noTimeMatchUpIds: y, requestConflicts: D, scheduledDates: P };
}
function Th(e) {
  let { scheduleAttributes: t = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: r = lr, scheduledDates: i, venueIds: n } = e, a = $i(e), o = $e(a) ? Object.values(a).map(({ tournamentId: c }) => c).filter(Boolean) : [];
  if (!(o != null && o.length)) return { error: xt };
  let s = 0;
  for (let c of o) {
    let u = a[c], d = sW({ ignoreMatchUpStatuses: r, scheduleAttributes: t, tournamentRecord: u, scheduledDates: i, venueIds: n });
    if (d.error) return d;
    s += d.clearedScheduleCount ?? 0;
  }
  return { ...j, clearedScheduleCount: s };
}
function sW({ scheduleAttributes: e = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: t = lr, tournamentRecord: r, scheduledDates: i, venueIds: n = [] }) {
  if (typeof r != "object") return { error: de };
  if (!Array.isArray(t) || !Array.isArray(n)) return { error: ie };
  n.length && e.push("venueId");
  let a = Pr({ matchUpFilters: { scheduledDates: i }, tournamentRecord: r }).matchUps ?? [], o = {};
  a.forEach(({ matchUpStatus: u, schedule: d, drawId: l, matchUpId: p }) => {
    (!u || !t.includes(u)) && cl({ schedule: d, scheduleAttributes: e }) && (!(n != null && n.length) || n.includes(d.venueId)) && (o[l] || (o[l] = []), o[l].push(p));
  });
  let s = r.tournamentId, c = 0;
  for (let u in o) {
    let { event: d, drawDefinition: l } = ci({ tournamentRecord: r, drawId: u }), p = Qr({ drawDefinition: l, matchUpFilters: { matchUpIds: o[u] } }).matchUps ?? [];
    for (let f of p) {
      let m = !1;
      f.timeItems = (f.timeItems ?? []).filter((h) => {
        let g = (h == null ? void 0 : h.itemType) && ![ua, Ja, ks, gm, Ls, xs].includes(h == null ? void 0 : h.itemType);
        return g || (m = !0), g;
      }), m && (Qe({ context: "clear schedules", eventId: d == null ? void 0 : d.eventId, drawDefinition: l, tournamentId: s, matchUp: f }), c += 1);
    }
  }
  return { ...j, clearedScheduleCount: c };
}
function Dh(e) {
  let { checkPotentialRequestConflicts: t = !0, scheduleCompletedMatchUps: r, clearScheduleDates: i, scheduleDates: n = [], tournamentRecords: a, periodLength: o, useGarman: s, dryRun: c, pro: u } = e, d = Ae(e, [{ [_r]: !0 }, { [Or]: (P) => !P || Array.isArray(P) && P.every(mi), [rb]: !1, [ui]: Gr }]);
  if (d.error) return d;
  let l = Ba({ tournamentRecords: a });
  if (l.error) return l;
  if (!l.schedulingProfile.length) return { ...j };
  let { modifications: p, issues: f = [], schedulingProfile: m = [] } = l, h = Object.assign({}, ...Object.values(a).map((P) => Zc({ tournamentRecord: P }).containedStructures)), g = n.map((P) => {
    if (mi(P)) return Ve(P);
  }).filter(Boolean), I = m.map((P) => P.scheduleDate).map((P) => mi(P) && Ve(P)).filter((P) => P && (!n.length || g.includes(P)));
  if (!I.length) return { error: lw };
  if (i && !c) {
    let P = Array.isArray(i) ? i : [];
    Th({ tournamentRecords: a, scheduledDates: P });
  }
  let U = xa({ ignoreDisabled: !1, tournamentRecords: a }).courts, { matchUps: v } = On({ matchUpFilters: { matchUpTypes: [mt, ft] }, afterRecoveryTimes: !0, nextMatchUps: !0, tournamentRecords: a }), { matchUpDependencies: S } = An({ includeParticipantDependencies: !0, tournamentRecords: a, matchUps: v }), { matchUpDailyLimits: T } = uh({ tournamentRecords: a }), { personRequests: A } = Qo({ requestType: gl, tournamentRecords: a }), y = m.filter((P) => {
    let w = Ve(P == null ? void 0 : P.scheduleDate);
    return I.includes(w);
  }).sort((P, w) => new Date(P.scheduleDate).getTime() - new Date(w.scheduleDate).getTime()), D = { schedulingProfileModifications: p, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: f, dateSchedulingProfiles: y, containedStructureIds: h, matchUpDependencies: S, matchUpDailyLimits: T, clearScheduleDates: i, tournamentRecords: a, schedulingProfile: m, personRequests: A, periodLength: o, useGarman: s, matchUps: v, dryRun: c, courts: U };
  return u ? oW(D) : aW(D);
}
function Ph(e) {
  let { tournamentRecord: t, tournamentRecords: r, activeTournamentId: i, ...n } = e || {};
  return n.tournamentId || (n.tournamentId = st()), n.startDate && !To(n.startDate) && !rp.test(n.startDate) ? { error: Sr } : n.endDate && !To(n.endDate) && !rp.test(n.endDate) ? { error: Sr } : (n.extensions && (n.extensions = n.extensions.filter(Wn)), { ...n });
}
function my({ addParticipants: e = !0, participantAttribute: t, tournamentRecord: r, personAttribute: i, teamNames: n, accessor: a, uuids: o }) {
  var m, h;
  if (!r) return { error: de };
  let s = {}, c = (r.participants ?? []).filter(({ participantType: g, participantRole: I }) => g === Xe && I === Cr), u = 0;
  for (let g of c) {
    let I = a && ((m = ns({ element: g, accessor: a })) == null ? void 0 : m.value) || i && ((h = g.person) == null ? void 0 : h[i]) || t && g[t];
    if (I) {
      if (!Object.keys(s).includes(I)) {
        s[I] = { participantName: (n == null ? void 0 : n[u]) ?? I, participantId: (o == null ? void 0 : o.pop()) ?? st(), individualParticipantIds: [], participantRole: Cr, participantType: lt };
        let U = { value: i ?? t, name: wg };
        it({ element: s[I], extension: U }), u += 1;
      }
      s[I].individualParticipantIds.push(g.participantId);
    }
  }
  let d = Object.keys(s), l = (r.participants ?? []).map((g) => {
    if (g.participantType !== lt || g.participantRole !== Cr) return;
    let { extension: I } = We({ name: wg, element: g }), U = I == null ? void 0 : I.value;
    if (d.includes(U)) return g.participantId;
  }).filter(Boolean), p = 0, f = [];
  return Object.keys(s).forEach((g) => {
    let I = s[g], { participantId: U } = I;
    l.includes(U) || (r.participants || (r.participants = []), e && r.participants.push(I), f.push(I), p++);
  }), e && p ? (Le({ payload: { tournamentId: r.tournamentId, participants: f }, topic: Xa }), { ...j, participantsAdded: p }) : f.length ? { ...j, newParticipants: f } : { error: QF };
}
var cW = [{ AA: "Annexia" }, { BA: "Bacteria" }, { BO: "Borduria" }, { BM: "Bensalem" }, { BS: "Basenji" }, { BI: "Balnibarbi" }, { BV: "Bartovia" }, { BZ: "Berzerkistan" }, { CA: "Caldonia" }, { CC: "Concordia" }, { CH: "Chula" }, { DA: "Deltora" }, { DW: "Discworld" }, { EA: "Eastasia" }, { EP: "Ecotopia" }, { ER: "Erewhon" }, { FA: "Freedonia" }, { FN: "Florin" }, { FG: "Fogg" }, { FK: "Fourecks" }, { GA: "Genovia" }, { GL: "Gilead" }, { GD: "Gilead" }, { GL: "Gondal" }, { GO: "Gondor" }, { GR: "Gruzinia" }, { GT: "Goritania" }, { GU: "Guilder" }, { HA: "Heldscalla" }, { HO: "Hidalgo" }, { IL: "Illyria" }, { KA: "Kinakuta" }, { KG: "Kangan" }, { KN: "Kreplachistan" }, { KS: "Kallipolis" }, { LH: "Lugash" }, { LI: "Listenbourg" }, { LT: "Lilliput" }, { LU: "Luggnagg" }, { LV: "Lichtenslava" }, { MR: "Moher" }, { NA: "Narnia" }, { NV: "Novaria" }, { OA: "Oceania" }, { OS: "Orsinia" }, { OV: "Octavia" }, { PA: "Palombia" }, { PG: "Penguina" }, { QA: "Qasha" }, { PM: "Panem" }, { SA: "Solymbria" }, { SD: "Syldavia" }, { SG: "San Glucose" }, { SL: "San Lorenzo" }, { SR: "Sontar" }, { SY: "Sylvania" }, { TF: "Tralfamadore" }, { TH: "Themyscira" }, { UA: "Utopia" }, { VA: "Vespugia" }, { WA: "Wakanda" }, { WX: "Wessex" }, { ZA: "Zamunda" }, { ZK: "Zubrowka" }], uW = ["Amber", "Ansul", "Atlantis", "Braavos", "Busytown", "Castle Rock", "Centralia", "Coober Pedy", "Chefchaouen", "Chronopolis", "Damanhur", "Diaspar", "Dictionopolis", "Diomira", "El Dorado", "Elista", "Ephesus", "Gotham", "Hadleyburg", "Hallstatt", "Hierusalem", "Ilium", "Inverness", "Kowloon", "Laputa", "Longyearbyen", "Lys", "Matmata", "Maycomb", "Metropolis", "Miyake-jima", "Monowi", "Nagoro", "Navarre", "New New York", "Nimbin", "Pemberley", "Pseudopolis", "Rivendell", "Roswell", "Shangri-La", "Springfield", "Supilinn", "Thneedville", "Trantor", "Wobegon", "Yonwood", "Xanadu", "Xylar", "Zion"];
function L1({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = Xr(uW), i = r.slice(0, e);
  return { cities: fe(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : yi(i)) };
}
function x1({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = Xr(cW), i = r.slice(0, e).map((n) => Object.keys(n)).flat();
  return { states: fe(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : yi(i)) };
}
function B1({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = fe(0, e).map(() => fe(0, 5).map(() => Hi(0, 9)).join(""));
  return { postalCodes: fe(0, t).map((i) => i < e ? r[i] : yi(r)) };
}
function Ep({ idPrefix: e, participantType: t, index: r, uuids: i }) {
  let n = Et(t) ? t[0] : "X";
  return e ? `${e}-${n}-${r}` : (i == null ? void 0 : i.pop()) || st();
}
function V1(e) {
  let { cities: t, states: r, postalCodes: i, nationalityCode: n, participantIndex: a } = e;
  return { postalCode: i == null ? void 0 : i[a], state: r == null ? void 0 : r[a], city: t == null ? void 0 : t[a], countryCode: n };
}
var dW = { lastNames: ["Abbey", "Ahern", "Ampleforth", "Ananiadis", "Andelic", "Assange", "Atreides", "Austen", "Bach", "Banks", "Barrington", "Batty", "Bauers", "Beals", "Beer", "Bennett", "Berry", "Bonaparte", "Brewer", "Brockovich", "Bukowski", "Cassidy", "Catton", "Calvino", "Carlin", "Carson", "Chip", "Constant", "Crane", "Crowne", "Cummings", "Curie", "Dallas", "Diamond", "Deckard", "Drazic", "Dunbar", "Earhart", "Eisenstein", "Eldritch", "Elliot", "Ellul", "Escher", "Eyre", "Faulkner", "Fulcher", "Fukuoka", "Godel", "Goldstein", "Greer", "Hedges", "Herbert", "Holmgren", "Humperdinck", "Huxley", "Illich", "Jeffers", "Jensen", "Jevons", "Johnson", "Johnstone", "Jovovich", "Kingsnorth", "Langer", "Fernwright", "Fuller", "Le Guin", "Lem", "Lovelace", "Mander", "McLuhan", "Midgely", "Mond", "Montoya", "Moore", "Murry", "Nagle", "Nearing", "Ogden", "Ophuls", "Parks", "Paz", "Peet", "Perfect", "Pendejo", "Pevensie", "Postman", "Ripley", "Rodda", "Rumfoord", "Runciter", "Rugen", "Sale", "Schumacher", "Shaftoe", "Shelley", "Shepard", "Smith", "Stratton", "Stewart", "Swift", "Tillich", "Turing", "Tyrell", "Twain", "Yeats", "Veblen", "Yates", "Vonnegut", "Waterhouse", "Watson", "Wolin", "Wirt", "Waschuk", "Wormwood"], firstFemale: ["Ada", "Amelia", "Amelie", "America", "Anne", "Antonia", "Aravis", "Astrid", "Beatrice", "Brienne", "Buttercup", "Caitlin", "Cimorene", "Cordelia", "Desdemona", "Ellen", "Elizabeth", "Emily", "Emmie", "Erin", "Eva", "Evelyn", "Heather", "Helen", "Hermia", "Hypatia", "Imogen", "Jane", "Jasmine", "Juliana", "Juliet", "Katniss", "Leeloo", "Lenina", "Lilith", "Linda", "Lizzie", "Louise", "Lucy", "Marie", "Mary", "Martha", "Matilda", "Milla", "Miranda", "Meg", "Melba", "Nicole", "Ola", "Portia", "Pris", "Rachael", "Rachel", "Rebecca", "River", "Rosa", "Rosalind", "Scout", "Sharn", "Susanne", "Titania", "Uhura", "Ursula", "Valentina", "Viola", "Virginia", "Xena", "Zoe"], firstMale: ["Alan", "Aldous", "August", "Axel", "Barda", "Barry", "Bill", "Bruce", "Charles", "Chris", "Constantine", "Darwin", "David", "Derrick", "Edward", "Emmanuel", "Ernst", "Estlin", "Fezzik", "Filby", "Frank", "Frito", "George", "Glen", "Helmholtz", "Inigo", "Italo", "Ivan", "Jacques", "James", "Jared", "Jerry", "Joe", "Johann", "Julian", "John Michael", "Jonathan", "Korben", "Kirkpatrick", "Kurt", "Lief", "Malachi", "Mark", "Marhsall", "Masanobu", "Maurits", "Michael", "Mustapha", "Neil", "Nikola", "Octavio", "Palmer", "Paul", "Pierre", "Robinson", "Rick", "Rincewind", "Roy", "Shannon", "Sheldon", "Stafford", "Stanislaw", "Stanley", "Syme", "Thorstein", "Thomas", "Tyrone", "Vizzini", "Walton", "Walker", "Warren", "Wendell", "Westley", "William", "Winston", "Zoran"] };
function tg(e) {
  let { count: t = 100, sex: r } = e || {};
  if (!t || r && ![pt, St].includes(r)) return { personData: [], error: ie };
  let i = Math.ceil(t * 1.3), { lastNames: n, firstFemale: a, firstMale: o } = dW, s = is.map(({ iso: h }) => h).filter(Boolean), c = Math.ceil(i / n.length), u = Math.ceil(i / a.length), d = Math.ceil(i / o.length), l = fe(0, c).flatMap(() => {
    let h = ge(n, !1, !0);
    return fe(0, n.length).map(() => Di(h));
  }), p = fe(0, u).flatMap(() => {
    let h = ge(a, !1, !0);
    return fe(0, a.length).map(() => Di(h));
  }), f = fe(0, d).flatMap(() => {
    let h = ge(o, !1, !0);
    return fe(0, o.length).map(() => Di(h));
  }), m = {};
  for (let h = 0; h < i; h++) {
    let g = l.pop(), I = r || yi([pt, St]), U = I === pt ? f.pop() : p.pop(), v = yi(s);
    m[`${U}${g}`] = { nationalityCode: v, sex: I, firstName: U, lastName: g };
  }
  return { personData: Object.values(m).slice(0, t) };
}
function G1(e) {
  let t = (e == null ? void 0 : e.count) || 1, { personExtensions: r, consideredDate: i, isMock: n = !0, gendersCount: a, personData: o, category: s, sex: c } = e || {};
  if (isNaN(t)) return { error: ie };
  let u = (a == null ? void 0 : a[pt]) || c === pt && t || 0, d = (a == null ? void 0 : a[St]) || c === St && t || 0;
  t = Math.max(t, u + d);
  let l = t - (u + d), p = u && tg({ count: u, sex: pt }).personData || [], f = d && tg({ count: d, sex: St }).personData || [], m = [...p, ...f, ...l && tg({ count: l }).personData || []], h = m.filter((D) => !c || u && d || D.sex === c), g = [];
  if (Array.isArray(o)) {
    let D = o.filter((P) => typeof P.firstName != "string" || typeof P.lastName != "string" || P.sex && ![pt, St].includes(P.sex) || P.nationalityCode && (typeof P.nationalityCode != "string" || P.nationalityCode.length > 3 || !is.find(({ iso: w, ioc: R }) => [w, R].includes(P.nationalityCode))) ? !1 : (P.nationalityCode && g.push(P.nationalityCode), !0));
    if (D.length) h = D;
    else return { error: ie };
  }
  let I = o ? h : Xr(h);
  if (I.length < t) {
    let { maleFirstNames: D, maleLastNames: P, femaleFirstNames: w, femaleLastNames: R, nationalityCodes: b } = m.reduce((E, O) => {
      let { firstName: M, lastName: N, nationalityCode: C } = O;
      return O.sex === pt ? (E.maleFirstNames.includes(M) || E.maleFirstNames.push(M), E.maleLastNames.includes(N) || E.maleLastNames.push(N)) : (E.femaleFirstNames.includes(M) || E.femaleFirstNames.push(M), E.femaleLastNames.includes(N) || E.femaleLastNames.push(N)), E.nationalityCodes.includes(C) || E.nationalityCodes.push(C), E;
    }, { maleFirstNames: [], maleLastNames: [], femaleFirstNames: [], femaleLastNames: [], nationalityCodes: [] });
    fe(0, t - I.length).forEach(() => {
      let E = c || yi([pt, St]), O = yi(b), M = yi(E === pt ? D : w), N = yi(E === pt ? P : R), C = { firstName: M, lastName: N, sex: E, nationalityCode: O };
      I.push(C);
    });
  }
  let { ageMinDate: U, ageMaxDate: v } = fs({ consideredDate: i, category: s }), S = be((U == null ? void 0 : U.slice(0, 4)) || 0) || be((v == null ? void 0 : v.slice(0, 4)) || 0) - 3, T = be((v == null ? void 0 : v.slice(0, 4)) || 0) || be((U == null ? void 0 : U.slice(0, 4)) || 0) + 3, A = (U || v) && [S, T], y = I.slice(0, t).map((D, P) => {
    let [w, R] = A || [], b = A && Di(fe(w, R)), E = Di(fe(0, 365)), O = b && Hk(b, E);
    return Object.assign(ye({ extensions: r || [{ name: "regionCode", value: P + 1 }], birthDate: O, isMock: n }), D);
  });
  return { persons: y.length && y || I[0], nationalityCodes: g };
}
var lW = ["Ace Academy", "Avengers", "Ball Bouncers", "Baseliners", "Captivators", "Civil Disobedients", "Continentals", "Court Royal", "Court Sharks", "Diamond Dogs", "Danger Zone", "Doubles Dominators", "Double Faults", "Tricksters", "Eliminators", "Court Crusaders", "Fuzz Busters", "Game Changers", "Goal Gurus", "Good Volley", "Green Machine", "Hawk Eyes", "Inside Outers", "Killer Instinct", "Line Toers", "Masters of Mayhem", "Matter Catchers", "Cheap Shot", "Mean Machines", "Mindspace Invaders", "Net Centric", "Net Positive", "Smash Mullet", "Over Your Head", "Spin Meisters", "Aggressors", "Racket Machine", "Slice Happy", "Refs Nightmare", "Sandeaters", "Sun Seekers", "Slicer Dicers", "Stacked Deck", "Cross Stringers", "The Emergence", "Total Demolition", "Touch and Go", "Unreturnables", "Upside Downers", "Vertically Challenged", "Visual Spectacle"];
function Op({ nameRoot: e = "TEAM", count: t = 1 } = {}) {
  let r = Xr(lW).slice(0, t);
  return r.length < t && fe(0, t - r.length).forEach((i) => r.push(`${e} ${i + 1}`)), { names: r };
}
function fu(e) {
  let { scaledParticipantsCount: t, rankingRange: r } = e, { ratingsParameters: i = Ur, valuesInstanceLimit: n, ratingsValues: a = [], consideredDate: o, categories: s, category: c, nationalityCodesCount: u, nationalityCodeType: d, nationalityCodes: l, participantsCount: p = 32, participantType: f, teamSize: m = 8, personIds: h, idPrefix: g, uuids: I, personExtensions: U, addressProps: v, gendersCount: S, matchUpType: T, personData: A, sex: y, inContext: D, withISO2: P, withIOC: w, scaleAllParticipants: R } = e, b = f === _e || T === Ao, E = f === lt || T === lt;
  r && (!Array.isArray(r) || !r.every((me) => jt(me)) || r.length !== 2) && (r = void 0), t = R ? p : t;
  let O = 1e3, M = t && t > O ? t : O;
  r = r || [1, M], r[1] += 1;
  let N = p * (b && 2 || E && (m ?? 8) || 1), C = G1({ count: N, personExtensions: U, consideredDate: o, gendersCount: S, personData: A, category: c, sex: y });
  if (C.error) return C;
  let { nationalityCodes: F, persons: x } = C, V = {}, k = {}, L = {}, B = {}, G = (me) => {
    Object.assign(V, me.doublesRankings), Object.assign(k, me.singlesRankings), Object.assign(B, me.doublesRatings), Object.assign(L, me.singlesRatings);
  };
  if ($e(c)) {
    let me = JT({ scaledParticipantsCount: t, ratingsParameters: i, participantType: f, ratingsValues: a, rankingRange: r, category: c });
    G(me);
  }
  Array.isArray(s) && s.forEach((me) => {
    let rt = JT({ scaledParticipantsCount: t, ratingsParameters: i, participantType: f, ratingsValues: a, rankingRange: r, category: me });
    G(rt);
  });
  let q = is.filter((me) => d === "IOC" && me.ioc || me.iso);
  function Y(me) {
    let rt = Math.ceil(N / me);
    return n && rt > n ? Math.ceil(N / n) : me;
  }
  let { postalCodesProfile: H, postalCodesCount: X, statesProfile: z, citiesProfile: Z, citiesCount: te, statesCount: ne } = v || {}, ee = (me) => Object.keys(me).map((rt) => fe(0, z[rt]).map(() => rt)).flat(), K = Z && ee(Z) || (v == null ? void 0 : v.cities) || L1({ count: te || N, participantsCount: N }).cities, J = z && ee(z) || (v == null ? void 0 : v.states) || x1({ count: ne || N, participantsCount: N }).states, $ = H && ee(H) || (v == null ? void 0 : v.postalCodes) || B1({ count: X || N, participantsCount: N }).postalCodes, ae = { cities: K, states: J, postalCodes: $ }, oe = Y(u), ce = oe ? Xr(q).slice(0, u) : l && q.filter((me) => l.includes(me.iso)) || q, se = Xr(fe(0, Math.ceil(N / (oe || 1))).map(() => ce).flat(1 / 0)), Te = Op({ count: p }).names;
  return { participants: fe(0, p).map((me) => {
    let rt = b && 2 || E && (m ?? 8) || 1, Ge = fe(0, rt).map((ve) => {
      let Ye = me * rt + ve;
      return xe(Ye);
    }), Bt = Ge.map((ve) => ve.participantId), Ut = Ge.map((ve) => ve.person.standardFamilyName).join("/"), Re = b ? _e : lt, De = { participantId: Ep({ participantType: Re, index: me, idPrefix: g, uuids: I }), participantName: b ? Ut : Te[me], participantRole: Cr, individualParticipantIds: Bt, participantType: Re };
    return D && (De.individualParticipants = Ge), b || E ? [De, ...Ge] : Ge;
  }).flat(), ...j };
  function xe(me) {
    let rt = x[me], { nationalityCode: Ge, participantExtensions: Bt, participantTimeItems: Ut, extensions: Re, firstName: De, birthDate: ve, lastName: Ye, personId: Ze, sex: Nt } = rt || {}, Tt = De || "GivenName", je = Ye || "FamilyName", It = `${Tt} ${je}`, Zt = se[me], _t = (F == null ? void 0 : F.length) && Ge || Zt && (d === "IOC" ? Zt.ioc || Zt.iso : Zt.iso || Zt.ioc) || Ge;
    se != null && se.length && !_t && !Ge && console.log("%c Invalid Nationality Code", { participantIndex: me, country: Zt });
    let er = V1({ ...ae, participantIndex: me, nationalityCode: _t }), Mt = ye({ participantId: Ep({ participantType: Xe, index: me, idPrefix: g, uuids: I }), extensions: Bt, timeItems: Ut, participantRole: Cr, participantType: Xe, participantName: It, person: { personId: Ze || (h == null ? void 0 : h.length) && h[me] || st(), birthDate: mi(ve) ? ve : void 0, addresses: [er], standardFamilyName: je, standardGivenName: Tt, nationalityCode: _t, extensions: Re, sex: Nt } });
    if (w && _t) {
      let Me = is.find(({ iso: Ot }) => Ot === _t);
      Me != null && Me.ioc && (Mt.person.iocNationalityCode = Me.ioc), Me != null && Me.label && (Mt.person.countryName = Me.label);
    }
    if (P && _t) {
      let Me = is.find(({ iso: Ot }) => Ot === _t);
      Me != null && Me.iso2 && (Mt.person.iso2NationalityCode = Me.iso2), Me != null && Me.label && (Mt.person.countryName = Me.label);
    }
    let He = (Me) => {
      var Ee, ir, Oe, ot;
      let Ot = Me.categoryName || Me.ratingType || Me.ageCategoryCode, vr = (Ee = k[Ot]) == null ? void 0 : Ee[me], Dt = (ir = V[Ot]) == null ? void 0 : ir[me];
      El({ scaleValue: vr, eventType: ms, scaleType: Ya, participant: Mt, category: Me }), El({ scaleValue: Dt, eventType: ya, scaleType: Ya, participant: Mt, category: Me });
      let mr = (Oe = L[Ot]) == null ? void 0 : Oe[me], qr = (ot = B[Ot]) == null ? void 0 : ot[me];
      El({ scaleValue: mr, eventType: ms, scaleType: qa, participant: Mt, category: Me }), El({ scaleValue: qr, eventType: ya, scaleType: qa, participant: Mt, category: Me });
    };
    return Array.isArray(s) ? s.forEach((Me) => He(Me)) : c && He(c), Mt;
  }
}
function El({ scaleValue: e, participant: t, eventType: r, scaleType: i, category: n }) {
  let a = n.categoryName || n.ratingType || n.ageCategoryCode, o = [Ro, i, r, a].join("."), s = { itemValue: e, itemType: o };
  a && e && (t.timeItems || (t.timeItems = []), t.timeItems.push(s));
}
function JT(e) {
  let { category: t, scaledParticipantsCount: r, ratingsParameters: i, participantType: n, ratingsValues: a = [] } = e, o = t.rankingRange || e.rankingRange || [1, 1e3], s = {}, c = {}, u = {}, d = {}, { categoryName: l, ageCategoryCode: p, ratingType: f } = t, m = t.categoryName || t.ratingType || t.ageCategoryCode;
  if ((l || p) && !f) {
    let [h, g] = o || [];
    if (c[m] = Xr(fe(h, g)).slice(0, r || Hi(20, 30)), [_e, lt].includes(n)) {
      let [I, U] = o || [];
      s[m] = Xr(fe(I, U)).slice(0, r || Hi(20, 30));
    }
  }
  if (f && i[f]) {
    let { ratingMax: h, ratingMin: g, ratingAttributes: I } = t, U = { ...i[f], ...I || {} }, { attributes: v = {}, decimalsCount: S, accessors: T, range: A, step: y } = U, D = (E) => {
      let O = {}, M = Object.keys(E || {});
      for (let N of M) {
        let C = E[N];
        if (typeof C == "object" && C.generator) {
          let { range: F } = C, [x, V] = F.slice().sort();
          O[N] = Hi(x, V);
        } else O[N] = C;
      }
      return O;
    }, P = A[0] > A[1] ? 2 : 0.7, [w, R] = A.slice().sort(), b = fe(0, 2e3).map(() => MP(w, R, P, y, S)).filter((E) => (!h || E <= h) && (!g || E >= g)).slice(0, r || Hi(20, 30)).map((E) => T ? Object.assign({}, ...T.map((O) => ({ [O]: E })), D(v)) : E);
    u[m] = [...a, ...b], [_e, lt].includes(n) && (d[m] = [...a, ...b]);
  }
  return { singlesRankings: c, doublesRankings: s, singlesRatings: u, doublesRatings: d };
}
function hy(e) {
  var f, m;
  let { alternatesCount: t = 0, tieFormatName: r, drawSize: i } = e, n = 0, a = 0, o = 0, s = 0, c = {}, u = { [pt]: 0, [St]: 0, [ni]: 0, [vo]: 0, [Mn]: 0 };
  (m = (f = $e(e.tieFormat) ? e.tieFormat : Sa({ namedFormat: r })) == null ? void 0 : f.collectionDefinitions) == null || m.filter(Boolean).forEach((h) => {
    let { category: g, collectionId: I, matchUpType: U, matchUpCount: v, gender: S } = h;
    if ([pt, St].includes(S)) {
      let T = v * (U === ft ? 2 : 1);
      u[S] < T && (u[S] = T);
    } else S === ni && (u[pt] < v && (u[pt] = v), u[St] < v && (u[St] = v));
    if (g) {
      let T = JSON.stringify(g);
      c[T] = g;
    }
    if (I || (h.collectionId = st()), Kt(ft)(U)) {
      let T = v;
      s += v, n = Math.max(n, T);
    }
    if (Kt(mt)(U)) {
      let T = v;
      o += v, a = Math.max(a, T);
    }
  });
  let d = Object.keys(c).length ? Math.max(o, s * 2) : Math.max(a, n * 2), l = n * (i + t), p = a * (i + t);
  return { maxDoublesDraw: l, maxSinglesDraw: p, teamSize: d, genders: u };
}
function pW({ participantsProfile: e, eventProfiles: t, drawProfiles: r }) {
  let { participantsCount: i, participantType: n = Xe } = e || {}, a = i || 0, o = { [St]: 0, [ni]: 0, [vo]: 0, [pt]: 0, [Mn]: 0 }, s = 0, c = 0, u = 0, d = 0, l = 0, p = ({ alternatesCount: m = 0, uniqueParticipants: h, tieFormatName: g, drawSize: I = 0, eventType: U, tieFormat: v, category: S, gender: T, stage: A }) => {
    let y = U === Xi, D = U === or, P = !!(h || A === Pe || S || T);
    if (D) {
      d = Math.max(d, I + m), v = typeof v == "object" ? v : Sa({ namedFormat: g });
      let { teamSize: w, maxDoublesDraw: R, maxSinglesDraw: b, genders: E } = hy({ alternatesCount: m, tieFormatName: g, tieFormat: v, drawSize: I });
      u = Math.max(u, w), c = Math.max(c, b), P || (s = Math.max(s, R)), Object.keys(E).forEach((O) => o[O] += E[O]);
    } else if (y) if (P) {
      let w = (I + m) * 2;
      l += w, T && (o[T] += w);
    } else I + m && I + m > s && (s = I + m);
    else if (P) {
      let w = I + m;
      T && (o[T] += w), l += w;
    } else I && I > c && (c = I + m);
  };
  if (t == null || t.forEach((m) => {
    let { tieFormatName: h, tieFormat: g, drawProfiles: I, eventType: U, category: v, gender: S } = m;
    if (I) for (let T of I) {
      let { tieFormatName: A, tieFormat: y } = T;
      p({ ...T, tieFormatName: A || h, tieFormat: y || g, eventType: U, category: v, gender: S });
    }
  }), Array.isArray(r)) for (let m of r) p(m);
  let f = Math.max(d * u, s * 2, c);
  return s && (n = _e), (i || a) < f && (i = f), i && s && [_e, or].includes(n) && (c && Math.floor(c / 2) > s ? i = Math.floor(c / 2) : (!c || s * 2 >= c) && (i = Math.ceil(i / 2))), i === void 0 && (i = !(t != null && t.length) && !(r != null && r.length) ? 32 : 0), i < a && (i = a), { uniqueParticipantsCount: l, participantsCount: i, largestTeamDraw: d, largestTeamSize: u, participantType: n, gendersCount: o };
}
function j1({ participantsProfile: e, tournamentRecord: t, eventProfiles: r, drawProfiles: i, startDate: n, uuids: a }) {
  if ((e == null ? void 0 : e.participantsCount) === 0) return { addedCount: 0, ...j };
  let { participantsCount: o, participantType: s, largestTeamDraw: c, largestTeamSize: u, gendersCount: d } = pW({ participantsProfile: e, eventProfiles: r, drawProfiles: i }), l = e == null ? void 0 : e.teamKey, p = fu({ consideredDate: n, ...e, participantsCount: o, participantType: s, gendersCount: d, uuids: a }).participants, f = 0, m = Un({ tournamentRecord: t, participants: p });
  if (m.error) return m;
  if (f += m.addedCount, l) {
    let U = my({ tournamentRecord: t, ...l });
    if (U.error) return U;
  }
  let h = p.filter(({ participantType: U }) => U === Xe).map(Ke), g = e != null && e.idPrefix ? `${lt}-${e.idPrefix}` : void 0, I = fe(0, c).map((U) => {
    let v = h.slice(U * u, (U + 1) * u), S = Ep({ index: U, participantType: s, idPrefix: g, uuids: a });
    return { participantName: `Team ${U + 1}`, participantRole: Cr, individualParticipantIds: v, participantType: lt, participantId: S };
  });
  return m = Un({ participants: I, tournamentRecord: t }), m.error ? m : (f += m.addedCount, { addedCount: f, ...j });
}
function _1({ drawProfiles: e, category: t, gender: r }) {
  let i = {}, n = e == null ? void 0 : e.reduce((o, s) => {
    let { qualifyingPositions: c = 0, participantsCount: u = 0, uniqueParticipants: d, stage: l = Ie, drawSize: p = 0 } = s || {};
    Object.keys(o).includes(l) || (o[l] = 0);
    let f = (u || p) - c;
    return d || r || t || l === Pe ? (Object.keys(i).includes(l) || (i[l] = 0), i[l] += f) : o[l] = Math.max(o[l], f), o;
  }, {}), a = Object.keys(i);
  return a.forEach((o) => n[o] += i[o]), { stageParticipantsCount: n, uniqueParticipantsCount: i, uniqueParticipantStages: a };
}
function W1({ allUniqueParticipantIds: e, stageParticipantsCount: t, eventParticipantType: r, targetParticipants: i }) {
  let n = t[Ie] || 0, a = t[Pe] || 0;
  return { stageParticipants: { QUALIFYING: i == null ? void 0 : i.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(0, a), MAIN: i == null ? void 0 : i.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(a, a + n) } };
}
var fW = { [ct]: 2, [$t]: 1, [sr]: 1, [Wr]: 1, [Je]: 4 };
function gy(e) {
  let { defaultWithScorePercent: t = 2, winningSide: r } = e, { matchUpStatusProfile: i = fW, matchUpFormat: n = Ia, pointsPerMinute: a = 1, sideWeight: o = 4 } = e;
  if (!Ri({ matchUpFormat: n })) return { error: AI };
  if (typeof i != "object") return { error: ie };
  if (t > 100 && (t = 100), isNaN(t) || isNaN(a) || isNaN(o)) return { error: ie };
  let s = Object.keys(i).filter((w) => Object.keys(Rb).includes(w) && w !== zt);
  if (Object.keys(s).reduce((w, R) => w + i[R], 0) > 100) return { error: ie, matchUpStatusProfile: i };
  let c = s.reduce((w, R) => (w.pointer = w.pointer + i[R], w.valueMap.push([w.pointer, R]), w), { pointer: 0, valueMap: [] }), u = Hi(1, 100), d = (c.valueMap.find((w) => u <= w[0]) ?? [100, zt])[1], l = { sets: [], scoreStringSide1: "", side2ScoreString: "" };
  if ([ct, Je].includes(d)) {
    r = r || Hi(1, 2);
    let w = { score: l, matchUpStatus: d, winningSide: r };
    if (!(d === Je && Hi(1, 100) > 100 - t)) return { outcome: w };
  } else if ([$t, sr].includes(d)) return { outcome: { score: l, matchUpStatus: d } };
  let p = ti(n), { bestOf: f = 1, exactly: m, setFormat: h, finalSetFormat: g } = p ?? {}, I = [], U = Hi(0, 1), v = r ? [r - 1] : [...fe(0, o).map(() => U), 1 - U], S = [Wr, Je, Zi, so].includes(d) && (Di(fe(1, m || f)) || 1), T, A = fe(1, (m ?? f) + 1);
  for (let w of A) {
    let R = w === (m ?? f), { set: b, incomplete: E, winningSideNumber: O } = mW({ setFormat: R && g || h, incomplete: S === w, pointsPerMinute: a, matchUpStatus: d, weightedRange: v, setNumber: w });
    if (I.push(b), E) {
      T = O;
      break;
    }
    if (ed({ matchUp: { score: { sets: I }, matchUpFormat: n } }).calculatedWinningSide) break;
  }
  let y = ed({ matchUp: { score: { sets: I }, matchUpFormat: n, winningSide: r } }), D = T ? r || T : y.calculatedWinningSide, { score: P } = w1({ winningSide: D, score: { sets: I }, matchUpStatus: d });
  return { outcome: { winningSide: D, matchUpStatus: d, score: P } };
}
function mW({ weightedRange: e = [0, 1], pointsPerMinute: t, matchUpStatus: r, incomplete: i, setFormat: n, setNumber: a }) {
  let o = { setNumber: a }, { setTo: s, tiebreakFormat: c, tiebreakAt: u, tiebreakSet: d, timed: l, minutes: p } = n, f = Hi(0, e.length - 1), m = e[f], h;
  if (l) {
    let g = p * t, I = Math.round(g * 0.2), U = g + Di([1, -1]) * I, v = bF(U, 2), S = [v, U - v];
    m && S.reverse(), h = e[f] + 1;
    let T = S[0] > S[1] && 1 || S[1] > S[0] && 2 || 0;
    if (i) {
      let [D, P] = S;
      return Object.assign(o, { side1Score: D, side2Score: P }), lr.includes(r) ? { set: o, incomplete: i, winningSideNumber: h } : { set: o, incomplete: i };
    }
    T || (S[Hi(0, 1)] += 1), T = S[0] > S[1] ? 1 : 2, T !== h && S.reverse();
    let [A, y] = S;
    return Object.assign(o, { side1Score: A, side2Score: y, winningSide: h }), { set: o };
  } else {
    if (i) return o.side1Score = Hi(0, u), o.side2Score = Hi(0, u), lr.includes(r) && (h = e[f] + 1), { set: o, incomplete: i, winningSideNumber: h };
    {
      let g = fe(1, s + 1).map((y) => fe(0, s + 2 - y).map(() => y)).flat(), I = g[Hi(0, g.length - 1)], U = s && rS({ isSide1: !0, tiebreakAt: u, lowValue: I, setTo: s }), v = !U, S = e.length === 1 && e[f] + 1;
      if (!v) {
        S ? (U[0] > U[1] ? 1 : 2) !== S && U.reverse() : m && U.reverse();
        let [y, D] = U;
        Object.assign(o, { side1Score: y, side2Score: D });
      }
      let T = Ju({ matchUpScoringFormat: { setFormat: n }, setObject: o }), A;
      if (T.hasTiebreakCondition || v) {
        let { NoAD: y, tiebreakTo: D } = c || d || {}, P = fe(1, D + 1).map((b) => fe(0, D + 2 - b).map(() => b)).flat(), w = P[Hi(0, P.length - 1)], R = Ym({ isSide1: !0, tiebreakNoAd: y, tiebreakTo: D, lowValue: w });
        if (R) if (v) {
          let b = R[0] > R[1] ? 1 : 2;
          S ? b !== S && R.reverse() : m && R.reverse(), [o.side1TiebreakScore, o.side2TiebreakScore] = R, A = R[0] > R[1] && 1 || R[1] > R[0] && 2 || void 0;
        } else T.leadingSide === 2 ? [o.side1TiebreakScore, o.side2TiebreakScore] = R : [o.side2TiebreakScore, o.side1TiebreakScore] = R;
      }
      o.winningSide = T.winningSide || T.leadingSide || S || A;
    }
  }
  return { set: o };
}
function Cp(e) {
  var I, U, v;
  let { matchUpStatusProfile: t, completeAllMatchUps: r, randomWinningSide: i, tournamentRecord: n, completionGoal: a, drawDefinition: o, event: s } = e;
  if (!o) return { error: Ue };
  let c = e.matchUpFormat || o.matchUpFormat || (s == null ? void 0 : s.matchUpFormat), u = o.structures.slice().sort(Cs), d = 0, { matchUps: l, matchUpsMap: p } = ur({ matchUpFilters: { matchUpTypes: [yt], roundNumbers: [1] }, contextFilters: { stages: [Ie, Pe] }, inContext: !0, drawDefinition: o });
  if (l != null && l.length) {
    let S = ((I = s == null ? void 0 : s.category) == null ? void 0 : I.ageCategoryCode) || ((U = s == null ? void 0 : s.category) == null ? void 0 : U.categoryName);
    if (S) {
      let T = r1({ singlesOnly: !0, tournamentRecord: n, drawDefinition: o, scaleAccessor: { scaleName: S, sortOrder: t1, scaleType: Ya }, event: s });
      if (T.error) return T;
      let { lineUps: A, participantsToAdd: y } = T;
      Un({ tournamentRecord: n, participants: y }), it({ element: o, extension: { name: Da, value: A } });
    } else {
      let T = (v = l[0]) == null ? void 0 : v.structureId, { positionAssignments: A } = gt({ drawDefinition: o, structureId: T });
      if (A != null && A.length) {
        let { participants: y } = Lt({ participantFilters: { participantTypes: [yt] }, tournamentRecord: n }), D = (P) => {
          let w = P.tieMatchUps.filter(Kt(mt)), R = P.tieMatchUps.filter(Kt(ft));
          w.forEach((b, E) => {
            let O = b.matchUpId;
            b.sides.forEach((M) => {
              var F;
              let { drawPosition: N } = M, C = y == null ? void 0 : y.find((x) => {
                var k;
                let { participantId: V } = x;
                return ((k = A.find((L) => L.participantId === V)) == null ? void 0 : k.drawPosition) === N;
              });
              if (C) {
                let x = (F = C.individualParticipantIds) == null ? void 0 : F[E];
                x && Mp({ teamParticipantId: C.participantId, participantId: x, tournamentRecord: n, drawDefinition: o, tieMatchUpId: O, event: s });
              }
            });
          }), R.forEach((b, E) => {
            let O = b.matchUpId;
            b.sides.forEach((M) => {
              var F, x;
              let { drawPosition: N } = M, C = y == null ? void 0 : y.find((V) => {
                var L;
                let { participantId: k } = V;
                return ((L = A.find((B) => B.participantId === k)) == null ? void 0 : L.drawPosition) === N;
              });
              C && ((x = (F = C.individualParticipantIds) == null ? void 0 : F.slice(E * 2, E * 2 + 2)) == null || x.forEach((V) => {
                Mp({ teamParticipantId: C.participantId, participantId: V, tournamentRecord: n, drawDefinition: o, tieMatchUpId: O, event: s });
              }));
            });
          });
        };
        l.forEach(D);
      }
    }
  }
  let f = typeof r == "string" && r, m = f && zt, h = u.length === 2 && u[0].finishingPosition === wo && qt(u.map(({ stage: S }) => S), [Ie, Wt]).length === 2, g = u.map(({ structureId: S }) => S);
  for (let S of g) {
    if (d >= a) break;
    let T = o.structures.find((D) => D.structureId === S), A = ut({ contextFilters: { matchUpTypes: [ft, mt] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: p, structure: T, event: s }).matchUps;
    A.length;
    let y = A.filter(({ winningSide: D }) => !D).sort(js).map(hr);
    for (let D of y) {
      if (!isNaN(a) && d >= a) break;
      let { matchUps: P } = ut({ matchUpFilters: { matchUpTypes: [ft, mt] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: p, structure: T, event: s }), w = P.find((b) => b.matchUpId === D), R = [$t, sr].includes(w.matchUpStatus);
      if (w != null && w.readyToScore && !R) {
        let b = hW({ matchUpStatusProfile: t, tournamentRecord: n, drawDefinition: o, targetMatchUp: w, matchUpFormat: c, matchUpStatus: m, scoreString: f, winningSide: !i && 1, event: s });
        if (b != null && b.error) return b;
        d += 1;
      }
    }
    h && T.finishingPosition === wo && e.completeRoundRobinPlayoffs && ru({ structureId: T.structureId, applyPositioning: !0, drawDefinition: o });
  }
  return { ...j, completedCount: d };
}
function q1(e) {
  let { matchUpStatusCodes: t, policyDefinitions: r, tournamentRecord: i, drawDefinition: n, targetMatchUp: a, matchUpStatus: o, matchUpFormat: s, scoreString: c, winningSide: u, event: d } = e;
  if (!a || a.matchUpStatus === at) return;
  let { matchUpId: l } = a || {}, { outcome: p } = uy({ matchUpFormat: s, matchUpStatus: o, scoreString: c, winningSide: u });
  return t && (p.matchUpStatusCodes = t), ml({ tournamentRecord: i, policyDefinitions: r, drawDefinition: n, matchUpFormat: s, matchUpId: l, outcome: p, event: d });
}
function hW(e) {
  let { matchUpStatusProfile: t = {}, tournamentRecord: r, policyDefinitions: i, drawDefinition: n, matchUpStatus: a, matchUpFormat: o, targetMatchUp: s, scoreString: c, winningSide: u, event: d } = e;
  if (c || a) return q1(e);
  let { matchUpId: l } = s || {}, { outcome: p } = gy({ matchUpStatusProfile: t, matchUpFormat: o, winningSide: u });
  return ml({ policyDefinitions: i, tournamentRecord: r, drawDefinition: n, matchUpFormat: o, matchUpId: l, outcome: p, event: d });
}
function H1({ matchUpStatusProfile: e, completeAllMatchUps: t, randomWinningSide: r, tournamentRecord: i, drawProfiles: n, isMock: a, event: o }) {
  var h, g, I, U;
  let s = Ht({ event: o }).flightProfile, { eventName: c, eventType: u, category: d } = o, { startDate: l } = i, p = [], f = (d == null ? void 0 : d.categoryName) || (d == null ? void 0 : d.ageCategoryCode) || (d == null ? void 0 : d.ratingType), m = (h = o.drawDefinitions) == null ? void 0 : h.map(({ drawId: v }) => v);
  if (Array.isArray(s == null ? void 0 : s.flights)) for (let [v, S] of s.flights.entries()) {
    let { drawId: T, stage: A, drawName: y, drawEntries: D } = S;
    p.push(S.drawId);
    let P = n[v], { seedsCount: w, generate: R = !0 } = P || {};
    if (R) {
      let b = D.filter(Ni(ca)).map(Ni(ca)), E = f || c;
      if (i && w && w <= b.length && fe(1, w + 1).forEach((F, x) => {
        let V = { scaleValue: F, scaleName: E, scaleType: $n, eventType: u, scaleDate: l }, k = b[x];
        nl({ tournamentRecord: i, participantId: k, scaleItem: V });
      }), m == null ? void 0 : m.includes(T)) break;
      let O = dl({ ...P, matchUpType: u, seedingScaleName: E, tournamentRecord: i, drawEntries: D, drawName: y, drawId: T, isMock: a, event: o, stage: A });
      if (O.error) return { error: O.error, drawIds: [] };
      let { drawDefinition: M } = O;
      if (!M) return { error: Fi };
      let N = (g = n[v]) == null ? void 0 : g.drawExtensions;
      if (Array.isArray(N) && N.filter(Wn).forEach((F) => it({ element: M, extension: F })), O = ll({ suppressNotifications: !0, tournamentRecord: i, drawDefinition: M, event: o }), O.error) return { error: O.error, drawIds: [] };
      if (P != null && P.withPlayoffs) {
        let F = (I = M.structures) == null ? void 0 : I[0].structureId, x = Fm({ idPrefix: P.idPrefix, ...P.withPlayoffs, tournamentRecord: i, drawDefinition: M, structureId: F, isMock: a, event: o });
        if (x != null && x.error) return x;
      }
      let C = P == null ? void 0 : P.completionGoal;
      if ((P == null ? void 0 : P.automated) !== !1 && (t || C)) {
        let F = P == null ? void 0 : P.matchUpFormat, x = Cp({ completeAllMatchUps: !C && t, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, completionGoal: C, drawDefinition: M, matchUpFormat: F, event: o });
        if (x.error) return { error: x.error, drawIds: [] };
        let V = x.completedCount;
        if ((P == null ? void 0 : P.drawType) === sa) {
          let k = (U = M.structures) == null ? void 0 : U.find((G) => G.stage === Ie);
          if (!k) return { error: kt };
          let L = ru({ structureId: k.structureId, tournamentRecord: i, drawDefinition: M, event: o });
          if (L.error) return { error: L.error, drawIds: [] };
          let B = C ? C - (V ?? 0) : void 0;
          if (L = Cp({ completeAllMatchUps: !C && t, completionGoal: C ? B : void 0, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, drawDefinition: M, matchUpFormat: F, event: o }), L.error) return { error: L.error, drawIds: [] };
        }
      }
    }
  }
  return { ...j, drawIds: p };
}
function Y1(e) {
  var A, y;
  let { participantsProfile: t = {}, uniqueParticipantsCount: r, ratingsParameters: i, tournamentRecord: n, eventProfile: a, eventIndex: o, event: s, uuids: c } = e, { category: u, gender: d, eventType: l } = s, p = Kt(jn)(l) && Xe || Kt(Xi)(l) && _e || l, f = r[Ie] || 0, m = r[Pe] || 0, h = (A = a.drawProfiles) != null && A.length ? f + m : ((y = a.participantsProfile) == null ? void 0 : y.participantsCount) ?? 0, g = [pt, St].includes(d) ? d : void 0, I = t != null && t.idPrefix ? `E-${o}-${t == null ? void 0 : t.idPrefix}` : void 0, { participants: U } = fu({ uuids: a.uuids || c, ...t, scaledParticipantsCount: a.scaledParticipantsCount, consideredDate: n == null ? void 0 : n.startDate, rankingRange: a.rankingRange, participantType: p, participantsCount: h, ratingsParameters: i, category: u, idPrefix: I, sex: g }), v = Un({ tournamentRecord: n, participants: U });
  if (v.error) return v;
  let S = U == null ? void 0 : U.filter(({ participantType: D }) => D === p), T = U == null ? void 0 : U.map(Ke);
  return { uniqueDrawParticipants: S, uniqueParticipantIds: T };
}
function gW({ autoEntryPositions: e, tournamentRecord: t, drawParticipants: r, drawProfile: i, event: n }) {
  let { drawType: a = xn, qualifyingPositions: o = 0, stage: s = Ie, drawSize: c = 0, drawName: u, drawId: d } = i, l = c - o, p = r.slice(0, l).map(Ke);
  if (p.length) {
    let h = Bn({ participantIds: p, autoEntryPositions: e, entryStage: s, tournamentRecord: t, event: n });
    if (h.error) return h;
  }
  let f = p.map((h) => ({ entryStatus: Ii, entryStage: s, participantId: h })), m = fh({ drawName: u || a, qualifyingPositions: o, drawEntries: f, drawId: d, event: n, stage: s });
  return m.error ? m : { ...j };
}
function z1({ uniqueDrawParticipants: e, autoEntryPositions: t, stageParticipants: r, tournamentRecord: i, drawProfiles: n, category: a, gender: o, event: s }) {
  let c = 0;
  for (let u of n) {
    let { qualifyingPositions: d = 0, uniqueParticipants: l, stage: p = Ie, drawSize: f = 0 } = u, m = f - d, h = l || o || a || p === Pe, g = h ? e.slice(c, c + m) : r[p || Ie] || [];
    h && (c += m);
    let I = gW({ autoEntryPositions: t, drawParticipants: g, tournamentRecord: i, drawProfile: u, event: s });
    if (I.error) return I;
  }
  return { ...j };
}
function K1(e) {
  var z;
  let { allUniqueParticipantIds: t, matchUpStatusProfile: r, participantsProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: c, tournamentRecord: u, eventProfile: d, eventIndex: l, publish: p, isMock: f, uuids: m } = e, h = d.gender, g = d.eventName, { eventType: I = jn, policyDefinitions: U, drawProfiles: v = [], eventExtensions: S, surfaceCategory: T, tieFormatName: A, processCodes: y, discipline: D, eventLevel: P, timeItems: w, ballType: R, category: b } = d, E = d.eventId || st(), O = d.tieFormat || (I === or ? Sa({ namedFormat: A, event: { eventId: E, category: b, gender: h }, hydrateCollections: o, isMock: f }) : void 0), M = u.participants;
  for (let Z of v) !h && Z.gender && (h = Z == null ? void 0 : Z.gender);
  let { stageParticipantsCount: N, uniqueParticipantsCount: C, uniqueParticipantStages: F } = _1({ drawProfiles: v, category: b, gender: h }), x = Kt(jn)(I) && Xe || Kt(Xi)(I) && _e || I, { uniqueDrawParticipants: V = [], uniqueParticipantIds: k = [] } = F ? Y1({ event: { eventType: I, category: b, gender: h }, uniqueParticipantsCount: C, participantsProfile: i, ratingsParameters: c, tournamentRecord: u, eventProfile: d, eventIndex: l, uuids: m }) : {}, { eventAttributes: L } = d;
  typeof L != "object" && (L = {});
  let B = (b == null ? void 0 : b.categoryName) || (b == null ? void 0 : b.ageCategoryCode) || (b == null ? void 0 : b.ratingType);
  g = g || B || "Generated Event";
  let G = { ...L, surfaceCategory: T, processCodes: y, discipline: D, eventLevel: P, eventName: g, eventType: I, tieFormat: O, ballType: R, category: b, eventId: E, gender: h };
  if (S != null && S.length && Array.isArray(S)) {
    let Z = S.filter(Wn);
    Z != null && Z.length && Object.assign(G, { extensions: Z });
  }
  if (Array.isArray(w) && w.forEach((Z) => Ys({ event: H, timeItem: Z })), typeof U == "object") for (let Z of Object.keys(U)) Co({ policyDefinitions: { [Z]: U[Z] }, event: G });
  G.category && (G.category.categoryName = B);
  let q, Y = su({ suppressNotifications: !1, internalUse: !0, tournamentRecord: u, event: G });
  if (Y.error) return Y;
  let H = Y == null ? void 0 : Y.event, { stageParticipants: X } = W1({ allUniqueParticipantIds: t, stageParticipantsCount: N, eventParticipantType: x, targetParticipants: M });
  if (v != null && v.length) {
    let Z = z1({ uniqueDrawParticipants: V, autoEntryPositions: a, stageParticipants: X, tournamentRecord: u, drawProfiles: v, category: b, gender: h, event: H });
    if (Z.error) return Z;
    let te = H1({ matchUpStatusProfile: r, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: v, isMock: f, event: H });
    if (te.error) return te;
    q = te.drawIds;
  } else if ((z = d == null ? void 0 : d.participantsProfile) != null && z.participantsCount) {
    let Z = V.map(Ke);
    if (Z.length) {
      let te = Bn({ participantIds: Z, autoEntryPositions: a, tournamentRecord: u, entryStage: Ie, event: H });
      if (te.error) return te;
    }
  }
  return p && uu({ tournamentRecord: u, event: H }), { drawIds: q, eventId: E, uniqueParticipantIds: k };
}
function Iy({ tournamentRecords: e, scheduleDate: t, venueId: r, round: i }) {
  if (!mi(t)) return { error: Sr };
  let n = "addSchedulingProfileRound", { extension: a } = We({ name: Us, tournamentRecords: e, discover: !0 }), o = (a == null ? void 0 : a.value) || [], s = o.find((p) => aa(t, p.scheduleDate));
  if (!s) {
    let { startDate: p, endDate: f } = Xm({ tournamentRecords: e }), m = new Date(t);
    if (p && m < new Date(p) || f && m > new Date(f)) return { error: Sr };
    s = { scheduleDate: t, venues: [] }, o.push(s);
  }
  let c = s.venues.find((p) => p.venueId === r);
  c || (c = { venueId: r, rounds: [] }, s.venues.push(c));
  let u = ["notBeforeTime"], d = (p) => Object.keys(p).filter((f) => !u.includes(f)).sort().map((f) => $e(p[f]) ? d(p[f]) : p[f]).flat().join("|");
  if (c.rounds.find((p) => d(p) === d(i))) return W({ result: { error: QP }, stack: n });
  c.rounds.push(i);
  let l = au({ tournamentRecords: e, schedulingProfile: o });
  return l.error ? l : { ...j };
}
function IW({ schedulingProfile: e, tournamentRecord: t }) {
  if (typeof e != "object") return { error: ie };
  let r = Zc({ tournamentRecord: t }).containedStructures, i = Pr({ tournamentRecord: t }).matchUps ?? [], { tournamentId: n } = t, a = [];
  for (let o of e) {
    let { scheduleDate: s, venues: c = [] } = o;
    for (let u of c) {
      let { rounds: d, venueId: l } = u;
      for (let p of d) {
        let { drawId: f, winnerFinishingPositionRange: m, roundSegment: h } = p, g = i.filter((I) => {
          var S;
          let U = (m == null ? void 0 : m.indexOf("-")) > 0 && m.split("-").map((T) => +T), v = (S = I.finishingPositionRange) == null ? void 0 : S.winner;
          return I.drawId === f && (!p.roundNumber || I.roundNumber === p.roundNumber) && (!v || !U || qt(v, U).length === 2 || Be(v).length === Be(U).length && qt(v, U).length === Be(v).length);
        })[0];
        if (g) {
          let { eventId: I, roundNumber: U, drawName: v, structureName: S, roundName: T } = g, A = g.structureId;
          U && !m && (A = Object.keys(r).find((P) => r[P].includes(A)) ?? A);
          let y = { tournamentId: n, structureId: A, roundNumber: U, roundSegment: h, eventId: I, drawId: f }, D = Iy({ tournamentRecords: { [n]: t }, round: y, scheduleDate: s, venueId: l });
          if (D.error) return D;
          a.push({ structureName: S, roundName: T, drawName: v, ...y });
        }
      }
    }
  }
  return { scheduledRounds: a };
}
function wh(e) {
  var Ge, Bt, Ut;
  let t = Ae(e, [{ drawProfile: !0, _ofType: pi }]);
  if (t.error) return t;
  let { allUniqueParticipantIds: r = [], participantsProfile: i = {}, matchUpStatusProfile: n, completeAllMatchUps: a, autoEntryPositions: o, hydrateCollections: s, randomWinningSide: c, ratingsParameters: u, tournamentRecord: d, isMock: l = !0, drawProfile: p, startDate: f, drawIndex: m, uuids: h } = e, g = ge(p, !1, !0), { excessParticipantAlternates: I = !0, matchUpFormat: U = Ia, drawType: v = xn, tournamentAlternates: S = 0, alternatesCount: T = 0, qualifyingPositions: A, qualifyingProfiles: y, generate: D = !0, eventExtensions: P, drawExtensions: w, completionGoal: R, tieFormatName: b, buildTeams: E, seedsCount: O, timeItems: M, drawName: N, category: C, idPrefix: F, publish: x, gender: V, stage: k } = g, L = g.drawSize || (g.ignoreDefaults ? void 0 : 32), B = g.eventId || st(), G = p.eventType || p.matchUpType || jn, q = G === Xi ? _e : Xe, Y = $e(p.tieFormat) && p.tieFormat || G === lt && Sa({ event: { eventId: B, category: C, gender: V }, namedFormat: b, hydrateCollections: s, isMock: l }) || void 0, H = (C == null ? void 0 : C.categoryName) || (C == null ? void 0 : C.ageCategoryCode) || (C == null ? void 0 : C.ratingType), X = p.eventName || H || `Generated ${G}`, z = (d == null ? void 0 : d.participants) || [], Z = ((y == null ? void 0 : y.map((Re) => Re.structureProfiles || []).flat().reduce((Re, De) => {
    let ve = !De.participantsCount || De.participantsCount > De.drawSize ? De.drawSize : De.participantsCount || 0;
    return Re + ve;
  }, 0)) || 0) * (q === _e ? 2 : 1), te = (!p.participantsCount || p.participantsCount > L ? L : p.participantsCount) || 0, ne = { eventName: X, eventType: G, tieFormat: Y, category: C, eventId: B, gender: V };
  Array.isArray(M) && M.forEach((Re) => Ys({ event: ne, timeItem: Re }));
  let { eventAttributes: ee } = p;
  if (typeof ee != "object" && (ee = {}), Object.assign(ne, ee), (P == null ? void 0 : P.length) && Array.isArray(P)) {
    let Re = P.filter(Wn);
    Re != null && Re.length && Object.assign(ne, { extensions: Re });
  }
  let K = [];
  if ((i == null ? void 0 : i.participantsCount) === 0 || p.uniqueParticipants || Z || !d || V || C) {
    let Re = (te || 0) + T + Z, De = Re, ve = { [pt]: 0, [St]: 0 }, Ye, Ze;
    G === lt && ({ teamSize: Ye, genders: Ze } = hy({ alternatesCount: T, tieFormatName: b, tieFormat: Y, drawSize: L }), Object.keys(Ze).forEach((je) => {
      [pt, St].includes(je) && Ze[je] && (ve[je] = L * Ze[je]);
    }), De = Ye * ((L || 0) + Z));
    let Nt = i != null && i.idPrefix ? `D-${m}-${i == null ? void 0 : i.idPrefix}` : void 0, Tt = fu({ ...i, scaledParticipantsCount: p.scaledParticipantsCount || i.scaledParticipantsCount, participantsCount: De, consideredDate: d == null ? void 0 : d.startDate, sex: V || (i == null ? void 0 : i.sex), rankingRange: p.rankingRange, uuids: p.uuids || h, ratingsParameters: u, participantType: q, gendersCount: ve, idPrefix: Nt, category: C }).participants;
    if (ne.category && (ne.category.categoryName = H), d) {
      let je = Un({ participants: Tt, tournamentRecord: d });
      if (je.error) return je;
    }
    if (Tt.forEach(({ participantId: je }) => K.push(je)), z = Tt, G === lt) {
      let je = Ze[pt] ? Tt.filter(({ participantType: Dt, person: mr }) => Dt === Xe && (mr == null ? void 0 : mr.sex) === pt).map(Ke) : [], It = Ze[St] ? Tt.filter(({ participantType: Dt, person: mr }) => Dt === Xe && (mr == null ? void 0 : mr.sex) === St).map(Ke) : [], Zt = Tt.filter(({ participantType: Dt }) => Dt === Xe).map(Ke).filter((Dt) => !je.includes(Dt) && !It.includes(Dt)), _t = [...g.teamNames ?? [], ...Op({ count: Re }).names], er = Ye - (Ze[pt] + Ze[St]), Mt = 0, He = 0, Me = 0, Ot = fe(0, Re).map((Dt) => {
        let mr = It.slice(Mt, Mt + Ze[St]), qr = je.slice(He, He + Ze[pt]), Ee = Zt.slice(Me, Me + er);
        Mt += Ze[St], He += Ze[pt], Me += er;
        let ir = E !== !1 ? [...mr, ...qr, ...Ee] : [];
        return { participantName: _t[Dt] || `Team ${Dt + 1}`, participantOtherName: `TM${Dt + 1}`, participantRole: Cr, individualParticipantIds: ir, participantType: lt, participantId: st() };
      }), vr = Un({ participants: Ot, tournamentRecord: d });
      if (!vr.success) return vr;
      z = Ot;
    }
  }
  let J = (Re) => {
    let { participantType: De } = Re;
    return Kt(jn)(G) && De === Xe || Kt(Xi)(G) && De === _e ? !0 : G === lt && De === lt;
  }, $ = (Re) => {
    var De, ve;
    return !p.gender || ((De = Re.person) == null ? void 0 : De.sex) === p.gender ? !0 : (ve = Re.individualParticipantIds) == null ? void 0 : ve.some((Ye) => {
      let Ze = z.find((Nt) => Nt.participantId === Ye);
      return Ze && $(Ze);
    });
  }, ae = z.filter(J).filter($).filter(({ participantId: Re }) => !r.includes(Re)), oe = ae.slice(0, te).map((Re) => Re.participantId);
  if (l && (oe != null && oe.length)) {
    let Re = Bn({ autoEntryPositions: o, entryStage: k, tournamentRecord: d, participantIds: oe, event: ne });
    if (Re.error) return Re;
  }
  let ce = Z ? ae.slice(te, te + Z).map((Re) => Re.participantId) : 0;
  if (l && (ce != null && ce.length)) {
    let Re = 0, De = 1, ve = (Ze, Nt) => Ze.stageSequence - Nt.stageSequence, Ye = (Ze, Nt) => Ze.roundTarget - Nt.roundTarget;
    for (let Ze of y.sort(Ye)) {
      De = Ze.roundTarget || De;
      let Nt = 1, Tt;
      for (let je of Ze.structureProfiles.sort(ve)) {
        let It = (je.drawSize || pI(je.participantsCount)) - (Tt || 0), Zt = ce.slice(Re, Re + It), _t = Bn({ entryStage: Pe, entryStageSequence: Nt, autoEntryPositions: o, tournamentRecord: d, participantIds: Zt, roundTarget: De, event: ne });
        if (_t.error) return _t;
        Tt = je.qualifyingPositions, Re += It, Nt += 1;
      }
      De += 1;
    }
  }
  let se = I && ((Ge = d == null ? void 0 : d.participants) == null ? void 0 : Ge.filter(({ participantId: Re }) => !oe.includes(Re)).filter(J).filter($).slice(0, T || L - te || S).map((Re) => Re.participantId));
  if (l && (se != null && se.length)) {
    let Re = Bn({ participantIds: se, autoEntryPositions: !1, entryStatus: fn, tournamentRecord: d, event: ne });
    if (Re.error) return Re.error;
  }
  let Te = H || X;
  d && O && O <= oe.length && fe(1, O + 1).forEach((Re, De) => {
    let ve = { scaleName: Te, scaleDate: f, scaleType: zv, scaleValue: Re, eventType: G }, Ye = oe[De];
    nl({ tournamentRecord: d, participantId: Ye, scaleItem: ve });
  });
  let xe = dl({ ...ge(p, !1, !0), tournamentRecord: d, seedingScaleName: Te, matchUpFormat: U, eventId: B, isMock: l, event: ne });
  if (xe.error) return xe;
  if (!xe.drawDefinition) return { error: Fi };
  let { drawDefinition: me } = xe, rt = me.drawId;
  if (Array.isArray(w) && w.filter(Wn).forEach((Re) => it({ element: me, extension: Re })), D) {
    if (ll({ drawDefinition: me, event: ne, suppressNotifications: !0 }), p.withPlayoffs) {
      let De = (Bt = me.structures) == null ? void 0 : Bt[0].structureId, ve = Fm({ ...p.withPlayoffs, tournamentRecord: d, drawDefinition: me, structureId: De, idPrefix: F, isMock: l, event: ne });
      if (ve != null && ve.error) return ve;
    }
    let Re = p.automated === !1;
    if (l && !Re) {
      let De = (ve) => {
        var Nt;
        let Ye = Cp({ completeAllMatchUps: ve.completeAllMatchUps, completionGoal: ve.completionGoal, matchUpStatusProfile: n, randomWinningSide: c, tournamentRecord: d, drawDefinition: me, matchUpFormat: U, event: ne });
        if (Ye.error) return Ye;
        let Ze = Ye.completedCount;
        if (v === sa) {
          let Tt = (Nt = me.structures) == null ? void 0 : Nt.find((Zt) => Zt.stage === Ie);
          if (!Tt) return { error: kt };
          ru({ structureId: Tt.structureId, tournamentRecord: d, drawDefinition: me, event: ne });
          let je = R ? R - (Ze ?? 0) : void 0, It = Cp({ completionGoal: R ? je : void 0, matchUpStatusProfile: n, completeAllMatchUps: a, randomWinningSide: c, tournamentRecord: d, drawDefinition: me, matchUpFormat: U, event: ne });
          if (It.error) return It;
        }
      };
      if (R && De({ completionGoal: R }), p.outcomes) {
        let { matchUps: ve } = Qr({ inContext: !0, drawDefinition: me, event: ne });
        for (let Ye of p.outcomes) {
          let { matchUpStatus: Ze = zt, matchUpStatusCodes: Nt, stageSequence: Tt = 1, matchUpIndex: je = 0, structureOrder: It, matchUpFormat: Zt, drawPositions: _t, roundPosition: er, stage: Mt = Ie, roundNumber: He, winningSide: Me, scoreString: Ot } = Ye, vr = (ve == null ? void 0 : ve.reduce((Ee, ir) => {
            let { structureId: Oe, matchUpId: ot } = ir;
            return Ee[Oe] ? Ee[Oe].push(ot) : Ee[Oe] = [ot], Ee;
          }, {})) ?? [], Dt = Object.assign({}, ...Object.keys(vr).map((Ee, ir) => ({ [Ee]: ir + 1 }))), mr = (Ut = ve == null ? void 0 : ve.filter((Ee) => (!Mt || Ee.stage === Mt) && (!Tt || Ee.stageSequence === Tt) && (!He || Ee.roundNumber === He) && (!er || Ee.roundPosition === er) && (!It || Dt[Ee.structureId] === It) && (!_t || qt(_t, Ee.drawPositions).length === 2))) == null ? void 0 : Ut[je], qr = q1({ matchUpStatusCodes: Nt, tournamentRecord: d, drawDefinition: me, targetMatchUp: mr, matchUpFormat: Zt, matchUpStatus: Ze, scoreString: Ot, winningSide: Me });
          if (qr != null && qr.error) return qr;
        }
      }
      a && De({ completeAllMatchUps: a });
    }
    x && uu({ tournamentRecord: d, event: ne });
  } else {
    let Re = fh({ drawEntries: me.entries, drawName: N || v, qualifyingPositions: A, drawId: rt, event: ne, stage: k });
    if (Re.error) return Re;
  }
  return { ...j, event: ye(ne), uniqueParticipantIds: K, targetParticipants: z, drawDefinition: me, eventId: B, drawId: rt };
}
var X1 = () => ({ altitude: void 0, courtId: void 0, courtName: "", courtDimensions: void 0, latitude: void 0, longitude: void 0, surfaceCategory: void 0, surfaceType: void 0, surfacedDate: void 0, dateAvailability: [], onlineResources: [], pace: void 0, notes: void 0 }), vW = X1;
function Fp(e) {
  return parseInt(e);
}
function $T({ startTime: e = "", endTime: t = "" } = {}) {
  if (!e || !t || !Uo.test(e) || !Uo.test(t)) return !1;
  let [r, i] = e.split(":").map(Fp), [n, a] = t.split(":").map(Fp);
  return n < r ? !1 : !(r === n && a < i);
}
function UW(e, t) {
  let [r, i] = e.startTime.split(":").map(Fp), [n, a] = t.startTime.split(":").map(Fp);
  return r < n ? -1 : r > n ? 1 : i < a ? -1 : i > a ? 1 : 0;
}
function Z1({ dateAvailability: e }) {
  if (!e) return { error: pw };
  if (!Array.isArray(e)) return { error: xl };
  let t = "Dates must be formated => YYYY-MM-DD", r = "Times must be 24 hour => 00:00";
  for (let i of e) {
    if (typeof i != "object") return { error: xl };
    let { date: n, startTime: a, endTime: o, bookings: s = [] } = i;
    if (!a || !o) return { error: xl };
    if (n && !Gn.test(n)) return { error: Sr, dateAvailability: { date: n }, info: t };
    if (!Uo.test(a)) return { error: on, dateAvailability: { startTime: a }, info: r };
    if (!Uo.test(o)) return { error: on, dateAvailability: { endTime: o }, info: r };
    if (a === o) return { error: on, dateAvailability: { startTime: a, endTime: o }, info: "startTime and endTime are equivalent" };
    if (!$T({ startTime: a, endTime: o })) return { error: on, dateAvailability: { startTime: a, endTime: o }, info: "endTime must be after startTime" };
    if (s) {
      if (!Array.isArray(s)) return { error: tp };
      for (let c of s) {
        if (typeof c != "object") return { error: tp };
        let { startTime: u, endTime: d } = c;
        if (!Uo.test(u)) return { error: on, booking: { startTime: u }, info: r };
        if (!Uo.test(d)) return { error: on, booking: { endTime: d }, info: r };
        if (u === d) return { error: on, dateAvailability: { startTime: u, endTime: d }, info: "startTime and endTime are equivalent" };
        if (!$T({ startTime: u, endTime: d })) return { error: on, dateAvailability: { startTime: u, endTime: d }, info: "endTime must be after startTime" };
      }
    }
  }
  return { valid: !0 };
}
function Rh({ tournamentRecord: e, disableNotice: t, venueId: r, courtId: i, court: n }) {
  let { venue: a } = fa({ tournamentRecord: e, venueId: r });
  if (!a) return { error: Rs };
  a.courts || (a.courts = []);
  let o = { ...X1(), venueId: r, courtId: i };
  if (o.courtId || (o.courtId = st()), a.courts.some((s) => s.courtId === o.courtId)) return { error: Nw };
  {
    let s = ((n == null ? void 0 : n.dateAvailability) || []).map((d) => {
      var l;
      return { ...d, date: Ve(d.date), startTime: Rt(d.startTime), endTime: Rt(d.endTime), bookings: (l = d.bookings) == null ? void 0 : l.map(({ startTime: p, endTime: f, bookingType: m }) => ({ startTime: Rt(p), endTime: Rt(f), bookingType: m })) };
    }), c = Object.keys(o);
    for (let d of c) if (n != null && n[d]) if (d === "dateAvailability") {
      let l = Z1({ dateAvailability: s });
      if (!l.valid && l.error) return l;
      o.dateAvailability = s;
    } else o[d] = n[d];
    let u = o;
    return a.courts.push(u), t || Le({ payload: { venue: a, tournamentId: e.tournamentId }, topic: _o, key: a.venueId }), { ...j, court: ge(o), venueId: r };
  }
}
function vy(e) {
  let { tournamentRecord: t, venueId: r } = e;
  if (typeof r != "string" || !r) return { error: io };
  let i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n = [], a;
  for (let o of Object.values(i)) {
    let { venue: s } = fa({ tournamentRecord: o, venueId: r });
    if (s) {
      let c = SW({ ...e, tournamentRecord: o });
      for (let u of (c == null ? void 0 : c.courts) ?? []) n.push(u == null ? void 0 : u.courtId);
      if (c.error) return c;
      a = !0;
    }
  }
  return a ? { ...j, courtIds: n } : { error: Rs };
}
function SW({ courtNameRoot: e = "Court", dateAvailability: t = [], venueAbbreviationRoot: r, tournamentRecord: i, courtNames: n = [], courtTimings: a, courtsCount: o, startTime: s, courtIds: c, endTime: u, idPrefix: d, venueId: l, dates: p }) {
  if (!l) return { error: io };
  let f = fa({ tournamentRecord: i, venueId: l });
  if (f.error) return f;
  let { venue: m } = f;
  if (!jt(o) || !n) return { error: bw };
  o = o ?? n.length;
  let h = fe(0, o).map((g) => {
    let I = a == null ? void 0 : a[g], U = I ? p.map((v) => ({ date: ln(v), startTime: s, endTime: u, ...I })) : t;
    return I && s && u && U.push({ startTime: s, endTime: u }), { courtName: n[g] || r && (m == null ? void 0 : m.venueAbbreviation) && `${m == null ? void 0 : m.venueAbbreviation} ${g + 1}` || `${e} ${g + 1}`, dateAvailability: U };
  }).map((g, I) => {
    let U = (c == null ? void 0 : c.pop()) || d && `${d}-${I + 1}`;
    return Rh({ disableNotice: !0, tournamentRecord: i, courtId: U, venueId: l, court: g });
  }).map((g) => g.court).filter(Boolean);
  return h.length !== o ? W({ info: "not all courts could be generated", result: { error: ie } }) : (m && Le({ payload: { venue: m, tournamentId: i.tournamentId }, topic: _o, key: m.venueId }), { ...j, courts: ge(h) });
}
function Uy({ tournamentRecord: e, ignoreExistingVenues: t, venueProfiles: r, uuids: i }) {
  let { startDate: n, endDate: a } = e, o = [];
  for (let [s, c] of r.entries()) {
    let { venueAbbreviation: u, venueId: d = (i == null ? void 0 : i.pop()) ?? st(), dateAvailability: l, startTime: p = "07:00", endTime: f = "19:00", courtTimings: m, courtsCount: h, courtNames: g, venueName: I, idPrefix: U, courtIds: v } = c, S = { venueName: I || `Venue ${s + 1}`, venueAbbreviation: u, venueId: d }, T = kd({ tournamentRecord: e, venue: S });
    if (T.error) {
      if (t) continue;
      return T;
    }
    o.push(d);
    let A = hc(n, a), y = !Array.isArray(l) && [{ startTime: p, endTime: f }].concat(A.map((D) => ({ date: ln(D), startTime: p, endTime: f })));
    if (h || g) {
      let D = vy({ dateAvailability: l || y, tournamentRecord: e, courtTimings: m, courtsCount: h, courtNames: g, startTime: p, idPrefix: U, courtIds: v, endTime: f, venueId: d, dates: A });
      if (D.error) return D;
    }
  }
  return o;
}
function yW(e) {
  var d, l, p;
  let { tournamentRecord: t, leagueProfiles: r, eventIds: i, venueIds: n, drawIds: a, allUniqueParticipantIds: o, uuids: s } = e, c = 0;
  for (let f of r) {
    let m = [], { tieFormatName: h = sp, teamProfiles: g = [], teamsCount: I = 0, category: U, idPrefix: v, gender: S } = f, T = f.leagueName ?? f.eventName ?? `League ${c + 1}`, A = f.leagueId ?? f.eventId ?? (s == null ? void 0 : s.pop()) ?? st();
    i.push(A);
    let y = $e(f.tieFormat) && f.tieFormat || Sa({ event: { eventId: A, category: U, gender: S }, namedFormat: h, isMock: e.isMock }) || void 0;
    if (!y) return { error: Gc };
    let D = Math.max(I, g.length), P = fe(0, D), { genders: w, teamSize: R } = hy({ tieFormat: y, drawSize: D }), b = { [St]: 0, [ni]: 0, [vo]: 0, [pt]: 0, [Mn]: 0 };
    Object.keys(w).forEach((O) => b[O] += w[O]);
    for (let O of P) {
      let M = ((d = g == null ? void 0 : g[O]) == null ? void 0 : d.teamName) ?? `Team ${O + 1}`, N = ((l = g == null ? void 0 : g[O]) == null ? void 0 : l.teamId) || (s == null ? void 0 : s.pop()) || st(), C = f.startDate ?? e.startDate, F = fu({ ...f == null ? void 0 : f.participantsProfile, participantsCount: R, consideredDate: C, gendersCount: b, category: U, gender: S, uuids: s }).participants, x = F.map((q) => q.participantId), V = lt, k = N ?? Ep({ participantType: V, idPrefix: v, index: O, uuids: s });
      m.push({ participantId: k, entryStatus: Ii, entryStage: Ie });
      let L = ((p = g == null ? void 0 : g[O]) == null ? void 0 : p.venueIds) ?? [], B = { participantId: k, participantRole: Cr, participantName: M, individualParticipantIds: x, participantType: V, homeVenueIds: L };
      L.forEach((q) => !n.includes(q) && n.push(q)), o.push(...x), o.push(k);
      let G = Un({ participants: [B, ...F], tournamentRecord: t });
      if (G.error) return G;
    }
    let E = { eventName: T, entries: m, eventType: lt, tieFormat: y, category: U, eventId: A, gender: S };
    if (t.events || (t.events = []), t.events.push(E), m.length) {
      let O = (jt(f.roundsCount) && f.roundsCount) ?? f.roundsCount === cL ? (D - 1) * 2 : D - 1, M = dl({ automated: f.automated, tournamentRecord: t, drawType: Li, roundsCount: O, drawSize: D, event: E });
      if (M.error) return M;
      let { drawDefinition: N } = M;
      if (N) {
        let C = N == null ? void 0 : N.drawId;
        ll({ drawDefinition: N, event: E, suppressNotifications: !0 }), a.push(C);
      }
    }
    c++;
  }
  let u = n.map((f) => ({ venueId: f }));
  Uy({ tournamentRecord: t, ignoreExistingVenues: !0, venueProfiles: u, uuids: s });
}
var AW = ["Generated Tournament", "CourtHive Challenge", "Replication Crisis", "Open Competition", "Factory Follies", "Mock Tournament", "Atomic Culture", "Racket Rally", "Stats Fail"];
function Q1(e) {
  var U, v, S;
  let { startDate: t, endDate: r } = e ?? {}, { tournamentName: i = Di(AW), ratingsParameters: n = Ur, tournamentExtensions: a, policyDefinitions: o, schedulingProfile: s, venueProfiles: c, uuids: u } = e ?? {}, d = (e == null ? void 0 : e.isMock) === !1 ? void 0 : !0;
  if (t && !mi(t) || r && !mi(r)) return { error: Sr };
  if (e.leagueProfiles && !Array.isArray(e.leagueProfiles) || e.eventProfiles && !Array.isArray(e.eventProfiles) || e.drawProfiles && !Array.isArray(e.drawProfiles)) return { error: ie };
  if (!t) {
    let T = /* @__PURE__ */ new Date();
    t = ln(r ?? T), r = ln(T.setDate(T.getDate() + 7));
  }
  if (!r) {
    let T = new Date(t);
    r = ln(T.setDate(T.getDate() + 7));
  }
  let l = Ph({ ...e.tournamentAttributes ?? {}, tournamentName: i, startDate: t, endDate: r, isMock: d }), p = c != null && c.length ? Uy({ tournamentRecord: l, venueProfiles: c, uuids: u }) : [];
  if (a != null && a.length && Array.isArray(a)) {
    let T = a.filter((A) => Wn({ extension: A }));
    T != null && T.length && Object.assign(l, { extensions: T, isMock: d });
  }
  if (typeof o == "object") for (let T of Object.keys(o)) Co({ policyDefinitions: { [T]: o[T] }, tournamentRecord: l });
  if (!((U = e == null ? void 0 : e.leagueProfiles) != null && U.length) || (v = e.eventProfiles) != null && v.length || (S = e.drawProfiles) != null && S.length || e.participantsProfile) {
    let T = j1({ tournamentRecord: l, ...e });
    if (!T.success) return T;
  }
  let f = [], m = [], h = [];
  if (e.leagueProfiles) {
    let T = yW({ allUniqueParticipantIds: f, tournamentRecord: l, ...e, eventIds: m, venueIds: p, drawIds: h });
    if (T != null && T.error) return T;
  }
  if (e.drawProfiles) {
    let T = TW({ allUniqueParticipantIds: f, ratingsParameters: n, tournamentRecord: l, ...e, eventIds: m, drawIds: h });
    if (T != null && T.error) return T;
  }
  if (e.eventProfiles) {
    let T = DW({ allUniqueParticipantIds: f, ratingsParameters: n, tournamentRecord: l, ...e, eventIds: m, drawIds: h });
    if (T != null && T.error) return T;
  }
  let { scheduledRounds: g = void 0, schedulerResult: I = {} } = s ? PW({ ...e, tournamentRecord: l }) : {};
  return _I(), ye({ ...j, tournamentRecord: l, scheduledRounds: g, schedulerResult: I, eventIds: m, venueIds: p, drawIds: h });
}
function TW(e) {
  let { tournamentRecord: t, drawProfiles: r, allUniqueParticipantIds: i, eventIds: n, drawIds: a } = e, o = 0;
  for (let s of r) {
    let c = wh({ allUniqueParticipantIds: i, tournamentRecord: t, drawProfile: s, drawIndex: o, ...e });
    if (c.error) return c;
    let { drawId: u, eventId: d, event: l, uniqueParticipantIds: p } = c;
    if ((s == null ? void 0 : s.addEvent) !== !1) {
      if (c = su({ suppressNotifications: !1, internalUse: !0, tournamentRecord: t, event: l }), c.error) return c;
      u && a.push(u), n.push(d);
    }
    p != null && p.length && i.push(...p), o += 1;
  }
}
function DW(e) {
  let { eventProfiles: t, allUniqueParticipantIds: r, eventIds: i, drawIds: n } = e, a = 0;
  for (let o of t) {
    let s = K1({ ...e, eventIndex: a, eventProfile: o });
    if (s.error) return s;
    let { eventId: c, drawIds: u, uniqueParticipantIds: d } = s;
    u && n.push(...u), i.push(c), d != null && d.length && r.push(...d), a += 1;
  }
}
function PW(e) {
  let { schedulingProfile: t, tournamentRecord: r, autoSchedule: i, periodLength: n, scheduleCompletedMatchUps: a } = e, o = IW({ schedulingProfile: t, tournamentRecord: r });
  if (o.error) return o;
  let s = o.scheduledRounds;
  if (i) {
    let { tournamentId: c } = r, u = { [c]: r };
    return { schedulerResult: Dh({ scheduleCompletedMatchUps: a, tournamentRecords: u, periodLength: n }), scheduledRounds: s };
  }
  return { scheduledRounds: s };
}
var J1 = {};
qe(J1, { anonymizeTournamentRecord: () => $1, modifyTournamentRecord: () => eO });
function $1({ keepExtensions: e = [], anonymizeParticipantNames: t = !0, tournamentRecord: r, tournamentName: i, personIds: n = [], tournamentId: a }) {
  var F, x, V, k, L;
  if (!r) return { error: de };
  let o = Array.isArray(e) ? dT.concat(...e) : dT, s = (B) => {
    var G;
    return Array.isArray(e) ? (G = B == null ? void 0 : B.extensions) == null ? void 0 : G.filter((q) => o.includes(q.name)) : B == null ? void 0 : B.extensions;
  }, c = {};
  r.extensions = s(r);
  let u = a || st();
  c[r.tournamentId] = u, r.tournamentId = u, r.createdAt = (/* @__PURE__ */ new Date()).toISOString(), r.tournamentName = i || `Anonymized: ${ln(/* @__PURE__ */ new Date())}`, r.isMock = !0, delete r.parentOrganisation;
  for (let B of r.participants || []) {
    B.extensions = s(B), B.onlineResources = [];
    let G = st();
    c[B.participantId] = G, B.participantId = G;
  }
  for (let B of r.participants || []) Array.isArray(B.individualParticipantIds) && (B.individualParticipantIds = B.individualParticipantIds.map((G) => c[G]));
  let d = 0;
  for (let B of r.venues || []) {
    B.venueAbbreviation = `V${d}`, B.extensions = s(B), B.venueName = `Venue #${d}`, B.onlineResources = [], B.addresses = [];
    let G = st();
    c[B.venueId] = G, B.isMock = !0, d += 1;
    let q = 0;
    for (let Y of B.courts || []) Y.courtName = `V${d}C${q}`, Y.extensions = s(Y), Y.onlineResources = [], Y.isMock = !0, q += 1;
  }
  let l = 1;
  for (let B of r.events || []) {
    B.extensions = s(B), B.onlineResources = [], B.isMock = !0;
    let G = st();
    c[B.eventId] = G, B.eventId = G;
    let q = ((F = B.category) == null ? void 0 : F.categoryName) || ((x = B.category) == null ? void 0 : x.ageCategoryCode) || ((V = B.category) == null ? void 0 : V.ratingType) || B.gender;
    if (B.eventName = `Event ${l} ${q}`, Array.isArray(B.entries)) for (let H of B.entries) H.participantId = c[H.participantId];
    for (let H of B.drawDefinitions || []) {
      H.extensions = s(H);
      let X = st();
      if (c[H.drawId] = X, H.drawId = X, H.isMock = !0, Array.isArray(H.entries)) for (let Z of H.entries) Z.participantId = c[Z.participantId];
      let z = (Z) => {
        Z.extensions = s(Z);
        let te = st();
        c[Z.structureId] = te, Z.structureId = te;
        for (let ne of Z.positionAssignments || []) ne.participantId && (ne.participantId = c[ne.participantId]);
        for (let ne of Z.seedAssignments || []) ne.participantId && (ne.participantId = c[ne.participantId]);
        for (let ne of Z.matchUps || []) {
          ne.isMock = !0;
          for (let ee of ne.sides || []) ee.lineUp && (ee.lineUp = ee.lineUp.map(({ participantId: K, collectionAssignments: J }) => ({ participantId: c[K], collectionAssignments: J })));
        }
      };
      for (let Z of H.structures || []) if (z(Z), Array.isArray(Z.structures)) for (let te of Z.structures) z(te);
      for (let Z of H.links || []) Z.source.structureId = c[Z.source.structureId], Z.target.structureId = c[Z.target.structureId];
    }
    let { extension: Y } = We({ name: gn, element: B });
    Array.isArray((k = Y == null ? void 0 : Y.value) == null ? void 0 : k.flights) && ((L = Y == null ? void 0 : Y.value.flights) == null || L.forEach((H) => {
      if (H.drawId = c[H.drawId], Array.isArray(H.drawEntries)) for (let X of H.drawEntries) X.participantId = c[X.participantId];
    })), l += 1;
  }
  let p = r.startDate || ln(/* @__PURE__ */ new Date()), f = (r.participants || []).filter(({ participantType: B }) => B === Xe), m = f.reduce((B, G) => {
    var Y;
    let q = (Y = G.person) == null ? void 0 : Y.sex;
    return [pt, St].includes(q) ? B[q] += 1 : B[vo] += 1, B;
  }, { [pt]: 0, [St]: 0, [vo]: 0 }), h = Object.assign({}, ...Object.keys(m).map((B) => {
    var G;
    return { [B]: ((G = G1({ category: { ageCategoryCode: "O18" }, count: m[B], addressProps: { citiesCount: 10 }, personExtensions: [], consideredDate: p, sex: B })) == null ? void 0 : G.persons) || [] };
  })), g = { [pt]: 0, [St]: 0, [vo]: 0 }, I = f.length, U = f.reduce((B, G) => {
    var z, Z;
    let q = ((Z = (z = G.person) == null ? void 0 : z.addresses) == null ? void 0 : Z[0]) || {}, { city: Y, state: H, postalCode: X } = q;
    return B.cities.includes(Y) || B.cities.push(Y), B.states.includes(H) || B.states.push(H), B.postalCodes.includes(X) || B.postalCodes.push(X), B;
  }, { cities: [], postalCodes: [], states: [] }), v = U.postalCodes.length, S = U.cities.length, T = U.states.length, { cities: A } = L1({ count: S || I, participantsCount: I }), { states: y } = x1({ count: T || I, participantsCount: I }), { postalCodes: D } = B1({ count: v || I, participantsCount: I }), P = { cities: A, states: y, postalCodes: D };
  f.forEach((B, G) => {
    var Z, te;
    let q = B == null ? void 0 : B.person, Y = (q == null ? void 0 : q.sex) || vo, H = (Z = Ve(q == null ? void 0 : q.birthDate)) == null ? void 0 : Z.split("-")[0], X = g[Y], z = h[Y][X];
    if (g[Y] += 1, H) {
      let [, ne, ee] = ((te = z == null ? void 0 : z.birthDate) == null ? void 0 : te.split("-")) || [], K = [H, ne, ee].join("-");
      z.birthDate = K;
    }
    if (q != null && q.addresses) {
      let ne = V1({ ...P, participantIndex: G, nationalityCode: z.nationalityCode });
      z.addresses = [ne];
    }
    z.personId = (n == null ? void 0 : n[G]) || st(), t ? (z.standardFamilyName = z.lastName, z.standardGivenName = z.firstName, B.participantName = `${z.standardGivenName} ${z.standardFamilyName}`) : (z.standardFamilyName = q == null ? void 0 : q.standardFamilyName, z.standardGivenName = q == null ? void 0 : q.standardGivenName), delete z.firstName, delete z.lastName, z.extensions = s(q), B.person = z, c[q == null ? void 0 : q.personId] = z.personId;
  }), (r.participants || []).filter(({ participantType: B }) => B === _e).forEach((B) => {
    let { individualParticipantIds: G } = B;
    B.participantName = wW({ individualParticipantIds: G, individualParticipants: f });
  });
  let w = (r.participants || []).filter(({ participantType: B }) => B === lt), R = w.length, b = Op({ count: R }).names;
  w.forEach((B, G) => {
    B.participantName = b[G];
  });
  let E = (r.participants || []).filter(({ participantType: B }) => B === Gi), O = E.length, M = Op({ count: O, nameRoot: "Group" }).names;
  E.forEach((B, G) => {
    B.participantName = M[G];
  });
  let { extension: N } = We({ element: r, name: Us });
  Array.isArray(N == null ? void 0 : N.value) && (N == null || N.value.forEach((B) => {
    B.tournamentId = c[B.tournamentId], B.structureId = c[B.structureId], B.eventId = c[B.eventId], B.drawId = c[B.drawId];
  }));
  let { extension: C } = We({ element: r, name: Kc });
  return Array.isArray(C == null ? void 0 : C.value) && (C == null || C.value.forEach((B) => {
    B.personId = c[B.personId];
  })), { ...j };
}
function wW({ individualParticipantIds: e, individualParticipants: t }) {
  let r = t.filter(({ participantId: i }) => e.includes(i)).map(({ person: i }) => i == null ? void 0 : i.standardFamilyName).filter(Boolean).sort().join("/");
  return e.length === 1 && (r += "/Unknown"), r;
}
function eO(e) {
  var P, w, R;
  let { ratingsParameters: t = Ur, participantsProfile: r = {}, matchUpStatusProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, schedulingProfile: c, tournamentRecord: u, autoSchedule: d, eventProfiles: l, periodLength: p, venueProfiles: f, drawProfiles: m, isMock: h, uuids: g } = e;
  if (!u) return { error: de };
  let I = [], U = [], v = [];
  l == null || l.forEach((b) => {
    var O;
    let E = (O = u.events) == null ? void 0 : O.find((M, N) => b.eventIndex !== void 0 && N === b.eventIndex || b.eventName && M.eventName === b.eventName || b.eventId && M.eventId === b.eventId);
    E != null && E.gender && (b.gender = E.gender);
  });
  let S = ((P = u.participants) == null ? void 0 : P.length) || void 0;
  S && (r != null && r.idPrefix) && (r.idPrefix = `${r.idPrefix}-${S}`);
  let T = j1({ startDate: u.startDate, participantsProfile: r, tournamentRecord: u, eventProfiles: l, drawProfiles: m, uuids: g });
  if (!T.success) return T;
  if (l) {
    let b = ((w = u.events) == null ? void 0 : w.length) || 0;
    for (let E of l) {
      let { ratingsParameters: O } = E, M = (R = u.events) == null ? void 0 : R.find((N, C) => E.eventIndex !== void 0 && C === E.eventIndex || E.eventName && N.eventName === E.eventName || E.eventId && N.eventId === E.eventId);
      if (M) {
        let { gender: N, category: C, eventType: F } = M, { drawProfiles: x, publish: V } = E, k = Kt(jn)(F) && Xe || Kt(Xi)(F) && _e || F;
        if (x) {
          let { stageParticipantsCount: L, uniqueParticipantsCount: B, uniqueParticipantStages: G } = _1({ drawProfiles: x, category: C, gender: N }), { uniqueDrawParticipants: q = [], uniqueParticipantIds: Y = [] } = G ? Y1({ event: { eventType: F, category: C, gender: N }, uniqueParticipantsCount: B, participantsProfile: r, ratingsParameters: O, tournamentRecord: u, eventProfile: E, uuids: g }) : {};
          I.push(...Y);
          let { stageParticipants: H } = W1({ targetParticipants: u.participants || [], allUniqueParticipantIds: I, stageParticipantsCount: L, eventParticipantType: k }), X = z1({ uniqueDrawParticipants: q, autoEntryPositions: a, stageParticipants: H, tournamentRecord: u, drawProfiles: x, category: C, gender: N, event: M });
          if (X.error || (X = H1({ matchUpStatusProfile: i, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: x, isMock: h, event: M }), X.error)) return X;
          v.push(...X.drawIds);
        }
        V && uu({ tournamentRecord: u, event: M });
      } else {
        let N = K1({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, randomWinningSide: s, ratingsParameters: O, tournamentRecord: u, eventProfile: E, eventIndex: b, uuids: g });
        if (N.error) return N;
        let { eventId: C, drawIds: F, uniqueParticipantIds: x } = N;
        F && v.push(...F), U.push(C), x != null && x.length && I.push(...x), b += 1;
      }
    }
  }
  if (m) {
    let b = (u.events || []).map((E) => {
      var O;
      return ((O = E.drawDefinitions) == null ? void 0 : O.map(() => 1)) || [];
    }).flat().reduce((E, O) => E + O, 0);
    for (let E of m) {
      let O = wh({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: t, tournamentRecord: u, drawProfile: E, drawIndex: b, uuids: g });
      if (O.error) return O;
      let { drawId: M, eventId: N, event: C, uniqueParticipantIds: F } = O;
      if (O = su({ tournamentRecord: u, event: C, internalUse: !0 }), O.error) return O;
      M && v.push(M), U.push(N), F != null && F.length && I.push(...F), b += 1;
    }
  }
  let A = f != null && f.length ? Uy({ tournamentRecord: u, venueProfiles: f }) : [], y, D = {};
  if (c != null && c.length) {
    let b = { [u.tournamentId]: u }, E = au({ tournamentRecords: b, schedulingProfile: c });
    if (E.error) return E;
    if (d) {
      let { tournamentId: O } = u, M = { [O]: u };
      D = Dh({ tournamentRecords: M, periodLength: p });
    }
  }
  return { totalParticipantsCount: u.participants.length, scheduledRounds: y, schedulerResult: D, ...j, eventIds: U, venueIds: A, drawIds: v };
}
var tO = {};
qe(tO, { addDynamicRatings: () => YU, addIndividualParticipantIds: () => Ih, addParticipant: () => Yn, addParticipants: () => Un, addPenalty: () => AO, addPersonRequests: () => sO, addPersons: () => TO, createGroupParticipant: () => fO, createTeamsFromParticipantAttributes: () => my, deleteParticipants: () => Ws, filterParticipants: () => jd, findParticipant: () => pO, getCompetitionParticipants: () => oS, getPairedParticipant: () => vn, getParticipantEventDetails: () => sS, getParticipantMembership: () => cS, getParticipantScaleItem: () => Ec, getParticipantSchedules: () => uS, getParticipantSignInStatus: () => dS, getParticipantTimeItem: () => Bv, getParticipants: () => Lt, getScaleValues: () => zc, mergeParticipants: () => yO, modifyIndividualParticipantIds: () => cO, modifyParticipant: () => vh, modifyParticipantName: () => mO, modifyParticipantOtherName: () => dO, modifyParticipantsSignInStatus: () => uO, modifyPenalty: () => UO, modifyPersonRequests: () => aO, mutate: () => rO, participantScaleItem: () => ta, query: () => oE, regenerateParticipantNames: () => lO, removeIndividualParticipantIds: () => nU, removeParticipantIdsFromAllTeams: () => Dm, removePenalty: () => IO, removePersonRequests: () => oO, removeRatings: () => gO, scaledTeamAssignment: () => hO, setParticipantScaleItem: () => nl, setParticipantScaleItems: () => t0, validateLineUp: () => wm });
var rO = {};
qe(rO, { addDynamicRatings: () => YU, addIndividualParticipantIds: () => Ih, addParticipant: () => Yn, addParticipants: () => Un, addPenalty: () => AO, addPersonRequests: () => sO, addPersons: () => TO, createGroupParticipant: () => fO, createTeamsFromParticipantAttributes: () => my, deleteParticipants: () => Ws, findParticipant: () => pO, mergeParticipants: () => yO, modifyIndividualParticipantIds: () => cO, modifyParticipant: () => vh, modifyParticipantName: () => mO, modifyParticipantOtherName: () => dO, modifyParticipantsSignInStatus: () => uO, modifyPenalty: () => UO, modifyPersonRequests: () => aO, regenerateParticipantNames: () => lO, removeIndividualParticipantIds: () => nU, removeParticipantIdsFromAllTeams: () => Dm, removePenalty: () => IO, removePersonRequests: () => oO, removeRatings: () => gO, scaledTeamAssignment: () => hO, setParticipantScaleItem: () => nl, setParticipantScaleItems: () => t0 });
function iO(e = 0) {
  (typeof e != "number" || isNaN(e)) && (e = 0);
  let t = /* @__PURE__ */ new Date();
  return t.setHours(t.getHours() + e), t.getTime().toString(36).slice(-6).toUpperCase();
}
function nO({ personRequests: e, personId: t, requests: r }) {
  e[t] || (e[t] = []);
  let i = r.filter(({ requestType: n }) => n).map((n) => {
    let { date: a, startTime: o, endTime: s } = n;
    return n.requestType === gl && (a = Ve(a), o = Rt(o), s = Rt(s), a && o && s) ? { date: a, startTime: o, endTime: s, requestType: n.requestType } : n;
  }).filter(Boolean);
  for (let n of i) n.requestId = iO(), e[t].push(n);
  return { mergeCount: i.length };
}
function Sy(e) {
  let { tournamentRecords: t, personRequests: r } = e, i = Ae(e, [{ [_r]: !0 }]);
  if (i.error) return i;
  if (!r) return { ...j };
  let n = Object.values(t);
  for (let a of n) {
    let o = a.participants ?? [], s = [];
    for (let c of Object.keys(r)) if (za({ tournamentParticipants: o, personId: c })) {
      let u = r[c];
      u.length && s.push({ personId: c, requests: u });
    }
    Object.keys(s).length && it({ element: a, extension: { value: s, name: Kc } });
  }
  return { ...j };
}
function aO(e) {
  let { tournamentRecords: t, requests: r, personId: i } = e, n = Ae(e, [{ [_r]: !0 }, { requests: !0, [ui]: Gr, [xi]: ie }]);
  if (n.error) return n;
  let a = r.map(({ requestId: u }) => u).filter(Boolean), { personRequests: o } = Qo({ tournamentRecords: t }), s = (u) => {
    o && (o[u] = o[u].map((d) => {
      if (!a.includes(d.requestId)) return d;
      let l = r.find((p) => p.requestId === d.requestId);
      if (l.requestType) return Object.assign(d, l);
    }).filter(Boolean));
  };
  if (i && (o != null && o[i])) s(i);
  else if (o) for (let u of Object.keys(o)) s(u);
  let c = r.filter((u) => !u.requestId);
  return c.length && nO({ personRequests: o, personId: i, requests: c }), Sy({ tournamentRecords: t, personRequests: o });
}
function oO(e) {
  let { tournamentRecords: t, requestType: r, requestId: i, personId: n, date: a } = e, o = Ae(e, [{ [_r]: !0 }]);
  if (o.error) return o;
  let { personRequests: s } = Qo({ tournamentRecords: t }), c = (d) => {
    var l;
    s && (s[d] = s[d].filter((p) => (!r || p.requestType !== r) && (!i || p.requestId !== i) && (!a || p.date !== a)), (l = s == null ? void 0 : s[d]) != null && l.length || delete s[d]);
  }, u = !r && !i && !n && !a;
  if (!u) {
    if (n && (s != null && s[n])) c(n);
    else if (s) for (let d of Object.keys(s)) c(d);
  }
  return u || !s || !Object.keys(s).length ? Zr({ name: Kc, tournamentRecords: t, discover: !0 }) : Sy({ tournamentRecords: t, personRequests: s });
}
function sO(e) {
  let { tournamentRecords: t, personId: r, requests: i } = e, n = Ae(e, [{ [_r]: !0, [hL]: !0 }, { requests: !0, [ui]: Gr, [xi]: ie }]);
  if (n.error) return n;
  let { personRequests: a } = Qo({ tournamentRecords: t }), { mergeCount: o } = nO({ personRequests: a, personId: r, requests: i });
  return o && a ? Sy({ tournamentRecords: t, personRequests: a }) : { error: ie };
}
function cO({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  let i = "modifyIndividualParticipantIds";
  if (!r) return W({ result: { error: de }, stack: i });
  if (!t || !e) return W({ result: { error: we }, stack: i });
  let n = r.participants || [], a = n.find((f) => f.participantId === t);
  if (!a) return W({ result: { error: Yt }, stack: i });
  if (![lt, Gi].includes(a.participantType)) return W({ result: { error: Nn }, context: { participantType: a.participantType }, stack: i });
  let o = e.filter((f) => {
    var m;
    return ((m = n.find((h) => h.participantId === f)) == null ? void 0 : m.participantType) !== Xe;
  });
  if (o.length) return W({ result: { error: Pi, invalidParticipantIds: o }, stack: i });
  let s = a.individualParticipantIds || [], c = e.filter((f) => !s.includes(f)), u = s.filter((f) => !e.includes(f)), d = Ih({ individualParticipantIds: c, groupingParticipantId: t, tournamentRecord: r });
  if (d.error) return W({ result: d, stack: i });
  let l = nU({ individualParticipantIds: u, groupingParticipantId: t, tournamentRecord: r });
  if (l.error) return W({ result: l, stack: i });
  let { topics: p } = Ji();
  if (p.includes(Lr)) {
    let f = n.find(({ participantId: m }) => m === t);
    Le({ topic: Lr, payload: { tournamentId: r.tournamentId, participants: [f] } });
  }
  return { ...d, ...l };
}
function uO({ tournamentRecord: e, participantIds: t, signInState: r }) {
  if (!e) return { error: de };
  if (!Array.isArray(t)) return { error: we };
  if (![Yu, xb].includes(r)) return { error: ie, signInState: r };
  let i = e.participants || [];
  if (!i.length) return { error: cd };
  let n = i.map(Ke), a = t.filter((u) => !n.includes(u));
  if (a.length) return { error: ie, context: { invalidParticipantIds: a } };
  let o = [], s = (/* @__PURE__ */ new Date()).toISOString();
  for (let u of i) {
    let { participantId: d } = u;
    if (t.includes(d)) {
      let l = FU({ duplicateValues: !1, tournamentRecord: e, participantId: d, timeItem: { itemType: Td, itemValue: r, createdAt: s } });
      if (l.error) return l;
      o.push(u);
    }
  }
  let { topics: c } = Ji();
  return o.length && c.includes(Lr) && Le({ topic: Lr, payload: { tournamentId: e.tournamentId, participants: o } }), { ...j };
}
function dO({ tournamentRecord: e, participantId: t, participantOtherName: r }) {
  if (!e) return { error: de };
  if (!t) return { error: cr };
  let { participant: i } = co({ tournamentRecord: e, participantId: t });
  if (!i) return { error: Yt };
  i.participantOtherName = r;
  let { topics: n } = Ji();
  return n.includes(Lr) && Le({ topic: Lr, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...j };
}
function eD({ personFormat: e, person: t }) {
  let r = (h) => h.replace(/\W/g, ""), i = (h) => /^[a-z]*$/.test(r(h)), n = (h) => /^[A-Z]*$/.test(r(h)), a = (h) => /^[LAST]{4}/.test(r(h)), o = (h) => h.toLowerCase().indexOf("l") < h.toLowerCase().indexOf("f"), s = (h) => h.indexOf(",") >= 0, c = (h) => h.toLowerCase().indexOf("f.") >= 0, u = (h) => h.toLowerCase().indexOf("f") < 0, d = (h) => h.indexOf(" ") > 0;
  if (!t) return;
  let l = d(e) ? " " : "", p = xg((t == null ? void 0 : t.standardGivenName) ?? ""), f = xg((t == null ? void 0 : t.standardFamilyName) ?? "");
  if (!e) return `${p}${l}${f}`;
  c(e) && !s(e) && !o(e) && (p = `${p[0]}.`), i(e) ? (p = p.toLowerCase(), f = f.toLowerCase()) : n(e) ? (p = p.toUpperCase(), f = f.toUpperCase()) : a(e) && (f = f.toUpperCase());
  let m = `${p}${l}${f}`;
  return u(e) ? m = f : o(e) && (s(e) ? m = `${f},${l}${p}` : m = `${f}${l}${p}`), m;
}
function RW({ participantMap: e, participant: t, formats: r }) {
  let { participantType: i, individualParticipantIds: n, person: a } = t, o = i && r[i];
  if (i !== ai && o) {
    let { personFormat: s, doublesJoiner: c } = o;
    i === Xe && (t.participantName = eD({ person: a, personFormat: s })), i === _e && (t.participantName = n == null ? void 0 : n.map((u) => {
      var l;
      let d = (l = e[u]) == null ? void 0 : l.person;
      return eD({ person: d, personFormat: s });
    }).filter(Boolean).join(c ?? "/"));
  }
}
function lO({ tournamentRecord: e, formats: t }) {
  if (!e) return { error: de };
  if (!$e(t)) return { error: we };
  let r = e.participants ?? [], i = LP(r, "participantId");
  for (let n of r) RW({ participant: n, participantMap: i, formats: t });
  return { ...j };
}
function pO(e) {
  let { tournamentRecord: t, policyDefinitions: r, contextProfile: i, participantId: n, personId: a } = e, o = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "string" && typeof a != "string") return { error: we, stack: "publicFindParticipant" };
  let s, c;
  for (let u of Object.values(o)) {
    c = u.tournamentId;
    let d = u.participants || [];
    if (s = za({ tournamentParticipants: d, internalUse: !0, policyDefinitions: r, contextProfile: i, participantId: n, personId: a }), s) break;
  }
  return { participant: s, tournamentId: c, ...j };
}
function fO({ individualParticipantIds: e = [], participantRoleResponsibilities: t, participantRole: r = DN, tournamentRecord: i, participantId: n, groupName: a }) {
  if (!i) return { error: de };
  if (!a) return { error: we, info: "Missing groupName" };
  if (!Array.isArray(e)) return { info: "Invalid individualParticipantIds", error: ie };
  let o = (Lt({ participantFilters: { participantTypes: [Xe] }, tournamentRecord: i }).participants ?? []).map((d) => d.participantId);
  for (let d of e) if (!o.includes(d)) return { error: Nn, participantId: d };
  let s = ye({ participantId: n || st(), participantRoleResponsibilities: t, participantName: a, individualParticipantIds: e, participantType: Gi, participantRole: r }), c = Yn({ participant: s, tournamentRecord: i });
  if (c.error) return c;
  let { topics: u } = Ji();
  return u.includes(Xa) && Le({ topic: Xa, payload: { tournamentId: i.tournamentId, participants: [s] } }), { ...j, participant: ge(s) };
}
function mO({ tournamentRecord: e, participantName: t, participantId: r }) {
  if (!e) return { error: de };
  if (!r) return { error: cr };
  if (!t) return { error: we, info: "Missing participantName" };
  let { participant: i } = co({ tournamentRecord: e, participantId: r });
  if (!i) return { error: Yt };
  i.participantName = t;
  let { topics: n } = Ji();
  return n.includes(Lr) && Le({ topic: Lr, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...j };
}
function hO({ clearExistingAssignments: e = !0, individualParticipantIds: t, reverseAssignmentOrder: r, initialTeamIndex: i = 0, scaledParticipants: n = [], teamParticipantIds: a, tournamentRecord: o, scaleAttributes: s, teamNameBase: c, teamsCount: u, eventId: d, event: l }) {
  var I, U, v, S, T;
  if (!o) return { error: de };
  if (!Array.isArray(a) && !ke(u) && !d || !ke(i) || n && !Array.isArray(n) || s && (typeof s != "object" || !Object.keys(s).length)) return { error: ie };
  if (!s && !n.length || !n && !(t && s)) return { error: we, info: "Missing scaling details" };
  if (d && !a) {
    if ((l == null ? void 0 : l.eventType) !== bi) return { error: na };
    a = (I = l == null ? void 0 : l.entries) == null ? void 0 : I.filter(({ entryStatus: A }) => A === Ii).map(Ke);
  }
  if (!(a != null && a.length) && !u) return { info: "Missing teamParticipantIds or teamsCount", error: we };
  let p = t ?? n.map(({ participantId: A }) => A);
  r && (a == null || a.reverse(), i += 1), i > ((a == null ? void 0 : a.length) || 0) - 1 && (i = 0);
  let f = (a == null ? void 0 : a.slice(i).concat(...a.slice(0, i))) ?? [], m = [];
  for (let A of o.participants ?? []) {
    let { participantId: y, participantType: D } = A;
    if (f.includes(y)) {
      if (D !== ai) return { error: Nn, participant: A };
      m.push(A);
    }
  }
  if (u && m.length < u) {
    let A = u - ((m == null ? void 0 : m.length) || 0), y = c ?? "Team", D = fe(0, A).map((b) => ({ participantName: `${y} ${b + 1}`, participantType: ai, participantRole: Cr })), { participants: P = [] } = Un({ participants: D, returnParticipants: !0, tournamentRecord: o }), w = P.map(Ke), R = ((U = o.participants) == null ? void 0 : U.filter(({ participantId: b }) => w.includes(b))) ?? [];
    m.push(...R);
  }
  if (!m.length) return { error: LI };
  if (e) for (let A of m) A.individualParticipantIds = [];
  else {
    let A = m.map((y) => y).flat();
    t != null && t.length ? p = p.filter((y) => !A.includes(y)) : n = n == null ? void 0 : n.filter(({ participantId: y }) => !A.includes(y));
  }
  if (!(t != null && t.length) && !(n != null && n.length)) return { error: xf, info: "Nothing to be done" };
  if (!n.length) {
    for (let A of o.participants ?? []) {
      let { participantId: y, participantType: D } = A;
      if (!p.includes(y)) continue;
      if (D !== Xe) return { error: Nn, participant: A };
      let P = (v = ta({ scaleAttributes: s, participant: A })) == null ? void 0 : v.scaleItem, w = s != null && s.accessor ? (S = P == null ? void 0 : P.scaleValue) == null ? void 0 : S[s == null ? void 0 : s.accessor] : P == null ? void 0 : P.scaleValue, R = { participantId: y, scaleValue: w };
      n.push(R);
    }
    if (!n.length) return { error: Yt };
  }
  n.sort((A, y) => s != null && s.sortOrder ? ((y == null ? void 0 : y.scaleValue) || 0) - ((A == null ? void 0 : A.scaleValue) || 0) : ((A == null ? void 0 : A.scaleValue) || 1 / 0) - ((y == null ? void 0 : y.scaleValue) || 1 / 0));
  for (let A of n) if (!A.participantId) return { error: ie, scaledParticipant: A };
  let h = 0;
  for (; h < n.length; ) {
    for (let A of m) {
      if (h + 1 > n.length) break;
      let y = n[h];
      A.individualParticipantIds.push(y.participantId), h++;
    }
    m.reverse();
  }
  let g = m.map(Ke);
  for (let A of o.events ?? []) {
    if (A.eventType !== bi) continue;
    let y = (A.entries ?? []).filter((D) => g.includes(D.participantId));
    for (let D of y) {
      let P = D.participantId, w = (T = m.find((b) => b.participantId === P)) == null ? void 0 : T.individualParticipantIds;
      A.entries = (A.entries ?? []).filter((b) => !w.includes(b.participantId)), (A.drawDefinitions ?? []).forEach((b) => {
        b.entries = (b.entries ?? []).filter((E) => !w.includes(E.participantId));
      });
      let { flightProfile: R } = Ht({ event: A });
      ((R == null ? void 0 : R.flights) || []).forEach((b) => {
        b.drawEntries = (b.drawEntries || []).filter((E) => !w.includes(E.participantId));
      });
    }
  }
  return { ...j, scaledParticipants: n };
}
function gO(e) {
  let t = Ae(e, [{ [fr]: !0, [cv]: !0 }, { ratingType: !1, [Or]: (o) => Ur[o] }]);
  if (t.error) return t;
  let r = `${e.ratingType}.${pv}`, i = e.asDynamic ? r : e.ratingType, n = [Ro, qa, e.eventType, i].join("."), a = e.tournamentRecord.participants ?? [];
  for (let o of a) o.timeItems && (o.timeItems = o.timeItems.filter((s) => s.itemType !== n));
  return { ...j };
}
function IO(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = bW({ ...e, tournamentRecord: r });
    if (i.error && i.error !== mc) return i;
  }
  return { ...j };
}
function bW({ tournamentRecord: e, penaltyId: t }) {
  if (!e) return { error: de };
  if (!t) return { error: EI };
  let r = (e == null ? void 0 : e.participants) ?? [], i = [], n = !1, a;
  return r.forEach((o) => {
    let s = !1;
    o.penalties = (o.penalties ?? []).filter((c) => (c.penaltyId === t && (s = !0, n || (a = c, n = !0)), s && i.push(o), c.penaltyId !== t));
  }), a && Le({ topic: Lr, payload: { tournamentId: e.tournamentId, participants: i } }), a ? { ...j, penalty: a } : { error: mc };
}
var NW = ({ penaltyId: e = st() } = {}) => ({ refereeParticipantId: void 0, penaltyCode: void 0, penaltyType: void 0, extensions: void 0, matchUpId: void 0, createdAt: void 0, issuedAt: void 0, notes: void 0, penaltyId: e }), vO = NW;
function UO(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = MW({ ...e, tournamentRecord: r });
    if (i.error && i.error !== mc || i.success) return i;
  }
  return { error: mc };
}
function MW({ tournamentRecord: e, modifications: t, penaltyId: r }) {
  if (!e) return { error: de };
  if (!t) return { error: ie, modifications: t };
  if (!r) return { error: EI };
  let i = (e == null ? void 0 : e.participants) ?? [], n = Object.keys(vO()).filter((c) => c !== "penaltyId"), a = Object.keys(t).filter((c) => n.includes(c));
  if (!a.length) return { error: Bf };
  let o, s = [];
  return i.forEach((c) => {
    let u = !1;
    c.penalties = (c.penalties ?? []).map((d) => (d.penaltyId === r && (u = !0, a.forEach((l) => Object.assign(d, { [l]: t[l] })), o || (o = d)), d)), u && s.push(c);
  }), o && Le({ topic: Lr, payload: { tournamentId: e.tournamentId, participants: s } }), o ? { ...j, penalty: o } : { error: mc };
}
function SO(e, t, r) {
  return !e && t ? t : e && !t || typeof e != "object" || typeof t != "object" ? e : Be(Object.keys(e).concat(Object.keys(t))).reduce((i, n) => {
    if (!t[n]) i[n] = e[n];
    else if (!e[n]) i[n] = t[n];
    else if (typeof e[n] != typeof t[n]) i[n] = t[n];
    else if (Array.isArray(e[n])) if (r === !0 || Array.isArray(r) && r.includes(n)) {
      let a = Be(e[n].map((o) => JSON.stringify(o)).concat(t[n].map((o) => JSON.stringify(o)))).map((o) => JSON.parse(o));
      i[n] = a;
    } else i[n] = t[n];
    else typeof e[n] == "object" ? i[n] = SO(e[n], t[n], r) : i[n] = t[n];
    return i;
  }, {});
}
function yO({ participants: e = [], tournamentRecord: t, arraysToMerge: r }) {
  if (!t) return { error: de };
  t.participants || (t.participants = []);
  let i = e.filter(Ni(ca)).map((u) => ({ [u.participantId]: u })), n = Object.assign({}, ...i), a = [];
  t.participants = t.participants.map((u) => {
    if (n[u.participantId]) {
      let d = SO(u, n[u.participantId], r);
      return a.push(d), d;
    }
    return u;
  });
  let o = t.participants.map(Ni(ca)) || [], s = e.filter(({ participantId: u }) => !o.includes(u)), { topics: c } = Ji();
  return s.length && (t.participants = t.participants.concat(...s), c.includes(Xa) && Le({ topic: Xa, payload: { participants: s } })), a.length && c.includes(Lr) && Le({ topic: Lr, payload: { tournamentId: t.tournamentId, participants: a } }), { modifiedParticipantsCount: a.length, newParticipantsCount: s.length, ...j };
}
function AO(e) {
  var a;
  let { tournamentRecord: t, participantIds: r } = e, i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n;
  for (let o of Object.values(i)) {
    let s = (a = Lt({ tournamentRecord: o }).participants ?? []) == null ? void 0 : a.map(Ke).filter((c) => r.includes(c));
    s.length && (n = EW({ ...e, penaltyId: e.penaltyId ?? n, tournamentRecord: o, participantIds: s }).penaltyId);
  }
  return n ? { ...j, penaltyId: n } : { error: Yt };
}
function EW({ refereeParticipantId: e, tournamentRecord: t, participantIds: r, penaltyCode: i, penaltyType: n, extensions: a, penaltyId: o, matchUpId: s, issuedAt: c, notes: u }) {
  if (!t) return { error: de };
  if (!r) return { error: cr };
  if (!n) return { error: Rw };
  let d = ((t == null ? void 0 : t.participants) ?? []).filter((f) => r.includes(f.participantId));
  if (!d.length) return { error: Yt };
  let l = (/* @__PURE__ */ new Date()).toISOString(), p = Object.assign(vO({ penaltyId: o }), { refereeParticipantId: e, penaltyCode: i, penaltyType: n, matchUpId: s, createdAt: l, issuedAt: c, notes: u });
  return Array.isArray(a) && a.forEach((f) => it({ element: p, extension: f })), d.forEach((f) => {
    f.penalties || (f.penalties = []), f.penalties.push(p);
  }), Le({ topic: Lr, payload: { tournamentId: t.tournamentId, participants: d } }), { ...j, penaltyId: p.penaltyId };
}
function TO({ participantRole: e = Cr, tournamentRecord: t, persons: r }) {
  var m;
  if (!t) return { error: de };
  if (!Array.isArray(r)) return { error: ie };
  if (!Object.keys(iU).includes(e)) return { error: gw };
  let i = (t.participants || []).map(({ person: h }) => h == null ? void 0 : h.personId).filter(Boolean), n = [], a = r.filter((h) => h && (!h.personId || !i.includes(h.personId))).map((h) => (h.personId || (h.personId = st()), n.push(h.personId), h)), o = (h, g) => Object.assign({}, ...Object.keys(h).filter((I) => !g.includes(I)).map((I) => ({ [I]: h[I] }))), s = a.map((h) => ye({ extensions: h.participantExtensions, timeItems: h.participantTimeItems, participantType: Xe, participantRole: e, person: o(h, ["participantExtensions", "participantTimeItems", "pairedPersons"]) })), c = 0, u = 0, d = Un({ participants: s, tournamentRecord: t });
  if (d.error) return d;
  u = d.addedCount || 0;
  let l = [], p = ((m = Lt({ participantFilters: { participantTypes: [Xe] }, tournamentRecord: t })) == null ? void 0 : m.participants) ?? [];
  if (e === Cr && r.filter(({ pairedPersons: h }) => h).forEach(({ personId: h, pairedPersons: g }) => {
    Array.isArray(g) && g.forEach((I) => {
      let U = [h, I.personId].map((v) => za({ tournamentParticipants: p, personId: v })).filter(Boolean);
      if (U.length === 2) {
        let v = U.map(Ke);
        l.push(ye({ extensions: I.participantExtensions, timeItems: I.timeItems, participantRole: Cr, individualParticipantIds: v, participantType: _e }));
      }
    });
  }), l.length) {
    if (d = Un({ participants: l, tournamentRecord: t }), d.error) return d;
    c = d.addedCount || 0;
  }
  let f = u + c;
  return { ...j, addedCount: f, newPersonIds: n };
}
var DO = {};
qe(DO, { bulkUpdatePublishedEventIds: () => IS, getAllEventData: () => vS, getCourtInfo: () => Um, getDrawData: () => Jm, getEventData: () => $m, getEventPublishStatus: () => nn, getPublishState: () => _s, getTournamentPublishStatus: () => Gd, getVenueData: () => Rc, mutate: () => PO, publishEvent: () => uu, publishEventSeeding: () => wO, publishOrderOfPlay: () => EO, publishParticipants: () => MO, query: () => pE, setEventDisplay: () => ph, unPublishEvent: () => OO, unPublishEventSeeding: () => RO, unPublishOrderOfPlay: () => NO, unPublishParticipants: () => bO });
var PO = {};
qe(PO, { publishEvent: () => uu, publishEventSeeding: () => wO, publishOrderOfPlay: () => EO, publishParticipants: () => MO, setEventDisplay: () => ph, unPublishEvent: () => OO, unPublishEventSeeding: () => RO, unPublishOrderOfPlay: () => NO, unPublishParticipants: () => bO });
function wO({ removePriorValues: e = !0, stageSeedingScaleNames: t, seedingScaleNames: r, tournamentRecord: i, status: n = ji, drawIds: a = [], event: o }) {
  var l, p, f, m;
  if (!i) return { error: de };
  if (!o) return { error: At };
  let s = nn({ event: o, status: n }), c = (((l = s == null ? void 0 : s.seeding) == null ? void 0 : l.seedingScaleNames) || r) && { ...(p = s == null ? void 0 : s.seeding) == null ? void 0 : p.seedingScaleNames, ...r }, u = (((f = s == null ? void 0 : s.seeding) == null ? void 0 : f.stageSeedingScaleNames) || t) && { ...(m = s == null ? void 0 : s.seeding) == null ? void 0 : m.stageSeedingScaleNames, ...t }, d = ye({ stageSeedingScaleNames: u, seedingScaleNames: c, published: !0, drawIds: a });
  return cu({ statusObject: { seeding: d }, removePriorValues: e, status: n, event: o }), Le({ topic: Ob, payload: { tournamentId: i.tournamentId, eventId: o.eventId, drawIds: a } }), { ...j };
}
function RO({ removePriorValues: e = !0, seedingScaleNames: t, tournamentRecord: r, status: i = ji, drawIds: n, stages: a, event: o }) {
  var c, u;
  if (!r) return { error: de };
  if (!o) return { error: At };
  let s = nn({ event: o });
  if (s) {
    let d = s.seeding;
    if (Array.isArray(a) && d.stageSeedingScaleNames) for (let l of a) d.stageSeedingScaleNames[l] && delete d.stageSeedingScaleNames[l];
    Array.isArray(t) && (d != null && d.seedingScaleNames) && (d.seedingScaleNames = d.seedingScaleNames.filter((l) => !t.includes(l))), Array.isArray(n) && (d != null && d.drawIds) && (d.drawIds = d.drawIds.filter((l) => !n.includes(l))), (!Object.values(d.stageSeedingScaleNames ?? {}).length && !((c = d.seedingScaleNames) != null && c.length) && !((u = d.drawIds) != null && u.length) || !a && !t && !(n != null && n.length)) && (delete d.stageSeedingScaleNames, delete d.seedingScaleNames, delete d.drawIds, d.published = !1), cu({ statusObject: { seeding: d }, removePriorValues: e, status: i, event: o });
  }
  return Le({ topic: Fv, payload: { tournamentId: r.tournamentId, eventId: o.eventId } }), { ...j };
}
function bO(e) {
  let t = $i(e);
  if (!Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = OW({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...j };
}
function OW({ removePriorValues: e = !0, tournamentRecord: t, status: r = ji }) {
  if (!t) return { error: de };
  let i = `${uo}.${lo}`, { timeItem: n } = en({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r] && delete a[r].participants, Xn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Le({ payload: { tournamentId: t.tournamentId }, topic: qL }), { ...j };
}
function NO(e) {
  let t = $i(e);
  if (!Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = CW({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...j };
}
function CW({ removePriorValues: e = !0, tournamentRecord: t, status: r = ji }) {
  if (!t) return { error: de };
  let i = `${uo}.${lo}`, { timeItem: n } = en({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r] && delete a[r].orderOfPlay, Xn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Le({ topic: kv, payload: { tournamentId: t.tournamentId } }), { ...j };
}
function MO(e) {
  let t = $i(e);
  if (!Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = FW({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...j };
}
function FW({ removePriorValues: e, tournamentRecord: t, status: r = ji }) {
  if (!t) return { error: de };
  let i = `${uo}.${lo}`, { timeItem: n } = en({ element: t, itemType: i }), a = (n == null ? void 0 : n.itemValue) || { [r]: {} };
  return a[r].participants = { published: !0 }, Xn({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Le({ payload: { tournamentId: t.tournamentId }, topic: Fb }), { ...j };
}
function EO(e) {
  let t = $i(e);
  if (!Object.keys(t).length) return { error: xt };
  for (let r of Object.values(t)) {
    let i = kW({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...j };
}
function kW({ scheduledDates: e = [], removePriorValues: t, tournamentRecord: r, status: i = ji, eventIds: n = [] }) {
  if (!r) return { error: de };
  let a = `${uo}.${lo}`, { timeItem: o } = en({ element: r, itemType: a }), s = (o == null ? void 0 : o.itemValue) || { [i]: {} };
  return s[i].orderOfPlay = { published: !0, scheduledDates: e, eventIds: n }, Xn({ timeItem: { itemValue: s, itemType: a }, element: r, removePriorValues: t }), Le({ topic: Cb, payload: { tournamentId: r.tournamentId, scheduledDates: e, eventIds: n } }), { ...j };
}
function OO({ removePriorValues: e = !0, tournamentRecord: t, status: r = ji, event: i }) {
  if (!t) return { error: de };
  if (!i) return { error: At };
  let n = `${uo}.${lo}`, { timeItem: a } = Dd({ itemType: n, event: i }), o = (a == null ? void 0 : a.itemValue) || { [r]: {} };
  return delete o[r].structureIds, delete o[r].drawDetails, delete o[r].drawIds, Ys({ event: i, timeItem: { itemValue: o, itemType: n }, removePriorValues: e }), cu({ statusObject: { structureIds: void 0, drawIds: void 0, seeding: void 0 }, removePriorValues: e, status: r, event: i }), Le({ topic: Cv, payload: { tournamentId: t.tournamentId, eventId: i.eventId } }), { eventId: i.eventId, ...j };
}
var CO = {};
qe(CO, { getEntryStatusReports: () => xW, getParticipantStats: () => LW, getStructureReports: () => VW, getVenuesReport: () => jW });
function LW({ withCompetitiveProfiles: e, opponentParticipantId: t, withIndividualStats: r, teamParticipantId: i, tournamentRecord: n, withScaleValues: a, tallyPolicy: o, matchUps: s }) {
  var y, D, P, w, R;
  if (!n) return { error: de };
  if (s && !Array.isArray(s)) return { error: gi };
  if (s = s ?? Pr({ tournamentRecord: n, participantsProfile: a ? { withScaleValues: a } : void 0 }).matchUps, !(s != null && s.length)) return { error: Ma };
  let c = [];
  t && c.push(t), i && c.push(i);
  let u = c.length ? { participantIds: c } : { participantTypes: [ai] }, d = Lt({ participantFilters: u, tournamentRecord: n }).participants ?? [];
  if (!d.every(({ participantType: b }) => b === ai)) return { error: Pi };
  c.length || c.push(...d.map(Ke));
  let l = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), h = (b, E = "") => p.get(b) || p.set(b, { participantName: E, participantId: b, competitorIds: [], competitiveness: {}, matchUpStatuses: {}, tiebreaks: [0, 0], matchUps: [0, 0], points: [0, 0], games: [0, 0], sets: [0, 0] }) && p.get(b);
  for (let b of d) {
    let { participantId: E, individualParticipantIds: O } = b;
    m.set(E, O ?? []), h(E, b.participantName);
  }
  if (i && !m.get(i)) return W({ result: { error: Yt }, context: { teamParticipantId: i } });
  if (t && !m.get(t)) return W({ result: { error: Yt }, context: { opponentParticipantId: t } });
  let g = [], I = (b) => {
    let E = [[], []];
    for (let M of b) {
      let N = M.participant;
      if (N != null && N.participantName) {
        l.set(N.participantId, { participantName: N.participantName, ratings: N.ratings });
        let C = p.get(N.participantId);
        C && (C.participantName = N.participantName);
      }
    }
    let O = ({ side: M, individualParticipantIds: N }) => {
      var C, F, x, V, k;
      return M.participantId && (!(N != null && N.length) || N.includes(M.participantId)) && [M.participantId] || ((F = (C = M.participant) == null ? void 0 : C.individualParticipantIds) == null ? void 0 : F.length) && (!(N != null && N.length) || qt(N, (x = M.participant) == null ? void 0 : x.individualParticipantIds).length === ((k = (V = M.participant) == null ? void 0 : V.individualParticipantIds) == null ? void 0 : k.length)) && M.participant.individualParticipantIds;
    };
    if (m.size) {
      let M = (N, C) => {
        for (let F of b) {
          if (!F.participant) continue;
          let x = O({ individualParticipantIds: C, side: F });
          if (x != null && x.length) {
            let V = F.sideNumber;
            if (!V) continue;
            let k = [N];
            r && k.push(...x), E[V - 1] = k;
            let L = p.get(N);
            for (let B of x.filter(Boolean)) L && !L.competitorIds.includes(B) && L.competitorIds.push(B);
          }
        }
      };
      if (i) (!t || b.every((N) => N.participant && (O({ individualParticipantIds: m.get(i), side: N }) || O({ individualParticipantIds: m.get(t), side: N })))) && M(i, m.get(i));
      else for (let [N, C] of m) M(N, C);
    } else if (r) for (let M of b) {
      if (!M.participant) continue;
      let N = O({ individualParticipantIds: [], side: M }), C = M.sideNumber;
      C && (E[C - 1] = N);
    }
    return E;
  };
  for (let b of s) {
    if (!$e(b)) return { error: gi };
    let { matchUpStatus: E, matchUpFormat: O, matchUpType: M, winningSide: N, score: C, sides: F } = b;
    if (!F || !C || M === Ci || E === at) continue;
    let x = I(F);
    if (!x.filter(Boolean).length) continue;
    let V = e && N && ((y = Cd({ matchUp: b })) == null ? void 0 : y.competitiveness);
    g.push(b);
    let k = RU({ matchUpStatus: E, matchUpFormat: O, tallyPolicy: o, winningSide: N, score: C }), L = vM({ matchUpStatus: E, matchUpFormat: O, tallyPolicy: o, winningSide: N, score: C }), { pointsTally: B, tiebreaksTally: G } = UM({ matchUpFormat: O, score: C });
    x.forEach((q, Y) => {
      var H;
      for (let X of q) {
        let z = (H = l.get(X)) == null ? void 0 : H.participantName, Z = h(X, z);
        if (Z) {
          let te = ($, ae) => ae.forEach((oe, ce) => Z[$][ce] += oe), ne = Y ? [...G].reverse() : G, ee = Y ? [...B].reverse() : B, K = Y ? [...L].reverse() : L, J = Y ? [...k].reverse() : k;
          if (te("tiebreaks", ne), te("points", ee), te("games", K), te("sets", J), N) {
            let $ = N - 1 === Y ? 0 : 1;
            Z.matchUps[$] += 1;
          }
          if (V) {
            let $ = V.toLowerCase();
            Z.competitiveness[$] || (Z.competitiveness[$] = [0, 0]), Z.competitiveness[$][Y] += 1;
          }
          if (E) {
            let $ = E.toLowerCase();
            Z.matchUpStatuses[$] || (Z.matchUpStatuses[$] = 0), Z.matchUpStatuses[$] += 1;
          }
        }
      }
    });
  }
  let U = ["tiebreaks", "matchUps", "points", "games", "sets"], v = ["competitive", "routine", "decisive"], S = /* @__PURE__ */ new Map(), T = (b, E) => (b ?? 0) + (E ?? 0);
  for (let [b, E] of p.entries()) {
    for (let O of U) {
      let M = E[O].reduce(T);
      if (M) {
        let N = E[O][0] / M, C = `${O}Ratio`, F = parseFloat(N.toFixed(2));
        E[C] = F, f.set(b, !0), S.has(C) || S.set(C, []), (D = S.get(C)) == null || D.push(F);
      }
    }
    for (let O of v) {
      let M = (w = (P = E.competitiveness) == null ? void 0 : P[O]) == null ? void 0 : w.reduce(T);
      if (M) {
        let N = E.competitiveness[O][0] / M, C = `${O}Ratio`, F = parseFloat(N.toFixed(2));
        E[C] = F;
      }
    }
  }
  if (!i) {
    let b = (E, O) => O - E;
    for (let E of p.values()) for (let O of U) {
      let M = `${O}Ratio`;
      if (typeof E[M] == "number") {
        let N = (R = S.get(M)) == null ? void 0 : R.sort(b).indexOf(E[M]);
        if (typeof N == "number" && N >= 0) {
          let C = `${O}Rank`;
          E[C] = N + 1;
        }
      }
    }
  }
  let A = { relevantMatchUps: g, ...j };
  return i ? (A.teamStats = p.get(i), t && (A.opponentStats = p.get(t))) : A.participatingTeamsCount = f.size, A.allParticipantStats = [...p.values()], A;
}
function kp({ participant: e, eventType: t }) {
  var u, d, l, p, f, m;
  let r = (u = e == null ? void 0 : e.person) == null ? void 0 : u.personId, i = (l = (d = e == null ? void 0 : e.person) == null ? void 0 : d.personOtherIds) == null ? void 0 : l[0], n = (p = e == null ? void 0 : e.person) == null ? void 0 : p.tennisId, a = (m = (f = e == null ? void 0 : e.ratings) == null ? void 0 : f[t]) == null ? void 0 : m.find(({ scaleName: h }) => h === wU), o = a == null ? void 0 : a.scaleValue, { wtnRating: s, confidence: c } = o || {};
  return { timeStamp: a == null ? void 0 : a.scaleDate, personOtherId: i, confidence: c, wtnRating: s, personId: r, tennisId: n };
}
function xW({ tournamentRecord: e }) {
  if (!e) return { error: de };
  let t = e.tournamentId, { participantMap: r } = Lt({ withScaleValues: !0, withEvents: !0, withSeeding: !0, tournamentRecord: e, withDraws: !0 }), i = (Pr({ matchUpFilters: { matchUpTypes: [es, Ao] }, tournamentRecord: e }).matchUps ?? []).flatMap(({ sides: f, matchUpType: m }) => f == null ? void 0 : f.flatMap((h) => {
    var g, I;
    return m === Ao ? (g = h == null ? void 0 : h.participant) == null ? void 0 : g.individualParticipantIds : ((I = h == null ? void 0 : h.participant) == null ? void 0 : I.participantId) || h.participantId;
  }).filter(Boolean)).filter(Boolean), n = [], a = {}, o = {}, s = {}, c = 0, u = ({ id: f, entry: m, eventId: h, eventType: g }) => {
    var w;
    let { qualifyingSeeding: I, mainSeeding: U, entryStatus: v, entryStage: S, drawId: T } = m;
    a[f] || (a[f] = []);
    let { participant: A, events: y } = (r == null ? void 0 : r[f]) ?? {}, D = kp({ participant: A, eventType: g }), P = (w = y == null ? void 0 : y[h]) == null ? void 0 : w.ranking;
    v === yU && n.push(f), a[f].push({ participantType: A == null ? void 0 : A.participantType, participantId: f, tournamentId: t, eventType: g, eventId: h, drawId: T, entryStatus: v, entryStage: S, ...D, ranking: P, mainSeeding: U, qualifyingSeeding: I });
  };
  for (let f of e.events ?? []) {
    let m = {}, h = (y) => {
      m[y] || (m[y] = { count: 0 }), m[y].count += 1;
    }, { drawDefinitions: g = [], eventType: I, eventId: U } = f, v = g.flatMap((y) => {
      let { drawId: D, entries: P } = y;
      c += 1;
      let w = ({ stage: O, stageSequence: M }) => O === Ie && M === 1 || O === Pe, R = (y.structures ?? []).filter(w).flatMap(({ positionAssignments: O }) => O).filter(Boolean).map(({ participantId: O }) => O), b = ({ participantId: O }) => R.includes(O), E = (O) => {
        var x, V, k, L, B, G, q, Y;
        let { participantId: M, entryStatus: N, entryStage: C } = O;
        h(N);
        let F = (L = (k = (V = (x = r == null ? void 0 : r[M]) == null ? void 0 : x.draws) == null ? void 0 : V[D]) == null ? void 0 : k.seedAssignments) == null ? void 0 : L[Ie];
        return { qualifyingSeeding: (Y = (q = (G = (B = r == null ? void 0 : r[M]) == null ? void 0 : B.draws) == null ? void 0 : G[D]) == null ? void 0 : q.seedAssignments) == null ? void 0 : Y[Pe], participantId: M, mainSeeding: F, entryStatus: N, entryStage: C, drawId: D };
      };
      return P == null ? void 0 : P.filter(b).map(E);
    }), S = (y) => {
      var w;
      let D = y.participantId, P = (w = r == null ? void 0 : r[D].participant.individualParticipantIds) == null ? void 0 : w.filter((R) => i.includes(R));
      return D && { [D]: { individualParticipantIds: P } };
    };
    I === ya ? (() => {
      let y = Object.assign({}, ...v.map(S).filter(Boolean)), D = (P) => {
        y[P.participantId].individualParticipantIds.forEach((w) => {
          u({ id: w, eventType: I, eventId: U, entry: P });
        });
      };
      v.forEach(D);
    })() : v.forEach((y) => {
      u({ id: y == null ? void 0 : y.participantId, eventType: I, eventId: U, entry: y });
    });
    let T = Object.values(m).reduce((y, D) => y + D.count, 0);
    Object.keys(m).forEach((y) => {
      m[y].pct = m[y].count / T * 100;
    }), s[U] = { tournamentId: t, eventId: U, entries: v, entryStatuses: m };
    let A = Object.assign({}, ...yn.flatMap((y) => {
      var D, P;
      return [{ [y + "_count"]: (D = m[y]) == null ? void 0 : D.count }, { [y + "_pct"]: (P = m[y]) == null ? void 0 : P.pct }];
    }));
    o[U] = { tournamentId: t, eventId: U, ...A };
  }
  let d = Object.values(r ?? {}).filter(({ participant: { participantType: f, participantRole: m } }) => f === Xe && m === Cr), l = d.filter(({ participant: f }) => !i.includes(f.participantId)).map(({ participant: f }) => f.participantId), p = { nonParticipatingEntriesCount: l.length, individualParticipantsCount: d.length, eventsCount: Object.values(s).length, nonParticipatingParticipantIds: l, drawDefinitionsCount: c, tournamentId: t };
  return { entryStatusReports: Object.values(o).flat(), participantEntryReports: Object.values(a).flat(), eventReports: Object.values(s).flat(), withDrawnParticipantIds: n, tournamentEntryReport: p };
}
function BW({ eventType: e, matchUps: t, eventId: r, drawId: i }) {
  let n = {}, a = (m) => {
    let h = m == null ? void 0 : m.matchUpFormat;
    h && (n[h] || (n[h] = 0), n[h] += 1);
  }, o = t.filter((m) => r ? m.eventId === r : m.drawId === i).reduce((m, h) => (a(h), (h.sides ?? []).flatMap((g) => {
    var I;
    return (((I = g == null ? void 0 : g.participant) == null ? void 0 : I.individualParticipants) || [g == null ? void 0 : g.participant]).filter(Boolean);
  }).forEach((g) => m[g.participantId] = g), m), {}), s = Object.values(o), c = s.map((m) => kp({ participant: m, eventType: e })).filter(({ wtnRating: m }) => m), u = (s.length - c.length) / s.length * 100, d = c.reduce((m, h) => {
    let { wtnRating: g, confidence: I } = h;
    return m.totalWTN += g, m.totalConfidence += I, m;
  }, { totalWTN: 0, totalConfidence: 0 }), l = c != null && c.length ? d.totalWTN / c.length : 0, p = c != null && c.length ? d.totalConfidence / c.length : 0, f = Object.values(n).reduce((m, h) => m + (h || 0), 0);
  return { matchUpFormatCounts: n, matchUpsCount: f, avgConfidence: p, pctNoRating: u, avgWTN: l };
}
function VW(e) {
  var m;
  let { tournamentRecord: t, extensionProfiles: r, firstFlightOnly: i } = e;
  if (!t) return { error: pc };
  let n = [], a = {}, o = {}, s = [], c = Object.assign({}, ...(r ?? []).map(({ name: h, label: g, accessor: I }) => {
    var S, T, A;
    let U = (T = (S = We({ element: t, name: h })) == null ? void 0 : S.extension) == null ? void 0 : T.value, v = I ? (A = ns({ element: U, accessor: I })) == null ? void 0 : A.value : U;
    return { [g || h]: v };
  })), u = t == null ? void 0 : t.tournamentId, d = Pr({ participantsProfile: { withScaleValues: !0 }, tournamentRecord: t }).matchUps ?? [], l = (h) => {
    var g, I, U;
    return (U = (I = (g = en({ itemType: Av, itemSubTypes: [$n], element: { timeItems: h } })) == null ? void 0 : g.timeItem) == null ? void 0 : I.itemValue) == null ? void 0 : U.scaleBasis;
  }, p = ({ positionManipulations: h }) => {
    h == null || h.forEach((g) => {
      let { structureId: I, name: U } = g, v = g.drawPositions || [g.drawPosition];
      a[I] || (a[I] = []), a[I].push(`${U}: ${v.join("/")}`);
    });
  }, f = (m = t == null ? void 0 : t.events) == null ? void 0 : m.flatMap(({ timeItems: h, drawDefinitions: g = [], extensions: I, eventType: U, eventName: v, eventId: S, category: T }) => {
    var O, M, N, C;
    let A = (N = (M = (O = I == null ? void 0 : I.find((F) => F.name === gn)) == null ? void 0 : O.value) == null ? void 0 : M.flights) == null ? void 0 : N.map((F) => ({ [F.drawId]: F.flightNumber })), y = A && Object.assign({}, ...A), D = I == null ? void 0 : I.find((F) => F.name === So), P = h == null ? void 0 : h.find((F) => F.itemType === So), w = ((C = D == null ? void 0 : D.value) == null ? void 0 : C.length) || (P == null ? void 0 : P.itemValue) || 0, R = Object.values(y ?? {}), b = y && Math.min(...R), E = l(h);
    return o[S] = { seedingBasis: E ? JSON.stringify(E) : void 0, totalPositionManipulations: 0, maxPositionManipulations: 0, generatedDrawsCount: 0, drawDeletionsCount: w, tournamentId: u, eventId: S }, g.filter((F) => !i || !A || y[F.drawId] === b).flatMap((F) => {
      let { matchUpFormat: x, tieFormat: V, timeItems: k, extensions: L, structures: B, drawName: G, drawType: q, drawId: Y } = F, { matchUpFormatCounts: H, matchUpsCount: X, avgConfidence: z, pctNoRating: Z, avgWTN: te } = BW({ eventType: U, matchUps: d, drawId: Y }), ne = l(k) || E, ee = GW({ extensions: L }), K = (ee == null ? void 0 : ee.length) || 0;
      return p({ positionManipulations: ee }), o[S].totalPositionManipulations += K, o[S].generatedDrawsCount += 1, K > o[S].maxPositionManipulations && (o[S].maxPositionManipulations = K), B == null ? void 0 : B.filter((J) => J.stageSequence === 1 && [Pe, Ie, kr, Wt].includes(J.stage)).map((J) => {
        var Dt, mr, qr;
        let $ = [Ie, Wt].includes(J.stage) ? d.find((Ee) => Ee.structureId === J.structureId && Ee.finishingRound === 1 && Ee.winningSide) : void 0;
        J.stage === Ie && n.push({ eventName: v, drawName: G, structureId: J.structureId });
        let ae = (mr = (Dt = $ == null ? void 0 : $.sides) == null ? void 0 : Dt.find((Ee) => Ee.sideNumber === $.winningSide)) == null ? void 0 : mr.participant, oe = (ae == null ? void 0 : ae.participantType) === ai && ae.participantId, ce = (ae == null ? void 0 : ae.participantType) === _e ? ae.individualParticipants : [], se = kp({ participant: (ce == null ? void 0 : ce[0]) || ae, eventType: U }), { personId: Te, personOtherId: xe, tennisId: me, confidence: rt, wtnRating: Ge } = se || {}, Bt = kp({ participant: ce == null ? void 0 : ce[1], eventType: U }), { personId: Ut, personOtherId: Re, tennisId: De, confidence: ve, wtnRating: Ye } = Bt || {}, { ageCategoryCode: Ze, categoryName: Nt, subType: Tt } = T ?? {}, je = J.matchUpFormat || x, It = (H[je] || 0) / X * 100, { tieFormatName: Zt, tieFormatDesc: _t } = bp(V), { tieFormatName: er, tieFormatDesc: Mt } = bp(J.tieFormat), He = _t === Mt, Me = !He && er, Ot = J.tieFormat && !He && Mt, vr = ((qr = ee == null ? void 0 : ee.filter((Ee) => Ee.structureId === J.structureId)) == null ? void 0 : qr.length) || 0;
        return { ...c, tournamentId: u, eventId: S, structureId: J.structureId, drawId: Y, eventType: U, category: Tt, categoryName: Nt, ageCategoryCode: Ze, flightNumber: y == null ? void 0 : y[Y], drawType: q, stage: J.stage, seedingBasis: ne ? JSON.stringify(ne) : void 0, winningPersonId: Te, winningPersonOtherId: xe, winningPersonTennisId: me, winningPersonWTNrating: Ge, winningPersonWTNconfidence: rt, winningPerson2Id: Ut, winningPerson2OtherId: Re, winningPerson2TennisId: De, winningPerson2WTNrating: Ye, winningPerson2WTNconfidence: ve, winningTeamId: oe, positionManipulations: vr, pctNoRating: Z, matchUpFormat: je, pctInitialMatchUpFormat: It, matchUpsCount: X, drawTieFormatName: Zt, drawTieFormatDesc: _t, tieFormatName: Me, tieFormatDesc: Ot, avgConfidence: z, avgWTN: te };
      });
    });
  });
  return n.forEach(({ eventName: h, drawName: g, structureId: I }) => {
    var U;
    (U = a[I]) != null && U.length && s.push({ eventName: h, drawName: g, actions: a[I] });
  }), { eventStructureReports: Object.values(o), structureReports: f, flightReports: s };
}
function GW({ extensions: e }) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.find(({ name: i }) => i === cc)) == null ? void 0 : t.value) == null ? void 0 : r.slice(1);
}
function jW({ ignoreDisabled: e = !0, tournamentRecords: t, tournamentId: r, venueIds: i = [], dates: n = [] }) {
  var d, l;
  if (!Array.isArray(n)) return { error: ie, dates: n };
  if (!Array.isArray(i)) return { error: ie, venueIds: i };
  if (!(t && Object.keys(t).filter((p) => !r || p === r) || []).length) return { error: xt };
  if (!n.every(mi)) return { error: Sr };
  let a = xa({ tournamentRecords: t, ignoreDisabled: e, dates: n });
  if (a.error) return a;
  let o = (d = a == null ? void 0 : a.venues) == null ? void 0 : d.filter(({ venueId: p }) => !(i != null && i.length) || i.includes(p)), s = (l = a.courts) == null ? void 0 : l.reduce((p, f) => {
    var m;
    return (m = f.dateAvailability) == null || m.forEach((h) => {
      let g = h.date;
      p.includes(g) || p.push(g);
    }), p;
  }, []).filter((p) => !n.length || n.includes(p)), c = { venueIds: o == null ? void 0 : o.map(({ venueId: p }) => p) }, { matchUps: u } = On({ afterRecoveryTimes: !0, tournamentRecords: t, matchUpFilters: c });
  return { venuesReport: o == null ? void 0 : o.map((p) => _W(s, p, u)) };
}
function _W(e, t, r) {
  let { venueId: i, courts: n, venueName: a } = t, o = {};
  return e.forEach((s) => {
    var f;
    let c = 0, u = 0, d = 0;
    for (let m of n) {
      let h = m.dateAvailability.find((I) => I.date === s), g = (f = h && du({ courtDate: h }).timeSlots) == null ? void 0 : f.reduce((I, U) => {
        let { startTime: v, endTime: S } = U, T = tt(S) - tt(v);
        return I + T;
      }, 0);
      g && (d += 1), c += g;
    }
    let l = r.filter(({ schedule: m }) => m.venueId === i && aa(s, m.scheduledDate));
    l.forEach(({ schedule: m }) => {
      let h = Rt(m.scheduledTime), g = fi(h, m.averageMinutes), I = tt(g) - tt(h);
      u += I;
    });
    let p = c ? (u / c * 100).toFixed(2) : "100";
    o[s] = { scheduledMatchUpsCount: l.length, availableCourts: d, availableMinutes: c, scheduledMinutes: u, percentUtilization: p };
  }), { venueId: i, venueName: a, venueReport: o };
}
var FO = {};
qe(FO, { addMatchUpCourtOrder: () => ey, addMatchUpEndTime: () => ry, addMatchUpOfficial: () => U1, addMatchUpResumeTime: () => ny, addMatchUpScheduleItems: () => yh, addMatchUpScheduledDate: () => Uh, addMatchUpScheduledTime: () => fo, addMatchUpStartTime: () => ty, addMatchUpStopTime: () => iy, addSchedulingProfileRound: () => Iy, allocateTeamMatchUpCourts: () => Sh, assignMatchUpCourt: () => Zs, assignMatchUpVenue: () => pu, bulkRescheduleMatchUps: () => _O, bulkScheduleMatchUps: () => Il, bulkScheduleTournamentMatchUps: () => rd, bulkUpdateCourtAssignments: () => BO, calculateScheduleTimes: () => yy, clearMatchUpSchedule: () => qO, clearScheduledMatchUps: () => Th, courtGridRows: () => nh, findMatchUpFormatTiming: () => th, findVenue: () => fa, generateBookings: () => Ah, generateVirtualCourts: () => mh, getMatchUpsToSchedule: () => eh, getPersonRequests: () => Qo, getProfileRounds: () => ih, getScheduledRoundsDetails: () => ol, getSchedulingProfile: () => Ba, getSchedulingProfileIssues: () => US, matchUpScheduleChange: () => WO, modifyMatchUpFormatTiming: () => BS, mutate: () => kO, proAutoSchedule: () => xO, proConflicts: () => GO, publicFindCourt: () => Xv, query: () => IE, removeEventMatchUpFormatTiming: () => lh, removeMatchUpCourtAssignment: () => LO, reorderUpcomingMatchUps: () => jO, scheduleMatchUps: () => VO, scheduleProfileRounds: () => Dh, setMatchUpDailyLimits: () => HO, setMatchUpHomeParticipantId: () => $S, setSchedulingProfile: () => au, toggleParticipantCheckInState: () => gh, validateSchedulingProfile: () => rh });
var kO = {};
qe(kO, { addMatchUpCourtOrder: () => ey, addMatchUpEndTime: () => ry, addMatchUpOfficial: () => U1, addMatchUpResumeTime: () => ny, addMatchUpScheduleItems: () => yh, addMatchUpScheduledDate: () => Uh, addMatchUpScheduledTime: () => fo, addMatchUpStartTime: () => ty, addMatchUpStopTime: () => iy, addSchedulingProfileRound: () => Iy, allocateTeamMatchUpCourts: () => Sh, assignMatchUpCourt: () => Zs, assignMatchUpVenue: () => pu, bulkRescheduleMatchUps: () => _O, bulkScheduleMatchUps: () => Il, bulkScheduleTournamentMatchUps: () => rd, bulkUpdateCourtAssignments: () => BO, calculateScheduleTimes: () => yy, clearMatchUpSchedule: () => qO, clearScheduledMatchUps: () => Th, findMatchUpFormatTiming: () => th, generateBookings: () => Ah, generateVirtualCourts: () => mh, matchUpScheduleChange: () => WO, modifyMatchUpFormatTiming: () => BS, proAutoSchedule: () => xO, proConflicts: () => GO, removeEventMatchUpFormatTiming: () => lh, removeMatchUpCourtAssignment: () => LO, reorderUpcomingMatchUps: () => jO, scheduleMatchUps: () => VO, scheduleProfileRounds: () => Dh, setMatchUpDailyLimits: () => HO, setMatchUpHomeParticipantId: () => $S, setSchedulingProfile: () => au, toggleParticipantCheckInState: () => gh, validateSchedulingProfile: () => rh });
function yy({ calculateStartTimeFromCourts: e = !0, defaultRecoveryMinutes: t = 0, averageMatchUpMinutes: r = 90, remainingScheduleTimes: i, clearScheduleDates: n, tournamentRecords: a, periodLength: o, scheduleDate: s, startTime: c, venueIds: u, endTime: d }) {
  if (typeof a != "object" || !Object.keys(a).length) return { error: xt };
  o = o ?? hh({ recoveryMinutes: t, averageMatchUpMinutes: r });
  let { courts: l, venues: p } = xa({ dates: [s], ignoreDisabled: !0, tournamentRecords: a }), f = l == null ? void 0 : l.filter((w) => !u || u.includes(w.venueId));
  c || (c = f == null ? void 0 : f.reduce((w, R) => {
    var E, O;
    let b = ((O = (E = R.dateAvailability) == null ? void 0 : E.find((M) => !M.date || aa(s, M.date))) == null ? void 0 : O.startTime) ?? R.startTime;
    return b && (!w || tt(b) < tt(w)) ? b : w;
  }, void 0)), d || (d = f == null ? void 0 : f.reduce((w, R) => {
    var E, O;
    let b = ((O = (E = R.dateAvailability) == null ? void 0 : E.find((M) => !M.date || aa(s, M.date))) == null ? void 0 : O.endTime) ?? R.endTime;
    return b && (!w || tt(b) > tt(w)) ? b : w;
  }, void 0));
  let m = Object.values(a), h = Object.assign({}, ...m.map((w) => (w.events ?? []).map((R) => {
    let { scheduleTiming: b } = Pd({ tournamentRecord: w, event: R });
    return { [R.eventId]: { event: R, scheduleTiming: b } };
  })).flat()), g = ul({ sortDateMatchUps: !1, tournamentRecords: a, matchUpFilters: { scheduledDate: s, venueIds: u } }), I = (g == null ? void 0 : g.dateMatchUps) ?? [], U = (g == null ? void 0 : g.completedMatchUps) ?? [], v = [];
  v.push(...I), v.push(...U);
  let S = { averageTimes: [{ minutes: { default: r } }], recoveryTimes: [{ minutes: { default: t } }] }, T = v == null ? void 0 : v.map(({ eventId: w, schedule: R, matchUpFormat: b }) => {
    let { event: E, scheduleTiming: O } = h[w], M = E == null ? void 0 : E.eventType, N = { ...O, defaultTiming: S, matchUpFormat: b }, { averageMinutes: C, recoveryMinutes: F } = vm({ eventType: M, timingDetails: N }), { courtId: x, venueId: V } = R, k = Rt(R.scheduledTime), L = fi(k, C);
    return { recoveryMinutes: F, averageMinutes: C, periodLength: o, startTime: k, endTime: L, courtId: x, venueId: V };
  }), A = { calculateStartTimeFromCourts: e, remainingScheduleTimes: i, averageMatchUpMinutes: r, date: s, clearScheduleDates: n, periodLength: o, startTime: c, endTime: d, bookings: T, courts: f }, { scheduleTimes: y } = zS(A), D = (u == null ? void 0 : u.length) === 1 && u[0] || (p == null ? void 0 : p.length) === 1 && p[0].venueId || void 0, P = v.map(hr);
  return { venueId: D, scheduleTimes: y, dateScheduledMatchUpIds: P };
}
function LO(e) {
  var f;
  let t = Ae(e, [{ [_r]: !0 }]);
  if (t.error) return t;
  let { removePriorValues: r, tournamentRecords: i, tournamentId: n, courtDayDate: a, matchUpId: o, courtId: s, drawId: c } = e, u = i[n];
  if (!u) return { error: de };
  let { drawDefinition: d, event: l } = po({ tournamentRecord: u, drawId: c });
  if (!d) return { error: Ue };
  let p = bt({ drawDefinition: d, event: l, matchUpId: o });
  if (p.error) return p;
  if (((f = p == null ? void 0 : p.matchUp) == null ? void 0 : f.matchUpType) === Ci) {
    let { itemValue: m } = zo({ timeItems: p.matchUp.timeItems ?? [], itemType: ua }), h = s && m.filter((g) => g.courtId !== s);
    return Mi({ duplicateValues: !1, removePriorValues: r, tournamentRecord: u, drawDefinition: d, matchUpId: o, timeItem: { itemType: ua, itemValue: h } });
  } else return Zs({ tournamentRecord: u, drawDefinition: d, courtDayDate: a, courtId: "", matchUpId: o });
}
function xO({ scheduleCompletedMatchUps: e, tournamentRecords: t, scheduledDate: r, matchUps: i }) {
  if (!rn(i)) return { error: ie };
  if (i.some(({ hasContext: f }) => !f)) return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Lf };
  let n = ul({ courtCompletedMatchUps: !0, withCourtGridRows: !0, minCourtGridRows: 10, tournamentRecords: t, matchUpFilters: { localPerspective: !0, scheduledDate: r } });
  if (n.error) return n;
  let { rows: a } = n, o = [], s = (f) => [(f.sides || []).map((m) => {
    var h;
    return [m.participantId, (h = m.participant) == null ? void 0 : h.individualParticipantIds];
  }), (f.potentialParticipants || []).flat().map((m) => [m.participantId, m.individualParticipantIds])].flat(1 / 0).filter(Boolean), c = a == null ? void 0 : a.reduce((f, m) => {
    let h = [], g = [];
    Object.values(m).forEach((U) => {
      if ($e(U) && (U.matchUpId && (h.push(U.matchUpId), o.push(U)), U.sides)) {
        let v = s(U);
        g.push(...v);
      }
    });
    let I = Object.values(m).filter((U) => $e(U) && !U.matchUpId);
    return f.concat({ matchUpIds: h, availableCourts: I, rowId: m.rowId, participantIds: g });
  }, []);
  i.filter(({ matchUpStatus: f }) => f && f !== at && (e || !lr.includes(f))).sort(js);
  let u = An({ matchUps: i.concat(o), includeParticipantDependencies: !0, tournamentRecords: t }).matchUpDependencies, d = [], l = [];
  for (; i.length && c.length; ) {
    let f = c.shift(), m = [];
    for (; i.length && f.availableCourts.length; ) {
      let h = i.concat(m).map((D) => D.matchUpId), g = i.shift(), I = g == null ? void 0 : g.matchUpId, U = I && u[I].matchUpIds.concat(u[I].dependentMatchUpIds), v = I && h.some((D) => u[I].matchUpIds.includes(D)), S = I && l.some((D) => u[I].dependentMatchUpIds.includes(D)), T = f.matchUpIds.some((D) => U.includes(D)), A = s(g), y = f.participantIds.some((D) => A.includes(D));
      if (g && !T && !v && !y && !S) {
        let D = f.availableCourts.shift();
        Object.assign(g.schedule, D.schedule), Object.assign(D, g), d.push(g), f.participantIds.push(...A), f.matchUpIds.push(I);
      } else g && m.push(g);
    }
    i.push(...m), l.push(...f.matchUpIds);
  }
  let p = d.map(({ matchUpId: f, tournamentId: m, schedule: h, drawId: g }) => ({ tournamentId: m, matchUpId: f, drawId: g, schedule: { ...h, scheduledDate: r } }));
  return n = Il({ tournamentRecords: t, matchUpDetails: p }), { ...n, scheduled: d, notScheduled: i };
}
function BO(e) {
  let { courtDayDate: t } = e, r = Ae(e, [{ courtAssignments: !0, [ui]: Gr, [xi]: we }, { [_r]: !0 }]);
  if (r.error) return r;
  let i = e.courtAssignments.reduce((a, o) => {
    let { tournamentId: s } = o;
    return a[s] || (a[s] = []), a[s].push(o), a;
  }, {}), n;
  return Object.keys(i).every((a) => {
    let o = e[_r][a];
    if (!o) return n = { error: de }, !1;
    let s = i[a].reduce((c, u) => {
      let { drawId: d } = u;
      return c[d] || (c[d] = []), c[d].push(u), c;
    }, {});
    Object.keys(s).every((c) => {
      let { drawDefinition: u } = ci({ tournamentRecord: o, drawId: c });
      return u ? (s[c].every((d) => {
        let { matchUpId: l, courtId: p } = d, f = Zs({ tournamentRecord: o, drawDefinition: u, courtDayDate: t, matchUpId: l, courtId: p });
        if (f.success) return f == null ? void 0 : f.success;
        n = { error: xw };
      }), !0) : (n = { error: Ue }, !1);
    });
  }), n || j;
}
function VO(e) {
  let { tournamentRecords: t, allDateMatchUpIds: r = [], averageMatchUpMinutes: i = 90, recoveryMinutes: n = 0, recoveryMinutesMap: a, matchUpPotentialParticipantIds: o = {}, individualParticipantProfiles: s = {}, matchUpNotBeforeTimes: c = {}, matchUpDailyLimits: u = {}, checkPotentialRequestConflicts: d = !0, remainingScheduleTimes: l, clearScheduleDates: p, periodLength: f = 30, scheduleDate: m, matchUpIds: h, venueIds: g, startTime: I, endTime: U, dryRun: v } = e, S = Ae(e, [{ [_r]: !0, [Id]: !0 }, { [Or]: mi, [xi]: Sr, [pL]: !0 }, { [Or]: (q) => !q || !isNaN(q), [gL]: !1, [xi]: ie, [IL]: !1, [vL]: !1 }]);
  if (S.error) return S;
  let T = e.competitionMatchUps ?? On({ nextMatchUps: !0, tournamentRecords: t }).matchUps ?? [], A = e.matchUpDependencies ?? An({ includeParticipantDependencies: !0, matchUps: T, tournamentRecords: t }).matchUpDependencies;
  T.forEach((q) => {
    var Y;
    (Y = q.schedule) != null && Y.scheduledDate && aa(m, Ve(q.schedule.scheduledDate)) && Cc({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: q });
  });
  let y = h.map((q) => T.find((Y) => Y.matchUpId === q)).filter(Boolean), { venueId: D, scheduleTimes: P, dateScheduledMatchUpIds: w } = yy({ tournamentRecords: t, remainingScheduleTimes: l, startTime: Rt(I), endTime: Rt(U), scheduleDate: Ve(m), averageMatchUpMinutes: i, clearScheduleDates: p, periodLength: f, venueIds: g }), R = {}, b = [], E = {}, O = {}, M = {};
  T.filter(({ matchUpId: q }) => w == null ? void 0 : w.includes(q)).forEach((q) => {
    var H;
    oI({ matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUp: q, value: 1 });
    let Y = (H = q.schedule) == null ? void 0 : H.scheduledTime;
    if (Y) {
      E[q.matchUpId] = Y;
      let X = a == null ? void 0 : a[q.matchUpId];
      td({ recoveryMinutes: X || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: A, scheduleTime: Y, matchUp: q });
    }
  });
  let N = y.filter((q) => {
    let Y = w == null ? void 0 : w.includes(q.matchUpId), H = [at, Je, zt, Bi, Wr, ct].includes(q == null ? void 0 : q.matchUpStatus);
    return !Y && !q.winningSide && !H;
  }), { matchUpMap: C, overLimitMatchUpIds: F, participantIdsAtLimit: x } = N.reduce((q, Y) => {
    let { drawId: H, tournamentId: X, matchUpType: z } = Y, { participantIdsAtLimit: Z, relevantParticipantIds: te } = fy({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, matchUpDailyLimits: u, matchUp: Y });
    return Z != null && Z.length ? (q.overLimitMatchUpIds.push(Y.matchUpId), q.participantIdsAtLimit.push(...Z), q) : (te.forEach((ne) => {
      hl({ individualParticipantProfiles: s, participantId: ne });
      let ee = s[ne].counters;
      ee[z] ? ee[z] += 1 : ee[z] = 1, ee[mn] ? ee[mn] += 1 : ee[mn] = 1;
    }), q.matchUpMap[X] || (q.matchUpMap[X] = {}), q.matchUpMap[X][H] ? q.matchUpMap[X][H].push(Y) : q.matchUpMap[X][H] = [Y], Cc({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: Y }), q);
  }, { matchUpMap: {}, overLimitMatchUpIds: [], participantIdsAtLimit: [] });
  N = N.filter(({ matchUpId: q }) => !F.includes(q));
  let V = 0, k = (P == null ? void 0 : P.length) ?? 0, { personRequests: L } = Qo({ tournamentRecords: t, requestType: gl });
  for (; P != null && P.length && N.length && V <= k; ) {
    V++;
    let { scheduleTime: q } = P.shift(), Y = N.find((H) => {
      let { matchUpId: X } = H, { dependenciesScheduled: z, remainingDependencies: Z } = dy({ matchUpScheduleTimes: E, matchUpDependencies: A, allDateMatchUpIds: r, matchUp: H });
      if (!z) return M[X] || (M[X] = []), M[X].push({ scheduleTime: q, remainingDependencies: Z }), !1;
      let { enoughTime: te } = py({ individualParticipantProfiles: s, matchUpNotBeforeTimes: c, matchUpDependencies: A, scheduleTime: q, matchUp: H });
      if (!te) return O[X] || (O[X] = []), O[X].push({ scheduleTime: q }), !1;
      let { conflicts: ne } = ly({ potentials: d, averageMatchUpMinutes: i, requestConflicts: R, personRequests: L, scheduleTime: q, scheduleDate: m, matchUp: H });
      if (ne != null && ne.length) return !1;
      let ee = a == null ? void 0 : a[H.matchUpId];
      return td({ recoveryMinutes: ee || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: A, scheduleTime: q, matchUp: H }), E[H.matchUpId] = q, !0;
    });
    N = N.filter(({ matchUpId: H }) => H !== (Y == null ? void 0 : Y.matchUpId)), Y || b.push(q);
  }
  N.forEach((q) => {
    oI({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, value: -1, matchUp: q });
  });
  let B = [];
  Object.keys(C).forEach((q) => {
    let Y = t[q];
    Y && Object.keys(C[q]).forEach((H) => {
      let { drawDefinition: X } = po({ tournamentRecord: Y, drawId: H });
      X && C[q][H].forEach(({ matchUpId: z }) => {
        let Z = E[z];
        if (Z) {
          let te = Z.split(":").map(Yi).join(":"), ne = `${Ve(m)}T${te}`;
          v ? B.push(z) : (fo({ drawDefinition: X, matchUpId: z, scheduledTime: ne }).success && B.push(z), D && pu({ tournamentRecords: t, tournamentRecord: Y, drawDefinition: X, matchUpId: z, venueId: D }));
        }
      });
    });
  });
  let G = vv(N);
  return { ...j, requestConflicts: Object.values(R), remainingScheduleTimes: P == null ? void 0 : P.map(({ scheduleTime: q }) => q), individualParticipantProfiles: s, matchUpNotBeforeTimes: c, participantIdsAtLimit: x, skippedScheduleTimes: b, overLimitMatchUpIds: F, scheduledMatchUpIds: B, noTimeMatchUpIds: G, recoveryTimeDeferred: O, dependencyDeferred: M };
}
function GO({ tournamentRecords: e, matchUps: t }) {
  if (!rn(t)) return { error: Ma };
  if (t.some(({ matchUpId: f, hasContext: m }) => f && !m)) return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Lf };
  let r = Math.max(...t.map(({ schedule: f }) => (f == null ? void 0 : f.courtOrder) || 1).map((f) => be(f))), i = fe(1, r + 1).map((f) => t.filter((m) => {
    var h;
    return be((h = m.schedule) == null ? void 0 : h.courtOrder) === f;
  })), n = {}, a = {}, o = {};
  i.flat().filter(Boolean).sort(js).forEach(({ schedule: f }) => delete f[ql]);
  let s = Be(t.map(({ drawId: f }) => f)), c = An({ includeParticipantDependencies: !0, tournamentRecords: e, drawIds: s }).matchUpDependencies, u = i.map((f, m) => f.reduce((h, g) => {
    if (!g.matchUpId) return h;
    let { matchUpId: I, winnerMatchUpId: U, loserMatchUpId: v, schedule: S, sides: T, potentialParticipants: A } = g, y = S == null ? void 0 : S.courtId;
    n[I] = m, a[y] = [], h.matchUpIds.push(I), o[I] = g;
    let D = c[I].matchUpIds;
    D.length && h.sourceMatchUpIds.push(...D);
    let P = (T == null ? void 0 : T.map((R) => {
      var b;
      return [(b = R.participant) == null ? void 0 : b.individualParticipantIds, R.participantId];
    }).flat().filter(Boolean)) ?? [], w = (A == null ? void 0 : A.flat().map(({ individualParticipantIds: R, participantId: b }) => [R, b]).flat().filter(Boolean)) || [];
    return h.participantIds.push(...w, ...P), U && h.targetMatchUpIds.push(U), v && h.targetMatchUpIds.push(v), h;
  }, { sourceMatchUpIds: [], targetMatchUpIds: [], participantIds: [], matchUpIds: [] })), d = (f, m) => c[f].sources.reduce((h, g, I) => g.includes(m) && I + 1 || h, 0), l = u.map(() => []), p = (f, m, h, g) => {
    if (!o[f].schedule[ql]) {
      o[f].schedule[ql] = m, o[f].schedule[cN] = g, l[n[f]].push({ matchUpId: f, issueType: h, issueIds: g, issue: m });
      let I = o[f].schedule.courtId;
      a[I] || (a[I] = []), a[I].push({ matchUpId: f, issue: m, issueType: h, issueIds: g });
    }
  };
  return u.forEach((f, m) => {
    let h = m ? u[m - 1] : void 0, g = u.slice(m + 1), I = {}, U = wi(f.participantIds), v = Object.keys(U).filter((A) => U[A] > 1), S = f.matchUpIds.filter((A) => c[A].participantIds.some((y) => v.includes(y)));
    S.forEach((A) => {
      I[A] || (I[A] = {}), I[A][ho] || (I[A][ho] = S.filter((y) => y !== A));
    });
    let T = h && f.participantIds.filter((A) => h.participantIds.includes(A));
    T && T.forEach((A) => {
      let y = f.matchUpIds.concat(h.matchUpIds).filter((D) => c[D].participantIds.includes(A));
      y.forEach((D) => {
        I[D] || (I[D] = {}), I[D][go] || (I[D][go] = y.filter((P) => P !== D));
      });
    }), f.matchUpIds.forEach((A) => {
      var P, w, R, b;
      let y = c[A].matchUpIds;
      for (let E of g) {
        let O = E.matchUpIds.filter((M) => y.includes(M));
        O != null && O.length && (O.forEach((M) => p(M, Cg, ja, [A])), p(A, Cg, ja, O));
      }
      if ((P = I[A]) != null && P[ho] && p(A, ho, Og, I[A][ho]), f.sourceMatchUpIds.includes(A)) {
        let E = f.matchUpIds.filter((O) => c[O].matchUpIds.includes(A));
        p(A, ho, ja, E), f.matchUpIds.filter((O) => c[O].matchUpIds.includes(A)).forEach((O) => p(O, ho, ja, [A]));
      }
      let D = (w = h == null ? void 0 : h.matchUpIds) == null ? void 0 : w.filter((E) => d(A, E) > 1);
      if (D != null && D.length && (p(A, Fg, ja, D), D.forEach((E) => p(E, Fg, ja, [A]))), (R = I[A]) != null && R[go] && p(A, go, Og, I[A][go]), (b = h == null ? void 0 : h.targetMatchUpIds) == null ? void 0 : b.includes(A)) {
        let E = o[A].schedule.courtId, O = y.filter((M) => h.matchUpIds.includes(M));
        O.some((M) => o[M].schedule.courtId === E) || (O.forEach((M) => p(M, go, ja, [A])), p(A, go, ja, O));
      }
    });
  }), { courtIssues: a, rowIssues: l };
}
function jO(e) {
  let t = "reorderUpcomingMatchUps", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length) return W({ result: { error: xt }, stack: t });
  let { matchUpsContextIds: i, firstToLast: n } = e;
  if (!i) return W({ result: { error: we }, stack: t });
  let a = i == null ? void 0 : i.length;
  if (!a) return { ...j };
  let o = 0;
  return i.forEach((c, u) => {
    let { tournamentId: d, drawId: l, matchUpId: p } = c, f = u + (n ? -1 : 1);
    f < 0 && (f = a - 1), f === a && (f = 0);
    let m = i[f].schedule.scheduledTime, h = s({ tournamentId: d, scheduledTime: m, matchUpId: p, drawId: l });
    if (h.success) o++;
    else return h;
  }), o === a ? j : W({ result: { error: Lw }, stack: t });
  function s({ tournamentId: c, scheduledTime: u, matchUpId: d, drawId: l }) {
    let p = r[c], { drawDefinition: f } = po({ tournamentRecord: p, drawId: l });
    return f ? fo({ drawDefinition: f, scheduledTime: u, matchUpId: d }) : { error: Fi };
  }
}
function _O(e) {
  var c, u;
  let { scheduleChange: t, matchUpIds: r, dryRun: i } = e;
  if (!r || !Array.isArray(r)) return { error: Ts };
  if (typeof t != "object") return { error: ie };
  let n = $i(e), a = [], o = [];
  for (let d of Object.values(n)) {
    let l = WW({ tournamentRecord: d, scheduleChange: t, matchUpIds: r, dryRun: i });
    if (l.error) return l;
    Array.isArray(l.notRescheduled) && o.push(...l.notRescheduled);
    let p = vv(l.notRescheduled), f = [];
    (c = l.rescheduled) == null || c.forEach((m) => {
      let { matchUpId: h } = m;
      p.includes(h) && f.push(h), a.push(m);
    }), f.length && (o = ((u = l == null ? void 0 : l.notRescheduled) == null ? void 0 : u.filter(({ matchUpId: m }) => !f.includes(m))) || []);
  }
  let s = !!(a.length && !o.length);
  return { ...j, rescheduled: a, notRescheduled: o, allRescheduled: s };
}
function WW({ tournamentRecord: e, scheduleChange: t, matchUpIds: r, dryRun: i }) {
  var S;
  if (!e) return { error: de };
  if (!r || !Array.isArray(r)) return { error: Ts };
  if (typeof t != "object") return { error: ie };
  let n = [], a = [], { minutesChange: o, daysChange: s } = t;
  if (!o && !s) return { ...j };
  if (o && isNaN(o)) return { error: ie };
  if (s && isNaN(s)) return { error: ie };
  let { matchUps: c } = Pr({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }), u = ({ matchUpStatus: T }) => !lr.includes(T), d = c == null ? void 0 : c.filter((T) => cl({ schedule: T.schedule })).filter((T) => u({ matchUpStatus: T.matchUpStatus }));
  if (!(d != null && d.length)) return { ...j };
  let { tournamentInfo: l } = Ks({ tournamentRecord: e }), { startDate: p, endDate: f } = l, m = d == null ? void 0 : d.reduce((T, A) => {
    let { matchUpId: y, drawId: D } = A;
    return T[D] ? T[D].push(y) : T[D] = [y], T;
  }, {}), h = 1440;
  for (let T of Object.keys(m)) {
    let A = po({ tournamentRecord: e, drawId: T });
    if (A.error) return A;
    let y = A.drawDefinition, D = m[T].filter((P) => r.includes(P));
    for (let P of D) if (P && y) {
      let w = (S = d.find((N) => N.matchUpId === P)) == null ? void 0 : S.schedule, { scheduledTime: R, scheduledDate: b } = w, E, O, M;
      if (!E && s && b) {
        let N = Ve(b);
        M = Su(N, s), E = new Date(M) < new Date(p) || new Date(M) > new Date(f);
      }
      if (o && R) {
        let N = Ve(R), C = tt(Rt(R)) + o;
        if (E = C < 0 || C > h, !E) {
          let F = fi(R, o), x = N && M || b === N && N;
          O = x ? `${x}T${F}` : F;
        }
      }
      if (E) a.push(P);
      else {
        if (!i) {
          if (O) {
            let N = fo({ scheduledTime: O, drawDefinition: y, matchUpId: P });
            if (N.error) return N;
          }
          if (M) {
            let N = Uh({ scheduledDate: M, drawDefinition: y, matchUpId: P });
            if (N.error) return N;
          }
        }
        (O || M) && n.push(P);
      }
    }
  }
  let g = Pr({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }).matchUps ?? [], I = g.filter(({ matchUpId: T }) => n.includes(T)), U = g.filter(({ matchUpId: T }) => a.includes(T)), v = I.length && !U.length;
  return { ...j, rescheduled: I, notRescheduled: U, allRescheduled: v };
}
function WO(e) {
  let t = "matchUpScheduleChange", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length) return { error: xt };
  let { sourceMatchUpContextIds: i, targetMatchUpContextIds: n, sourceCourtId: a, targetCourtId: o, courtDayDate: s } = e || {}, { drawId: c, matchUpId: u, tournamentId: d } = i || {}, { drawId: l, matchUpId: p, tournamentId: f } = n || {};
  if (!u && !p) return W({ result: { error: we }, stack: t });
  let { matchUps: m } = On({ matchUpFilters: { matchUpIds: [u, p].filter(Boolean), drawIds: [c, l].filter(Boolean) }, tournamentRecords: e.tournamentRecords }), h = m == null ? void 0 : m.find(({ matchUpId: S }) => S === u), g = m == null ? void 0 : m.find(({ matchUpId: S }) => S === p), I = 0;
  if (o && u && !p) {
    let S = U({ tournamentId: d, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (S != null && S.success && I++, S.error) return W({ result: S, stack: t });
  } else if (a && o && u && p) {
    let S = U({ tournamentId: d, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (S.success && I++, S.error) return W({ result: S, stack: t, info: "source" });
    let T = U({ tournamentId: f, sourceCourtId: o, matchUpId: p, matchUp: g, courtId: a, drawId: l, tournamentRecords: r, courtDayDate: s });
    if (T.success && I++, T.error) return W({ result: T, stack: t, info: "target" });
  } else return { error: we };
  return I ? j : W({ result: { error: Wc }, stack: t });
  function U(S) {
    let { tournamentRecords: T, tournamentId: A, matchUp: y, drawId: D } = S, P = T[A], { drawDefinition: w } = po({ tournamentRecord: P, drawId: D });
    return y.matchUpType === yt ? v({ ...S, tournamentRecord: P, drawDefinition: w }) : Zs({ ...S, tournamentRecord: P, drawDefinition: w });
  }
  function v({ removePriorValues: S, tournamentRecords: T, tournamentRecord: A, drawDefinition: y, sourceCourtId: D, courtDayDate: P, matchUpId: w, matchUp: R, courtId: b }) {
    let E = [b].concat(R.schedule.allocatedCourts.map(({ courtId: O }) => O).filter((O) => O !== D));
    return Sh({ removePriorValues: S, tournamentRecords: T, tournamentRecord: A, drawDefinition: y, courtDayDate: P, matchUpId: w, courtIds: E });
  }
}
function qO({ scheduleAttributes: e = [ua, Ja, ks, Ls, xs, Dn, ba, ea, Ua], tournamentRecord: t, drawDefinition: r, matchUpId: i }) {
  var s, c;
  let n = "clearMatchUpSchedule", a = r ? (s = Qr({ matchUpFilters: { matchUpIds: [i] }, inContext: !1, drawDefinition: r }).matchUps) == null ? void 0 : s[0] : (c = Pr({ matchUpFilters: { matchUpIds: [i] }, tournamentRecord: t, inContext: !1 }).matchUps) == null ? void 0 : c[0];
  if (!a) return { error: jr };
  let o = (a.timeItems ?? []).filter((u) => (u == null ? void 0 : u.itemType) && !e.includes(u == null ? void 0 : u.itemType));
  return a.timeItems = o, Qe({ tournamentId: t.tournamentId, context: n, drawDefinition: r, matchUp: a }), { ...j };
}
function HO(e) {
  let { tournamentRecord: t, tournamentId: r, dailyLimits: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "object" || !Object.keys(n).length) return { error: xt };
  if (typeof i != "object") return { error: Ea };
  let a = Object.keys(n).filter((o) => !r || r === o);
  if (r && !a.includes(r)) return { error: ie };
  for (let o of a) {
    let s = n[o], c = it({ extension: { name: Sd, value: { dailyLimits: i } }, element: s });
    if (c.error) return c;
  }
  return { ...j };
}
var YO = {};
qe(YO, { addCollectionDefinition: () => Dy, addCollectionGroup: () => JO, aggregateTieFormats: () => eC, compareTieFormats: () => Na, getTieFormat: () => Qm, modifyCollectionDefinition: () => Ay, modifyTieFormat: () => $O, mutate: () => zO, orderCollectionDefinitions: () => ZO, query: () => dE, removeCollectionDefinition: () => Ty, removeCollectionGroup: () => XO, tieFormatGenderValidityCheck: () => Hf, validateCollectionDefinition: () => fd });
var zO = {};
qe(zO, { addCollectionDefinition: () => Dy, addCollectionGroup: () => JO, aggregateTieFormats: () => eC, modifyCollectionDefinition: () => Ay, modifyTieFormat: () => $O, orderCollectionDefinitions: () => ZO, removeCollectionDefinition: () => Ty, removeCollectionGroup: () => XO });
function Lo({ drawDefinition: e, structureId: t, matchUpId: r, structure: i, matchUp: n, eventId: a, event: o }) {
  var u;
  let s = "getTieFormat", c;
  if (t = (i == null ? void 0 : i.structureId) ?? t, r = (n == null ? void 0 : n.matchUpId) ?? r, (r || t) && !e) return { error: Ue };
  if (a && o) c = Fn(o);
  else if (r) {
    if (e && (!n || !i)) {
      let d = bt({ drawDefinition: e, matchUpId: r });
      if (d.error) return d;
      if (((u = d.matchUp) == null ? void 0 : u.matchUpType) !== Ci) return W({ result: { error: gi }, stack: s });
      i || (i = d.structure), n || (n = d.matchUp);
    }
    c = Pu({ item: n, drawDefinition: e, structure: i, event: o }) || Pu({ item: i, drawDefinition: e, structure: i, event: o }) || Fn(e) || Fn(o);
  } else if (e && t) {
    if (!i) {
      let d = Ne({ drawDefinition: e, structureId: t });
      if (d.error) return d;
      i = d == null ? void 0 : d.structure;
    }
    c = Pu({ item: i, drawDefinition: e, structure: i, event: o }) || Fn(e) || Fn(o);
  } else c = Fn(e) || Fn(o);
  return c ? { ...j, structure: i, tieFormat: c, matchUp: n } : W({ result: { error: Gc }, stack: s });
}
function Lp({ matchUp: e, updateInProgressMatchUps: t }) {
  return !e.winningSide && ![lr].includes(e.matchUpStatus) && (t || e.matchUpStatus !== Sn && !pr(e));
}
function rg({ from: e, to: t }) {
  let r = Object.keys(e), i = qt(r, Object.keys(t)).length === r.length, n = r.filter((o) => e[o] !== t[o]).map((o) => ({ countChange: t[o] - e[o], collectionId: o })), a = r.every((o) => e[o] === t[o]);
  return { equivalent: i && a, matchUpsCountChanges: n };
}
function qW({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, structure: i, tieFormat: n, eventId: a, matchUp: o, event: s, uuids: c }) {
  var A, y, D, P;
  let u = "updateTieFormat", d = t == null ? void 0 : t.tournamentId, l = 0, p = 0, f = 0, m = 0, h = n == null ? void 0 : n.collectionDefinitions.reduce((w, R) => (w[R.collectionId] = (w[R.collectionId] || 0) + R.matchUpCount, w), {}), g = ({ tieFormat: w }) => {
    let R = w == null ? void 0 : w.collectionDefinitions.reduce((b, E) => (b[E.collectionId] = (b[E.collectionId] || 0) + E.matchUpCount, b), {});
    return rg({ from: R, to: h }).equivalent;
  }, I = (A = Lo({ drawDefinition: r })) == null ? void 0 : A.tieFormat, U = (y = Lo({ event: s })) == null ? void 0 : y.tieFormat;
  if (s && a) {
    for (let w of s.drawDefinitions ?? []) v({ drawDefinition: w });
    s.tieFormat = Er(n), m += 1;
  } else if (o) {
    if (!o.tieMatchUps) return W({ result: { error: gi }, stack: u });
    let w = wi((D = o.tieMatchUps) == null ? void 0 : D.map(({ collectionId: M }) => M)), R = rg({ to: h, from: w }), { changes: b, changesArePossible: E, cannotChangeReaon: O } = tD({ matchUp: o, check: R });
    if (R.equivalent) if (Lp({ matchUp: o, updateInProgressMatchUps: e })) o.tieFormat = Er(n), m += 1;
    else return W({ result: { error: bI }, info: "matchUp is IN_PROGRESS or COMPLETE", stack: u });
    else if (E) T({ tieFormat: n, matchUp: o, changes: b, uuids: c });
    else return W({ context: { collectionMap: h, matchUpMap: w }, result: { error: Jn }, info: O || "specified changes not possible", stack: u });
    p += 1, Qe({ eventId: s == null ? void 0 : s.eventId, context: u, drawDefinition: r, tournamentId: d, matchUp: o });
  } else if (i) {
    let w = (P = S({ inheritedTieFormat: I ?? U, structure: i })) == null ? void 0 : P.modifiedMatchUpsCount;
    w && (p += w, l += 1, m += 1);
    let R = !i.tieFormat || Na({ ancestor: i.tieFormat, descendant: n }).different;
    R && (i.tieFormat = Er(n), l += 1, m += 1), (w || R) && r && vt({ structureIds: [i.structureId], eventId: s == null ? void 0 : s.eventId, drawDefinition: r });
  } else if (r) v({ drawDefinition: r }), r.tieFormat = Er(n), m += 1;
  else return { error: Ue };
  return { modifiedStructuresCount: l, modifiedMatchUpsCount: p, addedMatchUpsCount: f, modifiedCount: m, ...j, tieFormat: n };
  function v({ drawDefinition: w }) {
    var E;
    let R = w.structures || [], b = [];
    for (let O of R) {
      if (O.tieFormat) continue;
      let M = (E = S({ inheritedTieFormat: U, structure: O })) == null ? void 0 : E.modifiedMatchUpsCount;
      if (M) {
        l += 1, p += M;
        let N = O.structureId;
        b.push(N);
      }
    }
    return vt({ structureIds: b, eventId: s == null ? void 0 : s.eventId, drawDefinition: w }), b.length;
  }
  function S({ inheritedTieFormat: w, structure: R }) {
    var O, M;
    let b = 0, E = ((O = ut({ matchUpFilters: { matchUpTypes: [yt] }, structure: R })) == null ? void 0 : O.matchUps) || [];
    for (let N of E) {
      let C = Lp({ matchUp: N, updateInProgressMatchUps: e }), F = !1, x = wi((M = N.tieMatchUps) == null ? void 0 : M.map(({ collectionId: k }) => k)), V = rg({ from: x, to: h });
      if (V.equivalent) N.tieFormat && g(N) && C && (N.tieFormat = Er(n), F = !0);
      else {
        let { changes: k, changesArePossible: L } = tD({ matchUp: N, check: V });
        if (L && !N.tieFormat) T({ changes: k, matchUp: N, tieFormat: n, uuids: c });
        else if (w) (!N.tieFormat || Na({ ancestor: w, descendant: N.tieFormat }).different) && (N.tieFormat = w, F = !0);
        else return W({ result: { error: Gc }, stack: u });
      }
      F && (b += 1, Qe({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: r, context: u, eventId: a, matchUp: N }));
    }
    return { modifiedMatchUpsCount: b };
  }
  function T({ uuids: w, matchUp: R, tieFormat: b, changes: E }) {
    R.tieFormat = Er(b);
    let O = [], M = [];
    return E.forEach((N) => {
      if (N.countChange > 0) {
        let C = Math.max(0, ...R.tieMatchUps.filter((V) => V.collectionId === N.collectionId).map(Ni("collectionPosition"))), F = b.collectionDefinitions.find((V) => V.collectionId === N.collectionId), x = Zd({ matchUpsLimit: N.countChange, collectionPositionOffset: C, collectionDefinition: F, matchUp: R, uuids: w });
        M.push(...ge(x, !1, !0)), f += M.length, R.tieMatchUps.push(...x);
      } else {
        let C = N.toBePlayedTieMatchUpIds.slice(0, Math.abs(N.countChange));
        console.log("remove", C.length), O.push(...C), R.tieMatchUps = R.tieMatchUps.filter(({ matchUpId: F }) => !C.includes(F));
      }
    }), M.length && Za({ matchUps: M, drawDefinition: r, tournamentId: d, eventId: a }), O.length && Ca({ matchUpIds: O, action: "updateTieFormat", drawDefinition: r, tournamentId: d, eventId: a }), { matchUpIdsRemoved: O, matchUpsAdded: M };
  }
}
function tD({ check: e, matchUp: t }) {
  let r = "", i = [];
  return { changesArePossible: e.matchUpsCountChanges.every(({ collectionId: n, countChange: a }) => {
    let o = t.tieMatchUps.filter((c) => c.collectionId === n && c.matchUpStatus === Xt).map(Ni("matchUpId")), s = o.length + a >= 0 || a > 0;
    return !s && a < 0 && (r = "Insufficient TO_BE_PLAYED matchUps"), i.push({ toBePlayedTieMatchUpIds: o, collectionId: n, countChange: a }), s;
  }), changes: i, cannotChangeReaon: r };
}
function bh({ appliedPolicies: e, drawDefinition: t, auditData: r }) {
  var a;
  if (!((a = e == null ? void 0 : e.audit) != null && a[Tu])) return;
  let { extension: i } = We({ name: Tu, element: t }), n = { value: Array.isArray(i == null ? void 0 : i.value) ? i == null ? void 0 : i.value.concat(r) : [r], name: Tu };
  it({ element: t, extension: n });
}
function Ay({ updateInProgressMatchUps: e = !1, tournamentRecord: t, collectionOrder: r, collectionName: i, tieFormatName: n, drawDefinition: a, matchUpFormat: o, matchUpCount: s, collectionId: c, matchUpType: u, structureId: d, matchUpId: l, category: p, eventId: f, gender: m, event: h, collectionValueProfiles: g, collectionValue: I, matchUpValue: U, scoreValue: v, setValue: S }) {
  let T = "modifyCollectionDefinition";
  if (o && !Ri({ matchUpFormat: o })) return W({ result: { error: ie }, context: { matchUpFormat: o }, stack: T });
  if (i && typeof i != "string") return W({ result: { error: ie }, context: { collectionName: i }, stack: T });
  if (m && !Object.values(HI).includes(m)) return W({ result: { error: ie }, context: { gender: m }, stack: T });
  if (p && typeof p != "object") return W({ result: { error: ie }, context: { category: p }, stack: T });
  let A = { collectionValueProfiles: g, collectionValue: I, matchUpValue: U, scoreValue: v, setValue: S };
  if (!Object.values(A).filter(Boolean).length && !r && !i && !o && !s && !u) return W({ result: { error: we }, stack: T });
  if (Object.values(A).filter(Boolean).length > 1) return W({ info: "Only one value assignment allowed per collectionDefinition", result: { error: ie }, stack: T });
  let y = Lo({ drawDefinition: a, structureId: d, matchUpId: l, eventId: f, event: h });
  if (y.error) return W({ result: y, stack: T });
  let { matchUp: D, structure: P, tieFormat: w } = y, R = Er(w), b = w == null ? void 0 : w.collectionDefinitions.find((B) => B.collectionId === c), E = R == null ? void 0 : R.collectionDefinitions.find((B) => B.collectionId === c);
  if (!b) return W({ info: "source collectionDefinition", result: { error: Tr }, context: { collectionId: c }, stack: T });
  let O = I ?? U ?? v ?? S;
  if (g != null && g.length) {
    let B = BP({ matchUpCount: s ?? (b == null ? void 0 : b.matchUpCount) ?? 0, collectionValueProfiles: g });
    if (B.errors) return W({ result: { error: ie }, info: B.errors, stack: T });
  } else if (O && !ke(O)) return W({ result: { error: ie }, info: "value is not an integer", context: { value: O }, stack: T });
  let M = (B, G) => qt(Object.keys(B), Object.keys(G)).length === Object.keys(B).length && qt(Object.values(B), Object.values(G)).length === Object.values(B).length, N = g && (!b.collectionValueProfiles || !M(b.collectionValueProfiles, g)), C = ke(I) && b.collectionValue !== I || ke(U) && b.matchUpValue !== U || ke(v) && b.scoreValue !== v || ke(S) && b.setValue !== S || N, F = [];
  if (C && (E.collectionValueProfiles = void 0, E.collectionValue = void 0, E.matchUpValue = void 0, E.scoreValue = void 0, E.setValue = void 0, Object.assign(E, A), F.push({ collectionId: c, ...ye(A) })), (ke(v) || ke(S)) && E.collectionGroupNumber) {
    let B = E.collectionGroupNumber;
    R.collectionDefinitions = R.collectionDefinitions.map((G) => {
      let { collectionGroupNumber: q, ...Y } = G;
      return q === B ? Y : G;
    }), R.collectionGroups = R.collectionGroups.filter(({ groupNumber: G }) => G !== B), F.push({ collectionId: c, change: "collectionGroupNumber removed" });
  }
  let { aggregateValue: x, valueGoal: V } = Xs(R), k = ye({ aggregateValue: x, valueGoal: V });
  if ((k.aggregateValue !== (w == null ? void 0 : w.winCriteria.aggregateValue) || k.valueGoal !== (w == null ? void 0 : w.winCriteria.valueGoal)) && (R.winCriteria = k, F.push({ collectionId: c, winCriteria: k })), ke(r) && b.collectionOrder !== r && (E.collectionOrder = r, F.push({ collectionId: c, collectionOrder: r })), i && b.collectionName !== i && (E.collectionName = i, F.push({ collectionId: c, collectionName: i })), o && b.matchUpFormat !== o && (E.matchUpFormat = o, F.push({ collectionId: c, matchUpFormat: o })), ke(s) && b.matchUpCount !== s && (E.matchUpCount = s, F.push({ collectionId: c, matchUpCount: s })), u && b.matchUpType !== u) return W({ result: { error: Vf }, context: { matchUpType: u }, stack: T });
  p && b.category !== p && (E.category = p, F.push({ collectionId: c, category: p })), m && b.gender !== m && (E.gender = m, F.push({ collectionId: c, gender: m }));
  let L = ye(R);
  if (y = oi({ tieFormat: L }), y.error) return W({ result: y, stack: T });
  if (!F.length) return W({ result: { ...j, modifications: F } });
  if ((w == null ? void 0 : w.tieFormatName) !== n ? (L.tieFormatName = n, F.push({ tieFormatName: n })) : F.length && (delete L.tieFormatName, F.push("tieFormatName removed: modifications without new tieFormatName")), y = qW({ tieFormat: L, updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: a, structure: P, eventId: f, matchUp: D, event: h }), !y.error) {
    let { appliedPolicies: B } = nt({ tournamentRecord: t }), G = ye({ collectionDefinition: E, drawId: a == null ? void 0 : a.drawId, action: T, structureId: d, matchUpId: l, eventId: f });
    bh({ appliedPolicies: B, drawDefinition: a, auditData: G });
  }
  return W({ result: { ...y, modifications: F }, stack: T });
}
function HW({ updateInProgressMatchUps: e, drawDefinition: t, structureId: r, structure: i, matchUpId: n, matchUp: a }) {
  var s, c;
  let o = [];
  return n && a ? o = [a] : r && i ? o = ((s = ut({ matchUpFilters: { matchUpTypes: [yt] }, structure: i })) == null ? void 0 : s.matchUps) ?? [] : t && (o = ((c = Qr({ matchUpFilters: { matchUpTypes: [yt] }, drawDefinition: t })) == null ? void 0 : c.matchUps) ?? []), { targetMatchUps: o.filter((u) => !u.winningSide && u.matchUpStatus !== zt && (e || u.matchUpStatus !== Sn && !pr(u))) };
}
function YW({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, targetMatchUps: i, tieFormat: n, event: a }) {
  for (let o of i) {
    let s = !!o.tieFormat;
    s && (o.tieFormat = Er(n));
    let c;
    if (e) {
      let u = nt({ tournamentRecord: t, drawDefinition: r, event: a }).appliedPolicies, d = La({ matchUpId: o.matchUpId, exitWhenNoValues: !0, tournamentRecord: t, appliedPolicies: u, drawDefinition: r, event: a });
      if (d.error) return d;
      c = d.score;
    }
    s && !c && Qe({ tournamentId: t == null ? void 0 : t.tournamentId, context: "updateTargetTeamMatchUps", eventId: a == null ? void 0 : a.eventId, matchUp: o, drawDefinition: r });
  }
  return { ...j };
}
function KO({ updateInProgressMatchUps: e, originalValueGoal: t, tournamentRecord: r, wasAggregateValue: i, tieFormatName: n, drawDefinition: a, structureId: o, structure: s, tieFormat: c, matchUpId: u, matchUp: d, eventId: l, event: p }) {
  let { aggregateValue: f, valueGoal: m } = Xs(c);
  c.winCriteria = ye({ aggregateValue: f, valueGoal: m }), (t && t !== m || f && !i) && (n ? c.tieFormatName = n : delete c.tieFormatName);
  let { targetMatchUps: h } = HW({ updateInProgressMatchUps: e, drawDefinition: a, structureId: o, structure: s, matchUpId: u, matchUp: d });
  YW({ updateInProgressMatchUps: e, tournamentRecord: r, targetMatchUps: h, drawDefinition: a, tieFormat: c, event: p });
  let g = ye(c), I = oi({ tieFormat: g });
  if (I.error) return I;
  if (l && p) p.tieFormat = g;
  else if (u && d) d.tieFormat = c;
  else if (s) s.tieFormat = g;
  else if (a) a.tieFormat = g;
  else if (!d || !a) return { error: Ue };
  return vt({ drawDefinition: a, eventId: p == null ? void 0 : p.eventId }), { ...j };
}
function XO({ updateInProgressMatchUps: e = !0, collectionGroupNumber: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, matchUpId: o, matchUp: s, eventId: c, event: u }) {
  if (!t) return { error: we };
  if (isNaN(t)) return { error: ie };
  let d = "removeCollectionGroup", l = s ? void 0 : Lo({ drawDefinition: i, structureId: a, matchUpId: o, eventId: c, event: u });
  if (l != null && l.error) return W({ result: l, stack: d });
  let p = l == null ? void 0 : l.structure;
  s = s ?? (l == null ? void 0 : l.matchUp);
  let f = l == null ? void 0 : l.tieFormat, m = f == null ? void 0 : f.winCriteria.valueGoal, h = f == null ? void 0 : f.winCriteria.aggregateValue, g = Er(f);
  if (l = oi({ tieFormat: g }), l.error) return W({ result: l, stack: d });
  let I = [];
  if (g.collectionDefinitions = g.collectionDefinitions.map((U) => {
    let { collectionGroupNumber: v, ...S } = U;
    return v !== t ? U : (I.push(U.collectionId), S);
  }), g.collectionGroups = g.collectionGroups.filter(({ groupNumber: U }) => U !== t), l = KO({ updateInProgressMatchUps: e, originalValueGoal: m, wasAggregateValue: h, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, structure: p, tieFormat: g, matchUpId: o, matchUp: s, eventId: c, event: u }), !l.error) {
    let { appliedPolicies: U } = nt({ tournamentRecord: r }), v = ye({ drawId: i == null ? void 0 : i.drawId, collectionGroupNumber: t, action: d, structureId: a, matchUpId: o, eventId: c });
    bh({ appliedPolicies: U, drawDefinition: i, auditData: v });
  }
  return W({ result: { ...l, modifiedCollectionIds: I }, stack: d });
}
function kc({ tieFormat: e, orderMap: t }) {
  var i, n;
  let r = Er(e);
  return (i = r.collectionDefinitions) == null || i.forEach((a) => {
    let o = t[a.collectionId];
    o && (a.collectionOrder = o);
  }), (n = r.collectionDefinitions) == null || n.sort((a, o) => lc(a.collectionOrder) - lc(o.collectionOrder)), r;
}
function ZO({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, orderMap: n, eventId: a, matchUp: o, event: s }) {
  var d;
  if (typeof n != "object" || !Object.values(n).every((l) => ke(l))) return W({ result: { error: ie }, context: { orderMap: n } });
  let c = r ? Ne({ drawDefinition: t, structureId: r }) : void 0;
  if (c != null && c.error) return c;
  let u = c == null ? void 0 : c.structure;
  if (a && (s != null && s.tieFormat)) rD({ tournamentRecord: e, event: s, orderMap: n });
  else if (i) {
    let l = t && bt({ drawDefinition: t, matchUpId: i });
    if (l != null && l.error) return l;
    if (o = l.matchUp, !o) return { error: hi };
    let p = (d = Qm({ tournamentRecord: e, matchUpId: i, structure: u, drawDefinition: t, event: s })) == null ? void 0 : d.tieFormat;
    o.tieFormat = kc({ tieFormat: p, orderMap: n }), Qe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: s == null ? void 0 : s.eventId, drawDefinition: t, matchUp: o });
  } else if (r) if (u != null && u.tieFormat) u.tieFormat = kc({ tieFormat: u.tieFormat, orderMap: n }), QO({ eventId: s == null ? void 0 : s.eventId, tournamentRecord: e, drawDefinition: t, structure: u, orderMap: n }), vt({ drawDefinition: t, structureIds: [u.structureId] });
  else if (t.tieFormat) sI({ structureIds: [r], tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
  else if (s != null && s.tieFormat) rD({ structureIds: [r], tournamentRecord: e, orderMap: n, event: s });
  else return { error: Tr };
  else if (t != null && t.tieFormat) sI({ tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
  else return { error: Tr };
  return { ...j };
}
function rD({ tournamentRecord: e, structureIds: t, orderMap: r, event: i }) {
  let n = kc({ tieFormat: i.tieFormat, orderMap: r });
  t != null && t.length || (i.tieFormat = n);
  for (let a of i.drawDefinitions ?? []) sI({ tournamentRecord: e, drawDefinition: a, structureIds: t, orderMap: r, event: i });
}
function sI({ tournamentRecord: e, drawDefinition: t, structureIds: r, orderMap: i, event: n }) {
  let a = t.tieFormat ?? (n == null ? void 0 : n.tieFormat), o = kc({ tieFormat: a, orderMap: i });
  r != null && r.length || (t.tieFormat = o);
  let s = [];
  for (let c of t.structures ?? []) r != null && r.length && !r.includes(c.structureId) || ((c.tieFormat || r != null && r.includes(c.structureId)) && (c.tieFormat = kc({ tieFormat: c.tieFormat ?? t.tieFormat ?? (n == null ? void 0 : n.tieFormat), orderMap: i })), QO({ eventId: n == null ? void 0 : n.eventId, tournamentRecord: e, drawDefinition: t, structure: c, orderMap: i }), s.push(c.structureId));
  vt({ drawDefinition: t, structureIds: s });
}
function QO({ tournamentRecord: e, drawDefinition: t, structure: r, orderMap: i, eventId: n }) {
  var o;
  let a = (o = ut({ matchUpFilters: { matchUpTypes: [yt] }, structure: r })) == null ? void 0 : o.matchUps;
  for (let s of a) s.tieFormat && (s.tieFormat = kc({ tieFormat: s.tieFormat, orderMap: i }), Qe({ tournamentId: e == null ? void 0 : e.tournamentId, drawDefinition: t, eventId: n, matchUp: s }));
}
function Ty({ updateInProgressMatchUps: e = !0, tieFormatComparison: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, collectionId: a, structureId: o, matchUpId: s, eventId: c, matchUp: u, event: d }) {
  var R, b, E, O, M;
  let l = "removeCollectionDefinition", p = u ? void 0 : Lo({ drawDefinition: i, structureId: o, matchUpId: s, eventId: c, event: d });
  if (p != null && p.error) return W({ result: p, stack: l });
  let f = p == null ? void 0 : p.structure;
  u = u ?? (p == null ? void 0 : p.matchUp);
  let m = p == null ? void 0 : p.tieFormat, h = Er(m);
  if (p = oi({ tieFormat: h }), p.error) return W({ result: p, stack: l });
  let g = (R = h == null ? void 0 : h.collectionDefinitions) == null ? void 0 : R.find((N) => N.collectionId === a);
  if (!g) return W({ result: { error: Tr, collectionId: a } });
  h.collectionDefinitions = h.collectionDefinitions.filter((N) => N.collectionId !== a), g.collectionGroupNumber && (h.collectionDefinitions = h.collectionDefinitions.map((N) => {
    let { collectionGroupNumber: C, ...F } = N;
    return F;
  }), h.collectionGroups = h.collectionGroups.filter(({ groupNumber: N }) => N !== g.collectionGroupNumber));
  let { aggregateValue: I, valueGoal: U } = Xs(h);
  h.winCriteria = ye({ aggregateValue: I, valueGoal: U });
  let v = m == null ? void 0 : m.winCriteria.valueGoal, S = m == null ? void 0 : m.winCriteria.aggregateValue;
  (v && v !== U || I && !S) && (n ? h.tieFormatName = n : delete h.tieFormatName);
  let T = [];
  s && u ? T = [u] : o && f ? T = ((b = ut({ matchUpFilters: { matchUpTypes: [yt] }, structure: f })) == null ? void 0 : b.matchUps) ?? [] : i ? T = ((E = Qr({ matchUpFilters: { matchUpTypes: [yt] }, drawDefinition: i })) == null ? void 0 : E.matchUps) ?? [] : d && (T = ((O = ma({ matchUpFilters: { matchUpTypes: [yt] }, drawDefinition: i })) == null ? void 0 : O.matchUps) ?? []);
  let A = (T || []).filter((N) => {
    var x, V, k;
    let C = (V = (x = N.tieMatchUps) == null ? void 0 : x.filter((L) => L.collectionId === a)) == null ? void 0 : V.some(pr), F = t && N.tieFormat ? (k = Na({ descendant: N.tieFormat, ancestor: h })) == null ? void 0 : k.different : !1;
    return e && !C || !N.winningSide && N.matchUpStatus !== zt && (e || N.matchUpStatus !== Sn && !pr(N) && !F);
  });
  if (!A.length) return { error: Wc };
  let { appliedPolicies: y } = nt({ tournamentRecord: r });
  if (s && u && e) {
    let N = (M = u.tieMatchUps) == null ? void 0 : M.filter((C) => C.collectionId === a);
    for (let C of N ?? []) {
      let F = fl({ matchUpId: C.matchUpId, tieMatchUpId: u == null ? void 0 : u.matchUpId, winningSide: void 0, removeScore: !0, tournamentRecord: r, appliedPolicies: y, drawDefinition: i, event: d });
      if (F.error || (F = bt({ drawDefinition: i, matchUpId: s }), F.error)) return F;
      u = F == null ? void 0 : F.matchUp;
    }
  }
  let D = [];
  for (let N of A) {
    for (let C of (N == null ? void 0 : N.sides) ?? []) C.lineUp = (C.lineUp ?? []).map((F) => ({ participantId: F.participantId, collectionAssignments: ((F == null ? void 0 : F.collectionAssignments) ?? []).filter((x) => x.collectionId !== a) }));
    if (N.tieMatchUps = (N.tieMatchUps ?? []).filter((C) => {
      let F = C.collectionId === a;
      return F && D.push(C.matchUpId), !F;
    }), N.tieFormat && (N.tieFormat = Er(h)), e) {
      let C = La({ matchUpId: N.matchUpId, exitWhenNoValues: !0, tournamentRecord: r, appliedPolicies: y, drawDefinition: i, event: d });
      if (C.error) return C;
    }
    Qe({ tournamentId: r == null ? void 0 : r.tournamentId, eventId: d == null ? void 0 : d.eventId, drawDefinition: i, context: l, matchUp: N });
  }
  D.length && Ca({ tournamentId: r == null ? void 0 : r.tournamentId, matchUpIds: D, eventId: d == null ? void 0 : d.eventId, drawDefinition: i });
  let P = ye(h);
  if (p = oi({ tieFormat: P }), p.error) return W({ result: p, stack: l });
  if (c && d) d.tieFormat = P;
  else if (s && u) u.tieFormat = P;
  else if (f) f.tieFormat = P;
  else if (i) i.tieFormat = P;
  else if (!u || !i) return { error: Ue };
  vt({ drawDefinition: i, eventId: d == null ? void 0 : d.eventId });
  let w = ye({ drawId: i == null ? void 0 : i.drawId, action: l, collectionId: a, structureId: o, matchUpId: s, eventId: c });
  return bh({ appliedPolicies: y, drawDefinition: i, auditData: w }), { tieFormat: P, deletedMatchUpIds: D, targetMatchUps: A, ...j };
}
function JO({ updateInProgressMatchUps: e = !0, tournamentRecord: t, groupDefinition: r, drawDefinition: i, collectionIds: n, tieFormatName: a, structureId: o, matchUpId: s, matchUp: c, eventId: u, event: d }) {
  let l = "addCollectionGroup";
  if (!Array.isArray(n)) return W({ result: { error: we }, stack: l });
  let p = c ? void 0 : Lo({ drawDefinition: i, structureId: o, matchUpId: s, eventId: u, event: d });
  if (p != null && p.error) return W({ result: p, stack: l });
  let f = p == null ? void 0 : p.structure;
  c = c || (p == null ? void 0 : p.matchUp);
  let m = p == null ? void 0 : p.tieFormat, h = m == null ? void 0 : m.winCriteria.valueGoal, g = Er(m);
  if (p = oi({ tieFormat: g }), p.error) return W({ result: p, stack: l });
  for (let U of g.collectionDefinitions) {
    let { collectionId: v, collectionGroupNumber: S } = U;
    if (S && n.includes(v)) return W({ info: "collectionIds cannot be part of other collectionGroups", result: { error: ie }, stack: l });
  }
  let I = (g.collectionGroups || []).reduce((U, v) => v.groupNumber > U ? v.groupNumber : U, 0) + 1;
  return r.groupNumber = I, g.collectionDefinitions = g.collectionDefinitions.map((U) => n.includes(U.collectionId) ? { ...U, collectionGroupNumber: I } : U), g.collectionGroups = [...g.collecitonGroups || [], r], KO({ updateInProgressMatchUps: e, originalValueGoal: h, tournamentRecord: t, drawDefinition: i, tieFormatName: a, structureId: o, structure: f, tieFormat: g, matchUpId: s, matchUp: c, eventId: u, event: d });
}
function Dy({ updateInProgressMatchUps: e = !0, collectionDefinition: t, referenceCategory: r, tournamentRecord: i, policyDefinitions: n, enforceCategory: a, referenceGender: o, drawDefinition: s, tieFormatName: c, enforceGender: u, structureId: d, matchUpId: l, matchUp: p, eventId: f, uuids: m, event: h }) {
  var V, k;
  let g = "addCollectionDefinition", I = nt({ tournamentRecord: i, drawDefinition: s, event: h }).appliedPolicies ?? {}, U = (n == null ? void 0 : n[Ar]) ?? (I == null ? void 0 : I[Ar]);
  a = a ?? ((V = U == null ? void 0 : U.participants) == null ? void 0 : V.enforceCategory);
  let v = (u ?? ((k = U == null ? void 0 : U.participants) == null ? void 0 : k.enforceGender)) !== !1, S = !!((r ?? (h == null ? void 0 : h.category)) && a !== !1), T = !!((o ?? (h == null ? void 0 : h.gender)) && v), A = fd({ referenceCategory: r ?? (h == null ? void 0 : h.category), collectionDefinition: t, referenceGender: o, checkCategory: S, checkGender: T, event: h });
  if (A.error) return W({ result: A, stack: g });
  let y = p != null && p.tieFormat ? void 0 : Lo({ drawDefinition: s, structureId: d, matchUpId: l, eventId: f, event: h });
  if (y != null && y.error) return W({ result: { error: y.error }, stack: g });
  let D = y == null ? void 0 : y.structure;
  p = p ?? (y == null ? void 0 : y.matchUp);
  let P = (p == null ? void 0 : p.tieFormat) ?? (y == null ? void 0 : y.tieFormat), w = Er(P);
  if (y = oi({ tieFormat: w }), y == null ? void 0 : y.error) return W({ result: { error: y.error }, stack: g });
  if (!t.collectionId) t.collectionId = st();
  else if (w.collectionDefinitions.map(({ collectionId: L }) => L).includes(t.collectionId)) return W({ context: { collectionId: t.collectionId }, result: { error: Gw } });
  w.collectionDefinitions.push(t), w.collectionDefinitions.sort((L, B) => (L.collectionOrder || 0) - (B.collectionOrder || 0)).forEach((L, B) => L.collectionOrder = B + 1);
  let { aggregateValue: R, valueGoal: b } = Xs(w);
  w.winCriteria = ye({ aggregateValue: R, valueGoal: b });
  let E = P == null ? void 0 : P.winCriteria.valueGoal, O = P == null ? void 0 : P.winCriteria.aggregateValue;
  (E && E !== b || R && !O) && (c ? w.tieFormatName = c : delete w.tieFormatName);
  let M = [], N = [], C = [], F = ye(w);
  if (y = oi({ tieFormat: F }), y == null ? void 0 : y.error) return W({ result: { error: y.error }, stack: g });
  if (f && h) {
    h.tieFormat = F;
    for (let L of h.drawDefinitions ?? []) if (!L.tieFormat) for (let B of L.structures ?? []) {
      if (B.tieFormat) continue;
      let G = ig({ updateInProgressMatchUps: e, collectionDefinition: t, structure: B, uuids: m });
      N.push(...G.newMatchUps), C.push(...G.targetMatchUps), M.push(B.structureId);
    }
    Ol({ modifiedMatchUps: C, eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: M, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (d && D) {
    D.tieFormat = F;
    let L = ig({ updateInProgressMatchUps: e, collectionDefinition: t, structure: D, uuids: m });
    N.push(...L.newMatchUps), C = L.targetMatchUps, Ol({ modifiedMatchUps: C, eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: M, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (l && p) {
    if (!Lp({ matchUp: p, updateInProgressMatchUps: e })) return W({ result: { error: bI }, stack: g });
    p.tieFormat = F;
    let L = Zd({ collectionDefinition: t, matchUp: p, uuids: m });
    Array.isArray(p.tieMatchUps) || (p.tieMatchUps = []), p.tieMatchUps.push(...L), N.push(...L), Ol({ modifiedMatchUps: [p], eventId: h == null ? void 0 : h.eventId, modifiedStructureIds: M, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else if (s) {
    s.tieFormat = F;
    for (let L of s.structures ?? []) {
      let B = ig({ updateInProgressMatchUps: e, collectionDefinition: t, structure: L, uuids: m });
      M.push(L.structureId), N.push(...B.newMatchUps), C.push(...B.targetMatchUps);
    }
    Ol({ modifiedMatchUps: C, eventId: h == null ? void 0 : h.eventId, tournamentRecord: i, drawDefinition: s, addedMatchUps: N, stack: g });
  } else return { error: Ue };
  let x = ye({ drawId: s == null ? void 0 : s.drawId, collectionDefinition: t, action: g, structureId: d, matchUpId: l, eventId: f });
  return bh({ appliedPolicies: I, drawDefinition: s, auditData: x }), { tieFormat: F, targetMatchUps: C, addedMatchUps: N, ...j };
}
function ig({ updateInProgressMatchUps: e, collectionDefinition: t, structure: r, uuids: i }) {
  var o;
  let n = [], a = ((o = ut({ matchUpFilters: { matchUpTypes: [yt] }, structure: r })) == null ? void 0 : o.matchUps).filter((s) => Lp({ matchUp: s, updateInProgressMatchUps: e }) && !s.tieFormat);
  for (let s of a) {
    let c = Zd({ collectionDefinition: t, matchUp: s, uuids: i });
    Array.isArray(s.tieMatchUps) || (s.tieMatchUps = []), s.tieMatchUps.push(...c), n.push(...c);
  }
  return { newMatchUps: n, targetMatchUps: a };
}
function Ol({ modifiedStructureIds: e, tournamentRecord: t, modifiedMatchUps: r, drawDefinition: i, addedMatchUps: n, eventId: a, stack: o }) {
  Za({ tournamentId: t == null ? void 0 : t.tournamentId, matchUps: n, drawDefinition: i, eventId: a }), r == null || r.forEach((s) => {
    Qe({ tournamentId: t == null ? void 0 : t.tournamentId, drawDefinition: i, context: o, matchUp: s, eventId: a });
  }), vt({ structureIds: e, drawDefinition: i, eventId: a });
}
function $O({ updateInProgressMatchUps: e = !1, tieFormatComparison: t, modifiedTieFormat: r, tournamentRecord: i, considerations: n, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, uuids: u, event: d }) {
  let l = "modifyTieFormat";
  if (!oi({ tieFormat: r }).valid) return W({ result: { error: Jn }, info: "falied validation", stack: l });
  let p = Lo({ drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: d });
  if (p.error) return W({ result: p, stack: l });
  let { matchUp: f, tieFormat: m } = p, h = Er(m), g = Na({ descendant: r, ancestor: h, considerations: n });
  if (g.invalid) return W({ context: { invalid: g.invalid }, result: { error: Jn }, stack: l });
  if (!(g != null && g.different)) return W({ result: { ...j }, info: "Nothing to do", stack: l });
  let I = h.collectionDefinitions.map(({ collectionId: P }) => P), U = r.collectionDefinitions.map(({ collectionId: P }) => P), v = I.filter((P) => !U.includes(P)), S = r.collectionDefinitions.filter(({ collectionId: P }) => !I.includes(P)), T = S.map(Ni("collectionId")), A = [], y, D = r.tieFormatName;
  for (let P of r.collectionDefinitions) {
    if (T.includes(P.collectionId)) continue;
    let w = Ay({ updateInProgressMatchUps: e, ...P, tournamentRecord: i, tieFormatName: D, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: d });
    if (w.modifications && A.push(...w.modifications), w.error) return W({ result: w, stack: l });
    w.tieFormat && (y = w.tieFormat);
  }
  for (let P of S) {
    let w = Dy({ updateInProgressMatchUps: e, collectionDefinition: P, tournamentRecord: i, drawDefinition: a, tieFormatName: D, structureId: o, matchUpId: s, matchUp: f, eventId: c, uuids: u, event: d });
    if (w.error) return W({ result: w, stack: l });
    w.tieFormat && (y = w.tieFormat);
  }
  for (let P of v) {
    let w = Ty({ updateInProgressMatchUps: e, tieFormatComparison: t, tournamentRecord: i, drawDefinition: a, tieFormatName: D, collectionId: P, structureId: o, matchUpId: s, eventId: c, matchUp: f, event: d });
    if (w.error) return W({ result: w, stack: l });
    w.tieFormat && (y = w.tieFormat);
  }
  return (m == null ? void 0 : m.tieFormatName) !== D ? (y.tieFormatName = D, A.push({ tieFormatName: D })) : (A.length || T.length || v.length) && (delete y.tieFormatName, A.push("tieFormatName removed: modifications without new tieFormatName")), y.collectionDefinitions = y.collectionDefinitions.sort((P, w) => lc(P.collectionOrder) - lc(w.collectionOrder)).map((P, w) => ({ ...P, collectionOrder: w + 1 })), { processedTieFormat: Er(y), modifications: A, ...j };
}
function eC({ tournamentRecord: e }) {
  if (!e) return { error: de };
  let t = 0;
  for (let r of e.events ?? []) {
    let i = r.tieFormats ?? [], n = (d) => {
      if (!d.tieFormat) return;
      let l;
      for (let p of i) Na({ descendant: d.tieFormat, ancestor: p }).different || (l = p.tieFormatId);
      if (l) d.tieFormatId = l, delete d.tieFormat;
      else {
        let p = ge(d.tieFormat, void 0, !0);
        p.tieFormatId || (p.tieFormatId = st()), d.tieFormatId = p.tieFormatId, delete d.tieFormat, i.push(p), t += 1;
      }
    }, a = r.eventType;
    n({ tieFormat: r.tieFormat, eventType: a });
    for (let d of r.drawDefinitions ?? []) {
      n({ tieFormat: d.tieFormat, eventType: a });
      for (let l of d.structures ?? []) n({ tieFormat: l.tieFormat, eventType: a });
    }
    let o = (d, l) => {
      var f;
      let p = (f = c.matchUps) == null ? void 0 : f.find((m) => m.matchUpId === d);
      p && (p.tieFormatId = l, delete p.tieFormat, Qe({ tournamentId: e == null ? void 0 : e.tournamentId, eventId: r.eventId, matchUp: p }));
    }, s = (d) => {
      let l = ge(d.tieFormat, void 0, !0);
      l.tieFormatId || (l.tieFormatId = st()), i.push(l), t += 1, o(d.matchUpId, l.tieFormatId);
    }, c = ma({ matchUpFilters: { matchUpTypes: [Ci] }, event: r }), u = c.matchUps ?? [];
    for (let d of u) {
      let l;
      for (let p of i) d.tieFormat && Na({ descendant: d.tieFormat, ancestor: p }).different || (l = p.tieFormatId);
      l ? o(d.matchUpId, l) : s(d);
    }
    i.length && (r.tieFormats = i);
  }
  return { ...j, addedCount: t };
}
var tC = {};
qe(tC, { addDrawDefinitionExtension: () => im, addEventExtension: () => oo, addEventTimeItem: () => Ys, addExtension: () => it, addNotes: () => Em, addOnlineResource: () => cC, addParticipantExtension: () => db, addParticipantTimeItem: () => FU, addTimeItem: () => Xn, addTournamentExtension: () => mv, addTournamentTimeItem: () => el, analyzeDraws: () => tl, analyzeTournament: () => hS, copyTournamentRecord: () => iC, createTournamentRecord: () => Ph, generate: () => rC, getAggregateTeamResults: () => mS, getAllowedDrawTypes: () => zm, getAllowedMatchUpFormats: () => lS, getAppliedPolicies: () => nt, getCompetitionDateRange: () => Xm, getCompetitionPenalties: () => pS, getPolicyDefinitions: () => Fa, getTournamentInfo: () => Ks, getTournamentPenalties: () => Km, getTournamentPersons: () => fS, getTournamentPoints: () => Zm, getTournamentStructures: () => hU, getTournamentTimeItem: () => mm, mutate: () => nC, query: () => sE, removeDrawDefinitionExtension: () => lb, removeEventExtension: () => nm, removeExtension: () => Zr, removeNotes: () => MU, removeOnlineResource: () => sC, removeParticipantExtension: () => pb, removeTournamentExtension: () => hv, setTournamentCategories: () => lC, setTournamentDates: () => Nh, setTournamentEndDate: () => fC, setTournamentName: () => uC, setTournamentNotes: () => dC, setTournamentStartDate: () => pC, setTournamentStatus: () => oC });
var rC = {};
qe(rC, { copyTournamentRecord: () => iC, createTournamentRecord: () => Ph });
function iC(e) {
  var p, f;
  let t = Ae(e, [{ tournamentRecord: !0, startDate: !0, endDate: !1, tournamentName: !0 }]);
  if (t.error) return t;
  let { startDate: r, endDate: i } = e.tournamentRecord, n = 24 * 60 * 60 * 1e3, a = (r && i ? new Date(Ve(i)).getTime() - new Date(Ve(r)).getTime() : 0) / n, o = e.endDate || XI(e.startDate, a), s = (m) => m == null ? void 0 : m.filter(({ itemType: h }) => {
    var g;
    return (g = e.itemTypeList) == null ? void 0 : g.includes(h);
  }), c = (m) => m == null ? void 0 : m.filter(({ name: h }) => {
    var g;
    return (g = e.extensionList) == null ? void 0 : g.includes(h);
  }), u = (m) => {
    let { timeItems: h, extensions: g, ...I } = m;
    return ge({ ...I, timeItems: s(h), extensions: c(g) }, !1, !0);
  }, d = (m) => {
    let { drawDefinitions: h, timeItems: g, extensions: I, startDate: U, endDate: v, ...S } = m;
    return ge({ extensions: c(I), timeItems: s(g), startDate: e.startDate, endDate: o, ...S }, !1, !0);
  }, l = { participants: e.copyParticipants ? ((p = e.tournamentRecord.participants) == null ? void 0 : p.map(u)) ?? [] : [], parentOrganisation: ge({ ...e.tournamentRecord.parentOrganisation }, !1, !0), venues: ge(e.tournamentRecord.venues ?? [], !1, !0), extensions: c(e.tournamentRecord.extensions), timeItems: s(e.tournamentRecord.timeItems), events: ((f = e.tournamentRecord.events) == null ? void 0 : f.map(d)) ?? [], weekdays: [...e.tournamentRecord.weekdays ?? []], tournamentName: e.tournamentName, startDate: e.startDate, tournamentId: st(), endDate: o };
  return { ...j, tournamentRecord: l };
}
var nC = {};
qe(nC, { addDrawDefinitionExtension: () => im, addEventExtension: () => oo, addEventTimeItem: () => Ys, addExtension: () => it, addNotes: () => Em, addOnlineResource: () => cC, addParticipantExtension: () => db, addParticipantTimeItem: () => FU, addTimeItem: () => Xn, addTournamentExtension: () => mv, addTournamentTimeItem: () => el, removeDrawDefinitionExtension: () => lb, removeEventExtension: () => nm, removeExtension: () => Zr, removeNotes: () => MU, removeOnlineResource: () => sC, removeParticipantExtension: () => pb, removeTournamentExtension: () => hv, setTournamentCategories: () => lC, setTournamentDates: () => Nh, setTournamentEndDate: () => fC, setTournamentName: () => uC, setTournamentNotes: () => dC, setTournamentStartDate: () => pC, setTournamentStatus: () => oC });
var zW = "ABANDONED", KW = "ACTIVE", XW = "CANCELLED", ZW = "COMPLETED", QW = "IN_PROGRESS", aC = { ABANDONED: zW, ACTIVE: KW, CANCELLED: XW, COMPLETED: ZW, IN_PROGRESS: QW };
function oC({ tournamentRecord: e, status: t }) {
  return e ? t && !Object.keys(aC).includes(t) ? { error: ie, info: "Unknown status" } : (e.tournamentStatus = t, { ...j }) : { error: de };
}
function sC(e) {
  var u, d, l;
  let t = Ae(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (((u = r.parentOrganisation) == null ? void 0 : u.parentOrganisationId) !== n) return W({ result: { error: Tr } });
    ec({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let p = (r.participants ?? []).find((f) => {
      var m;
      return o && ((m = f.person) == null ? void 0 : m.personId) === o || f.participantId === a;
    });
    if (!p) return W(o ? { result: { error: Tr } } : { result: { error: Yt } });
    if (o) {
      if (((d = p.person) == null ? void 0 : d.personId) !== o) return W({ result: { error: Ps } });
      ec({ element: p.person, onlineResource: i });
    } else ec({ element: p, onlineResource: i });
  } else if (s) {
    let p = (l = (r.venues ?? []).filter((f) => !c || f.venueId === c).flatMap((f) => (f.courts ?? []).filter((m) => m.courtId === s))) == null ? void 0 : l[0];
    if (!p) return W({ result: { error: _c } });
    ec({ element: p, onlineResource: i });
  } else if (c) {
    let p = (r.venues ?? []).find((f) => f.venueId === c);
    if (!p) return W({ result: { error: Rs } });
    ec({ element: p, onlineResource: i });
  } else ec({ element: r, onlineResource: i }), Le({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: jo });
  return { ...j };
}
function ec({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => !((i == null ? void 0 : i[gc]) === t[gc] && (i == null ? void 0 : i[Ic]) === t[Ic] && (i == null ? void 0 : i[vc]) === t[vc]));
  e.onlineResources = r;
}
function cC(e) {
  var u, d, l;
  let t = Ae(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (((u = r.parentOrganisation) == null ? void 0 : u.parentOrganisationId) !== n) return W({ result: { error: Tr } });
    tc({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let p = (r.participants ?? []).find((f) => {
      var m;
      return o && ((m = f.person) == null ? void 0 : m.personId) === o || f.participantId === a;
    });
    if (!p) return W(o ? { result: { error: Tr } } : { result: { error: Yt } });
    if (o) {
      if (((d = p.person) == null ? void 0 : d.personId) !== o) return W({ result: { error: Ps } });
      tc({ element: p.person, onlineResource: i });
    } else tc({ element: p, onlineResource: i });
  } else if (s) {
    let p = (l = (r.venues ?? []).filter((f) => !c || f.venueId === c).flatMap((f) => (f.courts ?? []).filter((m) => m.courtId === s))) == null ? void 0 : l[0];
    if (!p) return W({ result: { error: _c } });
    tc({ element: p, onlineResource: i });
  } else if (c) {
    let p = (r.venues ?? []).find((f) => f.venueId === c);
    if (!p) return W({ result: { error: Rs } });
    tc({ element: p, onlineResource: i });
  } else tc({ element: r, onlineResource: i }), Le({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: jo });
  return { ...j };
}
function tc({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => (i == null ? void 0 : i[gc]) !== t[gc] && (i == null ? void 0 : i[Ic]) !== t[Ic] && (i == null ? void 0 : i[vc]) !== t[vc]);
  return r.push(t), e.onlineResources = r, { ...j };
}
function uC({ tournamentRecord: e, promotionalName: t, tournamentName: r, formalName: i }) {
  if (!e) return { error: de };
  let n = e.tournamentId, a = { tournamentId: n };
  return r && r !== e.tournamentName && (e.tournamentName = r, a.tournamentName = r), t && t !== e.promotionalName && (e.promotionalName = t, a.promotionalName = t), i && i !== e.formalName && (e.formalName = i, a.formalName = i), e.promotionalName === e.tournamentName && (delete e.promotionalName, a.promotionalName = ""), e.formalName === e.tournamentName && (delete e.formalName, a.formalName = ""), Object.keys(a).length > 1 && Le({ topic: jo, payload: { parentOrganisation: e.parentOrganisation, tournamentId: n, ...a } }), { ...j };
}
function dC({ tournamentRecord: e, notes: t }) {
  if (!e) return { error: de };
  let r = t ? Em({ element: e, notes: t }) : MU({ element: e });
  return r.error ? r : (Le({ topic: jo, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, notes: t ?? "" } }), { ...j });
}
function lC({ tournamentRecord: e, categories: t }) {
  return e ? (t = (t || []).filter((r) => r.categoryName && r.type), e.tournamentCategories = t, Le({ topic: jo, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, categories: t } }), { ...j }) : { error: de };
}
function JW({ tournamentRecord: e }) {
  var a, o;
  if (!e) return { error: de };
  let { startDate: t, endDate: r } = e, i = hc(t, r), n = [];
  for (let s of e.venues || []) (a = s == null ? void 0 : s.courts) != null && a.length && n.push(...s.courts);
  for (let s of n) {
    let { startTime: c, endTime: u } = (s.dateAvailability ?? []).reduce((p, f) => {
      let m = tt(p.startTime), h = tt(p.endTime);
      return f.startTime && tt(f.startTime) < m && (p.startTime = f.startTime), f.endTime && tt(f.endTime) > h && (p.endTime = f.endTime), p;
    }, { startTime: "08:00", endTime: "18:00" }), d = i.map((p) => {
      var f;
      return ((f = s.dateAvailability) == null ? void 0 : f.find((m) => m.date === p)) ?? { date: p, startTime: c, endTime: u };
    }), l = (o = s.dateAvailability) == null ? void 0 : o.find((p) => !p.date);
    l && d.unshift(l), s.dateAvailability = d;
  }
  return { ...j };
}
function Nh(e) {
  var f, m;
  let { tournamentRecord: t, startDate: r, endDate: i, weekdays: n } = e, a = (f = e.activeDates) == null ? void 0 : f.filter(Boolean), o = Ae(e, [{ tournamentRecord: !0 }, { [Or]: (h) => Gn.test(h), [xi]: Sr, startDate: !1, endDate: !1 }, { [Or]: (h) => h.filter(Boolean).every((g) => Gn.test(g)), [xi]: Sr, activeDates: !1 }, { [Or]: _E, weekdays: !1 }]);
  if (o.error) return o;
  if (i && r && new Date(i) < new Date(r)) return { error: ie };
  if (i && r && new Date(r) > new Date(i)) return { error: ie };
  if (a != null && a.length) {
    let h = r || t.startDate, g = i || t.endDate, I = !h || a.every((v) => new Date(v) >= new Date(h)), U = !g || a.every((v) => new Date(v) <= new Date(g));
    if (!I || !U) return { error: Sr };
  }
  let s;
  (r && t.startDate && new Date(r) > new Date(t.startDate) || i && t.endDate && new Date(i) < new Date(t.endDate)) && (s = !0);
  let c = hc(t.startDate, t.endDate);
  r && (t.startDate = r), i && (t.endDate = i);
  let u = hc(t.startDate, t.endDate), d = c.filter((h) => !u.includes(h)), l = u.filter((h) => !c.includes(h));
  for (let h of t.events ?? []) r && h.startDate && new Date(h.startDate) < new Date(r) && (h.startDate = r), i && h.startDate && new Date(h.startDate) > new Date(i) && (h.startDate = r ?? i), i && h.endDate && new Date(h.endDate) > new Date(i) && (h.endDate = i), r && h.endDate && new Date(h.endDate) < new Date(r) && (h.endDate = i ?? r);
  r && t.endDate && new Date(r) > new Date(t.endDate) && (t.endDate = r), i && t.startDate && new Date(i) < new Date(t.startDate) && (t.startDate = i), a && (t.activeDates = a), n && (t.weekdays = n);
  let p = s && ((m = $W({ tournamentRecord: t })) == null ? void 0 : m.unscheduledMatchUpIds);
  return JW({ tournamentRecord: t }), Le({ payload: ye({ parentOrganisation: t.parentOrganisation, tournamentId: t.tournamentId, activeDates: a, startDate: r, weekdays: n, endDate: i }), topic: jo }), { ...j, unscheduledMatchUpIds: p, datesAdded: l, datesRemoved: d };
}
function pC({ tournamentRecord: e, startDate: t }) {
  return t ? Nh({ tournamentRecord: e, startDate: t }) : { error: Sr };
}
function fC({ tournamentRecord: e, endDate: t }) {
  return t ? Nh({ tournamentRecord: e, endDate: t }) : { error: Sr };
}
function $W({ tournamentRecord: e }) {
  let t = Pr({ tournamentRecord: e }).matchUps ?? [], r = e.startDate && new Date(e.startDate), i = e.endDate && new Date(e.endDate), n = [], a = [];
  for (let o of t) {
    let { schedule: s, matchUpId: c } = o;
    if (s && s.scheduledDate) {
      let u = new Date(s.scheduledDate);
      (r && u < r || i && u > i) && (a.push(c), n.includes(s.scheduledDate) || n.push(s.scheduledDate));
    }
  }
  return n.length && !Th({ scheduledDates: n, tournamentRecord: e }).clearedScheduleCount ? { error: jP } : { unscheduledMatchUpIds: a };
}
var mC = {};
qe(mC, { addCourt: () => Rh, addCourts: () => vy, addVenue: () => kd, deleteCourt: () => TC, deleteVenue: () => by, deleteVenues: () => vC, disableCourts: () => UC, disableVenues: () => SC, enableCourts: () => yC, enableVenues: () => AC, generate: () => hC, generateCourts: () => YS, getCompetitionVenues: () => al, getCourts: () => OS, getVenuesAndCourts: () => xa, modifyCourt: () => Ny, modifyCourtAvailability: () => wy, modifyVenue: () => DC, mutate: () => gC, publicFindVenue: () => Kv, query: () => TE });
var hC = {};
qe(hC, { generateCourts: () => YS });
var gC = {};
qe(gC, { addCourt: () => Rh, addCourts: () => vy, addVenue: () => kd, deleteCourt: () => TC, deleteVenue: () => by, deleteVenues: () => vC, disableCourts: () => UC, disableVenues: () => SC, enableCourts: () => yC, enableVenues: () => AC, modifyCourt: () => Ny, modifyCourtAvailability: () => wy, modifyVenue: () => DC });
function Py(e) {
  if (!(e != null && e.tournamentRecord) && !Array.isArray(e == null ? void 0 : e.venueMatchUps)) return { error: de };
  if (!(e != null && e.courtId)) return { error: Ds };
  let { scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i, venueMatchUps: n, courtId: a } = e, { schedulingProfile: o } = Ba({ tournamentRecord: r });
  if (Array.isArray(n)) return { matchUps: c({ matchUps: n, courtId: a }) };
  let { matchUps: s } = Pr({ scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i });
  return { matchUps: c({ matchUps: s, courtId: a }) };
  function c({ matchUps: u, courtId: d }) {
    let l = u.filter((p) => {
      var m, h, g;
      let f = (h = (m = p.schedule) == null ? void 0 : m.allocatedCourts) == null ? void 0 : h.map(({ courtId: I }) => I);
      return ((g = p.schedule) == null ? void 0 : g.courtId) === d || (f == null ? void 0 : f.includes(d));
    });
    return Np({ matchUps: l, schedulingProfile: o });
  }
}
function eq({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r, venueId: i }) {
  if (!t) return { error: de };
  if (!i) return { error: io };
  let { schedulingProfile: n } = Ba({ tournamentRecord: t }), { matchUps: a } = Pr({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r });
  return { matchUps: o({ matchUps: a, venueId: i }) };
  function o({ matchUps: s, venueId: c }) {
    let u = s.filter((d) => {
      var p, f, m;
      let l = (f = (p = d.schedule) == null ? void 0 : p.allocatedCourts) == null ? void 0 : f.map(({ venueId: h }) => h);
      return ((m = d.schedule) == null ? void 0 : m.venueId) === c || (l == null ? void 0 : l.includes(c));
    });
    return Np({ matchUps: u, schedulingProfile: n });
  }
}
function wy({ tournamentRecord: e, dateAvailability: t, disableNotice: r, venueMatchUps: i, courtId: n, force: a }) {
  var f, m, h;
  if (!e) return { error: de };
  if (!n) return { error: Ds };
  let o = Z1({ dateAvailability: t });
  if (o.error) return o;
  let { updatedDateAvailability: s, totalMergeCount: c } = tq(t);
  t = s;
  let u = Gs({ tournamentRecord: e, courtId: n });
  if (u.error) return u;
  let { court: d, venue: l } = u, { matchUps: p } = Py({ tournamentRecord: e, venueMatchUps: i, courtId: n });
  if (p != null && p.length) {
    let g = (f = nt({ tournamentRecord: e })) == null ? void 0 : f.appliedPolicies, I = a ?? ((h = (m = g == null ? void 0 : g[ao]) == null ? void 0 : m.allowDeletionWithScoresPresent) == null ? void 0 : h.courts), U = [];
    U.length && (I || console.log("throw error: scheduled court matchUps", U.length));
  }
  return d && (d.dateAvailability = t, !r && l && Le({ payload: { venue: l, tournamentId: e.tournamentId }, topic: _o, key: l.venueId })), { ...j, totalMergeCount: c };
}
function tq(e) {
  let t = 0, r = e.reduce((n, a) => {
    let { date: o, startTime: s, endTime: c, bookings: u } = a;
    return n[o] || (n[o] = []), n[o].push({ startTime: s, endTime: c, bookings: u }), n;
  }, {}), i = [];
  return Object.keys(r).forEach((n) => {
    r[n].sort(UW);
    let { mergedAvailability: a, mergeCount: o } = rq(r[n]);
    i.push(...a.map((s) => ({ date: n, ...s }))), t += o;
  }), { updatedDateAvailability: i, totalMergeCount: t };
}
function rq(e) {
  let t, r, i, n = e.length, a = 0, o = [];
  for (; e.length && n; ) {
    let c = e.shift(), { startTime: u, endTime: d, bookings: l } = c;
    if (n -= 1, !t) t = u, i = l, r = d;
    else if (ld(rr(r), rr(u), !1) > 0) {
      let p = { startTime: t, endTime: r };
      i != null && i.length && (p.bookings = i), o.push(p), t = u, i = l, r = d;
    } else l && (i ? i.push(l) : i = l), r = d, a += 1;
  }
  let s = { startTime: t, endTime: r };
  return i != null && i.length && (s.bookings = i), o.push(s), { mergedAvailability: o, mergeCount: a };
}
function Ry({ matchUpsCount: e = 0 }) {
  let t = `Schedule would be deleted from ${e} ${e === 1 ? "matchUp" : "matchUps"}; use { force: true }`;
  return { error: Hw, info: t };
}
function IC({ tournamentRecord: e, drawDefinition: t, matchUpId: r, drawId: i }) {
  let n = "removeCourtAssignment";
  if (!r) return { error: zr };
  if (!t && !i) return { error: Cn };
  let a;
  if (!t) {
    if (!e) return { error: de };
    ({ drawDefinition: t } = ci({ tournamentRecord: e, drawId: i }));
  }
  if (t) ({ matchUp: a } = bt({ drawDefinition: t, matchUpId: r }));
  else {
    if (!e) return { error: de };
    let o = Pr({ tournamentRecord: e, inContext: !1 }).matchUps ?? [];
    ({ matchUp: a } = wM({ matchUps: o, matchUpId: r }));
  }
  return a ? (a.timeItems && a.timeItems.find((o) => [Ja, ua].includes(o.itemType)) && (a.timeItems = a.timeItems.filter(({ itemType: o }) => ![Ja, ua].includes(o)), Qe({ tournamentId: e == null ? void 0 : e.tournamentId, context: n, drawDefinition: t, matchUp: a })), { ...j }) : { error: jr };
}
function by(e) {
  var c, u, d;
  if (typeof (e == null ? void 0 : e.venueId) != "string") return { error: io };
  let { tournamentRecord: t, venueId: r, force: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!Object.keys(n).length) return { error: de };
  let a = On({ tournamentRecords: n, contextFilters: { venueIds: [r] } }).matchUps ?? [], o = (c = nt({ tournamentRecord: t })) == null ? void 0 : c.appliedPolicies, s = i ?? ((d = (u = o == null ? void 0 : o[ao]) == null ? void 0 : u.allowDeletionWithScoresPresent) == null ? void 0 : d.venues);
  if (!a.length || s) for (let l of Object.values(n)) {
    for (let f of a) {
      let m = IC({ matchUpId: f.matchUpId, drawId: f.drawId, tournamentRecord: l });
      if (m.error) return m;
    }
    let p;
    l.venues = (l.venues ?? []).filter((f) => (f == null ? void 0 : f.venueId) !== r ? !0 : (p = !0, !1)), p && Le({ payload: { venueId: r, tournamentId: l.tournamentId }, topic: wv, key: r });
  }
  else return Ry({ matchUpsCount: a.length });
  return sl({ tournamentRecords: n }), { ...j };
}
function vC({ tournamentRecord: e, venueIds: t, force: r }) {
  if (!e) return { error: de };
  if (!Array.isArray(t)) return { error: ie };
  for (let i of e.venues || []) {
    let { venueId: n } = i;
    if (t.includes(n)) {
      let { venueId: a } = i, o = by({ tournamentRecord: e, venueId: a, force: r });
      if (o.error) return o;
    }
  }
  return { ...j };
}
function UC(e) {
  let { courtIds: t, dates: r } = e, i = $i(e), n = [{ [_r]: !0, [tm]: !0 }], a = Ae(e, n);
  if (a.error) return a;
  for (let o of Object.values(i)) iq({ tournamentRecord: o, courtIds: t, dates: r });
  return { ...j };
}
function iq({ tournamentRecord: e, courtIds: t, dates: r }) {
  let i = Array.isArray(r) && r.length ? { dates: r } : !0, n = (a) => it({ extension: { value: i, name: Pn }, creationTime: !1, element: a });
  for (let a of e.venues || []) for (let o of a.courts || []) if (t != null && t.includes(o.courtId)) {
    let s = n(o);
    if (s.error) return s;
  }
  return { ...j };
}
function SC(e) {
  let { tournamentRecords: t, tournamentId: r, venueIds: i } = e, n = [{ [_r]: !0, [rm]: !0 }], a = Ae(e, n);
  if (a.error) return a;
  let o = Object.keys(t).filter((s) => !r || s === r);
  for (let s of o) {
    let c = t[s];
    nq({ tournamentRecord: c, venueIds: i });
  }
  return { ...j };
}
function nq({ tournamentRecord: e, venueIds: t }) {
  for (let r of e.venues || []) if (t != null && t.includes(r.venueId)) {
    let i = it({ creationTime: !1, element: r, extension: { name: Pn, value: !0 } });
    if (i.error) return i;
  }
  return { ...j };
}
function yC(e) {
  let t = $i(e), r = [{ [_r]: !0 }];
  !e.enableAll && r.push({ [tm]: !0 });
  let i = Ae(e, r);
  if (i.error) return i;
  let { enableAll: n, courtIds: a, dates: o } = e;
  for (let s of Object.values(t)) aq({ tournamentRecord: s, courtIds: a, enableAll: n, dates: o });
  return { ...j };
}
function aq({ tournamentRecord: e, courtIds: t, enableAll: r, dates: i }) {
  for (let n of e.venues || []) for (let a of n.courts || []) if (r || t != null && t.includes(a.courtId)) if (Array.isArray(i)) {
    let { extension: o } = We({ element: a, name: Pn });
    if (o) {
      let s = o.value;
      Array.isArray(s.dates) && (s.dates = s.dates.filter((c) => !i.includes(c))), it({ extension: { name: Pn, value: s }, creationTime: !1, element: a });
    }
  } else Zr({ element: a, name: Pn });
  return { ...j };
}
function AC(e) {
  let t = $i(e), r = [{ [_r]: !0 }];
  !e.enableAll && r.push({ [rm]: !0 });
  let i = Ae(e, r);
  if (i.error) return i;
  let { venueIds: n, enableAll: a } = e;
  for (let o of Object.values(t)) for (let s of o.venues || []) (a || n != null && n.includes(s.venueId)) && Zr({ element: s, name: Pn });
  return { ...j };
}
function TC(e) {
  let { courtId: t, disableNotice: r, force: i } = e, n = $i(e), a = Ae(e, [{ [_r]: !0, [ab]: !0 }]);
  if (a.error) return a;
  let o, s;
  for (let c of Object.values(n)) {
    if (s = oq({ tournamentRecord: c, disableNotice: r, courtId: t, force: i }), s.error && s.error !== _c) return s;
    s.success && (o = !0);
  }
  return o ? { ...j } : s;
}
function oq({ tournamentRecord: e, disableNotice: t, courtId: r, force: i }) {
  var u, d, l;
  let n = Gs({ tournamentRecord: e, courtId: r });
  if (n.error) return n;
  let a = n.venue, { matchUps: o } = Py({ tournamentRecord: e, courtId: r }), s = (u = nt({ tournamentRecord: e })) == null ? void 0 : u.appliedPolicies, c = i ?? ((l = (d = s == null ? void 0 : s[ao]) == null ? void 0 : d.allowDeletionWithScoresPresent) == null ? void 0 : l.courts);
  if (!(o != null && o.length) || c) {
    for (let p of o ?? []) {
      let f = IC({ matchUpId: p.matchUpId, drawId: p.drawId, tournamentRecord: e });
      if (f.error) return f;
    }
    a && (a.courts = (a.courts ?? []).filter((p) => p.courtId !== r), t || Le({ payload: { venue: a, tournamentId: e.tournamentId }, topic: _o, key: a.venueId }));
  } else return Ry({ matchUpsCount: o.length });
  return { ...j };
}
function Ny(e) {
  let { disableNotice: t, modifications: r, courtId: i, force: n, venueMatchUps: a } = e, o = $i(e);
  if (!Object.keys(o).length) return { error: xt };
  let s, c;
  for (let u of Object.values(o)) {
    let d = sq({ tournamentRecord: u, disableNotice: t, venueMatchUps: a, modifications: r, courtId: i, force: n });
    if (d != null && d.error) return d;
    s = !0;
  }
  return s ? { ...j } : c;
}
function sq({ tournamentRecord: e, disableNotice: t, venueMatchUps: r, modifications: i, courtId: n, force: a }) {
  if (!e) return { error: de };
  if (!n) return { error: Ds };
  if (!i || typeof i != "object") return { error: Ea };
  let o = Gs({ tournamentRecord: e, courtId: n });
  if (o.error) return o;
  let { venue: s, court: c } = o, u = Object.keys(vW()).filter((p) => p !== "courtId");
  if (!Object.keys(i).filter((p) => u.includes(p)).length) return { error: Bf };
  let d = u.filter((p) => !["dateAvailability"].includes(p)), l = Object.keys(i).filter((p) => d.includes(p));
  if (c && l.forEach((p) => Object.assign(c, { [p]: i[p] })), i.dateAvailability) {
    let p = wy({ dateAvailability: i.dateAvailability, tournamentRecord: e, venueMatchUps: r, disableNotice: t, courtId: n, force: a });
    if (p.error) return p;
  }
  return t || Le({ payload: { venue: s, tournamentId: e.tournamentId }, topic: _o, key: s == null ? void 0 : s.venueId }), { ...j, court: ge(c) };
}
var cq = () => ({ venueId: void 0, venueName: "", venueAbbreviation: "", onlineResources: [], venueType: void 0, addresses: [], contacts: [], courts: [], roles: [] }), uq = cq;
function DC(e) {
  let { modifications: t, venueId: r, force: i } = e, n = $i(e);
  if (!Object.keys(n).length) return { error: xt };
  if (typeof r != "string") return { error: io };
  let a, o;
  for (let s of Object.values(n)) {
    let c = dq({ tournamentRecord: s, modifications: t, venueId: r, force: i });
    if (c.success && (o = !0), c.error && (a = c.error), c.error && c.error !== Rs) return c;
  }
  return sl({ tournamentRecords: n }), o ? { ...j } : { error: a };
}
function dq({ tournamentRecord: e, modifications: t, venueId: r, force: i }) {
  var g, I, U, v, S, T, A, y;
  if (!e) return { error: de };
  if (!t || typeof t != "object") return { error: Ea };
  if (!r) return { error: io };
  let n = (g = nt({ tournamentRecord: e })) == null ? void 0 : g.appliedPolicies, a = i ?? ((U = (I = n == null ? void 0 : n[ao]) == null ? void 0 : I.allowDeletionWithScoresPresent) == null ? void 0 : U.venues), { matchUps: o } = eq({ tournamentRecord: e, venueId: r }), s = fa({ tournamentRecord: e, venueId: r });
  if (s.error) return s;
  let c = s.venue, u = Object.keys(uq()).filter((D) => D !== "venueId");
  if (!Object.keys(t).filter((D) => u.includes(D)).length) return { error: Bf };
  let d = u.filter((D) => !["courts", "onlineResources"].includes(D)), l = Object.keys(t).filter((D) => d.includes(D));
  c && l.forEach((D) => Object.assign(c, { [D]: t[D] }));
  let p = ((v = c == null ? void 0 : c.courts) == null ? void 0 : v.map((D) => D.courtId)) ?? [], f = ((S = t.courts) == null ? void 0 : S.map((D) => D.courtId)) || [], m = f.length ? p.filter((D) => !f.includes(D)) : (t == null ? void 0 : t.courts) && p, h = [];
  if (m != null && m.length) {
    let D = (A = (T = c == null ? void 0 : c.courts) == null ? void 0 : T.filter((P) => m.includes(P.courtId))) == null ? void 0 : A.map((P) => {
      var R;
      let w = Py({ courtId: P.courtId, tournamentRecord: e, venueMatchUps: o });
      for (let b of w.matchUps ?? []) h.push({ matchUpId: b.matchUpId, drawId: b.drawId });
      return ((R = w.matchUps) == null ? void 0 : R.length) ?? 0;
    }).reduce((P, w) => P + w);
    if (c && (!D || a)) c.courts = (y = c.courts) == null ? void 0 : y.filter((P) => f.includes(P.courtId)), rd({ schedule: { courtId: "", scheduledDate: "" }, matchUpDetails: h, removePriorValues: !0, tournamentRecord: e });
    else return Ry({ matchUpsCount: D });
  }
  if (t.courts) for (let D of t.courts) {
    let { courtId: P } = D || {}, w = Ny({ modifications: D, disableNotice: !0, tournamentRecord: e, venueMatchUps: o, courtId: P, force: i });
    if (w.error === _c && (w = Rh({ disableNotice: !0, tournamentRecord: e, venueId: r, court: D })), w.error) return w;
  }
  return sl({ tournamentRecord: e }), c && Le({ payload: { venue: c, tournamentId: e.tournamentId }, topic: _o, key: c == null ? void 0 : c.venueId }), { ...j, venue: ge(c) };
}
var lq = {};
qe(lq, { JSON2CSV: () => vq, UUID: () => st, UUIDS: () => lR, allNumeric: () => FP, attributeFilter: () => gs, chunkArray: () => gr, chunkByNth: () => ug, chunkSizeProfile: () => CP, constantToString: () => Fr, countValues: () => EF, createMap: () => LP, dateTime: () => dR, definedAttributes: () => ye, dehydrateMatchUps: () => mq, extractAttributes: () => pN, flattenJSON: () => My, generateDateRange: () => hc, generateHashCode: () => VF, generateRange: () => fe, generateTimeCode: () => iO, groupValues: () => EP, hasAttributeValues: () => BF, instanceCount: () => wi, intersection: () => qt, isConvertableInteger: () => ke, isNumeric: () => jt, isOdd: () => NP, isPowerOf2: () => Rn, makeDeepCopy: () => ge, matchUpScheduleSort: () => fq, matchUpSort: () => js, nearestPowerOf2: () => fI, nextPowerOf2: () => Lc, noNulls: () => MF, noNumeric: () => kP, numericSort: () => ar, occurrences: () => CF, overlap: () => Jr, randomMember: () => yi, randomPop: () => Di, shuffleArray: () => Xr, structureSort: () => Cs, subSort: () => FF, undefinedToNull: () => dg, unique: () => Be, visualizeScheduledMatchUps: () => pq });
function pq({ scheduledMatchUps: e, showGlobalLog: t }) {
  Jx();
  let r = e == null ? void 0 : e.reduce((n, { structureId: a }) => n.includes(a) ? n : n.concat(a), []), i = Array.isArray(r) && { ...r.map((n) => {
    let { structureName: a, matchUpType: o } = e.find((s) => s.structureId === n);
    return { [n]: `${a} ${o}` };
  }) };
  r == null || r.forEach((n) => {
    var s;
    Oi({ color: "blue", method: "draw", structure: i[n], keyColors: { structure: "magenta" } }, !0);
    let a = e.filter((c) => c.structureId === n), o = ((s = $r({ matchUps: a })) == null ? void 0 : s.roundMatchUps) || [];
    Object.keys(o).forEach((c) => {
      Oi({ roundNumber: c, keyColors: { roundNumber: "brightcyan" } }, !0), o[c].forEach(({ matchUpId: u, schedule: d }) => {
        let l = Rt(d.scheduledTime);
        Oi({ matchUpId: u, time: l, date: d.scheduledDate, venue: d.venueId, keyColors: { time: "brightcyan", date: "brightcyan", matchUpId: "yellow", venue: "magenta" } }, !0);
      });
    });
  }), t && Qx();
}
var { extractTime: iD, timeStringMinutes: nD } = dR;
function fq(e, t) {
  let r = e.schedule ?? {}, i = t.schedule ?? {};
  if (r.scheduledDate && !i.scheduledDate) return 1;
  if (i.scheduledDate && !r.scheduledDate) return -1;
  if (r.scheduledDate && i.scheduledDate) {
    if (r.scheduledDate === i.scheduledDate) {
      if (r.scheduledTime && !i.scheduledTime) return 1;
      if (i.scheduledTime && !r.scheduledTime) return -1;
      if (r.scheduledTime && i.scheduledTime) {
        let n = nD(iD(r.scheduledTime)), a = nD(iD(i.scheduledTime));
        return n - a;
      }
    }
    return new Date(r.scheduledDate).getTime() - new Date(i.scheduledDate).getTime();
  }
  return 0;
}
function mq({ tournamentRecord: e }) {
  if (!e) return { error: de };
  if (typeof e != "object" || !e.tournamentId) return { error: ie };
  let { matchUps: t } = Pr({ tournamentRecord: e, inContext: !1 });
  if (t != null && t.length) {
    let r = hq({ tournamentRecord: e });
    Iq(t, r);
  }
  return { ...j };
}
function hq({ tournamentRecord: e }) {
  let t = {};
  for (let r of e.events || []) {
    r.matchUpFormat && (t[r.eventId] = r.matchUpFormat);
    for (let i of r.drawDefinitions || []) {
      i.matchUpFormat && (t[i.drawId] = i.matchUpFormat);
      for (let n of i.structures || []) {
        n.matchUpFormat && (t[n.structureId] = n.matchUpFormat);
        for (let a of n.structures || []) a.matchUpFormat && (t[a.structureId] = a.matchUpFormat);
      }
    }
  }
  return t;
}
var gq = ["collectionId", "collectionPosition", "drawPositions", "extensions", "finishingPositionRange", "finishingRound", "isMock", "matchUpId", "matchUpStatus", "matchUpStatusCodes", "orderOfFinish", "processCodes", "roundNumber", "tieFormat", "tieMatchUps", "roundPosition", "score", "sides", "winnerMatchUpId", "loserMatchUpId", "matchUpDuration", "winningSide"];
function Iq(e, t = {}) {
  for (let r of e) {
    let { structureId: i, drawId: n, eventId: a } = r, o = t[i] || t[n] || t[a], s = r.matchUpFormat === o ? void 0 : r.matchUpFormat;
    for (let c of Object.keys(r)) gq.includes(c) || delete r[c];
    r.sides && r.drawPositions && !r.tieMatchUps && delete r.sides, s && (r.matchUpFormat = s);
  }
}
function vq(e, t) {
  if (t && typeof t != "object") return { error: ie };
  let { columnTransform: r = {} } = t || {}, { includeTransformAccessors: i, includeHeaderRow: n = !0, returnTransformedJSON: a, removeEmptyColumns: o, onlyHeaderRow: s, columnAccessors: c = [], functionMap: u = {}, columnMap: d = {}, valuesMap: l = {}, context: p = {}, delimiter: f = '"', columnJoiner: m = ",", rowJoiner: h = `\r
`, keyJoiner: g = "." } = t || {};
  if (!Array.isArray(e) || !Array.isArray(c) || typeof p != "object" || typeof d != "object" || typeof r != "object" || typeof u != "object" || typeof l != "object" || typeof m != "string" || typeof h != "string" || typeof g != "string" || typeof f != "string") return { error: ie };
  r = Object.assign({}, ...Object.keys(r).reverse().map((O) => ({ [O]: Array.isArray(r[O]) ? r[O] : [typeof r[O] == "string" && r[O]].filter(Boolean) })));
  let I = e.filter(Boolean).map((O) => My(O, g)), U = Object.values(r).flat();
  i && c.push(...U);
  let v = I.reduce((O, M) => Object.keys(M).every((N) => !O.includes(N) && O.push(N) || !0) && O, []).filter((O) => !(c != null && c.length) || c.includes(O)), S = Object.assign({}, ...Object.keys(r).reverse().map((O) => r[O].map((M) => ({ [M]: O })).flat()).flat()), T = (O, M) => t != null && t.sortOrder ? t.sortOrder.includes(O) && t.sortOrder.includes(M) && t.sortOrder.indexOf(O) - t.sortOrder.indexOf(M) || !t.sortOrder.includes(M) && -1 : 0, A = v.reduce((O, M) => {
    let N = S[M];
    return N ? O.includes(N) || O.push(N) : O.push(M), O;
  }, []).sort(T);
  Object.keys(d).forEach((O) => !A.includes(O) && A.unshift(O)), Object.keys(r).forEach((O) => !A.includes(O) && A.unshift(O)), typeof p == "object" && Object.keys(p).forEach((O) => !A.includes(O) && A.unshift(O));
  let y = A.map((O) => d[O] || O);
  if (s) return [y];
  let D = (O) => `${f}${O}${f}`, P = [], w = (O) => Object.values(A.reduce((M, N, C) => {
    var L;
    let F = r[N], x = (F != null && F.length ? O[F.find((B) => O[B])] : O[N]) || (p == null ? void 0 : p[N]) || "", V = ((L = l[N]) == null ? void 0 : L[x]) || x, k = Ti(u[N]) ? u[N](V) : V;
    return M[N] = D(k), k && (P[C] = (P[C] || 0) + 1), M;
  }, {})), R = I.map(w), b = o && [...P].map((O, M) => !O && M).filter(jt).reverse();
  if (b) {
    let O = (M) => M.filter((N, C) => !b.includes(C));
    R = R.map(O), y = O(y);
  }
  let E = R.map((O) => O.join(m));
  return a ? E.map((O) => {
    let M = O.split(m);
    return Object.assign({}, ...M.map((N, C) => ({ [y[C]]: N })));
  }) : n ? [y.map(D).join(m), ...E].join(h) : E.join(h);
}
function My(e, t = ".", r = []) {
  return typeof e == "object" && Object.keys(e).reduce((i, n) => typeof e[n] != "object" ? (i[r.concat(n).join(t)] = e[n], i) : Object.assign(i, My(e[n], t, r.concat(n))), {});
}
var { FACTORY: aD } = mb;
function Uq({ tournamentRecord: e, value: t }) {
  let { extension: r } = We({ element: e, name: aD }), i = { name: aD, value: { ...r == null ? void 0 : r.value, ...t } };
  it({ element: e, extension: i });
}
function PC({ timeStamp: e }) {
  let t = Ns(), r = _I();
  return r && Object.values(t).forEach((i) => {
    Uq({ tournamentRecord: i, value: { version: wf(), timeStamp: e } });
  }), r;
}
function wC({ engineType: e, methodName: t, elapsed: r, params: i, result: n }) {
  var l, p;
  let a = ki();
  if (typeof a != "object") return;
  let o = { method: t }, s = (n == null ? void 0 : n.error) && (a.errors === !0 || Array.isArray(a.errors) && a.errors.includes(t)), c = Array.isArray(a.params) && ((l = a.params) == null ? void 0 : l.includes(t)), u = a.params && !Array.isArray(a.params) || c, d = Array.isArray(a.exclude) && a.exclude.includes(t);
  !d && ![void 0, !1].includes(a.perf) && !isNaN(a.perf) && r >= a.perf && (o.elapsed = r), !d && (s || u) && (o.params = i), !d && (s || a.result && !Array.isArray(a.result) && (!Array.isArray(a.params) || c) || Array.isArray(a.result) && ((p = a.result) != null && p.includes(t))) && (o.result = n), Object.keys(o).length > 1 && rR(o, e);
}
function Ey({ methodName: e, params: t, start: r }) {
  let i = { error: Gf, methodName: e }, n = r ? Date.now() - r : 0;
  return wC({ result: i, methodName: e, elapsed: n, params: t, engineType: "sync" }), i;
}
function Sq(e, t) {
  var a;
  if (t._middleware === !1) return t;
  if (t.tournamentId && !e[t.tournamentId]) return { error: de };
  let r = t.drawId || ((a = t.matchUp) == null ? void 0 : a.drawId);
  if (r) {
    let { event: o, drawDefinition: s, tournamentId: c } = ci({ tournamentRecords: e, drawId: r });
    s && (t.drawDefinition = s), c && (t.tournamentId = c), o && (t.event = o);
  }
  if (t.eventId && !t.event) {
    let { event: o, tournamentId: s } = ci({ eventId: t.eventId, tournamentRecords: e });
    if (!o) return { error: Ki };
    t.tournamentId = s, t.event = o;
  }
  let i = t.tournamentId ?? bs();
  if (!i && t) return t;
  let n = e[i];
  return i && !n ? { error: de } : (n && (t.tournamentRecord = n), t);
}
function Oy(e, t, r, i, n) {
  delete e.success, delete e.error;
  let a = Date.now(), o = bs();
  r && (r.activeTournamentId = o);
  let s = (r == null ? void 0 : r.tournamentRecord) || qI(o), c = typeof (r == null ? void 0 : r.tournamentRecord) == "object" && { [r == null ? void 0 : r.tournamentRecord.tournamentId]: r.tournamentRecord } || Ns(), u = r ? ge(r, void 0, !0) : void 0, d = r ? Sq(c, r) : void 0;
  if (d != null && d.error) return d;
  let l = yq({ params: d, tournamentRecords: c, tournamentRecord: s, methodName: i, method: t }), p = Date.now() - a;
  return wC({ result: l, methodName: i, elapsed: p, params: u, engineType: n }), l;
}
function yq({ tournamentRecords: e, tournamentRecord: t, params: r, methodName: i, method: n }) {
  if (ki()) return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  try {
    return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  } catch (a) {
    return qf({ engineName: "engine", methodName: i, params: r, err: a });
  }
}
function Mh(e) {
  let { mutationStatus: t, tournamentId: r, directives: i, timeStamp: n } = e || {}, { topics: a } = Ji();
  for (let o of [...a].sort(Aq)) {
    let s = $w({ topic: o });
    s != null && s.length && yg({ topic: o, notices: s });
  }
  t && n && a.includes(bg) && yg({ notices: [{ tournamentId: r, directives: i, timeStamp: n }], topic: bg });
}
var oD = { [Fv]: 5, [Cv]: 5, [kv]: 5, [Ov]: 5, [Ev]: 5, [Nv]: 5, [Mb]: 5, [Eb]: 5, [Mv]: 1, [um]: 1, [Lr]: 5, [_o]: 5, [bv]: 4, [Pv]: 4, [wv]: 4, [Rv]: 4, [cm]: 3, [yv]: 2 };
function Aq(e, t) {
  return (oD[t] || 0) - (oD[e] || 0);
}
function Tq({ convertExtensions: e, removeExtensions: t }) {
  let r = Ns();
  return { tournamentId: bs(), tournamentRecords: ge(r, e, !1, t) };
}
function Dq(e) {
  let { convertExtensions: t = !1, removeExtensions: r = !1 } = e ?? {}, i = (e == null ? void 0 : e.tournamentId) ?? bs();
  if (typeof i != "string") return {};
  let n = qI(i);
  return { tournamentRecord: ge(n, t, !1, r) };
}
function Pq() {
  var i;
  let e = Ns(), { extension: t } = We({ name: bo, tournamentRecords: e, discover: !0 }), r = ((i = t == null ? void 0 : t.value) == null ? void 0 : i.tournamentIds) || [];
  return Object.keys(e).forEach((n) => {
    r.includes(n) || delete e[n];
  }), Wf(e);
}
function sD(e, t = !0) {
  return typeof e != "object" || Array.isArray(e) ? { error: Ea } : e != null && e.tournamentId ? eR(t ? ge(e) : e) : { error: ie };
}
function id(e, t = !0) {
  if (typeof e != "object") return { error: Ea };
  if (ku(), Array.isArray(e)) {
    if (e.filter((r) => r == null ? void 0 : r.tournamentId).length !== e.length) return { error: fg };
    e = Object.assign({}, ...e.map((r) => ({ [r.tournamentId]: r })));
  } else if (e != null && e.tournamentId) e = { [e.tournamentId]: e }, ku(e.tournamentId);
  else if (!Object.keys(e).every((r) => e[r].tournamentId === r)) return { error: fg };
  return Wf(t ? ge(e) : e);
}
function wq(e, t, r, i, n, a) {
  let o = iR(r, i, n, a);
  if (o.error) return o;
  let s = o.methods ?? [];
  return Object.keys(s).filter((c) => Ti(s[c])).forEach((c) => {
    e[c] = (u) => {
      let d = () => t(e, { [c]: s[c], ...u });
      if (ki()) return d();
      try {
        return d();
      } catch (l) {
        qf({ engineName: "engine", methodName: c, params: u, err: l });
      }
    };
  }), { ...j, ...e };
}
function rc(e, t) {
  return t != null && t.error ? (e.error = t.error, e.success = !1) : (e.error = void 0, e.success = !0), e;
}
function RC(e, t) {
  e.importMethods = (r, i, n, a) => wq(e, t, r, i, n, a), e.getTournament = (r) => Dq(r), e.getState = (r) => Tq({ convertExtensions: r == null ? void 0 : r.convertExtensions, removeExtensions: r == null ? void 0 : r.removeExtensions }), e.version = () => wf(), e.reset = () => (Wf({}), rc(e)), e.devContext = (r) => (Cu(r), rc(e)), e.getDevContext = (r) => ki(r), e.newTournamentRecord = (r = {}) => {
    let i = Ph(r), n = i.tournamentId;
    return i.error ? i : (sD(i), ku(n), { ...j, tournamentId: n });
  }, e.setState = (r, i, n) => {
    Fu(i, n);
    let a = id(r, i);
    return rc(e, a);
  }, e.setTournamentId = (r) => ku(r), e.getTournamentId = () => bs(), e.setTournamentRecord = (r, i, n) => {
    Fu(i, n);
    let a = sD(r, i);
    return rc(e, a);
  }, e.removeTournamentRecord = (r) => {
    let i = tR(r);
    return rc(e, i);
  }, e.removeUnlinkedTournamentRecords = () => {
    let r = Pq();
    return rc(e, r);
  };
}
function Rq(e, t, r) {
  if (!Array.isArray(t)) return { error: ie, message: "directives must be an array" };
  let i = Jw(), n = Date.now(), a = r && ge(Ns(), !1, !0), o = [];
  for (let u of t) {
    if (typeof u != "object") return { error: ie, message: "directive must be an object" };
    if (u.params && typeof u.params != "object") return { error: ie, message: "params must be an object" };
    let { method: d, pipe: l } = u, p = u.params ? { ...u.params } : {};
    if (!i[d]) return Ey({ methodName: d, start: n, params: p });
    if (l) {
      let m = o[o.length - 1], h = Object.keys(l);
      for (let g of h) m[g] && (p[g] = m[g]);
    }
    let f = Oy(e, i[d], p, d, "sync");
    if (f != null && f.error) return a && id(a), { ...f, rolledBack: !!a };
    o.push({ ...f, methodName: d });
  }
  let s = Date.now(), c = PC({ timeStamp: s });
  return Mh({ directives: t, mutationStatus: c, timeStamp: s }), ud(), { success: o.every((u) => u.success), results: o };
}
function cD(e, t) {
  if (!$e(t)) return { error: ie, message: "args must be an object" };
  let r = Object.values(t).filter(Ti).length;
  if (r > 1) return { message: "there must be only one arg with typeof function", error: ie };
  let i = r ? Object.keys(t).find((f) => Ti(t[f])) : Et(t.method) && t.method;
  if (!i) return { error: Gf };
  let { [i]: n, ...a } = t, o = t != null && t.params ? { ...t.params } : { ...a }, s = o.rollbackOnError && ge(Ns(), !1, !0), c = n || e[i] || GI()[i];
  if (!c) return Ey({ methodName: i, params: o });
  let u = Oy(e, c, o, i, "sync") ?? {};
  u != null && u.error && s && id(s);
  let d = Date.now(), l = PC({ timeStamp: d }), p = (u == null ? void 0 : u.success) && (o == null ? void 0 : o.delayNotify) !== !0 && (o == null ? void 0 : o.doNotNotify) !== !0;
  return p && Mh({ directives: [{ method: c, params: o }], mutationStatus: l, timeStamp: d }), (p || !(u != null && u.success) || o != null && o.doNotNotify) && ud(), u;
}
var bq = (() => {
  let e = { executionQueue: (t, r) => Rq(e, t, r), execute: (t) => cD(e, t) };
  return RC(e, cD), e;
})(), bC = bq;
function uD(e, t) {
  if (!$e(t)) return { error: ie, message: "args must be an object" };
  let r = Object.values(t).filter(Ti).length;
  if (r > 1) return { message: "there must be only one arg with typeof function", error: ie };
  let i = r ? Object.keys(t).find((c) => Ti(t[c])) : Et(t.method) && t.method;
  if (!i) return { error: Gf };
  let { [i]: n, ...a } = t, o = t != null && t.params ? { ...t.params } : { ...a }, s = n || e[i] || GI()[i];
  return s ? Oy(e, s, o, i, "ask") : Ey({ methodName: i, params: o });
}
(() => {
  let e = { execute: (t) => uD(e, t) };
  return RC(e, uD), e;
})();
var us = {}, Wa;
function dD(e, t = !0) {
  if (!e) return { error: we };
  if (typeof e != "object") return { error: Ea };
  if (e.matchUpId) Wa = e.matchUpId, us[Wa] = t ? ge(e) : e;
  else if (Array.isArray(e)) for (let r of e.reverse()) r.matchUpId && (us[r.matchUpId] = t ? ge(r) : r, Wa || (Wa = r.matchUpId));
  else for (let r of Object.values(e)) r.matchUpId && (us[r.matchUpId] = t ? ge(r) : r, Wa || (Wa = r.matchUpId));
  return t ? ge(e) : e;
}
function Nq() {
  return us[Wa];
}
function Mq() {
  return Object.values(us);
}
function Eq() {
  Wa = void 0, us = {};
}
function Oq(e) {
  return ge(us[Wa], e == null ? void 0 : e.convertExtensions, !1, e == null ? void 0 : e.removeExtensions);
}
(() => {
  let e = { getState: (n) => Oq(n), version: () => wf(), reset: () => (Eq(), { ...j }), drawId: void 0, error: void 0, success: !1, devContext: (n) => (Cu(n), e), setState: (n, a, o) => {
    Fu(a, o);
    let s = dD(n);
    return t(s);
  } };
  function t(n) {
    return n != null && n.error ? (e.error = n.error, e.success = !1) : (e.error = void 0, e.success = !0, e.drawId = n.drawId), e;
  }
  return r([KU]), e;
  function r(n) {
    n.forEach((a) => {
      Object.keys(a).forEach((o) => {
        e[o] = (s) => {
          if (ki()) return i({ params: s, governor: a, methodName: o });
          try {
            return i({ params: s, governor: a, methodName: o });
          } catch (c) {
            qf({ engineName: "matchUpEngine", methodName: o, params: s, err: c });
          }
        };
      });
    });
  }
  function i({ params: n, governor: a, methodName: o }) {
    e.error = void 0, e.success = !1;
    let s = (n == null ? void 0 : n.matchUp) || Nq(), c = (n == null ? void 0 : n.matchUps) || Mq(), u = (n == null ? void 0 : n.rollbackOnError) && ge(s, !1, !0);
    n = { ...n, matchUpId: s == null ? void 0 : s.matchUpId, matchUps: c, matchUp: s };
    let d = a[o](n);
    if (d != null && d.error) return u && dD(u), { ...d, rolledBack: !!u };
    let l = (d == null ? void 0 : d.success) && (n == null ? void 0 : n.delayNotify) !== !0 && (n == null ? void 0 : n.doNotNotify) !== !0;
    return l && Mh(), (l || !(d != null && d.success) || n != null && n.doNotNotify) && ud(), d;
  }
})();
var ng = !1;
(() => {
  let e = { version: () => wf(), setDeepCopy: (i, n) => (Fu(i, n), e), devContext: (i) => (Cu(i), ng = !0, e) };
  return r([cy]), e;
  function t(i, n) {
    let a = i({ ...n });
    return a != null && a.error || Mh(), ud(), ng && (Cu(!1), ng = !1), a;
  }
  function r(i) {
    i.forEach((n) => {
      Object.keys(n).forEach((a) => {
        e[a] = (o) => {
          if (ki()) {
            let s = t(n[a], o);
            return !(s != null && s.error) && (o != null && o.setState) && (s != null && s.tournamentRecord) && id(s.tournamentRecord), s;
          } else try {
            let s = t(n[a], o);
            return !(s != null && s.error) && (o != null && o.setState) && (s != null && s.tournamentRecord) && id(s.tournamentRecord), s;
          } catch (s) {
            let c;
            typeof s == "string" ? c = s.toUpperCase() : s instanceof Error && (c = s.message), console.log("ERROR", { params: JSON.stringify(o), method: a, error: c });
          }
        };
      });
    });
  }
})();
bC.importMethods(PP, !0, 1);
var Cq = { getTournamentPoints: Zm }, Fq = Cq, kq = { calculateNewRatings: n0, generateDynamicRatings: a0 }, Lq = kq, xq = { ...Fq, ...Lq };
bC.importMethods(xq);
var NC = {};
qe(NC, { activeMatchUpStatuses: () => Sv, auditConstants: () => Kj, completedMatchUpStatuses: () => lr, directingMatchUpStatuses: () => Db, displayConstants: () => Aj, drawDefinitionConstants: () => eb, entryStatusConstants: () => _v, errorConditionConstants: () => rk, eventConstants: () => rL, extensionConstants: () => mb, flightConstants: () => p_, genderConstants: () => HI, keyValueConstants: () => zG, matchUpActionConstants: () => aG, matchUpStatusConstants: () => Rb, matchUpTypes: () => wF, nonDirectingMatchUpStatuses: () => Pb, particicipantsRequiredMatchUpStatuses: () => Ab, participantConstants: () => KL, participantRoles: () => iU, participantTypes: () => Du, penaltyConstants: () => tH, policyConstants: () => EL, positionActionConstants: () => IV, ratingConstants: () => OV, recoveryTimeRequiredMatchUpStatuses: () => WL, requestConstants: () => eW, resourceContants: () => Xk, resultConstants: () => GF, scaleConstants: () => RL, scheduleConstants: () => bx, sortingConstants: () => S_, surfaceConstants: () => sH, tieFormatConstants: () => Qk, timeItemConstants: () => Px, topicConstants: () => HL, tournamentConstants: () => aC, upcomingMatchUpStatuses: () => wb, validMatchUpStatuses: () => Tb, venueConstants: () => dH, weekdayConstants: () => jE });
var Bq = "Coaching", Vq = "Ball Abuse", Gq = "Racket Abuse", jq = "Verbal Abuse", _q = "INELIGIBILITY", Wq = "Physical Abuse", qq = "Unsportmanlike Conduct", Hq = "Dress Code Violation", Yq = "Equipment Violation", zq = "Leaving the court", Kq = "Failure to complete", Xq = "No Show", Zq = "Other", Qq = "REFUSAL_TO_PLAY", Jq = "PROHIBITED_SUBSTANCE", $q = "Puncuality", eH = "Failure to sign in", tH = { COACHING: Bq, BALL_ABUSE: Vq, RACKET_ABUSE: Gq, VERBAL_ABUSE: jq, PHYSICAL_ABUSE: Wq, INELIGIBILITY: _q, UNSPORTSMANLIKE_CONDUCT: qq, PROHIBITED_SUBSTANCE: Jq, DRESS_CODE_VIOLATION: Hq, EQUIMENT_VIOLATION: Yq, LEAVING_THE_COURT: zq, REFUSAL_TO_PLAY: Qq, FAILURE_TO_COMPLETE: Kq, NO_SHOW: Xq, OTHER: Zq, PUNCTUALITY: $q, FAILUIRE_TO_SIGN_IN: eH }, rH = "CLAY", iH = "HARD", nH = "GRASS", aH = "CARPET", oH = "ARTIFICIAL", sH = { CLAY: rH, HARD: iH, GRASS: nH, CARPET: aH, ARTIFICIAL: oH }, cH = "INDOOR", uH = "OUTDOOR", dH = { INDOOR: cH, OUTDOOR: uH }, Si = lI();
const lH = /* @__PURE__ */ da(Si);
function pH(e) {
  return Si.forwardRef(e);
}
function fH(e) {
  return pH((t, r) => {
    const { as: i, ...n } = t;
    return /* @__PURE__ */ Ai.jsx(i || e, { ...n, ref: r });
  });
}
function mH({ styled: e = fH } = {}) {
  const t = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * @example
     * const Div = poly("div")
     * const WithPoly = poly(AnotherComponent)
     */
    apply(r, i, n) {
      return e(...n);
    },
    /**
     * @example
     * <poly.div />
     */
    get(r, i) {
      const n = i;
      return t.has(n) || t.set(n, e(n)), t.get(n);
    }
  });
}
function hH(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function gH(...e) {
  return (t) => e.forEach((r) => hH(r, t));
}
var Cy = Si.forwardRef((e, t) => {
  const { children: r, ...i } = e, n = Si.Children.toArray(r), a = n.find(vH);
  if (a) {
    const o = a.props.children, s = n.map((c) => c === a ? Si.Children.count(o) > 1 ? Si.Children.only(null) : Si.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ Ai.jsx(cI, { ...i, ref: t, children: Si.isValidElement(o) ? Si.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ Ai.jsx(cI, { ...i, ref: t, children: r });
});
Cy.displayName = "Slot";
var cI = Si.forwardRef((e, t) => {
  const { children: r, ...i } = e;
  if (Si.isValidElement(r)) {
    const n = SH(r);
    return Si.cloneElement(r, {
      ...UH(i, r.props),
      // @ts-ignore
      ref: t ? gH(t, n) : n
    });
  }
  return Si.Children.count(r) > 1 ? Si.Children.only(null) : null;
});
cI.displayName = "SlotClone";
var IH = ({ children: e }) => /* @__PURE__ */ Ai.jsx(Ai.Fragment, { children: e });
function vH(e) {
  return Si.isValidElement(e) && e.type === IH;
}
function UH(e, t) {
  const r = { ...t };
  for (const i in t) {
    const n = e[i], a = t[i];
    /^on[A-Z]/.test(i) ? n && a ? r[i] = (...o) => {
      a(...o), n(...o);
    } : n && (r[i] = n) : i === "style" ? r[i] = { ...n, ...a } : i === "className" && (r[i] = [n, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function SH(e) {
  var t, r;
  let i = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, n = i && "isReactWarning" in i && i.isReactWarning;
  return n ? e.ref : (i = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = i && "isReactWarning" in i && i.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function yH(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var MC = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (a = n(a, i(s)));
      }
      return a;
    }
    function i(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var s in a)
        t.call(a, s) && a[s] && (o = n(o, s));
      return o;
    }
    function n(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(MC);
var AH = MC.exports;
const ag = /* @__PURE__ */ yH(AH), lD = (e) => ({
  DIRECT_ACCEPTANCE: "DA",
  SPECIAL_EXEMPT: "SE",
  JUNIOR_EXEMPT: "JE",
  WILDCARD: "WC",
  ALTERNATE: "ALT",
  LUCKY_LOSER: "LL",
  QUALIFIER: "Q"
})[e];
mH({
  styled: (e) => (t) => {
    const r = t.asChild ? Cy : t.as || e;
    return /* @__PURE__ */ Ai.jsx(r, { ...t });
  }
});
var nr = "colors", qi = "sizes", Ce = "space", TH = { gap: Ce, gridGap: Ce, columnGap: Ce, gridColumnGap: Ce, rowGap: Ce, gridRowGap: Ce, inset: Ce, insetBlock: Ce, insetBlockEnd: Ce, insetBlockStart: Ce, insetInline: Ce, insetInlineEnd: Ce, insetInlineStart: Ce, margin: Ce, marginTop: Ce, marginRight: Ce, marginBottom: Ce, marginLeft: Ce, marginBlock: Ce, marginBlockEnd: Ce, marginBlockStart: Ce, marginInline: Ce, marginInlineEnd: Ce, marginInlineStart: Ce, padding: Ce, paddingTop: Ce, paddingRight: Ce, paddingBottom: Ce, paddingLeft: Ce, paddingBlock: Ce, paddingBlockEnd: Ce, paddingBlockStart: Ce, paddingInline: Ce, paddingInlineEnd: Ce, paddingInlineStart: Ce, top: Ce, right: Ce, bottom: Ce, left: Ce, scrollMargin: Ce, scrollMarginTop: Ce, scrollMarginRight: Ce, scrollMarginBottom: Ce, scrollMarginLeft: Ce, scrollMarginX: Ce, scrollMarginY: Ce, scrollMarginBlock: Ce, scrollMarginBlockEnd: Ce, scrollMarginBlockStart: Ce, scrollMarginInline: Ce, scrollMarginInlineEnd: Ce, scrollMarginInlineStart: Ce, scrollPadding: Ce, scrollPaddingTop: Ce, scrollPaddingRight: Ce, scrollPaddingBottom: Ce, scrollPaddingLeft: Ce, scrollPaddingX: Ce, scrollPaddingY: Ce, scrollPaddingBlock: Ce, scrollPaddingBlockEnd: Ce, scrollPaddingBlockStart: Ce, scrollPaddingInline: Ce, scrollPaddingInlineEnd: Ce, scrollPaddingInlineStart: Ce, fontSize: "fontSizes", background: nr, backgroundColor: nr, backgroundImage: nr, borderImage: nr, border: nr, borderBlock: nr, borderBlockEnd: nr, borderBlockStart: nr, borderBottom: nr, borderBottomColor: nr, borderColor: nr, borderInline: nr, borderInlineEnd: nr, borderInlineStart: nr, borderLeft: nr, borderLeftColor: nr, borderRight: nr, borderRightColor: nr, borderTop: nr, borderTopColor: nr, caretColor: nr, color: nr, columnRuleColor: nr, fill: nr, outline: nr, outlineColor: nr, stroke: nr, textDecorationColor: nr, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: qi, minBlockSize: qi, maxBlockSize: qi, inlineSize: qi, minInlineSize: qi, maxInlineSize: qi, width: qi, minWidth: qi, maxWidth: qi, height: qi, minHeight: qi, maxHeight: qi, flexBasis: qi, gridTemplateColumns: qi, gridTemplateRows: qi, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, DH = (e, t) => typeof t == "function" ? { "()": Function.prototype.toString.call(t) } : t, vl = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r, ...i) => {
    const n = ((a) => JSON.stringify(a, DH))(t);
    return n in e ? e[n] : e[n] = r(t, ...i);
  };
}, Jl = Symbol.for("sxs.internal"), Fy = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), pD = (e) => {
  for (const t in e) return !0;
  return !1;
}, { hasOwnProperty: PH } = Object.prototype, uI = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, (t) => "-" + t.toLowerCase()), wH = /\s+(?![^()]*\))/, ic = (e) => (t) => e(...typeof t == "string" ? String(t).split(wH) : [t]), fD = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), tabSize: (e) => ({ MozTabSize: e, tabSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: ic((e, t) => ({ marginBlockStart: e, marginBlockEnd: t || e })), marginInline: ic((e, t) => ({ marginInlineStart: e, marginInlineEnd: t || e })), maxSize: ic((e, t) => ({ maxBlockSize: e, maxInlineSize: t || e })), minSize: ic((e, t) => ({ minBlockSize: e, minInlineSize: t || e })), paddingBlock: ic((e, t) => ({ paddingBlockStart: e, paddingBlockEnd: t || e })), paddingInline: ic((e, t) => ({ paddingInlineStart: e, paddingInlineEnd: t || e })) }, og = /([\d.]+)([^]*)/, RH = (e, t) => e.length ? e.reduce((r, i) => (r.push(...t.map((n) => n.includes("&") ? n.replace(/&/g, /[ +>|~]/.test(i) && /&.*&/.test(n) ? `:is(${i})` : i) : i + " " + n)), r), []) : t, bH = (e, t) => e in NH && typeof t == "string" ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (r, i, n, a) => i + (n === "stretch" ? `-moz-available${a};${uI(e)}:${i}-webkit-fill-available` : `-moz-fit-content${a};${uI(e)}:${i}fit-content`) + a) : String(t), NH = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, to = (e) => e ? e + "-" : "", EC = (e, t, r) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (i, n, a, o, s) => o == "$" == !!a ? i : (n || o == "--" ? "calc(" : "") + "var(--" + (o === "$" ? to(t) + (s.includes("$") ? "" : to(r)) + s.replace(/\$/g, "-") : s) + ")" + (n || o == "--" ? "*" + (n || "") + (a || "1") + ")" : "")), MH = /\s*,\s*(?![^()]*\))/, EH = Object.prototype.toString, sc = (e, t, r, i, n) => {
  let a, o, s;
  const c = (u, d, l) => {
    let p, f;
    const m = (h) => {
      for (p in h) {
        const U = p.charCodeAt(0) === 64, v = U && Array.isArray(h[p]) ? h[p] : [h[p]];
        for (f of v) {
          const S = /[A-Z]/.test(I = p) ? I : I.replace(/-[^]/g, (A) => A[1].toUpperCase()), T = typeof f == "object" && f && f.toString === EH && (!i.utils[S] || !d.length);
          if (S in i.utils && !T) {
            const A = i.utils[S];
            if (A !== o) {
              o = A, m(A(f)), o = null;
              continue;
            }
          } else if (S in fD) {
            const A = fD[S];
            if (A !== s) {
              s = A, m(A(f)), s = null;
              continue;
            }
          }
          if (U && (g = p.slice(1) in i.media ? "@media " + i.media[p.slice(1)] : p, p = g.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (A, y, D, P, w, R) => {
            const b = og.test(y), E = 0.0625 * (b ? -1 : 1), [O, M] = b ? [P, y] : [y, P];
            return "(" + (D[0] === "=" ? "" : D[0] === ">" === b ? "max-" : "min-") + O + ":" + (D[0] !== "=" && D.length === 1 ? M.replace(og, (N, C, F) => Number(C) + E * (D === ">" ? 1 : -1) + F) : M) + (w ? ") and (" + (w[0] === ">" ? "min-" : "max-") + O + ":" + (w.length === 1 ? R.replace(og, (N, C, F) => Number(C) + E * (w === ">" ? -1 : 1) + F) : R) : "") + ")";
          })), T) {
            const A = U ? l.concat(p) : [...l], y = U ? [...d] : RH(d, p.split(MH));
            a !== void 0 && n(mD(...a)), a = void 0, c(f, y, A);
          } else a === void 0 && (a = [[], d, l]), p = U || p.charCodeAt(0) !== 36 ? p : `--${to(i.prefix)}${p.slice(1).replace(/\$/g, "-")}`, f = T ? f : typeof f == "number" ? f && S in OH ? String(f) + "px" : String(f) : EC(bH(S, f ?? ""), i.prefix, i.themeMap[S]), a[0].push(`${U ? `${p} ` : `${uI(p)}:`}${f}`);
        }
      }
      var g, I;
    };
    m(u), a !== void 0 && n(mD(...a)), a = void 0;
  };
  c(e, t, r);
}, mD = (e, t, r) => `${r.map((i) => `${i}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, OH = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, hD = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), ds = (e) => ((t) => {
  let r, i = "";
  for (r = Math.abs(t); r > 52; r = r / 52 | 0) i = hD(r % 52) + i;
  return hD(r % 52) + i;
})(((t, r) => {
  let i = r.length;
  for (; i; ) t = 33 * t ^ r.charCodeAt(--i);
  return t;
})(5381, JSON.stringify(e)) >>> 0), yu = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], CH = (e) => {
  if (e.href && !e.href.startsWith(location.origin)) return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, FH = (e) => {
  let t;
  const r = () => {
    const { cssRules: n } = t.sheet;
    return [].map.call(n, (a, o) => {
      const { cssText: s } = a;
      let c = "";
      if (s.startsWith("--sxs")) return "";
      if (n[o - 1] && (c = n[o - 1].cssText).startsWith("--sxs")) {
        if (!a.cssRules.length) return "";
        for (const u in t.rules) if (t.rules[u].group === a) return `--sxs{--sxs:${[...t.rules[u].cache].join(" ")}}${s}`;
        return a.cssRules.length ? `${c}${s}` : "";
      }
      return s;
    }).join("");
  }, i = () => {
    if (t) {
      const { rules: s, sheet: c } = t;
      if (!c.deleteRule) {
        for (; Object(Object(c.cssRules)[0]).type === 3; ) c.cssRules.splice(0, 1);
        c.cssRules = [];
      }
      for (const u in s) delete s[u];
    }
    const n = Object(e).styleSheets || [];
    for (const s of n) if (CH(s)) {
      for (let c = 0, u = s.cssRules; u[c]; ++c) {
        const d = Object(u[c]);
        if (d.type !== 1) continue;
        const l = Object(u[c + 1]);
        if (l.type !== 4) continue;
        ++c;
        const { cssText: p } = d;
        if (!p.startsWith("--sxs")) continue;
        const f = p.slice(14, -3).trim().split(/\s+/), m = yu[f[0]];
        m && (t || (t = { sheet: s, reset: i, rules: {}, toString: r }), t.rules[m] = { group: l, index: c, cache: new Set(f) });
      }
      if (t) break;
    }
    if (!t) {
      const s = (c, u) => ({ type: u, cssRules: [], insertRule(d, l) {
        this.cssRules.splice(l, 0, s(d, { import: 3, undefined: 1 }[(d.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return c === "@media{}" ? `@media{${[].map.call(this.cssRules, (d) => d.cssText).join("")}}` : c;
      } });
      t = { sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : s("", "text/css"), rules: {}, reset: i, toString: r };
    }
    const { sheet: a, rules: o } = t;
    for (let s = yu.length - 1; s >= 0; --s) {
      const c = yu[s];
      if (!o[c]) {
        const u = yu[s + 1], d = o[u] ? o[u].index : a.cssRules.length;
        a.insertRule("@media{}", d), a.insertRule(`--sxs{--sxs:${s}}`, d), o[c] = { group: a.cssRules[d + 1], index: d, cache: /* @__PURE__ */ new Set([s]) };
      }
      kH(o[c]);
    }
  };
  return i(), t;
}, kH = (e) => {
  const t = e.group;
  let r = t.cssRules.length;
  e.apply = (i) => {
    try {
      t.insertRule(i, r), ++r;
    } catch {
    }
  };
}, vu = Symbol(), LH = vl(), xH = (e, t) => LH(e, () => (...r) => {
  let i = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const n of r) if (n != null) if (n[Jl]) {
    i.type == null && (i.type = n[Jl].type);
    for (const a of n[Jl].composers) i.composers.add(a);
  } else n.constructor !== Object || n.$$typeof ? i.type == null && (i.type = n) : i.composers.add(BH(n, e));
  return i.type == null && (i.type = "span"), i.composers.size || i.composers.add(["PJLV", {}, [], [], {}, []]), VH(e, i, t);
}), BH = ({ variants: e, compoundVariants: t, defaultVariants: r, ...i }, n) => {
  const a = `${to(n.prefix)}c-${ds(i)}`, o = [], s = [], c = /* @__PURE__ */ Object.create(null), u = [];
  for (const p in r) c[p] = String(r[p]);
  if (typeof e == "object" && e) for (const p in e) {
    d = c, l = p, PH.call(d, l) || (c[p] = "undefined");
    const f = e[p];
    for (const m in f) {
      const h = { [p]: String(m) };
      String(m) === "undefined" && u.push(p);
      const g = f[m], I = [h, g, !pD(g)];
      o.push(I);
    }
  }
  var d, l;
  if (typeof t == "object" && t) for (const p of t) {
    let { css: f, ...m } = p;
    f = typeof f == "object" && f || {};
    for (const g in m) m[g] = String(m[g]);
    const h = [m, f, !pD(f)];
    s.push(h);
  }
  return [a, i, o, s, c, u];
}, VH = (e, t, r) => {
  const [i, n, a, o] = GH(t.composers), s = typeof t.type == "function" || t.type.$$typeof ? ((l) => {
    function p() {
      for (let f = 0; f < p[vu].length; f++) {
        const [m, h] = p[vu][f];
        l.rules[m].apply(h);
      }
      return p[vu] = [], null;
    }
    return p[vu] = [], p.rules = {}, yu.forEach((f) => p.rules[f] = { apply: (m) => p[vu].push([f, m]) }), p;
  })(r) : null, c = (s || r).rules, u = `.${i}${n.length > 1 ? `:where(.${n.slice(1).join(".")})` : ""}`, d = (l) => {
    l = typeof l == "object" && l || jH;
    const { css: p, ...f } = l, m = {};
    for (const I in a) if (delete f[I], I in l) {
      let U = l[I];
      typeof U == "object" && U ? m[I] = { "@initial": a[I], ...U } : (U = String(U), m[I] = U !== "undefined" || o.has(I) ? U : a[I]);
    } else m[I] = a[I];
    const h = /* @__PURE__ */ new Set([...n]);
    for (const [I, U, v, S] of t.composers) {
      r.rules.styled.cache.has(I) || (r.rules.styled.cache.add(I), sc(U, [`.${I}`], [], e, (y) => {
        c.styled.apply(y);
      }));
      const T = gD(v, m, e.media), A = gD(S, m, e.media, !0);
      for (const y of T) if (y !== void 0) for (const [D, P, w] of y) {
        const R = `${I}-${ds(P)}-${D}`;
        h.add(R);
        const b = (w ? r.rules.resonevar : r.rules.onevar).cache, E = w ? c.resonevar : c.onevar;
        b.has(R) || (b.add(R), sc(P, [`.${R}`], [], e, (O) => {
          E.apply(O);
        }));
      }
      for (const y of A) if (y !== void 0) for (const [D, P] of y) {
        const w = `${I}-${ds(P)}-${D}`;
        h.add(w), r.rules.allvar.cache.has(w) || (r.rules.allvar.cache.add(w), sc(P, [`.${w}`], [], e, (R) => {
          c.allvar.apply(R);
        }));
      }
    }
    if (typeof p == "object" && p) {
      const I = `${i}-i${ds(p)}-css`;
      h.add(I), r.rules.inline.cache.has(I) || (r.rules.inline.cache.add(I), sc(p, [`.${I}`], [], e, (U) => {
        c.inline.apply(U);
      }));
    }
    for (const I of String(l.className || "").trim().split(/\s+/)) I && h.add(I);
    const g = f.className = [...h].join(" ");
    return { type: t.type, className: g, selector: u, props: f, toString: () => g, deferredInjector: s };
  };
  return Fy(d, { className: i, selector: u, [Jl]: t, toString: () => (r.rules.styled.cache.has(i) || d(), i) });
}, GH = (e) => {
  let t = "";
  const r = [], i = {}, n = [];
  for (const [a, , , , o, s] of e) {
    t === "" && (t = a), r.push(a), n.push(...s);
    for (const c in o) {
      const u = o[c];
      (i[c] === void 0 || u !== "undefined" || s.includes(u)) && (i[c] = u);
    }
  }
  return [t, r, i, new Set(n)];
}, gD = (e, t, r, i) => {
  const n = [];
  e: for (let [a, o, s] of e) {
    if (s) continue;
    let c, u = 0, d = !1;
    for (c in a) {
      const l = a[c];
      let p = t[c];
      if (p !== l) {
        if (typeof p != "object" || !p) continue e;
        {
          let f, m, h = 0;
          for (const g in p) {
            if (l === String(p[g])) {
              if (g !== "@initial") {
                const I = g.slice(1);
                (m = m || []).push(I in r ? r[I] : g.replace(/^@media ?/, "")), d = !0;
              }
              u += h, f = !0;
            }
            ++h;
          }
          if (m && m.length && (o = { ["@media " + m.join(", ")]: o }), !f) continue e;
        }
      }
    }
    (n[u] = n[u] || []).push([i ? "cv" : `${c}-${a[c]}`, o, d]);
  }
  return n;
}, jH = {}, _H = vl(), WH = (e, t) => _H(e, () => (...r) => {
  const i = () => {
    for (let n of r) {
      n = typeof n == "object" && n || {};
      let a = ds(n);
      if (!t.rules.global.cache.has(a)) {
        if (t.rules.global.cache.add(a), "@import" in n) {
          let o = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
          for (let s of [].concat(n["@import"])) s = s.includes('"') || s.includes("'") ? s : `"${s}"`, t.sheet.insertRule(`@import ${s};`, o++);
          delete n["@import"];
        }
        sc(n, [], [], e, (o) => {
          t.rules.global.apply(o);
        });
      }
    }
    return "";
  };
  return Fy(i, { toString: i });
}), qH = vl(), HH = (e, t) => qH(e, () => (r) => {
  const i = `${to(e.prefix)}k-${ds(r)}`, n = () => {
    if (!t.rules.global.cache.has(i)) {
      t.rules.global.cache.add(i);
      const a = [];
      sc(r, [], [], e, (s) => a.push(s));
      const o = `@keyframes ${i}{${a.join("")}}`;
      t.rules.global.apply(o);
    }
    return i;
  };
  return Fy(n, { get name() {
    return n();
  }, toString: n });
}), YH = class {
  constructor(e, t, r, i) {
    this.token = e == null ? "" : String(e), this.value = t == null ? "" : String(t), this.scale = r == null ? "" : String(r), this.prefix = i == null ? "" : String(i);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + to(this.prefix) + to(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, zH = vl(), KH = (e, t) => zH(e, () => (r, i) => {
  i = typeof r == "object" && r || Object(i);
  const n = `.${r = (r = typeof r == "string" ? r : "") || `${to(e.prefix)}t-${ds(i)}`}`, a = {}, o = [];
  for (const c in i) {
    a[c] = {};
    for (const u in i[c]) {
      const d = `--${to(e.prefix)}${c}-${u}`, l = EC(String(i[c][u]), e.prefix, c);
      a[c][u] = new YH(u, l, c, e.prefix), o.push(`${d}:${l}`);
    }
  }
  const s = () => {
    if (o.length && !t.rules.themed.cache.has(r)) {
      t.rules.themed.cache.add(r);
      const c = `${i === e.theme ? ":root," : ""}.${r}{${o.join(";")}}`;
      t.rules.themed.apply(c);
    }
    return r;
  };
  return { ...a, get className() {
    return s();
  }, selector: n, toString: s };
}), XH = vl(), ZH = (e) => {
  let t = !1;
  const r = XH(e, (i) => {
    t = !0;
    const n = "prefix" in (i = typeof i == "object" && i || {}) ? String(i.prefix) : "", a = typeof i.media == "object" && i.media || {}, o = typeof i.root == "object" ? i.root || null : globalThis.document || null, s = typeof i.theme == "object" && i.theme || {}, c = { prefix: n, media: a, theme: s, themeMap: typeof i.themeMap == "object" && i.themeMap || { ...TH }, utils: typeof i.utils == "object" && i.utils || {} }, u = FH(o), d = { css: xH(c, u), globalCss: WH(c, u), keyframes: HH(c, u), createTheme: KH(c, u), reset() {
      u.reset(), d.theme.toString();
    }, theme: {}, sheet: u, config: c, prefix: n, getCssText: u.toString, toString: u.toString };
    return String(d.theme = d.createTheme(s)), d;
  });
  return t || r.reset(), r;
};
const QH = (e) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), JH = ({
  numberOfLines: e,
  textOverflow: t = "ellipsis"
}) => ({
  "@supports(-webkit-box-orient: vertical)": {
    display: "-webkit-box",
    "-webkit-line-clamp": e,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    textOverflow: t
  }
}), $H = ({
  color: e = "$coreGreys100",
  fontSize: t = "$medium"
}) => ({
  textDecoration: "none",
  outLine: "none",
  fontStyle: "normal",
  fontFamily: "$default",
  fontSize: t,
  color: e,
  "-webkit-tap-highlight-color": "transparent"
}), eY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cutText: JH,
  flexCenter: QH,
  normalizeLink: $H
}, Symbol.toStringTag, { value: "Module" })), Mu = {
  utils: eY,
  media: {
    xs: "(min-width: 300px)",
    sm: "(min-width: 600px)",
    md: "(min-width: 900px)",
    lg: "(min-width: 1200px)",
    xl: "(min-width: 1536px)"
  },
  theme: {
    sizes: {
      sm: "4px",
      md: "8px",
      lg: "12px",
      xl: "20px"
    },
    colors: {
      // Clubspark/Draws specific tokens
      csHiContrast: "hsl(206,10%,5%)",
      csLoContrast: "white",
      csBackground: "#fff",
      csGray100: "hsl(206,22%,99%)",
      csGray200: "hsl(206,12%,97%)",
      csGray300: "hsl(206,11%,92%)",
      csGray400: "hsl(206,10%,84%)",
      csGray500: "hsl(206,10%,76%)",
      csGray550: "hsl(206,10%,60%)",
      csGray600: "hsl(206,10%,44%)",
      csLightGrey: "hsl(0,0%,94%)",
      csDarkGrey: "hsl(0,0%,40%)",
      csLightGreen: "#c3ed44",
      csHeaderText: "#323232",
      csHeaderTextGreen: "#0A8A11",
      csBlueHighlight: "#C6DDF5",
      csLighterBlueHighlight: "#D9E9F8",
      csDarkBlue: "rgb(7,20,64)",
      csMidBlue: "#005595",
      csFocusHighlight: "#155493",
      csHoverHighlight: "#155493",
      csRoundHeader: "#06143f",
      // Generic theme tokens (the generic theme was based on ITF/WTN but should now represent the clubspark default.)
      primary200: "#001870",
      primary150: "#001e8c",
      primary100main: "#0026af",
      primary70: "#4d67c7",
      primary50: "#8092d7",
      primary30: "#b3bee7",
      primary20: "#ccd4ef",
      primary10: "#e6e9f7",
      primary5: "#f2f4fb",
      secondary200: "#0a0f1f",
      secondary150: "#0d1327",
      secondary100main: "#101831",
      secondary70: "#585d6f",
      secondary50: "#878b98",
      secondary30: "#b7bac1",
      secondary20: "#cfd1d6",
      secondary10: "#e7e8ea",
      secondary5: "#f3f3f5",
      accent1200: "#028d4a",
      accent1150: "#02b760",
      accent1100main: "#02e075",
      accent170: "#4ee99e",
      accent150: "#80efba",
      accent130: "#b4f6d6",
      accent120: "#ccf9e3",
      accent110: "#e6fcf1",
      accent15: "#f2fdf8",
      navHighlight100: "#63FFB4",
      coreGreys150: "#272f45",
      coreGreys100main: "#323950",
      coreGreys70: "#707485",
      coreGreys50: "#989ca7",
      coreGreys20: "#d5d7de",
      coreGreys10: "#e3e5eb",
      coreGreys5: "#f4f5f8",
      success200: "#066d62",
      success150: "#00806b",
      success100: "#169e8f",
      success70: "#5cbbb1",
      success50: "#8acec7",
      success30: "#b9e2dd",
      success20: "#d0ece9",
      success10: "#e8f5f4",
      success5: "#f3faf9",
      pending200: "#dc972f",
      pending150: "#eab565",
      pending100: "#ffd177",
      pending70: "#ffdfa0",
      pending50: "#fcdea4",
      pending30: "#fff1d6",
      pending20: "#fff6e4",
      pending10: "#fffaf1",
      pending5: "#fffdf8",
      warning200: "#873100",
      warning150: "#b44200",
      warning100: "#dc5100",
      warning70: "#e6854d",
      warning50: "#eda880",
      warning30: "#f4cbb3",
      warning20: "#f8dccc",
      warning10: "#fbeee6",
      warning5: "#fdf6f2",
      destructive200: "#ad2f3e",
      destructive150: "#c21a2d",
      destructive100main: "#d42f42",
      destructive70: "#e16d7b",
      destructive50: "#e997a0",
      destructive30: "#f2c1c6",
      destructive20: "#f6d5d9",
      destructive10: "#fbeaec",
      destructive5: "#fdf5f6",
      highlight200: "#5d20c2",
      highlight150: "#6c46d8",
      highlight100: "#6e56f2",
      highlight70: "#9989f6",
      highlight50: "#b6aaf8",
      highlight30: "#d3ccfb",
      highlight20: "#e2ddfc",
      highlight10: "#f0eefe",
      highlight5: "#f8f7fe",
      highlightTwo200: "#002e8f",
      highlightTwo100: "#004dee",
      highlightTwo50: "#80a6f6",
      highlightTwo10: "#e6edfd",
      highlightTwo5: "#f2f6fe",
      lightBg100Main: "#fff",
      lightBg70: "rgba(255, 255, 255, 0.7)",
      lightBg50: "rgba(255, 255, 255, 0.5)",
      lightBg20: "rgba(255, 255, 255, 0.2)",
      lightBg10: "rgba(255, 255, 255, 0.1)",
      lightBg5: "rgba(255, 255, 255, 0.05)",
      darkBg100Main: "#272f45",
      darkBg70: "rgba(39, 47, 69, 0.7)",
      darkBg50: "rgba(39, 47, 69, 0.5)",
      darkBg20: "rgba(39, 47, 69, 0.2)",
      darkBg10: "rgba(39, 47, 69, 0.1)",
      darkBg5: "rgba(39, 47, 69, 0.05)",
      brightGreen100: "#6fbd57",
      genericWhite: "#fff",
      genericBlack: "#000",
      coreGreys100: "#323950",
      navHighlight100Main: "#F4F6F8",
      coreGreys15020: "rgba(39, 47, 69, 0.2)",
      pendingTwo30: "rgba(221, 157, 59, 0.3)",
      wtnRed: "#dc3741",
      marineBlue: "#003a70",
      primaryActive100: "$primary100main",
      headerGradientBg: "$primary100main",
      dialogShadow: "rgba(51, 51, 51, 0.15)",
      dialogOverlay: "rgba(0, 0, 0, 0.3)"
    },
    shadows: {
      darkBgTwo120: "rgba(0, 0, 0, 0.12)",
      shadowXS: "0 1px 3px 0 rgba(20, 29, 55, 0.1)",
      shadowSM: "0 2px 4px 0 rgba(20, 29, 55, 0.08)",
      shadowMD: "0 3px 8px 0 rgba(20, 29, 55, 0.08)",
      shadowLG: "0 5px 15px 0 rgba(20, 29, 55, 0.08)",
      shadowXL: "0 7px 18px 0 rgba(20, 29, 55, 0.08)",
      shadowXXL: "0 10px 30px 0 rgba(20, 29, 55, 0.08)"
    },
    fontSizes: {
      default: "initial",
      xsmall10: "0.625rem",
      xsmall: "0.6875rem",
      small: "0.75rem",
      semiMedium: "0.8125rem",
      medium: "0.875rem",
      medium15: "0.9375rem",
      large: "1rem",
      large18: "1.125rem",
      large20: "1.25rem",
      xlarge: "1.5rem",
      xlarge32: "2rem",
      xlarge44: "2.75rem",
      xlarge56: "3.5rem"
    },
    fontWeights: {
      default: "initial",
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    },
    lineHeights: {
      default: "initial",
      1: 1,
      2: 1.1,
      3: 1.2,
      4: 1.3,
      5: 1.4,
      6: 1.5,
      7: 1.6
    },
    letterSpacings: {
      default: "initial"
    },
    fonts: {
      default: "'DM Sans', sans-serif",
      clubspark: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    },
    transitions: {
      default: "250ms"
    },
    csBracket: {
      gap: "2.5rem",
      gapHalf: "calc($gap / 2)",
      lineWidth: "1px",
      radius: "0.25rem",
      lineColor: "#ccc",
      highlightLineColor: "$colors$csHiContrast"
    },
    csMatch: {
      headerHeight: "2.1rem",
      gap: "0.5rem",
      radius: "0.375rem",
      borderColor: "#e4e4e4"
    },
    space: {
      xxs: "2px",
      xs: "4px",
      sm: "5px",
      md: "12px",
      lg: "20px",
      xl: "25px"
    },
    radii: {
      none: 0,
      xs: "0.125rem",
      sm: "0.25rem",
      md: "0.5rem",
      lg: "1rem",
      xl: "2rem",
      circle: "50%"
    }
  }
}, {
  config: n5,
  createTheme: Ul,
  css: ls,
  keyframes: a5,
  theme: o5,
  globalCss: tY,
  getCssText: s5
} = ZH(Mu);
Ul("light-theme");
Ul("clubspark-light-theme", {
  ...Mu.theme,
  fonts: {
    ...Mu.theme.fonts,
    default: Mu.theme.fonts.clubspark
  }
});
Ul("dark-theme", {
  colors: {
    csHiContrast: "hsl(206,2%,93%)",
    csLoContrast: "hsl(206,8%,8%)",
    csBackground: "#333",
    csGray100: "hsl(206,8%,12%)",
    csGray200: "hsl(206,7%,14%)",
    csGray300: "hsl(206,7%,15%)",
    csGray400: "hsl(206,7%,24%)",
    csGray500: "hsl(206,7%,30%)",
    csGray600: "hsl(206,5%,53%)",
    csLightGrey: "hsl(206,7%,15%)",
    csDarkGrey: "hsl(206,5%,53%)",
    csHeaderBg: "#323232",
    csHeaderText: "#f4f4f4",
    csBlueHighlight: "#287CAD",
    csLighterBlueHighlight: "#004c64"
  },
  csBracket: {
    lineColor: "#1f1f1f",
    highlightLineColor: "$colors$csHiContrast"
  },
  csMatch: {
    borderColor: "#1f1f1f"
  },
  space: {},
  fonts: {}
});
const rY = {
  ...Mu.theme,
  colors: {
    primary200: "#004CA3",
    primary150: "#025CC2",
    primary100main: "#0367DB",
    primary70: "#0373F3",
    primary50: "#5BA4F7",
    primary30: "#B3D5FB",
    primary20: "#CCE3FC",
    primary10: "#E6F1FE",
    primary5: "#F2F8FE",
    secondary200: "#000A20",
    secondary150: "#0A173E",
    secondary100main: "#00143F",
    secondary70: "#5C6582",
    secondary50: "#8A91A5",
    secondary30: "#B9BDC9",
    secondary20: "#D0D3DB",
    secondary10: "#E8E9ED",
    secondary5: "#F3F4F6",
    accent1200: "#C15642",
    accent1150: "#E08E41",
    accent1100main: "#F0AA54",
    accent170: "#F4C387",
    accent150: "#F7D4A9",
    accent130: "#FAE5CC",
    accent120: "#FCEEDD",
    accent110: "#FDF6EE",
    accent15: "#FEFBF6",
    primaryActive100: "$primary100main",
    headerGradientBg: "$primary100main"
  },
  fonts: {
    default: "Inter, sans-serif"
  },
  radii: {
    sm: "5px"
  }
};
Ul("usta-light-theme", rY);
const iY = {
  colors: {
    primary200: "#002950",
    primary150: "#004586",
    primary100main: "#0054a3",
    primary70: "#4d87be",
    primary50: "#80a9d0",
    primary30: "#b3cce3",
    primary20: "#ccdded",
    primary10: "#e6eef6",
    primary5: "#f2f6fa",
    accent1200: "#8b050d",
    accent1150: "#bf222c",
    accent1100main: "#dc3741",
    accent170: "#e6737a",
    accent150: "#ed9ba0",
    accent130: "#f4c3c6",
    accent120: "#f8d7d9",
    accent110: "#fbebec",
    accent15: "#fdf5f6",
    navHighlight100: "#5ec5ff",
    primaryActive100: "$wtnRed",
    headerGradientBg: "linear-gradient(268.69deg, $wtnRed -14.8%, $marineBlue 112.85%)"
  },
  fonts: {
    default: "Poppins, sans-serif"
  }
};
Ul("itf-light-theme", iY);
const nY = lH.memo((e) => /* @__PURE__ */ Ai.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ Ai.jsx("path", { d: "M11.251.976a1.29 1.29 0 0 0 2.178.584 1.29 1.29 0 0 1 2.166 1.251 1.289 1.289 0 0 0 1.594 1.594 1.29 1.29 0 0 1 1.251 2.167 1.29 1.29 0 0 0 .583 2.177 1.29 1.29 0 0 1 0 2.502 1.29 1.29 0 0 0-.583 2.177 1.29 1.29 0 0 1-1.25 2.167 1.29 1.29 0 0 0-1.595 1.594 1.29 1.29 0 0 1-2.166 1.25 1.29 1.29 0 0 0-2.178.585 1.288 1.288 0 0 1-2.502 0 1.289 1.289 0 0 0-2.178-.584 1.29 1.29 0 0 1-2.166-1.251 1.29 1.29 0 0 0-1.594-1.594 1.29 1.29 0 0 1-1.251-2.167 1.29 1.29 0 0 0-.584-2.177 1.29 1.29 0 0 1 0-2.502 1.29 1.29 0 0 0 .584-2.177 1.29 1.29 0 0 1 1.25-2.167 1.29 1.29 0 0 0 1.595-1.594 1.29 1.29 0 0 1 2.166-1.25A1.29 1.29 0 0 0 8.75.975a1.29 1.29 0 0 1 2.502 0z" }),
  /* @__PURE__ */ Ai.jsx("path", { d: "m13.912 7.5-5.09 4.75-2.405-2.406", stroke: "#fff", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })
] })), aY = ls({
  fontFamily: "Poppins",
  fontWeight: 600,
  background: "-webkit-linear-gradient(90deg, #16234c, #e03e52 80%)",
  backgroundClip: "border-box",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent"
}), oY = ls({
  fontSize: "75%"
}), sY = ls({
  verticalAlign: "top"
}), cY = "data:font/woff;base64,d09GRgABAAAAACiIAAwAAAAAPuQAAQABAAAAAAAAAAAAAAAAAAAAAAAAAABHUE9TAAABHAAAAB4AAAAeRHRMdUdTVUIAAAE8AAAALAAAAC4fQCdhT1MvMgAAAWgAAABOAAAAYFpPoAtjbWFwAAABuAAAAJMAAADUsrLTCGdseWYAAAJMAAAfwgAAMyR322GTaGVhZAAAIhAAAAA2AAAANhqoJGdoaGVhAAAiSAAAAB8AAAAkDFQCqGhtdHgAACJoAAACDQAAA2jjqSkCbG9jYQAAJHgAAAGmAAABtu3m4gFtYXhwAAAmIAAAACAAAAAgAVwBJm5hbWUAACZAAAAA3QAAAcgjIkFscG9zdAAAJyAAAAFnAAACC6ldc5YAAQAAAAoAHAAcAAFERkxUAAgABAAAAAD//wAAAAAAAHjaY2BkYGDgYtABQmYXN58QBomU1DIjBhEgmcggwgACLCDi/38QCQCN4gbkeNpjYGGOZvzCwMrAwNTFFMHAwOANoRnjGIwYvRiAgI0BDtgZkIBniJs/wwEGBiVRFql/ixhSWPKZihUYGCaD5JjUmXYCKQUGFgAHEwtLAAB42mNgYGACYmYgFgGSjGCaheEAkNZhUACyeIAsXoY6hv+MhozBTHuYjjHdYrqjIKIgpSCnoKSgpmCl4KKwRlFJSUhJ9P9/BhDgBepbAFQdBFctrCChIANWbYmimvH/1/+P/x/6P/F/4T/Ofwx/3/5982Dbg80PNj1Y/2DNg1kPJj7Qur/13rF7R4DuIgEAALYaNRgAeNqVegVgG0fW8MzItgwhgyw7Rlm2ZZAsWSuwLMmyZGZmxsSuUY4dbKi5tKGGytwkV8g1x3ehcps01Cv3Lx80lzLT37RafW9W642c5MjJrnbfzr55PG/eW+SL4A9/Sx5FIuSHAtA8tBChYFmwDMukIqMCB4tDFWL8LTsPH2AfOXjq4EG86+D2gwfJo658stXNvup2swSz3AUiqNn9I/qIHEYiiiVUJBeFJOt1BkYbLgnzk781v2u+LC0tLjYtLZYcZqPwP12OtLi4NHrAuwmkGseLYuBdMbwrlisYOLbMq5zPwiGKeR7+YFQcQiIlOY+i6BUWMxK5WG7kDj3DHYyYOyQyuZghe5I23Z4ymvIsHHf+NumO3yhGFc/C8Qv2x2eTnsVnDvUfhb/+Q/1/hr/+Q4AaWdwPk3jRIpSI0pEWoUQ/P7FErk9O1jPh4VJ9BgF2jHpGAjfy5GSFJJZIEMD9/CQhBr0OACQ+s8tu71y2SqRMzas3L+u0N18jXiVKk+fVZ7O7MlXpzFltpuqmZotfTU1Afy0w+U6wvNxRNxpQU+PfVReXGfDGInmZA8/PWHDGV6dk+0wpKaoFZ0FPae5vyJfkBAoC2UYAfUqEQmZFm5CsT8Jy7CMJY7RAhxx5PTBQIMDSGvLyGuhBetnJCbyTXWKLldmQuyHP0dDgyGtottlsxFlXV1JSX1+y01VMjmQ1NaermtgWHtZE/xAiSA6U/EieQ8koAyGZwo9OQ/Vs5M506nCx3JAsT/CThIVLpaAOsTTRqKB3DOlv1M6UlDpzamtiItTN2ea6VB8nTpbJUuMUR4pWt0Y+zG4sPjJTbmnUZup6cosnZXJrUkZxmqpSk5SqiI7Spx2eviP1ofqKo+oupgAhTO0GbeHshrOaLby1wJM17kL8kugBaovhoLgQIyPxI5KwEKlE/s+hybGZqWUjS2baccIDB3FGb9Aw+8bdt7IXhoPgzSh4c8LzplRvCNHriAIMIEQSRsTqJSPLpmbGJod6jwUN48W33o1ThoN62ZcPPsC+10npseGl+E/kbygYbqRiqVghlRvFCqPCKAVl4xtUW7ZkOCXtoU7NDTdkTId1hJMHqxmmtnX37vYGJrO2dc8ewDGIhkk/WQq6RlgO9geGDUYHwjszfAb+Y9MLL3S/8AKdzdc9jU6hLZR7o0geempladEW9lMchsAfm3A2/hrfgQh6A9GxGvDOp9A2ijXcyy9beZ8UC84IY63uGvyY6LcULwbLwo+xX07ghaLf/nS/Txe1AQsiJJ9cAFxRc+0wMZkqnuo6HGzRoLdM79w5TQ98myTXZsuVhNltNnsYkT/zzKHfnDjxm5qJoqKJmnpnYaGzHuZVAaUu8iaNS6F6JlgerHpxikwudSnIJDzVokASST5Ei4HbHFApnQpMjZ/eTyyWSWT61d3jpSar2U7GRNcNjK4uGahUYSu7+M66a5ZlW/LLbM6VK/qLfzFUkNJV55HKzyScfIzSeT4oJrGE+6EMKRiOEToXaMFgmJ0097rBwkGdI8PsMAyXjmzzHfMptVkdLe2Lo2oackxZOX7jZONSbaMhp3mhT0hXqbldP75Un5enLzR3Yl2WxmSiMQ/8hwyQF1Egmg8c6TETzEiovkNFTAau3trRMeH76ae3NeJ/sOl9t92Gn2XvpRSXIgSyfxvFw41MwnF/JbUckcEyEsL+TlKnrh9SmSZrRzfNHw8qNxUVFRdm5i0cwUfI8ueik4vHrKVTjpEWtbGxqLgiMw3/EhF+jk9A0smgEQ7bnImS9YtkWgiCnKb5GfHRbF1VJVncn+0YMBlHypdMqzHpnwoc+nNDVZGtpKiAdGas3K7UmEbKCsdsbQ+swWMjVYdKCgpqKu35NZSzFJg1kLyO/DxWJ9PLSCD78RSOZG/E/yAbXOvIdA+N0lb358RBLnDUaUFvYMyC6rizEJISKek8id60VhlGKitGDSa1yeGYKSubdjiycFCh1VJYYjKVnqirLsivqnHg300YWvX6VkNWg1TSlWvvNxj6IbhL/mKxmLS2XO0pu9VUVJxlcVCPqECYZIMdcRIzcPMIZDBaQUGCCVFaXnVkFTkimhj7sHXD5A1T6cOd1ywTDx0vKLGBuIpv0k1cn5CkHyobu+5PxzccqJ9oOFiWU1BRlWutcrs93kzUKIFGGiSmZ3wA4PEQEd4HuAIg4fgAULYwisq2F23Gb5By6llJCojJUlx84cKuDz7Y/D78waiV6BTZQYI86y8GP/KFg+xwfUrC4Ajq7n6/u5vimQA8Fzx4QhkprLwTuygeUk7RAJ4U94/4A/IUkiI50MWFBQjLglFK5FRXxCv+4JHV64d9+nxlPUusBkPONYaBvK7ZNOGpiZ6Bwaq7dSV6S7bO0qlzZXllDIVuveg42YxMqIjOJIiYO3tMAhYfEa91fn7PnVHKq4bSMucRefyBJuOSQiZbHNfJVDTZnEVN8oA+rUgSlWyIumnHzPHh23Z0FS1smxw90PqLT28uL0jRa9Lt8gw12Vx/a3/1nnZVakpGR3X5piqzlv2HZNHixWVjunWbJ55dsX6zvFxRe2v/zk+3uM5m1mRorPr6DLWRyiwBTreRIyD5QNCOTCwPZULlCpEIf86+q13+46YfV9ROOm+8kRxxFX+C89jHqA+UwTsFkGstQpH0feRhHzI33g+SZqNWiOdHwuAfKo1LC9iPcUDRoC7XwLI7smy2rB2vOgqzb7kDt/Xm6BsyyWFNjdZSHZrBaNR6VpSlZSxvUq0nuS+Ss+RJFEOjJNWcVD4n0BsZ3tiTuvb3jB9SbInqthWMWK0jBbbuqC2KQ+O9+7rwM/vaRvuNhpxlFRXLbAZj/0jbvkFEOE7uBU4CUeglPcqDGY5weoHvfrCt7cHx999ftXHjqslJcrjh3uHhu+rIYdcDm1asvIGlixTFgs+CDIPALiU0jMokIAzJY19+iRew6/F60nau47UOcqSDH3seZgzgLJ2OhpUGn2ffvHDBSQ53PN/BvghPPVz/DbiWwbi57EJokiwggg2BPIhDYLlj2Xz2J7wuqOPmNmDbIxD8hU6f4ywrm8pZ2tLWUnNDDfA+SOXB005mYEagHQMlMjgYOJMZJ3vU6cRFwGkJ1lCi2NdxGv8GeozLtFEojH7MSYdwNCvB/07C1UKKy7Mm84tCMD452d4+OYVVSmUGoArqGBnpyDAYVfg7noYuTgtIhjkCMIMxPsN+AxQs2Mm+DLdG9jS89wy2sgfYX/JyfAjegVhgZEDczGOfsPud7e0A8jwVKeBynocr2A5QtKGhIoXz1arXnKu//Ybj6x02kR5w/Vcim5XGZnKEakcm50jBwQzZ7GQfBkqanETs+hE84SLxQwQ09CP5BDS0kO4HfARteGyIpgheasOK/VQZvfs7O/f3ejTlOYvb9lNdUI3sb+uzTYN55lAjnbbx1pnJcREGMges1Fa4KfzAPqlfkUztWONa55fV48Y/5W5Yuxb/odPMXiCHjZ3Zk2aD833E0bmRfA90htKo6KvgfMV71ZIiT74kEEwGVqkMPbME15U86Dog0AvntZvmC0R336n+Hb5x2iYQzlNtAaoXIClIUSTQDFOF4tnIgP94XxNHdlXtI+yGtbn2XPtaHM5+TA5ndWbnj4exf8OTuQaDFWGUDXKOB/qVNHcULAqIVdA9kXdEoKKWxhJOAR9P5K7ysZnMjlSrIb/BYhkpGtggXityGDJzFBZdQZPVNFoqzmy1qLJNKrkyYkFIUqXd0qoZaE42aNXxqRELQpOrHPpOE7UKBXA0DzjiVifKj1xP5h11HgN/dT1AWju4zAioHIIxodQrPGs92PFsOhD8aF1pWZ2zdE1Z2episOOCqurqKnycLWqYyc6eacBHEaZvkn2Agc9AwFrJPvanTezFVX95weNirseJA9GRbrfoVd66wbRFYhEMptb96l827Llz/YmVu+5av3s3984C19cYLPYMMbieJwyXxyLSx/s7BHqI9yIGliq89Y31d+9d98ab6++5aR1uY3/588+4DbezLAyj/kwq4R1/Oh/kiHQ6UnnB+cG6+++nzMDY4+yvcAPy4Mc/e+KbkabEmIaro7ByGLCDfRyf6etrwT/1tcDIm2Cn0y96YFaqDBy4f2DgRdEDnT93dPlwK/4Bdw3J9ewFfGlMeJF9dQIrf+PT9dP98HQ9YKj2YPCVQ8oOB65+EVAc6xLt53ZEieghcg05QmVq5FY20R0zn418vvyRh8gi15d4Mx2z1j1GHnG/Qefg8o5HXC+nDA/TJ4GkEn0giuYinUSh/+Bdsq9+tMfjUz+QNqJBIShBWJU4Ajh9X7kVSSpYXmzviZmaiunPLZopwM+oy5XKcrW6Ih3OeGh9EZNc7XqzVqErua7OWK9MrzOZGlXKBhOdqwzmWk/Oz87lnXJTsQX7XDbXWwM5JTP5+cuLc/tiIGpVqSuU6RXcVBVq7GIKN9TVXVeiVVST8+xXm+vSlfUmU4NS1chZOuUrE/haPHet5TMXYaEtWFXVf5109UKHtrCurrAvfnXEpt6qVQV4aENhV3NqRl9LS39TfV/RhoZLsjo/R1bB/15WJYahuKmp6L7c4uVXkZVagQNd0XUplwuLnysf6JeiWJqZysIFsr1inoKbUEzyfdg23+bc9uTVkdf1VF1bVHBtTeWq/OW42W6u98ck0lFdUd4DTDRsKMxfXZ1oKy/LpTKKgJNW5MNlvZ5gwNCMUgJSkjBYOzhltw+M6NIGYf0y4DMdiq6mLoVGwUmC/ZKzmjikBuo4i5m7d9J7URp+mVjwUF/0VO7K+ombAifnN5gLGmL6bCAeMKwnvAVENNSUXixfnj/Umq6vr25X6EFMdeuL3veSFL/S5YFWwjx5D/DhyZFptKYbO/xgn2myNDe3zOmMadETjWG4jD2OdaVVVaXsOXLeJU/27MURel5EuMoQ8q64SQHPIJ9KZznJxGzuXOJ6k1BZuM+zF/k3pXPfDIVDrvfETwFDTYVZIY/xwuNKrCnpjooje2dXbTnwEuiJaZxXQEhLYu8453SeugeHsp999hmYe+1Xl/KX85fyF+AmGu49WcNp0I/8Spl4C4ezYDiLFEvMnIh4OUU3ZjqWRkcOWy+TliA1hS0hOUuvNSNB/pp/Lf99S7Jn8TZlemEUMFH5J4O9NwOWhdTew/9dDsJ8ura4dH1V1frS8uuqlBWaDLCZMmVbQQAYeP3GwsKN9fUbi/rS6i2WurS0OktLD4087EWIPJqrRR6OzCsiTz9YJI08tt64KyLPz7qi9TTyMMnsQZGq5nrvyMP5xsWrRtTgfxMlcvuipqaiBu1F01eJErqk6p9fwY1Jl0cJPnfshbnmcVxJBLG/XmeKyStwOglWz+TXs+8RRTWtC7l/wBdgdDonYaHM8S/TDykV0ctLLGRGZM3Q6M25OZUmXY+tc8rHKTJkqDTxGSpLRRbWdeUGqGu0cnVSTFxsSHC8w6AsSeuqTVImRIfHBs9fJMvVq0vTYP5ooLaR/FbILCjBkFHwhTnJizHywtaKWrt9ajNEnBfiorqKa3Bmx5YtdLdR6P7/JIcoqJXhSxE3mJnNUEiOM6op087bMVG43rQnKMDUcD77PDU1zHDrIEJETxR0FU0KZSDjYHD8XStfvuGlVYP4Kc6huTEiNVEIOYl8NidR/2rF+PiKR5ZNTS+fcNIZ8K3sEFGwBTT9wUd5/PgjorgiJzH+fsPyieW/585Yyn50/DheiCOOH+feYV3EDO+IuWwplM5GzOyvZybeXHfn/UTx8+t4Holl2/EBui+BMQdhbIBnr6APlUNO8tuL7MaffsJrOzo68GhHhycTyMcHRQ+hTJA0zYcVXFhiJHw5+VJ5TgyGKGhCZ+SsYa2G8Q+oy89Txsf54QBGr2cCsF9cvDIvvy7An9Hg+301isTuVkNRdV9MfER1cHs2kx9EgvKZ7Pbg6oj4mL7qIkNrd6JC4wuUDLl3ordFMhqjpGCZbzudkyJanW0FCjd7KERAApAkREsggSs76ZM5kiiAe8KRS8mX4MZ/T2Hhf0tgI5dZfUp88V4UyUcGqfdenF9h5UxtTnR6dGRMSKTCp25hXU50WnR4fMhihU8tdtSEhCxcIIut538R18NZCT0cI7+a8GVdqgIxZG5PwDpAYz/TNX8lMc6uA2+yXIXJ4X4ILLSL7sQSgQihdeLdMuHTGLwud96w/1ijfXz58nF745j/8LxcQ1F9fVF7uqKwO6CpKXDX8PDuwKamgO5CRXprZSXNVdPcLMkgL6Ek8ACJTMEZBwg3WQgAs3U1KdgElTjJYDPD0lJ8xxok2YN514yRpVlmg31e0NO/8s1r68hRtTjCwqts5rxe/YoOgy3HEWOQVUnDeoq4NfUA/pBUoyi670C0jA9iUEAdH2ajtXyutiQVezaBAlfn4szaHKXFpLQw2TFxFiZHlWVS5WjNcbcYDcnJOiYZW9PNjHVxpIUxp1ty4DonMjKHMass15i0jMnEMFlemT7NcRiJWAzxZbYJoIA+BOfT+PdrH447dcp56lTcw9fete6++9bjbbXEHFu7fXttrJnUYiV7CNcBIi8rpn01COahYMtDTvonkrFrYGuyCUalupUkErqAemQH7c2uMN77vMtaPBKvcOvZVybyQykUn8nQ9dg7pp0ijUqji7LbezttlnT15TCrlXWXWMyFJWZzkdmqVJWrmipTMhTJUplMKm/MM9SHR14J1ddGTlstSqXFoqT8BZIRnEHOX5nDaL2uVXJ5ZCQce/lfMkJ/vQ+QTwas4x/wtQSzV0WR53kB7Gm9NunCrVFOB/GTSRl4hL+6p7n5nsHBe5ub7x1su76k5Pq2VjhvbsvtN2X3WcvHQpfO16Toc3P1yfrApaEjleTJtn1Lluxva9u/ZMm+tozyHR0d2ysrt3d07CivNi3Nzx8y1TjiEyqKi8sT4gsrKNdxuA3fA93AEBR71b1PuJcy4lQVGem5oS0twblpmkpVuyU1zWxOS7WQwpqM2AgNuy9DGqOu1+mtFp3OYtYBdhVagQ/j15EvXQ2MXLWY4c5b2tvHurtrufOK3/B/3J4FvUg68B/gDYTBVmV60uFks/Ef3t/aMqcTtQjk6oO0OA6/Qp4CSUehVKS9UtYhXl5lgOqIXCGXeOKoWChe2Lr0+i6Lpctg6LIUNzUVlzQ2lrSHh+rLlWLbgDxtKsE/KMg/gTxl4AfRM7u9taSklR5/kvnXlpX9P0VcaIC/vz+3z1yNV0AvRuSpfuMV7B7yYkMD0BwNst5JHkfzhTgr+Id3eyF6aa2+XpPZqK8dwBFZKQqjPiXFRDp60mv0+hplb7XebNYbTNl6mGspWkcGyChXo5PQxZDRz2YS+K7TrOgMdPlO42U3d3ff3H377d20I4m7cRr0XCM91BkvNaIu1ZDEOI39ZkQmiwwNCSetpCgn1SpLZ0rwQ8WOqsXKxdKosBBNdrwuNjErQU11FgJ86QFn6hWdrysbX7wxieWLK3OS7UkJUdGJdbm5laTZJ1oqjYmNSEqIjImKSAtsIDeaojUxsQp/Epgam2YyA5YIWCOzw8PCpPLL9/NivfGDd98lx0frVyHMZbp5c/MkSHG98qQ8Z1RbtiV1UsiTmtSaOPZ9kYo9x+VJOoofJiHpXOULybidYTDvnDKSPpA3sGBm+YppHEU6Xfvw4qm2tmW0U6rDfugEvo3rovjg+ciT21zE8wESwhunIAV6ITlRXGzcNBoNf8YyjVGrNRcvkkgWrTbSN8NwN9oPcUToYYbtbCFr8tn7cDTvuXeTE5ztg9y9zWmuPcVpmwyGJi3TbDA0ZuIEc2qqKSuVem2tSlln0NepVLUG8FeDLtvMAF4t+Oyjsz4bqqCtmSTuvLsLMqtRHOf5Ucw6rQ/XdbiOozMAZC6dpZZ+SRDqWXCMYJEKMZOwswW/xG4cwetOqFqO3bpGtamvj2fIQj8UcG3Ly9N+emHfPtqXSHC7yW4eqxxwcjUhTHH+S7ttNsAEJ9kdI3jqr1ezYM9czdxUO69mzD60Qk/OcbasQlnI/L9Y9JX8pv4nG+9jx67Be34jCOPfGn3TXBERxLiH8NckEwUJHTLeQgl3NjLSS0bAUMvAU/wW/IErOmUkU9iMZ13WKwO75vpKokPwm8j1CPPQu2j3VeAzc+DbBPhJ9KwXfFCAn0K/9YJPC/Bh9JQX/LQAfw5dQLsRofsSURNUAhdSr8KzXRo9NLywTIKDRaT0iy/wfHYD66pYg9fhc+yGl0nXK81vt9DeVwt7A97IruVWG9bTjVJfyjS1l/uo98bQqwfwHLSjEm/rz77kv8276i7vWXUYjO3X+KcLfj0R0Hln16B394pGDa7jxEkxhZfuZuD+SvjMHPg2AX4SjXrBpwX4MBrm4Avg7hMOj5LH73NV+IwH7v6O7twofh5+0v0JB/8a4OEUPw8fdn/IaSMAIXKQi5RR3n03kKHQe+NUxOCHH2hre2D8fEXF+ZUbN66c/P3vhR4cThrCqa77tq5YueX5ob/wUiGbOVvJ5G3lUY5qrlPDUa31cIP9rwqfmQPfJsBPoi+84IMUzuN/2ws+LcCH0afAJUar0VZiI2U0KiYpuA9xaOIuxd/fdlvZ7TeX3Hxz2c23boXr2zzXt9EYthhwQbeG66ymU+kJJRex/FIKDLtjJMUe20pUYE9qSPamZUB7yTquym7rT1ODZVknVKY214EMXGerB/PC76jYQ5ZGuCIV6tWF0HFKTLCNaOBqH1zlsMX5eFINRtZpZ3dpoKVDZcr1NTgZZfGW8CbwfCV8Zg58mwA/iZ70gk8L8GH0GAfndhwcHguP5zdot9D7OkK7SHzvi+sRCN2vZK/21+Q6rv8FLaS1WNFpBofdAQ2w6Ryj0fYJ9VmD+3vyC5EvYrxjM+eV0rkBGtDymw0Qp1CPM6xZU7JUn5kmlaTnlOWPdLZNipcRjapBoastSUqKj7UZi6xOcuPyzEqVLk8ukc4PiZFE1lhL27qb0jPtMkVwlC1TrpPHpkamqhx217tEC3xzVXFRNPCdj6je89ArCF0FPuMNJxcF+El0zAv+mgA/hR7wgp8X4MPosBf+LAH+HHqH+wW4TwTRoDTwHTtXO48lXht6WKO8q+iQ8EvmVtP9qMS8op1PhA9b4qctSjIWLVgTua7dMizrTRiw0Ir1qrIVxV1p3dayGccMbsvP6Qj8slwtlO+wX6Q6X54mL+9hUuvqUhlavd5Q2FRZmZFasLoi2l5dbf8nlPFMsyU9PibTroUSYvJ/GZK5PfMt8avDJxu84nH+UtPc1kZTU3mPf6oQjMf8y1ZWNlxqcvDyzOf0Vczr8U8IXQU+4w0nFwX4SXSXF/y8AB9GtyMkRFyK52m4IijPB10VPsPB+UhM8fPwk59QOB+JyXkBPvwhQrPdmSbyAYrhvn8TskFeWBB19EbqHFKjREwuUzFpKt1QW7W2uHh1WWZ5QjSzuiohZZkk7NqaiQo1LS+XKtNLlPiHY0N7Sz1F5ugYuyXFujheFhKWao1ynVJCX7YhPR3Ojemz8TuPs+Ua3pb3cbxyVW5REsBr+Rj0BAq4CnxmDlwkwE+iBy7ByXsC/BTa4wX/TIAPo/0oAOZvRWUAp18tchkz8u5vQO7gvePHFj5PcrHkH/wl/nE2Qerq7mZ/N3tDOYuGGWkFWoJiaZUH80Gexnhe9lyED52N8CI+wkvyoHrfXZRSVe6AYn5vSWoVm7X48/RsKOXjksVfpGRBZR+/UuGEWr4uva5iGQhdr2R/rca+CVDUz1GxF+OgxE9lylWGOftp5u32BLoafMYbTi4K8JPoES/4eQE+jB7m4Fx9lsPTzuPZj5DQU7hqNzP4at3MN/vsnp6CvffKbuZ3Zk9Pwcqwe0Ufs3+f8WoqzNLA0dbO03Y9utQBUnh1gBRcFZv7pkNEV9/FCNSEZ5PEuT6hB9AVn0x86PnWJ/3aqo57Ozvvba9am47Xs1+7fu/95QTe1vxWy7jZ7Pl8Its03ML+ccpmmyorc+bABzp8FMZcB4pB2Zd3MBVz6eDjr89lXpnkicc+GLqbPvW5HdDd3NRTMCZPmikAXy1bX5U/lSSfKIJOp2vAy09JNfQ9rfV+EH4LaqDvackyWj1eazEYLPmrqs55e+v5/JrqAvrFHz6N3oQ8jqBziN9h4xSwEl/PDlsquX3nzp3kQCN8yN1CtS8mHehDURZfMbtUu5Ike+0+P7Rr1Ha7WmPPjZaERUeHSaLJ7RZLptZi0UZER0vDY2LCPXN14lby2r+vQIdYVKHRYQsl84Ololx/uIkNCQmdR2/IHeZ58wIDJZJs8/x5QQHhEooTqkVkDN8xW4khY66P8B3d3Z4nooJLT0QFrhD+SSTI4GX+eyi5kbl5zVA1Pv05DBOkQ58wYnkHPCGHuSe+7tvR42CN8MQITxzw5PrPEaG48GbuDbEHm5THuNyD9XN4m1C8eIcwCt438ti/4mbgR8EceBk3h9gzy+xM33CzwSCM+tFZPIxfpLsjQ7JXOHvaLC83ZJWXZ52VmxON5eVGY5nnu09Sj7aBdQaj0wjRX7yX8+pgOGNau0M/cHUAZPSq2a2YrdRp4fnPnueh3vUBBf+cAVQMOTL75Tdh2MlJvJN+eghAhCE3vigSg3eqYJ0XFO0pwxvhx3t9F4Pv0gYJ/NCVyqcLvgR8ZHz6z4ntpYSUtif+eXqM7rq6bCXjMa99IhJ98lrMeEmPXtc/sm64MnrRoujK4XWj/Tp9vrVSIpVKKnPygcsI3E0+h/nFtE4UCqhD4V9SMO1YcU1nqTHiuyqwySryei3ps/bWLOseIE/ms+dxNFQRPv/8m29w9w8/8HaGv75kTfhrdoBak9stfP1O6D71/wDCWR6sAAAAAQAAAAQBBrj+PmNfDzz1AAMD6AAAAADYpKnCAAAAANsWNsz95/26CewENQAAAAcAAgAAAAAAAHjaY2BkYGCR+reIIYXz2t/nP0M53wBFUMEtALBiCAUAeNptkQOMnVEQRs+d/61t296tbdu2G9W23aBGWCOobbuNNk5t2+3k1khyMr6Yz7wEAOP6TnXamZokO/1IkNlUcqLJlneksJlk85CxSox5S1U5Sx+u4Sb1acszCkWoLJOoZLqQJ9UpIS00N4N8mUADmawUkinjtWcMjXlFoSkkUXrRw3FnlDRhoEST6TLUkT0ky3AaOm6kyQkaiq/ifI+P0NB4alyKXBml/n7ND9b4itpArbdUG6J2pOY6UUH7MmSr3r2TEOcOIbKQEtKZAMmnhLnFQrnAanOTiTKfVCee8XzGW9aSpjSUdqhV+pNmGhFp/Vn2/krG88tNyca+xRWgvbOU8aTbOe0zE9WGk2eGEqu1OlINb6c83uYF3lJHbbG+38V4U4v+ajtIFqk/dq/vrSHTdeepVBJ9q+2pQZYph7cTRr45TYK5pzueRZro7sWNEmYy3maT3nWBfqaV6tOGYNXEW//VUHeZwktKmQi8uUKo7kznKSEbSZYDym2SJJqSdu//wVmGr9296vA7xhN/RfnySnkul/H6ocPfyD7GqI22WvyG1UI103oZu9//4Kqstp3S/0/+uX8saT90+Id1dFBrtfgD1cJqptZqWVbvSyeN5ySaEnjzGA/TS3uO09ZZSVvNRymJFONm1hKlJJp56l+kl4yn0GSRp5SQhpR0kol2coi0GgmVvwJQTZQmAAAAeNpiYGBQg0IXhnCGdoYrjJKMCYy5gIbgAUhsIAAA4MTWKZfatm3btgfFsLZt27Zt22/bNneZTcwF5hMTzCQymazGlmV7siPYFewz1pfTuB7cGO4MF8DFcBk8z1O+Fj+ef8UHCFDoLEwTFgnbhFeCvxAj8mIFsb7YW5wo7hBvi/ESlIZJM6T10hHpkfRHipOKZUeuJDeWu8qD5PHybvmjnK7UVsYqC5RnSqhSpFZT26q91GXqSfWHJmrttKHabu2m9keL0nm9gt5M76Vv1Q/qQYZcurox3NhsfDRSTM6cZK41/S3Vqmo1sdpYa6yd1iPrt1Vot7K727PsVfYW+6L9wI6wC51azlTnoZPk5AERAFAB1AEtwBhwFFwEd8FL8BX4gkiQCgphLdgMdoL94Cg4Dc6Dm+AvGATjYBZikYmaoWVoE9qHTqFr6BF6h6vhKXgOXoTX4V34GL6E7+FXRCaIVCL1SCvSjQwiS8kz8on8I2EkieS5jdx2bm93oxvqxrq5tCLtTUfQqXQeXUo30iP0On1JfWgMzfFkj3qjvKXeJm9XCY/bd0cAAAABAAAA2gCQAAwAdQAGAAEAAgAeAAYAAABkAAAAAwACeNp9kENahlEARk92G4izbNck2zXL7re1keZhIS2tM8h6PtyXV0Al15RQVFoFPPD8ioto5OkVF1PP3SsuYZLDV1z6KVNGNbuvuFx99BXXi+CWtE+clO0+nxQXJAmopMW9fgHCjjHVG/0tFllnWx73CRA10cMGV1zKMkQYNt3vM8wK+6a3mKL1W6P1S0P/U+uccXZ1b/TCnJH8tzuHHgWS8hs8jf4g/fiJ9lWufq4uT6oE9S6wwQwZ0mZj6vq0/7iXG7smzJ3TaytGRFWNa3GGKJd2C2pf1+p4AYtCRK8AAAB42mzBg4ECAAAAwAtv27b/e9t2NoZsmZapBboTBOpVEc3UCAQDISFhLVq1adehU5duPXr16Tdg0JBhI0aNGTdh0pRpM2bNmbdg0ZJlK1atWbdh05ZtO3bt2Xcg4tCRYydOnTl34dKVazdu3bn34NGTZy9evXn34dOXbz9+/fkXFROXkJSSlpGVk1dQVFJWCYQbBMHDViAAAADAWe93rs3sXrY7Zdu2zZd5zi+fm1EpXoJhhU4kypSmWL2qZ6+k2hcnz607Gc9eSzbp2I0SDR7ce1Sh2bxZLd55L9sHiz6as2DVkmUrTn2yYc26Vp9dy7Ft05Yvzl1K8c1X3/30wy9lfvvrj3/+CxQgSLAzIcKEChcpQp9y0aLEiHXhyoAdbdqfvbHryJ4OnXr0mtKl27QkjUaMGnr2VrqnvWfkZPEL9fFhcg5iL83LNDBwNIDSLhDayRRMGzk5s7iWFuWDOEZGhqYAyYRuqAA=", uY = "data:font/woff2;base64,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", dY = "data:font/woff;base64,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", lY = "data:font/woff2;base64,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", pY = "data:font/woff;base64,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", fY = "data:font/woff2;base64,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", mY = "data:font/woff;base64,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", hY = "data:font/woff2;base64,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", gY = [{
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  src: `local(""), url("${hY}") format("woff2"), url("${mY}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  src: `local(""), url("${uY}") format("woff2"), url("${cY}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  src: `local(""), url("${lY}") format("woff2"), url("${dY}") format("woff")`
}, {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  src: `local(""), url("${fY}") format("woff2"), url("${pY}") format("woff")`
}], IY = tY({
  "@font-face": gY
}), vY = IY;
function UY({
  asChild: e,
  confident: t,
  className: r,
  classNames: i,
  hideMark: n,
  styles: a,
  props: o,
  children: s,
  sx: c
}) {
  vY();
  const u = e ? Cy : "data", [d, l] = (s || 0).toFixed(2).split(".");
  return /* @__PURE__ */ Ai.jsxs(u, { className: ag(aY(c && {
    css: c
  }), (a == null ? void 0 : a.root) && ls(a.root)(), r, i == null ? void 0 : i.root), value: s, ...o == null ? void 0 : o.root, children: [
    s ? /* @__PURE__ */ Ai.jsxs(Ai.Fragment, { children: [
      d,
      ".",
      /* @__PURE__ */ Ai.jsx("span", { className: ag(oY(), i == null ? void 0 : i.decimal, (a == null ? void 0 : a.decimal) && ls(a.decimal)()), ...o == null ? void 0 : o.decimal, children: l })
    ] }) : "-",
    !n && /* @__PURE__ */ Ai.jsx(nY, { className: ag(sY(), i == null ? void 0 : i.mark, (a == null ? void 0 : a.mark) && ls(a.mark)()), fill: t ? "#003A70" : "#D0D3DB", height: 8, width: 8, ...o == null ? void 0 : o.mark }),
    " "
  ] });
}
const SY = Si.memo(UY), yY = ls({
  fontSize: "$medium",
  margin: 0
}), AY = ({
  seed: e,
  status: t,
  showStatus: r
}) => {
  const i = e && t && r ? `[${e}/${lD(t) || ""}]` : e ? `[${e}]` : t && r ? `[${lD(t)}]` : "";
  return /* @__PURE__ */ Ai.jsx("p", { className: yY(), children: i });
}, TY = Si.memo(AY);
var Qn = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.CITY_STATE = "CITY_STATE", e.DISTRICT = "DISTRICT", e.SECTION = "SECTION", e.COUNTRY = "COUNTRY", e.TEAM = "TEAM", e.CONFERENCE = "CONFERENCE", e.REGION = "REGION", e.TEAM_ABBREVIATION = "TEAM_ABBREVIATION", e))(Qn || {}), DY = /* @__PURE__ */ ((e) => (e.NONE = "None", e.CITY_STATE = "City/State", e.DISTRICT = "District", e.SECTION = "Section", e.COUNTRY = "Country", e.TEAM = "Team", e.CONFERENCE = "Conference", e.REGION = "Region", e))(DY || {}), $l = /* @__PURE__ */ ((e) => (e.DATE = "DATE", e.TIME = "TIME", e.FACILITY = "FACILITY", e))($l || {}), PY = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.WTN = "WTN", e))(PY || {}), OC = /* @__PURE__ */ ((e) => (e.NTRP = "NTRP", e.WTN = "WTN", e.PT = "PT", e))(OC || {}), dI = /* @__PURE__ */ ((e) => (e.WITHDRAWAL = "WITHDRAWAL", e.WINNER = "WINNER", e))(dI || {});
const wY = {}, sg = "Personal circumstance", Eh = "en-US", CC = {
  /* Walkovers */
  W1: ["inj", "Injury"],
  W2: ["Ill", "Illness"],
  W3: ["pc", sg],
  W4: ["tae", "Tournament Administrative Error"],
  W5: ["Withdrawn", "Withdrawn"],
  /* Defaults */
  DQ: ["dq", "Disqualification for cause or ineligibility"],
  DM: ["cond", "Misconduct before or between matches"],
  D5: ["ad", "Failure to start match because of adult discipline"],
  D4: ["refsl", "Refusal to start match"],
  D6: ["ns", "Not showing up"],
  D7: ["late", "Lateness for match"],
  DD: ["Def/Def", "Double default"],
  D9: ["refsl", "Refusal to continue match"],
  DI: ["med", "Default (PEDs)"],
  DP: ["pps", "Default (Point Penalty System)"],
  /* Retirements */
  RJ: ["inj", "Injury"],
  RI: ["ill", "Illness"],
  RC: ["pc", sg],
  RD: ["ad", "Retirement because of adult discipline"],
  RU: ["elg", "Ret. (eligible)"],
  /* Withdrawal */
  "WD.INJ": ["inj", "Injury"],
  "WD.ILL": ["ill", "Illness"],
  "WD.PC": ["pc", sg],
  "WD.TAE": ["Tae", "Tournament Administrative Error"]
}, ky = (e, t, r, i) => {
  var h;
  const n = (r == null ? void 0 : r.dateTimeFormat) || {
    minute: "2-digit",
    hour: "numeric",
    day: "numeric",
    weekday: "short",
    month: "short",
    timeZone: i
  }, a = (r == null ? void 0 : r.dateFormat) || {
    day: "numeric",
    weekday: "short",
    month: "short",
    timeZone: i
  }, o = (r == null ? void 0 : r.timeFormat) || { timeStyle: "short" }, s = e.venueId || ((h = e.allocatedCourts) == null ? void 0 : h[0].venueId), c = t == null ? void 0 : t.find((g) => g.dates.includes(e.scheduledDate));
  if (!t || !c)
    return {
      scheduleFormat: n,
      venueId: e.venueId
    };
  const u = (c == null ? void 0 : c.selectedInformation) ?? [], [d, l, p] = [
    u.includes($l.DATE),
    u.includes($l.TIME),
    u.includes($l.FACILITY)
  ];
  return {
    scheduleFormat: d && l ? n : d ? a : l ? o : n,
    venueId: p ? s : void 0
  };
}, RY = (e, t) => {
  var r, i, n, a;
  if (e != null && e.scheduledDate)
    return la.tz(
      e.scheduledTime ? `${(r = e.scheduledDate) == null ? void 0 : r.split("T")[0]}T${((n = (i = e.scheduledTime) == null ? void 0 : i.split("Z")[0].split("T").reverse()) == null ? void 0 : n[0]) ?? ""}` : (a = e.scheduledDate) == null ? void 0 : a.split("Z")[0],
      t ?? "UTC"
    );
}, Ly = ({
  format: e,
  locale: t = Eh,
  schedule: r,
  unknown: i = "-",
  zone: n
}) => {
  if (!(r != null && r.scheduledDate) || !e) return i;
  const a = RY(r, n ?? "UTC");
  return bY({
    input: a,
    format: e,
    locale: t,
    zone: n,
    unknown: i
  });
}, bY = ({
  input: e,
  format: t,
  locale: r,
  zone: i,
  unknown: n = "Unknown"
}) => {
  const a = typeof e == "string" || e instanceof Date ? la.tz(e, i ?? "UTC") : e;
  return a != null && a.isValid ? typeof t == "string" ? a.format(t) : new Intl.DateTimeFormat(r, { ...i && { timeZone: i }, ...t }).format(a.toDate()) : n;
};
function c5({
  eventData: e,
  drawId: t,
  structureId: r,
  options: i
}) {
  var f;
  const { venuesData: n, drawsData: a, tournamentInfo: o } = e, s = a == null ? void 0 : a.find((m) => (m == null ? void 0 : m.drawId) === t), c = (f = s == null ? void 0 : s.structures) == null ? void 0 : f.find((m) => m.structureId === r), { roundProfile: u, roundMatchUps: d } = c ?? {};
  if (!d)
    return [];
  const l = Object.entries(d).flatMap(
    ([, m]) => m.flatMap(
      ({ sides: h }) => NY(h, e.eventInfo.eventType, {
        ...i,
        qualifyingParticipantIds: (c == null ? void 0 : c.stage) === "MAIN" ? i.qualifyingParticipantIds : void 0
      })
    )
  ).filter((m) => m.id);
  return Object.entries(d).sort(([m], [h]) => +m - +h).map(([m, h], g) => ({
    title: h[0].roundName ?? "",
    abbreviatedTitle: h[0].abbreviatedRoundName,
    double: u == null ? void 0 : u[m].preFeedRound,
    matches: h.map((I, U) => {
      var T;
      const v = (T = d[+m + 1]) == null ? void 0 : T[Math.floor(U / 2)], S = I.sides.findIndex(
        (A) => {
          var y;
          return (y = v == null ? void 0 : v.sides) == null ? void 0 : y.some(({ participantId: D }) => D && D === A.participantId);
        }
      );
      return FY(
        I,
        g,
        e.eventInfo.eventType,
        l,
        n,
        i,
        S,
        o == null ? void 0 : o.localTimeZone
      );
    })
  }));
}
function NY(e, t, r) {
  const i = t === Jt.EventTypeEnum.DOUBLES;
  return e ? e.map((n, a) => {
    const o = e[a === 0 ? 1 : 0];
    return {
      ...n,
      isDoubles: i,
      displaySideNumber: (n == null ? void 0 : n.displaySideNumber) ?? o ? o.displaySideNumber === 1 ? 2 : 1 : a + 1
    };
  }).sort(({ displaySideNumber: n }, { displaySideNumber: a }) => +n - +a).flatMap((n) => MY(n, r)) : [];
}
const MY = (e, t) => {
  var u;
  const { drawSettings: r, profileUrl: i, organisationName: n, qualifyingParticipantIds: a } = t, { participant: o, seedValue: s, isDoubles: c = !1 } = e;
  return o ? ((u = c ? o.individualParticipants : [o]) == null ? void 0 : u.flatMap(
    (d) => {
      var U, v, S, T, A, y, D, P;
      const { participantId: l, person: p, teams: f, extensions: m } = d ?? {}, h = i && n && ((v = (U = p == null ? void 0 : p.personOtherIds) == null ? void 0 : U.find((w) => w.uniqueOrganisationName === n)) == null ? void 0 : v.personId), g = EY(d, c), I = (S = a == null ? void 0 : a.includes) != null && S.call(a, o.participantId) ? _v.QUALIFIER : o.entryStatus;
      return {
        id: l,
        country: (A = (T = p == null ? void 0 : p.addresses) == null ? void 0 : T[0]) == null ? void 0 : A.countryCode,
        countryName: (D = (y = p == null ? void 0 : p.addresses) == null ? void 0 : y[0]) == null ? void 0 : D.countryCode,
        additionalInfo: FC(
          p,
          f,
          m,
          ((P = r == null ? void 0 : r.additionalPlayerInformation) == null ? void 0 : P[0]) ?? Qn.NONE
        ),
        draw: d == null ? void 0 : d.drawPosition,
        name: p ? OY(p.standardGivenName, p.standardFamilyName) : d == null ? void 0 : d.participantName,
        seed: s,
        decorator: /* @__PURE__ */ Ai.jsx(
          TY,
          {
            seed: s,
            showStatus: !!(r != null && r.showEntryStatus) && I !== Jt.EntryStatusEnum.DIRECT_ACCEPTANCE,
            status: I
          }
        ),
        adornment: /* @__PURE__ */ Ai.jsx(
          SY,
          {
            hideMark: !(g != null && g.wtnRating),
            props: g ? {
              mark: {
                fill: CY(g, t.wtnConfidenceBands)
              }
            } : void 0,
            children: (g == null ? void 0 : g.wtnRating) ?? 0
          }
        ),
        link: h && `${i}${h}`
      };
    }
  )) ?? [] : [];
}, EY = (e, t) => {
  var n, a, o, s;
  const r = t ? Jt.MatchUpTypeEnum.DOUBLES : Jt.MatchUpTypeEnum.SINGLES, i = (a = (n = e.ratings) == null ? void 0 : n[r]) == null ? void 0 : a.find((c) => c.scaleName === OC.WTN);
  return (i == null ? void 0 : i.scaleValue) ?? ((s = (o = e == null ? void 0 : e.timeItems) == null ? void 0 : o.filter((c) => (c == null ? void 0 : c.itemType) === `SCALE.RATING.${r}.WTN`).sort((c, u) => !c.createdAt || !u.createdAt ? 0 : new Date(u.createdAt).valueOf() - new Date(c.createdAt).valueOf())[0]) == null ? void 0 : s.itemValue);
}, FC = (e, t, r, i) => {
  var n, a, o, s, c, u, d, l, p;
  switch (i) {
    case Qn.COUNTRY:
      return ((a = (n = e == null ? void 0 : e.addresses) == null ? void 0 : n[0]) == null ? void 0 : a.countryCode) ?? "";
    case Qn.SECTION:
      return ID(e, "ustaSection");
    case Qn.DISTRICT:
      return ID(e, "ustaDistrict");
    case Qn.TEAM:
    case Qn.TEAM_ABBREVIATION:
      return ((o = t == null ? void 0 : t[0]) == null ? void 0 : o.participantName) ?? "";
    case Qn.CONFERENCE:
      return ((c = (s = r == null ? void 0 : r.find((f) => f.name === "conference")) == null ? void 0 : s.value) == null ? void 0 : c.replace("_", " ")) ?? "";
    case Qn.CITY_STATE:
      return [(d = (u = e == null ? void 0 : e.addresses) == null ? void 0 : u[0]) == null ? void 0 : d.city, (p = (l = e == null ? void 0 : e.addresses) == null ? void 0 : l[0]) == null ? void 0 : p.state].filter(Boolean).join(", ");
    case Qn.REGION:
    case Qn.NONE:
    default:
      return "";
  }
}, ID = (e, t) => {
  var r;
  if (!e) return "";
  if (e[`_${t}`])
    return e[`_${t}`].name;
  if (e.extensions) {
    const i = e.extensions.find((n) => n.name === t);
    return ((r = i == null ? void 0 : i.value) == null ? void 0 : r.name) ?? "";
  } else
    return "";
}, OY = (e, t) => e && t ? t + ", " + e : "", CY = (e, t) => {
  var i;
  const { confidence: r } = e;
  return (i = t == null ? void 0 : t.sort((n, a) => n.min < a.min ? 1 : -1).find((n) => n.min <= r)) == null ? void 0 : i.colour;
};
function FY(e, t, r, i, n, a, o, s) {
  var E, O;
  const { t: c, drawSettings: u } = a ?? {}, d = c || ((M) => M), { schedule: l, sides: p, score: f, matchUpId: m, matchUpStatus: h, matchUpStatusCodes: g, winningSide: I } = e, U = h === Jt.MatchUpStatusEnum.BYE, { scheduleFormat: v, venueId: S } = ky(
    l,
    (u == null ? void 0 : u.matchDayInformation) ?? [],
    a == null ? void 0 : a.dateFormats,
    s
  ), T = n.find((M) => M.venueId === S), A = (E = T == null ? void 0 : T.courtsInfo) == null ? void 0 : E.find((M) => M.courtId === (l == null ? void 0 : l.courtId)), y = U || !A ? "" : ` - ${A == null ? void 0 : A.courtName}`, D = r === Jt.EventTypeEnum.DOUBLES, P = D ? 2 : 1, w = null, R = Array.from({ length: P }).map(() => w), b = Ly({
    format: v,
    locale: (a == null ? void 0 : a.locale) || Eh,
    schedule: l,
    zone: s,
    unknown: ""
  });
  return {
    id: m,
    schedule: U ? "" : b || d("notScheduled"),
    score: ((O = f == null ? void 0 : f.sets) == null ? void 0 : O.map((M) => ({
      sideScores: [
        {
          ...Number.isSafeInteger(M == null ? void 0 : M.side1Score) && {
            score: M.side1Score
          },
          ...Number.isSafeInteger(M == null ? void 0 : M.side1TiebreakScore) && {
            tiebreak: M.side1TiebreakScore
          }
        },
        {
          ...Number.isSafeInteger(M == null ? void 0 : M.side2Score) && {
            score: M.side2Score
          },
          ...Number.isSafeInteger(M == null ? void 0 : M.side2TiebreakScore) && {
            tiebreak: M.side2TiebreakScore
          }
        }
      ],
      winningSide: M == null ? void 0 : M.winningSide
    }))) ?? [],
    completed: NC.completedMatchUpStatuses.includes(h),
    sides: p.map((M, N) => {
      var G;
      const { participant: C, sourceDrawPositionRange: F, drawPosition: x, participantFed: V } = M, k = LY(i, C, D);
      let L = xY(
        M,
        h,
        g,
        N,
        I
      );
      const B = (G = CC[g == null ? void 0 : g[0]]) == null ? void 0 : G[0];
      if (g != null && g.length) {
        const q = g.find(({ sideNumber: Y }) => Y === N + 1);
        q && (L = kY(L, q, C));
      }
      return {
        players: k.length ? k : R,
        progressed: o === N,
        draw: (t === 0 || V) && (F || x) || void 0,
        fed: V,
        specificStatus: B,
        status: L
      };
    }),
    venue: `${(T == null ? void 0 : T.venueAbbreviation) ?? ""}${y}`
  };
}
const kY = (e, t, r) => {
  let i = e;
  return t != null && t.matchUpStatus && (t == null ? void 0 : t.matchUpStatus) !== Jt.MatchUpStatusEnum.BYE && (r != null && r.participantId) && !(e === "WINNER" && t.matchUpStatus === Jt.MatchUpStatusEnum.COMPLETED) && (i = t.matchUpStatus), [
    Jt.MatchUpStatusEnum.TO_BE_PLAYED,
    Jt.MatchUpStatusEnum.CANCELLED,
    Jt.MatchUpStatusEnum.ABANDONED,
    Jt.MatchUpStatusEnum.INCOMPLETE,
    Jt.MatchUpStatusEnum.WALKOVER
  ].includes(t == null ? void 0 : t.previousMatchUpStatus) && (i = void 0), i;
}, LY = (e, t, r) => {
  if (!t)
    return [];
  let i;
  return r ? i = (t == null ? void 0 : t.individualParticipants) || [] : i = [
    {
      participantId: t == null ? void 0 : t.participantId,
      person: t == null ? void 0 : t.person,
      entryStatus: t == null ? void 0 : t.entryStatus
    }
  ], i == null ? void 0 : i.map((n) => ({
    ...e.find((a) => (a == null ? void 0 : a.id) === n.participantId) || null,
    entryStatus: n.entryStatus
  }));
}, xY = (e, t, r, i, n) => {
  const { participant: a, bye: o, qualifier: s } = e;
  let c = t === Jt.MatchUpStatusEnum.BYE ? void 0 : t || void 0, u = t || void 0;
  return ["WD.INJ", "WD.ILL", "WD.PC", "WD.WD", "WD.TAE"].includes(r == null ? void 0 : r[0]) && (u = dI.WITHDRAWAL), u === Jt.MatchUpStatusEnum.DOUBLE_WALKOVER ? c = Jt.MatchUpStatusEnum.WALKOVER : u === Jt.MatchUpStatusEnum.DOUBLE_DEFAULT ? c = Jt.MatchUpStatusEnum.DEFAULTED : o ? c = Jt.MatchUpStatusEnum.BYE : s && !a ? c = _v.QUALIFIER : n && n - 1 === i ? c = dI.WINNER : u !== Jt.MatchUpStatusEnum.BYE && (c = u), c;
}, BY = [
  Jt.MatchUpStatusEnum.CANCELLED,
  Jt.MatchUpStatusEnum.ABANDONED,
  Jt.MatchUpStatusEnum.COMPLETED,
  Jt.MatchUpStatusEnum.DEAD_RUBBER,
  Jt.MatchUpStatusEnum.DEFAULTED,
  Jt.MatchUpStatusEnum.DOUBLE_WALKOVER,
  Jt.MatchUpStatusEnum.RETIRED,
  Jt.MatchUpStatusEnum.WALKOVER
], u5 = (e, t, r) => {
  var R;
  const { venuesData: i, tournamentInfo: n, eventInfo: a } = e, { drawSettings: o, dateFormats: s, t: c } = r, { matchUpStatus: u, schedule: d, tieMatchUps: l, roundName: p, sides: f, score: m, winningSide: h, tieFormat: g } = t, I = a == null ? void 0 : a.gender, U = u === "BYE", { scheduleFormat: v, venueId: S } = ky(
    d,
    (o == null ? void 0 : o.matchDayInformation) ?? [],
    s,
    n == null ? void 0 : n.localTimeZone
  ), T = Ly({
    format: v,
    zone: n == null ? void 0 : n.localTimeZone,
    locale: (r == null ? void 0 : r.locale) || Eh,
    schedule: d,
    unknown: ""
  }), A = `${((R = e == null ? void 0 : e.eventInfo) == null ? void 0 : R.eventName) || ""}${p ? " - " + p : ""}`, y = U ? "" : T + (S && (d != null && d.venueAbbreviation) ? " at " + (d == null ? void 0 : d.venueAbbreviation) : ""), D = f == null ? void 0 : f.map((b, E) => {
    var O, M, N, C;
    return {
      name: (O = b == null ? void 0 : b.participant) != null && O.participantName ? (M = b == null ? void 0 : b.participant) == null ? void 0 : M.participantName : U ? c("bye") : "TBD",
      rank: ((N = b == null ? void 0 : b.participant) == null ? void 0 : N.rank) ?? "",
      score: (C = m == null ? void 0 : m[`scoreStringSide${E + 1}`]) == null ? void 0 : C.split("-")[0]
    };
  }), P = h - 1, w = jY(
    f,
    l,
    i,
    n,
    r,
    g || wY,
    I,
    c
  );
  return {
    heading: A,
    subheading: y,
    sides: D,
    sections: w,
    winningSideIndex: P
  };
}, VY = (e, t, r, i, n, a) => t.flatMap(
  ({ participant: o, seedValue: s, teamParticipant: c }) => {
    var u;
    return ((u = r ? o == null ? void 0 : o.individualParticipants : [
      {
        participantId: o == null ? void 0 : o.participantId,
        person: o == null ? void 0 : o.person,
        teams: o == null ? void 0 : o.teams,
        extensions: o == null ? void 0 : o.extensions
      }
    ]) == null ? void 0 : u.flatMap(({ participantId: d, person: l, teams: p, extensions: f }) => {
      var g, I, U, v, S, T, A, y;
      const m = i && n && ((g = l == null ? void 0 : l.personOtherIds.find((D) => D.uniqueOrganisationName === n)) == null ? void 0 : g.personId), h = ((U = (I = e.find((D) => {
        var P;
        return ((P = D == null ? void 0 : D.participant) == null ? void 0 : P.participantName) === (c == null ? void 0 : c.participantName);
      })) == null ? void 0 : I.participant) == null ? void 0 : U.participantOtherName) || "";
      return {
        id: d,
        country: (S = (v = l == null ? void 0 : l.addresses) == null ? void 0 : v[0]) == null ? void 0 : S.countryCode,
        countryName: (A = (T = l == null ? void 0 : l.addresses) == null ? void 0 : T[0]) == null ? void 0 : A.countryCode,
        additionalInfo: FC(
          l,
          p,
          f,
          (y = a == null ? void 0 : a.additionalPlayerInformation) == null ? void 0 : y[0]
        ),
        draw: o == null ? void 0 : o.drawPosition,
        name: l ? `${[l == null ? void 0 : l.standardFamilyName, l == null ? void 0 : l.standardGivenName].filter(Boolean).join(", ")} ${h ? "(" + h + ")" : ""}` : o == null ? void 0 : o.participantName,
        seed: s,
        wtn: void 0,
        link: m && `${i}${m}`
      };
    })) ?? [];
  }
), GY = ({ sides: e, matchUpStatus: t, winningSide: r, matchUpStatusCodes: i }, n, a, o, s) => {
  const c = (u) => ["WD.INJ", "WD.ILL", "WD.PC", "WD.WD", "WD.TAE"].includes(u);
  return e.map(({ participant: u, bye: d, participantFed: l }, p) => {
    var I, U;
    const f = ((I = n ? u == null ? void 0 : u.individualParticipants : (u == null ? void 0 : u.participantId) && [{ participantId: u == null ? void 0 : u.participantId, person: u == null ? void 0 : u.person }]) == null ? void 0 : I.map(({ participantId: v }) => s.find((S) => (S == null ? void 0 : S.id) === v) || o)) ?? a;
    let m;
    const h = c(i == null ? void 0 : i[0]) ? "WITHDRAWAL" : t;
    h === "DOUBLE_WALKOVER" ? m = "WALKOVER" : d ? m = "BYE" : r - 1 === p ? m = "WINNER" : h !== "BYE" && (m = h);
    const g = (U = CC[i == null ? void 0 : i[0]]) == null ? void 0 : U[0];
    return {
      players: f.length ? f : a,
      fed: l,
      status: m,
      specificStatus: g
    };
  });
}, jY = (e, t, r, i, n, a, o, s) => {
  var d;
  const { tieFormatName: c } = a, u = (d = a == null ? void 0 : a.collectionDefinitions) == null ? void 0 : d.map((l) => ({
    name: `${l == null ? void 0 : l.collectionName} ${c === "DOMINANT_DUO" ? s(o) : ""}`,
    tieMatches: t == null ? void 0 : t.filter((p) => p.collectionId === (l == null ? void 0 : l.collectionId)).sort((p, f) => ((p == null ? void 0 : p.collectionPosition) ?? 0) - ((f == null ? void 0 : f.collectionPosition) ?? 0))
  })).filter((l) => {
    var p;
    return (p = l == null ? void 0 : l.tieMatches) == null ? void 0 : p.length;
  });
  return u == null ? void 0 : u.map((l) => {
    var p;
    return {
      name: l == null ? void 0 : l.name,
      matches: (p = l == null ? void 0 : l.tieMatches) == null ? void 0 : p.map(
        ({ schedule: f, sides: m, score: h, matchUpStatus: g, matchUpStatusCodes: I, matchUpType: U, winningSide: v }, S) => {
          var F, x, V;
          const T = U === Jt.EventTypeEnum.DOUBLES, A = g === "BYE", { scheduleFormat: y, venueId: D } = ky(
            f,
            ((F = n == null ? void 0 : n.drawSettings) == null ? void 0 : F.matchDayInformation) ?? [],
            n == null ? void 0 : n.dateFormats,
            i == null ? void 0 : i.localTimeZone
          ), P = D && r.find((k) => k.venueId === D), w = (x = P == null ? void 0 : P.courtsInfo) == null ? void 0 : x.find((k) => k.courtId === (f == null ? void 0 : f.courtId)), R = T ? 2 : 1, E = VY(
            e,
            m,
            T,
            n == null ? void 0 : n.profileUrl,
            (n == null ? void 0 : n.organisationName) || "",
            n == null ? void 0 : n.drawSettings
          ), O = null, M = Array.from({ length: R }).map(() => O), N = Ly({
            format: y,
            locale: (n == null ? void 0 : n.locale) || Eh,
            zone: i == null ? void 0 : i.localTimeZone,
            schedule: f,
            unknown: ""
          }), C = ((V = h == null ? void 0 : h.sets) == null ? void 0 : V.map((k) => ({
            sideScores: [
              {
                ...Number.isSafeInteger(k.side1Score) && { score: k.side1Score },
                ...Number.isSafeInteger(k.side1TiebreakScore) && { tiebreak: k.side1TiebreakScore }
              },
              {
                ...Number.isSafeInteger(k.side2Score) && { score: k.side2Score },
                ...Number.isSafeInteger(k.side2TiebreakScore) && { tiebreak: k.side2TiebreakScore }
              }
            ],
            winningSide: k.winningSide
          }))) ?? [];
          return {
            index: S + 1,
            venue: `${(P == null ? void 0 : P.venueAbbreviation) ?? ""}${w ? ` - ${w == null ? void 0 : w.courtName}` : ""}`,
            completed: BY.includes(g),
            schedule: A ? "" : N || s("Not scheduled"),
            score: C,
            sides: GY(
              { sides: m, matchUpStatus: g, winningSide: v, matchUpStatusCodes: I },
              T,
              M,
              O,
              E
            )
          };
        }
      )
    };
  });
}, vD = ["YELLOW", "GREEN", "ORANGE", "RED"], Cl = ["SINGLES", "DOUBLES", "TEAM"], Fl = ["MEN", "WOMEN", "BOYS", "GIRLS", "MIXED", "ANY"], UD = ["INDIVIDUAL", "COMBINED"], kl = ["A", "B", "C", "D", "ANY", "Q"], d5 = (e) => (e == null ? void 0 : e.sort(_Y).sort(WY).sort(qY).sort(zY).sort(KY).sort(XY).sort(ZY)) || [], _Y = (e, t) => {
  const r = vD.indexOf(e.division.ballColour ?? ""), i = vD.indexOf(t.division.ballColour ?? "");
  return r > i ? 1 : r < i ? -1 : 0;
}, WY = (e, t) => {
  var n, a, o, s;
  const r = (n = e.division.ratingCategory) == null ? void 0 : n.ratingType, i = (a = t.division.ratingCategory) == null ? void 0 : a.ratingType;
  if (r === "NTRP" || i === "NTRP") {
    const c = UD.indexOf(((o = e.division.ratingCategory) == null ? void 0 : o.ratingCategoryType) ?? ""), u = UD.indexOf(((s = t.division.ratingCategory) == null ? void 0 : s.ratingCategoryType) ?? "");
    if (c > u)
      return 1;
    if (c < u)
      return -1;
  }
  return 0;
}, qY = (e, t) => {
  var n, a;
  const r = (n = e.division.ratingCategory) == null ? void 0 : n.ratingType, i = (a = t.division.ratingCategory) == null ? void 0 : a.ratingType;
  return r === "NTRP" || i === "NTRP" ? HY(e, t) : r === "WTN" || i === "WTN" ? YY(e, t) : 0;
}, HY = (e, t) => {
  var n, a;
  const r = ((n = e.division.ratingCategory) == null ? void 0 : n.value) ?? 0, i = ((a = t.division.ratingCategory) == null ? void 0 : a.value) ?? 0;
  return r || i ? r < i ? -1 : 1 : 0;
}, YY = (e, t) => {
  var n, a;
  const r = ((n = e.division.ratingCategory) == null ? void 0 : n.maximumValue) ?? 0, i = ((a = t.division.ratingCategory) == null ? void 0 : a.maximumValue) ?? 0;
  return r || i ? r > i ? -1 : 1 : 0;
}, zY = (e, t) => {
  var r, i;
  if (e.division.wheelchairRating !== null) {
    const n = (r = e.division.wheelchairRating) == null ? void 0 : r.toUpperCase(), a = (i = t.division.wheelchairRating) == null ? void 0 : i.toUpperCase();
    if (kl.indexOf(n) > kl.indexOf(a ?? ""))
      return 1;
    if (kl.indexOf(n) < kl.indexOf(a ?? ""))
      return -1;
  }
  return 0;
}, KY = (e, t) => {
  var o, s, c, u;
  const r = ((o = e.division.ageCategory) == null ? void 0 : o.maximumAge) ?? 0, i = ((s = e.division.ageCategory) == null ? void 0 : s.minimumAge) ?? 0, n = ((c = t.division.ageCategory) == null ? void 0 : c.maximumAge) ?? 0, a = ((u = t.division.ageCategory) == null ? void 0 : u.minimumAge) ?? 0;
  if (r || n) {
    if (r > n)
      return 1;
    if (r < n)
      return -1;
  } else {
    if (i > a)
      return 1;
    if (i < a)
      return -1;
  }
  return 0;
}, XY = (e, t) => {
  const r = e.division.gender === "COED" ? "ANY" : e.division.gender, i = t.division.gender === "COED" ? "ANY" : t.division.gender;
  return Fl.indexOf(r) > Fl.indexOf(i) ? 1 : Fl.indexOf(r) < Fl.indexOf(i) ? -1 : 0;
}, ZY = (e, t) => {
  const r = e.division.eventType, i = t.division.eventType;
  return Cl.indexOf(r) > Cl.indexOf(i) ? 1 : Cl.indexOf(r) < Cl.indexOf(i) ? -1 : 0;
};
var QY = /* @__PURE__ */ ((e) => (e.COMBINED = "COMBINED", e.INDIVIDUAL = "INDIVIDUAL", e))(QY || {}), JY = /* @__PURE__ */ ((e) => (e.GREEN = "GREEN", e.ORANGE = "ORANGE", e.RED = "RED", e.YELLOW = "YELLOW", e))(JY || {}), $Y = /* @__PURE__ */ ((e) => (e.FATHER_DAUGHTER = "FATHER_DAUGHTER", e.FATHER_SON = "FATHER_SON", e.GRANDFATHER_GRANDSON = "GRANDFATHER_GRANDSON", e.HUSBAND_WIFE = "HUSBAND_WIFE", e.MOTHER_DAUGHTER = "MOTHER_DAUGHTER", e.MOTHER_SON = "MOTHER_SON", e.SAME_GENDER_FEMALE = "SAME_GENDER_FEMALE", e.SAME_GENDER_MALE = "SAME_GENDER_MALE", e))($Y || {}), e5 = /* @__PURE__ */ ((e) => (e.BOYS = "BOYS", e.COED = "COED", e.GIRLS = "GIRLS", e.MIXED = "MIXED", e))(e5 || {}), t5 = /* @__PURE__ */ ((e) => (e.COMBINED = "COMBINED", e.INDIVIDUAL = "INDIVIDUAL", e))(t5 || {}), r5 = /* @__PURE__ */ ((e) => (e.DOUBLES_WTN = "DOUBLES_WTN", e.NTRP = "NTRP", e.PTP = "PTP", e.SINGLES_WTN = "SINGLES_WTN", e.WTN = "WTN", e))(r5 || {}), i5 = /* @__PURE__ */ ((e) => (e.A = "A", e.ANY = "ANY", e.B = "B", e.C = "C", e.D = "D", e.Q = "Q", e))(i5 || {});
export {
  PY as Adornments,
  QY as AgeCategoryType,
  JY as BallColour,
  Qn as DrawAdditionalPlayerInformation,
  DY as DrawAdditionalPlayerInformationLabel,
  $l as DrawMatchDayInformation,
  dI as ExtendedStatuses,
  $Y as FamilyType,
  e5 as Gender,
  t5 as RatingCategoryType,
  r5 as RatingType,
  OC as RatingTypeEnum,
  i5 as USTAWheelchairRating,
  vD as ballColourOrder,
  Cl as eventTypesOrder,
  Fl as genderOrder,
  UD as ntrpTypeOrder,
  d5 as orderEvents,
  KY as orderEventsByAge,
  _Y as orderEventsByBallColour,
  XY as orderEventsByGender,
  WY as orderEventsByNTRP,
  qY as orderEventsByRating,
  ZY as orderEventsByType,
  zY as orderWheelchairEvents,
  c5 as todsToNewDraws,
  u5 as todsToScorecard,
  kl as wheelchairSortOrder
};
